import * as React from 'react';
import { useState, useEffect, createContext, useRef, useContext } from 'react';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function getAugmentedNamespace(n) {
  if (n.__esModule) return n;
  var f = n.default;
	if (typeof f == "function") {
		var a = function a () {
			if (this instanceof a) {
        return Reflect.construct(f, arguments, this.constructor);
			}
			return f.apply(this, arguments);
		};
		a.prototype = f.prototype;
  } else a = {};
  Object.defineProperty(a, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

var fabric$1 = {};

var _nodeResolve_empty = {};

var _nodeResolve_empty$1 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	default: _nodeResolve_empty
});

var require$$2 = /*@__PURE__*/getAugmentedNamespace(_nodeResolve_empty$1);

/* build: `node build.js modules=ALL exclude=gestures,accessors,erasing requirejs minifier=uglifyjs` */

(function (exports) {
	/*! Fabric.js Copyright 2008-2015, Printio (Juriy Zaytsev, Maxim Chernyak) */

	var fabric = fabric || { version: '4.6.0' };
	{
	  exports.fabric = fabric;
	}
	/* _AMD_END_ */
	if (typeof document !== 'undefined' && typeof window !== 'undefined') {
	  if (document instanceof (typeof HTMLDocument !== 'undefined' ? HTMLDocument : Document)) {
	    fabric.document = document;
	  }
	  else {
	    fabric.document = document.implementation.createHTMLDocument('');
	  }
	  fabric.window = window;
	}
	else {
	  // assume we're running under node.js when document/window are not present
	  var jsdom = require$$2;
	  var virtualWindow = new jsdom.JSDOM(
	    decodeURIComponent('%3C!DOCTYPE%20html%3E%3Chtml%3E%3Chead%3E%3C%2Fhead%3E%3Cbody%3E%3C%2Fbody%3E%3C%2Fhtml%3E'),
	    {
	      features: {
	        FetchExternalResources: ['img']
	      },
	      resources: 'usable'
	    }).window;
	  fabric.document = virtualWindow.document;
	  fabric.jsdomImplForWrapper = require$$2.implForWrapper;
	  fabric.nodeCanvas = require$$2.Canvas;
	  fabric.window = virtualWindow;
	  DOMParser = fabric.window.DOMParser;
	}

	/**
	 * True when in environment that supports touch events
	 * @type boolean
	 */
	fabric.isTouchSupported = 'ontouchstart' in fabric.window || 'ontouchstart' in fabric.document ||
	  (fabric.window && fabric.window.navigator && fabric.window.navigator.maxTouchPoints > 0);

	/**
	 * True when in environment that's probably Node.js
	 * @type boolean
	 */
	fabric.isLikelyNode = typeof Buffer !== 'undefined' &&
	                      typeof window === 'undefined';

	/* _FROM_SVG_START_ */
	/**
	 * Attributes parsed from all SVG elements
	 * @type array
	 */
	fabric.SHARED_ATTRIBUTES = [
	  'display',
	  'transform',
	  'fill', 'fill-opacity', 'fill-rule',
	  'opacity',
	  'stroke', 'stroke-dasharray', 'stroke-linecap', 'stroke-dashoffset',
	  'stroke-linejoin', 'stroke-miterlimit',
	  'stroke-opacity', 'stroke-width',
	  'id', 'paint-order', 'vector-effect',
	  'instantiated_by_use', 'clip-path',
	];
	/* _FROM_SVG_END_ */

	/**
	 * Pixel per Inch as a default value set to 96. Can be changed for more realistic conversion.
	 */
	fabric.DPI = 96;
	fabric.reNum = '(?:[-+]?(?:\\d+|\\d*\\.\\d+)(?:[eE][-+]?\\d+)?)';
	fabric.commaWsp = '(?:\\s+,?\\s*|,\\s*)';
	fabric.rePathCommand = /([-+]?((\d+\.\d+)|((\d+)|(\.\d+)))(?:[eE][-+]?\d+)?)/ig;
	fabric.reNonWord = /[ \n\.,;!\?\-]/;
	fabric.fontPaths = { };
	fabric.iMatrix = [1, 0, 0, 1, 0, 0];
	fabric.svgNS = 'http://www.w3.org/2000/svg';

	/**
	 * Pixel limit for cache canvases. 1Mpx , 4Mpx should be fine.
	 * @since 1.7.14
	 * @type Number
	 * @default
	 */
	fabric.perfLimitSizeTotal = 2097152;

	/**
	 * Pixel limit for cache canvases width or height. IE fixes the maximum at 5000
	 * @since 1.7.14
	 * @type Number
	 * @default
	 */
	fabric.maxCacheSideLimit = 4096;

	/**
	 * Lowest pixel limit for cache canvases, set at 256PX
	 * @since 1.7.14
	 * @type Number
	 * @default
	 */
	fabric.minCacheSideLimit = 256;

	/**
	 * Cache Object for widths of chars in text rendering.
	 */
	fabric.charWidthsCache = { };

	/**
	 * if webgl is enabled and available, textureSize will determine the size
	 * of the canvas backend
	 * @since 2.0.0
	 * @type Number
	 * @default
	 */
	fabric.textureSize = 2048;

	/**
	 * When 'true', style information is not retained when copy/pasting text, making
	 * pasted text use destination style.
	 * Defaults to 'false'.
	 * @type Boolean
	 * @default
	 */
	fabric.disableStyleCopyPaste = false;

	/**
	 * Enable webgl for filtering picture is available
	 * A filtering backend will be initialized, this will both take memory and
	 * time since a default 2048x2048 canvas will be created for the gl context
	 * @since 2.0.0
	 * @type Boolean
	 * @default
	 */
	fabric.enableGLFiltering = true;

	/**
	 * Device Pixel Ratio
	 * @see https://developer.apple.com/library/safari/documentation/AudioVideo/Conceptual/HTML-canvas-guide/SettingUptheCanvas/SettingUptheCanvas.html
	 */
	fabric.devicePixelRatio = fabric.window.devicePixelRatio ||
	                          fabric.window.webkitDevicePixelRatio ||
	                          fabric.window.mozDevicePixelRatio ||
	                          1;
	/**
	 * Browser-specific constant to adjust CanvasRenderingContext2D.shadowBlur value,
	 * which is unitless and not rendered equally across browsers.
	 *
	 * Values that work quite well (as of October 2017) are:
	 * - Chrome: 1.5
	 * - Edge: 1.75
	 * - Firefox: 0.9
	 * - Safari: 0.95
	 *
	 * @since 2.0.0
	 * @type Number
	 * @default 1
	 */
	fabric.browserShadowBlurConstant = 1;

	/**
	 * This object contains the result of arc to bezier conversion for faster retrieving if the same arc needs to be converted again.
	 * It was an internal variable, is accessible since version 2.3.4
	 */
	fabric.arcToSegmentsCache = { };

	/**
	 * This object keeps the results of the boundsOfCurve calculation mapped by the joined arguments necessary to calculate it.
	 * It does speed up calculation, if you parse and add always the same paths, but in case of heavy usage of freedrawing
	 * you do not get any speed benefit and you get a big object in memory.
	 * The object was a private variable before, while now is appended to the lib so that you have access to it and you
	 * can eventually clear it.
	 * It was an internal variable, is accessible since version 2.3.4
	 */
	fabric.boundsOfCurveCache = { };

	/**
	 * If disabled boundsOfCurveCache is not used. For apps that make heavy usage of pencil drawing probably disabling it is better
	 * @default true
	 */
	fabric.cachesBoundsOfCurve = true;

	/**
	 * Skip performance testing of setupGLContext and force the use of putImageData that seems to be the one that works best on
	 * Chrome + old hardware. if your users are experiencing empty images after filtering you may try to force this to true
	 * this has to be set before instantiating the filtering backend ( before filtering the first image )
	 * @type Boolean
	 * @default false
	 */
	fabric.forceGLPutImageData = false;

	fabric.initFilterBackend = function() {
	  if (fabric.enableGLFiltering && fabric.isWebglSupported && fabric.isWebglSupported(fabric.textureSize)) {
	    console.log('max texture size: ' + fabric.maxTextureSize);
	    return (new fabric.WebglFilterBackend({ tileSize: fabric.textureSize }));
	  }
	  else if (fabric.Canvas2dFilterBackend) {
	    return (new fabric.Canvas2dFilterBackend());
	  }
	};


	if (typeof document !== 'undefined' && typeof window !== 'undefined') {
	  // ensure globality even if entire library were function wrapped (as in Meteor.js packaging system)
	  window.fabric = fabric;
	}


	(function() {

	  /**
	   * @private
	   * @param {String} eventName
	   * @param {Function} handler
	   */
	  function _removeEventListener(eventName, handler) {
	    if (!this.__eventListeners[eventName]) {
	      return;
	    }
	    var eventListener = this.__eventListeners[eventName];
	    if (handler) {
	      eventListener[eventListener.indexOf(handler)] = false;
	    }
	    else {
	      fabric.util.array.fill(eventListener, false);
	    }
	  }

	  /**
	   * Observes specified event
	   * @memberOf fabric.Observable
	   * @alias on
	   * @param {String|Object} eventName Event name (eg. 'after:render') or object with key/value pairs (eg. {'after:render': handler, 'selection:cleared': handler})
	   * @param {Function} handler Function that receives a notification when an event of the specified type occurs
	   * @return {Self} thisArg
	   * @chainable
	   */
	  function on(eventName, handler) {
	    if (!this.__eventListeners) {
	      this.__eventListeners = { };
	    }
	    // one object with key/value pairs was passed
	    if (arguments.length === 1) {
	      for (var prop in eventName) {
	        this.on(prop, eventName[prop]);
	      }
	    }
	    else {
	      if (!this.__eventListeners[eventName]) {
	        this.__eventListeners[eventName] = [];
	      }
	      this.__eventListeners[eventName].push(handler);
	    }
	    return this;
	  }

	  function _once(eventName, handler) {
	    var _handler = function () {
	      handler.apply(this, arguments);
	      this.off(eventName, _handler);
	    }.bind(this);
	    this.on(eventName, _handler);
	  }

	  function once(eventName, handler) {
	    // one object with key/value pairs was passed
	    if (arguments.length === 1) {
	      for (var prop in eventName) {
	        _once.call(this, prop, eventName[prop]);
	      }
	    }
	    else {
	      _once.call(this, eventName, handler);
	    }
	    return this;
	  }

	  /**
	   * Stops event observing for a particular event handler. Calling this method
	   * without arguments removes all handlers for all events
	   * @memberOf fabric.Observable
	   * @alias off
	   * @param {String|Object} eventName Event name (eg. 'after:render') or object with key/value pairs (eg. {'after:render': handler, 'selection:cleared': handler})
	   * @param {Function} handler Function to be deleted from EventListeners
	   * @return {Self} thisArg
	   * @chainable
	   */
	  function off(eventName, handler) {
	    if (!this.__eventListeners) {
	      return this;
	    }

	    // remove all key/value pairs (event name -> event handler)
	    if (arguments.length === 0) {
	      for (eventName in this.__eventListeners) {
	        _removeEventListener.call(this, eventName);
	      }
	    }
	    // one object with key/value pairs was passed
	    else if (arguments.length === 1 && typeof arguments[0] === 'object') {
	      for (var prop in eventName) {
	        _removeEventListener.call(this, prop, eventName[prop]);
	      }
	    }
	    else {
	      _removeEventListener.call(this, eventName, handler);
	    }
	    return this;
	  }

	  /**
	   * Fires event with an optional options object
	   * @memberOf fabric.Observable
	   * @param {String} eventName Event name to fire
	   * @param {Object} [options] Options object
	   * @return {Self} thisArg
	   * @chainable
	   */
	  function fire(eventName, options) {
	    if (!this.__eventListeners) {
	      return this;
	    }

	    var listenersForEvent = this.__eventListeners[eventName];
	    if (!listenersForEvent) {
	      return this;
	    }

	    for (var i = 0, len = listenersForEvent.length; i < len; i++) {
	      listenersForEvent[i] && listenersForEvent[i].call(this, options || { });
	    }
	    this.__eventListeners[eventName] = listenersForEvent.filter(function(value) {
	      return value !== false;
	    });
	    return this;
	  }

	  /**
	   * @namespace fabric.Observable
	   * @tutorial {@link http://fabricjs.com/fabric-intro-part-2#events}
	   * @see {@link http://fabricjs.com/events|Events demo}
	   */
	  fabric.Observable = {
	    fire: fire,
	    on: on,
	    once: once,
	    off: off,
	  };
	})();


	/**
	 * @namespace fabric.Collection
	 */
	fabric.Collection = {

	  _objects: [],

	  /**
	   * Adds objects to collection, Canvas or Group, then renders canvas
	   * (if `renderOnAddRemove` is not `false`).
	   * in case of Group no changes to bounding box are made.
	   * Objects should be instances of (or inherit from) fabric.Object
	   * Use of this function is highly discouraged for groups.
	   * you can add a bunch of objects with the add method but then you NEED
	   * to run a addWithUpdate call for the Group class or position/bbox will be wrong.
	   * @param {...fabric.Object} object Zero or more fabric instances
	   * @return {Self} thisArg
	   * @chainable
	   */
	  add: function () {
	    this._objects.push.apply(this._objects, arguments);
	    if (this._onObjectAdded) {
	      for (var i = 0, length = arguments.length; i < length; i++) {
	        this._onObjectAdded(arguments[i]);
	      }
	    }
	    this.renderOnAddRemove && this.requestRenderAll();
	    return this;
	  },

	  /**
	   * Inserts an object into collection at specified index, then renders canvas (if `renderOnAddRemove` is not `false`)
	   * An object should be an instance of (or inherit from) fabric.Object
	   * Use of this function is highly discouraged for groups.
	   * you can add a bunch of objects with the insertAt method but then you NEED
	   * to run a addWithUpdate call for the Group class or position/bbox will be wrong.
	   * @param {Object} object Object to insert
	   * @param {Number} index Index to insert object at
	   * @param {Boolean} nonSplicing When `true`, no splicing (shifting) of objects occurs
	   * @return {Self} thisArg
	   * @chainable
	   */
	  insertAt: function (object, index, nonSplicing) {
	    var objects = this._objects;
	    if (nonSplicing) {
	      objects[index] = object;
	    }
	    else {
	      objects.splice(index, 0, object);
	    }
	    this._onObjectAdded && this._onObjectAdded(object);
	    this.renderOnAddRemove && this.requestRenderAll();
	    return this;
	  },

	  /**
	   * Removes objects from a collection, then renders canvas (if `renderOnAddRemove` is not `false`)
	   * @param {...fabric.Object} object Zero or more fabric instances
	   * @return {Self} thisArg
	   * @chainable
	   */
	  remove: function() {
	    var objects = this._objects,
	        index, somethingRemoved = false;

	    for (var i = 0, length = arguments.length; i < length; i++) {
	      index = objects.indexOf(arguments[i]);

	      // only call onObjectRemoved if an object was actually removed
	      if (index !== -1) {
	        somethingRemoved = true;
	        objects.splice(index, 1);
	        this._onObjectRemoved && this._onObjectRemoved(arguments[i]);
	      }
	    }

	    this.renderOnAddRemove && somethingRemoved && this.requestRenderAll();
	    return this;
	  },

	  /**
	   * Executes given function for each object in this group
	   * @param {Function} callback
	   *                   Callback invoked with current object as first argument,
	   *                   index - as second and an array of all objects - as third.
	   *                   Callback is invoked in a context of Global Object (e.g. `window`)
	   *                   when no `context` argument is given
	   *
	   * @param {Object} context Context (aka thisObject)
	   * @return {Self} thisArg
	   * @chainable
	   */
	  forEachObject: function(callback, context) {
	    var objects = this.getObjects();
	    for (var i = 0, len = objects.length; i < len; i++) {
	      callback.call(context, objects[i], i, objects);
	    }
	    return this;
	  },

	  /**
	   * Returns an array of children objects of this instance
	   * Type parameter introduced in 1.3.10
	   * since 2.3.5 this method return always a COPY of the array;
	   * @param {String} [type] When specified, only objects of this type are returned
	   * @return {Array}
	   */
	  getObjects: function(type) {
	    if (typeof type === 'undefined') {
	      return this._objects.concat();
	    }
	    return this._objects.filter(function(o) {
	      return o.type === type;
	    });
	  },

	  /**
	   * Returns object at specified index
	   * @param {Number} index
	   * @return {Self} thisArg
	   */
	  item: function (index) {
	    return this._objects[index];
	  },

	  /**
	   * Returns true if collection contains no objects
	   * @return {Boolean} true if collection is empty
	   */
	  isEmpty: function () {
	    return this._objects.length === 0;
	  },

	  /**
	   * Returns a size of a collection (i.e: length of an array containing its objects)
	   * @return {Number} Collection size
	   */
	  size: function() {
	    return this._objects.length;
	  },

	  /**
	   * Returns true if collection contains an object
	   * @param {Object} object Object to check against
	   * @param {Boolean} [deep=false] `true` to check all descendants, `false` to check only `_objects`
	   * @return {Boolean} `true` if collection contains an object
	   */
	  contains: function (object, deep) {
	    if (this._objects.indexOf(object) > -1) {
	      return true;
	    }
	    else if (deep) {
	      return this._objects.some(function (obj) {
	        return typeof obj.contains === 'function' && obj.contains(object, true);
	      });
	    }
	    return false;
	  },

	  /**
	   * Returns number representation of a collection complexity
	   * @return {Number} complexity
	   */
	  complexity: function () {
	    return this._objects.reduce(function (memo, current) {
	      memo += current.complexity ? current.complexity() : 0;
	      return memo;
	    }, 0);
	  }
	};


	/**
	 * @namespace fabric.CommonMethods
	 */
	fabric.CommonMethods = {

	  /**
	   * Sets object's properties from options
	   * @param {Object} [options] Options object
	   */
	  _setOptions: function(options) {
	    for (var prop in options) {
	      this.set(prop, options[prop]);
	    }
	  },

	  /**
	   * @private
	   * @param {Object} [filler] Options object
	   * @param {String} [property] property to set the Gradient to
	   */
	  _initGradient: function(filler, property) {
	    if (filler && filler.colorStops && !(filler instanceof fabric.Gradient)) {
	      this.set(property, new fabric.Gradient(filler));
	    }
	  },

	  /**
	   * @private
	   * @param {Object} [filler] Options object
	   * @param {String} [property] property to set the Pattern to
	   * @param {Function} [callback] callback to invoke after pattern load
	   */
	  _initPattern: function(filler, property, callback) {
	    if (filler && filler.source && !(filler instanceof fabric.Pattern)) {
	      this.set(property, new fabric.Pattern(filler, callback));
	    }
	    else {
	      callback && callback();
	    }
	  },

	  /**
	   * @private
	   */
	  _setObject: function(obj) {
	    for (var prop in obj) {
	      this._set(prop, obj[prop]);
	    }
	  },

	  /**
	   * Sets property to a given value. When changing position/dimension -related properties (left, top, scale, angle, etc.) `set` does not update position of object's borders/controls. If you need to update those, call `setCoords()`.
	   * @param {String|Object} key Property name or object (if object, iterate over the object properties)
	   * @param {Object|Function} value Property value (if function, the value is passed into it and its return value is used as a new one)
	   * @return {fabric.Object} thisArg
	   * @chainable
	   */
	  set: function(key, value) {
	    if (typeof key === 'object') {
	      this._setObject(key);
	    }
	    else {
	      this._set(key, value);
	    }
	    return this;
	  },

	  _set: function(key, value) {
	    this[key] = value;
	  },

	  /**
	   * Toggles specified property from `true` to `false` or from `false` to `true`
	   * @param {String} property Property to toggle
	   * @return {fabric.Object} thisArg
	   * @chainable
	   */
	  toggle: function(property) {
	    var value = this.get(property);
	    if (typeof value === 'boolean') {
	      this.set(property, !value);
	    }
	    return this;
	  },

	  /**
	   * Basic getter
	   * @param {String} property Property name
	   * @return {*} value of a property
	   */
	  get: function(property) {
	    return this[property];
	  }
	};


	(function(global) {

	  var sqrt = Math.sqrt,
	      atan2 = Math.atan2,
	      pow = Math.pow,
	      PiBy180 = Math.PI / 180,
	      PiBy2 = Math.PI / 2;

	  /**
	   * @namespace fabric.util
	   */
	  fabric.util = {

	    /**
	     * Calculate the cos of an angle, avoiding returning floats for known results
	     * @static
	     * @memberOf fabric.util
	     * @param {Number} angle the angle in radians or in degree
	     * @return {Number}
	     */
	    cos: function(angle) {
	      if (angle === 0) { return 1; }
	      if (angle < 0) {
	        // cos(a) = cos(-a)
	        angle = -angle;
	      }
	      var angleSlice = angle / PiBy2;
	      switch (angleSlice) {
	        case 1: case 3: return 0;
	        case 2: return -1;
	      }
	      return Math.cos(angle);
	    },

	    /**
	     * Calculate the sin of an angle, avoiding returning floats for known results
	     * @static
	     * @memberOf fabric.util
	     * @param {Number} angle the angle in radians or in degree
	     * @return {Number}
	     */
	    sin: function(angle) {
	      if (angle === 0) { return 0; }
	      var angleSlice = angle / PiBy2, sign = 1;
	      if (angle < 0) {
	        // sin(-a) = -sin(a)
	        sign = -1;
	      }
	      switch (angleSlice) {
	        case 1: return sign;
	        case 2: return 0;
	        case 3: return -sign;
	      }
	      return Math.sin(angle);
	    },

	    /**
	     * Removes value from an array.
	     * Presence of value (and its position in an array) is determined via `Array.prototype.indexOf`
	     * @static
	     * @memberOf fabric.util
	     * @param {Array} array
	     * @param {*} value
	     * @return {Array} original array
	     */
	    removeFromArray: function(array, value) {
	      var idx = array.indexOf(value);
	      if (idx !== -1) {
	        array.splice(idx, 1);
	      }
	      return array;
	    },

	    /**
	     * Returns random number between 2 specified ones.
	     * @static
	     * @memberOf fabric.util
	     * @param {Number} min lower limit
	     * @param {Number} max upper limit
	     * @return {Number} random value (between min and max)
	     */
	    getRandomInt: function(min, max) {
	      return Math.floor(Math.random() * (max - min + 1)) + min;
	    },

	    /**
	     * Transforms degrees to radians.
	     * @static
	     * @memberOf fabric.util
	     * @param {Number} degrees value in degrees
	     * @return {Number} value in radians
	     */
	    degreesToRadians: function(degrees) {
	      return degrees * PiBy180;
	    },

	    /**
	     * Transforms radians to degrees.
	     * @static
	     * @memberOf fabric.util
	     * @param {Number} radians value in radians
	     * @return {Number} value in degrees
	     */
	    radiansToDegrees: function(radians) {
	      return radians / PiBy180;
	    },

	    /**
	     * Rotates `point` around `origin` with `radians`
	     * @static
	     * @memberOf fabric.util
	     * @param {fabric.Point} point The point to rotate
	     * @param {fabric.Point} origin The origin of the rotation
	     * @param {Number} radians The radians of the angle for the rotation
	     * @return {fabric.Point} The new rotated point
	     */
	    rotatePoint: function(point, origin, radians) {
	      var newPoint = new fabric.Point(point.x - origin.x, point.y - origin.y),
	          v = fabric.util.rotateVector(newPoint, radians);
	      return new fabric.Point(v.x, v.y).addEquals(origin);
	    },

	    /**
	     * Rotates `vector` with `radians`
	     * @static
	     * @memberOf fabric.util
	     * @param {Object} vector The vector to rotate (x and y)
	     * @param {Number} radians The radians of the angle for the rotation
	     * @return {Object} The new rotated point
	     */
	    rotateVector: function(vector, radians) {
	      var sin = fabric.util.sin(radians),
	          cos = fabric.util.cos(radians),
	          rx = vector.x * cos - vector.y * sin,
	          ry = vector.x * sin + vector.y * cos;
	      return {
	        x: rx,
	        y: ry
	      };
	    },

	    /**
	     * Apply transform t to point p
	     * @static
	     * @memberOf fabric.util
	     * @param  {fabric.Point} p The point to transform
	     * @param  {Array} t The transform
	     * @param  {Boolean} [ignoreOffset] Indicates that the offset should not be applied
	     * @return {fabric.Point} The transformed point
	     */
	    transformPoint: function(p, t, ignoreOffset) {
	      if (ignoreOffset) {
	        return new fabric.Point(
	          t[0] * p.x + t[2] * p.y,
	          t[1] * p.x + t[3] * p.y
	        );
	      }
	      return new fabric.Point(
	        t[0] * p.x + t[2] * p.y + t[4],
	        t[1] * p.x + t[3] * p.y + t[5]
	      );
	    },

	    /**
	     * Returns coordinates of points's bounding rectangle (left, top, width, height)
	     * @param {Array} points 4 points array
	     * @param {Array} [transform] an array of 6 numbers representing a 2x3 transform matrix
	     * @return {Object} Object with left, top, width, height properties
	     */
	    makeBoundingBoxFromPoints: function(points, transform) {
	      if (transform) {
	        for (var i = 0; i < points.length; i++) {
	          points[i] = fabric.util.transformPoint(points[i], transform);
	        }
	      }
	      var xPoints = [points[0].x, points[1].x, points[2].x, points[3].x],
	          minX = fabric.util.array.min(xPoints),
	          maxX = fabric.util.array.max(xPoints),
	          width = maxX - minX,
	          yPoints = [points[0].y, points[1].y, points[2].y, points[3].y],
	          minY = fabric.util.array.min(yPoints),
	          maxY = fabric.util.array.max(yPoints),
	          height = maxY - minY;

	      return {
	        left: minX,
	        top: minY,
	        width: width,
	        height: height
	      };
	    },

	    /**
	     * Invert transformation t
	     * @static
	     * @memberOf fabric.util
	     * @param {Array} t The transform
	     * @return {Array} The inverted transform
	     */
	    invertTransform: function(t) {
	      var a = 1 / (t[0] * t[3] - t[1] * t[2]),
	          r = [a * t[3], -a * t[1], -a * t[2], a * t[0]],
	          o = fabric.util.transformPoint({ x: t[4], y: t[5] }, r, true);
	      r[4] = -o.x;
	      r[5] = -o.y;
	      return r;
	    },

	    /**
	     * A wrapper around Number#toFixed, which contrary to native method returns number, not string.
	     * @static
	     * @memberOf fabric.util
	     * @param {Number|String} number number to operate on
	     * @param {Number} fractionDigits number of fraction digits to "leave"
	     * @return {Number}
	     */
	    toFixed: function(number, fractionDigits) {
	      return parseFloat(Number(number).toFixed(fractionDigits));
	    },

	    /**
	     * Converts from attribute value to pixel value if applicable.
	     * Returns converted pixels or original value not converted.
	     * @param {Number|String} value number to operate on
	     * @param {Number} fontSize
	     * @return {Number|String}
	     */
	    parseUnit: function(value, fontSize) {
	      var unit = /\D{0,2}$/.exec(value),
	          number = parseFloat(value);
	      if (!fontSize) {
	        fontSize = fabric.Text.DEFAULT_SVG_FONT_SIZE;
	      }
	      switch (unit[0]) {
	        case 'mm':
	          return number * fabric.DPI / 25.4;

	        case 'cm':
	          return number * fabric.DPI / 2.54;

	        case 'in':
	          return number * fabric.DPI;

	        case 'pt':
	          return number * fabric.DPI / 72; // or * 4 / 3

	        case 'pc':
	          return number * fabric.DPI / 72 * 12; // or * 16

	        case 'em':
	          return number * fontSize;

	        default:
	          return number;
	      }
	    },

	    /**
	     * Function which always returns `false`.
	     * @static
	     * @memberOf fabric.util
	     * @return {Boolean}
	     */
	    falseFunction: function() {
	      return false;
	    },

	    /**
	     * Returns klass "Class" object of given namespace
	     * @memberOf fabric.util
	     * @param {String} type Type of object (eg. 'circle')
	     * @param {String} namespace Namespace to get klass "Class" object from
	     * @return {Object} klass "Class"
	     */
	    getKlass: function(type, namespace) {
	      // capitalize first letter only
	      type = fabric.util.string.camelize(type.charAt(0).toUpperCase() + type.slice(1));
	      return fabric.util.resolveNamespace(namespace)[type];
	    },

	    /**
	     * Returns array of attributes for given svg that fabric parses
	     * @memberOf fabric.util
	     * @param {String} type Type of svg element (eg. 'circle')
	     * @return {Array} string names of supported attributes
	     */
	    getSvgAttributes: function(type) {
	      var attributes = [
	        'instantiated_by_use',
	        'style',
	        'id',
	        'class'
	      ];
	      switch (type) {
	        case 'linearGradient':
	          attributes = attributes.concat(['x1', 'y1', 'x2', 'y2', 'gradientUnits', 'gradientTransform']);
	          break;
	        case 'radialGradient':
	          attributes = attributes.concat(['gradientUnits', 'gradientTransform', 'cx', 'cy', 'r', 'fx', 'fy', 'fr']);
	          break;
	        case 'stop':
	          attributes = attributes.concat(['offset', 'stop-color', 'stop-opacity']);
	          break;
	      }
	      return attributes;
	    },

	    /**
	     * Returns object of given namespace
	     * @memberOf fabric.util
	     * @param {String} namespace Namespace string e.g. 'fabric.Image.filter' or 'fabric'
	     * @return {Object} Object for given namespace (default fabric)
	     */
	    resolveNamespace: function(namespace) {
	      if (!namespace) {
	        return fabric;
	      }

	      var parts = namespace.split('.'),
	          len = parts.length, i,
	          obj = global || fabric.window;

	      for (i = 0; i < len; ++i) {
	        obj = obj[parts[i]];
	      }

	      return obj;
	    },

	    /**
	     * Loads image element from given url and passes it to a callback
	     * @memberOf fabric.util
	     * @param {String} url URL representing an image
	     * @param {Function} callback Callback; invoked with loaded image
	     * @param {*} [context] Context to invoke callback in
	     * @param {Object} [crossOrigin] crossOrigin value to set image element to
	     */
	    loadImage: function(url, callback, context, crossOrigin) {
	      if (!url) {
	        callback && callback.call(context, url);
	        return;
	      }

	      var img = fabric.util.createImage();

	      /** @ignore */
	      var onLoadCallback = function () {
	        callback && callback.call(context, img, false);
	        img = img.onload = img.onerror = null;
	      };

	      img.onload = onLoadCallback;
	      /** @ignore */
	      img.onerror = function() {
	        fabric.log('Error loading ' + img.src);
	        callback && callback.call(context, null, true);
	        img = img.onload = img.onerror = null;
	      };

	      // data-urls appear to be buggy with crossOrigin
	      // https://github.com/kangax/fabric.js/commit/d0abb90f1cd5c5ef9d2a94d3fb21a22330da3e0a#commitcomment-4513767
	      // see https://code.google.com/p/chromium/issues/detail?id=315152
	      //     https://bugzilla.mozilla.org/show_bug.cgi?id=935069
	      // crossOrigin null is the same as not set.
	      if (url.indexOf('data') !== 0 &&
	        crossOrigin !== undefined &&
	        crossOrigin !== null) {
	        img.crossOrigin = crossOrigin;
	      }

	      // IE10 / IE11-Fix: SVG contents from data: URI
	      // will only be available if the IMG is present
	      // in the DOM (and visible)
	      if (url.substring(0,14) === 'data:image/svg') {
	        img.onload = null;
	        fabric.util.loadImageInDom(img, onLoadCallback);
	      }

	      img.src = url;
	    },

	    /**
	     * Attaches SVG image with data: URL to the dom
	     * @memberOf fabric.util
	     * @param {Object} img Image object with data:image/svg src
	     * @param {Function} callback Callback; invoked with loaded image
	     * @return {Object} DOM element (div containing the SVG image)
	     */
	    loadImageInDom: function(img, onLoadCallback) {
	      var div = fabric.document.createElement('div');
	      div.style.width = div.style.height = '1px';
	      div.style.left = div.style.top = '-100%';
	      div.style.position = 'absolute';
	      div.appendChild(img);
	      fabric.document.querySelector('body').appendChild(div);
	      /**
	       * Wrap in function to:
	       *   1. Call existing callback
	       *   2. Cleanup DOM
	       */
	      img.onload = function () {
	        onLoadCallback();
	        div.parentNode.removeChild(div);
	        div = null;
	      };
	    },

	    /**
	     * Creates corresponding fabric instances from their object representations
	     * @static
	     * @memberOf fabric.util
	     * @param {Array} objects Objects to enliven
	     * @param {Function} callback Callback to invoke when all objects are created
	     * @param {String} namespace Namespace to get klass "Class" object from
	     * @param {Function} reviver Method for further parsing of object elements,
	     * called after each fabric object created.
	     */
	    enlivenObjects: function(objects, callback, namespace, reviver) {
	      objects = objects || [];

	      var enlivenedObjects = [],
	          numLoadedObjects = 0,
	          numTotalObjects = objects.length;

	      function onLoaded() {
	        if (++numLoadedObjects === numTotalObjects) {
	          callback && callback(enlivenedObjects.filter(function(obj) {
	            // filter out undefined objects (objects that gave error)
	            return obj;
	          }));
	        }
	      }

	      if (!numTotalObjects) {
	        callback && callback(enlivenedObjects);
	        return;
	      }

	      objects.forEach(function (o, index) {
	        // if sparse array
	        if (!o || !o.type) {
	          onLoaded();
	          return;
	        }
	        var klass = fabric.util.getKlass(o.type, namespace);
	        klass.fromObject(o, function (obj, error) {
	          error || (enlivenedObjects[index] = obj);
	          reviver && reviver(o, obj, error);
	          onLoaded();
	        });
	      });
	    },

	    /**
	     * Create and wait for loading of patterns
	     * @static
	     * @memberOf fabric.util
	     * @param {Array} patterns Objects to enliven
	     * @param {Function} callback Callback to invoke when all objects are created
	     * called after each fabric object created.
	     */
	    enlivenPatterns: function(patterns, callback) {
	      patterns = patterns || [];

	      function onLoaded() {
	        if (++numLoadedPatterns === numPatterns) {
	          callback && callback(enlivenedPatterns);
	        }
	      }

	      var enlivenedPatterns = [],
	          numLoadedPatterns = 0,
	          numPatterns = patterns.length;

	      if (!numPatterns) {
	        callback && callback(enlivenedPatterns);
	        return;
	      }

	      patterns.forEach(function (p, index) {
	        if (p && p.source) {
	          new fabric.Pattern(p, function(pattern) {
	            enlivenedPatterns[index] = pattern;
	            onLoaded();
	          });
	        }
	        else {
	          enlivenedPatterns[index] = p;
	          onLoaded();
	        }
	      });
	    },

	    /**
	     * Groups SVG elements (usually those retrieved from SVG document)
	     * @static
	     * @memberOf fabric.util
	     * @param {Array} elements SVG elements to group
	     * @param {Object} [options] Options object
	     * @param {String} path Value to set sourcePath to
	     * @return {fabric.Object|fabric.Group}
	     */
	    groupSVGElements: function(elements, options, path) {
	      var object;
	      if (elements && elements.length === 1) {
	        return elements[0];
	      }
	      if (options) {
	        if (options.width && options.height) {
	          options.centerPoint = {
	            x: options.width / 2,
	            y: options.height / 2
	          };
	        }
	        else {
	          delete options.width;
	          delete options.height;
	        }
	      }
	      object = new fabric.Group(elements, options);
	      if (typeof path !== 'undefined') {
	        object.sourcePath = path;
	      }
	      return object;
	    },

	    /**
	     * Populates an object with properties of another object
	     * @static
	     * @memberOf fabric.util
	     * @param {Object} source Source object
	     * @param {Object} destination Destination object
	     * @return {Array} properties Properties names to include
	     */
	    populateWithProperties: function(source, destination, properties) {
	      if (properties && Object.prototype.toString.call(properties) === '[object Array]') {
	        for (var i = 0, len = properties.length; i < len; i++) {
	          if (properties[i] in source) {
	            destination[properties[i]] = source[properties[i]];
	          }
	        }
	      }
	    },

	    /**
	     * WARNING: THIS WAS TO SUPPORT OLD BROWSERS. deprecated.
	     * WILL BE REMOVED IN FABRIC 5.0
	     * Draws a dashed line between two points
	     *
	     * This method is used to draw dashed line around selection area.
	     * See <a href="http://stackoverflow.com/questions/4576724/dotted-stroke-in-canvas">dotted stroke in canvas</a>
	     *
	     * @param {CanvasRenderingContext2D} ctx context
	     * @param {Number} x  start x coordinate
	     * @param {Number} y start y coordinate
	     * @param {Number} x2 end x coordinate
	     * @param {Number} y2 end y coordinate
	     * @param {Array} da dash array pattern
	     * @deprecated
	     */
	    drawDashedLine: function(ctx, x, y, x2, y2, da) {
	      var dx = x2 - x,
	          dy = y2 - y,
	          len = sqrt(dx * dx + dy * dy),
	          rot = atan2(dy, dx),
	          dc = da.length,
	          di = 0,
	          draw = true;

	      ctx.save();
	      ctx.translate(x, y);
	      ctx.moveTo(0, 0);
	      ctx.rotate(rot);

	      x = 0;
	      while (len > x) {
	        x += da[di++ % dc];
	        if (x > len) {
	          x = len;
	        }
	        ctx[draw ? 'lineTo' : 'moveTo'](x, 0);
	        draw = !draw;
	      }

	      ctx.restore();
	    },

	    /**
	     * Creates canvas element
	     * @static
	     * @memberOf fabric.util
	     * @return {CanvasElement} initialized canvas element
	     */
	    createCanvasElement: function() {
	      return fabric.document.createElement('canvas');
	    },

	    /**
	     * Creates a canvas element that is a copy of another and is also painted
	     * @param {CanvasElement} canvas to copy size and content of
	     * @static
	     * @memberOf fabric.util
	     * @return {CanvasElement} initialized canvas element
	     */
	    copyCanvasElement: function(canvas) {
	      var newCanvas = fabric.util.createCanvasElement();
	      newCanvas.width = canvas.width;
	      newCanvas.height = canvas.height;
	      newCanvas.getContext('2d').drawImage(canvas, 0, 0);
	      return newCanvas;
	    },

	    /**
	     * since 2.6.0 moved from canvas instance to utility.
	     * @param {CanvasElement} canvasEl to copy size and content of
	     * @param {String} format 'jpeg' or 'png', in some browsers 'webp' is ok too
	     * @param {Number} quality <= 1 and > 0
	     * @static
	     * @memberOf fabric.util
	     * @return {String} data url
	     */
	    toDataURL: function(canvasEl, format, quality) {
	      return canvasEl.toDataURL('image/' + format, quality);
	    },

	    /**
	     * Creates image element (works on client and node)
	     * @static
	     * @memberOf fabric.util
	     * @return {HTMLImageElement} HTML image element
	     */
	    createImage: function() {
	      return fabric.document.createElement('img');
	    },

	    /**
	     * Multiply matrix A by matrix B to nest transformations
	     * @static
	     * @memberOf fabric.util
	     * @param  {Array} a First transformMatrix
	     * @param  {Array} b Second transformMatrix
	     * @param  {Boolean} is2x2 flag to multiply matrices as 2x2 matrices
	     * @return {Array} The product of the two transform matrices
	     */
	    multiplyTransformMatrices: function(a, b, is2x2) {
	      // Matrix multiply a * b
	      return [
	        a[0] * b[0] + a[2] * b[1],
	        a[1] * b[0] + a[3] * b[1],
	        a[0] * b[2] + a[2] * b[3],
	        a[1] * b[2] + a[3] * b[3],
	        is2x2 ? 0 : a[0] * b[4] + a[2] * b[5] + a[4],
	        is2x2 ? 0 : a[1] * b[4] + a[3] * b[5] + a[5]
	      ];
	    },

	    /**
	     * Decomposes standard 2x3 matrix into transform components
	     * @static
	     * @memberOf fabric.util
	     * @param  {Array} a transformMatrix
	     * @return {Object} Components of transform
	     */
	    qrDecompose: function(a) {
	      var angle = atan2(a[1], a[0]),
	          denom = pow(a[0], 2) + pow(a[1], 2),
	          scaleX = sqrt(denom),
	          scaleY = (a[0] * a[3] - a[2] * a[1]) / scaleX,
	          skewX = atan2(a[0] * a[2] + a[1] * a [3], denom);
	      return {
	        angle: angle / PiBy180,
	        scaleX: scaleX,
	        scaleY: scaleY,
	        skewX: skewX / PiBy180,
	        skewY: 0,
	        translateX: a[4],
	        translateY: a[5]
	      };
	    },

	    /**
	     * Returns a transform matrix starting from an object of the same kind of
	     * the one returned from qrDecompose, useful also if you want to calculate some
	     * transformations from an object that is not enlived yet
	     * @static
	     * @memberOf fabric.util
	     * @param  {Object} options
	     * @param  {Number} [options.angle] angle in degrees
	     * @return {Number[]} transform matrix
	     */
	    calcRotateMatrix: function(options) {
	      if (!options.angle) {
	        return fabric.iMatrix.concat();
	      }
	      var theta = fabric.util.degreesToRadians(options.angle),
	          cos = fabric.util.cos(theta),
	          sin = fabric.util.sin(theta);
	      return [cos, sin, -sin, cos, 0, 0];
	    },

	    /**
	     * Returns a transform matrix starting from an object of the same kind of
	     * the one returned from qrDecompose, useful also if you want to calculate some
	     * transformations from an object that is not enlived yet.
	     * is called DimensionsTransformMatrix because those properties are the one that influence
	     * the size of the resulting box of the object.
	     * @static
	     * @memberOf fabric.util
	     * @param  {Object} options
	     * @param  {Number} [options.scaleX]
	     * @param  {Number} [options.scaleY]
	     * @param  {Boolean} [options.flipX]
	     * @param  {Boolean} [options.flipY]
	     * @param  {Number} [options.skewX]
	     * @param  {Number} [options.skewX]
	     * @return {Number[]} transform matrix
	     */
	    calcDimensionsMatrix: function(options) {
	      var scaleX = typeof options.scaleX === 'undefined' ? 1 : options.scaleX,
	          scaleY = typeof options.scaleY === 'undefined' ? 1 : options.scaleY,
	          scaleMatrix = [
	            options.flipX ? -scaleX : scaleX,
	            0,
	            0,
	            options.flipY ? -scaleY : scaleY,
	            0,
	            0],
	          multiply = fabric.util.multiplyTransformMatrices,
	          degreesToRadians = fabric.util.degreesToRadians;
	      if (options.skewX) {
	        scaleMatrix = multiply(
	          scaleMatrix,
	          [1, 0, Math.tan(degreesToRadians(options.skewX)), 1],
	          true);
	      }
	      if (options.skewY) {
	        scaleMatrix = multiply(
	          scaleMatrix,
	          [1, Math.tan(degreesToRadians(options.skewY)), 0, 1],
	          true);
	      }
	      return scaleMatrix;
	    },

	    /**
	     * Returns a transform matrix starting from an object of the same kind of
	     * the one returned from qrDecompose, useful also if you want to calculate some
	     * transformations from an object that is not enlived yet
	     * @static
	     * @memberOf fabric.util
	     * @param  {Object} options
	     * @param  {Number} [options.angle]
	     * @param  {Number} [options.scaleX]
	     * @param  {Number} [options.scaleY]
	     * @param  {Boolean} [options.flipX]
	     * @param  {Boolean} [options.flipY]
	     * @param  {Number} [options.skewX]
	     * @param  {Number} [options.skewX]
	     * @param  {Number} [options.translateX]
	     * @param  {Number} [options.translateY]
	     * @return {Number[]} transform matrix
	     */
	    composeMatrix: function(options) {
	      var matrix = [1, 0, 0, 1, options.translateX || 0, options.translateY || 0],
	          multiply = fabric.util.multiplyTransformMatrices;
	      if (options.angle) {
	        matrix = multiply(matrix, fabric.util.calcRotateMatrix(options));
	      }
	      if (options.scaleX !== 1 || options.scaleY !== 1 ||
	          options.skewX || options.skewY || options.flipX || options.flipY) {
	        matrix = multiply(matrix, fabric.util.calcDimensionsMatrix(options));
	      }
	      return matrix;
	    },

	    /**
	     * reset an object transform state to neutral. Top and left are not accounted for
	     * @static
	     * @memberOf fabric.util
	     * @param  {fabric.Object} target object to transform
	     */
	    resetObjectTransform: function (target) {
	      target.scaleX = 1;
	      target.scaleY = 1;
	      target.skewX = 0;
	      target.skewY = 0;
	      target.flipX = false;
	      target.flipY = false;
	      target.rotate(0);
	    },

	    /**
	     * Extract Object transform values
	     * @static
	     * @memberOf fabric.util
	     * @param  {fabric.Object} target object to read from
	     * @return {Object} Components of transform
	     */
	    saveObjectTransform: function (target) {
	      return {
	        scaleX: target.scaleX,
	        scaleY: target.scaleY,
	        skewX: target.skewX,
	        skewY: target.skewY,
	        angle: target.angle,
	        left: target.left,
	        flipX: target.flipX,
	        flipY: target.flipY,
	        top: target.top
	      };
	    },

	    /**
	     * Returns true if context has transparent pixel
	     * at specified location (taking tolerance into account)
	     * @param {CanvasRenderingContext2D} ctx context
	     * @param {Number} x x coordinate
	     * @param {Number} y y coordinate
	     * @param {Number} tolerance Tolerance
	     */
	    isTransparent: function(ctx, x, y, tolerance) {

	      // If tolerance is > 0 adjust start coords to take into account.
	      // If moves off Canvas fix to 0
	      if (tolerance > 0) {
	        if (x > tolerance) {
	          x -= tolerance;
	        }
	        else {
	          x = 0;
	        }
	        if (y > tolerance) {
	          y -= tolerance;
	        }
	        else {
	          y = 0;
	        }
	      }

	      var _isTransparent = true, i, temp,
	          imageData = ctx.getImageData(x, y, (tolerance * 2) || 1, (tolerance * 2) || 1),
	          l = imageData.data.length;

	      // Split image data - for tolerance > 1, pixelDataSize = 4;
	      for (i = 3; i < l; i += 4) {
	        temp = imageData.data[i];
	        _isTransparent = temp <= 0;
	        if (_isTransparent === false) {
	          break; // Stop if colour found
	        }
	      }

	      imageData = null;

	      return _isTransparent;
	    },

	    /**
	     * Parse preserveAspectRatio attribute from element
	     * @param {string} attribute to be parsed
	     * @return {Object} an object containing align and meetOrSlice attribute
	     */
	    parsePreserveAspectRatioAttribute: function(attribute) {
	      var meetOrSlice = 'meet', alignX = 'Mid', alignY = 'Mid',
	          aspectRatioAttrs = attribute.split(' '), align;

	      if (aspectRatioAttrs && aspectRatioAttrs.length) {
	        meetOrSlice = aspectRatioAttrs.pop();
	        if (meetOrSlice !== 'meet' && meetOrSlice !== 'slice') {
	          align = meetOrSlice;
	          meetOrSlice = 'meet';
	        }
	        else if (aspectRatioAttrs.length) {
	          align = aspectRatioAttrs.pop();
	        }
	      }
	      //divide align in alignX and alignY
	      alignX = align !== 'none' ? align.slice(1, 4) : 'none';
	      alignY = align !== 'none' ? align.slice(5, 8) : 'none';
	      return {
	        meetOrSlice: meetOrSlice,
	        alignX: alignX,
	        alignY: alignY
	      };
	    },

	    /**
	     * Clear char widths cache for the given font family or all the cache if no
	     * fontFamily is specified.
	     * Use it if you know you are loading fonts in a lazy way and you are not waiting
	     * for custom fonts to load properly when adding text objects to the canvas.
	     * If a text object is added when its own font is not loaded yet, you will get wrong
	     * measurement and so wrong bounding boxes.
	     * After the font cache is cleared, either change the textObject text content or call
	     * initDimensions() to trigger a recalculation
	     * @memberOf fabric.util
	     * @param {String} [fontFamily] font family to clear
	     */
	    clearFabricFontCache: function(fontFamily) {
	      fontFamily = (fontFamily || '').toLowerCase();
	      if (!fontFamily) {
	        fabric.charWidthsCache = { };
	      }
	      else if (fabric.charWidthsCache[fontFamily]) {
	        delete fabric.charWidthsCache[fontFamily];
	      }
	    },

	    /**
	     * Given current aspect ratio, determines the max width and height that can
	     * respect the total allowed area for the cache.
	     * @memberOf fabric.util
	     * @param {Number} ar aspect ratio
	     * @param {Number} maximumArea Maximum area you want to achieve
	     * @return {Object.x} Limited dimensions by X
	     * @return {Object.y} Limited dimensions by Y
	     */
	    limitDimsByArea: function(ar, maximumArea) {
	      var roughWidth = Math.sqrt(maximumArea * ar),
	          perfLimitSizeY = Math.floor(maximumArea / roughWidth);
	      return { x: Math.floor(roughWidth), y: perfLimitSizeY };
	    },

	    capValue: function(min, value, max) {
	      return Math.max(min, Math.min(value, max));
	    },

	    /**
	     * Finds the scale for the object source to fit inside the object destination,
	     * keeping aspect ratio intact.
	     * respect the total allowed area for the cache.
	     * @memberOf fabric.util
	     * @param {Object | fabric.Object} source
	     * @param {Number} source.height natural unscaled height of the object
	     * @param {Number} source.width natural unscaled width of the object
	     * @param {Object | fabric.Object} destination
	     * @param {Number} destination.height natural unscaled height of the object
	     * @param {Number} destination.width natural unscaled width of the object
	     * @return {Number} scale factor to apply to source to fit into destination
	     */
	    findScaleToFit: function(source, destination) {
	      return Math.min(destination.width / source.width, destination.height / source.height);
	    },

	    /**
	     * Finds the scale for the object source to cover entirely the object destination,
	     * keeping aspect ratio intact.
	     * respect the total allowed area for the cache.
	     * @memberOf fabric.util
	     * @param {Object | fabric.Object} source
	     * @param {Number} source.height natural unscaled height of the object
	     * @param {Number} source.width natural unscaled width of the object
	     * @param {Object | fabric.Object} destination
	     * @param {Number} destination.height natural unscaled height of the object
	     * @param {Number} destination.width natural unscaled width of the object
	     * @return {Number} scale factor to apply to source to cover destination
	     */
	    findScaleToCover: function(source, destination) {
	      return Math.max(destination.width / source.width, destination.height / source.height);
	    },

	    /**
	     * given an array of 6 number returns something like `"matrix(...numbers)"`
	     * @memberOf fabric.util
	     * @param {Array} transform an array with 6 numbers
	     * @return {String} transform matrix for svg
	     * @return {Object.y} Limited dimensions by Y
	     */
	    matrixToSVG: function(transform) {
	      return 'matrix(' + transform.map(function(value) {
	        return fabric.util.toFixed(value, fabric.Object.NUM_FRACTION_DIGITS);
	      }).join(' ') + ')';
	    },

	    /**
	     * given an object and a transform, apply the inverse transform to the object,
	     * this is equivalent to remove from that object that transformation, so that
	     * added in a space with the removed transform, the object will be the same as before.
	     * Removing from an object a transform that scale by 2 is like scaling it by 1/2.
	     * Removing from an object a transfrom that rotate by 30deg is like rotating by 30deg
	     * in the opposite direction.
	     * This util is used to add objects inside transformed groups or nested groups.
	     * @memberOf fabric.util
	     * @param {fabric.Object} object the object you want to transform
	     * @param {Array} transform the destination transform
	     */
	    removeTransformFromObject: function(object, transform) {
	      var inverted = fabric.util.invertTransform(transform),
	          finalTransform = fabric.util.multiplyTransformMatrices(inverted, object.calcOwnMatrix());
	      fabric.util.applyTransformToObject(object, finalTransform);
	    },

	    /**
	     * given an object and a transform, apply the transform to the object.
	     * this is equivalent to change the space where the object is drawn.
	     * Adding to an object a transform that scale by 2 is like scaling it by 2.
	     * This is used when removing an object from an active selection for example.
	     * @memberOf fabric.util
	     * @param {fabric.Object} object the object you want to transform
	     * @param {Array} transform the destination transform
	     */
	    addTransformToObject: function(object, transform) {
	      fabric.util.applyTransformToObject(
	        object,
	        fabric.util.multiplyTransformMatrices(transform, object.calcOwnMatrix())
	      );
	    },

	    /**
	     * discard an object transform state and apply the one from the matrix.
	     * @memberOf fabric.util
	     * @param {fabric.Object} object the object you want to transform
	     * @param {Array} transform the destination transform
	     */
	    applyTransformToObject: function(object, transform) {
	      var options = fabric.util.qrDecompose(transform),
	          center = new fabric.Point(options.translateX, options.translateY);
	      object.flipX = false;
	      object.flipY = false;
	      object.set('scaleX', options.scaleX);
	      object.set('scaleY', options.scaleY);
	      object.skewX = options.skewX;
	      object.skewY = options.skewY;
	      object.angle = options.angle;
	      object.setPositionByOrigin(center, 'center', 'center');
	    },

	    /**
	     * given a width and height, return the size of the bounding box
	     * that can contains the box with width/height with applied transform
	     * described in options.
	     * Use to calculate the boxes around objects for controls.
	     * @memberOf fabric.util
	     * @param {Number} width
	     * @param {Number} height
	     * @param {Object} options
	     * @param {Number} options.scaleX
	     * @param {Number} options.scaleY
	     * @param {Number} options.skewX
	     * @param {Number} options.skewY
	     * @return {Object.x} width of containing
	     * @return {Object.y} height of containing
	     */
	    sizeAfterTransform: function(width, height, options) {
	      var dimX = width / 2, dimY = height / 2,
	          points = [
	            {
	              x: -dimX,
	              y: -dimY
	            },
	            {
	              x: dimX,
	              y: -dimY
	            },
	            {
	              x: -dimX,
	              y: dimY
	            },
	            {
	              x: dimX,
	              y: dimY
	            }],
	          transformMatrix = fabric.util.calcDimensionsMatrix(options),
	          bbox = fabric.util.makeBoundingBoxFromPoints(points, transformMatrix);
	      return {
	        x: bbox.width,
	        y: bbox.height,
	      };
	    }
	  };
	})(exports );


	(function() {
	  var _join = Array.prototype.join,
	      commandLengths = {
	        m: 2,
	        l: 2,
	        h: 1,
	        v: 1,
	        c: 6,
	        s: 4,
	        q: 4,
	        t: 2,
	        a: 7
	      },
	      repeatedCommands = {
	        m: 'l',
	        M: 'L'
	      };
	  function segmentToBezier(th2, th3, cosTh, sinTh, rx, ry, cx1, cy1, mT, fromX, fromY) {
	    var costh2 = fabric.util.cos(th2),
	        sinth2 = fabric.util.sin(th2),
	        costh3 = fabric.util.cos(th3),
	        sinth3 = fabric.util.sin(th3),
	        toX = cosTh * rx * costh3 - sinTh * ry * sinth3 + cx1,
	        toY = sinTh * rx * costh3 + cosTh * ry * sinth3 + cy1,
	        cp1X = fromX + mT * ( -cosTh * rx * sinth2 - sinTh * ry * costh2),
	        cp1Y = fromY + mT * ( -sinTh * rx * sinth2 + cosTh * ry * costh2),
	        cp2X = toX + mT * ( cosTh * rx * sinth3 + sinTh * ry * costh3),
	        cp2Y = toY + mT * ( sinTh * rx * sinth3 - cosTh * ry * costh3);

	    return ['C',
	      cp1X, cp1Y,
	      cp2X, cp2Y,
	      toX, toY
	    ];
	  }

	  /* Adapted from http://dxr.mozilla.org/mozilla-central/source/content/svg/content/src/nsSVGPathDataParser.cpp
	   * by Andrea Bogazzi code is under MPL. if you don't have a copy of the license you can take it here
	   * http://mozilla.org/MPL/2.0/
	   */
	  function arcToSegments(toX, toY, rx, ry, large, sweep, rotateX) {
	    var PI = Math.PI, th = rotateX * PI / 180,
	        sinTh = fabric.util.sin(th),
	        cosTh = fabric.util.cos(th),
	        fromX = 0, fromY = 0;

	    rx = Math.abs(rx);
	    ry = Math.abs(ry);

	    var px = -cosTh * toX * 0.5 - sinTh * toY * 0.5,
	        py = -cosTh * toY * 0.5 + sinTh * toX * 0.5,
	        rx2 = rx * rx, ry2 = ry * ry, py2 = py * py, px2 = px * px,
	        pl = rx2 * ry2 - rx2 * py2 - ry2 * px2,
	        root = 0;

	    if (pl < 0) {
	      var s = Math.sqrt(1 - pl / (rx2 * ry2));
	      rx *= s;
	      ry *= s;
	    }
	    else {
	      root = (large === sweep ? -1.0 : 1.0) *
	              Math.sqrt( pl / (rx2 * py2 + ry2 * px2));
	    }

	    var cx = root * rx * py / ry,
	        cy = -root * ry * px / rx,
	        cx1 = cosTh * cx - sinTh * cy + toX * 0.5,
	        cy1 = sinTh * cx + cosTh * cy + toY * 0.5,
	        mTheta = calcVectorAngle(1, 0, (px - cx) / rx, (py - cy) / ry),
	        dtheta = calcVectorAngle((px - cx) / rx, (py - cy) / ry, (-px - cx) / rx, (-py - cy) / ry);

	    if (sweep === 0 && dtheta > 0) {
	      dtheta -= 2 * PI;
	    }
	    else if (sweep === 1 && dtheta < 0) {
	      dtheta += 2 * PI;
	    }

	    // Convert into cubic bezier segments <= 90deg
	    var segments = Math.ceil(Math.abs(dtheta / PI * 2)),
	        result = [], mDelta = dtheta / segments,
	        mT = 8 / 3 * Math.sin(mDelta / 4) * Math.sin(mDelta / 4) / Math.sin(mDelta / 2),
	        th3 = mTheta + mDelta;

	    for (var i = 0; i < segments; i++) {
	      result[i] = segmentToBezier(mTheta, th3, cosTh, sinTh, rx, ry, cx1, cy1, mT, fromX, fromY);
	      fromX = result[i][5];
	      fromY = result[i][6];
	      mTheta = th3;
	      th3 += mDelta;
	    }
	    return result;
	  }

	  /*
	   * Private
	   */
	  function calcVectorAngle(ux, uy, vx, vy) {
	    var ta = Math.atan2(uy, ux),
	        tb = Math.atan2(vy, vx);
	    if (tb >= ta) {
	      return tb - ta;
	    }
	    else {
	      return 2 * Math.PI - (ta - tb);
	    }
	  }

	  /**
	   * Calculate bounding box of a beziercurve
	   * @param {Number} x0 starting point
	   * @param {Number} y0
	   * @param {Number} x1 first control point
	   * @param {Number} y1
	   * @param {Number} x2 secondo control point
	   * @param {Number} y2
	   * @param {Number} x3 end of bezier
	   * @param {Number} y3
	   */
	  // taken from http://jsbin.com/ivomiq/56/edit  no credits available for that.
	  // TODO: can we normalize this with the starting points set at 0 and then translated the bbox?
	  function getBoundsOfCurve(x0, y0, x1, y1, x2, y2, x3, y3) {
	    var argsString;
	    if (fabric.cachesBoundsOfCurve) {
	      argsString = _join.call(arguments);
	      if (fabric.boundsOfCurveCache[argsString]) {
	        return fabric.boundsOfCurveCache[argsString];
	      }
	    }

	    var sqrt = Math.sqrt,
	        min = Math.min, max = Math.max,
	        abs = Math.abs, tvalues = [],
	        bounds = [[], []],
	        a, b, c, t, t1, t2, b2ac, sqrtb2ac;

	    b = 6 * x0 - 12 * x1 + 6 * x2;
	    a = -3 * x0 + 9 * x1 - 9 * x2 + 3 * x3;
	    c = 3 * x1 - 3 * x0;

	    for (var i = 0; i < 2; ++i) {
	      if (i > 0) {
	        b = 6 * y0 - 12 * y1 + 6 * y2;
	        a = -3 * y0 + 9 * y1 - 9 * y2 + 3 * y3;
	        c = 3 * y1 - 3 * y0;
	      }

	      if (abs(a) < 1e-12) {
	        if (abs(b) < 1e-12) {
	          continue;
	        }
	        t = -c / b;
	        if (0 < t && t < 1) {
	          tvalues.push(t);
	        }
	        continue;
	      }
	      b2ac = b * b - 4 * c * a;
	      if (b2ac < 0) {
	        continue;
	      }
	      sqrtb2ac = sqrt(b2ac);
	      t1 = (-b + sqrtb2ac) / (2 * a);
	      if (0 < t1 && t1 < 1) {
	        tvalues.push(t1);
	      }
	      t2 = (-b - sqrtb2ac) / (2 * a);
	      if (0 < t2 && t2 < 1) {
	        tvalues.push(t2);
	      }
	    }

	    var x, y, j = tvalues.length, jlen = j, mt;
	    while (j--) {
	      t = tvalues[j];
	      mt = 1 - t;
	      x = (mt * mt * mt * x0) + (3 * mt * mt * t * x1) + (3 * mt * t * t * x2) + (t * t * t * x3);
	      bounds[0][j] = x;

	      y = (mt * mt * mt * y0) + (3 * mt * mt * t * y1) + (3 * mt * t * t * y2) + (t * t * t * y3);
	      bounds[1][j] = y;
	    }

	    bounds[0][jlen] = x0;
	    bounds[1][jlen] = y0;
	    bounds[0][jlen + 1] = x3;
	    bounds[1][jlen + 1] = y3;
	    var result = [
	      {
	        x: min.apply(null, bounds[0]),
	        y: min.apply(null, bounds[1])
	      },
	      {
	        x: max.apply(null, bounds[0]),
	        y: max.apply(null, bounds[1])
	      }
	    ];
	    if (fabric.cachesBoundsOfCurve) {
	      fabric.boundsOfCurveCache[argsString] = result;
	    }
	    return result;
	  }

	  /**
	   * Converts arc to a bunch of bezier curves
	   * @param {Number} fx starting point x
	   * @param {Number} fy starting point y
	   * @param {Array} coords Arc command
	   */
	  function fromArcToBeziers(fx, fy, coords) {
	    var rx = coords[1],
	        ry = coords[2],
	        rot = coords[3],
	        large = coords[4],
	        sweep = coords[5],
	        tx = coords[6],
	        ty = coords[7],
	        segsNorm = arcToSegments(tx - fx, ty - fy, rx, ry, large, sweep, rot);

	    for (var i = 0, len = segsNorm.length; i < len; i++) {
	      segsNorm[i][1] += fx;
	      segsNorm[i][2] += fy;
	      segsNorm[i][3] += fx;
	      segsNorm[i][4] += fy;
	      segsNorm[i][5] += fx;
	      segsNorm[i][6] += fy;
	    }
	    return segsNorm;
	  }
	  /**
	   * This function take a parsed SVG path and make it simpler for fabricJS logic.
	   * simplification consist of: only UPPERCASE absolute commands ( relative converted to absolute )
	   * S converted in C, T converted in Q, A converted in C.
	   * @param {Array} path the array of commands of a parsed svg path for fabric.Path
	   * @return {Array} the simplified array of commands of a parsed svg path for fabric.Path
	   */
	  function makePathSimpler(path) {
	    // x and y represent the last point of the path. the previous command point.
	    // we add them to each relative command to make it an absolute comment.
	    // we also swap the v V h H with L, because are easier to transform.
	    var x = 0, y = 0, len = path.length,
	        // x1 and y1 represent the last point of the subpath. the subpath is started with
	        // m or M command. When a z or Z command is drawn, x and y need to be resetted to
	        // the last x1 and y1.
	        x1 = 0, y1 = 0, current, i, converted,
	        // previous will host the letter of the previous command, to handle S and T.
	        // controlX and controlY will host the previous reflected control point
	        destinationPath = [], previous, controlX, controlY;
	    for (i = 0; i < len; ++i) {
	      converted = false;
	      current = path[i].slice(0);
	      switch (current[0]) { // first letter
	        case 'l': // lineto, relative
	          current[0] = 'L';
	          current[1] += x;
	          current[2] += y;
	          // falls through
	        case 'L':
	          x = current[1];
	          y = current[2];
	          break;
	        case 'h': // horizontal lineto, relative
	          current[1] += x;
	          // falls through
	        case 'H':
	          current[0] = 'L';
	          current[2] = y;
	          x = current[1];
	          break;
	        case 'v': // vertical lineto, relative
	          current[1] += y;
	          // falls through
	        case 'V':
	          current[0] = 'L';
	          y = current[1];
	          current[1] = x;
	          current[2] = y;
	          break;
	        case 'm': // moveTo, relative
	          current[0] = 'M';
	          current[1] += x;
	          current[2] += y;
	          // falls through
	        case 'M':
	          x = current[1];
	          y = current[2];
	          x1 = current[1];
	          y1 = current[2];
	          break;
	        case 'c': // bezierCurveTo, relative
	          current[0] = 'C';
	          current[1] += x;
	          current[2] += y;
	          current[3] += x;
	          current[4] += y;
	          current[5] += x;
	          current[6] += y;
	          // falls through
	        case 'C':
	          controlX = current[3];
	          controlY = current[4];
	          x = current[5];
	          y = current[6];
	          break;
	        case 's': // shorthand cubic bezierCurveTo, relative
	          current[0] = 'S';
	          current[1] += x;
	          current[2] += y;
	          current[3] += x;
	          current[4] += y;
	          // falls through
	        case 'S':
	          // would be sScC but since we are swapping sSc for C, we check just that.
	          if (previous === 'C') {
	            // calculate reflection of previous control points
	            controlX = 2 * x - controlX;
	            controlY = 2 * y - controlY;
	          }
	          else {
	            // If there is no previous command or if the previous command was not a C, c, S, or s,
	            // the control point is coincident with the current point
	            controlX = x;
	            controlY = y;
	          }
	          x = current[3];
	          y = current[4];
	          current[0] = 'C';
	          current[5] = current[3];
	          current[6] = current[4];
	          current[3] = current[1];
	          current[4] = current[2];
	          current[1] = controlX;
	          current[2] = controlY;
	          // current[3] and current[4] are NOW the second control point.
	          // we keep it for the next reflection.
	          controlX = current[3];
	          controlY = current[4];
	          break;
	        case 'q': // quadraticCurveTo, relative
	          current[0] = 'Q';
	          current[1] += x;
	          current[2] += y;
	          current[3] += x;
	          current[4] += y;
	          // falls through
	        case 'Q':
	          controlX = current[1];
	          controlY = current[2];
	          x = current[3];
	          y = current[4];
	          break;
	        case 't': // shorthand quadraticCurveTo, relative
	          current[0] = 'T';
	          current[1] += x;
	          current[2] += y;
	          // falls through
	        case 'T':
	          if (previous === 'Q') {
	            // calculate reflection of previous control point
	            controlX = 2 * x - controlX;
	            controlY = 2 * y - controlY;
	          }
	          else {
	            // If there is no previous command or if the previous command was not a Q, q, T or t,
	            // assume the control point is coincident with the current point
	            controlX = x;
	            controlY = y;
	          }
	          current[0] = 'Q';
	          x = current[1];
	          y = current[2];
	          current[1] = controlX;
	          current[2] = controlY;
	          current[3] = x;
	          current[4] = y;
	          break;
	        case 'a':
	          current[0] = 'A';
	          current[6] += x;
	          current[7] += y;
	          // falls through
	        case 'A':
	          converted = true;
	          destinationPath = destinationPath.concat(fromArcToBeziers(x, y, current));
	          x = current[6];
	          y = current[7];
	          break;
	        case 'z':
	        case 'Z':
	          x = x1;
	          y = y1;
	          break;
	      }
	      if (!converted) {
	        destinationPath.push(current);
	      }
	      previous = current[0];
	    }
	    return destinationPath;
	  }
	  /**
	   * Calc length from point x1,y1 to x2,y2
	   * @param {Number} x1 starting point x
	   * @param {Number} y1 starting point y
	   * @param {Number} x2 starting point x
	   * @param {Number} y2 starting point y
	   * @return {Number} length of segment
	   */
	  function calcLineLength(x1, y1, x2, y2) {
	    return Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
	  }

	  // functions for the Cubic beizer
	  // taken from: https://github.com/konvajs/konva/blob/7.0.5/src/shapes/Path.ts#L350
	  function CB1(t) {
	    return t * t * t;
	  }
	  function CB2(t) {
	    return 3 * t * t * (1 - t);
	  }
	  function CB3(t) {
	    return 3 * t * (1 - t) * (1 - t);
	  }
	  function CB4(t) {
	    return (1 - t) * (1 - t) * (1 - t);
	  }

	  function getPointOnCubicBezierIterator(p1x, p1y, p2x, p2y, p3x, p3y, p4x, p4y) {
	    return function(pct) {
	      var c1 = CB1(pct), c2 = CB2(pct), c3 = CB3(pct), c4 = CB4(pct);
	      return {
	        x: p4x * c1 + p3x * c2 + p2x * c3 + p1x * c4,
	        y: p4y * c1 + p3y * c2 + p2y * c3 + p1y * c4
	      };
	    };
	  }

	  function getTangentCubicIterator(p1x, p1y, p2x, p2y, p3x, p3y, p4x, p4y) {
	    return function (pct) {
	      var invT = 1 - pct,
	          tangentX = (3 * invT * invT * (p2x - p1x)) + (6 * invT * pct * (p3x - p2x)) +
	          (3 * pct * pct * (p4x - p3x)),
	          tangentY = (3 * invT * invT * (p2y - p1y)) + (6 * invT * pct * (p3y - p2y)) +
	          (3 * pct * pct * (p4y - p3y));
	      return Math.atan2(tangentY, tangentX);
	    };
	  }

	  function QB1(t) {
	    return t * t;
	  }

	  function QB2(t) {
	    return 2 * t * (1 - t);
	  }

	  function QB3(t) {
	    return (1 - t) * (1 - t);
	  }

	  function getPointOnQuadraticBezierIterator(p1x, p1y, p2x, p2y, p3x, p3y) {
	    return function(pct) {
	      var c1 = QB1(pct), c2 = QB2(pct), c3 = QB3(pct);
	      return {
	        x: p3x * c1 + p2x * c2 + p1x * c3,
	        y: p3y * c1 + p2y * c2 + p1y * c3
	      };
	    };
	  }

	  function getTangentQuadraticIterator(p1x, p1y, p2x, p2y, p3x, p3y) {
	    return function (pct) {
	      var invT = 1 - pct,
	          tangentX = (2 * invT * (p2x - p1x)) + (2 * pct * (p3x - p2x)),
	          tangentY = (2 * invT * (p2y - p1y)) + (2 * pct * (p3y - p2y));
	      return Math.atan2(tangentY, tangentX);
	    };
	  }


	  // this will run over a path segment ( a cubic or quadratic segment) and approximate it
	  // with 100 segemnts. This will good enough to calculate the length of the curve
	  function pathIterator(iterator, x1, y1) {
	    var tempP = { x: x1, y: y1 }, p, tmpLen = 0, perc;
	    for (perc = 1; perc <= 100; perc += 1) {
	      p = iterator(perc / 100);
	      tmpLen += calcLineLength(tempP.x, tempP.y, p.x, p.y);
	      tempP = p;
	    }
	    return tmpLen;
	  }

	  /**
	   * Given a pathInfo, and a distance in pixels, find the percentage from 0 to 1
	   * that correspond to that pixels run over the path.
	   * The percentage will be then used to find the correct point on the canvas for the path.
	   * @param {Array} segInfo fabricJS collection of information on a parsed path
	   * @param {Number} distance from starting point, in pixels.
	   * @return {Object} info object with x and y ( the point on canvas ) and angle, the tangent on that point;
	   */
	  function findPercentageForDistance(segInfo, distance) {
	    var perc = 0, tmpLen = 0, iterator = segInfo.iterator, tempP = { x: segInfo.x, y: segInfo.y },
	        p, nextLen, nextStep = 0.01, angleFinder = segInfo.angleFinder, lastPerc;
	    // nextStep > 0.0001 covers 0.00015625 that 1/64th of 1/100
	    // the path
	    while (tmpLen < distance && perc <= 1 && nextStep > 0.0001) {
	      p = iterator(perc);
	      lastPerc = perc;
	      nextLen = calcLineLength(tempP.x, tempP.y, p.x, p.y);
	      // compare tmpLen each cycle with distance, decide next perc to test.
	      if ((nextLen + tmpLen) > distance) {
	        // we discard this step and we make smaller steps.
	        nextStep /= 2;
	        perc -= nextStep;
	      }
	      else {
	        tempP = p;
	        perc += nextStep;
	        tmpLen += nextLen;
	      }
	    }
	    p.angle = angleFinder(lastPerc);
	    return p;
	  }

	  /**
	   * Run over a parsed and simplifed path and extrac some informations.
	   * informations are length of each command and starting point
	   * @param {Array} path fabricJS parsed path commands
	   * @return {Array} path commands informations
	   */
	  function getPathSegmentsInfo(path) {
	    var totalLength = 0, len = path.length, current,
	        //x2 and y2 are the coords of segment start
	        //x1 and y1 are the coords of the current point
	        x1 = 0, y1 = 0, x2 = 0, y2 = 0, info = [], iterator, tempInfo, angleFinder;
	    for (var i = 0; i < len; i++) {
	      current = path[i];
	      tempInfo = {
	        x: x1,
	        y: y1,
	        command: current[0],
	      };
	      switch (current[0]) { //first letter
	        case 'M':
	          tempInfo.length = 0;
	          x2 = x1 = current[1];
	          y2 = y1 = current[2];
	          break;
	        case 'L':
	          tempInfo.length = calcLineLength(x1, y1, current[1], current[2]);
	          x1 = current[1];
	          y1 = current[2];
	          break;
	        case 'C':
	          iterator = getPointOnCubicBezierIterator(
	            x1,
	            y1,
	            current[1],
	            current[2],
	            current[3],
	            current[4],
	            current[5],
	            current[6]
	          );
	          angleFinder = getTangentCubicIterator(
	            x1,
	            y1,
	            current[1],
	            current[2],
	            current[3],
	            current[4],
	            current[5],
	            current[6]
	          );
	          tempInfo.iterator = iterator;
	          tempInfo.angleFinder = angleFinder;
	          tempInfo.length = pathIterator(iterator, x1, y1);
	          x1 = current[5];
	          y1 = current[6];
	          break;
	        case 'Q':
	          iterator = getPointOnQuadraticBezierIterator(
	            x1,
	            y1,
	            current[1],
	            current[2],
	            current[3],
	            current[4]
	          );
	          angleFinder = getTangentQuadraticIterator(
	            x1,
	            y1,
	            current[1],
	            current[2],
	            current[3],
	            current[4]
	          );
	          tempInfo.iterator = iterator;
	          tempInfo.angleFinder = angleFinder;
	          tempInfo.length = pathIterator(iterator, x1, y1);
	          x1 = current[3];
	          y1 = current[4];
	          break;
	        case 'Z':
	        case 'z':
	          // we add those in order to ease calculations later
	          tempInfo.destX = x2;
	          tempInfo.destY = y2;
	          tempInfo.length = calcLineLength(x1, y1, x2, y2);
	          x1 = x2;
	          y1 = y2;
	          break;
	      }
	      totalLength += tempInfo.length;
	      info.push(tempInfo);
	    }
	    info.push({ length: totalLength, x: x1, y: y1 });
	    return info;
	  }

	  function getPointOnPath(path, distance, infos) {
	    if (!infos) {
	      infos = getPathSegmentsInfo(path);
	    }
	    var i = 0;
	    while ((distance - infos[i].length > 0) && i < (infos.length - 2)) {
	      distance -= infos[i].length;
	      i++;
	    }
	    // var distance = infos[infos.length - 1] * perc;
	    var segInfo = infos[i], segPercent = distance / segInfo.length,
	        command = segInfo.command, segment = path[i], info;

	    switch (command) {
	      case 'M':
	        return { x: segInfo.x, y: segInfo.y, angle: 0 };
	      case 'Z':
	      case 'z':
	        info = new fabric.Point(segInfo.x, segInfo.y).lerp(
	          new fabric.Point(segInfo.destX, segInfo.destY),
	          segPercent
	        );
	        info.angle = Math.atan2(segInfo.destY - segInfo.y, segInfo.destX - segInfo.x);
	        return info;
	      case 'L':
	        info = new fabric.Point(segInfo.x, segInfo.y).lerp(
	          new fabric.Point(segment[1], segment[2]),
	          segPercent
	        );
	        info.angle = Math.atan2(segment[2] - segInfo.y, segment[1] - segInfo.x);
	        return info;
	      case 'C':
	        return findPercentageForDistance(segInfo, distance);
	      case 'Q':
	        return findPercentageForDistance(segInfo, distance);
	    }
	  }

	  /**
	   *
	   * @param {string} pathString
	   * @return {(string|number)[][]} An array of SVG path commands
	   * @example <caption>Usage</caption>
	   * parsePath('M 3 4 Q 3 5 2 1 4 0 Q 9 12 2 1 4 0') === [
	   *   ['M', 3, 4],
	   *   ['Q', 3, 5, 2, 1, 4, 0],
	   *   ['Q', 9, 12, 2, 1, 4, 0],
	   * ];
	   *
	   */
	  function parsePath(pathString) {
	    var result = [],
	        coords = [],
	        currentPath,
	        parsed,
	        re = fabric.rePathCommand,
	        rNumber = '[-+]?(?:\\d*\\.\\d+|\\d+\\.?)(?:[eE][-+]?\\d+)?\\s*',
	        rNumberCommaWsp = '(' + rNumber + ')' + fabric.commaWsp,
	        rFlagCommaWsp = '([01])' + fabric.commaWsp + '?',
	        rArcSeq = rNumberCommaWsp + '?' + rNumberCommaWsp + '?' + rNumberCommaWsp + rFlagCommaWsp + rFlagCommaWsp +
	          rNumberCommaWsp + '?(' + rNumber + ')',
	        regArcArgumentSequence = new RegExp(rArcSeq, 'g'),
	        match,
	        coordsStr,
	        // one of commands (m,M,l,L,q,Q,c,C,etc.) followed by non-command characters (i.e. command values)
	        path;
	    if (!pathString || !pathString.match) {
	      return result;
	    }
	    path = pathString.match(/[mzlhvcsqta][^mzlhvcsqta]*/gi);

	    for (var i = 0, coordsParsed, len = path.length; i < len; i++) {
	      currentPath = path[i];

	      coordsStr = currentPath.slice(1).trim();
	      coords.length = 0;

	      var command = currentPath.charAt(0);
	      coordsParsed = [command];

	      if (command.toLowerCase() === 'a') {
	        // arcs have special flags that apparently don't require spaces so handle special
	        for (var args; (args = regArcArgumentSequence.exec(coordsStr));) {
	          for (var j = 1; j < args.length; j++) {
	            coords.push(args[j]);
	          }
	        }
	      }
	      else {
	        while ((match = re.exec(coordsStr))) {
	          coords.push(match[0]);
	        }
	      }

	      for (var j = 0, jlen = coords.length; j < jlen; j++) {
	        parsed = parseFloat(coords[j]);
	        if (!isNaN(parsed)) {
	          coordsParsed.push(parsed);
	        }
	      }

	      var commandLength = commandLengths[command.toLowerCase()],
	          repeatedCommand = repeatedCommands[command] || command;

	      if (coordsParsed.length - 1 > commandLength) {
	        for (var k = 1, klen = coordsParsed.length; k < klen; k += commandLength) {
	          result.push([command].concat(coordsParsed.slice(k, k + commandLength)));
	          command = repeatedCommand;
	        }
	      }
	      else {
	        result.push(coordsParsed);
	      }
	    }

	    return result;
	  }
	  /**
	   *
	   * Converts points to a smooth SVG path
	   * @param {{ x: number,y: number }[]} points Array of points
	   * @param {number} [correction] Apply a correction to the path (usually we use `width / 1000`). If value is undefined 0 is used as the correction value.
	   * @return {(string|number)[][]} An array of SVG path commands
	   */
	  function getSmoothPathFromPoints(points, correction) {
	    var path = [], i,
	        p1 = new fabric.Point(points[0].x, points[0].y),
	        p2 = new fabric.Point(points[1].x, points[1].y),
	        len = points.length, multSignX = 1, multSignY = 0, manyPoints = len > 2;
	    correction = correction || 0;

	    if (manyPoints) {
	      multSignX = points[2].x < p2.x ? -1 : points[2].x === p2.x ? 0 : 1;
	      multSignY = points[2].y < p2.y ? -1 : points[2].y === p2.y ? 0 : 1;
	    }
	    path.push(['M', p1.x - multSignX * correction, p1.y - multSignY * correction]);
	    for (i = 1; i < len; i++) {
	      if (!p1.eq(p2)) {
	        var midPoint = p1.midPointFrom(p2);
	        // p1 is our bezier control point
	        // midpoint is our endpoint
	        // start point is p(i-1) value.
	        path.push(['Q', p1.x, p1.y, midPoint.x, midPoint.y]);
	      }
	      p1 = points[i];
	      if ((i + 1) < points.length) {
	        p2 = points[i + 1];
	      }
	    }
	    if (manyPoints) {
	      multSignX = p1.x > points[i - 2].x ? 1 : p1.x === points[i - 2].x ? 0 : -1;
	      multSignY = p1.y > points[i - 2].y ? 1 : p1.y === points[i - 2].y ? 0 : -1;
	    }
	    path.push(['L', p1.x + multSignX * correction, p1.y + multSignY * correction]);
	    return path;
	  }
	  /**
	   * Transform a path by transforming each segment.
	   * it has to be a simplified path or it won't work.
	   * WARNING: this depends from pathOffset for correct operation
	   * @param {Array} path fabricJS parsed and simplified path commands
	   * @param {Array} transform matrix that represent the transformation
	   * @param {Object} [pathOffset] the fabric.Path pathOffset
	   * @param {Number} pathOffset.x
	   * @param {Number} pathOffset.y
	   * @returns {Array} the transformed path
	   */
	  function transformPath(path, transform, pathOffset) {
	    if (pathOffset) {
	      transform = fabric.util.multiplyTransformMatrices(
	        transform,
	        [1, 0, 0, 1, -pathOffset.x, -pathOffset.y]
	      );
	    }
	    return path.map(function(pathSegment) {
	      var newSegment = pathSegment.slice(0), point = {};
	      for (var i = 1; i < pathSegment.length - 1; i += 2) {
	        point.x = pathSegment[i];
	        point.y = pathSegment[i + 1];
	        point = fabric.util.transformPoint(point, transform);
	        newSegment[i] = point.x;
	        newSegment[i + 1] = point.y;
	      }
	      return newSegment;
	    });
	  }

	  /**
	   * Calculate bounding box of a elliptic-arc
	   * @deprecated
	   * @param {Number} fx start point of arc
	   * @param {Number} fy
	   * @param {Number} rx horizontal radius
	   * @param {Number} ry vertical radius
	   * @param {Number} rot angle of horizontal axis
	   * @param {Number} large 1 or 0, whatever the arc is the big or the small on the 2 points
	   * @param {Number} sweep 1 or 0, 1 clockwise or counterclockwise direction
	   * @param {Number} tx end point of arc
	   * @param {Number} ty
	   */
	  function getBoundsOfArc(fx, fy, rx, ry, rot, large, sweep, tx, ty) {

	    var fromX = 0, fromY = 0, bound, bounds = [],
	        segs = arcToSegments(tx - fx, ty - fy, rx, ry, large, sweep, rot);

	    for (var i = 0, len = segs.length; i < len; i++) {
	      bound = getBoundsOfCurve(fromX, fromY, segs[i][1], segs[i][2], segs[i][3], segs[i][4], segs[i][5], segs[i][6]);
	      bounds.push({ x: bound[0].x + fx, y: bound[0].y + fy });
	      bounds.push({ x: bound[1].x + fx, y: bound[1].y + fy });
	      fromX = segs[i][5];
	      fromY = segs[i][6];
	    }
	    return bounds;
	  }
	  /**
	   * Draws arc
	   * @deprecated
	   * @param {CanvasRenderingContext2D} ctx
	   * @param {Number} fx
	   * @param {Number} fy
	   * @param {Array} coords coords of the arc, without the front 'A/a'
	   */
	  function drawArc(ctx, fx, fy, coords) {
	    coords = coords.slice(0).unshift('X'); // command A or a does not matter
	    var beziers = fromArcToBeziers(fx, fy, coords);
	    beziers.forEach(function(bezier) {
	      ctx.bezierCurveTo.apply(ctx, bezier.slice(1));
	    });
	  }
	  /**
	   * Join path commands to go back to svg format
	   * @param {Array} pathData fabricJS parsed path commands
	   * @return {String} joined path 'M 0 0 L 20 30'
	   */
	  fabric.util.joinPath = function(pathData) {
	    return pathData.map(function (segment) { return segment.join(' '); }).join(' ');
	  };
	  fabric.util.parsePath = parsePath;
	  fabric.util.makePathSimpler = makePathSimpler;
	  fabric.util.getSmoothPathFromPoints = getSmoothPathFromPoints;
	  fabric.util.getPathSegmentsInfo = getPathSegmentsInfo;
	  fabric.util.getBoundsOfCurve = getBoundsOfCurve;
	  fabric.util.getPointOnPath = getPointOnPath;
	  fabric.util.transformPath = transformPath;
	  /**
	   * Typo of `fromArcToBeziers` kept for not breaking the api once corrected.
	   * Will be removed in fabric 5.0
	   * @deprecated
	   */
	  fabric.util.fromArcToBeizers = fromArcToBeziers;
	  // kept because we do not want to make breaking changes.
	  // but useless and deprecated.
	  fabric.util.getBoundsOfArc = getBoundsOfArc;
	  fabric.util.drawArc = drawArc;
	})();


	(function() {

	  var slice = Array.prototype.slice;

	  /**
	   * Invokes method on all items in a given array
	   * @memberOf fabric.util.array
	   * @param {Array} array Array to iterate over
	   * @param {String} method Name of a method to invoke
	   * @return {Array}
	   */
	  function invoke(array, method) {
	    var args = slice.call(arguments, 2), result = [];
	    for (var i = 0, len = array.length; i < len; i++) {
	      result[i] = args.length ? array[i][method].apply(array[i], args) : array[i][method].call(array[i]);
	    }
	    return result;
	  }

	  /**
	   * Finds maximum value in array (not necessarily "first" one)
	   * @memberOf fabric.util.array
	   * @param {Array} array Array to iterate over
	   * @param {String} byProperty
	   * @return {*}
	   */
	  function max(array, byProperty) {
	    return find(array, byProperty, function(value1, value2) {
	      return value1 >= value2;
	    });
	  }

	  /**
	   * Finds minimum value in array (not necessarily "first" one)
	   * @memberOf fabric.util.array
	   * @param {Array} array Array to iterate over
	   * @param {String} byProperty
	   * @return {*}
	   */
	  function min(array, byProperty) {
	    return find(array, byProperty, function(value1, value2) {
	      return value1 < value2;
	    });
	  }

	  /**
	   * @private
	   */
	  function fill(array, value) {
	    var k = array.length;
	    while (k--) {
	      array[k] = value;
	    }
	    return array;
	  }

	  /**
	   * @private
	   */
	  function find(array, byProperty, condition) {
	    if (!array || array.length === 0) {
	      return;
	    }

	    var i = array.length - 1,
	        result = byProperty ? array[i][byProperty] : array[i];
	    if (byProperty) {
	      while (i--) {
	        if (condition(array[i][byProperty], result)) {
	          result = array[i][byProperty];
	        }
	      }
	    }
	    else {
	      while (i--) {
	        if (condition(array[i], result)) {
	          result = array[i];
	        }
	      }
	    }
	    return result;
	  }

	  /**
	   * @namespace fabric.util.array
	   */
	  fabric.util.array = {
	    fill: fill,
	    invoke: invoke,
	    min: min,
	    max: max
	  };

	})();


	(function() {
	  /**
	   * Copies all enumerable properties of one js object to another
	   * this does not and cannot compete with generic utils.
	   * Does not clone or extend fabric.Object subclasses.
	   * This is mostly for internal use and has extra handling for fabricJS objects
	   * it skips the canvas and group properties in deep cloning.
	   * @memberOf fabric.util.object
	   * @param {Object} destination Where to copy to
	   * @param {Object} source Where to copy from
	   * @param {Boolean} [deep] Whether to extend nested objects
	   * @return {Object}
	   */

	  function extend(destination, source, deep) {
	    // JScript DontEnum bug is not taken care of
	    // the deep clone is for internal use, is not meant to avoid
	    // javascript traps or cloning html element or self referenced objects.
	    if (deep) {
	      if (!fabric.isLikelyNode && source instanceof Element) {
	        // avoid cloning deep images, canvases,
	        destination = source;
	      }
	      else if (source instanceof Array) {
	        destination = [];
	        for (var i = 0, len = source.length; i < len; i++) {
	          destination[i] = extend({ }, source[i], deep);
	        }
	      }
	      else if (source && typeof source === 'object') {
	        for (var property in source) {
	          if (property === 'canvas' || property === 'group') {
	            // we do not want to clone this props at all.
	            // we want to keep the keys in the copy
	            destination[property] = null;
	          }
	          else if (source.hasOwnProperty(property)) {
	            destination[property] = extend({ }, source[property], deep);
	          }
	        }
	      }
	      else {
	        // this sounds odd for an extend but is ok for recursive use
	        destination = source;
	      }
	    }
	    else {
	      for (var property in source) {
	        destination[property] = source[property];
	      }
	    }
	    return destination;
	  }

	  /**
	   * Creates an empty object and copies all enumerable properties of another object to it
	   * This method is mostly for internal use, and not intended for duplicating shapes in canvas. 
	   * @memberOf fabric.util.object
	   * @param {Object} object Object to clone
	   * @param {Boolean} [deep] Whether to clone nested objects
	   * @return {Object}
	   */

	  //TODO: this function return an empty object if you try to clone null
	  function clone(object, deep) {
	    return extend({ }, object, deep);
	  }

	  /** @namespace fabric.util.object */
	  fabric.util.object = {
	    extend: extend,
	    clone: clone
	  };
	  fabric.util.object.extend(fabric.util, fabric.Observable);
	})();


	(function() {

	  /**
	   * Camelizes a string
	   * @memberOf fabric.util.string
	   * @param {String} string String to camelize
	   * @return {String} Camelized version of a string
	   */
	  function camelize(string) {
	    return string.replace(/-+(.)?/g, function(match, character) {
	      return character ? character.toUpperCase() : '';
	    });
	  }

	  /**
	   * Capitalizes a string
	   * @memberOf fabric.util.string
	   * @param {String} string String to capitalize
	   * @param {Boolean} [firstLetterOnly] If true only first letter is capitalized
	   * and other letters stay untouched, if false first letter is capitalized
	   * and other letters are converted to lowercase.
	   * @return {String} Capitalized version of a string
	   */
	  function capitalize(string, firstLetterOnly) {
	    return string.charAt(0).toUpperCase() +
	      (firstLetterOnly ? string.slice(1) : string.slice(1).toLowerCase());
	  }

	  /**
	   * Escapes XML in a string
	   * @memberOf fabric.util.string
	   * @param {String} string String to escape
	   * @return {String} Escaped version of a string
	   */
	  function escapeXml(string) {
	    return string.replace(/&/g, '&amp;')
	      .replace(/"/g, '&quot;')
	      .replace(/'/g, '&apos;')
	      .replace(/</g, '&lt;')
	      .replace(/>/g, '&gt;');
	  }

	  /**
	   * Divide a string in the user perceived single units
	   * @memberOf fabric.util.string
	   * @param {String} textstring String to escape
	   * @return {Array} array containing the graphemes
	   */
	  function graphemeSplit(textstring) {
	    var i = 0, chr, graphemes = [];
	    for (i = 0, chr; i < textstring.length; i++) {
	      if ((chr = getWholeChar(textstring, i)) === false) {
	        continue;
	      }
	      graphemes.push(chr);
	    }
	    return graphemes;
	  }

	  // taken from mdn in the charAt doc page.
	  function getWholeChar(str, i) {
	    var code = str.charCodeAt(i);

	    if (isNaN(code)) {
	      return ''; // Position not found
	    }
	    if (code < 0xD800 || code > 0xDFFF) {
	      return str.charAt(i);
	    }

	    // High surrogate (could change last hex to 0xDB7F to treat high private
	    // surrogates as single characters)
	    if (0xD800 <= code && code <= 0xDBFF) {
	      if (str.length <= (i + 1)) {
	        throw 'High surrogate without following low surrogate';
	      }
	      var next = str.charCodeAt(i + 1);
	      if (0xDC00 > next || next > 0xDFFF) {
	        throw 'High surrogate without following low surrogate';
	      }
	      return str.charAt(i) + str.charAt(i + 1);
	    }
	    // Low surrogate (0xDC00 <= code && code <= 0xDFFF)
	    if (i === 0) {
	      throw 'Low surrogate without preceding high surrogate';
	    }
	    var prev = str.charCodeAt(i - 1);

	    // (could change last hex to 0xDB7F to treat high private
	    // surrogates as single characters)
	    if (0xD800 > prev || prev > 0xDBFF) {
	      throw 'Low surrogate without preceding high surrogate';
	    }
	    // We can pass over low surrogates now as the second component
	    // in a pair which we have already processed
	    return false;
	  }


	  /**
	   * String utilities
	   * @namespace fabric.util.string
	   */
	  fabric.util.string = {
	    camelize: camelize,
	    capitalize: capitalize,
	    escapeXml: escapeXml,
	    graphemeSplit: graphemeSplit
	  };
	})();


	(function() {

	  var slice = Array.prototype.slice, emptyFunction = function() { },

	      IS_DONTENUM_BUGGY = (function() {
	        for (var p in { toString: 1 }) {
	          if (p === 'toString') {
	            return false;
	          }
	        }
	        return true;
	      })(),

	      /** @ignore */
	      addMethods = function(klass, source, parent) {
	        for (var property in source) {

	          if (property in klass.prototype &&
	              typeof klass.prototype[property] === 'function' &&
	              (source[property] + '').indexOf('callSuper') > -1) {

	            klass.prototype[property] = (function(property) {
	              return function() {

	                var superclass = this.constructor.superclass;
	                this.constructor.superclass = parent;
	                var returnValue = source[property].apply(this, arguments);
	                this.constructor.superclass = superclass;

	                if (property !== 'initialize') {
	                  return returnValue;
	                }
	              };
	            })(property);
	          }
	          else {
	            klass.prototype[property] = source[property];
	          }

	          if (IS_DONTENUM_BUGGY) {
	            if (source.toString !== Object.prototype.toString) {
	              klass.prototype.toString = source.toString;
	            }
	            if (source.valueOf !== Object.prototype.valueOf) {
	              klass.prototype.valueOf = source.valueOf;
	            }
	          }
	        }
	      };

	  function Subclass() { }

	  function callSuper(methodName) {
	    var parentMethod = null,
	        _this = this;

	    // climb prototype chain to find method not equal to callee's method
	    while (_this.constructor.superclass) {
	      var superClassMethod = _this.constructor.superclass.prototype[methodName];
	      if (_this[methodName] !== superClassMethod) {
	        parentMethod = superClassMethod;
	        break;
	      }
	      // eslint-disable-next-line
	      _this = _this.constructor.superclass.prototype;
	    }

	    if (!parentMethod) {
	      return console.log('tried to callSuper ' + methodName + ', method not found in prototype chain', this);
	    }

	    return (arguments.length > 1)
	      ? parentMethod.apply(this, slice.call(arguments, 1))
	      : parentMethod.call(this);
	  }

	  /**
	   * Helper for creation of "classes".
	   * @memberOf fabric.util
	   * @param {Function} [parent] optional "Class" to inherit from
	   * @param {Object} [properties] Properties shared by all instances of this class
	   *                  (be careful modifying objects defined here as this would affect all instances)
	   */
	  function createClass() {
	    var parent = null,
	        properties = slice.call(arguments, 0);

	    if (typeof properties[0] === 'function') {
	      parent = properties.shift();
	    }
	    function klass() {
	      this.initialize.apply(this, arguments);
	    }

	    klass.superclass = parent;
	    klass.subclasses = [];

	    if (parent) {
	      Subclass.prototype = parent.prototype;
	      klass.prototype = new Subclass();
	      parent.subclasses.push(klass);
	    }
	    for (var i = 0, length = properties.length; i < length; i++) {
	      addMethods(klass, properties[i], parent);
	    }
	    if (!klass.prototype.initialize) {
	      klass.prototype.initialize = emptyFunction;
	    }
	    klass.prototype.constructor = klass;
	    klass.prototype.callSuper = callSuper;
	    return klass;
	  }

	  fabric.util.createClass = createClass;
	})();


	(function () {
	  // since ie11 can use addEventListener but they do not support options, i need to check
	  var couldUseAttachEvent = !!fabric.document.createElement('div').attachEvent,
	      touchEvents = ['touchstart', 'touchmove', 'touchend'];
	  /**
	   * Adds an event listener to an element
	   * @function
	   * @memberOf fabric.util
	   * @param {HTMLElement} element
	   * @param {String} eventName
	   * @param {Function} handler
	   */
	  fabric.util.addListener = function(element, eventName, handler, options) {
	    element && element.addEventListener(eventName, handler, couldUseAttachEvent ? false : options);
	  };

	  /**
	   * Removes an event listener from an element
	   * @function
	   * @memberOf fabric.util
	   * @param {HTMLElement} element
	   * @param {String} eventName
	   * @param {Function} handler
	   */
	  fabric.util.removeListener = function(element, eventName, handler, options) {
	    element && element.removeEventListener(eventName, handler, couldUseAttachEvent ? false : options);
	  };

	  function getTouchInfo(event) {
	    var touchProp = event.changedTouches;
	    if (touchProp && touchProp[0]) {
	      return touchProp[0];
	    }
	    return event;
	  }

	  fabric.util.getPointer = function(event) {
	    var element = event.target,
	        scroll = fabric.util.getScrollLeftTop(element),
	        _evt = getTouchInfo(event);
	    return {
	      x: _evt.clientX + scroll.left,
	      y: _evt.clientY + scroll.top
	    };
	  };

	  fabric.util.isTouchEvent = function(event) {
	    return touchEvents.indexOf(event.type) > -1 || event.pointerType === 'touch';
	  };
	})();


	(function () {

	  /**
	   * Cross-browser wrapper for setting element's style
	   * @memberOf fabric.util
	   * @param {HTMLElement} element
	   * @param {Object} styles
	   * @return {HTMLElement} Element that was passed as a first argument
	   */
	  function setStyle(element, styles) {
	    var elementStyle = element.style;
	    if (!elementStyle) {
	      return element;
	    }
	    if (typeof styles === 'string') {
	      element.style.cssText += ';' + styles;
	      return styles.indexOf('opacity') > -1
	        ? setOpacity(element, styles.match(/opacity:\s*(\d?\.?\d*)/)[1])
	        : element;
	    }
	    for (var property in styles) {
	      if (property === 'opacity') {
	        setOpacity(element, styles[property]);
	      }
	      else {
	        var normalizedProperty = (property === 'float' || property === 'cssFloat')
	          ? (typeof elementStyle.styleFloat === 'undefined' ? 'cssFloat' : 'styleFloat')
	          : property;
	        elementStyle[normalizedProperty] = styles[property];
	      }
	    }
	    return element;
	  }

	  var parseEl = fabric.document.createElement('div'),
	      supportsOpacity = typeof parseEl.style.opacity === 'string',
	      supportsFilters = typeof parseEl.style.filter === 'string',
	      reOpacity = /alpha\s*\(\s*opacity\s*=\s*([^\)]+)\)/,

	      /** @ignore */
	      setOpacity = function (element) { return element; };

	  if (supportsOpacity) {
	    /** @ignore */
	    setOpacity = function(element, value) {
	      element.style.opacity = value;
	      return element;
	    };
	  }
	  else if (supportsFilters) {
	    /** @ignore */
	    setOpacity = function(element, value) {
	      var es = element.style;
	      if (element.currentStyle && !element.currentStyle.hasLayout) {
	        es.zoom = 1;
	      }
	      if (reOpacity.test(es.filter)) {
	        value = value >= 0.9999 ? '' : ('alpha(opacity=' + (value * 100) + ')');
	        es.filter = es.filter.replace(reOpacity, value);
	      }
	      else {
	        es.filter += ' alpha(opacity=' + (value * 100) + ')';
	      }
	      return element;
	    };
	  }

	  fabric.util.setStyle = setStyle;

	})();


	(function() {

	  var _slice = Array.prototype.slice;

	  /**
	   * Takes id and returns an element with that id (if one exists in a document)
	   * @memberOf fabric.util
	   * @param {String|HTMLElement} id
	   * @return {HTMLElement|null}
	   */
	  function getById(id) {
	    return typeof id === 'string' ? fabric.document.getElementById(id) : id;
	  }

	  var sliceCanConvertNodelists,
	      /**
	       * Converts an array-like object (e.g. arguments or NodeList) to an array
	       * @memberOf fabric.util
	       * @param {Object} arrayLike
	       * @return {Array}
	       */
	      toArray = function(arrayLike) {
	        return _slice.call(arrayLike, 0);
	      };

	  try {
	    sliceCanConvertNodelists = toArray(fabric.document.childNodes) instanceof Array;
	  }
	  catch (err) { }

	  if (!sliceCanConvertNodelists) {
	    toArray = function(arrayLike) {
	      var arr = new Array(arrayLike.length), i = arrayLike.length;
	      while (i--) {
	        arr[i] = arrayLike[i];
	      }
	      return arr;
	    };
	  }

	  /**
	   * Creates specified element with specified attributes
	   * @memberOf fabric.util
	   * @param {String} tagName Type of an element to create
	   * @param {Object} [attributes] Attributes to set on an element
	   * @return {HTMLElement} Newly created element
	   */
	  function makeElement(tagName, attributes) {
	    var el = fabric.document.createElement(tagName);
	    for (var prop in attributes) {
	      if (prop === 'class') {
	        el.className = attributes[prop];
	      }
	      else if (prop === 'for') {
	        el.htmlFor = attributes[prop];
	      }
	      else {
	        el.setAttribute(prop, attributes[prop]);
	      }
	    }
	    return el;
	  }

	  /**
	   * Adds class to an element
	   * @memberOf fabric.util
	   * @param {HTMLElement} element Element to add class to
	   * @param {String} className Class to add to an element
	   */
	  function addClass(element, className) {
	    if (element && (' ' + element.className + ' ').indexOf(' ' + className + ' ') === -1) {
	      element.className += (element.className ? ' ' : '') + className;
	    }
	  }

	  /**
	   * Wraps element with another element
	   * @memberOf fabric.util
	   * @param {HTMLElement} element Element to wrap
	   * @param {HTMLElement|String} wrapper Element to wrap with
	   * @param {Object} [attributes] Attributes to set on a wrapper
	   * @return {HTMLElement} wrapper
	   */
	  function wrapElement(element, wrapper, attributes) {
	    if (typeof wrapper === 'string') {
	      wrapper = makeElement(wrapper, attributes);
	    }
	    if (element.parentNode) {
	      element.parentNode.replaceChild(wrapper, element);
	    }
	    wrapper.appendChild(element);
	    return wrapper;
	  }

	  /**
	   * Returns element scroll offsets
	   * @memberOf fabric.util
	   * @param {HTMLElement} element Element to operate on
	   * @return {Object} Object with left/top values
	   */
	  function getScrollLeftTop(element) {

	    var left = 0,
	        top = 0,
	        docElement = fabric.document.documentElement,
	        body = fabric.document.body || {
	          scrollLeft: 0, scrollTop: 0
	        };

	    // While loop checks (and then sets element to) .parentNode OR .host
	    //  to account for ShadowDOM. We still want to traverse up out of ShadowDOM,
	    //  but the .parentNode of a root ShadowDOM node will always be null, instead
	    //  it should be accessed through .host. See http://stackoverflow.com/a/24765528/4383938
	    while (element && (element.parentNode || element.host)) {

	      // Set element to element parent, or 'host' in case of ShadowDOM
	      element = element.parentNode || element.host;

	      if (element === fabric.document) {
	        left = body.scrollLeft || docElement.scrollLeft || 0;
	        top = body.scrollTop ||  docElement.scrollTop || 0;
	      }
	      else {
	        left += element.scrollLeft || 0;
	        top += element.scrollTop || 0;
	      }

	      if (element.nodeType === 1 && element.style.position === 'fixed') {
	        break;
	      }
	    }

	    return { left: left, top: top };
	  }

	  /**
	   * Returns offset for a given element
	   * @function
	   * @memberOf fabric.util
	   * @param {HTMLElement} element Element to get offset for
	   * @return {Object} Object with "left" and "top" properties
	   */
	  function getElementOffset(element) {
	    var docElem,
	        doc = element && element.ownerDocument,
	        box = { left: 0, top: 0 },
	        offset = { left: 0, top: 0 },
	        scrollLeftTop,
	        offsetAttributes = {
	          borderLeftWidth: 'left',
	          borderTopWidth:  'top',
	          paddingLeft:     'left',
	          paddingTop:      'top'
	        };

	    if (!doc) {
	      return offset;
	    }

	    for (var attr in offsetAttributes) {
	      offset[offsetAttributes[attr]] += parseInt(getElementStyle(element, attr), 10) || 0;
	    }

	    docElem = doc.documentElement;
	    if ( typeof element.getBoundingClientRect !== 'undefined' ) {
	      box = element.getBoundingClientRect();
	    }

	    scrollLeftTop = getScrollLeftTop(element);

	    return {
	      left: box.left + scrollLeftTop.left - (docElem.clientLeft || 0) + offset.left,
	      top: box.top + scrollLeftTop.top - (docElem.clientTop || 0)  + offset.top
	    };
	  }

	  /**
	   * Returns style attribute value of a given element
	   * @memberOf fabric.util
	   * @param {HTMLElement} element Element to get style attribute for
	   * @param {String} attr Style attribute to get for element
	   * @return {String} Style attribute value of the given element.
	   */
	  var getElementStyle;
	  if (fabric.document.defaultView && fabric.document.defaultView.getComputedStyle) {
	    getElementStyle = function(element, attr) {
	      var style = fabric.document.defaultView.getComputedStyle(element, null);
	      return style ? style[attr] : undefined;
	    };
	  }
	  else {
	    getElementStyle = function(element, attr) {
	      var value = element.style[attr];
	      if (!value && element.currentStyle) {
	        value = element.currentStyle[attr];
	      }
	      return value;
	    };
	  }

	  (function () {
	    var style = fabric.document.documentElement.style,
	        selectProp = 'userSelect' in style
	          ? 'userSelect'
	          : 'MozUserSelect' in style
	            ? 'MozUserSelect'
	            : 'WebkitUserSelect' in style
	              ? 'WebkitUserSelect'
	              : 'KhtmlUserSelect' in style
	                ? 'KhtmlUserSelect'
	                : '';

	    /**
	     * Makes element unselectable
	     * @memberOf fabric.util
	     * @param {HTMLElement} element Element to make unselectable
	     * @return {HTMLElement} Element that was passed in
	     */
	    function makeElementUnselectable(element) {
	      if (typeof element.onselectstart !== 'undefined') {
	        element.onselectstart = fabric.util.falseFunction;
	      }
	      if (selectProp) {
	        element.style[selectProp] = 'none';
	      }
	      else if (typeof element.unselectable === 'string') {
	        element.unselectable = 'on';
	      }
	      return element;
	    }

	    /**
	     * Makes element selectable
	     * @memberOf fabric.util
	     * @param {HTMLElement} element Element to make selectable
	     * @return {HTMLElement} Element that was passed in
	     */
	    function makeElementSelectable(element) {
	      if (typeof element.onselectstart !== 'undefined') {
	        element.onselectstart = null;
	      }
	      if (selectProp) {
	        element.style[selectProp] = '';
	      }
	      else if (typeof element.unselectable === 'string') {
	        element.unselectable = '';
	      }
	      return element;
	    }

	    fabric.util.makeElementUnselectable = makeElementUnselectable;
	    fabric.util.makeElementSelectable = makeElementSelectable;
	  })();

	  function getNodeCanvas(element) {
	    var impl = fabric.jsdomImplForWrapper(element);
	    return impl._canvas || impl._image;
	  }
	  function cleanUpJsdomNode(element) {
	    if (!fabric.isLikelyNode) {
	      return;
	    }
	    var impl = fabric.jsdomImplForWrapper(element);
	    if (impl) {
	      impl._image = null;
	      impl._canvas = null;
	      // unsure if necessary
	      impl._currentSrc = null;
	      impl._attributes = null;
	      impl._classList = null;
	    }
	  }

	  function setImageSmoothing(ctx, value) {
	    ctx.imageSmoothingEnabled = ctx.imageSmoothingEnabled || ctx.webkitImageSmoothingEnabled
	      || ctx.mozImageSmoothingEnabled || ctx.msImageSmoothingEnabled || ctx.oImageSmoothingEnabled;
	    ctx.imageSmoothingEnabled = value;
	  }

	  /**
	   * setImageSmoothing sets the context imageSmoothingEnabled property.
	   * Used by canvas and by ImageObject.
	   * @memberOf fabric.util
	   * @since 4.0.0
	   * @param {HTMLRenderingContext2D} ctx to set on
	   * @param {Boolean} value true or false
	   */
	  fabric.util.setImageSmoothing = setImageSmoothing;
	  fabric.util.getById = getById;
	  fabric.util.toArray = toArray;
	  fabric.util.addClass = addClass;
	  fabric.util.makeElement = makeElement;
	  fabric.util.wrapElement = wrapElement;
	  fabric.util.getScrollLeftTop = getScrollLeftTop;
	  fabric.util.getElementOffset = getElementOffset;
	  fabric.util.getNodeCanvas = getNodeCanvas;
	  fabric.util.cleanUpJsdomNode = cleanUpJsdomNode;

	})();


	(function() {

	  function addParamToUrl(url, param) {
	    return url + (/\?/.test(url) ? '&' : '?') + param;
	  }

	  function emptyFn() { }

	  /**
	   * Cross-browser abstraction for sending XMLHttpRequest
	   * @memberOf fabric.util
	   * @param {String} url URL to send XMLHttpRequest to
	   * @param {Object} [options] Options object
	   * @param {String} [options.method="GET"]
	   * @param {String} [options.parameters] parameters to append to url in GET or in body
	   * @param {String} [options.body] body to send with POST or PUT request
	   * @param {Function} options.onComplete Callback to invoke when request is completed
	   * @return {XMLHttpRequest} request
	   */
	  function request(url, options) {
	    options || (options = { });

	    var method = options.method ? options.method.toUpperCase() : 'GET',
	        onComplete = options.onComplete || function() { },
	        xhr = new fabric.window.XMLHttpRequest(),
	        body = options.body || options.parameters;

	    /** @ignore */
	    xhr.onreadystatechange = function() {
	      if (xhr.readyState === 4) {
	        onComplete(xhr);
	        xhr.onreadystatechange = emptyFn;
	      }
	    };

	    if (method === 'GET') {
	      body = null;
	      if (typeof options.parameters === 'string') {
	        url = addParamToUrl(url, options.parameters);
	      }
	    }

	    xhr.open(method, url, true);

	    if (method === 'POST' || method === 'PUT') {
	      xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
	    }

	    xhr.send(body);
	    return xhr;
	  }

	  fabric.util.request = request;
	})();


	/**
	 * Wrapper around `console.log` (when available)
	 * @param {*} [values] Values to log
	 */
	fabric.log = console.log;

	/**
	 * Wrapper around `console.warn` (when available)
	 * @param {*} [values] Values to log as a warning
	 */
	fabric.warn = console.warn;


	(function() {

	  function noop() {
	    return false;
	  }

	  function defaultEasing(t, b, c, d) {
	    return -c * Math.cos(t / d * (Math.PI / 2)) + c + b;
	  }

	  /**
	   * Changes value from one to another within certain period of time, invoking callbacks as value is being changed.
	   * @memberOf fabric.util
	   * @param {Object} [options] Animation options
	   * @param {Function} [options.onChange] Callback; invoked on every value change
	   * @param {Function} [options.onComplete] Callback; invoked when value change is completed
	   * @param {Number} [options.startValue=0] Starting value
	   * @param {Number} [options.endValue=100] Ending value
	   * @param {Number} [options.byValue=100] Value to modify the property by
	   * @param {Function} [options.easing] Easing function
	   * @param {Number} [options.duration=500] Duration of change (in ms)
	   * @param {Function} [options.abort] Additional function with logic. If returns true, onComplete is called.
	   * @returns {Function} abort function
	   */
	  function animate(options) {
	    var cancel = false;
	    requestAnimFrame(function(timestamp) {
	      options || (options = { });

	      var start = timestamp || +new Date(),
	          duration = options.duration || 500,
	          finish = start + duration, time,
	          onChange = options.onChange || noop,
	          abort = options.abort || noop,
	          onComplete = options.onComplete || noop,
	          easing = options.easing || defaultEasing,
	          startValue = 'startValue' in options ? options.startValue : 0,
	          endValue = 'endValue' in options ? options.endValue : 100,
	          byValue = options.byValue || endValue - startValue;

	      options.onStart && options.onStart();

	      (function tick(ticktime) {
	        // TODO: move abort call after calculation
	        // and pass (current,valuePerc, timePerc) as arguments
	        time = ticktime || +new Date();
	        var currentTime = time > finish ? duration : (time - start),
	            timePerc = currentTime / duration,
	            current = easing(currentTime, startValue, byValue, duration),
	            valuePerc = Math.abs((current - startValue) / byValue);
	        if (cancel) {
	          return;
	        }
	        if (abort(current, valuePerc, timePerc)) {
	          // remove this in 4.0
	          // does to even make sense to abort and run onComplete?
	          onComplete(endValue, 1, 1);
	          return;
	        }
	        if (time > finish) {
	          onChange(endValue, 1, 1);
	          onComplete(endValue, 1, 1);
	          return;
	        }
	        else {
	          onChange(current, valuePerc, timePerc);
	          requestAnimFrame(tick);
	        }
	      })(start);
	    });
	    return function() {
	      cancel = true;
	    };
	  }

	  var _requestAnimFrame = fabric.window.requestAnimationFrame       ||
	                          fabric.window.webkitRequestAnimationFrame ||
	                          fabric.window.mozRequestAnimationFrame    ||
	                          fabric.window.oRequestAnimationFrame      ||
	                          fabric.window.msRequestAnimationFrame     ||
	                          function(callback) {
	                            return fabric.window.setTimeout(callback, 1000 / 60);
	                          };

	  var _cancelAnimFrame = fabric.window.cancelAnimationFrame || fabric.window.clearTimeout;

	  /**
	   * requestAnimationFrame polyfill based on http://paulirish.com/2011/requestanimationframe-for-smart-animating/
	   * In order to get a precise start time, `requestAnimFrame` should be called as an entry into the method
	   * @memberOf fabric.util
	   * @param {Function} callback Callback to invoke
	   * @param {DOMElement} element optional Element to associate with animation
	   */
	  function requestAnimFrame() {
	    return _requestAnimFrame.apply(fabric.window, arguments);
	  }

	  function cancelAnimFrame() {
	    return _cancelAnimFrame.apply(fabric.window, arguments);
	  }

	  fabric.util.animate = animate;
	  fabric.util.requestAnimFrame = requestAnimFrame;
	  fabric.util.cancelAnimFrame = cancelAnimFrame;
	})();


	(function() {
	  // Calculate an in-between color. Returns a "rgba()" string.
	  // Credit: Edwin Martin <edwin@bitstorm.org>
	  //         http://www.bitstorm.org/jquery/color-animation/jquery.animate-colors.js
	  function calculateColor(begin, end, pos) {
	    var color = 'rgba('
	        + parseInt((begin[0] + pos * (end[0] - begin[0])), 10) + ','
	        + parseInt((begin[1] + pos * (end[1] - begin[1])), 10) + ','
	        + parseInt((begin[2] + pos * (end[2] - begin[2])), 10);

	    color += ',' + (begin && end ? parseFloat(begin[3] + pos * (end[3] - begin[3])) : 1);
	    color += ')';
	    return color;
	  }

	  /**
	   * Changes the color from one to another within certain period of time, invoking callbacks as value is being changed.
	   * @memberOf fabric.util
	   * @param {String} fromColor The starting color in hex or rgb(a) format.
	   * @param {String} toColor The starting color in hex or rgb(a) format.
	   * @param {Number} [duration] Duration of change (in ms).
	   * @param {Object} [options] Animation options
	   * @param {Function} [options.onChange] Callback; invoked on every value change
	   * @param {Function} [options.onComplete] Callback; invoked when value change is completed
	   * @param {Function} [options.colorEasing] Easing function. Note that this function only take two arguments (currentTime, duration). Thus the regular animation easing functions cannot be used.
	   * @param {Function} [options.abort] Additional function with logic. If returns true, onComplete is called.
	   * @returns {Function} abort function
	   */
	  function animateColor(fromColor, toColor, duration, options) {
	    var startColor = new fabric.Color(fromColor).getSource(),
	        endColor = new fabric.Color(toColor).getSource(),
	        originalOnComplete = options.onComplete,
	        originalOnChange = options.onChange;
	    options = options || {};

	    return fabric.util.animate(fabric.util.object.extend(options, {
	      duration: duration || 500,
	      startValue: startColor,
	      endValue: endColor,
	      byValue: endColor,
	      easing: function (currentTime, startValue, byValue, duration) {
	        var posValue = options.colorEasing
	          ? options.colorEasing(currentTime, duration)
	          : 1 - Math.cos(currentTime / duration * (Math.PI / 2));
	        return calculateColor(startValue, byValue, posValue);
	      },
	      // has to take in account for color restoring;
	      onComplete: function(current, valuePerc, timePerc) {
	        if (originalOnComplete) {
	          return originalOnComplete(
	            calculateColor(endColor, endColor, 0),
	            valuePerc,
	            timePerc
	          );
	        }
	      },
	      onChange: function(current, valuePerc, timePerc) {
	        if (originalOnChange) {
	          if (Array.isArray(current)) {
	            return originalOnChange(
	              calculateColor(current, current, 0),
	              valuePerc,
	              timePerc
	            );
	          }
	          originalOnChange(current, valuePerc, timePerc);
	        }
	      }
	    }));
	  }

	  fabric.util.animateColor = animateColor;

	})();


	(function() {

	  function normalize(a, c, p, s) {
	    if (a < Math.abs(c)) {
	      a = c;
	      s = p / 4;
	    }
	    else {
	      //handle the 0/0 case:
	      if (c === 0 && a === 0) {
	        s = p / (2 * Math.PI) * Math.asin(1);
	      }
	      else {
	        s = p / (2 * Math.PI) * Math.asin(c / a);
	      }
	    }
	    return { a: a, c: c, p: p, s: s };
	  }

	  function elastic(opts, t, d) {
	    return opts.a *
	      Math.pow(2, 10 * (t -= 1)) *
	      Math.sin( (t * d - opts.s) * (2 * Math.PI) / opts.p );
	  }

	  /**
	   * Cubic easing out
	   * @memberOf fabric.util.ease
	   */
	  function easeOutCubic(t, b, c, d) {
	    return c * ((t = t / d - 1) * t * t + 1) + b;
	  }

	  /**
	   * Cubic easing in and out
	   * @memberOf fabric.util.ease
	   */
	  function easeInOutCubic(t, b, c, d) {
	    t /= d / 2;
	    if (t < 1) {
	      return c / 2 * t * t * t + b;
	    }
	    return c / 2 * ((t -= 2) * t * t + 2) + b;
	  }

	  /**
	   * Quartic easing in
	   * @memberOf fabric.util.ease
	   */
	  function easeInQuart(t, b, c, d) {
	    return c * (t /= d) * t * t * t + b;
	  }

	  /**
	   * Quartic easing out
	   * @memberOf fabric.util.ease
	   */
	  function easeOutQuart(t, b, c, d) {
	    return -c * ((t = t / d - 1) * t * t * t - 1) + b;
	  }

	  /**
	   * Quartic easing in and out
	   * @memberOf fabric.util.ease
	   */
	  function easeInOutQuart(t, b, c, d) {
	    t /= d / 2;
	    if (t < 1) {
	      return c / 2 * t * t * t * t + b;
	    }
	    return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
	  }

	  /**
	   * Quintic easing in
	   * @memberOf fabric.util.ease
	   */
	  function easeInQuint(t, b, c, d) {
	    return c * (t /= d) * t * t * t * t + b;
	  }

	  /**
	   * Quintic easing out
	   * @memberOf fabric.util.ease
	   */
	  function easeOutQuint(t, b, c, d) {
	    return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
	  }

	  /**
	   * Quintic easing in and out
	   * @memberOf fabric.util.ease
	   */
	  function easeInOutQuint(t, b, c, d) {
	    t /= d / 2;
	    if (t < 1) {
	      return c / 2 * t * t * t * t * t + b;
	    }
	    return c / 2 * ((t -= 2) * t * t * t * t + 2) + b;
	  }

	  /**
	   * Sinusoidal easing in
	   * @memberOf fabric.util.ease
	   */
	  function easeInSine(t, b, c, d) {
	    return -c * Math.cos(t / d * (Math.PI / 2)) + c + b;
	  }

	  /**
	   * Sinusoidal easing out
	   * @memberOf fabric.util.ease
	   */
	  function easeOutSine(t, b, c, d) {
	    return c * Math.sin(t / d * (Math.PI / 2)) + b;
	  }

	  /**
	   * Sinusoidal easing in and out
	   * @memberOf fabric.util.ease
	   */
	  function easeInOutSine(t, b, c, d) {
	    return -c / 2 * (Math.cos(Math.PI * t / d) - 1) + b;
	  }

	  /**
	   * Exponential easing in
	   * @memberOf fabric.util.ease
	   */
	  function easeInExpo(t, b, c, d) {
	    return (t === 0) ? b : c * Math.pow(2, 10 * (t / d - 1)) + b;
	  }

	  /**
	   * Exponential easing out
	   * @memberOf fabric.util.ease
	   */
	  function easeOutExpo(t, b, c, d) {
	    return (t === d) ? b + c : c * (-Math.pow(2, -10 * t / d) + 1) + b;
	  }

	  /**
	   * Exponential easing in and out
	   * @memberOf fabric.util.ease
	   */
	  function easeInOutExpo(t, b, c, d) {
	    if (t === 0) {
	      return b;
	    }
	    if (t === d) {
	      return b + c;
	    }
	    t /= d / 2;
	    if (t < 1) {
	      return c / 2 * Math.pow(2, 10 * (t - 1)) + b;
	    }
	    return c / 2 * (-Math.pow(2, -10 * --t) + 2) + b;
	  }

	  /**
	   * Circular easing in
	   * @memberOf fabric.util.ease
	   */
	  function easeInCirc(t, b, c, d) {
	    return -c * (Math.sqrt(1 - (t /= d) * t) - 1) + b;
	  }

	  /**
	   * Circular easing out
	   * @memberOf fabric.util.ease
	   */
	  function easeOutCirc(t, b, c, d) {
	    return c * Math.sqrt(1 - (t = t / d - 1) * t) + b;
	  }

	  /**
	   * Circular easing in and out
	   * @memberOf fabric.util.ease
	   */
	  function easeInOutCirc(t, b, c, d) {
	    t /= d / 2;
	    if (t < 1) {
	      return -c / 2 * (Math.sqrt(1 - t * t) - 1) + b;
	    }
	    return c / 2 * (Math.sqrt(1 - (t -= 2) * t) + 1) + b;
	  }

	  /**
	   * Elastic easing in
	   * @memberOf fabric.util.ease
	   */
	  function easeInElastic(t, b, c, d) {
	    var s = 1.70158, p = 0, a = c;
	    if (t === 0) {
	      return b;
	    }
	    t /= d;
	    if (t === 1) {
	      return b + c;
	    }
	    if (!p) {
	      p = d * 0.3;
	    }
	    var opts = normalize(a, c, p, s);
	    return -elastic(opts, t, d) + b;
	  }

	  /**
	   * Elastic easing out
	   * @memberOf fabric.util.ease
	   */
	  function easeOutElastic(t, b, c, d) {
	    var s = 1.70158, p = 0, a = c;
	    if (t === 0) {
	      return b;
	    }
	    t /= d;
	    if (t === 1) {
	      return b + c;
	    }
	    if (!p) {
	      p = d * 0.3;
	    }
	    var opts = normalize(a, c, p, s);
	    return opts.a * Math.pow(2, -10 * t) * Math.sin((t * d - opts.s) * (2 * Math.PI) / opts.p ) + opts.c + b;
	  }

	  /**
	   * Elastic easing in and out
	   * @memberOf fabric.util.ease
	   */
	  function easeInOutElastic(t, b, c, d) {
	    var s = 1.70158, p = 0, a = c;
	    if (t === 0) {
	      return b;
	    }
	    t /= d / 2;
	    if (t === 2) {
	      return b + c;
	    }
	    if (!p) {
	      p = d * (0.3 * 1.5);
	    }
	    var opts = normalize(a, c, p, s);
	    if (t < 1) {
	      return -0.5 * elastic(opts, t, d) + b;
	    }
	    return opts.a * Math.pow(2, -10 * (t -= 1)) *
	      Math.sin((t * d - opts.s) * (2 * Math.PI) / opts.p ) * 0.5 + opts.c + b;
	  }

	  /**
	   * Backwards easing in
	   * @memberOf fabric.util.ease
	   */
	  function easeInBack(t, b, c, d, s) {
	    if (s === undefined) {
	      s = 1.70158;
	    }
	    return c * (t /= d) * t * ((s + 1) * t - s) + b;
	  }

	  /**
	   * Backwards easing out
	   * @memberOf fabric.util.ease
	   */
	  function easeOutBack(t, b, c, d, s) {
	    if (s === undefined) {
	      s = 1.70158;
	    }
	    return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
	  }

	  /**
	   * Backwards easing in and out
	   * @memberOf fabric.util.ease
	   */
	  function easeInOutBack(t, b, c, d, s) {
	    if (s === undefined) {
	      s = 1.70158;
	    }
	    t /= d / 2;
	    if (t < 1) {
	      return c / 2 * (t * t * (((s *= (1.525)) + 1) * t - s)) + b;
	    }
	    return c / 2 * ((t -= 2) * t * (((s *= (1.525)) + 1) * t + s) + 2) + b;
	  }

	  /**
	   * Bouncing easing in
	   * @memberOf fabric.util.ease
	   */
	  function easeInBounce(t, b, c, d) {
	    return c - easeOutBounce (d - t, 0, c, d) + b;
	  }

	  /**
	   * Bouncing easing out
	   * @memberOf fabric.util.ease
	   */
	  function easeOutBounce(t, b, c, d) {
	    if ((t /= d) < (1 / 2.75)) {
	      return c * (7.5625 * t * t) + b;
	    }
	    else if (t < (2 / 2.75)) {
	      return c * (7.5625 * (t -= (1.5 / 2.75)) * t + 0.75) + b;
	    }
	    else if (t < (2.5 / 2.75)) {
	      return c * (7.5625 * (t -= (2.25 / 2.75)) * t + 0.9375) + b;
	    }
	    else {
	      return c * (7.5625 * (t -= (2.625 / 2.75)) * t + 0.984375) + b;
	    }
	  }

	  /**
	   * Bouncing easing in and out
	   * @memberOf fabric.util.ease
	   */
	  function easeInOutBounce(t, b, c, d) {
	    if (t < d / 2) {
	      return easeInBounce (t * 2, 0, c, d) * 0.5 + b;
	    }
	    return easeOutBounce(t * 2 - d, 0, c, d) * 0.5 + c * 0.5 + b;
	  }

	  /**
	   * Easing functions
	   * See <a href="http://gizma.com/easing/">Easing Equations by Robert Penner</a>
	   * @namespace fabric.util.ease
	   */
	  fabric.util.ease = {

	    /**
	     * Quadratic easing in
	     * @memberOf fabric.util.ease
	     */
	    easeInQuad: function(t, b, c, d) {
	      return c * (t /= d) * t + b;
	    },

	    /**
	     * Quadratic easing out
	     * @memberOf fabric.util.ease
	     */
	    easeOutQuad: function(t, b, c, d) {
	      return -c * (t /= d) * (t - 2) + b;
	    },

	    /**
	     * Quadratic easing in and out
	     * @memberOf fabric.util.ease
	     */
	    easeInOutQuad: function(t, b, c, d) {
	      t /= (d / 2);
	      if (t < 1) {
	        return c / 2 * t * t + b;
	      }
	      return -c / 2 * ((--t) * (t - 2) - 1) + b;
	    },

	    /**
	     * Cubic easing in
	     * @memberOf fabric.util.ease
	     */
	    easeInCubic: function(t, b, c, d) {
	      return c * (t /= d) * t * t + b;
	    },

	    easeOutCubic: easeOutCubic,
	    easeInOutCubic: easeInOutCubic,
	    easeInQuart: easeInQuart,
	    easeOutQuart: easeOutQuart,
	    easeInOutQuart: easeInOutQuart,
	    easeInQuint: easeInQuint,
	    easeOutQuint: easeOutQuint,
	    easeInOutQuint: easeInOutQuint,
	    easeInSine: easeInSine,
	    easeOutSine: easeOutSine,
	    easeInOutSine: easeInOutSine,
	    easeInExpo: easeInExpo,
	    easeOutExpo: easeOutExpo,
	    easeInOutExpo: easeInOutExpo,
	    easeInCirc: easeInCirc,
	    easeOutCirc: easeOutCirc,
	    easeInOutCirc: easeInOutCirc,
	    easeInElastic: easeInElastic,
	    easeOutElastic: easeOutElastic,
	    easeInOutElastic: easeInOutElastic,
	    easeInBack: easeInBack,
	    easeOutBack: easeOutBack,
	    easeInOutBack: easeInOutBack,
	    easeInBounce: easeInBounce,
	    easeOutBounce: easeOutBounce,
	    easeInOutBounce: easeInOutBounce
	  };

	})();


	(function(global) {

	  /**
	   * @name fabric
	   * @namespace
	   */

	  var fabric = global.fabric || (global.fabric = { }),
	      extend = fabric.util.object.extend,
	      clone = fabric.util.object.clone,
	      toFixed = fabric.util.toFixed,
	      parseUnit = fabric.util.parseUnit,
	      multiplyTransformMatrices = fabric.util.multiplyTransformMatrices,

	      svgValidTagNames = ['path', 'circle', 'polygon', 'polyline', 'ellipse', 'rect', 'line',
	        'image', 'text'],
	      svgViewBoxElements = ['symbol', 'image', 'marker', 'pattern', 'view', 'svg'],
	      svgInvalidAncestors = ['pattern', 'defs', 'symbol', 'metadata', 'clipPath', 'mask', 'desc'],
	      svgValidParents = ['symbol', 'g', 'a', 'svg', 'clipPath', 'defs'],

	      attributesMap = {
	        cx:                   'left',
	        x:                    'left',
	        r:                    'radius',
	        cy:                   'top',
	        y:                    'top',
	        display:              'visible',
	        visibility:           'visible',
	        transform:            'transformMatrix',
	        'fill-opacity':       'fillOpacity',
	        'fill-rule':          'fillRule',
	        'font-family':        'fontFamily',
	        'font-size':          'fontSize',
	        'font-style':         'fontStyle',
	        'font-weight':        'fontWeight',
	        'letter-spacing':     'charSpacing',
	        'paint-order':        'paintFirst',
	        'stroke-dasharray':   'strokeDashArray',
	        'stroke-dashoffset':  'strokeDashOffset',
	        'stroke-linecap':     'strokeLineCap',
	        'stroke-linejoin':    'strokeLineJoin',
	        'stroke-miterlimit':  'strokeMiterLimit',
	        'stroke-opacity':     'strokeOpacity',
	        'stroke-width':       'strokeWidth',
	        'text-decoration':    'textDecoration',
	        'text-anchor':        'textAnchor',
	        opacity:              'opacity',
	        'clip-path':          'clipPath',
	        'clip-rule':          'clipRule',
	        'vector-effect':      'strokeUniform',
	        'image-rendering':    'imageSmoothing',
	      },

	      colorAttributes = {
	        stroke: 'strokeOpacity',
	        fill:   'fillOpacity'
	      },

	      fSize = 'font-size', cPath = 'clip-path';

	  fabric.svgValidTagNamesRegEx = getSvgRegex(svgValidTagNames);
	  fabric.svgViewBoxElementsRegEx = getSvgRegex(svgViewBoxElements);
	  fabric.svgInvalidAncestorsRegEx = getSvgRegex(svgInvalidAncestors);
	  fabric.svgValidParentsRegEx = getSvgRegex(svgValidParents);

	  fabric.cssRules = { };
	  fabric.gradientDefs = { };
	  fabric.clipPaths = { };

	  function normalizeAttr(attr) {
	    // transform attribute names
	    if (attr in attributesMap) {
	      return attributesMap[attr];
	    }
	    return attr;
	  }

	  function normalizeValue(attr, value, parentAttributes, fontSize) {
	    var isArray = Object.prototype.toString.call(value) === '[object Array]',
	        parsed;

	    if ((attr === 'fill' || attr === 'stroke') && value === 'none') {
	      value = '';
	    }
	    else if (attr === 'strokeUniform') {
	      return (value === 'non-scaling-stroke');
	    }
	    else if (attr === 'strokeDashArray') {
	      if (value === 'none') {
	        value = null;
	      }
	      else {
	        value = value.replace(/,/g, ' ').split(/\s+/).map(parseFloat);
	      }
	    }
	    else if (attr === 'transformMatrix') {
	      if (parentAttributes && parentAttributes.transformMatrix) {
	        value = multiplyTransformMatrices(
	          parentAttributes.transformMatrix, fabric.parseTransformAttribute(value));
	      }
	      else {
	        value = fabric.parseTransformAttribute(value);
	      }
	    }
	    else if (attr === 'visible') {
	      value = value !== 'none' && value !== 'hidden';
	      // display=none on parent element always takes precedence over child element
	      if (parentAttributes && parentAttributes.visible === false) {
	        value = false;
	      }
	    }
	    else if (attr === 'opacity') {
	      value = parseFloat(value);
	      if (parentAttributes && typeof parentAttributes.opacity !== 'undefined') {
	        value *= parentAttributes.opacity;
	      }
	    }
	    else if (attr === 'textAnchor' /* text-anchor */) {
	      value = value === 'start' ? 'left' : value === 'end' ? 'right' : 'center';
	    }
	    else if (attr === 'charSpacing') {
	      // parseUnit returns px and we convert it to em
	      parsed = parseUnit(value, fontSize) / fontSize * 1000;
	    }
	    else if (attr === 'paintFirst') {
	      var fillIndex = value.indexOf('fill');
	      var strokeIndex = value.indexOf('stroke');
	      var value = 'fill';
	      if (fillIndex > -1 && strokeIndex > -1 && strokeIndex < fillIndex) {
	        value = 'stroke';
	      }
	      else if (fillIndex === -1 && strokeIndex > -1) {
	        value = 'stroke';
	      }
	    }
	    else if (attr === 'href' || attr === 'xlink:href' || attr === 'font') {
	      return value;
	    }
	    else if (attr === 'imageSmoothing') {
	      return (value === 'optimizeQuality');
	    }
	    else {
	      parsed = isArray ? value.map(parseUnit) : parseUnit(value, fontSize);
	    }

	    return (!isArray && isNaN(parsed) ? value : parsed);
	  }

	  /**
	    * @private
	    */
	  function getSvgRegex(arr) {
	    return new RegExp('^(' + arr.join('|') + ')\\b', 'i');
	  }

	  /**
	   * @private
	   * @param {Object} attributes Array of attributes to parse
	   */
	  function _setStrokeFillOpacity(attributes) {
	    for (var attr in colorAttributes) {

	      if (typeof attributes[colorAttributes[attr]] === 'undefined' || attributes[attr] === '') {
	        continue;
	      }

	      if (typeof attributes[attr] === 'undefined') {
	        if (!fabric.Object.prototype[attr]) {
	          continue;
	        }
	        attributes[attr] = fabric.Object.prototype[attr];
	      }

	      if (attributes[attr].indexOf('url(') === 0) {
	        continue;
	      }

	      var color = new fabric.Color(attributes[attr]);
	      attributes[attr] = color.setAlpha(toFixed(color.getAlpha() * attributes[colorAttributes[attr]], 2)).toRgba();
	    }
	    return attributes;
	  }

	  /**
	   * @private
	   */
	  function _getMultipleNodes(doc, nodeNames) {
	    var nodeName, nodeArray = [], nodeList, i, len;
	    for (i = 0, len = nodeNames.length; i < len; i++) {
	      nodeName = nodeNames[i];
	      nodeList = doc.getElementsByTagName(nodeName);
	      nodeArray = nodeArray.concat(Array.prototype.slice.call(nodeList));
	    }
	    return nodeArray;
	  }

	  /**
	   * Parses "transform" attribute, returning an array of values
	   * @static
	   * @function
	   * @memberOf fabric
	   * @param {String} attributeValue String containing attribute value
	   * @return {Array} Array of 6 elements representing transformation matrix
	   */
	  fabric.parseTransformAttribute = (function() {
	    function rotateMatrix(matrix, args) {
	      var cos = fabric.util.cos(args[0]), sin = fabric.util.sin(args[0]),
	          x = 0, y = 0;
	      if (args.length === 3) {
	        x = args[1];
	        y = args[2];
	      }

	      matrix[0] = cos;
	      matrix[1] = sin;
	      matrix[2] = -sin;
	      matrix[3] = cos;
	      matrix[4] = x - (cos * x - sin * y);
	      matrix[5] = y - (sin * x + cos * y);
	    }

	    function scaleMatrix(matrix, args) {
	      var multiplierX = args[0],
	          multiplierY = (args.length === 2) ? args[1] : args[0];

	      matrix[0] = multiplierX;
	      matrix[3] = multiplierY;
	    }

	    function skewMatrix(matrix, args, pos) {
	      matrix[pos] = Math.tan(fabric.util.degreesToRadians(args[0]));
	    }

	    function translateMatrix(matrix, args) {
	      matrix[4] = args[0];
	      if (args.length === 2) {
	        matrix[5] = args[1];
	      }
	    }

	    // identity matrix
	    var iMatrix = fabric.iMatrix,

	        // == begin transform regexp
	        number = fabric.reNum,

	        commaWsp = fabric.commaWsp,

	        skewX = '(?:(skewX)\\s*\\(\\s*(' + number + ')\\s*\\))',

	        skewY = '(?:(skewY)\\s*\\(\\s*(' + number + ')\\s*\\))',

	        rotate = '(?:(rotate)\\s*\\(\\s*(' + number + ')(?:' +
	                    commaWsp + '(' + number + ')' +
	                    commaWsp + '(' + number + '))?\\s*\\))',

	        scale = '(?:(scale)\\s*\\(\\s*(' + number + ')(?:' +
	                    commaWsp + '(' + number + '))?\\s*\\))',

	        translate = '(?:(translate)\\s*\\(\\s*(' + number + ')(?:' +
	                    commaWsp + '(' + number + '))?\\s*\\))',

	        matrix = '(?:(matrix)\\s*\\(\\s*' +
	                  '(' + number + ')' + commaWsp +
	                  '(' + number + ')' + commaWsp +
	                  '(' + number + ')' + commaWsp +
	                  '(' + number + ')' + commaWsp +
	                  '(' + number + ')' + commaWsp +
	                  '(' + number + ')' +
	                  '\\s*\\))',

	        transform = '(?:' +
	                    matrix + '|' +
	                    translate + '|' +
	                    scale + '|' +
	                    rotate + '|' +
	                    skewX + '|' +
	                    skewY +
	                    ')',

	        transforms = '(?:' + transform + '(?:' + commaWsp + '*' + transform + ')*' + ')',

	        transformList = '^\\s*(?:' + transforms + '?)\\s*$',

	        // http://www.w3.org/TR/SVG/coords.html#TransformAttribute
	        reTransformList = new RegExp(transformList),
	        // == end transform regexp

	        reTransform = new RegExp(transform, 'g');

	    return function(attributeValue) {

	      // start with identity matrix
	      var matrix = iMatrix.concat(),
	          matrices = [];

	      // return if no argument was given or
	      // an argument does not match transform attribute regexp
	      if (!attributeValue || (attributeValue && !reTransformList.test(attributeValue))) {
	        return matrix;
	      }

	      attributeValue.replace(reTransform, function(match) {

	        var m = new RegExp(transform).exec(match).filter(function (match) {
	              // match !== '' && match != null
	              return (!!match);
	            }),
	            operation = m[1],
	            args = m.slice(2).map(parseFloat);

	        switch (operation) {
	          case 'translate':
	            translateMatrix(matrix, args);
	            break;
	          case 'rotate':
	            args[0] = fabric.util.degreesToRadians(args[0]);
	            rotateMatrix(matrix, args);
	            break;
	          case 'scale':
	            scaleMatrix(matrix, args);
	            break;
	          case 'skewX':
	            skewMatrix(matrix, args, 2);
	            break;
	          case 'skewY':
	            skewMatrix(matrix, args, 1);
	            break;
	          case 'matrix':
	            matrix = args;
	            break;
	        }

	        // snapshot current matrix into matrices array
	        matrices.push(matrix.concat());
	        // reset
	        matrix = iMatrix.concat();
	      });

	      var combinedMatrix = matrices[0];
	      while (matrices.length > 1) {
	        matrices.shift();
	        combinedMatrix = fabric.util.multiplyTransformMatrices(combinedMatrix, matrices[0]);
	      }
	      return combinedMatrix;
	    };
	  })();

	  /**
	   * @private
	   */
	  function parseStyleString(style, oStyle) {
	    var attr, value;
	    style.replace(/;\s*$/, '').split(';').forEach(function (chunk) {
	      var pair = chunk.split(':');

	      attr = pair[0].trim().toLowerCase();
	      value =  pair[1].trim();

	      oStyle[attr] = value;
	    });
	  }

	  /**
	   * @private
	   */
	  function parseStyleObject(style, oStyle) {
	    var attr, value;
	    for (var prop in style) {
	      if (typeof style[prop] === 'undefined') {
	        continue;
	      }

	      attr = prop.toLowerCase();
	      value = style[prop];

	      oStyle[attr] = value;
	    }
	  }

	  /**
	   * @private
	   */
	  function getGlobalStylesForElement(element, svgUid) {
	    var styles = { };
	    for (var rule in fabric.cssRules[svgUid]) {
	      if (elementMatchesRule(element, rule.split(' '))) {
	        for (var property in fabric.cssRules[svgUid][rule]) {
	          styles[property] = fabric.cssRules[svgUid][rule][property];
	        }
	      }
	    }
	    return styles;
	  }

	  /**
	   * @private
	   */
	  function elementMatchesRule(element, selectors) {
	    var firstMatching, parentMatching = true;
	    //start from rightmost selector.
	    firstMatching = selectorMatches(element, selectors.pop());
	    if (firstMatching && selectors.length) {
	      parentMatching = doesSomeParentMatch(element, selectors);
	    }
	    return firstMatching && parentMatching && (selectors.length === 0);
	  }

	  function doesSomeParentMatch(element, selectors) {
	    var selector, parentMatching = true;
	    while (element.parentNode && element.parentNode.nodeType === 1 && selectors.length) {
	      if (parentMatching) {
	        selector = selectors.pop();
	      }
	      element = element.parentNode;
	      parentMatching = selectorMatches(element, selector);
	    }
	    return selectors.length === 0;
	  }

	  /**
	   * @private
	   */
	  function selectorMatches(element, selector) {
	    var nodeName = element.nodeName,
	        classNames = element.getAttribute('class'),
	        id = element.getAttribute('id'), matcher, i;
	    // i check if a selector matches slicing away part from it.
	    // if i get empty string i should match
	    matcher = new RegExp('^' + nodeName, 'i');
	    selector = selector.replace(matcher, '');
	    if (id && selector.length) {
	      matcher = new RegExp('#' + id + '(?![a-zA-Z\\-]+)', 'i');
	      selector = selector.replace(matcher, '');
	    }
	    if (classNames && selector.length) {
	      classNames = classNames.split(' ');
	      for (i = classNames.length; i--;) {
	        matcher = new RegExp('\\.' + classNames[i] + '(?![a-zA-Z\\-]+)', 'i');
	        selector = selector.replace(matcher, '');
	      }
	    }
	    return selector.length === 0;
	  }

	  /**
	   * @private
	   * to support IE8 missing getElementById on SVGdocument and on node xmlDOM
	   */
	  function elementById(doc, id) {
	    var el;
	    doc.getElementById && (el = doc.getElementById(id));
	    if (el) {
	      return el;
	    }
	    var node, i, len, nodelist = doc.getElementsByTagName('*');
	    for (i = 0, len = nodelist.length; i < len; i++) {
	      node = nodelist[i];
	      if (id === node.getAttribute('id')) {
	        return node;
	      }
	    }
	  }

	  /**
	   * @private
	   */
	  function parseUseDirectives(doc) {
	    var nodelist = _getMultipleNodes(doc, ['use', 'svg:use']), i = 0;
	    while (nodelist.length && i < nodelist.length) {
	      var el = nodelist[i],
	          xlinkAttribute = el.getAttribute('xlink:href') || el.getAttribute('href');

	      if (xlinkAttribute === null) {
	        return;
	      }

	      var xlink = xlinkAttribute.substr(1),
	          x = el.getAttribute('x') || 0,
	          y = el.getAttribute('y') || 0,
	          el2 = elementById(doc, xlink).cloneNode(true),
	          currentTrans = (el2.getAttribute('transform') || '') + ' translate(' + x + ', ' + y + ')',
	          parentNode,
	          oldLength = nodelist.length, attr,
	          j,
	          attrs,
	          len,
	          namespace = fabric.svgNS;

	      applyViewboxTransform(el2);
	      if (/^svg$/i.test(el2.nodeName)) {
	        var el3 = el2.ownerDocument.createElementNS(namespace, 'g');
	        for (j = 0, attrs = el2.attributes, len = attrs.length; j < len; j++) {
	          attr = attrs.item(j);
	          el3.setAttributeNS(namespace, attr.nodeName, attr.nodeValue);
	        }
	        // el2.firstChild != null
	        while (el2.firstChild) {
	          el3.appendChild(el2.firstChild);
	        }
	        el2 = el3;
	      }

	      for (j = 0, attrs = el.attributes, len = attrs.length; j < len; j++) {
	        attr = attrs.item(j);
	        if (attr.nodeName === 'x' || attr.nodeName === 'y' ||
	          attr.nodeName === 'xlink:href' || attr.nodeName === 'href') {
	          continue;
	        }

	        if (attr.nodeName === 'transform') {
	          currentTrans = attr.nodeValue + ' ' + currentTrans;
	        }
	        else {
	          el2.setAttribute(attr.nodeName, attr.nodeValue);
	        }
	      }

	      el2.setAttribute('transform', currentTrans);
	      el2.setAttribute('instantiated_by_use', '1');
	      el2.removeAttribute('id');
	      parentNode = el.parentNode;
	      parentNode.replaceChild(el2, el);
	      // some browsers do not shorten nodelist after replaceChild (IE8)
	      if (nodelist.length === oldLength) {
	        i++;
	      }
	    }
	  }

	  // http://www.w3.org/TR/SVG/coords.html#ViewBoxAttribute
	  // matches, e.g.: +14.56e-12, etc.
	  var reViewBoxAttrValue = new RegExp(
	    '^' +
	    '\\s*(' + fabric.reNum + '+)\\s*,?' +
	    '\\s*(' + fabric.reNum + '+)\\s*,?' +
	    '\\s*(' + fabric.reNum + '+)\\s*,?' +
	    '\\s*(' + fabric.reNum + '+)\\s*' +
	    '$'
	  );

	  /**
	   * Add a <g> element that envelop all child elements and makes the viewbox transformMatrix descend on all elements
	   */
	  function applyViewboxTransform(element) {
	    if (!fabric.svgViewBoxElementsRegEx.test(element.nodeName)) {
	      return {};
	    }
	    var viewBoxAttr = element.getAttribute('viewBox'),
	        scaleX = 1,
	        scaleY = 1,
	        minX = 0,
	        minY = 0,
	        viewBoxWidth, viewBoxHeight, matrix, el,
	        widthAttr = element.getAttribute('width'),
	        heightAttr = element.getAttribute('height'),
	        x = element.getAttribute('x') || 0,
	        y = element.getAttribute('y') || 0,
	        preserveAspectRatio = element.getAttribute('preserveAspectRatio') || '',
	        missingViewBox = (!viewBoxAttr || !(viewBoxAttr = viewBoxAttr.match(reViewBoxAttrValue))),
	        missingDimAttr = (!widthAttr || !heightAttr || widthAttr === '100%' || heightAttr === '100%'),
	        toBeParsed = missingViewBox && missingDimAttr,
	        parsedDim = { }, translateMatrix = '', widthDiff = 0, heightDiff = 0;

	    parsedDim.width = 0;
	    parsedDim.height = 0;
	    parsedDim.toBeParsed = toBeParsed;

	    if (missingViewBox) {
	      if (((x || y) && element.parentNode && element.parentNode.nodeName !== '#document')) {
	        translateMatrix = ' translate(' + parseUnit(x) + ' ' + parseUnit(y) + ') ';
	        matrix = (element.getAttribute('transform') || '') + translateMatrix;
	        element.setAttribute('transform', matrix);
	        element.removeAttribute('x');
	        element.removeAttribute('y');
	      }
	    }

	    if (toBeParsed) {
	      return parsedDim;
	    }

	    if (missingViewBox) {
	      parsedDim.width = parseUnit(widthAttr);
	      parsedDim.height = parseUnit(heightAttr);
	      // set a transform for elements that have x y and are inner(only) SVGs
	      return parsedDim;
	    }
	    minX = -parseFloat(viewBoxAttr[1]);
	    minY = -parseFloat(viewBoxAttr[2]);
	    viewBoxWidth = parseFloat(viewBoxAttr[3]);
	    viewBoxHeight = parseFloat(viewBoxAttr[4]);
	    parsedDim.minX = minX;
	    parsedDim.minY = minY;
	    parsedDim.viewBoxWidth = viewBoxWidth;
	    parsedDim.viewBoxHeight = viewBoxHeight;
	    if (!missingDimAttr) {
	      parsedDim.width = parseUnit(widthAttr);
	      parsedDim.height = parseUnit(heightAttr);
	      scaleX = parsedDim.width / viewBoxWidth;
	      scaleY = parsedDim.height / viewBoxHeight;
	    }
	    else {
	      parsedDim.width = viewBoxWidth;
	      parsedDim.height = viewBoxHeight;
	    }

	    // default is to preserve aspect ratio
	    preserveAspectRatio = fabric.util.parsePreserveAspectRatioAttribute(preserveAspectRatio);
	    if (preserveAspectRatio.alignX !== 'none') {
	      //translate all container for the effect of Mid, Min, Max
	      if (preserveAspectRatio.meetOrSlice === 'meet') {
	        scaleY = scaleX = (scaleX > scaleY ? scaleY : scaleX);
	        // calculate additional translation to move the viewbox
	      }
	      if (preserveAspectRatio.meetOrSlice === 'slice') {
	        scaleY = scaleX = (scaleX > scaleY ? scaleX : scaleY);
	        // calculate additional translation to move the viewbox
	      }
	      widthDiff = parsedDim.width - viewBoxWidth * scaleX;
	      heightDiff = parsedDim.height - viewBoxHeight * scaleX;
	      if (preserveAspectRatio.alignX === 'Mid') {
	        widthDiff /= 2;
	      }
	      if (preserveAspectRatio.alignY === 'Mid') {
	        heightDiff /= 2;
	      }
	      if (preserveAspectRatio.alignX === 'Min') {
	        widthDiff = 0;
	      }
	      if (preserveAspectRatio.alignY === 'Min') {
	        heightDiff = 0;
	      }
	    }

	    if (scaleX === 1 && scaleY === 1 && minX === 0 && minY === 0 && x === 0 && y === 0) {
	      return parsedDim;
	    }
	    if ((x || y) && element.parentNode.nodeName !== '#document') {
	      translateMatrix = ' translate(' + parseUnit(x) + ' ' + parseUnit(y) + ') ';
	    }

	    matrix = translateMatrix + ' matrix(' + scaleX +
	                  ' 0' +
	                  ' 0 ' +
	                  scaleY + ' ' +
	                  (minX * scaleX + widthDiff) + ' ' +
	                  (minY * scaleY + heightDiff) + ') ';
	    // seems unused.
	    // parsedDim.viewboxTransform = fabric.parseTransformAttribute(matrix);
	    if (element.nodeName === 'svg') {
	      el = element.ownerDocument.createElementNS(fabric.svgNS, 'g');
	      // element.firstChild != null
	      while (element.firstChild) {
	        el.appendChild(element.firstChild);
	      }
	      element.appendChild(el);
	    }
	    else {
	      el = element;
	      el.removeAttribute('x');
	      el.removeAttribute('y');
	      matrix = el.getAttribute('transform') + matrix;
	    }
	    el.setAttribute('transform', matrix);
	    return parsedDim;
	  }

	  function hasAncestorWithNodeName(element, nodeName) {
	    while (element && (element = element.parentNode)) {
	      if (element.nodeName && nodeName.test(element.nodeName.replace('svg:', ''))
	        && !element.getAttribute('instantiated_by_use')) {
	        return true;
	      }
	    }
	    return false;
	  }

	  /**
	   * Parses an SVG document, converts it to an array of corresponding fabric.* instances and passes them to a callback
	   * @static
	   * @function
	   * @memberOf fabric
	   * @param {SVGDocument} doc SVG document to parse
	   * @param {Function} callback Callback to call when parsing is finished;
	   * It's being passed an array of elements (parsed from a document).
	   * @param {Function} [reviver] Method for further parsing of SVG elements, called after each fabric object created.
	   * @param {Object} [parsingOptions] options for parsing document
	   * @param {String} [parsingOptions.crossOrigin] crossOrigin settings
	   */
	  fabric.parseSVGDocument = function(doc, callback, reviver, parsingOptions) {
	    if (!doc) {
	      return;
	    }

	    parseUseDirectives(doc);

	    var svgUid =  fabric.Object.__uid++, i, len,
	        options = applyViewboxTransform(doc),
	        descendants = fabric.util.toArray(doc.getElementsByTagName('*'));
	    options.crossOrigin = parsingOptions && parsingOptions.crossOrigin;
	    options.svgUid = svgUid;

	    if (descendants.length === 0 && fabric.isLikelyNode) {
	      // we're likely in node, where "o3-xml" library fails to gEBTN("*")
	      // https://github.com/ajaxorg/node-o3-xml/issues/21
	      descendants = doc.selectNodes('//*[name(.)!="svg"]');
	      var arr = [];
	      for (i = 0, len = descendants.length; i < len; i++) {
	        arr[i] = descendants[i];
	      }
	      descendants = arr;
	    }

	    var elements = descendants.filter(function(el) {
	      applyViewboxTransform(el);
	      return fabric.svgValidTagNamesRegEx.test(el.nodeName.replace('svg:', '')) &&
	            !hasAncestorWithNodeName(el, fabric.svgInvalidAncestorsRegEx); // http://www.w3.org/TR/SVG/struct.html#DefsElement
	    });
	    if (!elements || (elements && !elements.length)) {
	      callback && callback([], {});
	      return;
	    }
	    var clipPaths = { };
	    descendants.filter(function(el) {
	      return el.nodeName.replace('svg:', '') === 'clipPath';
	    }).forEach(function(el) {
	      var id = el.getAttribute('id');
	      clipPaths[id] = fabric.util.toArray(el.getElementsByTagName('*')).filter(function(el) {
	        return fabric.svgValidTagNamesRegEx.test(el.nodeName.replace('svg:', ''));
	      });
	    });
	    fabric.gradientDefs[svgUid] = fabric.getGradientDefs(doc);
	    fabric.cssRules[svgUid] = fabric.getCSSRules(doc);
	    fabric.clipPaths[svgUid] = clipPaths;
	    // Precedence of rules:   style > class > attribute
	    fabric.parseElements(elements, function(instances, elements) {
	      if (callback) {
	        callback(instances, options, elements, descendants);
	        delete fabric.gradientDefs[svgUid];
	        delete fabric.cssRules[svgUid];
	        delete fabric.clipPaths[svgUid];
	      }
	    }, clone(options), reviver, parsingOptions);
	  };

	  function recursivelyParseGradientsXlink(doc, gradient) {
	    var gradientsAttrs = ['gradientTransform', 'x1', 'x2', 'y1', 'y2', 'gradientUnits', 'cx', 'cy', 'r', 'fx', 'fy'],
	        xlinkAttr = 'xlink:href',
	        xLink = gradient.getAttribute(xlinkAttr).substr(1),
	        referencedGradient = elementById(doc, xLink);
	    if (referencedGradient && referencedGradient.getAttribute(xlinkAttr)) {
	      recursivelyParseGradientsXlink(doc, referencedGradient);
	    }
	    gradientsAttrs.forEach(function(attr) {
	      if (referencedGradient && !gradient.hasAttribute(attr) && referencedGradient.hasAttribute(attr)) {
	        gradient.setAttribute(attr, referencedGradient.getAttribute(attr));
	      }
	    });
	    if (!gradient.children.length) {
	      var referenceClone = referencedGradient.cloneNode(true);
	      while (referenceClone.firstChild) {
	        gradient.appendChild(referenceClone.firstChild);
	      }
	    }
	    gradient.removeAttribute(xlinkAttr);
	  }

	  var reFontDeclaration = new RegExp(
	    '(normal|italic)?\\s*(normal|small-caps)?\\s*' +
	    '(normal|bold|bolder|lighter|100|200|300|400|500|600|700|800|900)?\\s*(' +
	      fabric.reNum +
	    '(?:px|cm|mm|em|pt|pc|in)*)(?:\\/(normal|' + fabric.reNum + '))?\\s+(.*)');

	  extend(fabric, {
	    /**
	     * Parses a short font declaration, building adding its properties to a style object
	     * @static
	     * @function
	     * @memberOf fabric
	     * @param {String} value font declaration
	     * @param {Object} oStyle definition
	     */
	    parseFontDeclaration: function(value, oStyle) {
	      var match = value.match(reFontDeclaration);

	      if (!match) {
	        return;
	      }
	      var fontStyle = match[1],
	          // font variant is not used
	          // fontVariant = match[2],
	          fontWeight = match[3],
	          fontSize = match[4],
	          lineHeight = match[5],
	          fontFamily = match[6];

	      if (fontStyle) {
	        oStyle.fontStyle = fontStyle;
	      }
	      if (fontWeight) {
	        oStyle.fontWeight = isNaN(parseFloat(fontWeight)) ? fontWeight : parseFloat(fontWeight);
	      }
	      if (fontSize) {
	        oStyle.fontSize = parseUnit(fontSize);
	      }
	      if (fontFamily) {
	        oStyle.fontFamily = fontFamily;
	      }
	      if (lineHeight) {
	        oStyle.lineHeight = lineHeight === 'normal' ? 1 : lineHeight;
	      }
	    },

	    /**
	     * Parses an SVG document, returning all of the gradient declarations found in it
	     * @static
	     * @function
	     * @memberOf fabric
	     * @param {SVGDocument} doc SVG document to parse
	     * @return {Object} Gradient definitions; key corresponds to element id, value -- to gradient definition element
	     */
	    getGradientDefs: function(doc) {
	      var tagArray = [
	            'linearGradient',
	            'radialGradient',
	            'svg:linearGradient',
	            'svg:radialGradient'],
	          elList = _getMultipleNodes(doc, tagArray),
	          el, j = 0, gradientDefs = { };
	      j = elList.length;
	      while (j--) {
	        el = elList[j];
	        if (el.getAttribute('xlink:href')) {
	          recursivelyParseGradientsXlink(doc, el);
	        }
	        gradientDefs[el.getAttribute('id')] = el;
	      }
	      return gradientDefs;
	    },

	    /**
	     * Returns an object of attributes' name/value, given element and an array of attribute names;
	     * Parses parent "g" nodes recursively upwards.
	     * @static
	     * @memberOf fabric
	     * @param {DOMElement} element Element to parse
	     * @param {Array} attributes Array of attributes to parse
	     * @return {Object} object containing parsed attributes' names/values
	     */
	    parseAttributes: function(element, attributes, svgUid) {

	      if (!element) {
	        return;
	      }

	      var value,
	          parentAttributes = { },
	          fontSize, parentFontSize;

	      if (typeof svgUid === 'undefined') {
	        svgUid = element.getAttribute('svgUid');
	      }
	      // if there's a parent container (`g` or `a` or `symbol` node), parse its attributes recursively upwards
	      if (element.parentNode && fabric.svgValidParentsRegEx.test(element.parentNode.nodeName)) {
	        parentAttributes = fabric.parseAttributes(element.parentNode, attributes, svgUid);
	      }

	      var ownAttributes = attributes.reduce(function(memo, attr) {
	        value = element.getAttribute(attr);
	        if (value) { // eslint-disable-line
	          memo[attr] = value;
	        }
	        return memo;
	      }, { });
	      // add values parsed from style, which take precedence over attributes
	      // (see: http://www.w3.org/TR/SVG/styling.html#UsingPresentationAttributes)
	      var cssAttrs = extend(
	        getGlobalStylesForElement(element, svgUid),
	        fabric.parseStyleAttribute(element)
	      );
	      ownAttributes = extend(
	        ownAttributes,
	        cssAttrs
	      );
	      if (cssAttrs[cPath]) {
	        element.setAttribute(cPath, cssAttrs[cPath]);
	      }
	      fontSize = parentFontSize = parentAttributes.fontSize || fabric.Text.DEFAULT_SVG_FONT_SIZE;
	      if (ownAttributes[fSize]) {
	        // looks like the minimum should be 9px when dealing with ems. this is what looks like in browsers.
	        ownAttributes[fSize] = fontSize = parseUnit(ownAttributes[fSize], parentFontSize);
	      }

	      var normalizedAttr, normalizedValue, normalizedStyle = {};
	      for (var attr in ownAttributes) {
	        normalizedAttr = normalizeAttr(attr);
	        normalizedValue = normalizeValue(normalizedAttr, ownAttributes[attr], parentAttributes, fontSize);
	        normalizedStyle[normalizedAttr] = normalizedValue;
	      }
	      if (normalizedStyle && normalizedStyle.font) {
	        fabric.parseFontDeclaration(normalizedStyle.font, normalizedStyle);
	      }
	      var mergedAttrs = extend(parentAttributes, normalizedStyle);
	      return fabric.svgValidParentsRegEx.test(element.nodeName) ? mergedAttrs : _setStrokeFillOpacity(mergedAttrs);
	    },

	    /**
	     * Transforms an array of svg elements to corresponding fabric.* instances
	     * @static
	     * @memberOf fabric
	     * @param {Array} elements Array of elements to parse
	     * @param {Function} callback Being passed an array of fabric instances (transformed from SVG elements)
	     * @param {Object} [options] Options object
	     * @param {Function} [reviver] Method for further parsing of SVG elements, called after each fabric object created.
	     */
	    parseElements: function(elements, callback, options, reviver, parsingOptions) {
	      new fabric.ElementsParser(elements, callback, options, reviver, parsingOptions).parse();
	    },

	    /**
	     * Parses "style" attribute, retuning an object with values
	     * @static
	     * @memberOf fabric
	     * @param {SVGElement} element Element to parse
	     * @return {Object} Objects with values parsed from style attribute of an element
	     */
	    parseStyleAttribute: function(element) {
	      var oStyle = { },
	          style = element.getAttribute('style');

	      if (!style) {
	        return oStyle;
	      }

	      if (typeof style === 'string') {
	        parseStyleString(style, oStyle);
	      }
	      else {
	        parseStyleObject(style, oStyle);
	      }

	      return oStyle;
	    },

	    /**
	     * Parses "points" attribute, returning an array of values
	     * @static
	     * @memberOf fabric
	     * @param {String} points points attribute string
	     * @return {Array} array of points
	     */
	    parsePointsAttribute: function(points) {

	      // points attribute is required and must not be empty
	      if (!points) {
	        return null;
	      }

	      // replace commas with whitespace and remove bookending whitespace
	      points = points.replace(/,/g, ' ').trim();

	      points = points.split(/\s+/);
	      var parsedPoints = [], i, len;

	      for (i = 0, len = points.length; i < len; i += 2) {
	        parsedPoints.push({
	          x: parseFloat(points[i]),
	          y: parseFloat(points[i + 1])
	        });
	      }

	      // odd number of points is an error
	      // if (parsedPoints.length % 2 !== 0) {
	      //   return null;
	      // }

	      return parsedPoints;
	    },

	    /**
	     * Returns CSS rules for a given SVG document
	     * @static
	     * @function
	     * @memberOf fabric
	     * @param {SVGDocument} doc SVG document to parse
	     * @return {Object} CSS rules of this document
	     */
	    getCSSRules: function(doc) {
	      var styles = doc.getElementsByTagName('style'), i, len,
	          allRules = { }, rules;

	      // very crude parsing of style contents
	      for (i = 0, len = styles.length; i < len; i++) {
	        var styleContents = styles[i].textContent;

	        // remove comments
	        styleContents = styleContents.replace(/\/\*[\s\S]*?\*\//g, '');
	        if (styleContents.trim() === '') {
	          continue;
	        }
	        rules = styleContents.match(/[^{]*\{[\s\S]*?\}/g);
	        rules = rules.map(function(rule) { return rule.trim(); });
	        // eslint-disable-next-line no-loop-func
	        rules.forEach(function(rule) {

	          var match = rule.match(/([\s\S]*?)\s*\{([^}]*)\}/),
	              ruleObj = { }, declaration = match[2].trim(),
	              propertyValuePairs = declaration.replace(/;$/, '').split(/\s*;\s*/);

	          for (i = 0, len = propertyValuePairs.length; i < len; i++) {
	            var pair = propertyValuePairs[i].split(/\s*:\s*/),
	                property = pair[0],
	                value = pair[1];
	            ruleObj[property] = value;
	          }
	          rule = match[1];
	          rule.split(',').forEach(function(_rule) {
	            _rule = _rule.replace(/^svg/i, '').trim();
	            if (_rule === '') {
	              return;
	            }
	            if (allRules[_rule]) {
	              fabric.util.object.extend(allRules[_rule], ruleObj);
	            }
	            else {
	              allRules[_rule] = fabric.util.object.clone(ruleObj);
	            }
	          });
	        });
	      }
	      return allRules;
	    },

	    /**
	     * Takes url corresponding to an SVG document, and parses it into a set of fabric objects.
	     * Note that SVG is fetched via XMLHttpRequest, so it needs to conform to SOP (Same Origin Policy)
	     * @memberOf fabric
	     * @param {String} url
	     * @param {Function} callback
	     * @param {Function} [reviver] Method for further parsing of SVG elements, called after each fabric object created.
	     * @param {Object} [options] Object containing options for parsing
	     * @param {String} [options.crossOrigin] crossOrigin crossOrigin setting to use for external resources
	     */
	    loadSVGFromURL: function(url, callback, reviver, options) {

	      url = url.replace(/^\n\s*/, '').trim();
	      new fabric.util.request(url, {
	        method: 'get',
	        onComplete: onComplete
	      });

	      function onComplete(r) {

	        var xml = r.responseXML;
	        if (!xml || !xml.documentElement) {
	          callback && callback(null);
	          return false;
	        }

	        fabric.parseSVGDocument(xml.documentElement, function (results, _options, elements, allElements) {
	          callback && callback(results, _options, elements, allElements);
	        }, reviver, options);
	      }
	    },

	    /**
	     * Takes string corresponding to an SVG document, and parses it into a set of fabric objects
	     * @memberOf fabric
	     * @param {String} string
	     * @param {Function} callback
	     * @param {Function} [reviver] Method for further parsing of SVG elements, called after each fabric object created.
	     * @param {Object} [options] Object containing options for parsing
	     * @param {String} [options.crossOrigin] crossOrigin crossOrigin setting to use for external resources
	     */
	    loadSVGFromString: function(string, callback, reviver, options) {
	      var parser = new fabric.window.DOMParser(),
	          doc = parser.parseFromString(string.trim(), 'text/xml');
	      fabric.parseSVGDocument(doc.documentElement, function (results, _options, elements, allElements) {
	        callback(results, _options, elements, allElements);
	      }, reviver, options);
	    }
	  });

	})(exports );


	fabric.ElementsParser = function(elements, callback, options, reviver, parsingOptions, doc) {
	  this.elements = elements;
	  this.callback = callback;
	  this.options = options;
	  this.reviver = reviver;
	  this.svgUid = (options && options.svgUid) || 0;
	  this.parsingOptions = parsingOptions;
	  this.regexUrl = /^url\(['"]?#([^'"]+)['"]?\)/g;
	  this.doc = doc;
	};

	(function(proto) {
	  proto.parse = function() {
	    this.instances = new Array(this.elements.length);
	    this.numElements = this.elements.length;
	    this.createObjects();
	  };

	  proto.createObjects = function() {
	    var _this = this;
	    this.elements.forEach(function(element, i) {
	      element.setAttribute('svgUid', _this.svgUid);
	      _this.createObject(element, i);
	    });
	  };

	  proto.findTag = function(el) {
	    return fabric[fabric.util.string.capitalize(el.tagName.replace('svg:', ''))];
	  };

	  proto.createObject = function(el, index) {
	    var klass = this.findTag(el);
	    if (klass && klass.fromElement) {
	      try {
	        klass.fromElement(el, this.createCallback(index, el), this.options);
	      }
	      catch (err) {
	        fabric.log(err);
	      }
	    }
	    else {
	      this.checkIfDone();
	    }
	  };

	  proto.createCallback = function(index, el) {
	    var _this = this;
	    return function(obj) {
	      var _options;
	      _this.resolveGradient(obj, el, 'fill');
	      _this.resolveGradient(obj, el, 'stroke');
	      if (obj instanceof fabric.Image && obj._originalElement) {
	        _options = obj.parsePreserveAspectRatioAttribute(el);
	      }
	      obj._removeTransformMatrix(_options);
	      _this.resolveClipPath(obj, el);
	      _this.reviver && _this.reviver(el, obj);
	      _this.instances[index] = obj;
	      _this.checkIfDone();
	    };
	  };

	  proto.extractPropertyDefinition = function(obj, property, storage) {
	    var value = obj[property], regex = this.regexUrl;
	    if (!regex.test(value)) {
	      return;
	    }
	    regex.lastIndex = 0;
	    var id = regex.exec(value)[1];
	    regex.lastIndex = 0;
	    return fabric[storage][this.svgUid][id];
	  };

	  proto.resolveGradient = function(obj, el, property) {
	    var gradientDef = this.extractPropertyDefinition(obj, property, 'gradientDefs');
	    if (gradientDef) {
	      var opacityAttr = el.getAttribute(property + '-opacity');
	      var gradient = fabric.Gradient.fromElement(gradientDef, obj, opacityAttr, this.options);
	      obj.set(property, gradient);
	    }
	  };

	  proto.createClipPathCallback = function(obj, container) {
	    return function(_newObj) {
	      _newObj._removeTransformMatrix();
	      _newObj.fillRule = _newObj.clipRule;
	      container.push(_newObj);
	    };
	  };

	  proto.resolveClipPath = function(obj, usingElement) {
	    var clipPath = this.extractPropertyDefinition(obj, 'clipPath', 'clipPaths'),
	        element, klass, objTransformInv, container, gTransform, options;
	    if (clipPath) {
	      container = [];
	      objTransformInv = fabric.util.invertTransform(obj.calcTransformMatrix());
	      // move the clipPath tag as sibling to the real element that is using it
	      var clipPathTag = clipPath[0].parentNode;
	      var clipPathOwner = usingElement;
	      while (clipPathOwner.parentNode && clipPathOwner.getAttribute('clip-path') !== obj.clipPath) {
	        clipPathOwner = clipPathOwner.parentNode;
	      }
	      clipPathOwner.parentNode.appendChild(clipPathTag);
	      for (var i = 0; i < clipPath.length; i++) {
	        element = clipPath[i];
	        klass = this.findTag(element);
	        klass.fromElement(
	          element,
	          this.createClipPathCallback(obj, container),
	          this.options
	        );
	      }
	      if (container.length === 1) {
	        clipPath = container[0];
	      }
	      else {
	        clipPath = new fabric.Group(container);
	      }
	      gTransform = fabric.util.multiplyTransformMatrices(
	        objTransformInv,
	        clipPath.calcTransformMatrix()
	      );
	      if (clipPath.clipPath) {
	        this.resolveClipPath(clipPath, clipPathOwner);
	      }
	      var options = fabric.util.qrDecompose(gTransform);
	      clipPath.flipX = false;
	      clipPath.flipY = false;
	      clipPath.set('scaleX', options.scaleX);
	      clipPath.set('scaleY', options.scaleY);
	      clipPath.angle = options.angle;
	      clipPath.skewX = options.skewX;
	      clipPath.skewY = 0;
	      clipPath.setPositionByOrigin({ x: options.translateX, y: options.translateY }, 'center', 'center');
	      obj.clipPath = clipPath;
	    }
	    else {
	      // if clip-path does not resolve to any element, delete the property.
	      delete obj.clipPath;
	    }
	  };

	  proto.checkIfDone = function() {
	    if (--this.numElements === 0) {
	      this.instances = this.instances.filter(function(el) {
	        // eslint-disable-next-line no-eq-null, eqeqeq
	        return el != null;
	      });
	      this.callback(this.instances, this.elements);
	    }
	  };
	})(fabric.ElementsParser.prototype);


	(function(global) {

	  /* Adaptation of work of Kevin Lindsey (kevin@kevlindev.com) */

	  var fabric = global.fabric || (global.fabric = { });

	  if (fabric.Point) {
	    fabric.warn('fabric.Point is already defined');
	    return;
	  }

	  fabric.Point = Point;

	  /**
	   * Point class
	   * @class fabric.Point
	   * @memberOf fabric
	   * @constructor
	   * @param {Number} x
	   * @param {Number} y
	   * @return {fabric.Point} thisArg
	   */
	  function Point(x, y) {
	    this.x = x;
	    this.y = y;
	  }

	  Point.prototype = /** @lends fabric.Point.prototype */ {

	    type: 'point',

	    constructor: Point,

	    /**
	     * Adds another point to this one and returns another one
	     * @param {fabric.Point} that
	     * @return {fabric.Point} new Point instance with added values
	     */
	    add: function (that) {
	      return new Point(this.x + that.x, this.y + that.y);
	    },

	    /**
	     * Adds another point to this one
	     * @param {fabric.Point} that
	     * @return {fabric.Point} thisArg
	     * @chainable
	     */
	    addEquals: function (that) {
	      this.x += that.x;
	      this.y += that.y;
	      return this;
	    },

	    /**
	     * Adds value to this point and returns a new one
	     * @param {Number} scalar
	     * @return {fabric.Point} new Point with added value
	     */
	    scalarAdd: function (scalar) {
	      return new Point(this.x + scalar, this.y + scalar);
	    },

	    /**
	     * Adds value to this point
	     * @param {Number} scalar
	     * @return {fabric.Point} thisArg
	     * @chainable
	     */
	    scalarAddEquals: function (scalar) {
	      this.x += scalar;
	      this.y += scalar;
	      return this;
	    },

	    /**
	     * Subtracts another point from this point and returns a new one
	     * @param {fabric.Point} that
	     * @return {fabric.Point} new Point object with subtracted values
	     */
	    subtract: function (that) {
	      return new Point(this.x - that.x, this.y - that.y);
	    },

	    /**
	     * Subtracts another point from this point
	     * @param {fabric.Point} that
	     * @return {fabric.Point} thisArg
	     * @chainable
	     */
	    subtractEquals: function (that) {
	      this.x -= that.x;
	      this.y -= that.y;
	      return this;
	    },

	    /**
	     * Subtracts value from this point and returns a new one
	     * @param {Number} scalar
	     * @return {fabric.Point}
	     */
	    scalarSubtract: function (scalar) {
	      return new Point(this.x - scalar, this.y - scalar);
	    },

	    /**
	     * Subtracts value from this point
	     * @param {Number} scalar
	     * @return {fabric.Point} thisArg
	     * @chainable
	     */
	    scalarSubtractEquals: function (scalar) {
	      this.x -= scalar;
	      this.y -= scalar;
	      return this;
	    },

	    /**
	     * Multiplies this point by a value and returns a new one
	     * TODO: rename in scalarMultiply in 2.0
	     * @param {Number} scalar
	     * @return {fabric.Point}
	     */
	    multiply: function (scalar) {
	      return new Point(this.x * scalar, this.y * scalar);
	    },

	    /**
	     * Multiplies this point by a value
	     * TODO: rename in scalarMultiplyEquals in 2.0
	     * @param {Number} scalar
	     * @return {fabric.Point} thisArg
	     * @chainable
	     */
	    multiplyEquals: function (scalar) {
	      this.x *= scalar;
	      this.y *= scalar;
	      return this;
	    },

	    /**
	     * Divides this point by a value and returns a new one
	     * TODO: rename in scalarDivide in 2.0
	     * @param {Number} scalar
	     * @return {fabric.Point}
	     */
	    divide: function (scalar) {
	      return new Point(this.x / scalar, this.y / scalar);
	    },

	    /**
	     * Divides this point by a value
	     * TODO: rename in scalarDivideEquals in 2.0
	     * @param {Number} scalar
	     * @return {fabric.Point} thisArg
	     * @chainable
	     */
	    divideEquals: function (scalar) {
	      this.x /= scalar;
	      this.y /= scalar;
	      return this;
	    },

	    /**
	     * Returns true if this point is equal to another one
	     * @param {fabric.Point} that
	     * @return {Boolean}
	     */
	    eq: function (that) {
	      return (this.x === that.x && this.y === that.y);
	    },

	    /**
	     * Returns true if this point is less than another one
	     * @param {fabric.Point} that
	     * @return {Boolean}
	     */
	    lt: function (that) {
	      return (this.x < that.x && this.y < that.y);
	    },

	    /**
	     * Returns true if this point is less than or equal to another one
	     * @param {fabric.Point} that
	     * @return {Boolean}
	     */
	    lte: function (that) {
	      return (this.x <= that.x && this.y <= that.y);
	    },

	    /**

	     * Returns true if this point is greater another one
	     * @param {fabric.Point} that
	     * @return {Boolean}
	     */
	    gt: function (that) {
	      return (this.x > that.x && this.y > that.y);
	    },

	    /**
	     * Returns true if this point is greater than or equal to another one
	     * @param {fabric.Point} that
	     * @return {Boolean}
	     */
	    gte: function (that) {
	      return (this.x >= that.x && this.y >= that.y);
	    },

	    /**
	     * Returns new point which is the result of linear interpolation with this one and another one
	     * @param {fabric.Point} that
	     * @param {Number} t , position of interpolation, between 0 and 1 default 0.5
	     * @return {fabric.Point}
	     */
	    lerp: function (that, t) {
	      if (typeof t === 'undefined') {
	        t = 0.5;
	      }
	      t = Math.max(Math.min(1, t), 0);
	      return new Point(this.x + (that.x - this.x) * t, this.y + (that.y - this.y) * t);
	    },

	    /**
	     * Returns distance from this point and another one
	     * @param {fabric.Point} that
	     * @return {Number}
	     */
	    distanceFrom: function (that) {
	      var dx = this.x - that.x,
	          dy = this.y - that.y;
	      return Math.sqrt(dx * dx + dy * dy);
	    },

	    /**
	     * Returns the point between this point and another one
	     * @param {fabric.Point} that
	     * @return {fabric.Point}
	     */
	    midPointFrom: function (that) {
	      return this.lerp(that);
	    },

	    /**
	     * Returns a new point which is the min of this and another one
	     * @param {fabric.Point} that
	     * @return {fabric.Point}
	     */
	    min: function (that) {
	      return new Point(Math.min(this.x, that.x), Math.min(this.y, that.y));
	    },

	    /**
	     * Returns a new point which is the max of this and another one
	     * @param {fabric.Point} that
	     * @return {fabric.Point}
	     */
	    max: function (that) {
	      return new Point(Math.max(this.x, that.x), Math.max(this.y, that.y));
	    },

	    /**
	     * Returns string representation of this point
	     * @return {String}
	     */
	    toString: function () {
	      return this.x + ',' + this.y;
	    },

	    /**
	     * Sets x/y of this point
	     * @param {Number} x
	     * @param {Number} y
	     * @chainable
	     */
	    setXY: function (x, y) {
	      this.x = x;
	      this.y = y;
	      return this;
	    },

	    /**
	     * Sets x of this point
	     * @param {Number} x
	     * @chainable
	     */
	    setX: function (x) {
	      this.x = x;
	      return this;
	    },

	    /**
	     * Sets y of this point
	     * @param {Number} y
	     * @chainable
	     */
	    setY: function (y) {
	      this.y = y;
	      return this;
	    },

	    /**
	     * Sets x/y of this point from another point
	     * @param {fabric.Point} that
	     * @chainable
	     */
	    setFromPoint: function (that) {
	      this.x = that.x;
	      this.y = that.y;
	      return this;
	    },

	    /**
	     * Swaps x/y of this point and another point
	     * @param {fabric.Point} that
	     */
	    swap: function (that) {
	      var x = this.x,
	          y = this.y;
	      this.x = that.x;
	      this.y = that.y;
	      that.x = x;
	      that.y = y;
	    },

	    /**
	     * return a cloned instance of the point
	     * @return {fabric.Point}
	     */
	    clone: function () {
	      return new Point(this.x, this.y);
	    }
	  };

	})(exports );


	(function(global) {

	  /* Adaptation of work of Kevin Lindsey (kevin@kevlindev.com) */
	  var fabric = global.fabric || (global.fabric = { });

	  if (fabric.Intersection) {
	    fabric.warn('fabric.Intersection is already defined');
	    return;
	  }

	  /**
	   * Intersection class
	   * @class fabric.Intersection
	   * @memberOf fabric
	   * @constructor
	   */
	  function Intersection(status) {
	    this.status = status;
	    this.points = [];
	  }

	  fabric.Intersection = Intersection;

	  fabric.Intersection.prototype = /** @lends fabric.Intersection.prototype */ {

	    constructor: Intersection,

	    /**
	     * Appends a point to intersection
	     * @param {fabric.Point} point
	     * @return {fabric.Intersection} thisArg
	     * @chainable
	     */
	    appendPoint: function (point) {
	      this.points.push(point);
	      return this;
	    },

	    /**
	     * Appends points to intersection
	     * @param {Array} points
	     * @return {fabric.Intersection} thisArg
	     * @chainable
	     */
	    appendPoints: function (points) {
	      this.points = this.points.concat(points);
	      return this;
	    }
	  };

	  /**
	   * Checks if one line intersects another
	   * TODO: rename in intersectSegmentSegment
	   * @static
	   * @param {fabric.Point} a1
	   * @param {fabric.Point} a2
	   * @param {fabric.Point} b1
	   * @param {fabric.Point} b2
	   * @return {fabric.Intersection}
	   */
	  fabric.Intersection.intersectLineLine = function (a1, a2, b1, b2) {
	    var result,
	        uaT = (b2.x - b1.x) * (a1.y - b1.y) - (b2.y - b1.y) * (a1.x - b1.x),
	        ubT = (a2.x - a1.x) * (a1.y - b1.y) - (a2.y - a1.y) * (a1.x - b1.x),
	        uB = (b2.y - b1.y) * (a2.x - a1.x) - (b2.x - b1.x) * (a2.y - a1.y);
	    if (uB !== 0) {
	      var ua = uaT / uB,
	          ub = ubT / uB;
	      if (0 <= ua && ua <= 1 && 0 <= ub && ub <= 1) {
	        result = new Intersection('Intersection');
	        result.appendPoint(new fabric.Point(a1.x + ua * (a2.x - a1.x), a1.y + ua * (a2.y - a1.y)));
	      }
	      else {
	        result = new Intersection();
	      }
	    }
	    else {
	      if (uaT === 0 || ubT === 0) {
	        result = new Intersection('Coincident');
	      }
	      else {
	        result = new Intersection('Parallel');
	      }
	    }
	    return result;
	  };

	  /**
	   * Checks if line intersects polygon
	   * TODO: rename in intersectSegmentPolygon
	   * fix detection of coincident
	   * @static
	   * @param {fabric.Point} a1
	   * @param {fabric.Point} a2
	   * @param {Array} points
	   * @return {fabric.Intersection}
	   */
	  fabric.Intersection.intersectLinePolygon = function(a1, a2, points) {
	    var result = new Intersection(),
	        length = points.length,
	        b1, b2, inter, i;

	    for (i = 0; i < length; i++) {
	      b1 = points[i];
	      b2 = points[(i + 1) % length];
	      inter = Intersection.intersectLineLine(a1, a2, b1, b2);

	      result.appendPoints(inter.points);
	    }
	    if (result.points.length > 0) {
	      result.status = 'Intersection';
	    }
	    return result;
	  };

	  /**
	   * Checks if polygon intersects another polygon
	   * @static
	   * @param {Array} points1
	   * @param {Array} points2
	   * @return {fabric.Intersection}
	   */
	  fabric.Intersection.intersectPolygonPolygon = function (points1, points2) {
	    var result = new Intersection(),
	        length = points1.length, i;

	    for (i = 0; i < length; i++) {
	      var a1 = points1[i],
	          a2 = points1[(i + 1) % length],
	          inter = Intersection.intersectLinePolygon(a1, a2, points2);

	      result.appendPoints(inter.points);
	    }
	    if (result.points.length > 0) {
	      result.status = 'Intersection';
	    }
	    return result;
	  };

	  /**
	   * Checks if polygon intersects rectangle
	   * @static
	   * @param {Array} points
	   * @param {fabric.Point} r1
	   * @param {fabric.Point} r2
	   * @return {fabric.Intersection}
	   */
	  fabric.Intersection.intersectPolygonRectangle = function (points, r1, r2) {
	    var min = r1.min(r2),
	        max = r1.max(r2),
	        topRight = new fabric.Point(max.x, min.y),
	        bottomLeft = new fabric.Point(min.x, max.y),
	        inter1 = Intersection.intersectLinePolygon(min, topRight, points),
	        inter2 = Intersection.intersectLinePolygon(topRight, max, points),
	        inter3 = Intersection.intersectLinePolygon(max, bottomLeft, points),
	        inter4 = Intersection.intersectLinePolygon(bottomLeft, min, points),
	        result = new Intersection();

	    result.appendPoints(inter1.points);
	    result.appendPoints(inter2.points);
	    result.appendPoints(inter3.points);
	    result.appendPoints(inter4.points);

	    if (result.points.length > 0) {
	      result.status = 'Intersection';
	    }
	    return result;
	  };

	})(exports );


	(function(global) {

	  var fabric = global.fabric || (global.fabric = { });

	  if (fabric.Color) {
	    fabric.warn('fabric.Color is already defined.');
	    return;
	  }

	  /**
	   * Color class
	   * The purpose of {@link fabric.Color} is to abstract and encapsulate common color operations;
	   * {@link fabric.Color} is a constructor and creates instances of {@link fabric.Color} objects.
	   *
	   * @class fabric.Color
	   * @param {String} color optional in hex or rgb(a) or hsl format or from known color list
	   * @return {fabric.Color} thisArg
	   * @tutorial {@link http://fabricjs.com/fabric-intro-part-2/#colors}
	   */
	  function Color(color) {
	    if (!color) {
	      this.setSource([0, 0, 0, 1]);
	    }
	    else {
	      this._tryParsingColor(color);
	    }
	  }

	  fabric.Color = Color;

	  fabric.Color.prototype = /** @lends fabric.Color.prototype */ {

	    /**
	     * @private
	     * @param {String|Array} color Color value to parse
	     */
	    _tryParsingColor: function(color) {
	      var source;

	      if (color in Color.colorNameMap) {
	        color = Color.colorNameMap[color];
	      }

	      if (color === 'transparent') {
	        source = [255, 255, 255, 0];
	      }

	      if (!source) {
	        source = Color.sourceFromHex(color);
	      }
	      if (!source) {
	        source = Color.sourceFromRgb(color);
	      }
	      if (!source) {
	        source = Color.sourceFromHsl(color);
	      }
	      if (!source) {
	        //if color is not recognize let's make black as canvas does
	        source = [0, 0, 0, 1];
	      }
	      if (source) {
	        this.setSource(source);
	      }
	    },

	    /**
	     * Adapted from <a href="https://rawgithub.com/mjijackson/mjijackson.github.com/master/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript.html">https://github.com/mjijackson</a>
	     * @private
	     * @param {Number} r Red color value
	     * @param {Number} g Green color value
	     * @param {Number} b Blue color value
	     * @return {Array} Hsl color
	     */
	    _rgbToHsl: function(r, g, b) {
	      r /= 255; g /= 255; b /= 255;

	      var h, s, l,
	          max = fabric.util.array.max([r, g, b]),
	          min = fabric.util.array.min([r, g, b]);

	      l = (max + min) / 2;

	      if (max === min) {
	        h = s = 0; // achromatic
	      }
	      else {
	        var d = max - min;
	        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
	        switch (max) {
	          case r:
	            h = (g - b) / d + (g < b ? 6 : 0);
	            break;
	          case g:
	            h = (b - r) / d + 2;
	            break;
	          case b:
	            h = (r - g) / d + 4;
	            break;
	        }
	        h /= 6;
	      }

	      return [
	        Math.round(h * 360),
	        Math.round(s * 100),
	        Math.round(l * 100)
	      ];
	    },

	    /**
	     * Returns source of this color (where source is an array representation; ex: [200, 200, 100, 1])
	     * @return {Array}
	     */
	    getSource: function() {
	      return this._source;
	    },

	    /**
	     * Sets source of this color (where source is an array representation; ex: [200, 200, 100, 1])
	     * @param {Array} source
	     */
	    setSource: function(source) {
	      this._source = source;
	    },

	    /**
	     * Returns color representation in RGB format
	     * @return {String} ex: rgb(0-255,0-255,0-255)
	     */
	    toRgb: function() {
	      var source = this.getSource();
	      return 'rgb(' + source[0] + ',' + source[1] + ',' + source[2] + ')';
	    },

	    /**
	     * Returns color representation in RGBA format
	     * @return {String} ex: rgba(0-255,0-255,0-255,0-1)
	     */
	    toRgba: function() {
	      var source = this.getSource();
	      return 'rgba(' + source[0] + ',' + source[1] + ',' + source[2] + ',' + source[3] + ')';
	    },

	    /**
	     * Returns color representation in HSL format
	     * @return {String} ex: hsl(0-360,0%-100%,0%-100%)
	     */
	    toHsl: function() {
	      var source = this.getSource(),
	          hsl = this._rgbToHsl(source[0], source[1], source[2]);

	      return 'hsl(' + hsl[0] + ',' + hsl[1] + '%,' + hsl[2] + '%)';
	    },

	    /**
	     * Returns color representation in HSLA format
	     * @return {String} ex: hsla(0-360,0%-100%,0%-100%,0-1)
	     */
	    toHsla: function() {
	      var source = this.getSource(),
	          hsl = this._rgbToHsl(source[0], source[1], source[2]);

	      return 'hsla(' + hsl[0] + ',' + hsl[1] + '%,' + hsl[2] + '%,' + source[3] + ')';
	    },

	    /**
	     * Returns color representation in HEX format
	     * @return {String} ex: FF5555
	     */
	    toHex: function() {
	      var source = this.getSource(), r, g, b;

	      r = source[0].toString(16);
	      r = (r.length === 1) ? ('0' + r) : r;

	      g = source[1].toString(16);
	      g = (g.length === 1) ? ('0' + g) : g;

	      b = source[2].toString(16);
	      b = (b.length === 1) ? ('0' + b) : b;

	      return r.toUpperCase() + g.toUpperCase() + b.toUpperCase();
	    },

	    /**
	     * Returns color representation in HEXA format
	     * @return {String} ex: FF5555CC
	     */
	    toHexa: function() {
	      var source = this.getSource(), a;

	      a = Math.round(source[3] * 255);
	      a = a.toString(16);
	      a = (a.length === 1) ? ('0' + a) : a;

	      return this.toHex() + a.toUpperCase();
	    },

	    /**
	     * Gets value of alpha channel for this color
	     * @return {Number} 0-1
	     */
	    getAlpha: function() {
	      return this.getSource()[3];
	    },

	    /**
	     * Sets value of alpha channel for this color
	     * @param {Number} alpha Alpha value 0-1
	     * @return {fabric.Color} thisArg
	     */
	    setAlpha: function(alpha) {
	      var source = this.getSource();
	      source[3] = alpha;
	      this.setSource(source);
	      return this;
	    },

	    /**
	     * Transforms color to its grayscale representation
	     * @return {fabric.Color} thisArg
	     */
	    toGrayscale: function() {
	      var source = this.getSource(),
	          average = parseInt((source[0] * 0.3 + source[1] * 0.59 + source[2] * 0.11).toFixed(0), 10),
	          currentAlpha = source[3];
	      this.setSource([average, average, average, currentAlpha]);
	      return this;
	    },

	    /**
	     * Transforms color to its black and white representation
	     * @param {Number} threshold
	     * @return {fabric.Color} thisArg
	     */
	    toBlackWhite: function(threshold) {
	      var source = this.getSource(),
	          average = (source[0] * 0.3 + source[1] * 0.59 + source[2] * 0.11).toFixed(0),
	          currentAlpha = source[3];

	      threshold = threshold || 127;

	      average = (Number(average) < Number(threshold)) ? 0 : 255;
	      this.setSource([average, average, average, currentAlpha]);
	      return this;
	    },

	    /**
	     * Overlays color with another color
	     * @param {String|fabric.Color} otherColor
	     * @return {fabric.Color} thisArg
	     */
	    overlayWith: function(otherColor) {
	      if (!(otherColor instanceof Color)) {
	        otherColor = new Color(otherColor);
	      }

	      var result = [],
	          alpha = this.getAlpha(),
	          otherAlpha = 0.5,
	          source = this.getSource(),
	          otherSource = otherColor.getSource(), i;

	      for (i = 0; i < 3; i++) {
	        result.push(Math.round((source[i] * (1 - otherAlpha)) + (otherSource[i] * otherAlpha)));
	      }

	      result[3] = alpha;
	      this.setSource(result);
	      return this;
	    }
	  };

	  /**
	   * Regex matching color in RGB or RGBA formats (ex: rgb(0, 0, 0), rgba(255, 100, 10, 0.5), rgba( 255 , 100 , 10 , 0.5 ), rgb(1,1,1), rgba(100%, 60%, 10%, 0.5))
	   * @static
	   * @field
	   * @memberOf fabric.Color
	   */
	  // eslint-disable-next-line max-len
	  fabric.Color.reRGBa = /^rgba?\(\s*(\d{1,3}(?:\.\d+)?\%?)\s*,\s*(\d{1,3}(?:\.\d+)?\%?)\s*,\s*(\d{1,3}(?:\.\d+)?\%?)\s*(?:\s*,\s*((?:\d*\.?\d+)?)\s*)?\)$/i;

	  /**
	   * Regex matching color in HSL or HSLA formats (ex: hsl(200, 80%, 10%), hsla(300, 50%, 80%, 0.5), hsla( 300 , 50% , 80% , 0.5 ))
	   * @static
	   * @field
	   * @memberOf fabric.Color
	   */
	  fabric.Color.reHSLa = /^hsla?\(\s*(\d{1,3})\s*,\s*(\d{1,3}\%)\s*,\s*(\d{1,3}\%)\s*(?:\s*,\s*(\d+(?:\.\d+)?)\s*)?\)$/i;

	  /**
	   * Regex matching color in HEX format (ex: #FF5544CC, #FF5555, 010155, aff)
	   * @static
	   * @field
	   * @memberOf fabric.Color
	   */
	  fabric.Color.reHex = /^#?([0-9a-f]{8}|[0-9a-f]{6}|[0-9a-f]{4}|[0-9a-f]{3})$/i;

	  /**
	   * Map of the 148 color names with HEX code
	   * @static
	   * @field
	   * @memberOf fabric.Color
	   * @see: https://www.w3.org/TR/css3-color/#svg-color
	   */
	  fabric.Color.colorNameMap = {
	    aliceblue:            '#F0F8FF',
	    antiquewhite:         '#FAEBD7',
	    aqua:                 '#00FFFF',
	    aquamarine:           '#7FFFD4',
	    azure:                '#F0FFFF',
	    beige:                '#F5F5DC',
	    bisque:               '#FFE4C4',
	    black:                '#000000',
	    blanchedalmond:       '#FFEBCD',
	    blue:                 '#0000FF',
	    blueviolet:           '#8A2BE2',
	    brown:                '#A52A2A',
	    burlywood:            '#DEB887',
	    cadetblue:            '#5F9EA0',
	    chartreuse:           '#7FFF00',
	    chocolate:            '#D2691E',
	    coral:                '#FF7F50',
	    cornflowerblue:       '#6495ED',
	    cornsilk:             '#FFF8DC',
	    crimson:              '#DC143C',
	    cyan:                 '#00FFFF',
	    darkblue:             '#00008B',
	    darkcyan:             '#008B8B',
	    darkgoldenrod:        '#B8860B',
	    darkgray:             '#A9A9A9',
	    darkgrey:             '#A9A9A9',
	    darkgreen:            '#006400',
	    darkkhaki:            '#BDB76B',
	    darkmagenta:          '#8B008B',
	    darkolivegreen:       '#556B2F',
	    darkorange:           '#FF8C00',
	    darkorchid:           '#9932CC',
	    darkred:              '#8B0000',
	    darksalmon:           '#E9967A',
	    darkseagreen:         '#8FBC8F',
	    darkslateblue:        '#483D8B',
	    darkslategray:        '#2F4F4F',
	    darkslategrey:        '#2F4F4F',
	    darkturquoise:        '#00CED1',
	    darkviolet:           '#9400D3',
	    deeppink:             '#FF1493',
	    deepskyblue:          '#00BFFF',
	    dimgray:              '#696969',
	    dimgrey:              '#696969',
	    dodgerblue:           '#1E90FF',
	    firebrick:            '#B22222',
	    floralwhite:          '#FFFAF0',
	    forestgreen:          '#228B22',
	    fuchsia:              '#FF00FF',
	    gainsboro:            '#DCDCDC',
	    ghostwhite:           '#F8F8FF',
	    gold:                 '#FFD700',
	    goldenrod:            '#DAA520',
	    gray:                 '#808080',
	    grey:                 '#808080',
	    green:                '#008000',
	    greenyellow:          '#ADFF2F',
	    honeydew:             '#F0FFF0',
	    hotpink:              '#FF69B4',
	    indianred:            '#CD5C5C',
	    indigo:               '#4B0082',
	    ivory:                '#FFFFF0',
	    khaki:                '#F0E68C',
	    lavender:             '#E6E6FA',
	    lavenderblush:        '#FFF0F5',
	    lawngreen:            '#7CFC00',
	    lemonchiffon:         '#FFFACD',
	    lightblue:            '#ADD8E6',
	    lightcoral:           '#F08080',
	    lightcyan:            '#E0FFFF',
	    lightgoldenrodyellow: '#FAFAD2',
	    lightgray:            '#D3D3D3',
	    lightgrey:            '#D3D3D3',
	    lightgreen:           '#90EE90',
	    lightpink:            '#FFB6C1',
	    lightsalmon:          '#FFA07A',
	    lightseagreen:        '#20B2AA',
	    lightskyblue:         '#87CEFA',
	    lightslategray:       '#778899',
	    lightslategrey:       '#778899',
	    lightsteelblue:       '#B0C4DE',
	    lightyellow:          '#FFFFE0',
	    lime:                 '#00FF00',
	    limegreen:            '#32CD32',
	    linen:                '#FAF0E6',
	    magenta:              '#FF00FF',
	    maroon:               '#800000',
	    mediumaquamarine:     '#66CDAA',
	    mediumblue:           '#0000CD',
	    mediumorchid:         '#BA55D3',
	    mediumpurple:         '#9370DB',
	    mediumseagreen:       '#3CB371',
	    mediumslateblue:      '#7B68EE',
	    mediumspringgreen:    '#00FA9A',
	    mediumturquoise:      '#48D1CC',
	    mediumvioletred:      '#C71585',
	    midnightblue:         '#191970',
	    mintcream:            '#F5FFFA',
	    mistyrose:            '#FFE4E1',
	    moccasin:             '#FFE4B5',
	    navajowhite:          '#FFDEAD',
	    navy:                 '#000080',
	    oldlace:              '#FDF5E6',
	    olive:                '#808000',
	    olivedrab:            '#6B8E23',
	    orange:               '#FFA500',
	    orangered:            '#FF4500',
	    orchid:               '#DA70D6',
	    palegoldenrod:        '#EEE8AA',
	    palegreen:            '#98FB98',
	    paleturquoise:        '#AFEEEE',
	    palevioletred:        '#DB7093',
	    papayawhip:           '#FFEFD5',
	    peachpuff:            '#FFDAB9',
	    peru:                 '#CD853F',
	    pink:                 '#FFC0CB',
	    plum:                 '#DDA0DD',
	    powderblue:           '#B0E0E6',
	    purple:               '#800080',
	    rebeccapurple:        '#663399',
	    red:                  '#FF0000',
	    rosybrown:            '#BC8F8F',
	    royalblue:            '#4169E1',
	    saddlebrown:          '#8B4513',
	    salmon:               '#FA8072',
	    sandybrown:           '#F4A460',
	    seagreen:             '#2E8B57',
	    seashell:             '#FFF5EE',
	    sienna:               '#A0522D',
	    silver:               '#C0C0C0',
	    skyblue:              '#87CEEB',
	    slateblue:            '#6A5ACD',
	    slategray:            '#708090',
	    slategrey:            '#708090',
	    snow:                 '#FFFAFA',
	    springgreen:          '#00FF7F',
	    steelblue:            '#4682B4',
	    tan:                  '#D2B48C',
	    teal:                 '#008080',
	    thistle:              '#D8BFD8',
	    tomato:               '#FF6347',
	    turquoise:            '#40E0D0',
	    violet:               '#EE82EE',
	    wheat:                '#F5DEB3',
	    white:                '#FFFFFF',
	    whitesmoke:           '#F5F5F5',
	    yellow:               '#FFFF00',
	    yellowgreen:          '#9ACD32'
	  };

	  /**
	   * @private
	   * @param {Number} p
	   * @param {Number} q
	   * @param {Number} t
	   * @return {Number}
	   */
	  function hue2rgb(p, q, t) {
	    if (t < 0) {
	      t += 1;
	    }
	    if (t > 1) {
	      t -= 1;
	    }
	    if (t < 1 / 6) {
	      return p + (q - p) * 6 * t;
	    }
	    if (t < 1 / 2) {
	      return q;
	    }
	    if (t < 2 / 3) {
	      return p + (q - p) * (2 / 3 - t) * 6;
	    }
	    return p;
	  }

	  /**
	   * Returns new color object, when given a color in RGB format
	   * @memberOf fabric.Color
	   * @param {String} color Color value ex: rgb(0-255,0-255,0-255)
	   * @return {fabric.Color}
	   */
	  fabric.Color.fromRgb = function(color) {
	    return Color.fromSource(Color.sourceFromRgb(color));
	  };

	  /**
	   * Returns array representation (ex: [100, 100, 200, 1]) of a color that's in RGB or RGBA format
	   * @memberOf fabric.Color
	   * @param {String} color Color value ex: rgb(0-255,0-255,0-255), rgb(0%-100%,0%-100%,0%-100%)
	   * @return {Array} source
	   */
	  fabric.Color.sourceFromRgb = function(color) {
	    var match = color.match(Color.reRGBa);
	    if (match) {
	      var r = parseInt(match[1], 10) / (/%$/.test(match[1]) ? 100 : 1) * (/%$/.test(match[1]) ? 255 : 1),
	          g = parseInt(match[2], 10) / (/%$/.test(match[2]) ? 100 : 1) * (/%$/.test(match[2]) ? 255 : 1),
	          b = parseInt(match[3], 10) / (/%$/.test(match[3]) ? 100 : 1) * (/%$/.test(match[3]) ? 255 : 1);

	      return [
	        parseInt(r, 10),
	        parseInt(g, 10),
	        parseInt(b, 10),
	        match[4] ? parseFloat(match[4]) : 1
	      ];
	    }
	  };

	  /**
	   * Returns new color object, when given a color in RGBA format
	   * @static
	   * @function
	   * @memberOf fabric.Color
	   * @param {String} color
	   * @return {fabric.Color}
	   */
	  fabric.Color.fromRgba = Color.fromRgb;

	  /**
	   * Returns new color object, when given a color in HSL format
	   * @param {String} color Color value ex: hsl(0-260,0%-100%,0%-100%)
	   * @memberOf fabric.Color
	   * @return {fabric.Color}
	   */
	  fabric.Color.fromHsl = function(color) {
	    return Color.fromSource(Color.sourceFromHsl(color));
	  };

	  /**
	   * Returns array representation (ex: [100, 100, 200, 1]) of a color that's in HSL or HSLA format.
	   * Adapted from <a href="https://rawgithub.com/mjijackson/mjijackson.github.com/master/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript.html">https://github.com/mjijackson</a>
	   * @memberOf fabric.Color
	   * @param {String} color Color value ex: hsl(0-360,0%-100%,0%-100%) or hsla(0-360,0%-100%,0%-100%, 0-1)
	   * @return {Array} source
	   * @see http://http://www.w3.org/TR/css3-color/#hsl-color
	   */
	  fabric.Color.sourceFromHsl = function(color) {
	    var match = color.match(Color.reHSLa);
	    if (!match) {
	      return;
	    }

	    var h = (((parseFloat(match[1]) % 360) + 360) % 360) / 360,
	        s = parseFloat(match[2]) / (/%$/.test(match[2]) ? 100 : 1),
	        l = parseFloat(match[3]) / (/%$/.test(match[3]) ? 100 : 1),
	        r, g, b;

	    if (s === 0) {
	      r = g = b = l;
	    }
	    else {
	      var q = l <= 0.5 ? l * (s + 1) : l + s - l * s,
	          p = l * 2 - q;

	      r = hue2rgb(p, q, h + 1 / 3);
	      g = hue2rgb(p, q, h);
	      b = hue2rgb(p, q, h - 1 / 3);
	    }

	    return [
	      Math.round(r * 255),
	      Math.round(g * 255),
	      Math.round(b * 255),
	      match[4] ? parseFloat(match[4]) : 1
	    ];
	  };

	  /**
	   * Returns new color object, when given a color in HSLA format
	   * @static
	   * @function
	   * @memberOf fabric.Color
	   * @param {String} color
	   * @return {fabric.Color}
	   */
	  fabric.Color.fromHsla = Color.fromHsl;

	  /**
	   * Returns new color object, when given a color in HEX format
	   * @static
	   * @memberOf fabric.Color
	   * @param {String} color Color value ex: FF5555
	   * @return {fabric.Color}
	   */
	  fabric.Color.fromHex = function(color) {
	    return Color.fromSource(Color.sourceFromHex(color));
	  };

	  /**
	   * Returns array representation (ex: [100, 100, 200, 1]) of a color that's in HEX format
	   * @static
	   * @memberOf fabric.Color
	   * @param {String} color ex: FF5555 or FF5544CC (RGBa)
	   * @return {Array} source
	   */
	  fabric.Color.sourceFromHex = function(color) {
	    if (color.match(Color.reHex)) {
	      var value = color.slice(color.indexOf('#') + 1),
	          isShortNotation = (value.length === 3 || value.length === 4),
	          isRGBa = (value.length === 8 || value.length === 4),
	          r = isShortNotation ? (value.charAt(0) + value.charAt(0)) : value.substring(0, 2),
	          g = isShortNotation ? (value.charAt(1) + value.charAt(1)) : value.substring(2, 4),
	          b = isShortNotation ? (value.charAt(2) + value.charAt(2)) : value.substring(4, 6),
	          a = isRGBa ? (isShortNotation ? (value.charAt(3) + value.charAt(3)) : value.substring(6, 8)) : 'FF';

	      return [
	        parseInt(r, 16),
	        parseInt(g, 16),
	        parseInt(b, 16),
	        parseFloat((parseInt(a, 16) / 255).toFixed(2))
	      ];
	    }
	  };

	  /**
	   * Returns new color object, when given color in array representation (ex: [200, 100, 100, 0.5])
	   * @static
	   * @memberOf fabric.Color
	   * @param {Array} source
	   * @return {fabric.Color}
	   */
	  fabric.Color.fromSource = function(source) {
	    var oColor = new Color();
	    oColor.setSource(source);
	    return oColor;
	  };

	})(exports );


	(function(global) {

	  var fabric = global.fabric || (global.fabric = { }),
	      scaleMap = ['e', 'se', 's', 'sw', 'w', 'nw', 'n', 'ne', 'e'],
	      skewMap = ['ns', 'nesw', 'ew', 'nwse'],
	      controls = {},
	      LEFT = 'left', TOP = 'top', RIGHT = 'right', BOTTOM = 'bottom', CENTER = 'center',
	      opposite = {
	        top: BOTTOM,
	        bottom: TOP,
	        left: RIGHT,
	        right: LEFT,
	        center: CENTER,
	      }, radiansToDegrees = fabric.util.radiansToDegrees,
	      sign = (Math.sign || function(x) { return ((x > 0) - (x < 0)) || +x; });

	  /**
	   * Combine control position and object angle to find the control direction compared
	   * to the object center.
	   * @param {fabric.Object} fabricObject the fabric object for which we are rendering controls
	   * @param {fabric.Control} control the control class
	   * @return {Number} 0 - 7 a quadrant number
	   */
	  function findCornerQuadrant(fabricObject, control) {
	    var cornerAngle = fabricObject.angle + radiansToDegrees(Math.atan2(control.y, control.x)) + 360;
	    return Math.round((cornerAngle % 360) / 45);
	  }

	  function fireEvent(eventName, options) {
	    var target = options.transform.target,
	        canvas = target.canvas,
	        canvasOptions = fabric.util.object.clone(options);
	    canvasOptions.target = target;
	    canvas && canvas.fire('object:' + eventName, canvasOptions);
	    target.fire(eventName, options);
	  }

	  /**
	   * Inspect event and fabricObject properties to understand if the scaling action
	   * @param {Event} eventData from the user action
	   * @param {fabric.Object} fabricObject the fabric object about to scale
	   * @return {Boolean} true if scale is proportional
	   */
	  function scaleIsProportional(eventData, fabricObject) {
	    var canvas = fabricObject.canvas, uniScaleKey = canvas.uniScaleKey,
	        uniformIsToggled = eventData[uniScaleKey];
	    return (canvas.uniformScaling && !uniformIsToggled) ||
	    (!canvas.uniformScaling && uniformIsToggled);
	  }

	  /**
	   * Checks if transform is centered
	   * @param {Object} transform transform data
	   * @return {Boolean} true if transform is centered
	   */
	  function isTransformCentered(transform) {
	    return transform.originX === CENTER && transform.originY === CENTER;
	  }

	  /**
	   * Inspect fabricObject to understand if the current scaling action is allowed
	   * @param {fabric.Object} fabricObject the fabric object about to scale
	   * @param {String} by 'x' or 'y' or ''
	   * @param {Boolean} scaleProportionally true if we are trying to scale proportionally
	   * @return {Boolean} true if scaling is not allowed at current conditions
	   */
	  function scalingIsForbidden(fabricObject, by, scaleProportionally) {
	    var lockX = fabricObject.lockScalingX, lockY = fabricObject.lockScalingY;
	    if (lockX && lockY) {
	      return true;
	    }
	    if (!by && (lockX || lockY) && scaleProportionally) {
	      return true;
	    }
	    if (lockX && by === 'x') {
	      return true;
	    }
	    if (lockY && by === 'y') {
	      return true;
	    }
	    return false;
	  }

	  /**
	   * return the correct cursor style for the scale action
	   * @param {Event} eventData the javascript event that is causing the scale
	   * @param {fabric.Control} control the control that is interested in the action
	   * @param {fabric.Object} fabricObject the fabric object that is interested in the action
	   * @return {String} a valid css string for the cursor
	   */
	  function scaleCursorStyleHandler(eventData, control, fabricObject) {
	    var notAllowed = 'not-allowed',
	        scaleProportionally = scaleIsProportional(eventData, fabricObject),
	        by = '';
	    if (control.x !== 0 && control.y === 0) {
	      by = 'x';
	    }
	    else if (control.x === 0 && control.y !== 0) {
	      by = 'y';
	    }
	    if (scalingIsForbidden(fabricObject, by, scaleProportionally)) {
	      return notAllowed;
	    }
	    var n = findCornerQuadrant(fabricObject, control);
	    return scaleMap[n] + '-resize';
	  }

	  /**
	   * return the correct cursor style for the skew action
	   * @param {Event} eventData the javascript event that is causing the scale
	   * @param {fabric.Control} control the control that is interested in the action
	   * @param {fabric.Object} fabricObject the fabric object that is interested in the action
	   * @return {String} a valid css string for the cursor
	   */
	  function skewCursorStyleHandler(eventData, control, fabricObject) {
	    var notAllowed = 'not-allowed';
	    if (control.x !== 0 && fabricObject.lockSkewingY) {
	      return notAllowed;
	    }
	    if (control.y !== 0 && fabricObject.lockSkewingX) {
	      return notAllowed;
	    }
	    var n = findCornerQuadrant(fabricObject, control) % 4;
	    return skewMap[n] + '-resize';
	  }

	  /**
	   * Combine skew and scale style handlers to cover fabric standard use case
	   * @param {Event} eventData the javascript event that is causing the scale
	   * @param {fabric.Control} control the control that is interested in the action
	   * @param {fabric.Object} fabricObject the fabric object that is interested in the action
	   * @return {String} a valid css string for the cursor
	   */
	  function scaleSkewCursorStyleHandler(eventData, control, fabricObject) {
	    if (eventData[fabricObject.canvas.altActionKey]) {
	      return controls.skewCursorStyleHandler(eventData, control, fabricObject);
	    }
	    return controls.scaleCursorStyleHandler(eventData, control, fabricObject);
	  }

	  /**
	   * Inspect event, control and fabricObject to return the correct action name
	   * @param {Event} eventData the javascript event that is causing the scale
	   * @param {fabric.Control} control the control that is interested in the action
	   * @param {fabric.Object} fabricObject the fabric object that is interested in the action
	   * @return {String} an action name
	   */
	  function scaleOrSkewActionName(eventData, control, fabricObject) {
	    var isAlternative = eventData[fabricObject.canvas.altActionKey];
	    if (control.x === 0) {
	      // then is scaleY or skewX
	      return isAlternative ? 'skewX' : 'scaleY';
	    }
	    if (control.y === 0) {
	      // then is scaleY or skewX
	      return isAlternative ? 'skewY' : 'scaleX';
	    }
	  }

	  /**
	   * Find the correct style for the control that is used for rotation.
	   * this function is very simple and it just take care of not-allowed or standard cursor
	   * @param {Event} eventData the javascript event that is causing the scale
	   * @param {fabric.Control} control the control that is interested in the action
	   * @param {fabric.Object} fabricObject the fabric object that is interested in the action
	   * @return {String} a valid css string for the cursor
	   */
	  function rotationStyleHandler(eventData, control, fabricObject) {
	    if (fabricObject.lockRotation) {
	      return 'not-allowed';
	    }
	    return control.cursorStyle;
	  }

	  function commonEventInfo(eventData, transform, x, y) {
	    return {
	      e: eventData,
	      transform: transform,
	      pointer: {
	        x: x,
	        y: y,
	      }
	    };
	  }

	  /**
	   * Wrap an action handler with saving/restoring object position on the transform.
	   * this is the code that permits to objects to keep their position while transforming.
	   * @param {Function} actionHandler the function to wrap
	   * @return {Function} a function with an action handler signature
	   */
	  function wrapWithFixedAnchor(actionHandler) {
	    return function(eventData, transform, x, y) {
	      var target = transform.target, centerPoint = target.getCenterPoint(),
	          constraint = target.translateToOriginPoint(centerPoint, transform.originX, transform.originY),
	          actionPerformed = actionHandler(eventData, transform, x, y);
	      target.setPositionByOrigin(constraint, transform.originX, transform.originY);
	      return actionPerformed;
	    };
	  }

	  /**
	   * Wrap an action handler with firing an event if the action is performed
	   * @param {Function} actionHandler the function to wrap
	   * @return {Function} a function with an action handler signature
	   */
	  function wrapWithFireEvent(eventName, actionHandler) {
	    return function(eventData, transform, x, y) {
	      var actionPerformed = actionHandler(eventData, transform, x, y);
	      if (actionPerformed) {
	        fireEvent(eventName, commonEventInfo(eventData, transform, x, y));
	      }
	      return actionPerformed;
	    };
	  }

	  /**
	   * Transforms a point described by x and y in a distance from the top left corner of the object
	   * bounding box.
	   * @param {Object} transform
	   * @param {String} originX
	   * @param {String} originY
	   * @param {number} x
	   * @param {number} y
	   * @return {Fabric.Point} the normalized point
	   */
	  function getLocalPoint(transform, originX, originY, x, y) {
	    var target = transform.target,
	        control = target.controls[transform.corner],
	        zoom = target.canvas.getZoom(),
	        padding = target.padding / zoom,
	        localPoint = target.toLocalPoint(new fabric.Point(x, y), originX, originY);
	    if (localPoint.x >= padding) {
	      localPoint.x -= padding;
	    }
	    if (localPoint.x <= -padding) {
	      localPoint.x += padding;
	    }
	    if (localPoint.y >= padding) {
	      localPoint.y -= padding;
	    }
	    if (localPoint.y <= padding) {
	      localPoint.y += padding;
	    }
	    localPoint.x -= control.offsetX;
	    localPoint.y -= control.offsetY;
	    return localPoint;
	  }

	  /**
	   * Detect if the fabric object is flipped on one side.
	   * @param {fabric.Object} target
	   * @return {Boolean} true if one flip, but not two.
	   */
	  function targetHasOneFlip(target) {
	    return target.flipX !== target.flipY;
	  }

	  /**
	   * Utility function to compensate the scale factor when skew is applied on both axes
	   * @private
	   */
	  function compensateScaleForSkew(target, oppositeSkew, scaleToCompensate, axis, reference) {
	    if (target[oppositeSkew] !== 0) {
	      var newDim = target._getTransformedDimensions()[axis];
	      var newValue = reference / newDim * target[scaleToCompensate];
	      target.set(scaleToCompensate, newValue);
	    }
	  }

	  /**
	   * Action handler for skewing on the X axis
	   * @private
	   */
	  function skewObjectX(eventData, transform, x, y) {
	    var target = transform.target,
	        // find how big the object would be, if there was no skewX. takes in account scaling
	        dimNoSkew = target._getTransformedDimensions(0, target.skewY),
	        localPoint = getLocalPoint(transform, transform.originX, transform.originY, x, y),
	        // the mouse is in the center of the object, and we want it to stay there.
	        // so the object will grow twice as much as the mouse.
	        // this makes the skew growth to localPoint * 2 - dimNoSkew.
	        totalSkewSize = Math.abs(localPoint.x * 2) - dimNoSkew.x,
	        currentSkew = target.skewX, newSkew;
	    if (totalSkewSize < 2) {
	      // let's make it easy to go back to position 0.
	      newSkew = 0;
	    }
	    else {
	      newSkew = radiansToDegrees(
	        Math.atan2((totalSkewSize / target.scaleX), (dimNoSkew.y / target.scaleY))
	      );
	      // now we have to find the sign of the skew.
	      // it mostly depend on the origin of transformation.
	      if (transform.originX === LEFT && transform.originY === BOTTOM) {
	        newSkew = -newSkew;
	      }
	      if (transform.originX === RIGHT && transform.originY === TOP) {
	        newSkew = -newSkew;
	      }
	      if (targetHasOneFlip(target)) {
	        newSkew = -newSkew;
	      }
	    }
	    var hasSkewed = currentSkew !== newSkew;
	    if (hasSkewed) {
	      var dimBeforeSkewing = target._getTransformedDimensions().y;
	      target.set('skewX', newSkew);
	      compensateScaleForSkew(target, 'skewY', 'scaleY', 'y', dimBeforeSkewing);
	    }
	    return hasSkewed;
	  }

	  /**
	   * Action handler for skewing on the Y axis
	   * @private
	   */
	  function skewObjectY(eventData, transform, x, y) {
	    var target = transform.target,
	        // find how big the object would be, if there was no skewX. takes in account scaling
	        dimNoSkew = target._getTransformedDimensions(target.skewX, 0),
	        localPoint = getLocalPoint(transform, transform.originX, transform.originY, x, y),
	        // the mouse is in the center of the object, and we want it to stay there.
	        // so the object will grow twice as much as the mouse.
	        // this makes the skew growth to localPoint * 2 - dimNoSkew.
	        totalSkewSize = Math.abs(localPoint.y * 2) - dimNoSkew.y,
	        currentSkew = target.skewY, newSkew;
	    if (totalSkewSize < 2) {
	      // let's make it easy to go back to position 0.
	      newSkew = 0;
	    }
	    else {
	      newSkew = radiansToDegrees(
	        Math.atan2((totalSkewSize / target.scaleY), (dimNoSkew.x / target.scaleX))
	      );
	      // now we have to find the sign of the skew.
	      // it mostly depend on the origin of transformation.
	      if (transform.originX === LEFT && transform.originY === BOTTOM) {
	        newSkew = -newSkew;
	      }
	      if (transform.originX === RIGHT && transform.originY === TOP) {
	        newSkew = -newSkew;
	      }
	      if (targetHasOneFlip(target)) {
	        newSkew = -newSkew;
	      }
	    }
	    var hasSkewed = currentSkew !== newSkew;
	    if (hasSkewed) {
	      var dimBeforeSkewing = target._getTransformedDimensions().x;
	      target.set('skewY', newSkew);
	      compensateScaleForSkew(target, 'skewX', 'scaleX', 'x', dimBeforeSkewing);
	    }
	    return hasSkewed;
	  }

	  /**
	   * Wrapped Action handler for skewing on the Y axis, takes care of the
	   * skew direction and determine the correct transform origin for the anchor point
	   * @param {Event} eventData javascript event that is doing the transform
	   * @param {Object} transform javascript object containing a series of information around the current transform
	   * @param {number} x current mouse x position, canvas normalized
	   * @param {number} y current mouse y position, canvas normalized
	   * @return {Boolean} true if some change happened
	   */
	  function skewHandlerX(eventData, transform, x, y) {
	    // step1 figure out and change transform origin.
	    // if skewX > 0 and originY bottom we anchor on right
	    // if skewX > 0 and originY top we anchor on left
	    // if skewX < 0 and originY bottom we anchor on left
	    // if skewX < 0 and originY top we anchor on right
	    // if skewX is 0, we look for mouse position to understand where are we going.
	    var target = transform.target, currentSkew = target.skewX, originX, originY = transform.originY;
	    if (target.lockSkewingX) {
	      return false;
	    }
	    if (currentSkew === 0) {
	      var localPointFromCenter = getLocalPoint(transform, CENTER, CENTER, x, y);
	      if (localPointFromCenter.x > 0) {
	        // we are pulling right, anchor left;
	        originX = LEFT;
	      }
	      else {
	        // we are pulling right, anchor right
	        originX = RIGHT;
	      }
	    }
	    else {
	      if (currentSkew > 0) {
	        originX = originY === TOP ? LEFT : RIGHT;
	      }
	      if (currentSkew < 0) {
	        originX = originY === TOP ? RIGHT : LEFT;
	      }
	      // is the object flipped on one side only? swap the origin.
	      if (targetHasOneFlip(target)) {
	        originX = originX === LEFT ? RIGHT : LEFT;
	      }
	    }

	    // once we have the origin, we find the anchor point
	    transform.originX = originX;
	    var finalHandler = wrapWithFireEvent('skewing', wrapWithFixedAnchor(skewObjectX));
	    return finalHandler(eventData, transform, x, y);
	  }

	  /**
	   * Wrapped Action handler for skewing on the Y axis, takes care of the
	   * skew direction and determine the correct transform origin for the anchor point
	   * @param {Event} eventData javascript event that is doing the transform
	   * @param {Object} transform javascript object containing a series of information around the current transform
	   * @param {number} x current mouse x position, canvas normalized
	   * @param {number} y current mouse y position, canvas normalized
	   * @return {Boolean} true if some change happened
	   */
	  function skewHandlerY(eventData, transform, x, y) {
	    // step1 figure out and change transform origin.
	    // if skewY > 0 and originX left we anchor on top
	    // if skewY > 0 and originX right we anchor on bottom
	    // if skewY < 0 and originX left we anchor on bottom
	    // if skewY < 0 and originX right we anchor on top
	    // if skewY is 0, we look for mouse position to understand where are we going.
	    var target = transform.target, currentSkew = target.skewY, originY, originX = transform.originX;
	    if (target.lockSkewingY) {
	      return false;
	    }
	    if (currentSkew === 0) {
	      var localPointFromCenter = getLocalPoint(transform, CENTER, CENTER, x, y);
	      if (localPointFromCenter.y > 0) {
	        // we are pulling down, anchor up;
	        originY = TOP;
	      }
	      else {
	        // we are pulling up, anchor down
	        originY = BOTTOM;
	      }
	    }
	    else {
	      if (currentSkew > 0) {
	        originY = originX === LEFT ? TOP : BOTTOM;
	      }
	      if (currentSkew < 0) {
	        originY = originX === LEFT ? BOTTOM : TOP;
	      }
	      // is the object flipped on one side only? swap the origin.
	      if (targetHasOneFlip(target)) {
	        originY = originY === TOP ? BOTTOM : TOP;
	      }
	    }

	    // once we have the origin, we find the anchor point
	    transform.originY = originY;
	    var finalHandler = wrapWithFireEvent('skewing', wrapWithFixedAnchor(skewObjectY));
	    return finalHandler(eventData, transform, x, y);
	  }

	  /**
	   * Action handler for rotation and snapping, without anchor point.
	   * Needs to be wrapped with `wrapWithFixedAnchor` to be effective
	   * @param {Event} eventData javascript event that is doing the transform
	   * @param {Object} transform javascript object containing a series of information around the current transform
	   * @param {number} x current mouse x position, canvas normalized
	   * @param {number} y current mouse y position, canvas normalized
	   * @return {Boolean} true if some change happened
	   * @private
	   */
	  function rotationWithSnapping(eventData, transform, x, y) {
	    var t = transform,
	        target = t.target,
	        pivotPoint = target.translateToOriginPoint(target.getCenterPoint(), t.originX, t.originY);

	    if (target.lockRotation) {
	      return false;
	    }

	    var lastAngle = Math.atan2(t.ey - pivotPoint.y, t.ex - pivotPoint.x),
	        curAngle = Math.atan2(y - pivotPoint.y, x - pivotPoint.x),
	        angle = radiansToDegrees(curAngle - lastAngle + t.theta),
	        hasRotated = true;

	    if (target.snapAngle > 0) {
	      var snapAngle  = target.snapAngle,
	          snapThreshold  = target.snapThreshold || snapAngle,
	          rightAngleLocked = Math.ceil(angle / snapAngle) * snapAngle,
	          leftAngleLocked = Math.floor(angle / snapAngle) * snapAngle;

	      if (Math.abs(angle - leftAngleLocked) < snapThreshold) {
	        angle = leftAngleLocked;
	      }
	      else if (Math.abs(angle - rightAngleLocked) < snapThreshold) {
	        angle = rightAngleLocked;
	      }
	    }

	    // normalize angle to positive value
	    if (angle < 0) {
	      angle = 360 + angle;
	    }
	    angle %= 360;

	    hasRotated = target.angle !== angle;
	    target.angle = angle;
	    return hasRotated;
	  }

	  /**
	   * Basic scaling logic, reused with different constrain for scaling X,Y, freely or equally.
	   * Needs to be wrapped with `wrapWithFixedAnchor` to be effective
	   * @param {Event} eventData javascript event that is doing the transform
	   * @param {Object} transform javascript object containing a series of information around the current transform
	   * @param {number} x current mouse x position, canvas normalized
	   * @param {number} y current mouse y position, canvas normalized
	   * @param {Object} options additional information for scaling
	   * @param {String} options.by 'x', 'y', 'equally' or '' to indicate type of scaling
	   * @return {Boolean} true if some change happened
	   * @private
	   */
	  function scaleObject(eventData, transform, x, y, options) {
	    options = options || {};
	    var target = transform.target,
	        lockScalingX = target.lockScalingX, lockScalingY = target.lockScalingY,
	        by = options.by, newPoint, scaleX, scaleY, dim,
	        scaleProportionally = scaleIsProportional(eventData, target),
	        forbidScaling = scalingIsForbidden(target, by, scaleProportionally),
	        signX, signY, gestureScale = transform.gestureScale;

	    if (forbidScaling) {
	      return false;
	    }
	    if (gestureScale) {
	      scaleX = transform.scaleX * gestureScale;
	      scaleY = transform.scaleY * gestureScale;
	    }
	    else {
	      newPoint = getLocalPoint(transform, transform.originX, transform.originY, x, y);
	      // use of sign: We use sign to detect change of direction of an action. sign usually change when
	      // we cross the origin point with the mouse. So a scale flip for example. There is an issue when scaling
	      // by center and scaling using one middle control ( default: mr, mt, ml, mb), the mouse movement can easily
	      // cross many time the origin point and flip the object. so we need a way to filter out the noise.
	      // This ternary here should be ok to filter out X scaling when we want Y only and vice versa.
	      signX = by !== 'y' ? sign(newPoint.x) : 1;
	      signY = by !== 'x' ? sign(newPoint.y) : 1;
	      if (!transform.signX) {
	        transform.signX = signX;
	      }
	      if (!transform.signY) {
	        transform.signY = signY;
	      }

	      if (target.lockScalingFlip &&
	        (transform.signX !== signX || transform.signY !== signY)
	      ) {
	        return false;
	      }

	      dim = target._getTransformedDimensions();
	      // missing detection of flip and logic to switch the origin
	      if (scaleProportionally && !by) {
	        // uniform scaling
	        var distance = Math.abs(newPoint.x) + Math.abs(newPoint.y),
	            original = transform.original,
	            originalDistance = Math.abs(dim.x * original.scaleX / target.scaleX) +
	              Math.abs(dim.y * original.scaleY / target.scaleY),
	            scale = distance / originalDistance;
	        scaleX = original.scaleX * scale;
	        scaleY = original.scaleY * scale;
	      }
	      else {
	        scaleX = Math.abs(newPoint.x * target.scaleX / dim.x);
	        scaleY = Math.abs(newPoint.y * target.scaleY / dim.y);
	      }
	      // if we are scaling by center, we need to double the scale
	      if (isTransformCentered(transform)) {
	        scaleX *= 2;
	        scaleY *= 2;
	      }
	      if (transform.signX !== signX && by !== 'y') {
	        transform.originX = opposite[transform.originX];
	        scaleX *= -1;
	        transform.signX = signX;
	      }
	      if (transform.signY !== signY && by !== 'x') {
	        transform.originY = opposite[transform.originY];
	        scaleY *= -1;
	        transform.signY = signY;
	      }
	    }
	    // minScale is taken are in the setter.
	    var oldScaleX = target.scaleX, oldScaleY = target.scaleY;
	    if (!by) {
	      !lockScalingX && target.set('scaleX', scaleX);
	      !lockScalingY && target.set('scaleY', scaleY);
	    }
	    else {
	      // forbidden cases already handled on top here.
	      by === 'x' && target.set('scaleX', scaleX);
	      by === 'y' && target.set('scaleY', scaleY);
	    }
	    return oldScaleX !== target.scaleX || oldScaleY !== target.scaleY;
	  }

	  /**
	   * Generic scaling logic, to scale from corners either equally or freely.
	   * Needs to be wrapped with `wrapWithFixedAnchor` to be effective
	   * @param {Event} eventData javascript event that is doing the transform
	   * @param {Object} transform javascript object containing a series of information around the current transform
	   * @param {number} x current mouse x position, canvas normalized
	   * @param {number} y current mouse y position, canvas normalized
	   * @return {Boolean} true if some change happened
	   */
	  function scaleObjectFromCorner(eventData, transform, x, y) {
	    return scaleObject(eventData, transform, x, y);
	  }

	  /**
	   * Scaling logic for the X axis.
	   * Needs to be wrapped with `wrapWithFixedAnchor` to be effective
	   * @param {Event} eventData javascript event that is doing the transform
	   * @param {Object} transform javascript object containing a series of information around the current transform
	   * @param {number} x current mouse x position, canvas normalized
	   * @param {number} y current mouse y position, canvas normalized
	   * @return {Boolean} true if some change happened
	   */
	  function scaleObjectX(eventData, transform, x, y) {
	    return scaleObject(eventData, transform, x, y , { by: 'x' });
	  }

	  /**
	   * Scaling logic for the Y axis.
	   * Needs to be wrapped with `wrapWithFixedAnchor` to be effective
	   * @param {Event} eventData javascript event that is doing the transform
	   * @param {Object} transform javascript object containing a series of information around the current transform
	   * @param {number} x current mouse x position, canvas normalized
	   * @param {number} y current mouse y position, canvas normalized
	   * @return {Boolean} true if some change happened
	   */
	  function scaleObjectY(eventData, transform, x, y) {
	    return scaleObject(eventData, transform, x, y , { by: 'y' });
	  }

	  /**
	   * Composed action handler to either scale Y or skew X
	   * Needs to be wrapped with `wrapWithFixedAnchor` to be effective
	   * @param {Event} eventData javascript event that is doing the transform
	   * @param {Object} transform javascript object containing a series of information around the current transform
	   * @param {number} x current mouse x position, canvas normalized
	   * @param {number} y current mouse y position, canvas normalized
	   * @return {Boolean} true if some change happened
	   */
	  function scalingYOrSkewingX(eventData, transform, x, y) {
	    // ok some safety needed here.
	    if (eventData[transform.target.canvas.altActionKey]) {
	      return controls.skewHandlerX(eventData, transform, x, y);
	    }
	    return controls.scalingY(eventData, transform, x, y);
	  }

	  /**
	   * Composed action handler to either scale X or skew Y
	   * Needs to be wrapped with `wrapWithFixedAnchor` to be effective
	   * @param {Event} eventData javascript event that is doing the transform
	   * @param {Object} transform javascript object containing a series of information around the current transform
	   * @param {number} x current mouse x position, canvas normalized
	   * @param {number} y current mouse y position, canvas normalized
	   * @return {Boolean} true if some change happened
	   */
	  function scalingXOrSkewingY(eventData, transform, x, y) {
	    // ok some safety needed here.
	    if (eventData[transform.target.canvas.altActionKey]) {
	      return controls.skewHandlerY(eventData, transform, x, y);
	    }
	    return controls.scalingX(eventData, transform, x, y);
	  }

	  /**
	   * Action handler to change textbox width
	   * Needs to be wrapped with `wrapWithFixedAnchor` to be effective
	   * @param {Event} eventData javascript event that is doing the transform
	   * @param {Object} transform javascript object containing a series of information around the current transform
	   * @param {number} x current mouse x position, canvas normalized
	   * @param {number} y current mouse y position, canvas normalized
	   * @return {Boolean} true if some change happened
	   */
	  function changeWidth(eventData, transform, x, y) {
	    var target = transform.target, localPoint = getLocalPoint(transform, transform.originX, transform.originY, x, y),
	        strokePadding = target.strokeWidth / (target.strokeUniform ? target.scaleX : 1),
	        multiplier = isTransformCentered(transform) ? 2 : 1,
	        oldWidth = target.width,
	        newWidth = Math.abs(localPoint.x * multiplier / target.scaleX) - strokePadding;
	    target.set('width', Math.max(newWidth, 0));
	    return oldWidth !== newWidth;
	  }

	  /**
	   * Action handler
	   * @private
	   * @param {Event} eventData javascript event that is doing the transform
	   * @param {Object} transform javascript object containing a series of information around the current transform
	   * @param {number} x current mouse x position, canvas normalized
	   * @param {number} y current mouse y position, canvas normalized
	   * @return {Boolean} true if the translation occurred
	   */
	  function dragHandler(eventData, transform, x, y) {
	    var target = transform.target,
	        newLeft = x - transform.offsetX,
	        newTop = y - transform.offsetY,
	        moveX = !target.get('lockMovementX') && target.left !== newLeft,
	        moveY = !target.get('lockMovementY') && target.top !== newTop;
	    moveX && target.set('left', newLeft);
	    moveY && target.set('top', newTop);
	    if (moveX || moveY) {
	      fireEvent('moving', commonEventInfo(eventData, transform, x, y));
	    }
	    return moveX || moveY;
	  }

	  controls.scaleCursorStyleHandler = scaleCursorStyleHandler;
	  controls.skewCursorStyleHandler = skewCursorStyleHandler;
	  controls.scaleSkewCursorStyleHandler = scaleSkewCursorStyleHandler;
	  controls.rotationWithSnapping = wrapWithFireEvent('rotating', wrapWithFixedAnchor(rotationWithSnapping));
	  controls.scalingEqually = wrapWithFireEvent('scaling', wrapWithFixedAnchor( scaleObjectFromCorner));
	  controls.scalingX = wrapWithFireEvent('scaling', wrapWithFixedAnchor(scaleObjectX));
	  controls.scalingY = wrapWithFireEvent('scaling', wrapWithFixedAnchor(scaleObjectY));
	  controls.scalingYOrSkewingX = scalingYOrSkewingX;
	  controls.scalingXOrSkewingY = scalingXOrSkewingY;
	  controls.changeWidth = wrapWithFireEvent('resizing', wrapWithFixedAnchor(changeWidth));
	  controls.skewHandlerX = skewHandlerX;
	  controls.skewHandlerY = skewHandlerY;
	  controls.dragHandler = dragHandler;
	  controls.scaleOrSkewActionName = scaleOrSkewActionName;
	  controls.rotationStyleHandler = rotationStyleHandler;
	  controls.fireEvent = fireEvent;
	  controls.wrapWithFixedAnchor = wrapWithFixedAnchor;
	  controls.wrapWithFireEvent = wrapWithFireEvent;
	  controls.getLocalPoint = getLocalPoint;
	  fabric.controlsUtils = controls;

	})(exports );


	(function(global) {

	  var fabric = global.fabric || (global.fabric = { }),
	      degreesToRadians = fabric.util.degreesToRadians,
	      controls = fabric.controlsUtils;

	  /**
	   * Render a round control, as per fabric features.
	   * This function is written to respect object properties like transparentCorners, cornerSize
	   * cornerColor, cornerStrokeColor
	   * plus the addition of offsetY and offsetX.
	   * @param {CanvasRenderingContext2D} ctx context to render on
	   * @param {Number} left x coordinate where the control center should be
	   * @param {Number} top y coordinate where the control center should be
	   * @param {Object} styleOverride override for fabric.Object controls style
	   * @param {fabric.Object} fabricObject the fabric object for which we are rendering controls
	   */
	  function renderCircleControl (ctx, left, top, styleOverride, fabricObject) {
	    styleOverride = styleOverride || {};
	    var xSize = this.sizeX || styleOverride.cornerSize || fabricObject.cornerSize,
	        ySize = this.sizeY || styleOverride.cornerSize || fabricObject.cornerSize,
	        transparentCorners = typeof styleOverride.transparentCorners !== 'undefined' ?
	          styleOverride.transparentCorners : fabricObject.transparentCorners,
	        methodName = transparentCorners ? 'stroke' : 'fill',
	        stroke = !transparentCorners && (styleOverride.cornerStrokeColor || fabricObject.cornerStrokeColor),
	        myLeft = left,
	        myTop = top, size;
	    ctx.save();
	    ctx.fillStyle = styleOverride.cornerColor || fabricObject.cornerColor;
	    ctx.strokeStyle = styleOverride.cornerStrokeColor || fabricObject.cornerStrokeColor;
	    // as soon as fabric react v5, remove ie11, use proper ellipse code.
	    if (xSize > ySize) {
	      size = xSize;
	      ctx.scale(1.0, ySize / xSize);
	      myTop = top * xSize / ySize;
	    }
	    else if (ySize > xSize) {
	      size = ySize;
	      ctx.scale(xSize / ySize, 1.0);
	      myLeft = left * ySize / xSize;
	    }
	    else {
	      size = xSize;
	    }
	    // this is still wrong
	    ctx.lineWidth = 1;
	    ctx.beginPath();
	    ctx.arc(myLeft, myTop, size / 2, 0, 2 * Math.PI, false);
	    ctx[methodName]();
	    if (stroke) {
	      ctx.stroke();
	    }
	    ctx.restore();
	  }

	  /**
	   * Render a square control, as per fabric features.
	   * This function is written to respect object properties like transparentCorners, cornerSize
	   * cornerColor, cornerStrokeColor
	   * plus the addition of offsetY and offsetX.
	   * @param {CanvasRenderingContext2D} ctx context to render on
	   * @param {Number} left x coordinate where the control center should be
	   * @param {Number} top y coordinate where the control center should be
	   * @param {Object} styleOverride override for fabric.Object controls style
	   * @param {fabric.Object} fabricObject the fabric object for which we are rendering controls
	   */
	  function renderSquareControl(ctx, left, top, styleOverride, fabricObject) {
	    styleOverride = styleOverride || {};
	    var xSize = this.sizeX || styleOverride.cornerSize || fabricObject.cornerSize,
	        ySize = this.sizeY || styleOverride.cornerSize || fabricObject.cornerSize,
	        transparentCorners = typeof styleOverride.transparentCorners !== 'undefined' ?
	          styleOverride.transparentCorners : fabricObject.transparentCorners,
	        methodName = transparentCorners ? 'stroke' : 'fill',
	        stroke = !transparentCorners && (
	          styleOverride.cornerStrokeColor || fabricObject.cornerStrokeColor
	        ), xSizeBy2 = xSize / 2, ySizeBy2 = ySize / 2;
	    ctx.save();
	    ctx.fillStyle = styleOverride.cornerColor || fabricObject.cornerColor;
	    ctx.strokeStyle = styleOverride.cornerStrokeColor || fabricObject.cornerStrokeColor;
	    // this is still wrong
	    ctx.lineWidth = 1;
	    ctx.translate(left, top);
	    ctx.rotate(degreesToRadians(fabricObject.angle));
	    // this does not work, and fixed with ( && ) does not make sense.
	    // to have real transparent corners we need the controls on upperCanvas
	    // transparentCorners || ctx.clearRect(-xSizeBy2, -ySizeBy2, xSize, ySize);
	    ctx[methodName + 'Rect'](-xSizeBy2, -ySizeBy2, xSize, ySize);
	    if (stroke) {
	      ctx.strokeRect(-xSizeBy2, -ySizeBy2, xSize, ySize);
	    }
	    ctx.restore();
	  }

	  controls.renderCircleControl = renderCircleControl;
	  controls.renderSquareControl = renderSquareControl;

	})(exports );


	(function(global) {

	  var fabric = global.fabric || (global.fabric = { });

	  function Control(options) {
	    for (var i in options) {
	      this[i] = options[i];
	    }
	  }

	  fabric.Control = Control;

	  fabric.Control.prototype = /** @lends fabric.Control.prototype */ {

	    /**
	     * keep track of control visibility.
	     * mainly for backward compatibility.
	     * if you do not want to see a control, you can remove it
	     * from the controlset.
	     * @type {Boolean}
	     * @default true
	     */
	    visible: true,

	    /**
	     * Name of the action that the control will likely execute.
	     * This is optional. FabricJS uses to identify what the user is doing for some
	     * extra optimizations. If you are writing a custom control and you want to know
	     * somewhere else in the code what is going on, you can use this string here.
	     * you can also provide a custom getActionName if your control run multiple actions
	     * depending on some external state.
	     * default to scale since is the most common, used on 4 corners by default
	     * @type {String}
	     * @default 'scale'
	     */
	    actionName: 'scale',

	    /**
	     * Drawing angle of the control.
	     * NOT used for now, but name marked as needed for internal logic
	     * example: to reuse the same drawing function for different rotated controls
	     * @type {Number}
	     * @default 0
	     */
	    angle: 0,

	    /**
	     * Relative position of the control. X
	     * 0,0 is the center of the Object, while -0.5 (left) or 0.5 (right) are the extremities
	     * of the bounding box.
	     * @type {Number}
	     * @default 0
	     */
	    x: 0,

	    /**
	     * Relative position of the control. Y
	     * 0,0 is the center of the Object, while -0.5 (top) or 0.5 (bottom) are the extremities
	     * of the bounding box.
	     * @type {Number}
	     * @default 0
	     */
	    y: 0,

	    /**
	     * Horizontal offset of the control from the defined position. In pixels
	     * Positive offset moves the control to the right, negative to the left.
	     * It used when you want to have position of control that does not scale with
	     * the bounding box. Example: rotation control is placed at x:0, y: 0.5 on
	     * the boundindbox, with an offset of 30 pixels vertically. Those 30 pixels will
	     * stay 30 pixels no matter how the object is big. Another example is having 2
	     * controls in the corner, that stay in the same position when the object scale.
	     * of the bounding box.
	     * @type {Number}
	     * @default 0
	     */
	    offsetX: 0,

	    /**
	     * Vertical offset of the control from the defined position. In pixels
	     * Positive offset moves the control to the bottom, negative to the top.
	     * @type {Number}
	     * @default 0
	     */
	    offsetY: 0,

	    /**
	     * Sets the length of the control. If null, defaults to object's cornerSize.
	     * Expects both sizeX and sizeY to be set when set.
	     * @type {?Number}
	     * @default null
	     */
	    sizeX: null,

	    /**
	     * Sets the height of the control. If null, defaults to object's cornerSize.
	     * Expects both sizeX and sizeY to be set when set.
	     * @type {?Number}
	     * @default null
	     */
	    sizeY: null,

	    /**
	     * Sets the length of the touch area of the control. If null, defaults to object's touchCornerSize.
	     * Expects both touchSizeX and touchSizeY to be set when set.
	     * @type {?Number}
	     * @default null
	     */
	    touchSizeX: null,

	    /**
	     * Sets the height of the touch area of the control. If null, defaults to object's touchCornerSize.
	     * Expects both touchSizeX and touchSizeY to be set when set.
	     * @type {?Number}
	     * @default null
	     */
	    touchSizeY: null,

	    /**
	     * Css cursor style to display when the control is hovered.
	     * if the method `cursorStyleHandler` is provided, this property is ignored.
	     * @type {String}
	     * @default 'crosshair'
	     */
	    cursorStyle: 'crosshair',

	    /**
	     * If controls has an offsetY or offsetX, draw a line that connects
	     * the control to the bounding box
	     * @type {Boolean}
	     * @default false
	     */
	    withConnection: false,

	    /**
	     * The control actionHandler, provide one to handle action ( control being moved )
	     * @param {Event} eventData the native mouse event
	     * @param {Object} transformData properties of the current transform
	     * @param {Number} x x position of the cursor
	     * @param {Number} y y position of the cursor
	     * @return {Boolean} true if the action/event modified the object
	     */
	    actionHandler: function(/* eventData, transformData, x, y */) { },

	    /**
	     * The control handler for mouse down, provide one to handle mouse down on control
	     * @param {Event} eventData the native mouse event
	     * @param {Object} transformData properties of the current transform
	     * @param {Number} x x position of the cursor
	     * @param {Number} y y position of the cursor
	     * @return {Boolean} true if the action/event modified the object
	     */
	    mouseDownHandler: function(/* eventData, transformData, x, y */) { },

	    /**
	     * The control mouseUpHandler, provide one to handle an effect on mouse up.
	     * @param {Event} eventData the native mouse event
	     * @param {Object} transformData properties of the current transform
	     * @param {Number} x x position of the cursor
	     * @param {Number} y y position of the cursor
	     * @return {Boolean} true if the action/event modified the object
	     */
	    mouseUpHandler: function(/* eventData, transformData, x, y */) { },

	    /**
	     * Returns control actionHandler
	     * @param {Event} eventData the native mouse event
	     * @param {fabric.Object} fabricObject on which the control is displayed
	     * @param {fabric.Control} control control for which the action handler is being asked
	     * @return {Function} the action handler
	     */
	    getActionHandler: function(/* eventData, fabricObject, control */) {
	      return this.actionHandler;
	    },

	    /**
	     * Returns control mouseDown handler
	     * @param {Event} eventData the native mouse event
	     * @param {fabric.Object} fabricObject on which the control is displayed
	     * @param {fabric.Control} control control for which the action handler is being asked
	     * @return {Function} the action handler
	     */
	    getMouseDownHandler: function(/* eventData, fabricObject, control */) {
	      return this.mouseDownHandler;
	    },

	    /**
	     * Returns control mouseUp handler
	     * @param {Event} eventData the native mouse event
	     * @param {fabric.Object} fabricObject on which the control is displayed
	     * @param {fabric.Control} control control for which the action handler is being asked
	     * @return {Function} the action handler
	     */
	    getMouseUpHandler: function(/* eventData, fabricObject, control */) {
	      return this.mouseUpHandler;
	    },

	    /**
	     * Returns control cursorStyle for css using cursorStyle. If you need a more elaborate
	     * function you can pass one in the constructor
	     * the cursorStyle property
	     * @param {Event} eventData the native mouse event
	     * @param {fabric.Control} control the current control ( likely this)
	     * @param {fabric.Object} object on which the control is displayed
	     * @return {String}
	     */
	    cursorStyleHandler: function(eventData, control /* fabricObject */) {
	      return control.cursorStyle;
	    },

	    /**
	     * Returns the action name. The basic implementation just return the actionName property.
	     * @param {Event} eventData the native mouse event
	     * @param {fabric.Control} control the current control ( likely this)
	     * @param {fabric.Object} object on which the control is displayed
	     * @return {String}
	     */
	    getActionName: function(eventData, control /* fabricObject */) {
	      return control.actionName;
	    },

	    /**
	     * Returns controls visibility
	     * @param {fabric.Object} object on which the control is displayed
	     * @param {String} controlKey key where the control is memorized on the
	     * @return {Boolean}
	     */
	    getVisibility: function(fabricObject, controlKey) {
	      var objectVisibility = fabricObject._controlsVisibility;
	      if (objectVisibility && typeof objectVisibility[controlKey] !== 'undefined') {
	        return objectVisibility[controlKey];
	      }
	      return this.visible;
	    },

	    /**
	     * Sets controls visibility
	     * @param {Boolean} visibility for the object
	     * @return {Void}
	     */
	    setVisibility: function(visibility /* name, fabricObject */) {
	      this.visible = visibility;
	    },


	    positionHandler: function(dim, finalMatrix /*, fabricObject, currentControl */) {
	      var point = fabric.util.transformPoint({
	        x: this.x * dim.x + this.offsetX,
	        y: this.y * dim.y + this.offsetY }, finalMatrix);
	      return point;
	    },

	    /**
	     * Returns the coords for this control based on object values.
	     * @param {Number} objectAngle angle from the fabric object holding the control
	     * @param {Number} objectCornerSize cornerSize from the fabric object holding the control (or touchCornerSize if
	     *   isTouch is true)
	     * @param {Number} centerX x coordinate where the control center should be
	     * @param {Number} centerY y coordinate where the control center should be
	     * @param {boolean} isTouch true if touch corner, false if normal corner
	     */
	    calcCornerCoords: function(objectAngle, objectCornerSize, centerX, centerY, isTouch) {
	      var cosHalfOffset,
	          sinHalfOffset,
	          cosHalfOffsetComp,
	          sinHalfOffsetComp,
	          xSize = (isTouch) ? this.touchSizeX : this.sizeX,
	          ySize = (isTouch) ? this.touchSizeY : this.sizeY;
	      if (xSize && ySize && xSize !== ySize) {
	        // handle rectangular corners
	        var controlTriangleAngle = Math.atan2(ySize, xSize);
	        var cornerHypotenuse = Math.sqrt(xSize * xSize + ySize * ySize) / 2;
	        var newTheta = controlTriangleAngle - fabric.util.degreesToRadians(objectAngle);
	        var newThetaComp = Math.PI / 2 - controlTriangleAngle - fabric.util.degreesToRadians(objectAngle);
	        cosHalfOffset = cornerHypotenuse * fabric.util.cos(newTheta);
	        sinHalfOffset = cornerHypotenuse * fabric.util.sin(newTheta);
	        // use complementary angle for two corners
	        cosHalfOffsetComp = cornerHypotenuse * fabric.util.cos(newThetaComp);
	        sinHalfOffsetComp = cornerHypotenuse * fabric.util.sin(newThetaComp);
	      }
	      else {
	        // handle square corners
	        // use default object corner size unless size is defined
	        var cornerSize = (xSize && ySize) ? xSize : objectCornerSize;
	        /* 0.7071067812 stands for sqrt(2)/2 */
	        cornerHypotenuse = cornerSize * 0.7071067812;
	        // complementary angles are equal since they're both 45 degrees
	        var newTheta = fabric.util.degreesToRadians(45 - objectAngle);
	        cosHalfOffset = cosHalfOffsetComp = cornerHypotenuse * fabric.util.cos(newTheta);
	        sinHalfOffset = sinHalfOffsetComp = cornerHypotenuse * fabric.util.sin(newTheta);
	      }

	      return {
	        tl: {
	          x: centerX - sinHalfOffsetComp,
	          y: centerY - cosHalfOffsetComp,
	        },
	        tr: {
	          x: centerX + cosHalfOffset,
	          y: centerY - sinHalfOffset,
	        },
	        bl: {
	          x: centerX - cosHalfOffset,
	          y: centerY + sinHalfOffset,
	        },
	        br: {
	          x: centerX + sinHalfOffsetComp,
	          y: centerY + cosHalfOffsetComp,
	        },
	      };
	    },

	    /**
	    * Render function for the control.
	    * When this function runs the context is unscaled. unrotate. Just retina scaled.
	    * all the functions will have to translate to the point left,top before starting Drawing
	    * if they want to draw a control where the position is detected.
	    * left and top are the result of the positionHandler function
	    * @param {RenderingContext2D} ctx the context where the control will be drawn
	    * @param {Number} left position of the canvas where we are about to render the control.
	    * @param {Number} top position of the canvas where we are about to render the control.
	    * @param {Object} styleOverride
	    * @param {fabric.Object} fabricObject the object where the control is about to be rendered
	    */
	    render: function(ctx, left, top, styleOverride, fabricObject) {
	      styleOverride = styleOverride || {};
	      switch (styleOverride.cornerStyle || fabricObject.cornerStyle) {
	        case 'circle':
	          fabric.controlsUtils.renderCircleControl.call(this, ctx, left, top, styleOverride, fabricObject);
	          break;
	        default:
	          fabric.controlsUtils.renderSquareControl.call(this, ctx, left, top, styleOverride, fabricObject);
	      }
	    },
	  };

	})(exports );


	(function() {

	  /* _FROM_SVG_START_ */
	  function getColorStop(el, multiplier) {
	    var style = el.getAttribute('style'),
	        offset = el.getAttribute('offset') || 0,
	        color, colorAlpha, opacity, i;

	    // convert percents to absolute values
	    offset = parseFloat(offset) / (/%$/.test(offset) ? 100 : 1);
	    offset = offset < 0 ? 0 : offset > 1 ? 1 : offset;
	    if (style) {
	      var keyValuePairs = style.split(/\s*;\s*/);

	      if (keyValuePairs[keyValuePairs.length - 1] === '') {
	        keyValuePairs.pop();
	      }

	      for (i = keyValuePairs.length; i--; ) {

	        var split = keyValuePairs[i].split(/\s*:\s*/),
	            key = split[0].trim(),
	            value = split[1].trim();

	        if (key === 'stop-color') {
	          color = value;
	        }
	        else if (key === 'stop-opacity') {
	          opacity = value;
	        }
	      }
	    }

	    if (!color) {
	      color = el.getAttribute('stop-color') || 'rgb(0,0,0)';
	    }
	    if (!opacity) {
	      opacity = el.getAttribute('stop-opacity');
	    }

	    color = new fabric.Color(color);
	    colorAlpha = color.getAlpha();
	    opacity = isNaN(parseFloat(opacity)) ? 1 : parseFloat(opacity);
	    opacity *= colorAlpha * multiplier;

	    return {
	      offset: offset,
	      color: color.toRgb(),
	      opacity: opacity
	    };
	  }

	  function getLinearCoords(el) {
	    return {
	      x1: el.getAttribute('x1') || 0,
	      y1: el.getAttribute('y1') || 0,
	      x2: el.getAttribute('x2') || '100%',
	      y2: el.getAttribute('y2') || 0
	    };
	  }

	  function getRadialCoords(el) {
	    return {
	      x1: el.getAttribute('fx') || el.getAttribute('cx') || '50%',
	      y1: el.getAttribute('fy') || el.getAttribute('cy') || '50%',
	      r1: 0,
	      x2: el.getAttribute('cx') || '50%',
	      y2: el.getAttribute('cy') || '50%',
	      r2: el.getAttribute('r') || '50%'
	    };
	  }
	  /* _FROM_SVG_END_ */

	  var clone = fabric.util.object.clone;

	  /**
	   * Gradient class
	   * @class fabric.Gradient
	   * @tutorial {@link http://fabricjs.com/fabric-intro-part-2#gradients}
	   * @see {@link fabric.Gradient#initialize} for constructor definition
	   */
	  fabric.Gradient = fabric.util.createClass(/** @lends fabric.Gradient.prototype */ {

	    /**
	     * Horizontal offset for aligning gradients coming from SVG when outside pathgroups
	     * @type Number
	     * @default 0
	     */
	    offsetX: 0,

	    /**
	     * Vertical offset for aligning gradients coming from SVG when outside pathgroups
	     * @type Number
	     * @default 0
	     */
	    offsetY: 0,

	    /**
	     * A transform matrix to apply to the gradient before painting.
	     * Imported from svg gradients, is not applied with the current transform in the center.
	     * Before this transform is applied, the origin point is at the top left corner of the object
	     * plus the addition of offsetY and offsetX.
	     * @type Number[]
	     * @default null
	     */
	    gradientTransform: null,

	    /**
	     * coordinates units for coords.
	     * If `pixels`, the number of coords are in the same unit of width / height.
	     * If set as `percentage` the coords are still a number, but 1 means 100% of width
	     * for the X and 100% of the height for the y. It can be bigger than 1 and negative.
	     * allowed values pixels or percentage.
	     * @type String
	     * @default 'pixels'
	     */
	    gradientUnits: 'pixels',

	    /**
	     * Gradient type linear or radial
	     * @type String
	     * @default 'pixels'
	     */
	    type: 'linear',

	    /**
	     * Constructor
	     * @param {Object} options Options object with type, coords, gradientUnits and colorStops
	     * @param {Object} [options.type] gradient type linear or radial
	     * @param {Object} [options.gradientUnits] gradient units
	     * @param {Object} [options.offsetX] SVG import compatibility
	     * @param {Object} [options.offsetY] SVG import compatibility
	     * @param {Object[]} options.colorStops contains the colorstops.
	     * @param {Object} options.coords contains the coords of the gradient
	     * @param {Number} [options.coords.x1] X coordiante of the first point for linear or of the focal point for radial
	     * @param {Number} [options.coords.y1] Y coordiante of the first point for linear or of the focal point for radial
	     * @param {Number} [options.coords.x2] X coordiante of the second point for linear or of the center point for radial
	     * @param {Number} [options.coords.y2] Y coordiante of the second point for linear or of the center point for radial
	     * @param {Number} [options.coords.r1] only for radial gradient, radius of the inner circle
	     * @param {Number} [options.coords.r2] only for radial gradient, radius of the external circle
	     * @return {fabric.Gradient} thisArg
	     */
	    initialize: function(options) {
	      options || (options = { });
	      options.coords || (options.coords = { });

	      var coords, _this = this;

	      // sets everything, then coords and colorstops get sets again
	      Object.keys(options).forEach(function(option) {
	        _this[option] = options[option];
	      });

	      if (this.id) {
	        this.id += '_' + fabric.Object.__uid++;
	      }
	      else {
	        this.id = fabric.Object.__uid++;
	      }

	      coords = {
	        x1: options.coords.x1 || 0,
	        y1: options.coords.y1 || 0,
	        x2: options.coords.x2 || 0,
	        y2: options.coords.y2 || 0
	      };

	      if (this.type === 'radial') {
	        coords.r1 = options.coords.r1 || 0;
	        coords.r2 = options.coords.r2 || 0;
	      }

	      this.coords = coords;
	      this.colorStops = options.colorStops.slice();
	    },

	    /**
	     * Adds another colorStop
	     * @param {Object} colorStop Object with offset and color
	     * @return {fabric.Gradient} thisArg
	     */
	    addColorStop: function(colorStops) {
	      for (var position in colorStops) {
	        var color = new fabric.Color(colorStops[position]);
	        this.colorStops.push({
	          offset: parseFloat(position),
	          color: color.toRgb(),
	          opacity: color.getAlpha()
	        });
	      }
	      return this;
	    },

	    /**
	     * Returns object representation of a gradient
	     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
	     * @return {Object}
	     */
	    toObject: function(propertiesToInclude) {
	      var object = {
	        type: this.type,
	        coords: this.coords,
	        colorStops: this.colorStops,
	        offsetX: this.offsetX,
	        offsetY: this.offsetY,
	        gradientUnits: this.gradientUnits,
	        gradientTransform: this.gradientTransform ? this.gradientTransform.concat() : this.gradientTransform
	      };
	      fabric.util.populateWithProperties(this, object, propertiesToInclude);

	      return object;
	    },

	    /* _TO_SVG_START_ */
	    /**
	     * Returns SVG representation of an gradient
	     * @param {Object} object Object to create a gradient for
	     * @return {String} SVG representation of an gradient (linear/radial)
	     */
	    toSVG: function(object, options) {
	      var coords = clone(this.coords, true), i, len, options = options || {},
	          markup, commonAttributes, colorStops = clone(this.colorStops, true),
	          needsSwap = coords.r1 > coords.r2,
	          transform = this.gradientTransform ? this.gradientTransform.concat() : fabric.iMatrix.concat(),
	          offsetX = -this.offsetX, offsetY = -this.offsetY,
	          withViewport = !!options.additionalTransform,
	          gradientUnits = this.gradientUnits === 'pixels' ? 'userSpaceOnUse' : 'objectBoundingBox';
	      // colorStops must be sorted ascending
	      colorStops.sort(function(a, b) {
	        return a.offset - b.offset;
	      });

	      if (gradientUnits === 'objectBoundingBox') {
	        offsetX /= object.width;
	        offsetY /= object.height;
	      }
	      else {
	        offsetX += object.width / 2;
	        offsetY += object.height / 2;
	      }
	      if (object.type === 'path' && this.gradientUnits !== 'percentage') {
	        offsetX -= object.pathOffset.x;
	        offsetY -= object.pathOffset.y;
	      }


	      transform[4] -= offsetX;
	      transform[5] -= offsetY;

	      commonAttributes = 'id="SVGID_' + this.id +
	                     '" gradientUnits="' + gradientUnits + '"';
	      commonAttributes += ' gradientTransform="' + (withViewport ?
	        options.additionalTransform + ' ' : '') + fabric.util.matrixToSVG(transform) + '" ';

	      if (this.type === 'linear') {
	        markup = [
	          '<linearGradient ',
	          commonAttributes,
	          ' x1="', coords.x1,
	          '" y1="', coords.y1,
	          '" x2="', coords.x2,
	          '" y2="', coords.y2,
	          '">\n'
	        ];
	      }
	      else if (this.type === 'radial') {
	        // svg radial gradient has just 1 radius. the biggest.
	        markup = [
	          '<radialGradient ',
	          commonAttributes,
	          ' cx="', needsSwap ? coords.x1 : coords.x2,
	          '" cy="', needsSwap ? coords.y1 : coords.y2,
	          '" r="', needsSwap ? coords.r1 : coords.r2,
	          '" fx="', needsSwap ? coords.x2 : coords.x1,
	          '" fy="', needsSwap ? coords.y2 : coords.y1,
	          '">\n'
	        ];
	      }

	      if (this.type === 'radial') {
	        if (needsSwap) {
	          // svg goes from internal to external radius. if radius are inverted, swap color stops.
	          colorStops = colorStops.concat();
	          colorStops.reverse();
	          for (i = 0, len = colorStops.length; i < len; i++) {
	            colorStops[i].offset = 1 - colorStops[i].offset;
	          }
	        }
	        var minRadius = Math.min(coords.r1, coords.r2);
	        if (minRadius > 0) {
	          // i have to shift all colorStops and add new one in 0.
	          var maxRadius = Math.max(coords.r1, coords.r2),
	              percentageShift = minRadius / maxRadius;
	          for (i = 0, len = colorStops.length; i < len; i++) {
	            colorStops[i].offset += percentageShift * (1 - colorStops[i].offset);
	          }
	        }
	      }

	      for (i = 0, len = colorStops.length; i < len; i++) {
	        var colorStop = colorStops[i];
	        markup.push(
	          '<stop ',
	          'offset="', (colorStop.offset * 100) + '%',
	          '" style="stop-color:', colorStop.color,
	          (typeof colorStop.opacity !== 'undefined' ? ';stop-opacity: ' + colorStop.opacity : ';'),
	          '"/>\n'
	        );
	      }

	      markup.push((this.type === 'linear' ? '</linearGradient>\n' : '</radialGradient>\n'));

	      return markup.join('');
	    },
	    /* _TO_SVG_END_ */

	    /**
	     * Returns an instance of CanvasGradient
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     * @return {CanvasGradient}
	     */
	    toLive: function(ctx) {
	      var gradient, coords = fabric.util.object.clone(this.coords), i, len;

	      if (!this.type) {
	        return;
	      }

	      if (this.type === 'linear') {
	        gradient = ctx.createLinearGradient(
	          coords.x1, coords.y1, coords.x2, coords.y2);
	      }
	      else if (this.type === 'radial') {
	        gradient = ctx.createRadialGradient(
	          coords.x1, coords.y1, coords.r1, coords.x2, coords.y2, coords.r2);
	      }

	      for (i = 0, len = this.colorStops.length; i < len; i++) {
	        var color = this.colorStops[i].color,
	            opacity = this.colorStops[i].opacity,
	            offset = this.colorStops[i].offset;

	        if (typeof opacity !== 'undefined') {
	          color = new fabric.Color(color).setAlpha(opacity).toRgba();
	        }
	        gradient.addColorStop(offset, color);
	      }

	      return gradient;
	    }
	  });

	  fabric.util.object.extend(fabric.Gradient, {

	    /* _FROM_SVG_START_ */
	    /**
	     * Returns {@link fabric.Gradient} instance from an SVG element
	     * @static
	     * @memberOf fabric.Gradient
	     * @param {SVGGradientElement} el SVG gradient element
	     * @param {fabric.Object} instance
	     * @param {String} opacityAttr A fill-opacity or stroke-opacity attribute to multiply to each stop's opacity.
	     * @param {Object} svgOptions an object containing the size of the SVG in order to parse correctly gradients
	     * that uses gradientUnits as 'userSpaceOnUse' and percentages.
	     * @param {Object.number} viewBoxWidth width part of the viewBox attribute on svg
	     * @param {Object.number} viewBoxHeight height part of the viewBox attribute on svg
	     * @param {Object.number} width width part of the svg tag if viewBox is not specified
	     * @param {Object.number} height height part of the svg tag if viewBox is not specified
	     * @return {fabric.Gradient} Gradient instance
	     * @see http://www.w3.org/TR/SVG/pservers.html#LinearGradientElement
	     * @see http://www.w3.org/TR/SVG/pservers.html#RadialGradientElement
	     */
	    fromElement: function(el, instance, opacityAttr, svgOptions) {
	      /**
	       *  @example:
	       *
	       *  <linearGradient id="linearGrad1">
	       *    <stop offset="0%" stop-color="white"/>
	       *    <stop offset="100%" stop-color="black"/>
	       *  </linearGradient>
	       *
	       *  OR
	       *
	       *  <linearGradient id="linearGrad2">
	       *    <stop offset="0" style="stop-color:rgb(255,255,255)"/>
	       *    <stop offset="1" style="stop-color:rgb(0,0,0)"/>
	       *  </linearGradient>
	       *
	       *  OR
	       *
	       *  <radialGradient id="radialGrad1">
	       *    <stop offset="0%" stop-color="white" stop-opacity="1" />
	       *    <stop offset="50%" stop-color="black" stop-opacity="0.5" />
	       *    <stop offset="100%" stop-color="white" stop-opacity="1" />
	       *  </radialGradient>
	       *
	       *  OR
	       *
	       *  <radialGradient id="radialGrad2">
	       *    <stop offset="0" stop-color="rgb(255,255,255)" />
	       *    <stop offset="0.5" stop-color="rgb(0,0,0)" />
	       *    <stop offset="1" stop-color="rgb(255,255,255)" />
	       *  </radialGradient>
	       *
	       */

	      var multiplier = parseFloat(opacityAttr) / (/%$/.test(opacityAttr) ? 100 : 1);
	      multiplier = multiplier < 0 ? 0 : multiplier > 1 ? 1 : multiplier;
	      if (isNaN(multiplier)) {
	        multiplier = 1;
	      }

	      var colorStopEls = el.getElementsByTagName('stop'),
	          type,
	          gradientUnits = el.getAttribute('gradientUnits') === 'userSpaceOnUse' ?
	            'pixels' : 'percentage',
	          gradientTransform = el.getAttribute('gradientTransform') || '',
	          colorStops = [],
	          coords, i, offsetX = 0, offsetY = 0,
	          transformMatrix;
	      if (el.nodeName === 'linearGradient' || el.nodeName === 'LINEARGRADIENT') {
	        type = 'linear';
	        coords = getLinearCoords(el);
	      }
	      else {
	        type = 'radial';
	        coords = getRadialCoords(el);
	      }

	      for (i = colorStopEls.length; i--; ) {
	        colorStops.push(getColorStop(colorStopEls[i], multiplier));
	      }

	      transformMatrix = fabric.parseTransformAttribute(gradientTransform);

	      __convertPercentUnitsToValues(instance, coords, svgOptions, gradientUnits);

	      if (gradientUnits === 'pixels') {
	        offsetX = -instance.left;
	        offsetY = -instance.top;
	      }

	      var gradient = new fabric.Gradient({
	        id: el.getAttribute('id'),
	        type: type,
	        coords: coords,
	        colorStops: colorStops,
	        gradientUnits: gradientUnits,
	        gradientTransform: transformMatrix,
	        offsetX: offsetX,
	        offsetY: offsetY,
	      });

	      return gradient;
	    }
	    /* _FROM_SVG_END_ */
	  });

	  /**
	   * @private
	   */
	  function __convertPercentUnitsToValues(instance, options, svgOptions, gradientUnits) {
	    var propValue, finalValue;
	    Object.keys(options).forEach(function(prop) {
	      propValue = options[prop];
	      if (propValue === 'Infinity') {
	        finalValue = 1;
	      }
	      else if (propValue === '-Infinity') {
	        finalValue = 0;
	      }
	      else {
	        finalValue = parseFloat(options[prop], 10);
	        if (typeof propValue === 'string' && /^(\d+\.\d+)%|(\d+)%$/.test(propValue)) {
	          finalValue *= 0.01;
	          if (gradientUnits === 'pixels') {
	            // then we need to fix those percentages here in svg parsing
	            if (prop === 'x1' || prop === 'x2' || prop === 'r2') {
	              finalValue *= svgOptions.viewBoxWidth || svgOptions.width;
	            }
	            if (prop === 'y1' || prop === 'y2') {
	              finalValue *= svgOptions.viewBoxHeight || svgOptions.height;
	            }
	          }
	        }
	      }
	      options[prop] = finalValue;
	    });
	  }
	})();


	(function() {

	  var toFixed = fabric.util.toFixed;

	  /**
	   * Pattern class
	   * @class fabric.Pattern
	   * @see {@link http://fabricjs.com/patterns|Pattern demo}
	   * @see {@link http://fabricjs.com/dynamic-patterns|DynamicPattern demo}
	   * @see {@link fabric.Pattern#initialize} for constructor definition
	   */


	  fabric.Pattern = fabric.util.createClass(/** @lends fabric.Pattern.prototype */ {

	    /**
	     * Repeat property of a pattern (one of repeat, repeat-x, repeat-y or no-repeat)
	     * @type String
	     * @default
	     */
	    repeat: 'repeat',

	    /**
	     * Pattern horizontal offset from object's left/top corner
	     * @type Number
	     * @default
	     */
	    offsetX: 0,

	    /**
	     * Pattern vertical offset from object's left/top corner
	     * @type Number
	     * @default
	     */
	    offsetY: 0,

	    /**
	     * crossOrigin value (one of "", "anonymous", "use-credentials")
	     * @see https://developer.mozilla.org/en-US/docs/HTML/CORS_settings_attributes
	     * @type String
	     * @default
	     */
	    crossOrigin: '',

	    /**
	     * transform matrix to change the pattern, imported from svgs.
	     * @type Array
	     * @default
	     */
	    patternTransform: null,

	    /**
	     * Constructor
	     * @param {Object} [options] Options object
	     * @param {Function} [callback] function to invoke after callback init.
	     * @return {fabric.Pattern} thisArg
	     */
	    initialize: function(options, callback) {
	      options || (options = { });

	      this.id = fabric.Object.__uid++;
	      this.setOptions(options);
	      if (!options.source || (options.source && typeof options.source !== 'string')) {
	        callback && callback(this);
	        return;
	      }
	      else {
	        // img src string
	        var _this = this;
	        this.source = fabric.util.createImage();
	        fabric.util.loadImage(options.source, function(img, isError) {
	          _this.source = img;
	          callback && callback(_this, isError);
	        }, null, this.crossOrigin);
	      }
	    },

	    /**
	     * Returns object representation of a pattern
	     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
	     * @return {Object} Object representation of a pattern instance
	     */
	    toObject: function(propertiesToInclude) {
	      var NUM_FRACTION_DIGITS = fabric.Object.NUM_FRACTION_DIGITS,
	          source, object;

	      // <img> element
	      if (typeof this.source.src === 'string') {
	        source = this.source.src;
	      }
	      // <canvas> element
	      else if (typeof this.source === 'object' && this.source.toDataURL) {
	        source = this.source.toDataURL();
	      }

	      object = {
	        type: 'pattern',
	        source: source,
	        repeat: this.repeat,
	        crossOrigin: this.crossOrigin,
	        offsetX: toFixed(this.offsetX, NUM_FRACTION_DIGITS),
	        offsetY: toFixed(this.offsetY, NUM_FRACTION_DIGITS),
	        patternTransform: this.patternTransform ? this.patternTransform.concat() : null
	      };
	      fabric.util.populateWithProperties(this, object, propertiesToInclude);

	      return object;
	    },

	    /* _TO_SVG_START_ */
	    /**
	     * Returns SVG representation of a pattern
	     * @param {fabric.Object} object
	     * @return {String} SVG representation of a pattern
	     */
	    toSVG: function(object) {
	      var patternSource = typeof this.source === 'function' ? this.source() : this.source,
	          patternWidth = patternSource.width / object.width,
	          patternHeight = patternSource.height / object.height,
	          patternOffsetX = this.offsetX / object.width,
	          patternOffsetY = this.offsetY / object.height,
	          patternImgSrc = '';
	      if (this.repeat === 'repeat-x' || this.repeat === 'no-repeat') {
	        patternHeight = 1;
	        if (patternOffsetY) {
	          patternHeight += Math.abs(patternOffsetY);
	        }
	      }
	      if (this.repeat === 'repeat-y' || this.repeat === 'no-repeat') {
	        patternWidth = 1;
	        if (patternOffsetX) {
	          patternWidth += Math.abs(patternOffsetX);
	        }

	      }
	      if (patternSource.src) {
	        patternImgSrc = patternSource.src;
	      }
	      else if (patternSource.toDataURL) {
	        patternImgSrc = patternSource.toDataURL();
	      }

	      return '<pattern id="SVGID_' + this.id +
	                    '" x="' + patternOffsetX +
	                    '" y="' + patternOffsetY +
	                    '" width="' + patternWidth +
	                    '" height="' + patternHeight + '">\n' +
	               '<image x="0" y="0"' +
	                      ' width="' + patternSource.width +
	                      '" height="' + patternSource.height +
	                      '" xlink:href="' + patternImgSrc +
	               '"></image>\n' +
	             '</pattern>\n';
	    },
	    /* _TO_SVG_END_ */

	    setOptions: function(options) {
	      for (var prop in options) {
	        this[prop] = options[prop];
	      }
	    },

	    /**
	     * Returns an instance of CanvasPattern
	     * @param {CanvasRenderingContext2D} ctx Context to create pattern
	     * @return {CanvasPattern}
	     */
	    toLive: function(ctx) {
	      var source = this.source;
	      // if the image failed to load, return, and allow rest to continue loading
	      if (!source) {
	        return '';
	      }

	      // if an image
	      if (typeof source.src !== 'undefined') {
	        if (!source.complete) {
	          return '';
	        }
	        if (source.naturalWidth === 0 || source.naturalHeight === 0) {
	          return '';
	        }
	      }
	      return ctx.createPattern(source, this.repeat);
	    }
	  });
	})();


	(function(global) {

	  var fabric = global.fabric || (global.fabric = { }),
	      toFixed = fabric.util.toFixed;

	  if (fabric.Shadow) {
	    fabric.warn('fabric.Shadow is already defined.');
	    return;
	  }

	  /**
	   * Shadow class
	   * @class fabric.Shadow
	   * @see {@link http://fabricjs.com/shadows|Shadow demo}
	   * @see {@link fabric.Shadow#initialize} for constructor definition
	   */
	  fabric.Shadow = fabric.util.createClass(/** @lends fabric.Shadow.prototype */ {

	    /**
	     * Shadow color
	     * @type String
	     * @default
	     */
	    color: 'rgb(0,0,0)',

	    /**
	     * Shadow blur
	     * @type Number
	     */
	    blur: 0,

	    /**
	     * Shadow horizontal offset
	     * @type Number
	     * @default
	     */
	    offsetX: 0,

	    /**
	     * Shadow vertical offset
	     * @type Number
	     * @default
	     */
	    offsetY: 0,

	    /**
	     * Whether the shadow should affect stroke operations
	     * @type Boolean
	     * @default
	     */
	    affectStroke: false,

	    /**
	     * Indicates whether toObject should include default values
	     * @type Boolean
	     * @default
	     */
	    includeDefaultValues: true,

	    /**
	     * When `false`, the shadow will scale with the object.
	     * When `true`, the shadow's offsetX, offsetY, and blur will not be affected by the object's scale.
	     * default to false
	     * @type Boolean
	     * @default
	     */
	    nonScaling: false,

	    /**
	     * Constructor
	     * @param {Object|String} [options] Options object with any of color, blur, offsetX, offsetY properties or string (e.g. "rgba(0,0,0,0.2) 2px 2px 10px")
	     * @return {fabric.Shadow} thisArg
	     */
	    initialize: function(options) {

	      if (typeof options === 'string') {
	        options = this._parseShadow(options);
	      }

	      for (var prop in options) {
	        this[prop] = options[prop];
	      }

	      this.id = fabric.Object.__uid++;
	    },

	    /**
	     * @private
	     * @param {String} shadow Shadow value to parse
	     * @return {Object} Shadow object with color, offsetX, offsetY and blur
	     */
	    _parseShadow: function(shadow) {
	      var shadowStr = shadow.trim(),
	          offsetsAndBlur = fabric.Shadow.reOffsetsAndBlur.exec(shadowStr) || [],
	          color = shadowStr.replace(fabric.Shadow.reOffsetsAndBlur, '') || 'rgb(0,0,0)';

	      return {
	        color: color.trim(),
	        offsetX: parseFloat(offsetsAndBlur[1], 10) || 0,
	        offsetY: parseFloat(offsetsAndBlur[2], 10) || 0,
	        blur: parseFloat(offsetsAndBlur[3], 10) || 0
	      };
	    },

	    /**
	     * Returns a string representation of an instance
	     * @see http://www.w3.org/TR/css-text-decor-3/#text-shadow
	     * @return {String} Returns CSS3 text-shadow declaration
	     */
	    toString: function() {
	      return [this.offsetX, this.offsetY, this.blur, this.color].join('px ');
	    },

	    /* _TO_SVG_START_ */
	    /**
	     * Returns SVG representation of a shadow
	     * @param {fabric.Object} object
	     * @return {String} SVG representation of a shadow
	     */
	    toSVG: function(object) {
	      var fBoxX = 40, fBoxY = 40, NUM_FRACTION_DIGITS = fabric.Object.NUM_FRACTION_DIGITS,
	          offset = fabric.util.rotateVector(
	            { x: this.offsetX, y: this.offsetY },
	            fabric.util.degreesToRadians(-object.angle)),
	          BLUR_BOX = 20, color = new fabric.Color(this.color);

	      if (object.width && object.height) {
	        //http://www.w3.org/TR/SVG/filters.html#FilterEffectsRegion
	        // we add some extra space to filter box to contain the blur ( 20 )
	        fBoxX = toFixed((Math.abs(offset.x) + this.blur) / object.width, NUM_FRACTION_DIGITS) * 100 + BLUR_BOX;
	        fBoxY = toFixed((Math.abs(offset.y) + this.blur) / object.height, NUM_FRACTION_DIGITS) * 100 + BLUR_BOX;
	      }
	      if (object.flipX) {
	        offset.x *= -1;
	      }
	      if (object.flipY) {
	        offset.y *= -1;
	      }

	      return (
	        '<filter id="SVGID_' + this.id + '" y="-' + fBoxY + '%" height="' + (100 + 2 * fBoxY) + '%" ' +
	          'x="-' + fBoxX + '%" width="' + (100 + 2 * fBoxX) + '%" ' + '>\n' +
	          '\t<feGaussianBlur in="SourceAlpha" stdDeviation="' +
	            toFixed(this.blur ? this.blur / 2 : 0, NUM_FRACTION_DIGITS) + '"></feGaussianBlur>\n' +
	          '\t<feOffset dx="' + toFixed(offset.x, NUM_FRACTION_DIGITS) +
	          '" dy="' + toFixed(offset.y, NUM_FRACTION_DIGITS) + '" result="oBlur" ></feOffset>\n' +
	          '\t<feFlood flood-color="' + color.toRgb() + '" flood-opacity="' + color.getAlpha() + '"/>\n' +
	          '\t<feComposite in2="oBlur" operator="in" />\n' +
	          '\t<feMerge>\n' +
	            '\t\t<feMergeNode></feMergeNode>\n' +
	            '\t\t<feMergeNode in="SourceGraphic"></feMergeNode>\n' +
	          '\t</feMerge>\n' +
	        '</filter>\n');
	    },
	    /* _TO_SVG_END_ */

	    /**
	     * Returns object representation of a shadow
	     * @return {Object} Object representation of a shadow instance
	     */
	    toObject: function() {
	      if (this.includeDefaultValues) {
	        return {
	          color: this.color,
	          blur: this.blur,
	          offsetX: this.offsetX,
	          offsetY: this.offsetY,
	          affectStroke: this.affectStroke,
	          nonScaling: this.nonScaling
	        };
	      }
	      var obj = { }, proto = fabric.Shadow.prototype;

	      ['color', 'blur', 'offsetX', 'offsetY', 'affectStroke', 'nonScaling'].forEach(function(prop) {
	        if (this[prop] !== proto[prop]) {
	          obj[prop] = this[prop];
	        }
	      }, this);

	      return obj;
	    }
	  });

	  /**
	   * Regex matching shadow offsetX, offsetY and blur (ex: "2px 2px 10px rgba(0,0,0,0.2)", "rgb(0,255,0) 2px 2px")
	   * @static
	   * @field
	   * @memberOf fabric.Shadow
	   */
	  // eslint-disable-next-line max-len
	  fabric.Shadow.reOffsetsAndBlur = /(?:\s|^)(-?\d+(?:\.\d*)?(?:px)?(?:\s?|$))?(-?\d+(?:\.\d*)?(?:px)?(?:\s?|$))?(\d+(?:\.\d*)?(?:px)?)?(?:\s?|$)(?:$|\s)/;

	})(exports );


	(function () {

	  if (fabric.StaticCanvas) {
	    fabric.warn('fabric.StaticCanvas is already defined.');
	    return;
	  }

	  // aliases for faster resolution
	  var extend = fabric.util.object.extend,
	      getElementOffset = fabric.util.getElementOffset,
	      removeFromArray = fabric.util.removeFromArray,
	      toFixed = fabric.util.toFixed,
	      transformPoint = fabric.util.transformPoint,
	      invertTransform = fabric.util.invertTransform,
	      getNodeCanvas = fabric.util.getNodeCanvas,
	      createCanvasElement = fabric.util.createCanvasElement,

	      CANVAS_INIT_ERROR = new Error('Could not initialize `canvas` element');

	  /**
	   * Static canvas class
	   * @class fabric.StaticCanvas
	   * @mixes fabric.Collection
	   * @mixes fabric.Observable
	   * @see {@link http://fabricjs.com/static_canvas|StaticCanvas demo}
	   * @see {@link fabric.StaticCanvas#initialize} for constructor definition
	   * @fires before:render
	   * @fires after:render
	   * @fires canvas:cleared
	   * @fires object:added
	   * @fires object:removed
	   */
	  fabric.StaticCanvas = fabric.util.createClass(fabric.CommonMethods, /** @lends fabric.StaticCanvas.prototype */ {

	    /**
	     * Constructor
	     * @param {HTMLElement | String} el &lt;canvas> element to initialize instance on
	     * @param {Object} [options] Options object
	     * @return {Object} thisArg
	     */
	    initialize: function(el, options) {
	      options || (options = { });
	      this.renderAndResetBound = this.renderAndReset.bind(this);
	      this.requestRenderAllBound = this.requestRenderAll.bind(this);
	      this._initStatic(el, options);
	    },

	    /**
	     * Background color of canvas instance.
	     * Should be set via {@link fabric.StaticCanvas#setBackgroundColor}.
	     * @type {(String|fabric.Pattern)}
	     * @default
	     */
	    backgroundColor: '',

	    /**
	     * Background image of canvas instance.
	     * since 2.4.0 image caching is active, please when putting an image as background, add to the
	     * canvas property a reference to the canvas it is on. Otherwise the image cannot detect the zoom
	     * vale. As an alternative you can disable image objectCaching
	     * @type fabric.Image
	     * @default
	     */
	    backgroundImage: null,

	    /**
	     * Overlay color of canvas instance.
	     * Should be set via {@link fabric.StaticCanvas#setOverlayColor}
	     * @since 1.3.9
	     * @type {(String|fabric.Pattern)}
	     * @default
	     */
	    overlayColor: '',

	    /**
	     * Overlay image of canvas instance.
	     * since 2.4.0 image caching is active, please when putting an image as overlay, add to the
	     * canvas property a reference to the canvas it is on. Otherwise the image cannot detect the zoom
	     * vale. As an alternative you can disable image objectCaching
	     * @type fabric.Image
	     * @default
	     */
	    overlayImage: null,

	    /**
	     * Indicates whether toObject/toDatalessObject should include default values
	     * if set to false, takes precedence over the object value.
	     * @type Boolean
	     * @default
	     */
	    includeDefaultValues: true,

	    /**
	     * Indicates whether objects' state should be saved
	     * @type Boolean
	     * @default
	     */
	    stateful: false,

	    /**
	     * Indicates whether {@link fabric.Collection.add}, {@link fabric.Collection.insertAt} and {@link fabric.Collection.remove},
	     * {@link fabric.StaticCanvas.moveTo}, {@link fabric.StaticCanvas.clear} and many more, should also re-render canvas.
	     * Disabling this option will not give a performance boost when adding/removing a lot of objects to/from canvas at once
	     * since the renders are quequed and executed one per frame.
	     * Disabling is suggested anyway and managing the renders of the app manually is not a big effort ( canvas.requestRenderAll() )
	     * Left default to true to do not break documentation and old app, fiddles.
	     * @type Boolean
	     * @default
	     */
	    renderOnAddRemove: true,

	    /**
	     * Indicates whether object controls (borders/controls) are rendered above overlay image
	     * @type Boolean
	     * @default
	     */
	    controlsAboveOverlay: false,

	    /**
	     * Indicates whether the browser can be scrolled when using a touchscreen and dragging on the canvas
	     * @type Boolean
	     * @default
	     */
	    allowTouchScrolling: false,

	    /**
	     * Indicates whether this canvas will use image smoothing, this is on by default in browsers
	     * @type Boolean
	     * @default
	     */
	    imageSmoothingEnabled: true,

	    /**
	     * The transformation (in the format of Canvas transform) which focuses the viewport
	     * @type Array
	     * @default
	     */
	    viewportTransform: fabric.iMatrix.concat(),

	    /**
	     * if set to false background image is not affected by viewport transform
	     * @since 1.6.3
	     * @type Boolean
	     * @default
	     */
	    backgroundVpt: true,

	    /**
	     * if set to false overlya image is not affected by viewport transform
	     * @since 1.6.3
	     * @type Boolean
	     * @default
	     */
	    overlayVpt: true,

	    /**
	     * When true, canvas is scaled by devicePixelRatio for better rendering on retina screens
	     * @type Boolean
	     * @default
	     */
	    enableRetinaScaling: true,

	    /**
	     * Describe canvas element extension over design
	     * properties are tl,tr,bl,br.
	     * if canvas is not zoomed/panned those points are the four corner of canvas
	     * if canvas is viewportTransformed you those points indicate the extension
	     * of canvas element in plain untrasformed coordinates
	     * The coordinates get updated with @method calcViewportBoundaries.
	     * @memberOf fabric.StaticCanvas.prototype
	     */
	    vptCoords: { },

	    /**
	     * Based on vptCoords and object.aCoords, skip rendering of objects that
	     * are not included in current viewport.
	     * May greatly help in applications with crowded canvas and use of zoom/pan
	     * If One of the corner of the bounding box of the object is on the canvas
	     * the objects get rendered.
	     * @memberOf fabric.StaticCanvas.prototype
	     * @type Boolean
	     * @default
	     */
	    skipOffscreen: true,

	    /**
	     * a fabricObject that, without stroke define a clipping area with their shape. filled in black
	     * the clipPath object gets used when the canvas has rendered, and the context is placed in the
	     * top left corner of the canvas.
	     * clipPath will clip away controls, if you do not want this to happen use controlsAboveOverlay = true
	     * @type fabric.Object
	     */
	    clipPath: undefined,

	    /**
	     * @private
	     * @param {HTMLElement | String} el &lt;canvas> element to initialize instance on
	     * @param {Object} [options] Options object
	     */
	    _initStatic: function(el, options) {
	      var cb = this.requestRenderAllBound;
	      this._objects = [];
	      this._createLowerCanvas(el);
	      this._initOptions(options);
	      // only initialize retina scaling once
	      if (!this.interactive) {
	        this._initRetinaScaling();
	      }

	      if (options.overlayImage) {
	        this.setOverlayImage(options.overlayImage, cb);
	      }
	      if (options.backgroundImage) {
	        this.setBackgroundImage(options.backgroundImage, cb);
	      }
	      if (options.backgroundColor) {
	        this.setBackgroundColor(options.backgroundColor, cb);
	      }
	      if (options.overlayColor) {
	        this.setOverlayColor(options.overlayColor, cb);
	      }
	      this.calcOffset();
	    },

	    /**
	     * @private
	     */
	    _isRetinaScaling: function() {
	      return (fabric.devicePixelRatio !== 1 && this.enableRetinaScaling);
	    },

	    /**
	     * @private
	     * @return {Number} retinaScaling if applied, otherwise 1;
	     */
	    getRetinaScaling: function() {
	      return this._isRetinaScaling() ? fabric.devicePixelRatio : 1;
	    },

	    /**
	     * @private
	     */
	    _initRetinaScaling: function() {
	      if (!this._isRetinaScaling()) {
	        return;
	      }
	      var scaleRatio = fabric.devicePixelRatio;
	      this.__initRetinaScaling(scaleRatio, this.lowerCanvasEl, this.contextContainer);
	      if (this.upperCanvasEl) {
	        this.__initRetinaScaling(scaleRatio, this.upperCanvasEl, this.contextTop);
	      }
	    },

	    __initRetinaScaling: function(scaleRatio, canvas, context) {
	      canvas.setAttribute('width', this.width * scaleRatio);
	      canvas.setAttribute('height', this.height * scaleRatio);
	      context.scale(scaleRatio, scaleRatio);
	    },


	    /**
	     * Calculates canvas element offset relative to the document
	     * This method is also attached as "resize" event handler of window
	     * @return {fabric.Canvas} instance
	     * @chainable
	     */
	    calcOffset: function () {
	      this._offset = getElementOffset(this.lowerCanvasEl);
	      return this;
	    },

	    /**
	     * Sets {@link fabric.StaticCanvas#overlayImage|overlay image} for this canvas
	     * @param {(fabric.Image|String)} image fabric.Image instance or URL of an image to set overlay to
	     * @param {Function} callback callback to invoke when image is loaded and set as an overlay
	     * @param {Object} [options] Optional options to set for the {@link fabric.Image|overlay image}.
	     * @return {fabric.Canvas} thisArg
	     * @chainable
	     * @see {@link http://jsfiddle.net/fabricjs/MnzHT/|jsFiddle demo}
	     * @example <caption>Normal overlayImage with left/top = 0</caption>
	     * canvas.setOverlayImage('http://fabricjs.com/assets/jail_cell_bars.png', canvas.renderAll.bind(canvas), {
	     *   // Needed to position overlayImage at 0/0
	     *   originX: 'left',
	     *   originY: 'top'
	     * });
	     * @example <caption>overlayImage with different properties</caption>
	     * canvas.setOverlayImage('http://fabricjs.com/assets/jail_cell_bars.png', canvas.renderAll.bind(canvas), {
	     *   opacity: 0.5,
	     *   angle: 45,
	     *   left: 400,
	     *   top: 400,
	     *   originX: 'left',
	     *   originY: 'top'
	     * });
	     * @example <caption>Stretched overlayImage #1 - width/height correspond to canvas width/height</caption>
	     * fabric.Image.fromURL('http://fabricjs.com/assets/jail_cell_bars.png', function(img, isError) {
	     *    img.set({width: canvas.width, height: canvas.height, originX: 'left', originY: 'top'});
	     *    canvas.setOverlayImage(img, canvas.renderAll.bind(canvas));
	     * });
	     * @example <caption>Stretched overlayImage #2 - width/height correspond to canvas width/height</caption>
	     * canvas.setOverlayImage('http://fabricjs.com/assets/jail_cell_bars.png', canvas.renderAll.bind(canvas), {
	     *   width: canvas.width,
	     *   height: canvas.height,
	     *   // Needed to position overlayImage at 0/0
	     *   originX: 'left',
	     *   originY: 'top'
	     * });
	     * @example <caption>overlayImage loaded from cross-origin</caption>
	     * canvas.setOverlayImage('http://fabricjs.com/assets/jail_cell_bars.png', canvas.renderAll.bind(canvas), {
	     *   opacity: 0.5,
	     *   angle: 45,
	     *   left: 400,
	     *   top: 400,
	     *   originX: 'left',
	     *   originY: 'top',
	     *   crossOrigin: 'anonymous'
	     * });
	     */
	    setOverlayImage: function (image, callback, options) {
	      return this.__setBgOverlayImage('overlayImage', image, callback, options);
	    },

	    /**
	     * Sets {@link fabric.StaticCanvas#backgroundImage|background image} for this canvas
	     * @param {(fabric.Image|String)} image fabric.Image instance or URL of an image to set background to
	     * @param {Function} callback Callback to invoke when image is loaded and set as background
	     * @param {Object} [options] Optional options to set for the {@link fabric.Image|background image}.
	     * @return {fabric.Canvas} thisArg
	     * @chainable
	     * @see {@link http://jsfiddle.net/djnr8o7a/28/|jsFiddle demo}
	     * @example <caption>Normal backgroundImage with left/top = 0</caption>
	     * canvas.setBackgroundImage('http://fabricjs.com/assets/honey_im_subtle.png', canvas.renderAll.bind(canvas), {
	     *   // Needed to position backgroundImage at 0/0
	     *   originX: 'left',
	     *   originY: 'top'
	     * });
	     * @example <caption>backgroundImage with different properties</caption>
	     * canvas.setBackgroundImage('http://fabricjs.com/assets/honey_im_subtle.png', canvas.renderAll.bind(canvas), {
	     *   opacity: 0.5,
	     *   angle: 45,
	     *   left: 400,
	     *   top: 400,
	     *   originX: 'left',
	     *   originY: 'top'
	     * });
	     * @example <caption>Stretched backgroundImage #1 - width/height correspond to canvas width/height</caption>
	     * fabric.Image.fromURL('http://fabricjs.com/assets/honey_im_subtle.png', function(img, isError) {
	     *    img.set({width: canvas.width, height: canvas.height, originX: 'left', originY: 'top'});
	     *    canvas.setBackgroundImage(img, canvas.renderAll.bind(canvas));
	     * });
	     * @example <caption>Stretched backgroundImage #2 - width/height correspond to canvas width/height</caption>
	     * canvas.setBackgroundImage('http://fabricjs.com/assets/honey_im_subtle.png', canvas.renderAll.bind(canvas), {
	     *   width: canvas.width,
	     *   height: canvas.height,
	     *   // Needed to position backgroundImage at 0/0
	     *   originX: 'left',
	     *   originY: 'top'
	     * });
	     * @example <caption>backgroundImage loaded from cross-origin</caption>
	     * canvas.setBackgroundImage('http://fabricjs.com/assets/honey_im_subtle.png', canvas.renderAll.bind(canvas), {
	     *   opacity: 0.5,
	     *   angle: 45,
	     *   left: 400,
	     *   top: 400,
	     *   originX: 'left',
	     *   originY: 'top',
	     *   crossOrigin: 'anonymous'
	     * });
	     */
	    // TODO: fix stretched examples
	    setBackgroundImage: function (image, callback, options) {
	      return this.__setBgOverlayImage('backgroundImage', image, callback, options);
	    },

	    /**
	     * Sets {@link fabric.StaticCanvas#overlayColor|foreground color} for this canvas
	     * @param {(String|fabric.Pattern)} overlayColor Color or pattern to set foreground color to
	     * @param {Function} callback Callback to invoke when foreground color is set
	     * @return {fabric.Canvas} thisArg
	     * @chainable
	     * @see {@link http://jsfiddle.net/fabricjs/pB55h/|jsFiddle demo}
	     * @example <caption>Normal overlayColor - color value</caption>
	     * canvas.setOverlayColor('rgba(255, 73, 64, 0.6)', canvas.renderAll.bind(canvas));
	     * @example <caption>fabric.Pattern used as overlayColor</caption>
	     * canvas.setOverlayColor({
	     *   source: 'http://fabricjs.com/assets/escheresque_ste.png'
	     * }, canvas.renderAll.bind(canvas));
	     * @example <caption>fabric.Pattern used as overlayColor with repeat and offset</caption>
	     * canvas.setOverlayColor({
	     *   source: 'http://fabricjs.com/assets/escheresque_ste.png',
	     *   repeat: 'repeat',
	     *   offsetX: 200,
	     *   offsetY: 100
	     * }, canvas.renderAll.bind(canvas));
	     */
	    setOverlayColor: function(overlayColor, callback) {
	      return this.__setBgOverlayColor('overlayColor', overlayColor, callback);
	    },

	    /**
	     * Sets {@link fabric.StaticCanvas#backgroundColor|background color} for this canvas
	     * @param {(String|fabric.Pattern)} backgroundColor Color or pattern to set background color to
	     * @param {Function} callback Callback to invoke when background color is set
	     * @return {fabric.Canvas} thisArg
	     * @chainable
	     * @see {@link http://jsfiddle.net/fabricjs/hXzvk/|jsFiddle demo}
	     * @example <caption>Normal backgroundColor - color value</caption>
	     * canvas.setBackgroundColor('rgba(255, 73, 64, 0.6)', canvas.renderAll.bind(canvas));
	     * @example <caption>fabric.Pattern used as backgroundColor</caption>
	     * canvas.setBackgroundColor({
	     *   source: 'http://fabricjs.com/assets/escheresque_ste.png'
	     * }, canvas.renderAll.bind(canvas));
	     * @example <caption>fabric.Pattern used as backgroundColor with repeat and offset</caption>
	     * canvas.setBackgroundColor({
	     *   source: 'http://fabricjs.com/assets/escheresque_ste.png',
	     *   repeat: 'repeat',
	     *   offsetX: 200,
	     *   offsetY: 100
	     * }, canvas.renderAll.bind(canvas));
	     */
	    setBackgroundColor: function(backgroundColor, callback) {
	      return this.__setBgOverlayColor('backgroundColor', backgroundColor, callback);
	    },

	    /**
	     * @private
	     * @param {String} property Property to set ({@link fabric.StaticCanvas#backgroundImage|backgroundImage}
	     * or {@link fabric.StaticCanvas#overlayImage|overlayImage})
	     * @param {(fabric.Image|String|null)} image fabric.Image instance, URL of an image or null to set background or overlay to
	     * @param {Function} callback Callback to invoke when image is loaded and set as background or overlay. The first argument is the created image, the second argument is a flag indicating whether an error occurred or not.
	     * @param {Object} [options] Optional options to set for the {@link fabric.Image|image}.
	     */
	    __setBgOverlayImage: function(property, image, callback, options) {
	      if (typeof image === 'string') {
	        fabric.util.loadImage(image, function(img, isError) {
	          if (img) {
	            var instance = new fabric.Image(img, options);
	            this[property] = instance;
	            instance.canvas = this;
	          }
	          callback && callback(img, isError);
	        }, this, options && options.crossOrigin);
	      }
	      else {
	        options && image.setOptions(options);
	        this[property] = image;
	        image && (image.canvas = this);
	        callback && callback(image, false);
	      }

	      return this;
	    },

	    /**
	     * @private
	     * @param {String} property Property to set ({@link fabric.StaticCanvas#backgroundColor|backgroundColor}
	     * or {@link fabric.StaticCanvas#overlayColor|overlayColor})
	     * @param {(Object|String|null)} color Object with pattern information, color value or null
	     * @param {Function} [callback] Callback is invoked when color is set
	     */
	    __setBgOverlayColor: function(property, color, callback) {
	      this[property] = color;
	      this._initGradient(color, property);
	      this._initPattern(color, property, callback);
	      return this;
	    },

	    /**
	     * @private
	     */
	    _createCanvasElement: function() {
	      var element = createCanvasElement();
	      if (!element) {
	        throw CANVAS_INIT_ERROR;
	      }
	      if (!element.style) {
	        element.style = { };
	      }
	      if (typeof element.getContext === 'undefined') {
	        throw CANVAS_INIT_ERROR;
	      }
	      return element;
	    },

	    /**
	     * @private
	     * @param {Object} [options] Options object
	     */
	    _initOptions: function (options) {
	      var lowerCanvasEl = this.lowerCanvasEl;
	      this._setOptions(options);

	      this.width = this.width || parseInt(lowerCanvasEl.width, 10) || 0;
	      this.height = this.height || parseInt(lowerCanvasEl.height, 10) || 0;

	      if (!this.lowerCanvasEl.style) {
	        return;
	      }

	      lowerCanvasEl.width = this.width;
	      lowerCanvasEl.height = this.height;

	      lowerCanvasEl.style.width = this.width + 'px';
	      lowerCanvasEl.style.height = this.height + 'px';

	      this.viewportTransform = this.viewportTransform.slice();
	    },

	    /**
	     * Creates a bottom canvas
	     * @private
	     * @param {HTMLElement} [canvasEl]
	     */
	    _createLowerCanvas: function (canvasEl) {
	      // canvasEl === 'HTMLCanvasElement' does not work on jsdom/node
	      if (canvasEl && canvasEl.getContext) {
	        this.lowerCanvasEl = canvasEl;
	      }
	      else {
	        this.lowerCanvasEl = fabric.util.getById(canvasEl) || this._createCanvasElement();
	      }

	      fabric.util.addClass(this.lowerCanvasEl, 'lower-canvas');
	      this._originalCanvasStyle = this.lowerCanvasEl.style;
	      if (this.interactive) {
	        this._applyCanvasStyle(this.lowerCanvasEl);
	      }

	      this.contextContainer = this.lowerCanvasEl.getContext('2d');
	    },

	    /**
	     * Returns canvas width (in px)
	     * @return {Number}
	     */
	    getWidth: function () {
	      return this.width;
	    },

	    /**
	     * Returns canvas height (in px)
	     * @return {Number}
	     */
	    getHeight: function () {
	      return this.height;
	    },

	    /**
	     * Sets width of this canvas instance
	     * @param {Number|String} value                         Value to set width to
	     * @param {Object}        [options]                     Options object
	     * @param {Boolean}       [options.backstoreOnly=false] Set the given dimensions only as canvas backstore dimensions
	     * @param {Boolean}       [options.cssOnly=false]       Set the given dimensions only as css dimensions
	     * @return {fabric.Canvas} instance
	     * @chainable true
	     */
	    setWidth: function (value, options) {
	      return this.setDimensions({ width: value }, options);
	    },

	    /**
	     * Sets height of this canvas instance
	     * @param {Number|String} value                         Value to set height to
	     * @param {Object}        [options]                     Options object
	     * @param {Boolean}       [options.backstoreOnly=false] Set the given dimensions only as canvas backstore dimensions
	     * @param {Boolean}       [options.cssOnly=false]       Set the given dimensions only as css dimensions
	     * @return {fabric.Canvas} instance
	     * @chainable true
	     */
	    setHeight: function (value, options) {
	      return this.setDimensions({ height: value }, options);
	    },

	    /**
	     * Sets dimensions (width, height) of this canvas instance. when options.cssOnly flag active you should also supply the unit of measure (px/%/em)
	     * @param {Object}        dimensions                    Object with width/height properties
	     * @param {Number|String} [dimensions.width]            Width of canvas element
	     * @param {Number|String} [dimensions.height]           Height of canvas element
	     * @param {Object}        [options]                     Options object
	     * @param {Boolean}       [options.backstoreOnly=false] Set the given dimensions only as canvas backstore dimensions
	     * @param {Boolean}       [options.cssOnly=false]       Set the given dimensions only as css dimensions
	     * @return {fabric.Canvas} thisArg
	     * @chainable
	     */
	    setDimensions: function (dimensions, options) {
	      var cssValue;

	      options = options || {};

	      for (var prop in dimensions) {
	        cssValue = dimensions[prop];

	        if (!options.cssOnly) {
	          this._setBackstoreDimension(prop, dimensions[prop]);
	          cssValue += 'px';
	          this.hasLostContext = true;
	        }

	        if (!options.backstoreOnly) {
	          this._setCssDimension(prop, cssValue);
	        }
	      }
	      if (this._isCurrentlyDrawing) {
	        this.freeDrawingBrush && this.freeDrawingBrush._setBrushStyles();
	      }
	      this._initRetinaScaling();
	      this.calcOffset();

	      if (!options.cssOnly) {
	        this.requestRenderAll();
	      }

	      return this;
	    },

	    /**
	     * Helper for setting width/height
	     * @private
	     * @param {String} prop property (width|height)
	     * @param {Number} value value to set property to
	     * @return {fabric.Canvas} instance
	     * @chainable true
	     */
	    _setBackstoreDimension: function (prop, value) {
	      this.lowerCanvasEl[prop] = value;

	      if (this.upperCanvasEl) {
	        this.upperCanvasEl[prop] = value;
	      }

	      if (this.cacheCanvasEl) {
	        this.cacheCanvasEl[prop] = value;
	      }

	      this[prop] = value;

	      return this;
	    },

	    /**
	     * Helper for setting css width/height
	     * @private
	     * @param {String} prop property (width|height)
	     * @param {String} value value to set property to
	     * @return {fabric.Canvas} instance
	     * @chainable true
	     */
	    _setCssDimension: function (prop, value) {
	      this.lowerCanvasEl.style[prop] = value;

	      if (this.upperCanvasEl) {
	        this.upperCanvasEl.style[prop] = value;
	      }

	      if (this.wrapperEl) {
	        this.wrapperEl.style[prop] = value;
	      }

	      return this;
	    },

	    /**
	     * Returns canvas zoom level
	     * @return {Number}
	     */
	    getZoom: function () {
	      return this.viewportTransform[0];
	    },

	    /**
	     * Sets viewport transform of this canvas instance
	     * @param {Array} vpt the transform in the form of context.transform
	     * @return {fabric.Canvas} instance
	     * @chainable true
	     */
	    setViewportTransform: function (vpt) {
	      var activeObject = this._activeObject,
	          backgroundObject = this.backgroundImage,
	          overlayObject = this.overlayImage,
	          object, i, len;
	      this.viewportTransform = vpt;
	      for (i = 0, len = this._objects.length; i < len; i++) {
	        object = this._objects[i];
	        object.group || object.setCoords(true);
	      }
	      if (activeObject) {
	        activeObject.setCoords();
	      }
	      if (backgroundObject) {
	        backgroundObject.setCoords(true);
	      }
	      if (overlayObject) {
	        overlayObject.setCoords(true);
	      }
	      this.calcViewportBoundaries();
	      this.renderOnAddRemove && this.requestRenderAll();
	      return this;
	    },

	    /**
	     * Sets zoom level of this canvas instance, the zoom centered around point
	     * meaning that following zoom to point with the same point will have the visual
	     * effect of the zoom originating from that point. The point won't move.
	     * It has nothing to do with canvas center or visual center of the viewport.
	     * @param {fabric.Point} point to zoom with respect to
	     * @param {Number} value to set zoom to, less than 1 zooms out
	     * @return {fabric.Canvas} instance
	     * @chainable true
	     */
	    zoomToPoint: function (point, value) {
	      // TODO: just change the scale, preserve other transformations
	      var before = point, vpt = this.viewportTransform.slice(0);
	      point = transformPoint(point, invertTransform(this.viewportTransform));
	      vpt[0] = value;
	      vpt[3] = value;
	      var after = transformPoint(point, vpt);
	      vpt[4] += before.x - after.x;
	      vpt[5] += before.y - after.y;
	      return this.setViewportTransform(vpt);
	    },

	    /**
	     * Sets zoom level of this canvas instance
	     * @param {Number} value to set zoom to, less than 1 zooms out
	     * @return {fabric.Canvas} instance
	     * @chainable true
	     */
	    setZoom: function (value) {
	      this.zoomToPoint(new fabric.Point(0, 0), value);
	      return this;
	    },

	    /**
	     * Pan viewport so as to place point at top left corner of canvas
	     * @param {fabric.Point} point to move to
	     * @return {fabric.Canvas} instance
	     * @chainable true
	     */
	    absolutePan: function (point) {
	      var vpt = this.viewportTransform.slice(0);
	      vpt[4] = -point.x;
	      vpt[5] = -point.y;
	      return this.setViewportTransform(vpt);
	    },

	    /**
	     * Pans viewpoint relatively
	     * @param {fabric.Point} point (position vector) to move by
	     * @return {fabric.Canvas} instance
	     * @chainable true
	     */
	    relativePan: function (point) {
	      return this.absolutePan(new fabric.Point(
	        -point.x - this.viewportTransform[4],
	        -point.y - this.viewportTransform[5]
	      ));
	    },

	    /**
	     * Returns &lt;canvas> element corresponding to this instance
	     * @return {HTMLCanvasElement}
	     */
	    getElement: function () {
	      return this.lowerCanvasEl;
	    },

	    /**
	     * @private
	     * @param {fabric.Object} obj Object that was added
	     */
	    _onObjectAdded: function(obj) {
	      this.stateful && obj.setupState();
	      obj._set('canvas', this);
	      obj.setCoords();
	      this.fire('object:added', { target: obj });
	      obj.fire('added');
	    },

	    /**
	     * @private
	     * @param {fabric.Object} obj Object that was removed
	     */
	    _onObjectRemoved: function(obj) {
	      this.fire('object:removed', { target: obj });
	      obj.fire('removed');
	      delete obj.canvas;
	    },

	    /**
	     * Clears specified context of canvas element
	     * @param {CanvasRenderingContext2D} ctx Context to clear
	     * @return {fabric.Canvas} thisArg
	     * @chainable
	     */
	    clearContext: function(ctx) {
	      ctx.clearRect(0, 0, this.width, this.height);
	      return this;
	    },

	    /**
	     * Returns context of canvas where objects are drawn
	     * @return {CanvasRenderingContext2D}
	     */
	    getContext: function () {
	      return this.contextContainer;
	    },

	    /**
	     * Clears all contexts (background, main, top) of an instance
	     * @return {fabric.Canvas} thisArg
	     * @chainable
	     */
	    clear: function () {
	      this.remove.apply(this, this.getObjects());
	      this.backgroundImage = null;
	      this.overlayImage = null;
	      this.backgroundColor = '';
	      this.overlayColor = '';
	      if (this._hasITextHandlers) {
	        this.off('mouse:up', this._mouseUpITextHandler);
	        this._iTextInstances = null;
	        this._hasITextHandlers = false;
	      }
	      this.clearContext(this.contextContainer);
	      this.fire('canvas:cleared');
	      this.renderOnAddRemove && this.requestRenderAll();
	      return this;
	    },

	    /**
	     * Renders the canvas
	     * @return {fabric.Canvas} instance
	     * @chainable
	     */
	    renderAll: function () {
	      var canvasToDrawOn = this.contextContainer;
	      this.renderCanvas(canvasToDrawOn, this._objects);
	      return this;
	    },

	    /**
	     * Function created to be instance bound at initialization
	     * used in requestAnimationFrame rendering
	     * Let the fabricJS call it. If you call it manually you could have more
	     * animationFrame stacking on to of each other
	     * for an imperative rendering, use canvas.renderAll
	     * @private
	     * @return {fabric.Canvas} instance
	     * @chainable
	     */
	    renderAndReset: function() {
	      this.isRendering = 0;
	      this.renderAll();
	    },

	    /**
	     * Append a renderAll request to next animation frame.
	     * unless one is already in progress, in that case nothing is done
	     * a boolean flag will avoid appending more.
	     * @return {fabric.Canvas} instance
	     * @chainable
	     */
	    requestRenderAll: function () {
	      if (!this.isRendering) {
	        this.isRendering = fabric.util.requestAnimFrame(this.renderAndResetBound);
	      }
	      return this;
	    },

	    /**
	     * Calculate the position of the 4 corner of canvas with current viewportTransform.
	     * helps to determinate when an object is in the current rendering viewport using
	     * object absolute coordinates ( aCoords )
	     * @return {Object} points.tl
	     * @chainable
	     */
	    calcViewportBoundaries: function() {
	      var points = { }, width = this.width, height = this.height,
	          iVpt = invertTransform(this.viewportTransform);
	      points.tl = transformPoint({ x: 0, y: 0 }, iVpt);
	      points.br = transformPoint({ x: width, y: height }, iVpt);
	      points.tr = new fabric.Point(points.br.x, points.tl.y);
	      points.bl = new fabric.Point(points.tl.x, points.br.y);
	      this.vptCoords = points;
	      return points;
	    },

	    cancelRequestedRender: function() {
	      if (this.isRendering) {
	        fabric.util.cancelAnimFrame(this.isRendering);
	        this.isRendering = 0;
	      }
	    },

	    /**
	     * Renders background, objects, overlay and controls.
	     * @param {CanvasRenderingContext2D} ctx
	     * @param {Array} objects to render
	     * @return {fabric.Canvas} instance
	     * @chainable
	     */
	    renderCanvas: function(ctx, objects) {
	      var v = this.viewportTransform, path = this.clipPath;
	      this.cancelRequestedRender();
	      this.calcViewportBoundaries();
	      this.clearContext(ctx);
	      fabric.util.setImageSmoothing(ctx, this.imageSmoothingEnabled);
	      this.fire('before:render', { ctx: ctx, });
	      this._renderBackground(ctx);

	      ctx.save();
	      //apply viewport transform once for all rendering process
	      ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
	      this._renderObjects(ctx, objects);
	      ctx.restore();
	      if (!this.controlsAboveOverlay && this.interactive) {
	        this.drawControls(ctx);
	      }
	      if (path) {
	        path.canvas = this;
	        // needed to setup a couple of variables
	        path.shouldCache();
	        path._transformDone = true;
	        path.renderCache({ forClipping: true });
	        this.drawClipPathOnCanvas(ctx);
	      }
	      this._renderOverlay(ctx);
	      if (this.controlsAboveOverlay && this.interactive) {
	        this.drawControls(ctx);
	      }
	      this.fire('after:render', { ctx: ctx, });
	    },

	    /**
	     * Paint the cached clipPath on the lowerCanvasEl
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    drawClipPathOnCanvas: function(ctx) {
	      var v = this.viewportTransform, path = this.clipPath;
	      ctx.save();
	      ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
	      // DEBUG: uncomment this line, comment the following
	      // ctx.globalAlpha = 0.4;
	      ctx.globalCompositeOperation = 'destination-in';
	      path.transform(ctx);
	      ctx.scale(1 / path.zoomX, 1 / path.zoomY);
	      ctx.drawImage(path._cacheCanvas, -path.cacheTranslationX, -path.cacheTranslationY);
	      ctx.restore();
	    },

	    /**
	     * @private
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     * @param {Array} objects to render
	     */
	    _renderObjects: function(ctx, objects) {
	      var i, len;
	      for (i = 0, len = objects.length; i < len; ++i) {
	        objects[i] && objects[i].render(ctx);
	      }
	    },

	    /**
	     * @private
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     * @param {string} property 'background' or 'overlay'
	     */
	    _renderBackgroundOrOverlay: function(ctx, property) {
	      var fill = this[property + 'Color'], object = this[property + 'Image'],
	          v = this.viewportTransform, needsVpt = this[property + 'Vpt'];
	      if (!fill && !object) {
	        return;
	      }
	      if (fill) {
	        ctx.save();
	        ctx.beginPath();
	        ctx.moveTo(0, 0);
	        ctx.lineTo(this.width, 0);
	        ctx.lineTo(this.width, this.height);
	        ctx.lineTo(0, this.height);
	        ctx.closePath();
	        ctx.fillStyle = fill.toLive
	          ? fill.toLive(ctx, this)
	          : fill;
	        if (needsVpt) {
	          ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
	        }
	        ctx.transform(1, 0, 0, 1, fill.offsetX || 0, fill.offsetY || 0);
	        var m = fill.gradientTransform || fill.patternTransform;
	        m && ctx.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
	        ctx.fill();
	        ctx.restore();
	      }
	      if (object) {
	        ctx.save();
	        if (needsVpt) {
	          ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
	        }
	        object.render(ctx);
	        ctx.restore();
	      }
	    },

	    /**
	     * @private
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    _renderBackground: function(ctx) {
	      this._renderBackgroundOrOverlay(ctx, 'background');
	    },

	    /**
	     * @private
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    _renderOverlay: function(ctx) {
	      this._renderBackgroundOrOverlay(ctx, 'overlay');
	    },

	    /**
	     * Returns coordinates of a center of canvas.
	     * Returned value is an object with top and left properties
	     * @return {Object} object with "top" and "left" number values
	     */
	    getCenter: function () {
	      return {
	        top: this.height / 2,
	        left: this.width / 2
	      };
	    },

	    /**
	     * Centers object horizontally in the canvas
	     * @param {fabric.Object} object Object to center horizontally
	     * @return {fabric.Canvas} thisArg
	     */
	    centerObjectH: function (object) {
	      return this._centerObject(object, new fabric.Point(this.getCenter().left, object.getCenterPoint().y));
	    },

	    /**
	     * Centers object vertically in the canvas
	     * @param {fabric.Object} object Object to center vertically
	     * @return {fabric.Canvas} thisArg
	     * @chainable
	     */
	    centerObjectV: function (object) {
	      return this._centerObject(object, new fabric.Point(object.getCenterPoint().x, this.getCenter().top));
	    },

	    /**
	     * Centers object vertically and horizontally in the canvas
	     * @param {fabric.Object} object Object to center vertically and horizontally
	     * @return {fabric.Canvas} thisArg
	     * @chainable
	     */
	    centerObject: function(object) {
	      var center = this.getCenter();

	      return this._centerObject(object, new fabric.Point(center.left, center.top));
	    },

	    /**
	     * Centers object vertically and horizontally in the viewport
	     * @param {fabric.Object} object Object to center vertically and horizontally
	     * @return {fabric.Canvas} thisArg
	     * @chainable
	     */
	    viewportCenterObject: function(object) {
	      var vpCenter = this.getVpCenter();

	      return this._centerObject(object, vpCenter);
	    },

	    /**
	     * Centers object horizontally in the viewport, object.top is unchanged
	     * @param {fabric.Object} object Object to center vertically and horizontally
	     * @return {fabric.Canvas} thisArg
	     * @chainable
	     */
	    viewportCenterObjectH: function(object) {
	      var vpCenter = this.getVpCenter();
	      this._centerObject(object, new fabric.Point(vpCenter.x, object.getCenterPoint().y));
	      return this;
	    },

	    /**
	     * Centers object Vertically in the viewport, object.top is unchanged
	     * @param {fabric.Object} object Object to center vertically and horizontally
	     * @return {fabric.Canvas} thisArg
	     * @chainable
	     */
	    viewportCenterObjectV: function(object) {
	      var vpCenter = this.getVpCenter();

	      return this._centerObject(object, new fabric.Point(object.getCenterPoint().x, vpCenter.y));
	    },

	    /**
	     * Calculate the point in canvas that correspond to the center of actual viewport.
	     * @return {fabric.Point} vpCenter, viewport center
	     * @chainable
	     */
	    getVpCenter: function() {
	      var center = this.getCenter(),
	          iVpt = invertTransform(this.viewportTransform);
	      return transformPoint({ x: center.left, y: center.top }, iVpt);
	    },

	    /**
	     * @private
	     * @param {fabric.Object} object Object to center
	     * @param {fabric.Point} center Center point
	     * @return {fabric.Canvas} thisArg
	     * @chainable
	     */
	    _centerObject: function(object, center) {
	      object.setPositionByOrigin(center, 'center', 'center');
	      object.setCoords();
	      this.renderOnAddRemove && this.requestRenderAll();
	      return this;
	    },

	    /**
	     * Returns dataless JSON representation of canvas
	     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
	     * @return {String} json string
	     */
	    toDatalessJSON: function (propertiesToInclude) {
	      return this.toDatalessObject(propertiesToInclude);
	    },

	    /**
	     * Returns object representation of canvas
	     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
	     * @return {Object} object representation of an instance
	     */
	    toObject: function (propertiesToInclude) {
	      return this._toObjectMethod('toObject', propertiesToInclude);
	    },

	    /**
	     * Returns dataless object representation of canvas
	     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
	     * @return {Object} object representation of an instance
	     */
	    toDatalessObject: function (propertiesToInclude) {
	      return this._toObjectMethod('toDatalessObject', propertiesToInclude);
	    },

	    /**
	     * @private
	     */
	    _toObjectMethod: function (methodName, propertiesToInclude) {

	      var clipPath = this.clipPath, data = {
	        version: fabric.version,
	        objects: this._toObjects(methodName, propertiesToInclude),
	      };
	      if (clipPath && !clipPath.excludeFromExport) {
	        data.clipPath = this._toObject(this.clipPath, methodName, propertiesToInclude);
	      }
	      extend(data, this.__serializeBgOverlay(methodName, propertiesToInclude));

	      fabric.util.populateWithProperties(this, data, propertiesToInclude);

	      return data;
	    },

	    /**
	     * @private
	     */
	    _toObjects: function(methodName, propertiesToInclude) {
	      return this._objects.filter(function(object) {
	        return !object.excludeFromExport;
	      }).map(function(instance) {
	        return this._toObject(instance, methodName, propertiesToInclude);
	      }, this);
	    },

	    /**
	     * @private
	     */
	    _toObject: function(instance, methodName, propertiesToInclude) {
	      var originalValue;

	      if (!this.includeDefaultValues) {
	        originalValue = instance.includeDefaultValues;
	        instance.includeDefaultValues = false;
	      }

	      var object = instance[methodName](propertiesToInclude);
	      if (!this.includeDefaultValues) {
	        instance.includeDefaultValues = originalValue;
	      }
	      return object;
	    },

	    /**
	     * @private
	     */
	    __serializeBgOverlay: function(methodName, propertiesToInclude) {
	      var data = {}, bgImage = this.backgroundImage, overlayImage = this.overlayImage,
	          bgColor = this.backgroundColor, overlayColor = this.overlayColor;

	      if (bgColor && bgColor.toObject) {
	        if (!bgColor.excludeFromExport) {
	          data.background = bgColor.toObject(propertiesToInclude);
	        }
	      }
	      else if (bgColor) {
	        data.background = bgColor;
	      }

	      if (overlayColor && overlayColor.toObject) {
	        if (!overlayColor.excludeFromExport) {
	          data.overlay = overlayColor.toObject(propertiesToInclude);
	        }
	      }
	      else if (overlayColor) {
	        data.overlay = overlayColor;
	      }

	      if (bgImage && !bgImage.excludeFromExport) {
	        data.backgroundImage = this._toObject(bgImage, methodName, propertiesToInclude);
	      }
	      if (overlayImage && !overlayImage.excludeFromExport) {
	        data.overlayImage = this._toObject(overlayImage, methodName, propertiesToInclude);
	      }

	      return data;
	    },

	    /* _TO_SVG_START_ */
	    /**
	     * When true, getSvgTransform() will apply the StaticCanvas.viewportTransform to the SVG transformation. When true,
	     * a zoomed canvas will then produce zoomed SVG output.
	     * @type Boolean
	     * @default
	     */
	    svgViewportTransformation: true,

	    /**
	     * Returns SVG representation of canvas
	     * @function
	     * @param {Object} [options] Options object for SVG output
	     * @param {Boolean} [options.suppressPreamble=false] If true xml tag is not included
	     * @param {Object} [options.viewBox] SVG viewbox object
	     * @param {Number} [options.viewBox.x] x-coordinate of viewbox
	     * @param {Number} [options.viewBox.y] y-coordinate of viewbox
	     * @param {Number} [options.viewBox.width] Width of viewbox
	     * @param {Number} [options.viewBox.height] Height of viewbox
	     * @param {String} [options.encoding=UTF-8] Encoding of SVG output
	     * @param {String} [options.width] desired width of svg with or without units
	     * @param {String} [options.height] desired height of svg with or without units
	     * @param {Function} [reviver] Method for further parsing of svg elements, called after each fabric object converted into svg representation.
	     * @return {String} SVG string
	     * @tutorial {@link http://fabricjs.com/fabric-intro-part-3#serialization}
	     * @see {@link http://jsfiddle.net/fabricjs/jQ3ZZ/|jsFiddle demo}
	     * @example <caption>Normal SVG output</caption>
	     * var svg = canvas.toSVG();
	     * @example <caption>SVG output without preamble (without &lt;?xml ../>)</caption>
	     * var svg = canvas.toSVG({suppressPreamble: true});
	     * @example <caption>SVG output with viewBox attribute</caption>
	     * var svg = canvas.toSVG({
	     *   viewBox: {
	     *     x: 100,
	     *     y: 100,
	     *     width: 200,
	     *     height: 300
	     *   }
	     * });
	     * @example <caption>SVG output with different encoding (default: UTF-8)</caption>
	     * var svg = canvas.toSVG({encoding: 'ISO-8859-1'});
	     * @example <caption>Modify SVG output with reviver function</caption>
	     * var svg = canvas.toSVG(null, function(svg) {
	     *   return svg.replace('stroke-dasharray: ; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; ', '');
	     * });
	     */
	    toSVG: function(options, reviver) {
	      options || (options = { });
	      options.reviver = reviver;
	      var markup = [];

	      this._setSVGPreamble(markup, options);
	      this._setSVGHeader(markup, options);
	      if (this.clipPath) {
	        markup.push('<g clip-path="url(#' + this.clipPath.clipPathId + ')" >\n');
	      }
	      this._setSVGBgOverlayColor(markup, 'background');
	      this._setSVGBgOverlayImage(markup, 'backgroundImage', reviver);
	      this._setSVGObjects(markup, reviver);
	      if (this.clipPath) {
	        markup.push('</g>\n');
	      }
	      this._setSVGBgOverlayColor(markup, 'overlay');
	      this._setSVGBgOverlayImage(markup, 'overlayImage', reviver);

	      markup.push('</svg>');

	      return markup.join('');
	    },

	    /**
	     * @private
	     */
	    _setSVGPreamble: function(markup, options) {
	      if (options.suppressPreamble) {
	        return;
	      }
	      markup.push(
	        '<?xml version="1.0" encoding="', (options.encoding || 'UTF-8'), '" standalone="no" ?>\n',
	        '<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" ',
	        '"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">\n'
	      );
	    },

	    /**
	     * @private
	     */
	    _setSVGHeader: function(markup, options) {
	      var width = options.width || this.width,
	          height = options.height || this.height,
	          vpt, viewBox = 'viewBox="0 0 ' + this.width + ' ' + this.height + '" ',
	          NUM_FRACTION_DIGITS = fabric.Object.NUM_FRACTION_DIGITS;

	      if (options.viewBox) {
	        viewBox = 'viewBox="' +
	                options.viewBox.x + ' ' +
	                options.viewBox.y + ' ' +
	                options.viewBox.width + ' ' +
	                options.viewBox.height + '" ';
	      }
	      else {
	        if (this.svgViewportTransformation) {
	          vpt = this.viewportTransform;
	          viewBox = 'viewBox="' +
	                  toFixed(-vpt[4] / vpt[0], NUM_FRACTION_DIGITS) + ' ' +
	                  toFixed(-vpt[5] / vpt[3], NUM_FRACTION_DIGITS) + ' ' +
	                  toFixed(this.width / vpt[0], NUM_FRACTION_DIGITS) + ' ' +
	                  toFixed(this.height / vpt[3], NUM_FRACTION_DIGITS) + '" ';
	        }
	      }

	      markup.push(
	        '<svg ',
	        'xmlns="http://www.w3.org/2000/svg" ',
	        'xmlns:xlink="http://www.w3.org/1999/xlink" ',
	        'version="1.1" ',
	        'width="', width, '" ',
	        'height="', height, '" ',
	        viewBox,
	        'xml:space="preserve">\n',
	        '<desc>Created with Fabric.js ', fabric.version, '</desc>\n',
	        '<defs>\n',
	        this.createSVGFontFacesMarkup(),
	        this.createSVGRefElementsMarkup(),
	        this.createSVGClipPathMarkup(options),
	        '</defs>\n'
	      );
	    },

	    createSVGClipPathMarkup: function(options) {
	      var clipPath = this.clipPath;
	      if (clipPath) {
	        clipPath.clipPathId = 'CLIPPATH_' + fabric.Object.__uid++;
	        return  '<clipPath id="' + clipPath.clipPathId + '" >\n' +
	          this.clipPath.toClipPathSVG(options.reviver) +
	          '</clipPath>\n';
	      }
	      return '';
	    },

	    /**
	     * Creates markup containing SVG referenced elements like patterns, gradients etc.
	     * @return {String}
	     */
	    createSVGRefElementsMarkup: function() {
	      var _this = this,
	          markup = ['background', 'overlay'].map(function(prop) {
	            var fill = _this[prop + 'Color'];
	            if (fill && fill.toLive) {
	              var shouldTransform = _this[prop + 'Vpt'], vpt = _this.viewportTransform,
	                  object = {
	                    width: _this.width / (shouldTransform ? vpt[0] : 1),
	                    height: _this.height / (shouldTransform ? vpt[3] : 1)
	                  };
	              return fill.toSVG(
	                object,
	                { additionalTransform: shouldTransform ? fabric.util.matrixToSVG(vpt) : '' }
	              );
	            }
	          });
	      return markup.join('');
	    },

	    /**
	     * Creates markup containing SVG font faces,
	     * font URLs for font faces must be collected by developers
	     * and are not extracted from the DOM by fabricjs
	     * @param {Array} objects Array of fabric objects
	     * @return {String}
	     */
	    createSVGFontFacesMarkup: function() {
	      var markup = '', fontList = { }, obj, fontFamily,
	          style, row, rowIndex, _char, charIndex, i, len,
	          fontPaths = fabric.fontPaths, objects = [];

	      this._objects.forEach(function add(object) {
	        objects.push(object);
	        if (object._objects) {
	          object._objects.forEach(add);
	        }
	      });

	      for (i = 0, len = objects.length; i < len; i++) {
	        obj = objects[i];
	        fontFamily = obj.fontFamily;
	        if (obj.type.indexOf('text') === -1 || fontList[fontFamily] || !fontPaths[fontFamily]) {
	          continue;
	        }
	        fontList[fontFamily] = true;
	        if (!obj.styles) {
	          continue;
	        }
	        style = obj.styles;
	        for (rowIndex in style) {
	          row = style[rowIndex];
	          for (charIndex in row) {
	            _char = row[charIndex];
	            fontFamily = _char.fontFamily;
	            if (!fontList[fontFamily] && fontPaths[fontFamily]) {
	              fontList[fontFamily] = true;
	            }
	          }
	        }
	      }

	      for (var j in fontList) {
	        markup += [
	          '\t\t@font-face {\n',
	          '\t\t\tfont-family: \'', j, '\';\n',
	          '\t\t\tsrc: url(\'', fontPaths[j], '\');\n',
	          '\t\t}\n'
	        ].join('');
	      }

	      if (markup) {
	        markup = [
	          '\t<style type="text/css">',
	          '<![CDATA[\n',
	          markup,
	          ']]>',
	          '</style>\n'
	        ].join('');
	      }

	      return markup;
	    },

	    /**
	     * @private
	     */
	    _setSVGObjects: function(markup, reviver) {
	      var instance, i, len, objects = this._objects;
	      for (i = 0, len = objects.length; i < len; i++) {
	        instance = objects[i];
	        if (instance.excludeFromExport) {
	          continue;
	        }
	        this._setSVGObject(markup, instance, reviver);
	      }
	    },

	    /**
	     * @private
	     */
	    _setSVGObject: function(markup, instance, reviver) {
	      markup.push(instance.toSVG(reviver));
	    },

	    /**
	     * @private
	     */
	    _setSVGBgOverlayImage: function(markup, property, reviver) {
	      if (this[property] && !this[property].excludeFromExport && this[property].toSVG) {
	        markup.push(this[property].toSVG(reviver));
	      }
	    },

	    /**
	     * @private
	     */
	    _setSVGBgOverlayColor: function(markup, property) {
	      var filler = this[property + 'Color'], vpt = this.viewportTransform, finalWidth = this.width,
	          finalHeight = this.height;
	      if (!filler) {
	        return;
	      }
	      if (filler.toLive) {
	        var repeat = filler.repeat, iVpt = fabric.util.invertTransform(vpt), shouldInvert = this[property + 'Vpt'],
	            additionalTransform = shouldInvert ? fabric.util.matrixToSVG(iVpt) : '';
	        markup.push(
	          '<rect transform="' + additionalTransform + ' translate(', finalWidth / 2, ',', finalHeight / 2, ')"',
	          ' x="', filler.offsetX - finalWidth / 2,
	          '" y="', filler.offsetY - finalHeight / 2, '" ',
	          'width="',
	          (repeat === 'repeat-y' || repeat === 'no-repeat'
	            ? filler.source.width
	            : finalWidth ),
	          '" height="',
	          (repeat === 'repeat-x' || repeat === 'no-repeat'
	            ? filler.source.height
	            : finalHeight),
	          '" fill="url(#SVGID_' + filler.id + ')"',
	          '></rect>\n'
	        );
	      }
	      else {
	        markup.push(
	          '<rect x="0" y="0" width="100%" height="100%" ',
	          'fill="', filler, '"',
	          '></rect>\n'
	        );
	      }
	    },
	    /* _TO_SVG_END_ */

	    /**
	     * Moves an object or the objects of a multiple selection
	     * to the bottom of the stack of drawn objects
	     * @param {fabric.Object} object Object to send to back
	     * @return {fabric.Canvas} thisArg
	     * @chainable
	     */
	    sendToBack: function (object) {
	      if (!object) {
	        return this;
	      }
	      var activeSelection = this._activeObject,
	          i, obj, objs;
	      if (object === activeSelection && object.type === 'activeSelection') {
	        objs = activeSelection._objects;
	        for (i = objs.length; i--;) {
	          obj = objs[i];
	          removeFromArray(this._objects, obj);
	          this._objects.unshift(obj);
	        }
	      }
	      else {
	        removeFromArray(this._objects, object);
	        this._objects.unshift(object);
	      }
	      this.renderOnAddRemove && this.requestRenderAll();
	      return this;
	    },

	    /**
	     * Moves an object or the objects of a multiple selection
	     * to the top of the stack of drawn objects
	     * @param {fabric.Object} object Object to send
	     * @return {fabric.Canvas} thisArg
	     * @chainable
	     */
	    bringToFront: function (object) {
	      if (!object) {
	        return this;
	      }
	      var activeSelection = this._activeObject,
	          i, obj, objs;
	      if (object === activeSelection && object.type === 'activeSelection') {
	        objs = activeSelection._objects;
	        for (i = 0; i < objs.length; i++) {
	          obj = objs[i];
	          removeFromArray(this._objects, obj);
	          this._objects.push(obj);
	        }
	      }
	      else {
	        removeFromArray(this._objects, object);
	        this._objects.push(object);
	      }
	      this.renderOnAddRemove && this.requestRenderAll();
	      return this;
	    },

	    /**
	     * Moves an object or a selection down in stack of drawn objects
	     * An optional parameter, intersecting allows to move the object in behind
	     * the first intersecting object. Where intersection is calculated with
	     * bounding box. If no intersection is found, there will not be change in the
	     * stack.
	     * @param {fabric.Object} object Object to send
	     * @param {Boolean} [intersecting] If `true`, send object behind next lower intersecting object
	     * @return {fabric.Canvas} thisArg
	     * @chainable
	     */
	    sendBackwards: function (object, intersecting) {
	      if (!object) {
	        return this;
	      }
	      var activeSelection = this._activeObject,
	          i, obj, idx, newIdx, objs, objsMoved = 0;

	      if (object === activeSelection && object.type === 'activeSelection') {
	        objs = activeSelection._objects;
	        for (i = 0; i < objs.length; i++) {
	          obj = objs[i];
	          idx = this._objects.indexOf(obj);
	          if (idx > 0 + objsMoved) {
	            newIdx = idx - 1;
	            removeFromArray(this._objects, obj);
	            this._objects.splice(newIdx, 0, obj);
	          }
	          objsMoved++;
	        }
	      }
	      else {
	        idx = this._objects.indexOf(object);
	        if (idx !== 0) {
	          // if object is not on the bottom of stack
	          newIdx = this._findNewLowerIndex(object, idx, intersecting);
	          removeFromArray(this._objects, object);
	          this._objects.splice(newIdx, 0, object);
	        }
	      }
	      this.renderOnAddRemove && this.requestRenderAll();
	      return this;
	    },

	    /**
	     * @private
	     */
	    _findNewLowerIndex: function(object, idx, intersecting) {
	      var newIdx, i;

	      if (intersecting) {
	        newIdx = idx;

	        // traverse down the stack looking for the nearest intersecting object
	        for (i = idx - 1; i >= 0; --i) {

	          var isIntersecting = object.intersectsWithObject(this._objects[i]) ||
	                               object.isContainedWithinObject(this._objects[i]) ||
	                               this._objects[i].isContainedWithinObject(object);

	          if (isIntersecting) {
	            newIdx = i;
	            break;
	          }
	        }
	      }
	      else {
	        newIdx = idx - 1;
	      }

	      return newIdx;
	    },

	    /**
	     * Moves an object or a selection up in stack of drawn objects
	     * An optional parameter, intersecting allows to move the object in front
	     * of the first intersecting object. Where intersection is calculated with
	     * bounding box. If no intersection is found, there will not be change in the
	     * stack.
	     * @param {fabric.Object} object Object to send
	     * @param {Boolean} [intersecting] If `true`, send object in front of next upper intersecting object
	     * @return {fabric.Canvas} thisArg
	     * @chainable
	     */
	    bringForward: function (object, intersecting) {
	      if (!object) {
	        return this;
	      }
	      var activeSelection = this._activeObject,
	          i, obj, idx, newIdx, objs, objsMoved = 0;

	      if (object === activeSelection && object.type === 'activeSelection') {
	        objs = activeSelection._objects;
	        for (i = objs.length; i--;) {
	          obj = objs[i];
	          idx = this._objects.indexOf(obj);
	          if (idx < this._objects.length - 1 - objsMoved) {
	            newIdx = idx + 1;
	            removeFromArray(this._objects, obj);
	            this._objects.splice(newIdx, 0, obj);
	          }
	          objsMoved++;
	        }
	      }
	      else {
	        idx = this._objects.indexOf(object);
	        if (idx !== this._objects.length - 1) {
	          // if object is not on top of stack (last item in an array)
	          newIdx = this._findNewUpperIndex(object, idx, intersecting);
	          removeFromArray(this._objects, object);
	          this._objects.splice(newIdx, 0, object);
	        }
	      }
	      this.renderOnAddRemove && this.requestRenderAll();
	      return this;
	    },

	    /**
	     * @private
	     */
	    _findNewUpperIndex: function(object, idx, intersecting) {
	      var newIdx, i, len;

	      if (intersecting) {
	        newIdx = idx;

	        // traverse up the stack looking for the nearest intersecting object
	        for (i = idx + 1, len = this._objects.length; i < len; ++i) {

	          var isIntersecting = object.intersectsWithObject(this._objects[i]) ||
	                               object.isContainedWithinObject(this._objects[i]) ||
	                               this._objects[i].isContainedWithinObject(object);

	          if (isIntersecting) {
	            newIdx = i;
	            break;
	          }
	        }
	      }
	      else {
	        newIdx = idx + 1;
	      }

	      return newIdx;
	    },

	    /**
	     * Moves an object to specified level in stack of drawn objects
	     * @param {fabric.Object} object Object to send
	     * @param {Number} index Position to move to
	     * @return {fabric.Canvas} thisArg
	     * @chainable
	     */
	    moveTo: function (object, index) {
	      removeFromArray(this._objects, object);
	      this._objects.splice(index, 0, object);
	      return this.renderOnAddRemove && this.requestRenderAll();
	    },

	    /**
	     * Clears a canvas element and dispose objects
	     * @return {fabric.Canvas} thisArg
	     * @chainable
	     */
	    dispose: function () {
	      // cancel eventually ongoing renders
	      if (this.isRendering) {
	        fabric.util.cancelAnimFrame(this.isRendering);
	        this.isRendering = 0;
	      }
	      this.forEachObject(function(object) {
	        object.dispose && object.dispose();
	      });
	      this._objects = [];
	      if (this.backgroundImage && this.backgroundImage.dispose) {
	        this.backgroundImage.dispose();
	      }
	      this.backgroundImage = null;
	      if (this.overlayImage && this.overlayImage.dispose) {
	        this.overlayImage.dispose();
	      }
	      this.overlayImage = null;
	      this._iTextInstances = null;
	      this.contextContainer = null;
	      // restore canvas style
	      this.lowerCanvasEl.classList.remove('lower-canvas');
	      this.lowerCanvasEl.style = this._originalCanvasStyle;
	      delete this._originalCanvasStyle;
	      // restore canvas size to original size in case retina scaling was applied
	      this.lowerCanvasEl.setAttribute('width', this.width);
	      this.lowerCanvasEl.setAttribute('height', this.height);
	      fabric.util.cleanUpJsdomNode(this.lowerCanvasEl);
	      this.lowerCanvasEl = undefined;
	      return this;
	    },

	    /**
	     * Returns a string representation of an instance
	     * @return {String} string representation of an instance
	     */
	    toString: function () {
	      return '#<fabric.Canvas (' + this.complexity() + '): ' +
	               '{ objects: ' + this._objects.length + ' }>';
	    }
	  });

	  extend(fabric.StaticCanvas.prototype, fabric.Observable);
	  extend(fabric.StaticCanvas.prototype, fabric.Collection);
	  extend(fabric.StaticCanvas.prototype, fabric.DataURLExporter);

	  extend(fabric.StaticCanvas, /** @lends fabric.StaticCanvas */ {

	    /**
	     * @static
	     * @type String
	     * @default
	     */
	    EMPTY_JSON: '{"objects": [], "background": "white"}',

	    /**
	     * Provides a way to check support of some of the canvas methods
	     * (either those of HTMLCanvasElement itself, or rendering context)
	     *
	     * @param {String} methodName Method to check support for;
	     *                            Could be one of "setLineDash"
	     * @return {Boolean | null} `true` if method is supported (or at least exists),
	     *                          `null` if canvas element or context can not be initialized
	     */
	    supports: function (methodName) {
	      var el = createCanvasElement();

	      if (!el || !el.getContext) {
	        return null;
	      }

	      var ctx = el.getContext('2d');
	      if (!ctx) {
	        return null;
	      }

	      switch (methodName) {

	        case 'setLineDash':
	          return typeof ctx.setLineDash !== 'undefined';

	        default:
	          return null;
	      }
	    }
	  });

	  /**
	   * Returns Object representation of canvas
	   * this alias is provided because if you call JSON.stringify on an instance,
	   * the toJSON object will be invoked if it exists.
	   * Having a toJSON method means you can do JSON.stringify(myCanvas)
	   * @function
	   * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
	   * @return {Object} JSON compatible object
	   * @tutorial {@link http://fabricjs.com/fabric-intro-part-3#serialization}
	   * @see {@link http://jsfiddle.net/fabricjs/pec86/|jsFiddle demo}
	   * @example <caption>JSON without additional properties</caption>
	   * var json = canvas.toJSON();
	   * @example <caption>JSON with additional properties included</caption>
	   * var json = canvas.toJSON(['lockMovementX', 'lockMovementY', 'lockRotation', 'lockScalingX', 'lockScalingY']);
	   * @example <caption>JSON without default values</caption>
	   * canvas.includeDefaultValues = false;
	   * var json = canvas.toJSON();
	   */
	  fabric.StaticCanvas.prototype.toJSON = fabric.StaticCanvas.prototype.toObject;

	  if (fabric.isLikelyNode) {
	    fabric.StaticCanvas.prototype.createPNGStream = function() {
	      var impl = getNodeCanvas(this.lowerCanvasEl);
	      return impl && impl.createPNGStream();
	    };
	    fabric.StaticCanvas.prototype.createJPEGStream = function(opts) {
	      var impl = getNodeCanvas(this.lowerCanvasEl);
	      return impl && impl.createJPEGStream(opts);
	    };
	  }
	})();


	/**
	 * BaseBrush class
	 * @class fabric.BaseBrush
	 * @see {@link http://fabricjs.com/freedrawing|Freedrawing demo}
	 */
	fabric.BaseBrush = fabric.util.createClass(/** @lends fabric.BaseBrush.prototype */ {

	  /**
	   * Color of a brush
	   * @type String
	   * @default
	   */
	  color: 'rgb(0, 0, 0)',

	  /**
	   * Width of a brush, has to be a Number, no string literals
	   * @type Number
	   * @default
	   */
	  width: 1,

	  /**
	   * Shadow object representing shadow of this shape.
	   * <b>Backwards incompatibility note:</b> This property replaces "shadowColor" (String), "shadowOffsetX" (Number),
	   * "shadowOffsetY" (Number) and "shadowBlur" (Number) since v1.2.12
	   * @type fabric.Shadow
	   * @default
	   */
	  shadow: null,

	  /**
	   * Line endings style of a brush (one of "butt", "round", "square")
	   * @type String
	   * @default
	   */
	  strokeLineCap: 'round',

	  /**
	   * Corner style of a brush (one of "bevel", "round", "miter")
	   * @type String
	   * @default
	   */
	  strokeLineJoin: 'round',

	  /**
	   * Maximum miter length (used for strokeLineJoin = "miter") of a brush's
	   * @type Number
	   * @default
	   */
	  strokeMiterLimit:         10,

	  /**
	   * Stroke Dash Array.
	   * @type Array
	   * @default
	   */
	  strokeDashArray: null,

	  /**
	   * When `true`, the free drawing is limited to the whiteboard size. Default to false.
	   * @type Boolean
	   * @default false
	  */

	  limitedToCanvasSize: false,


	  /**
	   * Sets brush styles
	   * @private
	   */
	  _setBrushStyles: function() {
	    var ctx = this.canvas.contextTop;
	    ctx.strokeStyle = this.color;
	    ctx.lineWidth = this.width;
	    ctx.lineCap = this.strokeLineCap;
	    ctx.miterLimit = this.strokeMiterLimit;
	    ctx.lineJoin = this.strokeLineJoin;
	    ctx.setLineDash(this.strokeDashArray || []);
	  },

	  /**
	   * Sets the transformation on given context
	   * @param {RenderingContext2d} ctx context to render on
	   * @private
	   */
	  _saveAndTransform: function(ctx) {
	    var v = this.canvas.viewportTransform;
	    ctx.save();
	    ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
	  },

	  /**
	   * Sets brush shadow styles
	   * @private
	   */
	  _setShadow: function() {
	    if (!this.shadow) {
	      return;
	    }

	    var canvas = this.canvas,
	        shadow = this.shadow,
	        ctx = canvas.contextTop,
	        zoom = canvas.getZoom();
	    if (canvas && canvas._isRetinaScaling()) {
	      zoom *= fabric.devicePixelRatio;
	    }

	    ctx.shadowColor = shadow.color;
	    ctx.shadowBlur = shadow.blur * zoom;
	    ctx.shadowOffsetX = shadow.offsetX * zoom;
	    ctx.shadowOffsetY = shadow.offsetY * zoom;
	  },

	  needsFullRender: function() {
	    var color = new fabric.Color(this.color);
	    return color.getAlpha() < 1 || !!this.shadow;
	  },

	  /**
	   * Removes brush shadow styles
	   * @private
	   */
	  _resetShadow: function() {
	    var ctx = this.canvas.contextTop;

	    ctx.shadowColor = '';
	    ctx.shadowBlur = ctx.shadowOffsetX = ctx.shadowOffsetY = 0;
	  },

	  /**
	   * Check is pointer is outside canvas boundaries
	   * @param {Object} pointer
	   * @private
	  */
	  _isOutSideCanvas: function(pointer) {
	    return pointer.x < 0 || pointer.x > this.canvas.getWidth() || pointer.y < 0 || pointer.y > this.canvas.getHeight();
	  }
	});


	(function() {
	  /**
	   * PencilBrush class
	   * @class fabric.PencilBrush
	   * @extends fabric.BaseBrush
	   */
	  fabric.PencilBrush = fabric.util.createClass(fabric.BaseBrush, /** @lends fabric.PencilBrush.prototype */ {

	    /**
	     * Discard points that are less than `decimate` pixel distant from each other
	     * @type Number
	     * @default 0.4
	     */
	    decimate: 0.4,

	    /**
	     * Constructor
	     * @param {fabric.Canvas} canvas
	     * @return {fabric.PencilBrush} Instance of a pencil brush
	     */
	    initialize: function(canvas) {
	      this.canvas = canvas;
	      this._points = [];
	    },

	    /**
	     * Invoked inside on mouse down and mouse move
	     * @param {Object} pointer
	     */
	    _drawSegment: function (ctx, p1, p2) {
	      var midPoint = p1.midPointFrom(p2);
	      ctx.quadraticCurveTo(p1.x, p1.y, midPoint.x, midPoint.y);
	      return midPoint;
	    },

	    /**
	     * Invoked on mouse down
	     * @param {Object} pointer
	     */
	    onMouseDown: function(pointer, options) {
	      if (!this.canvas._isMainEvent(options.e)) {
	        return;
	      }
	      this._prepareForDrawing(pointer);
	      // capture coordinates immediately
	      // this allows to draw dots (when movement never occurs)
	      this._captureDrawingPath(pointer);
	      this._render();
	    },

	    /**
	     * Invoked on mouse move
	     * @param {Object} pointer
	     */
	    onMouseMove: function(pointer, options) {
	      if (!this.canvas._isMainEvent(options.e)) {
	        return;
	      }
	      if (this.limitedToCanvasSize === true && this._isOutSideCanvas(pointer)) {
	        return;
	      }
	      if (this._captureDrawingPath(pointer) && this._points.length > 1) {
	        if (this.needsFullRender()) {
	          // redraw curve
	          // clear top canvas
	          this.canvas.clearContext(this.canvas.contextTop);
	          this._render();
	        }
	        else {
	          var points = this._points, length = points.length, ctx = this.canvas.contextTop;
	          // draw the curve update
	          this._saveAndTransform(ctx);
	          if (this.oldEnd) {
	            ctx.beginPath();
	            ctx.moveTo(this.oldEnd.x, this.oldEnd.y);
	          }
	          this.oldEnd = this._drawSegment(ctx, points[length - 2], points[length - 1], true);
	          ctx.stroke();
	          ctx.restore();
	        }
	      }
	    },

	    /**
	     * Invoked on mouse up
	     */
	    onMouseUp: function(options) {
	      if (!this.canvas._isMainEvent(options.e)) {
	        return true;
	      }
	      this.oldEnd = undefined;
	      this._finalizeAndAddPath();
	      return false;
	    },

	    /**
	     * @private
	     * @param {Object} pointer Actual mouse position related to the canvas.
	     */
	    _prepareForDrawing: function(pointer) {

	      var p = new fabric.Point(pointer.x, pointer.y);

	      this._reset();
	      this._addPoint(p);
	      this.canvas.contextTop.moveTo(p.x, p.y);
	    },

	    /**
	     * @private
	     * @param {fabric.Point} point Point to be added to points array
	     */
	    _addPoint: function(point) {
	      if (this._points.length > 1 && point.eq(this._points[this._points.length - 1])) {
	        return false;
	      }
	      this._points.push(point);
	      return true;
	    },

	    /**
	     * Clear points array and set contextTop canvas style.
	     * @private
	     */
	    _reset: function() {
	      this._points = [];
	      this._setBrushStyles();
	      this._setShadow();
	    },

	    /**
	     * @private
	     * @param {Object} pointer Actual mouse position related to the canvas.
	     */
	    _captureDrawingPath: function(pointer) {
	      var pointerPoint = new fabric.Point(pointer.x, pointer.y);
	      return this._addPoint(pointerPoint);
	    },

	    /**
	     * Draw a smooth path on the topCanvas using quadraticCurveTo
	     * @private
	     */
	    _render: function() {
	      var ctx  = this.canvas.contextTop, i, len,
	          p1 = this._points[0],
	          p2 = this._points[1];

	      this._saveAndTransform(ctx);
	      ctx.beginPath();
	      //if we only have 2 points in the path and they are the same
	      //it means that the user only clicked the canvas without moving the mouse
	      //then we should be drawing a dot. A path isn't drawn between two identical dots
	      //that's why we set them apart a bit
	      if (this._points.length === 2 && p1.x === p2.x && p1.y === p2.y) {
	        var width = this.width / 1000;
	        p1 = new fabric.Point(p1.x, p1.y);
	        p2 = new fabric.Point(p2.x, p2.y);
	        p1.x -= width;
	        p2.x += width;
	      }
	      ctx.moveTo(p1.x, p1.y);

	      for (i = 1, len = this._points.length; i < len; i++) {
	        // we pick the point between pi + 1 & pi + 2 as the
	        // end point and p1 as our control point.
	        this._drawSegment(ctx, p1, p2);
	        p1 = this._points[i];
	        p2 = this._points[i + 1];
	      }
	      // Draw last line as a straight line while
	      // we wait for the next point to be able to calculate
	      // the bezier control point
	      ctx.lineTo(p1.x, p1.y);
	      ctx.stroke();
	      ctx.restore();
	    },

	    /**
	     * Converts points to SVG path
	     * @param {Array} points Array of points
	     * @return {(string|number)[][]} SVG path commands
	     */
	    convertPointsToSVGPath: function (points) {
	      var correction = this.width / 1000;
	      return fabric.util.getSmoothPathFromPoints(points, correction);
	    },

	    /**
	     * @private
	     * @param {(string|number)[][]} pathData SVG path commands
	     * @returns {boolean}
	     */
	    _isEmptySVGPath: function (pathData) {
	      var pathString = fabric.util.joinPath(pathData);
	      return pathString === 'M 0 0 Q 0 0 0 0 L 0 0';
	    },

	    /**
	     * Creates fabric.Path object to add on canvas
	     * @param {(string|number)[][]} pathData Path data
	     * @return {fabric.Path} Path to add on canvas
	     */
	    createPath: function(pathData) {
	      var path = new fabric.Path(pathData, {
	        fill: null,
	        stroke: this.color,
	        strokeWidth: this.width,
	        strokeLineCap: this.strokeLineCap,
	        strokeMiterLimit: this.strokeMiterLimit,
	        strokeLineJoin: this.strokeLineJoin,
	        strokeDashArray: this.strokeDashArray,
	      });
	      if (this.shadow) {
	        this.shadow.affectStroke = true;
	        path.shadow = new fabric.Shadow(this.shadow);
	      }

	      return path;
	    },

	    /**
	     * Decimate points array with the decimate value
	     */
	    decimatePoints: function(points, distance) {
	      if (points.length <= 2) {
	        return points;
	      }
	      var zoom = this.canvas.getZoom(), adjustedDistance = Math.pow(distance / zoom, 2),
	          i, l = points.length - 1, lastPoint = points[0], newPoints = [lastPoint],
	          cDistance;
	      for (i = 1; i < l - 1; i++) {
	        cDistance = Math.pow(lastPoint.x - points[i].x, 2) + Math.pow(lastPoint.y - points[i].y, 2);
	        if (cDistance >= adjustedDistance) {
	          lastPoint = points[i];
	          newPoints.push(lastPoint);
	        }
	      }
	      /**
	       * Add the last point from the original line to the end of the array.
	       * This ensures decimate doesn't delete the last point on the line, and ensures the line is > 1 point.
	       */
	      newPoints.push(points[l]);
	      return newPoints;
	    },

	    /**
	     * On mouseup after drawing the path on contextTop canvas
	     * we use the points captured to create an new fabric path object
	     * and add it to the fabric canvas.
	     */
	    _finalizeAndAddPath: function() {
	      var ctx = this.canvas.contextTop;
	      ctx.closePath();
	      if (this.decimate) {
	        this._points = this.decimatePoints(this._points, this.decimate);
	      }
	      var pathData = this.convertPointsToSVGPath(this._points);
	      if (this._isEmptySVGPath(pathData)) {
	        // do not create 0 width/height paths, as they are
	        // rendered inconsistently across browsers
	        // Firefox 4, for example, renders a dot,
	        // whereas Chrome 10 renders nothing
	        this.canvas.requestRenderAll();
	        return;
	      }

	      var path = this.createPath(pathData);
	      this.canvas.clearContext(this.canvas.contextTop);
	      this.canvas.fire('before:path:created', { path: path });
	      this.canvas.add(path);
	      this.canvas.requestRenderAll();
	      path.setCoords();
	      this._resetShadow();


	      // fire event 'path' created
	      this.canvas.fire('path:created', { path: path });
	    }
	  });
	})();


	/**
	 * CircleBrush class
	 * @class fabric.CircleBrush
	 */
	fabric.CircleBrush = fabric.util.createClass(fabric.BaseBrush, /** @lends fabric.CircleBrush.prototype */ {

	  /**
	   * Width of a brush
	   * @type Number
	   * @default
	   */
	  width: 10,

	  /**
	   * Constructor
	   * @param {fabric.Canvas} canvas
	   * @return {fabric.CircleBrush} Instance of a circle brush
	   */
	  initialize: function(canvas) {
	    this.canvas = canvas;
	    this.points = [];
	  },

	  /**
	   * Invoked inside on mouse down and mouse move
	   * @param {Object} pointer
	   */
	  drawDot: function(pointer) {
	    var point = this.addPoint(pointer),
	        ctx = this.canvas.contextTop;
	    this._saveAndTransform(ctx);
	    this.dot(ctx, point);
	    ctx.restore();
	  },

	  dot: function(ctx, point) {
	    ctx.fillStyle = point.fill;
	    ctx.beginPath();
	    ctx.arc(point.x, point.y, point.radius, 0, Math.PI * 2, false);
	    ctx.closePath();
	    ctx.fill();
	  },

	  /**
	   * Invoked on mouse down
	   */
	  onMouseDown: function(pointer) {
	    this.points.length = 0;
	    this.canvas.clearContext(this.canvas.contextTop);
	    this._setShadow();
	    this.drawDot(pointer);
	  },

	  /**
	   * Render the full state of the brush
	   * @private
	   */
	  _render: function() {
	    var ctx  = this.canvas.contextTop, i, len,
	        points = this.points;
	    this._saveAndTransform(ctx);
	    for (i = 0, len = points.length; i < len; i++) {
	      this.dot(ctx, points[i]);
	    }
	    ctx.restore();
	  },

	  /**
	   * Invoked on mouse move
	   * @param {Object} pointer
	   */
	  onMouseMove: function(pointer) {
	    if (this.limitedToCanvasSize === true && this._isOutSideCanvas(pointer)) {
	      return;
	    }
	    if (this.needsFullRender()) {
	      this.canvas.clearContext(this.canvas.contextTop);
	      this.addPoint(pointer);
	      this._render();
	    }
	    else {
	      this.drawDot(pointer);
	    }
	  },

	  /**
	   * Invoked on mouse up
	   */
	  onMouseUp: function() {
	    var originalRenderOnAddRemove = this.canvas.renderOnAddRemove, i, len;
	    this.canvas.renderOnAddRemove = false;

	    var circles = [];

	    for (i = 0, len = this.points.length; i < len; i++) {
	      var point = this.points[i],
	          circle = new fabric.Circle({
	            radius: point.radius,
	            left: point.x,
	            top: point.y,
	            originX: 'center',
	            originY: 'center',
	            fill: point.fill
	          });

	      this.shadow && (circle.shadow = new fabric.Shadow(this.shadow));

	      circles.push(circle);
	    }
	    var group = new fabric.Group(circles);
	    group.canvas = this.canvas;

	    this.canvas.fire('before:path:created', { path: group });
	    this.canvas.add(group);
	    this.canvas.fire('path:created', { path: group });

	    this.canvas.clearContext(this.canvas.contextTop);
	    this._resetShadow();
	    this.canvas.renderOnAddRemove = originalRenderOnAddRemove;
	    this.canvas.requestRenderAll();
	  },

	  /**
	   * @param {Object} pointer
	   * @return {fabric.Point} Just added pointer point
	   */
	  addPoint: function(pointer) {
	    var pointerPoint = new fabric.Point(pointer.x, pointer.y),

	        circleRadius = fabric.util.getRandomInt(
	          Math.max(0, this.width - 20), this.width + 20) / 2,

	        circleColor = new fabric.Color(this.color)
	          .setAlpha(fabric.util.getRandomInt(0, 100) / 100)
	          .toRgba();

	    pointerPoint.radius = circleRadius;
	    pointerPoint.fill = circleColor;

	    this.points.push(pointerPoint);

	    return pointerPoint;
	  }
	});


	/**
	 * SprayBrush class
	 * @class fabric.SprayBrush
	 */
	fabric.SprayBrush = fabric.util.createClass( fabric.BaseBrush, /** @lends fabric.SprayBrush.prototype */ {

	  /**
	   * Width of a spray
	   * @type Number
	   * @default
	   */
	  width:              10,

	  /**
	   * Density of a spray (number of dots per chunk)
	   * @type Number
	   * @default
	   */
	  density:            20,

	  /**
	   * Width of spray dots
	   * @type Number
	   * @default
	   */
	  dotWidth:           1,

	  /**
	   * Width variance of spray dots
	   * @type Number
	   * @default
	   */
	  dotWidthVariance:   1,

	  /**
	   * Whether opacity of a dot should be random
	   * @type Boolean
	   * @default
	   */
	  randomOpacity:        false,

	  /**
	   * Whether overlapping dots (rectangles) should be removed (for performance reasons)
	   * @type Boolean
	   * @default
	   */
	  optimizeOverlapping:  true,

	  /**
	   * Constructor
	   * @param {fabric.Canvas} canvas
	   * @return {fabric.SprayBrush} Instance of a spray brush
	   */
	  initialize: function(canvas) {
	    this.canvas = canvas;
	    this.sprayChunks = [];
	  },

	  /**
	   * Invoked on mouse down
	   * @param {Object} pointer
	   */
	  onMouseDown: function(pointer) {
	    this.sprayChunks.length = 0;
	    this.canvas.clearContext(this.canvas.contextTop);
	    this._setShadow();

	    this.addSprayChunk(pointer);
	    this.render(this.sprayChunkPoints);
	  },

	  /**
	   * Invoked on mouse move
	   * @param {Object} pointer
	   */
	  onMouseMove: function(pointer) {
	    if (this.limitedToCanvasSize === true && this._isOutSideCanvas(pointer)) {
	      return;
	    }
	    this.addSprayChunk(pointer);
	    this.render(this.sprayChunkPoints);
	  },

	  /**
	   * Invoked on mouse up
	   */
	  onMouseUp: function() {
	    var originalRenderOnAddRemove = this.canvas.renderOnAddRemove;
	    this.canvas.renderOnAddRemove = false;

	    var rects = [];

	    for (var i = 0, ilen = this.sprayChunks.length; i < ilen; i++) {
	      var sprayChunk = this.sprayChunks[i];

	      for (var j = 0, jlen = sprayChunk.length; j < jlen; j++) {

	        var rect = new fabric.Rect({
	          width: sprayChunk[j].width,
	          height: sprayChunk[j].width,
	          left: sprayChunk[j].x + 1,
	          top: sprayChunk[j].y + 1,
	          originX: 'center',
	          originY: 'center',
	          fill: this.color
	        });
	        rects.push(rect);
	      }
	    }

	    if (this.optimizeOverlapping) {
	      rects = this._getOptimizedRects(rects);
	    }

	    var group = new fabric.Group(rects);
	    this.shadow && group.set('shadow', new fabric.Shadow(this.shadow));
	    this.canvas.fire('before:path:created', { path: group });
	    this.canvas.add(group);
	    this.canvas.fire('path:created', { path: group });

	    this.canvas.clearContext(this.canvas.contextTop);
	    this._resetShadow();
	    this.canvas.renderOnAddRemove = originalRenderOnAddRemove;
	    this.canvas.requestRenderAll();
	  },

	  /**
	   * @private
	   * @param {Array} rects
	   */
	  _getOptimizedRects: function(rects) {

	    // avoid creating duplicate rects at the same coordinates
	    var uniqueRects = { }, key, i, len;

	    for (i = 0, len = rects.length; i < len; i++) {
	      key = rects[i].left + '' + rects[i].top;
	      if (!uniqueRects[key]) {
	        uniqueRects[key] = rects[i];
	      }
	    }
	    var uniqueRectsArray = [];
	    for (key in uniqueRects) {
	      uniqueRectsArray.push(uniqueRects[key]);
	    }

	    return uniqueRectsArray;
	  },

	  /**
	   * Render new chunk of spray brush
	   */
	  render: function(sprayChunk) {
	    var ctx = this.canvas.contextTop, i, len;
	    ctx.fillStyle = this.color;

	    this._saveAndTransform(ctx);

	    for (i = 0, len = sprayChunk.length; i < len; i++) {
	      var point = sprayChunk[i];
	      if (typeof point.opacity !== 'undefined') {
	        ctx.globalAlpha = point.opacity;
	      }
	      ctx.fillRect(point.x, point.y, point.width, point.width);
	    }
	    ctx.restore();
	  },

	  /**
	   * Render all spray chunks
	   */
	  _render: function() {
	    var ctx = this.canvas.contextTop, i, ilen;
	    ctx.fillStyle = this.color;

	    this._saveAndTransform(ctx);

	    for (i = 0, ilen = this.sprayChunks.length; i < ilen; i++) {
	      this.render(this.sprayChunks[i]);
	    }
	    ctx.restore();
	  },

	  /**
	   * @param {Object} pointer
	   */
	  addSprayChunk: function(pointer) {
	    this.sprayChunkPoints = [];

	    var x, y, width, radius = this.width / 2, i;

	    for (i = 0; i < this.density; i++) {

	      x = fabric.util.getRandomInt(pointer.x - radius, pointer.x + radius);
	      y = fabric.util.getRandomInt(pointer.y - radius, pointer.y + radius);

	      if (this.dotWidthVariance) {
	        width = fabric.util.getRandomInt(
	          // bottom clamp width to 1
	          Math.max(1, this.dotWidth - this.dotWidthVariance),
	          this.dotWidth + this.dotWidthVariance);
	      }
	      else {
	        width = this.dotWidth;
	      }

	      var point = new fabric.Point(x, y);
	      point.width = width;

	      if (this.randomOpacity) {
	        point.opacity = fabric.util.getRandomInt(0, 100) / 100;
	      }

	      this.sprayChunkPoints.push(point);
	    }

	    this.sprayChunks.push(this.sprayChunkPoints);
	  }
	});


	/**
	 * PatternBrush class
	 * @class fabric.PatternBrush
	 * @extends fabric.BaseBrush
	 */
	fabric.PatternBrush = fabric.util.createClass(fabric.PencilBrush, /** @lends fabric.PatternBrush.prototype */ {

	  getPatternSrc: function() {

	    var dotWidth = 20,
	        dotDistance = 5,
	        patternCanvas = fabric.util.createCanvasElement(),
	        patternCtx = patternCanvas.getContext('2d');

	    patternCanvas.width = patternCanvas.height = dotWidth + dotDistance;

	    patternCtx.fillStyle = this.color;
	    patternCtx.beginPath();
	    patternCtx.arc(dotWidth / 2, dotWidth / 2, dotWidth / 2, 0, Math.PI * 2, false);
	    patternCtx.closePath();
	    patternCtx.fill();

	    return patternCanvas;
	  },

	  getPatternSrcFunction: function() {
	    return String(this.getPatternSrc).replace('this.color', '"' + this.color + '"');
	  },

	  /**
	   * Creates "pattern" instance property
	   */
	  getPattern: function() {
	    return this.canvas.contextTop.createPattern(this.source || this.getPatternSrc(), 'repeat');
	  },

	  /**
	   * Sets brush styles
	   */
	  _setBrushStyles: function() {
	    this.callSuper('_setBrushStyles');
	    this.canvas.contextTop.strokeStyle = this.getPattern();
	  },

	  /**
	   * Creates path
	   */
	  createPath: function(pathData) {
	    var path = this.callSuper('createPath', pathData),
	        topLeft = path._getLeftTopCoords().scalarAdd(path.strokeWidth / 2);

	    path.stroke = new fabric.Pattern({
	      source: this.source || this.getPatternSrcFunction(),
	      offsetX: -topLeft.x,
	      offsetY: -topLeft.y
	    });
	    return path;
	  }
	});


	(function() {

	  var getPointer = fabric.util.getPointer,
	      degreesToRadians = fabric.util.degreesToRadians,
	      isTouchEvent = fabric.util.isTouchEvent;

	  /**
	   * Canvas class
	   * @class fabric.Canvas
	   * @extends fabric.StaticCanvas
	   * @tutorial {@link http://fabricjs.com/fabric-intro-part-1#canvas}
	   * @see {@link fabric.Canvas#initialize} for constructor definition
	   *
	   * @fires object:modified at the end of a transform or any change when statefull is true
	   * @fires object:rotating while an object is being rotated from the control
	   * @fires object:scaling while an object is being scaled by controls
	   * @fires object:moving while an object is being dragged
	   * @fires object:skewing while an object is being skewed from the controls
	   *
	   * @fires before:transform before a transform is is started
	   * @fires before:selection:cleared
	   * @fires selection:cleared
	   * @fires selection:updated
	   * @fires selection:created
	   *
	   * @fires path:created after a drawing operation ends and the path is added
	   * @fires mouse:down
	   * @fires mouse:move
	   * @fires mouse:up
	   * @fires mouse:down:before  on mouse down, before the inner fabric logic runs
	   * @fires mouse:move:before on mouse move, before the inner fabric logic runs
	   * @fires mouse:up:before on mouse up, before the inner fabric logic runs
	   * @fires mouse:over
	   * @fires mouse:out
	   * @fires mouse:dblclick whenever a native dbl click event fires on the canvas.
	   *
	   * @fires dragover
	   * @fires dragenter
	   * @fires dragleave
	   * @fires drop
	   * @fires after:render at the end of the render process, receives the context in the callback
	   * @fires before:render at start the render process, receives the context in the callback
	   *
	   * the following events are deprecated:
	   * @fires object:rotated at the end of a rotation transform
	   * @fires object:scaled at the end of a scale transform
	   * @fires object:moved at the end of translation transform
	   * @fires object:skewed at the end of a skew transform
	   */
	  fabric.Canvas = fabric.util.createClass(fabric.StaticCanvas, /** @lends fabric.Canvas.prototype */ {

	    /**
	     * Constructor
	     * @param {HTMLElement | String} el &lt;canvas> element to initialize instance on
	     * @param {Object} [options] Options object
	     * @return {Object} thisArg
	     */
	    initialize: function(el, options) {
	      options || (options = { });
	      this.renderAndResetBound = this.renderAndReset.bind(this);
	      this.requestRenderAllBound = this.requestRenderAll.bind(this);
	      this._initStatic(el, options);
	      this._initInteractive();
	      this._createCacheCanvas();
	    },

	    /**
	     * When true, objects can be transformed by one side (unproportionally)
	     * when dragged on the corners that normally would not do that.
	     * @type Boolean
	     * @default
	     * @since fabric 4.0 // changed name and default value
	     */
	    uniformScaling:      true,

	    /**
	     * Indicates which key switches uniform scaling.
	     * values: 'altKey', 'shiftKey', 'ctrlKey'.
	     * If `null` or 'none' or any other string that is not a modifier key
	     * feature is disabled.
	     * totally wrong named. this sounds like `uniform scaling`
	     * if Canvas.uniformScaling is true, pressing this will set it to false
	     * and viceversa.
	     * @since 1.6.2
	     * @type String
	     * @default
	     */
	    uniScaleKey:           'shiftKey',

	    /**
	     * When true, objects use center point as the origin of scale transformation.
	     * <b>Backwards incompatibility note:</b> This property replaces "centerTransform" (Boolean).
	     * @since 1.3.4
	     * @type Boolean
	     * @default
	     */
	    centeredScaling:        false,

	    /**
	     * When true, objects use center point as the origin of rotate transformation.
	     * <b>Backwards incompatibility note:</b> This property replaces "centerTransform" (Boolean).
	     * @since 1.3.4
	     * @type Boolean
	     * @default
	     */
	    centeredRotation:       false,

	    /**
	     * Indicates which key enable centered Transform
	     * values: 'altKey', 'shiftKey', 'ctrlKey'.
	     * If `null` or 'none' or any other string that is not a modifier key
	     * feature is disabled feature disabled.
	     * @since 1.6.2
	     * @type String
	     * @default
	     */
	    centeredKey:           'altKey',

	    /**
	     * Indicates which key enable alternate action on corner
	     * values: 'altKey', 'shiftKey', 'ctrlKey'.
	     * If `null` or 'none' or any other string that is not a modifier key
	     * feature is disabled feature disabled.
	     * @since 1.6.2
	     * @type String
	     * @default
	     */
	    altActionKey:           'shiftKey',

	    /**
	     * Indicates that canvas is interactive. This property should not be changed.
	     * @type Boolean
	     * @default
	     */
	    interactive:            true,

	    /**
	     * Indicates whether group selection should be enabled
	     * @type Boolean
	     * @default
	     */
	    selection:              true,

	    /**
	     * Indicates which key or keys enable multiple click selection
	     * Pass value as a string or array of strings
	     * values: 'altKey', 'shiftKey', 'ctrlKey'.
	     * If `null` or empty or containing any other string that is not a modifier key
	     * feature is disabled.
	     * @since 1.6.2
	     * @type String|Array
	     * @default
	     */
	    selectionKey:           'shiftKey',

	    /**
	     * Indicates which key enable alternative selection
	     * in case of target overlapping with active object
	     * values: 'altKey', 'shiftKey', 'ctrlKey'.
	     * For a series of reason that come from the general expectations on how
	     * things should work, this feature works only for preserveObjectStacking true.
	     * If `null` or 'none' or any other string that is not a modifier key
	     * feature is disabled.
	     * @since 1.6.5
	     * @type null|String
	     * @default
	     */
	    altSelectionKey:           null,

	    /**
	     * Color of selection
	     * @type String
	     * @default
	     */
	    selectionColor:         'rgba(100, 100, 255, 0.3)', // blue

	    /**
	     * Default dash array pattern
	     * If not empty the selection border is dashed
	     * @type Array
	     */
	    selectionDashArray:     [],

	    /**
	     * Color of the border of selection (usually slightly darker than color of selection itself)
	     * @type String
	     * @default
	     */
	    selectionBorderColor:   'rgba(255, 255, 255, 0.3)',

	    /**
	     * Width of a line used in object/group selection
	     * @type Number
	     * @default
	     */
	    selectionLineWidth:     1,

	    /**
	     * Select only shapes that are fully contained in the dragged selection rectangle.
	     * @type Boolean
	     * @default
	     */
	    selectionFullyContained: false,

	    /**
	     * Default cursor value used when hovering over an object on canvas
	     * @type String
	     * @default
	     */
	    hoverCursor:            'move',

	    /**
	     * Default cursor value used when moving an object on canvas
	     * @type String
	     * @default
	     */
	    moveCursor:             'move',

	    /**
	     * Default cursor value used for the entire canvas
	     * @type String
	     * @default
	     */
	    defaultCursor:          'default',

	    /**
	     * Cursor value used during free drawing
	     * @type String
	     * @default
	     */
	    freeDrawingCursor:      'crosshair',

	    /**
	     * Cursor value used for rotation point
	     * @type String
	     * @default
	     */
	    rotationCursor:         'crosshair',

	    /**
	     * Cursor value used for disabled elements ( corners with disabled action )
	     * @type String
	     * @since 2.0.0
	     * @default
	     */
	    notAllowedCursor:         'not-allowed',

	    /**
	     * Default element class that's given to wrapper (div) element of canvas
	     * @type String
	     * @default
	     */
	    containerClass:         'canvas-container',

	    /**
	     * When true, object detection happens on per-pixel basis rather than on per-bounding-box
	     * @type Boolean
	     * @default
	     */
	    perPixelTargetFind:     false,

	    /**
	     * Number of pixels around target pixel to tolerate (consider active) during object detection
	     * @type Number
	     * @default
	     */
	    targetFindTolerance:    0,

	    /**
	     * When true, target detection is skipped. Target detection will return always undefined.
	     * click selection won't work anymore, events will fire with no targets.
	     * if something is selected before setting it to true, it will be deselected at the first click.
	     * area selection will still work. check the `selection` property too.
	     * if you deactivate both, you should look into staticCanvas.
	     * @type Boolean
	     * @default
	     */
	    skipTargetFind:         false,

	    /**
	     * When true, mouse events on canvas (mousedown/mousemove/mouseup) result in free drawing.
	     * After mousedown, mousemove creates a shape,
	     * and then mouseup finalizes it and adds an instance of `fabric.Path` onto canvas.
	     * @tutorial {@link http://fabricjs.com/fabric-intro-part-4#free_drawing}
	     * @type Boolean
	     * @default
	     */
	    isDrawingMode:          false,

	    /**
	     * Indicates whether objects should remain in current stack position when selected.
	     * When false objects are brought to top and rendered as part of the selection group
	     * @type Boolean
	     * @default
	     */
	    preserveObjectStacking: false,

	    /**
	     * Indicates the angle that an object will lock to while rotating.
	     * @type Number
	     * @since 1.6.7
	     * @default
	     */
	    snapAngle: 0,

	    /**
	     * Indicates the distance from the snapAngle the rotation will lock to the snapAngle.
	     * When `null`, the snapThreshold will default to the snapAngle.
	     * @type null|Number
	     * @since 1.6.7
	     * @default
	     */
	    snapThreshold: null,

	    /**
	     * Indicates if the right click on canvas can output the context menu or not
	     * @type Boolean
	     * @since 1.6.5
	     * @default
	     */
	    stopContextMenu: false,

	    /**
	     * Indicates if the canvas can fire right click events
	     * @type Boolean
	     * @since 1.6.5
	     * @default
	     */
	    fireRightClick: false,

	    /**
	     * Indicates if the canvas can fire middle click events
	     * @type Boolean
	     * @since 1.7.8
	     * @default
	     */
	    fireMiddleClick: false,

	    /**
	     * Keep track of the subTargets for Mouse Events
	     * @type fabric.Object[]
	     */
	    targets: [],

	    /**
	     * Keep track of the hovered target
	     * @type fabric.Object
	     * @private
	     */
	    _hoveredTarget: null,

	    /**
	     * hold the list of nested targets hovered
	     * @type fabric.Object[]
	     * @private
	     */
	    _hoveredTargets: [],

	    /**
	     * @private
	     */
	    _initInteractive: function() {
	      this._currentTransform = null;
	      this._groupSelector = null;
	      this._initWrapperElement();
	      this._createUpperCanvas();
	      this._initEventListeners();

	      this._initRetinaScaling();

	      this.freeDrawingBrush = fabric.PencilBrush && new fabric.PencilBrush(this);

	      this.calcOffset();
	    },

	    /**
	     * Divides objects in two groups, one to render immediately
	     * and one to render as activeGroup.
	     * @return {Array} objects to render immediately and pushes the other in the activeGroup.
	     */
	    _chooseObjectsToRender: function() {
	      var activeObjects = this.getActiveObjects(),
	          object, objsToRender, activeGroupObjects;

	      if (activeObjects.length > 0 && !this.preserveObjectStacking) {
	        objsToRender = [];
	        activeGroupObjects = [];
	        for (var i = 0, length = this._objects.length; i < length; i++) {
	          object = this._objects[i];
	          if (activeObjects.indexOf(object) === -1 ) {
	            objsToRender.push(object);
	          }
	          else {
	            activeGroupObjects.push(object);
	          }
	        }
	        if (activeObjects.length > 1) {
	          this._activeObject._objects = activeGroupObjects;
	        }
	        objsToRender.push.apply(objsToRender, activeGroupObjects);
	      }
	      else {
	        objsToRender = this._objects;
	      }
	      return objsToRender;
	    },

	    /**
	     * Renders both the top canvas and the secondary container canvas.
	     * @return {fabric.Canvas} instance
	     * @chainable
	     */
	    renderAll: function () {
	      if (this.contextTopDirty && !this._groupSelector && !this.isDrawingMode) {
	        this.clearContext(this.contextTop);
	        this.contextTopDirty = false;
	      }
	      if (this.hasLostContext) {
	        this.renderTopLayer(this.contextTop);
	      }
	      var canvasToDrawOn = this.contextContainer;
	      this.renderCanvas(canvasToDrawOn, this._chooseObjectsToRender());
	      return this;
	    },

	    renderTopLayer: function(ctx) {
	      ctx.save();
	      if (this.isDrawingMode && this._isCurrentlyDrawing) {
	        this.freeDrawingBrush && this.freeDrawingBrush._render();
	        this.contextTopDirty = true;
	      }
	      // we render the top context - last object
	      if (this.selection && this._groupSelector) {
	        this._drawSelection(ctx);
	        this.contextTopDirty = true;
	      }
	      ctx.restore();
	    },

	    /**
	     * Method to render only the top canvas.
	     * Also used to render the group selection box.
	     * @return {fabric.Canvas} thisArg
	     * @chainable
	     */
	    renderTop: function () {
	      var ctx = this.contextTop;
	      this.clearContext(ctx);
	      this.renderTopLayer(ctx);
	      this.fire('after:render');
	      return this;
	    },

	    /**
	     * @private
	     */
	    _normalizePointer: function (object, pointer) {
	      var m = object.calcTransformMatrix(),
	          invertedM = fabric.util.invertTransform(m),
	          vptPointer = this.restorePointerVpt(pointer);
	      return fabric.util.transformPoint(vptPointer, invertedM);
	    },

	    /**
	     * Returns true if object is transparent at a certain location
	     * @param {fabric.Object} target Object to check
	     * @param {Number} x Left coordinate
	     * @param {Number} y Top coordinate
	     * @return {Boolean}
	     */
	    isTargetTransparent: function (target, x, y) {
	      // in case the target is the activeObject, we cannot execute this optimization
	      // because we need to draw controls too.
	      if (target.shouldCache() && target._cacheCanvas && target !== this._activeObject) {
	        var normalizedPointer = this._normalizePointer(target, {x: x, y: y}),
	            targetRelativeX = Math.max(target.cacheTranslationX + (normalizedPointer.x * target.zoomX), 0),
	            targetRelativeY = Math.max(target.cacheTranslationY + (normalizedPointer.y * target.zoomY), 0);

	        var isTransparent = fabric.util.isTransparent(
	          target._cacheContext, Math.round(targetRelativeX), Math.round(targetRelativeY), this.targetFindTolerance);

	        return isTransparent;
	      }

	      var ctx = this.contextCache,
	          originalColor = target.selectionBackgroundColor, v = this.viewportTransform;

	      target.selectionBackgroundColor = '';

	      this.clearContext(ctx);

	      ctx.save();
	      ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
	      target.render(ctx);
	      ctx.restore();

	      target.selectionBackgroundColor = originalColor;

	      var isTransparent = fabric.util.isTransparent(
	        ctx, x, y, this.targetFindTolerance);

	      return isTransparent;
	    },

	    /**
	     * takes an event and determines if selection key has been pressed
	     * @private
	     * @param {Event} e Event object
	     */
	    _isSelectionKeyPressed: function(e) {
	      var selectionKeyPressed = false;

	      if (Object.prototype.toString.call(this.selectionKey) === '[object Array]') {
	        selectionKeyPressed = !!this.selectionKey.find(function(key) { return e[key] === true; });
	      }
	      else {
	        selectionKeyPressed = e[this.selectionKey];
	      }

	      return selectionKeyPressed;
	    },

	    /**
	     * @private
	     * @param {Event} e Event object
	     * @param {fabric.Object} target
	     */
	    _shouldClearSelection: function (e, target) {
	      var activeObjects = this.getActiveObjects(),
	          activeObject = this._activeObject;

	      return (
	        !target
	        ||
	        (target &&
	          activeObject &&
	          activeObjects.length > 1 &&
	          activeObjects.indexOf(target) === -1 &&
	          activeObject !== target &&
	          !this._isSelectionKeyPressed(e))
	        ||
	        (target && !target.evented)
	        ||
	        (target &&
	          !target.selectable &&
	          activeObject &&
	          activeObject !== target)
	      );
	    },

	    /**
	     * centeredScaling from object can't override centeredScaling from canvas.
	     * this should be fixed, since object setting should take precedence over canvas.
	     * also this should be something that will be migrated in the control properties.
	     * as ability to define the origin of the transformation that the control provide.
	     * @private
	     * @param {fabric.Object} target
	     * @param {String} action
	     * @param {Boolean} altKey
	     */
	    _shouldCenterTransform: function (target, action, altKey) {
	      if (!target) {
	        return;
	      }

	      var centerTransform;

	      if (action === 'scale' || action === 'scaleX' || action === 'scaleY' || action === 'resizing') {
	        centerTransform = this.centeredScaling || target.centeredScaling;
	      }
	      else if (action === 'rotate') {
	        centerTransform = this.centeredRotation || target.centeredRotation;
	      }

	      return centerTransform ? !altKey : altKey;
	    },

	    /**
	     * should disappear before release 4.0
	     * @private
	     */
	    _getOriginFromCorner: function(target, corner) {
	      var origin = {
	        x: target.originX,
	        y: target.originY
	      };

	      if (corner === 'ml' || corner === 'tl' || corner === 'bl') {
	        origin.x = 'right';
	      }
	      else if (corner === 'mr' || corner === 'tr' || corner === 'br') {
	        origin.x = 'left';
	      }

	      if (corner === 'tl' || corner === 'mt' || corner === 'tr') {
	        origin.y = 'bottom';
	      }
	      else if (corner === 'bl' || corner === 'mb' || corner === 'br') {
	        origin.y = 'top';
	      }
	      return origin;
	    },

	    /**
	     * @private
	     * @param {Boolean} alreadySelected true if target is already selected
	     * @param {String} corner a string representing the corner ml, mr, tl ...
	     * @param {Event} e Event object
	     * @param {fabric.Object} [target] inserted back to help overriding. Unused
	     */
	    _getActionFromCorner: function(alreadySelected, corner, e, target) {
	      if (!corner || !alreadySelected) {
	        return 'drag';
	      }
	      var control = target.controls[corner];
	      return control.getActionName(e, control, target);
	    },

	    /**
	     * @private
	     * @param {Event} e Event object
	     * @param {fabric.Object} target
	     */
	    _setupCurrentTransform: function (e, target, alreadySelected) {
	      if (!target) {
	        return;
	      }

	      var pointer = this.getPointer(e), corner = target.__corner,
	          control = target.controls[corner],
	          actionHandler = (alreadySelected && corner) ?
	            control.getActionHandler(e, target, control) : fabric.controlsUtils.dragHandler,
	          action = this._getActionFromCorner(alreadySelected, corner, e, target),
	          origin = this._getOriginFromCorner(target, corner),
	          altKey = e[this.centeredKey],
	          transform = {
	            target: target,
	            action: action,
	            actionHandler: actionHandler,
	            corner: corner,
	            scaleX: target.scaleX,
	            scaleY: target.scaleY,
	            skewX: target.skewX,
	            skewY: target.skewY,
	            // used by transation
	            offsetX: pointer.x - target.left,
	            offsetY: pointer.y - target.top,
	            originX: origin.x,
	            originY: origin.y,
	            ex: pointer.x,
	            ey: pointer.y,
	            lastX: pointer.x,
	            lastY: pointer.y,
	            // unsure they are useful anymore.
	            // left: target.left,
	            // top: target.top,
	            theta: degreesToRadians(target.angle),
	            // end of unsure
	            width: target.width * target.scaleX,
	            shiftKey: e.shiftKey,
	            altKey: altKey,
	            original: fabric.util.saveObjectTransform(target),
	          };

	      if (this._shouldCenterTransform(target, action, altKey)) {
	        transform.originX = 'center';
	        transform.originY = 'center';
	      }
	      transform.original.originX = origin.x;
	      transform.original.originY = origin.y;
	      this._currentTransform = transform;
	      this._beforeTransform(e);
	    },

	    /**
	     * Set the cursor type of the canvas element
	     * @param {String} value Cursor type of the canvas element.
	     * @see http://www.w3.org/TR/css3-ui/#cursor
	     */
	    setCursor: function (value) {
	      this.upperCanvasEl.style.cursor = value;
	    },

	    /**
	     * @private
	     * @param {CanvasRenderingContext2D} ctx to draw the selection on
	     */
	    _drawSelection: function (ctx) {
	      var selector = this._groupSelector,
	          viewportStart = new fabric.Point(selector.ex, selector.ey),
	          start = fabric.util.transformPoint(viewportStart, this.viewportTransform),
	          viewportExtent = new fabric.Point(selector.ex + selector.left, selector.ey + selector.top),
	          extent = fabric.util.transformPoint(viewportExtent, this.viewportTransform),
	          minX = Math.min(start.x, extent.x),
	          minY = Math.min(start.y, extent.y),
	          maxX = Math.max(start.x, extent.x),
	          maxY = Math.max(start.y, extent.y),
	          strokeOffset = this.selectionLineWidth / 2;

	      if (this.selectionColor) {
	        ctx.fillStyle = this.selectionColor;
	        ctx.fillRect(minX, minY, maxX - minX, maxY - minY);
	      }

	      if (!this.selectionLineWidth || !this.selectionBorderColor) {
	        return;
	      }
	      ctx.lineWidth = this.selectionLineWidth;
	      ctx.strokeStyle = this.selectionBorderColor;

	      minX += strokeOffset;
	      minY += strokeOffset;
	      maxX -= strokeOffset;
	      maxY -= strokeOffset;
	      // selection border
	      fabric.Object.prototype._setLineDash.call(this, ctx, this.selectionDashArray);
	      ctx.strokeRect(minX, minY, maxX - minX, maxY - minY);
	    },

	    /**
	     * Method that determines what object we are clicking on
	     * the skipGroup parameter is for internal use, is needed for shift+click action
	     * 11/09/2018 TODO: would be cool if findTarget could discern between being a full target
	     * or the outside part of the corner.
	     * @param {Event} e mouse event
	     * @param {Boolean} skipGroup when true, activeGroup is skipped and only objects are traversed through
	     * @return {fabric.Object} the target found
	     */
	    findTarget: function (e, skipGroup) {
	      if (this.skipTargetFind) {
	        return;
	      }

	      var ignoreZoom = true,
	          pointer = this.getPointer(e, ignoreZoom),
	          activeObject = this._activeObject,
	          aObjects = this.getActiveObjects(),
	          activeTarget, activeTargetSubs,
	          isTouch = isTouchEvent(e),
	          shouldLookForActive = (aObjects.length > 1 && !skipGroup) || aObjects.length === 1;

	      // first check current group (if one exists)
	      // active group does not check sub targets like normal groups.
	      // if active group just exits.
	      this.targets = [];

	      // if we hit the corner of an activeObject, let's return that.
	      if (shouldLookForActive && activeObject._findTargetCorner(pointer, isTouch)) {
	        return activeObject;
	      }
	      if (aObjects.length > 1 && !skipGroup && activeObject === this._searchPossibleTargets([activeObject], pointer)) {
	        return activeObject;
	      }
	      if (aObjects.length === 1 &&
	        activeObject === this._searchPossibleTargets([activeObject], pointer)) {
	        if (!this.preserveObjectStacking) {
	          return activeObject;
	        }
	        else {
	          activeTarget = activeObject;
	          activeTargetSubs = this.targets;
	          this.targets = [];
	        }
	      }
	      var target = this._searchPossibleTargets(this._objects, pointer);
	      if (e[this.altSelectionKey] && target && activeTarget && target !== activeTarget) {
	        target = activeTarget;
	        this.targets = activeTargetSubs;
	      }
	      return target;
	    },

	    /**
	     * Checks point is inside the object.
	     * @param {Object} [pointer] x,y object of point coordinates we want to check.
	     * @param {fabric.Object} obj Object to test against
	     * @param {Object} [globalPointer] x,y object of point coordinates relative to canvas used to search per pixel target.
	     * @return {Boolean} true if point is contained within an area of given object
	     * @private
	     */
	    _checkTarget: function(pointer, obj, globalPointer) {
	      if (obj &&
	          obj.visible &&
	          obj.evented &&
	          // http://www.geog.ubc.ca/courses/klink/gis.notes/ncgia/u32.html
	          // http://idav.ucdavis.edu/~okreylos/TAship/Spring2000/PointInPolygon.html
	          obj.containsPoint(pointer)
	      ) {
	        if ((this.perPixelTargetFind || obj.perPixelTargetFind) && !obj.isEditing) {
	          var isTransparent = this.isTargetTransparent(obj, globalPointer.x, globalPointer.y);
	          if (!isTransparent) {
	            return true;
	          }
	        }
	        else {
	          return true;
	        }
	      }
	    },

	    /**
	     * Function used to search inside objects an object that contains pointer in bounding box or that contains pointerOnCanvas when painted
	     * @param {Array} [objects] objects array to look into
	     * @param {Object} [pointer] x,y object of point coordinates we want to check.
	     * @return {fabric.Object} object that contains pointer
	     * @private
	     */
	    _searchPossibleTargets: function(objects, pointer) {
	      // Cache all targets where their bounding box contains point.
	      var target, i = objects.length, subTarget;
	      // Do not check for currently grouped objects, since we check the parent group itself.
	      // until we call this function specifically to search inside the activeGroup
	      while (i--) {
	        var objToCheck = objects[i];
	        var pointerToUse = objToCheck.group ?
	          this._normalizePointer(objToCheck.group, pointer) : pointer;
	        if (this._checkTarget(pointerToUse, objToCheck, pointer)) {
	          target = objects[i];
	          if (target.subTargetCheck && target instanceof fabric.Group) {
	            subTarget = this._searchPossibleTargets(target._objects, pointer);
	            subTarget && this.targets.push(subTarget);
	          }
	          break;
	        }
	      }
	      return target;
	    },

	    /**
	     * Returns pointer coordinates without the effect of the viewport
	     * @param {Object} pointer with "x" and "y" number values
	     * @return {Object} object with "x" and "y" number values
	     */
	    restorePointerVpt: function(pointer) {
	      return fabric.util.transformPoint(
	        pointer,
	        fabric.util.invertTransform(this.viewportTransform)
	      );
	    },

	    /**
	     * Returns pointer coordinates relative to canvas.
	     * Can return coordinates with or without viewportTransform.
	     * ignoreZoom false gives back coordinates that represent
	     * the point clicked on canvas element.
	     * ignoreZoom true gives back coordinates after being processed
	     * by the viewportTransform ( sort of coordinates of what is displayed
	     * on the canvas where you are clicking.
	     * ignoreZoom true = HTMLElement coordinates relative to top,left
	     * ignoreZoom false, default = fabric space coordinates, the same used for shape position
	     * To interact with your shapes top and left you want to use ignoreZoom true
	     * most of the time, while ignoreZoom false will give you coordinates
	     * compatible with the object.oCoords system.
	     * of the time.
	     * @param {Event} e
	     * @param {Boolean} ignoreZoom
	     * @return {Object} object with "x" and "y" number values
	     */
	    getPointer: function (e, ignoreZoom) {
	      // return cached values if we are in the event processing chain
	      if (this._absolutePointer && !ignoreZoom) {
	        return this._absolutePointer;
	      }
	      if (this._pointer && ignoreZoom) {
	        return this._pointer;
	      }

	      var pointer = getPointer(e),
	          upperCanvasEl = this.upperCanvasEl,
	          bounds = upperCanvasEl.getBoundingClientRect(),
	          boundsWidth = bounds.width || 0,
	          boundsHeight = bounds.height || 0,
	          cssScale;

	      if (!boundsWidth || !boundsHeight ) {
	        if ('top' in bounds && 'bottom' in bounds) {
	          boundsHeight = Math.abs( bounds.top - bounds.bottom );
	        }
	        if ('right' in bounds && 'left' in bounds) {
	          boundsWidth = Math.abs( bounds.right - bounds.left );
	        }
	      }

	      this.calcOffset();
	      pointer.x = pointer.x - this._offset.left;
	      pointer.y = pointer.y - this._offset.top;
	      if (!ignoreZoom) {
	        pointer = this.restorePointerVpt(pointer);
	      }

	      var retinaScaling = this.getRetinaScaling();
	      if (retinaScaling !== 1) {
	        pointer.x /= retinaScaling;
	        pointer.y /= retinaScaling;
	      }

	      if (boundsWidth === 0 || boundsHeight === 0) {
	        // If bounds are not available (i.e. not visible), do not apply scale.
	        cssScale = { width: 1, height: 1 };
	      }
	      else {
	        cssScale = {
	          width: upperCanvasEl.width / boundsWidth,
	          height: upperCanvasEl.height / boundsHeight
	        };
	      }

	      return {
	        x: pointer.x * cssScale.width,
	        y: pointer.y * cssScale.height
	      };
	    },

	    /**
	     * @private
	     * @throws {CANVAS_INIT_ERROR} If canvas can not be initialized
	     */
	    _createUpperCanvas: function () {
	      var lowerCanvasClass = this.lowerCanvasEl.className.replace(/\s*lower-canvas\s*/, ''),
	          lowerCanvasEl = this.lowerCanvasEl, upperCanvasEl = this.upperCanvasEl;

	      // there is no need to create a new upperCanvas element if we have already one.
	      if (upperCanvasEl) {
	        upperCanvasEl.className = '';
	      }
	      else {
	        upperCanvasEl = this._createCanvasElement();
	        this.upperCanvasEl = upperCanvasEl;
	      }
	      fabric.util.addClass(upperCanvasEl, 'upper-canvas ' + lowerCanvasClass);

	      this.wrapperEl.appendChild(upperCanvasEl);

	      this._copyCanvasStyle(lowerCanvasEl, upperCanvasEl);
	      this._applyCanvasStyle(upperCanvasEl);
	      this.contextTop = upperCanvasEl.getContext('2d');
	    },

	    /**
	     * @private
	     */
	    _createCacheCanvas: function () {
	      this.cacheCanvasEl = this._createCanvasElement();
	      this.cacheCanvasEl.setAttribute('width', this.width);
	      this.cacheCanvasEl.setAttribute('height', this.height);
	      this.contextCache = this.cacheCanvasEl.getContext('2d');
	    },

	    /**
	     * @private
	     */
	    _initWrapperElement: function () {
	      this.wrapperEl = fabric.util.wrapElement(this.lowerCanvasEl, 'div', {
	        'class': this.containerClass
	      });
	      fabric.util.setStyle(this.wrapperEl, {
	        width: this.width + 'px',
	        height: this.height + 'px',
	        position: 'relative'
	      });
	      fabric.util.makeElementUnselectable(this.wrapperEl);
	    },

	    /**
	     * @private
	     * @param {HTMLElement} element canvas element to apply styles on
	     */
	    _applyCanvasStyle: function (element) {
	      var width = this.width || element.width,
	          height = this.height || element.height;

	      fabric.util.setStyle(element, {
	        position: 'absolute',
	        width: width + 'px',
	        height: height + 'px',
	        left: 0,
	        top: 0,
	        'touch-action': this.allowTouchScrolling ? 'manipulation' : 'none',
	        '-ms-touch-action': this.allowTouchScrolling ? 'manipulation' : 'none'
	      });
	      element.width = width;
	      element.height = height;
	      fabric.util.makeElementUnselectable(element);
	    },

	    /**
	     * Copy the entire inline style from one element (fromEl) to another (toEl)
	     * @private
	     * @param {Element} fromEl Element style is copied from
	     * @param {Element} toEl Element copied style is applied to
	     */
	    _copyCanvasStyle: function (fromEl, toEl) {
	      toEl.style.cssText = fromEl.style.cssText;
	    },

	    /**
	     * Returns context of canvas where object selection is drawn
	     * @return {CanvasRenderingContext2D}
	     */
	    getSelectionContext: function() {
	      return this.contextTop;
	    },

	    /**
	     * Returns &lt;canvas> element on which object selection is drawn
	     * @return {HTMLCanvasElement}
	     */
	    getSelectionElement: function () {
	      return this.upperCanvasEl;
	    },

	    /**
	     * Returns currently active object
	     * @return {fabric.Object} active object
	     */
	    getActiveObject: function () {
	      return this._activeObject;
	    },

	    /**
	     * Returns an array with the current selected objects
	     * @return {fabric.Object} active object
	     */
	    getActiveObjects: function () {
	      var active = this._activeObject;
	      if (active) {
	        if (active.type === 'activeSelection' && active._objects) {
	          return active._objects.slice(0);
	        }
	        else {
	          return [active];
	        }
	      }
	      return [];
	    },

	    /**
	     * @private
	     * @param {fabric.Object} obj Object that was removed
	     */
	    _onObjectRemoved: function(obj) {
	      // removing active object should fire "selection:cleared" events
	      if (obj === this._activeObject) {
	        this.fire('before:selection:cleared', { target: obj });
	        this._discardActiveObject();
	        this.fire('selection:cleared', { target: obj });
	        obj.fire('deselected');
	      }
	      if (obj === this._hoveredTarget){
	        this._hoveredTarget = null;
	        this._hoveredTargets = [];
	      }
	      this.callSuper('_onObjectRemoved', obj);
	    },

	    /**
	     * @private
	     * Compares the old activeObject with the current one and fires correct events
	     * @param {fabric.Object} obj old activeObject
	     */
	    _fireSelectionEvents: function(oldObjects, e) {
	      var somethingChanged = false, objects = this.getActiveObjects(),
	          added = [], removed = [];
	      oldObjects.forEach(function(oldObject) {
	        if (objects.indexOf(oldObject) === -1) {
	          somethingChanged = true;
	          oldObject.fire('deselected', {
	            e: e,
	            target: oldObject
	          });
	          removed.push(oldObject);
	        }
	      });
	      objects.forEach(function(object) {
	        if (oldObjects.indexOf(object) === -1) {
	          somethingChanged = true;
	          object.fire('selected', {
	            e: e,
	            target: object
	          });
	          added.push(object);
	        }
	      });
	      if (oldObjects.length > 0 && objects.length > 0) {
	        somethingChanged && this.fire('selection:updated', {
	          e: e,
	          selected: added,
	          deselected: removed,
	          // added for backward compatibility
	          // deprecated
	          updated: added[0] || removed[0],
	          target: this._activeObject,
	        });
	      }
	      else if (objects.length > 0) {
	        this.fire('selection:created', {
	          e: e,
	          selected: added,
	          target: this._activeObject,
	        });
	      }
	      else if (oldObjects.length > 0) {
	        this.fire('selection:cleared', {
	          e: e,
	          deselected: removed,
	        });
	      }
	    },

	    /**
	     * Sets given object as the only active object on canvas
	     * @param {fabric.Object} object Object to set as an active one
	     * @param {Event} [e] Event (passed along when firing "object:selected")
	     * @return {fabric.Canvas} thisArg
	     * @chainable
	     */
	    setActiveObject: function (object, e) {
	      var currentActives = this.getActiveObjects();
	      this._setActiveObject(object, e);
	      this._fireSelectionEvents(currentActives, e);
	      return this;
	    },

	    /**
	     * This is a private method for now.
	     * This is supposed to be equivalent to setActiveObject but without firing
	     * any event. There is commitment to have this stay this way.
	     * This is the functional part of setActiveObject.
	     * @private
	     * @param {Object} object to set as active
	     * @param {Event} [e] Event (passed along when firing "object:selected")
	     * @return {Boolean} true if the selection happened
	     */
	    _setActiveObject: function(object, e) {
	      if (this._activeObject === object) {
	        return false;
	      }
	      if (!this._discardActiveObject(e, object)) {
	        return false;
	      }
	      if (object.onSelect({ e: e })) {
	        return false;
	      }
	      this._activeObject = object;
	      return true;
	    },

	    /**
	     * This is a private method for now.
	     * This is supposed to be equivalent to discardActiveObject but without firing
	     * any events. There is commitment to have this stay this way.
	     * This is the functional part of discardActiveObject.
	     * @param {Event} [e] Event (passed along when firing "object:deselected")
	     * @param {Object} object to set as active
	     * @return {Boolean} true if the selection happened
	     * @private
	     */
	    _discardActiveObject: function(e, object) {
	      var obj = this._activeObject;
	      if (obj) {
	        // onDeselect return TRUE to cancel selection;
	        if (obj.onDeselect({ e: e, object: object })) {
	          return false;
	        }
	        this._activeObject = null;
	      }
	      return true;
	    },

	    /**
	     * Discards currently active object and fire events. If the function is called by fabric
	     * as a consequence of a mouse event, the event is passed as a parameter and
	     * sent to the fire function for the custom events. When used as a method the
	     * e param does not have any application.
	     * @param {event} e
	     * @return {fabric.Canvas} thisArg
	     * @chainable
	     */
	    discardActiveObject: function (e) {
	      var currentActives = this.getActiveObjects(), activeObject = this.getActiveObject();
	      if (currentActives.length) {
	        this.fire('before:selection:cleared', { target: activeObject, e: e });
	      }
	      this._discardActiveObject(e);
	      this._fireSelectionEvents(currentActives, e);
	      return this;
	    },

	    /**
	     * Clears a canvas element and removes all event listeners
	     * @return {fabric.Canvas} thisArg
	     * @chainable
	     */
	    dispose: function () {
	      var wrapper = this.wrapperEl;
	      this.removeListeners();
	      wrapper.removeChild(this.upperCanvasEl);
	      wrapper.removeChild(this.lowerCanvasEl);
	      this.contextCache = null;
	      this.contextTop = null;
	      ['upperCanvasEl', 'cacheCanvasEl'].forEach((function(element) {
	        fabric.util.cleanUpJsdomNode(this[element]);
	        this[element] = undefined;
	      }).bind(this));
	      if (wrapper.parentNode) {
	        wrapper.parentNode.replaceChild(this.lowerCanvasEl, this.wrapperEl);
	      }
	      delete this.wrapperEl;
	      fabric.StaticCanvas.prototype.dispose.call(this);
	      return this;
	    },

	    /**
	     * Clears all contexts (background, main, top) of an instance
	     * @return {fabric.Canvas} thisArg
	     * @chainable
	     */
	    clear: function () {
	      // this.discardActiveGroup();
	      this.discardActiveObject();
	      this.clearContext(this.contextTop);
	      return this.callSuper('clear');
	    },

	    /**
	     * Draws objects' controls (borders/controls)
	     * @param {CanvasRenderingContext2D} ctx Context to render controls on
	     */
	    drawControls: function(ctx) {
	      var activeObject = this._activeObject;

	      if (activeObject) {
	        activeObject._renderControls(ctx);
	      }
	    },

	    /**
	     * @private
	     */
	    _toObject: function(instance, methodName, propertiesToInclude) {
	      //If the object is part of the current selection group, it should
	      //be transformed appropriately
	      //i.e. it should be serialised as it would appear if the selection group
	      //were to be destroyed.
	      var originalProperties = this._realizeGroupTransformOnObject(instance),
	          object = this.callSuper('_toObject', instance, methodName, propertiesToInclude);
	      //Undo the damage we did by changing all of its properties
	      this._unwindGroupTransformOnObject(instance, originalProperties);
	      return object;
	    },

	    /**
	     * Realises an object's group transformation on it
	     * @private
	     * @param {fabric.Object} [instance] the object to transform (gets mutated)
	     * @returns the original values of instance which were changed
	     */
	    _realizeGroupTransformOnObject: function(instance) {
	      if (instance.group && instance.group.type === 'activeSelection' && this._activeObject === instance.group) {
	        var layoutProps = ['angle', 'flipX', 'flipY', 'left', 'scaleX', 'scaleY', 'skewX', 'skewY', 'top'];
	        //Copy all the positionally relevant properties across now
	        var originalValues = {};
	        layoutProps.forEach(function(prop) {
	          originalValues[prop] = instance[prop];
	        });
	        fabric.util.addTransformToObject(instance, this._activeObject.calcOwnMatrix());
	        return originalValues;
	      }
	      else {
	        return null;
	      }
	    },

	    /**
	     * Restores the changed properties of instance
	     * @private
	     * @param {fabric.Object} [instance] the object to un-transform (gets mutated)
	     * @param {Object} [originalValues] the original values of instance, as returned by _realizeGroupTransformOnObject
	     */
	    _unwindGroupTransformOnObject: function(instance, originalValues) {
	      if (originalValues) {
	        instance.set(originalValues);
	      }
	    },

	    /**
	     * @private
	     */
	    _setSVGObject: function(markup, instance, reviver) {
	      //If the object is in a selection group, simulate what would happen to that
	      //object when the group is deselected
	      var originalProperties = this._realizeGroupTransformOnObject(instance);
	      this.callSuper('_setSVGObject', markup, instance, reviver);
	      this._unwindGroupTransformOnObject(instance, originalProperties);
	    },

	    setViewportTransform: function (vpt) {
	      if (this.renderOnAddRemove && this._activeObject && this._activeObject.isEditing) {
	        this._activeObject.clearContextTop();
	      }
	      fabric.StaticCanvas.prototype.setViewportTransform.call(this, vpt);
	    }
	  });

	  // copying static properties manually to work around Opera's bug,
	  // where "prototype" property is enumerable and overrides existing prototype
	  for (var prop in fabric.StaticCanvas) {
	    if (prop !== 'prototype') {
	      fabric.Canvas[prop] = fabric.StaticCanvas[prop];
	    }
	  }
	})();


	(function() {

	  var addListener = fabric.util.addListener,
	      removeListener = fabric.util.removeListener,
	      RIGHT_CLICK = 3, MIDDLE_CLICK = 2, LEFT_CLICK = 1,
	      addEventOptions = { passive: false };

	  function checkClick(e, value) {
	    return e.button && (e.button === value - 1);
	  }

	  fabric.util.object.extend(fabric.Canvas.prototype, /** @lends fabric.Canvas.prototype */ {

	    /**
	     * Contains the id of the touch event that owns the fabric transform
	     * @type Number
	     * @private
	     */
	    mainTouchId: null,

	    /**
	     * Adds mouse listeners to canvas
	     * @private
	     */
	    _initEventListeners: function () {
	      // in case we initialized the class twice. This should not happen normally
	      // but in some kind of applications where the canvas element may be changed
	      // this is a workaround to having double listeners.
	      this.removeListeners();
	      this._bindEvents();
	      this.addOrRemove(addListener, 'add');
	    },

	    /**
	     * return an event prefix pointer or mouse.
	     * @private
	     */
	    _getEventPrefix: function () {
	      return this.enablePointerEvents ? 'pointer' : 'mouse';
	    },

	    addOrRemove: function(functor, eventjsFunctor) {
	      var canvasElement = this.upperCanvasEl,
	          eventTypePrefix = this._getEventPrefix();
	      functor(fabric.window, 'resize', this._onResize);
	      functor(canvasElement, eventTypePrefix + 'down', this._onMouseDown);
	      functor(canvasElement, eventTypePrefix + 'move', this._onMouseMove, addEventOptions);
	      functor(canvasElement, eventTypePrefix + 'out', this._onMouseOut);
	      functor(canvasElement, eventTypePrefix + 'enter', this._onMouseEnter);
	      functor(canvasElement, 'wheel', this._onMouseWheel);
	      functor(canvasElement, 'contextmenu', this._onContextMenu);
	      functor(canvasElement, 'dblclick', this._onDoubleClick);
	      functor(canvasElement, 'dragover', this._onDragOver);
	      functor(canvasElement, 'dragenter', this._onDragEnter);
	      functor(canvasElement, 'dragleave', this._onDragLeave);
	      functor(canvasElement, 'drop', this._onDrop);
	      if (!this.enablePointerEvents) {
	        functor(canvasElement, 'touchstart', this._onTouchStart, addEventOptions);
	      }
	      if (typeof eventjs !== 'undefined' && eventjsFunctor in eventjs) {
	        eventjs[eventjsFunctor](canvasElement, 'gesture', this._onGesture);
	        eventjs[eventjsFunctor](canvasElement, 'drag', this._onDrag);
	        eventjs[eventjsFunctor](canvasElement, 'orientation', this._onOrientationChange);
	        eventjs[eventjsFunctor](canvasElement, 'shake', this._onShake);
	        eventjs[eventjsFunctor](canvasElement, 'longpress', this._onLongPress);
	      }
	    },

	    /**
	     * Removes all event listeners
	     */
	    removeListeners: function() {
	      this.addOrRemove(removeListener, 'remove');
	      // if you dispose on a mouseDown, before mouse up, you need to clean document to...
	      var eventTypePrefix = this._getEventPrefix();
	      removeListener(fabric.document, eventTypePrefix + 'up', this._onMouseUp);
	      removeListener(fabric.document, 'touchend', this._onTouchEnd, addEventOptions);
	      removeListener(fabric.document, eventTypePrefix + 'move', this._onMouseMove, addEventOptions);
	      removeListener(fabric.document, 'touchmove', this._onMouseMove, addEventOptions);
	    },

	    /**
	     * @private
	     */
	    _bindEvents: function() {
	      if (this.eventsBound) {
	        // for any reason we pass here twice we do not want to bind events twice.
	        return;
	      }
	      this._onMouseDown = this._onMouseDown.bind(this);
	      this._onTouchStart = this._onTouchStart.bind(this);
	      this._onMouseMove = this._onMouseMove.bind(this);
	      this._onMouseUp = this._onMouseUp.bind(this);
	      this._onTouchEnd = this._onTouchEnd.bind(this);
	      this._onResize = this._onResize.bind(this);
	      this._onGesture = this._onGesture.bind(this);
	      this._onDrag = this._onDrag.bind(this);
	      this._onShake = this._onShake.bind(this);
	      this._onLongPress = this._onLongPress.bind(this);
	      this._onOrientationChange = this._onOrientationChange.bind(this);
	      this._onMouseWheel = this._onMouseWheel.bind(this);
	      this._onMouseOut = this._onMouseOut.bind(this);
	      this._onMouseEnter = this._onMouseEnter.bind(this);
	      this._onContextMenu = this._onContextMenu.bind(this);
	      this._onDoubleClick = this._onDoubleClick.bind(this);
	      this._onDragOver = this._onDragOver.bind(this);
	      this._onDragEnter = this._simpleEventHandler.bind(this, 'dragenter');
	      this._onDragLeave = this._simpleEventHandler.bind(this, 'dragleave');
	      this._onDrop = this._simpleEventHandler.bind(this, 'drop');
	      this.eventsBound = true;
	    },

	    /**
	     * @private
	     * @param {Event} [e] Event object fired on Event.js gesture
	     * @param {Event} [self] Inner Event object
	     */
	    _onGesture: function(e, self) {
	      this.__onTransformGesture && this.__onTransformGesture(e, self);
	    },

	    /**
	     * @private
	     * @param {Event} [e] Event object fired on Event.js drag
	     * @param {Event} [self] Inner Event object
	     */
	    _onDrag: function(e, self) {
	      this.__onDrag && this.__onDrag(e, self);
	    },

	    /**
	     * @private
	     * @param {Event} [e] Event object fired on wheel event
	     */
	    _onMouseWheel: function(e) {
	      this.__onMouseWheel(e);
	    },

	    /**
	     * @private
	     * @param {Event} e Event object fired on mousedown
	     */
	    _onMouseOut: function(e) {
	      var target = this._hoveredTarget;
	      this.fire('mouse:out', { target: target, e: e });
	      this._hoveredTarget = null;
	      target && target.fire('mouseout', { e: e });

	      var _this = this;
	      this._hoveredTargets.forEach(function(_target){
	        _this.fire('mouse:out', { target: target, e: e });
	        _target && target.fire('mouseout', { e: e });
	      });
	      this._hoveredTargets = [];

	      if (this._iTextInstances) {
	        this._iTextInstances.forEach(function(obj) {
	          if (obj.isEditing) {
	            obj.hiddenTextarea.focus();
	          }
	        });
	      }
	    },

	    /**
	     * @private
	     * @param {Event} e Event object fired on mouseenter
	     */
	    _onMouseEnter: function(e) {
	      // This find target and consequent 'mouse:over' is used to
	      // clear old instances on hovered target.
	      // calling findTarget has the side effect of killing target.__corner.
	      // as a short term fix we are not firing this if we are currently transforming.
	      // as a long term fix we need to separate the action of finding a target with the
	      // side effects we added to it.
	      if (!this._currentTransform && !this.findTarget(e)) {
	        this.fire('mouse:over', { target: null, e: e });
	        this._hoveredTarget = null;
	        this._hoveredTargets = [];
	      }
	    },

	    /**
	     * @private
	     * @param {Event} [e] Event object fired on Event.js orientation change
	     * @param {Event} [self] Inner Event object
	     */
	    _onOrientationChange: function(e, self) {
	      this.__onOrientationChange && this.__onOrientationChange(e, self);
	    },

	    /**
	     * @private
	     * @param {Event} [e] Event object fired on Event.js shake
	     * @param {Event} [self] Inner Event object
	     */
	    _onShake: function(e, self) {
	      this.__onShake && this.__onShake(e, self);
	    },

	    /**
	     * @private
	     * @param {Event} [e] Event object fired on Event.js shake
	     * @param {Event} [self] Inner Event object
	     */
	    _onLongPress: function(e, self) {
	      this.__onLongPress && this.__onLongPress(e, self);
	    },

	    /**
	     * prevent default to allow drop event to be fired
	     * @private
	     * @param {Event} [e] Event object fired on Event.js shake
	     */
	    _onDragOver: function(e) {
	      e.preventDefault();
	      var target = this._simpleEventHandler('dragover', e);
	      this._fireEnterLeaveEvents(target, e);
	    },

	    /**
	     * @private
	     * @param {Event} e Event object fired on mousedown
	     */
	    _onContextMenu: function (e) {
	      if (this.stopContextMenu) {
	        e.stopPropagation();
	        e.preventDefault();
	      }
	      return false;
	    },

	    /**
	     * @private
	     * @param {Event} e Event object fired on mousedown
	     */
	    _onDoubleClick: function (e) {
	      this._cacheTransformEventData(e);
	      this._handleEvent(e, 'dblclick');
	      this._resetTransformEventData(e);
	    },

	    /**
	     * Return a the id of an event.
	     * returns either the pointerId or the identifier or 0 for the mouse event
	     * @private
	     * @param {Event} evt Event object
	     */
	    getPointerId: function(evt) {
	      var changedTouches = evt.changedTouches;

	      if (changedTouches) {
	        return changedTouches[0] && changedTouches[0].identifier;
	      }

	      if (this.enablePointerEvents) {
	        return evt.pointerId;
	      }

	      return -1;
	    },

	    /**
	     * Determines if an event has the id of the event that is considered main
	     * @private
	     * @param {evt} event Event object
	     */
	    _isMainEvent: function(evt) {
	      if (evt.isPrimary === true) {
	        return true;
	      }
	      if (evt.isPrimary === false) {
	        return false;
	      }
	      if (evt.type === 'touchend' && evt.touches.length === 0) {
	        return true;
	      }
	      if (evt.changedTouches) {
	        return evt.changedTouches[0].identifier === this.mainTouchId;
	      }
	      return true;
	    },

	    /**
	     * @private
	     * @param {Event} e Event object fired on mousedown
	     */
	    _onTouchStart: function(e) {
	      e.preventDefault();
	      if (this.mainTouchId === null) {
	        this.mainTouchId = this.getPointerId(e);
	      }
	      this.__onMouseDown(e);
	      this._resetTransformEventData();
	      var canvasElement = this.upperCanvasEl,
	          eventTypePrefix = this._getEventPrefix();
	      addListener(fabric.document, 'touchend', this._onTouchEnd, addEventOptions);
	      addListener(fabric.document, 'touchmove', this._onMouseMove, addEventOptions);
	      // Unbind mousedown to prevent double triggers from touch devices
	      removeListener(canvasElement, eventTypePrefix + 'down', this._onMouseDown);
	    },

	    /**
	     * @private
	     * @param {Event} e Event object fired on mousedown
	     */
	    _onMouseDown: function (e) {
	      this.__onMouseDown(e);
	      this._resetTransformEventData();
	      var canvasElement = this.upperCanvasEl,
	          eventTypePrefix = this._getEventPrefix();
	      removeListener(canvasElement, eventTypePrefix + 'move', this._onMouseMove, addEventOptions);
	      addListener(fabric.document, eventTypePrefix + 'up', this._onMouseUp);
	      addListener(fabric.document, eventTypePrefix + 'move', this._onMouseMove, addEventOptions);
	    },

	    /**
	     * @private
	     * @param {Event} e Event object fired on mousedown
	     */
	    _onTouchEnd: function(e) {
	      if (e.touches.length > 0) {
	        // if there are still touches stop here
	        return;
	      }
	      this.__onMouseUp(e);
	      this._resetTransformEventData();
	      this.mainTouchId = null;
	      var eventTypePrefix = this._getEventPrefix();
	      removeListener(fabric.document, 'touchend', this._onTouchEnd, addEventOptions);
	      removeListener(fabric.document, 'touchmove', this._onMouseMove, addEventOptions);
	      var _this = this;
	      if (this._willAddMouseDown) {
	        clearTimeout(this._willAddMouseDown);
	      }
	      this._willAddMouseDown = setTimeout(function() {
	        // Wait 400ms before rebinding mousedown to prevent double triggers
	        // from touch devices
	        addListener(_this.upperCanvasEl, eventTypePrefix + 'down', _this._onMouseDown);
	        _this._willAddMouseDown = 0;
	      }, 400);
	    },

	    /**
	     * @private
	     * @param {Event} e Event object fired on mouseup
	     */
	    _onMouseUp: function (e) {
	      this.__onMouseUp(e);
	      this._resetTransformEventData();
	      var canvasElement = this.upperCanvasEl,
	          eventTypePrefix = this._getEventPrefix();
	      if (this._isMainEvent(e)) {
	        removeListener(fabric.document, eventTypePrefix + 'up', this._onMouseUp);
	        removeListener(fabric.document, eventTypePrefix + 'move', this._onMouseMove, addEventOptions);
	        addListener(canvasElement, eventTypePrefix + 'move', this._onMouseMove, addEventOptions);
	      }
	    },

	    /**
	     * @private
	     * @param {Event} e Event object fired on mousemove
	     */
	    _onMouseMove: function (e) {
	      !this.allowTouchScrolling && e.preventDefault && e.preventDefault();
	      this.__onMouseMove(e);
	    },

	    /**
	     * @private
	     */
	    _onResize: function () {
	      this.calcOffset();
	    },

	    /**
	     * Decides whether the canvas should be redrawn in mouseup and mousedown events.
	     * @private
	     * @param {Object} target
	     */
	    _shouldRender: function(target) {
	      var activeObject = this._activeObject;

	      if (
	        !!activeObject !== !!target ||
	        (activeObject && target && (activeObject !== target))
	      ) {
	        // this covers: switch of target, from target to no target, selection of target
	        // multiSelection with key and mouse
	        return true;
	      }
	      else if (activeObject && activeObject.isEditing) {
	        // if we mouse up/down over a editing textbox a cursor change,
	        // there is no need to re render
	        return false;
	      }
	      return false;
	    },

	    /**
	     * Method that defines the actions when mouse is released on canvas.
	     * The method resets the currentTransform parameters, store the image corner
	     * position in the image object and render the canvas on top.
	     * @private
	     * @param {Event} e Event object fired on mouseup
	     */
	    __onMouseUp: function (e) {
	      var target, transform = this._currentTransform,
	          groupSelector = this._groupSelector, shouldRender = false,
	          isClick = (!groupSelector || (groupSelector.left === 0 && groupSelector.top === 0));
	      this._cacheTransformEventData(e);
	      target = this._target;
	      this._handleEvent(e, 'up:before');
	      // if right/middle click just fire events and return
	      // target undefined will make the _handleEvent search the target
	      if (checkClick(e, RIGHT_CLICK)) {
	        if (this.fireRightClick) {
	          this._handleEvent(e, 'up', RIGHT_CLICK, isClick);
	        }
	        return;
	      }

	      if (checkClick(e, MIDDLE_CLICK)) {
	        if (this.fireMiddleClick) {
	          this._handleEvent(e, 'up', MIDDLE_CLICK, isClick);
	        }
	        this._resetTransformEventData();
	        return;
	      }

	      if (this.isDrawingMode && this._isCurrentlyDrawing) {
	        this._onMouseUpInDrawingMode(e);
	        return;
	      }

	      if (!this._isMainEvent(e)) {
	        return;
	      }
	      if (transform) {
	        this._finalizeCurrentTransform(e);
	        shouldRender = transform.actionPerformed;
	      }
	      if (!isClick) {
	        var targetWasActive = target === this._activeObject;
	        this._maybeGroupObjects(e);
	        if (!shouldRender) {
	          shouldRender = (
	            this._shouldRender(target) ||
	            (!targetWasActive && target === this._activeObject)
	          );
	        }
	      }
	      if (target) {
	        if (target.selectable && target !== this._activeObject && target.activeOn === 'up') {
	          this.setActiveObject(target, e);
	          shouldRender = true;
	        }
	        else {
	          var corner = target._findTargetCorner(
	            this.getPointer(e, true),
	            fabric.util.isTouchEvent(e)
	          );
	          var control = target.controls[corner],
	              mouseUpHandler = control && control.getMouseUpHandler(e, target, control);
	          if (mouseUpHandler) {
	            var pointer = this.getPointer(e);
	            mouseUpHandler(e, transform, pointer.x, pointer.y);
	          }
	        }
	        target.isMoving = false;
	      }
	      this._setCursorFromEvent(e, target);
	      this._handleEvent(e, 'up', LEFT_CLICK, isClick);
	      this._groupSelector = null;
	      this._currentTransform = null;
	      // reset the target information about which corner is selected
	      target && (target.__corner = 0);
	      if (shouldRender) {
	        this.requestRenderAll();
	      }
	      else if (!isClick) {
	        this.renderTop();
	      }
	    },

	    /**
	     * @private
	     * Handle event firing for target and subtargets
	     * @param {Event} e event from mouse
	     * @param {String} eventType event to fire (up, down or move)
	     * @return {Fabric.Object} target return the the target found, for internal reasons.
	     */
	    _simpleEventHandler: function(eventType, e) {
	      var target = this.findTarget(e),
	          targets = this.targets,
	          options = {
	            e: e,
	            target: target,
	            subTargets: targets,
	          };
	      this.fire(eventType, options);
	      target && target.fire(eventType, options);
	      if (!targets) {
	        return target;
	      }
	      for (var i = 0; i < targets.length; i++) {
	        targets[i].fire(eventType, options);
	      }
	      return target;
	    },

	    /**
	     * @private
	     * Handle event firing for target and subtargets
	     * @param {Event} e event from mouse
	     * @param {String} eventType event to fire (up, down or move)
	     * @param {fabric.Object} targetObj receiving event
	     * @param {Number} [button] button used in the event 1 = left, 2 = middle, 3 = right
	     * @param {Boolean} isClick for left button only, indicates that the mouse up happened without move.
	     */
	    _handleEvent: function(e, eventType, button, isClick) {
	      var target = this._target,
	          targets = this.targets || [],
	          options = {
	            e: e,
	            target: target,
	            subTargets: targets,
	            button: button || LEFT_CLICK,
	            isClick: isClick || false,
	            pointer: this._pointer,
	            absolutePointer: this._absolutePointer,
	            transform: this._currentTransform
	          };
	      if (eventType === 'up') {
	        options.currentTarget = this.findTarget(e);
	        options.currentSubTargets = this.targets;
	      }
	      this.fire('mouse:' + eventType, options);
	      target && target.fire('mouse' + eventType, options);
	      for (var i = 0; i < targets.length; i++) {
	        targets[i].fire('mouse' + eventType, options);
	      }
	    },

	    /**
	     * @private
	     * @param {Event} e send the mouse event that generate the finalize down, so it can be used in the event
	     */
	    _finalizeCurrentTransform: function(e) {

	      var transform = this._currentTransform,
	          target = transform.target,
	          eventName,
	          options = {
	            e: e,
	            target: target,
	            transform: transform,
	            action: transform.action,
	          };

	      if (target._scaling) {
	        target._scaling = false;
	      }

	      target.setCoords();

	      if (transform.actionPerformed || (this.stateful && target.hasStateChanged())) {
	        if (transform.actionPerformed) {
	          // this is not friendly to the new control api.
	          // is deprecated.
	          eventName = this._addEventOptions(options, transform);
	          this._fire(eventName, options);
	        }
	        this._fire('modified', options);
	      }
	    },

	    /**
	     * Mutate option object in order to add by property and give back the event name.
	     * @private
	     * @deprecated since 4.2.0
	     * @param {Object} options to mutate
	     * @param {Object} transform to inspect action from
	     */
	    _addEventOptions: function(options, transform) {
	      // we can probably add more details at low cost
	      // scale change, rotation changes, translation changes
	      var eventName, by;
	      switch (transform.action) {
	        case 'scaleX':
	          eventName = 'scaled';
	          by = 'x';
	          break;
	        case 'scaleY':
	          eventName = 'scaled';
	          by = 'y';
	          break;
	        case 'skewX':
	          eventName = 'skewed';
	          by = 'x';
	          break;
	        case 'skewY':
	          eventName = 'skewed';
	          by = 'y';
	          break;
	        case 'scale':
	          eventName = 'scaled';
	          by = 'equally';
	          break;
	        case 'rotate':
	          eventName = 'rotated';
	          break;
	        case 'drag':
	          eventName = 'moved';
	          break;
	      }
	      options.by = by;
	      return eventName;
	    },

	    /**
	     * @private
	     * @param {Event} e Event object fired on mousedown
	     */
	    _onMouseDownInDrawingMode: function(e) {
	      this._isCurrentlyDrawing = true;
	      if (this.getActiveObject()) {
	        this.discardActiveObject(e).requestRenderAll();
	      }
	      var pointer = this.getPointer(e);
	      this.freeDrawingBrush.onMouseDown(pointer, { e: e, pointer: pointer });
	      this._handleEvent(e, 'down');
	    },

	    /**
	     * @private
	     * @param {Event} e Event object fired on mousemove
	     */
	    _onMouseMoveInDrawingMode: function(e) {
	      if (this._isCurrentlyDrawing) {
	        var pointer = this.getPointer(e);
	        this.freeDrawingBrush.onMouseMove(pointer, { e: e, pointer: pointer });
	      }
	      this.setCursor(this.freeDrawingCursor);
	      this._handleEvent(e, 'move');
	    },

	    /**
	     * @private
	     * @param {Event} e Event object fired on mouseup
	     */
	    _onMouseUpInDrawingMode: function(e) {
	      var pointer = this.getPointer(e);
	      this._isCurrentlyDrawing = this.freeDrawingBrush.onMouseUp({ e: e, pointer: pointer });
	      this._handleEvent(e, 'up');
	    },

	    /**
	     * Method that defines the actions when mouse is clicked on canvas.
	     * The method inits the currentTransform parameters and renders all the
	     * canvas so the current image can be placed on the top canvas and the rest
	     * in on the container one.
	     * @private
	     * @param {Event} e Event object fired on mousedown
	     */
	    __onMouseDown: function (e) {
	      this._cacheTransformEventData(e);
	      this._handleEvent(e, 'down:before');
	      var target = this._target;
	      // if right click just fire events
	      if (checkClick(e, RIGHT_CLICK)) {
	        if (this.fireRightClick) {
	          this._handleEvent(e, 'down', RIGHT_CLICK);
	        }
	        return;
	      }

	      if (checkClick(e, MIDDLE_CLICK)) {
	        if (this.fireMiddleClick) {
	          this._handleEvent(e, 'down', MIDDLE_CLICK);
	        }
	        return;
	      }

	      if (this.isDrawingMode) {
	        this._onMouseDownInDrawingMode(e);
	        return;
	      }

	      if (!this._isMainEvent(e)) {
	        return;
	      }

	      // ignore if some object is being transformed at this moment
	      if (this._currentTransform) {
	        return;
	      }

	      var pointer = this._pointer;
	      // save pointer for check in __onMouseUp event
	      this._previousPointer = pointer;
	      var shouldRender = this._shouldRender(target),
	          shouldGroup = this._shouldGroup(e, target);
	      if (this._shouldClearSelection(e, target)) {
	        this.discardActiveObject(e);
	      }
	      else if (shouldGroup) {
	        this._handleGrouping(e, target);
	        target = this._activeObject;
	      }

	      if (this.selection && (!target ||
	        (!target.selectable && !target.isEditing && target !== this._activeObject))) {
	        this._groupSelector = {
	          ex: this._absolutePointer.x,
	          ey: this._absolutePointer.y,
	          top: 0,
	          left: 0
	        };
	      }

	      if (target) {
	        var alreadySelected = target === this._activeObject;
	        if (target.selectable && target.activeOn === 'down') {
	          this.setActiveObject(target, e);
	        }
	        var corner = target._findTargetCorner(
	          this.getPointer(e, true),
	          fabric.util.isTouchEvent(e)
	        );
	        target.__corner = corner;
	        if (target === this._activeObject && (corner || !shouldGroup)) {
	          this._setupCurrentTransform(e, target, alreadySelected);
	          var control = target.controls[corner],
	              pointer = this.getPointer(e),
	              mouseDownHandler = control && control.getMouseDownHandler(e, target, control);
	          if (mouseDownHandler) {
	            mouseDownHandler(e, this._currentTransform, pointer.x, pointer.y);
	          }
	        }
	      }
	      this._handleEvent(e, 'down');
	      // we must renderAll so that we update the visuals
	      (shouldRender || shouldGroup) && this.requestRenderAll();
	    },

	    /**
	     * reset cache form common information needed during event processing
	     * @private
	     */
	    _resetTransformEventData: function() {
	      this._target = null;
	      this._pointer = null;
	      this._absolutePointer = null;
	    },

	    /**
	     * Cache common information needed during event processing
	     * @private
	     * @param {Event} e Event object fired on event
	     */
	    _cacheTransformEventData: function(e) {
	      // reset in order to avoid stale caching
	      this._resetTransformEventData();
	      this._pointer = this.getPointer(e, true);
	      this._absolutePointer = this.restorePointerVpt(this._pointer);
	      this._target = this._currentTransform ? this._currentTransform.target : this.findTarget(e) || null;
	    },

	    /**
	     * @private
	     */
	    _beforeTransform: function(e) {
	      var t = this._currentTransform;
	      this.stateful && t.target.saveState();
	      this.fire('before:transform', {
	        e: e,
	        transform: t,
	      });
	    },

	    /**
	     * Method that defines the actions when mouse is hovering the canvas.
	     * The currentTransform parameter will define whether the user is rotating/scaling/translating
	     * an image or neither of them (only hovering). A group selection is also possible and would cancel
	     * all any other type of action.
	     * In case of an image transformation only the top canvas will be rendered.
	     * @private
	     * @param {Event} e Event object fired on mousemove
	     */
	    __onMouseMove: function (e) {
	      this._handleEvent(e, 'move:before');
	      this._cacheTransformEventData(e);
	      var target, pointer;

	      if (this.isDrawingMode) {
	        this._onMouseMoveInDrawingMode(e);
	        return;
	      }

	      if (!this._isMainEvent(e)) {
	        return;
	      }

	      var groupSelector = this._groupSelector;

	      // We initially clicked in an empty area, so we draw a box for multiple selection
	      if (groupSelector) {
	        pointer = this._absolutePointer;

	        groupSelector.left = pointer.x - groupSelector.ex;
	        groupSelector.top = pointer.y - groupSelector.ey;

	        this.renderTop();
	      }
	      else if (!this._currentTransform) {
	        target = this.findTarget(e) || null;
	        this._setCursorFromEvent(e, target);
	        this._fireOverOutEvents(target, e);
	      }
	      else {
	        this._transformObject(e);
	      }
	      this._handleEvent(e, 'move');
	      this._resetTransformEventData();
	    },

	    /**
	     * Manage the mouseout, mouseover events for the fabric object on the canvas
	     * @param {Fabric.Object} target the target where the target from the mousemove event
	     * @param {Event} e Event object fired on mousemove
	     * @private
	     */
	    _fireOverOutEvents: function(target, e) {
	      var _hoveredTarget = this._hoveredTarget,
	          _hoveredTargets = this._hoveredTargets, targets = this.targets,
	          length = Math.max(_hoveredTargets.length, targets.length);

	      this.fireSyntheticInOutEvents(target, e, {
	        oldTarget: _hoveredTarget,
	        evtOut: 'mouseout',
	        canvasEvtOut: 'mouse:out',
	        evtIn: 'mouseover',
	        canvasEvtIn: 'mouse:over',
	      });
	      for (var i = 0; i < length; i++){
	        this.fireSyntheticInOutEvents(targets[i], e, {
	          oldTarget: _hoveredTargets[i],
	          evtOut: 'mouseout',
	          evtIn: 'mouseover',
	        });
	      }
	      this._hoveredTarget = target;
	      this._hoveredTargets = this.targets.concat();
	    },

	    /**
	     * Manage the dragEnter, dragLeave events for the fabric objects on the canvas
	     * @param {Fabric.Object} target the target where the target from the onDrag event
	     * @param {Event} e Event object fired on ondrag
	     * @private
	     */
	    _fireEnterLeaveEvents: function(target, e) {
	      var _draggedoverTarget = this._draggedoverTarget,
	          _hoveredTargets = this._hoveredTargets, targets = this.targets,
	          length = Math.max(_hoveredTargets.length, targets.length);

	      this.fireSyntheticInOutEvents(target, e, {
	        oldTarget: _draggedoverTarget,
	        evtOut: 'dragleave',
	        evtIn: 'dragenter',
	      });
	      for (var i = 0; i < length; i++) {
	        this.fireSyntheticInOutEvents(targets[i], e, {
	          oldTarget: _hoveredTargets[i],
	          evtOut: 'dragleave',
	          evtIn: 'dragenter',
	        });
	      }
	      this._draggedoverTarget = target;
	    },

	    /**
	     * Manage the synthetic in/out events for the fabric objects on the canvas
	     * @param {Fabric.Object} target the target where the target from the supported events
	     * @param {Event} e Event object fired
	     * @param {Object} config configuration for the function to work
	     * @param {String} config.targetName property on the canvas where the old target is stored
	     * @param {String} [config.canvasEvtOut] name of the event to fire at canvas level for out
	     * @param {String} config.evtOut name of the event to fire for out
	     * @param {String} [config.canvasEvtIn] name of the event to fire at canvas level for in
	     * @param {String} config.evtIn name of the event to fire for in
	     * @private
	     */
	    fireSyntheticInOutEvents: function(target, e, config) {
	      var inOpt, outOpt, oldTarget = config.oldTarget, outFires, inFires,
	          targetChanged = oldTarget !== target, canvasEvtIn = config.canvasEvtIn, canvasEvtOut = config.canvasEvtOut;
	      if (targetChanged) {
	        inOpt = { e: e, target: target, previousTarget: oldTarget };
	        outOpt = { e: e, target: oldTarget, nextTarget: target };
	      }
	      inFires = target && targetChanged;
	      outFires = oldTarget && targetChanged;
	      if (outFires) {
	        canvasEvtOut && this.fire(canvasEvtOut, outOpt);
	        oldTarget.fire(config.evtOut, outOpt);
	      }
	      if (inFires) {
	        canvasEvtIn && this.fire(canvasEvtIn, inOpt);
	        target.fire(config.evtIn, inOpt);
	      }
	    },

	    /**
	     * Method that defines actions when an Event Mouse Wheel
	     * @param {Event} e Event object fired on mouseup
	     */
	    __onMouseWheel: function(e) {
	      this._cacheTransformEventData(e);
	      this._handleEvent(e, 'wheel');
	      this._resetTransformEventData();
	    },

	    /**
	     * @private
	     * @param {Event} e Event fired on mousemove
	     */
	    _transformObject: function(e) {
	      var pointer = this.getPointer(e),
	          transform = this._currentTransform;

	      transform.reset = false;
	      transform.shiftKey = e.shiftKey;
	      transform.altKey = e[this.centeredKey];

	      this._performTransformAction(e, transform, pointer);
	      transform.actionPerformed && this.requestRenderAll();
	    },

	    /**
	     * @private
	     */
	    _performTransformAction: function(e, transform, pointer) {
	      var x = pointer.x,
	          y = pointer.y,
	          action = transform.action,
	          actionPerformed = false,
	          actionHandler = transform.actionHandler;
	          // this object could be created from the function in the control handlers


	      if (actionHandler) {
	        actionPerformed = actionHandler(e, transform, x, y);
	      }
	      if (action === 'drag' && actionPerformed) {
	        transform.target.isMoving = true;
	        this.setCursor(transform.target.moveCursor || this.moveCursor);
	      }
	      transform.actionPerformed = transform.actionPerformed || actionPerformed;
	    },

	    /**
	     * @private
	     */
	    _fire: fabric.controlsUtils.fireEvent,

	    /**
	     * Sets the cursor depending on where the canvas is being hovered.
	     * Note: very buggy in Opera
	     * @param {Event} e Event object
	     * @param {Object} target Object that the mouse is hovering, if so.
	     */
	    _setCursorFromEvent: function (e, target) {
	      if (!target) {
	        this.setCursor(this.defaultCursor);
	        return false;
	      }
	      var hoverCursor = target.hoverCursor || this.hoverCursor,
	          activeSelection = this._activeObject && this._activeObject.type === 'activeSelection' ?
	            this._activeObject : null,
	          // only show proper corner when group selection is not active
	          corner = (!activeSelection || !activeSelection.contains(target))
	          // here we call findTargetCorner always with undefined for the touch parameter.
	          // we assume that if you are using a cursor you do not need to interact with
	          // the bigger touch area.
	                    && target._findTargetCorner(this.getPointer(e, true));

	      if (!corner) {
	        if (target.subTargetCheck){
	          // hoverCursor should come from top-most subTarget,
	          // so we walk the array backwards
	          this.targets.concat().reverse().map(function(_target){
	            hoverCursor = _target.hoverCursor || hoverCursor;
	          });
	        }
	        this.setCursor(hoverCursor);
	      }
	      else {
	        this.setCursor(this.getCornerCursor(corner, target, e));
	      }
	    },

	    /**
	     * @private
	     */
	    getCornerCursor: function(corner, target, e) {
	      var control = target.controls[corner];
	      return control.cursorStyleHandler(e, control, target);
	    }
	  });
	})();


	(function() {

	  var min = Math.min,
	      max = Math.max;

	  fabric.util.object.extend(fabric.Canvas.prototype, /** @lends fabric.Canvas.prototype */ {

	    /**
	     * @private
	     * @param {Event} e Event object
	     * @param {fabric.Object} target
	     * @return {Boolean}
	     */
	    _shouldGroup: function(e, target) {
	      var activeObject = this._activeObject;
	      return activeObject && this._isSelectionKeyPressed(e) && target && target.selectable && this.selection &&
	            (activeObject !== target || activeObject.type === 'activeSelection') && !target.onSelect({ e: e });
	    },

	    /**
	     * @private
	     * @param {Event} e Event object
	     * @param {fabric.Object} target
	     */
	    _handleGrouping: function (e, target) {
	      var activeObject = this._activeObject;
	      // avoid multi select when shift click on a corner
	      if (activeObject.__corner) {
	        return;
	      }
	      if (target === activeObject) {
	        // if it's a group, find target again, using activeGroup objects
	        target = this.findTarget(e, true);
	        // if even object is not found or we are on activeObjectCorner, bail out
	        if (!target || !target.selectable) {
	          return;
	        }
	      }
	      if (activeObject && activeObject.type === 'activeSelection') {
	        this._updateActiveSelection(target, e);
	      }
	      else {
	        this._createActiveSelection(target, e);
	      }
	    },

	    /**
	     * @private
	     */
	    _updateActiveSelection: function(target, e) {
	      var activeSelection = this._activeObject,
	          currentActiveObjects = activeSelection._objects.slice(0);
	      if (activeSelection.contains(target)) {
	        activeSelection.removeWithUpdate(target);
	        this._hoveredTarget = target;
	        this._hoveredTargets = this.targets.concat();
	        if (activeSelection.size() === 1) {
	          // activate last remaining object
	          this._setActiveObject(activeSelection.item(0), e);
	        }
	      }
	      else {
	        activeSelection.addWithUpdate(target);
	        this._hoveredTarget = activeSelection;
	        this._hoveredTargets = this.targets.concat();
	      }
	      this._fireSelectionEvents(currentActiveObjects, e);
	    },

	    /**
	     * @private
	     */
	    _createActiveSelection: function(target, e) {
	      var currentActives = this.getActiveObjects(), group = this._createGroup(target);
	      this._hoveredTarget = group;
	      // ISSUE 4115: should we consider subTargets here?
	      // this._hoveredTargets = [];
	      // this._hoveredTargets = this.targets.concat();
	      this._setActiveObject(group, e);
	      this._fireSelectionEvents(currentActives, e);
	    },

	    /**
	     * @private
	     * @param {Object} target
	     */
	    _createGroup: function(target) {
	      var objects = this._objects,
	          isActiveLower = objects.indexOf(this._activeObject) < objects.indexOf(target),
	          groupObjects = isActiveLower
	            ? [this._activeObject, target]
	            : [target, this._activeObject];
	      this._activeObject.isEditing && this._activeObject.exitEditing();
	      return new fabric.ActiveSelection(groupObjects, {
	        canvas: this
	      });
	    },

	    /**
	     * @private
	     * @param {Event} e mouse event
	     */
	    _groupSelectedObjects: function (e) {

	      var group = this._collectObjects(e),
	          aGroup;

	      // do not create group for 1 element only
	      if (group.length === 1) {
	        this.setActiveObject(group[0], e);
	      }
	      else if (group.length > 1) {
	        aGroup = new fabric.ActiveSelection(group.reverse(), {
	          canvas: this
	        });
	        this.setActiveObject(aGroup, e);
	      }
	    },

	    /**
	     * @private
	     */
	    _collectObjects: function(e) {
	      var group = [],
	          currentObject,
	          x1 = this._groupSelector.ex,
	          y1 = this._groupSelector.ey,
	          x2 = x1 + this._groupSelector.left,
	          y2 = y1 + this._groupSelector.top,
	          selectionX1Y1 = new fabric.Point(min(x1, x2), min(y1, y2)),
	          selectionX2Y2 = new fabric.Point(max(x1, x2), max(y1, y2)),
	          allowIntersect = !this.selectionFullyContained,
	          isClick = x1 === x2 && y1 === y2;
	      // we iterate reverse order to collect top first in case of click.
	      for (var i = this._objects.length; i--; ) {
	        currentObject = this._objects[i];

	        if (!currentObject || !currentObject.selectable || !currentObject.visible) {
	          continue;
	        }

	        if ((allowIntersect && currentObject.intersectsWithRect(selectionX1Y1, selectionX2Y2, true)) ||
	            currentObject.isContainedWithinRect(selectionX1Y1, selectionX2Y2, true) ||
	            (allowIntersect && currentObject.containsPoint(selectionX1Y1, null, true)) ||
	            (allowIntersect && currentObject.containsPoint(selectionX2Y2, null, true))
	        ) {
	          group.push(currentObject);
	          // only add one object if it's a click
	          if (isClick) {
	            break;
	          }
	        }
	      }

	      if (group.length > 1) {
	        group = group.filter(function(object) {
	          return !object.onSelect({ e: e });
	        });
	      }

	      return group;
	    },

	    /**
	     * @private
	     */
	    _maybeGroupObjects: function(e) {
	      if (this.selection && this._groupSelector) {
	        this._groupSelectedObjects(e);
	      }
	      this.setCursor(this.defaultCursor);
	      // clear selection and current transformation
	      this._groupSelector = null;
	    }
	  });

	})();


	(function () {
	  fabric.util.object.extend(fabric.StaticCanvas.prototype, /** @lends fabric.StaticCanvas.prototype */ {

	    /**
	     * Exports canvas element to a dataurl image. Note that when multiplier is used, cropping is scaled appropriately
	     * @param {Object} [options] Options object
	     * @param {String} [options.format=png] The format of the output image. Either "jpeg" or "png"
	     * @param {Number} [options.quality=1] Quality level (0..1). Only used for jpeg.
	     * @param {Number} [options.multiplier=1] Multiplier to scale by, to have consistent
	     * @param {Number} [options.left] Cropping left offset. Introduced in v1.2.14
	     * @param {Number} [options.top] Cropping top offset. Introduced in v1.2.14
	     * @param {Number} [options.width] Cropping width. Introduced in v1.2.14
	     * @param {Number} [options.height] Cropping height. Introduced in v1.2.14
	     * @param {Boolean} [options.enableRetinaScaling] Enable retina scaling for clone image. Introduce in 2.0.0
	     * @return {String} Returns a data: URL containing a representation of the object in the format specified by options.format
	     * @see {@link http://jsfiddle.net/fabricjs/NfZVb/|jsFiddle demo}
	     * @example <caption>Generate jpeg dataURL with lower quality</caption>
	     * var dataURL = canvas.toDataURL({
	     *   format: 'jpeg',
	     *   quality: 0.8
	     * });
	     * @example <caption>Generate cropped png dataURL (clipping of canvas)</caption>
	     * var dataURL = canvas.toDataURL({
	     *   format: 'png',
	     *   left: 100,
	     *   top: 100,
	     *   width: 200,
	     *   height: 200
	     * });
	     * @example <caption>Generate double scaled png dataURL</caption>
	     * var dataURL = canvas.toDataURL({
	     *   format: 'png',
	     *   multiplier: 2
	     * });
	     */
	    toDataURL: function (options) {
	      options || (options = { });

	      var format = options.format || 'png',
	          quality = options.quality || 1,
	          multiplier = (options.multiplier || 1) * (options.enableRetinaScaling ? this.getRetinaScaling() : 1),
	          canvasEl = this.toCanvasElement(multiplier, options);
	      return fabric.util.toDataURL(canvasEl, format, quality);
	    },

	    /**
	     * Create a new HTMLCanvas element painted with the current canvas content.
	     * No need to resize the actual one or repaint it.
	     * Will transfer object ownership to a new canvas, paint it, and set everything back.
	     * This is an intermediary step used to get to a dataUrl but also it is useful to
	     * create quick image copies of a canvas without passing for the dataUrl string
	     * @param {Number} [multiplier] a zoom factor.
	     * @param {Object} [cropping] Cropping informations
	     * @param {Number} [cropping.left] Cropping left offset.
	     * @param {Number} [cropping.top] Cropping top offset.
	     * @param {Number} [cropping.width] Cropping width.
	     * @param {Number} [cropping.height] Cropping height.
	     */
	    toCanvasElement: function(multiplier, cropping) {
	      multiplier = multiplier || 1;
	      cropping = cropping || { };
	      var scaledWidth = (cropping.width || this.width) * multiplier,
	          scaledHeight = (cropping.height || this.height) * multiplier,
	          zoom = this.getZoom(),
	          originalWidth = this.width,
	          originalHeight = this.height,
	          newZoom = zoom * multiplier,
	          vp = this.viewportTransform,
	          translateX = (vp[4] - (cropping.left || 0)) * multiplier,
	          translateY = (vp[5] - (cropping.top || 0)) * multiplier,
	          originalInteractive = this.interactive,
	          newVp = [newZoom, 0, 0, newZoom, translateX, translateY],
	          originalRetina = this.enableRetinaScaling,
	          canvasEl = fabric.util.createCanvasElement(),
	          originalContextTop = this.contextTop;
	      canvasEl.width = scaledWidth;
	      canvasEl.height = scaledHeight;
	      this.contextTop = null;
	      this.enableRetinaScaling = false;
	      this.interactive = false;
	      this.viewportTransform = newVp;
	      this.width = scaledWidth;
	      this.height = scaledHeight;
	      this.calcViewportBoundaries();
	      this.renderCanvas(canvasEl.getContext('2d'), this._objects);
	      this.viewportTransform = vp;
	      this.width = originalWidth;
	      this.height = originalHeight;
	      this.calcViewportBoundaries();
	      this.interactive = originalInteractive;
	      this.enableRetinaScaling = originalRetina;
	      this.contextTop = originalContextTop;
	      return canvasEl;
	    },
	  });

	})();


	fabric.util.object.extend(fabric.StaticCanvas.prototype, /** @lends fabric.StaticCanvas.prototype */ {
	  /**
	   * Populates canvas with data from the specified JSON.
	   * JSON format must conform to the one of {@link fabric.Canvas#toJSON}
	   * @param {String|Object} json JSON string or object
	   * @param {Function} callback Callback, invoked when json is parsed
	   *                            and corresponding objects (e.g: {@link fabric.Image})
	   *                            are initialized
	   * @param {Function} [reviver] Method for further parsing of JSON elements, called after each fabric object created.
	   * @return {fabric.Canvas} instance
	   * @chainable
	   * @tutorial {@link http://fabricjs.com/fabric-intro-part-3#deserialization}
	   * @see {@link http://jsfiddle.net/fabricjs/fmgXt/|jsFiddle demo}
	   * @example <caption>loadFromJSON</caption>
	   * canvas.loadFromJSON(json, canvas.renderAll.bind(canvas));
	   * @example <caption>loadFromJSON with reviver</caption>
	   * canvas.loadFromJSON(json, canvas.renderAll.bind(canvas), function(o, object) {
	   *   // `o` = json object
	   *   // `object` = fabric.Object instance
	   *   // ... do some stuff ...
	   * });
	   */
	  loadFromJSON: function (json, callback, reviver) {
	    if (!json) {
	      return;
	    }

	    // serialize if it wasn't already
	    var serialized = (typeof json === 'string')
	      ? JSON.parse(json)
	      : fabric.util.object.clone(json);

	    var _this = this,
	        clipPath = serialized.clipPath,
	        renderOnAddRemove = this.renderOnAddRemove;

	    this.renderOnAddRemove = false;

	    delete serialized.clipPath;

	    this._enlivenObjects(serialized.objects, function (enlivenedObjects) {
	      _this.clear();
	      _this._setBgOverlay(serialized, function () {
	        if (clipPath) {
	          _this._enlivenObjects([clipPath], function (enlivenedCanvasClip) {
	            _this.clipPath = enlivenedCanvasClip[0];
	            _this.__setupCanvas.call(_this, serialized, enlivenedObjects, renderOnAddRemove, callback);
	          });
	        }
	        else {
	          _this.__setupCanvas.call(_this, serialized, enlivenedObjects, renderOnAddRemove, callback);
	        }
	      });
	    }, reviver);
	    return this;
	  },

	  /**
	   * @private
	   * @param {Object} serialized Object with background and overlay information
	   * @param {Array} restored canvas objects
	   * @param {Function} cached renderOnAddRemove callback
	   * @param {Function} callback Invoked after all background and overlay images/patterns loaded
	   */
	  __setupCanvas: function(serialized, enlivenedObjects, renderOnAddRemove, callback) {
	    var _this = this;
	    enlivenedObjects.forEach(function(obj, index) {
	      // we splice the array just in case some custom classes restored from JSON
	      // will add more object to canvas at canvas init.
	      _this.insertAt(obj, index);
	    });
	    this.renderOnAddRemove = renderOnAddRemove;
	    // remove parts i cannot set as options
	    delete serialized.objects;
	    delete serialized.backgroundImage;
	    delete serialized.overlayImage;
	    delete serialized.background;
	    delete serialized.overlay;
	    // this._initOptions does too many things to just
	    // call it. Normally loading an Object from JSON
	    // create the Object instance. Here the Canvas is
	    // already an instance and we are just loading things over it
	    this._setOptions(serialized);
	    this.renderAll();
	    callback && callback();
	  },

	  /**
	   * @private
	   * @param {Object} serialized Object with background and overlay information
	   * @param {Function} callback Invoked after all background and overlay images/patterns loaded
	   */
	  _setBgOverlay: function(serialized, callback) {
	    var loaded = {
	      backgroundColor: false,
	      overlayColor: false,
	      backgroundImage: false,
	      overlayImage: false
	    };

	    if (!serialized.backgroundImage && !serialized.overlayImage && !serialized.background && !serialized.overlay) {
	      callback && callback();
	      return;
	    }

	    var cbIfLoaded = function () {
	      if (loaded.backgroundImage && loaded.overlayImage && loaded.backgroundColor && loaded.overlayColor) {
	        callback && callback();
	      }
	    };

	    this.__setBgOverlay('backgroundImage', serialized.backgroundImage, loaded, cbIfLoaded);
	    this.__setBgOverlay('overlayImage', serialized.overlayImage, loaded, cbIfLoaded);
	    this.__setBgOverlay('backgroundColor', serialized.background, loaded, cbIfLoaded);
	    this.__setBgOverlay('overlayColor', serialized.overlay, loaded, cbIfLoaded);
	  },

	  /**
	   * @private
	   * @param {String} property Property to set (backgroundImage, overlayImage, backgroundColor, overlayColor)
	   * @param {(Object|String)} value Value to set
	   * @param {Object} loaded Set loaded property to true if property is set
	   * @param {Object} callback Callback function to invoke after property is set
	   */
	  __setBgOverlay: function(property, value, loaded, callback) {
	    var _this = this;

	    if (!value) {
	      loaded[property] = true;
	      callback && callback();
	      return;
	    }

	    if (property === 'backgroundImage' || property === 'overlayImage') {
	      fabric.util.enlivenObjects([value], function(enlivedObject){
	        _this[property] = enlivedObject[0];
	        loaded[property] = true;
	        callback && callback();
	      });
	    }
	    else {
	      this['set' + fabric.util.string.capitalize(property, true)](value, function() {
	        loaded[property] = true;
	        callback && callback();
	      });
	    }
	  },

	  /**
	   * @private
	   * @param {Array} objects
	   * @param {Function} callback
	   * @param {Function} [reviver]
	   */
	  _enlivenObjects: function (objects, callback, reviver) {
	    if (!objects || objects.length === 0) {
	      callback && callback([]);
	      return;
	    }

	    fabric.util.enlivenObjects(objects, function(enlivenedObjects) {
	      callback && callback(enlivenedObjects);
	    }, null, reviver);
	  },

	  /**
	   * @private
	   * @param {String} format
	   * @param {Function} callback
	   */
	  _toDataURL: function (format, callback) {
	    this.clone(function (clone) {
	      callback(clone.toDataURL(format));
	    });
	  },

	  /**
	   * @private
	   * @param {String} format
	   * @param {Number} multiplier
	   * @param {Function} callback
	   */
	  _toDataURLWithMultiplier: function (format, multiplier, callback) {
	    this.clone(function (clone) {
	      callback(clone.toDataURLWithMultiplier(format, multiplier));
	    });
	  },

	  /**
	   * Clones canvas instance
	   * @param {Object} [callback] Receives cloned instance as a first argument
	   * @param {Array} [properties] Array of properties to include in the cloned canvas and children
	   */
	  clone: function (callback, properties) {
	    var data = JSON.stringify(this.toJSON(properties));
	    this.cloneWithoutData(function(clone) {
	      clone.loadFromJSON(data, function() {
	        callback && callback(clone);
	      });
	    });
	  },

	  /**
	   * Clones canvas instance without cloning existing data.
	   * This essentially copies canvas dimensions, clipping properties, etc.
	   * but leaves data empty (so that you can populate it with your own)
	   * @param {Object} [callback] Receives cloned instance as a first argument
	   */
	  cloneWithoutData: function(callback) {
	    var el = fabric.util.createCanvasElement();

	    el.width = this.width;
	    el.height = this.height;

	    var clone = new fabric.Canvas(el);
	    if (this.backgroundImage) {
	      clone.setBackgroundImage(this.backgroundImage.src, function() {
	        clone.renderAll();
	        callback && callback(clone);
	      });
	      clone.backgroundImageOpacity = this.backgroundImageOpacity;
	      clone.backgroundImageStretch = this.backgroundImageStretch;
	    }
	    else {
	      callback && callback(clone);
	    }
	  }
	});


	(function(global) {

	  var fabric = global.fabric || (global.fabric = { }),
	      extend = fabric.util.object.extend,
	      clone = fabric.util.object.clone,
	      toFixed = fabric.util.toFixed,
	      capitalize = fabric.util.string.capitalize,
	      degreesToRadians = fabric.util.degreesToRadians,
	      objectCaching = !fabric.isLikelyNode,
	      ALIASING_LIMIT = 2;

	  if (fabric.Object) {
	    return;
	  }

	  /**
	   * Root object class from which all 2d shape classes inherit from
	   * @class fabric.Object
	   * @tutorial {@link http://fabricjs.com/fabric-intro-part-1#objects}
	   * @see {@link fabric.Object#initialize} for constructor definition
	   *
	   * @fires added
	   * @fires removed
	   *
	   * @fires selected
	   * @fires deselected
	   * @fires modified
	   * @fires modified
	   * @fires moved
	   * @fires scaled
	   * @fires rotated
	   * @fires skewed
	   *
	   * @fires rotating
	   * @fires scaling
	   * @fires moving
	   * @fires skewing
	   *
	   * @fires mousedown
	   * @fires mouseup
	   * @fires mouseover
	   * @fires mouseout
	   * @fires mousewheel
	   * @fires mousedblclick
	   *
	   * @fires dragover
	   * @fires dragenter
	   * @fires dragleave
	   * @fires drop
	   */
	  fabric.Object = fabric.util.createClass(fabric.CommonMethods, /** @lends fabric.Object.prototype */ {

	    /**
	     * Type of an object (rect, circle, path, etc.).
	     * Note that this property is meant to be read-only and not meant to be modified.
	     * If you modify, certain parts of Fabric (such as JSON loading) won't work correctly.
	     * @type String
	     * @default
	     */
	    type:                     'object',

	    /**
	     * Horizontal origin of transformation of an object (one of "left", "right", "center")
	     * See http://jsfiddle.net/1ow02gea/244/ on how originX/originY affect objects in groups
	     * @type String
	     * @default
	     */
	    originX:                  'left',

	    /**
	     * Vertical origin of transformation of an object (one of "top", "bottom", "center")
	     * See http://jsfiddle.net/1ow02gea/244/ on how originX/originY affect objects in groups
	     * @type String
	     * @default
	     */
	    originY:                  'top',

	    /**
	     * Top position of an object. Note that by default it's relative to object top. You can change this by setting originY={top/center/bottom}
	     * @type Number
	     * @default
	     */
	    top:                      0,

	    /**
	     * Left position of an object. Note that by default it's relative to object left. You can change this by setting originX={left/center/right}
	     * @type Number
	     * @default
	     */
	    left:                     0,

	    /**
	     * Object width
	     * @type Number
	     * @default
	     */
	    width:                    0,

	    /**
	     * Object height
	     * @type Number
	     * @default
	     */
	    height:                   0,

	    /**
	     * Object scale factor (horizontal)
	     * @type Number
	     * @default
	     */
	    scaleX:                   1,

	    /**
	     * Object scale factor (vertical)
	     * @type Number
	     * @default
	     */
	    scaleY:                   1,

	    /**
	     * When true, an object is rendered as flipped horizontally
	     * @type Boolean
	     * @default
	     */
	    flipX:                    false,

	    /**
	     * When true, an object is rendered as flipped vertically
	     * @type Boolean
	     * @default
	     */
	    flipY:                    false,

	    /**
	     * Opacity of an object
	     * @type Number
	     * @default
	     */
	    opacity:                  1,

	    /**
	     * Angle of rotation of an object (in degrees)
	     * @type Number
	     * @default
	     */
	    angle:                    0,

	    /**
	     * Angle of skew on x axes of an object (in degrees)
	     * @type Number
	     * @default
	     */
	    skewX:                    0,

	    /**
	     * Angle of skew on y axes of an object (in degrees)
	     * @type Number
	     * @default
	     */
	    skewY:                    0,

	    /**
	     * Size of object's controlling corners (in pixels)
	     * @type Number
	     * @default
	     */
	    cornerSize:               13,

	    /**
	     * Size of object's controlling corners when touch interaction is detected
	     * @type Number
	     * @default
	     */
	    touchCornerSize:               24,

	    /**
	     * When true, object's controlling corners are rendered as transparent inside (i.e. stroke instead of fill)
	     * @type Boolean
	     * @default
	     */
	    transparentCorners:       true,

	    /**
	     * Default cursor value used when hovering over this object on canvas
	     * @type String
	     * @default
	     */
	    hoverCursor:              null,

	    /**
	     * Default cursor value used when moving this object on canvas
	     * @type String
	     * @default
	     */
	    moveCursor:               null,

	    /**
	     * Padding between object and its controlling borders (in pixels)
	     * @type Number
	     * @default
	     */
	    padding:                  0,

	    /**
	     * Color of controlling borders of an object (when it's active)
	     * @type String
	     * @default
	     */
	    borderColor:              'rgb(178,204,255)',

	    /**
	     * Array specifying dash pattern of an object's borders (hasBorder must be true)
	     * @since 1.6.2
	     * @type Array
	     */
	    borderDashArray:          null,

	    /**
	     * Color of controlling corners of an object (when it's active)
	     * @type String
	     * @default
	     */
	    cornerColor:              'rgb(178,204,255)',

	    /**
	     * Color of controlling corners of an object (when it's active and transparentCorners false)
	     * @since 1.6.2
	     * @type String
	     * @default
	     */
	    cornerStrokeColor:        null,

	    /**
	     * Specify style of control, 'rect' or 'circle'
	     * @since 1.6.2
	     * @type String
	     */
	    cornerStyle:          'rect',

	    /**
	     * Array specifying dash pattern of an object's control (hasBorder must be true)
	     * @since 1.6.2
	     * @type Array
	     */
	    cornerDashArray:          null,

	    /**
	     * When true, this object will use center point as the origin of transformation
	     * when being scaled via the controls.
	     * <b>Backwards incompatibility note:</b> This property replaces "centerTransform" (Boolean).
	     * @since 1.3.4
	     * @type Boolean
	     * @default
	     */
	    centeredScaling:          false,

	    /**
	     * When true, this object will use center point as the origin of transformation
	     * when being rotated via the controls.
	     * <b>Backwards incompatibility note:</b> This property replaces "centerTransform" (Boolean).
	     * @since 1.3.4
	     * @type Boolean
	     * @default
	     */
	    centeredRotation:         true,

	    /**
	     * Color of object's fill
	     * takes css colors https://www.w3.org/TR/css-color-3/
	     * @type String
	     * @default
	     */
	    fill:                     'rgb(0,0,0)',

	    /**
	     * Fill rule used to fill an object
	     * accepted values are nonzero, evenodd
	     * <b>Backwards incompatibility note:</b> This property was used for setting globalCompositeOperation until v1.4.12 (use `fabric.Object#globalCompositeOperation` instead)
	     * @type String
	     * @default
	     */
	    fillRule:                 'nonzero',

	    /**
	     * Composite rule used for canvas globalCompositeOperation
	     * @type String
	     * @default
	     */
	    globalCompositeOperation: 'source-over',

	    /**
	     * Background color of an object.
	     * takes css colors https://www.w3.org/TR/css-color-3/
	     * @type String
	     * @default
	     */
	    backgroundColor:          '',

	    /**
	     * Selection Background color of an object. colored layer behind the object when it is active.
	     * does not mix good with globalCompositeOperation methods.
	     * @type String
	     * @default
	     */
	    selectionBackgroundColor:          '',

	    /**
	     * When defined, an object is rendered via stroke and this property specifies its color
	     * takes css colors https://www.w3.org/TR/css-color-3/
	     * @type String
	     * @default
	     */
	    stroke:                   null,

	    /**
	     * Width of a stroke used to render this object
	     * @type Number
	     * @default
	     */
	    strokeWidth:              1,

	    /**
	     * Array specifying dash pattern of an object's stroke (stroke must be defined)
	     * @type Array
	     */
	    strokeDashArray:          null,

	    /**
	     * Line offset of an object's stroke
	     * @type Number
	     * @default
	     */
	    strokeDashOffset: 0,

	    /**
	     * Line endings style of an object's stroke (one of "butt", "round", "square")
	     * @type String
	     * @default
	     */
	    strokeLineCap:            'butt',

	    /**
	     * Corner style of an object's stroke (one of "bevel", "round", "miter")
	     * @type String
	     * @default
	     */
	    strokeLineJoin:           'miter',

	    /**
	     * Maximum miter length (used for strokeLineJoin = "miter") of an object's stroke
	     * @type Number
	     * @default
	     */
	    strokeMiterLimit:         4,

	    /**
	     * Shadow object representing shadow of this shape
	     * @type fabric.Shadow
	     * @default
	     */
	    shadow:                   null,

	    /**
	     * Opacity of object's controlling borders when object is active and moving
	     * @type Number
	     * @default
	     */
	    borderOpacityWhenMoving:  0.4,

	    /**
	     * Scale factor of object's controlling borders
	     * bigger number will make a thicker border
	     * border is 1, so this is basically a border thickness
	     * since there is no way to change the border itself.
	     * @type Number
	     * @default
	     */
	    borderScaleFactor:        1,

	    /**
	     * Minimum allowed scale value of an object
	     * @type Number
	     * @default
	     */
	    minScaleLimit:            0,

	    /**
	     * When set to `false`, an object can not be selected for modification (using either point-click-based or group-based selection).
	     * But events still fire on it.
	     * @type Boolean
	     * @default
	     */
	    selectable:               true,

	    /**
	     * When set to `false`, an object can not be a target of events. All events propagate through it. Introduced in v1.3.4
	     * @type Boolean
	     * @default
	     */
	    evented:                  true,

	    /**
	     * When set to `false`, an object is not rendered on canvas
	     * @type Boolean
	     * @default
	     */
	    visible:                  true,

	    /**
	     * When set to `false`, object's controls are not displayed and can not be used to manipulate object
	     * @type Boolean
	     * @default
	     */
	    hasControls:              true,

	    /**
	     * When set to `false`, object's controlling borders are not rendered
	     * @type Boolean
	     * @default
	     */
	    hasBorders:               true,

	    /**
	     * When set to `true`, objects are "found" on canvas on per-pixel basis rather than according to bounding box
	     * @type Boolean
	     * @default
	     */
	    perPixelTargetFind:       false,

	    /**
	     * When `false`, default object's values are not included in its serialization
	     * @type Boolean
	     * @default
	     */
	    includeDefaultValues:     true,

	    /**
	     * When `true`, object horizontal movement is locked
	     * @type Boolean
	     * @default
	     */
	    lockMovementX:            false,

	    /**
	     * When `true`, object vertical movement is locked
	     * @type Boolean
	     * @default
	     */
	    lockMovementY:            false,

	    /**
	     * When `true`, object rotation is locked
	     * @type Boolean
	     * @default
	     */
	    lockRotation:             false,

	    /**
	     * When `true`, object horizontal scaling is locked
	     * @type Boolean
	     * @default
	     */
	    lockScalingX:             false,

	    /**
	     * When `true`, object vertical scaling is locked
	     * @type Boolean
	     * @default
	     */
	    lockScalingY:             false,

	    /**
	     * When `true`, object horizontal skewing is locked
	     * @type Boolean
	     * @default
	     */
	    lockSkewingX:             false,

	    /**
	     * When `true`, object vertical skewing is locked
	     * @type Boolean
	     * @default
	     */
	    lockSkewingY:             false,

	    /**
	     * When `true`, object cannot be flipped by scaling into negative values
	     * @type Boolean
	     * @default
	     */
	    lockScalingFlip:          false,

	    /**
	     * When `true`, object is not exported in OBJECT/JSON
	     * @since 1.6.3
	     * @type Boolean
	     * @default
	     */
	    excludeFromExport:        false,

	    /**
	     * When `true`, object is cached on an additional canvas.
	     * When `false`, object is not cached unless necessary ( clipPath )
	     * default to true
	     * @since 1.7.0
	     * @type Boolean
	     * @default true
	     */
	    objectCaching:            objectCaching,

	    /**
	     * When `true`, object properties are checked for cache invalidation. In some particular
	     * situation you may want this to be disabled ( spray brush, very big, groups)
	     * or if your application does not allow you to modify properties for groups child you want
	     * to disable it for groups.
	     * default to false
	     * since 1.7.0
	     * @type Boolean
	     * @default false
	     */
	    statefullCache:            false,

	    /**
	     * When `true`, cache does not get updated during scaling. The picture will get blocky if scaled
	     * too much and will be redrawn with correct details at the end of scaling.
	     * this setting is performance and application dependant.
	     * default to true
	     * since 1.7.0
	     * @type Boolean
	     * @default true
	     */
	    noScaleCache:              true,

	    /**
	     * When `false`, the stoke width will scale with the object.
	     * When `true`, the stroke will always match the exact pixel size entered for stroke width.
	     * default to false
	     * @since 2.6.0
	     * @type Boolean
	     * @default false
	     * @type Boolean
	     * @default false
	     */
	    strokeUniform:              false,

	    /**
	     * When set to `true`, object's cache will be rerendered next render call.
	     * since 1.7.0
	     * @type Boolean
	     * @default true
	     */
	    dirty:                true,

	    /**
	     * keeps the value of the last hovered corner during mouse move.
	     * 0 is no corner, or 'mt', 'ml', 'mtr' etc..
	     * It should be private, but there is no harm in using it as
	     * a read-only property.
	     * @type number|string|any
	     * @default 0
	     */
	    __corner: 0,

	    /**
	     * Determines if the fill or the stroke is drawn first (one of "fill" or "stroke")
	     * @type String
	     * @default
	     */
	    paintFirst:           'fill',

	    /**
	     * When 'down', object is set to active on mousedown/touchstart
	     * When 'up', object is set to active on mouseup/touchend
	     * Experimental. Let's see if this breaks anything before supporting officially
	     * @private
	     * since 4.4.0
	     * @type String
	     * @default 'down'
	     */
	    activeOn:           'down',

	    /**
	     * List of properties to consider when checking if state
	     * of an object is changed (fabric.Object#hasStateChanged)
	     * as well as for history (undo/redo) purposes
	     * @type Array
	     */
	    stateProperties: (
	      'top left width height scaleX scaleY flipX flipY originX originY transformMatrix ' +
	      'stroke strokeWidth strokeDashArray strokeLineCap strokeDashOffset strokeLineJoin strokeMiterLimit ' +
	      'angle opacity fill globalCompositeOperation shadow visible backgroundColor ' +
	      'skewX skewY fillRule paintFirst clipPath strokeUniform'
	    ).split(' '),

	    /**
	     * List of properties to consider when checking if cache needs refresh
	     * Those properties are checked by statefullCache ON ( or lazy mode if we want ) or from single
	     * calls to Object.set(key, value). If the key is in this list, the object is marked as dirty
	     * and refreshed at the next render
	     * @type Array
	     */
	    cacheProperties: (
	      'fill stroke strokeWidth strokeDashArray width height paintFirst strokeUniform' +
	      ' strokeLineCap strokeDashOffset strokeLineJoin strokeMiterLimit backgroundColor clipPath'
	    ).split(' '),

	    /**
	     * List of properties to consider for animating colors.
	     * @type Array
	     */
	    colorProperties: (
	      'fill stroke backgroundColor'
	    ).split(' '),

	    /**
	     * a fabricObject that, without stroke define a clipping area with their shape. filled in black
	     * the clipPath object gets used when the object has rendered, and the context is placed in the center
	     * of the object cacheCanvas.
	     * If you want 0,0 of a clipPath to align with an object center, use clipPath.originX/Y to 'center'
	     * @type fabric.Object
	     */
	    clipPath: undefined,

	    /**
	     * Meaningful ONLY when the object is used as clipPath.
	     * if true, the clipPath will make the object clip to the outside of the clipPath
	     * since 2.4.0
	     * @type boolean
	     * @default false
	     */
	    inverted: false,

	    /**
	     * Meaningful ONLY when the object is used as clipPath.
	     * if true, the clipPath will have its top and left relative to canvas, and will
	     * not be influenced by the object transform. This will make the clipPath relative
	     * to the canvas, but clipping just a particular object.
	     * WARNING this is beta, this feature may change or be renamed.
	     * since 2.4.0
	     * @type boolean
	     * @default false
	     */
	    absolutePositioned: false,

	    /**
	     * Constructor
	     * @param {Object} [options] Options object
	     */
	    initialize: function(options) {
	      if (options) {
	        this.setOptions(options);
	      }
	    },

	    /**
	     * Create a the canvas used to keep the cached copy of the object
	     * @private
	     */
	    _createCacheCanvas: function() {
	      this._cacheProperties = {};
	      this._cacheCanvas = fabric.util.createCanvasElement();
	      this._cacheContext = this._cacheCanvas.getContext('2d');
	      this._updateCacheCanvas();
	      // if canvas gets created, is empty, so dirty.
	      this.dirty = true;
	    },

	    /**
	     * Limit the cache dimensions so that X * Y do not cross fabric.perfLimitSizeTotal
	     * and each side do not cross fabric.cacheSideLimit
	     * those numbers are configurable so that you can get as much detail as you want
	     * making bargain with performances.
	     * @param {Object} dims
	     * @param {Object} dims.width width of canvas
	     * @param {Object} dims.height height of canvas
	     * @param {Object} dims.zoomX zoomX zoom value to unscale the canvas before drawing cache
	     * @param {Object} dims.zoomY zoomY zoom value to unscale the canvas before drawing cache
	     * @return {Object}.width width of canvas
	     * @return {Object}.height height of canvas
	     * @return {Object}.zoomX zoomX zoom value to unscale the canvas before drawing cache
	     * @return {Object}.zoomY zoomY zoom value to unscale the canvas before drawing cache
	     */
	    _limitCacheSize: function(dims) {
	      var perfLimitSizeTotal = fabric.perfLimitSizeTotal,
	          width = dims.width, height = dims.height,
	          max = fabric.maxCacheSideLimit, min = fabric.minCacheSideLimit;
	      if (width <= max && height <= max && width * height <= perfLimitSizeTotal) {
	        if (width < min) {
	          dims.width = min;
	        }
	        if (height < min) {
	          dims.height = min;
	        }
	        return dims;
	      }
	      var ar = width / height, limitedDims = fabric.util.limitDimsByArea(ar, perfLimitSizeTotal),
	          capValue = fabric.util.capValue,
	          x = capValue(min, limitedDims.x, max),
	          y = capValue(min, limitedDims.y, max);
	      if (width > x) {
	        dims.zoomX /= width / x;
	        dims.width = x;
	        dims.capped = true;
	      }
	      if (height > y) {
	        dims.zoomY /= height / y;
	        dims.height = y;
	        dims.capped = true;
	      }
	      return dims;
	    },

	    /**
	     * Return the dimension and the zoom level needed to create a cache canvas
	     * big enough to host the object to be cached.
	     * @private
	     * @return {Object}.x width of object to be cached
	     * @return {Object}.y height of object to be cached
	     * @return {Object}.width width of canvas
	     * @return {Object}.height height of canvas
	     * @return {Object}.zoomX zoomX zoom value to unscale the canvas before drawing cache
	     * @return {Object}.zoomY zoomY zoom value to unscale the canvas before drawing cache
	     */
	    _getCacheCanvasDimensions: function() {
	      var objectScale = this.getTotalObjectScaling(),
	          // caculate dimensions without skewing
	          dim = this._getTransformedDimensions(0, 0),
	          neededX = dim.x * objectScale.scaleX / this.scaleX,
	          neededY = dim.y * objectScale.scaleY / this.scaleY;
	      return {
	        // for sure this ALIASING_LIMIT is slightly creating problem
	        // in situation in which the cache canvas gets an upper limit
	        // also objectScale contains already scaleX and scaleY
	        width: neededX + ALIASING_LIMIT,
	        height: neededY + ALIASING_LIMIT,
	        zoomX: objectScale.scaleX,
	        zoomY: objectScale.scaleY,
	        x: neededX,
	        y: neededY
	      };
	    },

	    /**
	     * Update width and height of the canvas for cache
	     * returns true or false if canvas needed resize.
	     * @private
	     * @return {Boolean} true if the canvas has been resized
	     */
	    _updateCacheCanvas: function() {
	      var targetCanvas = this.canvas;
	      if (this.noScaleCache && targetCanvas && targetCanvas._currentTransform) {
	        var target = targetCanvas._currentTransform.target,
	            action = targetCanvas._currentTransform.action;
	        if (this === target && action.slice && action.slice(0, 5) === 'scale') {
	          return false;
	        }
	      }
	      var canvas = this._cacheCanvas,
	          dims = this._limitCacheSize(this._getCacheCanvasDimensions()),
	          minCacheSize = fabric.minCacheSideLimit,
	          width = dims.width, height = dims.height, drawingWidth, drawingHeight,
	          zoomX = dims.zoomX, zoomY = dims.zoomY,
	          dimensionsChanged = width !== this.cacheWidth || height !== this.cacheHeight,
	          zoomChanged = this.zoomX !== zoomX || this.zoomY !== zoomY,
	          shouldRedraw = dimensionsChanged || zoomChanged,
	          additionalWidth = 0, additionalHeight = 0, shouldResizeCanvas = false;
	      if (dimensionsChanged) {
	        var canvasWidth = this._cacheCanvas.width,
	            canvasHeight = this._cacheCanvas.height,
	            sizeGrowing = width > canvasWidth || height > canvasHeight,
	            sizeShrinking = (width < canvasWidth * 0.9 || height < canvasHeight * 0.9) &&
	              canvasWidth > minCacheSize && canvasHeight > minCacheSize;
	        shouldResizeCanvas = sizeGrowing || sizeShrinking;
	        if (sizeGrowing && !dims.capped && (width > minCacheSize || height > minCacheSize)) {
	          additionalWidth = width * 0.1;
	          additionalHeight = height * 0.1;
	        }
	      }
	      if (this instanceof fabric.Text && this.path) {
	        shouldRedraw = true;
	        shouldResizeCanvas = true;
	        additionalWidth += this.getHeightOfLine(0) * this.zoomX;
	        additionalHeight += this.getHeightOfLine(0) * this.zoomY;
	      }
	      if (shouldRedraw) {
	        if (shouldResizeCanvas) {
	          canvas.width = Math.ceil(width + additionalWidth);
	          canvas.height = Math.ceil(height + additionalHeight);
	        }
	        else {
	          this._cacheContext.setTransform(1, 0, 0, 1, 0, 0);
	          this._cacheContext.clearRect(0, 0, canvas.width, canvas.height);
	        }
	        drawingWidth = dims.x / 2;
	        drawingHeight = dims.y / 2;
	        this.cacheTranslationX = Math.round(canvas.width / 2 - drawingWidth) + drawingWidth;
	        this.cacheTranslationY = Math.round(canvas.height / 2 - drawingHeight) + drawingHeight;
	        this.cacheWidth = width;
	        this.cacheHeight = height;
	        this._cacheContext.translate(this.cacheTranslationX, this.cacheTranslationY);
	        this._cacheContext.scale(zoomX, zoomY);
	        this.zoomX = zoomX;
	        this.zoomY = zoomY;
	        return true;
	      }
	      return false;
	    },

	    /**
	     * Sets object's properties from options
	     * @param {Object} [options] Options object
	     */
	    setOptions: function(options) {
	      this._setOptions(options);
	      this._initGradient(options.fill, 'fill');
	      this._initGradient(options.stroke, 'stroke');
	      this._initPattern(options.fill, 'fill');
	      this._initPattern(options.stroke, 'stroke');
	    },

	    /**
	     * Transforms context when rendering an object
	     * @param {CanvasRenderingContext2D} ctx Context
	     */
	    transform: function(ctx) {
	      var needFullTransform = (this.group && !this.group._transformDone) ||
	         (this.group && this.canvas && ctx === this.canvas.contextTop);
	      var m = this.calcTransformMatrix(!needFullTransform);
	      ctx.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
	    },

	    /**
	     * Returns an object representation of an instance
	     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
	     * @return {Object} Object representation of an instance
	     */
	    toObject: function(propertiesToInclude) {
	      var NUM_FRACTION_DIGITS = fabric.Object.NUM_FRACTION_DIGITS,

	          object = {
	            type:                     this.type,
	            version:                  fabric.version,
	            originX:                  this.originX,
	            originY:                  this.originY,
	            left:                     toFixed(this.left, NUM_FRACTION_DIGITS),
	            top:                      toFixed(this.top, NUM_FRACTION_DIGITS),
	            width:                    toFixed(this.width, NUM_FRACTION_DIGITS),
	            height:                   toFixed(this.height, NUM_FRACTION_DIGITS),
	            fill:                     (this.fill && this.fill.toObject) ? this.fill.toObject() : this.fill,
	            stroke:                   (this.stroke && this.stroke.toObject) ? this.stroke.toObject() : this.stroke,
	            strokeWidth:              toFixed(this.strokeWidth, NUM_FRACTION_DIGITS),
	            strokeDashArray:          this.strokeDashArray ? this.strokeDashArray.concat() : this.strokeDashArray,
	            strokeLineCap:            this.strokeLineCap,
	            strokeDashOffset:         this.strokeDashOffset,
	            strokeLineJoin:           this.strokeLineJoin,
	            strokeUniform:            this.strokeUniform,
	            strokeMiterLimit:         toFixed(this.strokeMiterLimit, NUM_FRACTION_DIGITS),
	            scaleX:                   toFixed(this.scaleX, NUM_FRACTION_DIGITS),
	            scaleY:                   toFixed(this.scaleY, NUM_FRACTION_DIGITS),
	            angle:                    toFixed(this.angle, NUM_FRACTION_DIGITS),
	            flipX:                    this.flipX,
	            flipY:                    this.flipY,
	            opacity:                  toFixed(this.opacity, NUM_FRACTION_DIGITS),
	            shadow:                   (this.shadow && this.shadow.toObject) ? this.shadow.toObject() : this.shadow,
	            visible:                  this.visible,
	            backgroundColor:          this.backgroundColor,
	            fillRule:                 this.fillRule,
	            paintFirst:               this.paintFirst,
	            globalCompositeOperation: this.globalCompositeOperation,
	            skewX:                    toFixed(this.skewX, NUM_FRACTION_DIGITS),
	            skewY:                    toFixed(this.skewY, NUM_FRACTION_DIGITS),
	          };

	      if (this.clipPath && !this.clipPath.excludeFromExport) {
	        object.clipPath = this.clipPath.toObject(propertiesToInclude);
	        object.clipPath.inverted = this.clipPath.inverted;
	        object.clipPath.absolutePositioned = this.clipPath.absolutePositioned;
	      }

	      fabric.util.populateWithProperties(this, object, propertiesToInclude);
	      if (!this.includeDefaultValues) {
	        object = this._removeDefaultValues(object);
	      }

	      return object;
	    },

	    /**
	     * Returns (dataless) object representation of an instance
	     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
	     * @return {Object} Object representation of an instance
	     */
	    toDatalessObject: function(propertiesToInclude) {
	      // will be overwritten by subclasses
	      return this.toObject(propertiesToInclude);
	    },

	    /**
	     * @private
	     * @param {Object} object
	     */
	    _removeDefaultValues: function(object) {
	      var prototype = fabric.util.getKlass(object.type).prototype,
	          stateProperties = prototype.stateProperties;
	      stateProperties.forEach(function(prop) {
	        if (prop === 'left' || prop === 'top') {
	          return;
	        }
	        if (object[prop] === prototype[prop]) {
	          delete object[prop];
	        }
	        var isArray = Object.prototype.toString.call(object[prop]) === '[object Array]' &&
	                      Object.prototype.toString.call(prototype[prop]) === '[object Array]';

	        // basically a check for [] === []
	        if (isArray && object[prop].length === 0 && prototype[prop].length === 0) {
	          delete object[prop];
	        }
	      });

	      return object;
	    },

	    /**
	     * Returns a string representation of an instance
	     * @return {String}
	     */
	    toString: function() {
	      return '#<fabric.' + capitalize(this.type) + '>';
	    },

	    /**
	     * Return the object scale factor counting also the group scaling
	     * @return {Object} object with scaleX and scaleY properties
	     */
	    getObjectScaling: function() {
	      // if the object is a top level one, on the canvas, we go for simple aritmetic
	      // otherwise the complex method with angles will return approximations and decimals
	      // and will likely kill the cache when not needed
	      // https://github.com/fabricjs/fabric.js/issues/7157
	      if (!this.group) {
	        return {
	          scaleX: this.scaleX,
	          scaleY: this.scaleY,
	        };
	      }
	      // if we are inside a group total zoom calculation is complex, we defer to generic matrices
	      var options = fabric.util.qrDecompose(this.calcTransformMatrix());
	      return { scaleX: Math.abs(options.scaleX), scaleY: Math.abs(options.scaleY) };
	    },

	    /**
	     * Return the object scale factor counting also the group scaling, zoom and retina
	     * @return {Object} object with scaleX and scaleY properties
	     */
	    getTotalObjectScaling: function() {
	      var scale = this.getObjectScaling(), scaleX = scale.scaleX, scaleY = scale.scaleY;
	      if (this.canvas) {
	        var zoom = this.canvas.getZoom();
	        var retina = this.canvas.getRetinaScaling();
	        scaleX *= zoom * retina;
	        scaleY *= zoom * retina;
	      }
	      return { scaleX: scaleX, scaleY: scaleY };
	    },

	    /**
	     * Return the object opacity counting also the group property
	     * @return {Number}
	     */
	    getObjectOpacity: function() {
	      var opacity = this.opacity;
	      if (this.group) {
	        opacity *= this.group.getObjectOpacity();
	      }
	      return opacity;
	    },

	    /**
	     * @private
	     * @param {String} key
	     * @param {*} value
	     * @return {fabric.Object} thisArg
	     */
	    _set: function(key, value) {
	      var shouldConstrainValue = (key === 'scaleX' || key === 'scaleY'),
	          isChanged = this[key] !== value, groupNeedsUpdate = false;

	      if (shouldConstrainValue) {
	        value = this._constrainScale(value);
	      }
	      if (key === 'scaleX' && value < 0) {
	        this.flipX = !this.flipX;
	        value *= -1;
	      }
	      else if (key === 'scaleY' && value < 0) {
	        this.flipY = !this.flipY;
	        value *= -1;
	      }
	      else if (key === 'shadow' && value && !(value instanceof fabric.Shadow)) {
	        value = new fabric.Shadow(value);
	      }
	      else if (key === 'dirty' && this.group) {
	        this.group.set('dirty', value);
	      }

	      this[key] = value;

	      if (isChanged) {
	        groupNeedsUpdate = this.group && this.group.isOnACache();
	        if (this.cacheProperties.indexOf(key) > -1) {
	          this.dirty = true;
	          groupNeedsUpdate && this.group.set('dirty', true);
	        }
	        else if (groupNeedsUpdate && this.stateProperties.indexOf(key) > -1) {
	          this.group.set('dirty', true);
	        }
	      }
	      return this;
	    },

	    /**
	     * This callback function is called by the parent group of an object every
	     * time a non-delegated property changes on the group. It is passed the key
	     * and value as parameters. Not adding in this function's signature to avoid
	     * Travis build error about unused variables.
	     */
	    setOnGroup: function() {
	      // implemented by sub-classes, as needed.
	    },

	    /**
	     * Retrieves viewportTransform from Object's canvas if possible
	     * @method getViewportTransform
	     * @memberOf fabric.Object.prototype
	     * @return {Array}
	     */
	    getViewportTransform: function() {
	      if (this.canvas && this.canvas.viewportTransform) {
	        return this.canvas.viewportTransform;
	      }
	      return fabric.iMatrix.concat();
	    },

	    /*
	     * @private
	     * return if the object would be visible in rendering
	     * @memberOf fabric.Object.prototype
	     * @return {Boolean}
	     */
	    isNotVisible: function() {
	      return this.opacity === 0 ||
	        (!this.width && !this.height && this.strokeWidth === 0) ||
	        !this.visible;
	    },

	    /**
	     * Renders an object on a specified context
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    render: function(ctx) {
	      // do not render if width/height are zeros or object is not visible
	      if (this.isNotVisible()) {
	        return;
	      }
	      if (this.canvas && this.canvas.skipOffscreen && !this.group && !this.isOnScreen()) {
	        return;
	      }
	      ctx.save();
	      this._setupCompositeOperation(ctx);
	      this.drawSelectionBackground(ctx);
	      this.transform(ctx);
	      this._setOpacity(ctx);
	      this._setShadow(ctx, this);
	      if (this.shouldCache()) {
	        this.renderCache();
	        this.drawCacheOnCanvas(ctx);
	      }
	      else {
	        this._removeCacheCanvas();
	        this.dirty = false;
	        this.drawObject(ctx);
	        if (this.objectCaching && this.statefullCache) {
	          this.saveState({ propertySet: 'cacheProperties' });
	        }
	      }
	      ctx.restore();
	    },

	    renderCache: function(options) {
	      options = options || {};
	      if (!this._cacheCanvas) {
	        this._createCacheCanvas();
	      }
	      if (this.isCacheDirty()) {
	        this.statefullCache && this.saveState({ propertySet: 'cacheProperties' });
	        this.drawObject(this._cacheContext, options.forClipping);
	        this.dirty = false;
	      }
	    },

	    /**
	     * Remove cacheCanvas and its dimensions from the objects
	     */
	    _removeCacheCanvas: function() {
	      this._cacheCanvas = null;
	      this.cacheWidth = 0;
	      this.cacheHeight = 0;
	    },

	    /**
	     * return true if the object will draw a stroke
	     * Does not consider text styles. This is just a shortcut used at rendering time
	     * We want it to be an approximation and be fast.
	     * wrote to avoid extra caching, it has to return true when stroke happens,
	     * can guess when it will not happen at 100% chance, does not matter if it misses
	     * some use case where the stroke is invisible.
	     * @since 3.0.0
	     * @returns Boolean
	     */
	    hasStroke: function() {
	      return this.stroke && this.stroke !== 'transparent' && this.strokeWidth !== 0;
	    },

	    /**
	     * return true if the object will draw a fill
	     * Does not consider text styles. This is just a shortcut used at rendering time
	     * We want it to be an approximation and be fast.
	     * wrote to avoid extra caching, it has to return true when fill happens,
	     * can guess when it will not happen at 100% chance, does not matter if it misses
	     * some use case where the fill is invisible.
	     * @since 3.0.0
	     * @returns Boolean
	     */
	    hasFill: function() {
	      return this.fill && this.fill !== 'transparent';
	    },

	    /**
	     * When set to `true`, force the object to have its own cache, even if it is inside a group
	     * it may be needed when your object behave in a particular way on the cache and always needs
	     * its own isolated canvas to render correctly.
	     * Created to be overridden
	     * since 1.7.12
	     * @returns Boolean
	     */
	    needsItsOwnCache: function() {
	      if (this.paintFirst === 'stroke' &&
	        this.hasFill() && this.hasStroke() && typeof this.shadow === 'object') {
	        return true;
	      }
	      if (this.clipPath) {
	        return true;
	      }
	      return false;
	    },

	    /**
	     * Decide if the object should cache or not. Create its own cache level
	     * objectCaching is a global flag, wins over everything
	     * needsItsOwnCache should be used when the object drawing method requires
	     * a cache step. None of the fabric classes requires it.
	     * Generally you do not cache objects in groups because the group outside is cached.
	     * Read as: cache if is needed, or if the feature is enabled but we are not already caching.
	     * @return {Boolean}
	     */
	    shouldCache: function() {
	      this.ownCaching = this.needsItsOwnCache() || (
	        this.objectCaching &&
	        (!this.group || !this.group.isOnACache())
	      );
	      return this.ownCaching;
	    },

	    /**
	     * Check if this object or a child object will cast a shadow
	     * used by Group.shouldCache to know if child has a shadow recursively
	     * @return {Boolean}
	     */
	    willDrawShadow: function() {
	      return !!this.shadow && (this.shadow.offsetX !== 0 || this.shadow.offsetY !== 0);
	    },

	    /**
	     * Execute the drawing operation for an object clipPath
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    drawClipPathOnCache: function(ctx) {
	      var path = this.clipPath;
	      ctx.save();
	      // DEBUG: uncomment this line, comment the following
	      // ctx.globalAlpha = 0.4
	      if (path.inverted) {
	        ctx.globalCompositeOperation = 'destination-out';
	      }
	      else {
	        ctx.globalCompositeOperation = 'destination-in';
	      }
	      //ctx.scale(1 / 2, 1 / 2);
	      if (path.absolutePositioned) {
	        var m = fabric.util.invertTransform(this.calcTransformMatrix());
	        ctx.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
	      }
	      path.transform(ctx);
	      ctx.scale(1 / path.zoomX, 1 / path.zoomY);
	      ctx.drawImage(path._cacheCanvas, -path.cacheTranslationX, -path.cacheTranslationY);
	      ctx.restore();
	    },

	    /**
	     * Execute the drawing operation for an object on a specified context
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    drawObject: function(ctx, forClipping) {
	      var originalFill = this.fill, originalStroke = this.stroke;
	      if (forClipping) {
	        this.fill = 'black';
	        this.stroke = '';
	        this._setClippingProperties(ctx);
	      }
	      else {
	        this._renderBackground(ctx);
	      }
	      this._render(ctx);
	      this._drawClipPath(ctx);
	      this.fill = originalFill;
	      this.stroke = originalStroke;
	    },

	    _drawClipPath: function(ctx) {
	      var path = this.clipPath;
	      if (!path) { return; }
	      // needed to setup a couple of variables
	      // path canvas gets overridden with this one.
	      // TODO find a better solution?
	      path.canvas = this.canvas;
	      path.shouldCache();
	      path._transformDone = true;
	      path.renderCache({ forClipping: true });
	      this.drawClipPathOnCache(ctx);
	    },

	    /**
	     * Paint the cached copy of the object on the target context.
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    drawCacheOnCanvas: function(ctx) {
	      ctx.scale(1 / this.zoomX, 1 / this.zoomY);
	      ctx.drawImage(this._cacheCanvas, -this.cacheTranslationX, -this.cacheTranslationY);
	    },

	    /**
	     * Check if cache is dirty
	     * @param {Boolean} skipCanvas skip canvas checks because this object is painted
	     * on parent canvas.
	     */
	    isCacheDirty: function(skipCanvas) {
	      if (this.isNotVisible()) {
	        return false;
	      }
	      if (this._cacheCanvas && !skipCanvas && this._updateCacheCanvas()) {
	        // in this case the context is already cleared.
	        return true;
	      }
	      else {
	        if (this.dirty ||
	          (this.clipPath && this.clipPath.absolutePositioned) ||
	          (this.statefullCache && this.hasStateChanged('cacheProperties'))
	        ) {
	          if (this._cacheCanvas && !skipCanvas) {
	            var width = this.cacheWidth / this.zoomX;
	            var height = this.cacheHeight / this.zoomY;
	            this._cacheContext.clearRect(-width / 2, -height / 2, width, height);
	          }
	          return true;
	        }
	      }
	      return false;
	    },

	    /**
	     * Draws a background for the object big as its untransformed dimensions
	     * @private
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    _renderBackground: function(ctx) {
	      if (!this.backgroundColor) {
	        return;
	      }
	      var dim = this._getNonTransformedDimensions();
	      ctx.fillStyle = this.backgroundColor;

	      ctx.fillRect(
	        -dim.x / 2,
	        -dim.y / 2,
	        dim.x,
	        dim.y
	      );
	      // if there is background color no other shadows
	      // should be casted
	      this._removeShadow(ctx);
	    },

	    /**
	     * @private
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    _setOpacity: function(ctx) {
	      if (this.group && !this.group._transformDone) {
	        ctx.globalAlpha = this.getObjectOpacity();
	      }
	      else {
	        ctx.globalAlpha *= this.opacity;
	      }
	    },

	    _setStrokeStyles: function(ctx, decl) {
	      var stroke = decl.stroke;
	      if (stroke) {
	        ctx.lineWidth = decl.strokeWidth;
	        ctx.lineCap = decl.strokeLineCap;
	        ctx.lineDashOffset = decl.strokeDashOffset;
	        ctx.lineJoin = decl.strokeLineJoin;
	        ctx.miterLimit = decl.strokeMiterLimit;
	        if (stroke.toLive) {
	          if (stroke.gradientUnits === 'percentage' || stroke.gradientTransform || stroke.patternTransform) {
	            // need to transform gradient in a pattern.
	            // this is a slow process. If you are hitting this codepath, and the object
	            // is not using caching, you should consider switching it on.
	            // we need a canvas as big as the current object caching canvas.
	            this._applyPatternForTransformedGradient(ctx, stroke);
	          }
	          else {
	            // is a simple gradient or pattern
	            ctx.strokeStyle = stroke.toLive(ctx, this);
	            this._applyPatternGradientTransform(ctx, stroke);
	          }
	        }
	        else {
	          // is a color
	          ctx.strokeStyle = decl.stroke;
	        }
	      }
	    },

	    _setFillStyles: function(ctx, decl) {
	      var fill = decl.fill;
	      if (fill) {
	        if (fill.toLive) {
	          ctx.fillStyle = fill.toLive(ctx, this);
	          this._applyPatternGradientTransform(ctx, decl.fill);
	        }
	        else {
	          ctx.fillStyle = fill;
	        }
	      }
	    },

	    _setClippingProperties: function(ctx) {
	      ctx.globalAlpha = 1;
	      ctx.strokeStyle = 'transparent';
	      ctx.fillStyle = '#000000';
	    },

	    /**
	     * @private
	     * Sets line dash
	     * @param {CanvasRenderingContext2D} ctx Context to set the dash line on
	     * @param {Array} dashArray array representing dashes
	     */
	    _setLineDash: function(ctx, dashArray) {
	      if (!dashArray || dashArray.length === 0) {
	        return;
	      }
	      // Spec requires the concatenation of two copies the dash list when the number of elements is odd
	      if (1 & dashArray.length) {
	        dashArray.push.apply(dashArray, dashArray);
	      }
	      ctx.setLineDash(dashArray);
	    },

	    /**
	     * Renders controls and borders for the object
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     * @param {Object} [styleOverride] properties to override the object style
	     */
	    _renderControls: function(ctx, styleOverride) {
	      var vpt = this.getViewportTransform(),
	          matrix = this.calcTransformMatrix(),
	          options, drawBorders, drawControls;
	      styleOverride = styleOverride || { };
	      drawBorders = typeof styleOverride.hasBorders !== 'undefined' ? styleOverride.hasBorders : this.hasBorders;
	      drawControls = typeof styleOverride.hasControls !== 'undefined' ? styleOverride.hasControls : this.hasControls;
	      matrix = fabric.util.multiplyTransformMatrices(vpt, matrix);
	      options = fabric.util.qrDecompose(matrix);
	      ctx.save();
	      ctx.translate(options.translateX, options.translateY);
	      ctx.lineWidth = 1 * this.borderScaleFactor;
	      if (!this.group) {
	        ctx.globalAlpha = this.isMoving ? this.borderOpacityWhenMoving : 1;
	      }
	      ctx.rotate(degreesToRadians(options.angle));
	      if (styleOverride.forActiveSelection || this.group) {
	        drawBorders && this.drawBordersInGroup(ctx, options, styleOverride);
	      }
	      else {
	        drawBorders && this.drawBorders(ctx, styleOverride);
	      }
	      drawControls && this.drawControls(ctx, styleOverride);
	      ctx.restore();
	    },

	    /**
	     * @private
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    _setShadow: function(ctx) {
	      if (!this.shadow) {
	        return;
	      }

	      var shadow = this.shadow, canvas = this.canvas, scaling,
	          multX = (canvas && canvas.viewportTransform[0]) || 1,
	          multY = (canvas && canvas.viewportTransform[3]) || 1;
	      if (shadow.nonScaling) {
	        scaling = { scaleX: 1, scaleY: 1 };
	      }
	      else {
	        scaling = this.getObjectScaling();
	      }
	      if (canvas && canvas._isRetinaScaling()) {
	        multX *= fabric.devicePixelRatio;
	        multY *= fabric.devicePixelRatio;
	      }
	      ctx.shadowColor = shadow.color;
	      ctx.shadowBlur = shadow.blur * fabric.browserShadowBlurConstant *
	        (multX + multY) * (scaling.scaleX + scaling.scaleY) / 4;
	      ctx.shadowOffsetX = shadow.offsetX * multX * scaling.scaleX;
	      ctx.shadowOffsetY = shadow.offsetY * multY * scaling.scaleY;
	    },

	    /**
	     * @private
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    _removeShadow: function(ctx) {
	      if (!this.shadow) {
	        return;
	      }

	      ctx.shadowColor = '';
	      ctx.shadowBlur = ctx.shadowOffsetX = ctx.shadowOffsetY = 0;
	    },

	    /**
	     * @private
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     * @param {Object} filler fabric.Pattern or fabric.Gradient
	     * @return {Object} offset.offsetX offset for text rendering
	     * @return {Object} offset.offsetY offset for text rendering
	     */
	    _applyPatternGradientTransform: function(ctx, filler) {
	      if (!filler || !filler.toLive) {
	        return { offsetX: 0, offsetY: 0 };
	      }
	      var t = filler.gradientTransform || filler.patternTransform;
	      var offsetX = -this.width / 2 + filler.offsetX || 0,
	          offsetY = -this.height / 2 + filler.offsetY || 0;

	      if (filler.gradientUnits === 'percentage') {
	        ctx.transform(this.width, 0, 0, this.height, offsetX, offsetY);
	      }
	      else {
	        ctx.transform(1, 0, 0, 1, offsetX, offsetY);
	      }
	      if (t) {
	        ctx.transform(t[0], t[1], t[2], t[3], t[4], t[5]);
	      }
	      return { offsetX: offsetX, offsetY: offsetY };
	    },

	    /**
	     * @private
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    _renderPaintInOrder: function(ctx) {
	      if (this.paintFirst === 'stroke') {
	        this._renderStroke(ctx);
	        this._renderFill(ctx);
	      }
	      else {
	        this._renderFill(ctx);
	        this._renderStroke(ctx);
	      }
	    },

	    /**
	     * @private
	     * function that actually render something on the context.
	     * empty here to allow Obects to work on tests to benchmark fabric functionalites
	     * not related to rendering
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    _render: function(/* ctx */) {

	    },

	    /**
	     * @private
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    _renderFill: function(ctx) {
	      if (!this.fill) {
	        return;
	      }

	      ctx.save();
	      this._setFillStyles(ctx, this);
	      if (this.fillRule === 'evenodd') {
	        ctx.fill('evenodd');
	      }
	      else {
	        ctx.fill();
	      }
	      ctx.restore();
	    },

	    /**
	     * @private
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    _renderStroke: function(ctx) {
	      if (!this.stroke || this.strokeWidth === 0) {
	        return;
	      }

	      if (this.shadow && !this.shadow.affectStroke) {
	        this._removeShadow(ctx);
	      }

	      ctx.save();
	      if (this.strokeUniform && this.group) {
	        var scaling = this.getObjectScaling();
	        ctx.scale(1 / scaling.scaleX, 1 / scaling.scaleY);
	      }
	      else if (this.strokeUniform) {
	        ctx.scale(1 / this.scaleX, 1 / this.scaleY);
	      }
	      this._setLineDash(ctx, this.strokeDashArray);
	      this._setStrokeStyles(ctx, this);
	      ctx.stroke();
	      ctx.restore();
	    },

	    /**
	     * This function try to patch the missing gradientTransform on canvas gradients.
	     * transforming a context to transform the gradient, is going to transform the stroke too.
	     * we want to transform the gradient but not the stroke operation, so we create
	     * a transformed gradient on a pattern and then we use the pattern instead of the gradient.
	     * this method has drwabacks: is slow, is in low resolution, needs a patch for when the size
	     * is limited.
	     * @private
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     * @param {fabric.Gradient} filler a fabric gradient instance
	     */
	    _applyPatternForTransformedGradient: function(ctx, filler) {
	      var dims = this._limitCacheSize(this._getCacheCanvasDimensions()),
	          pCanvas = fabric.util.createCanvasElement(), pCtx, retinaScaling = this.canvas.getRetinaScaling(),
	          width = dims.x / this.scaleX / retinaScaling, height = dims.y / this.scaleY / retinaScaling;
	      pCanvas.width = width;
	      pCanvas.height = height;
	      pCtx = pCanvas.getContext('2d');
	      pCtx.beginPath(); pCtx.moveTo(0, 0); pCtx.lineTo(width, 0); pCtx.lineTo(width, height);
	      pCtx.lineTo(0, height); pCtx.closePath();
	      pCtx.translate(width / 2, height / 2);
	      pCtx.scale(
	        dims.zoomX / this.scaleX / retinaScaling,
	        dims.zoomY / this.scaleY / retinaScaling
	      );
	      this._applyPatternGradientTransform(pCtx, filler);
	      pCtx.fillStyle = filler.toLive(ctx);
	      pCtx.fill();
	      ctx.translate(-this.width / 2 - this.strokeWidth / 2, -this.height / 2 - this.strokeWidth / 2);
	      ctx.scale(
	        retinaScaling * this.scaleX / dims.zoomX,
	        retinaScaling * this.scaleY / dims.zoomY
	      );
	      ctx.strokeStyle = pCtx.createPattern(pCanvas, 'no-repeat');
	    },

	    /**
	     * This function is an helper for svg import. it returns the center of the object in the svg
	     * untransformed coordinates
	     * @private
	     * @return {Object} center point from element coordinates
	     */
	    _findCenterFromElement: function() {
	      return { x: this.left + this.width / 2, y: this.top + this.height / 2 };
	    },

	    /**
	     * This function is an helper for svg import. it decompose the transformMatrix
	     * and assign properties to object.
	     * untransformed coordinates
	     * @private
	     * @chainable
	     */
	    _assignTransformMatrixProps: function() {
	      if (this.transformMatrix) {
	        var options = fabric.util.qrDecompose(this.transformMatrix);
	        this.flipX = false;
	        this.flipY = false;
	        this.set('scaleX', options.scaleX);
	        this.set('scaleY', options.scaleY);
	        this.angle = options.angle;
	        this.skewX = options.skewX;
	        this.skewY = 0;
	      }
	    },

	    /**
	     * This function is an helper for svg import. it removes the transform matrix
	     * and set to object properties that fabricjs can handle
	     * @private
	     * @param {Object} preserveAspectRatioOptions
	     * @return {thisArg}
	     */
	    _removeTransformMatrix: function(preserveAspectRatioOptions) {
	      var center = this._findCenterFromElement();
	      if (this.transformMatrix) {
	        this._assignTransformMatrixProps();
	        center = fabric.util.transformPoint(center, this.transformMatrix);
	      }
	      this.transformMatrix = null;
	      if (preserveAspectRatioOptions) {
	        this.scaleX *= preserveAspectRatioOptions.scaleX;
	        this.scaleY *= preserveAspectRatioOptions.scaleY;
	        this.cropX = preserveAspectRatioOptions.cropX;
	        this.cropY = preserveAspectRatioOptions.cropY;
	        center.x += preserveAspectRatioOptions.offsetLeft;
	        center.y += preserveAspectRatioOptions.offsetTop;
	        this.width = preserveAspectRatioOptions.width;
	        this.height = preserveAspectRatioOptions.height;
	      }
	      this.setPositionByOrigin(center, 'center', 'center');
	    },

	    /**
	     * Clones an instance, using a callback method will work for every object.
	     * @param {Function} callback Callback is invoked with a clone as a first argument
	     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
	     */
	    clone: function(callback, propertiesToInclude) {
	      var objectForm = this.toObject(propertiesToInclude);
	      if (this.constructor.fromObject) {
	        this.constructor.fromObject(objectForm, callback);
	      }
	      else {
	        fabric.Object._fromObject('Object', objectForm, callback);
	      }
	    },

	    /**
	     * Creates an instance of fabric.Image out of an object
	     * makes use of toCanvasElement.
	     * Once this method was based on toDataUrl and loadImage, so it also had a quality
	     * and format option. toCanvasElement is faster and produce no loss of quality.
	     * If you need to get a real Jpeg or Png from an object, using toDataURL is the right way to do it.
	     * toCanvasElement and then toBlob from the obtained canvas is also a good option.
	     * This method is sync now, but still support the callback because we did not want to break.
	     * When fabricJS 5.0 will be planned, this will probably be changed to not have a callback.
	     * @param {Function} callback callback, invoked with an instance as a first argument
	     * @param {Object} [options] for clone as image, passed to toDataURL
	     * @param {Number} [options.multiplier=1] Multiplier to scale by
	     * @param {Number} [options.left] Cropping left offset. Introduced in v1.2.14
	     * @param {Number} [options.top] Cropping top offset. Introduced in v1.2.14
	     * @param {Number} [options.width] Cropping width. Introduced in v1.2.14
	     * @param {Number} [options.height] Cropping height. Introduced in v1.2.14
	     * @param {Boolean} [options.enableRetinaScaling] Enable retina scaling for clone image. Introduce in 1.6.4
	     * @param {Boolean} [options.withoutTransform] Remove current object transform ( no scale , no angle, no flip, no skew ). Introduced in 2.3.4
	     * @param {Boolean} [options.withoutShadow] Remove current object shadow. Introduced in 2.4.2
	     * @return {fabric.Object} thisArg
	     */
	    cloneAsImage: function(callback, options) {
	      var canvasEl = this.toCanvasElement(options);
	      if (callback) {
	        callback(new fabric.Image(canvasEl));
	      }
	      return this;
	    },

	    /**
	     * Converts an object into a HTMLCanvas element
	     * @param {Object} options Options object
	     * @param {Number} [options.multiplier=1] Multiplier to scale by
	     * @param {Number} [options.left] Cropping left offset. Introduced in v1.2.14
	     * @param {Number} [options.top] Cropping top offset. Introduced in v1.2.14
	     * @param {Number} [options.width] Cropping width. Introduced in v1.2.14
	     * @param {Number} [options.height] Cropping height. Introduced in v1.2.14
	     * @param {Boolean} [options.enableRetinaScaling] Enable retina scaling for clone image. Introduce in 1.6.4
	     * @param {Boolean} [options.withoutTransform] Remove current object transform ( no scale , no angle, no flip, no skew ). Introduced in 2.3.4
	     * @param {Boolean} [options.withoutShadow] Remove current object shadow. Introduced in 2.4.2
	     * @return {HTMLCanvasElement} Returns DOM element <canvas> with the fabric.Object
	     */
	    toCanvasElement: function(options) {
	      options || (options = { });

	      var utils = fabric.util, origParams = utils.saveObjectTransform(this),
	          originalGroup = this.group,
	          originalShadow = this.shadow, abs = Math.abs,
	          multiplier = (options.multiplier || 1) * (options.enableRetinaScaling ? fabric.devicePixelRatio : 1);
	      delete this.group;
	      if (options.withoutTransform) {
	        utils.resetObjectTransform(this);
	      }
	      if (options.withoutShadow) {
	        this.shadow = null;
	      }

	      var el = fabric.util.createCanvasElement(),
	          // skip canvas zoom and calculate with setCoords now.
	          boundingRect = this.getBoundingRect(true, true),
	          shadow = this.shadow, scaling,
	          shadowOffset = { x: 0, y: 0 }, shadowBlur,
	          width, height;

	      if (shadow) {
	        shadowBlur = shadow.blur;
	        if (shadow.nonScaling) {
	          scaling = { scaleX: 1, scaleY: 1 };
	        }
	        else {
	          scaling = this.getObjectScaling();
	        }
	        // consider non scaling shadow.
	        shadowOffset.x = 2 * Math.round(abs(shadow.offsetX) + shadowBlur) * (abs(scaling.scaleX));
	        shadowOffset.y = 2 * Math.round(abs(shadow.offsetY) + shadowBlur) * (abs(scaling.scaleY));
	      }
	      width = boundingRect.width + shadowOffset.x;
	      height = boundingRect.height + shadowOffset.y;
	      // if the current width/height is not an integer
	      // we need to make it so.
	      el.width = Math.ceil(width);
	      el.height = Math.ceil(height);
	      var canvas = new fabric.StaticCanvas(el, {
	        enableRetinaScaling: false,
	        renderOnAddRemove: false,
	        skipOffscreen: false,
	      });
	      if (options.format === 'jpeg') {
	        canvas.backgroundColor = '#fff';
	      }
	      this.setPositionByOrigin(new fabric.Point(canvas.width / 2, canvas.height / 2), 'center', 'center');

	      var originalCanvas = this.canvas;
	      canvas.add(this);
	      var canvasEl = canvas.toCanvasElement(multiplier || 1, options);
	      this.shadow = originalShadow;
	      this.set('canvas', originalCanvas);
	      if (originalGroup) {
	        this.group = originalGroup;
	      }
	      this.set(origParams).setCoords();
	      // canvas.dispose will call image.dispose that will nullify the elements
	      // since this canvas is a simple element for the process, we remove references
	      // to objects in this way in order to avoid object trashing.
	      canvas._objects = [];
	      canvas.dispose();
	      canvas = null;

	      return canvasEl;
	    },

	    /**
	     * Converts an object into a data-url-like string
	     * @param {Object} options Options object
	     * @param {String} [options.format=png] The format of the output image. Either "jpeg" or "png"
	     * @param {Number} [options.quality=1] Quality level (0..1). Only used for jpeg.
	     * @param {Number} [options.multiplier=1] Multiplier to scale by
	     * @param {Number} [options.left] Cropping left offset. Introduced in v1.2.14
	     * @param {Number} [options.top] Cropping top offset. Introduced in v1.2.14
	     * @param {Number} [options.width] Cropping width. Introduced in v1.2.14
	     * @param {Number} [options.height] Cropping height. Introduced in v1.2.14
	     * @param {Boolean} [options.enableRetinaScaling] Enable retina scaling for clone image. Introduce in 1.6.4
	     * @param {Boolean} [options.withoutTransform] Remove current object transform ( no scale , no angle, no flip, no skew ). Introduced in 2.3.4
	     * @param {Boolean} [options.withoutShadow] Remove current object shadow. Introduced in 2.4.2
	     * @return {String} Returns a data: URL containing a representation of the object in the format specified by options.format
	     */
	    toDataURL: function(options) {
	      options || (options = { });
	      return fabric.util.toDataURL(this.toCanvasElement(options), options.format || 'png', options.quality || 1);
	    },

	    /**
	     * Returns true if specified type is identical to the type of an instance
	     * @param {String} type Type to check against
	     * @return {Boolean}
	     */
	    isType: function(type) {
	      return this.type === type;
	    },

	    /**
	     * Returns complexity of an instance
	     * @return {Number} complexity of this instance (is 1 unless subclassed)
	     */
	    complexity: function() {
	      return 1;
	    },

	    /**
	     * Returns a JSON representation of an instance
	     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
	     * @return {Object} JSON
	     */
	    toJSON: function(propertiesToInclude) {
	      // delegate, not alias
	      return this.toObject(propertiesToInclude);
	    },

	    /**
	     * Sets "angle" of an instance with centered rotation
	     * @param {Number} angle Angle value (in degrees)
	     * @return {fabric.Object} thisArg
	     * @chainable
	     */
	    rotate: function(angle) {
	      var shouldCenterOrigin = (this.originX !== 'center' || this.originY !== 'center') && this.centeredRotation;

	      if (shouldCenterOrigin) {
	        this._setOriginToCenter();
	      }

	      this.set('angle', angle);

	      if (shouldCenterOrigin) {
	        this._resetOrigin();
	      }

	      return this;
	    },

	    /**
	     * Centers object horizontally on canvas to which it was added last.
	     * You might need to call `setCoords` on an object after centering, to update controls area.
	     * @return {fabric.Object} thisArg
	     * @chainable
	     */
	    centerH: function () {
	      this.canvas && this.canvas.centerObjectH(this);
	      return this;
	    },

	    /**
	     * Centers object horizontally on current viewport of canvas to which it was added last.
	     * You might need to call `setCoords` on an object after centering, to update controls area.
	     * @return {fabric.Object} thisArg
	     * @chainable
	     */
	    viewportCenterH: function () {
	      this.canvas && this.canvas.viewportCenterObjectH(this);
	      return this;
	    },

	    /**
	     * Centers object vertically on canvas to which it was added last.
	     * You might need to call `setCoords` on an object after centering, to update controls area.
	     * @return {fabric.Object} thisArg
	     * @chainable
	     */
	    centerV: function () {
	      this.canvas && this.canvas.centerObjectV(this);
	      return this;
	    },

	    /**
	     * Centers object vertically on current viewport of canvas to which it was added last.
	     * You might need to call `setCoords` on an object after centering, to update controls area.
	     * @return {fabric.Object} thisArg
	     * @chainable
	     */
	    viewportCenterV: function () {
	      this.canvas && this.canvas.viewportCenterObjectV(this);
	      return this;
	    },

	    /**
	     * Centers object vertically and horizontally on canvas to which is was added last
	     * You might need to call `setCoords` on an object after centering, to update controls area.
	     * @return {fabric.Object} thisArg
	     * @chainable
	     */
	    center: function () {
	      this.canvas && this.canvas.centerObject(this);
	      return this;
	    },

	    /**
	     * Centers object on current viewport of canvas to which it was added last.
	     * You might need to call `setCoords` on an object after centering, to update controls area.
	     * @return {fabric.Object} thisArg
	     * @chainable
	     */
	    viewportCenter: function () {
	      this.canvas && this.canvas.viewportCenterObject(this);
	      return this;
	    },

	    /**
	     * Returns coordinates of a pointer relative to an object
	     * @param {Event} e Event to operate upon
	     * @param {Object} [pointer] Pointer to operate upon (instead of event)
	     * @return {Object} Coordinates of a pointer (x, y)
	     */
	    getLocalPointer: function(e, pointer) {
	      pointer = pointer || this.canvas.getPointer(e);
	      var pClicked = new fabric.Point(pointer.x, pointer.y),
	          objectLeftTop = this._getLeftTopCoords();
	      if (this.angle) {
	        pClicked = fabric.util.rotatePoint(
	          pClicked, objectLeftTop, degreesToRadians(-this.angle));
	      }
	      return {
	        x: pClicked.x - objectLeftTop.x,
	        y: pClicked.y - objectLeftTop.y
	      };
	    },

	    /**
	     * Sets canvas globalCompositeOperation for specific object
	     * custom composition operation for the particular object can be specified using globalCompositeOperation property
	     * @param {CanvasRenderingContext2D} ctx Rendering canvas context
	     */
	    _setupCompositeOperation: function (ctx) {
	      if (this.globalCompositeOperation) {
	        ctx.globalCompositeOperation = this.globalCompositeOperation;
	      }
	    }
	  });

	  fabric.util.createAccessors && fabric.util.createAccessors(fabric.Object);

	  extend(fabric.Object.prototype, fabric.Observable);

	  /**
	   * Defines the number of fraction digits to use when serializing object values.
	   * You can use it to increase/decrease precision of such values like left, top, scaleX, scaleY, etc.
	   * @static
	   * @memberOf fabric.Object
	   * @constant
	   * @type Number
	   */
	  fabric.Object.NUM_FRACTION_DIGITS = 2;

	  fabric.Object._fromObject = function(className, object, callback, extraParam) {
	    var klass = fabric[className];
	    object = clone(object, true);
	    fabric.util.enlivenPatterns([object.fill, object.stroke], function(patterns) {
	      if (typeof patterns[0] !== 'undefined') {
	        object.fill = patterns[0];
	      }
	      if (typeof patterns[1] !== 'undefined') {
	        object.stroke = patterns[1];
	      }
	      fabric.util.enlivenObjects([object.clipPath], function(enlivedProps) {
	        object.clipPath = enlivedProps[0];
	        var instance = extraParam ? new klass(object[extraParam], object) : new klass(object);
	        callback && callback(instance);
	      });
	    });
	  };

	  /**
	   * Unique id used internally when creating SVG elements
	   * @static
	   * @memberOf fabric.Object
	   * @type Number
	   */
	  fabric.Object.__uid = 0;
	})(exports );


	(function() {

	  var degreesToRadians = fabric.util.degreesToRadians,
	      originXOffset = {
	        left: -0.5,
	        center: 0,
	        right: 0.5
	      },
	      originYOffset = {
	        top: -0.5,
	        center: 0,
	        bottom: 0.5
	      };

	  fabric.util.object.extend(fabric.Object.prototype, /** @lends fabric.Object.prototype */ {

	    /**
	     * Translates the coordinates from a set of origin to another (based on the object's dimensions)
	     * @param {fabric.Point} point The point which corresponds to the originX and originY params
	     * @param {String} fromOriginX Horizontal origin: 'left', 'center' or 'right'
	     * @param {String} fromOriginY Vertical origin: 'top', 'center' or 'bottom'
	     * @param {String} toOriginX Horizontal origin: 'left', 'center' or 'right'
	     * @param {String} toOriginY Vertical origin: 'top', 'center' or 'bottom'
	     * @return {fabric.Point}
	     */
	    translateToGivenOrigin: function(point, fromOriginX, fromOriginY, toOriginX, toOriginY) {
	      var x = point.x,
	          y = point.y,
	          offsetX, offsetY, dim;

	      if (typeof fromOriginX === 'string') {
	        fromOriginX = originXOffset[fromOriginX];
	      }
	      else {
	        fromOriginX -= 0.5;
	      }

	      if (typeof toOriginX === 'string') {
	        toOriginX = originXOffset[toOriginX];
	      }
	      else {
	        toOriginX -= 0.5;
	      }

	      offsetX = toOriginX - fromOriginX;

	      if (typeof fromOriginY === 'string') {
	        fromOriginY = originYOffset[fromOriginY];
	      }
	      else {
	        fromOriginY -= 0.5;
	      }

	      if (typeof toOriginY === 'string') {
	        toOriginY = originYOffset[toOriginY];
	      }
	      else {
	        toOriginY -= 0.5;
	      }

	      offsetY = toOriginY - fromOriginY;

	      if (offsetX || offsetY) {
	        dim = this._getTransformedDimensions();
	        x = point.x + offsetX * dim.x;
	        y = point.y + offsetY * dim.y;
	      }

	      return new fabric.Point(x, y);
	    },

	    /**
	     * Translates the coordinates from origin to center coordinates (based on the object's dimensions)
	     * @param {fabric.Point} point The point which corresponds to the originX and originY params
	     * @param {String} originX Horizontal origin: 'left', 'center' or 'right'
	     * @param {String} originY Vertical origin: 'top', 'center' or 'bottom'
	     * @return {fabric.Point}
	     */
	    translateToCenterPoint: function(point, originX, originY) {
	      var p = this.translateToGivenOrigin(point, originX, originY, 'center', 'center');
	      if (this.angle) {
	        return fabric.util.rotatePoint(p, point, degreesToRadians(this.angle));
	      }
	      return p;
	    },

	    /**
	     * Translates the coordinates from center to origin coordinates (based on the object's dimensions)
	     * @param {fabric.Point} center The point which corresponds to center of the object
	     * @param {String} originX Horizontal origin: 'left', 'center' or 'right'
	     * @param {String} originY Vertical origin: 'top', 'center' or 'bottom'
	     * @return {fabric.Point}
	     */
	    translateToOriginPoint: function(center, originX, originY) {
	      var p = this.translateToGivenOrigin(center, 'center', 'center', originX, originY);
	      if (this.angle) {
	        return fabric.util.rotatePoint(p, center, degreesToRadians(this.angle));
	      }
	      return p;
	    },

	    /**
	     * Returns the real center coordinates of the object
	     * @return {fabric.Point}
	     */
	    getCenterPoint: function() {
	      var leftTop = new fabric.Point(this.left, this.top);
	      return this.translateToCenterPoint(leftTop, this.originX, this.originY);
	    },

	    /**
	     * Returns the coordinates of the object based on center coordinates
	     * @param {fabric.Point} point The point which corresponds to the originX and originY params
	     * @return {fabric.Point}
	     */
	    // getOriginPoint: function(center) {
	    //   return this.translateToOriginPoint(center, this.originX, this.originY);
	    // },

	    /**
	     * Returns the coordinates of the object as if it has a different origin
	     * @param {String} originX Horizontal origin: 'left', 'center' or 'right'
	     * @param {String} originY Vertical origin: 'top', 'center' or 'bottom'
	     * @return {fabric.Point}
	     */
	    getPointByOrigin: function(originX, originY) {
	      var center = this.getCenterPoint();
	      return this.translateToOriginPoint(center, originX, originY);
	    },

	    /**
	     * Returns the point in local coordinates
	     * @param {fabric.Point} point The point relative to the global coordinate system
	     * @param {String} originX Horizontal origin: 'left', 'center' or 'right'
	     * @param {String} originY Vertical origin: 'top', 'center' or 'bottom'
	     * @return {fabric.Point}
	     */
	    toLocalPoint: function(point, originX, originY) {
	      var center = this.getCenterPoint(),
	          p, p2;

	      if (typeof originX !== 'undefined' && typeof originY !== 'undefined' ) {
	        p = this.translateToGivenOrigin(center, 'center', 'center', originX, originY);
	      }
	      else {
	        p = new fabric.Point(this.left, this.top);
	      }

	      p2 = new fabric.Point(point.x, point.y);
	      if (this.angle) {
	        p2 = fabric.util.rotatePoint(p2, center, -degreesToRadians(this.angle));
	      }
	      return p2.subtractEquals(p);
	    },

	    /**
	     * Returns the point in global coordinates
	     * @param {fabric.Point} The point relative to the local coordinate system
	     * @return {fabric.Point}
	     */
	    // toGlobalPoint: function(point) {
	    //   return fabric.util.rotatePoint(point, this.getCenterPoint(), degreesToRadians(this.angle)).addEquals(new fabric.Point(this.left, this.top));
	    // },

	    /**
	     * Sets the position of the object taking into consideration the object's origin
	     * @param {fabric.Point} pos The new position of the object
	     * @param {String} originX Horizontal origin: 'left', 'center' or 'right'
	     * @param {String} originY Vertical origin: 'top', 'center' or 'bottom'
	     * @return {void}
	     */
	    setPositionByOrigin: function(pos, originX, originY) {
	      var center = this.translateToCenterPoint(pos, originX, originY),
	          position = this.translateToOriginPoint(center, this.originX, this.originY);
	      this.set('left', position.x);
	      this.set('top', position.y);
	    },

	    /**
	     * @param {String} to One of 'left', 'center', 'right'
	     */
	    adjustPosition: function(to) {
	      var angle = degreesToRadians(this.angle),
	          hypotFull = this.getScaledWidth(),
	          xFull = fabric.util.cos(angle) * hypotFull,
	          yFull = fabric.util.sin(angle) * hypotFull,
	          offsetFrom, offsetTo;

	      //TODO: this function does not consider mixed situation like top, center.
	      if (typeof this.originX === 'string') {
	        offsetFrom = originXOffset[this.originX];
	      }
	      else {
	        offsetFrom = this.originX - 0.5;
	      }
	      if (typeof to === 'string') {
	        offsetTo = originXOffset[to];
	      }
	      else {
	        offsetTo = to - 0.5;
	      }
	      this.left += xFull * (offsetTo - offsetFrom);
	      this.top += yFull * (offsetTo - offsetFrom);
	      this.setCoords();
	      this.originX = to;
	    },

	    /**
	     * Sets the origin/position of the object to it's center point
	     * @private
	     * @return {void}
	     */
	    _setOriginToCenter: function() {
	      this._originalOriginX = this.originX;
	      this._originalOriginY = this.originY;

	      var center = this.getCenterPoint();

	      this.originX = 'center';
	      this.originY = 'center';

	      this.left = center.x;
	      this.top = center.y;
	    },

	    /**
	     * Resets the origin/position of the object to it's original origin
	     * @private
	     * @return {void}
	     */
	    _resetOrigin: function() {
	      var originPoint = this.translateToOriginPoint(
	        this.getCenterPoint(),
	        this._originalOriginX,
	        this._originalOriginY);

	      this.originX = this._originalOriginX;
	      this.originY = this._originalOriginY;

	      this.left = originPoint.x;
	      this.top = originPoint.y;

	      this._originalOriginX = null;
	      this._originalOriginY = null;
	    },

	    /**
	     * @private
	     */
	    _getLeftTopCoords: function() {
	      return this.translateToOriginPoint(this.getCenterPoint(), 'left', 'top');
	    },
	  });

	})();


	(function() {

	  function arrayFromCoords(coords) {
	    return [
	      new fabric.Point(coords.tl.x, coords.tl.y),
	      new fabric.Point(coords.tr.x, coords.tr.y),
	      new fabric.Point(coords.br.x, coords.br.y),
	      new fabric.Point(coords.bl.x, coords.bl.y)
	    ];
	  }

	  var util = fabric.util,
	      degreesToRadians = util.degreesToRadians,
	      multiplyMatrices = util.multiplyTransformMatrices,
	      transformPoint = util.transformPoint;

	  util.object.extend(fabric.Object.prototype, /** @lends fabric.Object.prototype */ {

	    /**
	     * Describe object's corner position in canvas element coordinates.
	     * properties are depending on control keys and padding the main controls.
	     * each property is an object with x, y and corner.
	     * The `corner` property contains in a similar manner the 4 points of the
	     * interactive area of the corner.
	     * The coordinates depends from the controls positionHandler and are used
	     * to draw and locate controls
	     * @memberOf fabric.Object.prototype
	     */
	    oCoords: null,

	    /**
	     * Describe object's corner position in canvas object absolute coordinates
	     * properties are tl,tr,bl,br and describe the four main corner.
	     * each property is an object with x, y, instance of Fabric.Point.
	     * The coordinates depends from this properties: width, height, scaleX, scaleY
	     * skewX, skewY, angle, strokeWidth, top, left.
	     * Those coordinates are useful to understand where an object is. They get updated
	     * with oCoords but they do not need to be updated when zoom or panning change.
	     * The coordinates get updated with @method setCoords.
	     * You can calculate them without updating with @method calcACoords();
	     * @memberOf fabric.Object.prototype
	     */
	    aCoords: null,

	    /**
	     * Describe object's corner position in canvas element coordinates.
	     * includes padding. Used of object detection.
	     * set and refreshed with setCoords and calcCoords.
	     * @memberOf fabric.Object.prototype
	     */
	    lineCoords: null,

	    /**
	     * storage for object transform matrix
	     */
	    ownMatrixCache: null,

	    /**
	     * storage for object full transform matrix
	     */
	    matrixCache: null,

	    /**
	     * custom controls interface
	     * controls are added by default_controls.js
	     */
	    controls: { },

	    /**
	     * return correct set of coordinates for intersection
	     * this will return either aCoords or lineCoords.
	     * @param {Boolean} absolute will return aCoords if true or lineCoords
	     * @return {Object} {tl, tr, br, bl} points
	     */
	    _getCoords: function(absolute, calculate) {
	      if (calculate) {
	        return (absolute ? this.calcACoords() : this.calcLineCoords());
	      }
	      if (!this.aCoords || !this.lineCoords) {
	        this.setCoords(true);
	      }
	      return (absolute ? this.aCoords : this.lineCoords);
	    },

	    /**
	     * return correct set of coordinates for intersection
	     * this will return either aCoords or lineCoords.
	     * The coords are returned in an array.
	     * @return {Array} [tl, tr, br, bl] of points
	     */
	    getCoords: function(absolute, calculate) {
	      return arrayFromCoords(this._getCoords(absolute, calculate));
	    },

	    /**
	     * Checks if object intersects with an area formed by 2 points
	     * @param {Object} pointTL top-left point of area
	     * @param {Object} pointBR bottom-right point of area
	     * @param {Boolean} [absolute] use coordinates without viewportTransform
	     * @param {Boolean} [calculate] use coordinates of current position instead of .oCoords
	     * @return {Boolean} true if object intersects with an area formed by 2 points
	     */
	    intersectsWithRect: function(pointTL, pointBR, absolute, calculate) {
	      var coords = this.getCoords(absolute, calculate),
	          intersection = fabric.Intersection.intersectPolygonRectangle(
	            coords,
	            pointTL,
	            pointBR
	          );
	      return intersection.status === 'Intersection';
	    },

	    /**
	     * Checks if object intersects with another object
	     * @param {Object} other Object to test
	     * @param {Boolean} [absolute] use coordinates without viewportTransform
	     * @param {Boolean} [calculate] use coordinates of current position instead of .oCoords
	     * @return {Boolean} true if object intersects with another object
	     */
	    intersectsWithObject: function(other, absolute, calculate) {
	      var intersection = fabric.Intersection.intersectPolygonPolygon(
	        this.getCoords(absolute, calculate),
	        other.getCoords(absolute, calculate)
	      );

	      return intersection.status === 'Intersection'
	        || other.isContainedWithinObject(this, absolute, calculate)
	        || this.isContainedWithinObject(other, absolute, calculate);
	    },

	    /**
	     * Checks if object is fully contained within area of another object
	     * @param {Object} other Object to test
	     * @param {Boolean} [absolute] use coordinates without viewportTransform
	     * @param {Boolean} [calculate] use coordinates of current position instead of .oCoords
	     * @return {Boolean} true if object is fully contained within area of another object
	     */
	    isContainedWithinObject: function(other, absolute, calculate) {
	      var points = this.getCoords(absolute, calculate),
	          otherCoords = absolute ? other.aCoords : other.lineCoords,
	          i = 0, lines = other._getImageLines(otherCoords);
	      for (; i < 4; i++) {
	        if (!other.containsPoint(points[i], lines)) {
	          return false;
	        }
	      }
	      return true;
	    },

	    /**
	     * Checks if object is fully contained within area formed by 2 points
	     * @param {Object} pointTL top-left point of area
	     * @param {Object} pointBR bottom-right point of area
	     * @param {Boolean} [absolute] use coordinates without viewportTransform
	     * @param {Boolean} [calculate] use coordinates of current position instead of .oCoords
	     * @return {Boolean} true if object is fully contained within area formed by 2 points
	     */
	    isContainedWithinRect: function(pointTL, pointBR, absolute, calculate) {
	      var boundingRect = this.getBoundingRect(absolute, calculate);

	      return (
	        boundingRect.left >= pointTL.x &&
	        boundingRect.left + boundingRect.width <= pointBR.x &&
	        boundingRect.top >= pointTL.y &&
	        boundingRect.top + boundingRect.height <= pointBR.y
	      );
	    },

	    /**
	     * Checks if point is inside the object
	     * @param {fabric.Point} point Point to check against
	     * @param {Object} [lines] object returned from @method _getImageLines
	     * @param {Boolean} [absolute] use coordinates without viewportTransform
	     * @param {Boolean} [calculate] use coordinates of current position instead of .oCoords
	     * @return {Boolean} true if point is inside the object
	     */
	    containsPoint: function(point, lines, absolute, calculate) {
	      var coords = this._getCoords(absolute, calculate),
	          lines = lines || this._getImageLines(coords),
	          xPoints = this._findCrossPoints(point, lines);
	      // if xPoints is odd then point is inside the object
	      return (xPoints !== 0 && xPoints % 2 === 1);
	    },

	    /**
	     * Checks if object is contained within the canvas with current viewportTransform
	     * the check is done stopping at first point that appears on screen
	     * @param {Boolean} [calculate] use coordinates of current position instead of .aCoords
	     * @return {Boolean} true if object is fully or partially contained within canvas
	     */
	    isOnScreen: function(calculate) {
	      if (!this.canvas) {
	        return false;
	      }
	      var pointTL = this.canvas.vptCoords.tl, pointBR = this.canvas.vptCoords.br;
	      var points = this.getCoords(true, calculate);
	      // if some point is on screen, the object is on screen.
	      if (points.some(function(point) {
	        return point.x <= pointBR.x && point.x >= pointTL.x &&
	        point.y <= pointBR.y && point.y >= pointTL.y;
	      })) {
	        return true;
	      }
	      // no points on screen, check intersection with absolute coordinates
	      if (this.intersectsWithRect(pointTL, pointBR, true, calculate)) {
	        return true;
	      }
	      return this._containsCenterOfCanvas(pointTL, pointBR, calculate);
	    },

	    /**
	     * Checks if the object contains the midpoint between canvas extremities
	     * Does not make sense outside the context of isOnScreen and isPartiallyOnScreen
	     * @private
	     * @param {Fabric.Point} pointTL Top Left point
	     * @param {Fabric.Point} pointBR Top Right point
	     * @param {Boolean} calculate use coordinates of current position instead of .oCoords
	     * @return {Boolean} true if the object contains the point
	     */
	    _containsCenterOfCanvas: function(pointTL, pointBR, calculate) {
	      // worst case scenario the object is so big that contains the screen
	      var centerPoint = { x: (pointTL.x + pointBR.x) / 2, y: (pointTL.y + pointBR.y) / 2 };
	      if (this.containsPoint(centerPoint, null, true, calculate)) {
	        return true;
	      }
	      return false;
	    },

	    /**
	     * Checks if object is partially contained within the canvas with current viewportTransform
	     * @param {Boolean} [calculate] use coordinates of current position instead of .oCoords
	     * @return {Boolean} true if object is partially contained within canvas
	     */
	    isPartiallyOnScreen: function(calculate) {
	      if (!this.canvas) {
	        return false;
	      }
	      var pointTL = this.canvas.vptCoords.tl, pointBR = this.canvas.vptCoords.br;
	      if (this.intersectsWithRect(pointTL, pointBR, true, calculate)) {
	        return true;
	      }
	      var allPointsAreOutside = this.getCoords(true, calculate).every(function(point) {
	        return (point.x >= pointBR.x || point.x <= pointTL.x) &&
	        (point.y >= pointBR.y || point.y <= pointTL.y);
	      });
	      return allPointsAreOutside && this._containsCenterOfCanvas(pointTL, pointBR, calculate);
	    },

	    /**
	     * Method that returns an object with the object edges in it, given the coordinates of the corners
	     * @private
	     * @param {Object} oCoords Coordinates of the object corners
	     */
	    _getImageLines: function(oCoords) {

	      var lines = {
	        topline: {
	          o: oCoords.tl,
	          d: oCoords.tr
	        },
	        rightline: {
	          o: oCoords.tr,
	          d: oCoords.br
	        },
	        bottomline: {
	          o: oCoords.br,
	          d: oCoords.bl
	        },
	        leftline: {
	          o: oCoords.bl,
	          d: oCoords.tl
	        }
	      };

	      // // debugging
	      // if (this.canvas.contextTop) {
	      //   this.canvas.contextTop.fillRect(lines.bottomline.d.x, lines.bottomline.d.y, 2, 2);
	      //   this.canvas.contextTop.fillRect(lines.bottomline.o.x, lines.bottomline.o.y, 2, 2);
	      //
	      //   this.canvas.contextTop.fillRect(lines.leftline.d.x, lines.leftline.d.y, 2, 2);
	      //   this.canvas.contextTop.fillRect(lines.leftline.o.x, lines.leftline.o.y, 2, 2);
	      //
	      //   this.canvas.contextTop.fillRect(lines.topline.d.x, lines.topline.d.y, 2, 2);
	      //   this.canvas.contextTop.fillRect(lines.topline.o.x, lines.topline.o.y, 2, 2);
	      //
	      //   this.canvas.contextTop.fillRect(lines.rightline.d.x, lines.rightline.d.y, 2, 2);
	      //   this.canvas.contextTop.fillRect(lines.rightline.o.x, lines.rightline.o.y, 2, 2);
	      // }

	      return lines;
	    },

	    /**
	     * Helper method to determine how many cross points are between the 4 object edges
	     * and the horizontal line determined by a point on canvas
	     * @private
	     * @param {fabric.Point} point Point to check
	     * @param {Object} lines Coordinates of the object being evaluated
	     */
	    // remove yi, not used but left code here just in case.
	    _findCrossPoints: function(point, lines) {
	      var b1, b2, a1, a2, xi, // yi,
	          xcount = 0,
	          iLine;

	      for (var lineKey in lines) {
	        iLine = lines[lineKey];
	        // optimisation 1: line below point. no cross
	        if ((iLine.o.y < point.y) && (iLine.d.y < point.y)) {
	          continue;
	        }
	        // optimisation 2: line above point. no cross
	        if ((iLine.o.y >= point.y) && (iLine.d.y >= point.y)) {
	          continue;
	        }
	        // optimisation 3: vertical line case
	        if ((iLine.o.x === iLine.d.x) && (iLine.o.x >= point.x)) {
	          xi = iLine.o.x;
	          // yi = point.y;
	        }
	        // calculate the intersection point
	        else {
	          b1 = 0;
	          b2 = (iLine.d.y - iLine.o.y) / (iLine.d.x - iLine.o.x);
	          a1 = point.y - b1 * point.x;
	          a2 = iLine.o.y - b2 * iLine.o.x;

	          xi = -(a1 - a2) / (b1 - b2);
	          // yi = a1 + b1 * xi;
	        }
	        // dont count xi < point.x cases
	        if (xi >= point.x) {
	          xcount += 1;
	        }
	        // optimisation 4: specific for square images
	        if (xcount === 2) {
	          break;
	        }
	      }
	      return xcount;
	    },

	    /**
	     * Returns coordinates of object's bounding rectangle (left, top, width, height)
	     * the box is intended as aligned to axis of canvas.
	     * @param {Boolean} [absolute] use coordinates without viewportTransform
	     * @param {Boolean} [calculate] use coordinates of current position instead of .oCoords / .aCoords
	     * @return {Object} Object with left, top, width, height properties
	     */
	    getBoundingRect: function(absolute, calculate) {
	      var coords = this.getCoords(absolute, calculate);
	      return util.makeBoundingBoxFromPoints(coords);
	    },

	    /**
	     * Returns width of an object's bounding box counting transformations
	     * before 2.0 it was named getWidth();
	     * @return {Number} width value
	     */
	    getScaledWidth: function() {
	      return this._getTransformedDimensions().x;
	    },

	    /**
	     * Returns height of an object bounding box counting transformations
	     * before 2.0 it was named getHeight();
	     * @return {Number} height value
	     */
	    getScaledHeight: function() {
	      return this._getTransformedDimensions().y;
	    },

	    /**
	     * Makes sure the scale is valid and modifies it if necessary
	     * @private
	     * @param {Number} value
	     * @return {Number}
	     */
	    _constrainScale: function(value) {
	      if (Math.abs(value) < this.minScaleLimit) {
	        if (value < 0) {
	          return -this.minScaleLimit;
	        }
	        else {
	          return this.minScaleLimit;
	        }
	      }
	      else if (value === 0) {
	        return 0.0001;
	      }
	      return value;
	    },

	    /**
	     * Scales an object (equally by x and y)
	     * @param {Number} value Scale factor
	     * @return {fabric.Object} thisArg
	     * @chainable
	     */
	    scale: function(value) {
	      this._set('scaleX', value);
	      this._set('scaleY', value);
	      return this.setCoords();
	    },

	    /**
	     * Scales an object to a given width, with respect to bounding box (scaling by x/y equally)
	     * @param {Number} value New width value
	     * @param {Boolean} absolute ignore viewport
	     * @return {fabric.Object} thisArg
	     * @chainable
	     */
	    scaleToWidth: function(value, absolute) {
	      // adjust to bounding rect factor so that rotated shapes would fit as well
	      var boundingRectFactor = this.getBoundingRect(absolute).width / this.getScaledWidth();
	      return this.scale(value / this.width / boundingRectFactor);
	    },

	    /**
	     * Scales an object to a given height, with respect to bounding box (scaling by x/y equally)
	     * @param {Number} value New height value
	     * @param {Boolean} absolute ignore viewport
	     * @return {fabric.Object} thisArg
	     * @chainable
	     */
	    scaleToHeight: function(value, absolute) {
	      // adjust to bounding rect factor so that rotated shapes would fit as well
	      var boundingRectFactor = this.getBoundingRect(absolute).height / this.getScaledHeight();
	      return this.scale(value / this.height / boundingRectFactor);
	    },

	    /**
	     * Calculates and returns the .coords of an object.
	     * unused by the library, only for the end dev.
	     * @return {Object} Object with tl, tr, br, bl ....
	     * @chainable
	     * @deprecated
	     */
	    calcCoords: function(absolute) {
	      // this is a compatibility function to avoid removing calcCoords now.
	      if (absolute) {
	        return this.calcACoords();
	      }
	      return this.calcOCoords();
	    },

	    calcLineCoords: function() {
	      var vpt = this.getViewportTransform(),
	          padding = this.padding, angle = degreesToRadians(this.angle),
	          cos = util.cos(angle), sin = util.sin(angle),
	          cosP = cos * padding, sinP = sin * padding, cosPSinP = cosP + sinP,
	          cosPMinusSinP = cosP - sinP, aCoords = this.calcACoords();

	      var lineCoords = {
	        tl: transformPoint(aCoords.tl, vpt),
	        tr: transformPoint(aCoords.tr, vpt),
	        bl: transformPoint(aCoords.bl, vpt),
	        br: transformPoint(aCoords.br, vpt),
	      };

	      if (padding) {
	        lineCoords.tl.x -= cosPMinusSinP;
	        lineCoords.tl.y -= cosPSinP;
	        lineCoords.tr.x += cosPSinP;
	        lineCoords.tr.y -= cosPMinusSinP;
	        lineCoords.bl.x -= cosPSinP;
	        lineCoords.bl.y += cosPMinusSinP;
	        lineCoords.br.x += cosPMinusSinP;
	        lineCoords.br.y += cosPSinP;
	      }

	      return lineCoords;
	    },

	    calcOCoords: function() {
	      var rotateMatrix = this._calcRotateMatrix(),
	          translateMatrix = this._calcTranslateMatrix(),
	          vpt = this.getViewportTransform(),
	          startMatrix = multiplyMatrices(vpt, translateMatrix),
	          finalMatrix = multiplyMatrices(startMatrix, rotateMatrix),
	          finalMatrix = multiplyMatrices(finalMatrix, [1 / vpt[0], 0, 0, 1 / vpt[3], 0, 0]),
	          dim = this._calculateCurrentDimensions(),
	          coords = {};
	      this.forEachControl(function(control, key, fabricObject) {
	        coords[key] = control.positionHandler(dim, finalMatrix, fabricObject);
	      });

	      // debug code
	      // var canvas = this.canvas;
	      // setTimeout(function() {
	      //   canvas.contextTop.clearRect(0, 0, 700, 700);
	      //   canvas.contextTop.fillStyle = 'green';
	      //   Object.keys(coords).forEach(function(key) {
	      //     var control = coords[key];
	      //     canvas.contextTop.fillRect(control.x, control.y, 3, 3);
	      //   });
	      // }, 50);
	      return coords;
	    },

	    calcACoords: function() {
	      var rotateMatrix = this._calcRotateMatrix(),
	          translateMatrix = this._calcTranslateMatrix(),
	          finalMatrix = multiplyMatrices(translateMatrix, rotateMatrix),
	          dim = this._getTransformedDimensions(),
	          w = dim.x / 2, h = dim.y / 2;
	      return {
	        // corners
	        tl: transformPoint({ x: -w, y: -h }, finalMatrix),
	        tr: transformPoint({ x: w, y: -h }, finalMatrix),
	        bl: transformPoint({ x: -w, y: h }, finalMatrix),
	        br: transformPoint({ x: w, y: h }, finalMatrix)
	      };
	    },

	    /**
	     * Sets corner and controls position coordinates based on current angle, width and height, left and top.
	     * oCoords are used to find the corners
	     * aCoords are used to quickly find an object on the canvas
	     * lineCoords are used to quickly find object during pointer events.
	     * See {@link https://github.com/kangax/fabric.js/wiki/When-to-call-setCoords|When-to-call-setCoords}
	     * @param {Boolean} [skipCorners] skip calculation of oCoords.
	     * @return {fabric.Object} thisArg
	     * @chainable
	     */
	    setCoords: function(skipCorners) {
	      this.aCoords = this.calcACoords();
	      // in case we are in a group, for how the inner group target check works,
	      // lineCoords are exactly aCoords. Since the vpt gets absorbed by the normalized pointer.
	      this.lineCoords = this.group ? this.aCoords : this.calcLineCoords();
	      if (skipCorners) {
	        return this;
	      }
	      // set coordinates of the draggable boxes in the corners used to scale/rotate the image
	      this.oCoords = this.calcOCoords();
	      this._setCornerCoords && this._setCornerCoords();
	      return this;
	    },

	    /**
	     * calculate rotation matrix of an object
	     * @return {Array} rotation matrix for the object
	     */
	    _calcRotateMatrix: function() {
	      return util.calcRotateMatrix(this);
	    },

	    /**
	     * calculate the translation matrix for an object transform
	     * @return {Array} rotation matrix for the object
	     */
	    _calcTranslateMatrix: function() {
	      var center = this.getCenterPoint();
	      return [1, 0, 0, 1, center.x, center.y];
	    },

	    transformMatrixKey: function(skipGroup) {
	      var sep = '_', prefix = '';
	      if (!skipGroup && this.group) {
	        prefix = this.group.transformMatrixKey(skipGroup) + sep;
	      }	      return prefix + this.top + sep + this.left + sep + this.scaleX + sep + this.scaleY +
	        sep + this.skewX + sep + this.skewY + sep + this.angle + sep + this.originX + sep + this.originY +
	        sep + this.width + sep + this.height + sep + this.strokeWidth + this.flipX + this.flipY;
	    },

	    /**
	     * calculate transform matrix that represents the current transformations from the
	     * object's properties.
	     * @param {Boolean} [skipGroup] return transform matrix for object not counting parent transformations
	     * There are some situation in which this is useful to avoid the fake rotation.
	     * @return {Array} transform matrix for the object
	     */
	    calcTransformMatrix: function(skipGroup) {
	      var matrix = this.calcOwnMatrix();
	      if (skipGroup || !this.group) {
	        return matrix;
	      }
	      var key = this.transformMatrixKey(skipGroup), cache = this.matrixCache || (this.matrixCache = {});
	      if (cache.key === key) {
	        return cache.value;
	      }
	      if (this.group) {
	        matrix = multiplyMatrices(this.group.calcTransformMatrix(false), matrix);
	      }
	      cache.key = key;
	      cache.value = matrix;
	      return matrix;
	    },

	    /**
	     * calculate transform matrix that represents the current transformations from the
	     * object's properties, this matrix does not include the group transformation
	     * @return {Array} transform matrix for the object
	     */
	    calcOwnMatrix: function() {
	      var key = this.transformMatrixKey(true), cache = this.ownMatrixCache || (this.ownMatrixCache = {});
	      if (cache.key === key) {
	        return cache.value;
	      }
	      var tMatrix = this._calcTranslateMatrix(),
	          options = {
	            angle: this.angle,
	            translateX: tMatrix[4],
	            translateY: tMatrix[5],
	            scaleX: this.scaleX,
	            scaleY: this.scaleY,
	            skewX: this.skewX,
	            skewY: this.skewY,
	            flipX: this.flipX,
	            flipY: this.flipY,
	          };
	      cache.key = key;
	      cache.value = util.composeMatrix(options);
	      return cache.value;
	    },

	    /*
	     * Calculate object dimensions from its properties
	     * @private
	     * @deprecated since 3.4.0, please use fabric.util._calcDimensionsTransformMatrix
	     * not including or including flipX, flipY to emulate the flipping boolean
	     * @return {Object} .x width dimension
	     * @return {Object} .y height dimension
	     */
	    _calcDimensionsTransformMatrix: function(skewX, skewY, flipping) {
	      return util.calcDimensionsMatrix({
	        skewX: skewX,
	        skewY: skewY,
	        scaleX: this.scaleX * (flipping && this.flipX ? -1 : 1),
	        scaleY: this.scaleY * (flipping && this.flipY ? -1 : 1)
	      });
	    },

	    /*
	     * Calculate object dimensions from its properties
	     * @private
	     * @return {Object} .x width dimension
	     * @return {Object} .y height dimension
	     */
	    _getNonTransformedDimensions: function() {
	      var strokeWidth = this.strokeWidth,
	          w = this.width + strokeWidth,
	          h = this.height + strokeWidth;
	      return { x: w, y: h };
	    },

	    /*
	     * Calculate object bounding box dimensions from its properties scale, skew.
	     * @param {Number} skewX, a value to override current skewX
	     * @param {Number} skewY, a value to override current skewY
	     * @private
	     * @return {Object} .x width dimension
	     * @return {Object} .y height dimension
	     */
	    _getTransformedDimensions: function(skewX, skewY) {
	      if (typeof skewX === 'undefined') {
	        skewX = this.skewX;
	      }
	      if (typeof skewY === 'undefined') {
	        skewY = this.skewY;
	      }
	      var dimensions, dimX, dimY,
	          noSkew = skewX === 0 && skewY === 0;

	      if (this.strokeUniform) {
	        dimX = this.width;
	        dimY = this.height;
	      }
	      else {
	        dimensions = this._getNonTransformedDimensions();
	        dimX = dimensions.x;
	        dimY = dimensions.y;
	      }
	      if (noSkew) {
	        return this._finalizeDimensions(dimX * this.scaleX, dimY * this.scaleY);
	      }
	      var bbox = util.sizeAfterTransform(dimX, dimY, {
	        scaleX: this.scaleX,
	        scaleY: this.scaleY,
	        skewX: skewX,
	        skewY: skewY,
	      });
	      return this._finalizeDimensions(bbox.x, bbox.y);
	    },

	    /*
	     * Calculate object bounding box dimensions from its properties scale, skew.
	     * @param Number width width of the bbox
	     * @param Number height height of the bbox
	     * @private
	     * @return {Object} .x finalized width dimension
	     * @return {Object} .y finalized height dimension
	     */
	    _finalizeDimensions: function(width, height) {
	      return this.strokeUniform ?
	        { x: width + this.strokeWidth, y: height + this.strokeWidth }
	        :
	        { x: width, y: height };
	    },

	    /*
	     * Calculate object dimensions for controls box, including padding and canvas zoom.
	     * and active selection
	     * private
	     */
	    _calculateCurrentDimensions: function()  {
	      var vpt = this.getViewportTransform(),
	          dim = this._getTransformedDimensions(),
	          p = transformPoint(dim, vpt, true);
	      return p.scalarAdd(2 * this.padding);
	    },
	  });
	})();


	fabric.util.object.extend(fabric.Object.prototype, /** @lends fabric.Object.prototype */ {

	  /**
	   * Moves an object to the bottom of the stack of drawn objects
	   * @return {fabric.Object} thisArg
	   * @chainable
	   */
	  sendToBack: function() {
	    if (this.group) {
	      fabric.StaticCanvas.prototype.sendToBack.call(this.group, this);
	    }
	    else if (this.canvas) {
	      this.canvas.sendToBack(this);
	    }
	    return this;
	  },

	  /**
	   * Moves an object to the top of the stack of drawn objects
	   * @return {fabric.Object} thisArg
	   * @chainable
	   */
	  bringToFront: function() {
	    if (this.group) {
	      fabric.StaticCanvas.prototype.bringToFront.call(this.group, this);
	    }
	    else if (this.canvas) {
	      this.canvas.bringToFront(this);
	    }
	    return this;
	  },

	  /**
	   * Moves an object down in stack of drawn objects
	   * @param {Boolean} [intersecting] If `true`, send object behind next lower intersecting object
	   * @return {fabric.Object} thisArg
	   * @chainable
	   */
	  sendBackwards: function(intersecting) {
	    if (this.group) {
	      fabric.StaticCanvas.prototype.sendBackwards.call(this.group, this, intersecting);
	    }
	    else if (this.canvas) {
	      this.canvas.sendBackwards(this, intersecting);
	    }
	    return this;
	  },

	  /**
	   * Moves an object up in stack of drawn objects
	   * @param {Boolean} [intersecting] If `true`, send object in front of next upper intersecting object
	   * @return {fabric.Object} thisArg
	   * @chainable
	   */
	  bringForward: function(intersecting) {
	    if (this.group) {
	      fabric.StaticCanvas.prototype.bringForward.call(this.group, this, intersecting);
	    }
	    else if (this.canvas) {
	      this.canvas.bringForward(this, intersecting);
	    }
	    return this;
	  },

	  /**
	   * Moves an object to specified level in stack of drawn objects
	   * @param {Number} index New position of object
	   * @return {fabric.Object} thisArg
	   * @chainable
	   */
	  moveTo: function(index) {
	    if (this.group && this.group.type !== 'activeSelection') {
	      fabric.StaticCanvas.prototype.moveTo.call(this.group, this, index);
	    }
	    else if (this.canvas) {
	      this.canvas.moveTo(this, index);
	    }
	    return this;
	  }
	});


	/* _TO_SVG_START_ */
	(function() {
	  function getSvgColorString(prop, value) {
	    if (!value) {
	      return prop + ': none; ';
	    }
	    else if (value.toLive) {
	      return prop + ': url(#SVGID_' + value.id + '); ';
	    }
	    else {
	      var color = new fabric.Color(value),
	          str = prop + ': ' + color.toRgb() + '; ',
	          opacity = color.getAlpha();
	      if (opacity !== 1) {
	        //change the color in rgb + opacity
	        str += prop + '-opacity: ' + opacity.toString() + '; ';
	      }
	      return str;
	    }
	  }

	  var toFixed = fabric.util.toFixed;

	  fabric.util.object.extend(fabric.Object.prototype, /** @lends fabric.Object.prototype */ {
	    /**
	     * Returns styles-string for svg-export
	     * @param {Boolean} skipShadow a boolean to skip shadow filter output
	     * @return {String}
	     */
	    getSvgStyles: function(skipShadow) {

	      var fillRule = this.fillRule ? this.fillRule : 'nonzero',
	          strokeWidth = this.strokeWidth ? this.strokeWidth : '0',
	          strokeDashArray = this.strokeDashArray ? this.strokeDashArray.join(' ') : 'none',
	          strokeDashOffset = this.strokeDashOffset ? this.strokeDashOffset : '0',
	          strokeLineCap = this.strokeLineCap ? this.strokeLineCap : 'butt',
	          strokeLineJoin = this.strokeLineJoin ? this.strokeLineJoin : 'miter',
	          strokeMiterLimit = this.strokeMiterLimit ? this.strokeMiterLimit : '4',
	          opacity = typeof this.opacity !== 'undefined' ? this.opacity : '1',
	          visibility = this.visible ? '' : ' visibility: hidden;',
	          filter = skipShadow ? '' : this.getSvgFilter(),
	          fill = getSvgColorString('fill', this.fill),
	          stroke = getSvgColorString('stroke', this.stroke);

	      return [
	        stroke,
	        'stroke-width: ', strokeWidth, '; ',
	        'stroke-dasharray: ', strokeDashArray, '; ',
	        'stroke-linecap: ', strokeLineCap, '; ',
	        'stroke-dashoffset: ', strokeDashOffset, '; ',
	        'stroke-linejoin: ', strokeLineJoin, '; ',
	        'stroke-miterlimit: ', strokeMiterLimit, '; ',
	        fill,
	        'fill-rule: ', fillRule, '; ',
	        'opacity: ', opacity, ';',
	        filter,
	        visibility
	      ].join('');
	    },

	    /**
	     * Returns styles-string for svg-export
	     * @param {Object} style the object from which to retrieve style properties
	     * @param {Boolean} useWhiteSpace a boolean to include an additional attribute in the style.
	     * @return {String}
	     */
	    getSvgSpanStyles: function(style, useWhiteSpace) {
	      var term = '; ';
	      var fontFamily = style.fontFamily ?
	        'font-family: ' + (((style.fontFamily.indexOf('\'') === -1 && style.fontFamily.indexOf('"') === -1) ?
	          '\'' + style.fontFamily  + '\'' : style.fontFamily)) + term : '';
	      var strokeWidth = style.strokeWidth ? 'stroke-width: ' + style.strokeWidth + term : '',
	          fontFamily = fontFamily,
	          fontSize = style.fontSize ? 'font-size: ' + style.fontSize + 'px' + term : '',
	          fontStyle = style.fontStyle ? 'font-style: ' + style.fontStyle + term : '',
	          fontWeight = style.fontWeight ? 'font-weight: ' + style.fontWeight + term : '',
	          fill = style.fill ? getSvgColorString('fill', style.fill) : '',
	          stroke = style.stroke ? getSvgColorString('stroke', style.stroke) : '',
	          textDecoration = this.getSvgTextDecoration(style),
	          deltaY = style.deltaY ? 'baseline-shift: ' + (-style.deltaY) + '; ' : '';
	      if (textDecoration) {
	        textDecoration = 'text-decoration: ' + textDecoration + term;
	      }

	      return [
	        stroke,
	        strokeWidth,
	        fontFamily,
	        fontSize,
	        fontStyle,
	        fontWeight,
	        textDecoration,
	        fill,
	        deltaY,
	        useWhiteSpace ? 'white-space: pre; ' : ''
	      ].join('');
	    },

	    /**
	     * Returns text-decoration property for svg-export
	     * @param {Object} style the object from which to retrieve style properties
	     * @return {String}
	     */
	    getSvgTextDecoration: function(style) {
	      return ['overline', 'underline', 'line-through'].filter(function(decoration) {
	        return style[decoration.replace('-', '')];
	      }).join(' ');
	    },

	    /**
	     * Returns filter for svg shadow
	     * @return {String}
	     */
	    getSvgFilter: function() {
	      return this.shadow ? 'filter: url(#SVGID_' + this.shadow.id + ');' : '';
	    },

	    /**
	     * Returns id attribute for svg output
	     * @return {String}
	     */
	    getSvgCommons: function() {
	      return [
	        this.id ? 'id="' + this.id + '" ' : '',
	        this.clipPath ? 'clip-path="url(#' + this.clipPath.clipPathId + ')" ' : '',
	      ].join('');
	    },

	    /**
	     * Returns transform-string for svg-export
	     * @param {Boolean} use the full transform or the single object one.
	     * @return {String}
	     */
	    getSvgTransform: function(full, additionalTransform) {
	      var transform = full ? this.calcTransformMatrix() : this.calcOwnMatrix(),
	          svgTransform = 'transform="' + fabric.util.matrixToSVG(transform);
	      return svgTransform +
	        (additionalTransform || '') + '" ';
	    },

	    _setSVGBg: function(textBgRects) {
	      if (this.backgroundColor) {
	        var NUM_FRACTION_DIGITS = fabric.Object.NUM_FRACTION_DIGITS;
	        textBgRects.push(
	          '\t\t<rect ',
	          this._getFillAttributes(this.backgroundColor),
	          ' x="',
	          toFixed(-this.width / 2, NUM_FRACTION_DIGITS),
	          '" y="',
	          toFixed(-this.height / 2, NUM_FRACTION_DIGITS),
	          '" width="',
	          toFixed(this.width, NUM_FRACTION_DIGITS),
	          '" height="',
	          toFixed(this.height, NUM_FRACTION_DIGITS),
	          '"></rect>\n');
	      }
	    },

	    /**
	     * Returns svg representation of an instance
	     * @param {Function} [reviver] Method for further parsing of svg representation.
	     * @return {String} svg representation of an instance
	     */
	    toSVG: function(reviver) {
	      return this._createBaseSVGMarkup(this._toSVG(reviver), { reviver: reviver });
	    },

	    /**
	     * Returns svg clipPath representation of an instance
	     * @param {Function} [reviver] Method for further parsing of svg representation.
	     * @return {String} svg representation of an instance
	     */
	    toClipPathSVG: function(reviver) {
	      return '\t' + this._createBaseClipPathSVGMarkup(this._toSVG(reviver), { reviver: reviver });
	    },

	    /**
	     * @private
	     */
	    _createBaseClipPathSVGMarkup: function(objectMarkup, options) {
	      options = options || {};
	      var reviver = options.reviver,
	          additionalTransform = options.additionalTransform || '',
	          commonPieces = [
	            this.getSvgTransform(true, additionalTransform),
	            this.getSvgCommons(),
	          ].join(''),
	          // insert commons in the markup, style and svgCommons
	          index = objectMarkup.indexOf('COMMON_PARTS');
	      objectMarkup[index] = commonPieces;
	      return reviver ? reviver(objectMarkup.join('')) : objectMarkup.join('');
	    },

	    /**
	     * @private
	     */
	    _createBaseSVGMarkup: function(objectMarkup, options) {
	      options = options || {};
	      var noStyle = options.noStyle,
	          reviver = options.reviver,
	          styleInfo = noStyle ? '' : 'style="' + this.getSvgStyles() + '" ',
	          shadowInfo = options.withShadow ? 'style="' + this.getSvgFilter() + '" ' : '',
	          clipPath = this.clipPath,
	          vectorEffect = this.strokeUniform ? 'vector-effect="non-scaling-stroke" ' : '',
	          absoluteClipPath = clipPath && clipPath.absolutePositioned,
	          stroke = this.stroke, fill = this.fill, shadow = this.shadow,
	          commonPieces, markup = [], clipPathMarkup,
	          // insert commons in the markup, style and svgCommons
	          index = objectMarkup.indexOf('COMMON_PARTS'),
	          additionalTransform = options.additionalTransform;
	      if (clipPath) {
	        clipPath.clipPathId = 'CLIPPATH_' + fabric.Object.__uid++;
	        clipPathMarkup = '<clipPath id="' + clipPath.clipPathId + '" >\n' +
	          clipPath.toClipPathSVG(reviver) +
	          '</clipPath>\n';
	      }
	      if (absoluteClipPath) {
	        markup.push(
	          '<g ', shadowInfo, this.getSvgCommons(), ' >\n'
	        );
	      }
	      markup.push(
	        '<g ',
	        this.getSvgTransform(false),
	        !absoluteClipPath ? shadowInfo + this.getSvgCommons() : '',
	        ' >\n'
	      );
	      commonPieces = [
	        styleInfo,
	        vectorEffect,
	        noStyle ? '' : this.addPaintOrder(), ' ',
	        additionalTransform ? 'transform="' + additionalTransform + '" ' : '',
	      ].join('');
	      objectMarkup[index] = commonPieces;
	      if (fill && fill.toLive) {
	        markup.push(fill.toSVG(this));
	      }
	      if (stroke && stroke.toLive) {
	        markup.push(stroke.toSVG(this));
	      }
	      if (shadow) {
	        markup.push(shadow.toSVG(this));
	      }
	      if (clipPath) {
	        markup.push(clipPathMarkup);
	      }
	      markup.push(objectMarkup.join(''));
	      markup.push('</g>\n');
	      absoluteClipPath && markup.push('</g>\n');
	      return reviver ? reviver(markup.join('')) : markup.join('');
	    },

	    addPaintOrder: function() {
	      return this.paintFirst !== 'fill' ? ' paint-order="' + this.paintFirst + '" ' : '';
	    }
	  });
	})();
	/* _TO_SVG_END_ */


	(function() {

	  var extend = fabric.util.object.extend,
	      originalSet = 'stateProperties';

	  /*
	    Depends on `stateProperties`
	  */
	  function saveProps(origin, destination, props) {
	    var tmpObj = { }, deep = true;
	    props.forEach(function(prop) {
	      tmpObj[prop] = origin[prop];
	    });

	    extend(origin[destination], tmpObj, deep);
	  }

	  function _isEqual(origValue, currentValue, firstPass) {
	    if (origValue === currentValue) {
	      // if the objects are identical, return
	      return true;
	    }
	    else if (Array.isArray(origValue)) {
	      if (!Array.isArray(currentValue) || origValue.length !== currentValue.length) {
	        return false;
	      }
	      for (var i = 0, len = origValue.length; i < len; i++) {
	        if (!_isEqual(origValue[i], currentValue[i])) {
	          return false;
	        }
	      }
	      return true;
	    }
	    else if (origValue && typeof origValue === 'object') {
	      var keys = Object.keys(origValue), key;
	      if (!currentValue ||
	          typeof currentValue !== 'object' ||
	          (!firstPass && keys.length !== Object.keys(currentValue).length)
	      ) {
	        return false;
	      }
	      for (var i = 0, len = keys.length; i < len; i++) {
	        key = keys[i];
	        // since clipPath is in the statefull cache list and the clipPath objects
	        // would be iterated as an object, this would lead to possible infinite recursion
	        // we do not want to compare those.
	        if (key === 'canvas' || key === 'group') {
	          continue;
	        }
	        if (!_isEqual(origValue[key], currentValue[key])) {
	          return false;
	        }
	      }
	      return true;
	    }
	  }


	  fabric.util.object.extend(fabric.Object.prototype, /** @lends fabric.Object.prototype */ {

	    /**
	     * Returns true if object state (one of its state properties) was changed
	     * @param {String} [propertySet] optional name for the set of property we want to save
	     * @return {Boolean} true if instance' state has changed since `{@link fabric.Object#saveState}` was called
	     */
	    hasStateChanged: function(propertySet) {
	      propertySet = propertySet || originalSet;
	      var dashedPropertySet = '_' + propertySet;
	      if (Object.keys(this[dashedPropertySet]).length < this[propertySet].length) {
	        return true;
	      }
	      return !_isEqual(this[dashedPropertySet], this, true);
	    },

	    /**
	     * Saves state of an object
	     * @param {Object} [options] Object with additional `stateProperties` array to include when saving state
	     * @return {fabric.Object} thisArg
	     */
	    saveState: function(options) {
	      var propertySet = options && options.propertySet || originalSet,
	          destination = '_' + propertySet;
	      if (!this[destination]) {
	        return this.setupState(options);
	      }
	      saveProps(this, destination, this[propertySet]);
	      if (options && options.stateProperties) {
	        saveProps(this, destination, options.stateProperties);
	      }
	      return this;
	    },

	    /**
	     * Setups state of an object
	     * @param {Object} [options] Object with additional `stateProperties` array to include when saving state
	     * @return {fabric.Object} thisArg
	     */
	    setupState: function(options) {
	      options = options || { };
	      var propertySet = options.propertySet || originalSet;
	      options.propertySet = propertySet;
	      this['_' + propertySet] = { };
	      this.saveState(options);
	      return this;
	    }
	  });
	})();


	(function() {

	  var degreesToRadians = fabric.util.degreesToRadians;

	  fabric.util.object.extend(fabric.Object.prototype, /** @lends fabric.Object.prototype */ {
	    /**
	     * Determines which corner has been clicked
	     * @private
	     * @param {Object} pointer The pointer indicating the mouse position
	     * @return {String|Boolean} corner code (tl, tr, bl, br, etc.), or false if nothing is found
	     */
	    _findTargetCorner: function(pointer, forTouch) {
	      // objects in group, anykind, are not self modificable,
	      // must not return an hovered corner.
	      if (!this.hasControls || this.group || (!this.canvas || this.canvas._activeObject !== this)) {
	        return false;
	      }

	      var ex = pointer.x,
	          ey = pointer.y,
	          xPoints,
	          lines, keys = Object.keys(this.oCoords),
	          j = keys.length - 1, i;
	      this.__corner = 0;

	      // cycle in reverse order so we pick first the one on top
	      for (; j >= 0; j--) {
	        i = keys[j];
	        if (!this.isControlVisible(i)) {
	          continue;
	        }

	        lines = this._getImageLines(forTouch ? this.oCoords[i].touchCorner : this.oCoords[i].corner);
	        // // debugging
	        //
	        // this.canvas.contextTop.fillRect(lines.bottomline.d.x, lines.bottomline.d.y, 2, 2);
	        // this.canvas.contextTop.fillRect(lines.bottomline.o.x, lines.bottomline.o.y, 2, 2);
	        //
	        // this.canvas.contextTop.fillRect(lines.leftline.d.x, lines.leftline.d.y, 2, 2);
	        // this.canvas.contextTop.fillRect(lines.leftline.o.x, lines.leftline.o.y, 2, 2);
	        //
	        // this.canvas.contextTop.fillRect(lines.topline.d.x, lines.topline.d.y, 2, 2);
	        // this.canvas.contextTop.fillRect(lines.topline.o.x, lines.topline.o.y, 2, 2);
	        //
	        // this.canvas.contextTop.fillRect(lines.rightline.d.x, lines.rightline.d.y, 2, 2);
	        // this.canvas.contextTop.fillRect(lines.rightline.o.x, lines.rightline.o.y, 2, 2);

	        xPoints = this._findCrossPoints({ x: ex, y: ey }, lines);
	        if (xPoints !== 0 && xPoints % 2 === 1) {
	          this.__corner = i;
	          return i;
	        }
	      }
	      return false;
	    },

	    /**
	     * Calls a function for each control. The function gets called,
	     * with the control, the object that is calling the iterator and the control's key
	     * @param {Function} fn function to iterate over the controls over
	     */
	    forEachControl: function(fn) {
	      for (var i in this.controls) {
	        fn(this.controls[i], i, this);
	      }	    },

	    /**
	     * Sets the coordinates of the draggable boxes in the corners of
	     * the image used to scale/rotate it.
	     * note: if we would switch to ROUND corner area, all of this would disappear.
	     * everything would resolve to a single point and a pythagorean theorem for the distance
	     * @private
	     */
	    _setCornerCoords: function() {
	      var coords = this.oCoords;

	      for (var control in coords) {
	        var controlObject = this.controls[control];
	        coords[control].corner = controlObject.calcCornerCoords(
	          this.angle, this.cornerSize, coords[control].x, coords[control].y, false);
	        coords[control].touchCorner = controlObject.calcCornerCoords(
	          this.angle, this.touchCornerSize, coords[control].x, coords[control].y, true);
	      }
	    },

	    /**
	     * Draws a colored layer behind the object, inside its selection borders.
	     * Requires public options: padding, selectionBackgroundColor
	     * this function is called when the context is transformed
	     * has checks to be skipped when the object is on a staticCanvas
	     * @param {CanvasRenderingContext2D} ctx Context to draw on
	     * @return {fabric.Object} thisArg
	     * @chainable
	     */
	    drawSelectionBackground: function(ctx) {
	      if (!this.selectionBackgroundColor ||
	        (this.canvas && !this.canvas.interactive) ||
	        (this.canvas && this.canvas._activeObject !== this)
	      ) {
	        return this;
	      }
	      ctx.save();
	      var center = this.getCenterPoint(), wh = this._calculateCurrentDimensions(),
	          vpt = this.canvas.viewportTransform;
	      ctx.translate(center.x, center.y);
	      ctx.scale(1 / vpt[0], 1 / vpt[3]);
	      ctx.rotate(degreesToRadians(this.angle));
	      ctx.fillStyle = this.selectionBackgroundColor;
	      ctx.fillRect(-wh.x / 2, -wh.y / 2, wh.x, wh.y);
	      ctx.restore();
	      return this;
	    },

	    /**
	     * Draws borders of an object's bounding box.
	     * Requires public properties: width, height
	     * Requires public options: padding, borderColor
	     * @param {CanvasRenderingContext2D} ctx Context to draw on
	     * @param {Object} styleOverride object to override the object style
	     * @return {fabric.Object} thisArg
	     * @chainable
	     */
	    drawBorders: function(ctx, styleOverride) {
	      styleOverride = styleOverride || {};
	      var wh = this._calculateCurrentDimensions(),
	          strokeWidth = this.borderScaleFactor,
	          width = wh.x + strokeWidth,
	          height = wh.y + strokeWidth,
	          hasControls = typeof styleOverride.hasControls !== 'undefined' ?
	            styleOverride.hasControls : this.hasControls,
	          shouldStroke = false;

	      ctx.save();
	      ctx.strokeStyle = styleOverride.borderColor || this.borderColor;
	      this._setLineDash(ctx, styleOverride.borderDashArray || this.borderDashArray);

	      ctx.strokeRect(
	        -width / 2,
	        -height / 2,
	        width,
	        height
	      );

	      if (hasControls) {
	        ctx.beginPath();
	        this.forEachControl(function(control, key, fabricObject) {
	          // in this moment, the ctx is centered on the object.
	          // width and height of the above function are the size of the bbox.
	          if (control.withConnection && control.getVisibility(fabricObject, key)) {
	            // reset movement for each control
	            shouldStroke = true;
	            ctx.moveTo(control.x * width, control.y * height);
	            ctx.lineTo(
	              control.x * width + control.offsetX,
	              control.y * height + control.offsetY
	            );
	          }
	        });
	        if (shouldStroke) {
	          ctx.stroke();
	        }
	      }
	      ctx.restore();
	      return this;
	    },

	    /**
	     * Draws borders of an object's bounding box when it is inside a group.
	     * Requires public properties: width, height
	     * Requires public options: padding, borderColor
	     * @param {CanvasRenderingContext2D} ctx Context to draw on
	     * @param {object} options object representing current object parameters
	     * @param {Object} styleOverride object to override the object style
	     * @return {fabric.Object} thisArg
	     * @chainable
	     */
	    drawBordersInGroup: function(ctx, options, styleOverride) {
	      styleOverride = styleOverride || {};
	      var bbox = fabric.util.sizeAfterTransform(this.width, this.height, options),
	          strokeWidth = this.strokeWidth,
	          strokeUniform = this.strokeUniform,
	          borderScaleFactor = this.borderScaleFactor,
	          width =
	            bbox.x + strokeWidth * (strokeUniform ? this.canvas.getZoom() : options.scaleX) + borderScaleFactor,
	          height =
	            bbox.y + strokeWidth * (strokeUniform ? this.canvas.getZoom() : options.scaleY) + borderScaleFactor;
	      ctx.save();
	      this._setLineDash(ctx, styleOverride.borderDashArray || this.borderDashArray);
	      ctx.strokeStyle = styleOverride.borderColor || this.borderColor;
	      ctx.strokeRect(
	        -width / 2,
	        -height / 2,
	        width,
	        height
	      );

	      ctx.restore();
	      return this;
	    },

	    /**
	     * Draws corners of an object's bounding box.
	     * Requires public properties: width, height
	     * Requires public options: cornerSize, padding
	     * @param {CanvasRenderingContext2D} ctx Context to draw on
	     * @param {Object} styleOverride object to override the object style
	     * @return {fabric.Object} thisArg
	     * @chainable
	     */
	    drawControls: function(ctx, styleOverride) {
	      styleOverride = styleOverride || {};
	      ctx.save();
	      var retinaScaling = this.canvas.getRetinaScaling(), matrix, p;
	      ctx.setTransform(retinaScaling, 0, 0, retinaScaling, 0, 0);
	      ctx.strokeStyle = ctx.fillStyle = styleOverride.cornerColor || this.cornerColor;
	      if (!this.transparentCorners) {
	        ctx.strokeStyle = styleOverride.cornerStrokeColor || this.cornerStrokeColor;
	      }
	      this._setLineDash(ctx, styleOverride.cornerDashArray || this.cornerDashArray);
	      this.setCoords();
	      if (this.group) {
	        // fabricJS does not really support drawing controls inside groups,
	        // this piece of code here helps having at least the control in places.
	        // If an application needs to show some objects as selected because of some UI state
	        // can still call Object._renderControls() on any object they desire, independently of groups.
	        // using no padding, circular controls and hiding the rotating cursor is higly suggested,
	        matrix = this.group.calcTransformMatrix();
	      }
	      this.forEachControl(function(control, key, fabricObject) {
	        p = fabricObject.oCoords[key];
	        if (control.getVisibility(fabricObject, key)) {
	          if (matrix) {
	            p = fabric.util.transformPoint(p, matrix);
	          }
	          control.render(ctx, p.x, p.y, styleOverride, fabricObject);
	        }
	      });
	      ctx.restore();

	      return this;
	    },

	    /**
	     * Returns true if the specified control is visible, false otherwise.
	     * @param {String} controlKey The key of the control. Possible values are 'tl', 'tr', 'br', 'bl', 'ml', 'mt', 'mr', 'mb', 'mtr'.
	     * @returns {Boolean} true if the specified control is visible, false otherwise
	     */
	    isControlVisible: function(controlKey) {
	      return this.controls[controlKey] && this.controls[controlKey].getVisibility(this, controlKey);
	    },

	    /**
	     * Sets the visibility of the specified control.
	     * @param {String} controlKey The key of the control. Possible values are 'tl', 'tr', 'br', 'bl', 'ml', 'mt', 'mr', 'mb', 'mtr'.
	     * @param {Boolean} visible true to set the specified control visible, false otherwise
	     * @return {fabric.Object} thisArg
	     * @chainable
	     */
	    setControlVisible: function(controlKey, visible) {
	      if (!this._controlsVisibility) {
	        this._controlsVisibility = {};
	      }
	      this._controlsVisibility[controlKey] = visible;
	      return this;
	    },

	    /**
	     * Sets the visibility state of object controls.
	     * @param {Object} [options] Options object
	     * @param {Boolean} [options.bl] true to enable the bottom-left control, false to disable it
	     * @param {Boolean} [options.br] true to enable the bottom-right control, false to disable it
	     * @param {Boolean} [options.mb] true to enable the middle-bottom control, false to disable it
	     * @param {Boolean} [options.ml] true to enable the middle-left control, false to disable it
	     * @param {Boolean} [options.mr] true to enable the middle-right control, false to disable it
	     * @param {Boolean} [options.mt] true to enable the middle-top control, false to disable it
	     * @param {Boolean} [options.tl] true to enable the top-left control, false to disable it
	     * @param {Boolean} [options.tr] true to enable the top-right control, false to disable it
	     * @param {Boolean} [options.mtr] true to enable the middle-top-rotate control, false to disable it
	     * @return {fabric.Object} thisArg
	     * @chainable
	     */
	    setControlsVisibility: function(options) {
	      options || (options = { });

	      for (var p in options) {
	        this.setControlVisible(p, options[p]);
	      }
	      return this;
	    },


	    /**
	     * This callback function is called every time _discardActiveObject or _setActiveObject
	     * try to to deselect this object. If the function returns true, the process is cancelled
	     * @param {Object} [options] options sent from the upper functions
	     * @param {Event} [options.e] event if the process is generated by an event
	     */
	    onDeselect: function() {
	      // implemented by sub-classes, as needed.
	    },


	    /**
	     * This callback function is called every time _discardActiveObject or _setActiveObject
	     * try to to select this object. If the function returns true, the process is cancelled
	     * @param {Object} [options] options sent from the upper functions
	     * @param {Event} [options.e] event if the process is generated by an event
	     */
	    onSelect: function() {
	      // implemented by sub-classes, as needed.
	    }
	  });
	})();


	fabric.util.object.extend(fabric.StaticCanvas.prototype, /** @lends fabric.StaticCanvas.prototype */ {

	  /**
	   * Animation duration (in ms) for fx* methods
	   * @type Number
	   * @default
	   */
	  FX_DURATION: 500,

	  /**
	   * Centers object horizontally with animation.
	   * @param {fabric.Object} object Object to center
	   * @param {Object} [callbacks] Callbacks object with optional "onComplete" and/or "onChange" properties
	   * @param {Function} [callbacks.onComplete] Invoked on completion
	   * @param {Function} [callbacks.onChange] Invoked on every step of animation
	   * @return {fabric.Canvas} thisArg
	   * @chainable
	   */
	  fxCenterObjectH: function (object, callbacks) {
	    callbacks = callbacks || { };

	    var empty = function() { },
	        onComplete = callbacks.onComplete || empty,
	        onChange = callbacks.onChange || empty,
	        _this = this;

	    fabric.util.animate({
	      startValue: object.left,
	      endValue: this.getCenter().left,
	      duration: this.FX_DURATION,
	      onChange: function(value) {
	        object.set('left', value);
	        _this.requestRenderAll();
	        onChange();
	      },
	      onComplete: function() {
	        object.setCoords();
	        onComplete();
	      }
	    });

	    return this;
	  },

	  /**
	   * Centers object vertically with animation.
	   * @param {fabric.Object} object Object to center
	   * @param {Object} [callbacks] Callbacks object with optional "onComplete" and/or "onChange" properties
	   * @param {Function} [callbacks.onComplete] Invoked on completion
	   * @param {Function} [callbacks.onChange] Invoked on every step of animation
	   * @return {fabric.Canvas} thisArg
	   * @chainable
	   */
	  fxCenterObjectV: function (object, callbacks) {
	    callbacks = callbacks || { };

	    var empty = function() { },
	        onComplete = callbacks.onComplete || empty,
	        onChange = callbacks.onChange || empty,
	        _this = this;

	    fabric.util.animate({
	      startValue: object.top,
	      endValue: this.getCenter().top,
	      duration: this.FX_DURATION,
	      onChange: function(value) {
	        object.set('top', value);
	        _this.requestRenderAll();
	        onChange();
	      },
	      onComplete: function() {
	        object.setCoords();
	        onComplete();
	      }
	    });

	    return this;
	  },

	  /**
	   * Same as `fabric.Canvas#remove` but animated
	   * @param {fabric.Object} object Object to remove
	   * @param {Object} [callbacks] Callbacks object with optional "onComplete" and/or "onChange" properties
	   * @param {Function} [callbacks.onComplete] Invoked on completion
	   * @param {Function} [callbacks.onChange] Invoked on every step of animation
	   * @return {fabric.Canvas} thisArg
	   * @chainable
	   */
	  fxRemove: function (object, callbacks) {
	    callbacks = callbacks || { };

	    var empty = function() { },
	        onComplete = callbacks.onComplete || empty,
	        onChange = callbacks.onChange || empty,
	        _this = this;

	    fabric.util.animate({
	      startValue: object.opacity,
	      endValue: 0,
	      duration: this.FX_DURATION,
	      onChange: function(value) {
	        object.set('opacity', value);
	        _this.requestRenderAll();
	        onChange();
	      },
	      onComplete: function () {
	        _this.remove(object);
	        onComplete();
	      }
	    });

	    return this;
	  }
	});

	fabric.util.object.extend(fabric.Object.prototype, /** @lends fabric.Object.prototype */ {
	  /**
	   * Animates object's properties
	   * @param {String|Object} property Property to animate (if string) or properties to animate (if object)
	   * @param {Number|Object} value Value to animate property to (if string was given first) or options object
	   * @return {fabric.Object} thisArg
	   * @tutorial {@link http://fabricjs.com/fabric-intro-part-2#animation}
	   * @chainable
	   *
	   * As object — multiple properties
	   *
	   * object.animate({ left: ..., top: ... });
	   * object.animate({ left: ..., top: ... }, { duration: ... });
	   *
	   * As string — one property
	   *
	   * object.animate('left', ...);
	   * object.animate('left', { duration: ... });
	   *
	   */
	  animate: function() {
	    if (arguments[0] && typeof arguments[0] === 'object') {
	      var propsToAnimate = [], prop, skipCallbacks;
	      for (prop in arguments[0]) {
	        propsToAnimate.push(prop);
	      }
	      for (var i = 0, len = propsToAnimate.length; i < len; i++) {
	        prop = propsToAnimate[i];
	        skipCallbacks = i !== len - 1;
	        this._animate(prop, arguments[0][prop], arguments[1], skipCallbacks);
	      }
	    }
	    else {
	      this._animate.apply(this, arguments);
	    }
	    return this;
	  },

	  /**
	   * @private
	   * @param {String} property Property to animate
	   * @param {String} to Value to animate to
	   * @param {Object} [options] Options object
	   * @param {Boolean} [skipCallbacks] When true, callbacks like onchange and oncomplete are not invoked
	   */
	  _animate: function(property, to, options, skipCallbacks) {
	    var _this = this, propPair;

	    to = to.toString();

	    if (!options) {
	      options = { };
	    }
	    else {
	      options = fabric.util.object.clone(options);
	    }

	    if (~property.indexOf('.')) {
	      propPair = property.split('.');
	    }

	    var propIsColor =
	      _this.colorProperties.indexOf(property) > -1 ||
	      (propPair && _this.colorProperties.indexOf(propPair[1]) > -1);

	    var currentValue = propPair
	      ? this.get(propPair[0])[propPair[1]]
	      : this.get(property);

	    if (!('from' in options)) {
	      options.from = currentValue;
	    }

	    if (!propIsColor) {
	      if (~to.indexOf('=')) {
	        to = currentValue + parseFloat(to.replace('=', ''));
	      }
	      else {
	        to = parseFloat(to);
	      }
	    }

	    var _options = {
	      startValue: options.from,
	      endValue: to,
	      byValue: options.by,
	      easing: options.easing,
	      duration: options.duration,
	      abort: options.abort && function(value, valueProgress, timeProgress) {
	        return options.abort.call(_this, value, valueProgress, timeProgress);
	      },
	      onChange: function (value, valueProgress, timeProgress) {
	        if (propPair) {
	          _this[propPair[0]][propPair[1]] = value;
	        }
	        else {
	          _this.set(property, value);
	        }
	        if (skipCallbacks) {
	          return;
	        }
	        options.onChange && options.onChange(value, valueProgress, timeProgress);
	      },
	      onComplete: function (value, valueProgress, timeProgress) {
	        if (skipCallbacks) {
	          return;
	        }

	        _this.setCoords();
	        options.onComplete && options.onComplete(value, valueProgress, timeProgress);
	      }
	    };

	    if (propIsColor) {
	      return fabric.util.animateColor(_options.startValue, _options.endValue, _options.duration, _options);
	    }
	    else {
	      return fabric.util.animate(_options);
	    }
	  }
	});


	(function(global) {

	  var fabric = global.fabric || (global.fabric = { }),
	      extend = fabric.util.object.extend,
	      clone = fabric.util.object.clone,
	      coordProps = { x1: 1, x2: 1, y1: 1, y2: 1 };

	  if (fabric.Line) {
	    fabric.warn('fabric.Line is already defined');
	    return;
	  }

	  /**
	   * Line class
	   * @class fabric.Line
	   * @extends fabric.Object
	   * @see {@link fabric.Line#initialize} for constructor definition
	   */
	  fabric.Line = fabric.util.createClass(fabric.Object, /** @lends fabric.Line.prototype */ {

	    /**
	     * Type of an object
	     * @type String
	     * @default
	     */
	    type: 'line',

	    /**
	     * x value or first line edge
	     * @type Number
	     * @default
	     */
	    x1: 0,

	    /**
	     * y value or first line edge
	     * @type Number
	     * @default
	     */
	    y1: 0,

	    /**
	     * x value or second line edge
	     * @type Number
	     * @default
	     */
	    x2: 0,

	    /**
	     * y value or second line edge
	     * @type Number
	     * @default
	     */
	    y2: 0,

	    cacheProperties: fabric.Object.prototype.cacheProperties.concat('x1', 'x2', 'y1', 'y2'),

	    /**
	     * Constructor
	     * @param {Array} [points] Array of points
	     * @param {Object} [options] Options object
	     * @return {fabric.Line} thisArg
	     */
	    initialize: function(points, options) {
	      if (!points) {
	        points = [0, 0, 0, 0];
	      }

	      this.callSuper('initialize', options);

	      this.set('x1', points[0]);
	      this.set('y1', points[1]);
	      this.set('x2', points[2]);
	      this.set('y2', points[3]);

	      this._setWidthHeight(options);
	    },

	    /**
	     * @private
	     * @param {Object} [options] Options
	     */
	    _setWidthHeight: function(options) {
	      options || (options = { });

	      this.width = Math.abs(this.x2 - this.x1);
	      this.height = Math.abs(this.y2 - this.y1);

	      this.left = 'left' in options
	        ? options.left
	        : this._getLeftToOriginX();

	      this.top = 'top' in options
	        ? options.top
	        : this._getTopToOriginY();
	    },

	    /**
	     * @private
	     * @param {String} key
	     * @param {*} value
	     */
	    _set: function(key, value) {
	      this.callSuper('_set', key, value);
	      if (typeof coordProps[key] !== 'undefined') {
	        this._setWidthHeight();
	      }
	      return this;
	    },

	    /**
	     * @private
	     * @return {Number} leftToOriginX Distance from left edge of canvas to originX of Line.
	     */
	    _getLeftToOriginX: makeEdgeToOriginGetter(
	      { // property names
	        origin: 'originX',
	        axis1: 'x1',
	        axis2: 'x2',
	        dimension: 'width'
	      },
	      { // possible values of origin
	        nearest: 'left',
	        center: 'center',
	        farthest: 'right'
	      }
	    ),

	    /**
	     * @private
	     * @return {Number} topToOriginY Distance from top edge of canvas to originY of Line.
	     */
	    _getTopToOriginY: makeEdgeToOriginGetter(
	      { // property names
	        origin: 'originY',
	        axis1: 'y1',
	        axis2: 'y2',
	        dimension: 'height'
	      },
	      { // possible values of origin
	        nearest: 'top',
	        center: 'center',
	        farthest: 'bottom'
	      }
	    ),

	    /**
	     * @private
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    _render: function(ctx) {
	      ctx.beginPath();


	      var p = this.calcLinePoints();
	      ctx.moveTo(p.x1, p.y1);
	      ctx.lineTo(p.x2, p.y2);

	      ctx.lineWidth = this.strokeWidth;

	      // TODO: test this
	      // make sure setting "fill" changes color of a line
	      // (by copying fillStyle to strokeStyle, since line is stroked, not filled)
	      var origStrokeStyle = ctx.strokeStyle;
	      ctx.strokeStyle = this.stroke || ctx.fillStyle;
	      this.stroke && this._renderStroke(ctx);
	      ctx.strokeStyle = origStrokeStyle;
	    },

	    /**
	     * This function is an helper for svg import. it returns the center of the object in the svg
	     * untransformed coordinates
	     * @private
	     * @return {Object} center point from element coordinates
	     */
	    _findCenterFromElement: function() {
	      return {
	        x: (this.x1 + this.x2) / 2,
	        y: (this.y1 + this.y2) / 2,
	      };
	    },

	    /**
	     * Returns object representation of an instance
	     * @method toObject
	     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
	     * @return {Object} object representation of an instance
	     */
	    toObject: function(propertiesToInclude) {
	      return extend(this.callSuper('toObject', propertiesToInclude), this.calcLinePoints());
	    },

	    /*
	     * Calculate object dimensions from its properties
	     * @private
	     */
	    _getNonTransformedDimensions: function() {
	      var dim = this.callSuper('_getNonTransformedDimensions');
	      if (this.strokeLineCap === 'butt') {
	        if (this.width === 0) {
	          dim.y -= this.strokeWidth;
	        }
	        if (this.height === 0) {
	          dim.x -= this.strokeWidth;
	        }
	      }
	      return dim;
	    },

	    /**
	     * Recalculates line points given width and height
	     * @private
	     */
	    calcLinePoints: function() {
	      var xMult = this.x1 <= this.x2 ? -1 : 1,
	          yMult = this.y1 <= this.y2 ? -1 : 1,
	          x1 = (xMult * this.width * 0.5),
	          y1 = (yMult * this.height * 0.5),
	          x2 = (xMult * this.width * -0.5),
	          y2 = (yMult * this.height * -0.5);

	      return {
	        x1: x1,
	        x2: x2,
	        y1: y1,
	        y2: y2
	      };
	    },

	    /* _TO_SVG_START_ */
	    /**
	     * Returns svg representation of an instance
	     * @return {Array} an array of strings with the specific svg representation
	     * of the instance
	     */
	    _toSVG: function() {
	      var p = this.calcLinePoints();
	      return [
	        '<line ', 'COMMON_PARTS',
	        'x1="', p.x1,
	        '" y1="', p.y1,
	        '" x2="', p.x2,
	        '" y2="', p.y2,
	        '" />\n'
	      ];
	    },
	    /* _TO_SVG_END_ */
	  });

	  /* _FROM_SVG_START_ */
	  /**
	   * List of attribute names to account for when parsing SVG element (used by {@link fabric.Line.fromElement})
	   * @static
	   * @memberOf fabric.Line
	   * @see http://www.w3.org/TR/SVG/shapes.html#LineElement
	   */
	  fabric.Line.ATTRIBUTE_NAMES = fabric.SHARED_ATTRIBUTES.concat('x1 y1 x2 y2'.split(' '));

	  /**
	   * Returns fabric.Line instance from an SVG element
	   * @static
	   * @memberOf fabric.Line
	   * @param {SVGElement} element Element to parse
	   * @param {Object} [options] Options object
	   * @param {Function} [callback] callback function invoked after parsing
	   */
	  fabric.Line.fromElement = function(element, callback, options) {
	    options = options || { };
	    var parsedAttributes = fabric.parseAttributes(element, fabric.Line.ATTRIBUTE_NAMES),
	        points = [
	          parsedAttributes.x1 || 0,
	          parsedAttributes.y1 || 0,
	          parsedAttributes.x2 || 0,
	          parsedAttributes.y2 || 0
	        ];
	    callback(new fabric.Line(points, extend(parsedAttributes, options)));
	  };
	  /* _FROM_SVG_END_ */

	  /**
	   * Returns fabric.Line instance from an object representation
	   * @static
	   * @memberOf fabric.Line
	   * @param {Object} object Object to create an instance from
	   * @param {function} [callback] invoked with new instance as first argument
	   */
	  fabric.Line.fromObject = function(object, callback) {
	    function _callback(instance) {
	      delete instance.points;
	      callback && callback(instance);
	    }	    var options = clone(object, true);
	    options.points = [object.x1, object.y1, object.x2, object.y2];
	    fabric.Object._fromObject('Line', options, _callback, 'points');
	  };

	  /**
	   * Produces a function that calculates distance from canvas edge to Line origin.
	   */
	  function makeEdgeToOriginGetter(propertyNames, originValues) {
	    var origin = propertyNames.origin,
	        axis1 = propertyNames.axis1,
	        axis2 = propertyNames.axis2,
	        dimension = propertyNames.dimension,
	        nearest = originValues.nearest,
	        center = originValues.center,
	        farthest = originValues.farthest;

	    return function() {
	      switch (this.get(origin)) {
	        case nearest:
	          return Math.min(this.get(axis1), this.get(axis2));
	        case center:
	          return Math.min(this.get(axis1), this.get(axis2)) + (0.5 * this.get(dimension));
	        case farthest:
	          return Math.max(this.get(axis1), this.get(axis2));
	      }
	    };

	  }

	})(exports );


	(function(global) {

	  var fabric = global.fabric || (global.fabric = { }),
	      pi = Math.PI;

	  if (fabric.Circle) {
	    fabric.warn('fabric.Circle is already defined.');
	    return;
	  }

	  /**
	   * Circle class
	   * @class fabric.Circle
	   * @extends fabric.Object
	   * @see {@link fabric.Circle#initialize} for constructor definition
	   */
	  fabric.Circle = fabric.util.createClass(fabric.Object, /** @lends fabric.Circle.prototype */ {

	    /**
	     * Type of an object
	     * @type String
	     * @default
	     */
	    type: 'circle',

	    /**
	     * Radius of this circle
	     * @type Number
	     * @default
	     */
	    radius: 0,

	    /**
	     * Start angle of the circle, moving clockwise
	     * deprecated type, this should be in degree, this was an oversight.
	     * probably will change to degrees in next major version
	     * @type Number
	     * @default 0
	     */
	    startAngle: 0,

	    /**
	     * End angle of the circle
	     * deprecated type, this should be in degree, this was an oversight.
	     * probably will change to degrees in next major version
	     * @type Number
	     * @default 2Pi
	     */
	    endAngle: pi * 2,

	    cacheProperties: fabric.Object.prototype.cacheProperties.concat('radius', 'startAngle', 'endAngle'),

	    /**
	     * @private
	     * @param {String} key
	     * @param {*} value
	     * @return {fabric.Circle} thisArg
	     */
	    _set: function(key, value) {
	      this.callSuper('_set', key, value);

	      if (key === 'radius') {
	        this.setRadius(value);
	      }

	      return this;
	    },

	    /**
	     * Returns object representation of an instance
	     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
	     * @return {Object} object representation of an instance
	     */
	    toObject: function(propertiesToInclude) {
	      return this.callSuper('toObject', ['radius', 'startAngle', 'endAngle'].concat(propertiesToInclude));
	    },

	    /* _TO_SVG_START_ */

	    /**
	     * Returns svg representation of an instance
	     * @return {Array} an array of strings with the specific svg representation
	     * of the instance
	     */
	    _toSVG: function() {
	      var svgString, x = 0, y = 0,
	          angle = (this.endAngle - this.startAngle) % ( 2 * pi);

	      if (angle === 0) {
	        svgString = [
	          '<circle ', 'COMMON_PARTS',
	          'cx="' + x + '" cy="' + y + '" ',
	          'r="', this.radius,
	          '" />\n'
	        ];
	      }
	      else {
	        var startX = fabric.util.cos(this.startAngle) * this.radius,
	            startY = fabric.util.sin(this.startAngle) * this.radius,
	            endX = fabric.util.cos(this.endAngle) * this.radius,
	            endY = fabric.util.sin(this.endAngle) * this.radius,
	            largeFlag = angle > pi ? '1' : '0';
	        svgString = [
	          '<path d="M ' + startX + ' ' + startY,
	          ' A ' + this.radius + ' ' + this.radius,
	          ' 0 ', +largeFlag + ' 1', ' ' + endX + ' ' + endY,
	          '" ', 'COMMON_PARTS', ' />\n'
	        ];
	      }
	      return svgString;
	    },
	    /* _TO_SVG_END_ */

	    /**
	     * @private
	     * @param {CanvasRenderingContext2D} ctx context to render on
	     */
	    _render: function(ctx) {
	      ctx.beginPath();
	      ctx.arc(
	        0,
	        0,
	        this.radius,
	        this.startAngle,
	        this.endAngle, false);
	      this._renderPaintInOrder(ctx);
	    },

	    /**
	     * Returns horizontal radius of an object (according to how an object is scaled)
	     * @return {Number}
	     */
	    getRadiusX: function() {
	      return this.get('radius') * this.get('scaleX');
	    },

	    /**
	     * Returns vertical radius of an object (according to how an object is scaled)
	     * @return {Number}
	     */
	    getRadiusY: function() {
	      return this.get('radius') * this.get('scaleY');
	    },

	    /**
	     * Sets radius of an object (and updates width accordingly)
	     * @return {fabric.Circle} thisArg
	     */
	    setRadius: function(value) {
	      this.radius = value;
	      return this.set('width', value * 2).set('height', value * 2);
	    },
	  });

	  /* _FROM_SVG_START_ */
	  /**
	   * List of attribute names to account for when parsing SVG element (used by {@link fabric.Circle.fromElement})
	   * @static
	   * @memberOf fabric.Circle
	   * @see: http://www.w3.org/TR/SVG/shapes.html#CircleElement
	   */
	  fabric.Circle.ATTRIBUTE_NAMES = fabric.SHARED_ATTRIBUTES.concat('cx cy r'.split(' '));

	  /**
	   * Returns {@link fabric.Circle} instance from an SVG element
	   * @static
	   * @memberOf fabric.Circle
	   * @param {SVGElement} element Element to parse
	   * @param {Function} [callback] Options callback invoked after parsing is finished
	   * @param {Object} [options] Options object
	   * @throws {Error} If value of `r` attribute is missing or invalid
	   */
	  fabric.Circle.fromElement = function(element, callback) {
	    var parsedAttributes = fabric.parseAttributes(element, fabric.Circle.ATTRIBUTE_NAMES);

	    if (!isValidRadius(parsedAttributes)) {
	      throw new Error('value of `r` attribute is required and can not be negative');
	    }

	    parsedAttributes.left = (parsedAttributes.left || 0) - parsedAttributes.radius;
	    parsedAttributes.top = (parsedAttributes.top || 0) - parsedAttributes.radius;
	    callback(new fabric.Circle(parsedAttributes));
	  };

	  /**
	   * @private
	   */
	  function isValidRadius(attributes) {
	    return (('radius' in attributes) && (attributes.radius >= 0));
	  }
	  /* _FROM_SVG_END_ */

	  /**
	   * Returns {@link fabric.Circle} instance from an object representation
	   * @static
	   * @memberOf fabric.Circle
	   * @param {Object} object Object to create an instance from
	   * @param {function} [callback] invoked with new instance as first argument
	   * @return {void}
	   */
	  fabric.Circle.fromObject = function(object, callback) {
	    fabric.Object._fromObject('Circle', object, callback);
	  };

	})(exports );


	(function(global) {

	  var fabric = global.fabric || (global.fabric = { });

	  if (fabric.Triangle) {
	    fabric.warn('fabric.Triangle is already defined');
	    return;
	  }

	  /**
	   * Triangle class
	   * @class fabric.Triangle
	   * @extends fabric.Object
	   * @return {fabric.Triangle} thisArg
	   * @see {@link fabric.Triangle#initialize} for constructor definition
	   */
	  fabric.Triangle = fabric.util.createClass(fabric.Object, /** @lends fabric.Triangle.prototype */ {

	    /**
	     * Type of an object
	     * @type String
	     * @default
	     */
	    type: 'triangle',

	    /**
	     * Width is set to 100 to compensate the old initialize code that was setting it to 100
	     * @type Number
	     * @default
	     */
	    width: 100,

	    /**
	     * Height is set to 100 to compensate the old initialize code that was setting it to 100
	     * @type Number
	     * @default
	     */
	    height: 100,

	    /**
	     * @private
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    _render: function(ctx) {
	      var widthBy2 = this.width / 2,
	          heightBy2 = this.height / 2;

	      ctx.beginPath();
	      ctx.moveTo(-widthBy2, heightBy2);
	      ctx.lineTo(0, -heightBy2);
	      ctx.lineTo(widthBy2, heightBy2);
	      ctx.closePath();

	      this._renderPaintInOrder(ctx);
	    },

	    /* _TO_SVG_START_ */
	    /**
	     * Returns svg representation of an instance
	     * @return {Array} an array of strings with the specific svg representation
	     * of the instance
	     */
	    _toSVG: function() {
	      var widthBy2 = this.width / 2,
	          heightBy2 = this.height / 2,
	          points = [
	            -widthBy2 + ' ' + heightBy2,
	            '0 ' + -heightBy2,
	            widthBy2 + ' ' + heightBy2
	          ].join(',');
	      return [
	        '<polygon ', 'COMMON_PARTS',
	        'points="', points,
	        '" />'
	      ];
	    },
	    /* _TO_SVG_END_ */
	  });

	  /**
	   * Returns {@link fabric.Triangle} instance from an object representation
	   * @static
	   * @memberOf fabric.Triangle
	   * @param {Object} object Object to create an instance from
	   * @param {function} [callback] invoked with new instance as first argument
	   */
	  fabric.Triangle.fromObject = function(object, callback) {
	    return fabric.Object._fromObject('Triangle', object, callback);
	  };

	})(exports );


	(function(global) {

	  var fabric = global.fabric || (global.fabric = { }),
	      piBy2   = Math.PI * 2;

	  if (fabric.Ellipse) {
	    fabric.warn('fabric.Ellipse is already defined.');
	    return;
	  }

	  /**
	   * Ellipse class
	   * @class fabric.Ellipse
	   * @extends fabric.Object
	   * @return {fabric.Ellipse} thisArg
	   * @see {@link fabric.Ellipse#initialize} for constructor definition
	   */
	  fabric.Ellipse = fabric.util.createClass(fabric.Object, /** @lends fabric.Ellipse.prototype */ {

	    /**
	     * Type of an object
	     * @type String
	     * @default
	     */
	    type: 'ellipse',

	    /**
	     * Horizontal radius
	     * @type Number
	     * @default
	     */
	    rx:   0,

	    /**
	     * Vertical radius
	     * @type Number
	     * @default
	     */
	    ry:   0,

	    cacheProperties: fabric.Object.prototype.cacheProperties.concat('rx', 'ry'),

	    /**
	     * Constructor
	     * @param {Object} [options] Options object
	     * @return {fabric.Ellipse} thisArg
	     */
	    initialize: function(options) {
	      this.callSuper('initialize', options);
	      this.set('rx', options && options.rx || 0);
	      this.set('ry', options && options.ry || 0);
	    },

	    /**
	     * @private
	     * @param {String} key
	     * @param {*} value
	     * @return {fabric.Ellipse} thisArg
	     */
	    _set: function(key, value) {
	      this.callSuper('_set', key, value);
	      switch (key) {

	        case 'rx':
	          this.rx = value;
	          this.set('width', value * 2);
	          break;

	        case 'ry':
	          this.ry = value;
	          this.set('height', value * 2);
	          break;

	      }
	      return this;
	    },

	    /**
	     * Returns horizontal radius of an object (according to how an object is scaled)
	     * @return {Number}
	     */
	    getRx: function() {
	      return this.get('rx') * this.get('scaleX');
	    },

	    /**
	     * Returns Vertical radius of an object (according to how an object is scaled)
	     * @return {Number}
	     */
	    getRy: function() {
	      return this.get('ry') * this.get('scaleY');
	    },

	    /**
	     * Returns object representation of an instance
	     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
	     * @return {Object} object representation of an instance
	     */
	    toObject: function(propertiesToInclude) {
	      return this.callSuper('toObject', ['rx', 'ry'].concat(propertiesToInclude));
	    },

	    /* _TO_SVG_START_ */
	    /**
	     * Returns svg representation of an instance
	     * @return {Array} an array of strings with the specific svg representation
	     * of the instance
	     */
	    _toSVG: function() {
	      return [
	        '<ellipse ', 'COMMON_PARTS',
	        'cx="0" cy="0" ',
	        'rx="', this.rx,
	        '" ry="', this.ry,
	        '" />\n'
	      ];
	    },
	    /* _TO_SVG_END_ */

	    /**
	     * @private
	     * @param {CanvasRenderingContext2D} ctx context to render on
	     */
	    _render: function(ctx) {
	      ctx.beginPath();
	      ctx.save();
	      ctx.transform(1, 0, 0, this.ry / this.rx, 0, 0);
	      ctx.arc(
	        0,
	        0,
	        this.rx,
	        0,
	        piBy2,
	        false);
	      ctx.restore();
	      this._renderPaintInOrder(ctx);
	    },
	  });

	  /* _FROM_SVG_START_ */
	  /**
	   * List of attribute names to account for when parsing SVG element (used by {@link fabric.Ellipse.fromElement})
	   * @static
	   * @memberOf fabric.Ellipse
	   * @see http://www.w3.org/TR/SVG/shapes.html#EllipseElement
	   */
	  fabric.Ellipse.ATTRIBUTE_NAMES = fabric.SHARED_ATTRIBUTES.concat('cx cy rx ry'.split(' '));

	  /**
	   * Returns {@link fabric.Ellipse} instance from an SVG element
	   * @static
	   * @memberOf fabric.Ellipse
	   * @param {SVGElement} element Element to parse
	   * @param {Function} [callback] Options callback invoked after parsing is finished
	   * @return {fabric.Ellipse}
	   */
	  fabric.Ellipse.fromElement = function(element, callback) {

	    var parsedAttributes = fabric.parseAttributes(element, fabric.Ellipse.ATTRIBUTE_NAMES);

	    parsedAttributes.left = (parsedAttributes.left || 0) - parsedAttributes.rx;
	    parsedAttributes.top = (parsedAttributes.top || 0) - parsedAttributes.ry;
	    callback(new fabric.Ellipse(parsedAttributes));
	  };
	  /* _FROM_SVG_END_ */

	  /**
	   * Returns {@link fabric.Ellipse} instance from an object representation
	   * @static
	   * @memberOf fabric.Ellipse
	   * @param {Object} object Object to create an instance from
	   * @param {function} [callback] invoked with new instance as first argument
	   * @return {void}
	   */
	  fabric.Ellipse.fromObject = function(object, callback) {
	    fabric.Object._fromObject('Ellipse', object, callback);
	  };

	})(exports );


	(function(global) {

	  var fabric = global.fabric || (global.fabric = { }),
	      extend = fabric.util.object.extend;

	  if (fabric.Rect) {
	    fabric.warn('fabric.Rect is already defined');
	    return;
	  }

	  /**
	   * Rectangle class
	   * @class fabric.Rect
	   * @extends fabric.Object
	   * @return {fabric.Rect} thisArg
	   * @see {@link fabric.Rect#initialize} for constructor definition
	   */
	  fabric.Rect = fabric.util.createClass(fabric.Object, /** @lends fabric.Rect.prototype */ {

	    /**
	     * List of properties to consider when checking if state of an object is changed ({@link fabric.Object#hasStateChanged})
	     * as well as for history (undo/redo) purposes
	     * @type Array
	     */
	    stateProperties: fabric.Object.prototype.stateProperties.concat('rx', 'ry'),

	    /**
	     * Type of an object
	     * @type String
	     * @default
	     */
	    type: 'rect',

	    /**
	     * Horizontal border radius
	     * @type Number
	     * @default
	     */
	    rx:   0,

	    /**
	     * Vertical border radius
	     * @type Number
	     * @default
	     */
	    ry:   0,

	    cacheProperties: fabric.Object.prototype.cacheProperties.concat('rx', 'ry'),

	    /**
	     * Constructor
	     * @param {Object} [options] Options object
	     * @return {Object} thisArg
	     */
	    initialize: function(options) {
	      this.callSuper('initialize', options);
	      this._initRxRy();
	    },

	    /**
	     * Initializes rx/ry attributes
	     * @private
	     */
	    _initRxRy: function() {
	      if (this.rx && !this.ry) {
	        this.ry = this.rx;
	      }
	      else if (this.ry && !this.rx) {
	        this.rx = this.ry;
	      }
	    },

	    /**
	     * @private
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    _render: function(ctx) {

	      // 1x1 case (used in spray brush) optimization was removed because
	      // with caching and higher zoom level this makes more damage than help

	      var rx = this.rx ? Math.min(this.rx, this.width / 2) : 0,
	          ry = this.ry ? Math.min(this.ry, this.height / 2) : 0,
	          w = this.width,
	          h = this.height,
	          x = -this.width / 2,
	          y = -this.height / 2,
	          isRounded = rx !== 0 || ry !== 0,
	          /* "magic number" for bezier approximations of arcs (http://itc.ktu.lt/itc354/Riskus354.pdf) */
	          k = 1 - 0.5522847498;
	      ctx.beginPath();

	      ctx.moveTo(x + rx, y);

	      ctx.lineTo(x + w - rx, y);
	      isRounded && ctx.bezierCurveTo(x + w - k * rx, y, x + w, y + k * ry, x + w, y + ry);

	      ctx.lineTo(x + w, y + h - ry);
	      isRounded && ctx.bezierCurveTo(x + w, y + h - k * ry, x + w - k * rx, y + h, x + w - rx, y + h);

	      ctx.lineTo(x + rx, y + h);
	      isRounded && ctx.bezierCurveTo(x + k * rx, y + h, x, y + h - k * ry, x, y + h - ry);

	      ctx.lineTo(x, y + ry);
	      isRounded && ctx.bezierCurveTo(x, y + k * ry, x + k * rx, y, x + rx, y);

	      ctx.closePath();

	      this._renderPaintInOrder(ctx);
	    },

	    /**
	     * Returns object representation of an instance
	     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
	     * @return {Object} object representation of an instance
	     */
	    toObject: function(propertiesToInclude) {
	      return this.callSuper('toObject', ['rx', 'ry'].concat(propertiesToInclude));
	    },

	    /* _TO_SVG_START_ */
	    /**
	     * Returns svg representation of an instance
	     * @return {Array} an array of strings with the specific svg representation
	     * of the instance
	     */
	    _toSVG: function() {
	      var x = -this.width / 2, y = -this.height / 2;
	      return [
	        '<rect ', 'COMMON_PARTS',
	        'x="', x, '" y="', y,
	        '" rx="', this.rx, '" ry="', this.ry,
	        '" width="', this.width, '" height="', this.height,
	        '" />\n'
	      ];
	    },
	    /* _TO_SVG_END_ */
	  });

	  /* _FROM_SVG_START_ */
	  /**
	   * List of attribute names to account for when parsing SVG element (used by `fabric.Rect.fromElement`)
	   * @static
	   * @memberOf fabric.Rect
	   * @see: http://www.w3.org/TR/SVG/shapes.html#RectElement
	   */
	  fabric.Rect.ATTRIBUTE_NAMES = fabric.SHARED_ATTRIBUTES.concat('x y rx ry width height'.split(' '));

	  /**
	   * Returns {@link fabric.Rect} instance from an SVG element
	   * @static
	   * @memberOf fabric.Rect
	   * @param {SVGElement} element Element to parse
	   * @param {Function} callback callback function invoked after parsing
	   * @param {Object} [options] Options object
	   */
	  fabric.Rect.fromElement = function(element, callback, options) {
	    if (!element) {
	      return callback(null);
	    }
	    options = options || { };

	    var parsedAttributes = fabric.parseAttributes(element, fabric.Rect.ATTRIBUTE_NAMES);
	    parsedAttributes.left = parsedAttributes.left || 0;
	    parsedAttributes.top  = parsedAttributes.top  || 0;
	    parsedAttributes.height  = parsedAttributes.height || 0;
	    parsedAttributes.width  = parsedAttributes.width || 0;
	    var rect = new fabric.Rect(extend((options ? fabric.util.object.clone(options) : { }), parsedAttributes));
	    rect.visible = rect.visible && rect.width > 0 && rect.height > 0;
	    callback(rect);
	  };
	  /* _FROM_SVG_END_ */

	  /**
	   * Returns {@link fabric.Rect} instance from an object representation
	   * @static
	   * @memberOf fabric.Rect
	   * @param {Object} object Object to create an instance from
	   * @param {Function} [callback] Callback to invoke when an fabric.Rect instance is created
	   */
	  fabric.Rect.fromObject = function(object, callback) {
	    return fabric.Object._fromObject('Rect', object, callback);
	  };

	})(exports );


	(function(global) {

	  var fabric = global.fabric || (global.fabric = { }),
	      extend = fabric.util.object.extend,
	      min = fabric.util.array.min,
	      max = fabric.util.array.max,
	      toFixed = fabric.util.toFixed;

	  if (fabric.Polyline) {
	    fabric.warn('fabric.Polyline is already defined');
	    return;
	  }

	  /**
	   * Polyline class
	   * @class fabric.Polyline
	   * @extends fabric.Object
	   * @see {@link fabric.Polyline#initialize} for constructor definition
	   */
	  fabric.Polyline = fabric.util.createClass(fabric.Object, /** @lends fabric.Polyline.prototype */ {

	    /**
	     * Type of an object
	     * @type String
	     * @default
	     */
	    type: 'polyline',

	    /**
	     * Points array
	     * @type Array
	     * @default
	     */
	    points: null,

	    cacheProperties: fabric.Object.prototype.cacheProperties.concat('points'),

	    /**
	     * Constructor
	     * @param {Array} points Array of points (where each point is an object with x and y)
	     * @param {Object} [options] Options object
	     * @return {fabric.Polyline} thisArg
	     * @example
	     * var poly = new fabric.Polyline([
	     *     { x: 10, y: 10 },
	     *     { x: 50, y: 30 },
	     *     { x: 40, y: 70 },
	     *     { x: 60, y: 50 },
	     *     { x: 100, y: 150 },
	     *     { x: 40, y: 100 }
	     *   ], {
	     *   stroke: 'red',
	     *   left: 100,
	     *   top: 100
	     * });
	     */
	    initialize: function(points, options) {
	      options = options || {};
	      this.points = points || [];
	      this.callSuper('initialize', options);
	      this._setPositionDimensions(options);
	    },

	    _setPositionDimensions: function(options) {
	      var calcDim = this._calcDimensions(options), correctLeftTop;
	      this.width = calcDim.width;
	      this.height = calcDim.height;
	      if (!options.fromSVG) {
	        correctLeftTop = this.translateToGivenOrigin(
	          { x: calcDim.left - this.strokeWidth / 2, y: calcDim.top - this.strokeWidth / 2 },
	          'left',
	          'top',
	          this.originX,
	          this.originY
	        );
	      }
	      if (typeof options.left === 'undefined') {
	        this.left = options.fromSVG ? calcDim.left : correctLeftTop.x;
	      }
	      if (typeof options.top === 'undefined') {
	        this.top = options.fromSVG ? calcDim.top : correctLeftTop.y;
	      }
	      this.pathOffset = {
	        x: calcDim.left + this.width / 2,
	        y: calcDim.top + this.height / 2
	      };
	    },

	    /**
	     * Calculate the polygon min and max point from points array,
	     * returning an object with left, top, width, height to measure the
	     * polygon size
	     * @return {Object} object.left X coordinate of the polygon leftmost point
	     * @return {Object} object.top Y coordinate of the polygon topmost point
	     * @return {Object} object.width distance between X coordinates of the polygon leftmost and rightmost point
	     * @return {Object} object.height distance between Y coordinates of the polygon topmost and bottommost point
	     * @private
	     */
	    _calcDimensions: function() {

	      var points = this.points,
	          minX = min(points, 'x') || 0,
	          minY = min(points, 'y') || 0,
	          maxX = max(points, 'x') || 0,
	          maxY = max(points, 'y') || 0,
	          width = (maxX - minX),
	          height = (maxY - minY);

	      return {
	        left: minX,
	        top: minY,
	        width: width,
	        height: height
	      };
	    },

	    /**
	     * Returns object representation of an instance
	     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
	     * @return {Object} Object representation of an instance
	     */
	    toObject: function(propertiesToInclude) {
	      return extend(this.callSuper('toObject', propertiesToInclude), {
	        points: this.points.concat()
	      });
	    },

	    /* _TO_SVG_START_ */
	    /**
	     * Returns svg representation of an instance
	     * @return {Array} an array of strings with the specific svg representation
	     * of the instance
	     */
	    _toSVG: function() {
	      var points = [], diffX = this.pathOffset.x, diffY = this.pathOffset.y,
	          NUM_FRACTION_DIGITS = fabric.Object.NUM_FRACTION_DIGITS;

	      for (var i = 0, len = this.points.length; i < len; i++) {
	        points.push(
	          toFixed(this.points[i].x - diffX, NUM_FRACTION_DIGITS), ',',
	          toFixed(this.points[i].y - diffY, NUM_FRACTION_DIGITS), ' '
	        );
	      }
	      return [
	        '<' + this.type + ' ', 'COMMON_PARTS',
	        'points="', points.join(''),
	        '" />\n'
	      ];
	    },
	    /* _TO_SVG_END_ */


	    /**
	     * @private
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    commonRender: function(ctx) {
	      var point, len = this.points.length,
	          x = this.pathOffset.x,
	          y = this.pathOffset.y;

	      if (!len || isNaN(this.points[len - 1].y)) {
	        // do not draw if no points or odd points
	        // NaN comes from parseFloat of a empty string in parser
	        return false;
	      }
	      ctx.beginPath();
	      ctx.moveTo(this.points[0].x - x, this.points[0].y - y);
	      for (var i = 0; i < len; i++) {
	        point = this.points[i];
	        ctx.lineTo(point.x - x, point.y - y);
	      }
	      return true;
	    },

	    /**
	     * @private
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    _render: function(ctx) {
	      if (!this.commonRender(ctx)) {
	        return;
	      }
	      this._renderPaintInOrder(ctx);
	    },

	    /**
	     * Returns complexity of an instance
	     * @return {Number} complexity of this instance
	     */
	    complexity: function() {
	      return this.get('points').length;
	    }
	  });

	  /* _FROM_SVG_START_ */
	  /**
	   * List of attribute names to account for when parsing SVG element (used by {@link fabric.Polyline.fromElement})
	   * @static
	   * @memberOf fabric.Polyline
	   * @see: http://www.w3.org/TR/SVG/shapes.html#PolylineElement
	   */
	  fabric.Polyline.ATTRIBUTE_NAMES = fabric.SHARED_ATTRIBUTES.concat();

	  /**
	   * Returns fabric.Polyline instance from an SVG element
	   * @static
	   * @memberOf fabric.Polyline
	   * @param {SVGElement} element Element to parser
	   * @param {Function} callback callback function invoked after parsing
	   * @param {Object} [options] Options object
	   */
	  fabric.Polyline.fromElementGenerator = function(_class) {
	    return function(element, callback, options) {
	      if (!element) {
	        return callback(null);
	      }
	      options || (options = { });

	      var points = fabric.parsePointsAttribute(element.getAttribute('points')),
	          parsedAttributes = fabric.parseAttributes(element, fabric[_class].ATTRIBUTE_NAMES);
	      parsedAttributes.fromSVG = true;
	      callback(new fabric[_class](points, extend(parsedAttributes, options)));
	    };
	  };

	  fabric.Polyline.fromElement = fabric.Polyline.fromElementGenerator('Polyline');

	  /* _FROM_SVG_END_ */

	  /**
	   * Returns fabric.Polyline instance from an object representation
	   * @static
	   * @memberOf fabric.Polyline
	   * @param {Object} object Object to create an instance from
	   * @param {Function} [callback] Callback to invoke when an fabric.Path instance is created
	   */
	  fabric.Polyline.fromObject = function(object, callback) {
	    return fabric.Object._fromObject('Polyline', object, callback, 'points');
	  };

	})(exports );


	(function(global) {

	  var fabric = global.fabric || (global.fabric = { });

	  if (fabric.Polygon) {
	    fabric.warn('fabric.Polygon is already defined');
	    return;
	  }

	  /**
	   * Polygon class
	   * @class fabric.Polygon
	   * @extends fabric.Polyline
	   * @see {@link fabric.Polygon#initialize} for constructor definition
	   */
	  fabric.Polygon = fabric.util.createClass(fabric.Polyline, /** @lends fabric.Polygon.prototype */ {

	    /**
	     * Type of an object
	     * @type String
	     * @default
	     */
	    type: 'polygon',

	    /**
	     * @private
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    _render: function(ctx) {
	      if (!this.commonRender(ctx)) {
	        return;
	      }
	      ctx.closePath();
	      this._renderPaintInOrder(ctx);
	    },

	  });

	  /* _FROM_SVG_START_ */
	  /**
	   * List of attribute names to account for when parsing SVG element (used by `fabric.Polygon.fromElement`)
	   * @static
	   * @memberOf fabric.Polygon
	   * @see: http://www.w3.org/TR/SVG/shapes.html#PolygonElement
	   */
	  fabric.Polygon.ATTRIBUTE_NAMES = fabric.SHARED_ATTRIBUTES.concat();

	  /**
	   * Returns {@link fabric.Polygon} instance from an SVG element
	   * @static
	   * @memberOf fabric.Polygon
	   * @param {SVGElement} element Element to parse
	   * @param {Function} callback callback function invoked after parsing
	   * @param {Object} [options] Options object
	   */
	  fabric.Polygon.fromElement = fabric.Polyline.fromElementGenerator('Polygon');
	  /* _FROM_SVG_END_ */

	  /**
	   * Returns fabric.Polygon instance from an object representation
	   * @static
	   * @memberOf fabric.Polygon
	   * @param {Object} object Object to create an instance from
	   * @param {Function} [callback] Callback to invoke when an fabric.Path instance is created
	   * @return {void}
	   */
	  fabric.Polygon.fromObject = function(object, callback) {
	    fabric.Object._fromObject('Polygon', object, callback, 'points');
	  };

	})(exports );


	(function(global) {

	  var fabric = global.fabric || (global.fabric = { }),
	      min = fabric.util.array.min,
	      max = fabric.util.array.max,
	      extend = fabric.util.object.extend,
	      _toString = Object.prototype.toString,
	      toFixed = fabric.util.toFixed;

	  if (fabric.Path) {
	    fabric.warn('fabric.Path is already defined');
	    return;
	  }

	  /**
	   * Path class
	   * @class fabric.Path
	   * @extends fabric.Object
	   * @tutorial {@link http://fabricjs.com/fabric-intro-part-1#path_and_pathgroup}
	   * @see {@link fabric.Path#initialize} for constructor definition
	   */
	  fabric.Path = fabric.util.createClass(fabric.Object, /** @lends fabric.Path.prototype */ {

	    /**
	     * Type of an object
	     * @type String
	     * @default
	     */
	    type: 'path',

	    /**
	     * Array of path points
	     * @type Array
	     * @default
	     */
	    path: null,

	    cacheProperties: fabric.Object.prototype.cacheProperties.concat('path', 'fillRule'),

	    stateProperties: fabric.Object.prototype.stateProperties.concat('path'),

	    /**
	     * Constructor
	     * @param {Array|String} path Path data (sequence of coordinates and corresponding "command" tokens)
	     * @param {Object} [options] Options object
	     * @return {fabric.Path} thisArg
	     */
	    initialize: function(path, options) {
	      options = options || { };
	      this.callSuper('initialize', options);
	      if (!path) {
	        path = [];
	      }

	      var fromArray = _toString.call(path) === '[object Array]';

	      this.path = fabric.util.makePathSimpler(
	        fromArray ? path : fabric.util.parsePath(path)
	      );

	      if (!this.path) {
	        return;
	      }
	      fabric.Polyline.prototype._setPositionDimensions.call(this, options);
	    },

	    /**
	     * @private
	     * @param {CanvasRenderingContext2D} ctx context to render path on
	     */
	    _renderPathCommands: function(ctx) {
	      var current, // current instruction
	          subpathStartX = 0,
	          subpathStartY = 0,
	          x = 0, // current x
	          y = 0, // current y
	          controlX = 0, // current control point x
	          controlY = 0, // current control point y
	          l = -this.pathOffset.x,
	          t = -this.pathOffset.y;

	      ctx.beginPath();

	      for (var i = 0, len = this.path.length; i < len; ++i) {

	        current = this.path[i];

	        switch (current[0]) { // first letter

	          case 'L': // lineto, absolute
	            x = current[1];
	            y = current[2];
	            ctx.lineTo(x + l, y + t);
	            break;

	          case 'M': // moveTo, absolute
	            x = current[1];
	            y = current[2];
	            subpathStartX = x;
	            subpathStartY = y;
	            ctx.moveTo(x + l, y + t);
	            break;

	          case 'C': // bezierCurveTo, absolute
	            x = current[5];
	            y = current[6];
	            controlX = current[3];
	            controlY = current[4];
	            ctx.bezierCurveTo(
	              current[1] + l,
	              current[2] + t,
	              controlX + l,
	              controlY + t,
	              x + l,
	              y + t
	            );
	            break;

	          case 'Q': // quadraticCurveTo, absolute
	            ctx.quadraticCurveTo(
	              current[1] + l,
	              current[2] + t,
	              current[3] + l,
	              current[4] + t
	            );
	            x = current[3];
	            y = current[4];
	            controlX = current[1];
	            controlY = current[2];
	            break;

	          case 'z':
	          case 'Z':
	            x = subpathStartX;
	            y = subpathStartY;
	            ctx.closePath();
	            break;
	        }
	      }
	    },

	    /**
	     * @private
	     * @param {CanvasRenderingContext2D} ctx context to render path on
	     */
	    _render: function(ctx) {
	      this._renderPathCommands(ctx);
	      this._renderPaintInOrder(ctx);
	    },

	    /**
	     * Returns string representation of an instance
	     * @return {String} string representation of an instance
	     */
	    toString: function() {
	      return '#<fabric.Path (' + this.complexity() +
	        '): { "top": ' + this.top + ', "left": ' + this.left + ' }>';
	    },

	    /**
	     * Returns object representation of an instance
	     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
	     * @return {Object} object representation of an instance
	     */
	    toObject: function(propertiesToInclude) {
	      return extend(this.callSuper('toObject', propertiesToInclude), {
	        path: this.path.map(function(item) { return item.slice(); }),
	      });
	    },

	    /**
	     * Returns dataless object representation of an instance
	     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
	     * @return {Object} object representation of an instance
	     */
	    toDatalessObject: function(propertiesToInclude) {
	      var o = this.toObject(['sourcePath'].concat(propertiesToInclude));
	      if (o.sourcePath) {
	        delete o.path;
	      }
	      return o;
	    },

	    /* _TO_SVG_START_ */
	    /**
	     * Returns svg representation of an instance
	     * @return {Array} an array of strings with the specific svg representation
	     * of the instance
	     */
	    _toSVG: function() {
	      var path = fabric.util.joinPath(this.path);
	      return [
	        '<path ', 'COMMON_PARTS',
	        'd="', path,
	        '" stroke-linecap="round" ',
	        '/>\n'
	      ];
	    },

	    _getOffsetTransform: function() {
	      var digits = fabric.Object.NUM_FRACTION_DIGITS;
	      return ' translate(' + toFixed(-this.pathOffset.x, digits) + ', ' +
	          toFixed(-this.pathOffset.y, digits) + ')';
	    },

	    /**
	     * Returns svg clipPath representation of an instance
	     * @param {Function} [reviver] Method for further parsing of svg representation.
	     * @return {String} svg representation of an instance
	     */
	    toClipPathSVG: function(reviver) {
	      var additionalTransform = this._getOffsetTransform();
	      return '\t' + this._createBaseClipPathSVGMarkup(
	        this._toSVG(), { reviver: reviver, additionalTransform: additionalTransform }
	      );
	    },

	    /**
	     * Returns svg representation of an instance
	     * @param {Function} [reviver] Method for further parsing of svg representation.
	     * @return {String} svg representation of an instance
	     */
	    toSVG: function(reviver) {
	      var additionalTransform = this._getOffsetTransform();
	      return this._createBaseSVGMarkup(this._toSVG(), { reviver: reviver, additionalTransform: additionalTransform  });
	    },
	    /* _TO_SVG_END_ */

	    /**
	     * Returns number representation of an instance complexity
	     * @return {Number} complexity of this instance
	     */
	    complexity: function() {
	      return this.path.length;
	    },

	    /**
	     * @private
	     */
	    _calcDimensions: function() {

	      var aX = [],
	          aY = [],
	          current, // current instruction
	          subpathStartX = 0,
	          subpathStartY = 0,
	          x = 0, // current x
	          y = 0, // current y
	          bounds;

	      for (var i = 0, len = this.path.length; i < len; ++i) {

	        current = this.path[i];

	        switch (current[0]) { // first letter

	          case 'L': // lineto, absolute
	            x = current[1];
	            y = current[2];
	            bounds = [];
	            break;

	          case 'M': // moveTo, absolute
	            x = current[1];
	            y = current[2];
	            subpathStartX = x;
	            subpathStartY = y;
	            bounds = [];
	            break;

	          case 'C': // bezierCurveTo, absolute
	            bounds = fabric.util.getBoundsOfCurve(x, y,
	              current[1],
	              current[2],
	              current[3],
	              current[4],
	              current[5],
	              current[6]
	            );
	            x = current[5];
	            y = current[6];
	            break;

	          case 'Q': // quadraticCurveTo, absolute
	            bounds = fabric.util.getBoundsOfCurve(x, y,
	              current[1],
	              current[2],
	              current[1],
	              current[2],
	              current[3],
	              current[4]
	            );
	            x = current[3];
	            y = current[4];
	            break;

	          case 'z':
	          case 'Z':
	            x = subpathStartX;
	            y = subpathStartY;
	            break;
	        }
	        bounds.forEach(function (point) {
	          aX.push(point.x);
	          aY.push(point.y);
	        });
	        aX.push(x);
	        aY.push(y);
	      }

	      var minX = min(aX) || 0,
	          minY = min(aY) || 0,
	          maxX = max(aX) || 0,
	          maxY = max(aY) || 0,
	          deltaX = maxX - minX,
	          deltaY = maxY - minY;

	      return {
	        left: minX,
	        top: minY,
	        width: deltaX,
	        height: deltaY
	      };
	    }
	  });

	  /**
	   * Creates an instance of fabric.Path from an object
	   * @static
	   * @memberOf fabric.Path
	   * @param {Object} object
	   * @param {Function} [callback] Callback to invoke when an fabric.Path instance is created
	   */
	  fabric.Path.fromObject = function(object, callback) {
	    if (typeof object.sourcePath === 'string') {
	      var pathUrl = object.sourcePath;
	      fabric.loadSVGFromURL(pathUrl, function (elements) {
	        var path = elements[0];
	        path.setOptions(object);
	        callback && callback(path);
	      });
	    }
	    else {
	      fabric.Object._fromObject('Path', object, callback, 'path');
	    }
	  };

	  /* _FROM_SVG_START_ */
	  /**
	   * List of attribute names to account for when parsing SVG element (used by `fabric.Path.fromElement`)
	   * @static
	   * @memberOf fabric.Path
	   * @see http://www.w3.org/TR/SVG/paths.html#PathElement
	   */
	  fabric.Path.ATTRIBUTE_NAMES = fabric.SHARED_ATTRIBUTES.concat(['d']);

	  /**
	   * Creates an instance of fabric.Path from an SVG <path> element
	   * @static
	   * @memberOf fabric.Path
	   * @param {SVGElement} element to parse
	   * @param {Function} callback Callback to invoke when an fabric.Path instance is created
	   * @param {Object} [options] Options object
	   * @param {Function} [callback] Options callback invoked after parsing is finished
	   */
	  fabric.Path.fromElement = function(element, callback, options) {
	    var parsedAttributes = fabric.parseAttributes(element, fabric.Path.ATTRIBUTE_NAMES);
	    parsedAttributes.fromSVG = true;
	    callback(new fabric.Path(parsedAttributes.d, extend(parsedAttributes, options)));
	  };
	  /* _FROM_SVG_END_ */

	})(exports );


	(function(global) {

	  var fabric = global.fabric || (global.fabric = { }),
	      min = fabric.util.array.min,
	      max = fabric.util.array.max;

	  if (fabric.Group) {
	    return;
	  }

	  /**
	   * Group class
	   * @class fabric.Group
	   * @extends fabric.Object
	   * @mixes fabric.Collection
	   * @tutorial {@link http://fabricjs.com/fabric-intro-part-3#groups}
	   * @see {@link fabric.Group#initialize} for constructor definition
	   */
	  fabric.Group = fabric.util.createClass(fabric.Object, fabric.Collection, /** @lends fabric.Group.prototype */ {

	    /**
	     * Type of an object
	     * @type String
	     * @default
	     */
	    type: 'group',

	    /**
	     * Width of stroke
	     * @type Number
	     * @default
	     */
	    strokeWidth: 0,

	    /**
	     * Indicates if click, mouseover, mouseout events & hoverCursor should also check for subtargets
	     * @type Boolean
	     * @default
	     */
	    subTargetCheck: false,

	    /**
	     * Groups are container, do not render anything on theyr own, ence no cache properties
	     * @type Array
	     * @default
	     */
	    cacheProperties: [],

	    /**
	     * setOnGroup is a method used for TextBox that is no more used since 2.0.0 The behavior is still
	     * available setting this boolean to true.
	     * @type Boolean
	     * @since 2.0.0
	     * @default
	     */
	    useSetOnGroup: false,

	    /**
	     * Constructor
	     * @param {Object} objects Group objects
	     * @param {Object} [options] Options object
	     * @param {Boolean} [isAlreadyGrouped] if true, objects have been grouped already.
	     * @return {Object} thisArg
	     */
	    initialize: function(objects, options, isAlreadyGrouped) {
	      options = options || {};
	      this._objects = [];
	      // if objects enclosed in a group have been grouped already,
	      // we cannot change properties of objects.
	      // Thus we need to set options to group without objects,
	      isAlreadyGrouped && this.callSuper('initialize', options);
	      this._objects = objects || [];
	      for (var i = this._objects.length; i--; ) {
	        this._objects[i].group = this;
	      }

	      if (!isAlreadyGrouped) {
	        var center = options && options.centerPoint;
	        // we want to set origins before calculating the bounding box.
	        // so that the topleft can be set with that in mind.
	        // if specific top and left are passed, are overwritten later
	        // with the callSuper('initialize', options)
	        if (options.originX !== undefined) {
	          this.originX = options.originX;
	        }
	        if (options.originY !== undefined) {
	          this.originY = options.originY;
	        }
	        // if coming from svg i do not want to calc bounds.
	        // i assume width and height are passed along options
	        center || this._calcBounds();
	        this._updateObjectsCoords(center);
	        delete options.centerPoint;
	        this.callSuper('initialize', options);
	      }
	      else {
	        this._updateObjectsACoords();
	      }

	      this.setCoords();
	    },

	    /**
	     * @private
	     */
	    _updateObjectsACoords: function() {
	      var skipControls = true;
	      for (var i = this._objects.length; i--; ){
	        this._objects[i].setCoords(skipControls);
	      }
	    },

	    /**
	     * @private
	     * @param {Boolean} [skipCoordsChange] if true, coordinates of objects enclosed in a group do not change
	     */
	    _updateObjectsCoords: function(center) {
	      var center = center || this.getCenterPoint();
	      for (var i = this._objects.length; i--; ){
	        this._updateObjectCoords(this._objects[i], center);
	      }
	    },

	    /**
	     * @private
	     * @param {Object} object
	     * @param {fabric.Point} center, current center of group.
	     */
	    _updateObjectCoords: function(object, center) {
	      var objectLeft = object.left,
	          objectTop = object.top,
	          skipControls = true;

	      object.set({
	        left: objectLeft - center.x,
	        top: objectTop - center.y
	      });
	      object.group = this;
	      object.setCoords(skipControls);
	    },

	    /**
	     * Returns string represenation of a group
	     * @return {String}
	     */
	    toString: function() {
	      return '#<fabric.Group: (' + this.complexity() + ')>';
	    },

	    /**
	     * Adds an object to a group; Then recalculates group's dimension, position.
	     * @param {Object} object
	     * @return {fabric.Group} thisArg
	     * @chainable
	     */
	    addWithUpdate: function(object) {
	      var nested = !!this.group;
	      this._restoreObjectsState();
	      fabric.util.resetObjectTransform(this);
	      if (object) {
	        if (nested) {
	          // if this group is inside another group, we need to pre transform the object
	          fabric.util.removeTransformFromObject(object, this.group.calcTransformMatrix());
	        }
	        this._objects.push(object);
	        object.group = this;
	        object._set('canvas', this.canvas);
	      }
	      this._calcBounds();
	      this._updateObjectsCoords();
	      this.dirty = true;
	      if (nested) {
	        this.group.addWithUpdate();
	      }
	      else {
	        this.setCoords();
	      }
	      return this;
	    },

	    /**
	     * Removes an object from a group; Then recalculates group's dimension, position.
	     * @param {Object} object
	     * @return {fabric.Group} thisArg
	     * @chainable
	     */
	    removeWithUpdate: function(object) {
	      this._restoreObjectsState();
	      fabric.util.resetObjectTransform(this);

	      this.remove(object);
	      this._calcBounds();
	      this._updateObjectsCoords();
	      this.setCoords();
	      this.dirty = true;
	      return this;
	    },

	    /**
	     * @private
	     */
	    _onObjectAdded: function(object) {
	      this.dirty = true;
	      object.group = this;
	      object._set('canvas', this.canvas);
	    },

	    /**
	     * @private
	     */
	    _onObjectRemoved: function(object) {
	      this.dirty = true;
	      delete object.group;
	    },

	    /**
	     * @private
	     */
	    _set: function(key, value) {
	      var i = this._objects.length;
	      if (this.useSetOnGroup) {
	        while (i--) {
	          this._objects[i].setOnGroup(key, value);
	        }
	      }
	      if (key === 'canvas') {
	        while (i--) {
	          this._objects[i]._set(key, value);
	        }
	      }
	      fabric.Object.prototype._set.call(this, key, value);
	    },

	    /**
	     * Returns object representation of an instance
	     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
	     * @return {Object} object representation of an instance
	     */
	    toObject: function(propertiesToInclude) {
	      var _includeDefaultValues = this.includeDefaultValues;
	      var objsToObject = this._objects
	        .filter(function (obj) {
	          return !obj.excludeFromExport;
	        })
	        .map(function (obj) {
	          var originalDefaults = obj.includeDefaultValues;
	          obj.includeDefaultValues = _includeDefaultValues;
	          var _obj = obj.toObject(propertiesToInclude);
	          obj.includeDefaultValues = originalDefaults;
	          return _obj;
	        });
	      var obj = fabric.Object.prototype.toObject.call(this, propertiesToInclude);
	      obj.objects = objsToObject;
	      return obj;
	    },

	    /**
	     * Returns object representation of an instance, in dataless mode.
	     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
	     * @return {Object} object representation of an instance
	     */
	    toDatalessObject: function(propertiesToInclude) {
	      var objsToObject, sourcePath = this.sourcePath;
	      if (sourcePath) {
	        objsToObject = sourcePath;
	      }
	      else {
	        var _includeDefaultValues = this.includeDefaultValues;
	        objsToObject = this._objects.map(function(obj) {
	          var originalDefaults = obj.includeDefaultValues;
	          obj.includeDefaultValues = _includeDefaultValues;
	          var _obj = obj.toDatalessObject(propertiesToInclude);
	          obj.includeDefaultValues = originalDefaults;
	          return _obj;
	        });
	      }
	      var obj = fabric.Object.prototype.toDatalessObject.call(this, propertiesToInclude);
	      obj.objects = objsToObject;
	      return obj;
	    },

	    /**
	     * Renders instance on a given context
	     * @param {CanvasRenderingContext2D} ctx context to render instance on
	     */
	    render: function(ctx) {
	      this._transformDone = true;
	      this.callSuper('render', ctx);
	      this._transformDone = false;
	    },

	    /**
	     * Decide if the object should cache or not. Create its own cache level
	     * needsItsOwnCache should be used when the object drawing method requires
	     * a cache step. None of the fabric classes requires it.
	     * Generally you do not cache objects in groups because the group is already cached.
	     * @return {Boolean}
	     */
	    shouldCache: function() {
	      var ownCache = fabric.Object.prototype.shouldCache.call(this);
	      if (ownCache) {
	        for (var i = 0, len = this._objects.length; i < len; i++) {
	          if (this._objects[i].willDrawShadow()) {
	            this.ownCaching = false;
	            return false;
	          }
	        }
	      }
	      return ownCache;
	    },

	    /**
	     * Check if this object or a child object will cast a shadow
	     * @return {Boolean}
	     */
	    willDrawShadow: function() {
	      if (fabric.Object.prototype.willDrawShadow.call(this)) {
	        return true;
	      }
	      for (var i = 0, len = this._objects.length; i < len; i++) {
	        if (this._objects[i].willDrawShadow()) {
	          return true;
	        }
	      }
	      return false;
	    },

	    /**
	     * Check if this group or its parent group are caching, recursively up
	     * @return {Boolean}
	     */
	    isOnACache: function() {
	      return this.ownCaching || (this.group && this.group.isOnACache());
	    },

	    /**
	     * Execute the drawing operation for an object on a specified context
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    drawObject: function(ctx) {
	      for (var i = 0, len = this._objects.length; i < len; i++) {
	        this._objects[i].render(ctx);
	      }
	      this._drawClipPath(ctx);
	    },

	    /**
	     * Check if cache is dirty
	     */
	    isCacheDirty: function(skipCanvas) {
	      if (this.callSuper('isCacheDirty', skipCanvas)) {
	        return true;
	      }
	      if (!this.statefullCache) {
	        return false;
	      }
	      for (var i = 0, len = this._objects.length; i < len; i++) {
	        if (this._objects[i].isCacheDirty(true)) {
	          if (this._cacheCanvas) {
	            // if this group has not a cache canvas there is nothing to clean
	            var x = this.cacheWidth / this.zoomX, y = this.cacheHeight / this.zoomY;
	            this._cacheContext.clearRect(-x / 2, -y / 2, x, y);
	          }
	          return true;
	        }
	      }
	      return false;
	    },

	    /**
	     * Restores original state of each of group objects (original state is that which was before group was created).
	     * if the nested boolean is true, the original state will be restored just for the
	     * first group and not for all the group chain
	     * @private
	     * @param {Boolean} nested tell the function to restore object state up to the parent group and not more
	     * @return {fabric.Group} thisArg
	     * @chainable
	     */
	    _restoreObjectsState: function() {
	      var groupMatrix = this.calcOwnMatrix();
	      this._objects.forEach(function(object) {
	        // instead of using _this = this;
	        fabric.util.addTransformToObject(object, groupMatrix);
	        delete object.group;
	        object.setCoords();
	      });
	      return this;
	    },

	    /**
	     * Realises the transform from this group onto the supplied object
	     * i.e. it tells you what would happen if the supplied object was in
	     * the group, and then the group was destroyed. It mutates the supplied
	     * object.
	     * Warning: this method is not useful anymore, it has been kept to no break the api.
	     * is not used in the fabricJS codebase
	     * this method will be reduced to using the utility.
	     * @private
	     * @deprecated
	     * @param {fabric.Object} object
	     * @param {Array} parentMatrix parent transformation
	     * @return {fabric.Object} transformedObject
	     */
	    realizeTransform: function(object, parentMatrix) {
	      fabric.util.addTransformToObject(object, parentMatrix);
	      return object;
	    },

	    /**
	     * Destroys a group (restoring state of its objects)
	     * @return {fabric.Group} thisArg
	     * @chainable
	     */
	    destroy: function() {
	      // when group is destroyed objects needs to get a repaint to be eventually
	      // displayed on canvas.
	      this._objects.forEach(function(object) {
	        object.set('dirty', true);
	      });
	      return this._restoreObjectsState();
	    },

	    /**
	     * make a group an active selection, remove the group from canvas
	     * the group has to be on canvas for this to work.
	     * @return {fabric.ActiveSelection} thisArg
	     * @chainable
	     */
	    toActiveSelection: function() {
	      if (!this.canvas) {
	        return;
	      }
	      var objects = this._objects, canvas = this.canvas;
	      this._objects = [];
	      var options = this.toObject();
	      delete options.objects;
	      var activeSelection = new fabric.ActiveSelection([]);
	      activeSelection.set(options);
	      activeSelection.type = 'activeSelection';
	      canvas.remove(this);
	      objects.forEach(function(object) {
	        object.group = activeSelection;
	        object.dirty = true;
	        canvas.add(object);
	      });
	      activeSelection.canvas = canvas;
	      activeSelection._objects = objects;
	      canvas._activeObject = activeSelection;
	      activeSelection.setCoords();
	      return activeSelection;
	    },

	    /**
	     * Destroys a group (restoring state of its objects)
	     * @return {fabric.Group} thisArg
	     * @chainable
	     */
	    ungroupOnCanvas: function() {
	      return this._restoreObjectsState();
	    },

	    /**
	     * Sets coordinates of all objects inside group
	     * @return {fabric.Group} thisArg
	     * @chainable
	     */
	    setObjectsCoords: function() {
	      var skipControls = true;
	      this.forEachObject(function(object) {
	        object.setCoords(skipControls);
	      });
	      return this;
	    },

	    /**
	     * @private
	     */
	    _calcBounds: function(onlyWidthHeight) {
	      var aX = [],
	          aY = [],
	          o, prop, coords,
	          props = ['tr', 'br', 'bl', 'tl'],
	          i = 0, iLen = this._objects.length,
	          j, jLen = props.length;

	      for ( ; i < iLen; ++i) {
	        o = this._objects[i];
	        coords = o.calcACoords();
	        for (j = 0; j < jLen; j++) {
	          prop = props[j];
	          aX.push(coords[prop].x);
	          aY.push(coords[prop].y);
	        }
	        o.aCoords = coords;
	      }

	      this._getBounds(aX, aY, onlyWidthHeight);
	    },

	    /**
	     * @private
	     */
	    _getBounds: function(aX, aY, onlyWidthHeight) {
	      var minXY = new fabric.Point(min(aX), min(aY)),
	          maxXY = new fabric.Point(max(aX), max(aY)),
	          top = minXY.y || 0, left = minXY.x || 0,
	          width = (maxXY.x - minXY.x) || 0,
	          height = (maxXY.y - minXY.y) || 0;
	      this.width = width;
	      this.height = height;
	      if (!onlyWidthHeight) {
	        // the bounding box always finds the topleft most corner.
	        // whatever is the group origin, we set up here the left/top position.
	        this.setPositionByOrigin({ x: left, y: top }, 'left', 'top');
	      }
	    },

	    /* _TO_SVG_START_ */
	    /**
	     * Returns svg representation of an instance
	     * @param {Function} [reviver] Method for further parsing of svg representation.
	     * @return {String} svg representation of an instance
	     */
	    _toSVG: function(reviver) {
	      var svgString = ['<g ', 'COMMON_PARTS', ' >\n'];

	      for (var i = 0, len = this._objects.length; i < len; i++) {
	        svgString.push('\t\t', this._objects[i].toSVG(reviver));
	      }
	      svgString.push('</g>\n');
	      return svgString;
	    },

	    /**
	     * Returns styles-string for svg-export, specific version for group
	     * @return {String}
	     */
	    getSvgStyles: function() {
	      var opacity = typeof this.opacity !== 'undefined' && this.opacity !== 1 ?
	            'opacity: ' + this.opacity + ';' : '',
	          visibility = this.visible ? '' : ' visibility: hidden;';
	      return [
	        opacity,
	        this.getSvgFilter(),
	        visibility
	      ].join('');
	    },

	    /**
	     * Returns svg clipPath representation of an instance
	     * @param {Function} [reviver] Method for further parsing of svg representation.
	     * @return {String} svg representation of an instance
	     */
	    toClipPathSVG: function(reviver) {
	      var svgString = [];

	      for (var i = 0, len = this._objects.length; i < len; i++) {
	        svgString.push('\t', this._objects[i].toClipPathSVG(reviver));
	      }

	      return this._createBaseClipPathSVGMarkup(svgString, { reviver: reviver });
	    },
	    /* _TO_SVG_END_ */
	  });

	  /**
	   * Returns {@link fabric.Group} instance from an object representation
	   * @static
	   * @memberOf fabric.Group
	   * @param {Object} object Object to create a group from
	   * @param {Function} [callback] Callback to invoke when an group instance is created
	   */
	  fabric.Group.fromObject = function(object, callback) {
	    var objects = object.objects,
	        options = fabric.util.object.clone(object, true);
	    delete options.objects;
	    if (typeof objects === 'string') {
	      // it has to be an url or something went wrong.
	      fabric.loadSVGFromURL(objects, function (elements) {
	        var group = fabric.util.groupSVGElements(elements, object, objects);
	        group.set(options);
	        callback && callback(group);
	      });
	      return;
	    }
	    fabric.util.enlivenObjects(objects, function(enlivenedObjects) {
	      fabric.util.enlivenObjects([object.clipPath], function(enlivedClipPath) {
	        var options = fabric.util.object.clone(object, true);
	        options.clipPath = enlivedClipPath[0];
	        delete options.objects;
	        callback && callback(new fabric.Group(enlivenedObjects, options, true));
	      });
	    });
	  };

	})(exports );


	(function(global) {

	  var fabric = global.fabric || (global.fabric = { });

	  if (fabric.ActiveSelection) {
	    return;
	  }

	  /**
	   * Group class
	   * @class fabric.ActiveSelection
	   * @extends fabric.Group
	   * @tutorial {@link http://fabricjs.com/fabric-intro-part-3#groups}
	   * @see {@link fabric.ActiveSelection#initialize} for constructor definition
	   */
	  fabric.ActiveSelection = fabric.util.createClass(fabric.Group, /** @lends fabric.ActiveSelection.prototype */ {

	    /**
	     * Type of an object
	     * @type String
	     * @default
	     */
	    type: 'activeSelection',

	    /**
	     * Constructor
	     * @param {Object} objects ActiveSelection objects
	     * @param {Object} [options] Options object
	     * @return {Object} thisArg
	     */
	    initialize: function(objects, options) {
	      options = options || {};
	      this._objects = objects || [];
	      for (var i = this._objects.length; i--; ) {
	        this._objects[i].group = this;
	      }

	      if (options.originX) {
	        this.originX = options.originX;
	      }
	      if (options.originY) {
	        this.originY = options.originY;
	      }
	      this._calcBounds();
	      this._updateObjectsCoords();
	      fabric.Object.prototype.initialize.call(this, options);
	      this.setCoords();
	    },

	    /**
	     * Change te activeSelection to a normal group,
	     * High level function that automatically adds it to canvas as
	     * active object. no events fired.
	     * @since 2.0.0
	     * @return {fabric.Group}
	     */
	    toGroup: function() {
	      var objects = this._objects.concat();
	      this._objects = [];
	      var options = fabric.Object.prototype.toObject.call(this);
	      var newGroup = new fabric.Group([]);
	      delete options.type;
	      newGroup.set(options);
	      objects.forEach(function(object) {
	        object.canvas.remove(object);
	        object.group = newGroup;
	      });
	      newGroup._objects = objects;
	      if (!this.canvas) {
	        return newGroup;
	      }
	      var canvas = this.canvas;
	      canvas.add(newGroup);
	      canvas._activeObject = newGroup;
	      newGroup.setCoords();
	      return newGroup;
	    },

	    /**
	     * If returns true, deselection is cancelled.
	     * @since 2.0.0
	     * @return {Boolean} [cancel]
	     */
	    onDeselect: function() {
	      this.destroy();
	      return false;
	    },

	    /**
	     * Returns string representation of a group
	     * @return {String}
	     */
	    toString: function() {
	      return '#<fabric.ActiveSelection: (' + this.complexity() + ')>';
	    },

	    /**
	     * Decide if the object should cache or not. Create its own cache level
	     * objectCaching is a global flag, wins over everything
	     * needsItsOwnCache should be used when the object drawing method requires
	     * a cache step. None of the fabric classes requires it.
	     * Generally you do not cache objects in groups because the group outside is cached.
	     * @return {Boolean}
	     */
	    shouldCache: function() {
	      return false;
	    },

	    /**
	     * Check if this group or its parent group are caching, recursively up
	     * @return {Boolean}
	     */
	    isOnACache: function() {
	      return false;
	    },

	    /**
	     * Renders controls and borders for the object
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     * @param {Object} [styleOverride] properties to override the object style
	     * @param {Object} [childrenOverride] properties to override the children overrides
	     */
	    _renderControls: function(ctx, styleOverride, childrenOverride) {
	      ctx.save();
	      ctx.globalAlpha = this.isMoving ? this.borderOpacityWhenMoving : 1;
	      this.callSuper('_renderControls', ctx, styleOverride);
	      childrenOverride = childrenOverride || { };
	      if (typeof childrenOverride.hasControls === 'undefined') {
	        childrenOverride.hasControls = false;
	      }
	      childrenOverride.forActiveSelection = true;
	      for (var i = 0, len = this._objects.length; i < len; i++) {
	        this._objects[i]._renderControls(ctx, childrenOverride);
	      }
	      ctx.restore();
	    },
	  });

	  /**
	   * Returns {@link fabric.ActiveSelection} instance from an object representation
	   * @static
	   * @memberOf fabric.ActiveSelection
	   * @param {Object} object Object to create a group from
	   * @param {Function} [callback] Callback to invoke when an ActiveSelection instance is created
	   */
	  fabric.ActiveSelection.fromObject = function(object, callback) {
	    fabric.util.enlivenObjects(object.objects, function(enlivenedObjects) {
	      delete object.objects;
	      callback && callback(new fabric.ActiveSelection(enlivenedObjects, object, true));
	    });
	  };

	})(exports );


	(function(global) {

	  var extend = fabric.util.object.extend;

	  if (!global.fabric) {
	    global.fabric = { };
	  }

	  if (global.fabric.Image) {
	    fabric.warn('fabric.Image is already defined.');
	    return;
	  }

	  /**
	   * Image class
	   * @class fabric.Image
	   * @extends fabric.Object
	   * @tutorial {@link http://fabricjs.com/fabric-intro-part-1#images}
	   * @see {@link fabric.Image#initialize} for constructor definition
	   */
	  fabric.Image = fabric.util.createClass(fabric.Object, /** @lends fabric.Image.prototype */ {

	    /**
	     * Type of an object
	     * @type String
	     * @default
	     */
	    type: 'image',

	    /**
	     * Width of a stroke.
	     * For image quality a stroke multiple of 2 gives better results.
	     * @type Number
	     * @default
	     */
	    strokeWidth: 0,

	    /**
	     * When calling {@link fabric.Image.getSrc}, return value from element src with `element.getAttribute('src')`.
	     * This allows for relative urls as image src.
	     * @since 2.7.0
	     * @type Boolean
	     * @default
	     */
	    srcFromAttribute: false,

	    /**
	     * private
	     * contains last value of scaleX to detect
	     * if the Image got resized after the last Render
	     * @type Number
	     */
	    _lastScaleX: 1,

	    /**
	     * private
	     * contains last value of scaleY to detect
	     * if the Image got resized after the last Render
	     * @type Number
	     */
	    _lastScaleY: 1,

	    /**
	     * private
	     * contains last value of scaling applied by the apply filter chain
	     * @type Number
	     */
	    _filterScalingX: 1,

	    /**
	     * private
	     * contains last value of scaling applied by the apply filter chain
	     * @type Number
	     */
	    _filterScalingY: 1,

	    /**
	     * minimum scale factor under which any resizeFilter is triggered to resize the image
	     * 0 will disable the automatic resize. 1 will trigger automatically always.
	     * number bigger than 1 are not implemented yet.
	     * @type Number
	     */
	    minimumScaleTrigger: 0.5,

	    /**
	     * List of properties to consider when checking if
	     * state of an object is changed ({@link fabric.Object#hasStateChanged})
	     * as well as for history (undo/redo) purposes
	     * @type Array
	     */
	    stateProperties: fabric.Object.prototype.stateProperties.concat('cropX', 'cropY'),

	    /**
	     * List of properties to consider when checking if cache needs refresh
	     * Those properties are checked by statefullCache ON ( or lazy mode if we want ) or from single
	     * calls to Object.set(key, value). If the key is in this list, the object is marked as dirty
	     * and refreshed at the next render
	     * @type Array
	     */
	    cacheProperties: fabric.Object.prototype.cacheProperties.concat('cropX', 'cropY'),

	    /**
	     * key used to retrieve the texture representing this image
	     * @since 2.0.0
	     * @type String
	     * @default
	     */
	    cacheKey: '',

	    /**
	     * Image crop in pixels from original image size.
	     * @since 2.0.0
	     * @type Number
	     * @default
	     */
	    cropX: 0,

	    /**
	     * Image crop in pixels from original image size.
	     * @since 2.0.0
	     * @type Number
	     * @default
	     */
	    cropY: 0,

	    /**
	     * Indicates whether this canvas will use image smoothing when painting this image.
	     * Also influence if the cacheCanvas for this image uses imageSmoothing
	     * @since 4.0.0-beta.11
	     * @type Boolean
	     * @default
	     */
	    imageSmoothing: true,

	    /**
	     * Constructor
	     * Image can be initialized with any canvas drawable or a string.
	     * The string should be a url and will be loaded as an image.
	     * Canvas and Image element work out of the box, while videos require extra code to work.
	     * Please check video element events for seeking.
	     * @param {HTMLImageElement | HTMLCanvasElement | HTMLVideoElement | String} element Image element
	     * @param {Object} [options] Options object
	     * @param {function} [callback] callback function to call after eventual filters applied.
	     * @return {fabric.Image} thisArg
	     */
	    initialize: function(element, options) {
	      options || (options = { });
	      this.filters = [];
	      this.cacheKey = 'texture' + fabric.Object.__uid++;
	      this.callSuper('initialize', options);
	      this._initElement(element, options);
	    },

	    /**
	     * Returns image element which this instance if based on
	     * @return {HTMLImageElement} Image element
	     */
	    getElement: function() {
	      return this._element || {};
	    },

	    /**
	     * Sets image element for this instance to a specified one.
	     * If filters defined they are applied to new image.
	     * You might need to call `canvas.renderAll` and `object.setCoords` after replacing, to render new image and update controls area.
	     * @param {HTMLImageElement} element
	     * @param {Object} [options] Options object
	     * @return {fabric.Image} thisArg
	     * @chainable
	     */
	    setElement: function(element, options) {
	      this.removeTexture(this.cacheKey);
	      this.removeTexture(this.cacheKey + '_filtered');
	      this._element = element;
	      this._originalElement = element;
	      this._initConfig(options);
	      if (this.filters.length !== 0) {
	        this.applyFilters();
	      }
	      // resizeFilters work on the already filtered copy.
	      // we need to apply resizeFilters AFTER normal filters.
	      // applyResizeFilters is run more often than normal filters
	      // and is triggered by user interactions rather than dev code
	      if (this.resizeFilter) {
	        this.applyResizeFilters();
	      }
	      return this;
	    },

	    /**
	     * Delete a single texture if in webgl mode
	     */
	    removeTexture: function(key) {
	      var backend = fabric.filterBackend;
	      if (backend && backend.evictCachesForKey) {
	        backend.evictCachesForKey(key);
	      }
	    },

	    /**
	     * Delete textures, reference to elements and eventually JSDOM cleanup
	     */
	    dispose: function() {
	      this.removeTexture(this.cacheKey);
	      this.removeTexture(this.cacheKey + '_filtered');
	      this._cacheContext = undefined;
	      ['_originalElement', '_element', '_filteredEl', '_cacheCanvas'].forEach((function(element) {
	        fabric.util.cleanUpJsdomNode(this[element]);
	        this[element] = undefined;
	      }).bind(this));
	    },

	    /**
	     * Get the crossOrigin value (of the corresponding image element)
	     */
	    getCrossOrigin: function() {
	      return this._originalElement && (this._originalElement.crossOrigin || null);
	    },

	    /**
	     * Returns original size of an image
	     * @return {Object} Object with "width" and "height" properties
	     */
	    getOriginalSize: function() {
	      var element = this.getElement();
	      return {
	        width: element.naturalWidth || element.width,
	        height: element.naturalHeight || element.height
	      };
	    },

	    /**
	     * @private
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    _stroke: function(ctx) {
	      if (!this.stroke || this.strokeWidth === 0) {
	        return;
	      }
	      var w = this.width / 2, h = this.height / 2;
	      ctx.beginPath();
	      ctx.moveTo(-w, -h);
	      ctx.lineTo(w, -h);
	      ctx.lineTo(w, h);
	      ctx.lineTo(-w, h);
	      ctx.lineTo(-w, -h);
	      ctx.closePath();
	    },

	    /**
	     * Returns object representation of an instance
	     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
	     * @return {Object} Object representation of an instance
	     */
	    toObject: function(propertiesToInclude) {
	      var filters = [];

	      this.filters.forEach(function(filterObj) {
	        if (filterObj) {
	          filters.push(filterObj.toObject());
	        }
	      });
	      var object = extend(
	        this.callSuper(
	          'toObject',
	          ['cropX', 'cropY'].concat(propertiesToInclude)
	        ), {
	          src: this.getSrc(),
	          crossOrigin: this.getCrossOrigin(),
	          filters: filters,
	        });
	      if (this.resizeFilter) {
	        object.resizeFilter = this.resizeFilter.toObject();
	      }
	      return object;
	    },

	    /**
	     * Returns true if an image has crop applied, inspecting values of cropX,cropY,width,height.
	     * @return {Boolean}
	     */
	    hasCrop: function() {
	      return this.cropX || this.cropY || this.width < this._element.width || this.height < this._element.height;
	    },

	    /* _TO_SVG_START_ */
	    /**
	     * Returns svg representation of an instance
	     * @return {Array} an array of strings with the specific svg representation
	     * of the instance
	     */
	    _toSVG: function() {
	      var svgString = [], imageMarkup = [], strokeSvg, element = this._element,
	          x = -this.width / 2, y = -this.height / 2, clipPath = '', imageRendering = '';
	      if (!element) {
	        return [];
	      }
	      if (this.hasCrop()) {
	        var clipPathId = fabric.Object.__uid++;
	        svgString.push(
	          '<clipPath id="imageCrop_' + clipPathId + '">\n',
	          '\t<rect x="' + x + '" y="' + y + '" width="' + this.width + '" height="' + this.height + '" />\n',
	          '</clipPath>\n'
	        );
	        clipPath = ' clip-path="url(#imageCrop_' + clipPathId + ')" ';
	      }
	      if (!this.imageSmoothing) {
	        imageRendering = '" image-rendering="optimizeSpeed';
	      }
	      imageMarkup.push('\t<image ', 'COMMON_PARTS', 'xlink:href="', this.getSvgSrc(true),
	        '" x="', x - this.cropX, '" y="', y - this.cropY,
	        // we're essentially moving origin of transformation from top/left corner to the center of the shape
	        // by wrapping it in container <g> element with actual transformation, then offsetting object to the top/left
	        // so that object's center aligns with container's left/top
	        '" width="', element.width || element.naturalWidth,
	        '" height="', element.height || element.height,
	        imageRendering,
	        '"', clipPath,
	        '></image>\n');

	      if (this.stroke || this.strokeDashArray) {
	        var origFill = this.fill;
	        this.fill = null;
	        strokeSvg = [
	          '\t<rect ',
	          'x="', x, '" y="', y,
	          '" width="', this.width, '" height="', this.height,
	          '" style="', this.getSvgStyles(),
	          '"/>\n'
	        ];
	        this.fill = origFill;
	      }
	      if (this.paintFirst !== 'fill') {
	        svgString = svgString.concat(strokeSvg, imageMarkup);
	      }
	      else {
	        svgString = svgString.concat(imageMarkup, strokeSvg);
	      }
	      return svgString;
	    },
	    /* _TO_SVG_END_ */

	    /**
	     * Returns source of an image
	     * @param {Boolean} filtered indicates if the src is needed for svg
	     * @return {String} Source of an image
	     */
	    getSrc: function(filtered) {
	      var element = filtered ? this._element : this._originalElement;
	      if (element) {
	        if (element.toDataURL) {
	          return element.toDataURL();
	        }

	        if (this.srcFromAttribute) {
	          return element.getAttribute('src');
	        }
	        else {
	          return element.src;
	        }
	      }
	      else {
	        return this.src || '';
	      }
	    },

	    /**
	     * Sets source of an image
	     * @param {String} src Source string (URL)
	     * @param {Function} [callback] Callback is invoked when image has been loaded (and all filters have been applied)
	     * @param {Object} [options] Options object
	     * @param {String} [options.crossOrigin] crossOrigin value (one of "", "anonymous", "use-credentials")
	     * @see https://developer.mozilla.org/en-US/docs/HTML/CORS_settings_attributes
	     * @return {fabric.Image} thisArg
	     * @chainable
	     */
	    setSrc: function(src, callback, options) {
	      fabric.util.loadImage(src, function(img, isError) {
	        this.setElement(img, options);
	        this._setWidthHeight();
	        callback && callback(this, isError);
	      }, this, options && options.crossOrigin);
	      return this;
	    },

	    /**
	     * Returns string representation of an instance
	     * @return {String} String representation of an instance
	     */
	    toString: function() {
	      return '#<fabric.Image: { src: "' + this.getSrc() + '" }>';
	    },

	    applyResizeFilters: function() {
	      var filter = this.resizeFilter,
	          minimumScale = this.minimumScaleTrigger,
	          objectScale = this.getTotalObjectScaling(),
	          scaleX = objectScale.scaleX,
	          scaleY = objectScale.scaleY,
	          elementToFilter = this._filteredEl || this._originalElement;
	      if (this.group) {
	        this.set('dirty', true);
	      }
	      if (!filter || (scaleX > minimumScale && scaleY > minimumScale)) {
	        this._element = elementToFilter;
	        this._filterScalingX = 1;
	        this._filterScalingY = 1;
	        this._lastScaleX = scaleX;
	        this._lastScaleY = scaleY;
	        return;
	      }
	      if (!fabric.filterBackend) {
	        fabric.filterBackend = fabric.initFilterBackend();
	      }
	      var canvasEl = fabric.util.createCanvasElement(),
	          cacheKey = this._filteredEl ? (this.cacheKey + '_filtered') : this.cacheKey,
	          sourceWidth = elementToFilter.width, sourceHeight = elementToFilter.height;
	      canvasEl.width = sourceWidth;
	      canvasEl.height = sourceHeight;
	      this._element = canvasEl;
	      this._lastScaleX = filter.scaleX = scaleX;
	      this._lastScaleY = filter.scaleY = scaleY;
	      fabric.filterBackend.applyFilters(
	        [filter], elementToFilter, sourceWidth, sourceHeight, this._element, cacheKey);
	      this._filterScalingX = canvasEl.width / this._originalElement.width;
	      this._filterScalingY = canvasEl.height / this._originalElement.height;
	    },

	    /**
	     * Applies filters assigned to this image (from "filters" array) or from filter param
	     * @method applyFilters
	     * @param {Array} filters to be applied
	     * @param {Boolean} forResizing specify if the filter operation is a resize operation
	     * @return {thisArg} return the fabric.Image object
	     * @chainable
	     */
	    applyFilters: function(filters) {

	      filters = filters || this.filters || [];
	      filters = filters.filter(function(filter) { return filter && !filter.isNeutralState(); });
	      this.set('dirty', true);

	      // needs to clear out or WEBGL will not resize correctly
	      this.removeTexture(this.cacheKey + '_filtered');

	      if (filters.length === 0) {
	        this._element = this._originalElement;
	        this._filteredEl = null;
	        this._filterScalingX = 1;
	        this._filterScalingY = 1;
	        return this;
	      }

	      var imgElement = this._originalElement,
	          sourceWidth = imgElement.naturalWidth || imgElement.width,
	          sourceHeight = imgElement.naturalHeight || imgElement.height;

	      if (this._element === this._originalElement) {
	        // if the element is the same we need to create a new element
	        var canvasEl = fabric.util.createCanvasElement();
	        canvasEl.width = sourceWidth;
	        canvasEl.height = sourceHeight;
	        this._element = canvasEl;
	        this._filteredEl = canvasEl;
	      }
	      else {
	        // clear the existing element to get new filter data
	        // also dereference the eventual resized _element
	        this._element = this._filteredEl;
	        this._filteredEl.getContext('2d').clearRect(0, 0, sourceWidth, sourceHeight);
	        // we also need to resize again at next renderAll, so remove saved _lastScaleX/Y
	        this._lastScaleX = 1;
	        this._lastScaleY = 1;
	      }
	      if (!fabric.filterBackend) {
	        fabric.filterBackend = fabric.initFilterBackend();
	      }
	      fabric.filterBackend.applyFilters(
	        filters, this._originalElement, sourceWidth, sourceHeight, this._element, this.cacheKey);
	      if (this._originalElement.width !== this._element.width ||
	        this._originalElement.height !== this._element.height) {
	        this._filterScalingX = this._element.width / this._originalElement.width;
	        this._filterScalingY = this._element.height / this._originalElement.height;
	      }
	      return this;
	    },

	    /**
	     * @private
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    _render: function(ctx) {
	      fabric.util.setImageSmoothing(ctx, this.imageSmoothing);
	      if (this.isMoving !== true && this.resizeFilter && this._needsResize()) {
	        this.applyResizeFilters();
	      }
	      this._stroke(ctx);
	      this._renderPaintInOrder(ctx);
	    },

	    /**
	     * Paint the cached copy of the object on the target context.
	     * it will set the imageSmoothing for the draw operation
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    drawCacheOnCanvas: function(ctx) {
	      fabric.util.setImageSmoothing(ctx, this.imageSmoothing);
	      fabric.Object.prototype.drawCacheOnCanvas.call(this, ctx);
	    },

	    /**
	     * Decide if the object should cache or not. Create its own cache level
	     * needsItsOwnCache should be used when the object drawing method requires
	     * a cache step. None of the fabric classes requires it.
	     * Generally you do not cache objects in groups because the group outside is cached.
	     * This is the special image version where we would like to avoid caching where possible.
	     * Essentially images do not benefit from caching. They may require caching, and in that
	     * case we do it. Also caching an image usually ends in a loss of details.
	     * A full performance audit should be done.
	     * @return {Boolean}
	     */
	    shouldCache: function() {
	      return this.needsItsOwnCache();
	    },

	    _renderFill: function(ctx) {
	      var elementToDraw = this._element;
	      if (!elementToDraw) {
	        return;
	      }
	      var scaleX = this._filterScalingX, scaleY = this._filterScalingY,
	          w = this.width, h = this.height, min = Math.min, max = Math.max,
	          // crop values cannot be lesser than 0.
	          cropX = max(this.cropX, 0), cropY = max(this.cropY, 0),
	          elWidth = elementToDraw.naturalWidth || elementToDraw.width,
	          elHeight = elementToDraw.naturalHeight || elementToDraw.height,
	          sX = cropX * scaleX,
	          sY = cropY * scaleY,
	          // the width height cannot exceed element width/height, starting from the crop offset.
	          sW = min(w * scaleX, elWidth - sX),
	          sH = min(h * scaleY, elHeight - sY),
	          x = -w / 2, y = -h / 2,
	          maxDestW = min(w, elWidth / scaleX - cropX),
	          maxDestH = min(h, elHeight / scaleY - cropY);

	      elementToDraw && ctx.drawImage(elementToDraw, sX, sY, sW, sH, x, y, maxDestW, maxDestH);
	    },

	    /**
	     * needed to check if image needs resize
	     * @private
	     */
	    _needsResize: function() {
	      var scale = this.getTotalObjectScaling();
	      return (scale.scaleX !== this._lastScaleX || scale.scaleY !== this._lastScaleY);
	    },

	    /**
	     * @private
	     */
	    _resetWidthHeight: function() {
	      this.set(this.getOriginalSize());
	    },

	    /**
	     * The Image class's initialization method. This method is automatically
	     * called by the constructor.
	     * @private
	     * @param {HTMLImageElement|String} element The element representing the image
	     * @param {Object} [options] Options object
	     */
	    _initElement: function(element, options) {
	      this.setElement(fabric.util.getById(element), options);
	      fabric.util.addClass(this.getElement(), fabric.Image.CSS_CANVAS);
	    },

	    /**
	     * @private
	     * @param {Object} [options] Options object
	     */
	    _initConfig: function(options) {
	      options || (options = { });
	      this.setOptions(options);
	      this._setWidthHeight(options);
	    },

	    /**
	     * @private
	     * @param {Array} filters to be initialized
	     * @param {Function} callback Callback to invoke when all fabric.Image.filters instances are created
	     */
	    _initFilters: function(filters, callback) {
	      if (filters && filters.length) {
	        fabric.util.enlivenObjects(filters, function(enlivenedObjects) {
	          callback && callback(enlivenedObjects);
	        }, 'fabric.Image.filters');
	      }
	      else {
	        callback && callback();
	      }
	    },

	    /**
	     * @private
	     * Set the width and the height of the image object, using the element or the
	     * options.
	     * @param {Object} [options] Object with width/height properties
	     */
	    _setWidthHeight: function(options) {
	      options || (options = { });
	      var el = this.getElement();
	      this.width = options.width || el.naturalWidth || el.width || 0;
	      this.height = options.height || el.naturalHeight || el.height || 0;
	    },

	    /**
	     * Calculate offset for center and scale factor for the image in order to respect
	     * the preserveAspectRatio attribute
	     * @private
	     * @return {Object}
	     */
	    parsePreserveAspectRatioAttribute: function() {
	      var pAR = fabric.util.parsePreserveAspectRatioAttribute(this.preserveAspectRatio || ''),
	          rWidth = this._element.width, rHeight = this._element.height,
	          scaleX = 1, scaleY = 1, offsetLeft = 0, offsetTop = 0, cropX = 0, cropY = 0,
	          offset, pWidth = this.width, pHeight = this.height, parsedAttributes = { width: pWidth, height: pHeight };
	      if (pAR && (pAR.alignX !== 'none' || pAR.alignY !== 'none')) {
	        if (pAR.meetOrSlice === 'meet') {
	          scaleX = scaleY = fabric.util.findScaleToFit(this._element, parsedAttributes);
	          offset = (pWidth - rWidth * scaleX) / 2;
	          if (pAR.alignX === 'Min') {
	            offsetLeft = -offset;
	          }
	          if (pAR.alignX === 'Max') {
	            offsetLeft = offset;
	          }
	          offset = (pHeight - rHeight * scaleY) / 2;
	          if (pAR.alignY === 'Min') {
	            offsetTop = -offset;
	          }
	          if (pAR.alignY === 'Max') {
	            offsetTop = offset;
	          }
	        }
	        if (pAR.meetOrSlice === 'slice') {
	          scaleX = scaleY = fabric.util.findScaleToCover(this._element, parsedAttributes);
	          offset = rWidth - pWidth / scaleX;
	          if (pAR.alignX === 'Mid') {
	            cropX = offset / 2;
	          }
	          if (pAR.alignX === 'Max') {
	            cropX = offset;
	          }
	          offset = rHeight - pHeight / scaleY;
	          if (pAR.alignY === 'Mid') {
	            cropY = offset / 2;
	          }
	          if (pAR.alignY === 'Max') {
	            cropY = offset;
	          }
	          rWidth = pWidth / scaleX;
	          rHeight = pHeight / scaleY;
	        }
	      }
	      else {
	        scaleX = pWidth / rWidth;
	        scaleY = pHeight / rHeight;
	      }
	      return {
	        width: rWidth,
	        height: rHeight,
	        scaleX: scaleX,
	        scaleY: scaleY,
	        offsetLeft: offsetLeft,
	        offsetTop: offsetTop,
	        cropX: cropX,
	        cropY: cropY
	      };
	    }
	  });

	  /**
	   * Default CSS class name for canvas
	   * @static
	   * @type String
	   * @default
	   */
	  fabric.Image.CSS_CANVAS = 'canvas-img';

	  /**
	   * Alias for getSrc
	   * @static
	   */
	  fabric.Image.prototype.getSvgSrc = fabric.Image.prototype.getSrc;

	  /**
	   * Creates an instance of fabric.Image from its object representation
	   * @static
	   * @param {Object} object Object to create an instance from
	   * @param {Function} callback Callback to invoke when an image instance is created
	   */
	  fabric.Image.fromObject = function(_object, callback) {
	    var object = fabric.util.object.clone(_object);
	    fabric.util.loadImage(object.src, function(img, isError) {
	      if (isError) {
	        callback && callback(null, true);
	        return;
	      }
	      fabric.Image.prototype._initFilters.call(object, object.filters, function(filters) {
	        object.filters = filters || [];
	        fabric.Image.prototype._initFilters.call(object, [object.resizeFilter], function(resizeFilters) {
	          object.resizeFilter = resizeFilters[0];
	          fabric.util.enlivenObjects([object.clipPath], function(enlivedProps) {
	            object.clipPath = enlivedProps[0];
	            var image = new fabric.Image(img, object);
	            callback(image, false);
	          });
	        });
	      });
	    }, null, object.crossOrigin);
	  };

	  /**
	   * Creates an instance of fabric.Image from an URL string
	   * @static
	   * @param {String} url URL to create an image from
	   * @param {Function} [callback] Callback to invoke when image is created (newly created image is passed as a first argument). Second argument is a boolean indicating if an error occurred or not.
	   * @param {Object} [imgOptions] Options object
	   */
	  fabric.Image.fromURL = function(url, callback, imgOptions) {
	    fabric.util.loadImage(url, function(img, isError) {
	      callback && callback(new fabric.Image(img, imgOptions), isError);
	    }, null, imgOptions && imgOptions.crossOrigin);
	  };

	  /* _FROM_SVG_START_ */
	  /**
	   * List of attribute names to account for when parsing SVG element (used by {@link fabric.Image.fromElement})
	   * @static
	   * @see {@link http://www.w3.org/TR/SVG/struct.html#ImageElement}
	   */
	  fabric.Image.ATTRIBUTE_NAMES =
	    fabric.SHARED_ATTRIBUTES.concat(
	      'x y width height preserveAspectRatio xlink:href crossOrigin image-rendering'.split(' ')
	    );

	  /**
	   * Returns {@link fabric.Image} instance from an SVG element
	   * @static
	   * @param {SVGElement} element Element to parse
	   * @param {Object} [options] Options object
	   * @param {Function} callback Callback to execute when fabric.Image object is created
	   * @return {fabric.Image} Instance of fabric.Image
	   */
	  fabric.Image.fromElement = function(element, callback, options) {
	    var parsedAttributes = fabric.parseAttributes(element, fabric.Image.ATTRIBUTE_NAMES);
	    fabric.Image.fromURL(parsedAttributes['xlink:href'], callback,
	      extend((options ? fabric.util.object.clone(options) : { }), parsedAttributes));
	  };
	  /* _FROM_SVG_END_ */

	})(exports );


	fabric.util.object.extend(fabric.Object.prototype, /** @lends fabric.Object.prototype */ {

	  /**
	   * @private
	   * @return {Number} angle value
	   */
	  _getAngleValueForStraighten: function() {
	    var angle = this.angle % 360;
	    if (angle > 0) {
	      return Math.round((angle - 1) / 90) * 90;
	    }
	    return Math.round(angle / 90) * 90;
	  },

	  /**
	   * Straightens an object (rotating it from current angle to one of 0, 90, 180, 270, etc. depending on which is closer)
	   * @return {fabric.Object} thisArg
	   * @chainable
	   */
	  straighten: function() {
	    this.rotate(this._getAngleValueForStraighten());
	    return this;
	  },

	  /**
	   * Same as {@link fabric.Object.prototype.straighten} but with animation
	   * @param {Object} callbacks Object with callback functions
	   * @param {Function} [callbacks.onComplete] Invoked on completion
	   * @param {Function} [callbacks.onChange] Invoked on every step of animation
	   * @return {fabric.Object} thisArg
	   * @chainable
	   */
	  fxStraighten: function(callbacks) {
	    callbacks = callbacks || { };

	    var empty = function() { },
	        onComplete = callbacks.onComplete || empty,
	        onChange = callbacks.onChange || empty,
	        _this = this;

	    fabric.util.animate({
	      startValue: this.get('angle'),
	      endValue: this._getAngleValueForStraighten(),
	      duration: this.FX_DURATION,
	      onChange: function(value) {
	        _this.rotate(value);
	        onChange();
	      },
	      onComplete: function() {
	        _this.setCoords();
	        onComplete();
	      },
	    });

	    return this;
	  }
	});

	fabric.util.object.extend(fabric.StaticCanvas.prototype, /** @lends fabric.StaticCanvas.prototype */ {

	  /**
	   * Straightens object, then rerenders canvas
	   * @param {fabric.Object} object Object to straighten
	   * @return {fabric.Canvas} thisArg
	   * @chainable
	   */
	  straightenObject: function (object) {
	    object.straighten();
	    this.requestRenderAll();
	    return this;
	  },

	  /**
	   * Same as {@link fabric.Canvas.prototype.straightenObject}, but animated
	   * @param {fabric.Object} object Object to straighten
	   * @return {fabric.Canvas} thisArg
	   * @chainable
	   */
	  fxStraightenObject: function (object) {
	    object.fxStraighten({
	      onChange: this.requestRenderAllBound
	    });
	    return this;
	  }
	});


	(function() {

	  /**
	   * Tests if webgl supports certain precision
	   * @param {WebGL} Canvas WebGL context to test on
	   * @param {String} Precision to test can be any of following: 'lowp', 'mediump', 'highp'
	   * @returns {Boolean} Whether the user's browser WebGL supports given precision.
	   */
	  function testPrecision(gl, precision){
	    var fragmentSource = 'precision ' + precision + ' float;\nvoid main(){}';
	    var fragmentShader = gl.createShader(gl.FRAGMENT_SHADER);
	    gl.shaderSource(fragmentShader, fragmentSource);
	    gl.compileShader(fragmentShader);
	    if (!gl.getShaderParameter(fragmentShader, gl.COMPILE_STATUS)) {
	      return false;
	    }
	    return true;
	  }

	  /**
	   * Indicate whether this filtering backend is supported by the user's browser.
	   * @param {Number} tileSize check if the tileSize is supported
	   * @returns {Boolean} Whether the user's browser supports WebGL.
	   */
	  fabric.isWebglSupported = function(tileSize) {
	    if (fabric.isLikelyNode) {
	      return false;
	    }
	    tileSize = tileSize || fabric.WebglFilterBackend.prototype.tileSize;
	    var canvas = document.createElement('canvas');
	    var gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
	    var isSupported = false;
	    // eslint-disable-next-line
	    if (gl) {
	      fabric.maxTextureSize = gl.getParameter(gl.MAX_TEXTURE_SIZE);
	      isSupported = fabric.maxTextureSize >= tileSize;
	      var precisions = ['highp', 'mediump', 'lowp'];
	      for (var i = 0; i < 3; i++){
	        if (testPrecision(gl, precisions[i])){
	          fabric.webGlPrecision = precisions[i];
	          break;
	        }	      }
	    }
	    this.isSupported = isSupported;
	    return isSupported;
	  };

	  fabric.WebglFilterBackend = WebglFilterBackend;

	  /**
	   * WebGL filter backend.
	   */
	  function WebglFilterBackend(options) {
	    if (options && options.tileSize) {
	      this.tileSize = options.tileSize;
	    }
	    this.setupGLContext(this.tileSize, this.tileSize);
	    this.captureGPUInfo();
	  }
	  WebglFilterBackend.prototype = /** @lends fabric.WebglFilterBackend.prototype */ {

	    tileSize: 2048,

	    /**
	     * Experimental. This object is a sort of repository of help layers used to avoid
	     * of recreating them during frequent filtering. If you are previewing a filter with
	     * a slider you probably do not want to create help layers every filter step.
	     * in this object there will be appended some canvases, created once, resized sometimes
	     * cleared never. Clearing is left to the developer.
	     **/
	    resources: {

	    },

	    /**
	     * Setup a WebGL context suitable for filtering, and bind any needed event handlers.
	     */
	    setupGLContext: function(width, height) {
	      this.dispose();
	      this.createWebGLCanvas(width, height);
	      // eslint-disable-next-line
	      this.aPosition = new Float32Array([0, 0, 0, 1, 1, 0, 1, 1]);
	      this.chooseFastestCopyGLTo2DMethod(width, height);
	    },

	    /**
	     * Pick a method to copy data from GL context to 2d canvas.  In some browsers using
	     * putImageData is faster than drawImage for that specific operation.
	     */
	    chooseFastestCopyGLTo2DMethod: function(width, height) {
	      var canMeasurePerf = typeof window.performance !== 'undefined', canUseImageData;
	      try {
	        new ImageData(1, 1);
	        canUseImageData = true;
	      }
	      catch (e) {
	        canUseImageData = false;
	      }
	      // eslint-disable-next-line no-undef
	      var canUseArrayBuffer = typeof ArrayBuffer !== 'undefined';
	      // eslint-disable-next-line no-undef
	      var canUseUint8Clamped = typeof Uint8ClampedArray !== 'undefined';

	      if (!(canMeasurePerf && canUseImageData && canUseArrayBuffer && canUseUint8Clamped)) {
	        return;
	      }

	      var targetCanvas = fabric.util.createCanvasElement();
	      // eslint-disable-next-line no-undef
	      var imageBuffer = new ArrayBuffer(width * height * 4);
	      if (fabric.forceGLPutImageData) {
	        this.imageBuffer = imageBuffer;
	        this.copyGLTo2D = copyGLTo2DPutImageData;
	        return;
	      }
	      var testContext = {
	        imageBuffer: imageBuffer,
	        destinationWidth: width,
	        destinationHeight: height,
	        targetCanvas: targetCanvas
	      };
	      var startTime, drawImageTime, putImageDataTime;
	      targetCanvas.width = width;
	      targetCanvas.height = height;

	      startTime = window.performance.now();
	      copyGLTo2DDrawImage.call(testContext, this.gl, testContext);
	      drawImageTime = window.performance.now() - startTime;

	      startTime = window.performance.now();
	      copyGLTo2DPutImageData.call(testContext, this.gl, testContext);
	      putImageDataTime = window.performance.now() - startTime;

	      if (drawImageTime > putImageDataTime) {
	        this.imageBuffer = imageBuffer;
	        this.copyGLTo2D = copyGLTo2DPutImageData;
	      }
	      else {
	        this.copyGLTo2D = copyGLTo2DDrawImage;
	      }
	    },

	    /**
	     * Create a canvas element and associated WebGL context and attaches them as
	     * class properties to the GLFilterBackend class.
	     */
	    createWebGLCanvas: function(width, height) {
	      var canvas = fabric.util.createCanvasElement();
	      canvas.width = width;
	      canvas.height = height;
	      var glOptions = {
	            alpha: true,
	            premultipliedAlpha: false,
	            depth: false,
	            stencil: false,
	            antialias: false
	          },
	          gl = canvas.getContext('webgl', glOptions);
	      if (!gl) {
	        gl = canvas.getContext('experimental-webgl', glOptions);
	      }
	      if (!gl) {
	        return;
	      }
	      gl.clearColor(0, 0, 0, 0);
	      // this canvas can fire webglcontextlost and webglcontextrestored
	      this.canvas = canvas;
	      this.gl = gl;
	    },

	    /**
	     * Attempts to apply the requested filters to the source provided, drawing the filtered output
	     * to the provided target canvas.
	     *
	     * @param {Array} filters The filters to apply.
	     * @param {HTMLImageElement|HTMLCanvasElement} source The source to be filtered.
	     * @param {Number} width The width of the source input.
	     * @param {Number} height The height of the source input.
	     * @param {HTMLCanvasElement} targetCanvas The destination for filtered output to be drawn.
	     * @param {String|undefined} cacheKey A key used to cache resources related to the source. If
	     * omitted, caching will be skipped.
	     */
	    applyFilters: function(filters, source, width, height, targetCanvas, cacheKey) {
	      var gl = this.gl;
	      var cachedTexture;
	      if (cacheKey) {
	        cachedTexture = this.getCachedTexture(cacheKey, source);
	      }
	      var pipelineState = {
	        originalWidth: source.width || source.originalWidth,
	        originalHeight: source.height || source.originalHeight,
	        sourceWidth: width,
	        sourceHeight: height,
	        destinationWidth: width,
	        destinationHeight: height,
	        context: gl,
	        sourceTexture: this.createTexture(gl, width, height, !cachedTexture && source),
	        targetTexture: this.createTexture(gl, width, height),
	        originalTexture: cachedTexture ||
	          this.createTexture(gl, width, height, !cachedTexture && source),
	        passes: filters.length,
	        webgl: true,
	        aPosition: this.aPosition,
	        programCache: this.programCache,
	        pass: 0,
	        filterBackend: this,
	        targetCanvas: targetCanvas
	      };
	      var tempFbo = gl.createFramebuffer();
	      gl.bindFramebuffer(gl.FRAMEBUFFER, tempFbo);
	      filters.forEach(function(filter) { filter && filter.applyTo(pipelineState); });
	      resizeCanvasIfNeeded(pipelineState);
	      this.copyGLTo2D(gl, pipelineState);
	      gl.bindTexture(gl.TEXTURE_2D, null);
	      gl.deleteTexture(pipelineState.sourceTexture);
	      gl.deleteTexture(pipelineState.targetTexture);
	      gl.deleteFramebuffer(tempFbo);
	      targetCanvas.getContext('2d').setTransform(1, 0, 0, 1, 0, 0);
	      return pipelineState;
	    },

	    /**
	     * Detach event listeners, remove references, and clean up caches.
	     */
	    dispose: function() {
	      if (this.canvas) {
	        this.canvas = null;
	        this.gl = null;
	      }
	      this.clearWebGLCaches();
	    },

	    /**
	     * Wipe out WebGL-related caches.
	     */
	    clearWebGLCaches: function() {
	      this.programCache = {};
	      this.textureCache = {};
	    },

	    /**
	     * Create a WebGL texture object.
	     *
	     * Accepts specific dimensions to initialize the texture to or a source image.
	     *
	     * @param {WebGLRenderingContext} gl The GL context to use for creating the texture.
	     * @param {Number} width The width to initialize the texture at.
	     * @param {Number} height The height to initialize the texture.
	     * @param {HTMLImageElement|HTMLCanvasElement} textureImageSource A source for the texture data.
	     * @returns {WebGLTexture}
	     */
	    createTexture: function(gl, width, height, textureImageSource) {
	      var texture = gl.createTexture();
	      gl.bindTexture(gl.TEXTURE_2D, texture);
	      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
	      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
	      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
	      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
	      if (textureImageSource) {
	        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, textureImageSource);
	      }
	      else {
	        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, width, height, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
	      }
	      return texture;
	    },

	    /**
	     * Can be optionally used to get a texture from the cache array
	     *
	     * If an existing texture is not found, a new texture is created and cached.
	     *
	     * @param {String} uniqueId A cache key to use to find an existing texture.
	     * @param {HTMLImageElement|HTMLCanvasElement} textureImageSource A source to use to create the
	     * texture cache entry if one does not already exist.
	     */
	    getCachedTexture: function(uniqueId, textureImageSource) {
	      if (this.textureCache[uniqueId]) {
	        return this.textureCache[uniqueId];
	      }
	      else {
	        var texture = this.createTexture(
	          this.gl, textureImageSource.width, textureImageSource.height, textureImageSource);
	        this.textureCache[uniqueId] = texture;
	        return texture;
	      }
	    },

	    /**
	     * Clear out cached resources related to a source image that has been
	     * filtered previously.
	     *
	     * @param {String} cacheKey The cache key provided when the source image was filtered.
	     */
	    evictCachesForKey: function(cacheKey) {
	      if (this.textureCache[cacheKey]) {
	        this.gl.deleteTexture(this.textureCache[cacheKey]);
	        delete this.textureCache[cacheKey];
	      }
	    },

	    copyGLTo2D: copyGLTo2DDrawImage,

	    /**
	     * Attempt to extract GPU information strings from a WebGL context.
	     *
	     * Useful information when debugging or blacklisting specific GPUs.
	     *
	     * @returns {Object} A GPU info object with renderer and vendor strings.
	     */
	    captureGPUInfo: function() {
	      if (this.gpuInfo) {
	        return this.gpuInfo;
	      }
	      var gl = this.gl, gpuInfo = { renderer: '', vendor: '' };
	      if (!gl) {
	        return gpuInfo;
	      }
	      var ext = gl.getExtension('WEBGL_debug_renderer_info');
	      if (ext) {
	        var renderer = gl.getParameter(ext.UNMASKED_RENDERER_WEBGL);
	        var vendor = gl.getParameter(ext.UNMASKED_VENDOR_WEBGL);
	        if (renderer) {
	          gpuInfo.renderer = renderer.toLowerCase();
	        }
	        if (vendor) {
	          gpuInfo.vendor = vendor.toLowerCase();
	        }
	      }
	      this.gpuInfo = gpuInfo;
	      return gpuInfo;
	    },
	  };
	})();

	function resizeCanvasIfNeeded(pipelineState) {
	  var targetCanvas = pipelineState.targetCanvas,
	      width = targetCanvas.width, height = targetCanvas.height,
	      dWidth = pipelineState.destinationWidth,
	      dHeight = pipelineState.destinationHeight;

	  if (width !== dWidth || height !== dHeight) {
	    targetCanvas.width = dWidth;
	    targetCanvas.height = dHeight;
	  }
	}

	/**
	 * Copy an input WebGL canvas on to an output 2D canvas.
	 *
	 * The WebGL canvas is assumed to be upside down, with the top-left pixel of the
	 * desired output image appearing in the bottom-left corner of the WebGL canvas.
	 *
	 * @param {WebGLRenderingContext} sourceContext The WebGL context to copy from.
	 * @param {HTMLCanvasElement} targetCanvas The 2D target canvas to copy on to.
	 * @param {Object} pipelineState The 2D target canvas to copy on to.
	 */
	function copyGLTo2DDrawImage(gl, pipelineState) {
	  var glCanvas = gl.canvas, targetCanvas = pipelineState.targetCanvas,
	      ctx = targetCanvas.getContext('2d');
	  ctx.translate(0, targetCanvas.height); // move it down again
	  ctx.scale(1, -1); // vertical flip
	  // where is my image on the big glcanvas?
	  var sourceY = glCanvas.height - targetCanvas.height;
	  ctx.drawImage(glCanvas, 0, sourceY, targetCanvas.width, targetCanvas.height, 0, 0,
	    targetCanvas.width, targetCanvas.height);
	}

	/**
	 * Copy an input WebGL canvas on to an output 2D canvas using 2d canvas' putImageData
	 * API. Measurably faster than using ctx.drawImage in Firefox (version 54 on OSX Sierra).
	 *
	 * @param {WebGLRenderingContext} sourceContext The WebGL context to copy from.
	 * @param {HTMLCanvasElement} targetCanvas The 2D target canvas to copy on to.
	 * @param {Object} pipelineState The 2D target canvas to copy on to.
	 */
	function copyGLTo2DPutImageData(gl, pipelineState) {
	  var targetCanvas = pipelineState.targetCanvas, ctx = targetCanvas.getContext('2d'),
	      dWidth = pipelineState.destinationWidth,
	      dHeight = pipelineState.destinationHeight,
	      numBytes = dWidth * dHeight * 4;

	  // eslint-disable-next-line no-undef
	  var u8 = new Uint8Array(this.imageBuffer, 0, numBytes);
	  // eslint-disable-next-line no-undef
	  var u8Clamped = new Uint8ClampedArray(this.imageBuffer, 0, numBytes);

	  gl.readPixels(0, 0, dWidth, dHeight, gl.RGBA, gl.UNSIGNED_BYTE, u8);
	  var imgData = new ImageData(u8Clamped, dWidth, dHeight);
	  ctx.putImageData(imgData, 0, 0);
	}


	(function() {

	  var noop = function() {};

	  fabric.Canvas2dFilterBackend = Canvas2dFilterBackend;

	  /**
	   * Canvas 2D filter backend.
	   */
	  function Canvas2dFilterBackend() {}
	  Canvas2dFilterBackend.prototype = /** @lends fabric.Canvas2dFilterBackend.prototype */ {
	    evictCachesForKey: noop,
	    dispose: noop,
	    clearWebGLCaches: noop,

	    /**
	     * Experimental. This object is a sort of repository of help layers used to avoid
	     * of recreating them during frequent filtering. If you are previewing a filter with
	     * a slider you probably do not want to create help layers every filter step.
	     * in this object there will be appended some canvases, created once, resized sometimes
	     * cleared never. Clearing is left to the developer.
	     **/
	    resources: {

	    },

	    /**
	     * Apply a set of filters against a source image and draw the filtered output
	     * to the provided destination canvas.
	     *
	     * @param {EnhancedFilter} filters The filter to apply.
	     * @param {HTMLImageElement|HTMLCanvasElement} sourceElement The source to be filtered.
	     * @param {Number} sourceWidth The width of the source input.
	     * @param {Number} sourceHeight The height of the source input.
	     * @param {HTMLCanvasElement} targetCanvas The destination for filtered output to be drawn.
	     */
	    applyFilters: function(filters, sourceElement, sourceWidth, sourceHeight, targetCanvas) {
	      var ctx = targetCanvas.getContext('2d');
	      ctx.drawImage(sourceElement, 0, 0, sourceWidth, sourceHeight);
	      var imageData = ctx.getImageData(0, 0, sourceWidth, sourceHeight);
	      var originalImageData = ctx.getImageData(0, 0, sourceWidth, sourceHeight);
	      var pipelineState = {
	        sourceWidth: sourceWidth,
	        sourceHeight: sourceHeight,
	        imageData: imageData,
	        originalEl: sourceElement,
	        originalImageData: originalImageData,
	        canvasEl: targetCanvas,
	        ctx: ctx,
	        filterBackend: this,
	      };
	      filters.forEach(function(filter) { filter.applyTo(pipelineState); });
	      if (pipelineState.imageData.width !== sourceWidth || pipelineState.imageData.height !== sourceHeight) {
	        targetCanvas.width = pipelineState.imageData.width;
	        targetCanvas.height = pipelineState.imageData.height;
	      }
	      ctx.putImageData(pipelineState.imageData, 0, 0);
	      return pipelineState;
	    },

	  };
	})();


	/**
	 * @namespace fabric.Image.filters
	 * @memberOf fabric.Image
	 * @tutorial {@link http://fabricjs.com/fabric-intro-part-2#image_filters}
	 * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
	 */
	fabric.Image = fabric.Image || { };
	fabric.Image.filters = fabric.Image.filters || { };

	/**
	 * Root filter class from which all filter classes inherit from
	 * @class fabric.Image.filters.BaseFilter
	 * @memberOf fabric.Image.filters
	 */
	fabric.Image.filters.BaseFilter = fabric.util.createClass(/** @lends fabric.Image.filters.BaseFilter.prototype */ {

	  /**
	   * Filter type
	   * @param {String} type
	   * @default
	   */
	  type: 'BaseFilter',

	  /**
	   * Array of attributes to send with buffers. do not modify
	   * @private
	   */

	  vertexSource: 'attribute vec2 aPosition;\n' +
	    'varying vec2 vTexCoord;\n' +
	    'void main() {\n' +
	      'vTexCoord = aPosition;\n' +
	      'gl_Position = vec4(aPosition * 2.0 - 1.0, 0.0, 1.0);\n' +
	    '}',

	  fragmentSource: 'precision highp float;\n' +
	    'varying vec2 vTexCoord;\n' +
	    'uniform sampler2D uTexture;\n' +
	    'void main() {\n' +
	      'gl_FragColor = texture2D(uTexture, vTexCoord);\n' +
	    '}',

	  /**
	   * Constructor
	   * @param {Object} [options] Options object
	   */
	  initialize: function(options) {
	    if (options) {
	      this.setOptions(options);
	    }
	  },

	  /**
	   * Sets filter's properties from options
	   * @param {Object} [options] Options object
	   */
	  setOptions: function(options) {
	    for (var prop in options) {
	      this[prop] = options[prop];
	    }
	  },

	  /**
	   * Compile this filter's shader program.
	   *
	   * @param {WebGLRenderingContext} gl The GL canvas context to use for shader compilation.
	   * @param {String} fragmentSource fragmentShader source for compilation
	   * @param {String} vertexSource vertexShader source for compilation
	   */
	  createProgram: function(gl, fragmentSource, vertexSource) {
	    fragmentSource = fragmentSource || this.fragmentSource;
	    vertexSource = vertexSource || this.vertexSource;
	    if (fabric.webGlPrecision !== 'highp'){
	      fragmentSource = fragmentSource.replace(
	        /precision highp float/g,
	        'precision ' + fabric.webGlPrecision + ' float'
	      );
	    }
	    var vertexShader = gl.createShader(gl.VERTEX_SHADER);
	    gl.shaderSource(vertexShader, vertexSource);
	    gl.compileShader(vertexShader);
	    if (!gl.getShaderParameter(vertexShader, gl.COMPILE_STATUS)) {
	      throw new Error(
	        // eslint-disable-next-line prefer-template
	        'Vertex shader compile error for ' + this.type + ': ' +
	        gl.getShaderInfoLog(vertexShader)
	      );
	    }

	    var fragmentShader = gl.createShader(gl.FRAGMENT_SHADER);
	    gl.shaderSource(fragmentShader, fragmentSource);
	    gl.compileShader(fragmentShader);
	    if (!gl.getShaderParameter(fragmentShader, gl.COMPILE_STATUS)) {
	      throw new Error(
	        // eslint-disable-next-line prefer-template
	        'Fragment shader compile error for ' + this.type + ': ' +
	        gl.getShaderInfoLog(fragmentShader)
	      );
	    }

	    var program = gl.createProgram();
	    gl.attachShader(program, vertexShader);
	    gl.attachShader(program, fragmentShader);
	    gl.linkProgram(program);
	    if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
	      throw new Error(
	        // eslint-disable-next-line prefer-template
	        'Shader link error for "${this.type}" ' +
	        gl.getProgramInfoLog(program)
	      );
	    }

	    var attributeLocations = this.getAttributeLocations(gl, program);
	    var uniformLocations = this.getUniformLocations(gl, program) || { };
	    uniformLocations.uStepW = gl.getUniformLocation(program, 'uStepW');
	    uniformLocations.uStepH = gl.getUniformLocation(program, 'uStepH');
	    return {
	      program: program,
	      attributeLocations: attributeLocations,
	      uniformLocations: uniformLocations
	    };
	  },

	  /**
	   * Return a map of attribute names to WebGLAttributeLocation objects.
	   *
	   * @param {WebGLRenderingContext} gl The canvas context used to compile the shader program.
	   * @param {WebGLShaderProgram} program The shader program from which to take attribute locations.
	   * @returns {Object} A map of attribute names to attribute locations.
	   */
	  getAttributeLocations: function(gl, program) {
	    return {
	      aPosition: gl.getAttribLocation(program, 'aPosition'),
	    };
	  },

	  /**
	   * Return a map of uniform names to WebGLUniformLocation objects.
	   *
	   * Intended to be overridden by subclasses.
	   *
	   * @param {WebGLRenderingContext} gl The canvas context used to compile the shader program.
	   * @param {WebGLShaderProgram} program The shader program from which to take uniform locations.
	   * @returns {Object} A map of uniform names to uniform locations.
	   */
	  getUniformLocations: function (/* gl, program */) {
	    // in case i do not need any special uniform i need to return an empty object
	    return { };
	  },

	  /**
	   * Send attribute data from this filter to its shader program on the GPU.
	   *
	   * @param {WebGLRenderingContext} gl The canvas context used to compile the shader program.
	   * @param {Object} attributeLocations A map of shader attribute names to their locations.
	   */
	  sendAttributeData: function(gl, attributeLocations, aPositionData) {
	    var attributeLocation = attributeLocations.aPosition;
	    var buffer = gl.createBuffer();
	    gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
	    gl.enableVertexAttribArray(attributeLocation);
	    gl.vertexAttribPointer(attributeLocation, 2, gl.FLOAT, false, 0, 0);
	    gl.bufferData(gl.ARRAY_BUFFER, aPositionData, gl.STATIC_DRAW);
	  },

	  _setupFrameBuffer: function(options) {
	    var gl = options.context, width, height;
	    if (options.passes > 1) {
	      width = options.destinationWidth;
	      height = options.destinationHeight;
	      if (options.sourceWidth !== width || options.sourceHeight !== height) {
	        gl.deleteTexture(options.targetTexture);
	        options.targetTexture = options.filterBackend.createTexture(gl, width, height);
	      }
	      gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D,
	        options.targetTexture, 0);
	    }
	    else {
	      // draw last filter on canvas and not to framebuffer.
	      gl.bindFramebuffer(gl.FRAMEBUFFER, null);
	      gl.finish();
	    }
	  },

	  _swapTextures: function(options) {
	    options.passes--;
	    options.pass++;
	    var temp = options.targetTexture;
	    options.targetTexture = options.sourceTexture;
	    options.sourceTexture = temp;
	  },

	  /**
	   * Generic isNeutral implementation for one parameter based filters.
	   * Used only in image applyFilters to discard filters that will not have an effect
	   * on the image
	   * Other filters may need their own version ( ColorMatrix, HueRotation, gamma, ComposedFilter )
	   * @param {Object} options
	   **/
	  isNeutralState: function(/* options */) {
	    var main = this.mainParameter,
	        _class = fabric.Image.filters[this.type].prototype;
	    if (main) {
	      if (Array.isArray(_class[main])) {
	        for (var i = _class[main].length; i--;) {
	          if (this[main][i] !== _class[main][i]) {
	            return false;
	          }
	        }
	        return true;
	      }
	      else {
	        return _class[main] === this[main];
	      }
	    }
	    else {
	      return false;
	    }
	  },

	  /**
	   * Apply this filter to the input image data provided.
	   *
	   * Determines whether to use WebGL or Canvas2D based on the options.webgl flag.
	   *
	   * @param {Object} options
	   * @param {Number} options.passes The number of filters remaining to be executed
	   * @param {Boolean} options.webgl Whether to use webgl to render the filter.
	   * @param {WebGLTexture} options.sourceTexture The texture setup as the source to be filtered.
	   * @param {WebGLTexture} options.targetTexture The texture where filtered output should be drawn.
	   * @param {WebGLRenderingContext} options.context The GL context used for rendering.
	   * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
	   */
	  applyTo: function(options) {
	    if (options.webgl) {
	      this._setupFrameBuffer(options);
	      this.applyToWebGL(options);
	      this._swapTextures(options);
	    }
	    else {
	      this.applyTo2d(options);
	    }
	  },

	  /**
	   * Retrieves the cached shader.
	   * @param {Object} options
	   * @param {WebGLRenderingContext} options.context The GL context used for rendering.
	   * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
	   */
	  retrieveShader: function(options) {
	    if (!options.programCache.hasOwnProperty(this.type)) {
	      options.programCache[this.type] = this.createProgram(options.context);
	    }
	    return options.programCache[this.type];
	  },

	  /**
	   * Apply this filter using webgl.
	   *
	   * @param {Object} options
	   * @param {Number} options.passes The number of filters remaining to be executed
	   * @param {Boolean} options.webgl Whether to use webgl to render the filter.
	   * @param {WebGLTexture} options.originalTexture The texture of the original input image.
	   * @param {WebGLTexture} options.sourceTexture The texture setup as the source to be filtered.
	   * @param {WebGLTexture} options.targetTexture The texture where filtered output should be drawn.
	   * @param {WebGLRenderingContext} options.context The GL context used for rendering.
	   * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
	   */
	  applyToWebGL: function(options) {
	    var gl = options.context;
	    var shader = this.retrieveShader(options);
	    if (options.pass === 0 && options.originalTexture) {
	      gl.bindTexture(gl.TEXTURE_2D, options.originalTexture);
	    }
	    else {
	      gl.bindTexture(gl.TEXTURE_2D, options.sourceTexture);
	    }
	    gl.useProgram(shader.program);
	    this.sendAttributeData(gl, shader.attributeLocations, options.aPosition);

	    gl.uniform1f(shader.uniformLocations.uStepW, 1 / options.sourceWidth);
	    gl.uniform1f(shader.uniformLocations.uStepH, 1 / options.sourceHeight);

	    this.sendUniformData(gl, shader.uniformLocations);
	    gl.viewport(0, 0, options.destinationWidth, options.destinationHeight);
	    gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
	  },

	  bindAdditionalTexture: function(gl, texture, textureUnit) {
	    gl.activeTexture(textureUnit);
	    gl.bindTexture(gl.TEXTURE_2D, texture);
	    // reset active texture to 0 as usual
	    gl.activeTexture(gl.TEXTURE0);
	  },

	  unbindAdditionalTexture: function(gl, textureUnit) {
	    gl.activeTexture(textureUnit);
	    gl.bindTexture(gl.TEXTURE_2D, null);
	    gl.activeTexture(gl.TEXTURE0);
	  },

	  getMainParameter: function() {
	    return this[this.mainParameter];
	  },

	  setMainParameter: function(value) {
	    this[this.mainParameter] = value;
	  },

	  /**
	   * Send uniform data from this filter to its shader program on the GPU.
	   *
	   * Intended to be overridden by subclasses.
	   *
	   * @param {WebGLRenderingContext} gl The canvas context used to compile the shader program.
	   * @param {Object} uniformLocations A map of shader uniform names to their locations.
	   */
	  sendUniformData: function(/* gl, uniformLocations */) {
	    // Intentionally left blank.  Override me in subclasses.
	  },

	  /**
	   * If needed by a 2d filter, this functions can create an helper canvas to be used
	   * remember that options.targetCanvas is available for use till end of chain.
	   */
	  createHelpLayer: function(options) {
	    if (!options.helpLayer) {
	      var helpLayer = document.createElement('canvas');
	      helpLayer.width = options.sourceWidth;
	      helpLayer.height = options.sourceHeight;
	      options.helpLayer = helpLayer;
	    }
	  },

	  /**
	   * Returns object representation of an instance
	   * @return {Object} Object representation of an instance
	   */
	  toObject: function() {
	    var object = { type: this.type }, mainP = this.mainParameter;
	    if (mainP) {
	      object[mainP] = this[mainP];
	    }
	    return object;
	  },

	  /**
	   * Returns a JSON representation of an instance
	   * @return {Object} JSON
	   */
	  toJSON: function() {
	    // delegate, not alias
	    return this.toObject();
	  }
	});

	fabric.Image.filters.BaseFilter.fromObject = function(object, callback) {
	  var filter = new fabric.Image.filters[object.type](object);
	  callback && callback(filter);
	  return filter;
	};


	(function(global) {

	  var fabric  = global.fabric || (global.fabric = { }),
	      filters = fabric.Image.filters,
	      createClass = fabric.util.createClass;

	  /**
	   * Color Matrix filter class
	   * @class fabric.Image.filters.ColorMatrix
	   * @memberOf fabric.Image.filters
	   * @extends fabric.Image.filters.BaseFilter
	   * @see {@link fabric.Image.filters.ColorMatrix#initialize} for constructor definition
	   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
	   * @see {@Link http://www.webwasp.co.uk/tutorials/219/Color_Matrix_Filter.php}
	   * @see {@Link http://phoboslab.org/log/2013/11/fast-image-filters-with-webgl}
	   * @example <caption>Kodachrome filter</caption>
	   * var filter = new fabric.Image.filters.ColorMatrix({
	   *  matrix: [
	       1.1285582396593525, -0.3967382283601348, -0.03992559172921793, 0, 63.72958762196502,
	       -0.16404339962244616, 1.0835251566291304, -0.05498805115633132, 0, 24.732407896706203,
	       -0.16786010706155763, -0.5603416277695248, 1.6014850761964943, 0, 35.62982807460946,
	       0, 0, 0, 1, 0
	      ]
	   * });
	   * object.filters.push(filter);
	   * object.applyFilters();
	   */
	  filters.ColorMatrix = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.ColorMatrix.prototype */ {

	    /**
	     * Filter type
	     * @param {String} type
	     * @default
	     */
	    type: 'ColorMatrix',

	    fragmentSource: 'precision highp float;\n' +
	      'uniform sampler2D uTexture;\n' +
	      'varying vec2 vTexCoord;\n' +
	      'uniform mat4 uColorMatrix;\n' +
	      'uniform vec4 uConstants;\n' +
	      'void main() {\n' +
	        'vec4 color = texture2D(uTexture, vTexCoord);\n' +
	        'color *= uColorMatrix;\n' +
	        'color += uConstants;\n' +
	        'gl_FragColor = color;\n' +
	      '}',

	    /**
	     * Colormatrix for pixels.
	     * array of 20 floats. Numbers in positions 4, 9, 14, 19 loose meaning
	     * outside the -1, 1 range.
	     * 0.0039215686 is the part of 1 that get translated to 1 in 2d
	     * @param {Array} matrix array of 20 numbers.
	     * @default
	     */
	    matrix: [
	      1, 0, 0, 0, 0,
	      0, 1, 0, 0, 0,
	      0, 0, 1, 0, 0,
	      0, 0, 0, 1, 0
	    ],

	    mainParameter: 'matrix',

	    /**
	     * Lock the colormatrix on the color part, skipping alpha, manly for non webgl scenario
	     * to save some calculation
	     */
	    colorsOnly: true,

	    /**
	     * Constructor
	     * @param {Object} [options] Options object
	     */
	    initialize: function(options) {
	      this.callSuper('initialize', options);
	      // create a new array instead mutating the prototype with push
	      this.matrix = this.matrix.slice(0);
	    },

	    /**
	     * Apply the ColorMatrix operation to a Uint8Array representing the pixels of an image.
	     *
	     * @param {Object} options
	     * @param {ImageData} options.imageData The Uint8Array to be filtered.
	     */
	    applyTo2d: function(options) {
	      var imageData = options.imageData,
	          data = imageData.data,
	          iLen = data.length,
	          m = this.matrix,
	          r, g, b, a, i, colorsOnly = this.colorsOnly;

	      for (i = 0; i < iLen; i += 4) {
	        r = data[i];
	        g = data[i + 1];
	        b = data[i + 2];
	        if (colorsOnly) {
	          data[i] = r * m[0] + g * m[1] + b * m[2] + m[4] * 255;
	          data[i + 1] = r * m[5] + g * m[6] + b * m[7] + m[9] * 255;
	          data[i + 2] = r * m[10] + g * m[11] + b * m[12] + m[14] * 255;
	        }
	        else {
	          a = data[i + 3];
	          data[i] = r * m[0] + g * m[1] + b * m[2] + a * m[3] + m[4] * 255;
	          data[i + 1] = r * m[5] + g * m[6] + b * m[7] + a * m[8] + m[9] * 255;
	          data[i + 2] = r * m[10] + g * m[11] + b * m[12] + a * m[13] + m[14] * 255;
	          data[i + 3] = r * m[15] + g * m[16] + b * m[17] + a * m[18] + m[19] * 255;
	        }
	      }
	    },

	    /**
	     * Return WebGL uniform locations for this filter's shader.
	     *
	     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	     * @param {WebGLShaderProgram} program This filter's compiled shader program.
	     */
	    getUniformLocations: function(gl, program) {
	      return {
	        uColorMatrix: gl.getUniformLocation(program, 'uColorMatrix'),
	        uConstants: gl.getUniformLocation(program, 'uConstants'),
	      };
	    },

	    /**
	     * Send data from this filter to its shader program's uniforms.
	     *
	     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
	     */
	    sendUniformData: function(gl, uniformLocations) {
	      var m = this.matrix,
	          matrix = [
	            m[0], m[1], m[2], m[3],
	            m[5], m[6], m[7], m[8],
	            m[10], m[11], m[12], m[13],
	            m[15], m[16], m[17], m[18]
	          ],
	          constants = [m[4], m[9], m[14], m[19]];
	      gl.uniformMatrix4fv(uniformLocations.uColorMatrix, false, matrix);
	      gl.uniform4fv(uniformLocations.uConstants, constants);
	    },
	  });

	  /**
	   * Returns filter instance from an object representation
	   * @static
	   * @param {Object} object Object to create an instance from
	   * @param {function} [callback] function to invoke after filter creation
	   * @return {fabric.Image.filters.ColorMatrix} Instance of fabric.Image.filters.ColorMatrix
	   */
	  fabric.Image.filters.ColorMatrix.fromObject = fabric.Image.filters.BaseFilter.fromObject;
	})(exports );


	(function(global) {

	  var fabric  = global.fabric || (global.fabric = { }),
	      filters = fabric.Image.filters,
	      createClass = fabric.util.createClass;

	  /**
	   * Brightness filter class
	   * @class fabric.Image.filters.Brightness
	   * @memberOf fabric.Image.filters
	   * @extends fabric.Image.filters.BaseFilter
	   * @see {@link fabric.Image.filters.Brightness#initialize} for constructor definition
	   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
	   * @example
	   * var filter = new fabric.Image.filters.Brightness({
	   *   brightness: 0.05
	   * });
	   * object.filters.push(filter);
	   * object.applyFilters();
	   */
	  filters.Brightness = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Brightness.prototype */ {

	    /**
	     * Filter type
	     * @param {String} type
	     * @default
	     */
	    type: 'Brightness',

	    /**
	     * Fragment source for the brightness program
	     */
	    fragmentSource: 'precision highp float;\n' +
	      'uniform sampler2D uTexture;\n' +
	      'uniform float uBrightness;\n' +
	      'varying vec2 vTexCoord;\n' +
	      'void main() {\n' +
	        'vec4 color = texture2D(uTexture, vTexCoord);\n' +
	        'color.rgb += uBrightness;\n' +
	        'gl_FragColor = color;\n' +
	      '}',

	    /**
	     * Brightness value, from -1 to 1.
	     * translated to -255 to 255 for 2d
	     * 0.0039215686 is the part of 1 that get translated to 1 in 2d
	     * @param {Number} brightness
	     * @default
	     */
	    brightness: 0,

	    /**
	     * Describe the property that is the filter parameter
	     * @param {String} m
	     * @default
	     */
	    mainParameter: 'brightness',

	    /**
	    * Apply the Brightness operation to a Uint8ClampedArray representing the pixels of an image.
	    *
	    * @param {Object} options
	    * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
	    */
	    applyTo2d: function(options) {
	      if (this.brightness === 0) {
	        return;
	      }
	      var imageData = options.imageData,
	          data = imageData.data, i, len = data.length,
	          brightness = Math.round(this.brightness * 255);
	      for (i = 0; i < len; i += 4) {
	        data[i] = data[i] + brightness;
	        data[i + 1] = data[i + 1] + brightness;
	        data[i + 2] = data[i + 2] + brightness;
	      }
	    },

	    /**
	     * Return WebGL uniform locations for this filter's shader.
	     *
	     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	     * @param {WebGLShaderProgram} program This filter's compiled shader program.
	     */
	    getUniformLocations: function(gl, program) {
	      return {
	        uBrightness: gl.getUniformLocation(program, 'uBrightness'),
	      };
	    },

	    /**
	     * Send data from this filter to its shader program's uniforms.
	     *
	     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
	     */
	    sendUniformData: function(gl, uniformLocations) {
	      gl.uniform1f(uniformLocations.uBrightness, this.brightness);
	    },
	  });

	  /**
	   * Returns filter instance from an object representation
	   * @static
	   * @param {Object} object Object to create an instance from
	   * @param {function} [callback] to be invoked after filter creation
	   * @return {fabric.Image.filters.Brightness} Instance of fabric.Image.filters.Brightness
	   */
	  fabric.Image.filters.Brightness.fromObject = fabric.Image.filters.BaseFilter.fromObject;

	})(exports );


	(function(global) {

	  var fabric  = global.fabric || (global.fabric = { }),
	      extend = fabric.util.object.extend,
	      filters = fabric.Image.filters,
	      createClass = fabric.util.createClass;

	  /**
	   * Adapted from <a href="http://www.html5rocks.com/en/tutorials/canvas/imagefilters/">html5rocks article</a>
	   * @class fabric.Image.filters.Convolute
	   * @memberOf fabric.Image.filters
	   * @extends fabric.Image.filters.BaseFilter
	   * @see {@link fabric.Image.filters.Convolute#initialize} for constructor definition
	   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
	   * @example <caption>Sharpen filter</caption>
	   * var filter = new fabric.Image.filters.Convolute({
	   *   matrix: [ 0, -1,  0,
	   *            -1,  5, -1,
	   *             0, -1,  0 ]
	   * });
	   * object.filters.push(filter);
	   * object.applyFilters();
	   * canvas.renderAll();
	   * @example <caption>Blur filter</caption>
	   * var filter = new fabric.Image.filters.Convolute({
	   *   matrix: [ 1/9, 1/9, 1/9,
	   *             1/9, 1/9, 1/9,
	   *             1/9, 1/9, 1/9 ]
	   * });
	   * object.filters.push(filter);
	   * object.applyFilters();
	   * canvas.renderAll();
	   * @example <caption>Emboss filter</caption>
	   * var filter = new fabric.Image.filters.Convolute({
	   *   matrix: [ 1,   1,  1,
	   *             1, 0.7, -1,
	   *            -1,  -1, -1 ]
	   * });
	   * object.filters.push(filter);
	   * object.applyFilters();
	   * canvas.renderAll();
	   * @example <caption>Emboss filter with opaqueness</caption>
	   * var filter = new fabric.Image.filters.Convolute({
	   *   opaque: true,
	   *   matrix: [ 1,   1,  1,
	   *             1, 0.7, -1,
	   *            -1,  -1, -1 ]
	   * });
	   * object.filters.push(filter);
	   * object.applyFilters();
	   * canvas.renderAll();
	   */
	  filters.Convolute = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Convolute.prototype */ {

	    /**
	     * Filter type
	     * @param {String} type
	     * @default
	     */
	    type: 'Convolute',

	    /*
	     * Opaque value (true/false)
	     */
	    opaque: false,

	    /*
	     * matrix for the filter, max 9x9
	     */
	    matrix: [0, 0, 0, 0, 1, 0, 0, 0, 0],

	    /**
	     * Fragment source for the brightness program
	     */
	    fragmentSource: {
	      Convolute_3_1: 'precision highp float;\n' +
	        'uniform sampler2D uTexture;\n' +
	        'uniform float uMatrix[9];\n' +
	        'uniform float uStepW;\n' +
	        'uniform float uStepH;\n' +
	        'varying vec2 vTexCoord;\n' +
	        'void main() {\n' +
	          'vec4 color = vec4(0, 0, 0, 0);\n' +
	          'for (float h = 0.0; h < 3.0; h+=1.0) {\n' +
	            'for (float w = 0.0; w < 3.0; w+=1.0) {\n' +
	              'vec2 matrixPos = vec2(uStepW * (w - 1), uStepH * (h - 1));\n' +
	              'color += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 3.0 + w)];\n' +
	            '}\n' +
	          '}\n' +
	          'gl_FragColor = color;\n' +
	        '}',
	      Convolute_3_0: 'precision highp float;\n' +
	        'uniform sampler2D uTexture;\n' +
	        'uniform float uMatrix[9];\n' +
	        'uniform float uStepW;\n' +
	        'uniform float uStepH;\n' +
	        'varying vec2 vTexCoord;\n' +
	        'void main() {\n' +
	          'vec4 color = vec4(0, 0, 0, 1);\n' +
	          'for (float h = 0.0; h < 3.0; h+=1.0) {\n' +
	            'for (float w = 0.0; w < 3.0; w+=1.0) {\n' +
	              'vec2 matrixPos = vec2(uStepW * (w - 1.0), uStepH * (h - 1.0));\n' +
	              'color.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 3.0 + w)];\n' +
	            '}\n' +
	          '}\n' +
	          'float alpha = texture2D(uTexture, vTexCoord).a;\n' +
	          'gl_FragColor = color;\n' +
	          'gl_FragColor.a = alpha;\n' +
	        '}',
	      Convolute_5_1: 'precision highp float;\n' +
	        'uniform sampler2D uTexture;\n' +
	        'uniform float uMatrix[25];\n' +
	        'uniform float uStepW;\n' +
	        'uniform float uStepH;\n' +
	        'varying vec2 vTexCoord;\n' +
	        'void main() {\n' +
	          'vec4 color = vec4(0, 0, 0, 0);\n' +
	          'for (float h = 0.0; h < 5.0; h+=1.0) {\n' +
	            'for (float w = 0.0; w < 5.0; w+=1.0) {\n' +
	              'vec2 matrixPos = vec2(uStepW * (w - 2.0), uStepH * (h - 2.0));\n' +
	              'color += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 5.0 + w)];\n' +
	            '}\n' +
	          '}\n' +
	          'gl_FragColor = color;\n' +
	        '}',
	      Convolute_5_0: 'precision highp float;\n' +
	        'uniform sampler2D uTexture;\n' +
	        'uniform float uMatrix[25];\n' +
	        'uniform float uStepW;\n' +
	        'uniform float uStepH;\n' +
	        'varying vec2 vTexCoord;\n' +
	        'void main() {\n' +
	          'vec4 color = vec4(0, 0, 0, 1);\n' +
	          'for (float h = 0.0; h < 5.0; h+=1.0) {\n' +
	            'for (float w = 0.0; w < 5.0; w+=1.0) {\n' +
	              'vec2 matrixPos = vec2(uStepW * (w - 2.0), uStepH * (h - 2.0));\n' +
	              'color.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 5.0 + w)];\n' +
	            '}\n' +
	          '}\n' +
	          'float alpha = texture2D(uTexture, vTexCoord).a;\n' +
	          'gl_FragColor = color;\n' +
	          'gl_FragColor.a = alpha;\n' +
	        '}',
	      Convolute_7_1: 'precision highp float;\n' +
	        'uniform sampler2D uTexture;\n' +
	        'uniform float uMatrix[49];\n' +
	        'uniform float uStepW;\n' +
	        'uniform float uStepH;\n' +
	        'varying vec2 vTexCoord;\n' +
	        'void main() {\n' +
	          'vec4 color = vec4(0, 0, 0, 0);\n' +
	          'for (float h = 0.0; h < 7.0; h+=1.0) {\n' +
	            'for (float w = 0.0; w < 7.0; w+=1.0) {\n' +
	              'vec2 matrixPos = vec2(uStepW * (w - 3.0), uStepH * (h - 3.0));\n' +
	              'color += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 7.0 + w)];\n' +
	            '}\n' +
	          '}\n' +
	          'gl_FragColor = color;\n' +
	        '}',
	      Convolute_7_0: 'precision highp float;\n' +
	        'uniform sampler2D uTexture;\n' +
	        'uniform float uMatrix[49];\n' +
	        'uniform float uStepW;\n' +
	        'uniform float uStepH;\n' +
	        'varying vec2 vTexCoord;\n' +
	        'void main() {\n' +
	          'vec4 color = vec4(0, 0, 0, 1);\n' +
	          'for (float h = 0.0; h < 7.0; h+=1.0) {\n' +
	            'for (float w = 0.0; w < 7.0; w+=1.0) {\n' +
	              'vec2 matrixPos = vec2(uStepW * (w - 3.0), uStepH * (h - 3.0));\n' +
	              'color.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 7.0 + w)];\n' +
	            '}\n' +
	          '}\n' +
	          'float alpha = texture2D(uTexture, vTexCoord).a;\n' +
	          'gl_FragColor = color;\n' +
	          'gl_FragColor.a = alpha;\n' +
	        '}',
	      Convolute_9_1: 'precision highp float;\n' +
	        'uniform sampler2D uTexture;\n' +
	        'uniform float uMatrix[81];\n' +
	        'uniform float uStepW;\n' +
	        'uniform float uStepH;\n' +
	        'varying vec2 vTexCoord;\n' +
	        'void main() {\n' +
	          'vec4 color = vec4(0, 0, 0, 0);\n' +
	          'for (float h = 0.0; h < 9.0; h+=1.0) {\n' +
	            'for (float w = 0.0; w < 9.0; w+=1.0) {\n' +
	              'vec2 matrixPos = vec2(uStepW * (w - 4.0), uStepH * (h - 4.0));\n' +
	              'color += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 9.0 + w)];\n' +
	            '}\n' +
	          '}\n' +
	          'gl_FragColor = color;\n' +
	        '}',
	      Convolute_9_0: 'precision highp float;\n' +
	        'uniform sampler2D uTexture;\n' +
	        'uniform float uMatrix[81];\n' +
	        'uniform float uStepW;\n' +
	        'uniform float uStepH;\n' +
	        'varying vec2 vTexCoord;\n' +
	        'void main() {\n' +
	          'vec4 color = vec4(0, 0, 0, 1);\n' +
	          'for (float h = 0.0; h < 9.0; h+=1.0) {\n' +
	            'for (float w = 0.0; w < 9.0; w+=1.0) {\n' +
	              'vec2 matrixPos = vec2(uStepW * (w - 4.0), uStepH * (h - 4.0));\n' +
	              'color.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 9.0 + w)];\n' +
	            '}\n' +
	          '}\n' +
	          'float alpha = texture2D(uTexture, vTexCoord).a;\n' +
	          'gl_FragColor = color;\n' +
	          'gl_FragColor.a = alpha;\n' +
	        '}',
	    },

	    /**
	     * Constructor
	     * @memberOf fabric.Image.filters.Convolute.prototype
	     * @param {Object} [options] Options object
	     * @param {Boolean} [options.opaque=false] Opaque value (true/false)
	     * @param {Array} [options.matrix] Filter matrix
	     */


	    /**
	    * Retrieves the cached shader.
	    * @param {Object} options
	    * @param {WebGLRenderingContext} options.context The GL context used for rendering.
	    * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
	    */
	    retrieveShader: function(options) {
	      var size = Math.sqrt(this.matrix.length);
	      var cacheKey = this.type + '_' + size + '_' + (this.opaque ? 1 : 0);
	      var shaderSource = this.fragmentSource[cacheKey];
	      if (!options.programCache.hasOwnProperty(cacheKey)) {
	        options.programCache[cacheKey] = this.createProgram(options.context, shaderSource);
	      }
	      return options.programCache[cacheKey];
	    },

	    /**
	     * Apply the Brightness operation to a Uint8ClampedArray representing the pixels of an image.
	     *
	     * @param {Object} options
	     * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
	     */
	    applyTo2d: function(options) {
	      var imageData = options.imageData,
	          data = imageData.data,
	          weights = this.matrix,
	          side = Math.round(Math.sqrt(weights.length)),
	          halfSide = Math.floor(side / 2),
	          sw = imageData.width,
	          sh = imageData.height,
	          output = options.ctx.createImageData(sw, sh),
	          dst = output.data,
	          // go through the destination image pixels
	          alphaFac = this.opaque ? 1 : 0,
	          r, g, b, a, dstOff,
	          scx, scy, srcOff, wt,
	          x, y, cx, cy;

	      for (y = 0; y < sh; y++) {
	        for (x = 0; x < sw; x++) {
	          dstOff = (y * sw + x) * 4;
	          // calculate the weighed sum of the source image pixels that
	          // fall under the convolution matrix
	          r = 0; g = 0; b = 0; a = 0;

	          for (cy = 0; cy < side; cy++) {
	            for (cx = 0; cx < side; cx++) {
	              scy = y + cy - halfSide;
	              scx = x + cx - halfSide;

	              // eslint-disable-next-line max-depth
	              if (scy < 0 || scy >= sh || scx < 0 || scx >= sw) {
	                continue;
	              }

	              srcOff = (scy * sw + scx) * 4;
	              wt = weights[cy * side + cx];

	              r += data[srcOff] * wt;
	              g += data[srcOff + 1] * wt;
	              b += data[srcOff + 2] * wt;
	              // eslint-disable-next-line max-depth
	              if (!alphaFac) {
	                a += data[srcOff + 3] * wt;
	              }
	            }
	          }
	          dst[dstOff] = r;
	          dst[dstOff + 1] = g;
	          dst[dstOff + 2] = b;
	          if (!alphaFac) {
	            dst[dstOff + 3] = a;
	          }
	          else {
	            dst[dstOff + 3] = data[dstOff + 3];
	          }
	        }
	      }
	      options.imageData = output;
	    },

	    /**
	     * Return WebGL uniform locations for this filter's shader.
	     *
	     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	     * @param {WebGLShaderProgram} program This filter's compiled shader program.
	     */
	    getUniformLocations: function(gl, program) {
	      return {
	        uMatrix: gl.getUniformLocation(program, 'uMatrix'),
	        uOpaque: gl.getUniformLocation(program, 'uOpaque'),
	        uHalfSize: gl.getUniformLocation(program, 'uHalfSize'),
	        uSize: gl.getUniformLocation(program, 'uSize'),
	      };
	    },

	    /**
	     * Send data from this filter to its shader program's uniforms.
	     *
	     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
	     */
	    sendUniformData: function(gl, uniformLocations) {
	      gl.uniform1fv(uniformLocations.uMatrix, this.matrix);
	    },

	    /**
	     * Returns object representation of an instance
	     * @return {Object} Object representation of an instance
	     */
	    toObject: function() {
	      return extend(this.callSuper('toObject'), {
	        opaque: this.opaque,
	        matrix: this.matrix
	      });
	    }
	  });

	  /**
	   * Returns filter instance from an object representation
	   * @static
	   * @param {Object} object Object to create an instance from
	   * @param {function} [callback] to be invoked after filter creation
	   * @return {fabric.Image.filters.Convolute} Instance of fabric.Image.filters.Convolute
	   */
	  fabric.Image.filters.Convolute.fromObject = fabric.Image.filters.BaseFilter.fromObject;

	})(exports );


	(function(global) {

	  var fabric  = global.fabric || (global.fabric = { }),
	      filters = fabric.Image.filters,
	      createClass = fabric.util.createClass;

	  /**
	   * Grayscale image filter class
	   * @class fabric.Image.filters.Grayscale
	   * @memberOf fabric.Image.filters
	   * @extends fabric.Image.filters.BaseFilter
	   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
	   * @example
	   * var filter = new fabric.Image.filters.Grayscale();
	   * object.filters.push(filter);
	   * object.applyFilters();
	   */
	  filters.Grayscale = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Grayscale.prototype */ {

	    /**
	     * Filter type
	     * @param {String} type
	     * @default
	     */
	    type: 'Grayscale',

	    fragmentSource: {
	      average: 'precision highp float;\n' +
	        'uniform sampler2D uTexture;\n' +
	        'varying vec2 vTexCoord;\n' +
	        'void main() {\n' +
	          'vec4 color = texture2D(uTexture, vTexCoord);\n' +
	          'float average = (color.r + color.b + color.g) / 3.0;\n' +
	          'gl_FragColor = vec4(average, average, average, color.a);\n' +
	        '}',
	      lightness: 'precision highp float;\n' +
	        'uniform sampler2D uTexture;\n' +
	        'uniform int uMode;\n' +
	        'varying vec2 vTexCoord;\n' +
	        'void main() {\n' +
	          'vec4 col = texture2D(uTexture, vTexCoord);\n' +
	          'float average = (max(max(col.r, col.g),col.b) + min(min(col.r, col.g),col.b)) / 2.0;\n' +
	          'gl_FragColor = vec4(average, average, average, col.a);\n' +
	        '}',
	      luminosity: 'precision highp float;\n' +
	        'uniform sampler2D uTexture;\n' +
	        'uniform int uMode;\n' +
	        'varying vec2 vTexCoord;\n' +
	        'void main() {\n' +
	          'vec4 col = texture2D(uTexture, vTexCoord);\n' +
	          'float average = 0.21 * col.r + 0.72 * col.g + 0.07 * col.b;\n' +
	          'gl_FragColor = vec4(average, average, average, col.a);\n' +
	        '}',
	    },


	    /**
	     * Grayscale mode, between 'average', 'lightness', 'luminosity'
	     * @param {String} type
	     * @default
	     */
	    mode: 'average',

	    mainParameter: 'mode',

	    /**
	     * Apply the Grayscale operation to a Uint8Array representing the pixels of an image.
	     *
	     * @param {Object} options
	     * @param {ImageData} options.imageData The Uint8Array to be filtered.
	     */
	    applyTo2d: function(options) {
	      var imageData = options.imageData,
	          data = imageData.data, i,
	          len = data.length, value,
	          mode = this.mode;
	      for (i = 0; i < len; i += 4) {
	        if (mode === 'average') {
	          value = (data[i] + data[i + 1] + data[i + 2]) / 3;
	        }
	        else if (mode === 'lightness') {
	          value = (Math.min(data[i], data[i + 1], data[i + 2]) +
	            Math.max(data[i], data[i + 1], data[i + 2])) / 2;
	        }
	        else if (mode === 'luminosity') {
	          value = 0.21 * data[i] + 0.72 * data[i + 1] + 0.07 * data[i + 2];
	        }
	        data[i] = value;
	        data[i + 1] = value;
	        data[i + 2] = value;
	      }
	    },

	    /**
	     * Retrieves the cached shader.
	     * @param {Object} options
	     * @param {WebGLRenderingContext} options.context The GL context used for rendering.
	     * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
	     */
	    retrieveShader: function(options) {
	      var cacheKey = this.type + '_' + this.mode;
	      if (!options.programCache.hasOwnProperty(cacheKey)) {
	        var shaderSource = this.fragmentSource[this.mode];
	        options.programCache[cacheKey] = this.createProgram(options.context, shaderSource);
	      }
	      return options.programCache[cacheKey];
	    },

	    /**
	     * Return WebGL uniform locations for this filter's shader.
	     *
	     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	     * @param {WebGLShaderProgram} program This filter's compiled shader program.
	     */
	    getUniformLocations: function(gl, program) {
	      return {
	        uMode: gl.getUniformLocation(program, 'uMode'),
	      };
	    },

	    /**
	     * Send data from this filter to its shader program's uniforms.
	     *
	     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
	     */
	    sendUniformData: function(gl, uniformLocations) {
	      // default average mode.
	      var mode = 1;
	      gl.uniform1i(uniformLocations.uMode, mode);
	    },

	    /**
	     * Grayscale filter isNeutralState implementation
	     * The filter is never neutral
	     * on the image
	     **/
	    isNeutralState: function() {
	      return false;
	    },
	  });

	  /**
	   * Returns filter instance from an object representation
	   * @static
	   * @param {Object} object Object to create an instance from
	   * @param {function} [callback] to be invoked after filter creation
	   * @return {fabric.Image.filters.Grayscale} Instance of fabric.Image.filters.Grayscale
	   */
	  fabric.Image.filters.Grayscale.fromObject = fabric.Image.filters.BaseFilter.fromObject;

	})(exports );


	(function(global) {

	  var fabric  = global.fabric || (global.fabric = { }),
	      filters = fabric.Image.filters,
	      createClass = fabric.util.createClass;

	  /**
	   * Invert filter class
	   * @class fabric.Image.filters.Invert
	   * @memberOf fabric.Image.filters
	   * @extends fabric.Image.filters.BaseFilter
	   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
	   * @example
	   * var filter = new fabric.Image.filters.Invert();
	   * object.filters.push(filter);
	   * object.applyFilters(canvas.renderAll.bind(canvas));
	   */
	  filters.Invert = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Invert.prototype */ {

	    /**
	     * Filter type
	     * @param {String} type
	     * @default
	     */
	    type: 'Invert',

	    fragmentSource: 'precision highp float;\n' +
	      'uniform sampler2D uTexture;\n' +
	      'uniform int uInvert;\n' +
	      'varying vec2 vTexCoord;\n' +
	      'void main() {\n' +
	        'vec4 color = texture2D(uTexture, vTexCoord);\n' +
	        'if (uInvert == 1) {\n' +
	          'gl_FragColor = vec4(1.0 - color.r,1.0 -color.g,1.0 -color.b,color.a);\n' +
	        '} else {\n' +
	          'gl_FragColor = color;\n' +
	        '}\n' +
	      '}',

	    /**
	     * Filter invert. if false, does nothing
	     * @param {Boolean} invert
	     * @default
	     */
	    invert: true,

	    mainParameter: 'invert',

	    /**
	     * Apply the Invert operation to a Uint8Array representing the pixels of an image.
	     *
	     * @param {Object} options
	     * @param {ImageData} options.imageData The Uint8Array to be filtered.
	     */
	    applyTo2d: function(options) {
	      var imageData = options.imageData,
	          data = imageData.data, i,
	          len = data.length;
	      for (i = 0; i < len; i += 4) {
	        data[i] = 255 - data[i];
	        data[i + 1] = 255 - data[i + 1];
	        data[i + 2] = 255 - data[i + 2];
	      }
	    },

	    /**
	     * Invert filter isNeutralState implementation
	     * Used only in image applyFilters to discard filters that will not have an effect
	     * on the image
	     * @param {Object} options
	     **/
	    isNeutralState: function() {
	      return !this.invert;
	    },

	    /**
	     * Return WebGL uniform locations for this filter's shader.
	     *
	     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	     * @param {WebGLShaderProgram} program This filter's compiled shader program.
	     */
	    getUniformLocations: function(gl, program) {
	      return {
	        uInvert: gl.getUniformLocation(program, 'uInvert'),
	      };
	    },

	    /**
	     * Send data from this filter to its shader program's uniforms.
	     *
	     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
	     */
	    sendUniformData: function(gl, uniformLocations) {
	      gl.uniform1i(uniformLocations.uInvert, this.invert);
	    },
	  });

	  /**
	   * Returns filter instance from an object representation
	   * @static
	   * @param {Object} object Object to create an instance from
	   * @param {function} [callback] to be invoked after filter creation
	   * @return {fabric.Image.filters.Invert} Instance of fabric.Image.filters.Invert
	   */
	  fabric.Image.filters.Invert.fromObject = fabric.Image.filters.BaseFilter.fromObject;


	})(exports );


	(function(global) {

	  var fabric  = global.fabric || (global.fabric = { }),
	      extend = fabric.util.object.extend,
	      filters = fabric.Image.filters,
	      createClass = fabric.util.createClass;

	  /**
	   * Noise filter class
	   * @class fabric.Image.filters.Noise
	   * @memberOf fabric.Image.filters
	   * @extends fabric.Image.filters.BaseFilter
	   * @see {@link fabric.Image.filters.Noise#initialize} for constructor definition
	   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
	   * @example
	   * var filter = new fabric.Image.filters.Noise({
	   *   noise: 700
	   * });
	   * object.filters.push(filter);
	   * object.applyFilters();
	   * canvas.renderAll();
	   */
	  filters.Noise = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Noise.prototype */ {

	    /**
	     * Filter type
	     * @param {String} type
	     * @default
	     */
	    type: 'Noise',

	    /**
	     * Fragment source for the noise program
	     */
	    fragmentSource: 'precision highp float;\n' +
	      'uniform sampler2D uTexture;\n' +
	      'uniform float uStepH;\n' +
	      'uniform float uNoise;\n' +
	      'uniform float uSeed;\n' +
	      'varying vec2 vTexCoord;\n' +
	      'float rand(vec2 co, float seed, float vScale) {\n' +
	        'return fract(sin(dot(co.xy * vScale ,vec2(12.9898 , 78.233))) * 43758.5453 * (seed + 0.01) / 2.0);\n' +
	      '}\n' +
	      'void main() {\n' +
	        'vec4 color = texture2D(uTexture, vTexCoord);\n' +
	        'color.rgb += (0.5 - rand(vTexCoord, uSeed, 0.1 / uStepH)) * uNoise;\n' +
	        'gl_FragColor = color;\n' +
	      '}',

	    /**
	     * Describe the property that is the filter parameter
	     * @param {String} m
	     * @default
	     */
	    mainParameter: 'noise',

	    /**
	     * Noise value, from
	     * @param {Number} noise
	     * @default
	     */
	    noise: 0,

	    /**
	     * Apply the Brightness operation to a Uint8ClampedArray representing the pixels of an image.
	     *
	     * @param {Object} options
	     * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
	     */
	    applyTo2d: function(options) {
	      if (this.noise === 0) {
	        return;
	      }
	      var imageData = options.imageData,
	          data = imageData.data, i, len = data.length,
	          noise = this.noise, rand;

	      for (i = 0, len = data.length; i < len; i += 4) {

	        rand = (0.5 - Math.random()) * noise;

	        data[i] += rand;
	        data[i + 1] += rand;
	        data[i + 2] += rand;
	      }
	    },

	    /**
	     * Return WebGL uniform locations for this filter's shader.
	     *
	     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	     * @param {WebGLShaderProgram} program This filter's compiled shader program.
	     */
	    getUniformLocations: function(gl, program) {
	      return {
	        uNoise: gl.getUniformLocation(program, 'uNoise'),
	        uSeed: gl.getUniformLocation(program, 'uSeed'),
	      };
	    },

	    /**
	     * Send data from this filter to its shader program's uniforms.
	     *
	     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
	     */
	    sendUniformData: function(gl, uniformLocations) {
	      gl.uniform1f(uniformLocations.uNoise, this.noise / 255);
	      gl.uniform1f(uniformLocations.uSeed, Math.random());
	    },

	    /**
	     * Returns object representation of an instance
	     * @return {Object} Object representation of an instance
	     */
	    toObject: function() {
	      return extend(this.callSuper('toObject'), {
	        noise: this.noise
	      });
	    }
	  });

	  /**
	   * Returns filter instance from an object representation
	   * @static
	   * @param {Object} object Object to create an instance from
	   * @param {Function} [callback] to be invoked after filter creation
	   * @return {fabric.Image.filters.Noise} Instance of fabric.Image.filters.Noise
	   */
	  fabric.Image.filters.Noise.fromObject = fabric.Image.filters.BaseFilter.fromObject;

	})(exports );


	(function(global) {

	  var fabric  = global.fabric || (global.fabric = { }),
	      filters = fabric.Image.filters,
	      createClass = fabric.util.createClass;

	  /**
	   * Pixelate filter class
	   * @class fabric.Image.filters.Pixelate
	   * @memberOf fabric.Image.filters
	   * @extends fabric.Image.filters.BaseFilter
	   * @see {@link fabric.Image.filters.Pixelate#initialize} for constructor definition
	   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
	   * @example
	   * var filter = new fabric.Image.filters.Pixelate({
	   *   blocksize: 8
	   * });
	   * object.filters.push(filter);
	   * object.applyFilters();
	   */
	  filters.Pixelate = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Pixelate.prototype */ {

	    /**
	     * Filter type
	     * @param {String} type
	     * @default
	     */
	    type: 'Pixelate',

	    blocksize: 4,

	    mainParameter: 'blocksize',

	    /**
	     * Fragment source for the Pixelate program
	     */
	    fragmentSource: 'precision highp float;\n' +
	      'uniform sampler2D uTexture;\n' +
	      'uniform float uBlocksize;\n' +
	      'uniform float uStepW;\n' +
	      'uniform float uStepH;\n' +
	      'varying vec2 vTexCoord;\n' +
	      'void main() {\n' +
	        'float blockW = uBlocksize * uStepW;\n' +
	        'float blockH = uBlocksize * uStepW;\n' +
	        'int posX = int(vTexCoord.x / blockW);\n' +
	        'int posY = int(vTexCoord.y / blockH);\n' +
	        'float fposX = float(posX);\n' +
	        'float fposY = float(posY);\n' +
	        'vec2 squareCoords = vec2(fposX * blockW, fposY * blockH);\n' +
	        'vec4 color = texture2D(uTexture, squareCoords);\n' +
	        'gl_FragColor = color;\n' +
	      '}',

	    /**
	     * Apply the Pixelate operation to a Uint8ClampedArray representing the pixels of an image.
	     *
	     * @param {Object} options
	     * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
	     */
	    applyTo2d: function(options) {
	      var imageData = options.imageData,
	          data = imageData.data,
	          iLen = imageData.height,
	          jLen = imageData.width,
	          index, i, j, r, g, b, a,
	          _i, _j, _iLen, _jLen;

	      for (i = 0; i < iLen; i += this.blocksize) {
	        for (j = 0; j < jLen; j += this.blocksize) {

	          index = (i * 4) * jLen + (j * 4);

	          r = data[index];
	          g = data[index + 1];
	          b = data[index + 2];
	          a = data[index + 3];

	          _iLen = Math.min(i + this.blocksize, iLen);
	          _jLen = Math.min(j + this.blocksize, jLen);
	          for (_i = i; _i < _iLen; _i++) {
	            for (_j = j; _j < _jLen; _j++) {
	              index = (_i * 4) * jLen + (_j * 4);
	              data[index] = r;
	              data[index + 1] = g;
	              data[index + 2] = b;
	              data[index + 3] = a;
	            }
	          }
	        }
	      }
	    },

	    /**
	     * Indicate when the filter is not gonna apply changes to the image
	     **/
	    isNeutralState: function() {
	      return this.blocksize === 1;
	    },

	    /**
	     * Return WebGL uniform locations for this filter's shader.
	     *
	     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	     * @param {WebGLShaderProgram} program This filter's compiled shader program.
	     */
	    getUniformLocations: function(gl, program) {
	      return {
	        uBlocksize: gl.getUniformLocation(program, 'uBlocksize'),
	        uStepW: gl.getUniformLocation(program, 'uStepW'),
	        uStepH: gl.getUniformLocation(program, 'uStepH'),
	      };
	    },

	    /**
	     * Send data from this filter to its shader program's uniforms.
	     *
	     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
	     */
	    sendUniformData: function(gl, uniformLocations) {
	      gl.uniform1f(uniformLocations.uBlocksize, this.blocksize);
	    },
	  });

	  /**
	   * Returns filter instance from an object representation
	   * @static
	   * @param {Object} object Object to create an instance from
	   * @param {Function} [callback] to be invoked after filter creation
	   * @return {fabric.Image.filters.Pixelate} Instance of fabric.Image.filters.Pixelate
	   */
	  fabric.Image.filters.Pixelate.fromObject = fabric.Image.filters.BaseFilter.fromObject;

	})(exports );


	(function(global) {

	  var fabric  = global.fabric || (global.fabric = { }),
	      extend = fabric.util.object.extend,
	      filters = fabric.Image.filters,
	      createClass = fabric.util.createClass;

	  /**
	   * Remove white filter class
	   * @class fabric.Image.filters.RemoveColor
	   * @memberOf fabric.Image.filters
	   * @extends fabric.Image.filters.BaseFilter
	   * @see {@link fabric.Image.filters.RemoveColor#initialize} for constructor definition
	   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
	   * @example
	   * var filter = new fabric.Image.filters.RemoveColor({
	   *   threshold: 0.2,
	   * });
	   * object.filters.push(filter);
	   * object.applyFilters();
	   * canvas.renderAll();
	   */
	  filters.RemoveColor = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.RemoveColor.prototype */ {

	    /**
	     * Filter type
	     * @param {String} type
	     * @default
	     */
	    type: 'RemoveColor',

	    /**
	     * Color to remove, in any format understood by fabric.Color.
	     * @param {String} type
	     * @default
	     */
	    color: '#FFFFFF',

	    /**
	     * Fragment source for the brightness program
	     */
	    fragmentSource: 'precision highp float;\n' +
	      'uniform sampler2D uTexture;\n' +
	      'uniform vec4 uLow;\n' +
	      'uniform vec4 uHigh;\n' +
	      'varying vec2 vTexCoord;\n' +
	      'void main() {\n' +
	        'gl_FragColor = texture2D(uTexture, vTexCoord);\n' +
	        'if(all(greaterThan(gl_FragColor.rgb,uLow.rgb)) && all(greaterThan(uHigh.rgb,gl_FragColor.rgb))) {\n' +
	          'gl_FragColor.a = 0.0;\n' +
	        '}\n' +
	      '}',

	    /**
	     * distance to actual color, as value up or down from each r,g,b
	     * between 0 and 1
	     **/
	    distance: 0.02,

	    /**
	     * For color to remove inside distance, use alpha channel for a smoother deletion
	     * NOT IMPLEMENTED YET
	     **/
	    useAlpha: false,

	    /**
	     * Constructor
	     * @memberOf fabric.Image.filters.RemoveWhite.prototype
	     * @param {Object} [options] Options object
	     * @param {Number} [options.color=#RRGGBB] Threshold value
	     * @param {Number} [options.distance=10] Distance value
	     */

	    /**
	     * Applies filter to canvas element
	     * @param {Object} canvasEl Canvas element to apply filter to
	     */
	    applyTo2d: function(options) {
	      var imageData = options.imageData,
	          data = imageData.data, i,
	          distance = this.distance * 255,
	          r, g, b,
	          source = new fabric.Color(this.color).getSource(),
	          lowC = [
	            source[0] - distance,
	            source[1] - distance,
	            source[2] - distance,
	          ],
	          highC = [
	            source[0] + distance,
	            source[1] + distance,
	            source[2] + distance,
	          ];


	      for (i = 0; i < data.length; i += 4) {
	        r = data[i];
	        g = data[i + 1];
	        b = data[i + 2];

	        if (r > lowC[0] &&
	            g > lowC[1] &&
	            b > lowC[2] &&
	            r < highC[0] &&
	            g < highC[1] &&
	            b < highC[2]) {
	          data[i + 3] = 0;
	        }
	      }
	    },

	    /**
	     * Return WebGL uniform locations for this filter's shader.
	     *
	     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	     * @param {WebGLShaderProgram} program This filter's compiled shader program.
	     */
	    getUniformLocations: function(gl, program) {
	      return {
	        uLow: gl.getUniformLocation(program, 'uLow'),
	        uHigh: gl.getUniformLocation(program, 'uHigh'),
	      };
	    },

	    /**
	     * Send data from this filter to its shader program's uniforms.
	     *
	     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
	     */
	    sendUniformData: function(gl, uniformLocations) {
	      var source = new fabric.Color(this.color).getSource(),
	          distance = parseFloat(this.distance),
	          lowC = [
	            0 + source[0] / 255 - distance,
	            0 + source[1] / 255 - distance,
	            0 + source[2] / 255 - distance,
	            1
	          ],
	          highC = [
	            source[0] / 255 + distance,
	            source[1] / 255 + distance,
	            source[2] / 255 + distance,
	            1
	          ];
	      gl.uniform4fv(uniformLocations.uLow, lowC);
	      gl.uniform4fv(uniformLocations.uHigh, highC);
	    },

	    /**
	     * Returns object representation of an instance
	     * @return {Object} Object representation of an instance
	     */
	    toObject: function() {
	      return extend(this.callSuper('toObject'), {
	        color: this.color,
	        distance: this.distance
	      });
	    }
	  });

	  /**
	   * Returns filter instance from an object representation
	   * @static
	   * @param {Object} object Object to create an instance from
	   * @param {Function} [callback] to be invoked after filter creation
	   * @return {fabric.Image.filters.RemoveColor} Instance of fabric.Image.filters.RemoveWhite
	   */
	  fabric.Image.filters.RemoveColor.fromObject = fabric.Image.filters.BaseFilter.fromObject;

	})(exports );


	(function(global) {

	  var fabric  = global.fabric || (global.fabric = { }),
	      filters = fabric.Image.filters,
	      createClass = fabric.util.createClass;

	  var matrices = {
	    Brownie: [
	      0.59970,0.34553,-0.27082,0,0.186,
	      -0.03770,0.86095,0.15059,0,-0.1449,
	      0.24113,-0.07441,0.44972,0,-0.02965,
	      0,0,0,1,0
	    ],
	    Vintage: [
	      0.62793,0.32021,-0.03965,0,0.03784,
	      0.02578,0.64411,0.03259,0,0.02926,
	      0.04660,-0.08512,0.52416,0,0.02023,
	      0,0,0,1,0
	    ],
	    Kodachrome: [
	      1.12855,-0.39673,-0.03992,0,0.24991,
	      -0.16404,1.08352,-0.05498,0,0.09698,
	      -0.16786,-0.56034,1.60148,0,0.13972,
	      0,0,0,1,0
	    ],
	    Technicolor: [
	      1.91252,-0.85453,-0.09155,0,0.04624,
	      -0.30878,1.76589,-0.10601,0,-0.27589,
	      -0.23110,-0.75018,1.84759,0,0.12137,
	      0,0,0,1,0
	    ],
	    Polaroid: [
	      1.438,-0.062,-0.062,0,0,
	      -0.122,1.378,-0.122,0,0,
	      -0.016,-0.016,1.483,0,0,
	      0,0,0,1,0
	    ],
	    Sepia: [
	      0.393, 0.769, 0.189, 0, 0,
	      0.349, 0.686, 0.168, 0, 0,
	      0.272, 0.534, 0.131, 0, 0,
	      0, 0, 0, 1, 0
	    ],
	    BlackWhite: [
	      1.5, 1.5, 1.5, 0, -1,
	      1.5, 1.5, 1.5, 0, -1,
	      1.5, 1.5, 1.5, 0, -1,
	      0, 0, 0, 1, 0,
	    ]
	  };

	  for (var key in matrices) {
	    filters[key] = createClass(filters.ColorMatrix, /** @lends fabric.Image.filters.Sepia.prototype */ {

	      /**
	       * Filter type
	       * @param {String} type
	       * @default
	       */
	      type: key,

	      /**
	       * Colormatrix for the effect
	       * array of 20 floats. Numbers in positions 4, 9, 14, 19 loose meaning
	       * outside the -1, 1 range.
	       * @param {Array} matrix array of 20 numbers.
	       * @default
	       */
	      matrix: matrices[key],

	      /**
	       * Lock the matrix export for this kind of static, parameter less filters.
	       */
	      mainParameter: false,
	      /**
	       * Lock the colormatrix on the color part, skipping alpha
	       */
	      colorsOnly: true,

	    });
	    fabric.Image.filters[key].fromObject = fabric.Image.filters.BaseFilter.fromObject;
	  }
	})(exports );


	(function(global) {

	  var fabric = global.fabric,
	      filters = fabric.Image.filters,
	      createClass = fabric.util.createClass;

	  /**
	   * Color Blend filter class
	   * @class fabric.Image.filter.BlendColor
	   * @memberOf fabric.Image.filters
	   * @extends fabric.Image.filters.BaseFilter
	   * @example
	   * var filter = new fabric.Image.filters.BlendColor({
	   *  color: '#000',
	   *  mode: 'multiply'
	   * });
	   *
	   * var filter = new fabric.Image.filters.BlendImage({
	   *  image: fabricImageObject,
	   *  mode: 'multiply',
	   *  alpha: 0.5
	   * });
	   * object.filters.push(filter);
	   * object.applyFilters();
	   * canvas.renderAll();
	   */

	  filters.BlendColor = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Blend.prototype */ {
	    type: 'BlendColor',

	    /**
	     * Color to make the blend operation with. default to a reddish color since black or white
	     * gives always strong result.
	     **/
	    color: '#F95C63',

	    /**
	     * Blend mode for the filter: one of multiply, add, diff, screen, subtract,
	     * darken, lighten, overlay, exclusion, tint.
	     **/
	    mode: 'multiply',

	    /**
	     * alpha value. represent the strength of the blend color operation.
	     **/
	    alpha: 1,

	    /**
	     * Fragment source for the Multiply program
	     */
	    fragmentSource: {
	      multiply: 'gl_FragColor.rgb *= uColor.rgb;\n',
	      screen: 'gl_FragColor.rgb = 1.0 - (1.0 - gl_FragColor.rgb) * (1.0 - uColor.rgb);\n',
	      add: 'gl_FragColor.rgb += uColor.rgb;\n',
	      diff: 'gl_FragColor.rgb = abs(gl_FragColor.rgb - uColor.rgb);\n',
	      subtract: 'gl_FragColor.rgb -= uColor.rgb;\n',
	      lighten: 'gl_FragColor.rgb = max(gl_FragColor.rgb, uColor.rgb);\n',
	      darken: 'gl_FragColor.rgb = min(gl_FragColor.rgb, uColor.rgb);\n',
	      exclusion: 'gl_FragColor.rgb += uColor.rgb - 2.0 * (uColor.rgb * gl_FragColor.rgb);\n',
	      overlay: 'if (uColor.r < 0.5) {\n' +
	          'gl_FragColor.r *= 2.0 * uColor.r;\n' +
	        '} else {\n' +
	          'gl_FragColor.r = 1.0 - 2.0 * (1.0 - gl_FragColor.r) * (1.0 - uColor.r);\n' +
	        '}\n' +
	        'if (uColor.g < 0.5) {\n' +
	          'gl_FragColor.g *= 2.0 * uColor.g;\n' +
	        '} else {\n' +
	          'gl_FragColor.g = 1.0 - 2.0 * (1.0 - gl_FragColor.g) * (1.0 - uColor.g);\n' +
	        '}\n' +
	        'if (uColor.b < 0.5) {\n' +
	          'gl_FragColor.b *= 2.0 * uColor.b;\n' +
	        '} else {\n' +
	          'gl_FragColor.b = 1.0 - 2.0 * (1.0 - gl_FragColor.b) * (1.0 - uColor.b);\n' +
	        '}\n',
	      tint: 'gl_FragColor.rgb *= (1.0 - uColor.a);\n' +
	        'gl_FragColor.rgb += uColor.rgb;\n',
	    },

	    /**
	     * build the fragment source for the filters, joining the common part with
	     * the specific one.
	     * @param {String} mode the mode of the filter, a key of this.fragmentSource
	     * @return {String} the source to be compiled
	     * @private
	     */
	    buildSource: function(mode) {
	      return 'precision highp float;\n' +
	        'uniform sampler2D uTexture;\n' +
	        'uniform vec4 uColor;\n' +
	        'varying vec2 vTexCoord;\n' +
	        'void main() {\n' +
	          'vec4 color = texture2D(uTexture, vTexCoord);\n' +
	          'gl_FragColor = color;\n' +
	          'if (color.a > 0.0) {\n' +
	            this.fragmentSource[mode] +
	          '}\n' +
	        '}';
	    },

	    /**
	     * Retrieves the cached shader.
	     * @param {Object} options
	     * @param {WebGLRenderingContext} options.context The GL context used for rendering.
	     * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
	     */
	    retrieveShader: function(options) {
	      var cacheKey = this.type + '_' + this.mode, shaderSource;
	      if (!options.programCache.hasOwnProperty(cacheKey)) {
	        shaderSource = this.buildSource(this.mode);
	        options.programCache[cacheKey] = this.createProgram(options.context, shaderSource);
	      }
	      return options.programCache[cacheKey];
	    },

	    /**
	     * Apply the Blend operation to a Uint8ClampedArray representing the pixels of an image.
	     *
	     * @param {Object} options
	     * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
	     */
	    applyTo2d: function(options) {
	      var imageData = options.imageData,
	          data = imageData.data, iLen = data.length,
	          tr, tg, tb,
	          r, g, b,
	          source, alpha1 = 1 - this.alpha;

	      source = new fabric.Color(this.color).getSource();
	      tr = source[0] * this.alpha;
	      tg = source[1] * this.alpha;
	      tb = source[2] * this.alpha;

	      for (var i = 0; i < iLen; i += 4) {

	        r = data[i];
	        g = data[i + 1];
	        b = data[i + 2];

	        switch (this.mode) {
	          case 'multiply':
	            data[i] = r * tr / 255;
	            data[i + 1] = g * tg / 255;
	            data[i + 2] = b * tb / 255;
	            break;
	          case 'screen':
	            data[i] = 255 - (255 - r) * (255 - tr) / 255;
	            data[i + 1] = 255 - (255 - g) * (255 - tg) / 255;
	            data[i + 2] = 255 - (255 - b) * (255 - tb) / 255;
	            break;
	          case 'add':
	            data[i] = r + tr;
	            data[i + 1] = g + tg;
	            data[i + 2] = b + tb;
	            break;
	          case 'diff':
	          case 'difference':
	            data[i] = Math.abs(r - tr);
	            data[i + 1] = Math.abs(g - tg);
	            data[i + 2] = Math.abs(b - tb);
	            break;
	          case 'subtract':
	            data[i] = r - tr;
	            data[i + 1] = g - tg;
	            data[i + 2] = b - tb;
	            break;
	          case 'darken':
	            data[i] = Math.min(r, tr);
	            data[i + 1] = Math.min(g, tg);
	            data[i + 2] = Math.min(b, tb);
	            break;
	          case 'lighten':
	            data[i] = Math.max(r, tr);
	            data[i + 1] = Math.max(g, tg);
	            data[i + 2] = Math.max(b, tb);
	            break;
	          case 'overlay':
	            data[i] = tr < 128 ? (2 * r * tr / 255) : (255 - 2 * (255 - r) * (255 - tr) / 255);
	            data[i + 1] = tg < 128 ? (2 * g * tg / 255) : (255 - 2 * (255 - g) * (255 - tg) / 255);
	            data[i + 2] = tb < 128 ? (2 * b * tb / 255) : (255 - 2 * (255 - b) * (255 - tb) / 255);
	            break;
	          case 'exclusion':
	            data[i] = tr + r - ((2 * tr * r) / 255);
	            data[i + 1] = tg + g - ((2 * tg * g) / 255);
	            data[i + 2] = tb + b - ((2 * tb * b) / 255);
	            break;
	          case 'tint':
	            data[i] = tr + r * alpha1;
	            data[i + 1] = tg + g * alpha1;
	            data[i + 2] = tb + b * alpha1;
	        }
	      }
	    },

	    /**
	     * Return WebGL uniform locations for this filter's shader.
	     *
	     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	     * @param {WebGLShaderProgram} program This filter's compiled shader program.
	     */
	    getUniformLocations: function(gl, program) {
	      return {
	        uColor: gl.getUniformLocation(program, 'uColor'),
	      };
	    },

	    /**
	     * Send data from this filter to its shader program's uniforms.
	     *
	     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
	     */
	    sendUniformData: function(gl, uniformLocations) {
	      var source = new fabric.Color(this.color).getSource();
	      source[0] = this.alpha * source[0] / 255;
	      source[1] = this.alpha * source[1] / 255;
	      source[2] = this.alpha * source[2] / 255;
	      source[3] = this.alpha;
	      gl.uniform4fv(uniformLocations.uColor, source);
	    },

	    /**
	     * Returns object representation of an instance
	     * @return {Object} Object representation of an instance
	     */
	    toObject: function() {
	      return {
	        type: this.type,
	        color: this.color,
	        mode: this.mode,
	        alpha: this.alpha
	      };
	    }
	  });

	  /**
	   * Returns filter instance from an object representation
	   * @static
	   * @param {Object} object Object to create an instance from
	   * @param {function} [callback] to be invoked after filter creation
	   * @return {fabric.Image.filters.BlendColor} Instance of fabric.Image.filters.BlendColor
	   */
	  fabric.Image.filters.BlendColor.fromObject = fabric.Image.filters.BaseFilter.fromObject;

	})(exports );


	(function(global) {

	  var fabric = global.fabric,
	      filters = fabric.Image.filters,
	      createClass = fabric.util.createClass;

	  /**
	   * Image Blend filter class
	   * @class fabric.Image.filter.BlendImage
	   * @memberOf fabric.Image.filters
	   * @extends fabric.Image.filters.BaseFilter
	   * @example
	   * var filter = new fabric.Image.filters.BlendColor({
	   *  color: '#000',
	   *  mode: 'multiply'
	   * });
	   *
	   * var filter = new fabric.Image.filters.BlendImage({
	   *  image: fabricImageObject,
	   *  mode: 'multiply',
	   *  alpha: 0.5
	   * });
	   * object.filters.push(filter);
	   * object.applyFilters();
	   * canvas.renderAll();
	   */

	  filters.BlendImage = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.BlendImage.prototype */ {
	    type: 'BlendImage',

	    /**
	     * Color to make the blend operation with. default to a reddish color since black or white
	     * gives always strong result.
	     **/
	    image: null,

	    /**
	     * Blend mode for the filter: one of multiply, add, diff, screen, subtract,
	     * darken, lighten, overlay, exclusion, tint.
	     **/
	    mode: 'multiply',

	    /**
	     * alpha value. represent the strength of the blend image operation.
	     * not implemented.
	     **/
	    alpha: 1,

	    vertexSource: 'attribute vec2 aPosition;\n' +
	      'varying vec2 vTexCoord;\n' +
	      'varying vec2 vTexCoord2;\n' +
	      'uniform mat3 uTransformMatrix;\n' +
	      'void main() {\n' +
	        'vTexCoord = aPosition;\n' +
	        'vTexCoord2 = (uTransformMatrix * vec3(aPosition, 1.0)).xy;\n' +
	        'gl_Position = vec4(aPosition * 2.0 - 1.0, 0.0, 1.0);\n' +
	      '}',

	    /**
	     * Fragment source for the Multiply program
	     */
	    fragmentSource: {
	      multiply: 'precision highp float;\n' +
	        'uniform sampler2D uTexture;\n' +
	        'uniform sampler2D uImage;\n' +
	        'uniform vec4 uColor;\n' +
	        'varying vec2 vTexCoord;\n' +
	        'varying vec2 vTexCoord2;\n' +
	        'void main() {\n' +
	          'vec4 color = texture2D(uTexture, vTexCoord);\n' +
	          'vec4 color2 = texture2D(uImage, vTexCoord2);\n' +
	          'color.rgba *= color2.rgba;\n' +
	          'gl_FragColor = color;\n' +
	        '}',
	      mask: 'precision highp float;\n' +
	        'uniform sampler2D uTexture;\n' +
	        'uniform sampler2D uImage;\n' +
	        'uniform vec4 uColor;\n' +
	        'varying vec2 vTexCoord;\n' +
	        'varying vec2 vTexCoord2;\n' +
	        'void main() {\n' +
	          'vec4 color = texture2D(uTexture, vTexCoord);\n' +
	          'vec4 color2 = texture2D(uImage, vTexCoord2);\n' +
	          'color.a = color2.a;\n' +
	          'gl_FragColor = color;\n' +
	        '}',
	    },

	    /**
	     * Retrieves the cached shader.
	     * @param {Object} options
	     * @param {WebGLRenderingContext} options.context The GL context used for rendering.
	     * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
	     */
	    retrieveShader: function(options) {
	      var cacheKey = this.type + '_' + this.mode;
	      var shaderSource = this.fragmentSource[this.mode];
	      if (!options.programCache.hasOwnProperty(cacheKey)) {
	        options.programCache[cacheKey] = this.createProgram(options.context, shaderSource);
	      }
	      return options.programCache[cacheKey];
	    },

	    applyToWebGL: function(options) {
	      // load texture to blend.
	      var gl = options.context,
	          texture = this.createTexture(options.filterBackend, this.image);
	      this.bindAdditionalTexture(gl, texture, gl.TEXTURE1);
	      this.callSuper('applyToWebGL', options);
	      this.unbindAdditionalTexture(gl, gl.TEXTURE1);
	    },

	    createTexture: function(backend, image) {
	      return backend.getCachedTexture(image.cacheKey, image._element);
	    },

	    /**
	     * Calculate a transformMatrix to adapt the image to blend over
	     * @param {Object} options
	     * @param {WebGLRenderingContext} options.context The GL context used for rendering.
	     * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
	     */
	    calculateMatrix: function() {
	      var image = this.image,
	          width = image._element.width,
	          height = image._element.height;
	      return [
	        1 / image.scaleX, 0, 0,
	        0, 1 / image.scaleY, 0,
	        -image.left / width, -image.top / height, 1
	      ];
	    },

	    /**
	     * Apply the Blend operation to a Uint8ClampedArray representing the pixels of an image.
	     *
	     * @param {Object} options
	     * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
	     */
	    applyTo2d: function(options) {
	      var imageData = options.imageData,
	          resources = options.filterBackend.resources,
	          data = imageData.data, iLen = data.length,
	          width = imageData.width,
	          height = imageData.height,
	          tr, tg, tb, ta,
	          r, g, b, a,
	          canvas1, context, image = this.image, blendData;

	      if (!resources.blendImage) {
	        resources.blendImage = fabric.util.createCanvasElement();
	      }
	      canvas1 = resources.blendImage;
	      context = canvas1.getContext('2d');
	      if (canvas1.width !== width || canvas1.height !== height) {
	        canvas1.width = width;
	        canvas1.height = height;
	      }
	      else {
	        context.clearRect(0, 0, width, height);
	      }
	      context.setTransform(image.scaleX, 0, 0, image.scaleY, image.left, image.top);
	      context.drawImage(image._element, 0, 0, width, height);
	      blendData = context.getImageData(0, 0, width, height).data;
	      for (var i = 0; i < iLen; i += 4) {

	        r = data[i];
	        g = data[i + 1];
	        b = data[i + 2];
	        a = data[i + 3];

	        tr = blendData[i];
	        tg = blendData[i + 1];
	        tb = blendData[i + 2];
	        ta = blendData[i + 3];

	        switch (this.mode) {
	          case 'multiply':
	            data[i] = r * tr / 255;
	            data[i + 1] = g * tg / 255;
	            data[i + 2] = b * tb / 255;
	            data[i + 3] = a * ta / 255;
	            break;
	          case 'mask':
	            data[i + 3] = ta;
	            break;
	        }
	      }
	    },

	    /**
	     * Return WebGL uniform locations for this filter's shader.
	     *
	     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	     * @param {WebGLShaderProgram} program This filter's compiled shader program.
	     */
	    getUniformLocations: function(gl, program) {
	      return {
	        uTransformMatrix: gl.getUniformLocation(program, 'uTransformMatrix'),
	        uImage: gl.getUniformLocation(program, 'uImage'),
	      };
	    },

	    /**
	     * Send data from this filter to its shader program's uniforms.
	     *
	     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
	     */
	    sendUniformData: function(gl, uniformLocations) {
	      var matrix = this.calculateMatrix();
	      gl.uniform1i(uniformLocations.uImage, 1); // texture unit 1.
	      gl.uniformMatrix3fv(uniformLocations.uTransformMatrix, false, matrix);
	    },

	    /**
	     * Returns object representation of an instance
	     * @return {Object} Object representation of an instance
	     */
	    toObject: function() {
	      return {
	        type: this.type,
	        image: this.image && this.image.toObject(),
	        mode: this.mode,
	        alpha: this.alpha
	      };
	    }
	  });

	  /**
	   * Returns filter instance from an object representation
	   * @static
	   * @param {Object} object Object to create an instance from
	   * @param {function} callback to be invoked after filter creation
	   * @return {fabric.Image.filters.BlendImage} Instance of fabric.Image.filters.BlendImage
	   */
	  fabric.Image.filters.BlendImage.fromObject = function(object, callback) {
	    fabric.Image.fromObject(object.image, function(image) {
	      var options = fabric.util.object.clone(object);
	      options.image = image;
	      callback(new fabric.Image.filters.BlendImage(options));
	    });
	  };

	})(exports );


	(function(global) {

	  var fabric  = global.fabric || (global.fabric = { }), pow = Math.pow, floor = Math.floor,
	      sqrt = Math.sqrt, abs = Math.abs, round = Math.round, sin = Math.sin,
	      ceil = Math.ceil,
	      filters = fabric.Image.filters,
	      createClass = fabric.util.createClass;

	  /**
	   * Resize image filter class
	   * @class fabric.Image.filters.Resize
	   * @memberOf fabric.Image.filters
	   * @extends fabric.Image.filters.BaseFilter
	   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
	   * @example
	   * var filter = new fabric.Image.filters.Resize();
	   * object.filters.push(filter);
	   * object.applyFilters(canvas.renderAll.bind(canvas));
	   */
	  filters.Resize = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Resize.prototype */ {

	    /**
	     * Filter type
	     * @param {String} type
	     * @default
	     */
	    type: 'Resize',

	    /**
	     * Resize type
	     * for webgl resizeType is just lanczos, for canvas2d can be:
	     * bilinear, hermite, sliceHack, lanczos.
	     * @param {String} resizeType
	     * @default
	     */
	    resizeType: 'hermite',

	    /**
	     * Scale factor for resizing, x axis
	     * @param {Number} scaleX
	     * @default
	     */
	    scaleX: 1,

	    /**
	     * Scale factor for resizing, y axis
	     * @param {Number} scaleY
	     * @default
	     */
	    scaleY: 1,

	    /**
	     * LanczosLobes parameter for lanczos filter, valid for resizeType lanczos
	     * @param {Number} lanczosLobes
	     * @default
	     */
	    lanczosLobes: 3,


	    /**
	     * Return WebGL uniform locations for this filter's shader.
	     *
	     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	     * @param {WebGLShaderProgram} program This filter's compiled shader program.
	     */
	    getUniformLocations: function(gl, program) {
	      return {
	        uDelta: gl.getUniformLocation(program, 'uDelta'),
	        uTaps: gl.getUniformLocation(program, 'uTaps'),
	      };
	    },

	    /**
	     * Send data from this filter to its shader program's uniforms.
	     *
	     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
	     */
	    sendUniformData: function(gl, uniformLocations) {
	      gl.uniform2fv(uniformLocations.uDelta, this.horizontal ? [1 / this.width, 0] : [0, 1 / this.height]);
	      gl.uniform1fv(uniformLocations.uTaps, this.taps);
	    },

	    /**
	     * Retrieves the cached shader.
	     * @param {Object} options
	     * @param {WebGLRenderingContext} options.context The GL context used for rendering.
	     * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
	     */
	    retrieveShader: function(options) {
	      var filterWindow = this.getFilterWindow(), cacheKey = this.type + '_' + filterWindow;
	      if (!options.programCache.hasOwnProperty(cacheKey)) {
	        var fragmentShader = this.generateShader(filterWindow);
	        options.programCache[cacheKey] = this.createProgram(options.context, fragmentShader);
	      }
	      return options.programCache[cacheKey];
	    },

	    getFilterWindow: function() {
	      var scale = this.tempScale;
	      return Math.ceil(this.lanczosLobes / scale);
	    },

	    getTaps: function() {
	      var lobeFunction = this.lanczosCreate(this.lanczosLobes), scale = this.tempScale,
	          filterWindow = this.getFilterWindow(), taps = new Array(filterWindow);
	      for (var i = 1; i <= filterWindow; i++) {
	        taps[i - 1] = lobeFunction(i * scale);
	      }
	      return taps;
	    },

	    /**
	     * Generate vertex and shader sources from the necessary steps numbers
	     * @param {Number} filterWindow
	     */
	    generateShader: function(filterWindow) {
	      var offsets = new Array(filterWindow),
	          fragmentShader = this.fragmentSourceTOP, filterWindow;

	      for (var i = 1; i <= filterWindow; i++) {
	        offsets[i - 1] = i + '.0 * uDelta';
	      }

	      fragmentShader += 'uniform float uTaps[' + filterWindow + '];\n';
	      fragmentShader += 'void main() {\n';
	      fragmentShader += '  vec4 color = texture2D(uTexture, vTexCoord);\n';
	      fragmentShader += '  float sum = 1.0;\n';

	      offsets.forEach(function(offset, i) {
	        fragmentShader += '  color += texture2D(uTexture, vTexCoord + ' + offset + ') * uTaps[' + i + '];\n';
	        fragmentShader += '  color += texture2D(uTexture, vTexCoord - ' + offset + ') * uTaps[' + i + '];\n';
	        fragmentShader += '  sum += 2.0 * uTaps[' + i + '];\n';
	      });
	      fragmentShader += '  gl_FragColor = color / sum;\n';
	      fragmentShader += '}';
	      return fragmentShader;
	    },

	    fragmentSourceTOP: 'precision highp float;\n' +
	      'uniform sampler2D uTexture;\n' +
	      'uniform vec2 uDelta;\n' +
	      'varying vec2 vTexCoord;\n',

	    /**
	     * Apply the resize filter to the image
	     * Determines whether to use WebGL or Canvas2D based on the options.webgl flag.
	     *
	     * @param {Object} options
	     * @param {Number} options.passes The number of filters remaining to be executed
	     * @param {Boolean} options.webgl Whether to use webgl to render the filter.
	     * @param {WebGLTexture} options.sourceTexture The texture setup as the source to be filtered.
	     * @param {WebGLTexture} options.targetTexture The texture where filtered output should be drawn.
	     * @param {WebGLRenderingContext} options.context The GL context used for rendering.
	     * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
	     */
	    applyTo: function(options) {
	      if (options.webgl) {
	        options.passes++;
	        this.width = options.sourceWidth;
	        this.horizontal = true;
	        this.dW = Math.round(this.width * this.scaleX);
	        this.dH = options.sourceHeight;
	        this.tempScale = this.dW / this.width;
	        this.taps = this.getTaps();
	        options.destinationWidth = this.dW;
	        this._setupFrameBuffer(options);
	        this.applyToWebGL(options);
	        this._swapTextures(options);
	        options.sourceWidth = options.destinationWidth;

	        this.height = options.sourceHeight;
	        this.horizontal = false;
	        this.dH = Math.round(this.height * this.scaleY);
	        this.tempScale = this.dH / this.height;
	        this.taps = this.getTaps();
	        options.destinationHeight = this.dH;
	        this._setupFrameBuffer(options);
	        this.applyToWebGL(options);
	        this._swapTextures(options);
	        options.sourceHeight = options.destinationHeight;
	      }
	      else {
	        this.applyTo2d(options);
	      }
	    },

	    isNeutralState: function() {
	      return this.scaleX === 1 && this.scaleY === 1;
	    },

	    lanczosCreate: function(lobes) {
	      return function(x) {
	        if (x >= lobes || x <= -lobes) {
	          return 0.0;
	        }
	        if (x < 1.19209290E-07 && x > -1.19209290E-07) {
	          return 1.0;
	        }
	        x *= Math.PI;
	        var xx = x / lobes;
	        return (sin(x) / x) * sin(xx) / xx;
	      };
	    },

	    /**
	     * Applies filter to canvas element
	     * @memberOf fabric.Image.filters.Resize.prototype
	     * @param {Object} canvasEl Canvas element to apply filter to
	     * @param {Number} scaleX
	     * @param {Number} scaleY
	     */
	    applyTo2d: function(options) {
	      var imageData = options.imageData,
	          scaleX = this.scaleX,
	          scaleY = this.scaleY;

	      this.rcpScaleX = 1 / scaleX;
	      this.rcpScaleY = 1 / scaleY;

	      var oW = imageData.width, oH = imageData.height,
	          dW = round(oW * scaleX), dH = round(oH * scaleY),
	          newData;

	      if (this.resizeType === 'sliceHack') {
	        newData = this.sliceByTwo(options, oW, oH, dW, dH);
	      }
	      else if (this.resizeType === 'hermite') {
	        newData = this.hermiteFastResize(options, oW, oH, dW, dH);
	      }
	      else if (this.resizeType === 'bilinear') {
	        newData = this.bilinearFiltering(options, oW, oH, dW, dH);
	      }
	      else if (this.resizeType === 'lanczos') {
	        newData = this.lanczosResize(options, oW, oH, dW, dH);
	      }
	      options.imageData = newData;
	    },

	    /**
	     * Filter sliceByTwo
	     * @param {Object} canvasEl Canvas element to apply filter to
	     * @param {Number} oW Original Width
	     * @param {Number} oH Original Height
	     * @param {Number} dW Destination Width
	     * @param {Number} dH Destination Height
	     * @returns {ImageData}
	     */
	    sliceByTwo: function(options, oW, oH, dW, dH) {
	      var imageData = options.imageData,
	          mult = 0.5, doneW = false, doneH = false, stepW = oW * mult,
	          stepH = oH * mult, resources = fabric.filterBackend.resources,
	          tmpCanvas, ctx, sX = 0, sY = 0, dX = oW, dY = 0;
	      if (!resources.sliceByTwo) {
	        resources.sliceByTwo = document.createElement('canvas');
	      }
	      tmpCanvas = resources.sliceByTwo;
	      if (tmpCanvas.width < oW * 1.5 || tmpCanvas.height < oH) {
	        tmpCanvas.width = oW * 1.5;
	        tmpCanvas.height = oH;
	      }
	      ctx = tmpCanvas.getContext('2d');
	      ctx.clearRect(0, 0, oW * 1.5, oH);
	      ctx.putImageData(imageData, 0, 0);

	      dW = floor(dW);
	      dH = floor(dH);

	      while (!doneW || !doneH) {
	        oW = stepW;
	        oH = stepH;
	        if (dW < floor(stepW * mult)) {
	          stepW = floor(stepW * mult);
	        }
	        else {
	          stepW = dW;
	          doneW = true;
	        }
	        if (dH < floor(stepH * mult)) {
	          stepH = floor(stepH * mult);
	        }
	        else {
	          stepH = dH;
	          doneH = true;
	        }
	        ctx.drawImage(tmpCanvas, sX, sY, oW, oH, dX, dY, stepW, stepH);
	        sX = dX;
	        sY = dY;
	        dY += stepH;
	      }
	      return ctx.getImageData(sX, sY, dW, dH);
	    },

	    /**
	     * Filter lanczosResize
	     * @param {Object} canvasEl Canvas element to apply filter to
	     * @param {Number} oW Original Width
	     * @param {Number} oH Original Height
	     * @param {Number} dW Destination Width
	     * @param {Number} dH Destination Height
	     * @returns {ImageData}
	     */
	    lanczosResize: function(options, oW, oH, dW, dH) {

	      function process(u) {
	        var v, i, weight, idx, a, red, green,
	            blue, alpha, fX, fY;
	        center.x = (u + 0.5) * ratioX;
	        icenter.x = floor(center.x);
	        for (v = 0; v < dH; v++) {
	          center.y = (v + 0.5) * ratioY;
	          icenter.y = floor(center.y);
	          a = 0; red = 0; green = 0; blue = 0; alpha = 0;
	          for (i = icenter.x - range2X; i <= icenter.x + range2X; i++) {
	            if (i < 0 || i >= oW) {
	              continue;
	            }
	            fX = floor(1000 * abs(i - center.x));
	            if (!cacheLanc[fX]) {
	              cacheLanc[fX] = { };
	            }
	            for (var j = icenter.y - range2Y; j <= icenter.y + range2Y; j++) {
	              if (j < 0 || j >= oH) {
	                continue;
	              }
	              fY = floor(1000 * abs(j - center.y));
	              if (!cacheLanc[fX][fY]) {
	                cacheLanc[fX][fY] = lanczos(sqrt(pow(fX * rcpRatioX, 2) + pow(fY * rcpRatioY, 2)) / 1000);
	              }
	              weight = cacheLanc[fX][fY];
	              if (weight > 0) {
	                idx = (j * oW + i) * 4;
	                a += weight;
	                red += weight * srcData[idx];
	                green += weight * srcData[idx + 1];
	                blue += weight * srcData[idx + 2];
	                alpha += weight * srcData[idx + 3];
	              }
	            }
	          }
	          idx = (v * dW + u) * 4;
	          destData[idx] = red / a;
	          destData[idx + 1] = green / a;
	          destData[idx + 2] = blue / a;
	          destData[idx + 3] = alpha / a;
	        }

	        if (++u < dW) {
	          return process(u);
	        }
	        else {
	          return destImg;
	        }
	      }

	      var srcData = options.imageData.data,
	          destImg = options.ctx.createImageData(dW, dH),
	          destData = destImg.data,
	          lanczos = this.lanczosCreate(this.lanczosLobes),
	          ratioX = this.rcpScaleX, ratioY = this.rcpScaleY,
	          rcpRatioX = 2 / this.rcpScaleX, rcpRatioY = 2 / this.rcpScaleY,
	          range2X = ceil(ratioX * this.lanczosLobes / 2),
	          range2Y = ceil(ratioY * this.lanczosLobes / 2),
	          cacheLanc = { }, center = { }, icenter = { };

	      return process(0);
	    },

	    /**
	     * bilinearFiltering
	     * @param {Object} canvasEl Canvas element to apply filter to
	     * @param {Number} oW Original Width
	     * @param {Number} oH Original Height
	     * @param {Number} dW Destination Width
	     * @param {Number} dH Destination Height
	     * @returns {ImageData}
	     */
	    bilinearFiltering: function(options, oW, oH, dW, dH) {
	      var a, b, c, d, x, y, i, j, xDiff, yDiff, chnl,
	          color, offset = 0, origPix, ratioX = this.rcpScaleX,
	          ratioY = this.rcpScaleY,
	          w4 = 4 * (oW - 1), img = options.imageData,
	          pixels = img.data, destImage = options.ctx.createImageData(dW, dH),
	          destPixels = destImage.data;
	      for (i = 0; i < dH; i++) {
	        for (j = 0; j < dW; j++) {
	          x = floor(ratioX * j);
	          y = floor(ratioY * i);
	          xDiff = ratioX * j - x;
	          yDiff = ratioY * i - y;
	          origPix = 4 * (y * oW + x);

	          for (chnl = 0; chnl < 4; chnl++) {
	            a = pixels[origPix + chnl];
	            b = pixels[origPix + 4 + chnl];
	            c = pixels[origPix + w4 + chnl];
	            d = pixels[origPix + w4 + 4 + chnl];
	            color = a * (1 - xDiff) * (1 - yDiff) + b * xDiff * (1 - yDiff) +
	                    c * yDiff * (1 - xDiff) + d * xDiff * yDiff;
	            destPixels[offset++] = color;
	          }
	        }
	      }
	      return destImage;
	    },

	    /**
	     * hermiteFastResize
	     * @param {Object} canvasEl Canvas element to apply filter to
	     * @param {Number} oW Original Width
	     * @param {Number} oH Original Height
	     * @param {Number} dW Destination Width
	     * @param {Number} dH Destination Height
	     * @returns {ImageData}
	     */
	    hermiteFastResize: function(options, oW, oH, dW, dH) {
	      var ratioW = this.rcpScaleX, ratioH = this.rcpScaleY,
	          ratioWHalf = ceil(ratioW / 2),
	          ratioHHalf = ceil(ratioH / 2),
	          img = options.imageData, data = img.data,
	          img2 = options.ctx.createImageData(dW, dH), data2 = img2.data;
	      for (var j = 0; j < dH; j++) {
	        for (var i = 0; i < dW; i++) {
	          var x2 = (i + j * dW) * 4, weight = 0, weights = 0, weightsAlpha = 0,
	              gxR = 0, gxG = 0, gxB = 0, gxA = 0, centerY = (j + 0.5) * ratioH;
	          for (var yy = floor(j * ratioH); yy < (j + 1) * ratioH; yy++) {
	            var dy = abs(centerY - (yy + 0.5)) / ratioHHalf,
	                centerX = (i + 0.5) * ratioW, w0 = dy * dy;
	            for (var xx = floor(i * ratioW); xx < (i + 1) * ratioW; xx++) {
	              var dx = abs(centerX - (xx + 0.5)) / ratioWHalf,
	                  w = sqrt(w0 + dx * dx);
	              /* eslint-disable max-depth */
	              if (w > 1 && w < -1) {
	                continue;
	              }
	              //hermite filter
	              weight = 2 * w * w * w - 3 * w * w + 1;
	              if (weight > 0) {
	                dx = 4 * (xx + yy * oW);
	                //alpha
	                gxA += weight * data[dx + 3];
	                weightsAlpha += weight;
	                //colors
	                if (data[dx + 3] < 255) {
	                  weight = weight * data[dx + 3] / 250;
	                }
	                gxR += weight * data[dx];
	                gxG += weight * data[dx + 1];
	                gxB += weight * data[dx + 2];
	                weights += weight;
	              }
	              /* eslint-enable max-depth */
	            }
	          }
	          data2[x2] = gxR / weights;
	          data2[x2 + 1] = gxG / weights;
	          data2[x2 + 2] = gxB / weights;
	          data2[x2 + 3] = gxA / weightsAlpha;
	        }
	      }
	      return img2;
	    },

	    /**
	     * Returns object representation of an instance
	     * @return {Object} Object representation of an instance
	     */
	    toObject: function() {
	      return {
	        type: this.type,
	        scaleX: this.scaleX,
	        scaleY: this.scaleY,
	        resizeType: this.resizeType,
	        lanczosLobes: this.lanczosLobes
	      };
	    }
	  });

	  /**
	   * Returns filter instance from an object representation
	   * @static
	   * @param {Object} object Object to create an instance from
	   * @param {Function} [callback] to be invoked after filter creation
	   * @return {fabric.Image.filters.Resize} Instance of fabric.Image.filters.Resize
	   */
	  fabric.Image.filters.Resize.fromObject = fabric.Image.filters.BaseFilter.fromObject;

	})(exports );


	(function(global) {

	  var fabric  = global.fabric || (global.fabric = { }),
	      filters = fabric.Image.filters,
	      createClass = fabric.util.createClass;

	  /**
	   * Contrast filter class
	   * @class fabric.Image.filters.Contrast
	   * @memberOf fabric.Image.filters
	   * @extends fabric.Image.filters.BaseFilter
	   * @see {@link fabric.Image.filters.Contrast#initialize} for constructor definition
	   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
	   * @example
	   * var filter = new fabric.Image.filters.Contrast({
	   *   contrast: 0.25
	   * });
	   * object.filters.push(filter);
	   * object.applyFilters();
	   */
	  filters.Contrast = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Contrast.prototype */ {

	    /**
	     * Filter type
	     * @param {String} type
	     * @default
	     */
	    type: 'Contrast',

	    fragmentSource: 'precision highp float;\n' +
	      'uniform sampler2D uTexture;\n' +
	      'uniform float uContrast;\n' +
	      'varying vec2 vTexCoord;\n' +
	      'void main() {\n' +
	        'vec4 color = texture2D(uTexture, vTexCoord);\n' +
	        'float contrastF = 1.015 * (uContrast + 1.0) / (1.0 * (1.015 - uContrast));\n' +
	        'color.rgb = contrastF * (color.rgb - 0.5) + 0.5;\n' +
	        'gl_FragColor = color;\n' +
	      '}',

	    /**
	     * contrast value, range from -1 to 1.
	     * @param {Number} contrast
	     * @default 0
	     */
	    contrast: 0,

	    mainParameter: 'contrast',

	    /**
	     * Constructor
	     * @memberOf fabric.Image.filters.Contrast.prototype
	     * @param {Object} [options] Options object
	     * @param {Number} [options.contrast=0] Value to contrast the image up (-1...1)
	     */

	    /**
	      * Apply the Contrast operation to a Uint8Array representing the pixels of an image.
	      *
	      * @param {Object} options
	      * @param {ImageData} options.imageData The Uint8Array to be filtered.
	      */
	    applyTo2d: function(options) {
	      if (this.contrast === 0) {
	        return;
	      }
	      var imageData = options.imageData, i, len,
	          data = imageData.data, len = data.length,
	          contrast = Math.floor(this.contrast * 255),
	          contrastF = 259 * (contrast + 255) / (255 * (259 - contrast));

	      for (i = 0; i < len; i += 4) {
	        data[i] = contrastF * (data[i] - 128) + 128;
	        data[i + 1] = contrastF * (data[i + 1] - 128) + 128;
	        data[i + 2] = contrastF * (data[i + 2] - 128) + 128;
	      }
	    },

	    /**
	     * Return WebGL uniform locations for this filter's shader.
	     *
	     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	     * @param {WebGLShaderProgram} program This filter's compiled shader program.
	     */
	    getUniformLocations: function(gl, program) {
	      return {
	        uContrast: gl.getUniformLocation(program, 'uContrast'),
	      };
	    },

	    /**
	     * Send data from this filter to its shader program's uniforms.
	     *
	     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
	     */
	    sendUniformData: function(gl, uniformLocations) {
	      gl.uniform1f(uniformLocations.uContrast, this.contrast);
	    },
	  });

	  /**
	   * Returns filter instance from an object representation
	   * @static
	   * @param {Object} object Object to create an instance from
	   * @param {function} [callback] to be invoked after filter creation
	   * @return {fabric.Image.filters.Contrast} Instance of fabric.Image.filters.Contrast
	   */
	  fabric.Image.filters.Contrast.fromObject = fabric.Image.filters.BaseFilter.fromObject;

	})(exports );


	(function(global) {

	  var fabric  = global.fabric || (global.fabric = { }),
	      filters = fabric.Image.filters,
	      createClass = fabric.util.createClass;

	  /**
	   * Saturate filter class
	   * @class fabric.Image.filters.Saturation
	   * @memberOf fabric.Image.filters
	   * @extends fabric.Image.filters.BaseFilter
	   * @see {@link fabric.Image.filters.Saturation#initialize} for constructor definition
	   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
	   * @example
	   * var filter = new fabric.Image.filters.Saturation({
	   *   saturation: 1
	   * });
	   * object.filters.push(filter);
	   * object.applyFilters();
	   */
	  filters.Saturation = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Saturation.prototype */ {

	    /**
	     * Filter type
	     * @param {String} type
	     * @default
	     */
	    type: 'Saturation',

	    fragmentSource: 'precision highp float;\n' +
	      'uniform sampler2D uTexture;\n' +
	      'uniform float uSaturation;\n' +
	      'varying vec2 vTexCoord;\n' +
	      'void main() {\n' +
	        'vec4 color = texture2D(uTexture, vTexCoord);\n' +
	        'float rgMax = max(color.r, color.g);\n' +
	        'float rgbMax = max(rgMax, color.b);\n' +
	        'color.r += rgbMax != color.r ? (rgbMax - color.r) * uSaturation : 0.00;\n' +
	        'color.g += rgbMax != color.g ? (rgbMax - color.g) * uSaturation : 0.00;\n' +
	        'color.b += rgbMax != color.b ? (rgbMax - color.b) * uSaturation : 0.00;\n' +
	        'gl_FragColor = color;\n' +
	      '}',

	    /**
	     * Saturation value, from -1 to 1.
	     * Increases/decreases the color saturation.
	     * A value of 0 has no effect.
	     * 
	     * @param {Number} saturation
	     * @default
	     */
	    saturation: 0,

	    mainParameter: 'saturation',

	    /**
	     * Constructor
	     * @memberOf fabric.Image.filters.Saturate.prototype
	     * @param {Object} [options] Options object
	     * @param {Number} [options.saturate=0] Value to saturate the image (-1...1)
	     */

	    /**
	     * Apply the Saturation operation to a Uint8ClampedArray representing the pixels of an image.
	     *
	     * @param {Object} options
	     * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
	     */
	    applyTo2d: function(options) {
	      if (this.saturation === 0) {
	        return;
	      }
	      var imageData = options.imageData,
	          data = imageData.data, len = data.length,
	          adjust = -this.saturation, i, max;

	      for (i = 0; i < len; i += 4) {
	        max = Math.max(data[i], data[i + 1], data[i + 2]);
	        data[i] += max !== data[i] ? (max - data[i]) * adjust : 0;
	        data[i + 1] += max !== data[i + 1] ? (max - data[i + 1]) * adjust : 0;
	        data[i + 2] += max !== data[i + 2] ? (max - data[i + 2]) * adjust : 0;
	      }
	    },

	    /**
	     * Return WebGL uniform locations for this filter's shader.
	     *
	     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	     * @param {WebGLShaderProgram} program This filter's compiled shader program.
	     */
	    getUniformLocations: function(gl, program) {
	      return {
	        uSaturation: gl.getUniformLocation(program, 'uSaturation'),
	      };
	    },

	    /**
	     * Send data from this filter to its shader program's uniforms.
	     *
	     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
	     */
	    sendUniformData: function(gl, uniformLocations) {
	      gl.uniform1f(uniformLocations.uSaturation, -this.saturation);
	    },
	  });

	  /**
	   * Returns filter instance from an object representation
	   * @static
	   * @param {Object} object Object to create an instance from
	   * @param {Function} [callback] to be invoked after filter creation
	   * @return {fabric.Image.filters.Saturation} Instance of fabric.Image.filters.Saturate
	   */
	  fabric.Image.filters.Saturation.fromObject = fabric.Image.filters.BaseFilter.fromObject;

	})(exports );


	(function(global) {

	  var fabric  = global.fabric || (global.fabric = { }),
	      filters = fabric.Image.filters,
	      createClass = fabric.util.createClass;

	  /**
	   * Vibrance filter class
	   * @class fabric.Image.filters.Vibrance
	   * @memberOf fabric.Image.filters
	   * @extends fabric.Image.filters.BaseFilter
	   * @see {@link fabric.Image.filters.Vibrance#initialize} for constructor definition
	   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
	   * @example
	   * var filter = new fabric.Image.filters.Vibrance({
	   *   vibrance: 1
	   * });
	   * object.filters.push(filter);
	   * object.applyFilters();
	   */
	  filters.Vibrance = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Vibrance.prototype */ {

	    /**
	     * Filter type
	     * @param {String} type
	     * @default
	     */
	    type: 'Vibrance',

	    fragmentSource: 'precision highp float;\n' +
	      'uniform sampler2D uTexture;\n' +
	      'uniform float uVibrance;\n' +
	      'varying vec2 vTexCoord;\n' +
	      'void main() {\n' +
	        'vec4 color = texture2D(uTexture, vTexCoord);\n' +
	        'float max = max(color.r, max(color.g, color.b));\n' +
	        'float avg = (color.r + color.g + color.b) / 3.0;\n' +
	        'float amt = (abs(max - avg) * 2.0) * uVibrance;\n' +
	        'color.r += max != color.r ? (max - color.r) * amt : 0.00;\n' +
	        'color.g += max != color.g ? (max - color.g) * amt : 0.00;\n' +
	        'color.b += max != color.b ? (max - color.b) * amt : 0.00;\n' +
	        'gl_FragColor = color;\n' +
	      '}',

	    /**
	     * Vibrance value, from -1 to 1.
	     * Increases/decreases the saturation of more muted colors with less effect on saturated colors.
	     * A value of 0 has no effect.
	     * 
	     * @param {Number} vibrance
	     * @default
	     */
	    vibrance: 0,

	    mainParameter: 'vibrance',

	    /**
	     * Constructor
	     * @memberOf fabric.Image.filters.Vibrance.prototype
	     * @param {Object} [options] Options object
	     * @param {Number} [options.vibrance=0] Vibrance value for the image (between -1 and 1)
	     */

	    /**
	     * Apply the Vibrance operation to a Uint8ClampedArray representing the pixels of an image.
	     *
	     * @param {Object} options
	     * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
	     */
	    applyTo2d: function(options) {
	      if (this.vibrance === 0) {
	        return;
	      }
	      var imageData = options.imageData,
	          data = imageData.data, len = data.length,
	          adjust = -this.vibrance, i, max, avg, amt;

	      for (i = 0; i < len; i += 4) {
	        max = Math.max(data[i], data[i + 1], data[i + 2]);
	        avg = (data[i] + data[i + 1] + data[i + 2]) / 3;
	        amt = ((Math.abs(max - avg) * 2 / 255) * adjust);
	        data[i] += max !== data[i] ? (max - data[i]) * amt : 0;
	        data[i + 1] += max !== data[i + 1] ? (max - data[i + 1]) * amt : 0;
	        data[i + 2] += max !== data[i + 2] ? (max - data[i + 2]) * amt : 0;
	      }
	    },

	    /**
	     * Return WebGL uniform locations for this filter's shader.
	     *
	     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	     * @param {WebGLShaderProgram} program This filter's compiled shader program.
	     */
	    getUniformLocations: function(gl, program) {
	      return {
	        uVibrance: gl.getUniformLocation(program, 'uVibrance'),
	      };
	    },

	    /**
	     * Send data from this filter to its shader program's uniforms.
	     *
	     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
	     */
	    sendUniformData: function(gl, uniformLocations) {
	      gl.uniform1f(uniformLocations.uVibrance, -this.vibrance);
	    },
	  });

	  /**
	   * Returns filter instance from an object representation
	   * @static
	   * @param {Object} object Object to create an instance from
	   * @param {Function} [callback] to be invoked after filter creation
	   * @return {fabric.Image.filters.Vibrance} Instance of fabric.Image.filters.Vibrance
	   */
	  fabric.Image.filters.Vibrance.fromObject = fabric.Image.filters.BaseFilter.fromObject;

	})(exports );


	(function(global) {

	  var fabric  = global.fabric || (global.fabric = { }),
	      filters = fabric.Image.filters,
	      createClass = fabric.util.createClass;

	  /**
	   * Blur filter class
	   * @class fabric.Image.filters.Blur
	   * @memberOf fabric.Image.filters
	   * @extends fabric.Image.filters.BaseFilter
	   * @see {@link fabric.Image.filters.Blur#initialize} for constructor definition
	   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
	   * @example
	   * var filter = new fabric.Image.filters.Blur({
	   *   blur: 0.5
	   * });
	   * object.filters.push(filter);
	   * object.applyFilters();
	   * canvas.renderAll();
	   */
	  filters.Blur = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Blur.prototype */ {

	    type: 'Blur',

	    /*
	'gl_FragColor = vec4(0.0);',
	'gl_FragColor += texture2D(texture, vTexCoord + -7 * uDelta)*0.0044299121055113265;',
	'gl_FragColor += texture2D(texture, vTexCoord + -6 * uDelta)*0.00895781211794;',
	'gl_FragColor += texture2D(texture, vTexCoord + -5 * uDelta)*0.0215963866053;',
	'gl_FragColor += texture2D(texture, vTexCoord + -4 * uDelta)*0.0443683338718;',
	'gl_FragColor += texture2D(texture, vTexCoord + -3 * uDelta)*0.0776744219933;',
	'gl_FragColor += texture2D(texture, vTexCoord + -2 * uDelta)*0.115876621105;',
	'gl_FragColor += texture2D(texture, vTexCoord + -1 * uDelta)*0.147308056121;',
	'gl_FragColor += texture2D(texture, vTexCoord              )*0.159576912161;',
	'gl_FragColor += texture2D(texture, vTexCoord + 1 * uDelta)*0.147308056121;',
	'gl_FragColor += texture2D(texture, vTexCoord + 2 * uDelta)*0.115876621105;',
	'gl_FragColor += texture2D(texture, vTexCoord + 3 * uDelta)*0.0776744219933;',
	'gl_FragColor += texture2D(texture, vTexCoord + 4 * uDelta)*0.0443683338718;',
	'gl_FragColor += texture2D(texture, vTexCoord + 5 * uDelta)*0.0215963866053;',
	'gl_FragColor += texture2D(texture, vTexCoord + 6 * uDelta)*0.00895781211794;',
	'gl_FragColor += texture2D(texture, vTexCoord + 7 * uDelta)*0.0044299121055113265;',
	*/

	    /* eslint-disable max-len */
	    fragmentSource: 'precision highp float;\n' +
	      'uniform sampler2D uTexture;\n' +
	      'uniform vec2 uDelta;\n' +
	      'varying vec2 vTexCoord;\n' +
	      'const float nSamples = 15.0;\n' +
	      'vec3 v3offset = vec3(12.9898, 78.233, 151.7182);\n' +
	      'float random(vec3 scale) {\n' +
	        /* use the fragment position for a different seed per-pixel */
	        'return fract(sin(dot(gl_FragCoord.xyz, scale)) * 43758.5453);\n' +
	      '}\n' +
	      'void main() {\n' +
	        'vec4 color = vec4(0.0);\n' +
	        'float total = 0.0;\n' +
	        'float offset = random(v3offset);\n' +
	        'for (float t = -nSamples; t <= nSamples; t++) {\n' +
	          'float percent = (t + offset - 0.5) / nSamples;\n' +
	          'float weight = 1.0 - abs(percent);\n' +
	          'color += texture2D(uTexture, vTexCoord + uDelta * percent) * weight;\n' +
	          'total += weight;\n' +
	        '}\n' +
	        'gl_FragColor = color / total;\n' +
	      '}',
	    /* eslint-enable max-len */

	    /**
	     * blur value, in percentage of image dimensions.
	     * specific to keep the image blur constant at different resolutions
	     * range between 0 and 1.
	     */
	    blur: 0,

	    mainParameter: 'blur',

	    applyTo: function(options) {
	      if (options.webgl) {
	        // this aspectRatio is used to give the same blur to vertical and horizontal
	        this.aspectRatio = options.sourceWidth / options.sourceHeight;
	        options.passes++;
	        this._setupFrameBuffer(options);
	        this.horizontal = true;
	        this.applyToWebGL(options);
	        this._swapTextures(options);
	        this._setupFrameBuffer(options);
	        this.horizontal = false;
	        this.applyToWebGL(options);
	        this._swapTextures(options);
	      }
	      else {
	        this.applyTo2d(options);
	      }
	    },

	    applyTo2d: function(options) {
	      // paint canvasEl with current image data.
	      //options.ctx.putImageData(options.imageData, 0, 0);
	      options.imageData = this.simpleBlur(options);
	    },

	    simpleBlur: function(options) {
	      var resources = options.filterBackend.resources, canvas1, canvas2,
	          width = options.imageData.width,
	          height = options.imageData.height;

	      if (!resources.blurLayer1) {
	        resources.blurLayer1 = fabric.util.createCanvasElement();
	        resources.blurLayer2 = fabric.util.createCanvasElement();
	      }
	      canvas1 = resources.blurLayer1;
	      canvas2 = resources.blurLayer2;
	      if (canvas1.width !== width || canvas1.height !== height) {
	        canvas2.width = canvas1.width = width;
	        canvas2.height = canvas1.height = height;
	      }
	      var ctx1 = canvas1.getContext('2d'),
	          ctx2 = canvas2.getContext('2d'),
	          nSamples = 15,
	          random, percent, j, i,
	          blur = this.blur * 0.06 * 0.5;

	      // load first canvas
	      ctx1.putImageData(options.imageData, 0, 0);
	      ctx2.clearRect(0, 0, width, height);

	      for (i = -nSamples; i <= nSamples; i++) {
	        random = (Math.random() - 0.5) / 4;
	        percent = i / nSamples;
	        j = blur * percent * width + random;
	        ctx2.globalAlpha = 1 - Math.abs(percent);
	        ctx2.drawImage(canvas1, j, random);
	        ctx1.drawImage(canvas2, 0, 0);
	        ctx2.globalAlpha = 1;
	        ctx2.clearRect(0, 0, canvas2.width, canvas2.height);
	      }
	      for (i = -nSamples; i <= nSamples; i++) {
	        random = (Math.random() - 0.5) / 4;
	        percent = i / nSamples;
	        j = blur * percent * height + random;
	        ctx2.globalAlpha = 1 - Math.abs(percent);
	        ctx2.drawImage(canvas1, random, j);
	        ctx1.drawImage(canvas2, 0, 0);
	        ctx2.globalAlpha = 1;
	        ctx2.clearRect(0, 0, canvas2.width, canvas2.height);
	      }
	      options.ctx.drawImage(canvas1, 0, 0);
	      var newImageData = options.ctx.getImageData(0, 0, canvas1.width, canvas1.height);
	      ctx1.globalAlpha = 1;
	      ctx1.clearRect(0, 0, canvas1.width, canvas1.height);
	      return newImageData;
	    },

	    /**
	     * Return WebGL uniform locations for this filter's shader.
	     *
	     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	     * @param {WebGLShaderProgram} program This filter's compiled shader program.
	     */
	    getUniformLocations: function(gl, program) {
	      return {
	        delta: gl.getUniformLocation(program, 'uDelta'),
	      };
	    },

	    /**
	     * Send data from this filter to its shader program's uniforms.
	     *
	     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
	     */
	    sendUniformData: function(gl, uniformLocations) {
	      var delta = this.chooseRightDelta();
	      gl.uniform2fv(uniformLocations.delta, delta);
	    },

	    /**
	     * choose right value of image percentage to blur with
	     * @returns {Array} a numeric array with delta values
	     */
	    chooseRightDelta: function() {
	      var blurScale = 1, delta = [0, 0], blur;
	      if (this.horizontal) {
	        if (this.aspectRatio > 1) {
	          // image is wide, i want to shrink radius horizontal
	          blurScale = 1 / this.aspectRatio;
	        }
	      }
	      else {
	        if (this.aspectRatio < 1) {
	          // image is tall, i want to shrink radius vertical
	          blurScale = this.aspectRatio;
	        }
	      }
	      blur = blurScale * this.blur * 0.12;
	      if (this.horizontal) {
	        delta[0] = blur;
	      }
	      else {
	        delta[1] = blur;
	      }
	      return delta;
	    },
	  });

	  /**
	   * Deserialize a JSON definition of a BlurFilter into a concrete instance.
	   */
	  filters.Blur.fromObject = fabric.Image.filters.BaseFilter.fromObject;

	})(exports );


	(function(global) {

	  var fabric  = global.fabric || (global.fabric = { }),
	      filters = fabric.Image.filters,
	      createClass = fabric.util.createClass;

	  /**
	   * Gamma filter class
	   * @class fabric.Image.filters.Gamma
	   * @memberOf fabric.Image.filters
	   * @extends fabric.Image.filters.BaseFilter
	   * @see {@link fabric.Image.filters.Gamma#initialize} for constructor definition
	   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
	   * @example
	   * var filter = new fabric.Image.filters.Gamma({
	   *   gamma: [1, 0.5, 2.1]
	   * });
	   * object.filters.push(filter);
	   * object.applyFilters();
	   */
	  filters.Gamma = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Gamma.prototype */ {

	    /**
	     * Filter type
	     * @param {String} type
	     * @default
	     */
	    type: 'Gamma',

	    fragmentSource: 'precision highp float;\n' +
	      'uniform sampler2D uTexture;\n' +
	      'uniform vec3 uGamma;\n' +
	      'varying vec2 vTexCoord;\n' +
	      'void main() {\n' +
	        'vec4 color = texture2D(uTexture, vTexCoord);\n' +
	        'vec3 correction = (1.0 / uGamma);\n' +
	        'color.r = pow(color.r, correction.r);\n' +
	        'color.g = pow(color.g, correction.g);\n' +
	        'color.b = pow(color.b, correction.b);\n' +
	        'gl_FragColor = color;\n' +
	        'gl_FragColor.rgb *= color.a;\n' +
	      '}',

	    /**
	     * Gamma array value, from 0.01 to 2.2.
	     * @param {Array} gamma
	     * @default
	     */
	    gamma: [1, 1, 1],

	    /**
	     * Describe the property that is the filter parameter
	     * @param {String} m
	     * @default
	     */
	    mainParameter: 'gamma',

	    /**
	     * Constructor
	     * @param {Object} [options] Options object
	     */
	    initialize: function(options) {
	      this.gamma = [1, 1, 1];
	      filters.BaseFilter.prototype.initialize.call(this, options);
	    },

	    /**
	     * Apply the Gamma operation to a Uint8Array representing the pixels of an image.
	     *
	     * @param {Object} options
	     * @param {ImageData} options.imageData The Uint8Array to be filtered.
	     */
	    applyTo2d: function(options) {
	      var imageData = options.imageData, data = imageData.data,
	          gamma = this.gamma, len = data.length,
	          rInv = 1 / gamma[0], gInv = 1 / gamma[1],
	          bInv = 1 / gamma[2], i;

	      if (!this.rVals) {
	        // eslint-disable-next-line
	        this.rVals = new Uint8Array(256);
	        // eslint-disable-next-line
	        this.gVals = new Uint8Array(256);
	        // eslint-disable-next-line
	        this.bVals = new Uint8Array(256);
	      }

	      // This is an optimization - pre-compute a look-up table for each color channel
	      // instead of performing these pow calls for each pixel in the image.
	      for (i = 0, len = 256; i < len; i++) {
	        this.rVals[i] = Math.pow(i / 255, rInv) * 255;
	        this.gVals[i] = Math.pow(i / 255, gInv) * 255;
	        this.bVals[i] = Math.pow(i / 255, bInv) * 255;
	      }
	      for (i = 0, len = data.length; i < len; i += 4) {
	        data[i] = this.rVals[data[i]];
	        data[i + 1] = this.gVals[data[i + 1]];
	        data[i + 2] = this.bVals[data[i + 2]];
	      }
	    },

	    /**
	     * Return WebGL uniform locations for this filter's shader.
	     *
	     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	     * @param {WebGLShaderProgram} program This filter's compiled shader program.
	     */
	    getUniformLocations: function(gl, program) {
	      return {
	        uGamma: gl.getUniformLocation(program, 'uGamma'),
	      };
	    },

	    /**
	     * Send data from this filter to its shader program's uniforms.
	     *
	     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
	     */
	    sendUniformData: function(gl, uniformLocations) {
	      gl.uniform3fv(uniformLocations.uGamma, this.gamma);
	    },
	  });

	  /**
	   * Returns filter instance from an object representation
	   * @static
	   * @param {Object} object Object to create an instance from
	   * @param {function} [callback] to be invoked after filter creation
	   * @return {fabric.Image.filters.Gamma} Instance of fabric.Image.filters.Gamma
	   */
	  fabric.Image.filters.Gamma.fromObject = fabric.Image.filters.BaseFilter.fromObject;

	})(exports );


	(function(global) {

	  var fabric  = global.fabric || (global.fabric = { }),
	      filters = fabric.Image.filters,
	      createClass = fabric.util.createClass;

	  /**
	   * A container class that knows how to apply a sequence of filters to an input image.
	   */
	  filters.Composed = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Composed.prototype */ {

	    type: 'Composed',

	    /**
	     * A non sparse array of filters to apply
	     */
	    subFilters: [],

	    /**
	     * Constructor
	     * @param {Object} [options] Options object
	     */
	    initialize: function(options) {
	      this.callSuper('initialize', options);
	      // create a new array instead mutating the prototype with push
	      this.subFilters = this.subFilters.slice(0);
	    },

	    /**
	     * Apply this container's filters to the input image provided.
	     *
	     * @param {Object} options
	     * @param {Number} options.passes The number of filters remaining to be applied.
	     */
	    applyTo: function(options) {
	      options.passes += this.subFilters.length - 1;
	      this.subFilters.forEach(function(filter) {
	        filter.applyTo(options);
	      });
	    },

	    /**
	     * Serialize this filter into JSON.
	     *
	     * @returns {Object} A JSON representation of this filter.
	     */
	    toObject: function() {
	      return fabric.util.object.extend(this.callSuper('toObject'), {
	        subFilters: this.subFilters.map(function(filter) { return filter.toObject(); }),
	      });
	    },

	    isNeutralState: function() {
	      return !this.subFilters.some(function(filter) { return !filter.isNeutralState(); });
	    }
	  });

	  /**
	   * Deserialize a JSON definition of a ComposedFilter into a concrete instance.
	   */
	  fabric.Image.filters.Composed.fromObject = function(object, callback) {
	    var filters = object.subFilters || [],
	        subFilters = filters.map(function(filter) {
	          return new fabric.Image.filters[filter.type](filter);
	        }),
	        instance = new fabric.Image.filters.Composed({ subFilters: subFilters });
	    callback && callback(instance);
	    return instance;
	  };
	})(exports );


	(function(global) {

	  var fabric  = global.fabric || (global.fabric = { }),
	      filters = fabric.Image.filters,
	      createClass = fabric.util.createClass;

	  /**
	   * HueRotation filter class
	   * @class fabric.Image.filters.HueRotation
	   * @memberOf fabric.Image.filters
	   * @extends fabric.Image.filters.BaseFilter
	   * @see {@link fabric.Image.filters.HueRotation#initialize} for constructor definition
	   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
	   * @example
	   * var filter = new fabric.Image.filters.HueRotation({
	   *   rotation: -0.5
	   * });
	   * object.filters.push(filter);
	   * object.applyFilters();
	   */
	  filters.HueRotation = createClass(filters.ColorMatrix, /** @lends fabric.Image.filters.HueRotation.prototype */ {

	    /**
	     * Filter type
	     * @param {String} type
	     * @default
	     */
	    type: 'HueRotation',

	    /**
	     * HueRotation value, from -1 to 1.
	     * the unit is radians
	     * @param {Number} myParameter
	     * @default
	     */
	    rotation: 0,

	    /**
	     * Describe the property that is the filter parameter
	     * @param {String} m
	     * @default
	     */
	    mainParameter: 'rotation',

	    calculateMatrix: function() {
	      var rad = this.rotation * Math.PI, cos = fabric.util.cos(rad), sin = fabric.util.sin(rad),
	          aThird = 1 / 3, aThirdSqtSin = Math.sqrt(aThird) * sin, OneMinusCos = 1 - cos;
	      this.matrix = [
	        1, 0, 0, 0, 0,
	        0, 1, 0, 0, 0,
	        0, 0, 1, 0, 0,
	        0, 0, 0, 1, 0
	      ];
	      this.matrix[0] = cos + OneMinusCos / 3;
	      this.matrix[1] = aThird * OneMinusCos - aThirdSqtSin;
	      this.matrix[2] = aThird * OneMinusCos + aThirdSqtSin;
	      this.matrix[5] = aThird * OneMinusCos + aThirdSqtSin;
	      this.matrix[6] = cos + aThird * OneMinusCos;
	      this.matrix[7] = aThird * OneMinusCos - aThirdSqtSin;
	      this.matrix[10] = aThird * OneMinusCos - aThirdSqtSin;
	      this.matrix[11] = aThird * OneMinusCos + aThirdSqtSin;
	      this.matrix[12] = cos + aThird * OneMinusCos;
	    },

	    /**
	     * HueRotation isNeutralState implementation
	     * Used only in image applyFilters to discard filters that will not have an effect
	     * on the image
	     * @param {Object} options
	     **/
	    isNeutralState: function(options) {
	      this.calculateMatrix();
	      return filters.BaseFilter.prototype.isNeutralState.call(this, options);
	    },

	    /**
	     * Apply this filter to the input image data provided.
	     *
	     * Determines whether to use WebGL or Canvas2D based on the options.webgl flag.
	     *
	     * @param {Object} options
	     * @param {Number} options.passes The number of filters remaining to be executed
	     * @param {Boolean} options.webgl Whether to use webgl to render the filter.
	     * @param {WebGLTexture} options.sourceTexture The texture setup as the source to be filtered.
	     * @param {WebGLTexture} options.targetTexture The texture where filtered output should be drawn.
	     * @param {WebGLRenderingContext} options.context The GL context used for rendering.
	     * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
	     */
	    applyTo: function(options) {
	      this.calculateMatrix();
	      filters.BaseFilter.prototype.applyTo.call(this, options);
	    },

	  });

	  /**
	   * Returns filter instance from an object representation
	   * @static
	   * @param {Object} object Object to create an instance from
	   * @param {function} [callback] to be invoked after filter creation
	   * @return {fabric.Image.filters.HueRotation} Instance of fabric.Image.filters.HueRotation
	   */
	  fabric.Image.filters.HueRotation.fromObject = fabric.Image.filters.BaseFilter.fromObject;

	})(exports );


	(function(global) {

	  var fabric = global.fabric || (global.fabric = { }),
	      clone = fabric.util.object.clone;

	  if (fabric.Text) {
	    fabric.warn('fabric.Text is already defined');
	    return;
	  }

	  var additionalProps =
	    ('fontFamily fontWeight fontSize text underline overline linethrough' +
	    ' textAlign fontStyle lineHeight textBackgroundColor charSpacing styles' +
	    ' direction path pathStartOffset pathSide').split(' ');

	  /**
	   * Text class
	   * @class fabric.Text
	   * @extends fabric.Object
	   * @return {fabric.Text} thisArg
	   * @tutorial {@link http://fabricjs.com/fabric-intro-part-2#text}
	   * @see {@link fabric.Text#initialize} for constructor definition
	   */
	  fabric.Text = fabric.util.createClass(fabric.Object, /** @lends fabric.Text.prototype */ {

	    /**
	     * Properties which when set cause object to change dimensions
	     * @type Array
	     * @private
	     */
	    _dimensionAffectingProps: [
	      'fontSize',
	      'fontWeight',
	      'fontFamily',
	      'fontStyle',
	      'lineHeight',
	      'text',
	      'charSpacing',
	      'textAlign',
	      'styles',
	      'path',
	      'pathStartOffset',
	      'pathSide'
	    ],

	    /**
	     * @private
	     */
	    _reNewline: /\r?\n/,

	    /**
	     * Use this regular expression to filter for whitespaces that is not a new line.
	     * Mostly used when text is 'justify' aligned.
	     * @private
	     */
	    _reSpacesAndTabs: /[ \t\r]/g,

	    /**
	     * Use this regular expression to filter for whitespace that is not a new line.
	     * Mostly used when text is 'justify' aligned.
	     * @private
	     */
	    _reSpaceAndTab: /[ \t\r]/,

	    /**
	     * Use this regular expression to filter consecutive groups of non spaces.
	     * Mostly used when text is 'justify' aligned.
	     * @private
	     */
	    _reWords: /\S+/g,

	    /**
	     * Type of an object
	     * @type String
	     * @default
	     */
	    type:                 'text',

	    /**
	     * Font size (in pixels)
	     * @type Number
	     * @default
	     */
	    fontSize:             40,

	    /**
	     * Font weight (e.g. bold, normal, 400, 600, 800)
	     * @type {(Number|String)}
	     * @default
	     */
	    fontWeight:           'normal',

	    /**
	     * Font family
	     * @type String
	     * @default
	     */
	    fontFamily:           'Times New Roman',

	    /**
	     * Text decoration underline.
	     * @type Boolean
	     * @default
	     */
	    underline:       false,

	    /**
	     * Text decoration overline.
	     * @type Boolean
	     * @default
	     */
	    overline:       false,

	    /**
	     * Text decoration linethrough.
	     * @type Boolean
	     * @default
	     */
	    linethrough:       false,

	    /**
	     * Text alignment. Possible values: "left", "center", "right", "justify",
	     * "justify-left", "justify-center" or "justify-right".
	     * @type String
	     * @default
	     */
	    textAlign:            'left',

	    /**
	     * Font style . Possible values: "", "normal", "italic" or "oblique".
	     * @type String
	     * @default
	     */
	    fontStyle:            'normal',

	    /**
	     * Line height
	     * @type Number
	     * @default
	     */
	    lineHeight:           1.16,

	    /**
	     * Superscript schema object (minimum overlap)
	     * @type {Object}
	     * @default
	     */
	    superscript: {
	      size:      0.60, // fontSize factor
	      baseline: -0.35  // baseline-shift factor (upwards)
	    },

	    /**
	     * Subscript schema object (minimum overlap)
	     * @type {Object}
	     * @default
	     */
	    subscript: {
	      size:      0.60, // fontSize factor
	      baseline:  0.11  // baseline-shift factor (downwards)
	    },

	    /**
	     * Background color of text lines
	     * @type String
	     * @default
	     */
	    textBackgroundColor:  '',

	    /**
	     * List of properties to consider when checking if
	     * state of an object is changed ({@link fabric.Object#hasStateChanged})
	     * as well as for history (undo/redo) purposes
	     * @type Array
	     */
	    stateProperties: fabric.Object.prototype.stateProperties.concat(additionalProps),

	    /**
	     * List of properties to consider when checking if cache needs refresh
	     * @type Array
	     */
	    cacheProperties: fabric.Object.prototype.cacheProperties.concat(additionalProps),

	    /**
	     * When defined, an object is rendered via stroke and this property specifies its color.
	     * <b>Backwards incompatibility note:</b> This property was named "strokeStyle" until v1.1.6
	     * @type String
	     * @default
	     */
	    stroke:               null,

	    /**
	     * Shadow object representing shadow of this shape.
	     * <b>Backwards incompatibility note:</b> This property was named "textShadow" (String) until v1.2.11
	     * @type fabric.Shadow
	     * @default
	     */
	    shadow:               null,

	    /**
	     * fabric.Path that the text should follow.
	     * since 4.6.0 the path will be drawn automatically.
	     * if you want to make the path visible, give it a stroke and strokeWidth or fill value
	     * if you want it to be hidden, assign visible = false to the path.
	     * This feature is in BETA, and SVG import/export is not yet supported.
	     * @type fabric.Path
	     * @example
	     * var textPath = new fabric.Text('Text on a path', {
	     *     top: 150,
	     *     left: 150,
	     *     textAlign: 'center',
	     *     charSpacing: -50,
	     *     path: new fabric.Path('M 0 0 C 50 -100 150 -100 200 0', {
	     *         strokeWidth: 1,
	     *         visible: false
	     *     }),
	     *     pathSide: 'left',
	     *     pathStartOffset: 0
	     * });
	     * @default
	     */
	    path:               null,

	    /**
	     * Offset amount for text path starting position
	     * Only used when text has a path
	     * @type Number
	     * @default
	     */
	    pathStartOffset:               0,

	    /**
	     * Which side of the path the text should be drawn on.
	     * Only used when text has a path
	     * @type {String} 'left|right'
	     * @default
	     */
	    pathSide:               'left',

	    /**
	     * @private
	     */
	    _fontSizeFraction: 0.222,

	    /**
	     * @private
	     */
	    offsets: {
	      underline: 0.10,
	      linethrough: -0.315,
	      overline: -0.88
	    },

	    /**
	     * Text Line proportion to font Size (in pixels)
	     * @type Number
	     * @default
	     */
	    _fontSizeMult:             1.13,

	    /**
	     * additional space between characters
	     * expressed in thousands of em unit
	     * @type Number
	     * @default
	     */
	    charSpacing:             0,

	    /**
	     * Object containing character styles - top-level properties -> line numbers,
	     * 2nd-level properties - character numbers
	     * @type Object
	     * @default
	     */
	    styles: null,

	    /**
	     * Reference to a context to measure text char or couple of chars
	     * the cacheContext of the canvas will be used or a freshly created one if the object is not on canvas
	     * once created it will be referenced on fabric._measuringContext to avoid creating a canvas for every
	     * text object created.
	     * @type {CanvasRenderingContext2D}
	     * @default
	     */
	    _measuringContext: null,

	    /**
	     * Baseline shift, styles only, keep at 0 for the main text object
	     * @type {Number}
	     * @default
	     */
	    deltaY: 0,

	    /**
	     * WARNING: EXPERIMENTAL. NOT SUPPORTED YET
	     * determine the direction of the text.
	     * This has to be set manually together with textAlign and originX for proper
	     * experience.
	     * some interesting link for the future
	     * https://www.w3.org/International/questions/qa-bidi-unicode-controls
	     * @since 4.5.0
	     * @type {String} 'ltr|rtl'
	     * @default
	     */
	    direction: 'ltr',

	    /**
	     * Array of properties that define a style unit (of 'styles').
	     * @type {Array}
	     * @default
	     */
	    _styleProperties: [
	      'stroke',
	      'strokeWidth',
	      'fill',
	      'fontFamily',
	      'fontSize',
	      'fontWeight',
	      'fontStyle',
	      'underline',
	      'overline',
	      'linethrough',
	      'deltaY',
	      'textBackgroundColor',
	    ],

	    /**
	     * contains characters bounding boxes
	     */
	    __charBounds: [],

	    /**
	     * use this size when measuring text. To avoid IE11 rounding errors
	     * @type {Number}
	     * @default
	     * @readonly
	     * @private
	     */
	    CACHE_FONT_SIZE: 400,

	    /**
	     * contains the min text width to avoid getting 0
	     * @type {Number}
	     * @default
	     */
	    MIN_TEXT_WIDTH: 2,

	    /**
	     * Constructor
	     * @param {String} text Text string
	     * @param {Object} [options] Options object
	     * @return {fabric.Text} thisArg
	     */
	    initialize: function(text, options) {
	      this.styles = options ? (options.styles || { }) : { };
	      this.text = text;
	      this.__skipDimension = true;
	      this.callSuper('initialize', options);
	      if (this.path) {
	        this.setPathInfo();
	      }
	      this.__skipDimension = false;
	      this.initDimensions();
	      this.setCoords();
	      this.setupState({ propertySet: '_dimensionAffectingProps' });
	    },

	    /**
	     * If text has a path, it will add the extra information needed
	     * for path and text calculations
	     * @return {fabric.Text} thisArg
	     */
	    setPathInfo: function() {
	      var path = this.path;
	      if (path) {
	        path.segmentsInfo = fabric.util.getPathSegmentsInfo(path.path);
	      }
	    },

	    /**
	     * Return a context for measurement of text string.
	     * if created it gets stored for reuse
	     * @param {String} text Text string
	     * @param {Object} [options] Options object
	     * @return {fabric.Text} thisArg
	     */
	    getMeasuringContext: function() {
	      // if we did not return we have to measure something.
	      if (!fabric._measuringContext) {
	        fabric._measuringContext = this.canvas && this.canvas.contextCache ||
	          fabric.util.createCanvasElement().getContext('2d');
	      }
	      return fabric._measuringContext;
	    },

	    /**
	     * @private
	     * Divides text into lines of text and lines of graphemes.
	     */
	    _splitText: function() {
	      var newLines = this._splitTextIntoLines(this.text);
	      this.textLines = newLines.lines;
	      this._textLines = newLines.graphemeLines;
	      this._unwrappedTextLines = newLines._unwrappedLines;
	      this._text = newLines.graphemeText;
	      return newLines;
	    },

	    /**
	     * Initialize or update text dimensions.
	     * Updates this.width and this.height with the proper values.
	     * Does not return dimensions.
	     */
	    initDimensions: function() {
	      if (this.__skipDimension) {
	        return;
	      }
	      this._splitText();
	      this._clearCache();
	      if (this.path) {
	        this.width = this.path.width;
	        this.height = this.path.height;
	      }
	      else {
	        this.width = this.calcTextWidth() || this.cursorWidth || this.MIN_TEXT_WIDTH;
	        this.height = this.calcTextHeight();
	      }
	      if (this.textAlign.indexOf('justify') !== -1) {
	        // once text is measured we need to make space fatter to make justified text.
	        this.enlargeSpaces();
	      }
	      this.saveState({ propertySet: '_dimensionAffectingProps' });
	    },

	    /**
	     * Enlarge space boxes and shift the others
	     */
	    enlargeSpaces: function() {
	      var diffSpace, currentLineWidth, numberOfSpaces, accumulatedSpace, line, charBound, spaces;
	      for (var i = 0, len = this._textLines.length; i < len; i++) {
	        if (this.textAlign !== 'justify' && (i === len - 1 || this.isEndOfWrapping(i))) {
	          continue;
	        }
	        accumulatedSpace = 0;
	        line = this._textLines[i];
	        currentLineWidth = this.getLineWidth(i);
	        if (currentLineWidth < this.width && (spaces = this.textLines[i].match(this._reSpacesAndTabs))) {
	          numberOfSpaces = spaces.length;
	          diffSpace = (this.width - currentLineWidth) / numberOfSpaces;
	          for (var j = 0, jlen = line.length; j <= jlen; j++) {
	            charBound = this.__charBounds[i][j];
	            if (this._reSpaceAndTab.test(line[j])) {
	              charBound.width += diffSpace;
	              charBound.kernedWidth += diffSpace;
	              charBound.left += accumulatedSpace;
	              accumulatedSpace += diffSpace;
	            }
	            else {
	              charBound.left += accumulatedSpace;
	            }
	          }
	        }
	      }
	    },

	    /**
	     * Detect if the text line is ended with an hard break
	     * text and itext do not have wrapping, return false
	     * @return {Boolean}
	     */
	    isEndOfWrapping: function(lineIndex) {
	      return lineIndex === this._textLines.length - 1;
	    },

	    /**
	     * Detect if a line has a linebreak and so we need to account for it when moving
	     * and counting style.
	     * It return always for text and Itext.
	     * @return Number
	     */
	    missingNewlineOffset: function() {
	      return 1;
	    },

	    /**
	     * Returns string representation of an instance
	     * @return {String} String representation of text object
	     */
	    toString: function() {
	      return '#<fabric.Text (' + this.complexity() +
	        '): { "text": "' + this.text + '", "fontFamily": "' + this.fontFamily + '" }>';
	    },

	    /**
	     * Return the dimension and the zoom level needed to create a cache canvas
	     * big enough to host the object to be cached.
	     * @private
	     * @param {Object} dim.x width of object to be cached
	     * @param {Object} dim.y height of object to be cached
	     * @return {Object}.width width of canvas
	     * @return {Object}.height height of canvas
	     * @return {Object}.zoomX zoomX zoom value to unscale the canvas before drawing cache
	     * @return {Object}.zoomY zoomY zoom value to unscale the canvas before drawing cache
	     */
	    _getCacheCanvasDimensions: function() {
	      var dims = this.callSuper('_getCacheCanvasDimensions');
	      var fontSize = this.fontSize;
	      dims.width += fontSize * dims.zoomX;
	      dims.height += fontSize * dims.zoomY;
	      return dims;
	    },

	    /**
	     * @private
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    _render: function(ctx) {
	      var path = this.path;
	      path && !path.isNotVisible() && path._render(ctx);
	      this._setTextStyles(ctx);
	      this._renderTextLinesBackground(ctx);
	      this._renderTextDecoration(ctx, 'underline');
	      this._renderText(ctx);
	      this._renderTextDecoration(ctx, 'overline');
	      this._renderTextDecoration(ctx, 'linethrough');
	    },

	    /**
	     * @private
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    _renderText: function(ctx) {
	      if (this.paintFirst === 'stroke') {
	        this._renderTextStroke(ctx);
	        this._renderTextFill(ctx);
	      }
	      else {
	        this._renderTextFill(ctx);
	        this._renderTextStroke(ctx);
	      }
	    },

	    /**
	     * Set the font parameter of the context with the object properties or with charStyle
	     * @private
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     * @param {Object} [charStyle] object with font style properties
	     * @param {String} [charStyle.fontFamily] Font Family
	     * @param {Number} [charStyle.fontSize] Font size in pixels. ( without px suffix )
	     * @param {String} [charStyle.fontWeight] Font weight
	     * @param {String} [charStyle.fontStyle] Font style (italic|normal)
	     */
	    _setTextStyles: function(ctx, charStyle, forMeasuring) {
	      ctx.textBaseline = 'alphabetic';
	      ctx.font = this._getFontDeclaration(charStyle, forMeasuring);
	    },

	    /**
	     * calculate and return the text Width measuring each line.
	     * @private
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     * @return {Number} Maximum width of fabric.Text object
	     */
	    calcTextWidth: function() {
	      var maxWidth = this.getLineWidth(0);

	      for (var i = 1, len = this._textLines.length; i < len; i++) {
	        var currentLineWidth = this.getLineWidth(i);
	        if (currentLineWidth > maxWidth) {
	          maxWidth = currentLineWidth;
	        }
	      }
	      return maxWidth;
	    },

	    /**
	     * @private
	     * @param {String} method Method name ("fillText" or "strokeText")
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     * @param {String} line Text to render
	     * @param {Number} left Left position of text
	     * @param {Number} top Top position of text
	     * @param {Number} lineIndex Index of a line in a text
	     */
	    _renderTextLine: function(method, ctx, line, left, top, lineIndex) {
	      this._renderChars(method, ctx, line, left, top, lineIndex);
	    },

	    /**
	     * Renders the text background for lines, taking care of style
	     * @private
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    _renderTextLinesBackground: function(ctx) {
	      if (!this.textBackgroundColor && !this.styleHas('textBackgroundColor')) {
	        return;
	      }
	      var heightOfLine,
	          lineLeftOffset, originalFill = ctx.fillStyle,
	          line, lastColor,
	          leftOffset = this._getLeftOffset(),
	          lineTopOffset = this._getTopOffset(),
	          boxStart = 0, boxWidth = 0, charBox, currentColor, path = this.path,
	          drawStart;

	      for (var i = 0, len = this._textLines.length; i < len; i++) {
	        heightOfLine = this.getHeightOfLine(i);
	        if (!this.textBackgroundColor && !this.styleHas('textBackgroundColor', i)) {
	          lineTopOffset += heightOfLine;
	          continue;
	        }
	        line = this._textLines[i];
	        lineLeftOffset = this._getLineLeftOffset(i);
	        boxWidth = 0;
	        boxStart = 0;
	        lastColor = this.getValueOfPropertyAt(i, 0, 'textBackgroundColor');
	        for (var j = 0, jlen = line.length; j < jlen; j++) {
	          charBox = this.__charBounds[i][j];
	          currentColor = this.getValueOfPropertyAt(i, j, 'textBackgroundColor');
	          if (path) {
	            ctx.save();
	            ctx.translate(charBox.renderLeft, charBox.renderTop);
	            ctx.rotate(charBox.angle);
	            ctx.fillStyle = currentColor;
	            currentColor && ctx.fillRect(
	              -charBox.width / 2,
	              -heightOfLine / this.lineHeight * (1 - this._fontSizeFraction),
	              charBox.width,
	              heightOfLine / this.lineHeight
	            );
	            ctx.restore();
	          }
	          else if (currentColor !== lastColor) {
	            drawStart = leftOffset + lineLeftOffset + boxStart;
	            if (this.direction === 'rtl') {
	              drawStart = this.width - drawStart - boxWidth;
	            }
	            ctx.fillStyle = lastColor;
	            lastColor && ctx.fillRect(
	              drawStart,
	              lineTopOffset,
	              boxWidth,
	              heightOfLine / this.lineHeight
	            );
	            boxStart = charBox.left;
	            boxWidth = charBox.width;
	            lastColor = currentColor;
	          }
	          else {
	            boxWidth += charBox.kernedWidth;
	          }
	        }
	        if (currentColor && !path) {
	          drawStart = leftOffset + lineLeftOffset + boxStart;
	          if (this.direction === 'rtl') {
	            drawStart = this.width - drawStart - boxWidth;
	          }
	          ctx.fillStyle = currentColor;
	          ctx.fillRect(
	            drawStart,
	            lineTopOffset,
	            boxWidth,
	            heightOfLine / this.lineHeight
	          );
	        }
	        lineTopOffset += heightOfLine;
	      }
	      ctx.fillStyle = originalFill;
	      // if there is text background color no
	      // other shadows should be casted
	      this._removeShadow(ctx);
	    },

	    /**
	     * @private
	     * @param {Object} decl style declaration for cache
	     * @param {String} decl.fontFamily fontFamily
	     * @param {String} decl.fontStyle fontStyle
	     * @param {String} decl.fontWeight fontWeight
	     * @return {Object} reference to cache
	     */
	    getFontCache: function(decl) {
	      var fontFamily = decl.fontFamily.toLowerCase();
	      if (!fabric.charWidthsCache[fontFamily]) {
	        fabric.charWidthsCache[fontFamily] = { };
	      }
	      var cache = fabric.charWidthsCache[fontFamily],
	          cacheProp = decl.fontStyle.toLowerCase() + '_' + (decl.fontWeight + '').toLowerCase();
	      if (!cache[cacheProp]) {
	        cache[cacheProp] = { };
	      }
	      return cache[cacheProp];
	    },

	    /**
	     * measure and return the width of a single character.
	     * possibly overridden to accommodate different measure logic or
	     * to hook some external lib for character measurement
	     * @private
	     * @param {String} _char, char to be measured
	     * @param {Object} charStyle style of char to be measured
	     * @param {String} [previousChar] previous char
	     * @param {Object} [prevCharStyle] style of previous char
	     */
	    _measureChar: function(_char, charStyle, previousChar, prevCharStyle) {
	      // first i try to return from cache
	      var fontCache = this.getFontCache(charStyle), fontDeclaration = this._getFontDeclaration(charStyle),
	          previousFontDeclaration = this._getFontDeclaration(prevCharStyle), couple = previousChar + _char,
	          stylesAreEqual = fontDeclaration === previousFontDeclaration, width, coupleWidth, previousWidth,
	          fontMultiplier = charStyle.fontSize / this.CACHE_FONT_SIZE, kernedWidth;

	      if (previousChar && fontCache[previousChar] !== undefined) {
	        previousWidth = fontCache[previousChar];
	      }
	      if (fontCache[_char] !== undefined) {
	        kernedWidth = width = fontCache[_char];
	      }
	      if (stylesAreEqual && fontCache[couple] !== undefined) {
	        coupleWidth = fontCache[couple];
	        kernedWidth = coupleWidth - previousWidth;
	      }
	      if (width === undefined || previousWidth === undefined || coupleWidth === undefined) {
	        var ctx = this.getMeasuringContext();
	        // send a TRUE to specify measuring font size CACHE_FONT_SIZE
	        this._setTextStyles(ctx, charStyle, true);
	      }
	      if (width === undefined) {
	        kernedWidth = width = ctx.measureText(_char).width;
	        fontCache[_char] = width;
	      }
	      if (previousWidth === undefined && stylesAreEqual && previousChar) {
	        previousWidth = ctx.measureText(previousChar).width;
	        fontCache[previousChar] = previousWidth;
	      }
	      if (stylesAreEqual && coupleWidth === undefined) {
	        // we can measure the kerning couple and subtract the width of the previous character
	        coupleWidth = ctx.measureText(couple).width;
	        fontCache[couple] = coupleWidth;
	        kernedWidth = coupleWidth - previousWidth;
	      }
	      return { width: width * fontMultiplier, kernedWidth: kernedWidth * fontMultiplier };
	    },

	    /**
	     * Computes height of character at given position
	     * @param {Number} line the line index number
	     * @param {Number} _char the character index number
	     * @return {Number} fontSize of the character
	     */
	    getHeightOfChar: function(line, _char) {
	      return this.getValueOfPropertyAt(line, _char, 'fontSize');
	    },

	    /**
	     * measure a text line measuring all characters.
	     * @param {Number} lineIndex line number
	     * @return {Number} Line width
	     */
	    measureLine: function(lineIndex) {
	      var lineInfo = this._measureLine(lineIndex);
	      if (this.charSpacing !== 0) {
	        lineInfo.width -= this._getWidthOfCharSpacing();
	      }
	      if (lineInfo.width < 0) {
	        lineInfo.width = 0;
	      }
	      return lineInfo;
	    },

	    /**
	     * measure every grapheme of a line, populating __charBounds
	     * @param {Number} lineIndex
	     * @return {Object} object.width total width of characters
	     * @return {Object} object.widthOfSpaces length of chars that match this._reSpacesAndTabs
	     */
	    _measureLine: function(lineIndex) {
	      var width = 0, i, grapheme, line = this._textLines[lineIndex], prevGrapheme,
	          graphemeInfo, numOfSpaces = 0, lineBounds = new Array(line.length),
	          positionInPath = 0, startingPoint, totalPathLength, path = this.path,
	          reverse = this.pathSide === 'right';

	      this.__charBounds[lineIndex] = lineBounds;
	      for (i = 0; i < line.length; i++) {
	        grapheme = line[i];
	        graphemeInfo = this._getGraphemeBox(grapheme, lineIndex, i, prevGrapheme);
	        lineBounds[i] = graphemeInfo;
	        width += graphemeInfo.kernedWidth;
	        prevGrapheme = grapheme;
	      }
	      // this latest bound box represent the last character of the line
	      // to simplify cursor handling in interactive mode.
	      lineBounds[i] = {
	        left: graphemeInfo ? graphemeInfo.left + graphemeInfo.width : 0,
	        width: 0,
	        kernedWidth: 0,
	        height: this.fontSize
	      };
	      if (path) {
	        totalPathLength = path.segmentsInfo[path.segmentsInfo.length - 1].length;
	        startingPoint = fabric.util.getPointOnPath(path.path, 0, path.segmentsInfo);
	        startingPoint.x += path.pathOffset.x;
	        startingPoint.y += path.pathOffset.y;
	        switch (this.textAlign) {
	          case 'left':
	            positionInPath = reverse ? (totalPathLength - width) : 0;
	            break;
	          case 'center':
	            positionInPath = (totalPathLength - width) / 2;
	            break;
	          case 'right':
	            positionInPath = reverse ? 0 : (totalPathLength - width);
	            break;
	          //todo - add support for justify
	        }
	        positionInPath += this.pathStartOffset * (reverse ? -1 : 1);
	        for (i = reverse ? line.length - 1 : 0;
	          reverse ? i >= 0 : i < line.length;
	          reverse ? i-- : i++) {
	          graphemeInfo = lineBounds[i];
	          if (positionInPath > totalPathLength) {
	            positionInPath %= totalPathLength;
	          }
	          else if (positionInPath < 0) {
	            positionInPath += totalPathLength;
	          }
	          // it would probably much faster to send all the grapheme position for a line
	          // and calculate path position/angle at once.
	          this._setGraphemeOnPath(positionInPath, graphemeInfo, startingPoint);
	          positionInPath += graphemeInfo.kernedWidth;
	        }
	      }
	      return { width: width, numOfSpaces: numOfSpaces };
	    },

	    /**
	     * Calculate the angle  and the left,top position of the char that follow a path.
	     * It appends it to graphemeInfo to be reused later at rendering
	     * @private
	     * @param {Number} positionInPath to be measured
	     * @param {Object} graphemeInfo current grapheme box information
	     * @param {Object} startingPoint position of the point
	     */
	    _setGraphemeOnPath: function(positionInPath, graphemeInfo, startingPoint) {
	      var centerPosition = positionInPath + graphemeInfo.kernedWidth / 2,
	          path = this.path;

	      // we are at currentPositionOnPath. we want to know what point on the path is.
	      var info = fabric.util.getPointOnPath(path.path, centerPosition, path.segmentsInfo);
	      graphemeInfo.renderLeft = info.x - startingPoint.x;
	      graphemeInfo.renderTop = info.y - startingPoint.y;
	      graphemeInfo.angle = info.angle + (this.pathSide ===  'right' ? Math.PI : 0);
	    },

	    /**
	     * Measure and return the info of a single grapheme.
	     * needs the the info of previous graphemes already filled
	     * @private
	     * @param {String} grapheme to be measured
	     * @param {Number} lineIndex index of the line where the char is
	     * @param {Number} charIndex position in the line
	     * @param {String} [prevGrapheme] character preceding the one to be measured
	     */
	    _getGraphemeBox: function(grapheme, lineIndex, charIndex, prevGrapheme, skipLeft) {
	      var style = this.getCompleteStyleDeclaration(lineIndex, charIndex),
	          prevStyle = prevGrapheme ? this.getCompleteStyleDeclaration(lineIndex, charIndex - 1) : { },
	          info = this._measureChar(grapheme, style, prevGrapheme, prevStyle),
	          kernedWidth = info.kernedWidth,
	          width = info.width, charSpacing;

	      if (this.charSpacing !== 0) {
	        charSpacing = this._getWidthOfCharSpacing();
	        width += charSpacing;
	        kernedWidth += charSpacing;
	      }

	      var box = {
	        width: width,
	        left: 0,
	        height: style.fontSize,
	        kernedWidth: kernedWidth,
	        deltaY: style.deltaY,
	      };
	      if (charIndex > 0 && !skipLeft) {
	        var previousBox = this.__charBounds[lineIndex][charIndex - 1];
	        box.left = previousBox.left + previousBox.width + info.kernedWidth - info.width;
	      }
	      return box;
	    },

	    /**
	     * Calculate height of line at 'lineIndex'
	     * @param {Number} lineIndex index of line to calculate
	     * @return {Number}
	     */
	    getHeightOfLine: function(lineIndex) {
	      if (this.__lineHeights[lineIndex]) {
	        return this.__lineHeights[lineIndex];
	      }

	      var line = this._textLines[lineIndex],
	          // char 0 is measured before the line cycle because it nneds to char
	          // emptylines
	          maxHeight = this.getHeightOfChar(lineIndex, 0);
	      for (var i = 1, len = line.length; i < len; i++) {
	        maxHeight = Math.max(this.getHeightOfChar(lineIndex, i), maxHeight);
	      }

	      return this.__lineHeights[lineIndex] = maxHeight * this.lineHeight * this._fontSizeMult;
	    },

	    /**
	     * Calculate text box height
	     */
	    calcTextHeight: function() {
	      var lineHeight, height = 0;
	      for (var i = 0, len = this._textLines.length; i < len; i++) {
	        lineHeight = this.getHeightOfLine(i);
	        height += (i === len - 1 ? lineHeight / this.lineHeight : lineHeight);
	      }
	      return height;
	    },

	    /**
	     * @private
	     * @return {Number} Left offset
	     */
	    _getLeftOffset: function() {
	      return this.direction === 'ltr' ? -this.width / 2 : this.width / 2;
	    },

	    /**
	     * @private
	     * @return {Number} Top offset
	     */
	    _getTopOffset: function() {
	      return -this.height / 2;
	    },

	    /**
	     * @private
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     * @param {String} method Method name ("fillText" or "strokeText")
	     */
	    _renderTextCommon: function(ctx, method) {
	      ctx.save();
	      var lineHeights = 0, left = this._getLeftOffset(), top = this._getTopOffset();
	      for (var i = 0, len = this._textLines.length; i < len; i++) {
	        var heightOfLine = this.getHeightOfLine(i),
	            maxHeight = heightOfLine / this.lineHeight,
	            leftOffset = this._getLineLeftOffset(i);
	        this._renderTextLine(
	          method,
	          ctx,
	          this._textLines[i],
	          left + leftOffset,
	          top + lineHeights + maxHeight,
	          i
	        );
	        lineHeights += heightOfLine;
	      }
	      ctx.restore();
	    },

	    /**
	     * @private
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    _renderTextFill: function(ctx) {
	      if (!this.fill && !this.styleHas('fill')) {
	        return;
	      }

	      this._renderTextCommon(ctx, 'fillText');
	    },

	    /**
	     * @private
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    _renderTextStroke: function(ctx) {
	      if ((!this.stroke || this.strokeWidth === 0) && this.isEmptyStyles()) {
	        return;
	      }

	      if (this.shadow && !this.shadow.affectStroke) {
	        this._removeShadow(ctx);
	      }

	      ctx.save();
	      this._setLineDash(ctx, this.strokeDashArray);
	      ctx.beginPath();
	      this._renderTextCommon(ctx, 'strokeText');
	      ctx.closePath();
	      ctx.restore();
	    },

	    /**
	     * @private
	     * @param {String} method fillText or strokeText.
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     * @param {Array} line Content of the line, splitted in an array by grapheme
	     * @param {Number} left
	     * @param {Number} top
	     * @param {Number} lineIndex
	     */
	    _renderChars: function(method, ctx, line, left, top, lineIndex) {
	      // set proper line offset
	      var lineHeight = this.getHeightOfLine(lineIndex),
	          isJustify = this.textAlign.indexOf('justify') !== -1,
	          actualStyle,
	          nextStyle,
	          charsToRender = '',
	          charBox,
	          boxWidth = 0,
	          timeToRender,
	          path = this.path,
	          shortCut = !isJustify && this.charSpacing === 0 && this.isEmptyStyles(lineIndex) && !path,
	          isLtr = this.direction === 'ltr', sign = this.direction === 'ltr' ? 1 : -1,
	          drawingLeft;

	      ctx.save();
	      top -= lineHeight * this._fontSizeFraction / this.lineHeight;
	      if (shortCut) {
	        // render all the line in one pass without checking
	        // drawingLeft = isLtr ? left : left - this.getLineWidth(lineIndex);
	        ctx.canvas.setAttribute('dir', isLtr ? 'ltr' : 'rtl');
	        ctx.direction = isLtr ? 'ltr' : 'rtl';
	        ctx.textAlign = isLtr ? 'left' : 'right';
	        this._renderChar(method, ctx, lineIndex, 0, line.join(''), left, top, lineHeight);
	        ctx.restore();
	        return;
	      }
	      for (var i = 0, len = line.length - 1; i <= len; i++) {
	        timeToRender = i === len || this.charSpacing || path;
	        charsToRender += line[i];
	        charBox = this.__charBounds[lineIndex][i];
	        if (boxWidth === 0) {
	          left += sign * (charBox.kernedWidth - charBox.width);
	          boxWidth += charBox.width;
	        }
	        else {
	          boxWidth += charBox.kernedWidth;
	        }
	        if (isJustify && !timeToRender) {
	          if (this._reSpaceAndTab.test(line[i])) {
	            timeToRender = true;
	          }
	        }
	        if (!timeToRender) {
	          // if we have charSpacing, we render char by char
	          actualStyle = actualStyle || this.getCompleteStyleDeclaration(lineIndex, i);
	          nextStyle = this.getCompleteStyleDeclaration(lineIndex, i + 1);
	          timeToRender = this._hasStyleChanged(actualStyle, nextStyle);
	        }
	        if (timeToRender) {
	          if (path) {
	            ctx.save();
	            ctx.translate(charBox.renderLeft, charBox.renderTop);
	            ctx.rotate(charBox.angle);
	            this._renderChar(method, ctx, lineIndex, i, charsToRender, -boxWidth / 2, 0, lineHeight);
	            ctx.restore();
	          }
	          else {
	            drawingLeft = left;
	            ctx.canvas.setAttribute('dir', isLtr ? 'ltr' : 'rtl');
	            ctx.direction = isLtr ? 'ltr' : 'rtl';
	            ctx.textAlign = isLtr ? 'left' : 'right';
	            this._renderChar(method, ctx, lineIndex, i, charsToRender, drawingLeft, top, lineHeight);
	          }
	          charsToRender = '';
	          actualStyle = nextStyle;
	          left += sign * boxWidth;
	          boxWidth = 0;
	        }
	      }
	      ctx.restore();
	    },

	    /**
	     * This function try to patch the missing gradientTransform on canvas gradients.
	     * transforming a context to transform the gradient, is going to transform the stroke too.
	     * we want to transform the gradient but not the stroke operation, so we create
	     * a transformed gradient on a pattern and then we use the pattern instead of the gradient.
	     * this method has drawbacks: is slow, is in low resolution, needs a patch for when the size
	     * is limited.
	     * @private
	     * @param {fabric.Gradient} filler a fabric gradient instance
	     * @return {CanvasPattern} a pattern to use as fill/stroke style
	     */
	    _applyPatternGradientTransformText: function(filler) {
	      var pCanvas = fabric.util.createCanvasElement(), pCtx,
	          // TODO: verify compatibility with strokeUniform
	          width = this.width + this.strokeWidth, height = this.height + this.strokeWidth;
	      pCanvas.width = width;
	      pCanvas.height = height;
	      pCtx = pCanvas.getContext('2d');
	      pCtx.beginPath(); pCtx.moveTo(0, 0); pCtx.lineTo(width, 0); pCtx.lineTo(width, height);
	      pCtx.lineTo(0, height); pCtx.closePath();
	      pCtx.translate(width / 2, height / 2);
	      pCtx.fillStyle = filler.toLive(pCtx);
	      this._applyPatternGradientTransform(pCtx, filler);
	      pCtx.fill();
	      return pCtx.createPattern(pCanvas, 'no-repeat');
	    },

	    handleFiller: function(ctx, property, filler) {
	      var offsetX, offsetY;
	      if (filler.toLive) {
	        if (filler.gradientUnits === 'percentage' || filler.gradientTransform || filler.patternTransform) {
	          // need to transform gradient in a pattern.
	          // this is a slow process. If you are hitting this codepath, and the object
	          // is not using caching, you should consider switching it on.
	          // we need a canvas as big as the current object caching canvas.
	          offsetX = -this.width / 2;
	          offsetY = -this.height / 2;
	          ctx.translate(offsetX, offsetY);
	          ctx[property] = this._applyPatternGradientTransformText(filler);
	          return { offsetX: offsetX, offsetY: offsetY };
	        }
	        else {
	          // is a simple gradient or pattern
	          ctx[property] = filler.toLive(ctx, this);
	          return this._applyPatternGradientTransform(ctx, filler);
	        }
	      }
	      else {
	        // is a color
	        ctx[property] = filler;
	      }
	      return { offsetX: 0, offsetY: 0 };
	    },

	    _setStrokeStyles: function(ctx, decl) {
	      ctx.lineWidth = decl.strokeWidth;
	      ctx.lineCap = this.strokeLineCap;
	      ctx.lineDashOffset = this.strokeDashOffset;
	      ctx.lineJoin = this.strokeLineJoin;
	      ctx.miterLimit = this.strokeMiterLimit;
	      return this.handleFiller(ctx, 'strokeStyle', decl.stroke);
	    },

	    _setFillStyles: function(ctx, decl) {
	      return this.handleFiller(ctx, 'fillStyle', decl.fill);
	    },

	    /**
	     * @private
	     * @param {String} method
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     * @param {Number} lineIndex
	     * @param {Number} charIndex
	     * @param {String} _char
	     * @param {Number} left Left coordinate
	     * @param {Number} top Top coordinate
	     * @param {Number} lineHeight Height of the line
	     */
	    _renderChar: function(method, ctx, lineIndex, charIndex, _char, left, top) {
	      var decl = this._getStyleDeclaration(lineIndex, charIndex),
	          fullDecl = this.getCompleteStyleDeclaration(lineIndex, charIndex),
	          shouldFill = method === 'fillText' && fullDecl.fill,
	          shouldStroke = method === 'strokeText' && fullDecl.stroke && fullDecl.strokeWidth,
	          fillOffsets, strokeOffsets;

	      if (!shouldStroke && !shouldFill) {
	        return;
	      }
	      ctx.save();

	      shouldFill && (fillOffsets = this._setFillStyles(ctx, fullDecl));
	      shouldStroke && (strokeOffsets = this._setStrokeStyles(ctx, fullDecl));

	      ctx.font = this._getFontDeclaration(fullDecl);


	      if (decl && decl.textBackgroundColor) {
	        this._removeShadow(ctx);
	      }
	      if (decl && decl.deltaY) {
	        top += decl.deltaY;
	      }
	      shouldFill && ctx.fillText(_char, left - fillOffsets.offsetX, top - fillOffsets.offsetY);
	      shouldStroke && ctx.strokeText(_char, left - strokeOffsets.offsetX, top - strokeOffsets.offsetY);
	      ctx.restore();
	    },

	    /**
	     * Turns the character into a 'superior figure' (i.e. 'superscript')
	     * @param {Number} start selection start
	     * @param {Number} end selection end
	     * @returns {fabric.Text} thisArg
	     * @chainable
	     */
	    setSuperscript: function(start, end) {
	      return this._setScript(start, end, this.superscript);
	    },

	    /**
	     * Turns the character into an 'inferior figure' (i.e. 'subscript')
	     * @param {Number} start selection start
	     * @param {Number} end selection end
	     * @returns {fabric.Text} thisArg
	     * @chainable
	     */
	    setSubscript: function(start, end) {
	      return this._setScript(start, end, this.subscript);
	    },

	    /**
	     * Applies 'schema' at given position
	     * @private
	     * @param {Number} start selection start
	     * @param {Number} end selection end
	     * @param {Number} schema
	     * @returns {fabric.Text} thisArg
	     * @chainable
	     */
	    _setScript: function(start, end, schema) {
	      var loc = this.get2DCursorLocation(start, true),
	          fontSize = this.getValueOfPropertyAt(loc.lineIndex, loc.charIndex, 'fontSize'),
	          dy = this.getValueOfPropertyAt(loc.lineIndex, loc.charIndex, 'deltaY'),
	          style = { fontSize: fontSize * schema.size, deltaY: dy + fontSize * schema.baseline };
	      this.setSelectionStyles(style, start, end);
	      return this;
	    },

	    /**
	     * @private
	     * @param {Object} prevStyle
	     * @param {Object} thisStyle
	     */
	    _hasStyleChanged: function(prevStyle, thisStyle) {
	      return prevStyle.fill !== thisStyle.fill ||
	              prevStyle.stroke !== thisStyle.stroke ||
	              prevStyle.strokeWidth !== thisStyle.strokeWidth ||
	              prevStyle.fontSize !== thisStyle.fontSize ||
	              prevStyle.fontFamily !== thisStyle.fontFamily ||
	              prevStyle.fontWeight !== thisStyle.fontWeight ||
	              prevStyle.fontStyle !== thisStyle.fontStyle ||
	              prevStyle.deltaY !== thisStyle.deltaY;
	    },

	    /**
	     * @private
	     * @param {Object} prevStyle
	     * @param {Object} thisStyle
	     */
	    _hasStyleChangedForSvg: function(prevStyle, thisStyle) {
	      return this._hasStyleChanged(prevStyle, thisStyle) ||
	        prevStyle.overline !== thisStyle.overline ||
	        prevStyle.underline !== thisStyle.underline ||
	        prevStyle.linethrough !== thisStyle.linethrough;
	    },

	    /**
	     * @private
	     * @param {Number} lineIndex index text line
	     * @return {Number} Line left offset
	     */
	    _getLineLeftOffset: function(lineIndex) {
	      var lineWidth = this.getLineWidth(lineIndex),
	          lineDiff = this.width - lineWidth, textAlign = this.textAlign, direction = this.direction,
	          isEndOfWrapping, leftOffset = 0, isEndOfWrapping = this.isEndOfWrapping(lineIndex);
	      if (textAlign === 'justify'
	        || (textAlign === 'justify-center' && !isEndOfWrapping)
	        || (textAlign === 'justify-right' && !isEndOfWrapping)
	        || (textAlign === 'justify-left' && !isEndOfWrapping)
	      ) {
	        return 0;
	      }
	      if (textAlign === 'center') {
	        leftOffset = lineDiff / 2;
	      }
	      if (textAlign === 'right') {
	        leftOffset = lineDiff;
	      }
	      if (textAlign === 'justify-center') {
	        leftOffset = lineDiff / 2;
	      }
	      if (textAlign === 'justify-right') {
	        leftOffset = lineDiff;
	      }
	      if (direction === 'rtl') {
	        leftOffset -= lineDiff;
	      }
	      return leftOffset;
	    },

	    /**
	     * @private
	     */
	    _clearCache: function() {
	      this.__lineWidths = [];
	      this.__lineHeights = [];
	      this.__charBounds = [];
	    },

	    /**
	     * @private
	     */
	    _shouldClearDimensionCache: function() {
	      var shouldClear = this._forceClearCache;
	      shouldClear || (shouldClear = this.hasStateChanged('_dimensionAffectingProps'));
	      if (shouldClear) {
	        this.dirty = true;
	        this._forceClearCache = false;
	      }
	      return shouldClear;
	    },

	    /**
	     * Measure a single line given its index. Used to calculate the initial
	     * text bounding box. The values are calculated and stored in __lineWidths cache.
	     * @private
	     * @param {Number} lineIndex line number
	     * @return {Number} Line width
	     */
	    getLineWidth: function(lineIndex) {
	      if (this.__lineWidths[lineIndex]) {
	        return this.__lineWidths[lineIndex];
	      }

	      var width, line = this._textLines[lineIndex], lineInfo;

	      if (line === '') {
	        width = 0;
	      }
	      else {
	        lineInfo = this.measureLine(lineIndex);
	        width = lineInfo.width;
	      }
	      this.__lineWidths[lineIndex] = width;
	      return width;
	    },

	    _getWidthOfCharSpacing: function() {
	      if (this.charSpacing !== 0) {
	        return this.fontSize * this.charSpacing / 1000;
	      }
	      return 0;
	    },

	    /**
	     * Retrieves the value of property at given character position
	     * @param {Number} lineIndex the line number
	     * @param {Number} charIndex the character number
	     * @param {String} property the property name
	     * @returns the value of 'property'
	     */
	    getValueOfPropertyAt: function(lineIndex, charIndex, property) {
	      var charStyle = this._getStyleDeclaration(lineIndex, charIndex);
	      if (charStyle && typeof charStyle[property] !== 'undefined') {
	        return charStyle[property];
	      }
	      return this[property];
	    },

	    /**
	     * @private
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    _renderTextDecoration: function(ctx, type) {
	      if (!this[type] && !this.styleHas(type)) {
	        return;
	      }
	      var heightOfLine, size, _size,
	          lineLeftOffset, dy, _dy,
	          line, lastDecoration,
	          leftOffset = this._getLeftOffset(),
	          topOffset = this._getTopOffset(), top,
	          boxStart, boxWidth, charBox, currentDecoration,
	          maxHeight, currentFill, lastFill, path = this.path,
	          charSpacing = this._getWidthOfCharSpacing(),
	          offsetY = this.offsets[type];

	      for (var i = 0, len = this._textLines.length; i < len; i++) {
	        heightOfLine = this.getHeightOfLine(i);
	        if (!this[type] && !this.styleHas(type, i)) {
	          topOffset += heightOfLine;
	          continue;
	        }
	        line = this._textLines[i];
	        maxHeight = heightOfLine / this.lineHeight;
	        lineLeftOffset = this._getLineLeftOffset(i);
	        boxStart = 0;
	        boxWidth = 0;
	        lastDecoration = this.getValueOfPropertyAt(i, 0, type);
	        lastFill = this.getValueOfPropertyAt(i, 0, 'fill');
	        top = topOffset + maxHeight * (1 - this._fontSizeFraction);
	        size = this.getHeightOfChar(i, 0);
	        dy = this.getValueOfPropertyAt(i, 0, 'deltaY');
	        for (var j = 0, jlen = line.length; j < jlen; j++) {
	          charBox = this.__charBounds[i][j];
	          currentDecoration = this.getValueOfPropertyAt(i, j, type);
	          currentFill = this.getValueOfPropertyAt(i, j, 'fill');
	          _size = this.getHeightOfChar(i, j);
	          _dy = this.getValueOfPropertyAt(i, j, 'deltaY');
	          if (path && currentDecoration && currentFill) {
	            ctx.save();
	            ctx.fillStyle = lastFill;
	            ctx.translate(charBox.renderLeft, charBox.renderTop);
	            ctx.rotate(charBox.angle);
	            ctx.fillRect(
	              -charBox.kernedWidth / 2,
	              offsetY * _size + _dy,
	              charBox.kernedWidth,
	              this.fontSize / 15
	            );
	            ctx.restore();
	          }
	          else if (
	            (currentDecoration !== lastDecoration || currentFill !== lastFill || _size !== size || _dy !== dy)
	            && boxWidth > 0
	          ) {
	            var drawStart = leftOffset + lineLeftOffset + boxStart;
	            if (this.direction === 'rtl') {
	              drawStart = this.width - drawStart - boxWidth;
	            }
	            if (lastDecoration && lastFill) {
	              ctx.fillStyle = lastFill;
	              ctx.fillRect(
	                drawStart,
	                top + offsetY * size + dy,
	                boxWidth,
	                this.fontSize / 15
	              );
	            }
	            boxStart = charBox.left;
	            boxWidth = charBox.width;
	            lastDecoration = currentDecoration;
	            lastFill = currentFill;
	            size = _size;
	            dy = _dy;
	          }
	          else {
	            boxWidth += charBox.kernedWidth;
	          }
	        }
	        var drawStart = leftOffset + lineLeftOffset + boxStart;
	        if (this.direction === 'rtl') {
	          drawStart = this.width - drawStart - boxWidth;
	        }
	        ctx.fillStyle = currentFill;
	        currentDecoration && currentFill && ctx.fillRect(
	          drawStart,
	          top + offsetY * size + dy,
	          boxWidth - charSpacing,
	          this.fontSize / 15
	        );
	        topOffset += heightOfLine;
	      }
	      // if there is text background color no
	      // other shadows should be casted
	      this._removeShadow(ctx);
	    },

	    /**
	     * return font declaration string for canvas context
	     * @param {Object} [styleObject] object
	     * @returns {String} font declaration formatted for canvas context.
	     */
	    _getFontDeclaration: function(styleObject, forMeasuring) {
	      var style = styleObject || this, family = this.fontFamily,
	          fontIsGeneric = fabric.Text.genericFonts.indexOf(family.toLowerCase()) > -1;
	      var fontFamily = family === undefined ||
	      family.indexOf('\'') > -1 || family.indexOf(',') > -1 ||
	      family.indexOf('"') > -1 || fontIsGeneric
	        ? style.fontFamily : '"' + style.fontFamily + '"';
	      return [
	        // node-canvas needs "weight style", while browsers need "style weight"
	        // verify if this can be fixed in JSDOM
	        (fabric.isLikelyNode ? style.fontWeight : style.fontStyle),
	        (fabric.isLikelyNode ? style.fontStyle : style.fontWeight),
	        forMeasuring ? this.CACHE_FONT_SIZE + 'px' : style.fontSize + 'px',
	        fontFamily
	      ].join(' ');
	    },

	    /**
	     * Renders text instance on a specified context
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    render: function(ctx) {
	      // do not render if object is not visible
	      if (!this.visible) {
	        return;
	      }
	      if (this.canvas && this.canvas.skipOffscreen && !this.group && !this.isOnScreen()) {
	        return;
	      }
	      if (this._shouldClearDimensionCache()) {
	        this.initDimensions();
	      }
	      this.callSuper('render', ctx);
	    },

	    /**
	     * Returns the text as an array of lines.
	     * @param {String} text text to split
	     * @returns {Array} Lines in the text
	     */
	    _splitTextIntoLines: function(text) {
	      var lines = text.split(this._reNewline),
	          newLines = new Array(lines.length),
	          newLine = ['\n'],
	          newText = [];
	      for (var i = 0; i < lines.length; i++) {
	        newLines[i] = fabric.util.string.graphemeSplit(lines[i]);
	        newText = newText.concat(newLines[i], newLine);
	      }
	      newText.pop();
	      return { _unwrappedLines: newLines, lines: lines, graphemeText: newText, graphemeLines: newLines };
	    },

	    /**
	     * Returns object representation of an instance
	     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
	     * @return {Object} Object representation of an instance
	     */
	    toObject: function(propertiesToInclude) {
	      var allProperties = additionalProps.concat(propertiesToInclude);
	      var obj = this.callSuper('toObject', allProperties);
	      // styles will be overridden with a properly cloned structure
	      obj.styles = clone(this.styles, true);
	      if (obj.path) {
	        obj.path = this.path.toObject();
	      }
	      return obj;
	    },

	    /**
	     * Sets property to a given value. When changing position/dimension -related properties (left, top, scale, angle, etc.) `set` does not update position of object's borders/controls. If you need to update those, call `setCoords()`.
	     * @param {String|Object} key Property name or object (if object, iterate over the object properties)
	     * @param {Object|Function} value Property value (if function, the value is passed into it and its return value is used as a new one)
	     * @return {fabric.Object} thisArg
	     * @chainable
	     */
	    set: function(key, value) {
	      this.callSuper('set', key, value);
	      var needsDims = false;
	      var isAddingPath = false;
	      if (typeof key === 'object') {
	        for (var _key in key) {
	          if (_key === 'path') {
	            this.setPathInfo();
	          }
	          needsDims = needsDims || this._dimensionAffectingProps.indexOf(_key) !== -1;
	          isAddingPath = isAddingPath || _key === 'path';
	        }
	      }
	      else {
	        needsDims = this._dimensionAffectingProps.indexOf(key) !== -1;
	        isAddingPath = key === 'path';
	      }
	      if (isAddingPath) {
	        this.setPathInfo();
	      }
	      if (needsDims) {
	        this.initDimensions();
	        this.setCoords();
	      }
	      return this;
	    },

	    /**
	     * Returns complexity of an instance
	     * @return {Number} complexity
	     */
	    complexity: function() {
	      return 1;
	    }
	  });

	  /* _FROM_SVG_START_ */
	  /**
	   * List of attribute names to account for when parsing SVG element (used by {@link fabric.Text.fromElement})
	   * @static
	   * @memberOf fabric.Text
	   * @see: http://www.w3.org/TR/SVG/text.html#TextElement
	   */
	  fabric.Text.ATTRIBUTE_NAMES = fabric.SHARED_ATTRIBUTES.concat(
	    'x y dx dy font-family font-style font-weight font-size letter-spacing text-decoration text-anchor'.split(' '));

	  /**
	   * Default SVG font size
	   * @static
	   * @memberOf fabric.Text
	   */
	  fabric.Text.DEFAULT_SVG_FONT_SIZE = 16;

	  /**
	   * Returns fabric.Text instance from an SVG element (<b>not yet implemented</b>)
	   * @static
	   * @memberOf fabric.Text
	   * @param {SVGElement} element Element to parse
	   * @param {Function} callback callback function invoked after parsing
	   * @param {Object} [options] Options object
	   */
	  fabric.Text.fromElement = function(element, callback, options) {
	    if (!element) {
	      return callback(null);
	    }

	    var parsedAttributes = fabric.parseAttributes(element, fabric.Text.ATTRIBUTE_NAMES),
	        parsedAnchor = parsedAttributes.textAnchor || 'left';
	    options = fabric.util.object.extend((options ? clone(options) : { }), parsedAttributes);

	    options.top = options.top || 0;
	    options.left = options.left || 0;
	    if (parsedAttributes.textDecoration) {
	      var textDecoration = parsedAttributes.textDecoration;
	      if (textDecoration.indexOf('underline') !== -1) {
	        options.underline = true;
	      }
	      if (textDecoration.indexOf('overline') !== -1) {
	        options.overline = true;
	      }
	      if (textDecoration.indexOf('line-through') !== -1) {
	        options.linethrough = true;
	      }
	      delete options.textDecoration;
	    }
	    if ('dx' in parsedAttributes) {
	      options.left += parsedAttributes.dx;
	    }
	    if ('dy' in parsedAttributes) {
	      options.top += parsedAttributes.dy;
	    }
	    if (!('fontSize' in options)) {
	      options.fontSize = fabric.Text.DEFAULT_SVG_FONT_SIZE;
	    }

	    var textContent = '';

	    // The XML is not properly parsed in IE9 so a workaround to get
	    // textContent is through firstChild.data. Another workaround would be
	    // to convert XML loaded from a file to be converted using DOMParser (same way loadSVGFromString() does)
	    if (!('textContent' in element)) {
	      if ('firstChild' in element && element.firstChild !== null) {
	        if ('data' in element.firstChild && element.firstChild.data !== null) {
	          textContent = element.firstChild.data;
	        }
	      }
	    }
	    else {
	      textContent = element.textContent;
	    }

	    textContent = textContent.replace(/^\s+|\s+$|\n+/g, '').replace(/\s+/g, ' ');
	    var originalStrokeWidth = options.strokeWidth;
	    options.strokeWidth = 0;

	    var text = new fabric.Text(textContent, options),
	        textHeightScaleFactor = text.getScaledHeight() / text.height,
	        lineHeightDiff = (text.height + text.strokeWidth) * text.lineHeight - text.height,
	        scaledDiff = lineHeightDiff * textHeightScaleFactor,
	        textHeight = text.getScaledHeight() + scaledDiff,
	        offX = 0;
	    /*
	      Adjust positioning:
	        x/y attributes in SVG correspond to the bottom-left corner of text bounding box
	        fabric output by default at top, left.
	    */
	    if (parsedAnchor === 'center') {
	      offX = text.getScaledWidth() / 2;
	    }
	    if (parsedAnchor === 'right') {
	      offX = text.getScaledWidth();
	    }
	    text.set({
	      left: text.left - offX,
	      top: text.top - (textHeight - text.fontSize * (0.07 + text._fontSizeFraction)) / text.lineHeight,
	      strokeWidth: typeof originalStrokeWidth !== 'undefined' ? originalStrokeWidth : 1,
	    });
	    callback(text);
	  };
	  /* _FROM_SVG_END_ */

	  /**
	   * Returns fabric.Text instance from an object representation
	   * @static
	   * @memberOf fabric.Text
	   * @param {Object} object plain js Object to create an instance from
	   * @param {Function} [callback] Callback to invoke when an fabric.Text instance is created
	   */
	  fabric.Text.fromObject = function(object, callback) {
	    var objectCopy = clone(object), path = object.path;
	    delete objectCopy.path;
	    return fabric.Object._fromObject('Text', objectCopy, function(textInstance) {
	      if (path) {
	        fabric.Object._fromObject('Path', path, function(pathInstance) {
	          textInstance.set('path', pathInstance);
	          callback(textInstance);
	        }, 'path');
	      }
	      else {
	        callback(textInstance);
	      }
	    }, 'text');
	  };

	  fabric.Text.genericFonts = ['sans-serif', 'serif', 'cursive', 'fantasy', 'monospace'];

	  fabric.util.createAccessors && fabric.util.createAccessors(fabric.Text);

	})(exports );


	(function() {
	  fabric.util.object.extend(fabric.Text.prototype, /** @lends fabric.Text.prototype */ {
	    /**
	     * Returns true if object has no styling or no styling in a line
	     * @param {Number} lineIndex , lineIndex is on wrapped lines.
	     * @return {Boolean}
	     */
	    isEmptyStyles: function(lineIndex) {
	      if (!this.styles) {
	        return true;
	      }
	      if (typeof lineIndex !== 'undefined' && !this.styles[lineIndex]) {
	        return true;
	      }
	      var obj = typeof lineIndex === 'undefined' ? this.styles : { line: this.styles[lineIndex] };
	      for (var p1 in obj) {
	        for (var p2 in obj[p1]) {
	          // eslint-disable-next-line no-unused-vars
	          for (var p3 in obj[p1][p2]) {
	            return false;
	          }
	        }
	      }
	      return true;
	    },

	    /**
	     * Returns true if object has a style property or has it ina specified line
	     * This function is used to detect if a text will use a particular property or not.
	     * @param {String} property to check for
	     * @param {Number} lineIndex to check the style on
	     * @return {Boolean}
	     */
	    styleHas: function(property, lineIndex) {
	      if (!this.styles || !property || property === '') {
	        return false;
	      }
	      if (typeof lineIndex !== 'undefined' && !this.styles[lineIndex]) {
	        return false;
	      }
	      var obj = typeof lineIndex === 'undefined' ? this.styles : { 0: this.styles[lineIndex] };
	      // eslint-disable-next-line
	      for (var p1 in obj) {
	        // eslint-disable-next-line
	        for (var p2 in obj[p1]) {
	          if (typeof obj[p1][p2][property] !== 'undefined') {
	            return true;
	          }
	        }
	      }
	      return false;
	    },

	    /**
	     * Check if characters in a text have a value for a property
	     * whose value matches the textbox's value for that property.  If so,
	     * the character-level property is deleted.  If the character
	     * has no other properties, then it is also deleted.  Finally,
	     * if the line containing that character has no other characters
	     * then it also is deleted.
	     *
	     * @param {string} property The property to compare between characters and text.
	     */
	    cleanStyle: function(property) {
	      if (!this.styles || !property || property === '') {
	        return false;
	      }
	      var obj = this.styles, stylesCount = 0, letterCount, stylePropertyValue,
	          allStyleObjectPropertiesMatch = true, graphemeCount = 0, styleObject;
	      // eslint-disable-next-line
	      for (var p1 in obj) {
	        letterCount = 0;
	        // eslint-disable-next-line
	        for (var p2 in obj[p1]) {
	          var styleObject = obj[p1][p2],
	              stylePropertyHasBeenSet = styleObject.hasOwnProperty(property);

	          stylesCount++;

	          if (stylePropertyHasBeenSet) {
	            if (!stylePropertyValue) {
	              stylePropertyValue = styleObject[property];
	            }
	            else if (styleObject[property] !== stylePropertyValue) {
	              allStyleObjectPropertiesMatch = false;
	            }

	            if (styleObject[property] === this[property]) {
	              delete styleObject[property];
	            }
	          }
	          else {
	            allStyleObjectPropertiesMatch = false;
	          }

	          if (Object.keys(styleObject).length !== 0) {
	            letterCount++;
	          }
	          else {
	            delete obj[p1][p2];
	          }
	        }

	        if (letterCount === 0) {
	          delete obj[p1];
	        }
	      }
	      // if every grapheme has the same style set then
	      // delete those styles and set it on the parent
	      for (var i = 0; i < this._textLines.length; i++) {
	        graphemeCount += this._textLines[i].length;
	      }
	      if (allStyleObjectPropertiesMatch && stylesCount === graphemeCount) {
	        this[property] = stylePropertyValue;
	        this.removeStyle(property);
	      }
	    },

	    /**
	     * Remove a style property or properties from all individual character styles
	     * in a text object.  Deletes the character style object if it contains no other style
	     * props.  Deletes a line style object if it contains no other character styles.
	     *
	     * @param {String} props The property to remove from character styles.
	     */
	    removeStyle: function(property) {
	      if (!this.styles || !property || property === '') {
	        return;
	      }
	      var obj = this.styles, line, lineNum, charNum;
	      for (lineNum in obj) {
	        line = obj[lineNum];
	        for (charNum in line) {
	          delete line[charNum][property];
	          if (Object.keys(line[charNum]).length === 0) {
	            delete line[charNum];
	          }
	        }
	        if (Object.keys(line).length === 0) {
	          delete obj[lineNum];
	        }
	      }
	    },

	    /**
	     * @private
	     */
	    _extendStyles: function(index, styles) {
	      var loc = this.get2DCursorLocation(index);

	      if (!this._getLineStyle(loc.lineIndex)) {
	        this._setLineStyle(loc.lineIndex);
	      }

	      if (!this._getStyleDeclaration(loc.lineIndex, loc.charIndex)) {
	        this._setStyleDeclaration(loc.lineIndex, loc.charIndex, {});
	      }

	      fabric.util.object.extend(this._getStyleDeclaration(loc.lineIndex, loc.charIndex), styles);
	    },

	    /**
	     * Returns 2d representation (lineIndex and charIndex) of cursor (or selection start)
	     * @param {Number} [selectionStart] Optional index. When not given, current selectionStart is used.
	     * @param {Boolean} [skipWrapping] consider the location for unwrapped lines. useful to manage styles.
	     */
	    get2DCursorLocation: function(selectionStart, skipWrapping) {
	      if (typeof selectionStart === 'undefined') {
	        selectionStart = this.selectionStart;
	      }
	      var lines = skipWrapping ? this._unwrappedTextLines : this._textLines,
	          len = lines.length;
	      for (var i = 0; i < len; i++) {
	        if (selectionStart <= lines[i].length) {
	          return {
	            lineIndex: i,
	            charIndex: selectionStart
	          };
	        }
	        selectionStart -= lines[i].length + this.missingNewlineOffset(i);
	      }
	      return {
	        lineIndex: i - 1,
	        charIndex: lines[i - 1].length < selectionStart ? lines[i - 1].length : selectionStart
	      };
	    },

	    /**
	     * Gets style of a current selection/cursor (at the start position)
	     * if startIndex or endIndex are not provided, selectionStart or selectionEnd will be used.
	     * @param {Number} [startIndex] Start index to get styles at
	     * @param {Number} [endIndex] End index to get styles at, if not specified selectionEnd or startIndex + 1
	     * @param {Boolean} [complete] get full style or not
	     * @return {Array} styles an array with one, zero or more Style objects
	     */
	    getSelectionStyles: function(startIndex, endIndex, complete) {
	      if (typeof startIndex === 'undefined') {
	        startIndex = this.selectionStart || 0;
	      }
	      if (typeof endIndex === 'undefined') {
	        endIndex = this.selectionEnd || startIndex;
	      }
	      var styles = [];
	      for (var i = startIndex; i < endIndex; i++) {
	        styles.push(this.getStyleAtPosition(i, complete));
	      }
	      return styles;
	    },

	    /**
	     * Gets style of a current selection/cursor position
	     * @param {Number} position  to get styles at
	     * @param {Boolean} [complete] full style if true
	     * @return {Object} style Style object at a specified index
	     * @private
	     */
	    getStyleAtPosition: function(position, complete) {
	      var loc = this.get2DCursorLocation(position),
	          style = complete ? this.getCompleteStyleDeclaration(loc.lineIndex, loc.charIndex) :
	            this._getStyleDeclaration(loc.lineIndex, loc.charIndex);
	      return style || {};
	    },

	    /**
	     * Sets style of a current selection, if no selection exist, do not set anything.
	     * @param {Object} [styles] Styles object
	     * @param {Number} [startIndex] Start index to get styles at
	     * @param {Number} [endIndex] End index to get styles at, if not specified selectionEnd or startIndex + 1
	     * @return {fabric.IText} thisArg
	     * @chainable
	     */
	    setSelectionStyles: function(styles, startIndex, endIndex) {
	      if (typeof startIndex === 'undefined') {
	        startIndex = this.selectionStart || 0;
	      }
	      if (typeof endIndex === 'undefined') {
	        endIndex = this.selectionEnd || startIndex;
	      }
	      for (var i = startIndex; i < endIndex; i++) {
	        this._extendStyles(i, styles);
	      }
	      /* not included in _extendStyles to avoid clearing cache more than once */
	      this._forceClearCache = true;
	      return this;
	    },

	    /**
	     * get the reference, not a clone, of the style object for a given character
	     * @param {Number} lineIndex
	     * @param {Number} charIndex
	     * @return {Object} style object
	     */
	    _getStyleDeclaration: function(lineIndex, charIndex) {
	      var lineStyle = this.styles && this.styles[lineIndex];
	      if (!lineStyle) {
	        return null;
	      }
	      return lineStyle[charIndex];
	    },

	    /**
	     * return a new object that contains all the style property for a character
	     * the object returned is newly created
	     * @param {Number} lineIndex of the line where the character is
	     * @param {Number} charIndex position of the character on the line
	     * @return {Object} style object
	     */
	    getCompleteStyleDeclaration: function(lineIndex, charIndex) {
	      var style = this._getStyleDeclaration(lineIndex, charIndex) || { },
	          styleObject = { }, prop;
	      for (var i = 0; i < this._styleProperties.length; i++) {
	        prop = this._styleProperties[i];
	        styleObject[prop] = typeof style[prop] === 'undefined' ? this[prop] : style[prop];
	      }
	      return styleObject;
	    },

	    /**
	     * @param {Number} lineIndex
	     * @param {Number} charIndex
	     * @param {Object} style
	     * @private
	     */
	    _setStyleDeclaration: function(lineIndex, charIndex, style) {
	      this.styles[lineIndex][charIndex] = style;
	    },

	    /**
	     *
	     * @param {Number} lineIndex
	     * @param {Number} charIndex
	     * @private
	     */
	    _deleteStyleDeclaration: function(lineIndex, charIndex) {
	      delete this.styles[lineIndex][charIndex];
	    },

	    /**
	     * @param {Number} lineIndex
	     * @return {Boolean} if the line exists or not
	     * @private
	     */
	    _getLineStyle: function(lineIndex) {
	      return !!this.styles[lineIndex];
	    },

	    /**
	     * Set the line style to an empty object so that is initialized
	     * @param {Number} lineIndex
	     * @private
	     */
	    _setLineStyle: function(lineIndex) {
	      this.styles[lineIndex] = {};
	    },

	    /**
	     * @param {Number} lineIndex
	     * @private
	     */
	    _deleteLineStyle: function(lineIndex) {
	      delete this.styles[lineIndex];
	    }
	  });
	})();


	(function() {

	  function parseDecoration(object) {
	    if (object.textDecoration) {
	      object.textDecoration.indexOf('underline') > -1 && (object.underline = true);
	      object.textDecoration.indexOf('line-through') > -1 && (object.linethrough = true);
	      object.textDecoration.indexOf('overline') > -1 && (object.overline = true);
	      delete object.textDecoration;
	    }
	  }

	  /**
	   * IText class (introduced in <b>v1.4</b>) Events are also fired with "text:"
	   * prefix when observing canvas.
	   * @class fabric.IText
	   * @extends fabric.Text
	   * @mixes fabric.Observable
	   *
	   * @fires changed
	   * @fires selection:changed
	   * @fires editing:entered
	   * @fires editing:exited
	   *
	   * @return {fabric.IText} thisArg
	   * @see {@link fabric.IText#initialize} for constructor definition
	   *
	   * <p>Supported key combinations:</p>
	   * <pre>
	   *   Move cursor:                    left, right, up, down
	   *   Select character:               shift + left, shift + right
	   *   Select text vertically:         shift + up, shift + down
	   *   Move cursor by word:            alt + left, alt + right
	   *   Select words:                   shift + alt + left, shift + alt + right
	   *   Move cursor to line start/end:  cmd + left, cmd + right or home, end
	   *   Select till start/end of line:  cmd + shift + left, cmd + shift + right or shift + home, shift + end
	   *   Jump to start/end of text:      cmd + up, cmd + down
	   *   Select till start/end of text:  cmd + shift + up, cmd + shift + down or shift + pgUp, shift + pgDown
	   *   Delete character:               backspace
	   *   Delete word:                    alt + backspace
	   *   Delete line:                    cmd + backspace
	   *   Forward delete:                 delete
	   *   Copy text:                      ctrl/cmd + c
	   *   Paste text:                     ctrl/cmd + v
	   *   Cut text:                       ctrl/cmd + x
	   *   Select entire text:             ctrl/cmd + a
	   *   Quit editing                    tab or esc
	   * </pre>
	   *
	   * <p>Supported mouse/touch combination</p>
	   * <pre>
	   *   Position cursor:                click/touch
	   *   Create selection:               click/touch & drag
	   *   Create selection:               click & shift + click
	   *   Select word:                    double click
	   *   Select line:                    triple click
	   * </pre>
	   */
	  fabric.IText = fabric.util.createClass(fabric.Text, fabric.Observable, /** @lends fabric.IText.prototype */ {

	    /**
	     * Type of an object
	     * @type String
	     * @default
	     */
	    type: 'i-text',

	    /**
	     * Index where text selection starts (or where cursor is when there is no selection)
	     * @type Number
	     * @default
	     */
	    selectionStart: 0,

	    /**
	     * Index where text selection ends
	     * @type Number
	     * @default
	     */
	    selectionEnd: 0,

	    /**
	     * Color of text selection
	     * @type String
	     * @default
	     */
	    selectionColor: 'rgba(17,119,255,0.3)',

	    /**
	     * Indicates whether text is in editing mode
	     * @type Boolean
	     * @default
	     */
	    isEditing: false,

	    /**
	     * Indicates whether a text can be edited
	     * @type Boolean
	     * @default
	     */
	    editable: true,

	    /**
	     * Border color of text object while it's in editing mode
	     * @type String
	     * @default
	     */
	    editingBorderColor: 'rgba(102,153,255,0.25)',

	    /**
	     * Width of cursor (in px)
	     * @type Number
	     * @default
	     */
	    cursorWidth: 2,

	    /**
	     * Color of text cursor color in editing mode.
	     * if not set (default) will take color from the text.
	     * if set to a color value that fabric can understand, it will
	     * be used instead of the color of the text at the current position.
	     * @type String
	     * @default
	     */
	    cursorColor: '',

	    /**
	     * Delay between cursor blink (in ms)
	     * @type Number
	     * @default
	     */
	    cursorDelay: 1000,

	    /**
	     * Duration of cursor fadein (in ms)
	     * @type Number
	     * @default
	     */
	    cursorDuration: 600,

	    /**
	     * Indicates whether internal text char widths can be cached
	     * @type Boolean
	     * @default
	     */
	    caching: true,

	    /**
	     * DOM container to append the hiddenTextarea.
	     * An alternative to attaching to the document.body.
	     * Useful to reduce laggish redraw of the full document.body tree and
	     * also with modals event capturing that won't let the textarea take focus.
	     * @type HTMLElement
	     * @default
	     */
	    hiddenTextareaContainer: null,

	    /**
	     * @private
	     */
	    _reSpace: /\s|\n/,

	    /**
	     * @private
	     */
	    _currentCursorOpacity: 0,

	    /**
	     * @private
	     */
	    _selectionDirection: null,

	    /**
	     * @private
	     */
	    _abortCursorAnimation: false,

	    /**
	     * @private
	     */
	    __widthOfSpace: [],

	    /**
	     * Helps determining when the text is in composition, so that the cursor
	     * rendering is altered.
	     */
	    inCompositionMode: false,

	    /**
	     * Constructor
	     * @param {String} text Text string
	     * @param {Object} [options] Options object
	     * @return {fabric.IText} thisArg
	     */
	    initialize: function(text, options) {
	      this.callSuper('initialize', text, options);
	      this.initBehavior();
	    },

	    /**
	     * Sets selection start (left boundary of a selection)
	     * @param {Number} index Index to set selection start to
	     */
	    setSelectionStart: function(index) {
	      index = Math.max(index, 0);
	      this._updateAndFire('selectionStart', index);
	    },

	    /**
	     * Sets selection end (right boundary of a selection)
	     * @param {Number} index Index to set selection end to
	     */
	    setSelectionEnd: function(index) {
	      index = Math.min(index, this.text.length);
	      this._updateAndFire('selectionEnd', index);
	    },

	    /**
	     * @private
	     * @param {String} property 'selectionStart' or 'selectionEnd'
	     * @param {Number} index new position of property
	     */
	    _updateAndFire: function(property, index) {
	      if (this[property] !== index) {
	        this._fireSelectionChanged();
	        this[property] = index;
	      }
	      this._updateTextarea();
	    },

	    /**
	     * Fires the even of selection changed
	     * @private
	     */
	    _fireSelectionChanged: function() {
	      this.fire('selection:changed');
	      this.canvas && this.canvas.fire('text:selection:changed', { target: this });
	    },

	    /**
	     * Initialize text dimensions. Render all text on given context
	     * or on a offscreen canvas to get the text width with measureText.
	     * Updates this.width and this.height with the proper values.
	     * Does not return dimensions.
	     * @private
	     */
	    initDimensions: function() {
	      this.isEditing && this.initDelayedCursor();
	      this.clearContextTop();
	      this.callSuper('initDimensions');
	    },

	    /**
	     * @private
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    render: function(ctx) {
	      this.clearContextTop();
	      this.callSuper('render', ctx);
	      // clear the cursorOffsetCache, so we ensure to calculate once per renderCursor
	      // the correct position but not at every cursor animation.
	      this.cursorOffsetCache = { };
	      this.renderCursorOrSelection();
	    },

	    /**
	     * @private
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    _render: function(ctx) {
	      this.callSuper('_render', ctx);
	    },

	    /**
	     * Prepare and clean the contextTop
	     */
	    clearContextTop: function(skipRestore) {
	      if (!this.isEditing || !this.canvas || !this.canvas.contextTop) {
	        return;
	      }
	      var ctx = this.canvas.contextTop, v = this.canvas.viewportTransform;
	      ctx.save();
	      ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
	      this.transform(ctx);
	      this._clearTextArea(ctx);
	      skipRestore || ctx.restore();
	    },
	    /**
	     * Renders cursor or selection (depending on what exists)
	     * it does on the contextTop. If contextTop is not available, do nothing.
	     */
	    renderCursorOrSelection: function() {
	      if (!this.isEditing || !this.canvas || !this.canvas.contextTop) {
	        return;
	      }
	      var boundaries = this._getCursorBoundaries(),
	          ctx = this.canvas.contextTop;
	      this.clearContextTop(true);
	      if (this.selectionStart === this.selectionEnd) {
	        this.renderCursor(boundaries, ctx);
	      }
	      else {
	        this.renderSelection(boundaries, ctx);
	      }
	      ctx.restore();
	    },

	    _clearTextArea: function(ctx) {
	      // we add 4 pixel, to be sure to do not leave any pixel out
	      var width = this.width + 4, height = this.height + 4;
	      ctx.clearRect(-width / 2, -height / 2, width, height);
	    },

	    /**
	     * Returns cursor boundaries (left, top, leftOffset, topOffset)
	     * @private
	     * @param {Array} chars Array of characters
	     * @param {String} typeOfBoundaries
	     */
	    _getCursorBoundaries: function(position) {

	      // left/top are left/top of entire text box
	      // leftOffset/topOffset are offset from that left/top point of a text box

	      if (typeof position === 'undefined') {
	        position = this.selectionStart;
	      }

	      var left = this._getLeftOffset(),
	          top = this._getTopOffset(),
	          offsets = this._getCursorBoundariesOffsets(position);
	      return {
	        left: left,
	        top: top,
	        leftOffset: offsets.left,
	        topOffset: offsets.top
	      };
	    },

	    /**
	     * @private
	     */
	    _getCursorBoundariesOffsets: function(position) {
	      if (this.cursorOffsetCache && 'top' in this.cursorOffsetCache) {
	        return this.cursorOffsetCache;
	      }
	      var lineLeftOffset,
	          lineIndex,
	          charIndex,
	          topOffset = 0,
	          leftOffset = 0,
	          boundaries,
	          cursorPosition = this.get2DCursorLocation(position);
	      charIndex = cursorPosition.charIndex;
	      lineIndex = cursorPosition.lineIndex;
	      for (var i = 0; i < lineIndex; i++) {
	        topOffset += this.getHeightOfLine(i);
	      }
	      lineLeftOffset = this._getLineLeftOffset(lineIndex);
	      var bound = this.__charBounds[lineIndex][charIndex];
	      bound && (leftOffset = bound.left);
	      if (this.charSpacing !== 0 && charIndex === this._textLines[lineIndex].length) {
	        leftOffset -= this._getWidthOfCharSpacing();
	      }
	      boundaries = {
	        top: topOffset,
	        left: lineLeftOffset + (leftOffset > 0 ? leftOffset : 0),
	      };
	      if (this.direction === 'rtl') {
	        boundaries.left *= -1;
	      }
	      this.cursorOffsetCache = boundaries;
	      return this.cursorOffsetCache;
	    },

	    /**
	     * Renders cursor
	     * @param {Object} boundaries
	     * @param {CanvasRenderingContext2D} ctx transformed context to draw on
	     */
	    renderCursor: function(boundaries, ctx) {
	      var cursorLocation = this.get2DCursorLocation(),
	          lineIndex = cursorLocation.lineIndex,
	          charIndex = cursorLocation.charIndex > 0 ? cursorLocation.charIndex - 1 : 0,
	          charHeight = this.getValueOfPropertyAt(lineIndex, charIndex, 'fontSize'),
	          multiplier = this.scaleX * this.canvas.getZoom(),
	          cursorWidth = this.cursorWidth / multiplier,
	          topOffset = boundaries.topOffset,
	          dy = this.getValueOfPropertyAt(lineIndex, charIndex, 'deltaY');
	      topOffset += (1 - this._fontSizeFraction) * this.getHeightOfLine(lineIndex) / this.lineHeight
	        - charHeight * (1 - this._fontSizeFraction);

	      if (this.inCompositionMode) {
	        this.renderSelection(boundaries, ctx);
	      }
	      ctx.fillStyle = this.cursorColor || this.getValueOfPropertyAt(lineIndex, charIndex, 'fill');
	      ctx.globalAlpha = this.__isMousedown ? 1 : this._currentCursorOpacity;
	      ctx.fillRect(
	        boundaries.left + boundaries.leftOffset - cursorWidth / 2,
	        topOffset + boundaries.top + dy,
	        cursorWidth,
	        charHeight);
	    },

	    /**
	     * Renders text selection
	     * @param {Object} boundaries Object with left/top/leftOffset/topOffset
	     * @param {CanvasRenderingContext2D} ctx transformed context to draw on
	     */
	    renderSelection: function(boundaries, ctx) {

	      var selectionStart = this.inCompositionMode ? this.hiddenTextarea.selectionStart : this.selectionStart,
	          selectionEnd = this.inCompositionMode ? this.hiddenTextarea.selectionEnd : this.selectionEnd,
	          isJustify = this.textAlign.indexOf('justify') !== -1,
	          start = this.get2DCursorLocation(selectionStart),
	          end = this.get2DCursorLocation(selectionEnd),
	          startLine = start.lineIndex,
	          endLine = end.lineIndex,
	          startChar = start.charIndex < 0 ? 0 : start.charIndex,
	          endChar = end.charIndex < 0 ? 0 : end.charIndex;

	      for (var i = startLine; i <= endLine; i++) {
	        var lineOffset = this._getLineLeftOffset(i) || 0,
	            lineHeight = this.getHeightOfLine(i),
	            realLineHeight = 0, boxStart = 0, boxEnd = 0;

	        if (i === startLine) {
	          boxStart = this.__charBounds[startLine][startChar].left;
	        }
	        if (i >= startLine && i < endLine) {
	          boxEnd = isJustify && !this.isEndOfWrapping(i) ? this.width : this.getLineWidth(i) || 5; // WTF is this 5?
	        }
	        else if (i === endLine) {
	          if (endChar === 0) {
	            boxEnd = this.__charBounds[endLine][endChar].left;
	          }
	          else {
	            var charSpacing = this._getWidthOfCharSpacing();
	            boxEnd = this.__charBounds[endLine][endChar - 1].left
	              + this.__charBounds[endLine][endChar - 1].width - charSpacing;
	          }
	        }
	        realLineHeight = lineHeight;
	        if (this.lineHeight < 1 || (i === endLine && this.lineHeight > 1)) {
	          lineHeight /= this.lineHeight;
	        }
	        var drawStart = boundaries.left + lineOffset + boxStart,
	            drawWidth = boxEnd - boxStart,
	            drawHeight = lineHeight, extraTop = 0;
	        if (this.inCompositionMode) {
	          ctx.fillStyle = this.compositionColor || 'black';
	          drawHeight = 1;
	          extraTop = lineHeight;
	        }
	        else {
	          ctx.fillStyle = this.selectionColor;
	        }
	        if (this.direction === 'rtl') {
	          drawStart = this.width - drawStart - drawWidth;
	        }
	        ctx.fillRect(
	          drawStart,
	          boundaries.top + boundaries.topOffset + extraTop,
	          drawWidth,
	          drawHeight);
	        boundaries.topOffset += realLineHeight;
	      }
	    },

	    /**
	     * High level function to know the height of the cursor.
	     * the currentChar is the one that precedes the cursor
	     * Returns fontSize of char at the current cursor
	     * Unused from the library, is for the end user
	     * @return {Number} Character font size
	     */
	    getCurrentCharFontSize: function() {
	      var cp = this._getCurrentCharIndex();
	      return this.getValueOfPropertyAt(cp.l, cp.c, 'fontSize');
	    },

	    /**
	     * High level function to know the color of the cursor.
	     * the currentChar is the one that precedes the cursor
	     * Returns color (fill) of char at the current cursor
	     * if the text object has a pattern or gradient for filler, it will return that.
	     * Unused by the library, is for the end user
	     * @return {String | fabric.Gradient | fabric.Pattern} Character color (fill)
	     */
	    getCurrentCharColor: function() {
	      var cp = this._getCurrentCharIndex();
	      return this.getValueOfPropertyAt(cp.l, cp.c, 'fill');
	    },

	    /**
	     * Returns the cursor position for the getCurrent.. functions
	     * @private
	     */
	    _getCurrentCharIndex: function() {
	      var cursorPosition = this.get2DCursorLocation(this.selectionStart, true),
	          charIndex = cursorPosition.charIndex > 0 ? cursorPosition.charIndex - 1 : 0;
	      return { l: cursorPosition.lineIndex, c: charIndex };
	    }
	  });

	  /**
	   * Returns fabric.IText instance from an object representation
	   * @static
	   * @memberOf fabric.IText
	   * @param {Object} object Object to create an instance from
	   * @param {function} [callback] invoked with new instance as argument
	   */
	  fabric.IText.fromObject = function(object, callback) {
	    parseDecoration(object);
	    if (object.styles) {
	      for (var i in object.styles) {
	        for (var j in object.styles[i]) {
	          parseDecoration(object.styles[i][j]);
	        }
	      }
	    }
	    fabric.Object._fromObject('IText', object, callback, 'text');
	  };
	})();


	(function() {

	  var clone = fabric.util.object.clone;

	  fabric.util.object.extend(fabric.IText.prototype, /** @lends fabric.IText.prototype */ {

	    /**
	     * Initializes all the interactive behavior of IText
	     */
	    initBehavior: function() {
	      this.initAddedHandler();
	      this.initRemovedHandler();
	      this.initCursorSelectionHandlers();
	      this.initDoubleClickSimulation();
	      this.mouseMoveHandler = this.mouseMoveHandler.bind(this);
	    },

	    onDeselect: function() {
	      this.isEditing && this.exitEditing();
	      this.selected = false;
	    },

	    /**
	     * Initializes "added" event handler
	     */
	    initAddedHandler: function() {
	      var _this = this;
	      this.on('added', function() {
	        var canvas = _this.canvas;
	        if (canvas) {
	          if (!canvas._hasITextHandlers) {
	            canvas._hasITextHandlers = true;
	            _this._initCanvasHandlers(canvas);
	          }
	          canvas._iTextInstances = canvas._iTextInstances || [];
	          canvas._iTextInstances.push(_this);
	        }
	      });
	    },

	    initRemovedHandler: function() {
	      var _this = this;
	      this.on('removed', function() {
	        var canvas = _this.canvas;
	        if (canvas) {
	          canvas._iTextInstances = canvas._iTextInstances || [];
	          fabric.util.removeFromArray(canvas._iTextInstances, _this);
	          if (canvas._iTextInstances.length === 0) {
	            canvas._hasITextHandlers = false;
	            _this._removeCanvasHandlers(canvas);
	          }
	        }
	      });
	    },

	    /**
	     * register canvas event to manage exiting on other instances
	     * @private
	     */
	    _initCanvasHandlers: function(canvas) {
	      canvas._mouseUpITextHandler = function() {
	        if (canvas._iTextInstances) {
	          canvas._iTextInstances.forEach(function(obj) {
	            obj.__isMousedown = false;
	          });
	        }
	      };
	      canvas.on('mouse:up', canvas._mouseUpITextHandler);
	    },

	    /**
	     * remove canvas event to manage exiting on other instances
	     * @private
	     */
	    _removeCanvasHandlers: function(canvas) {
	      canvas.off('mouse:up', canvas._mouseUpITextHandler);
	    },

	    /**
	     * @private
	     */
	    _tick: function() {
	      this._currentTickState = this._animateCursor(this, 1, this.cursorDuration, '_onTickComplete');
	    },

	    /**
	     * @private
	     */
	    _animateCursor: function(obj, targetOpacity, duration, completeMethod) {

	      var tickState;

	      tickState = {
	        isAborted: false,
	        abort: function() {
	          this.isAborted = true;
	        },
	      };

	      obj.animate('_currentCursorOpacity', targetOpacity, {
	        duration: duration,
	        onComplete: function() {
	          if (!tickState.isAborted) {
	            obj[completeMethod]();
	          }
	        },
	        onChange: function() {
	          // we do not want to animate a selection, only cursor
	          if (obj.canvas && obj.selectionStart === obj.selectionEnd) {
	            obj.renderCursorOrSelection();
	          }
	        },
	        abort: function() {
	          return tickState.isAborted;
	        }
	      });
	      return tickState;
	    },

	    /**
	     * @private
	     */
	    _onTickComplete: function() {

	      var _this = this;

	      if (this._cursorTimeout1) {
	        clearTimeout(this._cursorTimeout1);
	      }
	      this._cursorTimeout1 = setTimeout(function() {
	        _this._currentTickCompleteState = _this._animateCursor(_this, 0, this.cursorDuration / 2, '_tick');
	      }, 100);
	    },

	    /**
	     * Initializes delayed cursor
	     */
	    initDelayedCursor: function(restart) {
	      var _this = this,
	          delay = restart ? 0 : this.cursorDelay;

	      this.abortCursorAnimation();
	      this._currentCursorOpacity = 1;
	      this._cursorTimeout2 = setTimeout(function() {
	        _this._tick();
	      }, delay);
	    },

	    /**
	     * Aborts cursor animation and clears all timeouts
	     */
	    abortCursorAnimation: function() {
	      var shouldClear = this._currentTickState || this._currentTickCompleteState,
	          canvas = this.canvas;
	      this._currentTickState && this._currentTickState.abort();
	      this._currentTickCompleteState && this._currentTickCompleteState.abort();

	      clearTimeout(this._cursorTimeout1);
	      clearTimeout(this._cursorTimeout2);

	      this._currentCursorOpacity = 0;
	      // to clear just itext area we need to transform the context
	      // it may not be worth it
	      if (shouldClear && canvas) {
	        canvas.clearContext(canvas.contextTop || canvas.contextContainer);
	      }

	    },

	    /**
	     * Selects entire text
	     * @return {fabric.IText} thisArg
	     * @chainable
	     */
	    selectAll: function() {
	      this.selectionStart = 0;
	      this.selectionEnd = this._text.length;
	      this._fireSelectionChanged();
	      this._updateTextarea();
	      return this;
	    },

	    /**
	     * Returns selected text
	     * @return {String}
	     */
	    getSelectedText: function() {
	      return this._text.slice(this.selectionStart, this.selectionEnd).join('');
	    },

	    /**
	     * Find new selection index representing start of current word according to current selection index
	     * @param {Number} startFrom Current selection index
	     * @return {Number} New selection index
	     */
	    findWordBoundaryLeft: function(startFrom) {
	      var offset = 0, index = startFrom - 1;

	      // remove space before cursor first
	      if (this._reSpace.test(this._text[index])) {
	        while (this._reSpace.test(this._text[index])) {
	          offset++;
	          index--;
	        }
	      }
	      while (/\S/.test(this._text[index]) && index > -1) {
	        offset++;
	        index--;
	      }

	      return startFrom - offset;
	    },

	    /**
	     * Find new selection index representing end of current word according to current selection index
	     * @param {Number} startFrom Current selection index
	     * @return {Number} New selection index
	     */
	    findWordBoundaryRight: function(startFrom) {
	      var offset = 0, index = startFrom;

	      // remove space after cursor first
	      if (this._reSpace.test(this._text[index])) {
	        while (this._reSpace.test(this._text[index])) {
	          offset++;
	          index++;
	        }
	      }
	      while (/\S/.test(this._text[index]) && index < this._text.length) {
	        offset++;
	        index++;
	      }

	      return startFrom + offset;
	    },

	    /**
	     * Find new selection index representing start of current line according to current selection index
	     * @param {Number} startFrom Current selection index
	     * @return {Number} New selection index
	     */
	    findLineBoundaryLeft: function(startFrom) {
	      var offset = 0, index = startFrom - 1;

	      while (!/\n/.test(this._text[index]) && index > -1) {
	        offset++;
	        index--;
	      }

	      return startFrom - offset;
	    },

	    /**
	     * Find new selection index representing end of current line according to current selection index
	     * @param {Number} startFrom Current selection index
	     * @return {Number} New selection index
	     */
	    findLineBoundaryRight: function(startFrom) {
	      var offset = 0, index = startFrom;

	      while (!/\n/.test(this._text[index]) && index < this._text.length) {
	        offset++;
	        index++;
	      }

	      return startFrom + offset;
	    },

	    /**
	     * Finds index corresponding to beginning or end of a word
	     * @param {Number} selectionStart Index of a character
	     * @param {Number} direction 1 or -1
	     * @return {Number} Index of the beginning or end of a word
	     */
	    searchWordBoundary: function(selectionStart, direction) {
	      var text = this._text,
	          index     = this._reSpace.test(text[selectionStart]) ? selectionStart - 1 : selectionStart,
	          _char     = text[index],
	          // wrong
	          reNonWord = fabric.reNonWord;

	      while (!reNonWord.test(_char) && index > 0 && index < text.length) {
	        index += direction;
	        _char = text[index];
	      }
	      if (reNonWord.test(_char)) {
	        index += direction === 1 ? 0 : 1;
	      }
	      return index;
	    },

	    /**
	     * Selects a word based on the index
	     * @param {Number} selectionStart Index of a character
	     */
	    selectWord: function(selectionStart) {
	      selectionStart = selectionStart || this.selectionStart;
	      var newSelectionStart = this.searchWordBoundary(selectionStart, -1), /* search backwards */
	          newSelectionEnd = this.searchWordBoundary(selectionStart, 1); /* search forward */

	      this.selectionStart = newSelectionStart;
	      this.selectionEnd = newSelectionEnd;
	      this._fireSelectionChanged();
	      this._updateTextarea();
	      this.renderCursorOrSelection();
	    },

	    /**
	     * Selects a line based on the index
	     * @param {Number} selectionStart Index of a character
	     * @return {fabric.IText} thisArg
	     * @chainable
	     */
	    selectLine: function(selectionStart) {
	      selectionStart = selectionStart || this.selectionStart;
	      var newSelectionStart = this.findLineBoundaryLeft(selectionStart),
	          newSelectionEnd = this.findLineBoundaryRight(selectionStart);

	      this.selectionStart = newSelectionStart;
	      this.selectionEnd = newSelectionEnd;
	      this._fireSelectionChanged();
	      this._updateTextarea();
	      return this;
	    },

	    /**
	     * Enters editing state
	     * @return {fabric.IText} thisArg
	     * @chainable
	     */
	    enterEditing: function(e) {
	      if (this.isEditing || !this.editable) {
	        return;
	      }

	      if (this.canvas) {
	        this.canvas.calcOffset();
	        this.exitEditingOnOthers(this.canvas);
	      }

	      this.isEditing = true;

	      this.initHiddenTextarea(e);
	      this.hiddenTextarea.focus();
	      this.hiddenTextarea.value = this.text;
	      this._updateTextarea();
	      this._saveEditingProps();
	      this._setEditingProps();
	      this._textBeforeEdit = this.text;

	      this._tick();
	      this.fire('editing:entered');
	      this._fireSelectionChanged();
	      if (!this.canvas) {
	        return this;
	      }
	      this.canvas.fire('text:editing:entered', { target: this });
	      this.initMouseMoveHandler();
	      this.canvas.requestRenderAll();
	      return this;
	    },

	    exitEditingOnOthers: function(canvas) {
	      if (canvas._iTextInstances) {
	        canvas._iTextInstances.forEach(function(obj) {
	          obj.selected = false;
	          if (obj.isEditing) {
	            obj.exitEditing();
	          }
	        });
	      }
	    },

	    /**
	     * Initializes "mousemove" event handler
	     */
	    initMouseMoveHandler: function() {
	      this.canvas.on('mouse:move', this.mouseMoveHandler);
	    },

	    /**
	     * @private
	     */
	    mouseMoveHandler: function(options) {
	      if (!this.__isMousedown || !this.isEditing) {
	        return;
	      }

	      var newSelectionStart = this.getSelectionStartFromPointer(options.e),
	          currentStart = this.selectionStart,
	          currentEnd = this.selectionEnd;
	      if (
	        (newSelectionStart !== this.__selectionStartOnMouseDown || currentStart === currentEnd)
	        &&
	        (currentStart === newSelectionStart || currentEnd === newSelectionStart)
	      ) {
	        return;
	      }
	      if (newSelectionStart > this.__selectionStartOnMouseDown) {
	        this.selectionStart = this.__selectionStartOnMouseDown;
	        this.selectionEnd = newSelectionStart;
	      }
	      else {
	        this.selectionStart = newSelectionStart;
	        this.selectionEnd = this.__selectionStartOnMouseDown;
	      }
	      if (this.selectionStart !== currentStart || this.selectionEnd !== currentEnd) {
	        this.restartCursorIfNeeded();
	        this._fireSelectionChanged();
	        this._updateTextarea();
	        this.renderCursorOrSelection();
	      }
	    },

	    /**
	     * @private
	     */
	    _setEditingProps: function() {
	      this.hoverCursor = 'text';

	      if (this.canvas) {
	        this.canvas.defaultCursor = this.canvas.moveCursor = 'text';
	      }

	      this.borderColor = this.editingBorderColor;
	      this.hasControls = this.selectable = false;
	      this.lockMovementX = this.lockMovementY = true;
	    },

	    /**
	     * convert from textarea to grapheme indexes
	     */
	    fromStringToGraphemeSelection: function(start, end, text) {
	      var smallerTextStart = text.slice(0, start),
	          graphemeStart = fabric.util.string.graphemeSplit(smallerTextStart).length;
	      if (start === end) {
	        return { selectionStart: graphemeStart, selectionEnd: graphemeStart };
	      }
	      var smallerTextEnd = text.slice(start, end),
	          graphemeEnd = fabric.util.string.graphemeSplit(smallerTextEnd).length;
	      return { selectionStart: graphemeStart, selectionEnd: graphemeStart + graphemeEnd };
	    },

	    /**
	     * convert from fabric to textarea values
	     */
	    fromGraphemeToStringSelection: function(start, end, _text) {
	      var smallerTextStart = _text.slice(0, start),
	          graphemeStart = smallerTextStart.join('').length;
	      if (start === end) {
	        return { selectionStart: graphemeStart, selectionEnd: graphemeStart };
	      }
	      var smallerTextEnd = _text.slice(start, end),
	          graphemeEnd = smallerTextEnd.join('').length;
	      return { selectionStart: graphemeStart, selectionEnd: graphemeStart + graphemeEnd };
	    },

	    /**
	     * @private
	     */
	    _updateTextarea: function() {
	      this.cursorOffsetCache = { };
	      if (!this.hiddenTextarea) {
	        return;
	      }
	      if (!this.inCompositionMode) {
	        var newSelection = this.fromGraphemeToStringSelection(this.selectionStart, this.selectionEnd, this._text);
	        this.hiddenTextarea.selectionStart = newSelection.selectionStart;
	        this.hiddenTextarea.selectionEnd = newSelection.selectionEnd;
	      }
	      this.updateTextareaPosition();
	    },

	    /**
	     * @private
	     */
	    updateFromTextArea: function() {
	      if (!this.hiddenTextarea) {
	        return;
	      }
	      this.cursorOffsetCache = { };
	      this.text = this.hiddenTextarea.value;
	      if (this._shouldClearDimensionCache()) {
	        this.initDimensions();
	        this.setCoords();
	      }
	      var newSelection = this.fromStringToGraphemeSelection(
	        this.hiddenTextarea.selectionStart, this.hiddenTextarea.selectionEnd, this.hiddenTextarea.value);
	      this.selectionEnd = this.selectionStart = newSelection.selectionEnd;
	      if (!this.inCompositionMode) {
	        this.selectionStart = newSelection.selectionStart;
	      }
	      this.updateTextareaPosition();
	    },

	    /**
	     * @private
	     */
	    updateTextareaPosition: function() {
	      if (this.selectionStart === this.selectionEnd) {
	        var style = this._calcTextareaPosition();
	        this.hiddenTextarea.style.left = style.left;
	        this.hiddenTextarea.style.top = style.top;
	      }
	    },

	    /**
	     * @private
	     * @return {Object} style contains style for hiddenTextarea
	     */
	    _calcTextareaPosition: function() {
	      if (!this.canvas) {
	        return { x: 1, y: 1 };
	      }
	      var desiredPosition = this.inCompositionMode ? this.compositionStart : this.selectionStart,
	          boundaries = this._getCursorBoundaries(desiredPosition),
	          cursorLocation = this.get2DCursorLocation(desiredPosition),
	          lineIndex = cursorLocation.lineIndex,
	          charIndex = cursorLocation.charIndex,
	          charHeight = this.getValueOfPropertyAt(lineIndex, charIndex, 'fontSize') * this.lineHeight,
	          leftOffset = boundaries.leftOffset,
	          m = this.calcTransformMatrix(),
	          p = {
	            x: boundaries.left + leftOffset,
	            y: boundaries.top + boundaries.topOffset + charHeight
	          },
	          retinaScaling = this.canvas.getRetinaScaling(),
	          upperCanvas = this.canvas.upperCanvasEl,
	          upperCanvasWidth = upperCanvas.width / retinaScaling,
	          upperCanvasHeight = upperCanvas.height / retinaScaling,
	          maxWidth = upperCanvasWidth - charHeight,
	          maxHeight = upperCanvasHeight - charHeight,
	          scaleX = upperCanvas.clientWidth / upperCanvasWidth,
	          scaleY = upperCanvas.clientHeight / upperCanvasHeight;

	      p = fabric.util.transformPoint(p, m);
	      p = fabric.util.transformPoint(p, this.canvas.viewportTransform);
	      p.x *= scaleX;
	      p.y *= scaleY;
	      if (p.x < 0) {
	        p.x = 0;
	      }
	      if (p.x > maxWidth) {
	        p.x = maxWidth;
	      }
	      if (p.y < 0) {
	        p.y = 0;
	      }
	      if (p.y > maxHeight) {
	        p.y = maxHeight;
	      }

	      // add canvas offset on document
	      p.x += this.canvas._offset.left;
	      p.y += this.canvas._offset.top;

	      return { left: p.x + 'px', top: p.y + 'px', fontSize: charHeight + 'px', charHeight: charHeight };
	    },

	    /**
	     * @private
	     */
	    _saveEditingProps: function() {
	      this._savedProps = {
	        hasControls: this.hasControls,
	        borderColor: this.borderColor,
	        lockMovementX: this.lockMovementX,
	        lockMovementY: this.lockMovementY,
	        hoverCursor: this.hoverCursor,
	        selectable: this.selectable,
	        defaultCursor: this.canvas && this.canvas.defaultCursor,
	        moveCursor: this.canvas && this.canvas.moveCursor
	      };
	    },

	    /**
	     * @private
	     */
	    _restoreEditingProps: function() {
	      if (!this._savedProps) {
	        return;
	      }

	      this.hoverCursor = this._savedProps.hoverCursor;
	      this.hasControls = this._savedProps.hasControls;
	      this.borderColor = this._savedProps.borderColor;
	      this.selectable = this._savedProps.selectable;
	      this.lockMovementX = this._savedProps.lockMovementX;
	      this.lockMovementY = this._savedProps.lockMovementY;

	      if (this.canvas) {
	        this.canvas.defaultCursor = this._savedProps.defaultCursor;
	        this.canvas.moveCursor = this._savedProps.moveCursor;
	      }
	    },

	    /**
	     * Exits from editing state
	     * @return {fabric.IText} thisArg
	     * @chainable
	     */
	    exitEditing: function() {
	      var isTextChanged = (this._textBeforeEdit !== this.text);
	      var hiddenTextarea = this.hiddenTextarea;
	      this.selected = false;
	      this.isEditing = false;

	      this.selectionEnd = this.selectionStart;

	      if (hiddenTextarea) {
	        hiddenTextarea.blur && hiddenTextarea.blur();
	        hiddenTextarea.parentNode && hiddenTextarea.parentNode.removeChild(hiddenTextarea);
	      }
	      this.hiddenTextarea = null;
	      this.abortCursorAnimation();
	      this._restoreEditingProps();
	      this._currentCursorOpacity = 0;
	      if (this._shouldClearDimensionCache()) {
	        this.initDimensions();
	        this.setCoords();
	      }
	      this.fire('editing:exited');
	      isTextChanged && this.fire('modified');
	      if (this.canvas) {
	        this.canvas.off('mouse:move', this.mouseMoveHandler);
	        this.canvas.fire('text:editing:exited', { target: this });
	        isTextChanged && this.canvas.fire('object:modified', { target: this });
	      }
	      return this;
	    },

	    /**
	     * @private
	     */
	    _removeExtraneousStyles: function() {
	      for (var prop in this.styles) {
	        if (!this._textLines[prop]) {
	          delete this.styles[prop];
	        }
	      }
	    },

	    /**
	     * remove and reflow a style block from start to end.
	     * @param {Number} start linear start position for removal (included in removal)
	     * @param {Number} end linear end position for removal ( excluded from removal )
	     */
	    removeStyleFromTo: function(start, end) {
	      var cursorStart = this.get2DCursorLocation(start, true),
	          cursorEnd = this.get2DCursorLocation(end, true),
	          lineStart = cursorStart.lineIndex,
	          charStart = cursorStart.charIndex,
	          lineEnd = cursorEnd.lineIndex,
	          charEnd = cursorEnd.charIndex,
	          i, styleObj;
	      if (lineStart !== lineEnd) {
	        // step1 remove the trailing of lineStart
	        if (this.styles[lineStart]) {
	          for (i = charStart; i < this._unwrappedTextLines[lineStart].length; i++) {
	            delete this.styles[lineStart][i];
	          }
	        }
	        // step2 move the trailing of lineEnd to lineStart if needed
	        if (this.styles[lineEnd]) {
	          for (i = charEnd; i < this._unwrappedTextLines[lineEnd].length; i++) {
	            styleObj = this.styles[lineEnd][i];
	            if (styleObj) {
	              this.styles[lineStart] || (this.styles[lineStart] = { });
	              this.styles[lineStart][charStart + i - charEnd] = styleObj;
	            }
	          }
	        }
	        // step3 detects lines will be completely removed.
	        for (i = lineStart + 1; i <= lineEnd; i++) {
	          delete this.styles[i];
	        }
	        // step4 shift remaining lines.
	        this.shiftLineStyles(lineEnd, lineStart - lineEnd);
	      }
	      else {
	        // remove and shift left on the same line
	        if (this.styles[lineStart]) {
	          styleObj = this.styles[lineStart];
	          var diff = charEnd - charStart, numericChar, _char;
	          for (i = charStart; i < charEnd; i++) {
	            delete styleObj[i];
	          }
	          for (_char in this.styles[lineStart]) {
	            numericChar = parseInt(_char, 10);
	            if (numericChar >= charEnd) {
	              styleObj[numericChar - diff] = styleObj[_char];
	              delete styleObj[_char];
	            }
	          }
	        }
	      }
	    },

	    /**
	     * Shifts line styles up or down
	     * @param {Number} lineIndex Index of a line
	     * @param {Number} offset Can any number?
	     */
	    shiftLineStyles: function(lineIndex, offset) {
	      // shift all line styles by offset upward or downward
	      // do not clone deep. we need new array, not new style objects
	      var clonedStyles = clone(this.styles);
	      for (var line in this.styles) {
	        var numericLine = parseInt(line, 10);
	        if (numericLine > lineIndex) {
	          this.styles[numericLine + offset] = clonedStyles[numericLine];
	          if (!clonedStyles[numericLine - offset]) {
	            delete this.styles[numericLine];
	          }
	        }
	      }
	    },

	    restartCursorIfNeeded: function() {
	      if (!this._currentTickState || this._currentTickState.isAborted
	        || !this._currentTickCompleteState || this._currentTickCompleteState.isAborted
	      ) {
	        this.initDelayedCursor();
	      }
	    },

	    /**
	     * Handle insertion of more consecutive style lines for when one or more
	     * newlines gets added to the text. Since current style needs to be shifted
	     * first we shift the current style of the number lines needed, then we add
	     * new lines from the last to the first.
	     * @param {Number} lineIndex Index of a line
	     * @param {Number} charIndex Index of a char
	     * @param {Number} qty number of lines to add
	     * @param {Array} copiedStyle Array of objects styles
	     */
	    insertNewlineStyleObject: function(lineIndex, charIndex, qty, copiedStyle) {
	      var currentCharStyle,
	          newLineStyles = {},
	          somethingAdded = false,
	          isEndOfLine = this._unwrappedTextLines[lineIndex].length === charIndex;

	      qty || (qty = 1);
	      this.shiftLineStyles(lineIndex, qty);
	      if (this.styles[lineIndex]) {
	        currentCharStyle = this.styles[lineIndex][charIndex === 0 ? charIndex : charIndex - 1];
	      }
	      // we clone styles of all chars
	      // after cursor onto the current line
	      for (var index in this.styles[lineIndex]) {
	        var numIndex = parseInt(index, 10);
	        if (numIndex >= charIndex) {
	          somethingAdded = true;
	          newLineStyles[numIndex - charIndex] = this.styles[lineIndex][index];
	          // remove lines from the previous line since they're on a new line now
	          if (!(isEndOfLine && charIndex === 0)) {
	            delete this.styles[lineIndex][index];
	          }
	        }
	      }
	      var styleCarriedOver = false;
	      if (somethingAdded && !isEndOfLine) {
	        // if is end of line, the extra style we copied
	        // is probably not something we want
	        this.styles[lineIndex + qty] = newLineStyles;
	        styleCarriedOver = true;
	      }
	      if (styleCarriedOver) {
	        // skip the last line of since we already prepared it.
	        qty--;
	      }
	      // for the all the lines or all the other lines
	      // we clone current char style onto the next (otherwise empty) line
	      while (qty > 0) {
	        if (copiedStyle && copiedStyle[qty - 1]) {
	          this.styles[lineIndex + qty] = { 0: clone(copiedStyle[qty - 1]) };
	        }
	        else if (currentCharStyle) {
	          this.styles[lineIndex + qty] = { 0: clone(currentCharStyle) };
	        }
	        else {
	          delete this.styles[lineIndex + qty];
	        }
	        qty--;
	      }
	      this._forceClearCache = true;
	    },

	    /**
	     * Inserts style object for a given line/char index
	     * @param {Number} lineIndex Index of a line
	     * @param {Number} charIndex Index of a char
	     * @param {Number} quantity number Style object to insert, if given
	     * @param {Array} copiedStyle array of style objects
	     */
	    insertCharStyleObject: function(lineIndex, charIndex, quantity, copiedStyle) {
	      if (!this.styles) {
	        this.styles = {};
	      }
	      var currentLineStyles       = this.styles[lineIndex],
	          currentLineStylesCloned = currentLineStyles ? clone(currentLineStyles) : {};

	      quantity || (quantity = 1);
	      // shift all char styles by quantity forward
	      // 0,1,2,3 -> (charIndex=2) -> 0,1,3,4 -> (insert 2) -> 0,1,2,3,4
	      for (var index in currentLineStylesCloned) {
	        var numericIndex = parseInt(index, 10);
	        if (numericIndex >= charIndex) {
	          currentLineStyles[numericIndex + quantity] = currentLineStylesCloned[numericIndex];
	          // only delete the style if there was nothing moved there
	          if (!currentLineStylesCloned[numericIndex - quantity]) {
	            delete currentLineStyles[numericIndex];
	          }
	        }
	      }
	      this._forceClearCache = true;
	      if (copiedStyle) {
	        while (quantity--) {
	          if (!Object.keys(copiedStyle[quantity]).length) {
	            continue;
	          }
	          if (!this.styles[lineIndex]) {
	            this.styles[lineIndex] = {};
	          }
	          this.styles[lineIndex][charIndex + quantity] = clone(copiedStyle[quantity]);
	        }
	        return;
	      }
	      if (!currentLineStyles) {
	        return;
	      }
	      var newStyle = currentLineStyles[charIndex ? charIndex - 1 : 1];
	      while (newStyle && quantity--) {
	        this.styles[lineIndex][charIndex + quantity] = clone(newStyle);
	      }
	    },

	    /**
	     * Inserts style object(s)
	     * @param {Array} insertedText Characters at the location where style is inserted
	     * @param {Number} start cursor index for inserting style
	     * @param {Array} [copiedStyle] array of style objects to insert.
	     */
	    insertNewStyleBlock: function(insertedText, start, copiedStyle) {
	      var cursorLoc = this.get2DCursorLocation(start, true),
	          addedLines = [0], linesLength = 0;
	      // get an array of how many char per lines are being added.
	      for (var i = 0; i < insertedText.length; i++) {
	        if (insertedText[i] === '\n') {
	          linesLength++;
	          addedLines[linesLength] = 0;
	        }
	        else {
	          addedLines[linesLength]++;
	        }
	      }
	      // for the first line copy the style from the current char position.
	      if (addedLines[0] > 0) {
	        this.insertCharStyleObject(cursorLoc.lineIndex, cursorLoc.charIndex, addedLines[0], copiedStyle);
	        copiedStyle = copiedStyle && copiedStyle.slice(addedLines[0] + 1);
	      }
	      linesLength && this.insertNewlineStyleObject(
	        cursorLoc.lineIndex, cursorLoc.charIndex + addedLines[0], linesLength);
	      for (var i = 1; i < linesLength; i++) {
	        if (addedLines[i] > 0) {
	          this.insertCharStyleObject(cursorLoc.lineIndex + i, 0, addedLines[i], copiedStyle);
	        }
	        else if (copiedStyle) {
	          this.styles[cursorLoc.lineIndex + i][0] = copiedStyle[0];
	        }
	        copiedStyle = copiedStyle && copiedStyle.slice(addedLines[i] + 1);
	      }
	      // we use i outside the loop to get it like linesLength
	      if (addedLines[i] > 0) {
	        this.insertCharStyleObject(cursorLoc.lineIndex + i, 0, addedLines[i], copiedStyle);
	      }
	    },

	    /**
	     * Set the selectionStart and selectionEnd according to the new position of cursor
	     * mimic the key - mouse navigation when shift is pressed.
	     */
	    setSelectionStartEndWithShift: function(start, end, newSelection) {
	      if (newSelection <= start) {
	        if (end === start) {
	          this._selectionDirection = 'left';
	        }
	        else if (this._selectionDirection === 'right') {
	          this._selectionDirection = 'left';
	          this.selectionEnd = start;
	        }
	        this.selectionStart = newSelection;
	      }
	      else if (newSelection > start && newSelection < end) {
	        if (this._selectionDirection === 'right') {
	          this.selectionEnd = newSelection;
	        }
	        else {
	          this.selectionStart = newSelection;
	        }
	      }
	      else {
	        // newSelection is > selection start and end
	        if (end === start) {
	          this._selectionDirection = 'right';
	        }
	        else if (this._selectionDirection === 'left') {
	          this._selectionDirection = 'right';
	          this.selectionStart = end;
	        }
	        this.selectionEnd = newSelection;
	      }
	    },

	    setSelectionInBoundaries: function() {
	      var length = this.text.length;
	      if (this.selectionStart > length) {
	        this.selectionStart = length;
	      }
	      else if (this.selectionStart < 0) {
	        this.selectionStart = 0;
	      }
	      if (this.selectionEnd > length) {
	        this.selectionEnd = length;
	      }
	      else if (this.selectionEnd < 0) {
	        this.selectionEnd = 0;
	      }
	    }
	  });
	})();


	fabric.util.object.extend(fabric.IText.prototype, /** @lends fabric.IText.prototype */ {
	  /**
	   * Initializes "dbclick" event handler
	   */
	  initDoubleClickSimulation: function() {

	    // for double click
	    this.__lastClickTime = +new Date();

	    // for triple click
	    this.__lastLastClickTime = +new Date();

	    this.__lastPointer = { };

	    this.on('mousedown', this.onMouseDown);
	  },

	  /**
	   * Default event handler to simulate triple click
	   * @private
	   */
	  onMouseDown: function(options) {
	    if (!this.canvas) {
	      return;
	    }
	    this.__newClickTime = +new Date();
	    var newPointer = options.pointer;
	    if (this.isTripleClick(newPointer)) {
	      this.fire('tripleclick', options);
	      this._stopEvent(options.e);
	    }
	    this.__lastLastClickTime = this.__lastClickTime;
	    this.__lastClickTime = this.__newClickTime;
	    this.__lastPointer = newPointer;
	    this.__lastIsEditing = this.isEditing;
	    this.__lastSelected = this.selected;
	  },

	  isTripleClick: function(newPointer) {
	    return this.__newClickTime - this.__lastClickTime < 500 &&
	        this.__lastClickTime - this.__lastLastClickTime < 500 &&
	        this.__lastPointer.x === newPointer.x &&
	        this.__lastPointer.y === newPointer.y;
	  },

	  /**
	   * @private
	   */
	  _stopEvent: function(e) {
	    e.preventDefault && e.preventDefault();
	    e.stopPropagation && e.stopPropagation();
	  },

	  /**
	   * Initializes event handlers related to cursor or selection
	   */
	  initCursorSelectionHandlers: function() {
	    this.initMousedownHandler();
	    this.initMouseupHandler();
	    this.initClicks();
	  },

	  /**
	   * Default handler for double click, select a word
	   */
	  doubleClickHandler: function(options) {
	    if (!this.isEditing) {
	      return;
	    }
	    this.selectWord(this.getSelectionStartFromPointer(options.e));
	  },

	  /**
	   * Default handler for triple click, select a line
	   */
	  tripleClickHandler: function(options) {
	    if (!this.isEditing) {
	      return;
	    }
	    this.selectLine(this.getSelectionStartFromPointer(options.e));
	  },

	  /**
	   * Initializes double and triple click event handlers
	   */
	  initClicks: function() {
	    this.on('mousedblclick', this.doubleClickHandler);
	    this.on('tripleclick', this.tripleClickHandler);
	  },

	  /**
	   * Default event handler for the basic functionalities needed on _mouseDown
	   * can be overridden to do something different.
	   * Scope of this implementation is: find the click position, set selectionStart
	   * find selectionEnd, initialize the drawing of either cursor or selection area
	   * initializing a mousedDown on a text area will cancel fabricjs knowledge of
	   * current compositionMode. It will be set to false.
	   */
	  _mouseDownHandler: function(options) {
	    if (!this.canvas || !this.editable || (options.e.button && options.e.button !== 1)) {
	      return;
	    }

	    this.__isMousedown = true;

	    if (this.selected) {
	      this.inCompositionMode = false;
	      this.setCursorByClick(options.e);
	    }

	    if (this.isEditing) {
	      this.__selectionStartOnMouseDown = this.selectionStart;
	      if (this.selectionStart === this.selectionEnd) {
	        this.abortCursorAnimation();
	      }
	      this.renderCursorOrSelection();
	    }
	  },

	  /**
	   * Default event handler for the basic functionalities needed on mousedown:before
	   * can be overridden to do something different.
	   * Scope of this implementation is: verify the object is already selected when mousing down
	   */
	  _mouseDownHandlerBefore: function(options) {
	    if (!this.canvas || !this.editable || (options.e.button && options.e.button !== 1)) {
	      return;
	    }
	    // we want to avoid that an object that was selected and then becomes unselectable,
	    // may trigger editing mode in some way.
	    this.selected = this === this.canvas._activeObject;
	  },

	  /**
	   * Initializes "mousedown" event handler
	   */
	  initMousedownHandler: function() {
	    this.on('mousedown', this._mouseDownHandler);
	    this.on('mousedown:before', this._mouseDownHandlerBefore);
	  },

	  /**
	   * Initializes "mouseup" event handler
	   */
	  initMouseupHandler: function() {
	    this.on('mouseup', this.mouseUpHandler);
	  },

	  /**
	   * standard handler for mouse up, overridable
	   * @private
	   */
	  mouseUpHandler: function(options) {
	    this.__isMousedown = false;
	    if (!this.editable || this.group ||
	      (options.transform && options.transform.actionPerformed) ||
	      (options.e.button && options.e.button !== 1)) {
	      return;
	    }

	    if (this.canvas) {
	      var currentActive = this.canvas._activeObject;
	      if (currentActive && currentActive !== this) {
	        // avoid running this logic when there is an active object
	        // this because is possible with shift click and fast clicks,
	        // to rapidly deselect and reselect this object and trigger an enterEdit
	        return;
	      }
	    }

	    if (this.__lastSelected && !this.__corner) {
	      this.selected = false;
	      this.__lastSelected = false;
	      this.enterEditing(options.e);
	      if (this.selectionStart === this.selectionEnd) {
	        this.initDelayedCursor(true);
	      }
	      else {
	        this.renderCursorOrSelection();
	      }
	    }
	    else {
	      this.selected = true;
	    }
	  },

	  /**
	   * Changes cursor location in a text depending on passed pointer (x/y) object
	   * @param {Event} e Event object
	   */
	  setCursorByClick: function(e) {
	    var newSelection = this.getSelectionStartFromPointer(e),
	        start = this.selectionStart, end = this.selectionEnd;
	    if (e.shiftKey) {
	      this.setSelectionStartEndWithShift(start, end, newSelection);
	    }
	    else {
	      this.selectionStart = newSelection;
	      this.selectionEnd = newSelection;
	    }
	    if (this.isEditing) {
	      this._fireSelectionChanged();
	      this._updateTextarea();
	    }
	  },

	  /**
	   * Returns index of a character corresponding to where an object was clicked
	   * @param {Event} e Event object
	   * @return {Number} Index of a character
	   */
	  getSelectionStartFromPointer: function(e) {
	    var mouseOffset = this.getLocalPointer(e),
	        prevWidth = 0,
	        width = 0,
	        height = 0,
	        charIndex = 0,
	        lineIndex = 0,
	        lineLeftOffset,
	        line;
	    for (var i = 0, len = this._textLines.length; i < len; i++) {
	      if (height <= mouseOffset.y) {
	        height += this.getHeightOfLine(i) * this.scaleY;
	        lineIndex = i;
	        if (i > 0) {
	          charIndex += this._textLines[i - 1].length + this.missingNewlineOffset(i - 1);
	        }
	      }
	      else {
	        break;
	      }
	    }
	    lineLeftOffset = this._getLineLeftOffset(lineIndex);
	    width = lineLeftOffset * this.scaleX;
	    line = this._textLines[lineIndex];
	    // handling of RTL: in order to get things work correctly,
	    // we assume RTL writing is mirrored compared to LTR writing.
	    // so in position detection we mirror the X offset, and when is time
	    // of rendering it, we mirror it again.
	    if (this.direction === 'rtl') {
	      mouseOffset.x = this.width * this.scaleX - mouseOffset.x + width;
	    }
	    for (var j = 0, jlen = line.length; j < jlen; j++) {
	      prevWidth = width;
	      // i removed something about flipX here, check.
	      width += this.__charBounds[lineIndex][j].kernedWidth * this.scaleX;
	      if (width <= mouseOffset.x) {
	        charIndex++;
	      }
	      else {
	        break;
	      }
	    }
	    return this._getNewSelectionStartFromOffset(mouseOffset, prevWidth, width, charIndex, jlen);
	  },

	  /**
	   * @private
	   */
	  _getNewSelectionStartFromOffset: function(mouseOffset, prevWidth, width, index, jlen) {
	    // we need Math.abs because when width is after the last char, the offset is given as 1, while is 0
	    var distanceBtwLastCharAndCursor = mouseOffset.x - prevWidth,
	        distanceBtwNextCharAndCursor = width - mouseOffset.x,
	        offset = distanceBtwNextCharAndCursor > distanceBtwLastCharAndCursor ||
	          distanceBtwNextCharAndCursor < 0 ? 0 : 1,
	        newSelectionStart = index + offset;
	    // if object is horizontally flipped, mirror cursor location from the end
	    if (this.flipX) {
	      newSelectionStart = jlen - newSelectionStart;
	    }

	    if (newSelectionStart > this._text.length) {
	      newSelectionStart = this._text.length;
	    }

	    return newSelectionStart;
	  }
	});


	fabric.util.object.extend(fabric.IText.prototype, /** @lends fabric.IText.prototype */ {

	  /**
	   * Initializes hidden textarea (needed to bring up keyboard in iOS)
	   */
	  initHiddenTextarea: function() {
	    this.hiddenTextarea = fabric.document.createElement('textarea');
	    this.hiddenTextarea.setAttribute('autocapitalize', 'off');
	    this.hiddenTextarea.setAttribute('autocorrect', 'off');
	    this.hiddenTextarea.setAttribute('autocomplete', 'off');
	    this.hiddenTextarea.setAttribute('spellcheck', 'false');
	    this.hiddenTextarea.setAttribute('data-fabric-hiddentextarea', '');
	    this.hiddenTextarea.setAttribute('wrap', 'off');
	    var style = this._calcTextareaPosition();
	    // line-height: 1px; was removed from the style to fix this:
	    // https://bugs.chromium.org/p/chromium/issues/detail?id=870966
	    this.hiddenTextarea.style.cssText = 'position: absolute; top: ' + style.top +
	    '; left: ' + style.left + '; z-index: -999; opacity: 0; width: 1px; height: 1px; font-size: 1px;' +
	    ' paddingｰtop: ' + style.fontSize + ';';

	    if (this.hiddenTextareaContainer) {
	      this.hiddenTextareaContainer.appendChild(this.hiddenTextarea);
	    }
	    else {
	      fabric.document.body.appendChild(this.hiddenTextarea);
	    }

	    fabric.util.addListener(this.hiddenTextarea, 'keydown', this.onKeyDown.bind(this));
	    fabric.util.addListener(this.hiddenTextarea, 'keyup', this.onKeyUp.bind(this));
	    fabric.util.addListener(this.hiddenTextarea, 'input', this.onInput.bind(this));
	    fabric.util.addListener(this.hiddenTextarea, 'copy', this.copy.bind(this));
	    fabric.util.addListener(this.hiddenTextarea, 'cut', this.copy.bind(this));
	    fabric.util.addListener(this.hiddenTextarea, 'paste', this.paste.bind(this));
	    fabric.util.addListener(this.hiddenTextarea, 'compositionstart', this.onCompositionStart.bind(this));
	    fabric.util.addListener(this.hiddenTextarea, 'compositionupdate', this.onCompositionUpdate.bind(this));
	    fabric.util.addListener(this.hiddenTextarea, 'compositionend', this.onCompositionEnd.bind(this));

	    if (!this._clickHandlerInitialized && this.canvas) {
	      fabric.util.addListener(this.canvas.upperCanvasEl, 'click', this.onClick.bind(this));
	      this._clickHandlerInitialized = true;
	    }
	  },

	  /**
	   * For functionalities on keyDown
	   * Map a special key to a function of the instance/prototype
	   * If you need different behaviour for ESC or TAB or arrows, you have to change
	   * this map setting the name of a function that you build on the fabric.Itext or
	   * your prototype.
	   * the map change will affect all Instances unless you need for only some text Instances
	   * in that case you have to clone this object and assign your Instance.
	   * this.keysMap = fabric.util.object.clone(this.keysMap);
	   * The function must be in fabric.Itext.prototype.myFunction And will receive event as args[0]
	   */
	  keysMap: {
	    9:  'exitEditing',
	    27: 'exitEditing',
	    33: 'moveCursorUp',
	    34: 'moveCursorDown',
	    35: 'moveCursorRight',
	    36: 'moveCursorLeft',
	    37: 'moveCursorLeft',
	    38: 'moveCursorUp',
	    39: 'moveCursorRight',
	    40: 'moveCursorDown',
	  },

	  keysMapRtl: {
	    9:  'exitEditing',
	    27: 'exitEditing',
	    33: 'moveCursorUp',
	    34: 'moveCursorDown',
	    35: 'moveCursorLeft',
	    36: 'moveCursorRight',
	    37: 'moveCursorRight',
	    38: 'moveCursorUp',
	    39: 'moveCursorLeft',
	    40: 'moveCursorDown',
	  },

	  /**
	   * For functionalities on keyUp + ctrl || cmd
	   */
	  ctrlKeysMapUp: {
	    67: 'copy',
	    88: 'cut'
	  },

	  /**
	   * For functionalities on keyDown + ctrl || cmd
	   */
	  ctrlKeysMapDown: {
	    65: 'selectAll'
	  },

	  onClick: function() {
	    // No need to trigger click event here, focus is enough to have the keyboard appear on Android
	    this.hiddenTextarea && this.hiddenTextarea.focus();
	  },

	  /**
	   * Handles keydown event
	   * only used for arrows and combination of modifier keys.
	   * @param {Event} e Event object
	   */
	  onKeyDown: function(e) {
	    if (!this.isEditing) {
	      return;
	    }
	    var keyMap = this.direction === 'rtl' ? this.keysMapRtl : this.keysMap;
	    if (e.keyCode in keyMap) {
	      this[keyMap[e.keyCode]](e);
	    }
	    else if ((e.keyCode in this.ctrlKeysMapDown) && (e.ctrlKey || e.metaKey)) {
	      this[this.ctrlKeysMapDown[e.keyCode]](e);
	    }
	    else {
	      return;
	    }
	    e.stopImmediatePropagation();
	    e.preventDefault();
	    if (e.keyCode >= 33 && e.keyCode <= 40) {
	      // if i press an arrow key just update selection
	      this.inCompositionMode = false;
	      this.clearContextTop();
	      this.renderCursorOrSelection();
	    }
	    else {
	      this.canvas && this.canvas.requestRenderAll();
	    }
	  },

	  /**
	   * Handles keyup event
	   * We handle KeyUp because ie11 and edge have difficulties copy/pasting
	   * if a copy/cut event fired, keyup is dismissed
	   * @param {Event} e Event object
	   */
	  onKeyUp: function(e) {
	    if (!this.isEditing || this._copyDone || this.inCompositionMode) {
	      this._copyDone = false;
	      return;
	    }
	    if ((e.keyCode in this.ctrlKeysMapUp) && (e.ctrlKey || e.metaKey)) {
	      this[this.ctrlKeysMapUp[e.keyCode]](e);
	    }
	    else {
	      return;
	    }
	    e.stopImmediatePropagation();
	    e.preventDefault();
	    this.canvas && this.canvas.requestRenderAll();
	  },

	  /**
	   * Handles onInput event
	   * @param {Event} e Event object
	   */
	  onInput: function(e) {
	    var fromPaste = this.fromPaste;
	    this.fromPaste = false;
	    e && e.stopPropagation();
	    if (!this.isEditing) {
	      return;
	    }
	    // decisions about style changes.
	    var nextText = this._splitTextIntoLines(this.hiddenTextarea.value).graphemeText,
	        charCount = this._text.length,
	        nextCharCount = nextText.length,
	        removedText, insertedText,
	        charDiff = nextCharCount - charCount,
	        selectionStart = this.selectionStart, selectionEnd = this.selectionEnd,
	        selection = selectionStart !== selectionEnd,
	        copiedStyle, removeFrom, removeTo;
	    if (this.hiddenTextarea.value === '') {
	      this.styles = { };
	      this.updateFromTextArea();
	      this.fire('changed');
	      if (this.canvas) {
	        this.canvas.fire('text:changed', { target: this });
	        this.canvas.requestRenderAll();
	      }
	      return;
	    }

	    var textareaSelection = this.fromStringToGraphemeSelection(
	      this.hiddenTextarea.selectionStart,
	      this.hiddenTextarea.selectionEnd,
	      this.hiddenTextarea.value
	    );
	    var backDelete = selectionStart > textareaSelection.selectionStart;

	    if (selection) {
	      removedText = this._text.slice(selectionStart, selectionEnd);
	      charDiff += selectionEnd - selectionStart;
	    }
	    else if (nextCharCount < charCount) {
	      if (backDelete) {
	        removedText = this._text.slice(selectionEnd + charDiff, selectionEnd);
	      }
	      else {
	        removedText = this._text.slice(selectionStart, selectionStart - charDiff);
	      }
	    }
	    insertedText = nextText.slice(textareaSelection.selectionEnd - charDiff, textareaSelection.selectionEnd);
	    if (removedText && removedText.length) {
	      if (insertedText.length) {
	        // let's copy some style before deleting.
	        // we want to copy the style before the cursor OR the style at the cursor if selection
	        // is bigger than 0.
	        copiedStyle = this.getSelectionStyles(selectionStart, selectionStart + 1, false);
	        // now duplicate the style one for each inserted text.
	        copiedStyle = insertedText.map(function() {
	          // this return an array of references, but that is fine since we are
	          // copying the style later.
	          return copiedStyle[0];
	        });
	      }
	      if (selection) {
	        removeFrom = selectionStart;
	        removeTo = selectionEnd;
	      }
	      else if (backDelete) {
	        // detect differences between forwardDelete and backDelete
	        removeFrom = selectionEnd - removedText.length;
	        removeTo = selectionEnd;
	      }
	      else {
	        removeFrom = selectionEnd;
	        removeTo = selectionEnd + removedText.length;
	      }
	      this.removeStyleFromTo(removeFrom, removeTo);
	    }
	    if (insertedText.length) {
	      if (fromPaste && insertedText.join('') === fabric.copiedText && !fabric.disableStyleCopyPaste) {
	        copiedStyle = fabric.copiedTextStyle;
	      }
	      this.insertNewStyleBlock(insertedText, selectionStart, copiedStyle);
	    }
	    this.updateFromTextArea();
	    this.fire('changed');
	    if (this.canvas) {
	      this.canvas.fire('text:changed', { target: this });
	      this.canvas.requestRenderAll();
	    }
	  },
	  /**
	   * Composition start
	   */
	  onCompositionStart: function() {
	    this.inCompositionMode = true;
	  },

	  /**
	   * Composition end
	   */
	  onCompositionEnd: function() {
	    this.inCompositionMode = false;
	  },

	  // /**
	  //  * Composition update
	  //  */
	  onCompositionUpdate: function(e) {
	    this.compositionStart = e.target.selectionStart;
	    this.compositionEnd = e.target.selectionEnd;
	    this.updateTextareaPosition();
	  },

	  /**
	   * Copies selected text
	   * @param {Event} e Event object
	   */
	  copy: function() {
	    if (this.selectionStart === this.selectionEnd) {
	      //do not cut-copy if no selection
	      return;
	    }

	    fabric.copiedText = this.getSelectedText();
	    if (!fabric.disableStyleCopyPaste) {
	      fabric.copiedTextStyle = this.getSelectionStyles(this.selectionStart, this.selectionEnd, true);
	    }
	    else {
	      fabric.copiedTextStyle = null;
	    }
	    this._copyDone = true;
	  },

	  /**
	   * Pastes text
	   * @param {Event} e Event object
	   */
	  paste: function() {
	    this.fromPaste = true;
	  },

	  /**
	   * @private
	   * @param {Event} e Event object
	   * @return {Object} Clipboard data object
	   */
	  _getClipboardData: function(e) {
	    return (e && e.clipboardData) || fabric.window.clipboardData;
	  },

	  /**
	   * Finds the width in pixels before the cursor on the same line
	   * @private
	   * @param {Number} lineIndex
	   * @param {Number} charIndex
	   * @return {Number} widthBeforeCursor width before cursor
	   */
	  _getWidthBeforeCursor: function(lineIndex, charIndex) {
	    var widthBeforeCursor = this._getLineLeftOffset(lineIndex), bound;

	    if (charIndex > 0) {
	      bound = this.__charBounds[lineIndex][charIndex - 1];
	      widthBeforeCursor += bound.left + bound.width;
	    }
	    return widthBeforeCursor;
	  },

	  /**
	   * Gets start offset of a selection
	   * @param {Event} e Event object
	   * @param {Boolean} isRight
	   * @return {Number}
	   */
	  getDownCursorOffset: function(e, isRight) {
	    var selectionProp = this._getSelectionForOffset(e, isRight),
	        cursorLocation = this.get2DCursorLocation(selectionProp),
	        lineIndex = cursorLocation.lineIndex;
	    // if on last line, down cursor goes to end of line
	    if (lineIndex === this._textLines.length - 1 || e.metaKey || e.keyCode === 34) {
	      // move to the end of a text
	      return this._text.length - selectionProp;
	    }
	    var charIndex = cursorLocation.charIndex,
	        widthBeforeCursor = this._getWidthBeforeCursor(lineIndex, charIndex),
	        indexOnOtherLine = this._getIndexOnLine(lineIndex + 1, widthBeforeCursor),
	        textAfterCursor = this._textLines[lineIndex].slice(charIndex);
	    return textAfterCursor.length + indexOnOtherLine + 1 + this.missingNewlineOffset(lineIndex);
	  },

	  /**
	   * private
	   * Helps finding if the offset should be counted from Start or End
	   * @param {Event} e Event object
	   * @param {Boolean} isRight
	   * @return {Number}
	   */
	  _getSelectionForOffset: function(e, isRight) {
	    if (e.shiftKey && this.selectionStart !== this.selectionEnd && isRight) {
	      return this.selectionEnd;
	    }
	    else {
	      return this.selectionStart;
	    }
	  },

	  /**
	   * @param {Event} e Event object
	   * @param {Boolean} isRight
	   * @return {Number}
	   */
	  getUpCursorOffset: function(e, isRight) {
	    var selectionProp = this._getSelectionForOffset(e, isRight),
	        cursorLocation = this.get2DCursorLocation(selectionProp),
	        lineIndex = cursorLocation.lineIndex;
	    if (lineIndex === 0 || e.metaKey || e.keyCode === 33) {
	      // if on first line, up cursor goes to start of line
	      return -selectionProp;
	    }
	    var charIndex = cursorLocation.charIndex,
	        widthBeforeCursor = this._getWidthBeforeCursor(lineIndex, charIndex),
	        indexOnOtherLine = this._getIndexOnLine(lineIndex - 1, widthBeforeCursor),
	        textBeforeCursor = this._textLines[lineIndex].slice(0, charIndex),
	        missingNewlineOffset = this.missingNewlineOffset(lineIndex - 1);
	    // return a negative offset
	    return -this._textLines[lineIndex - 1].length
	     + indexOnOtherLine - textBeforeCursor.length + (1 - missingNewlineOffset);
	  },

	  /**
	   * for a given width it founds the matching character.
	   * @private
	   */
	  _getIndexOnLine: function(lineIndex, width) {

	    var line = this._textLines[lineIndex],
	        lineLeftOffset = this._getLineLeftOffset(lineIndex),
	        widthOfCharsOnLine = lineLeftOffset,
	        indexOnLine = 0, charWidth, foundMatch;

	    for (var j = 0, jlen = line.length; j < jlen; j++) {
	      charWidth = this.__charBounds[lineIndex][j].width;
	      widthOfCharsOnLine += charWidth;
	      if (widthOfCharsOnLine > width) {
	        foundMatch = true;
	        var leftEdge = widthOfCharsOnLine - charWidth,
	            rightEdge = widthOfCharsOnLine,
	            offsetFromLeftEdge = Math.abs(leftEdge - width),
	            offsetFromRightEdge = Math.abs(rightEdge - width);

	        indexOnLine = offsetFromRightEdge < offsetFromLeftEdge ? j : (j - 1);
	        break;
	      }
	    }

	    // reached end
	    if (!foundMatch) {
	      indexOnLine = line.length - 1;
	    }

	    return indexOnLine;
	  },


	  /**
	   * Moves cursor down
	   * @param {Event} e Event object
	   */
	  moveCursorDown: function(e) {
	    if (this.selectionStart >= this._text.length && this.selectionEnd >= this._text.length) {
	      return;
	    }
	    this._moveCursorUpOrDown('Down', e);
	  },

	  /**
	   * Moves cursor up
	   * @param {Event} e Event object
	   */
	  moveCursorUp: function(e) {
	    if (this.selectionStart === 0 && this.selectionEnd === 0) {
	      return;
	    }
	    this._moveCursorUpOrDown('Up', e);
	  },

	  /**
	   * Moves cursor up or down, fires the events
	   * @param {String} direction 'Up' or 'Down'
	   * @param {Event} e Event object
	   */
	  _moveCursorUpOrDown: function(direction, e) {
	    // getUpCursorOffset
	    // getDownCursorOffset
	    var action = 'get' + direction + 'CursorOffset',
	        offset = this[action](e, this._selectionDirection === 'right');
	    if (e.shiftKey) {
	      this.moveCursorWithShift(offset);
	    }
	    else {
	      this.moveCursorWithoutShift(offset);
	    }
	    if (offset !== 0) {
	      this.setSelectionInBoundaries();
	      this.abortCursorAnimation();
	      this._currentCursorOpacity = 1;
	      this.initDelayedCursor();
	      this._fireSelectionChanged();
	      this._updateTextarea();
	    }
	  },

	  /**
	   * Moves cursor with shift
	   * @param {Number} offset
	   */
	  moveCursorWithShift: function(offset) {
	    var newSelection = this._selectionDirection === 'left'
	      ? this.selectionStart + offset
	      : this.selectionEnd + offset;
	    this.setSelectionStartEndWithShift(this.selectionStart, this.selectionEnd, newSelection);
	    return offset !== 0;
	  },

	  /**
	   * Moves cursor up without shift
	   * @param {Number} offset
	   */
	  moveCursorWithoutShift: function(offset) {
	    if (offset < 0) {
	      this.selectionStart += offset;
	      this.selectionEnd = this.selectionStart;
	    }
	    else {
	      this.selectionEnd += offset;
	      this.selectionStart = this.selectionEnd;
	    }
	    return offset !== 0;
	  },

	  /**
	   * Moves cursor left
	   * @param {Event} e Event object
	   */
	  moveCursorLeft: function(e) {
	    if (this.selectionStart === 0 && this.selectionEnd === 0) {
	      return;
	    }
	    this._moveCursorLeftOrRight('Left', e);
	  },

	  /**
	   * @private
	   * @return {Boolean} true if a change happened
	   */
	  _move: function(e, prop, direction) {
	    var newValue;
	    if (e.altKey) {
	      newValue = this['findWordBoundary' + direction](this[prop]);
	    }
	    else if (e.metaKey || e.keyCode === 35 ||  e.keyCode === 36 ) {
	      newValue = this['findLineBoundary' + direction](this[prop]);
	    }
	    else {
	      this[prop] += direction === 'Left' ? -1 : 1;
	      return true;
	    }
	    if (typeof newValue !== undefined && this[prop] !== newValue) {
	      this[prop] = newValue;
	      return true;
	    }
	  },

	  /**
	   * @private
	   */
	  _moveLeft: function(e, prop) {
	    return this._move(e, prop, 'Left');
	  },

	  /**
	   * @private
	   */
	  _moveRight: function(e, prop) {
	    return this._move(e, prop, 'Right');
	  },

	  /**
	   * Moves cursor left without keeping selection
	   * @param {Event} e
	   */
	  moveCursorLeftWithoutShift: function(e) {
	    var change = true;
	    this._selectionDirection = 'left';

	    // only move cursor when there is no selection,
	    // otherwise we discard it, and leave cursor on same place
	    if (this.selectionEnd === this.selectionStart && this.selectionStart !== 0) {
	      change = this._moveLeft(e, 'selectionStart');

	    }
	    this.selectionEnd = this.selectionStart;
	    return change;
	  },

	  /**
	   * Moves cursor left while keeping selection
	   * @param {Event} e
	   */
	  moveCursorLeftWithShift: function(e) {
	    if (this._selectionDirection === 'right' && this.selectionStart !== this.selectionEnd) {
	      return this._moveLeft(e, 'selectionEnd');
	    }
	    else if (this.selectionStart !== 0){
	      this._selectionDirection = 'left';
	      return this._moveLeft(e, 'selectionStart');
	    }
	  },

	  /**
	   * Moves cursor right
	   * @param {Event} e Event object
	   */
	  moveCursorRight: function(e) {
	    if (this.selectionStart >= this._text.length && this.selectionEnd >= this._text.length) {
	      return;
	    }
	    this._moveCursorLeftOrRight('Right', e);
	  },

	  /**
	   * Moves cursor right or Left, fires event
	   * @param {String} direction 'Left', 'Right'
	   * @param {Event} e Event object
	   */
	  _moveCursorLeftOrRight: function(direction, e) {
	    var actionName = 'moveCursor' + direction + 'With';
	    this._currentCursorOpacity = 1;

	    if (e.shiftKey) {
	      actionName += 'Shift';
	    }
	    else {
	      actionName += 'outShift';
	    }
	    if (this[actionName](e)) {
	      this.abortCursorAnimation();
	      this.initDelayedCursor();
	      this._fireSelectionChanged();
	      this._updateTextarea();
	    }
	  },

	  /**
	   * Moves cursor right while keeping selection
	   * @param {Event} e
	   */
	  moveCursorRightWithShift: function(e) {
	    if (this._selectionDirection === 'left' && this.selectionStart !== this.selectionEnd) {
	      return this._moveRight(e, 'selectionStart');
	    }
	    else if (this.selectionEnd !== this._text.length) {
	      this._selectionDirection = 'right';
	      return this._moveRight(e, 'selectionEnd');
	    }
	  },

	  /**
	   * Moves cursor right without keeping selection
	   * @param {Event} e Event object
	   */
	  moveCursorRightWithoutShift: function(e) {
	    var changed = true;
	    this._selectionDirection = 'right';

	    if (this.selectionStart === this.selectionEnd) {
	      changed = this._moveRight(e, 'selectionStart');
	      this.selectionEnd = this.selectionStart;
	    }
	    else {
	      this.selectionStart = this.selectionEnd;
	    }
	    return changed;
	  },

	  /**
	   * Removes characters from start/end
	   * start/end ar per grapheme position in _text array.
	   *
	   * @param {Number} start
	   * @param {Number} end default to start + 1
	   */
	  removeChars: function(start, end) {
	    if (typeof end === 'undefined') {
	      end = start + 1;
	    }
	    this.removeStyleFromTo(start, end);
	    this._text.splice(start, end - start);
	    this.text = this._text.join('');
	    this.set('dirty', true);
	    if (this._shouldClearDimensionCache()) {
	      this.initDimensions();
	      this.setCoords();
	    }
	    this._removeExtraneousStyles();
	  },

	  /**
	   * insert characters at start position, before start position.
	   * start  equal 1 it means the text get inserted between actual grapheme 0 and 1
	   * if style array is provided, it must be as the same length of text in graphemes
	   * if end is provided and is bigger than start, old text is replaced.
	   * start/end ar per grapheme position in _text array.
	   *
	   * @param {String} text text to insert
	   * @param {Array} style array of style objects
	   * @param {Number} start
	   * @param {Number} end default to start + 1
	   */
	  insertChars: function(text, style, start, end) {
	    if (typeof end === 'undefined') {
	      end = start;
	    }
	    if (end > start) {
	      this.removeStyleFromTo(start, end);
	    }
	    var graphemes = fabric.util.string.graphemeSplit(text);
	    this.insertNewStyleBlock(graphemes, start, style);
	    this._text = [].concat(this._text.slice(0, start), graphemes, this._text.slice(end));
	    this.text = this._text.join('');
	    this.set('dirty', true);
	    if (this._shouldClearDimensionCache()) {
	      this.initDimensions();
	      this.setCoords();
	    }
	    this._removeExtraneousStyles();
	  },

	});


	/* _TO_SVG_START_ */
	(function() {
	  var toFixed = fabric.util.toFixed,
	      multipleSpacesRegex = /  +/g;

	  fabric.util.object.extend(fabric.Text.prototype, /** @lends fabric.Text.prototype */ {

	    /**
	     * Returns SVG representation of an instance
	     * @param {Function} [reviver] Method for further parsing of svg representation.
	     * @return {String} svg representation of an instance
	     */
	    _toSVG: function() {
	      var offsets = this._getSVGLeftTopOffsets(),
	          textAndBg = this._getSVGTextAndBg(offsets.textTop, offsets.textLeft);
	      return this._wrapSVGTextAndBg(textAndBg);
	    },

	    /**
	     * Returns svg representation of an instance
	     * @param {Function} [reviver] Method for further parsing of svg representation.
	     * @return {String} svg representation of an instance
	     */
	    toSVG: function(reviver) {
	      return this._createBaseSVGMarkup(
	        this._toSVG(),
	        { reviver: reviver, noStyle: true, withShadow: true }
	      );
	    },

	    /**
	     * @private
	     */
	    _getSVGLeftTopOffsets: function() {
	      return {
	        textLeft: -this.width / 2,
	        textTop: -this.height / 2,
	        lineTop: this.getHeightOfLine(0)
	      };
	    },

	    /**
	     * @private
	     */
	    _wrapSVGTextAndBg: function(textAndBg) {
	      var noShadow = true,
	          textDecoration = this.getSvgTextDecoration(this);
	      return [
	        textAndBg.textBgRects.join(''),
	        '\t\t<text xml:space="preserve" ',
	        (this.fontFamily ? 'font-family="' + this.fontFamily.replace(/"/g, '\'') + '" ' : ''),
	        (this.fontSize ? 'font-size="' + this.fontSize + '" ' : ''),
	        (this.fontStyle ? 'font-style="' + this.fontStyle + '" ' : ''),
	        (this.fontWeight ? 'font-weight="' + this.fontWeight + '" ' : ''),
	        (textDecoration ? 'text-decoration="' + textDecoration + '" ' : ''),
	        'style="', this.getSvgStyles(noShadow), '"', this.addPaintOrder(), ' >',
	        textAndBg.textSpans.join(''),
	        '</text>\n'
	      ];
	    },

	    /**
	     * @private
	     * @param {Number} textTopOffset Text top offset
	     * @param {Number} textLeftOffset Text left offset
	     * @return {Object}
	     */
	    _getSVGTextAndBg: function(textTopOffset, textLeftOffset) {
	      var textSpans = [],
	          textBgRects = [],
	          height = textTopOffset, lineOffset;
	      // bounding-box background
	      this._setSVGBg(textBgRects);

	      // text and text-background
	      for (var i = 0, len = this._textLines.length; i < len; i++) {
	        lineOffset = this._getLineLeftOffset(i);
	        if (this.textBackgroundColor || this.styleHas('textBackgroundColor', i)) {
	          this._setSVGTextLineBg(textBgRects, i, textLeftOffset + lineOffset, height);
	        }
	        this._setSVGTextLineText(textSpans, i, textLeftOffset + lineOffset, height);
	        height += this.getHeightOfLine(i);
	      }

	      return {
	        textSpans: textSpans,
	        textBgRects: textBgRects
	      };
	    },

	    /**
	     * @private
	     */
	    _createTextCharSpan: function(_char, styleDecl, left, top) {
	      var shouldUseWhitespace = _char !== _char.trim() || _char.match(multipleSpacesRegex),
	          styleProps = this.getSvgSpanStyles(styleDecl, shouldUseWhitespace),
	          fillStyles = styleProps ? 'style="' + styleProps + '"' : '',
	          dy = styleDecl.deltaY, dySpan = '',
	          NUM_FRACTION_DIGITS = fabric.Object.NUM_FRACTION_DIGITS;
	      if (dy) {
	        dySpan = ' dy="' + toFixed(dy, NUM_FRACTION_DIGITS) + '" ';
	      }
	      return [
	        '<tspan x="', toFixed(left, NUM_FRACTION_DIGITS), '" y="',
	        toFixed(top, NUM_FRACTION_DIGITS), '" ', dySpan,
	        fillStyles, '>',
	        fabric.util.string.escapeXml(_char),
	        '</tspan>'
	      ].join('');
	    },

	    _setSVGTextLineText: function(textSpans, lineIndex, textLeftOffset, textTopOffset) {
	      // set proper line offset
	      var lineHeight = this.getHeightOfLine(lineIndex),
	          isJustify = this.textAlign.indexOf('justify') !== -1,
	          actualStyle,
	          nextStyle,
	          charsToRender = '',
	          charBox, style,
	          boxWidth = 0,
	          line = this._textLines[lineIndex],
	          timeToRender;

	      textTopOffset += lineHeight * (1 - this._fontSizeFraction) / this.lineHeight;
	      for (var i = 0, len = line.length - 1; i <= len; i++) {
	        timeToRender = i === len || this.charSpacing;
	        charsToRender += line[i];
	        charBox = this.__charBounds[lineIndex][i];
	        if (boxWidth === 0) {
	          textLeftOffset += charBox.kernedWidth - charBox.width;
	          boxWidth += charBox.width;
	        }
	        else {
	          boxWidth += charBox.kernedWidth;
	        }
	        if (isJustify && !timeToRender) {
	          if (this._reSpaceAndTab.test(line[i])) {
	            timeToRender = true;
	          }
	        }
	        if (!timeToRender) {
	          // if we have charSpacing, we render char by char
	          actualStyle = actualStyle || this.getCompleteStyleDeclaration(lineIndex, i);
	          nextStyle = this.getCompleteStyleDeclaration(lineIndex, i + 1);
	          timeToRender = this._hasStyleChangedForSvg(actualStyle, nextStyle);
	        }
	        if (timeToRender) {
	          style = this._getStyleDeclaration(lineIndex, i) || { };
	          textSpans.push(this._createTextCharSpan(charsToRender, style, textLeftOffset, textTopOffset));
	          charsToRender = '';
	          actualStyle = nextStyle;
	          textLeftOffset += boxWidth;
	          boxWidth = 0;
	        }
	      }
	    },

	    _pushTextBgRect: function(textBgRects, color, left, top, width, height) {
	      var NUM_FRACTION_DIGITS = fabric.Object.NUM_FRACTION_DIGITS;
	      textBgRects.push(
	        '\t\t<rect ',
	        this._getFillAttributes(color),
	        ' x="',
	        toFixed(left, NUM_FRACTION_DIGITS),
	        '" y="',
	        toFixed(top, NUM_FRACTION_DIGITS),
	        '" width="',
	        toFixed(width, NUM_FRACTION_DIGITS),
	        '" height="',
	        toFixed(height, NUM_FRACTION_DIGITS),
	        '"></rect>\n');
	    },

	    _setSVGTextLineBg: function(textBgRects, i, leftOffset, textTopOffset) {
	      var line = this._textLines[i],
	          heightOfLine = this.getHeightOfLine(i) / this.lineHeight,
	          boxWidth = 0,
	          boxStart = 0,
	          charBox, currentColor,
	          lastColor = this.getValueOfPropertyAt(i, 0, 'textBackgroundColor');
	      for (var j = 0, jlen = line.length; j < jlen; j++) {
	        charBox = this.__charBounds[i][j];
	        currentColor = this.getValueOfPropertyAt(i, j, 'textBackgroundColor');
	        if (currentColor !== lastColor) {
	          lastColor && this._pushTextBgRect(textBgRects, lastColor, leftOffset + boxStart,
	            textTopOffset, boxWidth, heightOfLine);
	          boxStart = charBox.left;
	          boxWidth = charBox.width;
	          lastColor = currentColor;
	        }
	        else {
	          boxWidth += charBox.kernedWidth;
	        }
	      }
	      currentColor && this._pushTextBgRect(textBgRects, currentColor, leftOffset + boxStart,
	        textTopOffset, boxWidth, heightOfLine);
	    },

	    /**
	     * Adobe Illustrator (at least CS5) is unable to render rgba()-based fill values
	     * we work around it by "moving" alpha channel into opacity attribute and setting fill's alpha to 1
	     *
	     * @private
	     * @param {*} value
	     * @return {String}
	     */
	    _getFillAttributes: function(value) {
	      var fillColor = (value && typeof value === 'string') ? new fabric.Color(value) : '';
	      if (!fillColor || !fillColor.getSource() || fillColor.getAlpha() === 1) {
	        return 'fill="' + value + '"';
	      }
	      return 'opacity="' + fillColor.getAlpha() + '" fill="' + fillColor.setAlpha(1).toRgb() + '"';
	    },

	    /**
	     * @private
	     */
	    _getSVGLineTopOffset: function(lineIndex) {
	      var lineTopOffset = 0, lastHeight = 0;
	      for (var j = 0; j < lineIndex; j++) {
	        lineTopOffset += this.getHeightOfLine(j);
	      }
	      lastHeight = this.getHeightOfLine(j);
	      return {
	        lineTop: lineTopOffset,
	        offset: (this._fontSizeMult - this._fontSizeFraction) * lastHeight / (this.lineHeight * this._fontSizeMult)
	      };
	    },

	    /**
	     * Returns styles-string for svg-export
	     * @param {Boolean} skipShadow a boolean to skip shadow filter output
	     * @return {String}
	     */
	    getSvgStyles: function(skipShadow) {
	      var svgStyle = fabric.Object.prototype.getSvgStyles.call(this, skipShadow);
	      return svgStyle + ' white-space: pre;';
	    },
	  });
	})();
	/* _TO_SVG_END_ */


	(function(global) {

	  var fabric = global.fabric || (global.fabric = {});

	  /**
	   * Textbox class, based on IText, allows the user to resize the text rectangle
	   * and wraps lines automatically. Textboxes have their Y scaling locked, the
	   * user can only change width. Height is adjusted automatically based on the
	   * wrapping of lines.
	   * @class fabric.Textbox
	   * @extends fabric.IText
	   * @mixes fabric.Observable
	   * @return {fabric.Textbox} thisArg
	   * @see {@link fabric.Textbox#initialize} for constructor definition
	   */
	  fabric.Textbox = fabric.util.createClass(fabric.IText, fabric.Observable, {

	    /**
	     * Type of an object
	     * @type String
	     * @default
	     */
	    type: 'textbox',

	    /**
	     * Minimum width of textbox, in pixels.
	     * @type Number
	     * @default
	     */
	    minWidth: 20,

	    /**
	     * Minimum calculated width of a textbox, in pixels.
	     * fixed to 2 so that an empty textbox cannot go to 0
	     * and is still selectable without text.
	     * @type Number
	     * @default
	     */
	    dynamicMinWidth: 2,

	    /**
	     * Cached array of text wrapping.
	     * @type Array
	     */
	    __cachedLines: null,

	    /**
	     * Override standard Object class values
	     */
	    lockScalingFlip: true,

	    /**
	     * Override standard Object class values
	     * Textbox needs this on false
	     */
	    noScaleCache: false,

	    /**
	     * Properties which when set cause object to change dimensions
	     * @type Object
	     * @private
	     */
	    _dimensionAffectingProps: fabric.Text.prototype._dimensionAffectingProps.concat('width'),

	    /**
	     * Use this regular expression to split strings in breakable lines
	     * @private
	     */
	    _wordJoiners: /[ \t\r]/,

	    /**
	     * Use this boolean property in order to split strings that have no white space concept.
	     * this is a cheap way to help with chinese/japanese
	     * @type Boolean
	     * @since 2.6.0
	     */
	    splitByGrapheme: false,

	    /**
	     * Unlike superclass's version of this function, Textbox does not update
	     * its width.
	     * @private
	     * @override
	     */
	    initDimensions: function() {
	      if (this.__skipDimension) {
	        return;
	      }
	      this.isEditing && this.initDelayedCursor();
	      this.clearContextTop();
	      this._clearCache();
	      // clear dynamicMinWidth as it will be different after we re-wrap line
	      this.dynamicMinWidth = 0;
	      // wrap lines
	      this._styleMap = this._generateStyleMap(this._splitText());
	      // if after wrapping, the width is smaller than dynamicMinWidth, change the width and re-wrap
	      if (this.dynamicMinWidth > this.width) {
	        this._set('width', this.dynamicMinWidth);
	      }
	      if (this.textAlign.indexOf('justify') !== -1) {
	        // once text is measured we need to make space fatter to make justified text.
	        this.enlargeSpaces();
	      }
	      // clear cache and re-calculate height
	      this.height = this.calcTextHeight();
	      this.saveState({ propertySet: '_dimensionAffectingProps' });
	    },

	    /**
	     * Generate an object that translates the style object so that it is
	     * broken up by visual lines (new lines and automatic wrapping).
	     * The original text styles object is broken up by actual lines (new lines only),
	     * which is only sufficient for Text / IText
	     * @private
	     */
	    _generateStyleMap: function(textInfo) {
	      var realLineCount     = 0,
	          realLineCharCount = 0,
	          charCount         = 0,
	          map               = {};

	      for (var i = 0; i < textInfo.graphemeLines.length; i++) {
	        if (textInfo.graphemeText[charCount] === '\n' && i > 0) {
	          realLineCharCount = 0;
	          charCount++;
	          realLineCount++;
	        }
	        else if (!this.splitByGrapheme && this._reSpaceAndTab.test(textInfo.graphemeText[charCount]) && i > 0) {
	          // this case deals with space's that are removed from end of lines when wrapping
	          realLineCharCount++;
	          charCount++;
	        }

	        map[i] = { line: realLineCount, offset: realLineCharCount };

	        charCount += textInfo.graphemeLines[i].length;
	        realLineCharCount += textInfo.graphemeLines[i].length;
	      }

	      return map;
	    },

	    /**
	     * Returns true if object has a style property or has it on a specified line
	     * @param {Number} lineIndex
	     * @return {Boolean}
	     */
	    styleHas: function(property, lineIndex) {
	      if (this._styleMap && !this.isWrapping) {
	        var map = this._styleMap[lineIndex];
	        if (map) {
	          lineIndex = map.line;
	        }
	      }
	      return fabric.Text.prototype.styleHas.call(this, property, lineIndex);
	    },

	    /**
	     * Returns true if object has no styling or no styling in a line
	     * @param {Number} lineIndex , lineIndex is on wrapped lines.
	     * @return {Boolean}
	     */
	    isEmptyStyles: function(lineIndex) {
	      if (!this.styles) {
	        return true;
	      }
	      var offset = 0, nextLineIndex = lineIndex + 1, nextOffset, obj, shouldLimit = false,
	          map = this._styleMap[lineIndex], mapNextLine = this._styleMap[lineIndex + 1];
	      if (map) {
	        lineIndex = map.line;
	        offset = map.offset;
	      }
	      if (mapNextLine) {
	        nextLineIndex = mapNextLine.line;
	        shouldLimit = nextLineIndex === lineIndex;
	        nextOffset = mapNextLine.offset;
	      }
	      obj = typeof lineIndex === 'undefined' ? this.styles : { line: this.styles[lineIndex] };
	      for (var p1 in obj) {
	        for (var p2 in obj[p1]) {
	          if (p2 >= offset && (!shouldLimit || p2 < nextOffset)) {
	            // eslint-disable-next-line no-unused-vars
	            for (var p3 in obj[p1][p2]) {
	              return false;
	            }
	          }
	        }
	      }
	      return true;
	    },

	    /**
	     * @param {Number} lineIndex
	     * @param {Number} charIndex
	     * @private
	     */
	    _getStyleDeclaration: function(lineIndex, charIndex) {
	      if (this._styleMap && !this.isWrapping) {
	        var map = this._styleMap[lineIndex];
	        if (!map) {
	          return null;
	        }
	        lineIndex = map.line;
	        charIndex = map.offset + charIndex;
	      }
	      return this.callSuper('_getStyleDeclaration', lineIndex, charIndex);
	    },

	    /**
	     * @param {Number} lineIndex
	     * @param {Number} charIndex
	     * @param {Object} style
	     * @private
	     */
	    _setStyleDeclaration: function(lineIndex, charIndex, style) {
	      var map = this._styleMap[lineIndex];
	      lineIndex = map.line;
	      charIndex = map.offset + charIndex;

	      this.styles[lineIndex][charIndex] = style;
	    },

	    /**
	     * @param {Number} lineIndex
	     * @param {Number} charIndex
	     * @private
	     */
	    _deleteStyleDeclaration: function(lineIndex, charIndex) {
	      var map = this._styleMap[lineIndex];
	      lineIndex = map.line;
	      charIndex = map.offset + charIndex;
	      delete this.styles[lineIndex][charIndex];
	    },

	    /**
	     * probably broken need a fix
	     * Returns the real style line that correspond to the wrapped lineIndex line
	     * Used just to verify if the line does exist or not.
	     * @param {Number} lineIndex
	     * @returns {Boolean} if the line exists or not
	     * @private
	     */
	    _getLineStyle: function(lineIndex) {
	      var map = this._styleMap[lineIndex];
	      return !!this.styles[map.line];
	    },

	    /**
	     * Set the line style to an empty object so that is initialized
	     * @param {Number} lineIndex
	     * @param {Object} style
	     * @private
	     */
	    _setLineStyle: function(lineIndex) {
	      var map = this._styleMap[lineIndex];
	      this.styles[map.line] = {};
	    },

	    /**
	     * Wraps text using the 'width' property of Textbox. First this function
	     * splits text on newlines, so we preserve newlines entered by the user.
	     * Then it wraps each line using the width of the Textbox by calling
	     * _wrapLine().
	     * @param {Array} lines The string array of text that is split into lines
	     * @param {Number} desiredWidth width you want to wrap to
	     * @returns {Array} Array of lines
	     */
	    _wrapText: function(lines, desiredWidth) {
	      var wrapped = [], i;
	      this.isWrapping = true;
	      for (i = 0; i < lines.length; i++) {
	        wrapped = wrapped.concat(this._wrapLine(lines[i], i, desiredWidth));
	      }
	      this.isWrapping = false;
	      return wrapped;
	    },

	    /**
	     * Helper function to measure a string of text, given its lineIndex and charIndex offset
	     * it gets called when charBounds are not available yet.
	     * @param {CanvasRenderingContext2D} ctx
	     * @param {String} text
	     * @param {number} lineIndex
	     * @param {number} charOffset
	     * @returns {number}
	     * @private
	     */
	    _measureWord: function(word, lineIndex, charOffset) {
	      var width = 0, prevGrapheme, skipLeft = true;
	      charOffset = charOffset || 0;
	      for (var i = 0, len = word.length; i < len; i++) {
	        var box = this._getGraphemeBox(word[i], lineIndex, i + charOffset, prevGrapheme, skipLeft);
	        width += box.kernedWidth;
	        prevGrapheme = word[i];
	      }
	      return width;
	    },

	    /**
	     * Wraps a line of text using the width of the Textbox and a context.
	     * @param {Array} line The grapheme array that represent the line
	     * @param {Number} lineIndex
	     * @param {Number} desiredWidth width you want to wrap the line to
	     * @param {Number} reservedSpace space to remove from wrapping for custom functionalities
	     * @returns {Array} Array of line(s) into which the given text is wrapped
	     * to.
	     */
	    _wrapLine: function(_line, lineIndex, desiredWidth, reservedSpace) {
	      var lineWidth = 0,
	          splitByGrapheme = this.splitByGrapheme,
	          graphemeLines = [],
	          line = [],
	          // spaces in different languages?
	          words = splitByGrapheme ? fabric.util.string.graphemeSplit(_line) : _line.split(this._wordJoiners),
	          word = '',
	          offset = 0,
	          infix = splitByGrapheme ? '' : ' ',
	          wordWidth = 0,
	          infixWidth = 0,
	          largestWordWidth = 0,
	          lineJustStarted = true,
	          additionalSpace = this._getWidthOfCharSpacing(),
	          reservedSpace = reservedSpace || 0;
	      // fix a difference between split and graphemeSplit
	      if (words.length === 0) {
	        words.push([]);
	      }
	      desiredWidth -= reservedSpace;
	      for (var i = 0; i < words.length; i++) {
	        // if using splitByGrapheme words are already in graphemes.
	        word = splitByGrapheme ? words[i] : fabric.util.string.graphemeSplit(words[i]);
	        wordWidth = this._measureWord(word, lineIndex, offset);
	        offset += word.length;

	        lineWidth += infixWidth + wordWidth - additionalSpace;
	        if (lineWidth > desiredWidth && !lineJustStarted) {
	          graphemeLines.push(line);
	          line = [];
	          lineWidth = wordWidth;
	          lineJustStarted = true;
	        }
	        else {
	          lineWidth += additionalSpace;
	        }

	        if (!lineJustStarted && !splitByGrapheme) {
	          line.push(infix);
	        }
	        line = line.concat(word);

	        infixWidth = splitByGrapheme ? 0 : this._measureWord([infix], lineIndex, offset);
	        offset++;
	        lineJustStarted = false;
	        // keep track of largest word
	        if (wordWidth > largestWordWidth) {
	          largestWordWidth = wordWidth;
	        }
	      }

	      i && graphemeLines.push(line);

	      if (largestWordWidth + reservedSpace > this.dynamicMinWidth) {
	        this.dynamicMinWidth = largestWordWidth - additionalSpace + reservedSpace;
	      }
	      return graphemeLines;
	    },

	    /**
	     * Detect if the text line is ended with an hard break
	     * text and itext do not have wrapping, return false
	     * @param {Number} lineIndex text to split
	     * @return {Boolean}
	     */
	    isEndOfWrapping: function(lineIndex) {
	      if (!this._styleMap[lineIndex + 1]) {
	        // is last line, return true;
	        return true;
	      }
	      if (this._styleMap[lineIndex + 1].line !== this._styleMap[lineIndex].line) {
	        // this is last line before a line break, return true;
	        return true;
	      }
	      return false;
	    },

	    /**
	     * Detect if a line has a linebreak and so we need to account for it when moving
	     * and counting style.
	     * @return Number
	     */
	    missingNewlineOffset: function(lineIndex) {
	      if (this.splitByGrapheme) {
	        return this.isEndOfWrapping(lineIndex) ? 1 : 0;
	      }
	      return 1;
	    },

	    /**
	    * Gets lines of text to render in the Textbox. This function calculates
	    * text wrapping on the fly every time it is called.
	    * @param {String} text text to split
	    * @returns {Array} Array of lines in the Textbox.
	    * @override
	    */
	    _splitTextIntoLines: function(text) {
	      var newText = fabric.Text.prototype._splitTextIntoLines.call(this, text),
	          graphemeLines = this._wrapText(newText.lines, this.width),
	          lines = new Array(graphemeLines.length);
	      for (var i = 0; i < graphemeLines.length; i++) {
	        lines[i] = graphemeLines[i].join('');
	      }
	      newText.lines = lines;
	      newText.graphemeLines = graphemeLines;
	      return newText;
	    },

	    getMinWidth: function() {
	      return Math.max(this.minWidth, this.dynamicMinWidth);
	    },

	    _removeExtraneousStyles: function() {
	      var linesToKeep = {};
	      for (var prop in this._styleMap) {
	        if (this._textLines[prop]) {
	          linesToKeep[this._styleMap[prop].line] = 1;
	        }
	      }
	      for (var prop in this.styles) {
	        if (!linesToKeep[prop]) {
	          delete this.styles[prop];
	        }
	      }
	    },

	    /**
	     * Returns object representation of an instance
	     * @method toObject
	     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
	     * @return {Object} object representation of an instance
	     */
	    toObject: function(propertiesToInclude) {
	      return this.callSuper('toObject', ['minWidth', 'splitByGrapheme'].concat(propertiesToInclude));
	    }
	  });

	  /**
	   * Returns fabric.Textbox instance from an object representation
	   * @static
	   * @memberOf fabric.Textbox
	   * @param {Object} object Object to create an instance from
	   * @param {Function} [callback] Callback to invoke when an fabric.Textbox instance is created
	   */
	  fabric.Textbox.fromObject = function(object, callback) {
	    return fabric.Object._fromObject('Textbox', object, callback, 'text');
	  };
	})(exports );


	(function() {

	  var controlsUtils = fabric.controlsUtils,
	      scaleSkewStyleHandler = controlsUtils.scaleSkewCursorStyleHandler,
	      scaleStyleHandler = controlsUtils.scaleCursorStyleHandler,
	      scalingEqually = controlsUtils.scalingEqually,
	      scalingYOrSkewingX = controlsUtils.scalingYOrSkewingX,
	      scalingXOrSkewingY = controlsUtils.scalingXOrSkewingY,
	      scaleOrSkewActionName = controlsUtils.scaleOrSkewActionName,
	      objectControls = fabric.Object.prototype.controls;

	  objectControls.ml = new fabric.Control({
	    x: -0.5,
	    y: 0,
	    cursorStyleHandler: scaleSkewStyleHandler,
	    actionHandler: scalingXOrSkewingY,
	    getActionName: scaleOrSkewActionName,
	  });

	  objectControls.mr = new fabric.Control({
	    x: 0.5,
	    y: 0,
	    cursorStyleHandler: scaleSkewStyleHandler,
	    actionHandler: scalingXOrSkewingY,
	    getActionName: scaleOrSkewActionName,
	  });

	  objectControls.mb = new fabric.Control({
	    x: 0,
	    y: 0.5,
	    cursorStyleHandler: scaleSkewStyleHandler,
	    actionHandler: scalingYOrSkewingX,
	    getActionName: scaleOrSkewActionName,
	  });

	  objectControls.mt = new fabric.Control({
	    x: 0,
	    y: -0.5,
	    cursorStyleHandler: scaleSkewStyleHandler,
	    actionHandler: scalingYOrSkewingX,
	    getActionName: scaleOrSkewActionName,
	  });

	  objectControls.tl = new fabric.Control({
	    x: -0.5,
	    y: -0.5,
	    cursorStyleHandler: scaleStyleHandler,
	    actionHandler: scalingEqually
	  });

	  objectControls.tr = new fabric.Control({
	    x: 0.5,
	    y: -0.5,
	    cursorStyleHandler: scaleStyleHandler,
	    actionHandler: scalingEqually
	  });

	  objectControls.bl = new fabric.Control({
	    x: -0.5,
	    y: 0.5,
	    cursorStyleHandler: scaleStyleHandler,
	    actionHandler: scalingEqually
	  });

	  objectControls.br = new fabric.Control({
	    x: 0.5,
	    y: 0.5,
	    cursorStyleHandler: scaleStyleHandler,
	    actionHandler: scalingEqually
	  });

	  objectControls.mtr = new fabric.Control({
	    x: 0,
	    y: -0.5,
	    actionHandler: controlsUtils.rotationWithSnapping,
	    cursorStyleHandler: controlsUtils.rotationStyleHandler,
	    offsetY: -40,
	    withConnection: true,
	    actionName: 'rotate',
	  });

	  if (fabric.Textbox) {
	    // this is breaking the prototype inheritance, no time / ideas to fix it.
	    // is important to document that if you want to have all objects to have a
	    // specific custom control, you have to add it to Object prototype and to Textbox
	    // prototype. The controls are shared as references. So changes to control `tr`
	    // can still apply to all objects if needed.
	    var textBoxControls = fabric.Textbox.prototype.controls = { };

	    textBoxControls.mtr = objectControls.mtr;
	    textBoxControls.tr = objectControls.tr;
	    textBoxControls.br = objectControls.br;
	    textBoxControls.tl = objectControls.tl;
	    textBoxControls.bl = objectControls.bl;
	    textBoxControls.mt = objectControls.mt;
	    textBoxControls.mb = objectControls.mb;

	    textBoxControls.mr = new fabric.Control({
	      x: 0.5,
	      y: 0,
	      actionHandler: controlsUtils.changeWidth,
	      cursorStyleHandler: scaleSkewStyleHandler,
	      actionName: 'resizing',
	    });

	    textBoxControls.ml = new fabric.Control({
	      x: -0.5,
	      y: 0,
	      actionHandler: controlsUtils.changeWidth,
	      cursorStyleHandler: scaleSkewStyleHandler,
	      actionName: 'resizing',
	    });
	  }
	})(); 
} (fabric$1));

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).slice(1));
}
function unsafeStringify(arr, offset = 0) {
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  //
  // Note to future-self: No, you can't remove the `toLowerCase()` call.
  // REF: https://github.com/uuidjs/uuid/pull/677#issuecomment-1757351351
  return (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase();
}

// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).

var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }
  return getRandomValues(rnds8);
}

var randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var native = {
  randomUUID
};

function v4(options, buf, offset) {
  if (native.randomUUID && !buf && !options) {
    return native.randomUUID();
  }
  options = options || {};
  var rnds = options.random || (options.rng || rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80;
  return unsafeStringify(rnds);
}

function loadFromJSON(json) {
    this.loading?.(true);
    let canvas = this.canvas, me = this;
    this.mute();
    if (typeof json === 'string') {
        json = JSON.parse(json);
    }
    return new Promise(function (resolve) {
        canvas.loadFromJSON(json, function () {
            me.transformCanvasViewport();
            const currentPage = me.currentPage;
            currentPage?.setDesign(json);
            canvas.fire('canvas:x-ready', currentPage);
            me.loading?.(false);
            me.unmute();
            resolve(null);
        });
    });
}
class CanvasEditor {
    constructor(wrapper, loading) {
        this.margin = 10;
        this.canvasWidth = 0;
        this.canvasHeight = 0;
        this.pageHeight = 0;
        this.pageWidth = 0;
        this.pageX = 0;
        this.pageY = 0;
        this.muteUndoRedoStack = 0;
        this.urStack = [];
        this.currentStep = -1;
        this.maxUndoStepCount = 5;
        this.notificationCallbacks = [];
        this.scale = 1;
        this.wrapper = wrapper;
        this.loading = loading;
    }
    restrictObject(target, valProp, getMaxVal, rangeProp) {
        var ranges = target[rangeProp];
        if (ranges) {
            var max = getMaxVal(), value = target[valProp], value2 = value + max, mid = value + max / 2, isAligned = false, needCoordsCalc;
            for (var range of ranges) {
                if (range[0] < mid && mid < range[1]) {
                    if (range[0] > value) {
                        target[valProp] = range[0];
                        needCoordsCalc = true;
                    }
                    else if (range[1] < value2) {
                        target[valProp] = range[1] - max;
                        needCoordsCalc = true;
                    }
                    isAligned = true;
                    break;
                }
            }
            if (!isAligned) {
                let range = ranges[0], min = Number.MAX_VALUE;
                for (let r of ranges) {
                    let rMid = (r[0] + r[1]) / 2, diff = Math.abs(rMid - mid);
                    if (diff < min) {
                        min = diff;
                        range = r;
                    }
                }
                if (Math.abs(range[0] - mid) > Math.abs(range[1] - mid)) {
                    target[valProp] = range[1] - max;
                    needCoordsCalc = true;
                }
                else {
                    target[valProp] = range[0];
                    needCoordsCalc = true;
                }
            }
            needCoordsCalc && target.setCoords();
        }
    }
    enumerateCanvasObjects(callback, includeGroups, descendSVG) {
        this.canvas.getObjects().forEach((o) => {
            this.enumerateObjects(o, callback, includeGroups, descendSVG);
        });
    }
    enumerateObjects(object, callback, includeGroups, descendPathGroups) {
        var keepEnumerating = true;
        if (object.type === 'group' || (object.type === 'svg' && descendPathGroups)) {
            if (includeGroups) {
                keepEnumerating = callback(object);
            }
            var objects = object.getObjects();
            for (var i = 0, length = objects.length; keepEnumerating && i < length; i++) {
                keepEnumerating = this.enumerateObjects(objects[i], callback, includeGroups, descendPathGroups);
            }
        }
        else {
            keepEnumerating = callback(object);
        }
        return keepEnumerating;
    }
    transformCanvasViewport() {
        let canvas = this.canvas, page = this.currentPage, margin = this.margin * 2, canvasWidth = this.canvasWidth - margin, canvasHeight = this.canvasHeight - margin, totalWidth = (page?.getEffectiveWidth() || canvasWidth), totalHeight = (page?.getEffectiveHeight() || canvasHeight), rx = canvasWidth / totalWidth, ry = canvasHeight / totalHeight, rr = (rx < ry) ? rx : ry;
        totalWidth *= rr;
        totalHeight *= rr;
        canvas.width = this.canvasWidth;
        canvas.height = this.canvasHeight;
        this.pageX = (canvasWidth - totalWidth + margin) / 2;
        this.pageY = (canvasHeight - totalHeight + margin) / 2;
        this.pageWidth = totalWidth;
        this.pageHeight = totalHeight;
        this.scale = rr;
        let tx = this.pageX + (page?.getLeft() || 0) * rr;
        let ty = this.pageY + (page?.getTop() || 0) * rr;
        canvas.setViewportTransform([rr, 0, 0, rr, tx, ty]);
    }
    recalcCanvasLayout(width, height) {
        this.canvas.setDimensions({ width, height });
        this.canvasWidth = width;
        this.canvasHeight = height;
        this.transformCanvasViewport();
    }
    shouldDeleteObjects(objects) {
        const allow = Boolean(objects.length);
        if (allow) {
            for (let obj of objects) {
                const o = obj;
                if (o.isLocked() || o.undeletable) {
                    return false;
                }
            }
        }
        return allow;
    }
    mute() {
        this.muteUndoRedoStack++;
    }
    unmute() {
        if (this.muteUndoRedoStack > 0)
            this.muteUndoRedoStack--;
    }
    deleteObjects(objects) {
        if (objects && objects.length === 0) {
            return;
        }
        let canvas = this.canvas;
        this.mute();
        canvas.discardActiveObject();
        objects.forEach((object) => {
            object.getParent().remove(object);
        });
        this.unmute();
        canvas.fire('object:removed', { target: objects });
        canvas.renderAll();
    }
    copyObjects(objects) {
        let copyPromises, canvas = this.canvas;
        this.mute();
        canvas.discardActiveObject();
        copyPromises = objects.map((object) => new Promise((resolve) => {
            object.clone(function (copy) {
                copy.set('top', (object.top || 0) + 5);
                copy.set('left', (object.left || 0) + 5);
                copy.set('id', v4());
                if (copy) {
                    let parent = object.getParent();
                    if (canvas === parent) {
                        parent.insertAt(copy, parent._objects.indexOf(object) + 1);
                    }
                    else {
                        parent.add(copy);
                    }
                }
                resolve(copy);
            });
        }));
        Promise.all(copyPromises).then(copiedObjects => {
            let numObjects = copiedObjects.length, newObject;
            if (numObjects === 1) {
                canvas.setActiveObject(copiedObjects[0]);
                newObject = copiedObjects[0];
            }
            else {
                var selectionGroup = new fabric$1.fabric.ActiveSelection(copiedObjects, {
                    canvas: canvas
                });
                selectionGroup.layer = copiedObjects[0].layer;
                canvas.setActiveObject(selectionGroup);
                newObject = selectionGroup;
            }
            canvas.fire('object:added', { target: newObject });
            canvas.renderAll();
        }).finally(() => {
            this.unmute();
        });
    }
    getJSON() {
        let json = this.canvas.toJSON(), page = this.currentPage;
        json.pageWidth = page?.getWidth();
        json.pageHeight = page?.getHeight();
        return JSON.stringify(json);
    }
    updatePage() {
        this.currentPage?.setDesign(this.getJSON());
    }
    notifyStateChange() {
        for (let cb of this.notificationCallbacks) {
            try {
                cb();
            }
            catch (e) { }
        }
    }
    onCanvasStateChange(cb) {
        this.notificationCallbacks.push(cb);
    }
    offCanvasStateChange(cb) {
        this.notificationCallbacks = this.notificationCallbacks.filter(i => i !== cb);
    }
    saveCurrentState() {
        if (this.muteUndoRedoStack) {
            return;
        }
        if (this.currentStep < this.urStack.length - 1) {
            this.urStack.splice(this.currentStep + 1);
        }
        this.urStack.push(this.getJSON());
        this.currentStep++;
        if (this.urStack.length > this.maxUndoStepCount + 1) {
            this.urStack.shift();
            this.currentStep--;
        }
        this.notifyStateChange();
    }
    canUndo() {
        return this.currentStep > 0;
    }
    canRedo() {
        return this.currentStep < ((this.urStack?.length || 0) - 1);
    }
    async loadCurrentState() {
        return loadFromJSON.call(this, this.urStack[this.currentStep]);
    }
    redo() {
        if (!this.canRedo()) {
            return;
        }
        this.currentStep++;
        this.loadCurrentState();
        this.notifyStateChange();
    }
    undo() {
        if (!this.canUndo()) {
            return;
        }
        this.currentStep--;
        this.loadCurrentState();
        this.notifyStateChange();
    }
}

function useContainerDimensions(myRef) {
    const getDimensions = () => ({
        width: myRef.current?.offsetWidth || 0,
        height: myRef.current?.offsetHeight || 0
    });
    const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
    useEffect(() => {
        let observer;
        if (myRef.current) {
            setDimensions(getDimensions());
            observer = new ResizeObserver((entries) => {
                window.requestAnimationFrame(() => {
                    if (!Array.isArray(entries) || !entries.length || !myRef.current) {
                        return;
                    }
                    setDimensions(getDimensions());
                });
            });
            observer.observe(myRef.current);
        }
        return () => {
            observer?.disconnect();
        };
    }, [myRef]);
    return dimensions;
}

var img$3 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAAACXBIWXMAABYlAAAWJQFJUiTwAAAFJUlEQVR4nO2d3XHjNhDH9zz3LndgdWClgigVxBPOhI/mVRBdBdZ14KvgoEc+cOJUcHIFkTuwOjhV4Mw6f5wggRLxTUjib0Yjm5BN8q/Fxy4W4Ie3tzfqi6KsJkQ0JaIxEU3wftNxORsiWhHRK17LphZL7VOJSCpgUVbXRHSHFws30j7kzgsRCQi6OisBi7JiwSoi+l0rjIMUUzS1+BHzRO8CKjd4jWox8z0xrI3/58ygWsaCq/sTEc2bWrzGOMeHP/68nxPRw95x/ganLiJCuBleIauoL4sYQl61iMfcclsCMYwpyqpCA/+QmXjMPV9bUVZzrcQDtsBjjaCRJRZlNUab86tWmCdrbl5C9N5X2pFdOi2xKKsZrO5UxCO0yd+LsnrUSizpskCJZokQVSTsWWPB93bn2jZ2WaBkxxJRZdn8T108wr2tMKi3xlRAUkScosry7+cCd3j/ohO0wkZAKeL3DHvYUHyzFdFWwEvASkTTTiQVMlDwA+8qY7yuEzUfv5j41H0LuEZnxO7WyqYnRKMvoznTCO4if5mTrmvqS8AFHP1gYSiMDObwOEKhDd/2SS1gFH9UJYJX9LWpxUw7ClIJ+AzXKZpw+yDCJAKNGH47VFtSCPi5qYW3y+RCQG9pjfZQq8oxhzEb9GS9iMfwDTe1YEv8ohXacYPwnEZMAe9ShtaP0dSCO5dPRz5iwgPa1x1iCvjk6l/GoKmFCCCiFkuMKeAIvnNuIn7WCsy537fC2K5cjiJym/yPVmDOjhWm8IWzExGTXWvtqBl3aoA5VTAhKxExHLEOXYGR+rcpozG5ibj0qMq9CEgZVufWsZ0Bt/Ie+ogHjhB96R24lgvH6+AIUG8B1ZuMrFAb2xnyXo2v4HJdLLDCZ4f7v5UC9uGrrnNx84DQjhjAE2xSwEVCS9wgvS0nXNvk6c/0NgwOU7RLq7awUN8UZeUyVbv4KH/CTbUGDS+EJwcBx8O05haXNnkyCLjFZbph1GuSeW4UZWUtxmCBngwCejII6MkgoCeDgOBYGvMxBgG3RM9QPXe0OV8DNoOAW6bakW5Wg4BbXAR8HQTcpsS5JGgOAgLXKc7lIOD/OAnIU6MXLyAy8l2qL6f/DsMYj1m593mUixbQw/pIRu8vNh4I123lWn2bWvSWmZALcw/r+zkNGkRAnh91dcb7AAsm/3I89UYV0KsKIz1jiXyXDZYyZJH3cgh80a8eyx8WTS38s7P2xCO8i8wSKXeAeEvPtSP+Gaot4klyzEZ9RxHPZ6HiYn+xkLWAR8STZCdiIPE2bWNGKwENxJNIEXvPgVG2J/BdIvvYtlTNuBOxEG+fL1jokpyA6+U4m6w14GokoId4khdsJ5Uk9wZW9xhwU4zDiw27BAzQ7atEXe4aadup48tdDQScYqOJkARdcA2LmyEsFXRLPemyHeLjgeMqK/RAIS/sHsum1kgre7IVU9m8sYq0h4JRIqhpG8j/6G+tIDzPyqYT6sYTavLnFD/H3nrFbNMJi16Yv+lvWsF58gkLEzsxHgcGWi56ChiLR7YD6QsQ0Uo8co3GoGfmxv9ctoDaYIW99ajAKZiAE7GIL1rh6SH3hnEaUjmHs9BDsYhftcLTYQHxnBf9BJkTQZUWPe7Wa0uw4G+QkD7MfxJge5EUcI0Zh4qcB5+Vi7SHVQii7J4UbVozIyGDb3SmEn1euKcdzaWP3RoEDUnqhxFMlIcRhA4AvCBmKc7uYQRtKKtD5eMw5CMxugbn2uMwelsBSkT/ASL3KORBagyBAAAAAElFTkSuQmCC";

var img$2 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA4CAYAAACohjseAAAACXBIWXMAAAsTAAALEwEAmpwYAAACWElEQVRoge2az0sVURTHv0mQQoGQayGXLnXxFoHMwiwMVFy5EHRTy6Ak2pTMxug/aFOLdFcbRVwbUaB/QELQr0V/wGuRGPiqc/E+vFzPvTN35r6ZCc8XPgwy955zPiLje8wF4meBeEe0ib8BqPVvifkezBQlF4h1hEm5eK7rNSqPEEeuy8Nqx/dnmPiFuIKHxLUqJXzZQly5LptVSrgyDX64A+ImMZkDte6jo850dSpnc4n4xAz1h0gCa13X++xan4n+OOOG5wkzkGK9YL0NR73HpSc1oh7P48j+s5rFyYPAHqZDLObYz7Go93MPnNkc+8eQ49/LS6bB/8SLLMHfDRiyDEdZgnUPGANvfjZgwDK0swTvIvyDclNQc9/JEjSTMkV2Qwr0ILs4O1NatFjKFBPBHkcEQ5Iyxc6tYAsnX2/WiIuONUvEtr5yUfue6jotx5raBL8baziBEZx+zuzon+0sGzW+OfrUJpjVMLHWJDn6cRHBkNgNRdDTMIEIiiAggmGxG4qgp2ECERRBQATDYjcUQU/DBCIogoAIhsVuKIKehglEUAQBEQyL3dAnaL56XmXuT1h1Jpg1q8b9jqNPbYIfjDWTzP0hnL57VNerzJopo8Z7R5/aBNXA98DLdTNK3NdXV27oOtwvAJB3E2FJmWIi2ONEFVxhin0h+spOWTCq71dmpgdFC84xxRSviFsodpqpKKqf68DtTFHBK+CPazUJdU71clFBlWcNkPCxVkZOZYDYb4AIxx4iHbUcJHYaIGSyreeKmtvEG+IHcVyx0LHu+xoBp4D/Ac6W4eYyr6DZAAAAAElFTkSuQmCC";

/**
 * https://opentype.js.org v1.3.4 | (c) Frederik De Bleser and other contributors | MIT License | Uses tiny-inflate by Devon Govett and string.prototype.codepointat polyfill by Mathias Bynens
 */

/*! https://mths.be/codepointat v0.2.0 by @mathias */
if (!String.prototype.codePointAt) {
	(function() {
		var defineProperty = (function() {
			// IE 8 only supports `Object.defineProperty` on DOM elements
			try {
				var object = {};
				var $defineProperty = Object.defineProperty;
				var result = $defineProperty(object, object, object) && $defineProperty;
			} catch(error) {}
			return result;
		}());
		var codePointAt = function(position) {
			if (this == null) {
				throw TypeError();
			}
			var string = String(this);
			var size = string.length;
			// `ToInteger`
			var index = position ? Number(position) : 0;
			if (index != index) { // better `isNaN`
				index = 0;
			}
			// Account for out-of-bounds indices:
			if (index < 0 || index >= size) {
				return undefined;
			}
			// Get the first code unit
			var first = string.charCodeAt(index);
			var second;
			if ( // check if it’s the start of a surrogate pair
				first >= 0xD800 && first <= 0xDBFF && // high surrogate
				size > index + 1 // there is a next code unit
			) {
				second = string.charCodeAt(index + 1);
				if (second >= 0xDC00 && second <= 0xDFFF) { // low surrogate
					// https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
					return (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
				}
			}
			return first;
		};
		if (defineProperty) {
			defineProperty(String.prototype, 'codePointAt', {
				'value': codePointAt,
				'configurable': true,
				'writable': true
			});
		} else {
			String.prototype.codePointAt = codePointAt;
		}
	}());
}

var TINF_OK = 0;
var TINF_DATA_ERROR = -3;

function Tree() {
  this.table = new Uint16Array(16);   /* table of code length counts */
  this.trans = new Uint16Array(288);  /* code -> symbol translation table */
}

function Data(source, dest) {
  this.source = source;
  this.sourceIndex = 0;
  this.tag = 0;
  this.bitcount = 0;
  
  this.dest = dest;
  this.destLen = 0;
  
  this.ltree = new Tree();  /* dynamic length/symbol tree */
  this.dtree = new Tree();  /* dynamic distance tree */
}

/* --------------------------------------------------- *
 * -- uninitialized global data (static structures) -- *
 * --------------------------------------------------- */

var sltree = new Tree();
var sdtree = new Tree();

/* extra bits and base tables for length codes */
var length_bits = new Uint8Array(30);
var length_base = new Uint16Array(30);

/* extra bits and base tables for distance codes */
var dist_bits = new Uint8Array(30);
var dist_base = new Uint16Array(30);

/* special ordering of code length codes */
var clcidx = new Uint8Array([
  16, 17, 18, 0, 8, 7, 9, 6,
  10, 5, 11, 4, 12, 3, 13, 2,
  14, 1, 15
]);

/* used by tinf_decode_trees, avoids allocations every call */
var code_tree = new Tree();
var lengths = new Uint8Array(288 + 32);

/* ----------------------- *
 * -- utility functions -- *
 * ----------------------- */

/* build extra bits and base tables */
function tinf_build_bits_base(bits, base, delta, first) {
  var i, sum;

  /* build bits table */
  for (i = 0; i < delta; ++i) { bits[i] = 0; }
  for (i = 0; i < 30 - delta; ++i) { bits[i + delta] = i / delta | 0; }

  /* build base table */
  for (sum = first, i = 0; i < 30; ++i) {
    base[i] = sum;
    sum += 1 << bits[i];
  }
}

/* build the fixed huffman trees */
function tinf_build_fixed_trees(lt, dt) {
  var i;

  /* build fixed length tree */
  for (i = 0; i < 7; ++i) { lt.table[i] = 0; }

  lt.table[7] = 24;
  lt.table[8] = 152;
  lt.table[9] = 112;

  for (i = 0; i < 24; ++i) { lt.trans[i] = 256 + i; }
  for (i = 0; i < 144; ++i) { lt.trans[24 + i] = i; }
  for (i = 0; i < 8; ++i) { lt.trans[24 + 144 + i] = 280 + i; }
  for (i = 0; i < 112; ++i) { lt.trans[24 + 144 + 8 + i] = 144 + i; }

  /* build fixed distance tree */
  for (i = 0; i < 5; ++i) { dt.table[i] = 0; }

  dt.table[5] = 32;

  for (i = 0; i < 32; ++i) { dt.trans[i] = i; }
}

/* given an array of code lengths, build a tree */
var offs = new Uint16Array(16);

function tinf_build_tree(t, lengths, off, num) {
  var i, sum;

  /* clear code length count table */
  for (i = 0; i < 16; ++i) { t.table[i] = 0; }

  /* scan symbol lengths, and sum code length counts */
  for (i = 0; i < num; ++i) { t.table[lengths[off + i]]++; }

  t.table[0] = 0;

  /* compute offset table for distribution sort */
  for (sum = 0, i = 0; i < 16; ++i) {
    offs[i] = sum;
    sum += t.table[i];
  }

  /* create code->symbol translation table (symbols sorted by code) */
  for (i = 0; i < num; ++i) {
    if (lengths[off + i]) { t.trans[offs[lengths[off + i]]++] = i; }
  }
}

/* ---------------------- *
 * -- decode functions -- *
 * ---------------------- */

/* get one bit from source stream */
function tinf_getbit(d) {
  /* check if tag is empty */
  if (!d.bitcount--) {
    /* load next tag */
    d.tag = d.source[d.sourceIndex++];
    d.bitcount = 7;
  }

  /* shift bit out of tag */
  var bit = d.tag & 1;
  d.tag >>>= 1;

  return bit;
}

/* read a num bit value from a stream and add base */
function tinf_read_bits(d, num, base) {
  if (!num)
    { return base; }

  while (d.bitcount < 24) {
    d.tag |= d.source[d.sourceIndex++] << d.bitcount;
    d.bitcount += 8;
  }

  var val = d.tag & (0xffff >>> (16 - num));
  d.tag >>>= num;
  d.bitcount -= num;
  return val + base;
}

/* given a data stream and a tree, decode a symbol */
function tinf_decode_symbol(d, t) {
  while (d.bitcount < 24) {
    d.tag |= d.source[d.sourceIndex++] << d.bitcount;
    d.bitcount += 8;
  }
  
  var sum = 0, cur = 0, len = 0;
  var tag = d.tag;

  /* get more bits while code value is above sum */
  do {
    cur = 2 * cur + (tag & 1);
    tag >>>= 1;
    ++len;

    sum += t.table[len];
    cur -= t.table[len];
  } while (cur >= 0);
  
  d.tag = tag;
  d.bitcount -= len;

  return t.trans[sum + cur];
}

/* given a data stream, decode dynamic trees from it */
function tinf_decode_trees(d, lt, dt) {
  var hlit, hdist, hclen;
  var i, num, length;

  /* get 5 bits HLIT (257-286) */
  hlit = tinf_read_bits(d, 5, 257);

  /* get 5 bits HDIST (1-32) */
  hdist = tinf_read_bits(d, 5, 1);

  /* get 4 bits HCLEN (4-19) */
  hclen = tinf_read_bits(d, 4, 4);

  for (i = 0; i < 19; ++i) { lengths[i] = 0; }

  /* read code lengths for code length alphabet */
  for (i = 0; i < hclen; ++i) {
    /* get 3 bits code length (0-7) */
    var clen = tinf_read_bits(d, 3, 0);
    lengths[clcidx[i]] = clen;
  }

  /* build code length tree */
  tinf_build_tree(code_tree, lengths, 0, 19);

  /* decode code lengths for the dynamic trees */
  for (num = 0; num < hlit + hdist;) {
    var sym = tinf_decode_symbol(d, code_tree);

    switch (sym) {
      case 16:
        /* copy previous code length 3-6 times (read 2 bits) */
        var prev = lengths[num - 1];
        for (length = tinf_read_bits(d, 2, 3); length; --length) {
          lengths[num++] = prev;
        }
        break;
      case 17:
        /* repeat code length 0 for 3-10 times (read 3 bits) */
        for (length = tinf_read_bits(d, 3, 3); length; --length) {
          lengths[num++] = 0;
        }
        break;
      case 18:
        /* repeat code length 0 for 11-138 times (read 7 bits) */
        for (length = tinf_read_bits(d, 7, 11); length; --length) {
          lengths[num++] = 0;
        }
        break;
      default:
        /* values 0-15 represent the actual code lengths */
        lengths[num++] = sym;
        break;
    }
  }

  /* build dynamic trees */
  tinf_build_tree(lt, lengths, 0, hlit);
  tinf_build_tree(dt, lengths, hlit, hdist);
}

/* ----------------------------- *
 * -- block inflate functions -- *
 * ----------------------------- */

/* given a stream and two trees, inflate a block of data */
function tinf_inflate_block_data(d, lt, dt) {
  while (1) {
    var sym = tinf_decode_symbol(d, lt);

    /* check for end of block */
    if (sym === 256) {
      return TINF_OK;
    }

    if (sym < 256) {
      d.dest[d.destLen++] = sym;
    } else {
      var length, dist, offs;
      var i;

      sym -= 257;

      /* possibly get more bits from length code */
      length = tinf_read_bits(d, length_bits[sym], length_base[sym]);

      dist = tinf_decode_symbol(d, dt);

      /* possibly get more bits from distance code */
      offs = d.destLen - tinf_read_bits(d, dist_bits[dist], dist_base[dist]);

      /* copy match */
      for (i = offs; i < offs + length; ++i) {
        d.dest[d.destLen++] = d.dest[i];
      }
    }
  }
}

/* inflate an uncompressed block of data */
function tinf_inflate_uncompressed_block(d) {
  var length, invlength;
  var i;
  
  /* unread from bitbuffer */
  while (d.bitcount > 8) {
    d.sourceIndex--;
    d.bitcount -= 8;
  }

  /* get length */
  length = d.source[d.sourceIndex + 1];
  length = 256 * length + d.source[d.sourceIndex];

  /* get one's complement of length */
  invlength = d.source[d.sourceIndex + 3];
  invlength = 256 * invlength + d.source[d.sourceIndex + 2];

  /* check length */
  if (length !== (~invlength & 0x0000ffff))
    { return TINF_DATA_ERROR; }

  d.sourceIndex += 4;

  /* copy block */
  for (i = length; i; --i)
    { d.dest[d.destLen++] = d.source[d.sourceIndex++]; }

  /* make sure we start next block on a byte boundary */
  d.bitcount = 0;

  return TINF_OK;
}

/* inflate stream from source to dest */
function tinf_uncompress(source, dest) {
  var d = new Data(source, dest);
  var bfinal, btype, res;

  do {
    /* read final block flag */
    bfinal = tinf_getbit(d);

    /* read block type (2 bits) */
    btype = tinf_read_bits(d, 2, 0);

    /* decompress block */
    switch (btype) {
      case 0:
        /* decompress uncompressed block */
        res = tinf_inflate_uncompressed_block(d);
        break;
      case 1:
        /* decompress block with fixed huffman trees */
        res = tinf_inflate_block_data(d, sltree, sdtree);
        break;
      case 2:
        /* decompress block with dynamic huffman trees */
        tinf_decode_trees(d, d.ltree, d.dtree);
        res = tinf_inflate_block_data(d, d.ltree, d.dtree);
        break;
      default:
        res = TINF_DATA_ERROR;
    }

    if (res !== TINF_OK)
      { throw new Error('Data error'); }

  } while (!bfinal);

  if (d.destLen < d.dest.length) {
    if (typeof d.dest.slice === 'function')
      { return d.dest.slice(0, d.destLen); }
    else
      { return d.dest.subarray(0, d.destLen); }
  }
  
  return d.dest;
}

/* -------------------- *
 * -- initialization -- *
 * -------------------- */

/* build fixed huffman trees */
tinf_build_fixed_trees(sltree, sdtree);

/* build extra bits and base tables */
tinf_build_bits_base(length_bits, length_base, 4, 3);
tinf_build_bits_base(dist_bits, dist_base, 2, 1);

/* fix a special case */
length_bits[28] = 0;
length_base[28] = 258;

var tinyInflate = tinf_uncompress;

// The Bounding Box object

function derive(v0, v1, v2, v3, t) {
    return Math.pow(1 - t, 3) * v0 +
        3 * Math.pow(1 - t, 2) * t * v1 +
        3 * (1 - t) * Math.pow(t, 2) * v2 +
        Math.pow(t, 3) * v3;
}
/**
 * A bounding box is an enclosing box that describes the smallest measure within which all the points lie.
 * It is used to calculate the bounding box of a glyph or text path.
 *
 * On initialization, x1/y1/x2/y2 will be NaN. Check if the bounding box is empty using `isEmpty()`.
 *
 * @exports opentype.BoundingBox
 * @class
 * @constructor
 */
function BoundingBox() {
    this.x1 = Number.NaN;
    this.y1 = Number.NaN;
    this.x2 = Number.NaN;
    this.y2 = Number.NaN;
}

/**
 * Returns true if the bounding box is empty, that is, no points have been added to the box yet.
 */
BoundingBox.prototype.isEmpty = function() {
    return isNaN(this.x1) || isNaN(this.y1) || isNaN(this.x2) || isNaN(this.y2);
};

/**
 * Add the point to the bounding box.
 * The x1/y1/x2/y2 coordinates of the bounding box will now encompass the given point.
 * @param {number} x - The X coordinate of the point.
 * @param {number} y - The Y coordinate of the point.
 */
BoundingBox.prototype.addPoint = function(x, y) {
    if (typeof x === 'number') {
        if (isNaN(this.x1) || isNaN(this.x2)) {
            this.x1 = x;
            this.x2 = x;
        }
        if (x < this.x1) {
            this.x1 = x;
        }
        if (x > this.x2) {
            this.x2 = x;
        }
    }
    if (typeof y === 'number') {
        if (isNaN(this.y1) || isNaN(this.y2)) {
            this.y1 = y;
            this.y2 = y;
        }
        if (y < this.y1) {
            this.y1 = y;
        }
        if (y > this.y2) {
            this.y2 = y;
        }
    }
};

/**
 * Add a X coordinate to the bounding box.
 * This extends the bounding box to include the X coordinate.
 * This function is used internally inside of addBezier.
 * @param {number} x - The X coordinate of the point.
 */
BoundingBox.prototype.addX = function(x) {
    this.addPoint(x, null);
};

/**
 * Add a Y coordinate to the bounding box.
 * This extends the bounding box to include the Y coordinate.
 * This function is used internally inside of addBezier.
 * @param {number} y - The Y coordinate of the point.
 */
BoundingBox.prototype.addY = function(y) {
    this.addPoint(null, y);
};

/**
 * Add a Bézier curve to the bounding box.
 * This extends the bounding box to include the entire Bézier.
 * @param {number} x0 - The starting X coordinate.
 * @param {number} y0 - The starting Y coordinate.
 * @param {number} x1 - The X coordinate of the first control point.
 * @param {number} y1 - The Y coordinate of the first control point.
 * @param {number} x2 - The X coordinate of the second control point.
 * @param {number} y2 - The Y coordinate of the second control point.
 * @param {number} x - The ending X coordinate.
 * @param {number} y - The ending Y coordinate.
 */
BoundingBox.prototype.addBezier = function(x0, y0, x1, y1, x2, y2, x, y) {
    // This code is based on http://nishiohirokazu.blogspot.com/2009/06/how-to-calculate-bezier-curves-bounding.html
    // and https://github.com/icons8/svg-path-bounding-box

    var p0 = [x0, y0];
    var p1 = [x1, y1];
    var p2 = [x2, y2];
    var p3 = [x, y];

    this.addPoint(x0, y0);
    this.addPoint(x, y);

    for (var i = 0; i <= 1; i++) {
        var b = 6 * p0[i] - 12 * p1[i] + 6 * p2[i];
        var a = -3 * p0[i] + 9 * p1[i] - 9 * p2[i] + 3 * p3[i];
        var c = 3 * p1[i] - 3 * p0[i];

        if (a === 0) {
            if (b === 0) { continue; }
            var t = -c / b;
            if (0 < t && t < 1) {
                if (i === 0) { this.addX(derive(p0[i], p1[i], p2[i], p3[i], t)); }
                if (i === 1) { this.addY(derive(p0[i], p1[i], p2[i], p3[i], t)); }
            }
            continue;
        }

        var b2ac = Math.pow(b, 2) - 4 * c * a;
        if (b2ac < 0) { continue; }
        var t1 = (-b + Math.sqrt(b2ac)) / (2 * a);
        if (0 < t1 && t1 < 1) {
            if (i === 0) { this.addX(derive(p0[i], p1[i], p2[i], p3[i], t1)); }
            if (i === 1) { this.addY(derive(p0[i], p1[i], p2[i], p3[i], t1)); }
        }
        var t2 = (-b - Math.sqrt(b2ac)) / (2 * a);
        if (0 < t2 && t2 < 1) {
            if (i === 0) { this.addX(derive(p0[i], p1[i], p2[i], p3[i], t2)); }
            if (i === 1) { this.addY(derive(p0[i], p1[i], p2[i], p3[i], t2)); }
        }
    }
};

/**
 * Add a quadratic curve to the bounding box.
 * This extends the bounding box to include the entire quadratic curve.
 * @param {number} x0 - The starting X coordinate.
 * @param {number} y0 - The starting Y coordinate.
 * @param {number} x1 - The X coordinate of the control point.
 * @param {number} y1 - The Y coordinate of the control point.
 * @param {number} x - The ending X coordinate.
 * @param {number} y - The ending Y coordinate.
 */
BoundingBox.prototype.addQuad = function(x0, y0, x1, y1, x, y) {
    var cp1x = x0 + 2 / 3 * (x1 - x0);
    var cp1y = y0 + 2 / 3 * (y1 - y0);
    var cp2x = cp1x + 1 / 3 * (x - x0);
    var cp2y = cp1y + 1 / 3 * (y - y0);
    this.addBezier(x0, y0, cp1x, cp1y, cp2x, cp2y, x, y);
};

// Geometric objects

/**
 * A bézier path containing a set of path commands similar to a SVG path.
 * Paths can be drawn on a context using `draw`.
 * @exports opentype.Path
 * @class
 * @constructor
 */
function Path() {
    this.commands = [];
    this.fill = 'black';
    this.stroke = null;
    this.strokeWidth = 1;
}

/**
 * @param  {number} x
 * @param  {number} y
 */
Path.prototype.moveTo = function(x, y) {
    this.commands.push({
        type: 'M',
        x: x,
        y: y
    });
};

/**
 * @param  {number} x
 * @param  {number} y
 */
Path.prototype.lineTo = function(x, y) {
    this.commands.push({
        type: 'L',
        x: x,
        y: y
    });
};

/**
 * Draws cubic curve
 * @function
 * curveTo
 * @memberof opentype.Path.prototype
 * @param  {number} x1 - x of control 1
 * @param  {number} y1 - y of control 1
 * @param  {number} x2 - x of control 2
 * @param  {number} y2 - y of control 2
 * @param  {number} x - x of path point
 * @param  {number} y - y of path point
 */

/**
 * Draws cubic curve
 * @function
 * bezierCurveTo
 * @memberof opentype.Path.prototype
 * @param  {number} x1 - x of control 1
 * @param  {number} y1 - y of control 1
 * @param  {number} x2 - x of control 2
 * @param  {number} y2 - y of control 2
 * @param  {number} x - x of path point
 * @param  {number} y - y of path point
 * @see curveTo
 */
Path.prototype.curveTo = Path.prototype.bezierCurveTo = function(x1, y1, x2, y2, x, y) {
    this.commands.push({
        type: 'C',
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2,
        x: x,
        y: y
    });
};

/**
 * Draws quadratic curve
 * @function
 * quadraticCurveTo
 * @memberof opentype.Path.prototype
 * @param  {number} x1 - x of control
 * @param  {number} y1 - y of control
 * @param  {number} x - x of path point
 * @param  {number} y - y of path point
 */

/**
 * Draws quadratic curve
 * @function
 * quadTo
 * @memberof opentype.Path.prototype
 * @param  {number} x1 - x of control
 * @param  {number} y1 - y of control
 * @param  {number} x - x of path point
 * @param  {number} y - y of path point
 */
Path.prototype.quadTo = Path.prototype.quadraticCurveTo = function(x1, y1, x, y) {
    this.commands.push({
        type: 'Q',
        x1: x1,
        y1: y1,
        x: x,
        y: y
    });
};

/**
 * Closes the path
 * @function closePath
 * @memberof opentype.Path.prototype
 */

/**
 * Close the path
 * @function close
 * @memberof opentype.Path.prototype
 */
Path.prototype.close = Path.prototype.closePath = function() {
    this.commands.push({
        type: 'Z'
    });
};

/**
 * Add the given path or list of commands to the commands of this path.
 * @param  {Array} pathOrCommands - another opentype.Path, an opentype.BoundingBox, or an array of commands.
 */
Path.prototype.extend = function(pathOrCommands) {
    if (pathOrCommands.commands) {
        pathOrCommands = pathOrCommands.commands;
    } else if (pathOrCommands instanceof BoundingBox) {
        var box = pathOrCommands;
        this.moveTo(box.x1, box.y1);
        this.lineTo(box.x2, box.y1);
        this.lineTo(box.x2, box.y2);
        this.lineTo(box.x1, box.y2);
        this.close();
        return;
    }

    Array.prototype.push.apply(this.commands, pathOrCommands);
};

/**
 * Calculate the bounding box of the path.
 * @returns {opentype.BoundingBox}
 */
Path.prototype.getBoundingBox = function() {
    var box = new BoundingBox();

    var startX = 0;
    var startY = 0;
    var prevX = 0;
    var prevY = 0;
    for (var i = 0; i < this.commands.length; i++) {
        var cmd = this.commands[i];
        switch (cmd.type) {
            case 'M':
                box.addPoint(cmd.x, cmd.y);
                startX = prevX = cmd.x;
                startY = prevY = cmd.y;
                break;
            case 'L':
                box.addPoint(cmd.x, cmd.y);
                prevX = cmd.x;
                prevY = cmd.y;
                break;
            case 'Q':
                box.addQuad(prevX, prevY, cmd.x1, cmd.y1, cmd.x, cmd.y);
                prevX = cmd.x;
                prevY = cmd.y;
                break;
            case 'C':
                box.addBezier(prevX, prevY, cmd.x1, cmd.y1, cmd.x2, cmd.y2, cmd.x, cmd.y);
                prevX = cmd.x;
                prevY = cmd.y;
                break;
            case 'Z':
                prevX = startX;
                prevY = startY;
                break;
            default:
                throw new Error('Unexpected path command ' + cmd.type);
        }
    }
    if (box.isEmpty()) {
        box.addPoint(0, 0);
    }
    return box;
};

/**
 * Draw the path to a 2D context.
 * @param {CanvasRenderingContext2D} ctx - A 2D drawing context.
 */
Path.prototype.draw = function(ctx) {
    ctx.beginPath();
    for (var i = 0; i < this.commands.length; i += 1) {
        var cmd = this.commands[i];
        if (cmd.type === 'M') {
            ctx.moveTo(cmd.x, cmd.y);
        } else if (cmd.type === 'L') {
            ctx.lineTo(cmd.x, cmd.y);
        } else if (cmd.type === 'C') {
            ctx.bezierCurveTo(cmd.x1, cmd.y1, cmd.x2, cmd.y2, cmd.x, cmd.y);
        } else if (cmd.type === 'Q') {
            ctx.quadraticCurveTo(cmd.x1, cmd.y1, cmd.x, cmd.y);
        } else if (cmd.type === 'Z') {
            ctx.closePath();
        }
    }

    if (this.fill) {
        ctx.fillStyle = this.fill;
        ctx.fill();
    }

    if (this.stroke) {
        ctx.strokeStyle = this.stroke;
        ctx.lineWidth = this.strokeWidth;
        ctx.stroke();
    }
};

/**
 * Convert the Path to a string of path data instructions
 * See http://www.w3.org/TR/SVG/paths.html#PathData
 * @param  {number} [decimalPlaces=2] - The amount of decimal places for floating-point values
 * @return {string}
 */
Path.prototype.toPathData = function(decimalPlaces) {
    decimalPlaces = decimalPlaces !== undefined ? decimalPlaces : 2;

    function floatToString(v) {
        if (Math.round(v) === v) {
            return '' + Math.round(v);
        } else {
            return v.toFixed(decimalPlaces);
        }
    }

    function packValues() {
        var arguments$1 = arguments;

        var s = '';
        for (var i = 0; i < arguments.length; i += 1) {
            var v = arguments$1[i];
            if (v >= 0 && i > 0) {
                s += ' ';
            }

            s += floatToString(v);
        }

        return s;
    }

    var d = '';
    for (var i = 0; i < this.commands.length; i += 1) {
        var cmd = this.commands[i];
        if (cmd.type === 'M') {
            d += 'M' + packValues(cmd.x, cmd.y);
        } else if (cmd.type === 'L') {
            d += 'L' + packValues(cmd.x, cmd.y);
        } else if (cmd.type === 'C') {
            d += 'C' + packValues(cmd.x1, cmd.y1, cmd.x2, cmd.y2, cmd.x, cmd.y);
        } else if (cmd.type === 'Q') {
            d += 'Q' + packValues(cmd.x1, cmd.y1, cmd.x, cmd.y);
        } else if (cmd.type === 'Z') {
            d += 'Z';
        }
    }

    return d;
};

/**
 * Convert the path to an SVG <path> element, as a string.
 * @param  {number} [decimalPlaces=2] - The amount of decimal places for floating-point values
 * @return {string}
 */
Path.prototype.toSVG = function(decimalPlaces) {
    var svg = '<path d="';
    svg += this.toPathData(decimalPlaces);
    svg += '"';
    if (this.fill && this.fill !== 'black') {
        if (this.fill === null) {
            svg += ' fill="none"';
        } else {
            svg += ' fill="' + this.fill + '"';
        }
    }

    if (this.stroke) {
        svg += ' stroke="' + this.stroke + '" stroke-width="' + this.strokeWidth + '"';
    }

    svg += '/>';
    return svg;
};

/**
 * Convert the path to a DOM element.
 * @param  {number} [decimalPlaces=2] - The amount of decimal places for floating-point values
 * @return {SVGPathElement}
 */
Path.prototype.toDOMElement = function(decimalPlaces) {
    var temporaryPath = this.toPathData(decimalPlaces);
    var newPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');

    newPath.setAttribute('d', temporaryPath);

    return newPath;
};

// Run-time checking of preconditions.

function fail(message) {
    throw new Error(message);
}

// Precondition function that checks if the given predicate is true.
// If not, it will throw an error.
function argument(predicate, message) {
    if (!predicate) {
        fail(message);
    }
}
var check = { fail: fail, argument: argument, assert: argument };

// Data types used in the OpenType font file.

var LIMIT16 = 32768; // The limit at which a 16-bit number switches signs == 2^15
var LIMIT32 = 2147483648; // The limit at which a 32-bit number switches signs == 2 ^ 31

/**
 * @exports opentype.decode
 * @class
 */
var decode = {};
/**
 * @exports opentype.encode
 * @class
 */
var encode$2 = {};
/**
 * @exports opentype.sizeOf
 * @class
 */
var sizeOf = {};

// Return a function that always returns the same value.
function constant(v) {
    return function() {
        return v;
    };
}

// OpenType data types //////////////////////////////////////////////////////

/**
 * Convert an 8-bit unsigned integer to a list of 1 byte.
 * @param {number}
 * @returns {Array}
 */
encode$2.BYTE = function(v) {
    check.argument(v >= 0 && v <= 255, 'Byte value should be between 0 and 255.');
    return [v];
};
/**
 * @constant
 * @type {number}
 */
sizeOf.BYTE = constant(1);

/**
 * Convert a 8-bit signed integer to a list of 1 byte.
 * @param {string}
 * @returns {Array}
 */
encode$2.CHAR = function(v) {
    return [v.charCodeAt(0)];
};

/**
 * @constant
 * @type {number}
 */
sizeOf.CHAR = constant(1);

/**
 * Convert an ASCII string to a list of bytes.
 * @param {string}
 * @returns {Array}
 */
encode$2.CHARARRAY = function(v) {
    if (typeof v === 'undefined') {
        v = '';
        console.warn('Undefined CHARARRAY encountered and treated as an empty string. This is probably caused by a missing glyph name.');
    }
    var b = [];
    for (var i = 0; i < v.length; i += 1) {
        b[i] = v.charCodeAt(i);
    }

    return b;
};

/**
 * @param {Array}
 * @returns {number}
 */
sizeOf.CHARARRAY = function(v) {
    if (typeof v === 'undefined') {
        return 0;
    }
    return v.length;
};

/**
 * Convert a 16-bit unsigned integer to a list of 2 bytes.
 * @param {number}
 * @returns {Array}
 */
encode$2.USHORT = function(v) {
    return [(v >> 8) & 0xFF, v & 0xFF];
};

/**
 * @constant
 * @type {number}
 */
sizeOf.USHORT = constant(2);

/**
 * Convert a 16-bit signed integer to a list of 2 bytes.
 * @param {number}
 * @returns {Array}
 */
encode$2.SHORT = function(v) {
    // Two's complement
    if (v >= LIMIT16) {
        v = -(2 * LIMIT16 - v);
    }

    return [(v >> 8) & 0xFF, v & 0xFF];
};

/**
 * @constant
 * @type {number}
 */
sizeOf.SHORT = constant(2);

/**
 * Convert a 24-bit unsigned integer to a list of 3 bytes.
 * @param {number}
 * @returns {Array}
 */
encode$2.UINT24 = function(v) {
    return [(v >> 16) & 0xFF, (v >> 8) & 0xFF, v & 0xFF];
};

/**
 * @constant
 * @type {number}
 */
sizeOf.UINT24 = constant(3);

/**
 * Convert a 32-bit unsigned integer to a list of 4 bytes.
 * @param {number}
 * @returns {Array}
 */
encode$2.ULONG = function(v) {
    return [(v >> 24) & 0xFF, (v >> 16) & 0xFF, (v >> 8) & 0xFF, v & 0xFF];
};

/**
 * @constant
 * @type {number}
 */
sizeOf.ULONG = constant(4);

/**
 * Convert a 32-bit unsigned integer to a list of 4 bytes.
 * @param {number}
 * @returns {Array}
 */
encode$2.LONG = function(v) {
    // Two's complement
    if (v >= LIMIT32) {
        v = -(2 * LIMIT32 - v);
    }

    return [(v >> 24) & 0xFF, (v >> 16) & 0xFF, (v >> 8) & 0xFF, v & 0xFF];
};

/**
 * @constant
 * @type {number}
 */
sizeOf.LONG = constant(4);

encode$2.FIXED = encode$2.ULONG;
sizeOf.FIXED = sizeOf.ULONG;

encode$2.FWORD = encode$2.SHORT;
sizeOf.FWORD = sizeOf.SHORT;

encode$2.UFWORD = encode$2.USHORT;
sizeOf.UFWORD = sizeOf.USHORT;

/**
 * Convert a 32-bit Apple Mac timestamp integer to a list of 8 bytes, 64-bit timestamp.
 * @param {number}
 * @returns {Array}
 */
encode$2.LONGDATETIME = function(v) {
    return [0, 0, 0, 0, (v >> 24) & 0xFF, (v >> 16) & 0xFF, (v >> 8) & 0xFF, v & 0xFF];
};

/**
 * @constant
 * @type {number}
 */
sizeOf.LONGDATETIME = constant(8);

/**
 * Convert a 4-char tag to a list of 4 bytes.
 * @param {string}
 * @returns {Array}
 */
encode$2.TAG = function(v) {
    check.argument(v.length === 4, 'Tag should be exactly 4 ASCII characters.');
    return [v.charCodeAt(0),
            v.charCodeAt(1),
            v.charCodeAt(2),
            v.charCodeAt(3)];
};

/**
 * @constant
 * @type {number}
 */
sizeOf.TAG = constant(4);

// CFF data types ///////////////////////////////////////////////////////////

encode$2.Card8 = encode$2.BYTE;
sizeOf.Card8 = sizeOf.BYTE;

encode$2.Card16 = encode$2.USHORT;
sizeOf.Card16 = sizeOf.USHORT;

encode$2.OffSize = encode$2.BYTE;
sizeOf.OffSize = sizeOf.BYTE;

encode$2.SID = encode$2.USHORT;
sizeOf.SID = sizeOf.USHORT;

// Convert a numeric operand or charstring number to a variable-size list of bytes.
/**
 * Convert a numeric operand or charstring number to a variable-size list of bytes.
 * @param {number}
 * @returns {Array}
 */
encode$2.NUMBER = function(v) {
    if (v >= -107 && v <= 107) {
        return [v + 139];
    } else if (v >= 108 && v <= 1131) {
        v = v - 108;
        return [(v >> 8) + 247, v & 0xFF];
    } else if (v >= -1131 && v <= -108) {
        v = -v - 108;
        return [(v >> 8) + 251, v & 0xFF];
    } else if (v >= -32768 && v <= 32767) {
        return encode$2.NUMBER16(v);
    } else {
        return encode$2.NUMBER32(v);
    }
};

/**
 * @param {number}
 * @returns {number}
 */
sizeOf.NUMBER = function(v) {
    return encode$2.NUMBER(v).length;
};

/**
 * Convert a signed number between -32768 and +32767 to a three-byte value.
 * This ensures we always use three bytes, but is not the most compact format.
 * @param {number}
 * @returns {Array}
 */
encode$2.NUMBER16 = function(v) {
    return [28, (v >> 8) & 0xFF, v & 0xFF];
};

/**
 * @constant
 * @type {number}
 */
sizeOf.NUMBER16 = constant(3);

/**
 * Convert a signed number between -(2^31) and +(2^31-1) to a five-byte value.
 * This is useful if you want to be sure you always use four bytes,
 * at the expense of wasting a few bytes for smaller numbers.
 * @param {number}
 * @returns {Array}
 */
encode$2.NUMBER32 = function(v) {
    return [29, (v >> 24) & 0xFF, (v >> 16) & 0xFF, (v >> 8) & 0xFF, v & 0xFF];
};

/**
 * @constant
 * @type {number}
 */
sizeOf.NUMBER32 = constant(5);

/**
 * @param {number}
 * @returns {Array}
 */
encode$2.REAL = function(v) {
    var value = v.toString();

    // Some numbers use an epsilon to encode the value. (e.g. JavaScript will store 0.0000001 as 1e-7)
    // This code converts it back to a number without the epsilon.
    var m = /\.(\d*?)(?:9{5,20}|0{5,20})\d{0,2}(?:e(.+)|$)/.exec(value);
    if (m) {
        var epsilon = parseFloat('1e' + ((m[2] ? +m[2] : 0) + m[1].length));
        value = (Math.round(v * epsilon) / epsilon).toString();
    }

    var nibbles = '';
    for (var i = 0, ii = value.length; i < ii; i += 1) {
        var c = value[i];
        if (c === 'e') {
            nibbles += value[++i] === '-' ? 'c' : 'b';
        } else if (c === '.') {
            nibbles += 'a';
        } else if (c === '-') {
            nibbles += 'e';
        } else {
            nibbles += c;
        }
    }

    nibbles += (nibbles.length & 1) ? 'f' : 'ff';
    var out = [30];
    for (var i$1 = 0, ii$1 = nibbles.length; i$1 < ii$1; i$1 += 2) {
        out.push(parseInt(nibbles.substr(i$1, 2), 16));
    }

    return out;
};

/**
 * @param {number}
 * @returns {number}
 */
sizeOf.REAL = function(v) {
    return encode$2.REAL(v).length;
};

encode$2.NAME = encode$2.CHARARRAY;
sizeOf.NAME = sizeOf.CHARARRAY;

encode$2.STRING = encode$2.CHARARRAY;
sizeOf.STRING = sizeOf.CHARARRAY;

/**
 * @param {DataView} data
 * @param {number} offset
 * @param {number} numBytes
 * @returns {string}
 */
decode.UTF8 = function(data, offset, numBytes) {
    var codePoints = [];
    var numChars = numBytes;
    for (var j = 0; j < numChars; j++, offset += 1) {
        codePoints[j] = data.getUint8(offset);
    }

    return String.fromCharCode.apply(null, codePoints);
};

/**
 * @param {DataView} data
 * @param {number} offset
 * @param {number} numBytes
 * @returns {string}
 */
decode.UTF16 = function(data, offset, numBytes) {
    var codePoints = [];
    var numChars = numBytes / 2;
    for (var j = 0; j < numChars; j++, offset += 2) {
        codePoints[j] = data.getUint16(offset);
    }

    return String.fromCharCode.apply(null, codePoints);
};

/**
 * Convert a JavaScript string to UTF16-BE.
 * @param {string}
 * @returns {Array}
 */
encode$2.UTF16 = function(v) {
    var b = [];
    for (var i = 0; i < v.length; i += 1) {
        var codepoint = v.charCodeAt(i);
        b[b.length] = (codepoint >> 8) & 0xFF;
        b[b.length] = codepoint & 0xFF;
    }

    return b;
};

/**
 * @param {string}
 * @returns {number}
 */
sizeOf.UTF16 = function(v) {
    return v.length * 2;
};

// Data for converting old eight-bit Macintosh encodings to Unicode.
// This representation is optimized for decoding; encoding is slower
// and needs more memory. The assumption is that all opentype.js users
// want to open fonts, but saving a font will be comparatively rare
// so it can be more expensive. Keyed by IANA character set name.
//
// Python script for generating these strings:
//
//     s = u''.join([chr(c).decode('mac_greek') for c in range(128, 256)])
//     print(s.encode('utf-8'))
/**
 * @private
 */
var eightBitMacEncodings = {
    'x-mac-croatian':  // Python: 'mac_croatian'
    'ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®Š™´¨≠ŽØ∞±≤≥∆µ∂∑∏š∫ªºΩžø' +
    '¿¡¬√ƒ≈Ć«Č… ÀÃÕŒœĐ—“”‘’÷◊©⁄€‹›Æ»–·‚„‰ÂćÁčÈÍÎÏÌÓÔđÒÚÛÙıˆ˜¯πË˚¸Êæˇ',
    'x-mac-cyrillic':  // Python: 'mac_cyrillic'
    'АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ†°Ґ£§•¶І®©™Ђђ≠Ѓѓ∞±≤≥іµґЈЄєЇїЉљЊњ' +
    'јЅ¬√ƒ≈∆«»… ЋћЌќѕ–—“”‘’÷„ЎўЏџ№Ёёяабвгдежзийклмнопрстуфхцчшщъыьэю',
    'x-mac-gaelic': // http://unicode.org/Public/MAPPINGS/VENDORS/APPLE/GAELIC.TXT
    'ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØḂ±≤≥ḃĊċḊḋḞḟĠġṀæø' +
    'ṁṖṗɼƒſṠ«»… ÀÃÕŒœ–—“”‘’ṡẛÿŸṪ€‹›Ŷŷṫ·Ỳỳ⁊ÂÊÁËÈÍÎÏÌÓÔ♣ÒÚÛÙıÝýŴŵẄẅẀẁẂẃ',
    'x-mac-greek':  // Python: 'mac_greek'
    'Ä¹²É³ÖÜ΅àâä΄¨çéèêë£™îï•½‰ôö¦€ùûü†ΓΔΘΛΞΠß®©ΣΪ§≠°·Α±≤≥¥ΒΕΖΗΙΚΜΦΫΨΩ' +
    'άΝ¬ΟΡ≈Τ«»… ΥΧΆΈœ–―“”‘’÷ΉΊΌΎέήίόΏύαβψδεφγηιξκλμνοπώρστθωςχυζϊϋΐΰ\u00AD',
    'x-mac-icelandic':  // Python: 'mac_iceland'
    'ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûüÝ°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø' +
    '¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄€ÐðÞþý·‚„‰ÂÊÁËÈÍÎÏÌÓÔÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ',
    'x-mac-inuit': // http://unicode.org/Public/MAPPINGS/VENDORS/APPLE/INUIT.TXT
    'ᐃᐄᐅᐆᐊᐋᐱᐲᐳᐴᐸᐹᑉᑎᑏᑐᑑᑕᑖᑦᑭᑮᑯᑰᑲᑳᒃᒋᒌᒍᒎᒐᒑ°ᒡᒥᒦ•¶ᒧ®©™ᒨᒪᒫᒻᓂᓃᓄᓅᓇᓈᓐᓯᓰᓱᓲᓴᓵᔅᓕᓖᓗ' +
    'ᓘᓚᓛᓪᔨᔩᔪᔫᔭ… ᔮᔾᕕᕖᕗ–—“”‘’ᕘᕙᕚᕝᕆᕇᕈᕉᕋᕌᕐᕿᖀᖁᖂᖃᖄᖅᖏᖐᖑᖒᖓᖔᖕᙱᙲᙳᙴᙵᙶᖖᖠᖡᖢᖣᖤᖥᖦᕼŁł',
    'x-mac-ce':  // Python: 'mac_latin2'
    'ÄĀāÉĄÖÜáąČäčĆćéŹźĎíďĒēĖóėôöõúĚěü†°Ę£§•¶ß®©™ę¨≠ģĮįĪ≤≥īĶ∂∑łĻļĽľĹĺŅ' +
    'ņŃ¬√ńŇ∆«»… ňŐÕőŌ–—“”‘’÷◊ōŔŕŘ‹›řŖŗŠ‚„šŚśÁŤťÍŽžŪÓÔūŮÚůŰűŲųÝýķŻŁżĢˇ',
    macintosh:  // Python: 'mac_roman'
    'ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø' +
    '¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄€‹›ﬁﬂ‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ',
    'x-mac-romanian':  // Python: 'mac_romanian'
    'ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ĂȘ∞±≤≥¥µ∂∑∏π∫ªºΩăș' +
    '¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄€‹›Țț‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ',
    'x-mac-turkish':  // Python: 'mac_turkish'
    'ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø' +
    '¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸĞğİıŞş‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔÒÚÛÙˆ˜¯˘˙˚¸˝˛ˇ'
};

/**
 * Decodes an old-style Macintosh string. Returns either a Unicode JavaScript
 * string, or 'undefined' if the encoding is unsupported. For example, we do
 * not support Chinese, Japanese or Korean because these would need large
 * mapping tables.
 * @param {DataView} dataView
 * @param {number} offset
 * @param {number} dataLength
 * @param {string} encoding
 * @returns {string}
 */
decode.MACSTRING = function(dataView, offset, dataLength, encoding) {
    var table = eightBitMacEncodings[encoding];
    if (table === undefined) {
        return undefined;
    }

    var result = '';
    for (var i = 0; i < dataLength; i++) {
        var c = dataView.getUint8(offset + i);
        // In all eight-bit Mac encodings, the characters 0x00..0x7F are
        // mapped to U+0000..U+007F; we only need to look up the others.
        if (c <= 0x7F) {
            result += String.fromCharCode(c);
        } else {
            result += table[c & 0x7F];
        }
    }

    return result;
};

// Helper function for encode.MACSTRING. Returns a dictionary for mapping
// Unicode character codes to their 8-bit MacOS equivalent. This table
// is not exactly a super cheap data structure, but we do not care because
// encoding Macintosh strings is only rarely needed in typical applications.
var macEncodingTableCache = typeof WeakMap === 'function' && new WeakMap();
var macEncodingCacheKeys;
var getMacEncodingTable = function (encoding) {
    // Since we use encoding as a cache key for WeakMap, it has to be
    // a String object and not a literal. And at least on NodeJS 2.10.1,
    // WeakMap requires that the same String instance is passed for cache hits.
    if (!macEncodingCacheKeys) {
        macEncodingCacheKeys = {};
        for (var e in eightBitMacEncodings) {
            /*jshint -W053 */  // Suppress "Do not use String as a constructor."
            macEncodingCacheKeys[e] = new String(e);
        }
    }

    var cacheKey = macEncodingCacheKeys[encoding];
    if (cacheKey === undefined) {
        return undefined;
    }

    // We can't do "if (cache.has(key)) {return cache.get(key)}" here:
    // since garbage collection may run at any time, it could also kick in
    // between the calls to cache.has() and cache.get(). In that case,
    // we would return 'undefined' even though we do support the encoding.
    if (macEncodingTableCache) {
        var cachedTable = macEncodingTableCache.get(cacheKey);
        if (cachedTable !== undefined) {
            return cachedTable;
        }
    }

    var decodingTable = eightBitMacEncodings[encoding];
    if (decodingTable === undefined) {
        return undefined;
    }

    var encodingTable = {};
    for (var i = 0; i < decodingTable.length; i++) {
        encodingTable[decodingTable.charCodeAt(i)] = i + 0x80;
    }

    if (macEncodingTableCache) {
        macEncodingTableCache.set(cacheKey, encodingTable);
    }

    return encodingTable;
};

/**
 * Encodes an old-style Macintosh string. Returns a byte array upon success.
 * If the requested encoding is unsupported, or if the input string contains
 * a character that cannot be expressed in the encoding, the function returns
 * 'undefined'.
 * @param {string} str
 * @param {string} encoding
 * @returns {Array}
 */
encode$2.MACSTRING = function(str, encoding) {
    var table = getMacEncodingTable(encoding);
    if (table === undefined) {
        return undefined;
    }

    var result = [];
    for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);

        // In all eight-bit Mac encodings, the characters 0x00..0x7F are
        // mapped to U+0000..U+007F; we only need to look up the others.
        if (c >= 0x80) {
            c = table[c];
            if (c === undefined) {
                // str contains a Unicode character that cannot be encoded
                // in the requested encoding.
                return undefined;
            }
        }
        result[i] = c;
        // result.push(c);
    }

    return result;
};

/**
 * @param {string} str
 * @param {string} encoding
 * @returns {number}
 */
sizeOf.MACSTRING = function(str, encoding) {
    var b = encode$2.MACSTRING(str, encoding);
    if (b !== undefined) {
        return b.length;
    } else {
        return 0;
    }
};

// Helper for encode.VARDELTAS
function isByteEncodable(value) {
    return value >= -128 && value <= 127;
}

// Helper for encode.VARDELTAS
function encodeVarDeltaRunAsZeroes(deltas, pos, result) {
    var runLength = 0;
    var numDeltas = deltas.length;
    while (pos < numDeltas && runLength < 64 && deltas[pos] === 0) {
        ++pos;
        ++runLength;
    }
    result.push(0x80 | (runLength - 1));
    return pos;
}

// Helper for encode.VARDELTAS
function encodeVarDeltaRunAsBytes(deltas, offset, result) {
    var runLength = 0;
    var numDeltas = deltas.length;
    var pos = offset;
    while (pos < numDeltas && runLength < 64) {
        var value = deltas[pos];
        if (!isByteEncodable(value)) {
            break;
        }

        // Within a byte-encoded run of deltas, a single zero is best
        // stored literally as 0x00 value. However, if we have two or
        // more zeroes in a sequence, it is better to start a new run.
        // Fore example, the sequence of deltas [15, 15, 0, 15, 15]
        // becomes 6 bytes (04 0F 0F 00 0F 0F) when storing the zero
        // within the current run, but 7 bytes (01 0F 0F 80 01 0F 0F)
        // when starting a new run.
        if (value === 0 && pos + 1 < numDeltas && deltas[pos + 1] === 0) {
            break;
        }

        ++pos;
        ++runLength;
    }
    result.push(runLength - 1);
    for (var i = offset; i < pos; ++i) {
        result.push((deltas[i] + 256) & 0xff);
    }
    return pos;
}

// Helper for encode.VARDELTAS
function encodeVarDeltaRunAsWords(deltas, offset, result) {
    var runLength = 0;
    var numDeltas = deltas.length;
    var pos = offset;
    while (pos < numDeltas && runLength < 64) {
        var value = deltas[pos];

        // Within a word-encoded run of deltas, it is easiest to start
        // a new run (with a different encoding) whenever we encounter
        // a zero value. For example, the sequence [0x6666, 0, 0x7777]
        // needs 7 bytes when storing the zero inside the current run
        // (42 66 66 00 00 77 77), and equally 7 bytes when starting a
        // new run (40 66 66 80 40 77 77).
        if (value === 0) {
            break;
        }

        // Within a word-encoded run of deltas, a single value in the
        // range (-128..127) should be encoded within the current run
        // because it is more compact. For example, the sequence
        // [0x6666, 2, 0x7777] becomes 7 bytes when storing the value
        // literally (42 66 66 00 02 77 77), but 8 bytes when starting
        // a new run (40 66 66 00 02 40 77 77).
        if (isByteEncodable(value) && pos + 1 < numDeltas && isByteEncodable(deltas[pos + 1])) {
            break;
        }

        ++pos;
        ++runLength;
    }
    result.push(0x40 | (runLength - 1));
    for (var i = offset; i < pos; ++i) {
        var val = deltas[i];
        result.push(((val + 0x10000) >> 8) & 0xff, (val + 0x100) & 0xff);
    }
    return pos;
}

/**
 * Encode a list of variation adjustment deltas.
 *
 * Variation adjustment deltas are used in ‘gvar’ and ‘cvar’ tables.
 * They indicate how points (in ‘gvar’) or values (in ‘cvar’) get adjusted
 * when generating instances of variation fonts.
 *
 * @see https://www.microsoft.com/typography/otspec/gvar.htm
 * @see https://developer.apple.com/fonts/TrueType-Reference-Manual/RM06/Chap6gvar.html
 * @param {Array}
 * @return {Array}
 */
encode$2.VARDELTAS = function(deltas) {
    var pos = 0;
    var result = [];
    while (pos < deltas.length) {
        var value = deltas[pos];
        if (value === 0) {
            pos = encodeVarDeltaRunAsZeroes(deltas, pos, result);
        } else if (value >= -128 && value <= 127) {
            pos = encodeVarDeltaRunAsBytes(deltas, pos, result);
        } else {
            pos = encodeVarDeltaRunAsWords(deltas, pos, result);
        }
    }
    return result;
};

// Convert a list of values to a CFF INDEX structure.
// The values should be objects containing name / type / value.
/**
 * @param {Array} l
 * @returns {Array}
 */
encode$2.INDEX = function(l) {
    //var offset, offsets, offsetEncoder, encodedOffsets, encodedOffset, data,
    //    i, v;
    // Because we have to know which data type to use to encode the offsets,
    // we have to go through the values twice: once to encode the data and
    // calculate the offsets, then again to encode the offsets using the fitting data type.
    var offset = 1; // First offset is always 1.
    var offsets = [offset];
    var data = [];
    for (var i = 0; i < l.length; i += 1) {
        var v = encode$2.OBJECT(l[i]);
        Array.prototype.push.apply(data, v);
        offset += v.length;
        offsets.push(offset);
    }

    if (data.length === 0) {
        return [0, 0];
    }

    var encodedOffsets = [];
    var offSize = (1 + Math.floor(Math.log(offset) / Math.log(2)) / 8) | 0;
    var offsetEncoder = [undefined, encode$2.BYTE, encode$2.USHORT, encode$2.UINT24, encode$2.ULONG][offSize];
    for (var i$1 = 0; i$1 < offsets.length; i$1 += 1) {
        var encodedOffset = offsetEncoder(offsets[i$1]);
        Array.prototype.push.apply(encodedOffsets, encodedOffset);
    }

    return Array.prototype.concat(encode$2.Card16(l.length),
                           encode$2.OffSize(offSize),
                           encodedOffsets,
                           data);
};

/**
 * @param {Array}
 * @returns {number}
 */
sizeOf.INDEX = function(v) {
    return encode$2.INDEX(v).length;
};

/**
 * Convert an object to a CFF DICT structure.
 * The keys should be numeric.
 * The values should be objects containing name / type / value.
 * @param {Object} m
 * @returns {Array}
 */
encode$2.DICT = function(m) {
    var d = [];
    var keys = Object.keys(m);
    var length = keys.length;

    for (var i = 0; i < length; i += 1) {
        // Object.keys() return string keys, but our keys are always numeric.
        var k = parseInt(keys[i], 0);
        var v = m[k];
        // Value comes before the key.
        d = d.concat(encode$2.OPERAND(v.value, v.type));
        d = d.concat(encode$2.OPERATOR(k));
    }

    return d;
};

/**
 * @param {Object}
 * @returns {number}
 */
sizeOf.DICT = function(m) {
    return encode$2.DICT(m).length;
};

/**
 * @param {number}
 * @returns {Array}
 */
encode$2.OPERATOR = function(v) {
    if (v < 1200) {
        return [v];
    } else {
        return [12, v - 1200];
    }
};

/**
 * @param {Array} v
 * @param {string}
 * @returns {Array}
 */
encode$2.OPERAND = function(v, type) {
    var d = [];
    if (Array.isArray(type)) {
        for (var i = 0; i < type.length; i += 1) {
            check.argument(v.length === type.length, 'Not enough arguments given for type' + type);
            d = d.concat(encode$2.OPERAND(v[i], type[i]));
        }
    } else {
        if (type === 'SID') {
            d = d.concat(encode$2.NUMBER(v));
        } else if (type === 'offset') {
            // We make it easy for ourselves and always encode offsets as
            // 4 bytes. This makes offset calculation for the top dict easier.
            d = d.concat(encode$2.NUMBER32(v));
        } else if (type === 'number') {
            d = d.concat(encode$2.NUMBER(v));
        } else if (type === 'real') {
            d = d.concat(encode$2.REAL(v));
        } else {
            throw new Error('Unknown operand type ' + type);
            // FIXME Add support for booleans
        }
    }

    return d;
};

encode$2.OP = encode$2.BYTE;
sizeOf.OP = sizeOf.BYTE;

// memoize charstring encoding using WeakMap if available
var wmm = typeof WeakMap === 'function' && new WeakMap();

/**
 * Convert a list of CharString operations to bytes.
 * @param {Array}
 * @returns {Array}
 */
encode$2.CHARSTRING = function(ops) {
    // See encode.MACSTRING for why we don't do "if (wmm && wmm.has(ops))".
    if (wmm) {
        var cachedValue = wmm.get(ops);
        if (cachedValue !== undefined) {
            return cachedValue;
        }
    }

    var d = [];
    var length = ops.length;

    for (var i = 0; i < length; i += 1) {
        var op = ops[i];
        d = d.concat(encode$2[op.type](op.value));
    }

    if (wmm) {
        wmm.set(ops, d);
    }

    return d;
};

/**
 * @param {Array}
 * @returns {number}
 */
sizeOf.CHARSTRING = function(ops) {
    return encode$2.CHARSTRING(ops).length;
};

// Utility functions ////////////////////////////////////////////////////////

/**
 * Convert an object containing name / type / value to bytes.
 * @param {Object}
 * @returns {Array}
 */
encode$2.OBJECT = function(v) {
    var encodingFunction = encode$2[v.type];
    check.argument(encodingFunction !== undefined, 'No encoding function for type ' + v.type);
    return encodingFunction(v.value);
};

/**
 * @param {Object}
 * @returns {number}
 */
sizeOf.OBJECT = function(v) {
    var sizeOfFunction = sizeOf[v.type];
    check.argument(sizeOfFunction !== undefined, 'No sizeOf function for type ' + v.type);
    return sizeOfFunction(v.value);
};

/**
 * Convert a table object to bytes.
 * A table contains a list of fields containing the metadata (name, type and default value).
 * The table itself has the field values set as attributes.
 * @param {opentype.Table}
 * @returns {Array}
 */
encode$2.TABLE = function(table) {
    var d = [];
    var length = table.fields.length;
    var subtables = [];
    var subtableOffsets = [];

    for (var i = 0; i < length; i += 1) {
        var field = table.fields[i];
        var encodingFunction = encode$2[field.type];
        check.argument(encodingFunction !== undefined, 'No encoding function for field type ' + field.type + ' (' + field.name + ')');
        var value = table[field.name];
        if (value === undefined) {
            value = field.value;
        }

        var bytes = encodingFunction(value);

        if (field.type === 'TABLE') {
            subtableOffsets.push(d.length);
            d = d.concat([0, 0]);
            subtables.push(bytes);
        } else {
            d = d.concat(bytes);
        }
    }

    for (var i$1 = 0; i$1 < subtables.length; i$1 += 1) {
        var o = subtableOffsets[i$1];
        var offset = d.length;
        check.argument(offset < 65536, 'Table ' + table.tableName + ' too big.');
        d[o] = offset >> 8;
        d[o + 1] = offset & 0xff;
        d = d.concat(subtables[i$1]);
    }

    return d;
};

/**
 * @param {opentype.Table}
 * @returns {number}
 */
sizeOf.TABLE = function(table) {
    var numBytes = 0;
    var length = table.fields.length;

    for (var i = 0; i < length; i += 1) {
        var field = table.fields[i];
        var sizeOfFunction = sizeOf[field.type];
        check.argument(sizeOfFunction !== undefined, 'No sizeOf function for field type ' + field.type + ' (' + field.name + ')');
        var value = table[field.name];
        if (value === undefined) {
            value = field.value;
        }

        numBytes += sizeOfFunction(value);

        // Subtables take 2 more bytes for offsets.
        if (field.type === 'TABLE') {
            numBytes += 2;
        }
    }

    return numBytes;
};

encode$2.RECORD = encode$2.TABLE;
sizeOf.RECORD = sizeOf.TABLE;

// Merge in a list of bytes.
encode$2.LITERAL = function(v) {
    return v;
};

sizeOf.LITERAL = function(v) {
    return v.length;
};

// Table metadata

/**
 * @exports opentype.Table
 * @class
 * @param {string} tableName
 * @param {Array} fields
 * @param {Object} options
 * @constructor
 */
function Table(tableName, fields, options) {
    // For coverage tables with coverage format 2, we do not want to add the coverage data directly to the table object,
    // as this will result in wrong encoding order of the coverage data on serialization to bytes.
    // The fallback of using the field values directly when not present on the table is handled in types.encode.TABLE() already.
    if (fields.length && (fields[0].name !== 'coverageFormat' || fields[0].value === 1)) {
        for (var i = 0; i < fields.length; i += 1) {
            var field = fields[i];
            this[field.name] = field.value;
        }
    }

    this.tableName = tableName;
    this.fields = fields;
    if (options) {
        var optionKeys = Object.keys(options);
        for (var i$1 = 0; i$1 < optionKeys.length; i$1 += 1) {
            var k = optionKeys[i$1];
            var v = options[k];
            if (this[k] !== undefined) {
                this[k] = v;
            }
        }
    }
}

/**
 * Encodes the table and returns an array of bytes
 * @return {Array}
 */
Table.prototype.encode = function() {
    return encode$2.TABLE(this);
};

/**
 * Get the size of the table.
 * @return {number}
 */
Table.prototype.sizeOf = function() {
    return sizeOf.TABLE(this);
};

/**
 * @private
 */
function ushortList(itemName, list, count) {
    if (count === undefined) {
        count = list.length;
    }
    var fields = new Array(list.length + 1);
    fields[0] = {name: itemName + 'Count', type: 'USHORT', value: count};
    for (var i = 0; i < list.length; i++) {
        fields[i + 1] = {name: itemName + i, type: 'USHORT', value: list[i]};
    }
    return fields;
}

/**
 * @private
 */
function tableList(itemName, records, itemCallback) {
    var count = records.length;
    var fields = new Array(count + 1);
    fields[0] = {name: itemName + 'Count', type: 'USHORT', value: count};
    for (var i = 0; i < count; i++) {
        fields[i + 1] = {name: itemName + i, type: 'TABLE', value: itemCallback(records[i], i)};
    }
    return fields;
}

/**
 * @private
 */
function recordList(itemName, records, itemCallback) {
    var count = records.length;
    var fields = [];
    fields[0] = {name: itemName + 'Count', type: 'USHORT', value: count};
    for (var i = 0; i < count; i++) {
        fields = fields.concat(itemCallback(records[i], i));
    }
    return fields;
}

// Common Layout Tables

/**
 * @exports opentype.Coverage
 * @class
 * @param {opentype.Table}
 * @constructor
 * @extends opentype.Table
 */
function Coverage(coverageTable) {
    if (coverageTable.format === 1) {
        Table.call(this, 'coverageTable',
            [{name: 'coverageFormat', type: 'USHORT', value: 1}]
            .concat(ushortList('glyph', coverageTable.glyphs))
        );
    } else if (coverageTable.format === 2) {
        Table.call(this, 'coverageTable',
            [{name: 'coverageFormat', type: 'USHORT', value: 2}]
            .concat(recordList('rangeRecord', coverageTable.ranges, function(RangeRecord) {
                return [
                    {name: 'startGlyphID', type: 'USHORT', value: RangeRecord.start},
                    {name: 'endGlyphID', type: 'USHORT', value: RangeRecord.end},
                    {name: 'startCoverageIndex', type: 'USHORT', value: RangeRecord.index} ];
            }))
        );
    } else {
        check.assert(false, 'Coverage format must be 1 or 2.');
    }
}
Coverage.prototype = Object.create(Table.prototype);
Coverage.prototype.constructor = Coverage;

function ScriptList(scriptListTable) {
    Table.call(this, 'scriptListTable',
        recordList('scriptRecord', scriptListTable, function(scriptRecord, i) {
            var script = scriptRecord.script;
            var defaultLangSys = script.defaultLangSys;
            check.assert(!!defaultLangSys, 'Unable to write GSUB: script ' + scriptRecord.tag + ' has no default language system.');
            return [
                {name: 'scriptTag' + i, type: 'TAG', value: scriptRecord.tag},
                {name: 'script' + i, type: 'TABLE', value: new Table('scriptTable', [
                    {name: 'defaultLangSys', type: 'TABLE', value: new Table('defaultLangSys', [
                        {name: 'lookupOrder', type: 'USHORT', value: 0},
                        {name: 'reqFeatureIndex', type: 'USHORT', value: defaultLangSys.reqFeatureIndex}]
                        .concat(ushortList('featureIndex', defaultLangSys.featureIndexes)))}
                    ].concat(recordList('langSys', script.langSysRecords, function(langSysRecord, i) {
                        var langSys = langSysRecord.langSys;
                        return [
                            {name: 'langSysTag' + i, type: 'TAG', value: langSysRecord.tag},
                            {name: 'langSys' + i, type: 'TABLE', value: new Table('langSys', [
                                {name: 'lookupOrder', type: 'USHORT', value: 0},
                                {name: 'reqFeatureIndex', type: 'USHORT', value: langSys.reqFeatureIndex}
                                ].concat(ushortList('featureIndex', langSys.featureIndexes)))}
                        ];
                    })))}
            ];
        })
    );
}
ScriptList.prototype = Object.create(Table.prototype);
ScriptList.prototype.constructor = ScriptList;

/**
 * @exports opentype.FeatureList
 * @class
 * @param {opentype.Table}
 * @constructor
 * @extends opentype.Table
 */
function FeatureList(featureListTable) {
    Table.call(this, 'featureListTable',
        recordList('featureRecord', featureListTable, function(featureRecord, i) {
            var feature = featureRecord.feature;
            return [
                {name: 'featureTag' + i, type: 'TAG', value: featureRecord.tag},
                {name: 'feature' + i, type: 'TABLE', value: new Table('featureTable', [
                    {name: 'featureParams', type: 'USHORT', value: feature.featureParams} ].concat(ushortList('lookupListIndex', feature.lookupListIndexes)))}
            ];
        })
    );
}
FeatureList.prototype = Object.create(Table.prototype);
FeatureList.prototype.constructor = FeatureList;

/**
 * @exports opentype.LookupList
 * @class
 * @param {opentype.Table}
 * @param {Object}
 * @constructor
 * @extends opentype.Table
 */
function LookupList(lookupListTable, subtableMakers) {
    Table.call(this, 'lookupListTable', tableList('lookup', lookupListTable, function(lookupTable) {
        var subtableCallback = subtableMakers[lookupTable.lookupType];
        check.assert(!!subtableCallback, 'Unable to write GSUB lookup type ' + lookupTable.lookupType + ' tables.');
        return new Table('lookupTable', [
            {name: 'lookupType', type: 'USHORT', value: lookupTable.lookupType},
            {name: 'lookupFlag', type: 'USHORT', value: lookupTable.lookupFlag}
        ].concat(tableList('subtable', lookupTable.subtables, subtableCallback)));
    }));
}
LookupList.prototype = Object.create(Table.prototype);
LookupList.prototype.constructor = LookupList;

// Record = same as Table, but inlined (a Table has an offset and its data is further in the stream)
// Don't use offsets inside Records (probable bug), only in Tables.
var table = {
    Table: Table,
    Record: Table,
    Coverage: Coverage,
    ScriptList: ScriptList,
    FeatureList: FeatureList,
    LookupList: LookupList,
    ushortList: ushortList,
    tableList: tableList,
    recordList: recordList,
};

// Parsing utility functions

// Retrieve an unsigned byte from the DataView.
function getByte(dataView, offset) {
    return dataView.getUint8(offset);
}

// Retrieve an unsigned 16-bit short from the DataView.
// The value is stored in big endian.
function getUShort(dataView, offset) {
    return dataView.getUint16(offset, false);
}

// Retrieve a signed 16-bit short from the DataView.
// The value is stored in big endian.
function getShort(dataView, offset) {
    return dataView.getInt16(offset, false);
}

// Retrieve an unsigned 32-bit long from the DataView.
// The value is stored in big endian.
function getULong(dataView, offset) {
    return dataView.getUint32(offset, false);
}

// Retrieve a 32-bit signed fixed-point number (16.16) from the DataView.
// The value is stored in big endian.
function getFixed(dataView, offset) {
    var decimal = dataView.getInt16(offset, false);
    var fraction = dataView.getUint16(offset + 2, false);
    return decimal + fraction / 65535;
}

// Retrieve a 4-character tag from the DataView.
// Tags are used to identify tables.
function getTag(dataView, offset) {
    var tag = '';
    for (var i = offset; i < offset + 4; i += 1) {
        tag += String.fromCharCode(dataView.getInt8(i));
    }

    return tag;
}

// Retrieve an offset from the DataView.
// Offsets are 1 to 4 bytes in length, depending on the offSize argument.
function getOffset(dataView, offset, offSize) {
    var v = 0;
    for (var i = 0; i < offSize; i += 1) {
        v <<= 8;
        v += dataView.getUint8(offset + i);
    }

    return v;
}

// Retrieve a number of bytes from start offset to the end offset from the DataView.
function getBytes(dataView, startOffset, endOffset) {
    var bytes = [];
    for (var i = startOffset; i < endOffset; i += 1) {
        bytes.push(dataView.getUint8(i));
    }

    return bytes;
}

// Convert the list of bytes to a string.
function bytesToString(bytes) {
    var s = '';
    for (var i = 0; i < bytes.length; i += 1) {
        s += String.fromCharCode(bytes[i]);
    }

    return s;
}

var typeOffsets = {
    byte: 1,
    uShort: 2,
    short: 2,
    uLong: 4,
    fixed: 4,
    longDateTime: 8,
    tag: 4
};

// A stateful parser that changes the offset whenever a value is retrieved.
// The data is a DataView.
function Parser(data, offset) {
    this.data = data;
    this.offset = offset;
    this.relativeOffset = 0;
}

Parser.prototype.parseByte = function() {
    var v = this.data.getUint8(this.offset + this.relativeOffset);
    this.relativeOffset += 1;
    return v;
};

Parser.prototype.parseChar = function() {
    var v = this.data.getInt8(this.offset + this.relativeOffset);
    this.relativeOffset += 1;
    return v;
};

Parser.prototype.parseCard8 = Parser.prototype.parseByte;

Parser.prototype.parseUShort = function() {
    var v = this.data.getUint16(this.offset + this.relativeOffset);
    this.relativeOffset += 2;
    return v;
};

Parser.prototype.parseCard16 = Parser.prototype.parseUShort;
Parser.prototype.parseSID = Parser.prototype.parseUShort;
Parser.prototype.parseOffset16 = Parser.prototype.parseUShort;

Parser.prototype.parseShort = function() {
    var v = this.data.getInt16(this.offset + this.relativeOffset);
    this.relativeOffset += 2;
    return v;
};

Parser.prototype.parseF2Dot14 = function() {
    var v = this.data.getInt16(this.offset + this.relativeOffset) / 16384;
    this.relativeOffset += 2;
    return v;
};

Parser.prototype.parseULong = function() {
    var v = getULong(this.data, this.offset + this.relativeOffset);
    this.relativeOffset += 4;
    return v;
};

Parser.prototype.parseOffset32 = Parser.prototype.parseULong;

Parser.prototype.parseFixed = function() {
    var v = getFixed(this.data, this.offset + this.relativeOffset);
    this.relativeOffset += 4;
    return v;
};

Parser.prototype.parseString = function(length) {
    var dataView = this.data;
    var offset = this.offset + this.relativeOffset;
    var string = '';
    this.relativeOffset += length;
    for (var i = 0; i < length; i++) {
        string += String.fromCharCode(dataView.getUint8(offset + i));
    }

    return string;
};

Parser.prototype.parseTag = function() {
    return this.parseString(4);
};

// LONGDATETIME is a 64-bit integer.
// JavaScript and unix timestamps traditionally use 32 bits, so we
// only take the last 32 bits.
// + Since until 2038 those bits will be filled by zeros we can ignore them.
Parser.prototype.parseLongDateTime = function() {
    var v = getULong(this.data, this.offset + this.relativeOffset + 4);
    // Subtract seconds between 01/01/1904 and 01/01/1970
    // to convert Apple Mac timestamp to Standard Unix timestamp
    v -= 2082844800;
    this.relativeOffset += 8;
    return v;
};

Parser.prototype.parseVersion = function(minorBase) {
    var major = getUShort(this.data, this.offset + this.relativeOffset);

    // How to interpret the minor version is very vague in the spec. 0x5000 is 5, 0x1000 is 1
    // Default returns the correct number if minor = 0xN000 where N is 0-9
    // Set minorBase to 1 for tables that use minor = N where N is 0-9
    var minor = getUShort(this.data, this.offset + this.relativeOffset + 2);
    this.relativeOffset += 4;
    if (minorBase === undefined) { minorBase = 0x1000; }
    return major + minor / minorBase / 10;
};

Parser.prototype.skip = function(type, amount) {
    if (amount === undefined) {
        amount = 1;
    }

    this.relativeOffset += typeOffsets[type] * amount;
};

///// Parsing lists and records ///////////////////////////////

// Parse a list of 32 bit unsigned integers.
Parser.prototype.parseULongList = function(count) {
    if (count === undefined) { count = this.parseULong(); }
    var offsets = new Array(count);
    var dataView = this.data;
    var offset = this.offset + this.relativeOffset;
    for (var i = 0; i < count; i++) {
        offsets[i] = dataView.getUint32(offset);
        offset += 4;
    }

    this.relativeOffset += count * 4;
    return offsets;
};

// Parse a list of 16 bit unsigned integers. The length of the list can be read on the stream
// or provided as an argument.
Parser.prototype.parseOffset16List =
Parser.prototype.parseUShortList = function(count) {
    if (count === undefined) { count = this.parseUShort(); }
    var offsets = new Array(count);
    var dataView = this.data;
    var offset = this.offset + this.relativeOffset;
    for (var i = 0; i < count; i++) {
        offsets[i] = dataView.getUint16(offset);
        offset += 2;
    }

    this.relativeOffset += count * 2;
    return offsets;
};

// Parses a list of 16 bit signed integers.
Parser.prototype.parseShortList = function(count) {
    var list = new Array(count);
    var dataView = this.data;
    var offset = this.offset + this.relativeOffset;
    for (var i = 0; i < count; i++) {
        list[i] = dataView.getInt16(offset);
        offset += 2;
    }

    this.relativeOffset += count * 2;
    return list;
};

// Parses a list of bytes.
Parser.prototype.parseByteList = function(count) {
    var list = new Array(count);
    var dataView = this.data;
    var offset = this.offset + this.relativeOffset;
    for (var i = 0; i < count; i++) {
        list[i] = dataView.getUint8(offset++);
    }

    this.relativeOffset += count;
    return list;
};

/**
 * Parse a list of items.
 * Record count is optional, if omitted it is read from the stream.
 * itemCallback is one of the Parser methods.
 */
Parser.prototype.parseList = function(count, itemCallback) {
    if (!itemCallback) {
        itemCallback = count;
        count = this.parseUShort();
    }
    var list = new Array(count);
    for (var i = 0; i < count; i++) {
        list[i] = itemCallback.call(this);
    }
    return list;
};

Parser.prototype.parseList32 = function(count, itemCallback) {
    if (!itemCallback) {
        itemCallback = count;
        count = this.parseULong();
    }
    var list = new Array(count);
    for (var i = 0; i < count; i++) {
        list[i] = itemCallback.call(this);
    }
    return list;
};

/**
 * Parse a list of records.
 * Record count is optional, if omitted it is read from the stream.
 * Example of recordDescription: { sequenceIndex: Parser.uShort, lookupListIndex: Parser.uShort }
 */
Parser.prototype.parseRecordList = function(count, recordDescription) {
    // If the count argument is absent, read it in the stream.
    if (!recordDescription) {
        recordDescription = count;
        count = this.parseUShort();
    }
    var records = new Array(count);
    var fields = Object.keys(recordDescription);
    for (var i = 0; i < count; i++) {
        var rec = {};
        for (var j = 0; j < fields.length; j++) {
            var fieldName = fields[j];
            var fieldType = recordDescription[fieldName];
            rec[fieldName] = fieldType.call(this);
        }
        records[i] = rec;
    }
    return records;
};

Parser.prototype.parseRecordList32 = function(count, recordDescription) {
    // If the count argument is absent, read it in the stream.
    if (!recordDescription) {
        recordDescription = count;
        count = this.parseULong();
    }
    var records = new Array(count);
    var fields = Object.keys(recordDescription);
    for (var i = 0; i < count; i++) {
        var rec = {};
        for (var j = 0; j < fields.length; j++) {
            var fieldName = fields[j];
            var fieldType = recordDescription[fieldName];
            rec[fieldName] = fieldType.call(this);
        }
        records[i] = rec;
    }
    return records;
};

// Parse a data structure into an object
// Example of description: { sequenceIndex: Parser.uShort, lookupListIndex: Parser.uShort }
Parser.prototype.parseStruct = function(description) {
    if (typeof description === 'function') {
        return description.call(this);
    } else {
        var fields = Object.keys(description);
        var struct = {};
        for (var j = 0; j < fields.length; j++) {
            var fieldName = fields[j];
            var fieldType = description[fieldName];
            struct[fieldName] = fieldType.call(this);
        }
        return struct;
    }
};

/**
 * Parse a GPOS valueRecord
 * https://docs.microsoft.com/en-us/typography/opentype/spec/gpos#value-record
 * valueFormat is optional, if omitted it is read from the stream.
 */
Parser.prototype.parseValueRecord = function(valueFormat) {
    if (valueFormat === undefined) {
        valueFormat = this.parseUShort();
    }
    if (valueFormat === 0) {
        // valueFormat2 in kerning pairs is most often 0
        // in this case return undefined instead of an empty object, to save space
        return;
    }
    var valueRecord = {};

    if (valueFormat & 0x0001) { valueRecord.xPlacement = this.parseShort(); }
    if (valueFormat & 0x0002) { valueRecord.yPlacement = this.parseShort(); }
    if (valueFormat & 0x0004) { valueRecord.xAdvance = this.parseShort(); }
    if (valueFormat & 0x0008) { valueRecord.yAdvance = this.parseShort(); }

    // Device table (non-variable font) / VariationIndex table (variable font) not supported
    // https://docs.microsoft.com/fr-fr/typography/opentype/spec/chapter2#devVarIdxTbls
    if (valueFormat & 0x0010) { valueRecord.xPlaDevice = undefined; this.parseShort(); }
    if (valueFormat & 0x0020) { valueRecord.yPlaDevice = undefined; this.parseShort(); }
    if (valueFormat & 0x0040) { valueRecord.xAdvDevice = undefined; this.parseShort(); }
    if (valueFormat & 0x0080) { valueRecord.yAdvDevice = undefined; this.parseShort(); }

    return valueRecord;
};

/**
 * Parse a list of GPOS valueRecords
 * https://docs.microsoft.com/en-us/typography/opentype/spec/gpos#value-record
 * valueFormat and valueCount are read from the stream.
 */
Parser.prototype.parseValueRecordList = function() {
    var valueFormat = this.parseUShort();
    var valueCount = this.parseUShort();
    var values = new Array(valueCount);
    for (var i = 0; i < valueCount; i++) {
        values[i] = this.parseValueRecord(valueFormat);
    }
    return values;
};

Parser.prototype.parsePointer = function(description) {
    var structOffset = this.parseOffset16();
    if (structOffset > 0) {
        // NULL offset => return undefined
        return new Parser(this.data, this.offset + structOffset).parseStruct(description);
    }
    return undefined;
};

Parser.prototype.parsePointer32 = function(description) {
    var structOffset = this.parseOffset32();
    if (structOffset > 0) {
        // NULL offset => return undefined
        return new Parser(this.data, this.offset + structOffset).parseStruct(description);
    }
    return undefined;
};

/**
 * Parse a list of offsets to lists of 16-bit integers,
 * or a list of offsets to lists of offsets to any kind of items.
 * If itemCallback is not provided, a list of list of UShort is assumed.
 * If provided, itemCallback is called on each item and must parse the item.
 * See examples in tables/gsub.js
 */
Parser.prototype.parseListOfLists = function(itemCallback) {
    var offsets = this.parseOffset16List();
    var count = offsets.length;
    var relativeOffset = this.relativeOffset;
    var list = new Array(count);
    for (var i = 0; i < count; i++) {
        var start = offsets[i];
        if (start === 0) {
            // NULL offset
            // Add i as owned property to list. Convenient with assert.
            list[i] = undefined;
            continue;
        }
        this.relativeOffset = start;
        if (itemCallback) {
            var subOffsets = this.parseOffset16List();
            var subList = new Array(subOffsets.length);
            for (var j = 0; j < subOffsets.length; j++) {
                this.relativeOffset = start + subOffsets[j];
                subList[j] = itemCallback.call(this);
            }
            list[i] = subList;
        } else {
            list[i] = this.parseUShortList();
        }
    }
    this.relativeOffset = relativeOffset;
    return list;
};

///// Complex tables parsing //////////////////////////////////

// Parse a coverage table in a GSUB, GPOS or GDEF table.
// https://www.microsoft.com/typography/OTSPEC/chapter2.htm
// parser.offset must point to the start of the table containing the coverage.
Parser.prototype.parseCoverage = function() {
    var startOffset = this.offset + this.relativeOffset;
    var format = this.parseUShort();
    var count = this.parseUShort();
    if (format === 1) {
        return {
            format: 1,
            glyphs: this.parseUShortList(count)
        };
    } else if (format === 2) {
        var ranges = new Array(count);
        for (var i = 0; i < count; i++) {
            ranges[i] = {
                start: this.parseUShort(),
                end: this.parseUShort(),
                index: this.parseUShort()
            };
        }
        return {
            format: 2,
            ranges: ranges
        };
    }
    throw new Error('0x' + startOffset.toString(16) + ': Coverage format must be 1 or 2.');
};

// Parse a Class Definition Table in a GSUB, GPOS or GDEF table.
// https://www.microsoft.com/typography/OTSPEC/chapter2.htm
Parser.prototype.parseClassDef = function() {
    var startOffset = this.offset + this.relativeOffset;
    var format = this.parseUShort();
    if (format === 1) {
        return {
            format: 1,
            startGlyph: this.parseUShort(),
            classes: this.parseUShortList()
        };
    } else if (format === 2) {
        return {
            format: 2,
            ranges: this.parseRecordList({
                start: Parser.uShort,
                end: Parser.uShort,
                classId: Parser.uShort
            })
        };
    }
    throw new Error('0x' + startOffset.toString(16) + ': ClassDef format must be 1 or 2.');
};

///// Static methods ///////////////////////////////////
// These convenience methods can be used as callbacks and should be called with "this" context set to a Parser instance.

Parser.list = function(count, itemCallback) {
    return function() {
        return this.parseList(count, itemCallback);
    };
};

Parser.list32 = function(count, itemCallback) {
    return function() {
        return this.parseList32(count, itemCallback);
    };
};

Parser.recordList = function(count, recordDescription) {
    return function() {
        return this.parseRecordList(count, recordDescription);
    };
};

Parser.recordList32 = function(count, recordDescription) {
    return function() {
        return this.parseRecordList32(count, recordDescription);
    };
};

Parser.pointer = function(description) {
    return function() {
        return this.parsePointer(description);
    };
};

Parser.pointer32 = function(description) {
    return function() {
        return this.parsePointer32(description);
    };
};

Parser.tag = Parser.prototype.parseTag;
Parser.byte = Parser.prototype.parseByte;
Parser.uShort = Parser.offset16 = Parser.prototype.parseUShort;
Parser.uShortList = Parser.prototype.parseUShortList;
Parser.uLong = Parser.offset32 = Parser.prototype.parseULong;
Parser.uLongList = Parser.prototype.parseULongList;
Parser.struct = Parser.prototype.parseStruct;
Parser.coverage = Parser.prototype.parseCoverage;
Parser.classDef = Parser.prototype.parseClassDef;

///// Script, Feature, Lookup lists ///////////////////////////////////////////////
// https://www.microsoft.com/typography/OTSPEC/chapter2.htm

var langSysTable = {
    reserved: Parser.uShort,
    reqFeatureIndex: Parser.uShort,
    featureIndexes: Parser.uShortList
};

Parser.prototype.parseScriptList = function() {
    return this.parsePointer(Parser.recordList({
        tag: Parser.tag,
        script: Parser.pointer({
            defaultLangSys: Parser.pointer(langSysTable),
            langSysRecords: Parser.recordList({
                tag: Parser.tag,
                langSys: Parser.pointer(langSysTable)
            })
        })
    })) || [];
};

Parser.prototype.parseFeatureList = function() {
    return this.parsePointer(Parser.recordList({
        tag: Parser.tag,
        feature: Parser.pointer({
            featureParams: Parser.offset16,
            lookupListIndexes: Parser.uShortList
        })
    })) || [];
};

Parser.prototype.parseLookupList = function(lookupTableParsers) {
    return this.parsePointer(Parser.list(Parser.pointer(function() {
        var lookupType = this.parseUShort();
        check.argument(1 <= lookupType && lookupType <= 9, 'GPOS/GSUB lookup type ' + lookupType + ' unknown.');
        var lookupFlag = this.parseUShort();
        var useMarkFilteringSet = lookupFlag & 0x10;
        return {
            lookupType: lookupType,
            lookupFlag: lookupFlag,
            subtables: this.parseList(Parser.pointer(lookupTableParsers[lookupType])),
            markFilteringSet: useMarkFilteringSet ? this.parseUShort() : undefined
        };
    }))) || [];
};

Parser.prototype.parseFeatureVariationsList = function() {
    return this.parsePointer32(function() {
        var majorVersion = this.parseUShort();
        var minorVersion = this.parseUShort();
        check.argument(majorVersion === 1 && minorVersion < 1, 'GPOS/GSUB feature variations table unknown.');
        var featureVariations = this.parseRecordList32({
            conditionSetOffset: Parser.offset32,
            featureTableSubstitutionOffset: Parser.offset32
        });
        return featureVariations;
    }) || [];
};

var parse = {
    getByte: getByte,
    getCard8: getByte,
    getUShort: getUShort,
    getCard16: getUShort,
    getShort: getShort,
    getULong: getULong,
    getFixed: getFixed,
    getTag: getTag,
    getOffset: getOffset,
    getBytes: getBytes,
    bytesToString: bytesToString,
    Parser: Parser,
};

// The `cmap` table stores the mappings from characters to glyphs.

function parseCmapTableFormat12(cmap, p) {
    //Skip reserved.
    p.parseUShort();

    // Length in bytes of the sub-tables.
    cmap.length = p.parseULong();
    cmap.language = p.parseULong();

    var groupCount;
    cmap.groupCount = groupCount = p.parseULong();
    cmap.glyphIndexMap = {};

    for (var i = 0; i < groupCount; i += 1) {
        var startCharCode = p.parseULong();
        var endCharCode = p.parseULong();
        var startGlyphId = p.parseULong();

        for (var c = startCharCode; c <= endCharCode; c += 1) {
            cmap.glyphIndexMap[c] = startGlyphId;
            startGlyphId++;
        }
    }
}

function parseCmapTableFormat4(cmap, p, data, start, offset) {
    // Length in bytes of the sub-tables.
    cmap.length = p.parseUShort();
    cmap.language = p.parseUShort();

    // segCount is stored x 2.
    var segCount;
    cmap.segCount = segCount = p.parseUShort() >> 1;

    // Skip searchRange, entrySelector, rangeShift.
    p.skip('uShort', 3);

    // The "unrolled" mapping from character codes to glyph indices.
    cmap.glyphIndexMap = {};
    var endCountParser = new parse.Parser(data, start + offset + 14);
    var startCountParser = new parse.Parser(data, start + offset + 16 + segCount * 2);
    var idDeltaParser = new parse.Parser(data, start + offset + 16 + segCount * 4);
    var idRangeOffsetParser = new parse.Parser(data, start + offset + 16 + segCount * 6);
    var glyphIndexOffset = start + offset + 16 + segCount * 8;
    for (var i = 0; i < segCount - 1; i += 1) {
        var glyphIndex = (void 0);
        var endCount = endCountParser.parseUShort();
        var startCount = startCountParser.parseUShort();
        var idDelta = idDeltaParser.parseShort();
        var idRangeOffset = idRangeOffsetParser.parseUShort();
        for (var c = startCount; c <= endCount; c += 1) {
            if (idRangeOffset !== 0) {
                // The idRangeOffset is relative to the current position in the idRangeOffset array.
                // Take the current offset in the idRangeOffset array.
                glyphIndexOffset = (idRangeOffsetParser.offset + idRangeOffsetParser.relativeOffset - 2);

                // Add the value of the idRangeOffset, which will move us into the glyphIndex array.
                glyphIndexOffset += idRangeOffset;

                // Then add the character index of the current segment, multiplied by 2 for USHORTs.
                glyphIndexOffset += (c - startCount) * 2;
                glyphIndex = parse.getUShort(data, glyphIndexOffset);
                if (glyphIndex !== 0) {
                    glyphIndex = (glyphIndex + idDelta) & 0xFFFF;
                }
            } else {
                glyphIndex = (c + idDelta) & 0xFFFF;
            }

            cmap.glyphIndexMap[c] = glyphIndex;
        }
    }
}

// Parse the `cmap` table. This table stores the mappings from characters to glyphs.
// There are many available formats, but we only support the Windows format 4 and 12.
// This function returns a `CmapEncoding` object or null if no supported format could be found.
function parseCmapTable(data, start) {
    var cmap = {};
    cmap.version = parse.getUShort(data, start);
    check.argument(cmap.version === 0, 'cmap table version should be 0.');

    // The cmap table can contain many sub-tables, each with their own format.
    // We're only interested in a "platform 0" (Unicode format) and "platform 3" (Windows format) table.
    cmap.numTables = parse.getUShort(data, start + 2);
    var offset = -1;
    for (var i = cmap.numTables - 1; i >= 0; i -= 1) {
        var platformId = parse.getUShort(data, start + 4 + (i * 8));
        var encodingId = parse.getUShort(data, start + 4 + (i * 8) + 2);
        if ((platformId === 3 && (encodingId === 0 || encodingId === 1 || encodingId === 10)) ||
            (platformId === 0 && (encodingId === 0 || encodingId === 1 || encodingId === 2 || encodingId === 3 || encodingId === 4))) {
            offset = parse.getULong(data, start + 4 + (i * 8) + 4);
            break;
        }
    }

    if (offset === -1) {
        // There is no cmap table in the font that we support.
        throw new Error('No valid cmap sub-tables found.');
    }

    var p = new parse.Parser(data, start + offset);
    cmap.format = p.parseUShort();

    if (cmap.format === 12) {
        parseCmapTableFormat12(cmap, p);
    } else if (cmap.format === 4) {
        parseCmapTableFormat4(cmap, p, data, start, offset);
    } else {
        throw new Error('Only format 4 and 12 cmap tables are supported (found format ' + cmap.format + ').');
    }

    return cmap;
}

function addSegment(t, code, glyphIndex) {
    t.segments.push({
        end: code,
        start: code,
        delta: -(code - glyphIndex),
        offset: 0,
        glyphIndex: glyphIndex
    });
}

function addTerminatorSegment(t) {
    t.segments.push({
        end: 0xFFFF,
        start: 0xFFFF,
        delta: 1,
        offset: 0
    });
}

// Make cmap table, format 4 by default, 12 if needed only
function makeCmapTable(glyphs) {
    // Plan 0 is the base Unicode Plan but emojis, for example are on another plan, and needs cmap 12 format (with 32bit)
    var isPlan0Only = true;
    var i;

    // Check if we need to add cmap format 12 or if format 4 only is fine
    for (i = glyphs.length - 1; i > 0; i -= 1) {
        var g = glyphs.get(i);
        if (g.unicode > 65535) {
            console.log('Adding CMAP format 12 (needed!)');
            isPlan0Only = false;
            break;
        }
    }

    var cmapTable = [
        {name: 'version', type: 'USHORT', value: 0},
        {name: 'numTables', type: 'USHORT', value: isPlan0Only ? 1 : 2},

        // CMAP 4 header
        {name: 'platformID', type: 'USHORT', value: 3},
        {name: 'encodingID', type: 'USHORT', value: 1},
        {name: 'offset', type: 'ULONG', value: isPlan0Only ? 12 : (12 + 8)}
    ];

    if (!isPlan0Only)
        { cmapTable = cmapTable.concat([
            // CMAP 12 header
            {name: 'cmap12PlatformID', type: 'USHORT', value: 3}, // We encode only for PlatformID = 3 (Windows) because it is supported everywhere
            {name: 'cmap12EncodingID', type: 'USHORT', value: 10},
            {name: 'cmap12Offset', type: 'ULONG', value: 0}
        ]); }

    cmapTable = cmapTable.concat([
        // CMAP 4 Subtable
        {name: 'format', type: 'USHORT', value: 4},
        {name: 'cmap4Length', type: 'USHORT', value: 0},
        {name: 'language', type: 'USHORT', value: 0},
        {name: 'segCountX2', type: 'USHORT', value: 0},
        {name: 'searchRange', type: 'USHORT', value: 0},
        {name: 'entrySelector', type: 'USHORT', value: 0},
        {name: 'rangeShift', type: 'USHORT', value: 0}
    ]);

    var t = new table.Table('cmap', cmapTable);

    t.segments = [];
    for (i = 0; i < glyphs.length; i += 1) {
        var glyph = glyphs.get(i);
        for (var j = 0; j < glyph.unicodes.length; j += 1) {
            addSegment(t, glyph.unicodes[j], i);
        }

        t.segments = t.segments.sort(function (a, b) {
            return a.start - b.start;
        });
    }

    addTerminatorSegment(t);

    var segCount = t.segments.length;
    var segCountToRemove = 0;

    // CMAP 4
    // Set up parallel segment arrays.
    var endCounts = [];
    var startCounts = [];
    var idDeltas = [];
    var idRangeOffsets = [];
    var glyphIds = [];

    // CMAP 12
    var cmap12Groups = [];

    // Reminder this loop is not following the specification at 100%
    // The specification -> find suites of characters and make a group
    // Here we're doing one group for each letter
    // Doing as the spec can save 8 times (or more) space
    for (i = 0; i < segCount; i += 1) {
        var segment = t.segments[i];

        // CMAP 4
        if (segment.end <= 65535 && segment.start <= 65535) {
            endCounts = endCounts.concat({name: 'end_' + i, type: 'USHORT', value: segment.end});
            startCounts = startCounts.concat({name: 'start_' + i, type: 'USHORT', value: segment.start});
            idDeltas = idDeltas.concat({name: 'idDelta_' + i, type: 'SHORT', value: segment.delta});
            idRangeOffsets = idRangeOffsets.concat({name: 'idRangeOffset_' + i, type: 'USHORT', value: segment.offset});
            if (segment.glyphId !== undefined) {
                glyphIds = glyphIds.concat({name: 'glyph_' + i, type: 'USHORT', value: segment.glyphId});
            }
        } else {
            // Skip Unicode > 65535 (16bit unsigned max) for CMAP 4, will be added in CMAP 12
            segCountToRemove += 1;
        }

        // CMAP 12
        // Skip Terminator Segment
        if (!isPlan0Only && segment.glyphIndex !== undefined) {
            cmap12Groups = cmap12Groups.concat({name: 'cmap12Start_' + i, type: 'ULONG', value: segment.start});
            cmap12Groups = cmap12Groups.concat({name: 'cmap12End_' + i, type: 'ULONG', value: segment.end});
            cmap12Groups = cmap12Groups.concat({name: 'cmap12Glyph_' + i, type: 'ULONG', value: segment.glyphIndex});
        }
    }

    // CMAP 4 Subtable
    t.segCountX2 = (segCount - segCountToRemove) * 2;
    t.searchRange = Math.pow(2, Math.floor(Math.log((segCount - segCountToRemove)) / Math.log(2))) * 2;
    t.entrySelector = Math.log(t.searchRange / 2) / Math.log(2);
    t.rangeShift = t.segCountX2 - t.searchRange;

    t.fields = t.fields.concat(endCounts);
    t.fields.push({name: 'reservedPad', type: 'USHORT', value: 0});
    t.fields = t.fields.concat(startCounts);
    t.fields = t.fields.concat(idDeltas);
    t.fields = t.fields.concat(idRangeOffsets);
    t.fields = t.fields.concat(glyphIds);

    t.cmap4Length = 14 + // Subtable header
        endCounts.length * 2 +
        2 + // reservedPad
        startCounts.length * 2 +
        idDeltas.length * 2 +
        idRangeOffsets.length * 2 +
        glyphIds.length * 2;

    if (!isPlan0Only) {
        // CMAP 12 Subtable
        var cmap12Length = 16 + // Subtable header
            cmap12Groups.length * 4;

        t.cmap12Offset = 12 + (2 * 2) + 4 + t.cmap4Length;
        t.fields = t.fields.concat([
            {name: 'cmap12Format', type: 'USHORT', value: 12},
            {name: 'cmap12Reserved', type: 'USHORT', value: 0},
            {name: 'cmap12Length', type: 'ULONG', value: cmap12Length},
            {name: 'cmap12Language', type: 'ULONG', value: 0},
            {name: 'cmap12nGroups', type: 'ULONG', value: cmap12Groups.length / 3}
        ]);

        t.fields = t.fields.concat(cmap12Groups);
    }

    return t;
}

var cmap = { parse: parseCmapTable, make: makeCmapTable };

// Glyph encoding

var cffStandardStrings = [
    '.notdef', 'space', 'exclam', 'quotedbl', 'numbersign', 'dollar', 'percent', 'ampersand', 'quoteright',
    'parenleft', 'parenright', 'asterisk', 'plus', 'comma', 'hyphen', 'period', 'slash', 'zero', 'one', 'two',
    'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'colon', 'semicolon', 'less', 'equal', 'greater',
    'question', 'at', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S',
    'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'bracketleft', 'backslash', 'bracketright', 'asciicircum', 'underscore',
    'quoteleft', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't',
    'u', 'v', 'w', 'x', 'y', 'z', 'braceleft', 'bar', 'braceright', 'asciitilde', 'exclamdown', 'cent', 'sterling',
    'fraction', 'yen', 'florin', 'section', 'currency', 'quotesingle', 'quotedblleft', 'guillemotleft',
    'guilsinglleft', 'guilsinglright', 'fi', 'fl', 'endash', 'dagger', 'daggerdbl', 'periodcentered', 'paragraph',
    'bullet', 'quotesinglbase', 'quotedblbase', 'quotedblright', 'guillemotright', 'ellipsis', 'perthousand',
    'questiondown', 'grave', 'acute', 'circumflex', 'tilde', 'macron', 'breve', 'dotaccent', 'dieresis', 'ring',
    'cedilla', 'hungarumlaut', 'ogonek', 'caron', 'emdash', 'AE', 'ordfeminine', 'Lslash', 'Oslash', 'OE',
    'ordmasculine', 'ae', 'dotlessi', 'lslash', 'oslash', 'oe', 'germandbls', 'onesuperior', 'logicalnot', 'mu',
    'trademark', 'Eth', 'onehalf', 'plusminus', 'Thorn', 'onequarter', 'divide', 'brokenbar', 'degree', 'thorn',
    'threequarters', 'twosuperior', 'registered', 'minus', 'eth', 'multiply', 'threesuperior', 'copyright',
    'Aacute', 'Acircumflex', 'Adieresis', 'Agrave', 'Aring', 'Atilde', 'Ccedilla', 'Eacute', 'Ecircumflex',
    'Edieresis', 'Egrave', 'Iacute', 'Icircumflex', 'Idieresis', 'Igrave', 'Ntilde', 'Oacute', 'Ocircumflex',
    'Odieresis', 'Ograve', 'Otilde', 'Scaron', 'Uacute', 'Ucircumflex', 'Udieresis', 'Ugrave', 'Yacute',
    'Ydieresis', 'Zcaron', 'aacute', 'acircumflex', 'adieresis', 'agrave', 'aring', 'atilde', 'ccedilla', 'eacute',
    'ecircumflex', 'edieresis', 'egrave', 'iacute', 'icircumflex', 'idieresis', 'igrave', 'ntilde', 'oacute',
    'ocircumflex', 'odieresis', 'ograve', 'otilde', 'scaron', 'uacute', 'ucircumflex', 'udieresis', 'ugrave',
    'yacute', 'ydieresis', 'zcaron', 'exclamsmall', 'Hungarumlautsmall', 'dollaroldstyle', 'dollarsuperior',
    'ampersandsmall', 'Acutesmall', 'parenleftsuperior', 'parenrightsuperior', '266 ff', 'onedotenleader',
    'zerooldstyle', 'oneoldstyle', 'twooldstyle', 'threeoldstyle', 'fouroldstyle', 'fiveoldstyle', 'sixoldstyle',
    'sevenoldstyle', 'eightoldstyle', 'nineoldstyle', 'commasuperior', 'threequartersemdash', 'periodsuperior',
    'questionsmall', 'asuperior', 'bsuperior', 'centsuperior', 'dsuperior', 'esuperior', 'isuperior', 'lsuperior',
    'msuperior', 'nsuperior', 'osuperior', 'rsuperior', 'ssuperior', 'tsuperior', 'ff', 'ffi', 'ffl',
    'parenleftinferior', 'parenrightinferior', 'Circumflexsmall', 'hyphensuperior', 'Gravesmall', 'Asmall',
    'Bsmall', 'Csmall', 'Dsmall', 'Esmall', 'Fsmall', 'Gsmall', 'Hsmall', 'Ismall', 'Jsmall', 'Ksmall', 'Lsmall',
    'Msmall', 'Nsmall', 'Osmall', 'Psmall', 'Qsmall', 'Rsmall', 'Ssmall', 'Tsmall', 'Usmall', 'Vsmall', 'Wsmall',
    'Xsmall', 'Ysmall', 'Zsmall', 'colonmonetary', 'onefitted', 'rupiah', 'Tildesmall', 'exclamdownsmall',
    'centoldstyle', 'Lslashsmall', 'Scaronsmall', 'Zcaronsmall', 'Dieresissmall', 'Brevesmall', 'Caronsmall',
    'Dotaccentsmall', 'Macronsmall', 'figuredash', 'hypheninferior', 'Ogoneksmall', 'Ringsmall', 'Cedillasmall',
    'questiondownsmall', 'oneeighth', 'threeeighths', 'fiveeighths', 'seveneighths', 'onethird', 'twothirds',
    'zerosuperior', 'foursuperior', 'fivesuperior', 'sixsuperior', 'sevensuperior', 'eightsuperior', 'ninesuperior',
    'zeroinferior', 'oneinferior', 'twoinferior', 'threeinferior', 'fourinferior', 'fiveinferior', 'sixinferior',
    'seveninferior', 'eightinferior', 'nineinferior', 'centinferior', 'dollarinferior', 'periodinferior',
    'commainferior', 'Agravesmall', 'Aacutesmall', 'Acircumflexsmall', 'Atildesmall', 'Adieresissmall',
    'Aringsmall', 'AEsmall', 'Ccedillasmall', 'Egravesmall', 'Eacutesmall', 'Ecircumflexsmall', 'Edieresissmall',
    'Igravesmall', 'Iacutesmall', 'Icircumflexsmall', 'Idieresissmall', 'Ethsmall', 'Ntildesmall', 'Ogravesmall',
    'Oacutesmall', 'Ocircumflexsmall', 'Otildesmall', 'Odieresissmall', 'OEsmall', 'Oslashsmall', 'Ugravesmall',
    'Uacutesmall', 'Ucircumflexsmall', 'Udieresissmall', 'Yacutesmall', 'Thornsmall', 'Ydieresissmall', '001.000',
    '001.001', '001.002', '001.003', 'Black', 'Bold', 'Book', 'Light', 'Medium', 'Regular', 'Roman', 'Semibold'];

var cffStandardEncoding = [
    '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '',
    '', '', '', '', 'space', 'exclam', 'quotedbl', 'numbersign', 'dollar', 'percent', 'ampersand', 'quoteright',
    'parenleft', 'parenright', 'asterisk', 'plus', 'comma', 'hyphen', 'period', 'slash', 'zero', 'one', 'two',
    'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'colon', 'semicolon', 'less', 'equal', 'greater',
    'question', 'at', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S',
    'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'bracketleft', 'backslash', 'bracketright', 'asciicircum', 'underscore',
    'quoteleft', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't',
    'u', 'v', 'w', 'x', 'y', 'z', 'braceleft', 'bar', 'braceright', 'asciitilde', '', '', '', '', '', '', '', '',
    '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '',
    'exclamdown', 'cent', 'sterling', 'fraction', 'yen', 'florin', 'section', 'currency', 'quotesingle',
    'quotedblleft', 'guillemotleft', 'guilsinglleft', 'guilsinglright', 'fi', 'fl', '', 'endash', 'dagger',
    'daggerdbl', 'periodcentered', '', 'paragraph', 'bullet', 'quotesinglbase', 'quotedblbase', 'quotedblright',
    'guillemotright', 'ellipsis', 'perthousand', '', 'questiondown', '', 'grave', 'acute', 'circumflex', 'tilde',
    'macron', 'breve', 'dotaccent', 'dieresis', '', 'ring', 'cedilla', '', 'hungarumlaut', 'ogonek', 'caron',
    'emdash', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 'AE', '', 'ordfeminine', '', '', '',
    '', 'Lslash', 'Oslash', 'OE', 'ordmasculine', '', '', '', '', '', 'ae', '', '', '', 'dotlessi', '', '',
    'lslash', 'oslash', 'oe', 'germandbls'];

var cffExpertEncoding = [
    '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '',
    '', '', '', '', 'space', 'exclamsmall', 'Hungarumlautsmall', '', 'dollaroldstyle', 'dollarsuperior',
    'ampersandsmall', 'Acutesmall', 'parenleftsuperior', 'parenrightsuperior', 'twodotenleader', 'onedotenleader',
    'comma', 'hyphen', 'period', 'fraction', 'zerooldstyle', 'oneoldstyle', 'twooldstyle', 'threeoldstyle',
    'fouroldstyle', 'fiveoldstyle', 'sixoldstyle', 'sevenoldstyle', 'eightoldstyle', 'nineoldstyle', 'colon',
    'semicolon', 'commasuperior', 'threequartersemdash', 'periodsuperior', 'questionsmall', '', 'asuperior',
    'bsuperior', 'centsuperior', 'dsuperior', 'esuperior', '', '', 'isuperior', '', '', 'lsuperior', 'msuperior',
    'nsuperior', 'osuperior', '', '', 'rsuperior', 'ssuperior', 'tsuperior', '', 'ff', 'fi', 'fl', 'ffi', 'ffl',
    'parenleftinferior', '', 'parenrightinferior', 'Circumflexsmall', 'hyphensuperior', 'Gravesmall', 'Asmall',
    'Bsmall', 'Csmall', 'Dsmall', 'Esmall', 'Fsmall', 'Gsmall', 'Hsmall', 'Ismall', 'Jsmall', 'Ksmall', 'Lsmall',
    'Msmall', 'Nsmall', 'Osmall', 'Psmall', 'Qsmall', 'Rsmall', 'Ssmall', 'Tsmall', 'Usmall', 'Vsmall', 'Wsmall',
    'Xsmall', 'Ysmall', 'Zsmall', 'colonmonetary', 'onefitted', 'rupiah', 'Tildesmall', '', '', '', '', '', '', '',
    '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '',
    'exclamdownsmall', 'centoldstyle', 'Lslashsmall', '', '', 'Scaronsmall', 'Zcaronsmall', 'Dieresissmall',
    'Brevesmall', 'Caronsmall', '', 'Dotaccentsmall', '', '', 'Macronsmall', '', '', 'figuredash', 'hypheninferior',
    '', '', 'Ogoneksmall', 'Ringsmall', 'Cedillasmall', '', '', '', 'onequarter', 'onehalf', 'threequarters',
    'questiondownsmall', 'oneeighth', 'threeeighths', 'fiveeighths', 'seveneighths', 'onethird', 'twothirds', '',
    '', 'zerosuperior', 'onesuperior', 'twosuperior', 'threesuperior', 'foursuperior', 'fivesuperior',
    'sixsuperior', 'sevensuperior', 'eightsuperior', 'ninesuperior', 'zeroinferior', 'oneinferior', 'twoinferior',
    'threeinferior', 'fourinferior', 'fiveinferior', 'sixinferior', 'seveninferior', 'eightinferior',
    'nineinferior', 'centinferior', 'dollarinferior', 'periodinferior', 'commainferior', 'Agravesmall',
    'Aacutesmall', 'Acircumflexsmall', 'Atildesmall', 'Adieresissmall', 'Aringsmall', 'AEsmall', 'Ccedillasmall',
    'Egravesmall', 'Eacutesmall', 'Ecircumflexsmall', 'Edieresissmall', 'Igravesmall', 'Iacutesmall',
    'Icircumflexsmall', 'Idieresissmall', 'Ethsmall', 'Ntildesmall', 'Ogravesmall', 'Oacutesmall',
    'Ocircumflexsmall', 'Otildesmall', 'Odieresissmall', 'OEsmall', 'Oslashsmall', 'Ugravesmall', 'Uacutesmall',
    'Ucircumflexsmall', 'Udieresissmall', 'Yacutesmall', 'Thornsmall', 'Ydieresissmall'];

var standardNames = [
    '.notdef', '.null', 'nonmarkingreturn', 'space', 'exclam', 'quotedbl', 'numbersign', 'dollar', 'percent',
    'ampersand', 'quotesingle', 'parenleft', 'parenright', 'asterisk', 'plus', 'comma', 'hyphen', 'period', 'slash',
    'zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'colon', 'semicolon', 'less',
    'equal', 'greater', 'question', 'at', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O',
    'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'bracketleft', 'backslash', 'bracketright',
    'asciicircum', 'underscore', 'grave', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o',
    'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'braceleft', 'bar', 'braceright', 'asciitilde',
    'Adieresis', 'Aring', 'Ccedilla', 'Eacute', 'Ntilde', 'Odieresis', 'Udieresis', 'aacute', 'agrave',
    'acircumflex', 'adieresis', 'atilde', 'aring', 'ccedilla', 'eacute', 'egrave', 'ecircumflex', 'edieresis',
    'iacute', 'igrave', 'icircumflex', 'idieresis', 'ntilde', 'oacute', 'ograve', 'ocircumflex', 'odieresis',
    'otilde', 'uacute', 'ugrave', 'ucircumflex', 'udieresis', 'dagger', 'degree', 'cent', 'sterling', 'section',
    'bullet', 'paragraph', 'germandbls', 'registered', 'copyright', 'trademark', 'acute', 'dieresis', 'notequal',
    'AE', 'Oslash', 'infinity', 'plusminus', 'lessequal', 'greaterequal', 'yen', 'mu', 'partialdiff', 'summation',
    'product', 'pi', 'integral', 'ordfeminine', 'ordmasculine', 'Omega', 'ae', 'oslash', 'questiondown',
    'exclamdown', 'logicalnot', 'radical', 'florin', 'approxequal', 'Delta', 'guillemotleft', 'guillemotright',
    'ellipsis', 'nonbreakingspace', 'Agrave', 'Atilde', 'Otilde', 'OE', 'oe', 'endash', 'emdash', 'quotedblleft',
    'quotedblright', 'quoteleft', 'quoteright', 'divide', 'lozenge', 'ydieresis', 'Ydieresis', 'fraction',
    'currency', 'guilsinglleft', 'guilsinglright', 'fi', 'fl', 'daggerdbl', 'periodcentered', 'quotesinglbase',
    'quotedblbase', 'perthousand', 'Acircumflex', 'Ecircumflex', 'Aacute', 'Edieresis', 'Egrave', 'Iacute',
    'Icircumflex', 'Idieresis', 'Igrave', 'Oacute', 'Ocircumflex', 'apple', 'Ograve', 'Uacute', 'Ucircumflex',
    'Ugrave', 'dotlessi', 'circumflex', 'tilde', 'macron', 'breve', 'dotaccent', 'ring', 'cedilla', 'hungarumlaut',
    'ogonek', 'caron', 'Lslash', 'lslash', 'Scaron', 'scaron', 'Zcaron', 'zcaron', 'brokenbar', 'Eth', 'eth',
    'Yacute', 'yacute', 'Thorn', 'thorn', 'minus', 'multiply', 'onesuperior', 'twosuperior', 'threesuperior',
    'onehalf', 'onequarter', 'threequarters', 'franc', 'Gbreve', 'gbreve', 'Idotaccent', 'Scedilla', 'scedilla',
    'Cacute', 'cacute', 'Ccaron', 'ccaron', 'dcroat'];

/**
 * This is the encoding used for fonts created from scratch.
 * It loops through all glyphs and finds the appropriate unicode value.
 * Since it's linear time, other encodings will be faster.
 * @exports opentype.DefaultEncoding
 * @class
 * @constructor
 * @param {opentype.Font}
 */
function DefaultEncoding(font) {
    this.font = font;
}

DefaultEncoding.prototype.charToGlyphIndex = function(c) {
    var code = c.codePointAt(0);
    var glyphs = this.font.glyphs;
    if (glyphs) {
        for (var i = 0; i < glyphs.length; i += 1) {
            var glyph = glyphs.get(i);
            for (var j = 0; j < glyph.unicodes.length; j += 1) {
                if (glyph.unicodes[j] === code) {
                    return i;
                }
            }
        }
    }
    return null;
};

/**
 * @exports opentype.CmapEncoding
 * @class
 * @constructor
 * @param {Object} cmap - a object with the cmap encoded data
 */
function CmapEncoding(cmap) {
    this.cmap = cmap;
}

/**
 * @param  {string} c - the character
 * @return {number} The glyph index.
 */
CmapEncoding.prototype.charToGlyphIndex = function(c) {
    return this.cmap.glyphIndexMap[c.codePointAt(0)] || 0;
};

/**
 * @exports opentype.CffEncoding
 * @class
 * @constructor
 * @param {string} encoding - The encoding
 * @param {Array} charset - The character set.
 */
function CffEncoding(encoding, charset) {
    this.encoding = encoding;
    this.charset = charset;
}

/**
 * @param  {string} s - The character
 * @return {number} The index.
 */
CffEncoding.prototype.charToGlyphIndex = function(s) {
    var code = s.codePointAt(0);
    var charName = this.encoding[code];
    return this.charset.indexOf(charName);
};

/**
 * @exports opentype.GlyphNames
 * @class
 * @constructor
 * @param {Object} post
 */
function GlyphNames(post) {
    switch (post.version) {
        case 1:
            this.names = standardNames.slice();
            break;
        case 2:
            this.names = new Array(post.numberOfGlyphs);
            for (var i = 0; i < post.numberOfGlyphs; i++) {
                if (post.glyphNameIndex[i] < standardNames.length) {
                    this.names[i] = standardNames[post.glyphNameIndex[i]];
                } else {
                    this.names[i] = post.names[post.glyphNameIndex[i] - standardNames.length];
                }
            }

            break;
        case 2.5:
            this.names = new Array(post.numberOfGlyphs);
            for (var i$1 = 0; i$1 < post.numberOfGlyphs; i$1++) {
                this.names[i$1] = standardNames[i$1 + post.glyphNameIndex[i$1]];
            }

            break;
        case 3:
            this.names = [];
            break;
        default:
            this.names = [];
            break;
    }
}

/**
 * Gets the index of a glyph by name.
 * @param  {string} name - The glyph name
 * @return {number} The index
 */
GlyphNames.prototype.nameToGlyphIndex = function(name) {
    return this.names.indexOf(name);
};

/**
 * @param  {number} gid
 * @return {string}
 */
GlyphNames.prototype.glyphIndexToName = function(gid) {
    return this.names[gid];
};

function addGlyphNamesAll(font) {
    var glyph;
    var glyphIndexMap = font.tables.cmap.glyphIndexMap;
    var charCodes = Object.keys(glyphIndexMap);

    for (var i = 0; i < charCodes.length; i += 1) {
        var c = charCodes[i];
        var glyphIndex = glyphIndexMap[c];
        glyph = font.glyphs.get(glyphIndex);
        glyph.addUnicode(parseInt(c));
    }

    for (var i$1 = 0; i$1 < font.glyphs.length; i$1 += 1) {
        glyph = font.glyphs.get(i$1);
        if (font.cffEncoding) {
            if (font.isCIDFont) {
                glyph.name = 'gid' + i$1;
            } else {
                glyph.name = font.cffEncoding.charset[i$1];
            }
        } else if (font.glyphNames.names) {
            glyph.name = font.glyphNames.glyphIndexToName(i$1);
        }
    }
}

function addGlyphNamesToUnicodeMap(font) {
    font._IndexToUnicodeMap = {};

    var glyphIndexMap = font.tables.cmap.glyphIndexMap;
    var charCodes = Object.keys(glyphIndexMap);

    for (var i = 0; i < charCodes.length; i += 1) {
        var c = charCodes[i];
        var glyphIndex = glyphIndexMap[c];
        if (font._IndexToUnicodeMap[glyphIndex] === undefined) {
            font._IndexToUnicodeMap[glyphIndex] = {
                unicodes: [parseInt(c)]
            };
        } else {
            font._IndexToUnicodeMap[glyphIndex].unicodes.push(parseInt(c));
        }
    }
}

/**
 * @alias opentype.addGlyphNames
 * @param {opentype.Font}
 * @param {Object}
 */
function addGlyphNames(font, opt) {
    if (opt.lowMemory) {
        addGlyphNamesToUnicodeMap(font);
    } else {
        addGlyphNamesAll(font);
    }
}

// Drawing utility functions.

// Draw a line on the given context from point `x1,y1` to point `x2,y2`.
function line(ctx, x1, y1, x2, y2) {
    ctx.beginPath();
    ctx.moveTo(x1, y1);
    ctx.lineTo(x2, y2);
    ctx.stroke();
}

var draw = { line: line };

// The Glyph object
// import glyf from './tables/glyf' Can't be imported here, because it's a circular dependency

function getPathDefinition(glyph, path) {
    var _path = path || new Path();
    return {
        configurable: true,

        get: function() {
            if (typeof _path === 'function') {
                _path = _path();
            }

            return _path;
        },

        set: function(p) {
            _path = p;
        }
    };
}
/**
 * @typedef GlyphOptions
 * @type Object
 * @property {string} [name] - The glyph name
 * @property {number} [unicode]
 * @property {Array} [unicodes]
 * @property {number} [xMin]
 * @property {number} [yMin]
 * @property {number} [xMax]
 * @property {number} [yMax]
 * @property {number} [advanceWidth]
 */

// A Glyph is an individual mark that often corresponds to a character.
// Some glyphs, such as ligatures, are a combination of many characters.
// Glyphs are the basic building blocks of a font.
//
// The `Glyph` class contains utility methods for drawing the path and its points.
/**
 * @exports opentype.Glyph
 * @class
 * @param {GlyphOptions}
 * @constructor
 */
function Glyph(options) {
    // By putting all the code on a prototype function (which is only declared once)
    // we reduce the memory requirements for larger fonts by some 2%
    this.bindConstructorValues(options);
}

/**
 * @param  {GlyphOptions}
 */
Glyph.prototype.bindConstructorValues = function(options) {
    this.index = options.index || 0;

    // These three values cannot be deferred for memory optimization:
    this.name = options.name || null;
    this.unicode = options.unicode || undefined;
    this.unicodes = options.unicodes || options.unicode !== undefined ? [options.unicode] : [];

    // But by binding these values only when necessary, we reduce can
    // the memory requirements by almost 3% for larger fonts.
    if ('xMin' in options) {
        this.xMin = options.xMin;
    }

    if ('yMin' in options) {
        this.yMin = options.yMin;
    }

    if ('xMax' in options) {
        this.xMax = options.xMax;
    }

    if ('yMax' in options) {
        this.yMax = options.yMax;
    }

    if ('advanceWidth' in options) {
        this.advanceWidth = options.advanceWidth;
    }

    // The path for a glyph is the most memory intensive, and is bound as a value
    // with a getter/setter to ensure we actually do path parsing only once the
    // path is actually needed by anything.
    Object.defineProperty(this, 'path', getPathDefinition(this, options.path));
};

/**
 * @param {number}
 */
Glyph.prototype.addUnicode = function(unicode) {
    if (this.unicodes.length === 0) {
        this.unicode = unicode;
    }

    this.unicodes.push(unicode);
};

/**
 * Calculate the minimum bounding box for this glyph.
 * @return {opentype.BoundingBox}
 */
Glyph.prototype.getBoundingBox = function() {
    return this.path.getBoundingBox();
};

/**
 * Convert the glyph to a Path we can draw on a drawing context.
 * @param  {number} [x=0] - Horizontal position of the beginning of the text.
 * @param  {number} [y=0] - Vertical position of the *baseline* of the text.
 * @param  {number} [fontSize=72] - Font size in pixels. We scale the glyph units by `1 / unitsPerEm * fontSize`.
 * @param  {Object=} options - xScale, yScale to stretch the glyph.
 * @param  {opentype.Font} if hinting is to be used, the font
 * @return {opentype.Path}
 */
Glyph.prototype.getPath = function(x, y, fontSize, options, font) {
    x = x !== undefined ? x : 0;
    y = y !== undefined ? y : 0;
    fontSize = fontSize !== undefined ? fontSize : 72;
    var commands;
    var hPoints;
    if (!options) { options = { }; }
    var xScale = options.xScale;
    var yScale = options.yScale;

    if (options.hinting && font && font.hinting) {
        // in case of hinting, the hinting engine takes care
        // of scaling the points (not the path) before hinting.
        hPoints = this.path && font.hinting.exec(this, fontSize);
        // in case the hinting engine failed hPoints is undefined
        // and thus reverts to plain rending
    }

    if (hPoints) {
        // Call font.hinting.getCommands instead of `glyf.getPath(hPoints).commands` to avoid a circular dependency
        commands = font.hinting.getCommands(hPoints);
        x = Math.round(x);
        y = Math.round(y);
        // TODO in case of hinting xyScaling is not yet supported
        xScale = yScale = 1;
    } else {
        commands = this.path.commands;
        var scale = 1 / (this.path.unitsPerEm || 1000) * fontSize;
        if (xScale === undefined) { xScale = scale; }
        if (yScale === undefined) { yScale = scale; }
    }

    var p = new Path();
    for (var i = 0; i < commands.length; i += 1) {
        var cmd = commands[i];
        if (cmd.type === 'M') {
            p.moveTo(x + (cmd.x * xScale), y + (-cmd.y * yScale));
        } else if (cmd.type === 'L') {
            p.lineTo(x + (cmd.x * xScale), y + (-cmd.y * yScale));
        } else if (cmd.type === 'Q') {
            p.quadraticCurveTo(x + (cmd.x1 * xScale), y + (-cmd.y1 * yScale),
                               x + (cmd.x * xScale), y + (-cmd.y * yScale));
        } else if (cmd.type === 'C') {
            p.curveTo(x + (cmd.x1 * xScale), y + (-cmd.y1 * yScale),
                      x + (cmd.x2 * xScale), y + (-cmd.y2 * yScale),
                      x + (cmd.x * xScale), y + (-cmd.y * yScale));
        } else if (cmd.type === 'Z') {
            p.closePath();
        }
    }

    return p;
};

/**
 * Split the glyph into contours.
 * This function is here for backwards compatibility, and to
 * provide raw access to the TrueType glyph outlines.
 * @return {Array}
 */
Glyph.prototype.getContours = function() {
    if (this.points === undefined) {
        return [];
    }

    var contours = [];
    var currentContour = [];
    for (var i = 0; i < this.points.length; i += 1) {
        var pt = this.points[i];
        currentContour.push(pt);
        if (pt.lastPointOfContour) {
            contours.push(currentContour);
            currentContour = [];
        }
    }

    check.argument(currentContour.length === 0, 'There are still points left in the current contour.');
    return contours;
};

/**
 * Calculate the xMin/yMin/xMax/yMax/lsb/rsb for a Glyph.
 * @return {Object}
 */
Glyph.prototype.getMetrics = function() {
    var commands = this.path.commands;
    var xCoords = [];
    var yCoords = [];
    for (var i = 0; i < commands.length; i += 1) {
        var cmd = commands[i];
        if (cmd.type !== 'Z') {
            xCoords.push(cmd.x);
            yCoords.push(cmd.y);
        }

        if (cmd.type === 'Q' || cmd.type === 'C') {
            xCoords.push(cmd.x1);
            yCoords.push(cmd.y1);
        }

        if (cmd.type === 'C') {
            xCoords.push(cmd.x2);
            yCoords.push(cmd.y2);
        }
    }

    var metrics = {
        xMin: Math.min.apply(null, xCoords),
        yMin: Math.min.apply(null, yCoords),
        xMax: Math.max.apply(null, xCoords),
        yMax: Math.max.apply(null, yCoords),
        leftSideBearing: this.leftSideBearing
    };

    if (!isFinite(metrics.xMin)) {
        metrics.xMin = 0;
    }

    if (!isFinite(metrics.xMax)) {
        metrics.xMax = this.advanceWidth;
    }

    if (!isFinite(metrics.yMin)) {
        metrics.yMin = 0;
    }

    if (!isFinite(metrics.yMax)) {
        metrics.yMax = 0;
    }

    metrics.rightSideBearing = this.advanceWidth - metrics.leftSideBearing - (metrics.xMax - metrics.xMin);
    return metrics;
};

/**
 * Draw the glyph on the given context.
 * @param  {CanvasRenderingContext2D} ctx - A 2D drawing context, like Canvas.
 * @param  {number} [x=0] - Horizontal position of the beginning of the text.
 * @param  {number} [y=0] - Vertical position of the *baseline* of the text.
 * @param  {number} [fontSize=72] - Font size in pixels. We scale the glyph units by `1 / unitsPerEm * fontSize`.
 * @param  {Object=} options - xScale, yScale to stretch the glyph.
 */
Glyph.prototype.draw = function(ctx, x, y, fontSize, options) {
    this.getPath(x, y, fontSize, options).draw(ctx);
};

/**
 * Draw the points of the glyph.
 * On-curve points will be drawn in blue, off-curve points will be drawn in red.
 * @param  {CanvasRenderingContext2D} ctx - A 2D drawing context, like Canvas.
 * @param  {number} [x=0] - Horizontal position of the beginning of the text.
 * @param  {number} [y=0] - Vertical position of the *baseline* of the text.
 * @param  {number} [fontSize=72] - Font size in pixels. We scale the glyph units by `1 / unitsPerEm * fontSize`.
 */
Glyph.prototype.drawPoints = function(ctx, x, y, fontSize) {
    function drawCircles(l, x, y, scale) {
        ctx.beginPath();
        for (var j = 0; j < l.length; j += 1) {
            ctx.moveTo(x + (l[j].x * scale), y + (l[j].y * scale));
            ctx.arc(x + (l[j].x * scale), y + (l[j].y * scale), 2, 0, Math.PI * 2, false);
        }

        ctx.closePath();
        ctx.fill();
    }

    x = x !== undefined ? x : 0;
    y = y !== undefined ? y : 0;
    fontSize = fontSize !== undefined ? fontSize : 24;
    var scale = 1 / this.path.unitsPerEm * fontSize;

    var blueCircles = [];
    var redCircles = [];
    var path = this.path;
    for (var i = 0; i < path.commands.length; i += 1) {
        var cmd = path.commands[i];
        if (cmd.x !== undefined) {
            blueCircles.push({x: cmd.x, y: -cmd.y});
        }

        if (cmd.x1 !== undefined) {
            redCircles.push({x: cmd.x1, y: -cmd.y1});
        }

        if (cmd.x2 !== undefined) {
            redCircles.push({x: cmd.x2, y: -cmd.y2});
        }
    }

    ctx.fillStyle = 'blue';
    drawCircles(blueCircles, x, y, scale);
    ctx.fillStyle = 'red';
    drawCircles(redCircles, x, y, scale);
};

/**
 * Draw lines indicating important font measurements.
 * Black lines indicate the origin of the coordinate system (point 0,0).
 * Blue lines indicate the glyph bounding box.
 * Green line indicates the advance width of the glyph.
 * @param  {CanvasRenderingContext2D} ctx - A 2D drawing context, like Canvas.
 * @param  {number} [x=0] - Horizontal position of the beginning of the text.
 * @param  {number} [y=0] - Vertical position of the *baseline* of the text.
 * @param  {number} [fontSize=72] - Font size in pixels. We scale the glyph units by `1 / unitsPerEm * fontSize`.
 */
Glyph.prototype.drawMetrics = function(ctx, x, y, fontSize) {
    var scale;
    x = x !== undefined ? x : 0;
    y = y !== undefined ? y : 0;
    fontSize = fontSize !== undefined ? fontSize : 24;
    scale = 1 / this.path.unitsPerEm * fontSize;
    ctx.lineWidth = 1;

    // Draw the origin
    ctx.strokeStyle = 'black';
    draw.line(ctx, x, -10000, x, 10000);
    draw.line(ctx, -10000, y, 10000, y);

    // This code is here due to memory optimization: by not using
    // defaults in the constructor, we save a notable amount of memory.
    var xMin = this.xMin || 0;
    var yMin = this.yMin || 0;
    var xMax = this.xMax || 0;
    var yMax = this.yMax || 0;
    var advanceWidth = this.advanceWidth || 0;

    // Draw the glyph box
    ctx.strokeStyle = 'blue';
    draw.line(ctx, x + (xMin * scale), -10000, x + (xMin * scale), 10000);
    draw.line(ctx, x + (xMax * scale), -10000, x + (xMax * scale), 10000);
    draw.line(ctx, -10000, y + (-yMin * scale), 10000, y + (-yMin * scale));
    draw.line(ctx, -10000, y + (-yMax * scale), 10000, y + (-yMax * scale));

    // Draw the advance width
    ctx.strokeStyle = 'green';
    draw.line(ctx, x + (advanceWidth * scale), -10000, x + (advanceWidth * scale), 10000);
};

// The GlyphSet object

// Define a property on the glyph that depends on the path being loaded.
function defineDependentProperty(glyph, externalName, internalName) {
    Object.defineProperty(glyph, externalName, {
        get: function() {
            // Request the path property to make sure the path is loaded.
            glyph.path; // jshint ignore:line
            return glyph[internalName];
        },
        set: function(newValue) {
            glyph[internalName] = newValue;
        },
        enumerable: true,
        configurable: true
    });
}

/**
 * A GlyphSet represents all glyphs available in the font, but modelled using
 * a deferred glyph loader, for retrieving glyphs only once they are absolutely
 * necessary, to keep the memory footprint down.
 * @exports opentype.GlyphSet
 * @class
 * @param {opentype.Font}
 * @param {Array}
 */
function GlyphSet(font, glyphs) {
    this.font = font;
    this.glyphs = {};
    if (Array.isArray(glyphs)) {
        for (var i = 0; i < glyphs.length; i++) {
            var glyph = glyphs[i];
            glyph.path.unitsPerEm = font.unitsPerEm;
            this.glyphs[i] = glyph;
        }
    }

    this.length = (glyphs && glyphs.length) || 0;
}

/**
 * @param  {number} index
 * @return {opentype.Glyph}
 */
GlyphSet.prototype.get = function(index) {
    // this.glyphs[index] is 'undefined' when low memory mode is on. glyph is pushed on request only.
    if (this.glyphs[index] === undefined) {
        this.font._push(index);
        if (typeof this.glyphs[index] === 'function') {
            this.glyphs[index] = this.glyphs[index]();
        }

        var glyph = this.glyphs[index];
        var unicodeObj = this.font._IndexToUnicodeMap[index];

        if (unicodeObj) {
            for (var j = 0; j < unicodeObj.unicodes.length; j++)
                { glyph.addUnicode(unicodeObj.unicodes[j]); }
        }

        if (this.font.cffEncoding) {
            if (this.font.isCIDFont) {
                glyph.name = 'gid' + index;
            } else {
                glyph.name = this.font.cffEncoding.charset[index];
            }
        } else if (this.font.glyphNames.names) {
            glyph.name = this.font.glyphNames.glyphIndexToName(index);
        }

        this.glyphs[index].advanceWidth = this.font._hmtxTableData[index].advanceWidth;
        this.glyphs[index].leftSideBearing = this.font._hmtxTableData[index].leftSideBearing;
    } else {
        if (typeof this.glyphs[index] === 'function') {
            this.glyphs[index] = this.glyphs[index]();
        }
    }

    return this.glyphs[index];
};

/**
 * @param  {number} index
 * @param  {Object}
 */
GlyphSet.prototype.push = function(index, loader) {
    this.glyphs[index] = loader;
    this.length++;
};

/**
 * @alias opentype.glyphLoader
 * @param  {opentype.Font} font
 * @param  {number} index
 * @return {opentype.Glyph}
 */
function glyphLoader(font, index) {
    return new Glyph({index: index, font: font});
}

/**
 * Generate a stub glyph that can be filled with all metadata *except*
 * the "points" and "path" properties, which must be loaded only once
 * the glyph's path is actually requested for text shaping.
 * @alias opentype.ttfGlyphLoader
 * @param  {opentype.Font} font
 * @param  {number} index
 * @param  {Function} parseGlyph
 * @param  {Object} data
 * @param  {number} position
 * @param  {Function} buildPath
 * @return {opentype.Glyph}
 */
function ttfGlyphLoader(font, index, parseGlyph, data, position, buildPath) {
    return function() {
        var glyph = new Glyph({index: index, font: font});

        glyph.path = function() {
            parseGlyph(glyph, data, position);
            var path = buildPath(font.glyphs, glyph);
            path.unitsPerEm = font.unitsPerEm;
            return path;
        };

        defineDependentProperty(glyph, 'xMin', '_xMin');
        defineDependentProperty(glyph, 'xMax', '_xMax');
        defineDependentProperty(glyph, 'yMin', '_yMin');
        defineDependentProperty(glyph, 'yMax', '_yMax');

        return glyph;
    };
}
/**
 * @alias opentype.cffGlyphLoader
 * @param  {opentype.Font} font
 * @param  {number} index
 * @param  {Function} parseCFFCharstring
 * @param  {string} charstring
 * @return {opentype.Glyph}
 */
function cffGlyphLoader(font, index, parseCFFCharstring, charstring) {
    return function() {
        var glyph = new Glyph({index: index, font: font});

        glyph.path = function() {
            var path = parseCFFCharstring(font, glyph, charstring);
            path.unitsPerEm = font.unitsPerEm;
            return path;
        };

        return glyph;
    };
}

var glyphset = { GlyphSet: GlyphSet, glyphLoader: glyphLoader, ttfGlyphLoader: ttfGlyphLoader, cffGlyphLoader: cffGlyphLoader };

// The `CFF` table contains the glyph outlines in PostScript format.

// Custom equals function that can also check lists.
function equals(a, b) {
    if (a === b) {
        return true;
    } else if (Array.isArray(a) && Array.isArray(b)) {
        if (a.length !== b.length) {
            return false;
        }

        for (var i = 0; i < a.length; i += 1) {
            if (!equals(a[i], b[i])) {
                return false;
            }
        }

        return true;
    } else {
        return false;
    }
}

// Subroutines are encoded using the negative half of the number space.
// See type 2 chapter 4.7 "Subroutine operators".
function calcCFFSubroutineBias(subrs) {
    var bias;
    if (subrs.length < 1240) {
        bias = 107;
    } else if (subrs.length < 33900) {
        bias = 1131;
    } else {
        bias = 32768;
    }

    return bias;
}

// Parse a `CFF` INDEX array.
// An index array consists of a list of offsets, then a list of objects at those offsets.
function parseCFFIndex(data, start, conversionFn) {
    var offsets = [];
    var objects = [];
    var count = parse.getCard16(data, start);
    var objectOffset;
    var endOffset;
    if (count !== 0) {
        var offsetSize = parse.getByte(data, start + 2);
        objectOffset = start + ((count + 1) * offsetSize) + 2;
        var pos = start + 3;
        for (var i = 0; i < count + 1; i += 1) {
            offsets.push(parse.getOffset(data, pos, offsetSize));
            pos += offsetSize;
        }

        // The total size of the index array is 4 header bytes + the value of the last offset.
        endOffset = objectOffset + offsets[count];
    } else {
        endOffset = start + 2;
    }

    for (var i$1 = 0; i$1 < offsets.length - 1; i$1 += 1) {
        var value = parse.getBytes(data, objectOffset + offsets[i$1], objectOffset + offsets[i$1 + 1]);
        if (conversionFn) {
            value = conversionFn(value);
        }

        objects.push(value);
    }

    return {objects: objects, startOffset: start, endOffset: endOffset};
}

function parseCFFIndexLowMemory(data, start) {
    var offsets = [];
    var count = parse.getCard16(data, start);
    var objectOffset;
    var endOffset;
    if (count !== 0) {
        var offsetSize = parse.getByte(data, start + 2);
        objectOffset = start + ((count + 1) * offsetSize) + 2;
        var pos = start + 3;
        for (var i = 0; i < count + 1; i += 1) {
            offsets.push(parse.getOffset(data, pos, offsetSize));
            pos += offsetSize;
        }

        // The total size of the index array is 4 header bytes + the value of the last offset.
        endOffset = objectOffset + offsets[count];
    } else {
        endOffset = start + 2;
    }

    return {offsets: offsets, startOffset: start, endOffset: endOffset};
}
function getCffIndexObject(i, offsets, data, start, conversionFn) {
    var count = parse.getCard16(data, start);
    var objectOffset = 0;
    if (count !== 0) {
        var offsetSize = parse.getByte(data, start + 2);
        objectOffset = start + ((count + 1) * offsetSize) + 2;
    }

    var value = parse.getBytes(data, objectOffset + offsets[i], objectOffset + offsets[i + 1]);
    return value;
}

// Parse a `CFF` DICT real value.
function parseFloatOperand(parser) {
    var s = '';
    var eof = 15;
    var lookup = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.', 'E', 'E-', null, '-'];
    while (true) {
        var b = parser.parseByte();
        var n1 = b >> 4;
        var n2 = b & 15;

        if (n1 === eof) {
            break;
        }

        s += lookup[n1];

        if (n2 === eof) {
            break;
        }

        s += lookup[n2];
    }

    return parseFloat(s);
}

// Parse a `CFF` DICT operand.
function parseOperand(parser, b0) {
    var b1;
    var b2;
    var b3;
    var b4;
    if (b0 === 28) {
        b1 = parser.parseByte();
        b2 = parser.parseByte();
        return b1 << 8 | b2;
    }

    if (b0 === 29) {
        b1 = parser.parseByte();
        b2 = parser.parseByte();
        b3 = parser.parseByte();
        b4 = parser.parseByte();
        return b1 << 24 | b2 << 16 | b3 << 8 | b4;
    }

    if (b0 === 30) {
        return parseFloatOperand(parser);
    }

    if (b0 >= 32 && b0 <= 246) {
        return b0 - 139;
    }

    if (b0 >= 247 && b0 <= 250) {
        b1 = parser.parseByte();
        return (b0 - 247) * 256 + b1 + 108;
    }

    if (b0 >= 251 && b0 <= 254) {
        b1 = parser.parseByte();
        return -(b0 - 251) * 256 - b1 - 108;
    }

    throw new Error('Invalid b0 ' + b0);
}

// Convert the entries returned by `parseDict` to a proper dictionary.
// If a value is a list of one, it is unpacked.
function entriesToObject(entries) {
    var o = {};
    for (var i = 0; i < entries.length; i += 1) {
        var key = entries[i][0];
        var values = entries[i][1];
        var value = (void 0);
        if (values.length === 1) {
            value = values[0];
        } else {
            value = values;
        }

        if (o.hasOwnProperty(key) && !isNaN(o[key])) {
            throw new Error('Object ' + o + ' already has key ' + key);
        }

        o[key] = value;
    }

    return o;
}

// Parse a `CFF` DICT object.
// A dictionary contains key-value pairs in a compact tokenized format.
function parseCFFDict(data, start, size) {
    start = start !== undefined ? start : 0;
    var parser = new parse.Parser(data, start);
    var entries = [];
    var operands = [];
    size = size !== undefined ? size : data.length;

    while (parser.relativeOffset < size) {
        var op = parser.parseByte();

        // The first byte for each dict item distinguishes between operator (key) and operand (value).
        // Values <= 21 are operators.
        if (op <= 21) {
            // Two-byte operators have an initial escape byte of 12.
            if (op === 12) {
                op = 1200 + parser.parseByte();
            }

            entries.push([op, operands]);
            operands = [];
        } else {
            // Since the operands (values) come before the operators (keys), we store all operands in a list
            // until we encounter an operator.
            operands.push(parseOperand(parser, op));
        }
    }

    return entriesToObject(entries);
}

// Given a String Index (SID), return the value of the string.
// Strings below index 392 are standard CFF strings and are not encoded in the font.
function getCFFString(strings, index) {
    if (index <= 390) {
        index = cffStandardStrings[index];
    } else {
        index = strings[index - 391];
    }

    return index;
}

// Interpret a dictionary and return a new dictionary with readable keys and values for missing entries.
// This function takes `meta` which is a list of objects containing `operand`, `name` and `default`.
function interpretDict(dict, meta, strings) {
    var newDict = {};
    var value;

    // Because we also want to include missing values, we start out from the meta list
    // and lookup values in the dict.
    for (var i = 0; i < meta.length; i += 1) {
        var m = meta[i];

        if (Array.isArray(m.type)) {
            var values = [];
            values.length = m.type.length;
            for (var j = 0; j < m.type.length; j++) {
                value = dict[m.op] !== undefined ? dict[m.op][j] : undefined;
                if (value === undefined) {
                    value = m.value !== undefined && m.value[j] !== undefined ? m.value[j] : null;
                }
                if (m.type[j] === 'SID') {
                    value = getCFFString(strings, value);
                }
                values[j] = value;
            }
            newDict[m.name] = values;
        } else {
            value = dict[m.op];
            if (value === undefined) {
                value = m.value !== undefined ? m.value : null;
            }

            if (m.type === 'SID') {
                value = getCFFString(strings, value);
            }
            newDict[m.name] = value;
        }
    }

    return newDict;
}

// Parse the CFF header.
function parseCFFHeader(data, start) {
    var header = {};
    header.formatMajor = parse.getCard8(data, start);
    header.formatMinor = parse.getCard8(data, start + 1);
    header.size = parse.getCard8(data, start + 2);
    header.offsetSize = parse.getCard8(data, start + 3);
    header.startOffset = start;
    header.endOffset = start + 4;
    return header;
}

var TOP_DICT_META = [
    {name: 'version', op: 0, type: 'SID'},
    {name: 'notice', op: 1, type: 'SID'},
    {name: 'copyright', op: 1200, type: 'SID'},
    {name: 'fullName', op: 2, type: 'SID'},
    {name: 'familyName', op: 3, type: 'SID'},
    {name: 'weight', op: 4, type: 'SID'},
    {name: 'isFixedPitch', op: 1201, type: 'number', value: 0},
    {name: 'italicAngle', op: 1202, type: 'number', value: 0},
    {name: 'underlinePosition', op: 1203, type: 'number', value: -100},
    {name: 'underlineThickness', op: 1204, type: 'number', value: 50},
    {name: 'paintType', op: 1205, type: 'number', value: 0},
    {name: 'charstringType', op: 1206, type: 'number', value: 2},
    {
        name: 'fontMatrix',
        op: 1207,
        type: ['real', 'real', 'real', 'real', 'real', 'real'],
        value: [0.001, 0, 0, 0.001, 0, 0]
    },
    {name: 'uniqueId', op: 13, type: 'number'},
    {name: 'fontBBox', op: 5, type: ['number', 'number', 'number', 'number'], value: [0, 0, 0, 0]},
    {name: 'strokeWidth', op: 1208, type: 'number', value: 0},
    {name: 'xuid', op: 14, type: [], value: null},
    {name: 'charset', op: 15, type: 'offset', value: 0},
    {name: 'encoding', op: 16, type: 'offset', value: 0},
    {name: 'charStrings', op: 17, type: 'offset', value: 0},
    {name: 'private', op: 18, type: ['number', 'offset'], value: [0, 0]},
    {name: 'ros', op: 1230, type: ['SID', 'SID', 'number']},
    {name: 'cidFontVersion', op: 1231, type: 'number', value: 0},
    {name: 'cidFontRevision', op: 1232, type: 'number', value: 0},
    {name: 'cidFontType', op: 1233, type: 'number', value: 0},
    {name: 'cidCount', op: 1234, type: 'number', value: 8720},
    {name: 'uidBase', op: 1235, type: 'number'},
    {name: 'fdArray', op: 1236, type: 'offset'},
    {name: 'fdSelect', op: 1237, type: 'offset'},
    {name: 'fontName', op: 1238, type: 'SID'}
];

var PRIVATE_DICT_META = [
    {name: 'subrs', op: 19, type: 'offset', value: 0},
    {name: 'defaultWidthX', op: 20, type: 'number', value: 0},
    {name: 'nominalWidthX', op: 21, type: 'number', value: 0}
];

// Parse the CFF top dictionary. A CFF table can contain multiple fonts, each with their own top dictionary.
// The top dictionary contains the essential metadata for the font, together with the private dictionary.
function parseCFFTopDict(data, strings) {
    var dict = parseCFFDict(data, 0, data.byteLength);
    return interpretDict(dict, TOP_DICT_META, strings);
}

// Parse the CFF private dictionary. We don't fully parse out all the values, only the ones we need.
function parseCFFPrivateDict(data, start, size, strings) {
    var dict = parseCFFDict(data, start, size);
    return interpretDict(dict, PRIVATE_DICT_META, strings);
}

// Returns a list of "Top DICT"s found using an INDEX list.
// Used to read both the usual high-level Top DICTs and also the FDArray
// discovered inside CID-keyed fonts.  When a Top DICT has a reference to
// a Private DICT that is read and saved into the Top DICT.
//
// In addition to the expected/optional values as outlined in TOP_DICT_META
// the following values might be saved into the Top DICT.
//
//    _subrs []        array of local CFF subroutines from Private DICT
//    _subrsBias       bias value computed from number of subroutines
//                      (see calcCFFSubroutineBias() and parseCFFCharstring())
//    _defaultWidthX   default widths for CFF characters
//    _nominalWidthX   bias added to width embedded within glyph description
//
//    _privateDict     saved copy of parsed Private DICT from Top DICT
function gatherCFFTopDicts(data, start, cffIndex, strings) {
    var topDictArray = [];
    for (var iTopDict = 0; iTopDict < cffIndex.length; iTopDict += 1) {
        var topDictData = new DataView(new Uint8Array(cffIndex[iTopDict]).buffer);
        var topDict = parseCFFTopDict(topDictData, strings);
        topDict._subrs = [];
        topDict._subrsBias = 0;
        topDict._defaultWidthX = 0;
        topDict._nominalWidthX = 0;
        var privateSize = topDict.private[0];
        var privateOffset = topDict.private[1];
        if (privateSize !== 0 && privateOffset !== 0) {
            var privateDict = parseCFFPrivateDict(data, privateOffset + start, privateSize, strings);
            topDict._defaultWidthX = privateDict.defaultWidthX;
            topDict._nominalWidthX = privateDict.nominalWidthX;
            if (privateDict.subrs !== 0) {
                var subrOffset = privateOffset + privateDict.subrs;
                var subrIndex = parseCFFIndex(data, subrOffset + start);
                topDict._subrs = subrIndex.objects;
                topDict._subrsBias = calcCFFSubroutineBias(topDict._subrs);
            }
            topDict._privateDict = privateDict;
        }
        topDictArray.push(topDict);
    }
    return topDictArray;
}

// Parse the CFF charset table, which contains internal names for all the glyphs.
// This function will return a list of glyph names.
// See Adobe TN #5176 chapter 13, "Charsets".
function parseCFFCharset(data, start, nGlyphs, strings) {
    var sid;
    var count;
    var parser = new parse.Parser(data, start);

    // The .notdef glyph is not included, so subtract 1.
    nGlyphs -= 1;
    var charset = ['.notdef'];

    var format = parser.parseCard8();
    if (format === 0) {
        for (var i = 0; i < nGlyphs; i += 1) {
            sid = parser.parseSID();
            charset.push(getCFFString(strings, sid));
        }
    } else if (format === 1) {
        while (charset.length <= nGlyphs) {
            sid = parser.parseSID();
            count = parser.parseCard8();
            for (var i$1 = 0; i$1 <= count; i$1 += 1) {
                charset.push(getCFFString(strings, sid));
                sid += 1;
            }
        }
    } else if (format === 2) {
        while (charset.length <= nGlyphs) {
            sid = parser.parseSID();
            count = parser.parseCard16();
            for (var i$2 = 0; i$2 <= count; i$2 += 1) {
                charset.push(getCFFString(strings, sid));
                sid += 1;
            }
        }
    } else {
        throw new Error('Unknown charset format ' + format);
    }

    return charset;
}

// Parse the CFF encoding data. Only one encoding can be specified per font.
// See Adobe TN #5176 chapter 12, "Encodings".
function parseCFFEncoding(data, start, charset) {
    var code;
    var enc = {};
    var parser = new parse.Parser(data, start);
    var format = parser.parseCard8();
    if (format === 0) {
        var nCodes = parser.parseCard8();
        for (var i = 0; i < nCodes; i += 1) {
            code = parser.parseCard8();
            enc[code] = i;
        }
    } else if (format === 1) {
        var nRanges = parser.parseCard8();
        code = 1;
        for (var i$1 = 0; i$1 < nRanges; i$1 += 1) {
            var first = parser.parseCard8();
            var nLeft = parser.parseCard8();
            for (var j = first; j <= first + nLeft; j += 1) {
                enc[j] = code;
                code += 1;
            }
        }
    } else {
        throw new Error('Unknown encoding format ' + format);
    }

    return new CffEncoding(enc, charset);
}

// Take in charstring code and return a Glyph object.
// The encoding is described in the Type 2 Charstring Format
// https://www.microsoft.com/typography/OTSPEC/charstr2.htm
function parseCFFCharstring(font, glyph, code) {
    var c1x;
    var c1y;
    var c2x;
    var c2y;
    var p = new Path();
    var stack = [];
    var nStems = 0;
    var haveWidth = false;
    var open = false;
    var x = 0;
    var y = 0;
    var subrs;
    var subrsBias;
    var defaultWidthX;
    var nominalWidthX;
    if (font.isCIDFont) {
        var fdIndex = font.tables.cff.topDict._fdSelect[glyph.index];
        var fdDict = font.tables.cff.topDict._fdArray[fdIndex];
        subrs = fdDict._subrs;
        subrsBias = fdDict._subrsBias;
        defaultWidthX = fdDict._defaultWidthX;
        nominalWidthX = fdDict._nominalWidthX;
    } else {
        subrs = font.tables.cff.topDict._subrs;
        subrsBias = font.tables.cff.topDict._subrsBias;
        defaultWidthX = font.tables.cff.topDict._defaultWidthX;
        nominalWidthX = font.tables.cff.topDict._nominalWidthX;
    }
    var width = defaultWidthX;

    function newContour(x, y) {
        if (open) {
            p.closePath();
        }

        p.moveTo(x, y);
        open = true;
    }

    function parseStems() {
        var hasWidthArg;

        // The number of stem operators on the stack is always even.
        // If the value is uneven, that means a width is specified.
        hasWidthArg = stack.length % 2 !== 0;
        if (hasWidthArg && !haveWidth) {
            width = stack.shift() + nominalWidthX;
        }

        nStems += stack.length >> 1;
        stack.length = 0;
        haveWidth = true;
    }

    function parse(code) {
        var b1;
        var b2;
        var b3;
        var b4;
        var codeIndex;
        var subrCode;
        var jpx;
        var jpy;
        var c3x;
        var c3y;
        var c4x;
        var c4y;

        var i = 0;
        while (i < code.length) {
            var v = code[i];
            i += 1;
            switch (v) {
                case 1: // hstem
                    parseStems();
                    break;
                case 3: // vstem
                    parseStems();
                    break;
                case 4: // vmoveto
                    if (stack.length > 1 && !haveWidth) {
                        width = stack.shift() + nominalWidthX;
                        haveWidth = true;
                    }

                    y += stack.pop();
                    newContour(x, y);
                    break;
                case 5: // rlineto
                    while (stack.length > 0) {
                        x += stack.shift();
                        y += stack.shift();
                        p.lineTo(x, y);
                    }

                    break;
                case 6: // hlineto
                    while (stack.length > 0) {
                        x += stack.shift();
                        p.lineTo(x, y);
                        if (stack.length === 0) {
                            break;
                        }

                        y += stack.shift();
                        p.lineTo(x, y);
                    }

                    break;
                case 7: // vlineto
                    while (stack.length > 0) {
                        y += stack.shift();
                        p.lineTo(x, y);
                        if (stack.length === 0) {
                            break;
                        }

                        x += stack.shift();
                        p.lineTo(x, y);
                    }

                    break;
                case 8: // rrcurveto
                    while (stack.length > 0) {
                        c1x = x + stack.shift();
                        c1y = y + stack.shift();
                        c2x = c1x + stack.shift();
                        c2y = c1y + stack.shift();
                        x = c2x + stack.shift();
                        y = c2y + stack.shift();
                        p.curveTo(c1x, c1y, c2x, c2y, x, y);
                    }

                    break;
                case 10: // callsubr
                    codeIndex = stack.pop() + subrsBias;
                    subrCode = subrs[codeIndex];
                    if (subrCode) {
                        parse(subrCode);
                    }

                    break;
                case 11: // return
                    return;
                case 12: // flex operators
                    v = code[i];
                    i += 1;
                    switch (v) {
                        case 35: // flex
                            // |- dx1 dy1 dx2 dy2 dx3 dy3 dx4 dy4 dx5 dy5 dx6 dy6 fd flex (12 35) |-
                            c1x = x   + stack.shift();    // dx1
                            c1y = y   + stack.shift();    // dy1
                            c2x = c1x + stack.shift();    // dx2
                            c2y = c1y + stack.shift();    // dy2
                            jpx = c2x + stack.shift();    // dx3
                            jpy = c2y + stack.shift();    // dy3
                            c3x = jpx + stack.shift();    // dx4
                            c3y = jpy + stack.shift();    // dy4
                            c4x = c3x + stack.shift();    // dx5
                            c4y = c3y + stack.shift();    // dy5
                            x = c4x   + stack.shift();    // dx6
                            y = c4y   + stack.shift();    // dy6
                            stack.shift();                // flex depth
                            p.curveTo(c1x, c1y, c2x, c2y, jpx, jpy);
                            p.curveTo(c3x, c3y, c4x, c4y, x, y);
                            break;
                        case 34: // hflex
                            // |- dx1 dx2 dy2 dx3 dx4 dx5 dx6 hflex (12 34) |-
                            c1x = x   + stack.shift();    // dx1
                            c1y = y;                      // dy1
                            c2x = c1x + stack.shift();    // dx2
                            c2y = c1y + stack.shift();    // dy2
                            jpx = c2x + stack.shift();    // dx3
                            jpy = c2y;                    // dy3
                            c3x = jpx + stack.shift();    // dx4
                            c3y = c2y;                    // dy4
                            c4x = c3x + stack.shift();    // dx5
                            c4y = y;                      // dy5
                            x = c4x + stack.shift();      // dx6
                            p.curveTo(c1x, c1y, c2x, c2y, jpx, jpy);
                            p.curveTo(c3x, c3y, c4x, c4y, x, y);
                            break;
                        case 36: // hflex1
                            // |- dx1 dy1 dx2 dy2 dx3 dx4 dx5 dy5 dx6 hflex1 (12 36) |-
                            c1x = x   + stack.shift();    // dx1
                            c1y = y   + stack.shift();    // dy1
                            c2x = c1x + stack.shift();    // dx2
                            c2y = c1y + stack.shift();    // dy2
                            jpx = c2x + stack.shift();    // dx3
                            jpy = c2y;                    // dy3
                            c3x = jpx + stack.shift();    // dx4
                            c3y = c2y;                    // dy4
                            c4x = c3x + stack.shift();    // dx5
                            c4y = c3y + stack.shift();    // dy5
                            x = c4x + stack.shift();      // dx6
                            p.curveTo(c1x, c1y, c2x, c2y, jpx, jpy);
                            p.curveTo(c3x, c3y, c4x, c4y, x, y);
                            break;
                        case 37: // flex1
                            // |- dx1 dy1 dx2 dy2 dx3 dy3 dx4 dy4 dx5 dy5 d6 flex1 (12 37) |-
                            c1x = x   + stack.shift();    // dx1
                            c1y = y   + stack.shift();    // dy1
                            c2x = c1x + stack.shift();    // dx2
                            c2y = c1y + stack.shift();    // dy2
                            jpx = c2x + stack.shift();    // dx3
                            jpy = c2y + stack.shift();    // dy3
                            c3x = jpx + stack.shift();    // dx4
                            c3y = jpy + stack.shift();    // dy4
                            c4x = c3x + stack.shift();    // dx5
                            c4y = c3y + stack.shift();    // dy5
                            if (Math.abs(c4x - x) > Math.abs(c4y - y)) {
                                x = c4x + stack.shift();
                            } else {
                                y = c4y + stack.shift();
                            }

                            p.curveTo(c1x, c1y, c2x, c2y, jpx, jpy);
                            p.curveTo(c3x, c3y, c4x, c4y, x, y);
                            break;
                        default:
                            console.log('Glyph ' + glyph.index + ': unknown operator ' + 1200 + v);
                            stack.length = 0;
                    }
                    break;
                case 14: // endchar
                    if (stack.length > 0 && !haveWidth) {
                        width = stack.shift() + nominalWidthX;
                        haveWidth = true;
                    }

                    if (open) {
                        p.closePath();
                        open = false;
                    }

                    break;
                case 18: // hstemhm
                    parseStems();
                    break;
                case 19: // hintmask
                case 20: // cntrmask
                    parseStems();
                    i += (nStems + 7) >> 3;
                    break;
                case 21: // rmoveto
                    if (stack.length > 2 && !haveWidth) {
                        width = stack.shift() + nominalWidthX;
                        haveWidth = true;
                    }

                    y += stack.pop();
                    x += stack.pop();
                    newContour(x, y);
                    break;
                case 22: // hmoveto
                    if (stack.length > 1 && !haveWidth) {
                        width = stack.shift() + nominalWidthX;
                        haveWidth = true;
                    }

                    x += stack.pop();
                    newContour(x, y);
                    break;
                case 23: // vstemhm
                    parseStems();
                    break;
                case 24: // rcurveline
                    while (stack.length > 2) {
                        c1x = x + stack.shift();
                        c1y = y + stack.shift();
                        c2x = c1x + stack.shift();
                        c2y = c1y + stack.shift();
                        x = c2x + stack.shift();
                        y = c2y + stack.shift();
                        p.curveTo(c1x, c1y, c2x, c2y, x, y);
                    }

                    x += stack.shift();
                    y += stack.shift();
                    p.lineTo(x, y);
                    break;
                case 25: // rlinecurve
                    while (stack.length > 6) {
                        x += stack.shift();
                        y += stack.shift();
                        p.lineTo(x, y);
                    }

                    c1x = x + stack.shift();
                    c1y = y + stack.shift();
                    c2x = c1x + stack.shift();
                    c2y = c1y + stack.shift();
                    x = c2x + stack.shift();
                    y = c2y + stack.shift();
                    p.curveTo(c1x, c1y, c2x, c2y, x, y);
                    break;
                case 26: // vvcurveto
                    if (stack.length % 2) {
                        x += stack.shift();
                    }

                    while (stack.length > 0) {
                        c1x = x;
                        c1y = y + stack.shift();
                        c2x = c1x + stack.shift();
                        c2y = c1y + stack.shift();
                        x = c2x;
                        y = c2y + stack.shift();
                        p.curveTo(c1x, c1y, c2x, c2y, x, y);
                    }

                    break;
                case 27: // hhcurveto
                    if (stack.length % 2) {
                        y += stack.shift();
                    }

                    while (stack.length > 0) {
                        c1x = x + stack.shift();
                        c1y = y;
                        c2x = c1x + stack.shift();
                        c2y = c1y + stack.shift();
                        x = c2x + stack.shift();
                        y = c2y;
                        p.curveTo(c1x, c1y, c2x, c2y, x, y);
                    }

                    break;
                case 28: // shortint
                    b1 = code[i];
                    b2 = code[i + 1];
                    stack.push(((b1 << 24) | (b2 << 16)) >> 16);
                    i += 2;
                    break;
                case 29: // callgsubr
                    codeIndex = stack.pop() + font.gsubrsBias;
                    subrCode = font.gsubrs[codeIndex];
                    if (subrCode) {
                        parse(subrCode);
                    }

                    break;
                case 30: // vhcurveto
                    while (stack.length > 0) {
                        c1x = x;
                        c1y = y + stack.shift();
                        c2x = c1x + stack.shift();
                        c2y = c1y + stack.shift();
                        x = c2x + stack.shift();
                        y = c2y + (stack.length === 1 ? stack.shift() : 0);
                        p.curveTo(c1x, c1y, c2x, c2y, x, y);
                        if (stack.length === 0) {
                            break;
                        }

                        c1x = x + stack.shift();
                        c1y = y;
                        c2x = c1x + stack.shift();
                        c2y = c1y + stack.shift();
                        y = c2y + stack.shift();
                        x = c2x + (stack.length === 1 ? stack.shift() : 0);
                        p.curveTo(c1x, c1y, c2x, c2y, x, y);
                    }

                    break;
                case 31: // hvcurveto
                    while (stack.length > 0) {
                        c1x = x + stack.shift();
                        c1y = y;
                        c2x = c1x + stack.shift();
                        c2y = c1y + stack.shift();
                        y = c2y + stack.shift();
                        x = c2x + (stack.length === 1 ? stack.shift() : 0);
                        p.curveTo(c1x, c1y, c2x, c2y, x, y);
                        if (stack.length === 0) {
                            break;
                        }

                        c1x = x;
                        c1y = y + stack.shift();
                        c2x = c1x + stack.shift();
                        c2y = c1y + stack.shift();
                        x = c2x + stack.shift();
                        y = c2y + (stack.length === 1 ? stack.shift() : 0);
                        p.curveTo(c1x, c1y, c2x, c2y, x, y);
                    }

                    break;
                default:
                    if (v < 32) {
                        console.log('Glyph ' + glyph.index + ': unknown operator ' + v);
                    } else if (v < 247) {
                        stack.push(v - 139);
                    } else if (v < 251) {
                        b1 = code[i];
                        i += 1;
                        stack.push((v - 247) * 256 + b1 + 108);
                    } else if (v < 255) {
                        b1 = code[i];
                        i += 1;
                        stack.push(-(v - 251) * 256 - b1 - 108);
                    } else {
                        b1 = code[i];
                        b2 = code[i + 1];
                        b3 = code[i + 2];
                        b4 = code[i + 3];
                        i += 4;
                        stack.push(((b1 << 24) | (b2 << 16) | (b3 << 8) | b4) / 65536);
                    }
            }
        }
    }

    parse(code);

    glyph.advanceWidth = width;
    return p;
}

function parseCFFFDSelect(data, start, nGlyphs, fdArrayCount) {
    var fdSelect = [];
    var fdIndex;
    var parser = new parse.Parser(data, start);
    var format = parser.parseCard8();
    if (format === 0) {
        // Simple list of nGlyphs elements
        for (var iGid = 0; iGid < nGlyphs; iGid++) {
            fdIndex = parser.parseCard8();
            if (fdIndex >= fdArrayCount) {
                throw new Error('CFF table CID Font FDSelect has bad FD index value ' + fdIndex + ' (FD count ' + fdArrayCount + ')');
            }
            fdSelect.push(fdIndex);
        }
    } else if (format === 3) {
        // Ranges
        var nRanges = parser.parseCard16();
        var first = parser.parseCard16();
        if (first !== 0) {
            throw new Error('CFF Table CID Font FDSelect format 3 range has bad initial GID ' + first);
        }
        var next;
        for (var iRange = 0; iRange < nRanges; iRange++) {
            fdIndex = parser.parseCard8();
            next = parser.parseCard16();
            if (fdIndex >= fdArrayCount) {
                throw new Error('CFF table CID Font FDSelect has bad FD index value ' + fdIndex + ' (FD count ' + fdArrayCount + ')');
            }
            if (next > nGlyphs) {
                throw new Error('CFF Table CID Font FDSelect format 3 range has bad GID ' + next);
            }
            for (; first < next; first++) {
                fdSelect.push(fdIndex);
            }
            first = next;
        }
        if (next !== nGlyphs) {
            throw new Error('CFF Table CID Font FDSelect format 3 range has bad final GID ' + next);
        }
    } else {
        throw new Error('CFF Table CID Font FDSelect table has unsupported format ' + format);
    }
    return fdSelect;
}

// Parse the `CFF` table, which contains the glyph outlines in PostScript format.
function parseCFFTable(data, start, font, opt) {
    font.tables.cff = {};
    var header = parseCFFHeader(data, start);
    var nameIndex = parseCFFIndex(data, header.endOffset, parse.bytesToString);
    var topDictIndex = parseCFFIndex(data, nameIndex.endOffset);
    var stringIndex = parseCFFIndex(data, topDictIndex.endOffset, parse.bytesToString);
    var globalSubrIndex = parseCFFIndex(data, stringIndex.endOffset);
    font.gsubrs = globalSubrIndex.objects;
    font.gsubrsBias = calcCFFSubroutineBias(font.gsubrs);

    var topDictArray = gatherCFFTopDicts(data, start, topDictIndex.objects, stringIndex.objects);
    if (topDictArray.length !== 1) {
        throw new Error('CFF table has too many fonts in \'FontSet\' - count of fonts NameIndex.length = ' + topDictArray.length);
    }

    var topDict = topDictArray[0];
    font.tables.cff.topDict = topDict;

    if (topDict._privateDict) {
        font.defaultWidthX = topDict._privateDict.defaultWidthX;
        font.nominalWidthX = topDict._privateDict.nominalWidthX;
    }

    if (topDict.ros[0] !== undefined && topDict.ros[1] !== undefined) {
        font.isCIDFont = true;
    }

    if (font.isCIDFont) {
        var fdArrayOffset = topDict.fdArray;
        var fdSelectOffset = topDict.fdSelect;
        if (fdArrayOffset === 0 || fdSelectOffset === 0) {
            throw new Error('Font is marked as a CID font, but FDArray and/or FDSelect information is missing');
        }
        fdArrayOffset += start;
        var fdArrayIndex = parseCFFIndex(data, fdArrayOffset);
        var fdArray = gatherCFFTopDicts(data, start, fdArrayIndex.objects, stringIndex.objects);
        topDict._fdArray = fdArray;
        fdSelectOffset += start;
        topDict._fdSelect = parseCFFFDSelect(data, fdSelectOffset, font.numGlyphs, fdArray.length);
    }

    var privateDictOffset = start + topDict.private[1];
    var privateDict = parseCFFPrivateDict(data, privateDictOffset, topDict.private[0], stringIndex.objects);
    font.defaultWidthX = privateDict.defaultWidthX;
    font.nominalWidthX = privateDict.nominalWidthX;

    if (privateDict.subrs !== 0) {
        var subrOffset = privateDictOffset + privateDict.subrs;
        var subrIndex = parseCFFIndex(data, subrOffset);
        font.subrs = subrIndex.objects;
        font.subrsBias = calcCFFSubroutineBias(font.subrs);
    } else {
        font.subrs = [];
        font.subrsBias = 0;
    }

    // Offsets in the top dict are relative to the beginning of the CFF data, so add the CFF start offset.
    var charStringsIndex;
    if (opt.lowMemory) {
        charStringsIndex = parseCFFIndexLowMemory(data, start + topDict.charStrings);
        font.nGlyphs = charStringsIndex.offsets.length;
    } else {
        charStringsIndex = parseCFFIndex(data, start + topDict.charStrings);
        font.nGlyphs = charStringsIndex.objects.length;
    }

    var charset = parseCFFCharset(data, start + topDict.charset, font.nGlyphs, stringIndex.objects);
    if (topDict.encoding === 0) {
        // Standard encoding
        font.cffEncoding = new CffEncoding(cffStandardEncoding, charset);
    } else if (topDict.encoding === 1) {
        // Expert encoding
        font.cffEncoding = new CffEncoding(cffExpertEncoding, charset);
    } else {
        font.cffEncoding = parseCFFEncoding(data, start + topDict.encoding, charset);
    }

    // Prefer the CMAP encoding to the CFF encoding.
    font.encoding = font.encoding || font.cffEncoding;

    font.glyphs = new glyphset.GlyphSet(font);
    if (opt.lowMemory) {
        font._push = function(i) {
            var charString = getCffIndexObject(i, charStringsIndex.offsets, data, start + topDict.charStrings);
            font.glyphs.push(i, glyphset.cffGlyphLoader(font, i, parseCFFCharstring, charString));
        };
    } else {
        for (var i = 0; i < font.nGlyphs; i += 1) {
            var charString = charStringsIndex.objects[i];
            font.glyphs.push(i, glyphset.cffGlyphLoader(font, i, parseCFFCharstring, charString));
        }
    }
}

// Convert a string to a String ID (SID).
// The list of strings is modified in place.
function encodeString(s, strings) {
    var sid;

    // Is the string in the CFF standard strings?
    var i = cffStandardStrings.indexOf(s);
    if (i >= 0) {
        sid = i;
    }

    // Is the string already in the string index?
    i = strings.indexOf(s);
    if (i >= 0) {
        sid = i + cffStandardStrings.length;
    } else {
        sid = cffStandardStrings.length + strings.length;
        strings.push(s);
    }

    return sid;
}

function makeHeader() {
    return new table.Record('Header', [
        {name: 'major', type: 'Card8', value: 1},
        {name: 'minor', type: 'Card8', value: 0},
        {name: 'hdrSize', type: 'Card8', value: 4},
        {name: 'major', type: 'Card8', value: 1}
    ]);
}

function makeNameIndex(fontNames) {
    var t = new table.Record('Name INDEX', [
        {name: 'names', type: 'INDEX', value: []}
    ]);
    t.names = [];
    for (var i = 0; i < fontNames.length; i += 1) {
        t.names.push({name: 'name_' + i, type: 'NAME', value: fontNames[i]});
    }

    return t;
}

// Given a dictionary's metadata, create a DICT structure.
function makeDict(meta, attrs, strings) {
    var m = {};
    for (var i = 0; i < meta.length; i += 1) {
        var entry = meta[i];
        var value = attrs[entry.name];
        if (value !== undefined && !equals(value, entry.value)) {
            if (entry.type === 'SID') {
                value = encodeString(value, strings);
            }

            m[entry.op] = {name: entry.name, type: entry.type, value: value};
        }
    }

    return m;
}

// The Top DICT houses the global font attributes.
function makeTopDict(attrs, strings) {
    var t = new table.Record('Top DICT', [
        {name: 'dict', type: 'DICT', value: {}}
    ]);
    t.dict = makeDict(TOP_DICT_META, attrs, strings);
    return t;
}

function makeTopDictIndex(topDict) {
    var t = new table.Record('Top DICT INDEX', [
        {name: 'topDicts', type: 'INDEX', value: []}
    ]);
    t.topDicts = [{name: 'topDict_0', type: 'TABLE', value: topDict}];
    return t;
}

function makeStringIndex(strings) {
    var t = new table.Record('String INDEX', [
        {name: 'strings', type: 'INDEX', value: []}
    ]);
    t.strings = [];
    for (var i = 0; i < strings.length; i += 1) {
        t.strings.push({name: 'string_' + i, type: 'STRING', value: strings[i]});
    }

    return t;
}

function makeGlobalSubrIndex() {
    // Currently we don't use subroutines.
    return new table.Record('Global Subr INDEX', [
        {name: 'subrs', type: 'INDEX', value: []}
    ]);
}

function makeCharsets(glyphNames, strings) {
    var t = new table.Record('Charsets', [
        {name: 'format', type: 'Card8', value: 0}
    ]);
    for (var i = 0; i < glyphNames.length; i += 1) {
        var glyphName = glyphNames[i];
        var glyphSID = encodeString(glyphName, strings);
        t.fields.push({name: 'glyph_' + i, type: 'SID', value: glyphSID});
    }

    return t;
}

function glyphToOps(glyph) {
    var ops = [];
    var path = glyph.path;
    ops.push({name: 'width', type: 'NUMBER', value: glyph.advanceWidth});
    var x = 0;
    var y = 0;
    for (var i = 0; i < path.commands.length; i += 1) {
        var dx = (void 0);
        var dy = (void 0);
        var cmd = path.commands[i];
        if (cmd.type === 'Q') {
            // CFF only supports bézier curves, so convert the quad to a bézier.
            var _13 = 1 / 3;
            var _23 = 2 / 3;

            // We're going to create a new command so we don't change the original path.
            // Since all coordinates are relative, we round() them ASAP to avoid propagating errors.
            cmd = {
                type: 'C',
                x: cmd.x,
                y: cmd.y,
                x1: Math.round(_13 * x + _23 * cmd.x1),
                y1: Math.round(_13 * y + _23 * cmd.y1),
                x2: Math.round(_13 * cmd.x + _23 * cmd.x1),
                y2: Math.round(_13 * cmd.y + _23 * cmd.y1)
            };
        }

        if (cmd.type === 'M') {
            dx = Math.round(cmd.x - x);
            dy = Math.round(cmd.y - y);
            ops.push({name: 'dx', type: 'NUMBER', value: dx});
            ops.push({name: 'dy', type: 'NUMBER', value: dy});
            ops.push({name: 'rmoveto', type: 'OP', value: 21});
            x = Math.round(cmd.x);
            y = Math.round(cmd.y);
        } else if (cmd.type === 'L') {
            dx = Math.round(cmd.x - x);
            dy = Math.round(cmd.y - y);
            ops.push({name: 'dx', type: 'NUMBER', value: dx});
            ops.push({name: 'dy', type: 'NUMBER', value: dy});
            ops.push({name: 'rlineto', type: 'OP', value: 5});
            x = Math.round(cmd.x);
            y = Math.round(cmd.y);
        } else if (cmd.type === 'C') {
            var dx1 = Math.round(cmd.x1 - x);
            var dy1 = Math.round(cmd.y1 - y);
            var dx2 = Math.round(cmd.x2 - cmd.x1);
            var dy2 = Math.round(cmd.y2 - cmd.y1);
            dx = Math.round(cmd.x - cmd.x2);
            dy = Math.round(cmd.y - cmd.y2);
            ops.push({name: 'dx1', type: 'NUMBER', value: dx1});
            ops.push({name: 'dy1', type: 'NUMBER', value: dy1});
            ops.push({name: 'dx2', type: 'NUMBER', value: dx2});
            ops.push({name: 'dy2', type: 'NUMBER', value: dy2});
            ops.push({name: 'dx', type: 'NUMBER', value: dx});
            ops.push({name: 'dy', type: 'NUMBER', value: dy});
            ops.push({name: 'rrcurveto', type: 'OP', value: 8});
            x = Math.round(cmd.x);
            y = Math.round(cmd.y);
        }

        // Contours are closed automatically.
    }

    ops.push({name: 'endchar', type: 'OP', value: 14});
    return ops;
}

function makeCharStringsIndex(glyphs) {
    var t = new table.Record('CharStrings INDEX', [
        {name: 'charStrings', type: 'INDEX', value: []}
    ]);

    for (var i = 0; i < glyphs.length; i += 1) {
        var glyph = glyphs.get(i);
        var ops = glyphToOps(glyph);
        t.charStrings.push({name: glyph.name, type: 'CHARSTRING', value: ops});
    }

    return t;
}

function makePrivateDict(attrs, strings) {
    var t = new table.Record('Private DICT', [
        {name: 'dict', type: 'DICT', value: {}}
    ]);
    t.dict = makeDict(PRIVATE_DICT_META, attrs, strings);
    return t;
}

function makeCFFTable(glyphs, options) {
    var t = new table.Table('CFF ', [
        {name: 'header', type: 'RECORD'},
        {name: 'nameIndex', type: 'RECORD'},
        {name: 'topDictIndex', type: 'RECORD'},
        {name: 'stringIndex', type: 'RECORD'},
        {name: 'globalSubrIndex', type: 'RECORD'},
        {name: 'charsets', type: 'RECORD'},
        {name: 'charStringsIndex', type: 'RECORD'},
        {name: 'privateDict', type: 'RECORD'}
    ]);

    var fontScale = 1 / options.unitsPerEm;
    // We use non-zero values for the offsets so that the DICT encodes them.
    // This is important because the size of the Top DICT plays a role in offset calculation,
    // and the size shouldn't change after we've written correct offsets.
    var attrs = {
        version: options.version,
        fullName: options.fullName,
        familyName: options.familyName,
        weight: options.weightName,
        fontBBox: options.fontBBox || [0, 0, 0, 0],
        fontMatrix: [fontScale, 0, 0, fontScale, 0, 0],
        charset: 999,
        encoding: 0,
        charStrings: 999,
        private: [0, 999]
    };

    var privateAttrs = {};

    var glyphNames = [];
    var glyph;

    // Skip first glyph (.notdef)
    for (var i = 1; i < glyphs.length; i += 1) {
        glyph = glyphs.get(i);
        glyphNames.push(glyph.name);
    }

    var strings = [];

    t.header = makeHeader();
    t.nameIndex = makeNameIndex([options.postScriptName]);
    var topDict = makeTopDict(attrs, strings);
    t.topDictIndex = makeTopDictIndex(topDict);
    t.globalSubrIndex = makeGlobalSubrIndex();
    t.charsets = makeCharsets(glyphNames, strings);
    t.charStringsIndex = makeCharStringsIndex(glyphs);
    t.privateDict = makePrivateDict(privateAttrs, strings);

    // Needs to come at the end, to encode all custom strings used in the font.
    t.stringIndex = makeStringIndex(strings);

    var startOffset = t.header.sizeOf() +
        t.nameIndex.sizeOf() +
        t.topDictIndex.sizeOf() +
        t.stringIndex.sizeOf() +
        t.globalSubrIndex.sizeOf();
    attrs.charset = startOffset;

    // We use the CFF standard encoding; proper encoding will be handled in cmap.
    attrs.encoding = 0;
    attrs.charStrings = attrs.charset + t.charsets.sizeOf();
    attrs.private[1] = attrs.charStrings + t.charStringsIndex.sizeOf();

    // Recreate the Top DICT INDEX with the correct offsets.
    topDict = makeTopDict(attrs, strings);
    t.topDictIndex = makeTopDictIndex(topDict);

    return t;
}

var cff = { parse: parseCFFTable, make: makeCFFTable };

// The `head` table contains global information about the font.

// Parse the header `head` table
function parseHeadTable(data, start) {
    var head = {};
    var p = new parse.Parser(data, start);
    head.version = p.parseVersion();
    head.fontRevision = Math.round(p.parseFixed() * 1000) / 1000;
    head.checkSumAdjustment = p.parseULong();
    head.magicNumber = p.parseULong();
    check.argument(head.magicNumber === 0x5F0F3CF5, 'Font header has wrong magic number.');
    head.flags = p.parseUShort();
    head.unitsPerEm = p.parseUShort();
    head.created = p.parseLongDateTime();
    head.modified = p.parseLongDateTime();
    head.xMin = p.parseShort();
    head.yMin = p.parseShort();
    head.xMax = p.parseShort();
    head.yMax = p.parseShort();
    head.macStyle = p.parseUShort();
    head.lowestRecPPEM = p.parseUShort();
    head.fontDirectionHint = p.parseShort();
    head.indexToLocFormat = p.parseShort();
    head.glyphDataFormat = p.parseShort();
    return head;
}

function makeHeadTable(options) {
    // Apple Mac timestamp epoch is 01/01/1904 not 01/01/1970
    var timestamp = Math.round(new Date().getTime() / 1000) + 2082844800;
    var createdTimestamp = timestamp;

    if (options.createdTimestamp) {
        createdTimestamp = options.createdTimestamp + 2082844800;
    }

    return new table.Table('head', [
        {name: 'version', type: 'FIXED', value: 0x00010000},
        {name: 'fontRevision', type: 'FIXED', value: 0x00010000},
        {name: 'checkSumAdjustment', type: 'ULONG', value: 0},
        {name: 'magicNumber', type: 'ULONG', value: 0x5F0F3CF5},
        {name: 'flags', type: 'USHORT', value: 0},
        {name: 'unitsPerEm', type: 'USHORT', value: 1000},
        {name: 'created', type: 'LONGDATETIME', value: createdTimestamp},
        {name: 'modified', type: 'LONGDATETIME', value: timestamp},
        {name: 'xMin', type: 'SHORT', value: 0},
        {name: 'yMin', type: 'SHORT', value: 0},
        {name: 'xMax', type: 'SHORT', value: 0},
        {name: 'yMax', type: 'SHORT', value: 0},
        {name: 'macStyle', type: 'USHORT', value: 0},
        {name: 'lowestRecPPEM', type: 'USHORT', value: 0},
        {name: 'fontDirectionHint', type: 'SHORT', value: 2},
        {name: 'indexToLocFormat', type: 'SHORT', value: 0},
        {name: 'glyphDataFormat', type: 'SHORT', value: 0}
    ], options);
}

var head = { parse: parseHeadTable, make: makeHeadTable };

// The `hhea` table contains information for horizontal layout.

// Parse the horizontal header `hhea` table
function parseHheaTable(data, start) {
    var hhea = {};
    var p = new parse.Parser(data, start);
    hhea.version = p.parseVersion();
    hhea.ascender = p.parseShort();
    hhea.descender = p.parseShort();
    hhea.lineGap = p.parseShort();
    hhea.advanceWidthMax = p.parseUShort();
    hhea.minLeftSideBearing = p.parseShort();
    hhea.minRightSideBearing = p.parseShort();
    hhea.xMaxExtent = p.parseShort();
    hhea.caretSlopeRise = p.parseShort();
    hhea.caretSlopeRun = p.parseShort();
    hhea.caretOffset = p.parseShort();
    p.relativeOffset += 8;
    hhea.metricDataFormat = p.parseShort();
    hhea.numberOfHMetrics = p.parseUShort();
    return hhea;
}

function makeHheaTable(options) {
    return new table.Table('hhea', [
        {name: 'version', type: 'FIXED', value: 0x00010000},
        {name: 'ascender', type: 'FWORD', value: 0},
        {name: 'descender', type: 'FWORD', value: 0},
        {name: 'lineGap', type: 'FWORD', value: 0},
        {name: 'advanceWidthMax', type: 'UFWORD', value: 0},
        {name: 'minLeftSideBearing', type: 'FWORD', value: 0},
        {name: 'minRightSideBearing', type: 'FWORD', value: 0},
        {name: 'xMaxExtent', type: 'FWORD', value: 0},
        {name: 'caretSlopeRise', type: 'SHORT', value: 1},
        {name: 'caretSlopeRun', type: 'SHORT', value: 0},
        {name: 'caretOffset', type: 'SHORT', value: 0},
        {name: 'reserved1', type: 'SHORT', value: 0},
        {name: 'reserved2', type: 'SHORT', value: 0},
        {name: 'reserved3', type: 'SHORT', value: 0},
        {name: 'reserved4', type: 'SHORT', value: 0},
        {name: 'metricDataFormat', type: 'SHORT', value: 0},
        {name: 'numberOfHMetrics', type: 'USHORT', value: 0}
    ], options);
}

var hhea = { parse: parseHheaTable, make: makeHheaTable };

// The `hmtx` table contains the horizontal metrics for all glyphs.

function parseHmtxTableAll(data, start, numMetrics, numGlyphs, glyphs) {
    var advanceWidth;
    var leftSideBearing;
    var p = new parse.Parser(data, start);
    for (var i = 0; i < numGlyphs; i += 1) {
        // If the font is monospaced, only one entry is needed. This last entry applies to all subsequent glyphs.
        if (i < numMetrics) {
            advanceWidth = p.parseUShort();
            leftSideBearing = p.parseShort();
        }

        var glyph = glyphs.get(i);
        glyph.advanceWidth = advanceWidth;
        glyph.leftSideBearing = leftSideBearing;
    }
}

function parseHmtxTableOnLowMemory(font, data, start, numMetrics, numGlyphs) {
    font._hmtxTableData = {};

    var advanceWidth;
    var leftSideBearing;
    var p = new parse.Parser(data, start);
    for (var i = 0; i < numGlyphs; i += 1) {
        // If the font is monospaced, only one entry is needed. This last entry applies to all subsequent glyphs.
        if (i < numMetrics) {
            advanceWidth = p.parseUShort();
            leftSideBearing = p.parseShort();
        }

        font._hmtxTableData[i] = {
            advanceWidth: advanceWidth,
            leftSideBearing: leftSideBearing
        };
    }
}

// Parse the `hmtx` table, which contains the horizontal metrics for all glyphs.
// This function augments the glyph array, adding the advanceWidth and leftSideBearing to each glyph.
function parseHmtxTable(font, data, start, numMetrics, numGlyphs, glyphs, opt) {
    if (opt.lowMemory)
        { parseHmtxTableOnLowMemory(font, data, start, numMetrics, numGlyphs); }
    else
        { parseHmtxTableAll(data, start, numMetrics, numGlyphs, glyphs); }
}

function makeHmtxTable(glyphs) {
    var t = new table.Table('hmtx', []);
    for (var i = 0; i < glyphs.length; i += 1) {
        var glyph = glyphs.get(i);
        var advanceWidth = glyph.advanceWidth || 0;
        var leftSideBearing = glyph.leftSideBearing || 0;
        t.fields.push({name: 'advanceWidth_' + i, type: 'USHORT', value: advanceWidth});
        t.fields.push({name: 'leftSideBearing_' + i, type: 'SHORT', value: leftSideBearing});
    }

    return t;
}

var hmtx = { parse: parseHmtxTable, make: makeHmtxTable };

// The `ltag` table stores IETF BCP-47 language tags. It allows supporting

function makeLtagTable(tags) {
    var result = new table.Table('ltag', [
        {name: 'version', type: 'ULONG', value: 1},
        {name: 'flags', type: 'ULONG', value: 0},
        {name: 'numTags', type: 'ULONG', value: tags.length}
    ]);

    var stringPool = '';
    var stringPoolOffset = 12 + tags.length * 4;
    for (var i = 0; i < tags.length; ++i) {
        var pos = stringPool.indexOf(tags[i]);
        if (pos < 0) {
            pos = stringPool.length;
            stringPool += tags[i];
        }

        result.fields.push({name: 'offset ' + i, type: 'USHORT', value: stringPoolOffset + pos});
        result.fields.push({name: 'length ' + i, type: 'USHORT', value: tags[i].length});
    }

    result.fields.push({name: 'stringPool', type: 'CHARARRAY', value: stringPool});
    return result;
}

function parseLtagTable(data, start) {
    var p = new parse.Parser(data, start);
    var tableVersion = p.parseULong();
    check.argument(tableVersion === 1, 'Unsupported ltag table version.');
    // The 'ltag' specification does not define any flags; skip the field.
    p.skip('uLong', 1);
    var numTags = p.parseULong();

    var tags = [];
    for (var i = 0; i < numTags; i++) {
        var tag = '';
        var offset = start + p.parseUShort();
        var length = p.parseUShort();
        for (var j = offset; j < offset + length; ++j) {
            tag += String.fromCharCode(data.getInt8(j));
        }

        tags.push(tag);
    }

    return tags;
}

var ltag = { make: makeLtagTable, parse: parseLtagTable };

// The `maxp` table establishes the memory requirements for the font.

// Parse the maximum profile `maxp` table.
function parseMaxpTable(data, start) {
    var maxp = {};
    var p = new parse.Parser(data, start);
    maxp.version = p.parseVersion();
    maxp.numGlyphs = p.parseUShort();
    if (maxp.version === 1.0) {
        maxp.maxPoints = p.parseUShort();
        maxp.maxContours = p.parseUShort();
        maxp.maxCompositePoints = p.parseUShort();
        maxp.maxCompositeContours = p.parseUShort();
        maxp.maxZones = p.parseUShort();
        maxp.maxTwilightPoints = p.parseUShort();
        maxp.maxStorage = p.parseUShort();
        maxp.maxFunctionDefs = p.parseUShort();
        maxp.maxInstructionDefs = p.parseUShort();
        maxp.maxStackElements = p.parseUShort();
        maxp.maxSizeOfInstructions = p.parseUShort();
        maxp.maxComponentElements = p.parseUShort();
        maxp.maxComponentDepth = p.parseUShort();
    }

    return maxp;
}

function makeMaxpTable(numGlyphs) {
    return new table.Table('maxp', [
        {name: 'version', type: 'FIXED', value: 0x00005000},
        {name: 'numGlyphs', type: 'USHORT', value: numGlyphs}
    ]);
}

var maxp = { parse: parseMaxpTable, make: makeMaxpTable };

// The `name` naming table.

// NameIDs for the name table.
var nameTableNames = [
    'copyright',              // 0
    'fontFamily',             // 1
    'fontSubfamily',          // 2
    'uniqueID',               // 3
    'fullName',               // 4
    'version',                // 5
    'postScriptName',         // 6
    'trademark',              // 7
    'manufacturer',           // 8
    'designer',               // 9
    'description',            // 10
    'manufacturerURL',        // 11
    'designerURL',            // 12
    'license',                // 13
    'licenseURL',             // 14
    'reserved',               // 15
    'preferredFamily',        // 16
    'preferredSubfamily',     // 17
    'compatibleFullName',     // 18
    'sampleText',             // 19
    'postScriptFindFontName', // 20
    'wwsFamily',              // 21
    'wwsSubfamily'            // 22
];

var macLanguages = {
    0: 'en',
    1: 'fr',
    2: 'de',
    3: 'it',
    4: 'nl',
    5: 'sv',
    6: 'es',
    7: 'da',
    8: 'pt',
    9: 'no',
    10: 'he',
    11: 'ja',
    12: 'ar',
    13: 'fi',
    14: 'el',
    15: 'is',
    16: 'mt',
    17: 'tr',
    18: 'hr',
    19: 'zh-Hant',
    20: 'ur',
    21: 'hi',
    22: 'th',
    23: 'ko',
    24: 'lt',
    25: 'pl',
    26: 'hu',
    27: 'es',
    28: 'lv',
    29: 'se',
    30: 'fo',
    31: 'fa',
    32: 'ru',
    33: 'zh',
    34: 'nl-BE',
    35: 'ga',
    36: 'sq',
    37: 'ro',
    38: 'cz',
    39: 'sk',
    40: 'si',
    41: 'yi',
    42: 'sr',
    43: 'mk',
    44: 'bg',
    45: 'uk',
    46: 'be',
    47: 'uz',
    48: 'kk',
    49: 'az-Cyrl',
    50: 'az-Arab',
    51: 'hy',
    52: 'ka',
    53: 'mo',
    54: 'ky',
    55: 'tg',
    56: 'tk',
    57: 'mn-CN',
    58: 'mn',
    59: 'ps',
    60: 'ks',
    61: 'ku',
    62: 'sd',
    63: 'bo',
    64: 'ne',
    65: 'sa',
    66: 'mr',
    67: 'bn',
    68: 'as',
    69: 'gu',
    70: 'pa',
    71: 'or',
    72: 'ml',
    73: 'kn',
    74: 'ta',
    75: 'te',
    76: 'si',
    77: 'my',
    78: 'km',
    79: 'lo',
    80: 'vi',
    81: 'id',
    82: 'tl',
    83: 'ms',
    84: 'ms-Arab',
    85: 'am',
    86: 'ti',
    87: 'om',
    88: 'so',
    89: 'sw',
    90: 'rw',
    91: 'rn',
    92: 'ny',
    93: 'mg',
    94: 'eo',
    128: 'cy',
    129: 'eu',
    130: 'ca',
    131: 'la',
    132: 'qu',
    133: 'gn',
    134: 'ay',
    135: 'tt',
    136: 'ug',
    137: 'dz',
    138: 'jv',
    139: 'su',
    140: 'gl',
    141: 'af',
    142: 'br',
    143: 'iu',
    144: 'gd',
    145: 'gv',
    146: 'ga',
    147: 'to',
    148: 'el-polyton',
    149: 'kl',
    150: 'az',
    151: 'nn'
};

// MacOS language ID → MacOS script ID
//
// Note that the script ID is not sufficient to determine what encoding
// to use in TrueType files. For some languages, MacOS used a modification
// of a mainstream script. For example, an Icelandic name would be stored
// with smRoman in the TrueType naming table, but the actual encoding
// is a special Icelandic version of the normal Macintosh Roman encoding.
// As another example, Inuktitut uses an 8-bit encoding for Canadian Aboriginal
// Syllables but MacOS had run out of available script codes, so this was
// done as a (pretty radical) "modification" of Ethiopic.
//
// http://unicode.org/Public/MAPPINGS/VENDORS/APPLE/Readme.txt
var macLanguageToScript = {
    0: 0,  // langEnglish → smRoman
    1: 0,  // langFrench → smRoman
    2: 0,  // langGerman → smRoman
    3: 0,  // langItalian → smRoman
    4: 0,  // langDutch → smRoman
    5: 0,  // langSwedish → smRoman
    6: 0,  // langSpanish → smRoman
    7: 0,  // langDanish → smRoman
    8: 0,  // langPortuguese → smRoman
    9: 0,  // langNorwegian → smRoman
    10: 5,  // langHebrew → smHebrew
    11: 1,  // langJapanese → smJapanese
    12: 4,  // langArabic → smArabic
    13: 0,  // langFinnish → smRoman
    14: 6,  // langGreek → smGreek
    15: 0,  // langIcelandic → smRoman (modified)
    16: 0,  // langMaltese → smRoman
    17: 0,  // langTurkish → smRoman (modified)
    18: 0,  // langCroatian → smRoman (modified)
    19: 2,  // langTradChinese → smTradChinese
    20: 4,  // langUrdu → smArabic
    21: 9,  // langHindi → smDevanagari
    22: 21,  // langThai → smThai
    23: 3,  // langKorean → smKorean
    24: 29,  // langLithuanian → smCentralEuroRoman
    25: 29,  // langPolish → smCentralEuroRoman
    26: 29,  // langHungarian → smCentralEuroRoman
    27: 29,  // langEstonian → smCentralEuroRoman
    28: 29,  // langLatvian → smCentralEuroRoman
    29: 0,  // langSami → smRoman
    30: 0,  // langFaroese → smRoman (modified)
    31: 4,  // langFarsi → smArabic (modified)
    32: 7,  // langRussian → smCyrillic
    33: 25,  // langSimpChinese → smSimpChinese
    34: 0,  // langFlemish → smRoman
    35: 0,  // langIrishGaelic → smRoman (modified)
    36: 0,  // langAlbanian → smRoman
    37: 0,  // langRomanian → smRoman (modified)
    38: 29,  // langCzech → smCentralEuroRoman
    39: 29,  // langSlovak → smCentralEuroRoman
    40: 0,  // langSlovenian → smRoman (modified)
    41: 5,  // langYiddish → smHebrew
    42: 7,  // langSerbian → smCyrillic
    43: 7,  // langMacedonian → smCyrillic
    44: 7,  // langBulgarian → smCyrillic
    45: 7,  // langUkrainian → smCyrillic (modified)
    46: 7,  // langByelorussian → smCyrillic
    47: 7,  // langUzbek → smCyrillic
    48: 7,  // langKazakh → smCyrillic
    49: 7,  // langAzerbaijani → smCyrillic
    50: 4,  // langAzerbaijanAr → smArabic
    51: 24,  // langArmenian → smArmenian
    52: 23,  // langGeorgian → smGeorgian
    53: 7,  // langMoldavian → smCyrillic
    54: 7,  // langKirghiz → smCyrillic
    55: 7,  // langTajiki → smCyrillic
    56: 7,  // langTurkmen → smCyrillic
    57: 27,  // langMongolian → smMongolian
    58: 7,  // langMongolianCyr → smCyrillic
    59: 4,  // langPashto → smArabic
    60: 4,  // langKurdish → smArabic
    61: 4,  // langKashmiri → smArabic
    62: 4,  // langSindhi → smArabic
    63: 26,  // langTibetan → smTibetan
    64: 9,  // langNepali → smDevanagari
    65: 9,  // langSanskrit → smDevanagari
    66: 9,  // langMarathi → smDevanagari
    67: 13,  // langBengali → smBengali
    68: 13,  // langAssamese → smBengali
    69: 11,  // langGujarati → smGujarati
    70: 10,  // langPunjabi → smGurmukhi
    71: 12,  // langOriya → smOriya
    72: 17,  // langMalayalam → smMalayalam
    73: 16,  // langKannada → smKannada
    74: 14,  // langTamil → smTamil
    75: 15,  // langTelugu → smTelugu
    76: 18,  // langSinhalese → smSinhalese
    77: 19,  // langBurmese → smBurmese
    78: 20,  // langKhmer → smKhmer
    79: 22,  // langLao → smLao
    80: 30,  // langVietnamese → smVietnamese
    81: 0,  // langIndonesian → smRoman
    82: 0,  // langTagalog → smRoman
    83: 0,  // langMalayRoman → smRoman
    84: 4,  // langMalayArabic → smArabic
    85: 28,  // langAmharic → smEthiopic
    86: 28,  // langTigrinya → smEthiopic
    87: 28,  // langOromo → smEthiopic
    88: 0,  // langSomali → smRoman
    89: 0,  // langSwahili → smRoman
    90: 0,  // langKinyarwanda → smRoman
    91: 0,  // langRundi → smRoman
    92: 0,  // langNyanja → smRoman
    93: 0,  // langMalagasy → smRoman
    94: 0,  // langEsperanto → smRoman
    128: 0,  // langWelsh → smRoman (modified)
    129: 0,  // langBasque → smRoman
    130: 0,  // langCatalan → smRoman
    131: 0,  // langLatin → smRoman
    132: 0,  // langQuechua → smRoman
    133: 0,  // langGuarani → smRoman
    134: 0,  // langAymara → smRoman
    135: 7,  // langTatar → smCyrillic
    136: 4,  // langUighur → smArabic
    137: 26,  // langDzongkha → smTibetan
    138: 0,  // langJavaneseRom → smRoman
    139: 0,  // langSundaneseRom → smRoman
    140: 0,  // langGalician → smRoman
    141: 0,  // langAfrikaans → smRoman
    142: 0,  // langBreton → smRoman (modified)
    143: 28,  // langInuktitut → smEthiopic (modified)
    144: 0,  // langScottishGaelic → smRoman (modified)
    145: 0,  // langManxGaelic → smRoman (modified)
    146: 0,  // langIrishGaelicScript → smRoman (modified)
    147: 0,  // langTongan → smRoman
    148: 6,  // langGreekAncient → smRoman
    149: 0,  // langGreenlandic → smRoman
    150: 0,  // langAzerbaijanRoman → smRoman
    151: 0   // langNynorsk → smRoman
};

// While Microsoft indicates a region/country for all its language
// IDs, we omit the region code if it's equal to the "most likely
// region subtag" according to Unicode CLDR. For scripts, we omit
// the subtag if it is equal to the Suppress-Script entry in the
// IANA language subtag registry for IETF BCP 47.
//
// For example, Microsoft states that its language code 0x041A is
// Croatian in Croatia. We transform this to the BCP 47 language code 'hr'
// and not 'hr-HR' because Croatia is the default country for Croatian,
// according to Unicode CLDR. As another example, Microsoft states
// that 0x101A is Croatian (Latin) in Bosnia-Herzegovina. We transform
// this to 'hr-BA' and not 'hr-Latn-BA' because Latin is the default script
// for the Croatian language, according to IANA.
//
// http://www.unicode.org/cldr/charts/latest/supplemental/likely_subtags.html
// http://www.iana.org/assignments/language-subtag-registry/language-subtag-registry
var windowsLanguages = {
    0x0436: 'af',
    0x041C: 'sq',
    0x0484: 'gsw',
    0x045E: 'am',
    0x1401: 'ar-DZ',
    0x3C01: 'ar-BH',
    0x0C01: 'ar',
    0x0801: 'ar-IQ',
    0x2C01: 'ar-JO',
    0x3401: 'ar-KW',
    0x3001: 'ar-LB',
    0x1001: 'ar-LY',
    0x1801: 'ary',
    0x2001: 'ar-OM',
    0x4001: 'ar-QA',
    0x0401: 'ar-SA',
    0x2801: 'ar-SY',
    0x1C01: 'aeb',
    0x3801: 'ar-AE',
    0x2401: 'ar-YE',
    0x042B: 'hy',
    0x044D: 'as',
    0x082C: 'az-Cyrl',
    0x042C: 'az',
    0x046D: 'ba',
    0x042D: 'eu',
    0x0423: 'be',
    0x0845: 'bn',
    0x0445: 'bn-IN',
    0x201A: 'bs-Cyrl',
    0x141A: 'bs',
    0x047E: 'br',
    0x0402: 'bg',
    0x0403: 'ca',
    0x0C04: 'zh-HK',
    0x1404: 'zh-MO',
    0x0804: 'zh',
    0x1004: 'zh-SG',
    0x0404: 'zh-TW',
    0x0483: 'co',
    0x041A: 'hr',
    0x101A: 'hr-BA',
    0x0405: 'cs',
    0x0406: 'da',
    0x048C: 'prs',
    0x0465: 'dv',
    0x0813: 'nl-BE',
    0x0413: 'nl',
    0x0C09: 'en-AU',
    0x2809: 'en-BZ',
    0x1009: 'en-CA',
    0x2409: 'en-029',
    0x4009: 'en-IN',
    0x1809: 'en-IE',
    0x2009: 'en-JM',
    0x4409: 'en-MY',
    0x1409: 'en-NZ',
    0x3409: 'en-PH',
    0x4809: 'en-SG',
    0x1C09: 'en-ZA',
    0x2C09: 'en-TT',
    0x0809: 'en-GB',
    0x0409: 'en',
    0x3009: 'en-ZW',
    0x0425: 'et',
    0x0438: 'fo',
    0x0464: 'fil',
    0x040B: 'fi',
    0x080C: 'fr-BE',
    0x0C0C: 'fr-CA',
    0x040C: 'fr',
    0x140C: 'fr-LU',
    0x180C: 'fr-MC',
    0x100C: 'fr-CH',
    0x0462: 'fy',
    0x0456: 'gl',
    0x0437: 'ka',
    0x0C07: 'de-AT',
    0x0407: 'de',
    0x1407: 'de-LI',
    0x1007: 'de-LU',
    0x0807: 'de-CH',
    0x0408: 'el',
    0x046F: 'kl',
    0x0447: 'gu',
    0x0468: 'ha',
    0x040D: 'he',
    0x0439: 'hi',
    0x040E: 'hu',
    0x040F: 'is',
    0x0470: 'ig',
    0x0421: 'id',
    0x045D: 'iu',
    0x085D: 'iu-Latn',
    0x083C: 'ga',
    0x0434: 'xh',
    0x0435: 'zu',
    0x0410: 'it',
    0x0810: 'it-CH',
    0x0411: 'ja',
    0x044B: 'kn',
    0x043F: 'kk',
    0x0453: 'km',
    0x0486: 'quc',
    0x0487: 'rw',
    0x0441: 'sw',
    0x0457: 'kok',
    0x0412: 'ko',
    0x0440: 'ky',
    0x0454: 'lo',
    0x0426: 'lv',
    0x0427: 'lt',
    0x082E: 'dsb',
    0x046E: 'lb',
    0x042F: 'mk',
    0x083E: 'ms-BN',
    0x043E: 'ms',
    0x044C: 'ml',
    0x043A: 'mt',
    0x0481: 'mi',
    0x047A: 'arn',
    0x044E: 'mr',
    0x047C: 'moh',
    0x0450: 'mn',
    0x0850: 'mn-CN',
    0x0461: 'ne',
    0x0414: 'nb',
    0x0814: 'nn',
    0x0482: 'oc',
    0x0448: 'or',
    0x0463: 'ps',
    0x0415: 'pl',
    0x0416: 'pt',
    0x0816: 'pt-PT',
    0x0446: 'pa',
    0x046B: 'qu-BO',
    0x086B: 'qu-EC',
    0x0C6B: 'qu',
    0x0418: 'ro',
    0x0417: 'rm',
    0x0419: 'ru',
    0x243B: 'smn',
    0x103B: 'smj-NO',
    0x143B: 'smj',
    0x0C3B: 'se-FI',
    0x043B: 'se',
    0x083B: 'se-SE',
    0x203B: 'sms',
    0x183B: 'sma-NO',
    0x1C3B: 'sms',
    0x044F: 'sa',
    0x1C1A: 'sr-Cyrl-BA',
    0x0C1A: 'sr',
    0x181A: 'sr-Latn-BA',
    0x081A: 'sr-Latn',
    0x046C: 'nso',
    0x0432: 'tn',
    0x045B: 'si',
    0x041B: 'sk',
    0x0424: 'sl',
    0x2C0A: 'es-AR',
    0x400A: 'es-BO',
    0x340A: 'es-CL',
    0x240A: 'es-CO',
    0x140A: 'es-CR',
    0x1C0A: 'es-DO',
    0x300A: 'es-EC',
    0x440A: 'es-SV',
    0x100A: 'es-GT',
    0x480A: 'es-HN',
    0x080A: 'es-MX',
    0x4C0A: 'es-NI',
    0x180A: 'es-PA',
    0x3C0A: 'es-PY',
    0x280A: 'es-PE',
    0x500A: 'es-PR',

    // Microsoft has defined two different language codes for
    // “Spanish with modern sorting” and “Spanish with traditional
    // sorting”. This makes sense for collation APIs, and it would be
    // possible to express this in BCP 47 language tags via Unicode
    // extensions (eg., es-u-co-trad is Spanish with traditional
    // sorting). However, for storing names in fonts, the distinction
    // does not make sense, so we give “es” in both cases.
    0x0C0A: 'es',
    0x040A: 'es',

    0x540A: 'es-US',
    0x380A: 'es-UY',
    0x200A: 'es-VE',
    0x081D: 'sv-FI',
    0x041D: 'sv',
    0x045A: 'syr',
    0x0428: 'tg',
    0x085F: 'tzm',
    0x0449: 'ta',
    0x0444: 'tt',
    0x044A: 'te',
    0x041E: 'th',
    0x0451: 'bo',
    0x041F: 'tr',
    0x0442: 'tk',
    0x0480: 'ug',
    0x0422: 'uk',
    0x042E: 'hsb',
    0x0420: 'ur',
    0x0843: 'uz-Cyrl',
    0x0443: 'uz',
    0x042A: 'vi',
    0x0452: 'cy',
    0x0488: 'wo',
    0x0485: 'sah',
    0x0478: 'ii',
    0x046A: 'yo'
};

// Returns a IETF BCP 47 language code, for example 'zh-Hant'
// for 'Chinese in the traditional script'.
function getLanguageCode(platformID, languageID, ltag) {
    switch (platformID) {
        case 0:  // Unicode
            if (languageID === 0xFFFF) {
                return 'und';
            } else if (ltag) {
                return ltag[languageID];
            }

            break;

        case 1:  // Macintosh
            return macLanguages[languageID];

        case 3:  // Windows
            return windowsLanguages[languageID];
    }

    return undefined;
}

var utf16 = 'utf-16';

// MacOS script ID → encoding. This table stores the default case,
// which can be overridden by macLanguageEncodings.
var macScriptEncodings = {
    0: 'macintosh',           // smRoman
    1: 'x-mac-japanese',      // smJapanese
    2: 'x-mac-chinesetrad',   // smTradChinese
    3: 'x-mac-korean',        // smKorean
    6: 'x-mac-greek',         // smGreek
    7: 'x-mac-cyrillic',      // smCyrillic
    9: 'x-mac-devanagai',     // smDevanagari
    10: 'x-mac-gurmukhi',     // smGurmukhi
    11: 'x-mac-gujarati',     // smGujarati
    12: 'x-mac-oriya',        // smOriya
    13: 'x-mac-bengali',      // smBengali
    14: 'x-mac-tamil',        // smTamil
    15: 'x-mac-telugu',       // smTelugu
    16: 'x-mac-kannada',      // smKannada
    17: 'x-mac-malayalam',    // smMalayalam
    18: 'x-mac-sinhalese',    // smSinhalese
    19: 'x-mac-burmese',      // smBurmese
    20: 'x-mac-khmer',        // smKhmer
    21: 'x-mac-thai',         // smThai
    22: 'x-mac-lao',          // smLao
    23: 'x-mac-georgian',     // smGeorgian
    24: 'x-mac-armenian',     // smArmenian
    25: 'x-mac-chinesesimp',  // smSimpChinese
    26: 'x-mac-tibetan',      // smTibetan
    27: 'x-mac-mongolian',    // smMongolian
    28: 'x-mac-ethiopic',     // smEthiopic
    29: 'x-mac-ce',           // smCentralEuroRoman
    30: 'x-mac-vietnamese',   // smVietnamese
    31: 'x-mac-extarabic'     // smExtArabic
};

// MacOS language ID → encoding. This table stores the exceptional
// cases, which override macScriptEncodings. For writing MacOS naming
// tables, we need to emit a MacOS script ID. Therefore, we cannot
// merge macScriptEncodings into macLanguageEncodings.
//
// http://unicode.org/Public/MAPPINGS/VENDORS/APPLE/Readme.txt
var macLanguageEncodings = {
    15: 'x-mac-icelandic',    // langIcelandic
    17: 'x-mac-turkish',      // langTurkish
    18: 'x-mac-croatian',     // langCroatian
    24: 'x-mac-ce',           // langLithuanian
    25: 'x-mac-ce',           // langPolish
    26: 'x-mac-ce',           // langHungarian
    27: 'x-mac-ce',           // langEstonian
    28: 'x-mac-ce',           // langLatvian
    30: 'x-mac-icelandic',    // langFaroese
    37: 'x-mac-romanian',     // langRomanian
    38: 'x-mac-ce',           // langCzech
    39: 'x-mac-ce',           // langSlovak
    40: 'x-mac-ce',           // langSlovenian
    143: 'x-mac-inuit',       // langInuktitut
    146: 'x-mac-gaelic'       // langIrishGaelicScript
};

function getEncoding(platformID, encodingID, languageID) {
    switch (platformID) {
        case 0:  // Unicode
            return utf16;

        case 1:  // Apple Macintosh
            return macLanguageEncodings[languageID] || macScriptEncodings[encodingID];

        case 3:  // Microsoft Windows
            if (encodingID === 1 || encodingID === 10) {
                return utf16;
            }

            break;
    }

    return undefined;
}

// Parse the naming `name` table.
// FIXME: Format 1 additional fields are not supported yet.
// ltag is the content of the `ltag' table, such as ['en', 'zh-Hans', 'de-CH-1904'].
function parseNameTable(data, start, ltag) {
    var name = {};
    var p = new parse.Parser(data, start);
    var format = p.parseUShort();
    var count = p.parseUShort();
    var stringOffset = p.offset + p.parseUShort();
    for (var i = 0; i < count; i++) {
        var platformID = p.parseUShort();
        var encodingID = p.parseUShort();
        var languageID = p.parseUShort();
        var nameID = p.parseUShort();
        var property = nameTableNames[nameID] || nameID;
        var byteLength = p.parseUShort();
        var offset = p.parseUShort();
        var language = getLanguageCode(platformID, languageID, ltag);
        var encoding = getEncoding(platformID, encodingID, languageID);
        if (encoding !== undefined && language !== undefined) {
            var text = (void 0);
            if (encoding === utf16) {
                text = decode.UTF16(data, stringOffset + offset, byteLength);
            } else {
                text = decode.MACSTRING(data, stringOffset + offset, byteLength, encoding);
            }

            if (text) {
                var translations = name[property];
                if (translations === undefined) {
                    translations = name[property] = {};
                }

                translations[language] = text;
            }
        }
    }
    if (format === 1) {
        // FIXME: Also handle Microsoft's 'name' table 1.
        p.parseUShort();
    }

    return name;
}

// {23: 'foo'} → {'foo': 23}
// ['bar', 'baz'] → {'bar': 0, 'baz': 1}
function reverseDict(dict) {
    var result = {};
    for (var key in dict) {
        result[dict[key]] = parseInt(key);
    }

    return result;
}

function makeNameRecord(platformID, encodingID, languageID, nameID, length, offset) {
    return new table.Record('NameRecord', [
        {name: 'platformID', type: 'USHORT', value: platformID},
        {name: 'encodingID', type: 'USHORT', value: encodingID},
        {name: 'languageID', type: 'USHORT', value: languageID},
        {name: 'nameID', type: 'USHORT', value: nameID},
        {name: 'length', type: 'USHORT', value: length},
        {name: 'offset', type: 'USHORT', value: offset}
    ]);
}

// Finds the position of needle in haystack, or -1 if not there.
// Like String.indexOf(), but for arrays.
function findSubArray(needle, haystack) {
    var needleLength = needle.length;
    var limit = haystack.length - needleLength + 1;

    loop:
    for (var pos = 0; pos < limit; pos++) {
        for (; pos < limit; pos++) {
            for (var k = 0; k < needleLength; k++) {
                if (haystack[pos + k] !== needle[k]) {
                    continue loop;
                }
            }

            return pos;
        }
    }

    return -1;
}

function addStringToPool(s, pool) {
    var offset = findSubArray(s, pool);
    if (offset < 0) {
        offset = pool.length;
        var i = 0;
        var len = s.length;
        for (; i < len; ++i) {
            pool.push(s[i]);
        }

    }

    return offset;
}

function makeNameTable(names, ltag) {
    var nameID;
    var nameIDs = [];

    var namesWithNumericKeys = {};
    var nameTableIds = reverseDict(nameTableNames);
    for (var key in names) {
        var id = nameTableIds[key];
        if (id === undefined) {
            id = key;
        }

        nameID = parseInt(id);

        if (isNaN(nameID)) {
            throw new Error('Name table entry "' + key + '" does not exist, see nameTableNames for complete list.');
        }

        namesWithNumericKeys[nameID] = names[key];
        nameIDs.push(nameID);
    }

    var macLanguageIds = reverseDict(macLanguages);
    var windowsLanguageIds = reverseDict(windowsLanguages);

    var nameRecords = [];
    var stringPool = [];

    for (var i = 0; i < nameIDs.length; i++) {
        nameID = nameIDs[i];
        var translations = namesWithNumericKeys[nameID];
        for (var lang in translations) {
            var text = translations[lang];

            // For MacOS, we try to emit the name in the form that was introduced
            // in the initial version of the TrueType spec (in the late 1980s).
            // However, this can fail for various reasons: the requested BCP 47
            // language code might not have an old-style Mac equivalent;
            // we might not have a codec for the needed character encoding;
            // or the name might contain characters that cannot be expressed
            // in the old-style Macintosh encoding. In case of failure, we emit
            // the name in a more modern fashion (Unicode encoding with BCP 47
            // language tags) that is recognized by MacOS 10.5, released in 2009.
            // If fonts were only read by operating systems, we could simply
            // emit all names in the modern form; this would be much easier.
            // However, there are many applications and libraries that read
            // 'name' tables directly, and these will usually only recognize
            // the ancient form (silently skipping the unrecognized names).
            var macPlatform = 1;  // Macintosh
            var macLanguage = macLanguageIds[lang];
            var macScript = macLanguageToScript[macLanguage];
            var macEncoding = getEncoding(macPlatform, macScript, macLanguage);
            var macName = encode$2.MACSTRING(text, macEncoding);
            if (macName === undefined) {
                macPlatform = 0;  // Unicode
                macLanguage = ltag.indexOf(lang);
                if (macLanguage < 0) {
                    macLanguage = ltag.length;
                    ltag.push(lang);
                }

                macScript = 4;  // Unicode 2.0 and later
                macName = encode$2.UTF16(text);
            }

            var macNameOffset = addStringToPool(macName, stringPool);
            nameRecords.push(makeNameRecord(macPlatform, macScript, macLanguage,
                                            nameID, macName.length, macNameOffset));

            var winLanguage = windowsLanguageIds[lang];
            if (winLanguage !== undefined) {
                var winName = encode$2.UTF16(text);
                var winNameOffset = addStringToPool(winName, stringPool);
                nameRecords.push(makeNameRecord(3, 1, winLanguage,
                                                nameID, winName.length, winNameOffset));
            }
        }
    }

    nameRecords.sort(function(a, b) {
        return ((a.platformID - b.platformID) ||
                (a.encodingID - b.encodingID) ||
                (a.languageID - b.languageID) ||
                (a.nameID - b.nameID));
    });

    var t = new table.Table('name', [
        {name: 'format', type: 'USHORT', value: 0},
        {name: 'count', type: 'USHORT', value: nameRecords.length},
        {name: 'stringOffset', type: 'USHORT', value: 6 + nameRecords.length * 12}
    ]);

    for (var r = 0; r < nameRecords.length; r++) {
        t.fields.push({name: 'record_' + r, type: 'RECORD', value: nameRecords[r]});
    }

    t.fields.push({name: 'strings', type: 'LITERAL', value: stringPool});
    return t;
}

var _name = { parse: parseNameTable, make: makeNameTable };

// The `OS/2` table contains metrics required in OpenType fonts.

var unicodeRanges = [
    {begin: 0x0000, end: 0x007F}, // Basic Latin
    {begin: 0x0080, end: 0x00FF}, // Latin-1 Supplement
    {begin: 0x0100, end: 0x017F}, // Latin Extended-A
    {begin: 0x0180, end: 0x024F}, // Latin Extended-B
    {begin: 0x0250, end: 0x02AF}, // IPA Extensions
    {begin: 0x02B0, end: 0x02FF}, // Spacing Modifier Letters
    {begin: 0x0300, end: 0x036F}, // Combining Diacritical Marks
    {begin: 0x0370, end: 0x03FF}, // Greek and Coptic
    {begin: 0x2C80, end: 0x2CFF}, // Coptic
    {begin: 0x0400, end: 0x04FF}, // Cyrillic
    {begin: 0x0530, end: 0x058F}, // Armenian
    {begin: 0x0590, end: 0x05FF}, // Hebrew
    {begin: 0xA500, end: 0xA63F}, // Vai
    {begin: 0x0600, end: 0x06FF}, // Arabic
    {begin: 0x07C0, end: 0x07FF}, // NKo
    {begin: 0x0900, end: 0x097F}, // Devanagari
    {begin: 0x0980, end: 0x09FF}, // Bengali
    {begin: 0x0A00, end: 0x0A7F}, // Gurmukhi
    {begin: 0x0A80, end: 0x0AFF}, // Gujarati
    {begin: 0x0B00, end: 0x0B7F}, // Oriya
    {begin: 0x0B80, end: 0x0BFF}, // Tamil
    {begin: 0x0C00, end: 0x0C7F}, // Telugu
    {begin: 0x0C80, end: 0x0CFF}, // Kannada
    {begin: 0x0D00, end: 0x0D7F}, // Malayalam
    {begin: 0x0E00, end: 0x0E7F}, // Thai
    {begin: 0x0E80, end: 0x0EFF}, // Lao
    {begin: 0x10A0, end: 0x10FF}, // Georgian
    {begin: 0x1B00, end: 0x1B7F}, // Balinese
    {begin: 0x1100, end: 0x11FF}, // Hangul Jamo
    {begin: 0x1E00, end: 0x1EFF}, // Latin Extended Additional
    {begin: 0x1F00, end: 0x1FFF}, // Greek Extended
    {begin: 0x2000, end: 0x206F}, // General Punctuation
    {begin: 0x2070, end: 0x209F}, // Superscripts And Subscripts
    {begin: 0x20A0, end: 0x20CF}, // Currency Symbol
    {begin: 0x20D0, end: 0x20FF}, // Combining Diacritical Marks For Symbols
    {begin: 0x2100, end: 0x214F}, // Letterlike Symbols
    {begin: 0x2150, end: 0x218F}, // Number Forms
    {begin: 0x2190, end: 0x21FF}, // Arrows
    {begin: 0x2200, end: 0x22FF}, // Mathematical Operators
    {begin: 0x2300, end: 0x23FF}, // Miscellaneous Technical
    {begin: 0x2400, end: 0x243F}, // Control Pictures
    {begin: 0x2440, end: 0x245F}, // Optical Character Recognition
    {begin: 0x2460, end: 0x24FF}, // Enclosed Alphanumerics
    {begin: 0x2500, end: 0x257F}, // Box Drawing
    {begin: 0x2580, end: 0x259F}, // Block Elements
    {begin: 0x25A0, end: 0x25FF}, // Geometric Shapes
    {begin: 0x2600, end: 0x26FF}, // Miscellaneous Symbols
    {begin: 0x2700, end: 0x27BF}, // Dingbats
    {begin: 0x3000, end: 0x303F}, // CJK Symbols And Punctuation
    {begin: 0x3040, end: 0x309F}, // Hiragana
    {begin: 0x30A0, end: 0x30FF}, // Katakana
    {begin: 0x3100, end: 0x312F}, // Bopomofo
    {begin: 0x3130, end: 0x318F}, // Hangul Compatibility Jamo
    {begin: 0xA840, end: 0xA87F}, // Phags-pa
    {begin: 0x3200, end: 0x32FF}, // Enclosed CJK Letters And Months
    {begin: 0x3300, end: 0x33FF}, // CJK Compatibility
    {begin: 0xAC00, end: 0xD7AF}, // Hangul Syllables
    {begin: 0xD800, end: 0xDFFF}, // Non-Plane 0 *
    {begin: 0x10900, end: 0x1091F}, // Phoenicia
    {begin: 0x4E00, end: 0x9FFF}, // CJK Unified Ideographs
    {begin: 0xE000, end: 0xF8FF}, // Private Use Area (plane 0)
    {begin: 0x31C0, end: 0x31EF}, // CJK Strokes
    {begin: 0xFB00, end: 0xFB4F}, // Alphabetic Presentation Forms
    {begin: 0xFB50, end: 0xFDFF}, // Arabic Presentation Forms-A
    {begin: 0xFE20, end: 0xFE2F}, // Combining Half Marks
    {begin: 0xFE10, end: 0xFE1F}, // Vertical Forms
    {begin: 0xFE50, end: 0xFE6F}, // Small Form Variants
    {begin: 0xFE70, end: 0xFEFF}, // Arabic Presentation Forms-B
    {begin: 0xFF00, end: 0xFFEF}, // Halfwidth And Fullwidth Forms
    {begin: 0xFFF0, end: 0xFFFF}, // Specials
    {begin: 0x0F00, end: 0x0FFF}, // Tibetan
    {begin: 0x0700, end: 0x074F}, // Syriac
    {begin: 0x0780, end: 0x07BF}, // Thaana
    {begin: 0x0D80, end: 0x0DFF}, // Sinhala
    {begin: 0x1000, end: 0x109F}, // Myanmar
    {begin: 0x1200, end: 0x137F}, // Ethiopic
    {begin: 0x13A0, end: 0x13FF}, // Cherokee
    {begin: 0x1400, end: 0x167F}, // Unified Canadian Aboriginal Syllabics
    {begin: 0x1680, end: 0x169F}, // Ogham
    {begin: 0x16A0, end: 0x16FF}, // Runic
    {begin: 0x1780, end: 0x17FF}, // Khmer
    {begin: 0x1800, end: 0x18AF}, // Mongolian
    {begin: 0x2800, end: 0x28FF}, // Braille Patterns
    {begin: 0xA000, end: 0xA48F}, // Yi Syllables
    {begin: 0x1700, end: 0x171F}, // Tagalog
    {begin: 0x10300, end: 0x1032F}, // Old Italic
    {begin: 0x10330, end: 0x1034F}, // Gothic
    {begin: 0x10400, end: 0x1044F}, // Deseret
    {begin: 0x1D000, end: 0x1D0FF}, // Byzantine Musical Symbols
    {begin: 0x1D400, end: 0x1D7FF}, // Mathematical Alphanumeric Symbols
    {begin: 0xFF000, end: 0xFFFFD}, // Private Use (plane 15)
    {begin: 0xFE00, end: 0xFE0F}, // Variation Selectors
    {begin: 0xE0000, end: 0xE007F}, // Tags
    {begin: 0x1900, end: 0x194F}, // Limbu
    {begin: 0x1950, end: 0x197F}, // Tai Le
    {begin: 0x1980, end: 0x19DF}, // New Tai Lue
    {begin: 0x1A00, end: 0x1A1F}, // Buginese
    {begin: 0x2C00, end: 0x2C5F}, // Glagolitic
    {begin: 0x2D30, end: 0x2D7F}, // Tifinagh
    {begin: 0x4DC0, end: 0x4DFF}, // Yijing Hexagram Symbols
    {begin: 0xA800, end: 0xA82F}, // Syloti Nagri
    {begin: 0x10000, end: 0x1007F}, // Linear B Syllabary
    {begin: 0x10140, end: 0x1018F}, // Ancient Greek Numbers
    {begin: 0x10380, end: 0x1039F}, // Ugaritic
    {begin: 0x103A0, end: 0x103DF}, // Old Persian
    {begin: 0x10450, end: 0x1047F}, // Shavian
    {begin: 0x10480, end: 0x104AF}, // Osmanya
    {begin: 0x10800, end: 0x1083F}, // Cypriot Syllabary
    {begin: 0x10A00, end: 0x10A5F}, // Kharoshthi
    {begin: 0x1D300, end: 0x1D35F}, // Tai Xuan Jing Symbols
    {begin: 0x12000, end: 0x123FF}, // Cuneiform
    {begin: 0x1D360, end: 0x1D37F}, // Counting Rod Numerals
    {begin: 0x1B80, end: 0x1BBF}, // Sundanese
    {begin: 0x1C00, end: 0x1C4F}, // Lepcha
    {begin: 0x1C50, end: 0x1C7F}, // Ol Chiki
    {begin: 0xA880, end: 0xA8DF}, // Saurashtra
    {begin: 0xA900, end: 0xA92F}, // Kayah Li
    {begin: 0xA930, end: 0xA95F}, // Rejang
    {begin: 0xAA00, end: 0xAA5F}, // Cham
    {begin: 0x10190, end: 0x101CF}, // Ancient Symbols
    {begin: 0x101D0, end: 0x101FF}, // Phaistos Disc
    {begin: 0x102A0, end: 0x102DF}, // Carian
    {begin: 0x1F030, end: 0x1F09F}  // Domino Tiles
];

function getUnicodeRange(unicode) {
    for (var i = 0; i < unicodeRanges.length; i += 1) {
        var range = unicodeRanges[i];
        if (unicode >= range.begin && unicode < range.end) {
            return i;
        }
    }

    return -1;
}

// Parse the OS/2 and Windows metrics `OS/2` table
function parseOS2Table(data, start) {
    var os2 = {};
    var p = new parse.Parser(data, start);
    os2.version = p.parseUShort();
    os2.xAvgCharWidth = p.parseShort();
    os2.usWeightClass = p.parseUShort();
    os2.usWidthClass = p.parseUShort();
    os2.fsType = p.parseUShort();
    os2.ySubscriptXSize = p.parseShort();
    os2.ySubscriptYSize = p.parseShort();
    os2.ySubscriptXOffset = p.parseShort();
    os2.ySubscriptYOffset = p.parseShort();
    os2.ySuperscriptXSize = p.parseShort();
    os2.ySuperscriptYSize = p.parseShort();
    os2.ySuperscriptXOffset = p.parseShort();
    os2.ySuperscriptYOffset = p.parseShort();
    os2.yStrikeoutSize = p.parseShort();
    os2.yStrikeoutPosition = p.parseShort();
    os2.sFamilyClass = p.parseShort();
    os2.panose = [];
    for (var i = 0; i < 10; i++) {
        os2.panose[i] = p.parseByte();
    }

    os2.ulUnicodeRange1 = p.parseULong();
    os2.ulUnicodeRange2 = p.parseULong();
    os2.ulUnicodeRange3 = p.parseULong();
    os2.ulUnicodeRange4 = p.parseULong();
    os2.achVendID = String.fromCharCode(p.parseByte(), p.parseByte(), p.parseByte(), p.parseByte());
    os2.fsSelection = p.parseUShort();
    os2.usFirstCharIndex = p.parseUShort();
    os2.usLastCharIndex = p.parseUShort();
    os2.sTypoAscender = p.parseShort();
    os2.sTypoDescender = p.parseShort();
    os2.sTypoLineGap = p.parseShort();
    os2.usWinAscent = p.parseUShort();
    os2.usWinDescent = p.parseUShort();
    if (os2.version >= 1) {
        os2.ulCodePageRange1 = p.parseULong();
        os2.ulCodePageRange2 = p.parseULong();
    }

    if (os2.version >= 2) {
        os2.sxHeight = p.parseShort();
        os2.sCapHeight = p.parseShort();
        os2.usDefaultChar = p.parseUShort();
        os2.usBreakChar = p.parseUShort();
        os2.usMaxContent = p.parseUShort();
    }

    return os2;
}

function makeOS2Table(options) {
    return new table.Table('OS/2', [
        {name: 'version', type: 'USHORT', value: 0x0003},
        {name: 'xAvgCharWidth', type: 'SHORT', value: 0},
        {name: 'usWeightClass', type: 'USHORT', value: 0},
        {name: 'usWidthClass', type: 'USHORT', value: 0},
        {name: 'fsType', type: 'USHORT', value: 0},
        {name: 'ySubscriptXSize', type: 'SHORT', value: 650},
        {name: 'ySubscriptYSize', type: 'SHORT', value: 699},
        {name: 'ySubscriptXOffset', type: 'SHORT', value: 0},
        {name: 'ySubscriptYOffset', type: 'SHORT', value: 140},
        {name: 'ySuperscriptXSize', type: 'SHORT', value: 650},
        {name: 'ySuperscriptYSize', type: 'SHORT', value: 699},
        {name: 'ySuperscriptXOffset', type: 'SHORT', value: 0},
        {name: 'ySuperscriptYOffset', type: 'SHORT', value: 479},
        {name: 'yStrikeoutSize', type: 'SHORT', value: 49},
        {name: 'yStrikeoutPosition', type: 'SHORT', value: 258},
        {name: 'sFamilyClass', type: 'SHORT', value: 0},
        {name: 'bFamilyType', type: 'BYTE', value: 0},
        {name: 'bSerifStyle', type: 'BYTE', value: 0},
        {name: 'bWeight', type: 'BYTE', value: 0},
        {name: 'bProportion', type: 'BYTE', value: 0},
        {name: 'bContrast', type: 'BYTE', value: 0},
        {name: 'bStrokeVariation', type: 'BYTE', value: 0},
        {name: 'bArmStyle', type: 'BYTE', value: 0},
        {name: 'bLetterform', type: 'BYTE', value: 0},
        {name: 'bMidline', type: 'BYTE', value: 0},
        {name: 'bXHeight', type: 'BYTE', value: 0},
        {name: 'ulUnicodeRange1', type: 'ULONG', value: 0},
        {name: 'ulUnicodeRange2', type: 'ULONG', value: 0},
        {name: 'ulUnicodeRange3', type: 'ULONG', value: 0},
        {name: 'ulUnicodeRange4', type: 'ULONG', value: 0},
        {name: 'achVendID', type: 'CHARARRAY', value: 'XXXX'},
        {name: 'fsSelection', type: 'USHORT', value: 0},
        {name: 'usFirstCharIndex', type: 'USHORT', value: 0},
        {name: 'usLastCharIndex', type: 'USHORT', value: 0},
        {name: 'sTypoAscender', type: 'SHORT', value: 0},
        {name: 'sTypoDescender', type: 'SHORT', value: 0},
        {name: 'sTypoLineGap', type: 'SHORT', value: 0},
        {name: 'usWinAscent', type: 'USHORT', value: 0},
        {name: 'usWinDescent', type: 'USHORT', value: 0},
        {name: 'ulCodePageRange1', type: 'ULONG', value: 0},
        {name: 'ulCodePageRange2', type: 'ULONG', value: 0},
        {name: 'sxHeight', type: 'SHORT', value: 0},
        {name: 'sCapHeight', type: 'SHORT', value: 0},
        {name: 'usDefaultChar', type: 'USHORT', value: 0},
        {name: 'usBreakChar', type: 'USHORT', value: 0},
        {name: 'usMaxContext', type: 'USHORT', value: 0}
    ], options);
}

var os2 = { parse: parseOS2Table, make: makeOS2Table, unicodeRanges: unicodeRanges, getUnicodeRange: getUnicodeRange };

// The `post` table stores additional PostScript information, such as glyph names.

// Parse the PostScript `post` table
function parsePostTable(data, start) {
    var post = {};
    var p = new parse.Parser(data, start);
    post.version = p.parseVersion();
    post.italicAngle = p.parseFixed();
    post.underlinePosition = p.parseShort();
    post.underlineThickness = p.parseShort();
    post.isFixedPitch = p.parseULong();
    post.minMemType42 = p.parseULong();
    post.maxMemType42 = p.parseULong();
    post.minMemType1 = p.parseULong();
    post.maxMemType1 = p.parseULong();
    switch (post.version) {
        case 1:
            post.names = standardNames.slice();
            break;
        case 2:
            post.numberOfGlyphs = p.parseUShort();
            post.glyphNameIndex = new Array(post.numberOfGlyphs);
            for (var i = 0; i < post.numberOfGlyphs; i++) {
                post.glyphNameIndex[i] = p.parseUShort();
            }

            post.names = [];
            for (var i$1 = 0; i$1 < post.numberOfGlyphs; i$1++) {
                if (post.glyphNameIndex[i$1] >= standardNames.length) {
                    var nameLength = p.parseChar();
                    post.names.push(p.parseString(nameLength));
                }
            }

            break;
        case 2.5:
            post.numberOfGlyphs = p.parseUShort();
            post.offset = new Array(post.numberOfGlyphs);
            for (var i$2 = 0; i$2 < post.numberOfGlyphs; i$2++) {
                post.offset[i$2] = p.parseChar();
            }

            break;
    }
    return post;
}

function makePostTable() {
    return new table.Table('post', [
        {name: 'version', type: 'FIXED', value: 0x00030000},
        {name: 'italicAngle', type: 'FIXED', value: 0},
        {name: 'underlinePosition', type: 'FWORD', value: 0},
        {name: 'underlineThickness', type: 'FWORD', value: 0},
        {name: 'isFixedPitch', type: 'ULONG', value: 0},
        {name: 'minMemType42', type: 'ULONG', value: 0},
        {name: 'maxMemType42', type: 'ULONG', value: 0},
        {name: 'minMemType1', type: 'ULONG', value: 0},
        {name: 'maxMemType1', type: 'ULONG', value: 0}
    ]);
}

var post = { parse: parsePostTable, make: makePostTable };

// The `GSUB` table contains ligatures, among other things.

var subtableParsers = new Array(9);         // subtableParsers[0] is unused

// https://www.microsoft.com/typography/OTSPEC/GSUB.htm#SS
subtableParsers[1] = function parseLookup1() {
    var start = this.offset + this.relativeOffset;
    var substFormat = this.parseUShort();
    if (substFormat === 1) {
        return {
            substFormat: 1,
            coverage: this.parsePointer(Parser.coverage),
            deltaGlyphId: this.parseUShort()
        };
    } else if (substFormat === 2) {
        return {
            substFormat: 2,
            coverage: this.parsePointer(Parser.coverage),
            substitute: this.parseOffset16List()
        };
    }
    check.assert(false, '0x' + start.toString(16) + ': lookup type 1 format must be 1 or 2.');
};

// https://www.microsoft.com/typography/OTSPEC/GSUB.htm#MS
subtableParsers[2] = function parseLookup2() {
    var substFormat = this.parseUShort();
    check.argument(substFormat === 1, 'GSUB Multiple Substitution Subtable identifier-format must be 1');
    return {
        substFormat: substFormat,
        coverage: this.parsePointer(Parser.coverage),
        sequences: this.parseListOfLists()
    };
};

// https://www.microsoft.com/typography/OTSPEC/GSUB.htm#AS
subtableParsers[3] = function parseLookup3() {
    var substFormat = this.parseUShort();
    check.argument(substFormat === 1, 'GSUB Alternate Substitution Subtable identifier-format must be 1');
    return {
        substFormat: substFormat,
        coverage: this.parsePointer(Parser.coverage),
        alternateSets: this.parseListOfLists()
    };
};

// https://www.microsoft.com/typography/OTSPEC/GSUB.htm#LS
subtableParsers[4] = function parseLookup4() {
    var substFormat = this.parseUShort();
    check.argument(substFormat === 1, 'GSUB ligature table identifier-format must be 1');
    return {
        substFormat: substFormat,
        coverage: this.parsePointer(Parser.coverage),
        ligatureSets: this.parseListOfLists(function() {
            return {
                ligGlyph: this.parseUShort(),
                components: this.parseUShortList(this.parseUShort() - 1)
            };
        })
    };
};

var lookupRecordDesc = {
    sequenceIndex: Parser.uShort,
    lookupListIndex: Parser.uShort
};

// https://www.microsoft.com/typography/OTSPEC/GSUB.htm#CSF
subtableParsers[5] = function parseLookup5() {
    var start = this.offset + this.relativeOffset;
    var substFormat = this.parseUShort();

    if (substFormat === 1) {
        return {
            substFormat: substFormat,
            coverage: this.parsePointer(Parser.coverage),
            ruleSets: this.parseListOfLists(function() {
                var glyphCount = this.parseUShort();
                var substCount = this.parseUShort();
                return {
                    input: this.parseUShortList(glyphCount - 1),
                    lookupRecords: this.parseRecordList(substCount, lookupRecordDesc)
                };
            })
        };
    } else if (substFormat === 2) {
        return {
            substFormat: substFormat,
            coverage: this.parsePointer(Parser.coverage),
            classDef: this.parsePointer(Parser.classDef),
            classSets: this.parseListOfLists(function() {
                var glyphCount = this.parseUShort();
                var substCount = this.parseUShort();
                return {
                    classes: this.parseUShortList(glyphCount - 1),
                    lookupRecords: this.parseRecordList(substCount, lookupRecordDesc)
                };
            })
        };
    } else if (substFormat === 3) {
        var glyphCount = this.parseUShort();
        var substCount = this.parseUShort();
        return {
            substFormat: substFormat,
            coverages: this.parseList(glyphCount, Parser.pointer(Parser.coverage)),
            lookupRecords: this.parseRecordList(substCount, lookupRecordDesc)
        };
    }
    check.assert(false, '0x' + start.toString(16) + ': lookup type 5 format must be 1, 2 or 3.');
};

// https://www.microsoft.com/typography/OTSPEC/GSUB.htm#CC
subtableParsers[6] = function parseLookup6() {
    var start = this.offset + this.relativeOffset;
    var substFormat = this.parseUShort();
    if (substFormat === 1) {
        return {
            substFormat: 1,
            coverage: this.parsePointer(Parser.coverage),
            chainRuleSets: this.parseListOfLists(function() {
                return {
                    backtrack: this.parseUShortList(),
                    input: this.parseUShortList(this.parseShort() - 1),
                    lookahead: this.parseUShortList(),
                    lookupRecords: this.parseRecordList(lookupRecordDesc)
                };
            })
        };
    } else if (substFormat === 2) {
        return {
            substFormat: 2,
            coverage: this.parsePointer(Parser.coverage),
            backtrackClassDef: this.parsePointer(Parser.classDef),
            inputClassDef: this.parsePointer(Parser.classDef),
            lookaheadClassDef: this.parsePointer(Parser.classDef),
            chainClassSet: this.parseListOfLists(function() {
                return {
                    backtrack: this.parseUShortList(),
                    input: this.parseUShortList(this.parseShort() - 1),
                    lookahead: this.parseUShortList(),
                    lookupRecords: this.parseRecordList(lookupRecordDesc)
                };
            })
        };
    } else if (substFormat === 3) {
        return {
            substFormat: 3,
            backtrackCoverage: this.parseList(Parser.pointer(Parser.coverage)),
            inputCoverage: this.parseList(Parser.pointer(Parser.coverage)),
            lookaheadCoverage: this.parseList(Parser.pointer(Parser.coverage)),
            lookupRecords: this.parseRecordList(lookupRecordDesc)
        };
    }
    check.assert(false, '0x' + start.toString(16) + ': lookup type 6 format must be 1, 2 or 3.');
};

// https://www.microsoft.com/typography/OTSPEC/GSUB.htm#ES
subtableParsers[7] = function parseLookup7() {
    // Extension Substitution subtable
    var substFormat = this.parseUShort();
    check.argument(substFormat === 1, 'GSUB Extension Substitution subtable identifier-format must be 1');
    var extensionLookupType = this.parseUShort();
    var extensionParser = new Parser(this.data, this.offset + this.parseULong());
    return {
        substFormat: 1,
        lookupType: extensionLookupType,
        extension: subtableParsers[extensionLookupType].call(extensionParser)
    };
};

// https://www.microsoft.com/typography/OTSPEC/GSUB.htm#RCCS
subtableParsers[8] = function parseLookup8() {
    var substFormat = this.parseUShort();
    check.argument(substFormat === 1, 'GSUB Reverse Chaining Contextual Single Substitution Subtable identifier-format must be 1');
    return {
        substFormat: substFormat,
        coverage: this.parsePointer(Parser.coverage),
        backtrackCoverage: this.parseList(Parser.pointer(Parser.coverage)),
        lookaheadCoverage: this.parseList(Parser.pointer(Parser.coverage)),
        substitutes: this.parseUShortList()
    };
};

// https://www.microsoft.com/typography/OTSPEC/gsub.htm
function parseGsubTable(data, start) {
    start = start || 0;
    var p = new Parser(data, start);
    var tableVersion = p.parseVersion(1);
    check.argument(tableVersion === 1 || tableVersion === 1.1, 'Unsupported GSUB table version.');
    if (tableVersion === 1) {
        return {
            version: tableVersion,
            scripts: p.parseScriptList(),
            features: p.parseFeatureList(),
            lookups: p.parseLookupList(subtableParsers)
        };
    } else {
        return {
            version: tableVersion,
            scripts: p.parseScriptList(),
            features: p.parseFeatureList(),
            lookups: p.parseLookupList(subtableParsers),
            variations: p.parseFeatureVariationsList()
        };
    }

}

// GSUB Writing //////////////////////////////////////////////
var subtableMakers = new Array(9);

subtableMakers[1] = function makeLookup1(subtable) {
    if (subtable.substFormat === 1) {
        return new table.Table('substitutionTable', [
            {name: 'substFormat', type: 'USHORT', value: 1},
            {name: 'coverage', type: 'TABLE', value: new table.Coverage(subtable.coverage)},
            {name: 'deltaGlyphID', type: 'USHORT', value: subtable.deltaGlyphId}
        ]);
    } else {
        return new table.Table('substitutionTable', [
            {name: 'substFormat', type: 'USHORT', value: 2},
            {name: 'coverage', type: 'TABLE', value: new table.Coverage(subtable.coverage)}
        ].concat(table.ushortList('substitute', subtable.substitute)));
    }
};

subtableMakers[2] = function makeLookup2(subtable) {
    check.assert(subtable.substFormat === 1, 'Lookup type 2 substFormat must be 1.');
    return new table.Table('substitutionTable', [
        {name: 'substFormat', type: 'USHORT', value: 1},
        {name: 'coverage', type: 'TABLE', value: new table.Coverage(subtable.coverage)}
    ].concat(table.tableList('seqSet', subtable.sequences, function(sequenceSet) {
        return new table.Table('sequenceSetTable', table.ushortList('sequence', sequenceSet));
    })));
};

subtableMakers[3] = function makeLookup3(subtable) {
    check.assert(subtable.substFormat === 1, 'Lookup type 3 substFormat must be 1.');
    return new table.Table('substitutionTable', [
        {name: 'substFormat', type: 'USHORT', value: 1},
        {name: 'coverage', type: 'TABLE', value: new table.Coverage(subtable.coverage)}
    ].concat(table.tableList('altSet', subtable.alternateSets, function(alternateSet) {
        return new table.Table('alternateSetTable', table.ushortList('alternate', alternateSet));
    })));
};

subtableMakers[4] = function makeLookup4(subtable) {
    check.assert(subtable.substFormat === 1, 'Lookup type 4 substFormat must be 1.');
    return new table.Table('substitutionTable', [
        {name: 'substFormat', type: 'USHORT', value: 1},
        {name: 'coverage', type: 'TABLE', value: new table.Coverage(subtable.coverage)}
    ].concat(table.tableList('ligSet', subtable.ligatureSets, function(ligatureSet) {
        return new table.Table('ligatureSetTable', table.tableList('ligature', ligatureSet, function(ligature) {
            return new table.Table('ligatureTable',
                [{name: 'ligGlyph', type: 'USHORT', value: ligature.ligGlyph}]
                .concat(table.ushortList('component', ligature.components, ligature.components.length + 1))
            );
        }));
    })));
};

subtableMakers[6] = function makeLookup6(subtable) {
    if (subtable.substFormat === 1) {
        var returnTable = new table.Table('chainContextTable', [
            {name: 'substFormat', type: 'USHORT', value: subtable.substFormat},
            {name: 'coverage', type: 'TABLE', value: new table.Coverage(subtable.coverage)}
        ].concat(table.tableList('chainRuleSet', subtable.chainRuleSets, function(chainRuleSet) {
            return new table.Table('chainRuleSetTable', table.tableList('chainRule', chainRuleSet, function(chainRule) {
                var tableData = table.ushortList('backtrackGlyph', chainRule.backtrack, chainRule.backtrack.length)
                    .concat(table.ushortList('inputGlyph', chainRule.input, chainRule.input.length + 1))
                    .concat(table.ushortList('lookaheadGlyph', chainRule.lookahead, chainRule.lookahead.length))
                    .concat(table.ushortList('substitution', [], chainRule.lookupRecords.length));

                chainRule.lookupRecords.forEach(function (record, i) {
                    tableData = tableData
                        .concat({name: 'sequenceIndex' + i, type: 'USHORT', value: record.sequenceIndex})
                        .concat({name: 'lookupListIndex' + i, type: 'USHORT', value: record.lookupListIndex});
                });
                return new table.Table('chainRuleTable', tableData);
            }));
        })));
        return returnTable;
    } else if (subtable.substFormat === 2) {
        check.assert(false, 'lookup type 6 format 2 is not yet supported.');
    } else if (subtable.substFormat === 3) {
        var tableData = [
            {name: 'substFormat', type: 'USHORT', value: subtable.substFormat} ];

        tableData.push({name: 'backtrackGlyphCount', type: 'USHORT', value: subtable.backtrackCoverage.length});
        subtable.backtrackCoverage.forEach(function (coverage, i) {
            tableData.push({name: 'backtrackCoverage' + i, type: 'TABLE', value: new table.Coverage(coverage)});
        });
        tableData.push({name: 'inputGlyphCount', type: 'USHORT', value: subtable.inputCoverage.length});
        subtable.inputCoverage.forEach(function (coverage, i) {
            tableData.push({name: 'inputCoverage' + i, type: 'TABLE', value: new table.Coverage(coverage)});
        });
        tableData.push({name: 'lookaheadGlyphCount', type: 'USHORT', value: subtable.lookaheadCoverage.length});
        subtable.lookaheadCoverage.forEach(function (coverage, i) {
            tableData.push({name: 'lookaheadCoverage' + i, type: 'TABLE', value: new table.Coverage(coverage)});
        });

        tableData.push({name: 'substitutionCount', type: 'USHORT', value: subtable.lookupRecords.length});
        subtable.lookupRecords.forEach(function (record, i) {
            tableData = tableData
                .concat({name: 'sequenceIndex' + i, type: 'USHORT', value: record.sequenceIndex})
                .concat({name: 'lookupListIndex' + i, type: 'USHORT', value: record.lookupListIndex});
        });

        var returnTable$1 = new table.Table('chainContextTable', tableData);

        return returnTable$1;
    }

    check.assert(false, 'lookup type 6 format must be 1, 2 or 3.');
};

function makeGsubTable(gsub) {
    return new table.Table('GSUB', [
        {name: 'version', type: 'ULONG', value: 0x10000},
        {name: 'scripts', type: 'TABLE', value: new table.ScriptList(gsub.scripts)},
        {name: 'features', type: 'TABLE', value: new table.FeatureList(gsub.features)},
        {name: 'lookups', type: 'TABLE', value: new table.LookupList(gsub.lookups, subtableMakers)}
    ]);
}

var gsub = { parse: parseGsubTable, make: makeGsubTable };

// The `GPOS` table contains kerning pairs, among other things.

// Parse the metadata `meta` table.
// https://developer.apple.com/fonts/TrueType-Reference-Manual/RM06/Chap6meta.html
function parseMetaTable(data, start) {
    var p = new parse.Parser(data, start);
    var tableVersion = p.parseULong();
    check.argument(tableVersion === 1, 'Unsupported META table version.');
    p.parseULong(); // flags - currently unused and set to 0
    p.parseULong(); // tableOffset
    var numDataMaps = p.parseULong();

    var tags = {};
    for (var i = 0; i < numDataMaps; i++) {
        var tag = p.parseTag();
        var dataOffset = p.parseULong();
        var dataLength = p.parseULong();
        var text = decode.UTF8(data, start + dataOffset, dataLength);

        tags[tag] = text;
    }
    return tags;
}

function makeMetaTable(tags) {
    var numTags = Object.keys(tags).length;
    var stringPool = '';
    var stringPoolOffset = 16 + numTags * 12;

    var result = new table.Table('meta', [
        {name: 'version', type: 'ULONG', value: 1},
        {name: 'flags', type: 'ULONG', value: 0},
        {name: 'offset', type: 'ULONG', value: stringPoolOffset},
        {name: 'numTags', type: 'ULONG', value: numTags}
    ]);

    for (var tag in tags) {
        var pos = stringPool.length;
        stringPool += tags[tag];

        result.fields.push({name: 'tag ' + tag, type: 'TAG', value: tag});
        result.fields.push({name: 'offset ' + tag, type: 'ULONG', value: stringPoolOffset + pos});
        result.fields.push({name: 'length ' + tag, type: 'ULONG', value: tags[tag].length});
    }

    result.fields.push({name: 'stringPool', type: 'CHARARRAY', value: stringPool});

    return result;
}

var meta = { parse: parseMetaTable, make: makeMetaTable };

// The `sfnt` wrapper provides organization for the tables in the font.

function log2(v) {
    return Math.log(v) / Math.log(2) | 0;
}

function computeCheckSum(bytes) {
    while (bytes.length % 4 !== 0) {
        bytes.push(0);
    }

    var sum = 0;
    for (var i = 0; i < bytes.length; i += 4) {
        sum += (bytes[i] << 24) +
            (bytes[i + 1] << 16) +
            (bytes[i + 2] << 8) +
            (bytes[i + 3]);
    }

    sum %= Math.pow(2, 32);
    return sum;
}

function makeTableRecord(tag, checkSum, offset, length) {
    return new table.Record('Table Record', [
        {name: 'tag', type: 'TAG', value: tag !== undefined ? tag : ''},
        {name: 'checkSum', type: 'ULONG', value: checkSum !== undefined ? checkSum : 0},
        {name: 'offset', type: 'ULONG', value: offset !== undefined ? offset : 0},
        {name: 'length', type: 'ULONG', value: length !== undefined ? length : 0}
    ]);
}

function makeSfntTable(tables) {
    var sfnt = new table.Table('sfnt', [
        {name: 'version', type: 'TAG', value: 'OTTO'},
        {name: 'numTables', type: 'USHORT', value: 0},
        {name: 'searchRange', type: 'USHORT', value: 0},
        {name: 'entrySelector', type: 'USHORT', value: 0},
        {name: 'rangeShift', type: 'USHORT', value: 0}
    ]);
    sfnt.tables = tables;
    sfnt.numTables = tables.length;
    var highestPowerOf2 = Math.pow(2, log2(sfnt.numTables));
    sfnt.searchRange = 16 * highestPowerOf2;
    sfnt.entrySelector = log2(highestPowerOf2);
    sfnt.rangeShift = sfnt.numTables * 16 - sfnt.searchRange;

    var recordFields = [];
    var tableFields = [];

    var offset = sfnt.sizeOf() + (makeTableRecord().sizeOf() * sfnt.numTables);
    while (offset % 4 !== 0) {
        offset += 1;
        tableFields.push({name: 'padding', type: 'BYTE', value: 0});
    }

    for (var i = 0; i < tables.length; i += 1) {
        var t = tables[i];
        check.argument(t.tableName.length === 4, 'Table name' + t.tableName + ' is invalid.');
        var tableLength = t.sizeOf();
        var tableRecord = makeTableRecord(t.tableName, computeCheckSum(t.encode()), offset, tableLength);
        recordFields.push({name: tableRecord.tag + ' Table Record', type: 'RECORD', value: tableRecord});
        tableFields.push({name: t.tableName + ' table', type: 'RECORD', value: t});
        offset += tableLength;
        check.argument(!isNaN(offset), 'Something went wrong calculating the offset.');
        while (offset % 4 !== 0) {
            offset += 1;
            tableFields.push({name: 'padding', type: 'BYTE', value: 0});
        }
    }

    // Table records need to be sorted alphabetically.
    recordFields.sort(function(r1, r2) {
        if (r1.value.tag > r2.value.tag) {
            return 1;
        } else {
            return -1;
        }
    });

    sfnt.fields = sfnt.fields.concat(recordFields);
    sfnt.fields = sfnt.fields.concat(tableFields);
    return sfnt;
}

// Get the metrics for a character. If the string has more than one character
// this function returns metrics for the first available character.
// You can provide optional fallback metrics if no characters are available.
function metricsForChar(font, chars, notFoundMetrics) {
    for (var i = 0; i < chars.length; i += 1) {
        var glyphIndex = font.charToGlyphIndex(chars[i]);
        if (glyphIndex > 0) {
            var glyph = font.glyphs.get(glyphIndex);
            return glyph.getMetrics();
        }
    }

    return notFoundMetrics;
}

function average(vs) {
    var sum = 0;
    for (var i = 0; i < vs.length; i += 1) {
        sum += vs[i];
    }

    return sum / vs.length;
}

// Convert the font object to a SFNT data structure.
// This structure contains all the necessary tables and metadata to create a binary OTF file.
function fontToSfntTable(font) {
    var xMins = [];
    var yMins = [];
    var xMaxs = [];
    var yMaxs = [];
    var advanceWidths = [];
    var leftSideBearings = [];
    var rightSideBearings = [];
    var firstCharIndex;
    var lastCharIndex = 0;
    var ulUnicodeRange1 = 0;
    var ulUnicodeRange2 = 0;
    var ulUnicodeRange3 = 0;
    var ulUnicodeRange4 = 0;

    for (var i = 0; i < font.glyphs.length; i += 1) {
        var glyph = font.glyphs.get(i);
        var unicode = glyph.unicode | 0;

        if (isNaN(glyph.advanceWidth)) {
            throw new Error('Glyph ' + glyph.name + ' (' + i + '): advanceWidth is not a number.');
        }

        if (firstCharIndex > unicode || firstCharIndex === undefined) {
            // ignore .notdef char
            if (unicode > 0) {
                firstCharIndex = unicode;
            }
        }

        if (lastCharIndex < unicode) {
            lastCharIndex = unicode;
        }

        var position = os2.getUnicodeRange(unicode);
        if (position < 32) {
            ulUnicodeRange1 |= 1 << position;
        } else if (position < 64) {
            ulUnicodeRange2 |= 1 << position - 32;
        } else if (position < 96) {
            ulUnicodeRange3 |= 1 << position - 64;
        } else if (position < 123) {
            ulUnicodeRange4 |= 1 << position - 96;
        } else {
            throw new Error('Unicode ranges bits > 123 are reserved for internal usage');
        }
        // Skip non-important characters.
        if (glyph.name === '.notdef') { continue; }
        var metrics = glyph.getMetrics();
        xMins.push(metrics.xMin);
        yMins.push(metrics.yMin);
        xMaxs.push(metrics.xMax);
        yMaxs.push(metrics.yMax);
        leftSideBearings.push(metrics.leftSideBearing);
        rightSideBearings.push(metrics.rightSideBearing);
        advanceWidths.push(glyph.advanceWidth);
    }

    var globals = {
        xMin: Math.min.apply(null, xMins),
        yMin: Math.min.apply(null, yMins),
        xMax: Math.max.apply(null, xMaxs),
        yMax: Math.max.apply(null, yMaxs),
        advanceWidthMax: Math.max.apply(null, advanceWidths),
        advanceWidthAvg: average(advanceWidths),
        minLeftSideBearing: Math.min.apply(null, leftSideBearings),
        maxLeftSideBearing: Math.max.apply(null, leftSideBearings),
        minRightSideBearing: Math.min.apply(null, rightSideBearings)
    };
    globals.ascender = font.ascender;
    globals.descender = font.descender;

    var headTable = head.make({
        flags: 3, // 00000011 (baseline for font at y=0; left sidebearing point at x=0)
        unitsPerEm: font.unitsPerEm,
        xMin: globals.xMin,
        yMin: globals.yMin,
        xMax: globals.xMax,
        yMax: globals.yMax,
        lowestRecPPEM: 3,
        createdTimestamp: font.createdTimestamp
    });

    var hheaTable = hhea.make({
        ascender: globals.ascender,
        descender: globals.descender,
        advanceWidthMax: globals.advanceWidthMax,
        minLeftSideBearing: globals.minLeftSideBearing,
        minRightSideBearing: globals.minRightSideBearing,
        xMaxExtent: globals.maxLeftSideBearing + (globals.xMax - globals.xMin),
        numberOfHMetrics: font.glyphs.length
    });

    var maxpTable = maxp.make(font.glyphs.length);

    var os2Table = os2.make(Object.assign({
        xAvgCharWidth: Math.round(globals.advanceWidthAvg),
        usFirstCharIndex: firstCharIndex,
        usLastCharIndex: lastCharIndex,
        ulUnicodeRange1: ulUnicodeRange1,
        ulUnicodeRange2: ulUnicodeRange2,
        ulUnicodeRange3: ulUnicodeRange3,
        ulUnicodeRange4: ulUnicodeRange4,
        // See http://typophile.com/node/13081 for more info on vertical metrics.
        // We get metrics for typical characters (such as "x" for xHeight).
        // We provide some fallback characters if characters are unavailable: their
        // ordering was chosen experimentally.
        sTypoAscender: globals.ascender,
        sTypoDescender: globals.descender,
        sTypoLineGap: 0,
        usWinAscent: globals.yMax,
        usWinDescent: Math.abs(globals.yMin),
        ulCodePageRange1: 1, // FIXME: hard-code Latin 1 support for now
        sxHeight: metricsForChar(font, 'xyvw', {yMax: Math.round(globals.ascender / 2)}).yMax,
        sCapHeight: metricsForChar(font, 'HIKLEFJMNTZBDPRAGOQSUVWXY', globals).yMax,
        usDefaultChar: font.hasChar(' ') ? 32 : 0, // Use space as the default character, if available.
        usBreakChar: font.hasChar(' ') ? 32 : 0, // Use space as the break character, if available.
    }, font.tables.os2));

    var hmtxTable = hmtx.make(font.glyphs);
    var cmapTable = cmap.make(font.glyphs);

    var englishFamilyName = font.getEnglishName('fontFamily');
    var englishStyleName = font.getEnglishName('fontSubfamily');
    var englishFullName = englishFamilyName + ' ' + englishStyleName;
    var postScriptName = font.getEnglishName('postScriptName');
    if (!postScriptName) {
        postScriptName = englishFamilyName.replace(/\s/g, '') + '-' + englishStyleName;
    }

    var names = {};
    for (var n in font.names) {
        names[n] = font.names[n];
    }

    if (!names.uniqueID) {
        names.uniqueID = {en: font.getEnglishName('manufacturer') + ':' + englishFullName};
    }

    if (!names.postScriptName) {
        names.postScriptName = {en: postScriptName};
    }

    if (!names.preferredFamily) {
        names.preferredFamily = font.names.fontFamily;
    }

    if (!names.preferredSubfamily) {
        names.preferredSubfamily = font.names.fontSubfamily;
    }

    var languageTags = [];
    var nameTable = _name.make(names, languageTags);
    var ltagTable = (languageTags.length > 0 ? ltag.make(languageTags) : undefined);

    var postTable = post.make();
    var cffTable = cff.make(font.glyphs, {
        version: font.getEnglishName('version'),
        fullName: englishFullName,
        familyName: englishFamilyName,
        weightName: englishStyleName,
        postScriptName: postScriptName,
        unitsPerEm: font.unitsPerEm,
        fontBBox: [0, globals.yMin, globals.ascender, globals.advanceWidthMax]
    });

    var metaTable = (font.metas && Object.keys(font.metas).length > 0) ? meta.make(font.metas) : undefined;

    // The order does not matter because makeSfntTable() will sort them.
    var tables = [headTable, hheaTable, maxpTable, os2Table, nameTable, cmapTable, postTable, cffTable, hmtxTable];
    if (ltagTable) {
        tables.push(ltagTable);
    }
    // Optional tables
    if (font.tables.gsub) {
        tables.push(gsub.make(font.tables.gsub));
    }
    if (metaTable) {
        tables.push(metaTable);
    }

    var sfntTable = makeSfntTable(tables);

    // Compute the font's checkSum and store it in head.checkSumAdjustment.
    var bytes = sfntTable.encode();
    var checkSum = computeCheckSum(bytes);
    var tableFields = sfntTable.fields;
    var checkSumAdjusted = false;
    for (var i$1 = 0; i$1 < tableFields.length; i$1 += 1) {
        if (tableFields[i$1].name === 'head table') {
            tableFields[i$1].value.checkSumAdjustment = 0xB1B0AFBA - checkSum;
            checkSumAdjusted = true;
            break;
        }
    }

    if (!checkSumAdjusted) {
        throw new Error('Could not find head table with checkSum to adjust.');
    }

    return sfntTable;
}

var sfnt = { make: makeSfntTable, fontToTable: fontToSfntTable, computeCheckSum: computeCheckSum };

// The Layout object is the prototype of Substitution objects, and provides

function searchTag(arr, tag) {
    /* jshint bitwise: false */
    var imin = 0;
    var imax = arr.length - 1;
    while (imin <= imax) {
        var imid = (imin + imax) >>> 1;
        var val = arr[imid].tag;
        if (val === tag) {
            return imid;
        } else if (val < tag) {
            imin = imid + 1;
        } else { imax = imid - 1; }
    }
    // Not found: return -1-insertion point
    return -imin - 1;
}

function binSearch(arr, value) {
    /* jshint bitwise: false */
    var imin = 0;
    var imax = arr.length - 1;
    while (imin <= imax) {
        var imid = (imin + imax) >>> 1;
        var val = arr[imid];
        if (val === value) {
            return imid;
        } else if (val < value) {
            imin = imid + 1;
        } else { imax = imid - 1; }
    }
    // Not found: return -1-insertion point
    return -imin - 1;
}

// binary search in a list of ranges (coverage, class definition)
function searchRange(ranges, value) {
    // jshint bitwise: false
    var range;
    var imin = 0;
    var imax = ranges.length - 1;
    while (imin <= imax) {
        var imid = (imin + imax) >>> 1;
        range = ranges[imid];
        var start = range.start;
        if (start === value) {
            return range;
        } else if (start < value) {
            imin = imid + 1;
        } else { imax = imid - 1; }
    }
    if (imin > 0) {
        range = ranges[imin - 1];
        if (value > range.end) { return 0; }
        return range;
    }
}

/**
 * @exports opentype.Layout
 * @class
 */
function Layout(font, tableName) {
    this.font = font;
    this.tableName = tableName;
}

Layout.prototype = {

    /**
     * Binary search an object by "tag" property
     * @instance
     * @function searchTag
     * @memberof opentype.Layout
     * @param  {Array} arr
     * @param  {string} tag
     * @return {number}
     */
    searchTag: searchTag,

    /**
     * Binary search in a list of numbers
     * @instance
     * @function binSearch
     * @memberof opentype.Layout
     * @param  {Array} arr
     * @param  {number} value
     * @return {number}
     */
    binSearch: binSearch,

    /**
     * Get or create the Layout table (GSUB, GPOS etc).
     * @param  {boolean} create - Whether to create a new one.
     * @return {Object} The GSUB or GPOS table.
     */
    getTable: function(create) {
        var layout = this.font.tables[this.tableName];
        if (!layout && create) {
            layout = this.font.tables[this.tableName] = this.createDefaultTable();
        }
        return layout;
    },

    /**
     * Returns all scripts in the substitution table.
     * @instance
     * @return {Array}
     */
    getScriptNames: function() {
        var layout = this.getTable();
        if (!layout) { return []; }
        return layout.scripts.map(function(script) {
            return script.tag;
        });
    },

    /**
     * Returns the best bet for a script name.
     * Returns 'DFLT' if it exists.
     * If not, returns 'latn' if it exists.
     * If neither exist, returns undefined.
     */
    getDefaultScriptName: function() {
        var layout = this.getTable();
        if (!layout) { return; }
        var hasLatn = false;
        for (var i = 0; i < layout.scripts.length; i++) {
            var name = layout.scripts[i].tag;
            if (name === 'DFLT') { return name; }
            if (name === 'latn') { hasLatn = true; }
        }
        if (hasLatn) { return 'latn'; }
    },

    /**
     * Returns all LangSysRecords in the given script.
     * @instance
     * @param {string} [script='DFLT']
     * @param {boolean} create - forces the creation of this script table if it doesn't exist.
     * @return {Object} An object with tag and script properties.
     */
    getScriptTable: function(script, create) {
        var layout = this.getTable(create);
        if (layout) {
            script = script || 'DFLT';
            var scripts = layout.scripts;
            var pos = searchTag(layout.scripts, script);
            if (pos >= 0) {
                return scripts[pos].script;
            } else if (create) {
                var scr = {
                    tag: script,
                    script: {
                        defaultLangSys: {reserved: 0, reqFeatureIndex: 0xffff, featureIndexes: []},
                        langSysRecords: []
                    }
                };
                scripts.splice(-1 - pos, 0, scr);
                return scr.script;
            }
        }
    },

    /**
     * Returns a language system table
     * @instance
     * @param {string} [script='DFLT']
     * @param {string} [language='dlft']
     * @param {boolean} create - forces the creation of this langSysTable if it doesn't exist.
     * @return {Object}
     */
    getLangSysTable: function(script, language, create) {
        var scriptTable = this.getScriptTable(script, create);
        if (scriptTable) {
            if (!language || language === 'dflt' || language === 'DFLT') {
                return scriptTable.defaultLangSys;
            }
            var pos = searchTag(scriptTable.langSysRecords, language);
            if (pos >= 0) {
                return scriptTable.langSysRecords[pos].langSys;
            } else if (create) {
                var langSysRecord = {
                    tag: language,
                    langSys: {reserved: 0, reqFeatureIndex: 0xffff, featureIndexes: []}
                };
                scriptTable.langSysRecords.splice(-1 - pos, 0, langSysRecord);
                return langSysRecord.langSys;
            }
        }
    },

    /**
     * Get a specific feature table.
     * @instance
     * @param {string} [script='DFLT']
     * @param {string} [language='dlft']
     * @param {string} feature - One of the codes listed at https://www.microsoft.com/typography/OTSPEC/featurelist.htm
     * @param {boolean} create - forces the creation of the feature table if it doesn't exist.
     * @return {Object}
     */
    getFeatureTable: function(script, language, feature, create) {
        var langSysTable = this.getLangSysTable(script, language, create);
        if (langSysTable) {
            var featureRecord;
            var featIndexes = langSysTable.featureIndexes;
            var allFeatures = this.font.tables[this.tableName].features;
            // The FeatureIndex array of indices is in arbitrary order,
            // even if allFeatures is sorted alphabetically by feature tag.
            for (var i = 0; i < featIndexes.length; i++) {
                featureRecord = allFeatures[featIndexes[i]];
                if (featureRecord.tag === feature) {
                    return featureRecord.feature;
                }
            }
            if (create) {
                var index = allFeatures.length;
                // Automatic ordering of features would require to shift feature indexes in the script list.
                check.assert(index === 0 || feature >= allFeatures[index - 1].tag, 'Features must be added in alphabetical order.');
                featureRecord = {
                    tag: feature,
                    feature: { params: 0, lookupListIndexes: [] }
                };
                allFeatures.push(featureRecord);
                featIndexes.push(index);
                return featureRecord.feature;
            }
        }
    },

    /**
     * Get the lookup tables of a given type for a script/language/feature.
     * @instance
     * @param {string} [script='DFLT']
     * @param {string} [language='dlft']
     * @param {string} feature - 4-letter feature code
     * @param {number} lookupType - 1 to 9
     * @param {boolean} create - forces the creation of the lookup table if it doesn't exist, with no subtables.
     * @return {Object[]}
     */
    getLookupTables: function(script, language, feature, lookupType, create) {
        var featureTable = this.getFeatureTable(script, language, feature, create);
        var tables = [];
        if (featureTable) {
            var lookupTable;
            var lookupListIndexes = featureTable.lookupListIndexes;
            var allLookups = this.font.tables[this.tableName].lookups;
            // lookupListIndexes are in no particular order, so use naive search.
            for (var i = 0; i < lookupListIndexes.length; i++) {
                lookupTable = allLookups[lookupListIndexes[i]];
                if (lookupTable.lookupType === lookupType) {
                    tables.push(lookupTable);
                }
            }
            if (tables.length === 0 && create) {
                lookupTable = {
                    lookupType: lookupType,
                    lookupFlag: 0,
                    subtables: [],
                    markFilteringSet: undefined
                };
                var index = allLookups.length;
                allLookups.push(lookupTable);
                lookupListIndexes.push(index);
                return [lookupTable];
            }
        }
        return tables;
    },

    /**
     * Find a glyph in a class definition table
     * https://docs.microsoft.com/en-us/typography/opentype/spec/chapter2#class-definition-table
     * @param {object} classDefTable - an OpenType Layout class definition table
     * @param {number} glyphIndex - the index of the glyph to find
     * @returns {number} -1 if not found
     */
    getGlyphClass: function(classDefTable, glyphIndex) {
        switch (classDefTable.format) {
            case 1:
                if (classDefTable.startGlyph <= glyphIndex && glyphIndex < classDefTable.startGlyph + classDefTable.classes.length) {
                    return classDefTable.classes[glyphIndex - classDefTable.startGlyph];
                }
                return 0;
            case 2:
                var range = searchRange(classDefTable.ranges, glyphIndex);
                return range ? range.classId : 0;
        }
    },

    /**
     * Find a glyph in a coverage table
     * https://docs.microsoft.com/en-us/typography/opentype/spec/chapter2#coverage-table
     * @param {object} coverageTable - an OpenType Layout coverage table
     * @param {number} glyphIndex - the index of the glyph to find
     * @returns {number} -1 if not found
     */
    getCoverageIndex: function(coverageTable, glyphIndex) {
        switch (coverageTable.format) {
            case 1:
                var index = binSearch(coverageTable.glyphs, glyphIndex);
                return index >= 0 ? index : -1;
            case 2:
                var range = searchRange(coverageTable.ranges, glyphIndex);
                return range ? range.index + glyphIndex - range.start : -1;
        }
    },

    /**
     * Returns the list of glyph indexes of a coverage table.
     * Format 1: the list is stored raw
     * Format 2: compact list as range records.
     * @instance
     * @param  {Object} coverageTable
     * @return {Array}
     */
    expandCoverage: function(coverageTable) {
        if (coverageTable.format === 1) {
            return coverageTable.glyphs;
        } else {
            var glyphs = [];
            var ranges = coverageTable.ranges;
            for (var i = 0; i < ranges.length; i++) {
                var range = ranges[i];
                var start = range.start;
                var end = range.end;
                for (var j = start; j <= end; j++) {
                    glyphs.push(j);
                }
            }
            return glyphs;
        }
    }

};

// The Position object provides utility methods to manipulate

/**
 * @exports opentype.Position
 * @class
 * @extends opentype.Layout
 * @param {opentype.Font}
 * @constructor
 */
function Position(font) {
    Layout.call(this, font, 'gpos');
}

Position.prototype = Layout.prototype;

/**
 * Init some data for faster and easier access later.
 */
Position.prototype.init = function() {
    var script = this.getDefaultScriptName();
    this.defaultKerningTables = this.getKerningTables(script);
};

/**
 * Find a glyph pair in a list of lookup tables of type 2 and retrieve the xAdvance kerning value.
 *
 * @param {integer} leftIndex - left glyph index
 * @param {integer} rightIndex - right glyph index
 * @returns {integer}
 */
Position.prototype.getKerningValue = function(kerningLookups, leftIndex, rightIndex) {
    for (var i = 0; i < kerningLookups.length; i++) {
        var subtables = kerningLookups[i].subtables;
        for (var j = 0; j < subtables.length; j++) {
            var subtable = subtables[j];
            var covIndex = this.getCoverageIndex(subtable.coverage, leftIndex);
            if (covIndex < 0) { continue; }
            switch (subtable.posFormat) {
                case 1:
                    // Search Pair Adjustment Positioning Format 1
                    var pairSet = subtable.pairSets[covIndex];
                    for (var k = 0; k < pairSet.length; k++) {
                        var pair = pairSet[k];
                        if (pair.secondGlyph === rightIndex) {
                            return pair.value1 && pair.value1.xAdvance || 0;
                        }
                    }
                    break;      // left glyph found, not right glyph - try next subtable
                case 2:
                    // Search Pair Adjustment Positioning Format 2
                    var class1 = this.getGlyphClass(subtable.classDef1, leftIndex);
                    var class2 = this.getGlyphClass(subtable.classDef2, rightIndex);
                    var pair$1 = subtable.classRecords[class1][class2];
                    return pair$1.value1 && pair$1.value1.xAdvance || 0;
            }
        }
    }
    return 0;
};

/**
 * List all kerning lookup tables.
 *
 * @param {string} [script='DFLT'] - use font.position.getDefaultScriptName() for a better default value
 * @param {string} [language='dflt']
 * @return {object[]} The list of kerning lookup tables (may be empty), or undefined if there is no GPOS table (and we should use the kern table)
 */
Position.prototype.getKerningTables = function(script, language) {
    if (this.font.tables.gpos) {
        return this.getLookupTables(script, language, 'kern', 2);
    }
};

// The Substitution object provides utility methods to manipulate

/**
 * @exports opentype.Substitution
 * @class
 * @extends opentype.Layout
 * @param {opentype.Font}
 * @constructor
 */
function Substitution(font) {
    Layout.call(this, font, 'gsub');
}

// Check if 2 arrays of primitives are equal.
function arraysEqual(ar1, ar2) {
    var n = ar1.length;
    if (n !== ar2.length) { return false; }
    for (var i = 0; i < n; i++) {
        if (ar1[i] !== ar2[i]) { return false; }
    }
    return true;
}

// Find the first subtable of a lookup table in a particular format.
function getSubstFormat(lookupTable, format, defaultSubtable) {
    var subtables = lookupTable.subtables;
    for (var i = 0; i < subtables.length; i++) {
        var subtable = subtables[i];
        if (subtable.substFormat === format) {
            return subtable;
        }
    }
    if (defaultSubtable) {
        subtables.push(defaultSubtable);
        return defaultSubtable;
    }
    return undefined;
}

Substitution.prototype = Layout.prototype;

/**
 * Create a default GSUB table.
 * @return {Object} gsub - The GSUB table.
 */
Substitution.prototype.createDefaultTable = function() {
    // Generate a default empty GSUB table with just a DFLT script and dflt lang sys.
    return {
        version: 1,
        scripts: [{
            tag: 'DFLT',
            script: {
                defaultLangSys: { reserved: 0, reqFeatureIndex: 0xffff, featureIndexes: [] },
                langSysRecords: []
            }
        }],
        features: [],
        lookups: []
    };
};

/**
 * List all single substitutions (lookup type 1) for a given script, language, and feature.
 * @param {string} [script='DFLT']
 * @param {string} [language='dflt']
 * @param {string} feature - 4-character feature name ('aalt', 'salt', 'ss01'...)
 * @return {Array} substitutions - The list of substitutions.
 */
Substitution.prototype.getSingle = function(feature, script, language) {
    var substitutions = [];
    var lookupTables = this.getLookupTables(script, language, feature, 1);
    for (var idx = 0; idx < lookupTables.length; idx++) {
        var subtables = lookupTables[idx].subtables;
        for (var i = 0; i < subtables.length; i++) {
            var subtable = subtables[i];
            var glyphs = this.expandCoverage(subtable.coverage);
            var j = (void 0);
            if (subtable.substFormat === 1) {
                var delta = subtable.deltaGlyphId;
                for (j = 0; j < glyphs.length; j++) {
                    var glyph = glyphs[j];
                    substitutions.push({ sub: glyph, by: glyph + delta });
                }
            } else {
                var substitute = subtable.substitute;
                for (j = 0; j < glyphs.length; j++) {
                    substitutions.push({ sub: glyphs[j], by: substitute[j] });
                }
            }
        }
    }
    return substitutions;
};

/**
 * List all multiple substitutions (lookup type 2) for a given script, language, and feature.
 * @param {string} [script='DFLT']
 * @param {string} [language='dflt']
 * @param {string} feature - 4-character feature name ('ccmp', 'stch')
 * @return {Array} substitutions - The list of substitutions.
 */
Substitution.prototype.getMultiple = function(feature, script, language) {
    var substitutions = [];
    var lookupTables = this.getLookupTables(script, language, feature, 2);
    for (var idx = 0; idx < lookupTables.length; idx++) {
        var subtables = lookupTables[idx].subtables;
        for (var i = 0; i < subtables.length; i++) {
            var subtable = subtables[i];
            var glyphs = this.expandCoverage(subtable.coverage);
            var j = (void 0);

            for (j = 0; j < glyphs.length; j++) {
                var glyph = glyphs[j];
                var replacements = subtable.sequences[j];
                substitutions.push({ sub: glyph, by: replacements });
            }
        }
    }
    return substitutions;
};

/**
 * List all alternates (lookup type 3) for a given script, language, and feature.
 * @param {string} [script='DFLT']
 * @param {string} [language='dflt']
 * @param {string} feature - 4-character feature name ('aalt', 'salt'...)
 * @return {Array} alternates - The list of alternates
 */
Substitution.prototype.getAlternates = function(feature, script, language) {
    var alternates = [];
    var lookupTables = this.getLookupTables(script, language, feature, 3);
    for (var idx = 0; idx < lookupTables.length; idx++) {
        var subtables = lookupTables[idx].subtables;
        for (var i = 0; i < subtables.length; i++) {
            var subtable = subtables[i];
            var glyphs = this.expandCoverage(subtable.coverage);
            var alternateSets = subtable.alternateSets;
            for (var j = 0; j < glyphs.length; j++) {
                alternates.push({ sub: glyphs[j], by: alternateSets[j] });
            }
        }
    }
    return alternates;
};

/**
 * List all ligatures (lookup type 4) for a given script, language, and feature.
 * The result is an array of ligature objects like { sub: [ids], by: id }
 * @param {string} feature - 4-letter feature name ('liga', 'rlig', 'dlig'...)
 * @param {string} [script='DFLT']
 * @param {string} [language='dflt']
 * @return {Array} ligatures - The list of ligatures.
 */
Substitution.prototype.getLigatures = function(feature, script, language) {
    var ligatures = [];
    var lookupTables = this.getLookupTables(script, language, feature, 4);
    for (var idx = 0; idx < lookupTables.length; idx++) {
        var subtables = lookupTables[idx].subtables;
        for (var i = 0; i < subtables.length; i++) {
            var subtable = subtables[i];
            var glyphs = this.expandCoverage(subtable.coverage);
            var ligatureSets = subtable.ligatureSets;
            for (var j = 0; j < glyphs.length; j++) {
                var startGlyph = glyphs[j];
                var ligSet = ligatureSets[j];
                for (var k = 0; k < ligSet.length; k++) {
                    var lig = ligSet[k];
                    ligatures.push({
                        sub: [startGlyph].concat(lig.components),
                        by: lig.ligGlyph
                    });
                }
            }
        }
    }
    return ligatures;
};

/**
 * Add or modify a single substitution (lookup type 1)
 * Format 2, more flexible, is always used.
 * @param {string} feature - 4-letter feature name ('liga', 'rlig', 'dlig'...)
 * @param {Object} substitution - { sub: id, by: id } (format 1 is not supported)
 * @param {string} [script='DFLT']
 * @param {string} [language='dflt']
 */
Substitution.prototype.addSingle = function(feature, substitution, script, language) {
    var lookupTable = this.getLookupTables(script, language, feature, 1, true)[0];
    var subtable = getSubstFormat(lookupTable, 2, {                // lookup type 1 subtable, format 2, coverage format 1
        substFormat: 2,
        coverage: {format: 1, glyphs: []},
        substitute: []
    });
    check.assert(subtable.coverage.format === 1, 'Single: unable to modify coverage table format ' + subtable.coverage.format);
    var coverageGlyph = substitution.sub;
    var pos = this.binSearch(subtable.coverage.glyphs, coverageGlyph);
    if (pos < 0) {
        pos = -1 - pos;
        subtable.coverage.glyphs.splice(pos, 0, coverageGlyph);
        subtable.substitute.splice(pos, 0, 0);
    }
    subtable.substitute[pos] = substitution.by;
};

/**
 * Add or modify a multiple substitution (lookup type 2)
 * @param {string} feature - 4-letter feature name ('ccmp', 'stch')
 * @param {Object} substitution - { sub: id, by: [id] } for format 2.
 * @param {string} [script='DFLT']
 * @param {string} [language='dflt']
 */
Substitution.prototype.addMultiple = function(feature, substitution, script, language) {
    check.assert(substitution.by instanceof Array && substitution.by.length > 1, 'Multiple: "by" must be an array of two or more ids');
    var lookupTable = this.getLookupTables(script, language, feature, 2, true)[0];
    var subtable = getSubstFormat(lookupTable, 1, {                // lookup type 2 subtable, format 1, coverage format 1
        substFormat: 1,
        coverage: {format: 1, glyphs: []},
        sequences: []
    });
    check.assert(subtable.coverage.format === 1, 'Multiple: unable to modify coverage table format ' + subtable.coverage.format);
    var coverageGlyph = substitution.sub;
    var pos = this.binSearch(subtable.coverage.glyphs, coverageGlyph);
    if (pos < 0) {
        pos = -1 - pos;
        subtable.coverage.glyphs.splice(pos, 0, coverageGlyph);
        subtable.sequences.splice(pos, 0, 0);
    }
    subtable.sequences[pos] = substitution.by;
};

/**
 * Add or modify an alternate substitution (lookup type 3)
 * @param {string} feature - 4-letter feature name ('liga', 'rlig', 'dlig'...)
 * @param {Object} substitution - { sub: id, by: [ids] }
 * @param {string} [script='DFLT']
 * @param {string} [language='dflt']
 */
Substitution.prototype.addAlternate = function(feature, substitution, script, language) {
    var lookupTable = this.getLookupTables(script, language, feature, 3, true)[0];
    var subtable = getSubstFormat(lookupTable, 1, {                // lookup type 3 subtable, format 1, coverage format 1
        substFormat: 1,
        coverage: {format: 1, glyphs: []},
        alternateSets: []
    });
    check.assert(subtable.coverage.format === 1, 'Alternate: unable to modify coverage table format ' + subtable.coverage.format);
    var coverageGlyph = substitution.sub;
    var pos = this.binSearch(subtable.coverage.glyphs, coverageGlyph);
    if (pos < 0) {
        pos = -1 - pos;
        subtable.coverage.glyphs.splice(pos, 0, coverageGlyph);
        subtable.alternateSets.splice(pos, 0, 0);
    }
    subtable.alternateSets[pos] = substitution.by;
};

/**
 * Add a ligature (lookup type 4)
 * Ligatures with more components must be stored ahead of those with fewer components in order to be found
 * @param {string} feature - 4-letter feature name ('liga', 'rlig', 'dlig'...)
 * @param {Object} ligature - { sub: [ids], by: id }
 * @param {string} [script='DFLT']
 * @param {string} [language='dflt']
 */
Substitution.prototype.addLigature = function(feature, ligature, script, language) {
    var lookupTable = this.getLookupTables(script, language, feature, 4, true)[0];
    var subtable = lookupTable.subtables[0];
    if (!subtable) {
        subtable = {                // lookup type 4 subtable, format 1, coverage format 1
            substFormat: 1,
            coverage: { format: 1, glyphs: [] },
            ligatureSets: []
        };
        lookupTable.subtables[0] = subtable;
    }
    check.assert(subtable.coverage.format === 1, 'Ligature: unable to modify coverage table format ' + subtable.coverage.format);
    var coverageGlyph = ligature.sub[0];
    var ligComponents = ligature.sub.slice(1);
    var ligatureTable = {
        ligGlyph: ligature.by,
        components: ligComponents
    };
    var pos = this.binSearch(subtable.coverage.glyphs, coverageGlyph);
    if (pos >= 0) {
        // ligatureSet already exists
        var ligatureSet = subtable.ligatureSets[pos];
        for (var i = 0; i < ligatureSet.length; i++) {
            // If ligature already exists, return.
            if (arraysEqual(ligatureSet[i].components, ligComponents)) {
                return;
            }
        }
        // ligature does not exist: add it.
        ligatureSet.push(ligatureTable);
    } else {
        // Create a new ligatureSet and add coverage for the first glyph.
        pos = -1 - pos;
        subtable.coverage.glyphs.splice(pos, 0, coverageGlyph);
        subtable.ligatureSets.splice(pos, 0, [ligatureTable]);
    }
};

/**
 * List all feature data for a given script and language.
 * @param {string} feature - 4-letter feature name
 * @param {string} [script='DFLT']
 * @param {string} [language='dflt']
 * @return {Array} substitutions - The list of substitutions.
 */
Substitution.prototype.getFeature = function(feature, script, language) {
    if (/ss\d\d/.test(feature)) {
        // ss01 - ss20
        return this.getSingle(feature, script, language);
    }
    switch (feature) {
        case 'aalt':
        case 'salt':
            return this.getSingle(feature, script, language)
                    .concat(this.getAlternates(feature, script, language));
        case 'dlig':
        case 'liga':
        case 'rlig':
            return this.getLigatures(feature, script, language);
        case 'ccmp':
            return this.getMultiple(feature, script, language)
                .concat(this.getLigatures(feature, script, language));
        case 'stch':
            return this.getMultiple(feature, script, language);
    }
    return undefined;
};

/**
 * Add a substitution to a feature for a given script and language.
 * @param {string} feature - 4-letter feature name
 * @param {Object} sub - the substitution to add (an object like { sub: id or [ids], by: id or [ids] })
 * @param {string} [script='DFLT']
 * @param {string} [language='dflt']
 */
Substitution.prototype.add = function(feature, sub, script, language) {
    if (/ss\d\d/.test(feature)) {
        // ss01 - ss20
        return this.addSingle(feature, sub, script, language);
    }
    switch (feature) {
        case 'aalt':
        case 'salt':
            if (typeof sub.by === 'number') {
                return this.addSingle(feature, sub, script, language);
            }
            return this.addAlternate(feature, sub, script, language);
        case 'dlig':
        case 'liga':
        case 'rlig':
            return this.addLigature(feature, sub, script, language);
        case 'ccmp':
            if (sub.by instanceof Array) {
                return this.addMultiple(feature, sub, script, language);
            }
            return this.addLigature(feature, sub, script, language);
    }
    return undefined;
};

function isBrowser() {
    return typeof window !== 'undefined';
}

function nodeBufferToArrayBuffer(buffer) {
    var ab = new ArrayBuffer(buffer.length);
    var view = new Uint8Array(ab);
    for (var i = 0; i < buffer.length; ++i) {
        view[i] = buffer[i];
    }

    return ab;
}

function arrayBufferToNodeBuffer(ab) {
    var buffer = new Buffer(ab.byteLength);
    var view = new Uint8Array(ab);
    for (var i = 0; i < buffer.length; ++i) {
        buffer[i] = view[i];
    }

    return buffer;
}

function checkArgument(expression, message) {
    if (!expression) {
        throw message;
    }
}

// The `glyf` table describes the glyphs in TrueType outline format.

// Parse the coordinate data for a glyph.
function parseGlyphCoordinate(p, flag, previousValue, shortVectorBitMask, sameBitMask) {
    var v;
    if ((flag & shortVectorBitMask) > 0) {
        // The coordinate is 1 byte long.
        v = p.parseByte();
        // The `same` bit is re-used for short values to signify the sign of the value.
        if ((flag & sameBitMask) === 0) {
            v = -v;
        }

        v = previousValue + v;
    } else {
        //  The coordinate is 2 bytes long.
        // If the `same` bit is set, the coordinate is the same as the previous coordinate.
        if ((flag & sameBitMask) > 0) {
            v = previousValue;
        } else {
            // Parse the coordinate as a signed 16-bit delta value.
            v = previousValue + p.parseShort();
        }
    }

    return v;
}

// Parse a TrueType glyph.
function parseGlyph(glyph, data, start) {
    var p = new parse.Parser(data, start);
    glyph.numberOfContours = p.parseShort();
    glyph._xMin = p.parseShort();
    glyph._yMin = p.parseShort();
    glyph._xMax = p.parseShort();
    glyph._yMax = p.parseShort();
    var flags;
    var flag;

    if (glyph.numberOfContours > 0) {
        // This glyph is not a composite.
        var endPointIndices = glyph.endPointIndices = [];
        for (var i = 0; i < glyph.numberOfContours; i += 1) {
            endPointIndices.push(p.parseUShort());
        }

        glyph.instructionLength = p.parseUShort();
        glyph.instructions = [];
        for (var i$1 = 0; i$1 < glyph.instructionLength; i$1 += 1) {
            glyph.instructions.push(p.parseByte());
        }

        var numberOfCoordinates = endPointIndices[endPointIndices.length - 1] + 1;
        flags = [];
        for (var i$2 = 0; i$2 < numberOfCoordinates; i$2 += 1) {
            flag = p.parseByte();
            flags.push(flag);
            // If bit 3 is set, we repeat this flag n times, where n is the next byte.
            if ((flag & 8) > 0) {
                var repeatCount = p.parseByte();
                for (var j = 0; j < repeatCount; j += 1) {
                    flags.push(flag);
                    i$2 += 1;
                }
            }
        }

        check.argument(flags.length === numberOfCoordinates, 'Bad flags.');

        if (endPointIndices.length > 0) {
            var points = [];
            var point;
            // X/Y coordinates are relative to the previous point, except for the first point which is relative to 0,0.
            if (numberOfCoordinates > 0) {
                for (var i$3 = 0; i$3 < numberOfCoordinates; i$3 += 1) {
                    flag = flags[i$3];
                    point = {};
                    point.onCurve = !!(flag & 1);
                    point.lastPointOfContour = endPointIndices.indexOf(i$3) >= 0;
                    points.push(point);
                }

                var px = 0;
                for (var i$4 = 0; i$4 < numberOfCoordinates; i$4 += 1) {
                    flag = flags[i$4];
                    point = points[i$4];
                    point.x = parseGlyphCoordinate(p, flag, px, 2, 16);
                    px = point.x;
                }

                var py = 0;
                for (var i$5 = 0; i$5 < numberOfCoordinates; i$5 += 1) {
                    flag = flags[i$5];
                    point = points[i$5];
                    point.y = parseGlyphCoordinate(p, flag, py, 4, 32);
                    py = point.y;
                }
            }

            glyph.points = points;
        } else {
            glyph.points = [];
        }
    } else if (glyph.numberOfContours === 0) {
        glyph.points = [];
    } else {
        glyph.isComposite = true;
        glyph.points = [];
        glyph.components = [];
        var moreComponents = true;
        while (moreComponents) {
            flags = p.parseUShort();
            var component = {
                glyphIndex: p.parseUShort(),
                xScale: 1,
                scale01: 0,
                scale10: 0,
                yScale: 1,
                dx: 0,
                dy: 0
            };
            if ((flags & 1) > 0) {
                // The arguments are words
                if ((flags & 2) > 0) {
                    // values are offset
                    component.dx = p.parseShort();
                    component.dy = p.parseShort();
                } else {
                    // values are matched points
                    component.matchedPoints = [p.parseUShort(), p.parseUShort()];
                }

            } else {
                // The arguments are bytes
                if ((flags & 2) > 0) {
                    // values are offset
                    component.dx = p.parseChar();
                    component.dy = p.parseChar();
                } else {
                    // values are matched points
                    component.matchedPoints = [p.parseByte(), p.parseByte()];
                }
            }

            if ((flags & 8) > 0) {
                // We have a scale
                component.xScale = component.yScale = p.parseF2Dot14();
            } else if ((flags & 64) > 0) {
                // We have an X / Y scale
                component.xScale = p.parseF2Dot14();
                component.yScale = p.parseF2Dot14();
            } else if ((flags & 128) > 0) {
                // We have a 2x2 transformation
                component.xScale = p.parseF2Dot14();
                component.scale01 = p.parseF2Dot14();
                component.scale10 = p.parseF2Dot14();
                component.yScale = p.parseF2Dot14();
            }

            glyph.components.push(component);
            moreComponents = !!(flags & 32);
        }
        if (flags & 0x100) {
            // We have instructions
            glyph.instructionLength = p.parseUShort();
            glyph.instructions = [];
            for (var i$6 = 0; i$6 < glyph.instructionLength; i$6 += 1) {
                glyph.instructions.push(p.parseByte());
            }
        }
    }
}

// Transform an array of points and return a new array.
function transformPoints(points, transform) {
    var newPoints = [];
    for (var i = 0; i < points.length; i += 1) {
        var pt = points[i];
        var newPt = {
            x: transform.xScale * pt.x + transform.scale01 * pt.y + transform.dx,
            y: transform.scale10 * pt.x + transform.yScale * pt.y + transform.dy,
            onCurve: pt.onCurve,
            lastPointOfContour: pt.lastPointOfContour
        };
        newPoints.push(newPt);
    }

    return newPoints;
}

function getContours(points) {
    var contours = [];
    var currentContour = [];
    for (var i = 0; i < points.length; i += 1) {
        var pt = points[i];
        currentContour.push(pt);
        if (pt.lastPointOfContour) {
            contours.push(currentContour);
            currentContour = [];
        }
    }

    check.argument(currentContour.length === 0, 'There are still points left in the current contour.');
    return contours;
}

// Convert the TrueType glyph outline to a Path.
function getPath(points) {
    var p = new Path();
    if (!points) {
        return p;
    }

    var contours = getContours(points);

    for (var contourIndex = 0; contourIndex < contours.length; ++contourIndex) {
        var contour = contours[contourIndex];

        var prev = null;
        var curr = contour[contour.length - 1];
        var next = contour[0];

        if (curr.onCurve) {
            p.moveTo(curr.x, curr.y);
        } else {
            if (next.onCurve) {
                p.moveTo(next.x, next.y);
            } else {
                // If both first and last points are off-curve, start at their middle.
                var start = {x: (curr.x + next.x) * 0.5, y: (curr.y + next.y) * 0.5};
                p.moveTo(start.x, start.y);
            }
        }

        for (var i = 0; i < contour.length; ++i) {
            prev = curr;
            curr = next;
            next = contour[(i + 1) % contour.length];

            if (curr.onCurve) {
                // This is a straight line.
                p.lineTo(curr.x, curr.y);
            } else {
                var next2 = next;

                if (!prev.onCurve) {
                    ({ x: (curr.x + prev.x) * 0.5, y: (curr.y + prev.y) * 0.5 });
                }

                if (!next.onCurve) {
                    next2 = { x: (curr.x + next.x) * 0.5, y: (curr.y + next.y) * 0.5 };
                }

                p.quadraticCurveTo(curr.x, curr.y, next2.x, next2.y);
            }
        }

        p.closePath();
    }
    return p;
}

function buildPath(glyphs, glyph) {
    if (glyph.isComposite) {
        for (var j = 0; j < glyph.components.length; j += 1) {
            var component = glyph.components[j];
            var componentGlyph = glyphs.get(component.glyphIndex);
            // Force the ttfGlyphLoader to parse the glyph.
            componentGlyph.getPath();
            if (componentGlyph.points) {
                var transformedPoints = (void 0);
                if (component.matchedPoints === undefined) {
                    // component positioned by offset
                    transformedPoints = transformPoints(componentGlyph.points, component);
                } else {
                    // component positioned by matched points
                    if ((component.matchedPoints[0] > glyph.points.length - 1) ||
                        (component.matchedPoints[1] > componentGlyph.points.length - 1)) {
                        throw Error('Matched points out of range in ' + glyph.name);
                    }
                    var firstPt = glyph.points[component.matchedPoints[0]];
                    var secondPt = componentGlyph.points[component.matchedPoints[1]];
                    var transform = {
                        xScale: component.xScale, scale01: component.scale01,
                        scale10: component.scale10, yScale: component.yScale,
                        dx: 0, dy: 0
                    };
                    secondPt = transformPoints([secondPt], transform)[0];
                    transform.dx = firstPt.x - secondPt.x;
                    transform.dy = firstPt.y - secondPt.y;
                    transformedPoints = transformPoints(componentGlyph.points, transform);
                }
                glyph.points = glyph.points.concat(transformedPoints);
            }
        }
    }

    return getPath(glyph.points);
}

function parseGlyfTableAll(data, start, loca, font) {
    var glyphs = new glyphset.GlyphSet(font);

    // The last element of the loca table is invalid.
    for (var i = 0; i < loca.length - 1; i += 1) {
        var offset = loca[i];
        var nextOffset = loca[i + 1];
        if (offset !== nextOffset) {
            glyphs.push(i, glyphset.ttfGlyphLoader(font, i, parseGlyph, data, start + offset, buildPath));
        } else {
            glyphs.push(i, glyphset.glyphLoader(font, i));
        }
    }

    return glyphs;
}

function parseGlyfTableOnLowMemory(data, start, loca, font) {
    var glyphs = new glyphset.GlyphSet(font);

    font._push = function(i) {
        var offset = loca[i];
        var nextOffset = loca[i + 1];
        if (offset !== nextOffset) {
            glyphs.push(i, glyphset.ttfGlyphLoader(font, i, parseGlyph, data, start + offset, buildPath));
        } else {
            glyphs.push(i, glyphset.glyphLoader(font, i));
        }
    };

    return glyphs;
}

// Parse all the glyphs according to the offsets from the `loca` table.
function parseGlyfTable(data, start, loca, font, opt) {
    if (opt.lowMemory)
        { return parseGlyfTableOnLowMemory(data, start, loca, font); }
    else
        { return parseGlyfTableAll(data, start, loca, font); }
}

var glyf = { getPath: getPath, parse: parseGlyfTable};

/* A TrueType font hinting interpreter.
*
* (c) 2017 Axel Kittenberger
*
* This interpreter has been implemented according to this documentation:
* https://developer.apple.com/fonts/TrueType-Reference-Manual/RM05/Chap5.html
*
* According to the documentation F24DOT6 values are used for pixels.
* That means calculation is 1/64 pixel accurate and uses integer operations.
* However, Javascript has floating point operations by default and only
* those are available. One could make a case to simulate the 1/64 accuracy
* exactly by truncating after every division operation
* (for example with << 0) to get pixel exactly results as other TrueType
* implementations. It may make sense since some fonts are pixel optimized
* by hand using DELTAP instructions. The current implementation doesn't
* and rather uses full floating point precision.
*
* xScale, yScale and rotation is currently ignored.
*
* A few non-trivial instructions are missing as I didn't encounter yet
* a font that used them to test a possible implementation.
*
* Some fonts seem to use undocumented features regarding the twilight zone.
* Only some of them are implemented as they were encountered.
*
* The exports.DEBUG statements are removed on the minified distribution file.
*/

var instructionTable;
var exec;
var execGlyph;
var execComponent;

/*
* Creates a hinting object.
*
* There ought to be exactly one
* for each truetype font that is used for hinting.
*/
function Hinting(font) {
    // the font this hinting object is for
    this.font = font;

    this.getCommands = function (hPoints) {
        return glyf.getPath(hPoints).commands;
    };

    // cached states
    this._fpgmState  =
    this._prepState  =
        undefined;

    // errorState
    // 0 ... all okay
    // 1 ... had an error in a glyf,
    //       continue working but stop spamming
    //       the console
    // 2 ... error at prep, stop hinting at this ppem
    // 3 ... error at fpeg, stop hinting for this font at all
    this._errorState = 0;
}

/*
* Not rounding.
*/
function roundOff(v) {
    return v;
}

/*
* Rounding to grid.
*/
function roundToGrid(v) {
    //Rounding in TT is supposed to "symmetrical around zero"
    return Math.sign(v) * Math.round(Math.abs(v));
}

/*
* Rounding to double grid.
*/
function roundToDoubleGrid(v) {
    return Math.sign(v) * Math.round(Math.abs(v * 2)) / 2;
}

/*
* Rounding to half grid.
*/
function roundToHalfGrid(v) {
    return Math.sign(v) * (Math.round(Math.abs(v) + 0.5) - 0.5);
}

/*
* Rounding to up to grid.
*/
function roundUpToGrid(v) {
    return Math.sign(v) * Math.ceil(Math.abs(v));
}

/*
* Rounding to down to grid.
*/
function roundDownToGrid(v) {
    return Math.sign(v) * Math.floor(Math.abs(v));
}

/*
* Super rounding.
*/
var roundSuper = function (v) {
    var period = this.srPeriod;
    var phase = this.srPhase;
    var threshold = this.srThreshold;
    var sign = 1;

    if (v < 0) {
        v = -v;
        sign = -1;
    }

    v += threshold - phase;

    v = Math.trunc(v / period) * period;

    v += phase;

    // according to http://xgridfit.sourceforge.net/round.html
    if (v < 0) { return phase * sign; }

    return v * sign;
};

/*
* Unit vector of x-axis.
*/
var xUnitVector = {
    x: 1,

    y: 0,

    axis: 'x',

    // Gets the projected distance between two points.
    // o1/o2 ... if true, respective original position is used.
    distance: function (p1, p2, o1, o2) {
        return (o1 ? p1.xo : p1.x) - (o2 ? p2.xo : p2.x);
    },

    // Moves point p so the moved position has the same relative
    // position to the moved positions of rp1 and rp2 than the
    // original positions had.
    //
    // See APPENDIX on INTERPOLATE at the bottom of this file.
    interpolate: function (p, rp1, rp2, pv) {
        var do1;
        var do2;
        var doa1;
        var doa2;
        var dm1;
        var dm2;
        var dt;

        if (!pv || pv === this) {
            do1 = p.xo - rp1.xo;
            do2 = p.xo - rp2.xo;
            dm1 = rp1.x - rp1.xo;
            dm2 = rp2.x - rp2.xo;
            doa1 = Math.abs(do1);
            doa2 = Math.abs(do2);
            dt = doa1 + doa2;

            if (dt === 0) {
                p.x = p.xo + (dm1 + dm2) / 2;
                return;
            }

            p.x = p.xo + (dm1 * doa2 + dm2 * doa1) / dt;
            return;
        }

        do1 = pv.distance(p, rp1, true, true);
        do2 = pv.distance(p, rp2, true, true);
        dm1 = pv.distance(rp1, rp1, false, true);
        dm2 = pv.distance(rp2, rp2, false, true);
        doa1 = Math.abs(do1);
        doa2 = Math.abs(do2);
        dt = doa1 + doa2;

        if (dt === 0) {
            xUnitVector.setRelative(p, p, (dm1 + dm2) / 2, pv, true);
            return;
        }

        xUnitVector.setRelative(p, p, (dm1 * doa2 + dm2 * doa1) / dt, pv, true);
    },

    // Slope of line normal to this
    normalSlope: Number.NEGATIVE_INFINITY,

    // Sets the point 'p' relative to point 'rp'
    // by the distance 'd'.
    //
    // See APPENDIX on SETRELATIVE at the bottom of this file.
    //
    // p   ... point to set
    // rp  ... reference point
    // d   ... distance on projection vector
    // pv  ... projection vector (undefined = this)
    // org ... if true, uses the original position of rp as reference.
    setRelative: function (p, rp, d, pv, org) {
        if (!pv || pv === this) {
            p.x = (org ? rp.xo : rp.x) + d;
            return;
        }

        var rpx = org ? rp.xo : rp.x;
        var rpy = org ? rp.yo : rp.y;
        var rpdx = rpx + d * pv.x;
        var rpdy = rpy + d * pv.y;

        p.x = rpdx + (p.y - rpdy) / pv.normalSlope;
    },

    // Slope of vector line.
    slope: 0,

    // Touches the point p.
    touch: function (p) {
        p.xTouched = true;
    },

    // Tests if a point p is touched.
    touched: function (p) {
        return p.xTouched;
    },

    // Untouches the point p.
    untouch: function (p) {
        p.xTouched = false;
    }
};

/*
* Unit vector of y-axis.
*/
var yUnitVector = {
    x: 0,

    y: 1,

    axis: 'y',

    // Gets the projected distance between two points.
    // o1/o2 ... if true, respective original position is used.
    distance: function (p1, p2, o1, o2) {
        return (o1 ? p1.yo : p1.y) - (o2 ? p2.yo : p2.y);
    },

    // Moves point p so the moved position has the same relative
    // position to the moved positions of rp1 and rp2 than the
    // original positions had.
    //
    // See APPENDIX on INTERPOLATE at the bottom of this file.
    interpolate: function (p, rp1, rp2, pv) {
        var do1;
        var do2;
        var doa1;
        var doa2;
        var dm1;
        var dm2;
        var dt;

        if (!pv || pv === this) {
            do1 = p.yo - rp1.yo;
            do2 = p.yo - rp2.yo;
            dm1 = rp1.y - rp1.yo;
            dm2 = rp2.y - rp2.yo;
            doa1 = Math.abs(do1);
            doa2 = Math.abs(do2);
            dt = doa1 + doa2;

            if (dt === 0) {
                p.y = p.yo + (dm1 + dm2) / 2;
                return;
            }

            p.y = p.yo + (dm1 * doa2 + dm2 * doa1) / dt;
            return;
        }

        do1 = pv.distance(p, rp1, true, true);
        do2 = pv.distance(p, rp2, true, true);
        dm1 = pv.distance(rp1, rp1, false, true);
        dm2 = pv.distance(rp2, rp2, false, true);
        doa1 = Math.abs(do1);
        doa2 = Math.abs(do2);
        dt = doa1 + doa2;

        if (dt === 0) {
            yUnitVector.setRelative(p, p, (dm1 + dm2) / 2, pv, true);
            return;
        }

        yUnitVector.setRelative(p, p, (dm1 * doa2 + dm2 * doa1) / dt, pv, true);
    },

    // Slope of line normal to this.
    normalSlope: 0,

    // Sets the point 'p' relative to point 'rp'
    // by the distance 'd'
    //
    // See APPENDIX on SETRELATIVE at the bottom of this file.
    //
    // p   ... point to set
    // rp  ... reference point
    // d   ... distance on projection vector
    // pv  ... projection vector (undefined = this)
    // org ... if true, uses the original position of rp as reference.
    setRelative: function (p, rp, d, pv, org) {
        if (!pv || pv === this) {
            p.y = (org ? rp.yo : rp.y) + d;
            return;
        }

        var rpx = org ? rp.xo : rp.x;
        var rpy = org ? rp.yo : rp.y;
        var rpdx = rpx + d * pv.x;
        var rpdy = rpy + d * pv.y;

        p.y = rpdy + pv.normalSlope * (p.x - rpdx);
    },

    // Slope of vector line.
    slope: Number.POSITIVE_INFINITY,

    // Touches the point p.
    touch: function (p) {
        p.yTouched = true;
    },

    // Tests if a point p is touched.
    touched: function (p) {
        return p.yTouched;
    },

    // Untouches the point p.
    untouch: function (p) {
        p.yTouched = false;
    }
};

Object.freeze(xUnitVector);
Object.freeze(yUnitVector);

/*
* Creates a unit vector that is not x- or y-axis.
*/
function UnitVector(x, y) {
    this.x = x;
    this.y = y;
    this.axis = undefined;
    this.slope = y / x;
    this.normalSlope = -x / y;
    Object.freeze(this);
}

/*
* Gets the projected distance between two points.
* o1/o2 ... if true, respective original position is used.
*/
UnitVector.prototype.distance = function(p1, p2, o1, o2) {
    return (
        this.x * xUnitVector.distance(p1, p2, o1, o2) +
        this.y * yUnitVector.distance(p1, p2, o1, o2)
    );
};

/*
* Moves point p so the moved position has the same relative
* position to the moved positions of rp1 and rp2 than the
* original positions had.
*
* See APPENDIX on INTERPOLATE at the bottom of this file.
*/
UnitVector.prototype.interpolate = function(p, rp1, rp2, pv) {
    var dm1;
    var dm2;
    var do1;
    var do2;
    var doa1;
    var doa2;
    var dt;

    do1 = pv.distance(p, rp1, true, true);
    do2 = pv.distance(p, rp2, true, true);
    dm1 = pv.distance(rp1, rp1, false, true);
    dm2 = pv.distance(rp2, rp2, false, true);
    doa1 = Math.abs(do1);
    doa2 = Math.abs(do2);
    dt = doa1 + doa2;

    if (dt === 0) {
        this.setRelative(p, p, (dm1 + dm2) / 2, pv, true);
        return;
    }

    this.setRelative(p, p, (dm1 * doa2 + dm2 * doa1) / dt, pv, true);
};

/*
* Sets the point 'p' relative to point 'rp'
* by the distance 'd'
*
* See APPENDIX on SETRELATIVE at the bottom of this file.
*
* p   ...  point to set
* rp  ... reference point
* d   ... distance on projection vector
* pv  ... projection vector (undefined = this)
* org ... if true, uses the original position of rp as reference.
*/
UnitVector.prototype.setRelative = function(p, rp, d, pv, org) {
    pv = pv || this;

    var rpx = org ? rp.xo : rp.x;
    var rpy = org ? rp.yo : rp.y;
    var rpdx = rpx + d * pv.x;
    var rpdy = rpy + d * pv.y;

    var pvns = pv.normalSlope;
    var fvs = this.slope;

    var px = p.x;
    var py = p.y;

    p.x = (fvs * px - pvns * rpdx + rpdy - py) / (fvs - pvns);
    p.y = fvs * (p.x - px) + py;
};

/*
* Touches the point p.
*/
UnitVector.prototype.touch = function(p) {
    p.xTouched = true;
    p.yTouched = true;
};

/*
* Returns a unit vector with x/y coordinates.
*/
function getUnitVector(x, y) {
    var d = Math.sqrt(x * x + y * y);

    x /= d;
    y /= d;

    if (x === 1 && y === 0) { return xUnitVector; }
    else if (x === 0 && y === 1) { return yUnitVector; }
    else { return new UnitVector(x, y); }
}

/*
* Creates a point in the hinting engine.
*/
function HPoint(
    x,
    y,
    lastPointOfContour,
    onCurve
) {
    this.x = this.xo = Math.round(x * 64) / 64; // hinted x value and original x-value
    this.y = this.yo = Math.round(y * 64) / 64; // hinted y value and original y-value

    this.lastPointOfContour = lastPointOfContour;
    this.onCurve = onCurve;
    this.prevPointOnContour = undefined;
    this.nextPointOnContour = undefined;
    this.xTouched = false;
    this.yTouched = false;

    Object.preventExtensions(this);
}

/*
* Returns the next touched point on the contour.
*
* v  ... unit vector to test touch axis.
*/
HPoint.prototype.nextTouched = function(v) {
    var p = this.nextPointOnContour;

    while (!v.touched(p) && p !== this) { p = p.nextPointOnContour; }

    return p;
};

/*
* Returns the previous touched point on the contour
*
* v  ... unit vector to test touch axis.
*/
HPoint.prototype.prevTouched = function(v) {
    var p = this.prevPointOnContour;

    while (!v.touched(p) && p !== this) { p = p.prevPointOnContour; }

    return p;
};

/*
* The zero point.
*/
var HPZero = Object.freeze(new HPoint(0, 0));

/*
* The default state of the interpreter.
*
* Note: Freezing the defaultState and then deriving from it
* makes the V8 Javascript engine going awkward,
* so this is avoided, albeit the defaultState shouldn't
* ever change.
*/
var defaultState = {
    cvCutIn: 17 / 16,    // control value cut in
    deltaBase: 9,
    deltaShift: 0.125,
    loop: 1,             // loops some instructions
    minDis: 1,           // minimum distance
    autoFlip: true
};

/*
* The current state of the interpreter.
*
* env  ... 'fpgm' or 'prep' or 'glyf'
* prog ... the program
*/
function State(env, prog) {
    this.env = env;
    this.stack = [];
    this.prog = prog;

    switch (env) {
        case 'glyf' :
            this.zp0 = this.zp1 = this.zp2 = 1;
            this.rp0 = this.rp1 = this.rp2 = 0;
            /* fall through */
        case 'prep' :
            this.fv = this.pv = this.dpv = xUnitVector;
            this.round = roundToGrid;
    }
}

/*
* Executes a glyph program.
*
* This does the hinting for each glyph.
*
* Returns an array of moved points.
*
* glyph: the glyph to hint
* ppem: the size the glyph is rendered for
*/
Hinting.prototype.exec = function(glyph, ppem) {
    if (typeof ppem !== 'number') {
        throw new Error('Point size is not a number!');
    }

    // Received a fatal error, don't do any hinting anymore.
    if (this._errorState > 2) { return; }

    var font = this.font;
    var prepState = this._prepState;

    if (!prepState || prepState.ppem !== ppem) {
        var fpgmState = this._fpgmState;

        if (!fpgmState) {
            // Executes the fpgm state.
            // This is used by fonts to define functions.
            State.prototype = defaultState;

            fpgmState =
            this._fpgmState =
                new State('fpgm', font.tables.fpgm);

            fpgmState.funcs = [ ];
            fpgmState.font = font;

            if (exports.DEBUG) {
                console.log('---EXEC FPGM---');
                fpgmState.step = -1;
            }

            try {
                exec(fpgmState);
            } catch (e) {
                console.log('Hinting error in FPGM:' + e);
                this._errorState = 3;
                return;
            }
        }

        // Executes the prep program for this ppem setting.
        // This is used by fonts to set cvt values
        // depending on to be rendered font size.

        State.prototype = fpgmState;
        prepState =
        this._prepState =
            new State('prep', font.tables.prep);

        prepState.ppem = ppem;

        // Creates a copy of the cvt table
        // and scales it to the current ppem setting.
        var oCvt = font.tables.cvt;
        if (oCvt) {
            var cvt = prepState.cvt = new Array(oCvt.length);
            var scale = ppem / font.unitsPerEm;
            for (var c = 0; c < oCvt.length; c++) {
                cvt[c] = oCvt[c] * scale;
            }
        } else {
            prepState.cvt = [];
        }

        if (exports.DEBUG) {
            console.log('---EXEC PREP---');
            prepState.step = -1;
        }

        try {
            exec(prepState);
        } catch (e) {
            if (this._errorState < 2) {
                console.log('Hinting error in PREP:' + e);
            }
            this._errorState = 2;
        }
    }

    if (this._errorState > 1) { return; }

    try {
        return execGlyph(glyph, prepState);
    } catch (e) {
        if (this._errorState < 1) {
            console.log('Hinting error:' + e);
            console.log('Note: further hinting errors are silenced');
        }
        this._errorState = 1;
        return undefined;
    }
};

/*
* Executes the hinting program for a glyph.
*/
execGlyph = function(glyph, prepState) {
    // original point positions
    var xScale = prepState.ppem / prepState.font.unitsPerEm;
    var yScale = xScale;
    var components = glyph.components;
    var contours;
    var gZone;
    var state;

    State.prototype = prepState;
    if (!components) {
        state = new State('glyf', glyph.instructions);
        if (exports.DEBUG) {
            console.log('---EXEC GLYPH---');
            state.step = -1;
        }
        execComponent(glyph, state, xScale, yScale);
        gZone = state.gZone;
    } else {
        var font = prepState.font;
        gZone = [];
        contours = [];
        for (var i = 0; i < components.length; i++) {
            var c = components[i];
            var cg = font.glyphs.get(c.glyphIndex);

            state = new State('glyf', cg.instructions);

            if (exports.DEBUG) {
                console.log('---EXEC COMP ' + i + '---');
                state.step = -1;
            }

            execComponent(cg, state, xScale, yScale);
            // appends the computed points to the result array
            // post processes the component points
            var dx = Math.round(c.dx * xScale);
            var dy = Math.round(c.dy * yScale);
            var gz = state.gZone;
            var cc = state.contours;
            for (var pi = 0; pi < gz.length; pi++) {
                var p = gz[pi];
                p.xTouched = p.yTouched = false;
                p.xo = p.x = p.x + dx;
                p.yo = p.y = p.y + dy;
            }

            var gLen = gZone.length;
            gZone.push.apply(gZone, gz);
            for (var j = 0; j < cc.length; j++) {
                contours.push(cc[j] + gLen);
            }
        }

        if (glyph.instructions && !state.inhibitGridFit) {
            // the composite has instructions on its own
            state = new State('glyf', glyph.instructions);

            state.gZone = state.z0 = state.z1 = state.z2 = gZone;

            state.contours = contours;

            // note: HPZero cannot be used here, since
            //       the point might be modified
            gZone.push(
                new HPoint(0, 0),
                new HPoint(Math.round(glyph.advanceWidth * xScale), 0)
            );

            if (exports.DEBUG) {
                console.log('---EXEC COMPOSITE---');
                state.step = -1;
            }

            exec(state);

            gZone.length -= 2;
        }
    }

    return gZone;
};

/*
* Executes the hinting program for a component of a multi-component glyph
* or of the glyph itself for a non-component glyph.
*/
execComponent = function(glyph, state, xScale, yScale)
{
    var points = glyph.points || [];
    var pLen = points.length;
    var gZone = state.gZone = state.z0 = state.z1 = state.z2 = [];
    var contours = state.contours = [];

    // Scales the original points and
    // makes copies for the hinted points.
    var cp; // current point
    for (var i = 0; i < pLen; i++) {
        cp = points[i];

        gZone[i] = new HPoint(
            cp.x * xScale,
            cp.y * yScale,
            cp.lastPointOfContour,
            cp.onCurve
        );
    }

    // Chain links the contours.
    var sp; // start point
    var np; // next point

    for (var i$1 = 0; i$1 < pLen; i$1++) {
        cp = gZone[i$1];

        if (!sp) {
            sp = cp;
            contours.push(i$1);
        }

        if (cp.lastPointOfContour) {
            cp.nextPointOnContour = sp;
            sp.prevPointOnContour = cp;
            sp = undefined;
        } else {
            np = gZone[i$1 + 1];
            cp.nextPointOnContour = np;
            np.prevPointOnContour = cp;
        }
    }

    if (state.inhibitGridFit) { return; }

    if (exports.DEBUG) {
        console.log('PROCESSING GLYPH', state.stack);
        for (var i$2 = 0; i$2 < pLen; i$2++) {
            console.log(i$2, gZone[i$2].x, gZone[i$2].y);
        }
    }

    gZone.push(
        new HPoint(0, 0),
        new HPoint(Math.round(glyph.advanceWidth * xScale), 0)
    );

    exec(state);

    // Removes the extra points.
    gZone.length -= 2;

    if (exports.DEBUG) {
        console.log('FINISHED GLYPH', state.stack);
        for (var i$3 = 0; i$3 < pLen; i$3++) {
            console.log(i$3, gZone[i$3].x, gZone[i$3].y);
        }
    }
};

/*
* Executes the program loaded in state.
*/
exec = function(state) {
    var prog = state.prog;

    if (!prog) { return; }

    var pLen = prog.length;
    var ins;

    for (state.ip = 0; state.ip < pLen; state.ip++) {
        if (exports.DEBUG) { state.step++; }
        ins = instructionTable[prog[state.ip]];

        if (!ins) {
            throw new Error(
                'unknown instruction: 0x' +
                Number(prog[state.ip]).toString(16)
            );
        }

        ins(state);

        // very extensive debugging for each step
        /*
        if (exports.DEBUG) {
            var da;
            if (state.gZone) {
                da = [];
                for (let i = 0; i < state.gZone.length; i++)
                {
                    da.push(i + ' ' +
                        state.gZone[i].x * 64 + ' ' +
                        state.gZone[i].y * 64 + ' ' +
                        (state.gZone[i].xTouched ? 'x' : '') +
                        (state.gZone[i].yTouched ? 'y' : '')
                    );
                }
                console.log('GZ', da);
            }

            if (state.tZone) {
                da = [];
                for (let i = 0; i < state.tZone.length; i++) {
                    da.push(i + ' ' +
                        state.tZone[i].x * 64 + ' ' +
                        state.tZone[i].y * 64 + ' ' +
                        (state.tZone[i].xTouched ? 'x' : '') +
                        (state.tZone[i].yTouched ? 'y' : '')
                    );
                }
                console.log('TZ', da);
            }

            if (state.stack.length > 10) {
                console.log(
                    state.stack.length,
                    '...', state.stack.slice(state.stack.length - 10)
                );
            } else {
                console.log(state.stack.length, state.stack);
            }
        }
        */
    }
};

/*
* Initializes the twilight zone.
*
* This is only done if a SZPx instruction
* refers to the twilight zone.
*/
function initTZone(state)
{
    var tZone = state.tZone = new Array(state.gZone.length);

    // no idea if this is actually correct...
    for (var i = 0; i < tZone.length; i++)
    {
        tZone[i] = new HPoint(0, 0);
    }
}

/*
* Skips the instruction pointer ahead over an IF/ELSE block.
* handleElse .. if true breaks on matching ELSE
*/
function skip(state, handleElse)
{
    var prog = state.prog;
    var ip = state.ip;
    var nesting = 1;
    var ins;

    do {
        ins = prog[++ip];
        if (ins === 0x58) // IF
            { nesting++; }
        else if (ins === 0x59) // EIF
            { nesting--; }
        else if (ins === 0x40) // NPUSHB
            { ip += prog[ip + 1] + 1; }
        else if (ins === 0x41) // NPUSHW
            { ip += 2 * prog[ip + 1] + 1; }
        else if (ins >= 0xB0 && ins <= 0xB7) // PUSHB
            { ip += ins - 0xB0 + 1; }
        else if (ins >= 0xB8 && ins <= 0xBF) // PUSHW
            { ip += (ins - 0xB8 + 1) * 2; }
        else if (handleElse && nesting === 1 && ins === 0x1B) // ELSE
            { break; }
    } while (nesting > 0);

    state.ip = ip;
}

/*----------------------------------------------------------*
*          And then a lot of instructions...                *
*----------------------------------------------------------*/

// SVTCA[a] Set freedom and projection Vectors To Coordinate Axis
// 0x00-0x01
function SVTCA(v, state) {
    if (exports.DEBUG) { console.log(state.step, 'SVTCA[' + v.axis + ']'); }

    state.fv = state.pv = state.dpv = v;
}

// SPVTCA[a] Set Projection Vector to Coordinate Axis
// 0x02-0x03
function SPVTCA(v, state) {
    if (exports.DEBUG) { console.log(state.step, 'SPVTCA[' + v.axis + ']'); }

    state.pv = state.dpv = v;
}

// SFVTCA[a] Set Freedom Vector to Coordinate Axis
// 0x04-0x05
function SFVTCA(v, state) {
    if (exports.DEBUG) { console.log(state.step, 'SFVTCA[' + v.axis + ']'); }

    state.fv = v;
}

// SPVTL[a] Set Projection Vector To Line
// 0x06-0x07
function SPVTL(a, state) {
    var stack = state.stack;
    var p2i = stack.pop();
    var p1i = stack.pop();
    var p2 = state.z2[p2i];
    var p1 = state.z1[p1i];

    if (exports.DEBUG) { console.log('SPVTL[' + a + ']', p2i, p1i); }

    var dx;
    var dy;

    if (!a) {
        dx = p1.x - p2.x;
        dy = p1.y - p2.y;
    } else {
        dx = p2.y - p1.y;
        dy = p1.x - p2.x;
    }

    state.pv = state.dpv = getUnitVector(dx, dy);
}

// SFVTL[a] Set Freedom Vector To Line
// 0x08-0x09
function SFVTL(a, state) {
    var stack = state.stack;
    var p2i = stack.pop();
    var p1i = stack.pop();
    var p2 = state.z2[p2i];
    var p1 = state.z1[p1i];

    if (exports.DEBUG) { console.log('SFVTL[' + a + ']', p2i, p1i); }

    var dx;
    var dy;

    if (!a) {
        dx = p1.x - p2.x;
        dy = p1.y - p2.y;
    } else {
        dx = p2.y - p1.y;
        dy = p1.x - p2.x;
    }

    state.fv = getUnitVector(dx, dy);
}

// SPVFS[] Set Projection Vector From Stack
// 0x0A
function SPVFS(state) {
    var stack = state.stack;
    var y = stack.pop();
    var x = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'SPVFS[]', y, x); }

    state.pv = state.dpv = getUnitVector(x, y);
}

// SFVFS[] Set Freedom Vector From Stack
// 0x0B
function SFVFS(state) {
    var stack = state.stack;
    var y = stack.pop();
    var x = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'SPVFS[]', y, x); }

    state.fv = getUnitVector(x, y);
}

// GPV[] Get Projection Vector
// 0x0C
function GPV(state) {
    var stack = state.stack;
    var pv = state.pv;

    if (exports.DEBUG) { console.log(state.step, 'GPV[]'); }

    stack.push(pv.x * 0x4000);
    stack.push(pv.y * 0x4000);
}

// GFV[] Get Freedom Vector
// 0x0C
function GFV(state) {
    var stack = state.stack;
    var fv = state.fv;

    if (exports.DEBUG) { console.log(state.step, 'GFV[]'); }

    stack.push(fv.x * 0x4000);
    stack.push(fv.y * 0x4000);
}

// SFVTPV[] Set Freedom Vector To Projection Vector
// 0x0E
function SFVTPV(state) {
    state.fv = state.pv;

    if (exports.DEBUG) { console.log(state.step, 'SFVTPV[]'); }
}

// ISECT[] moves point p to the InterSECTion of two lines
// 0x0F
function ISECT(state)
{
    var stack = state.stack;
    var pa0i = stack.pop();
    var pa1i = stack.pop();
    var pb0i = stack.pop();
    var pb1i = stack.pop();
    var pi = stack.pop();
    var z0 = state.z0;
    var z1 = state.z1;
    var pa0 = z0[pa0i];
    var pa1 = z0[pa1i];
    var pb0 = z1[pb0i];
    var pb1 = z1[pb1i];
    var p = state.z2[pi];

    if (exports.DEBUG) { console.log('ISECT[], ', pa0i, pa1i, pb0i, pb1i, pi); }

    // math from
    // en.wikipedia.org/wiki/Line%E2%80%93line_intersection#Given_two_points_on_each_line

    var x1 = pa0.x;
    var y1 = pa0.y;
    var x2 = pa1.x;
    var y2 = pa1.y;
    var x3 = pb0.x;
    var y3 = pb0.y;
    var x4 = pb1.x;
    var y4 = pb1.y;

    var div = (x1 - x2) * (y3 - y4) - (y1 - y2) * (x3 - x4);
    var f1 = x1 * y2 - y1 * x2;
    var f2 = x3 * y4 - y3 * x4;

    p.x = (f1 * (x3 - x4) - f2 * (x1 - x2)) / div;
    p.y = (f1 * (y3 - y4) - f2 * (y1 - y2)) / div;
}

// SRP0[] Set Reference Point 0
// 0x10
function SRP0(state) {
    state.rp0 = state.stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'SRP0[]', state.rp0); }
}

// SRP1[] Set Reference Point 1
// 0x11
function SRP1(state) {
    state.rp1 = state.stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'SRP1[]', state.rp1); }
}

// SRP1[] Set Reference Point 2
// 0x12
function SRP2(state) {
    state.rp2 = state.stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'SRP2[]', state.rp2); }
}

// SZP0[] Set Zone Pointer 0
// 0x13
function SZP0(state) {
    var n = state.stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'SZP0[]', n); }

    state.zp0 = n;

    switch (n) {
        case 0:
            if (!state.tZone) { initTZone(state); }
            state.z0 = state.tZone;
            break;
        case 1 :
            state.z0 = state.gZone;
            break;
        default :
            throw new Error('Invalid zone pointer');
    }
}

// SZP1[] Set Zone Pointer 1
// 0x14
function SZP1(state) {
    var n = state.stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'SZP1[]', n); }

    state.zp1 = n;

    switch (n) {
        case 0:
            if (!state.tZone) { initTZone(state); }
            state.z1 = state.tZone;
            break;
        case 1 :
            state.z1 = state.gZone;
            break;
        default :
            throw new Error('Invalid zone pointer');
    }
}

// SZP2[] Set Zone Pointer 2
// 0x15
function SZP2(state) {
    var n = state.stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'SZP2[]', n); }

    state.zp2 = n;

    switch (n) {
        case 0:
            if (!state.tZone) { initTZone(state); }
            state.z2 = state.tZone;
            break;
        case 1 :
            state.z2 = state.gZone;
            break;
        default :
            throw new Error('Invalid zone pointer');
    }
}

// SZPS[] Set Zone PointerS
// 0x16
function SZPS(state) {
    var n = state.stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'SZPS[]', n); }

    state.zp0 = state.zp1 = state.zp2 = n;

    switch (n) {
        case 0:
            if (!state.tZone) { initTZone(state); }
            state.z0 = state.z1 = state.z2 = state.tZone;
            break;
        case 1 :
            state.z0 = state.z1 = state.z2 = state.gZone;
            break;
        default :
            throw new Error('Invalid zone pointer');
    }
}

// SLOOP[] Set LOOP variable
// 0x17
function SLOOP(state) {
    state.loop = state.stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'SLOOP[]', state.loop); }
}

// RTG[] Round To Grid
// 0x18
function RTG(state) {
    if (exports.DEBUG) { console.log(state.step, 'RTG[]'); }

    state.round = roundToGrid;
}

// RTHG[] Round To Half Grid
// 0x19
function RTHG(state) {
    if (exports.DEBUG) { console.log(state.step, 'RTHG[]'); }

    state.round = roundToHalfGrid;
}

// SMD[] Set Minimum Distance
// 0x1A
function SMD(state) {
    var d = state.stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'SMD[]', d); }

    state.minDis = d / 0x40;
}

// ELSE[] ELSE clause
// 0x1B
function ELSE(state) {
    // This instruction has been reached by executing a then branch
    // so it just skips ahead until matching EIF.
    //
    // In case the IF was negative the IF[] instruction already
    // skipped forward over the ELSE[]

    if (exports.DEBUG) { console.log(state.step, 'ELSE[]'); }

    skip(state, false);
}

// JMPR[] JuMP Relative
// 0x1C
function JMPR(state) {
    var o = state.stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'JMPR[]', o); }

    // A jump by 1 would do nothing.
    state.ip += o - 1;
}

// SCVTCI[] Set Control Value Table Cut-In
// 0x1D
function SCVTCI(state) {
    var n = state.stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'SCVTCI[]', n); }

    state.cvCutIn = n / 0x40;
}

// DUP[] DUPlicate top stack element
// 0x20
function DUP(state) {
    var stack = state.stack;

    if (exports.DEBUG) { console.log(state.step, 'DUP[]'); }

    stack.push(stack[stack.length - 1]);
}

// POP[] POP top stack element
// 0x21
function POP(state) {
    if (exports.DEBUG) { console.log(state.step, 'POP[]'); }

    state.stack.pop();
}

// CLEAR[] CLEAR the stack
// 0x22
function CLEAR(state) {
    if (exports.DEBUG) { console.log(state.step, 'CLEAR[]'); }

    state.stack.length = 0;
}

// SWAP[] SWAP the top two elements on the stack
// 0x23
function SWAP(state) {
    var stack = state.stack;

    var a = stack.pop();
    var b = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'SWAP[]'); }

    stack.push(a);
    stack.push(b);
}

// DEPTH[] DEPTH of the stack
// 0x24
function DEPTH(state) {
    var stack = state.stack;

    if (exports.DEBUG) { console.log(state.step, 'DEPTH[]'); }

    stack.push(stack.length);
}

// LOOPCALL[] LOOPCALL function
// 0x2A
function LOOPCALL(state) {
    var stack = state.stack;
    var fn = stack.pop();
    var c = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'LOOPCALL[]', fn, c); }

    // saves callers program
    var cip = state.ip;
    var cprog = state.prog;

    state.prog = state.funcs[fn];

    // executes the function
    for (var i = 0; i < c; i++) {
        exec(state);

        if (exports.DEBUG) { console.log(
            ++state.step,
            i + 1 < c ? 'next loopcall' : 'done loopcall',
            i
        ); }
    }

    // restores the callers program
    state.ip = cip;
    state.prog = cprog;
}

// CALL[] CALL function
// 0x2B
function CALL(state) {
    var fn = state.stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'CALL[]', fn); }

    // saves callers program
    var cip = state.ip;
    var cprog = state.prog;

    state.prog = state.funcs[fn];

    // executes the function
    exec(state);

    // restores the callers program
    state.ip = cip;
    state.prog = cprog;

    if (exports.DEBUG) { console.log(++state.step, 'returning from', fn); }
}

// CINDEX[] Copy the INDEXed element to the top of the stack
// 0x25
function CINDEX(state) {
    var stack = state.stack;
    var k = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'CINDEX[]', k); }

    // In case of k == 1, it copies the last element after popping
    // thus stack.length - k.
    stack.push(stack[stack.length - k]);
}

// MINDEX[] Move the INDEXed element to the top of the stack
// 0x26
function MINDEX(state) {
    var stack = state.stack;
    var k = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'MINDEX[]', k); }

    stack.push(stack.splice(stack.length - k, 1)[0]);
}

// FDEF[] Function DEFinition
// 0x2C
function FDEF(state) {
    if (state.env !== 'fpgm') { throw new Error('FDEF not allowed here'); }
    var stack = state.stack;
    var prog = state.prog;
    var ip = state.ip;

    var fn = stack.pop();
    var ipBegin = ip;

    if (exports.DEBUG) { console.log(state.step, 'FDEF[]', fn); }

    while (prog[++ip] !== 0x2D){ }

    state.ip = ip;
    state.funcs[fn] = prog.slice(ipBegin + 1, ip);
}

// MDAP[a] Move Direct Absolute Point
// 0x2E-0x2F
function MDAP(round, state) {
    var pi = state.stack.pop();
    var p = state.z0[pi];
    var fv = state.fv;
    var pv = state.pv;

    if (exports.DEBUG) { console.log(state.step, 'MDAP[' + round + ']', pi); }

    var d = pv.distance(p, HPZero);

    if (round) { d = state.round(d); }

    fv.setRelative(p, HPZero, d, pv);
    fv.touch(p);

    state.rp0 = state.rp1 = pi;
}

// IUP[a] Interpolate Untouched Points through the outline
// 0x30
function IUP(v, state) {
    var z2 = state.z2;
    var pLen = z2.length - 2;
    var cp;
    var pp;
    var np;

    if (exports.DEBUG) { console.log(state.step, 'IUP[' + v.axis + ']'); }

    for (var i = 0; i < pLen; i++) {
        cp = z2[i]; // current point

        // if this point has been touched go on
        if (v.touched(cp)) { continue; }

        pp = cp.prevTouched(v);

        // no point on the contour has been touched?
        if (pp === cp) { continue; }

        np = cp.nextTouched(v);

        if (pp === np) {
            // only one point on the contour has been touched
            // so simply moves the point like that

            v.setRelative(cp, cp, v.distance(pp, pp, false, true), v, true);
        }

        v.interpolate(cp, pp, np, v);
    }
}

// SHP[] SHift Point using reference point
// 0x32-0x33
function SHP(a, state) {
    var stack = state.stack;
    var rpi = a ? state.rp1 : state.rp2;
    var rp = (a ? state.z0 : state.z1)[rpi];
    var fv = state.fv;
    var pv = state.pv;
    var loop = state.loop;
    var z2 = state.z2;

    while (loop--)
    {
        var pi = stack.pop();
        var p = z2[pi];

        var d = pv.distance(rp, rp, false, true);
        fv.setRelative(p, p, d, pv);
        fv.touch(p);

        if (exports.DEBUG) {
            console.log(
                state.step,
                (state.loop > 1 ?
                   'loop ' + (state.loop - loop) + ': ' :
                   ''
                ) +
                'SHP[' + (a ? 'rp1' : 'rp2') + ']', pi
            );
        }
    }

    state.loop = 1;
}

// SHC[] SHift Contour using reference point
// 0x36-0x37
function SHC(a, state) {
    var stack = state.stack;
    var rpi = a ? state.rp1 : state.rp2;
    var rp = (a ? state.z0 : state.z1)[rpi];
    var fv = state.fv;
    var pv = state.pv;
    var ci = stack.pop();
    var sp = state.z2[state.contours[ci]];
    var p = sp;

    if (exports.DEBUG) { console.log(state.step, 'SHC[' + a + ']', ci); }

    var d = pv.distance(rp, rp, false, true);

    do {
        if (p !== rp) { fv.setRelative(p, p, d, pv); }
        p = p.nextPointOnContour;
    } while (p !== sp);
}

// SHZ[] SHift Zone using reference point
// 0x36-0x37
function SHZ(a, state) {
    var stack = state.stack;
    var rpi = a ? state.rp1 : state.rp2;
    var rp = (a ? state.z0 : state.z1)[rpi];
    var fv = state.fv;
    var pv = state.pv;

    var e = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'SHZ[' + a + ']', e); }

    var z;
    switch (e) {
        case 0 : z = state.tZone; break;
        case 1 : z = state.gZone; break;
        default : throw new Error('Invalid zone');
    }

    var p;
    var d = pv.distance(rp, rp, false, true);
    var pLen = z.length - 2;
    for (var i = 0; i < pLen; i++)
    {
        p = z[i];
        fv.setRelative(p, p, d, pv);
        //if (p !== rp) fv.setRelative(p, p, d, pv);
    }
}

// SHPIX[] SHift point by a PIXel amount
// 0x38
function SHPIX(state) {
    var stack = state.stack;
    var loop = state.loop;
    var fv = state.fv;
    var d = stack.pop() / 0x40;
    var z2 = state.z2;

    while (loop--) {
        var pi = stack.pop();
        var p = z2[pi];

        if (exports.DEBUG) {
            console.log(
                state.step,
                (state.loop > 1 ? 'loop ' + (state.loop - loop) + ': ' : '') +
                'SHPIX[]', pi, d
            );
        }

        fv.setRelative(p, p, d);
        fv.touch(p);
    }

    state.loop = 1;
}

// IP[] Interpolate Point
// 0x39
function IP(state) {
    var stack = state.stack;
    var rp1i = state.rp1;
    var rp2i = state.rp2;
    var loop = state.loop;
    var rp1 = state.z0[rp1i];
    var rp2 = state.z1[rp2i];
    var fv = state.fv;
    var pv = state.dpv;
    var z2 = state.z2;

    while (loop--) {
        var pi = stack.pop();
        var p = z2[pi];

        if (exports.DEBUG) {
            console.log(
                state.step,
                (state.loop > 1 ? 'loop ' + (state.loop - loop) + ': ' : '') +
                'IP[]', pi, rp1i, '<->', rp2i
            );
        }

        fv.interpolate(p, rp1, rp2, pv);

        fv.touch(p);
    }

    state.loop = 1;
}

// MSIRP[a] Move Stack Indirect Relative Point
// 0x3A-0x3B
function MSIRP(a, state) {
    var stack = state.stack;
    var d = stack.pop() / 64;
    var pi = stack.pop();
    var p = state.z1[pi];
    var rp0 = state.z0[state.rp0];
    var fv = state.fv;
    var pv = state.pv;

    fv.setRelative(p, rp0, d, pv);
    fv.touch(p);

    if (exports.DEBUG) { console.log(state.step, 'MSIRP[' + a + ']', d, pi); }

    state.rp1 = state.rp0;
    state.rp2 = pi;
    if (a) { state.rp0 = pi; }
}

// ALIGNRP[] Align to reference point.
// 0x3C
function ALIGNRP(state) {
    var stack = state.stack;
    var rp0i = state.rp0;
    var rp0 = state.z0[rp0i];
    var loop = state.loop;
    var fv = state.fv;
    var pv = state.pv;
    var z1 = state.z1;

    while (loop--) {
        var pi = stack.pop();
        var p = z1[pi];

        if (exports.DEBUG) {
            console.log(
                state.step,
                (state.loop > 1 ? 'loop ' + (state.loop - loop) + ': ' : '') +
                'ALIGNRP[]', pi
            );
        }

        fv.setRelative(p, rp0, 0, pv);
        fv.touch(p);
    }

    state.loop = 1;
}

// RTG[] Round To Double Grid
// 0x3D
function RTDG(state) {
    if (exports.DEBUG) { console.log(state.step, 'RTDG[]'); }

    state.round = roundToDoubleGrid;
}

// MIAP[a] Move Indirect Absolute Point
// 0x3E-0x3F
function MIAP(round, state) {
    var stack = state.stack;
    var n = stack.pop();
    var pi = stack.pop();
    var p = state.z0[pi];
    var fv = state.fv;
    var pv = state.pv;
    var cv = state.cvt[n];

    if (exports.DEBUG) {
        console.log(
            state.step,
            'MIAP[' + round + ']',
            n, '(', cv, ')', pi
        );
    }

    var d = pv.distance(p, HPZero);

    if (round) {
        if (Math.abs(d - cv) < state.cvCutIn) { d = cv; }

        d = state.round(d);
    }

    fv.setRelative(p, HPZero, d, pv);

    if (state.zp0 === 0) {
        p.xo = p.x;
        p.yo = p.y;
    }

    fv.touch(p);

    state.rp0 = state.rp1 = pi;
}

// NPUSB[] PUSH N Bytes
// 0x40
function NPUSHB(state) {
    var prog = state.prog;
    var ip = state.ip;
    var stack = state.stack;

    var n = prog[++ip];

    if (exports.DEBUG) { console.log(state.step, 'NPUSHB[]', n); }

    for (var i = 0; i < n; i++) { stack.push(prog[++ip]); }

    state.ip = ip;
}

// NPUSHW[] PUSH N Words
// 0x41
function NPUSHW(state) {
    var ip = state.ip;
    var prog = state.prog;
    var stack = state.stack;
    var n = prog[++ip];

    if (exports.DEBUG) { console.log(state.step, 'NPUSHW[]', n); }

    for (var i = 0; i < n; i++) {
        var w = (prog[++ip] << 8) | prog[++ip];
        if (w & 0x8000) { w = -((w ^ 0xffff) + 1); }
        stack.push(w);
    }

    state.ip = ip;
}

// WS[] Write Store
// 0x42
function WS(state) {
    var stack = state.stack;
    var store = state.store;

    if (!store) { store = state.store = []; }

    var v = stack.pop();
    var l = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'WS', v, l); }

    store[l] = v;
}

// RS[] Read Store
// 0x43
function RS(state) {
    var stack = state.stack;
    var store = state.store;

    var l = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'RS', l); }

    var v = (store && store[l]) || 0;

    stack.push(v);
}

// WCVTP[] Write Control Value Table in Pixel units
// 0x44
function WCVTP(state) {
    var stack = state.stack;

    var v = stack.pop();
    var l = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'WCVTP', v, l); }

    state.cvt[l] = v / 0x40;
}

// RCVT[] Read Control Value Table entry
// 0x45
function RCVT(state) {
    var stack = state.stack;
    var cvte = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'RCVT', cvte); }

    stack.push(state.cvt[cvte] * 0x40);
}

// GC[] Get Coordinate projected onto the projection vector
// 0x46-0x47
function GC(a, state) {
    var stack = state.stack;
    var pi = stack.pop();
    var p = state.z2[pi];

    if (exports.DEBUG) { console.log(state.step, 'GC[' + a + ']', pi); }

    stack.push(state.dpv.distance(p, HPZero, a, false) * 0x40);
}

// MD[a] Measure Distance
// 0x49-0x4A
function MD(a, state) {
    var stack = state.stack;
    var pi2 = stack.pop();
    var pi1 = stack.pop();
    var p2 = state.z1[pi2];
    var p1 = state.z0[pi1];
    var d = state.dpv.distance(p1, p2, a, a);

    if (exports.DEBUG) { console.log(state.step, 'MD[' + a + ']', pi2, pi1, '->', d); }

    state.stack.push(Math.round(d * 64));
}

// MPPEM[] Measure Pixels Per EM
// 0x4B
function MPPEM(state) {
    if (exports.DEBUG) { console.log(state.step, 'MPPEM[]'); }
    state.stack.push(state.ppem);
}

// FLIPON[] set the auto FLIP Boolean to ON
// 0x4D
function FLIPON(state) {
    if (exports.DEBUG) { console.log(state.step, 'FLIPON[]'); }
    state.autoFlip = true;
}

// LT[] Less Than
// 0x50
function LT(state) {
    var stack = state.stack;
    var e2 = stack.pop();
    var e1 = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'LT[]', e2, e1); }

    stack.push(e1 < e2 ? 1 : 0);
}

// LTEQ[] Less Than or EQual
// 0x53
function LTEQ(state) {
    var stack = state.stack;
    var e2 = stack.pop();
    var e1 = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'LTEQ[]', e2, e1); }

    stack.push(e1 <= e2 ? 1 : 0);
}

// GTEQ[] Greater Than
// 0x52
function GT(state) {
    var stack = state.stack;
    var e2 = stack.pop();
    var e1 = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'GT[]', e2, e1); }

    stack.push(e1 > e2 ? 1 : 0);
}

// GTEQ[] Greater Than or EQual
// 0x53
function GTEQ(state) {
    var stack = state.stack;
    var e2 = stack.pop();
    var e1 = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'GTEQ[]', e2, e1); }

    stack.push(e1 >= e2 ? 1 : 0);
}

// EQ[] EQual
// 0x54
function EQ(state) {
    var stack = state.stack;
    var e2 = stack.pop();
    var e1 = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'EQ[]', e2, e1); }

    stack.push(e2 === e1 ? 1 : 0);
}

// NEQ[] Not EQual
// 0x55
function NEQ(state) {
    var stack = state.stack;
    var e2 = stack.pop();
    var e1 = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'NEQ[]', e2, e1); }

    stack.push(e2 !== e1 ? 1 : 0);
}

// ODD[] ODD
// 0x56
function ODD(state) {
    var stack = state.stack;
    var n = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'ODD[]', n); }

    stack.push(Math.trunc(n) % 2 ? 1 : 0);
}

// EVEN[] EVEN
// 0x57
function EVEN(state) {
    var stack = state.stack;
    var n = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'EVEN[]', n); }

    stack.push(Math.trunc(n) % 2 ? 0 : 1);
}

// IF[] IF test
// 0x58
function IF(state) {
    var test = state.stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'IF[]', test); }

    // if test is true it just continues
    // if not the ip is skipped until matching ELSE or EIF
    if (!test) {
        skip(state, true);

        if (exports.DEBUG) { console.log(state.step,  'EIF[]'); }
    }
}

// EIF[] End IF
// 0x59
function EIF(state) {
    // this can be reached normally when
    // executing an else branch.
    // -> just ignore it

    if (exports.DEBUG) { console.log(state.step, 'EIF[]'); }
}

// AND[] logical AND
// 0x5A
function AND(state) {
    var stack = state.stack;
    var e2 = stack.pop();
    var e1 = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'AND[]', e2, e1); }

    stack.push(e2 && e1 ? 1 : 0);
}

// OR[] logical OR
// 0x5B
function OR(state) {
    var stack = state.stack;
    var e2 = stack.pop();
    var e1 = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'OR[]', e2, e1); }

    stack.push(e2 || e1 ? 1 : 0);
}

// NOT[] logical NOT
// 0x5C
function NOT(state) {
    var stack = state.stack;
    var e = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'NOT[]', e); }

    stack.push(e ? 0 : 1);
}

// DELTAP1[] DELTA exception P1
// DELTAP2[] DELTA exception P2
// DELTAP3[] DELTA exception P3
// 0x5D, 0x71, 0x72
function DELTAP123(b, state) {
    var stack = state.stack;
    var n = stack.pop();
    var fv = state.fv;
    var pv = state.pv;
    var ppem = state.ppem;
    var base = state.deltaBase + (b - 1) * 16;
    var ds = state.deltaShift;
    var z0 = state.z0;

    if (exports.DEBUG) { console.log(state.step, 'DELTAP[' + b + ']', n, stack); }

    for (var i = 0; i < n; i++) {
        var pi = stack.pop();
        var arg = stack.pop();
        var appem = base + ((arg & 0xF0) >> 4);
        if (appem !== ppem) { continue; }

        var mag = (arg & 0x0F) - 8;
        if (mag >= 0) { mag++; }
        if (exports.DEBUG) { console.log(state.step, 'DELTAPFIX', pi, 'by', mag * ds); }

        var p = z0[pi];
        fv.setRelative(p, p, mag * ds, pv);
    }
}

// SDB[] Set Delta Base in the graphics state
// 0x5E
function SDB(state) {
    var stack = state.stack;
    var n = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'SDB[]', n); }

    state.deltaBase = n;
}

// SDS[] Set Delta Shift in the graphics state
// 0x5F
function SDS(state) {
    var stack = state.stack;
    var n = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'SDS[]', n); }

    state.deltaShift = Math.pow(0.5, n);
}

// ADD[] ADD
// 0x60
function ADD(state) {
    var stack = state.stack;
    var n2 = stack.pop();
    var n1 = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'ADD[]', n2, n1); }

    stack.push(n1 + n2);
}

// SUB[] SUB
// 0x61
function SUB(state) {
    var stack = state.stack;
    var n2 = stack.pop();
    var n1 = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'SUB[]', n2, n1); }

    stack.push(n1 - n2);
}

// DIV[] DIV
// 0x62
function DIV(state) {
    var stack = state.stack;
    var n2 = stack.pop();
    var n1 = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'DIV[]', n2, n1); }

    stack.push(n1 * 64 / n2);
}

// MUL[] MUL
// 0x63
function MUL(state) {
    var stack = state.stack;
    var n2 = stack.pop();
    var n1 = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'MUL[]', n2, n1); }

    stack.push(n1 * n2 / 64);
}

// ABS[] ABSolute value
// 0x64
function ABS(state) {
    var stack = state.stack;
    var n = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'ABS[]', n); }

    stack.push(Math.abs(n));
}

// NEG[] NEGate
// 0x65
function NEG(state) {
    var stack = state.stack;
    var n = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'NEG[]', n); }

    stack.push(-n);
}

// FLOOR[] FLOOR
// 0x66
function FLOOR(state) {
    var stack = state.stack;
    var n = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'FLOOR[]', n); }

    stack.push(Math.floor(n / 0x40) * 0x40);
}

// CEILING[] CEILING
// 0x67
function CEILING(state) {
    var stack = state.stack;
    var n = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'CEILING[]', n); }

    stack.push(Math.ceil(n / 0x40) * 0x40);
}

// ROUND[ab] ROUND value
// 0x68-0x6B
function ROUND(dt, state) {
    var stack = state.stack;
    var n = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'ROUND[]'); }

    stack.push(state.round(n / 0x40) * 0x40);
}

// WCVTF[] Write Control Value Table in Funits
// 0x70
function WCVTF(state) {
    var stack = state.stack;
    var v = stack.pop();
    var l = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'WCVTF[]', v, l); }

    state.cvt[l] = v * state.ppem / state.font.unitsPerEm;
}

// DELTAC1[] DELTA exception C1
// DELTAC2[] DELTA exception C2
// DELTAC3[] DELTA exception C3
// 0x73, 0x74, 0x75
function DELTAC123(b, state) {
    var stack = state.stack;
    var n = stack.pop();
    var ppem = state.ppem;
    var base = state.deltaBase + (b - 1) * 16;
    var ds = state.deltaShift;

    if (exports.DEBUG) { console.log(state.step, 'DELTAC[' + b + ']', n, stack); }

    for (var i = 0; i < n; i++) {
        var c = stack.pop();
        var arg = stack.pop();
        var appem = base + ((arg & 0xF0) >> 4);
        if (appem !== ppem) { continue; }

        var mag = (arg & 0x0F) - 8;
        if (mag >= 0) { mag++; }

        var delta = mag * ds;

        if (exports.DEBUG) { console.log(state.step, 'DELTACFIX', c, 'by', delta); }

        state.cvt[c] += delta;
    }
}

// SROUND[] Super ROUND
// 0x76
function SROUND(state) {
    var n = state.stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'SROUND[]', n); }

    state.round = roundSuper;

    var period;

    switch (n & 0xC0) {
        case 0x00:
            period = 0.5;
            break;
        case 0x40:
            period = 1;
            break;
        case 0x80:
            period = 2;
            break;
        default:
            throw new Error('invalid SROUND value');
    }

    state.srPeriod = period;

    switch (n & 0x30) {
        case 0x00:
            state.srPhase = 0;
            break;
        case 0x10:
            state.srPhase = 0.25 * period;
            break;
        case 0x20:
            state.srPhase = 0.5  * period;
            break;
        case 0x30:
            state.srPhase = 0.75 * period;
            break;
        default: throw new Error('invalid SROUND value');
    }

    n &= 0x0F;

    if (n === 0) { state.srThreshold = 0; }
    else { state.srThreshold = (n / 8 - 0.5) * period; }
}

// S45ROUND[] Super ROUND 45 degrees
// 0x77
function S45ROUND(state) {
    var n = state.stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'S45ROUND[]', n); }

    state.round = roundSuper;

    var period;

    switch (n & 0xC0) {
        case 0x00:
            period = Math.sqrt(2) / 2;
            break;
        case 0x40:
            period = Math.sqrt(2);
            break;
        case 0x80:
            period = 2 * Math.sqrt(2);
            break;
        default:
            throw new Error('invalid S45ROUND value');
    }

    state.srPeriod = period;

    switch (n & 0x30) {
        case 0x00:
            state.srPhase = 0;
            break;
        case 0x10:
            state.srPhase = 0.25 * period;
            break;
        case 0x20:
            state.srPhase = 0.5  * period;
            break;
        case 0x30:
            state.srPhase = 0.75 * period;
            break;
        default:
            throw new Error('invalid S45ROUND value');
    }

    n &= 0x0F;

    if (n === 0) { state.srThreshold = 0; }
    else { state.srThreshold = (n / 8 - 0.5) * period; }
}

// ROFF[] Round Off
// 0x7A
function ROFF(state) {
    if (exports.DEBUG) { console.log(state.step, 'ROFF[]'); }

    state.round = roundOff;
}

// RUTG[] Round Up To Grid
// 0x7C
function RUTG(state) {
    if (exports.DEBUG) { console.log(state.step, 'RUTG[]'); }

    state.round = roundUpToGrid;
}

// RDTG[] Round Down To Grid
// 0x7D
function RDTG(state) {
    if (exports.DEBUG) { console.log(state.step, 'RDTG[]'); }

    state.round = roundDownToGrid;
}

// SCANCTRL[] SCAN conversion ConTRoL
// 0x85
function SCANCTRL(state) {
    var n = state.stack.pop();

    // ignored by opentype.js

    if (exports.DEBUG) { console.log(state.step, 'SCANCTRL[]', n); }
}

// SDPVTL[a] Set Dual Projection Vector To Line
// 0x86-0x87
function SDPVTL(a, state) {
    var stack = state.stack;
    var p2i = stack.pop();
    var p1i = stack.pop();
    var p2 = state.z2[p2i];
    var p1 = state.z1[p1i];

    if (exports.DEBUG) { console.log(state.step, 'SDPVTL[' + a + ']', p2i, p1i); }

    var dx;
    var dy;

    if (!a) {
        dx = p1.x - p2.x;
        dy = p1.y - p2.y;
    } else {
        dx = p2.y - p1.y;
        dy = p1.x - p2.x;
    }

    state.dpv = getUnitVector(dx, dy);
}

// GETINFO[] GET INFOrmation
// 0x88
function GETINFO(state) {
    var stack = state.stack;
    var sel = stack.pop();
    var r = 0;

    if (exports.DEBUG) { console.log(state.step, 'GETINFO[]', sel); }

    // v35 as in no subpixel hinting
    if (sel & 0x01) { r = 35; }

    // TODO rotation and stretch currently not supported
    // and thus those GETINFO are always 0.

    // opentype.js is always gray scaling
    if (sel & 0x20) { r |= 0x1000; }

    stack.push(r);
}

// ROLL[] ROLL the top three stack elements
// 0x8A
function ROLL(state) {
    var stack = state.stack;
    var a = stack.pop();
    var b = stack.pop();
    var c = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'ROLL[]'); }

    stack.push(b);
    stack.push(a);
    stack.push(c);
}

// MAX[] MAXimum of top two stack elements
// 0x8B
function MAX(state) {
    var stack = state.stack;
    var e2 = stack.pop();
    var e1 = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'MAX[]', e2, e1); }

    stack.push(Math.max(e1, e2));
}

// MIN[] MINimum of top two stack elements
// 0x8C
function MIN(state) {
    var stack = state.stack;
    var e2 = stack.pop();
    var e1 = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'MIN[]', e2, e1); }

    stack.push(Math.min(e1, e2));
}

// SCANTYPE[] SCANTYPE
// 0x8D
function SCANTYPE(state) {
    var n = state.stack.pop();
    // ignored by opentype.js
    if (exports.DEBUG) { console.log(state.step, 'SCANTYPE[]', n); }
}

// INSTCTRL[] INSTCTRL
// 0x8D
function INSTCTRL(state) {
    var s = state.stack.pop();
    var v = state.stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'INSTCTRL[]', s, v); }

    switch (s) {
        case 1 : state.inhibitGridFit = !!v; return;
        case 2 : state.ignoreCvt = !!v; return;
        default: throw new Error('invalid INSTCTRL[] selector');
    }
}

// PUSHB[abc] PUSH Bytes
// 0xB0-0xB7
function PUSHB(n, state) {
    var stack = state.stack;
    var prog = state.prog;
    var ip = state.ip;

    if (exports.DEBUG) { console.log(state.step, 'PUSHB[' + n + ']'); }

    for (var i = 0; i < n; i++) { stack.push(prog[++ip]); }

    state.ip = ip;
}

// PUSHW[abc] PUSH Words
// 0xB8-0xBF
function PUSHW(n, state) {
    var ip = state.ip;
    var prog = state.prog;
    var stack = state.stack;

    if (exports.DEBUG) { console.log(state.ip, 'PUSHW[' + n + ']'); }

    for (var i = 0; i < n; i++) {
        var w = (prog[++ip] << 8) | prog[++ip];
        if (w & 0x8000) { w = -((w ^ 0xffff) + 1); }
        stack.push(w);
    }

    state.ip = ip;
}

// MDRP[abcde] Move Direct Relative Point
// 0xD0-0xEF
// (if indirect is 0)
//
// and
//
// MIRP[abcde] Move Indirect Relative Point
// 0xE0-0xFF
// (if indirect is 1)

function MDRP_MIRP(indirect, setRp0, keepD, ro, dt, state) {
    var stack = state.stack;
    var cvte = indirect && stack.pop();
    var pi = stack.pop();
    var rp0i = state.rp0;
    var rp = state.z0[rp0i];
    var p = state.z1[pi];

    var md = state.minDis;
    var fv = state.fv;
    var pv = state.dpv;
    var od; // original distance
    var d; // moving distance
    var sign; // sign of distance
    var cv;

    d = od = pv.distance(p, rp, true, true);
    sign = d >= 0 ? 1 : -1; // Math.sign would be 0 in case of 0

    // TODO consider autoFlip
    d = Math.abs(d);

    if (indirect) {
        cv = state.cvt[cvte];

        if (ro && Math.abs(d - cv) < state.cvCutIn) { d = cv; }
    }

    if (keepD && d < md) { d = md; }

    if (ro) { d = state.round(d); }

    fv.setRelative(p, rp, sign * d, pv);
    fv.touch(p);

    if (exports.DEBUG) {
        console.log(
            state.step,
            (indirect ? 'MIRP[' : 'MDRP[') +
            (setRp0 ? 'M' : 'm') +
            (keepD ? '>' : '_') +
            (ro ? 'R' : '_') +
            (dt === 0 ? 'Gr' : (dt === 1 ? 'Bl' : (dt === 2 ? 'Wh' : ''))) +
            ']',
            indirect ?
                cvte + '(' + state.cvt[cvte] + ',' +  cv + ')' :
                '',
            pi,
            '(d =', od, '->', sign * d, ')'
        );
    }

    state.rp1 = state.rp0;
    state.rp2 = pi;
    if (setRp0) { state.rp0 = pi; }
}

/*
* The instruction table.
*/
instructionTable = [
    /* 0x00 */ SVTCA.bind(undefined, yUnitVector),
    /* 0x01 */ SVTCA.bind(undefined, xUnitVector),
    /* 0x02 */ SPVTCA.bind(undefined, yUnitVector),
    /* 0x03 */ SPVTCA.bind(undefined, xUnitVector),
    /* 0x04 */ SFVTCA.bind(undefined, yUnitVector),
    /* 0x05 */ SFVTCA.bind(undefined, xUnitVector),
    /* 0x06 */ SPVTL.bind(undefined, 0),
    /* 0x07 */ SPVTL.bind(undefined, 1),
    /* 0x08 */ SFVTL.bind(undefined, 0),
    /* 0x09 */ SFVTL.bind(undefined, 1),
    /* 0x0A */ SPVFS,
    /* 0x0B */ SFVFS,
    /* 0x0C */ GPV,
    /* 0x0D */ GFV,
    /* 0x0E */ SFVTPV,
    /* 0x0F */ ISECT,
    /* 0x10 */ SRP0,
    /* 0x11 */ SRP1,
    /* 0x12 */ SRP2,
    /* 0x13 */ SZP0,
    /* 0x14 */ SZP1,
    /* 0x15 */ SZP2,
    /* 0x16 */ SZPS,
    /* 0x17 */ SLOOP,
    /* 0x18 */ RTG,
    /* 0x19 */ RTHG,
    /* 0x1A */ SMD,
    /* 0x1B */ ELSE,
    /* 0x1C */ JMPR,
    /* 0x1D */ SCVTCI,
    /* 0x1E */ undefined,   // TODO SSWCI
    /* 0x1F */ undefined,   // TODO SSW
    /* 0x20 */ DUP,
    /* 0x21 */ POP,
    /* 0x22 */ CLEAR,
    /* 0x23 */ SWAP,
    /* 0x24 */ DEPTH,
    /* 0x25 */ CINDEX,
    /* 0x26 */ MINDEX,
    /* 0x27 */ undefined,   // TODO ALIGNPTS
    /* 0x28 */ undefined,
    /* 0x29 */ undefined,   // TODO UTP
    /* 0x2A */ LOOPCALL,
    /* 0x2B */ CALL,
    /* 0x2C */ FDEF,
    /* 0x2D */ undefined,   // ENDF (eaten by FDEF)
    /* 0x2E */ MDAP.bind(undefined, 0),
    /* 0x2F */ MDAP.bind(undefined, 1),
    /* 0x30 */ IUP.bind(undefined, yUnitVector),
    /* 0x31 */ IUP.bind(undefined, xUnitVector),
    /* 0x32 */ SHP.bind(undefined, 0),
    /* 0x33 */ SHP.bind(undefined, 1),
    /* 0x34 */ SHC.bind(undefined, 0),
    /* 0x35 */ SHC.bind(undefined, 1),
    /* 0x36 */ SHZ.bind(undefined, 0),
    /* 0x37 */ SHZ.bind(undefined, 1),
    /* 0x38 */ SHPIX,
    /* 0x39 */ IP,
    /* 0x3A */ MSIRP.bind(undefined, 0),
    /* 0x3B */ MSIRP.bind(undefined, 1),
    /* 0x3C */ ALIGNRP,
    /* 0x3D */ RTDG,
    /* 0x3E */ MIAP.bind(undefined, 0),
    /* 0x3F */ MIAP.bind(undefined, 1),
    /* 0x40 */ NPUSHB,
    /* 0x41 */ NPUSHW,
    /* 0x42 */ WS,
    /* 0x43 */ RS,
    /* 0x44 */ WCVTP,
    /* 0x45 */ RCVT,
    /* 0x46 */ GC.bind(undefined, 0),
    /* 0x47 */ GC.bind(undefined, 1),
    /* 0x48 */ undefined,   // TODO SCFS
    /* 0x49 */ MD.bind(undefined, 0),
    /* 0x4A */ MD.bind(undefined, 1),
    /* 0x4B */ MPPEM,
    /* 0x4C */ undefined,   // TODO MPS
    /* 0x4D */ FLIPON,
    /* 0x4E */ undefined,   // TODO FLIPOFF
    /* 0x4F */ undefined,   // TODO DEBUG
    /* 0x50 */ LT,
    /* 0x51 */ LTEQ,
    /* 0x52 */ GT,
    /* 0x53 */ GTEQ,
    /* 0x54 */ EQ,
    /* 0x55 */ NEQ,
    /* 0x56 */ ODD,
    /* 0x57 */ EVEN,
    /* 0x58 */ IF,
    /* 0x59 */ EIF,
    /* 0x5A */ AND,
    /* 0x5B */ OR,
    /* 0x5C */ NOT,
    /* 0x5D */ DELTAP123.bind(undefined, 1),
    /* 0x5E */ SDB,
    /* 0x5F */ SDS,
    /* 0x60 */ ADD,
    /* 0x61 */ SUB,
    /* 0x62 */ DIV,
    /* 0x63 */ MUL,
    /* 0x64 */ ABS,
    /* 0x65 */ NEG,
    /* 0x66 */ FLOOR,
    /* 0x67 */ CEILING,
    /* 0x68 */ ROUND.bind(undefined, 0),
    /* 0x69 */ ROUND.bind(undefined, 1),
    /* 0x6A */ ROUND.bind(undefined, 2),
    /* 0x6B */ ROUND.bind(undefined, 3),
    /* 0x6C */ undefined,   // TODO NROUND[ab]
    /* 0x6D */ undefined,   // TODO NROUND[ab]
    /* 0x6E */ undefined,   // TODO NROUND[ab]
    /* 0x6F */ undefined,   // TODO NROUND[ab]
    /* 0x70 */ WCVTF,
    /* 0x71 */ DELTAP123.bind(undefined, 2),
    /* 0x72 */ DELTAP123.bind(undefined, 3),
    /* 0x73 */ DELTAC123.bind(undefined, 1),
    /* 0x74 */ DELTAC123.bind(undefined, 2),
    /* 0x75 */ DELTAC123.bind(undefined, 3),
    /* 0x76 */ SROUND,
    /* 0x77 */ S45ROUND,
    /* 0x78 */ undefined,   // TODO JROT[]
    /* 0x79 */ undefined,   // TODO JROF[]
    /* 0x7A */ ROFF,
    /* 0x7B */ undefined,
    /* 0x7C */ RUTG,
    /* 0x7D */ RDTG,
    /* 0x7E */ POP, // actually SANGW, supposed to do only a pop though
    /* 0x7F */ POP, // actually AA, supposed to do only a pop though
    /* 0x80 */ undefined,   // TODO FLIPPT
    /* 0x81 */ undefined,   // TODO FLIPRGON
    /* 0x82 */ undefined,   // TODO FLIPRGOFF
    /* 0x83 */ undefined,
    /* 0x84 */ undefined,
    /* 0x85 */ SCANCTRL,
    /* 0x86 */ SDPVTL.bind(undefined, 0),
    /* 0x87 */ SDPVTL.bind(undefined, 1),
    /* 0x88 */ GETINFO,
    /* 0x89 */ undefined,   // TODO IDEF
    /* 0x8A */ ROLL,
    /* 0x8B */ MAX,
    /* 0x8C */ MIN,
    /* 0x8D */ SCANTYPE,
    /* 0x8E */ INSTCTRL,
    /* 0x8F */ undefined,
    /* 0x90 */ undefined,
    /* 0x91 */ undefined,
    /* 0x92 */ undefined,
    /* 0x93 */ undefined,
    /* 0x94 */ undefined,
    /* 0x95 */ undefined,
    /* 0x96 */ undefined,
    /* 0x97 */ undefined,
    /* 0x98 */ undefined,
    /* 0x99 */ undefined,
    /* 0x9A */ undefined,
    /* 0x9B */ undefined,
    /* 0x9C */ undefined,
    /* 0x9D */ undefined,
    /* 0x9E */ undefined,
    /* 0x9F */ undefined,
    /* 0xA0 */ undefined,
    /* 0xA1 */ undefined,
    /* 0xA2 */ undefined,
    /* 0xA3 */ undefined,
    /* 0xA4 */ undefined,
    /* 0xA5 */ undefined,
    /* 0xA6 */ undefined,
    /* 0xA7 */ undefined,
    /* 0xA8 */ undefined,
    /* 0xA9 */ undefined,
    /* 0xAA */ undefined,
    /* 0xAB */ undefined,
    /* 0xAC */ undefined,
    /* 0xAD */ undefined,
    /* 0xAE */ undefined,
    /* 0xAF */ undefined,
    /* 0xB0 */ PUSHB.bind(undefined, 1),
    /* 0xB1 */ PUSHB.bind(undefined, 2),
    /* 0xB2 */ PUSHB.bind(undefined, 3),
    /* 0xB3 */ PUSHB.bind(undefined, 4),
    /* 0xB4 */ PUSHB.bind(undefined, 5),
    /* 0xB5 */ PUSHB.bind(undefined, 6),
    /* 0xB6 */ PUSHB.bind(undefined, 7),
    /* 0xB7 */ PUSHB.bind(undefined, 8),
    /* 0xB8 */ PUSHW.bind(undefined, 1),
    /* 0xB9 */ PUSHW.bind(undefined, 2),
    /* 0xBA */ PUSHW.bind(undefined, 3),
    /* 0xBB */ PUSHW.bind(undefined, 4),
    /* 0xBC */ PUSHW.bind(undefined, 5),
    /* 0xBD */ PUSHW.bind(undefined, 6),
    /* 0xBE */ PUSHW.bind(undefined, 7),
    /* 0xBF */ PUSHW.bind(undefined, 8),
    /* 0xC0 */ MDRP_MIRP.bind(undefined, 0, 0, 0, 0, 0),
    /* 0xC1 */ MDRP_MIRP.bind(undefined, 0, 0, 0, 0, 1),
    /* 0xC2 */ MDRP_MIRP.bind(undefined, 0, 0, 0, 0, 2),
    /* 0xC3 */ MDRP_MIRP.bind(undefined, 0, 0, 0, 0, 3),
    /* 0xC4 */ MDRP_MIRP.bind(undefined, 0, 0, 0, 1, 0),
    /* 0xC5 */ MDRP_MIRP.bind(undefined, 0, 0, 0, 1, 1),
    /* 0xC6 */ MDRP_MIRP.bind(undefined, 0, 0, 0, 1, 2),
    /* 0xC7 */ MDRP_MIRP.bind(undefined, 0, 0, 0, 1, 3),
    /* 0xC8 */ MDRP_MIRP.bind(undefined, 0, 0, 1, 0, 0),
    /* 0xC9 */ MDRP_MIRP.bind(undefined, 0, 0, 1, 0, 1),
    /* 0xCA */ MDRP_MIRP.bind(undefined, 0, 0, 1, 0, 2),
    /* 0xCB */ MDRP_MIRP.bind(undefined, 0, 0, 1, 0, 3),
    /* 0xCC */ MDRP_MIRP.bind(undefined, 0, 0, 1, 1, 0),
    /* 0xCD */ MDRP_MIRP.bind(undefined, 0, 0, 1, 1, 1),
    /* 0xCE */ MDRP_MIRP.bind(undefined, 0, 0, 1, 1, 2),
    /* 0xCF */ MDRP_MIRP.bind(undefined, 0, 0, 1, 1, 3),
    /* 0xD0 */ MDRP_MIRP.bind(undefined, 0, 1, 0, 0, 0),
    /* 0xD1 */ MDRP_MIRP.bind(undefined, 0, 1, 0, 0, 1),
    /* 0xD2 */ MDRP_MIRP.bind(undefined, 0, 1, 0, 0, 2),
    /* 0xD3 */ MDRP_MIRP.bind(undefined, 0, 1, 0, 0, 3),
    /* 0xD4 */ MDRP_MIRP.bind(undefined, 0, 1, 0, 1, 0),
    /* 0xD5 */ MDRP_MIRP.bind(undefined, 0, 1, 0, 1, 1),
    /* 0xD6 */ MDRP_MIRP.bind(undefined, 0, 1, 0, 1, 2),
    /* 0xD7 */ MDRP_MIRP.bind(undefined, 0, 1, 0, 1, 3),
    /* 0xD8 */ MDRP_MIRP.bind(undefined, 0, 1, 1, 0, 0),
    /* 0xD9 */ MDRP_MIRP.bind(undefined, 0, 1, 1, 0, 1),
    /* 0xDA */ MDRP_MIRP.bind(undefined, 0, 1, 1, 0, 2),
    /* 0xDB */ MDRP_MIRP.bind(undefined, 0, 1, 1, 0, 3),
    /* 0xDC */ MDRP_MIRP.bind(undefined, 0, 1, 1, 1, 0),
    /* 0xDD */ MDRP_MIRP.bind(undefined, 0, 1, 1, 1, 1),
    /* 0xDE */ MDRP_MIRP.bind(undefined, 0, 1, 1, 1, 2),
    /* 0xDF */ MDRP_MIRP.bind(undefined, 0, 1, 1, 1, 3),
    /* 0xE0 */ MDRP_MIRP.bind(undefined, 1, 0, 0, 0, 0),
    /* 0xE1 */ MDRP_MIRP.bind(undefined, 1, 0, 0, 0, 1),
    /* 0xE2 */ MDRP_MIRP.bind(undefined, 1, 0, 0, 0, 2),
    /* 0xE3 */ MDRP_MIRP.bind(undefined, 1, 0, 0, 0, 3),
    /* 0xE4 */ MDRP_MIRP.bind(undefined, 1, 0, 0, 1, 0),
    /* 0xE5 */ MDRP_MIRP.bind(undefined, 1, 0, 0, 1, 1),
    /* 0xE6 */ MDRP_MIRP.bind(undefined, 1, 0, 0, 1, 2),
    /* 0xE7 */ MDRP_MIRP.bind(undefined, 1, 0, 0, 1, 3),
    /* 0xE8 */ MDRP_MIRP.bind(undefined, 1, 0, 1, 0, 0),
    /* 0xE9 */ MDRP_MIRP.bind(undefined, 1, 0, 1, 0, 1),
    /* 0xEA */ MDRP_MIRP.bind(undefined, 1, 0, 1, 0, 2),
    /* 0xEB */ MDRP_MIRP.bind(undefined, 1, 0, 1, 0, 3),
    /* 0xEC */ MDRP_MIRP.bind(undefined, 1, 0, 1, 1, 0),
    /* 0xED */ MDRP_MIRP.bind(undefined, 1, 0, 1, 1, 1),
    /* 0xEE */ MDRP_MIRP.bind(undefined, 1, 0, 1, 1, 2),
    /* 0xEF */ MDRP_MIRP.bind(undefined, 1, 0, 1, 1, 3),
    /* 0xF0 */ MDRP_MIRP.bind(undefined, 1, 1, 0, 0, 0),
    /* 0xF1 */ MDRP_MIRP.bind(undefined, 1, 1, 0, 0, 1),
    /* 0xF2 */ MDRP_MIRP.bind(undefined, 1, 1, 0, 0, 2),
    /* 0xF3 */ MDRP_MIRP.bind(undefined, 1, 1, 0, 0, 3),
    /* 0xF4 */ MDRP_MIRP.bind(undefined, 1, 1, 0, 1, 0),
    /* 0xF5 */ MDRP_MIRP.bind(undefined, 1, 1, 0, 1, 1),
    /* 0xF6 */ MDRP_MIRP.bind(undefined, 1, 1, 0, 1, 2),
    /* 0xF7 */ MDRP_MIRP.bind(undefined, 1, 1, 0, 1, 3),
    /* 0xF8 */ MDRP_MIRP.bind(undefined, 1, 1, 1, 0, 0),
    /* 0xF9 */ MDRP_MIRP.bind(undefined, 1, 1, 1, 0, 1),
    /* 0xFA */ MDRP_MIRP.bind(undefined, 1, 1, 1, 0, 2),
    /* 0xFB */ MDRP_MIRP.bind(undefined, 1, 1, 1, 0, 3),
    /* 0xFC */ MDRP_MIRP.bind(undefined, 1, 1, 1, 1, 0),
    /* 0xFD */ MDRP_MIRP.bind(undefined, 1, 1, 1, 1, 1),
    /* 0xFE */ MDRP_MIRP.bind(undefined, 1, 1, 1, 1, 2),
    /* 0xFF */ MDRP_MIRP.bind(undefined, 1, 1, 1, 1, 3)
];

/*****************************
  Mathematical Considerations
******************************

fv ... refers to freedom vector
pv ... refers to projection vector
rp ... refers to reference point
p  ... refers to to point being operated on
d  ... refers to distance

SETRELATIVE:
============

case freedom vector == x-axis:
------------------------------

                        (pv)
                     .-'
              rpd .-'
               .-*
          d .-'90°'
         .-'       '
      .-'           '
   *-'               ' b
  rp                  '
                       '
                        '
            p *----------*-------------- (fv)
                          pm

  rpdx = rpx + d * pv.x
  rpdy = rpy + d * pv.y

  equation of line b

   y - rpdy = pvns * (x- rpdx)

   y = p.y

   x = rpdx + ( p.y - rpdy ) / pvns


case freedom vector == y-axis:
------------------------------

    * pm
    |\
    | \
    |  \
    |   \
    |    \
    |     \
    |      \
    |       \
    |        \
    |         \ b
    |          \
    |           \
    |            \    .-' (pv)
    |         90° \.-'
    |           .-'* rpd
    |        .-'
    *     *-'  d
    p     rp

  rpdx = rpx + d * pv.x
  rpdy = rpy + d * pv.y

  equation of line b:
           pvns ... normal slope to pv

   y - rpdy = pvns * (x - rpdx)

   x = p.x

   y = rpdy +  pvns * (p.x - rpdx)



generic case:
-------------


                              .'(fv)
                            .'
                          .* pm
                        .' !
                      .'    .
                    .'      !
                  .'         . b
                .'           !
               *              .
              p               !
                         90°   .    ... (pv)
                           ...-*-'''
                  ...---'''    rpd
         ...---'''   d
   *--'''
  rp

    rpdx = rpx + d * pv.x
    rpdy = rpy + d * pv.y

 equation of line b:
    pvns... normal slope to pv

    y - rpdy = pvns * (x - rpdx)

 equation of freedom vector line:
    fvs ... slope of freedom vector (=fy/fx)

    y - py = fvs * (x - px)


  on pm both equations are true for same x/y

    y - rpdy = pvns * (x - rpdx)

    y - py = fvs * (x - px)

  form to y and set equal:

    pvns * (x - rpdx) + rpdy = fvs * (x - px) + py

  expand:

    pvns * x - pvns * rpdx + rpdy = fvs * x - fvs * px + py

  switch:

    fvs * x - fvs * px + py = pvns * x - pvns * rpdx + rpdy

  solve for x:

    fvs * x - pvns * x = fvs * px - pvns * rpdx - py + rpdy



          fvs * px - pvns * rpdx + rpdy - py
    x =  -----------------------------------
                 fvs - pvns

  and:

    y = fvs * (x - px) + py



INTERPOLATE:
============

Examples of point interpolation.

The weight of the movement of the reference point gets bigger
the further the other reference point is away, thus the safest
option (that is avoiding 0/0 divisions) is to weight the
original distance of the other point by the sum of both distances.

If the sum of both distances is 0, then move the point by the
arithmetic average of the movement of both reference points.




           (+6)
    rp1o *---->*rp1
         .     .                          (+12)
         .     .                  rp2o *---------->* rp2
         .     .                       .           .
         .     .                       .           .
         .    10          20           .           .
         |.........|...................|           .
               .   .                               .
               .   . (+8)                          .
                po *------>*p                      .
               .           .                       .
               .    12     .          24           .
               |...........|.......................|
                                  36


-------



           (+10)
    rp1o *-------->*rp1
         .         .                      (-10)
         .         .              rp2 *<---------* rpo2
         .         .                   .         .
         .         .                   .         .
         .    10   .          30       .         .
         |.........|.............................|
                   .                   .
                   . (+5)              .
                po *--->* p            .
                   .    .              .
                   .    .   20         .
                   |....|..............|
                     5        15


-------


           (+10)
    rp1o *-------->*rp1
         .         .
         .         .
    rp2o *-------->*rp2


                               (+10)
                          po *-------->* p

-------


           (+10)
    rp1o *-------->*rp1
         .         .
         .         .(+30)
    rp2o *---------------------------->*rp2


                                        (+25)
                          po *----------------------->* p



vim: set ts=4 sw=4 expandtab:
*****/

/**
 * Converts a string into a list of tokens.
 */

/**
 * Create a new token
 * @param {string} char a single char
 */
function Token(char) {
    this.char = char;
    this.state = {};
    this.activeState = null;
}

/**
 * Create a new context range
 * @param {number} startIndex range start index
 * @param {number} endOffset range end index offset
 * @param {string} contextName owner context name
 */
function ContextRange(startIndex, endOffset, contextName) {
    this.contextName = contextName;
    this.startIndex = startIndex;
    this.endOffset = endOffset;
}

/**
 * Check context start and end
 * @param {string} contextName a unique context name
 * @param {function} checkStart a predicate function the indicates a context's start
 * @param {function} checkEnd a predicate function the indicates a context's end
 */
function ContextChecker(contextName, checkStart, checkEnd) {
    this.contextName = contextName;
    this.openRange = null;
    this.ranges = [];
    this.checkStart = checkStart;
    this.checkEnd = checkEnd;
}

/**
 * @typedef ContextParams
 * @type Object
 * @property {array} context context items
 * @property {number} currentIndex current item index
 */

/**
 * Create a context params
 * @param {array} context a list of items
 * @param {number} currentIndex current item index
 */
function ContextParams(context, currentIndex) {
    this.context = context;
    this.index = currentIndex;
    this.length = context.length;
    this.current = context[currentIndex];
    this.backtrack = context.slice(0, currentIndex);
    this.lookahead = context.slice(currentIndex + 1);
}

/**
 * Create an event instance
 * @param {string} eventId event unique id
 */
function Event(eventId) {
    this.eventId = eventId;
    this.subscribers = [];
}

/**
 * Initialize a core events and auto subscribe required event handlers
 * @param {any} events an object that enlists core events handlers
 */
function initializeCoreEvents(events) {
    var this$1$1 = this;

    var coreEvents = [
        'start', 'end', 'next', 'newToken', 'contextStart',
        'contextEnd', 'insertToken', 'removeToken', 'removeRange',
        'replaceToken', 'replaceRange', 'composeRUD', 'updateContextsRanges'
    ];

    coreEvents.forEach(function (eventId) {
        Object.defineProperty(this$1$1.events, eventId, {
            value: new Event(eventId)
        });
    });

    if (!!events) {
        coreEvents.forEach(function (eventId) {
            var event = events[eventId];
            if (typeof event === 'function') {
                this$1$1.events[eventId].subscribe(event);
            }
        });
    }
    var requiresContextUpdate = [
        'insertToken', 'removeToken', 'removeRange',
        'replaceToken', 'replaceRange', 'composeRUD'
    ];
    requiresContextUpdate.forEach(function (eventId) {
        this$1$1.events[eventId].subscribe(
            this$1$1.updateContextsRanges
        );
    });
}

/**
 * Converts a string into a list of tokens
 * @param {any} events tokenizer core events
 */
function Tokenizer(events) {
    this.tokens = [];
    this.registeredContexts = {};
    this.contextCheckers = [];
    this.events = {};
    this.registeredModifiers = [];

    initializeCoreEvents.call(this, events);
}

/**
 * Sets the state of a token, usually called by a state modifier.
 * @param {string} key state item key
 * @param {any} value state item value
 */
Token.prototype.setState = function(key, value) {
    this.state[key] = value;
    this.activeState = { key: key, value: this.state[key] };
    return this.activeState;
};

Token.prototype.getState = function (stateId) {
    return this.state[stateId] || null;
};

/**
 * Checks if an index exists in the tokens list.
 * @param {number} index token index
 */
Tokenizer.prototype.inboundIndex = function(index) {
    return index >= 0 && index < this.tokens.length;
};

/**
 * Compose and apply a list of operations (replace, update, delete)
 * @param {array} RUDs replace, update and delete operations
 * TODO: Perf. Optimization (lengthBefore === lengthAfter ? dispatch once)
 */
Tokenizer.prototype.composeRUD = function (RUDs) {
    var this$1$1 = this;

    var silent = true;
    var state = RUDs.map(function (RUD) { return (
        this$1$1[RUD[0]].apply(this$1$1, RUD.slice(1).concat(silent))
    ); });
    var hasFAILObject = function (obj) { return (
        typeof obj === 'object' &&
        obj.hasOwnProperty('FAIL')
    ); };
    if (state.every(hasFAILObject)) {
        return {
            FAIL: "composeRUD: one or more operations hasn't completed successfully",
            report: state.filter(hasFAILObject)
        };
    }
    this.dispatch('composeRUD', [state.filter(function (op) { return !hasFAILObject(op); })]);
};

/**
 * Replace a range of tokens with a list of tokens
 * @param {number} startIndex range start index
 * @param {number} offset range offset
 * @param {token} tokens a list of tokens to replace
 * @param {boolean} silent dispatch events and update context ranges
 */
Tokenizer.prototype.replaceRange = function (startIndex, offset, tokens, silent) {
    offset = offset !== null ? offset : this.tokens.length;
    var isTokenType = tokens.every(function (token) { return token instanceof Token; });
    if (!isNaN(startIndex) && this.inboundIndex(startIndex) && isTokenType) {
        var replaced = this.tokens.splice.apply(
            this.tokens, [startIndex, offset].concat(tokens)
        );
        if (!silent) { this.dispatch('replaceToken', [startIndex, offset, tokens]); }
        return [replaced, tokens];
    } else {
        return { FAIL: 'replaceRange: invalid tokens or startIndex.' };
    }
};

/**
 * Replace a token with another token
 * @param {number} index token index
 * @param {token} token a token to replace
 * @param {boolean} silent dispatch events and update context ranges
 */
Tokenizer.prototype.replaceToken = function (index, token, silent) {
    if (!isNaN(index) && this.inboundIndex(index) && token instanceof Token) {
        var replaced = this.tokens.splice(index, 1, token);
        if (!silent) { this.dispatch('replaceToken', [index, token]); }
        return [replaced[0], token];
    } else {
        return { FAIL: 'replaceToken: invalid token or index.' };
    }
};

/**
 * Removes a range of tokens
 * @param {number} startIndex range start index
 * @param {number} offset range offset
 * @param {boolean} silent dispatch events and update context ranges
 */
Tokenizer.prototype.removeRange = function(startIndex, offset, silent) {
    offset = !isNaN(offset) ? offset : this.tokens.length;
    var tokens = this.tokens.splice(startIndex, offset);
    if (!silent) { this.dispatch('removeRange', [tokens, startIndex, offset]); }
    return tokens;
};

/**
 * Remove a token at a certain index
 * @param {number} index token index
 * @param {boolean} silent dispatch events and update context ranges
 */
Tokenizer.prototype.removeToken = function(index, silent) {
    if (!isNaN(index) && this.inboundIndex(index)) {
        var token = this.tokens.splice(index, 1);
        if (!silent) { this.dispatch('removeToken', [token, index]); }
        return token;
    } else {
        return { FAIL: 'removeToken: invalid token index.' };
    }
};

/**
 * Insert a list of tokens at a certain index
 * @param {array} tokens a list of tokens to insert
 * @param {number} index insert the list of tokens at index
 * @param {boolean} silent dispatch events and update context ranges
 */
Tokenizer.prototype.insertToken = function (tokens, index, silent) {
    var tokenType = tokens.every(
        function (token) { return token instanceof Token; }
    );
    if (tokenType) {
        this.tokens.splice.apply(
            this.tokens, [index, 0].concat(tokens)
        );
        if (!silent) { this.dispatch('insertToken', [tokens, index]); }
        return tokens;
    } else {
        return { FAIL: 'insertToken: invalid token(s).' };
    }
};

/**
 * A state modifier that is called on 'newToken' event
 * @param {string} modifierId state modifier id
 * @param {function} condition a predicate function that returns true or false
 * @param {function} modifier a function to update token state
 */
Tokenizer.prototype.registerModifier = function(modifierId, condition, modifier) {
    this.events.newToken.subscribe(function(token, contextParams) {
        var conditionParams = [token, contextParams];
        var canApplyModifier = (
            condition === null ||
            condition.apply(this, conditionParams) === true
        );
        var modifierParams = [token, contextParams];
        if (canApplyModifier) {
            var newStateValue = modifier.apply(this, modifierParams);
            token.setState(modifierId, newStateValue);
        }
    });
    this.registeredModifiers.push(modifierId);
};

/**
 * Subscribe a handler to an event
 * @param {function} eventHandler an event handler function
 */
Event.prototype.subscribe = function (eventHandler) {
    if (typeof eventHandler === 'function') {
        return ((this.subscribers.push(eventHandler)) - 1);
    } else {
        return { FAIL: ("invalid '" + (this.eventId) + "' event handler")};
    }
};

/**
 * Unsubscribe an event handler
 * @param {string} subsId subscription id
 */
Event.prototype.unsubscribe = function (subsId) {
    this.subscribers.splice(subsId, 1);
};

/**
 * Sets context params current value index
 * @param {number} index context params current value index
 */
ContextParams.prototype.setCurrentIndex = function(index) {
    this.index = index;
    this.current = this.context[index];
    this.backtrack = this.context.slice(0, index);
    this.lookahead = this.context.slice(index + 1);
};

/**
 * Get an item at an offset from the current value
 * example (current value is 3):
 *  1    2   [3]   4    5   |   items values
 * -2   -1    0    1    2   |   offset values
 * @param {number} offset an offset from current value index
 */
ContextParams.prototype.get = function (offset) {
    switch (true) {
        case (offset === 0):
            return this.current;
        case (offset < 0 && Math.abs(offset) <= this.backtrack.length):
            return this.backtrack.slice(offset)[0];
        case (offset > 0 && offset <= this.lookahead.length):
            return this.lookahead[offset - 1];
        default:
            return null;
    }
};

/**
 * Converts a context range into a string value
 * @param {contextRange} range a context range
 */
Tokenizer.prototype.rangeToText = function (range) {
    if (range instanceof ContextRange) {
        return (
            this.getRangeTokens(range)
                .map(function (token) { return token.char; }).join('')
        );
    }
};

/**
 * Converts all tokens into a string
 */
Tokenizer.prototype.getText = function () {
    return this.tokens.map(function (token) { return token.char; }).join('');
};

/**
 * Get a context by name
 * @param {string} contextName context name to get
 */
Tokenizer.prototype.getContext = function (contextName) {
    var context = this.registeredContexts[contextName];
    return !!context ? context : null;
};

/**
 * Subscribes a new event handler to an event
 * @param {string} eventName event name to subscribe to
 * @param {function} eventHandler a function to be invoked on event
 */
Tokenizer.prototype.on = function(eventName, eventHandler) {
    var event = this.events[eventName];
    if (!!event) {
        return event.subscribe(eventHandler);
    } else {
        return null;
    }
};

/**
 * Dispatches an event
 * @param {string} eventName event name
 * @param {any} args event handler arguments
 */
Tokenizer.prototype.dispatch = function(eventName, args) {
    var this$1$1 = this;

    var event = this.events[eventName];
    if (event instanceof Event) {
        event.subscribers.forEach(function (subscriber) {
            subscriber.apply(this$1$1, args || []);
        });
    }
};

/**
 * Register a new context checker
 * @param {string} contextName a unique context name
 * @param {function} contextStartCheck a predicate function that returns true on context start
 * @param {function} contextEndCheck  a predicate function that returns true on context end
 * TODO: call tokenize on registration to update context ranges with the new context.
 */
Tokenizer.prototype.registerContextChecker = function(contextName, contextStartCheck, contextEndCheck) {
    if (!!this.getContext(contextName)) { return {
        FAIL:
        ("context name '" + contextName + "' is already registered.")
    }; }
    if (typeof contextStartCheck !== 'function') { return {
        FAIL:
        "missing context start check."
    }; }
    if (typeof contextEndCheck !== 'function') { return {
        FAIL:
        "missing context end check."
    }; }
    var contextCheckers = new ContextChecker(
        contextName, contextStartCheck, contextEndCheck
    );
    this.registeredContexts[contextName] = contextCheckers;
    this.contextCheckers.push(contextCheckers);
    return contextCheckers;
};

/**
 * Gets a context range tokens
 * @param {contextRange} range a context range
 */
Tokenizer.prototype.getRangeTokens = function(range) {
    var endIndex = range.startIndex + range.endOffset;
    return [].concat(
        this.tokens
            .slice(range.startIndex, endIndex)
    );
};

/**
 * Gets the ranges of a context
 * @param {string} contextName context name
 */
Tokenizer.prototype.getContextRanges = function(contextName) {
    var context = this.getContext(contextName);
    if (!!context) {
        return context.ranges;
    } else {
        return { FAIL: ("context checker '" + contextName + "' is not registered.") };
    }
};

/**
 * Resets context ranges to run context update
 */
Tokenizer.prototype.resetContextsRanges = function () {
    var registeredContexts = this.registeredContexts;
    for (var contextName in registeredContexts) {
        if (registeredContexts.hasOwnProperty(contextName)) {
            var context = registeredContexts[contextName];
            context.ranges = [];
        }
    }
};

/**
 * Updates context ranges
 */
Tokenizer.prototype.updateContextsRanges = function () {
    this.resetContextsRanges();
    var chars = this.tokens.map(function (token) { return token.char; });
    for (var i = 0; i < chars.length; i++) {
        var contextParams = new ContextParams(chars, i);
        this.runContextCheck(contextParams);
    }
    this.dispatch('updateContextsRanges', [this.registeredContexts]);
};

/**
 * Sets the end offset of an open range
 * @param {number} offset range end offset
 * @param {string} contextName context name
 */
Tokenizer.prototype.setEndOffset = function (offset, contextName) {
    var startIndex = this.getContext(contextName).openRange.startIndex;
    var range = new ContextRange(startIndex, offset, contextName);
    var ranges = this.getContext(contextName).ranges;
    range.rangeId = contextName + "." + (ranges.length);
    ranges.push(range);
    this.getContext(contextName).openRange = null;
    return range;
};

/**
 * Runs a context check on the current context
 * @param {contextParams} contextParams current context params
 */
Tokenizer.prototype.runContextCheck = function(contextParams) {
    var this$1$1 = this;

    var index = contextParams.index;
    this.contextCheckers.forEach(function (contextChecker) {
        var contextName = contextChecker.contextName;
        var openRange = this$1$1.getContext(contextName).openRange;
        if (!openRange && contextChecker.checkStart(contextParams)) {
            openRange = new ContextRange(index, null, contextName);
            this$1$1.getContext(contextName).openRange = openRange;
            this$1$1.dispatch('contextStart', [contextName, index]);
        }
        if (!!openRange && contextChecker.checkEnd(contextParams)) {
            var offset = (index - openRange.startIndex) + 1;
            var range = this$1$1.setEndOffset(offset, contextName);
            this$1$1.dispatch('contextEnd', [contextName, range]);
        }
    });
};

/**
 * Converts a text into a list of tokens
 * @param {string} text a text to tokenize
 */
Tokenizer.prototype.tokenize = function (text) {
    this.tokens = [];
    this.resetContextsRanges();
    var chars = Array.from(text);
    this.dispatch('start');
    for (var i = 0; i < chars.length; i++) {
        var char = chars[i];
        var contextParams = new ContextParams(chars, i);
        this.dispatch('next', [contextParams]);
        this.runContextCheck(contextParams);
        var token = new Token(char);
        this.tokens.push(token);
        this.dispatch('newToken', [token, contextParams]);
    }
    this.dispatch('end', [this.tokens]);
    return this.tokens;
};

// ╭─┄┄┄────────────────────────┄─────────────────────────────────────────────╮
// ┊ Character Class Assertions ┊ Checks if a char belongs to a certain class ┊
// ╰─╾──────────────────────────┄─────────────────────────────────────────────╯
// jscs:disable maximumLineLength
/**
 * Check if a char is Arabic
 * @param {string} c a single char
 */
function isArabicChar(c) {
    return /[\u0600-\u065F\u066A-\u06D2\u06FA-\u06FF]/.test(c);
}

/**
 * Check if a char is an isolated arabic char
 * @param {string} c a single char
 */
function isIsolatedArabicChar(char) {
    return /[\u0630\u0690\u0621\u0631\u0661\u0671\u0622\u0632\u0672\u0692\u06C2\u0623\u0673\u0693\u06C3\u0624\u0694\u06C4\u0625\u0675\u0695\u06C5\u06E5\u0676\u0696\u06C6\u0627\u0677\u0697\u06C7\u0648\u0688\u0698\u06C8\u0689\u0699\u06C9\u068A\u06CA\u066B\u068B\u06CB\u068C\u068D\u06CD\u06FD\u068E\u06EE\u06FE\u062F\u068F\u06CF\u06EF]/.test(char);
}

/**
 * Check if a char is an Arabic Tashkeel char
 * @param {string} c a single char
 */
function isTashkeelArabicChar(char) {
    return /[\u0600-\u0605\u060C-\u060E\u0610-\u061B\u061E\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED]/.test(char);
}

/**
 * Check if a char is Latin
 * @param {string} c a single char
 */
function isLatinChar(c) {
    return /[A-z]/.test(c);
}

/**
 * Check if a char is whitespace char
 * @param {string} c a single char
 */
function isWhiteSpace(c) {
    return /\s/.test(c);
}

/**
 * Query a feature by some of it's properties to lookup a glyph substitution.
 */

/**
 * Create feature query instance
 * @param {Font} font opentype font instance
 */
function FeatureQuery(font) {
    this.font = font;
    this.features = {};
}

/**
 * @typedef SubstitutionAction
 * @type Object
 * @property {number} id substitution type
 * @property {string} tag feature tag
 * @property {any} substitution substitution value(s)
 */

/**
 * Create a substitution action instance
 * @param {SubstitutionAction} action
 */
function SubstitutionAction(action) {
    this.id = action.id;
    this.tag = action.tag;
    this.substitution = action.substitution;
}

/**
 * Lookup a coverage table
 * @param {number} glyphIndex glyph index
 * @param {CoverageTable} coverage coverage table
 */
function lookupCoverage(glyphIndex, coverage) {
    if (!glyphIndex) { return -1; }
    switch (coverage.format) {
        case 1:
            return coverage.glyphs.indexOf(glyphIndex);

        case 2:
            var ranges = coverage.ranges;
            for (var i = 0; i < ranges.length; i++) {
                var range = ranges[i];
                if (glyphIndex >= range.start && glyphIndex <= range.end) {
                    var offset = glyphIndex - range.start;
                    return range.index + offset;
                }
            }
            break;
        default:
            return -1; // not found
    }
    return -1;
}

/**
 * Handle a single substitution - format 1
 * @param {ContextParams} contextParams context params to lookup
 */
function singleSubstitutionFormat1(glyphIndex, subtable) {
    var substituteIndex = lookupCoverage(glyphIndex, subtable.coverage);
    if (substituteIndex === -1) { return null; }
    return glyphIndex + subtable.deltaGlyphId;
}

/**
 * Handle a single substitution - format 2
 * @param {ContextParams} contextParams context params to lookup
 */
function singleSubstitutionFormat2(glyphIndex, subtable) {
    var substituteIndex = lookupCoverage(glyphIndex, subtable.coverage);
    if (substituteIndex === -1) { return null; }
    return subtable.substitute[substituteIndex];
}

/**
 * Lookup a list of coverage tables
 * @param {any} coverageList a list of coverage tables
 * @param {ContextParams} contextParams context params to lookup
 */
function lookupCoverageList(coverageList, contextParams) {
    var lookupList = [];
    for (var i = 0; i < coverageList.length; i++) {
        var coverage = coverageList[i];
        var glyphIndex = contextParams.current;
        glyphIndex = Array.isArray(glyphIndex) ? glyphIndex[0] : glyphIndex;
        var lookupIndex = lookupCoverage(glyphIndex, coverage);
        if (lookupIndex !== -1) {
            lookupList.push(lookupIndex);
        }
    }
    if (lookupList.length !== coverageList.length) { return -1; }
    return lookupList;
}

/**
 * Handle chaining context substitution - format 3
 * @param {ContextParams} contextParams context params to lookup
 */
function chainingSubstitutionFormat3(contextParams, subtable) {
    var lookupsCount = (
        subtable.inputCoverage.length +
        subtable.lookaheadCoverage.length +
        subtable.backtrackCoverage.length
    );
    if (contextParams.context.length < lookupsCount) { return []; }
    // INPUT LOOKUP //
    var inputLookups = lookupCoverageList(
        subtable.inputCoverage, contextParams
    );
    if (inputLookups === -1) { return []; }
    // LOOKAHEAD LOOKUP //
    var lookaheadOffset = subtable.inputCoverage.length - 1;
    if (contextParams.lookahead.length < subtable.lookaheadCoverage.length) { return []; }
    var lookaheadContext = contextParams.lookahead.slice(lookaheadOffset);
    while (lookaheadContext.length && isTashkeelArabicChar(lookaheadContext[0].char)) {
        lookaheadContext.shift();
    }
    var lookaheadParams = new ContextParams(lookaheadContext, 0);
    var lookaheadLookups = lookupCoverageList(
        subtable.lookaheadCoverage, lookaheadParams
    );
    // BACKTRACK LOOKUP //
    var backtrackContext = [].concat(contextParams.backtrack);
    backtrackContext.reverse();
    while (backtrackContext.length && isTashkeelArabicChar(backtrackContext[0].char)) {
        backtrackContext.shift();
    }
    if (backtrackContext.length < subtable.backtrackCoverage.length) { return []; }
    var backtrackParams = new ContextParams(backtrackContext, 0);
    var backtrackLookups = lookupCoverageList(
        subtable.backtrackCoverage, backtrackParams
    );
    var contextRulesMatch = (
        inputLookups.length === subtable.inputCoverage.length &&
        lookaheadLookups.length === subtable.lookaheadCoverage.length &&
        backtrackLookups.length === subtable.backtrackCoverage.length
    );
    var substitutions = [];
    if (contextRulesMatch) {
        for (var i = 0; i < subtable.lookupRecords.length; i++) {
            var lookupRecord = subtable.lookupRecords[i];
            var lookupListIndex = lookupRecord.lookupListIndex;
            var lookupTable = this.getLookupByIndex(lookupListIndex);
            for (var s = 0; s < lookupTable.subtables.length; s++) {
                var subtable$1 = lookupTable.subtables[s];
                var lookup = this.getLookupMethod(lookupTable, subtable$1);
                var substitutionType = this.getSubstitutionType(lookupTable, subtable$1);
                if (substitutionType === '12') {
                    for (var n = 0; n < inputLookups.length; n++) {
                        var glyphIndex = contextParams.get(n);
                        var substitution = lookup(glyphIndex);
                        if (substitution) { substitutions.push(substitution); }
                    }
                }
            }
        }
    }
    return substitutions;
}

/**
 * Handle ligature substitution - format 1
 * @param {ContextParams} contextParams context params to lookup
 */
function ligatureSubstitutionFormat1(contextParams, subtable) {
    // COVERAGE LOOKUP //
    var glyphIndex = contextParams.current;
    var ligSetIndex = lookupCoverage(glyphIndex, subtable.coverage);
    if (ligSetIndex === -1) { return null; }
    // COMPONENTS LOOKUP
    // (!) note, components are ordered in the written direction.
    var ligature;
    var ligatureSet = subtable.ligatureSets[ligSetIndex];
    for (var s = 0; s < ligatureSet.length; s++) {
        ligature = ligatureSet[s];
        for (var l = 0; l < ligature.components.length; l++) {
            var lookaheadItem = contextParams.lookahead[l];
            var component = ligature.components[l];
            if (lookaheadItem !== component) { break; }
            if (l === ligature.components.length - 1) { return ligature; }
        }
    }
    return null;
}

/**
 * Handle decomposition substitution - format 1
 * @param {number} glyphIndex glyph index
 * @param {any} subtable subtable
 */
function decompositionSubstitutionFormat1(glyphIndex, subtable) {
    var substituteIndex = lookupCoverage(glyphIndex, subtable.coverage);
    if (substituteIndex === -1) { return null; }
    return subtable.sequences[substituteIndex];
}

/**
 * Get default script features indexes
 */
FeatureQuery.prototype.getDefaultScriptFeaturesIndexes = function () {
    var scripts = this.font.tables.gsub.scripts;
    for (var s = 0; s < scripts.length; s++) {
        var script = scripts[s];
        if (script.tag === 'DFLT') { return (
            script.script.defaultLangSys.featureIndexes
        ); }
    }
    return [];
};

/**
 * Get feature indexes of a specific script
 * @param {string} scriptTag script tag
 */
FeatureQuery.prototype.getScriptFeaturesIndexes = function(scriptTag) {
    var tables = this.font.tables;
    if (!tables.gsub) { return []; }
    if (!scriptTag) { return this.getDefaultScriptFeaturesIndexes(); }
    var scripts = this.font.tables.gsub.scripts;
    for (var i = 0; i < scripts.length; i++) {
        var script = scripts[i];
        if (script.tag === scriptTag && script.script.defaultLangSys) {
            return script.script.defaultLangSys.featureIndexes;
        } else {
            var langSysRecords = script.langSysRecords;
            if (!!langSysRecords) {
                for (var j = 0; j < langSysRecords.length; j++) {
                    var langSysRecord = langSysRecords[j];
                    if (langSysRecord.tag === scriptTag) {
                        var langSys = langSysRecord.langSys;
                        return langSys.featureIndexes;
                    }
                }
            }
        }
    }
    return this.getDefaultScriptFeaturesIndexes();
};

/**
 * Map a feature tag to a gsub feature
 * @param {any} features gsub features
 * @param {string} scriptTag script tag
 */
FeatureQuery.prototype.mapTagsToFeatures = function (features, scriptTag) {
    var tags = {};
    for (var i = 0; i < features.length; i++) {
        var tag = features[i].tag;
        var feature = features[i].feature;
        tags[tag] = feature;
    }
    this.features[scriptTag].tags = tags;
};

/**
 * Get features of a specific script
 * @param {string} scriptTag script tag
 */
FeatureQuery.prototype.getScriptFeatures = function (scriptTag) {
    var features = this.features[scriptTag];
    if (this.features.hasOwnProperty(scriptTag)) { return features; }
    var featuresIndexes = this.getScriptFeaturesIndexes(scriptTag);
    if (!featuresIndexes) { return null; }
    var gsub = this.font.tables.gsub;
    features = featuresIndexes.map(function (index) { return gsub.features[index]; });
    this.features[scriptTag] = features;
    this.mapTagsToFeatures(features, scriptTag);
    return features;
};

/**
 * Get substitution type
 * @param {any} lookupTable lookup table
 * @param {any} subtable subtable
 */
FeatureQuery.prototype.getSubstitutionType = function(lookupTable, subtable) {
    var lookupType = lookupTable.lookupType.toString();
    var substFormat = subtable.substFormat.toString();
    return lookupType + substFormat;
};

/**
 * Get lookup method
 * @param {any} lookupTable lookup table
 * @param {any} subtable subtable
 */
FeatureQuery.prototype.getLookupMethod = function(lookupTable, subtable) {
    var this$1$1 = this;

    var substitutionType = this.getSubstitutionType(lookupTable, subtable);
    switch (substitutionType) {
        case '11':
            return function (glyphIndex) { return singleSubstitutionFormat1.apply(
                this$1$1, [glyphIndex, subtable]
            ); };
        case '12':
            return function (glyphIndex) { return singleSubstitutionFormat2.apply(
                this$1$1, [glyphIndex, subtable]
            ); };
        case '63':
            return function (contextParams) { return chainingSubstitutionFormat3.apply(
                this$1$1, [contextParams, subtable]
            ); };
        case '41':
            return function (contextParams) { return ligatureSubstitutionFormat1.apply(
                this$1$1, [contextParams, subtable]
            ); };
        case '21':
            return function (glyphIndex) { return decompositionSubstitutionFormat1.apply(
                this$1$1, [glyphIndex, subtable]
            ); };
        default:
            throw new Error(
                "lookupType: " + (lookupTable.lookupType) + " - " +
                "substFormat: " + (subtable.substFormat) + " " +
                "is not yet supported"
            );
    }
};

/**
 * [ LOOKUP TYPES ]
 * -------------------------------
 * Single                        1;
 * Multiple                      2;
 * Alternate                     3;
 * Ligature                      4;
 * Context                       5;
 * ChainingContext               6;
 * ExtensionSubstitution         7;
 * ReverseChainingContext        8;
 * -------------------------------
 *
 */

/**
 * @typedef FQuery
 * @type Object
 * @param {string} tag feature tag
 * @param {string} script feature script
 * @param {ContextParams} contextParams context params
 */

/**
 * Lookup a feature using a query parameters
 * @param {FQuery} query feature query
 */
FeatureQuery.prototype.lookupFeature = function (query) {
    var contextParams = query.contextParams;
    var currentIndex = contextParams.index;
    var feature = this.getFeature({
        tag: query.tag, script: query.script
    });
    if (!feature) { return new Error(
        "font '" + (this.font.names.fullName.en) + "' " +
        "doesn't support feature '" + (query.tag) + "' " +
        "for script '" + (query.script) + "'."
    ); }
    var lookups = this.getFeatureLookups(feature);
    var substitutions = [].concat(contextParams.context);
    for (var l = 0; l < lookups.length; l++) {
        var lookupTable = lookups[l];
        var subtables = this.getLookupSubtables(lookupTable);
        for (var s = 0; s < subtables.length; s++) {
            var subtable = subtables[s];
            var substType = this.getSubstitutionType(lookupTable, subtable);
            var lookup = this.getLookupMethod(lookupTable, subtable);
            var substitution = (void 0);
            switch (substType) {
                case '11':
                    substitution = lookup(contextParams.current);
                    if (substitution) {
                        substitutions.splice(currentIndex, 1, new SubstitutionAction({
                            id: 11, tag: query.tag, substitution: substitution
                        }));
                    }
                    break;
                case '12':
                    substitution = lookup(contextParams.current);
                    if (substitution) {
                        substitutions.splice(currentIndex, 1, new SubstitutionAction({
                            id: 12, tag: query.tag, substitution: substitution
                        }));
                    }
                    break;
                case '63':
                    substitution = lookup(contextParams);
                    if (Array.isArray(substitution) && substitution.length) {
                        substitutions.splice(currentIndex, 1, new SubstitutionAction({
                            id: 63, tag: query.tag, substitution: substitution
                        }));
                    }
                    break;
                case '41':
                    substitution = lookup(contextParams);
                    if (substitution) {
                        substitutions.splice(currentIndex, 1, new SubstitutionAction({
                            id: 41, tag: query.tag, substitution: substitution
                        }));
                    }
                    break;
                case '21':
                    substitution = lookup(contextParams.current);
                    if (substitution) {
                        substitutions.splice(currentIndex, 1, new SubstitutionAction({
                            id: 21, tag: query.tag, substitution: substitution
                        }));
                    }
                    break;
            }
            contextParams = new ContextParams(substitutions, currentIndex);
            if (Array.isArray(substitution) && !substitution.length) { continue; }
            substitution = null;
        }
    }
    return substitutions.length ? substitutions : null;
};

/**
 * Checks if a font supports a specific features
 * @param {FQuery} query feature query object
 */
FeatureQuery.prototype.supports = function (query) {
    if (!query.script) { return false; }
    this.getScriptFeatures(query.script);
    var supportedScript = this.features.hasOwnProperty(query.script);
    if (!query.tag) { return supportedScript; }
    var supportedFeature = (
        this.features[query.script].some(function (feature) { return feature.tag === query.tag; })
    );
    return supportedScript && supportedFeature;
};

/**
 * Get lookup table subtables
 * @param {any} lookupTable lookup table
 */
FeatureQuery.prototype.getLookupSubtables = function (lookupTable) {
    return lookupTable.subtables || null;
};

/**
 * Get lookup table by index
 * @param {number} index lookup table index
 */
FeatureQuery.prototype.getLookupByIndex = function (index) {
    var lookups = this.font.tables.gsub.lookups;
    return lookups[index] || null;
};

/**
 * Get lookup tables for a feature
 * @param {string} feature
 */
FeatureQuery.prototype.getFeatureLookups = function (feature) {
    // TODO: memoize
    return feature.lookupListIndexes.map(this.getLookupByIndex.bind(this));
};

/**
 * Query a feature by it's properties
 * @param {any} query an object that describes the properties of a query
 */
FeatureQuery.prototype.getFeature = function getFeature(query) {
    if (!this.font) { return { FAIL: "No font was found"}; }
    if (!this.features.hasOwnProperty(query.script)) {
        this.getScriptFeatures(query.script);
    }
    var scriptFeatures = this.features[query.script];
    if (!scriptFeatures) { return (
        { FAIL: ("No feature for script " + (query.script))}
    ); }
    if (!scriptFeatures.tags[query.tag]) { return null; }
    return this.features[query.script].tags[query.tag];
};

/**
 * Arabic word context checkers
 */

function arabicWordStartCheck(contextParams) {
    var char = contextParams.current;
    var prevChar = contextParams.get(-1);
    return (
        // ? arabic first char
        (prevChar === null && isArabicChar(char)) ||
        // ? arabic char preceded with a non arabic char
        (!isArabicChar(prevChar) && isArabicChar(char))
    );
}

function arabicWordEndCheck(contextParams) {
    var nextChar = contextParams.get(1);
    return (
        // ? last arabic char
        (nextChar === null) ||
        // ? next char is not arabic
        (!isArabicChar(nextChar))
    );
}

var arabicWordCheck = {
    startCheck: arabicWordStartCheck,
    endCheck: arabicWordEndCheck
};

/**
 * Arabic sentence context checkers
 */

function arabicSentenceStartCheck(contextParams) {
    var char = contextParams.current;
    var prevChar = contextParams.get(-1);
    return (
        // ? an arabic char preceded with a non arabic char
        (isArabicChar(char) || isTashkeelArabicChar(char)) &&
        !isArabicChar(prevChar)
    );
}

function arabicSentenceEndCheck(contextParams) {
    var nextChar = contextParams.get(1);
    switch (true) {
        case nextChar === null:
            return true;
        case (!isArabicChar(nextChar) && !isTashkeelArabicChar(nextChar)):
            var nextIsWhitespace = isWhiteSpace(nextChar);
            if (!nextIsWhitespace) { return true; }
            if (nextIsWhitespace) {
                var arabicCharAhead = false;
                arabicCharAhead = (
                    contextParams.lookahead.some(
                        function (c) { return isArabicChar(c) || isTashkeelArabicChar(c); }
                    )
                );
                if (!arabicCharAhead) { return true; }
            }
            break;
        default:
            return false;
    }
}

var arabicSentenceCheck = {
    startCheck: arabicSentenceStartCheck,
    endCheck: arabicSentenceEndCheck
};

/**
 * Apply single substitution format 1
 * @param {Array} substitutions substitutions
 * @param {any} tokens a list of tokens
 * @param {number} index token index
 */
function singleSubstitutionFormat1$1(action, tokens, index) {
    tokens[index].setState(action.tag, action.substitution);
}

/**
 * Apply single substitution format 2
 * @param {Array} substitutions substitutions
 * @param {any} tokens a list of tokens
 * @param {number} index token index
 */
function singleSubstitutionFormat2$1(action, tokens, index) {
    tokens[index].setState(action.tag, action.substitution);
}

/**
 * Apply chaining context substitution format 3
 * @param {Array} substitutions substitutions
 * @param {any} tokens a list of tokens
 * @param {number} index token index
 */
function chainingSubstitutionFormat3$1(action, tokens, index) {
    action.substitution.forEach(function (subst, offset) {
        var token = tokens[index + offset];
        token.setState(action.tag, subst);
    });
}

/**
 * Apply ligature substitution format 1
 * @param {Array} substitutions substitutions
 * @param {any} tokens a list of tokens
 * @param {number} index token index
 */
function ligatureSubstitutionFormat1$1(action, tokens, index) {
    var token = tokens[index];
    token.setState(action.tag, action.substitution.ligGlyph);
    var compsCount = action.substitution.components.length;
    for (var i = 0; i < compsCount; i++) {
        token = tokens[index + i + 1];
        token.setState('deleted', true);
    }
}

/**
 * Supported substitutions
 */
var SUBSTITUTIONS = {
    11: singleSubstitutionFormat1$1,
    12: singleSubstitutionFormat2$1,
    63: chainingSubstitutionFormat3$1,
    41: ligatureSubstitutionFormat1$1
};

/**
 * Apply substitutions to a list of tokens
 * @param {Array} substitutions substitutions
 * @param {any} tokens a list of tokens
 * @param {number} index token index
 */
function applySubstitution(action, tokens, index) {
    if (action instanceof SubstitutionAction && SUBSTITUTIONS[action.id]) {
        SUBSTITUTIONS[action.id](action, tokens, index);
    }
}

/**
 * Apply Arabic presentation forms to a range of tokens
 */

/**
 * Check if a char can be connected to it's preceding char
 * @param {ContextParams} charContextParams context params of a char
 */
function willConnectPrev(charContextParams) {
    var backtrack = [].concat(charContextParams.backtrack);
    for (var i = backtrack.length - 1; i >= 0; i--) {
        var prevChar = backtrack[i];
        var isolated = isIsolatedArabicChar(prevChar);
        var tashkeel = isTashkeelArabicChar(prevChar);
        if (!isolated && !tashkeel) { return true; }
        if (isolated) { return false; }
    }
    return false;
}

/**
 * Check if a char can be connected to it's proceeding char
 * @param {ContextParams} charContextParams context params of a char
 */
function willConnectNext(charContextParams) {
    if (isIsolatedArabicChar(charContextParams.current)) { return false; }
    for (var i = 0; i < charContextParams.lookahead.length; i++) {
        var nextChar = charContextParams.lookahead[i];
        var tashkeel = isTashkeelArabicChar(nextChar);
        if (!tashkeel) { return true; }
    }
    return false;
}

/**
 * Apply arabic presentation forms to a list of tokens
 * @param {ContextRange} range a range of tokens
 */
function arabicPresentationForms(range) {
    var this$1$1 = this;

    var script = 'arab';
    var tags = this.featuresTags[script];
    var tokens = this.tokenizer.getRangeTokens(range);
    if (tokens.length === 1) { return; }
    var contextParams = new ContextParams(
        tokens.map(function (token) { return token.getState('glyphIndex'); }
    ), 0);
    var charContextParams = new ContextParams(
        tokens.map(function (token) { return token.char; }
    ), 0);
    tokens.forEach(function (token, index) {
        if (isTashkeelArabicChar(token.char)) { return; }
        contextParams.setCurrentIndex(index);
        charContextParams.setCurrentIndex(index);
        var CONNECT = 0; // 2 bits 00 (10: can connect next) (01: can connect prev)
        if (willConnectPrev(charContextParams)) { CONNECT |= 1; }
        if (willConnectNext(charContextParams)) { CONNECT |= 2; }
        var tag;
        switch (CONNECT) {
            case 1: (tag = 'fina'); break;
            case 2: (tag = 'init'); break;
            case 3: (tag = 'medi'); break;
        }
        if (tags.indexOf(tag) === -1) { return; }
        var substitutions = this$1$1.query.lookupFeature({
            tag: tag, script: script, contextParams: contextParams
        });
        if (substitutions instanceof Error) { return console.info(substitutions.message); }
        substitutions.forEach(function (action, index) {
            if (action instanceof SubstitutionAction) {
                applySubstitution(action, tokens, index);
                contextParams.context[index] = action.substitution;
            }
        });
    });
}

/**
 * Apply Arabic required ligatures feature to a range of tokens
 */

/**
 * Update context params
 * @param {any} tokens a list of tokens
 * @param {number} index current item index
 */
function getContextParams(tokens, index) {
    var context = tokens.map(function (token) { return token.activeState.value; });
    return new ContextParams(context, 0);
}

/**
 * Apply Arabic required ligatures to a context range
 * @param {ContextRange} range a range of tokens
 */
function arabicRequiredLigatures(range) {
    var this$1$1 = this;

    var script = 'arab';
    var tokens = this.tokenizer.getRangeTokens(range);
    var contextParams = getContextParams(tokens);
    contextParams.context.forEach(function (glyphIndex, index) {
        contextParams.setCurrentIndex(index);
        var substitutions = this$1$1.query.lookupFeature({
            tag: 'rlig', script: script, contextParams: contextParams
        });
        if (substitutions.length) {
            substitutions.forEach(
                function (action) { return applySubstitution(action, tokens, index); }
            );
            contextParams = getContextParams(tokens);
        }
    });
}

/**
 * Latin word context checkers
 */

function latinWordStartCheck(contextParams) {
    var char = contextParams.current;
    var prevChar = contextParams.get(-1);
    return (
        // ? latin first char
        (prevChar === null && isLatinChar(char)) ||
        // ? latin char preceded with a non latin char
        (!isLatinChar(prevChar) && isLatinChar(char))
    );
}

function latinWordEndCheck(contextParams) {
    var nextChar = contextParams.get(1);
    return (
        // ? last latin char
        (nextChar === null) ||
        // ? next char is not latin
        (!isLatinChar(nextChar))
    );
}

var latinWordCheck = {
    startCheck: latinWordStartCheck,
    endCheck: latinWordEndCheck
};

/**
 * Apply Latin ligature feature to a range of tokens
 */

/**
 * Update context params
 * @param {any} tokens a list of tokens
 * @param {number} index current item index
 */
function getContextParams$1(tokens, index) {
    var context = tokens.map(function (token) { return token.activeState.value; });
    return new ContextParams(context, 0);
}

/**
 * Apply Arabic required ligatures to a context range
 * @param {ContextRange} range a range of tokens
 */
function latinLigature(range) {
    var this$1$1 = this;

    var script = 'latn';
    var tokens = this.tokenizer.getRangeTokens(range);
    var contextParams = getContextParams$1(tokens);
    contextParams.context.forEach(function (glyphIndex, index) {
        contextParams.setCurrentIndex(index);
        var substitutions = this$1$1.query.lookupFeature({
            tag: 'liga', script: script, contextParams: contextParams
        });
        if (substitutions.length) {
            substitutions.forEach(
                function (action) { return applySubstitution(action, tokens, index); }
            );
            contextParams = getContextParams$1(tokens);
        }
    });
}

/**
 * Infer bidirectional properties for a given text and apply
 * the corresponding layout rules.
 */

/**
 * Create Bidi. features
 * @param {string} baseDir text base direction. value either 'ltr' or 'rtl'
 */
function Bidi(baseDir) {
    this.baseDir = baseDir || 'ltr';
    this.tokenizer = new Tokenizer();
    this.featuresTags = {};
}

/**
 * Sets Bidi text
 * @param {string} text a text input
 */
Bidi.prototype.setText = function (text) {
    this.text = text;
};

/**
 * Store essential context checks:
 * arabic word check for applying gsub features
 * arabic sentence check for adjusting arabic layout
 */
Bidi.prototype.contextChecks = ({
    latinWordCheck: latinWordCheck,
    arabicWordCheck: arabicWordCheck,
    arabicSentenceCheck: arabicSentenceCheck
});

/**
 * Register arabic word check
 */
function registerContextChecker(checkId) {
    var check = this.contextChecks[(checkId + "Check")];
    return this.tokenizer.registerContextChecker(
        checkId, check.startCheck, check.endCheck
    );
}

/**
 * Perform pre tokenization procedure then
 * tokenize text input
 */
function tokenizeText() {
    registerContextChecker.call(this, 'latinWord');
    registerContextChecker.call(this, 'arabicWord');
    registerContextChecker.call(this, 'arabicSentence');
    return this.tokenizer.tokenize(this.text);
}

/**
 * Reverse arabic sentence layout
 * TODO: check base dir before applying adjustments - priority low
 */
function reverseArabicSentences() {
    var this$1$1 = this;

    var ranges = this.tokenizer.getContextRanges('arabicSentence');
    ranges.forEach(function (range) {
        var rangeTokens = this$1$1.tokenizer.getRangeTokens(range);
        this$1$1.tokenizer.replaceRange(
            range.startIndex,
            range.endOffset,
            rangeTokens.reverse()
        );
    });
}

/**
 * Register supported features tags
 * @param {script} script script tag
 * @param {Array} tags features tags list
 */
Bidi.prototype.registerFeatures = function (script, tags) {
    var this$1$1 = this;

    var supportedTags = tags.filter(
        function (tag) { return this$1$1.query.supports({script: script, tag: tag}); }
    );
    if (!this.featuresTags.hasOwnProperty(script)) {
        this.featuresTags[script] = supportedTags;
    } else {
        this.featuresTags[script] =
        this.featuresTags[script].concat(supportedTags);
    }
};

/**
 * Apply GSUB features
 * @param {Array} tagsList a list of features tags
 * @param {string} script a script tag
 * @param {Font} font opentype font instance
 */
Bidi.prototype.applyFeatures = function (font, features) {
    if (!font) { throw new Error(
        'No valid font was provided to apply features'
    ); }
    if (!this.query) { this.query = new FeatureQuery(font); }
    for (var f = 0; f < features.length; f++) {
        var feature = features[f];
        if (!this.query.supports({script: feature.script})) { continue; }
        this.registerFeatures(feature.script, feature.tags);
    }
};

/**
 * Register a state modifier
 * @param {string} modifierId state modifier id
 * @param {function} condition a predicate function that returns true or false
 * @param {function} modifier a modifier function to set token state
 */
Bidi.prototype.registerModifier = function (modifierId, condition, modifier) {
    this.tokenizer.registerModifier(modifierId, condition, modifier);
};

/**
 * Check if 'glyphIndex' is registered
 */
function checkGlyphIndexStatus() {
    if (this.tokenizer.registeredModifiers.indexOf('glyphIndex') === -1) {
        throw new Error(
            'glyphIndex modifier is required to apply ' +
            'arabic presentation features.'
        );
    }
}

/**
 * Apply arabic presentation forms features
 */
function applyArabicPresentationForms() {
    var this$1$1 = this;

    var script = 'arab';
    if (!this.featuresTags.hasOwnProperty(script)) { return; }
    checkGlyphIndexStatus.call(this);
    var ranges = this.tokenizer.getContextRanges('arabicWord');
    ranges.forEach(function (range) {
        arabicPresentationForms.call(this$1$1, range);
    });
}

/**
 * Apply required arabic ligatures
 */
function applyArabicRequireLigatures() {
    var this$1$1 = this;

    var script = 'arab';
    if (!this.featuresTags.hasOwnProperty(script)) { return; }
    var tags = this.featuresTags[script];
    if (tags.indexOf('rlig') === -1) { return; }
    checkGlyphIndexStatus.call(this);
    var ranges = this.tokenizer.getContextRanges('arabicWord');
    ranges.forEach(function (range) {
        arabicRequiredLigatures.call(this$1$1, range);
    });
}

/**
 * Apply required arabic ligatures
 */
function applyLatinLigatures() {
    var this$1$1 = this;

    var script = 'latn';
    if (!this.featuresTags.hasOwnProperty(script)) { return; }
    var tags = this.featuresTags[script];
    if (tags.indexOf('liga') === -1) { return; }
    checkGlyphIndexStatus.call(this);
    var ranges = this.tokenizer.getContextRanges('latinWord');
    ranges.forEach(function (range) {
        latinLigature.call(this$1$1, range);
    });
}

/**
 * Check if a context is registered
 * @param {string} contextId context id
 */
Bidi.prototype.checkContextReady = function (contextId) {
    return !!this.tokenizer.getContext(contextId);
};

/**
 * Apply features to registered contexts
 */
Bidi.prototype.applyFeaturesToContexts = function () {
    if (this.checkContextReady('arabicWord')) {
        applyArabicPresentationForms.call(this);
        applyArabicRequireLigatures.call(this);
    }
    if (this.checkContextReady('latinWord')) {
        applyLatinLigatures.call(this);
    }
    if (this.checkContextReady('arabicSentence')) {
        reverseArabicSentences.call(this);
    }
};

/**
 * process text input
 * @param {string} text an input text
 */
Bidi.prototype.processText = function(text) {
    if (!this.text || this.text !== text) {
        this.setText(text);
        tokenizeText.call(this);
        this.applyFeaturesToContexts();
    }
};

/**
 * Process a string of text to identify and adjust
 * bidirectional text entities.
 * @param {string} text input text
 */
Bidi.prototype.getBidiText = function (text) {
    this.processText(text);
    return this.tokenizer.getText();
};

/**
 * Get the current state index of each token
 * @param {text} text an input text
 */
Bidi.prototype.getTextGlyphs = function (text) {
    this.processText(text);
    var indexes = [];
    for (var i = 0; i < this.tokenizer.tokens.length; i++) {
        var token = this.tokenizer.tokens[i];
        if (token.state.deleted) { continue; }
        var index = token.activeState.value;
        indexes.push(Array.isArray(index) ? index[0] : index);
    }
    return indexes;
};

// The Font object

/**
 * @typedef FontOptions
 * @type Object
 * @property {Boolean} empty - whether to create a new empty font
 * @property {string} familyName
 * @property {string} styleName
 * @property {string=} fullName
 * @property {string=} postScriptName
 * @property {string=} designer
 * @property {string=} designerURL
 * @property {string=} manufacturer
 * @property {string=} manufacturerURL
 * @property {string=} license
 * @property {string=} licenseURL
 * @property {string=} version
 * @property {string=} description
 * @property {string=} copyright
 * @property {string=} trademark
 * @property {Number} unitsPerEm
 * @property {Number} ascender
 * @property {Number} descender
 * @property {Number} createdTimestamp
 * @property {string=} weightClass
 * @property {string=} widthClass
 * @property {string=} fsSelection
 */

/**
 * A Font represents a loaded OpenType font file.
 * It contains a set of glyphs and methods to draw text on a drawing context,
 * or to get a path representing the text.
 * @exports opentype.Font
 * @class
 * @param {FontOptions}
 * @constructor
 */
function Font(options) {
    options = options || {};
    options.tables = options.tables || {};

    if (!options.empty) {
        // Check that we've provided the minimum set of names.
        checkArgument(options.familyName, 'When creating a new Font object, familyName is required.');
        checkArgument(options.styleName, 'When creating a new Font object, styleName is required.');
        checkArgument(options.unitsPerEm, 'When creating a new Font object, unitsPerEm is required.');
        checkArgument(options.ascender, 'When creating a new Font object, ascender is required.');
        checkArgument(options.descender <= 0, 'When creating a new Font object, negative descender value is required.');

        // OS X will complain if the names are empty, so we put a single space everywhere by default.
        this.names = {
            fontFamily: {en: options.familyName || ' '},
            fontSubfamily: {en: options.styleName || ' '},
            fullName: {en: options.fullName || options.familyName + ' ' + options.styleName},
            // postScriptName may not contain any whitespace
            postScriptName: {en: options.postScriptName || (options.familyName + options.styleName).replace(/\s/g, '')},
            designer: {en: options.designer || ' '},
            designerURL: {en: options.designerURL || ' '},
            manufacturer: {en: options.manufacturer || ' '},
            manufacturerURL: {en: options.manufacturerURL || ' '},
            license: {en: options.license || ' '},
            licenseURL: {en: options.licenseURL || ' '},
            version: {en: options.version || 'Version 0.1'},
            description: {en: options.description || ' '},
            copyright: {en: options.copyright || ' '},
            trademark: {en: options.trademark || ' '}
        };
        this.unitsPerEm = options.unitsPerEm || 1000;
        this.ascender = options.ascender;
        this.descender = options.descender;
        this.createdTimestamp = options.createdTimestamp;
        this.tables = Object.assign(options.tables, {
            os2: Object.assign({
                usWeightClass: options.weightClass || this.usWeightClasses.MEDIUM,
                usWidthClass: options.widthClass || this.usWidthClasses.MEDIUM,
                fsSelection: options.fsSelection || this.fsSelectionValues.REGULAR,
            }, options.tables.os2)
        });
    }

    this.supported = true; // Deprecated: parseBuffer will throw an error if font is not supported.
    this.glyphs = new glyphset.GlyphSet(this, options.glyphs || []);
    this.encoding = new DefaultEncoding(this);
    this.position = new Position(this);
    this.substitution = new Substitution(this);
    this.tables = this.tables || {};

    // needed for low memory mode only.
    this._push = null;
    this._hmtxTableData = {};

    Object.defineProperty(this, 'hinting', {
        get: function() {
            if (this._hinting) { return this._hinting; }
            if (this.outlinesFormat === 'truetype') {
                return (this._hinting = new Hinting(this));
            }
        }
    });
}

/**
 * Check if the font has a glyph for the given character.
 * @param  {string}
 * @return {Boolean}
 */
Font.prototype.hasChar = function(c) {
    return this.encoding.charToGlyphIndex(c) !== null;
};

/**
 * Convert the given character to a single glyph index.
 * Note that this function assumes that there is a one-to-one mapping between
 * the given character and a glyph; for complex scripts this might not be the case.
 * @param  {string}
 * @return {Number}
 */
Font.prototype.charToGlyphIndex = function(s) {
    return this.encoding.charToGlyphIndex(s);
};

/**
 * Convert the given character to a single Glyph object.
 * Note that this function assumes that there is a one-to-one mapping between
 * the given character and a glyph; for complex scripts this might not be the case.
 * @param  {string}
 * @return {opentype.Glyph}
 */
Font.prototype.charToGlyph = function(c) {
    var glyphIndex = this.charToGlyphIndex(c);
    var glyph = this.glyphs.get(glyphIndex);
    if (!glyph) {
        // .notdef
        glyph = this.glyphs.get(0);
    }

    return glyph;
};

/**
 * Update features
 * @param {any} options features options
 */
Font.prototype.updateFeatures = function (options) {
    // TODO: update all features options not only 'latn'.
    return this.defaultRenderOptions.features.map(function (feature) {
        if (feature.script === 'latn') {
            return {
                script: 'latn',
                tags: feature.tags.filter(function (tag) { return options[tag]; })
            };
        } else {
            return feature;
        }
    });
};

/**
 * Convert the given text to a list of Glyph objects.
 * Note that there is no strict one-to-one mapping between characters and
 * glyphs, so the list of returned glyphs can be larger or smaller than the
 * length of the given string.
 * @param  {string}
 * @param  {GlyphRenderOptions} [options]
 * @return {opentype.Glyph[]}
 */
Font.prototype.stringToGlyphs = function(s, options) {
    var this$1$1 = this;


    var bidi = new Bidi();

    // Create and register 'glyphIndex' state modifier
    var charToGlyphIndexMod = function (token) { return this$1$1.charToGlyphIndex(token.char); };
    bidi.registerModifier('glyphIndex', null, charToGlyphIndexMod);

    // roll-back to default features
    var features = options ?
    this.updateFeatures(options.features) :
    this.defaultRenderOptions.features;

    bidi.applyFeatures(this, features);

    var indexes = bidi.getTextGlyphs(s);

    var length = indexes.length;

    // convert glyph indexes to glyph objects
    var glyphs = new Array(length);
    var notdef = this.glyphs.get(0);
    for (var i = 0; i < length; i += 1) {
        glyphs[i] = this.glyphs.get(indexes[i]) || notdef;
    }
    return glyphs;
};

/**
 * @param  {string}
 * @return {Number}
 */
Font.prototype.nameToGlyphIndex = function(name) {
    return this.glyphNames.nameToGlyphIndex(name);
};

/**
 * @param  {string}
 * @return {opentype.Glyph}
 */
Font.prototype.nameToGlyph = function(name) {
    var glyphIndex = this.nameToGlyphIndex(name);
    var glyph = this.glyphs.get(glyphIndex);
    if (!glyph) {
        // .notdef
        glyph = this.glyphs.get(0);
    }

    return glyph;
};

/**
 * @param  {Number}
 * @return {String}
 */
Font.prototype.glyphIndexToName = function(gid) {
    if (!this.glyphNames.glyphIndexToName) {
        return '';
    }

    return this.glyphNames.glyphIndexToName(gid);
};

/**
 * Retrieve the value of the kerning pair between the left glyph (or its index)
 * and the right glyph (or its index). If no kerning pair is found, return 0.
 * The kerning value gets added to the advance width when calculating the spacing
 * between glyphs.
 * For GPOS kerning, this method uses the default script and language, which covers
 * most use cases. To have greater control, use font.position.getKerningValue .
 * @param  {opentype.Glyph} leftGlyph
 * @param  {opentype.Glyph} rightGlyph
 * @return {Number}
 */
Font.prototype.getKerningValue = function(leftGlyph, rightGlyph) {
    leftGlyph = leftGlyph.index || leftGlyph;
    rightGlyph = rightGlyph.index || rightGlyph;
    var gposKerning = this.position.defaultKerningTables;
    if (gposKerning) {
        return this.position.getKerningValue(gposKerning, leftGlyph, rightGlyph);
    }
    // "kern" table
    return this.kerningPairs[leftGlyph + ',' + rightGlyph] || 0;
};

/**
 * @typedef GlyphRenderOptions
 * @type Object
 * @property {string} [script] - script used to determine which features to apply. By default, 'DFLT' or 'latn' is used.
 *                               See https://www.microsoft.com/typography/otspec/scripttags.htm
 * @property {string} [language='dflt'] - language system used to determine which features to apply.
 *                                        See https://www.microsoft.com/typography/developers/opentype/languagetags.aspx
 * @property {boolean} [kerning=true] - whether to include kerning values
 * @property {object} [features] - OpenType Layout feature tags. Used to enable or disable the features of the given script/language system.
 *                                 See https://www.microsoft.com/typography/otspec/featuretags.htm
 */
Font.prototype.defaultRenderOptions = {
    kerning: true,
    features: [
        /**
         * these 4 features are required to render Arabic text properly
         * and shouldn't be turned off when rendering arabic text.
         */
        { script: 'arab', tags: ['init', 'medi', 'fina', 'rlig'] },
        { script: 'latn', tags: ['liga', 'rlig'] }
    ]
};

/**
 * Helper function that invokes the given callback for each glyph in the given text.
 * The callback gets `(glyph, x, y, fontSize, options)`.* @param  {string} text
 * @param {string} text - The text to apply.
 * @param  {number} [x=0] - Horizontal position of the beginning of the text.
 * @param  {number} [y=0] - Vertical position of the *baseline* of the text.
 * @param  {number} [fontSize=72] - Font size in pixels. We scale the glyph units by `1 / unitsPerEm * fontSize`.
 * @param  {GlyphRenderOptions=} options
 * @param  {Function} callback
 */
Font.prototype.forEachGlyph = function(text, x, y, fontSize, options, callback) {
    x = x !== undefined ? x : 0;
    y = y !== undefined ? y : 0;
    fontSize = fontSize !== undefined ? fontSize : 72;
    options = Object.assign({}, this.defaultRenderOptions, options);
    var fontScale = 1 / this.unitsPerEm * fontSize;
    var glyphs = this.stringToGlyphs(text, options);
    var kerningLookups;
    if (options.kerning) {
        var script = options.script || this.position.getDefaultScriptName();
        kerningLookups = this.position.getKerningTables(script, options.language);
    }
    for (var i = 0; i < glyphs.length; i += 1) {
        var glyph = glyphs[i];
        callback.call(this, glyph, x, y, fontSize, options);
        if (glyph.advanceWidth) {
            x += glyph.advanceWidth * fontScale;
        }

        if (options.kerning && i < glyphs.length - 1) {
            // We should apply position adjustment lookups in a more generic way.
            // Here we only use the xAdvance value.
            var kerningValue = kerningLookups ?
                  this.position.getKerningValue(kerningLookups, glyph.index, glyphs[i + 1].index) :
                  this.getKerningValue(glyph, glyphs[i + 1]);
            x += kerningValue * fontScale;
        }

        if (options.letterSpacing) {
            x += options.letterSpacing * fontSize;
        } else if (options.tracking) {
            x += (options.tracking / 1000) * fontSize;
        }
    }
    return x;
};

/**
 * Create a Path object that represents the given text.
 * @param  {string} text - The text to create.
 * @param  {number} [x=0] - Horizontal position of the beginning of the text.
 * @param  {number} [y=0] - Vertical position of the *baseline* of the text.
 * @param  {number} [fontSize=72] - Font size in pixels. We scale the glyph units by `1 / unitsPerEm * fontSize`.
 * @param  {GlyphRenderOptions=} options
 * @return {opentype.Path}
 */
Font.prototype.getPath = function(text, x, y, fontSize, options) {
    var fullPath = new Path();
    this.forEachGlyph(text, x, y, fontSize, options, function(glyph, gX, gY, gFontSize) {
        var glyphPath = glyph.getPath(gX, gY, gFontSize, options, this);
        fullPath.extend(glyphPath);
    });
    return fullPath;
};

/**
 * Create an array of Path objects that represent the glyphs of a given text.
 * @param  {string} text - The text to create.
 * @param  {number} [x=0] - Horizontal position of the beginning of the text.
 * @param  {number} [y=0] - Vertical position of the *baseline* of the text.
 * @param  {number} [fontSize=72] - Font size in pixels. We scale the glyph units by `1 / unitsPerEm * fontSize`.
 * @param  {GlyphRenderOptions=} options
 * @return {opentype.Path[]}
 */
Font.prototype.getPaths = function(text, x, y, fontSize, options) {
    var glyphPaths = [];
    this.forEachGlyph(text, x, y, fontSize, options, function(glyph, gX, gY, gFontSize) {
        var glyphPath = glyph.getPath(gX, gY, gFontSize, options, this);
        glyphPaths.push(glyphPath);
    });

    return glyphPaths;
};

/**
 * Returns the advance width of a text.
 *
 * This is something different than Path.getBoundingBox() as for example a
 * suffixed whitespace increases the advanceWidth but not the bounding box
 * or an overhanging letter like a calligraphic 'f' might have a quite larger
 * bounding box than its advance width.
 *
 * This corresponds to canvas2dContext.measureText(text).width
 *
 * @param  {string} text - The text to create.
 * @param  {number} [fontSize=72] - Font size in pixels. We scale the glyph units by `1 / unitsPerEm * fontSize`.
 * @param  {GlyphRenderOptions=} options
 * @return advance width
 */
Font.prototype.getAdvanceWidth = function(text, fontSize, options) {
    return this.forEachGlyph(text, 0, 0, fontSize, options, function() {});
};

/**
 * Draw the text on the given drawing context.
 * @param  {CanvasRenderingContext2D} ctx - A 2D drawing context, like Canvas.
 * @param  {string} text - The text to create.
 * @param  {number} [x=0] - Horizontal position of the beginning of the text.
 * @param  {number} [y=0] - Vertical position of the *baseline* of the text.
 * @param  {number} [fontSize=72] - Font size in pixels. We scale the glyph units by `1 / unitsPerEm * fontSize`.
 * @param  {GlyphRenderOptions=} options
 */
Font.prototype.draw = function(ctx, text, x, y, fontSize, options) {
    this.getPath(text, x, y, fontSize, options).draw(ctx);
};

/**
 * Draw the points of all glyphs in the text.
 * On-curve points will be drawn in blue, off-curve points will be drawn in red.
 * @param {CanvasRenderingContext2D} ctx - A 2D drawing context, like Canvas.
 * @param {string} text - The text to create.
 * @param {number} [x=0] - Horizontal position of the beginning of the text.
 * @param {number} [y=0] - Vertical position of the *baseline* of the text.
 * @param {number} [fontSize=72] - Font size in pixels. We scale the glyph units by `1 / unitsPerEm * fontSize`.
 * @param {GlyphRenderOptions=} options
 */
Font.prototype.drawPoints = function(ctx, text, x, y, fontSize, options) {
    this.forEachGlyph(text, x, y, fontSize, options, function(glyph, gX, gY, gFontSize) {
        glyph.drawPoints(ctx, gX, gY, gFontSize);
    });
};

/**
 * Draw lines indicating important font measurements for all glyphs in the text.
 * Black lines indicate the origin of the coordinate system (point 0,0).
 * Blue lines indicate the glyph bounding box.
 * Green line indicates the advance width of the glyph.
 * @param {CanvasRenderingContext2D} ctx - A 2D drawing context, like Canvas.
 * @param {string} text - The text to create.
 * @param {number} [x=0] - Horizontal position of the beginning of the text.
 * @param {number} [y=0] - Vertical position of the *baseline* of the text.
 * @param {number} [fontSize=72] - Font size in pixels. We scale the glyph units by `1 / unitsPerEm * fontSize`.
 * @param {GlyphRenderOptions=} options
 */
Font.prototype.drawMetrics = function(ctx, text, x, y, fontSize, options) {
    this.forEachGlyph(text, x, y, fontSize, options, function(glyph, gX, gY, gFontSize) {
        glyph.drawMetrics(ctx, gX, gY, gFontSize);
    });
};

/**
 * @param  {string}
 * @return {string}
 */
Font.prototype.getEnglishName = function(name) {
    var translations = this.names[name];
    if (translations) {
        return translations.en;
    }
};

/**
 * Validate
 */
Font.prototype.validate = function() {
    var _this = this;

    function assert(predicate, message) {
    }

    function assertNamePresent(name) {
        var englishName = _this.getEnglishName(name);
        assert(englishName && englishName.trim().length > 0);
    }

    // Identification information
    assertNamePresent('fontFamily');
    assertNamePresent('weightName');
    assertNamePresent('manufacturer');
    assertNamePresent('copyright');
    assertNamePresent('version');

    // Dimension information
    assert(this.unitsPerEm > 0);
};

/**
 * Convert the font object to a SFNT data structure.
 * This structure contains all the necessary tables and metadata to create a binary OTF file.
 * @return {opentype.Table}
 */
Font.prototype.toTables = function() {
    return sfnt.fontToTable(this);
};
/**
 * @deprecated Font.toBuffer is deprecated. Use Font.toArrayBuffer instead.
 */
Font.prototype.toBuffer = function() {
    console.warn('Font.toBuffer is deprecated. Use Font.toArrayBuffer instead.');
    return this.toArrayBuffer();
};
/**
 * Converts a `opentype.Font` into an `ArrayBuffer`
 * @return {ArrayBuffer}
 */
Font.prototype.toArrayBuffer = function() {
    var sfntTable = this.toTables();
    var bytes = sfntTable.encode();
    var buffer = new ArrayBuffer(bytes.length);
    var intArray = new Uint8Array(buffer);
    for (var i = 0; i < bytes.length; i++) {
        intArray[i] = bytes[i];
    }

    return buffer;
};

/**
 * Initiate a download of the OpenType font.
 */
Font.prototype.download = function(fileName) {
    var familyName = this.getEnglishName('fontFamily');
    var styleName = this.getEnglishName('fontSubfamily');
    fileName = fileName || familyName.replace(/\s/g, '') + '-' + styleName + '.otf';
    var arrayBuffer = this.toArrayBuffer();

    if (isBrowser()) {
        window.URL = window.URL || window.webkitURL;

        if (window.URL) {
            var dataView = new DataView(arrayBuffer);
            var blob = new Blob([dataView], {type: 'font/opentype'});

            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;

            var event = document.createEvent('MouseEvents');
            event.initEvent('click', true, false);
            link.dispatchEvent(event);
        } else {
            console.warn('Font file could not be downloaded. Try using a different browser.');
        }
    } else {
        var fs = require('fs');
        var buffer = arrayBufferToNodeBuffer(arrayBuffer);
        fs.writeFileSync(fileName, buffer);
    }
};
/**
 * @private
 */
Font.prototype.fsSelectionValues = {
    ITALIC:              0x001, //1
    UNDERSCORE:          0x002, //2
    NEGATIVE:            0x004, //4
    OUTLINED:            0x008, //8
    STRIKEOUT:           0x010, //16
    BOLD:                0x020, //32
    REGULAR:             0x040, //64
    USER_TYPO_METRICS:   0x080, //128
    WWS:                 0x100, //256
    OBLIQUE:             0x200  //512
};

/**
 * @private
 */
Font.prototype.usWidthClasses = {
    ULTRA_CONDENSED: 1,
    EXTRA_CONDENSED: 2,
    CONDENSED: 3,
    SEMI_CONDENSED: 4,
    MEDIUM: 5,
    SEMI_EXPANDED: 6,
    EXPANDED: 7,
    EXTRA_EXPANDED: 8,
    ULTRA_EXPANDED: 9
};

/**
 * @private
 */
Font.prototype.usWeightClasses = {
    THIN: 100,
    EXTRA_LIGHT: 200,
    LIGHT: 300,
    NORMAL: 400,
    MEDIUM: 500,
    SEMI_BOLD: 600,
    BOLD: 700,
    EXTRA_BOLD: 800,
    BLACK:    900
};

// The `fvar` table stores font variation axes and instances.

function addName(name, names) {
    var nameString = JSON.stringify(name);
    var nameID = 256;
    for (var nameKey in names) {
        var n = parseInt(nameKey);
        if (!n || n < 256) {
            continue;
        }

        if (JSON.stringify(names[nameKey]) === nameString) {
            return n;
        }

        if (nameID <= n) {
            nameID = n + 1;
        }
    }

    names[nameID] = name;
    return nameID;
}

function makeFvarAxis(n, axis, names) {
    var nameID = addName(axis.name, names);
    return [
        {name: 'tag_' + n, type: 'TAG', value: axis.tag},
        {name: 'minValue_' + n, type: 'FIXED', value: axis.minValue << 16},
        {name: 'defaultValue_' + n, type: 'FIXED', value: axis.defaultValue << 16},
        {name: 'maxValue_' + n, type: 'FIXED', value: axis.maxValue << 16},
        {name: 'flags_' + n, type: 'USHORT', value: 0},
        {name: 'nameID_' + n, type: 'USHORT', value: nameID}
    ];
}

function parseFvarAxis(data, start, names) {
    var axis = {};
    var p = new parse.Parser(data, start);
    axis.tag = p.parseTag();
    axis.minValue = p.parseFixed();
    axis.defaultValue = p.parseFixed();
    axis.maxValue = p.parseFixed();
    p.skip('uShort', 1);  // reserved for flags; no values defined
    axis.name = names[p.parseUShort()] || {};
    return axis;
}

function makeFvarInstance(n, inst, axes, names) {
    var nameID = addName(inst.name, names);
    var fields = [
        {name: 'nameID_' + n, type: 'USHORT', value: nameID},
        {name: 'flags_' + n, type: 'USHORT', value: 0}
    ];

    for (var i = 0; i < axes.length; ++i) {
        var axisTag = axes[i].tag;
        fields.push({
            name: 'axis_' + n + ' ' + axisTag,
            type: 'FIXED',
            value: inst.coordinates[axisTag] << 16
        });
    }

    return fields;
}

function parseFvarInstance(data, start, axes, names) {
    var inst = {};
    var p = new parse.Parser(data, start);
    inst.name = names[p.parseUShort()] || {};
    p.skip('uShort', 1);  // reserved for flags; no values defined

    inst.coordinates = {};
    for (var i = 0; i < axes.length; ++i) {
        inst.coordinates[axes[i].tag] = p.parseFixed();
    }

    return inst;
}

function makeFvarTable(fvar, names) {
    var result = new table.Table('fvar', [
        {name: 'version', type: 'ULONG', value: 0x10000},
        {name: 'offsetToData', type: 'USHORT', value: 0},
        {name: 'countSizePairs', type: 'USHORT', value: 2},
        {name: 'axisCount', type: 'USHORT', value: fvar.axes.length},
        {name: 'axisSize', type: 'USHORT', value: 20},
        {name: 'instanceCount', type: 'USHORT', value: fvar.instances.length},
        {name: 'instanceSize', type: 'USHORT', value: 4 + fvar.axes.length * 4}
    ]);
    result.offsetToData = result.sizeOf();

    for (var i = 0; i < fvar.axes.length; i++) {
        result.fields = result.fields.concat(makeFvarAxis(i, fvar.axes[i], names));
    }

    for (var j = 0; j < fvar.instances.length; j++) {
        result.fields = result.fields.concat(makeFvarInstance(j, fvar.instances[j], fvar.axes, names));
    }

    return result;
}

function parseFvarTable(data, start, names) {
    var p = new parse.Parser(data, start);
    var tableVersion = p.parseULong();
    check.argument(tableVersion === 0x00010000, 'Unsupported fvar table version.');
    var offsetToData = p.parseOffset16();
    // Skip countSizePairs.
    p.skip('uShort', 1);
    var axisCount = p.parseUShort();
    var axisSize = p.parseUShort();
    var instanceCount = p.parseUShort();
    var instanceSize = p.parseUShort();

    var axes = [];
    for (var i = 0; i < axisCount; i++) {
        axes.push(parseFvarAxis(data, start + offsetToData + i * axisSize, names));
    }

    var instances = [];
    var instanceStart = start + offsetToData + axisCount * axisSize;
    for (var j = 0; j < instanceCount; j++) {
        instances.push(parseFvarInstance(data, instanceStart + j * instanceSize, axes, names));
    }

    return {axes: axes, instances: instances};
}

var fvar = { make: makeFvarTable, parse: parseFvarTable };

// The `GDEF` table contains various glyph properties

var attachList = function() {
    return {
        coverage: this.parsePointer(Parser.coverage),
        attachPoints: this.parseList(Parser.pointer(Parser.uShortList))
    };
};

var caretValue = function() {
    var format = this.parseUShort();
    check.argument(format === 1 || format === 2 || format === 3,
        'Unsupported CaretValue table version.');
    if (format === 1) {
        return { coordinate: this.parseShort() };
    } else if (format === 2) {
        return { pointindex: this.parseShort() };
    } else if (format === 3) {
        // Device / Variation Index tables unsupported
        return { coordinate: this.parseShort() };
    }
};

var ligGlyph = function() {
    return this.parseList(Parser.pointer(caretValue));
};

var ligCaretList = function() {
    return {
        coverage: this.parsePointer(Parser.coverage),
        ligGlyphs: this.parseList(Parser.pointer(ligGlyph))
    };
};

var markGlyphSets = function() {
    this.parseUShort(); // Version
    return this.parseList(Parser.pointer(Parser.coverage));
};

function parseGDEFTable(data, start) {
    start = start || 0;
    var p = new Parser(data, start);
    var tableVersion = p.parseVersion(1);
    check.argument(tableVersion === 1 || tableVersion === 1.2 || tableVersion === 1.3,
        'Unsupported GDEF table version.');
    var gdef = {
        version: tableVersion,
        classDef: p.parsePointer(Parser.classDef),
        attachList: p.parsePointer(attachList),
        ligCaretList: p.parsePointer(ligCaretList),
        markAttachClassDef: p.parsePointer(Parser.classDef)
    };
    if (tableVersion >= 1.2) {
        gdef.markGlyphSets = p.parsePointer(markGlyphSets);
    }
    return gdef;
}
var gdef = { parse: parseGDEFTable };

// The `GPOS` table contains kerning pairs, among other things.

var subtableParsers$1 = new Array(10);         // subtableParsers[0] is unused

// https://docs.microsoft.com/en-us/typography/opentype/spec/gpos#lookup-type-1-single-adjustment-positioning-subtable
// this = Parser instance
subtableParsers$1[1] = function parseLookup1() {
    var start = this.offset + this.relativeOffset;
    var posformat = this.parseUShort();
    if (posformat === 1) {
        return {
            posFormat: 1,
            coverage: this.parsePointer(Parser.coverage),
            value: this.parseValueRecord()
        };
    } else if (posformat === 2) {
        return {
            posFormat: 2,
            coverage: this.parsePointer(Parser.coverage),
            values: this.parseValueRecordList()
        };
    }
    check.assert(false, '0x' + start.toString(16) + ': GPOS lookup type 1 format must be 1 or 2.');
};

// https://docs.microsoft.com/en-us/typography/opentype/spec/gpos#lookup-type-2-pair-adjustment-positioning-subtable
subtableParsers$1[2] = function parseLookup2() {
    var start = this.offset + this.relativeOffset;
    var posFormat = this.parseUShort();
    check.assert(posFormat === 1 || posFormat === 2, '0x' + start.toString(16) + ': GPOS lookup type 2 format must be 1 or 2.');
    var coverage = this.parsePointer(Parser.coverage);
    var valueFormat1 = this.parseUShort();
    var valueFormat2 = this.parseUShort();
    if (posFormat === 1) {
        // Adjustments for Glyph Pairs
        return {
            posFormat: posFormat,
            coverage: coverage,
            valueFormat1: valueFormat1,
            valueFormat2: valueFormat2,
            pairSets: this.parseList(Parser.pointer(Parser.list(function() {
                return {        // pairValueRecord
                    secondGlyph: this.parseUShort(),
                    value1: this.parseValueRecord(valueFormat1),
                    value2: this.parseValueRecord(valueFormat2)
                };
            })))
        };
    } else if (posFormat === 2) {
        var classDef1 = this.parsePointer(Parser.classDef);
        var classDef2 = this.parsePointer(Parser.classDef);
        var class1Count = this.parseUShort();
        var class2Count = this.parseUShort();
        return {
            // Class Pair Adjustment
            posFormat: posFormat,
            coverage: coverage,
            valueFormat1: valueFormat1,
            valueFormat2: valueFormat2,
            classDef1: classDef1,
            classDef2: classDef2,
            class1Count: class1Count,
            class2Count: class2Count,
            classRecords: this.parseList(class1Count, Parser.list(class2Count, function() {
                return {
                    value1: this.parseValueRecord(valueFormat1),
                    value2: this.parseValueRecord(valueFormat2)
                };
            }))
        };
    }
};

subtableParsers$1[3] = function parseLookup3() { return { error: 'GPOS Lookup 3 not supported' }; };
subtableParsers$1[4] = function parseLookup4() { return { error: 'GPOS Lookup 4 not supported' }; };
subtableParsers$1[5] = function parseLookup5() { return { error: 'GPOS Lookup 5 not supported' }; };
subtableParsers$1[6] = function parseLookup6() { return { error: 'GPOS Lookup 6 not supported' }; };
subtableParsers$1[7] = function parseLookup7() { return { error: 'GPOS Lookup 7 not supported' }; };
subtableParsers$1[8] = function parseLookup8() { return { error: 'GPOS Lookup 8 not supported' }; };
subtableParsers$1[9] = function parseLookup9() { return { error: 'GPOS Lookup 9 not supported' }; };

// https://docs.microsoft.com/en-us/typography/opentype/spec/gpos
function parseGposTable(data, start) {
    start = start || 0;
    var p = new Parser(data, start);
    var tableVersion = p.parseVersion(1);
    check.argument(tableVersion === 1 || tableVersion === 1.1, 'Unsupported GPOS table version ' + tableVersion);

    if (tableVersion === 1) {
        return {
            version: tableVersion,
            scripts: p.parseScriptList(),
            features: p.parseFeatureList(),
            lookups: p.parseLookupList(subtableParsers$1)
        };
    } else {
        return {
            version: tableVersion,
            scripts: p.parseScriptList(),
            features: p.parseFeatureList(),
            lookups: p.parseLookupList(subtableParsers$1),
            variations: p.parseFeatureVariationsList()
        };
    }

}

// GPOS Writing //////////////////////////////////////////////
// NOT SUPPORTED
var subtableMakers$1 = new Array(10);

function makeGposTable(gpos) {
    return new table.Table('GPOS', [
        {name: 'version', type: 'ULONG', value: 0x10000},
        {name: 'scripts', type: 'TABLE', value: new table.ScriptList(gpos.scripts)},
        {name: 'features', type: 'TABLE', value: new table.FeatureList(gpos.features)},
        {name: 'lookups', type: 'TABLE', value: new table.LookupList(gpos.lookups, subtableMakers$1)}
    ]);
}

var gpos = { parse: parseGposTable, make: makeGposTable };

// The `kern` table contains kerning pairs.

function parseWindowsKernTable(p) {
    var pairs = {};
    // Skip nTables.
    p.skip('uShort');
    var subtableVersion = p.parseUShort();
    check.argument(subtableVersion === 0, 'Unsupported kern sub-table version.');
    // Skip subtableLength, subtableCoverage
    p.skip('uShort', 2);
    var nPairs = p.parseUShort();
    // Skip searchRange, entrySelector, rangeShift.
    p.skip('uShort', 3);
    for (var i = 0; i < nPairs; i += 1) {
        var leftIndex = p.parseUShort();
        var rightIndex = p.parseUShort();
        var value = p.parseShort();
        pairs[leftIndex + ',' + rightIndex] = value;
    }
    return pairs;
}

function parseMacKernTable(p) {
    var pairs = {};
    // The Mac kern table stores the version as a fixed (32 bits) but we only loaded the first 16 bits.
    // Skip the rest.
    p.skip('uShort');
    var nTables = p.parseULong();
    //check.argument(nTables === 1, 'Only 1 subtable is supported (got ' + nTables + ').');
    if (nTables > 1) {
        console.warn('Only the first kern subtable is supported.');
    }
    p.skip('uLong');
    var coverage = p.parseUShort();
    var subtableVersion = coverage & 0xFF;
    p.skip('uShort');
    if (subtableVersion === 0) {
        var nPairs = p.parseUShort();
        // Skip searchRange, entrySelector, rangeShift.
        p.skip('uShort', 3);
        for (var i = 0; i < nPairs; i += 1) {
            var leftIndex = p.parseUShort();
            var rightIndex = p.parseUShort();
            var value = p.parseShort();
            pairs[leftIndex + ',' + rightIndex] = value;
        }
    }
    return pairs;
}

// Parse the `kern` table which contains kerning pairs.
function parseKernTable(data, start) {
    var p = new parse.Parser(data, start);
    var tableVersion = p.parseUShort();
    if (tableVersion === 0) {
        return parseWindowsKernTable(p);
    } else if (tableVersion === 1) {
        return parseMacKernTable(p);
    } else {
        throw new Error('Unsupported kern table version (' + tableVersion + ').');
    }
}

var kern = { parse: parseKernTable };

// The `loca` table stores the offsets to the locations of the glyphs in the font.

// Parse the `loca` table. This table stores the offsets to the locations of the glyphs in the font,
// relative to the beginning of the glyphData table.
// The number of glyphs stored in the `loca` table is specified in the `maxp` table (under numGlyphs)
// The loca table has two versions: a short version where offsets are stored as uShorts, and a long
// version where offsets are stored as uLongs. The `head` table specifies which version to use
// (under indexToLocFormat).
function parseLocaTable(data, start, numGlyphs, shortVersion) {
    var p = new parse.Parser(data, start);
    var parseFn = shortVersion ? p.parseUShort : p.parseULong;
    // There is an extra entry after the last index element to compute the length of the last glyph.
    // That's why we use numGlyphs + 1.
    var glyphOffsets = [];
    for (var i = 0; i < numGlyphs + 1; i += 1) {
        var glyphOffset = parseFn.call(p);
        if (shortVersion) {
            // The short table version stores the actual offset divided by 2.
            glyphOffset *= 2;
        }

        glyphOffsets.push(glyphOffset);
    }

    return glyphOffsets;
}

var loca = { parse: parseLocaTable };

// opentype.js

/**
 * The opentype library.
 * @namespace opentype
 */

// File loaders /////////////////////////////////////////////////////////
/**
 * Loads a font from a file. The callback throws an error message as the first parameter if it fails
 * and the font as an ArrayBuffer in the second parameter if it succeeds.
 * @param  {string} path - The path of the file
 * @param  {Function} callback - The function to call when the font load completes
 */
function loadFromFile(path, callback) {
    var fs = require('fs');
    fs.readFile(path, function(err, buffer) {
        if (err) {
            return callback(err.message);
        }

        callback(null, nodeBufferToArrayBuffer(buffer));
    });
}
/**
 * Loads a font from a URL. The callback throws an error message as the first parameter if it fails
 * and the font as an ArrayBuffer in the second parameter if it succeeds.
 * @param  {string} url - The URL of the font file.
 * @param  {Function} callback - The function to call when the font load completes
 */
function loadFromUrl(url, callback) {
    var request = new XMLHttpRequest();
    request.open('get', url, true);
    request.responseType = 'arraybuffer';
    request.onload = function() {
        if (request.response) {
            return callback(null, request.response);
        } else {
            return callback('Font could not be loaded: ' + request.statusText);
        }
    };

    request.onerror = function () {
        callback('Font could not be loaded');
    };

    request.send();
}

// Table Directory Entries //////////////////////////////////////////////
/**
 * Parses OpenType table entries.
 * @param  {DataView}
 * @param  {Number}
 * @return {Object[]}
 */
function parseOpenTypeTableEntries(data, numTables) {
    var tableEntries = [];
    var p = 12;
    for (var i = 0; i < numTables; i += 1) {
        var tag = parse.getTag(data, p);
        var checksum = parse.getULong(data, p + 4);
        var offset = parse.getULong(data, p + 8);
        var length = parse.getULong(data, p + 12);
        tableEntries.push({tag: tag, checksum: checksum, offset: offset, length: length, compression: false});
        p += 16;
    }

    return tableEntries;
}

/**
 * Parses WOFF table entries.
 * @param  {DataView}
 * @param  {Number}
 * @return {Object[]}
 */
function parseWOFFTableEntries(data, numTables) {
    var tableEntries = [];
    var p = 44; // offset to the first table directory entry.
    for (var i = 0; i < numTables; i += 1) {
        var tag = parse.getTag(data, p);
        var offset = parse.getULong(data, p + 4);
        var compLength = parse.getULong(data, p + 8);
        var origLength = parse.getULong(data, p + 12);
        var compression = (void 0);
        if (compLength < origLength) {
            compression = 'WOFF';
        } else {
            compression = false;
        }

        tableEntries.push({tag: tag, offset: offset, compression: compression,
            compressedLength: compLength, length: origLength});
        p += 20;
    }

    return tableEntries;
}

/**
 * @typedef TableData
 * @type Object
 * @property {DataView} data - The DataView
 * @property {number} offset - The data offset.
 */

/**
 * @param  {DataView}
 * @param  {Object}
 * @return {TableData}
 */
function uncompressTable(data, tableEntry) {
    if (tableEntry.compression === 'WOFF') {
        var inBuffer = new Uint8Array(data.buffer, tableEntry.offset + 2, tableEntry.compressedLength - 2);
        var outBuffer = new Uint8Array(tableEntry.length);
        tinyInflate(inBuffer, outBuffer);
        if (outBuffer.byteLength !== tableEntry.length) {
            throw new Error('Decompression error: ' + tableEntry.tag + ' decompressed length doesn\'t match recorded length');
        }

        var view = new DataView(outBuffer.buffer, 0);
        return {data: view, offset: 0};
    } else {
        return {data: data, offset: tableEntry.offset};
    }
}

// Public API ///////////////////////////////////////////////////////////

/**
 * Parse the OpenType file data (as an ArrayBuffer) and return a Font object.
 * Throws an error if the font could not be parsed.
 * @param  {ArrayBuffer}
 * @param  {Object} opt - options for parsing
 * @return {opentype.Font}
 */
function parseBuffer(buffer, opt) {
    opt = (opt === undefined || opt === null) ?  {} : opt;

    var indexToLocFormat;
    var ltagTable;

    // Since the constructor can also be called to create new fonts from scratch, we indicate this
    // should be an empty font that we'll fill with our own data.
    var font = new Font({empty: true});

    // OpenType fonts use big endian byte ordering.
    // We can't rely on typed array view types, because they operate with the endianness of the host computer.
    // Instead we use DataViews where we can specify endianness.
    var data = new DataView(buffer, 0);
    var numTables;
    var tableEntries = [];
    var signature = parse.getTag(data, 0);
    if (signature === String.fromCharCode(0, 1, 0, 0) || signature === 'true' || signature === 'typ1') {
        font.outlinesFormat = 'truetype';
        numTables = parse.getUShort(data, 4);
        tableEntries = parseOpenTypeTableEntries(data, numTables);
    } else if (signature === 'OTTO') {
        font.outlinesFormat = 'cff';
        numTables = parse.getUShort(data, 4);
        tableEntries = parseOpenTypeTableEntries(data, numTables);
    } else if (signature === 'wOFF') {
        var flavor = parse.getTag(data, 4);
        if (flavor === String.fromCharCode(0, 1, 0, 0)) {
            font.outlinesFormat = 'truetype';
        } else if (flavor === 'OTTO') {
            font.outlinesFormat = 'cff';
        } else {
            throw new Error('Unsupported OpenType flavor ' + signature);
        }

        numTables = parse.getUShort(data, 12);
        tableEntries = parseWOFFTableEntries(data, numTables);
    } else {
        throw new Error('Unsupported OpenType signature ' + signature);
    }

    var cffTableEntry;
    var fvarTableEntry;
    var glyfTableEntry;
    var gdefTableEntry;
    var gposTableEntry;
    var gsubTableEntry;
    var hmtxTableEntry;
    var kernTableEntry;
    var locaTableEntry;
    var nameTableEntry;
    var metaTableEntry;
    var p;

    for (var i = 0; i < numTables; i += 1) {
        var tableEntry = tableEntries[i];
        var table = (void 0);
        switch (tableEntry.tag) {
            case 'cmap':
                table = uncompressTable(data, tableEntry);
                font.tables.cmap = cmap.parse(table.data, table.offset);
                font.encoding = new CmapEncoding(font.tables.cmap);
                break;
            case 'cvt ' :
                table = uncompressTable(data, tableEntry);
                p = new parse.Parser(table.data, table.offset);
                font.tables.cvt = p.parseShortList(tableEntry.length / 2);
                break;
            case 'fvar':
                fvarTableEntry = tableEntry;
                break;
            case 'fpgm' :
                table = uncompressTable(data, tableEntry);
                p = new parse.Parser(table.data, table.offset);
                font.tables.fpgm = p.parseByteList(tableEntry.length);
                break;
            case 'head':
                table = uncompressTable(data, tableEntry);
                font.tables.head = head.parse(table.data, table.offset);
                font.unitsPerEm = font.tables.head.unitsPerEm;
                indexToLocFormat = font.tables.head.indexToLocFormat;
                break;
            case 'hhea':
                table = uncompressTable(data, tableEntry);
                font.tables.hhea = hhea.parse(table.data, table.offset);
                font.ascender = font.tables.hhea.ascender;
                font.descender = font.tables.hhea.descender;
                font.numberOfHMetrics = font.tables.hhea.numberOfHMetrics;
                break;
            case 'hmtx':
                hmtxTableEntry = tableEntry;
                break;
            case 'ltag':
                table = uncompressTable(data, tableEntry);
                ltagTable = ltag.parse(table.data, table.offset);
                break;
            case 'maxp':
                table = uncompressTable(data, tableEntry);
                font.tables.maxp = maxp.parse(table.data, table.offset);
                font.numGlyphs = font.tables.maxp.numGlyphs;
                break;
            case 'name':
                nameTableEntry = tableEntry;
                break;
            case 'OS/2':
                table = uncompressTable(data, tableEntry);
                font.tables.os2 = os2.parse(table.data, table.offset);
                break;
            case 'post':
                table = uncompressTable(data, tableEntry);
                font.tables.post = post.parse(table.data, table.offset);
                font.glyphNames = new GlyphNames(font.tables.post);
                break;
            case 'prep' :
                table = uncompressTable(data, tableEntry);
                p = new parse.Parser(table.data, table.offset);
                font.tables.prep = p.parseByteList(tableEntry.length);
                break;
            case 'glyf':
                glyfTableEntry = tableEntry;
                break;
            case 'loca':
                locaTableEntry = tableEntry;
                break;
            case 'CFF ':
                cffTableEntry = tableEntry;
                break;
            case 'kern':
                kernTableEntry = tableEntry;
                break;
            case 'GDEF':
                gdefTableEntry = tableEntry;
                break;
            case 'GPOS':
                gposTableEntry = tableEntry;
                break;
            case 'GSUB':
                gsubTableEntry = tableEntry;
                break;
            case 'meta':
                metaTableEntry = tableEntry;
                break;
        }
    }

    var nameTable = uncompressTable(data, nameTableEntry);
    font.tables.name = _name.parse(nameTable.data, nameTable.offset, ltagTable);
    font.names = font.tables.name;

    if (glyfTableEntry && locaTableEntry) {
        var shortVersion = indexToLocFormat === 0;
        var locaTable = uncompressTable(data, locaTableEntry);
        var locaOffsets = loca.parse(locaTable.data, locaTable.offset, font.numGlyphs, shortVersion);
        var glyfTable = uncompressTable(data, glyfTableEntry);
        font.glyphs = glyf.parse(glyfTable.data, glyfTable.offset, locaOffsets, font, opt);
    } else if (cffTableEntry) {
        var cffTable = uncompressTable(data, cffTableEntry);
        cff.parse(cffTable.data, cffTable.offset, font, opt);
    } else {
        throw new Error('Font doesn\'t contain TrueType or CFF outlines.');
    }

    var hmtxTable = uncompressTable(data, hmtxTableEntry);
    hmtx.parse(font, hmtxTable.data, hmtxTable.offset, font.numberOfHMetrics, font.numGlyphs, font.glyphs, opt);
    addGlyphNames(font, opt);

    if (kernTableEntry) {
        var kernTable = uncompressTable(data, kernTableEntry);
        font.kerningPairs = kern.parse(kernTable.data, kernTable.offset);
    } else {
        font.kerningPairs = {};
    }

    if (gdefTableEntry) {
        var gdefTable = uncompressTable(data, gdefTableEntry);
        font.tables.gdef = gdef.parse(gdefTable.data, gdefTable.offset);
    }

    if (gposTableEntry) {
        var gposTable = uncompressTable(data, gposTableEntry);
        font.tables.gpos = gpos.parse(gposTable.data, gposTable.offset);
        font.position.init();
    }

    if (gsubTableEntry) {
        var gsubTable = uncompressTable(data, gsubTableEntry);
        font.tables.gsub = gsub.parse(gsubTable.data, gsubTable.offset);
    }

    if (fvarTableEntry) {
        var fvarTable = uncompressTable(data, fvarTableEntry);
        font.tables.fvar = fvar.parse(fvarTable.data, fvarTable.offset, font.names);
    }

    if (metaTableEntry) {
        var metaTable = uncompressTable(data, metaTableEntry);
        font.tables.meta = meta.parse(metaTable.data, metaTable.offset);
        font.metas = font.tables.meta;
    }

    return font;
}

/**
 * Asynchronously load the font from a URL or a filesystem. When done, call the callback
 * with two arguments `(err, font)`. The `err` will be null on success,
 * the `font` is a Font object.
 * We use the node.js callback convention so that
 * opentype.js can integrate with frameworks like async.js.
 * @alias opentype.load
 * @param  {string} url - The URL of the font to load.
 * @param  {Function} callback - The callback.
 */
function load(url, callback, opt) {
    opt = (opt === undefined || opt === null) ?  {} : opt;
    var isNode = typeof window === 'undefined';
    var loadFn = isNode && !opt.isUrl ? loadFromFile : loadFromUrl;

    return new Promise(function (resolve, reject) {
        loadFn(url, function(err, arrayBuffer) {
            if (err) {
                if (callback) {
                    return callback(err);
                } else {
                    reject(err);
                }
            }
            var font;
            try {
                font = parseBuffer(arrayBuffer, opt);
            } catch (e) {
                if (callback) {
                    return callback(e, null);
                } else {
                    reject(e);
                }
            }
            if (callback) {
                return callback(null, font);
            } else {
                resolve(font);
            }
        });
    });
}

/**
 * Synchronously load the font from a URL or file.
 * When done, returns the font object or throws an error.
 * @alias opentype.loadSync
 * @param  {string} url - The URL of the font to load.
 * @param  {Object} opt - opt.lowMemory
 * @return {opentype.Font}
 */
function loadSync(url, opt) {
    var fs = require('fs');
    var buffer = fs.readFileSync(url);
    return parseBuffer(nodeBufferToArrayBuffer(buffer), opt);
}

var opentype = /*#__PURE__*/Object.freeze({
	__proto__: null,
	Font: Font,
	Glyph: Glyph,
	Path: Path,
	BoundingBox: BoundingBox,
	_parse: parse,
	parse: parseBuffer,
	load: load,
	loadSync: loadSync
});

async function getOpenTypeFont() {
    if (!this.openTypeFont) {
        var fontPath = this.style.getPropertyValue('src').match(/^url\(("|'|\s)*(.*?)("|'|\s)*\)$/i)[2];
        if (!fontPath.match(/^(http|\/|\\).*$/)) {
            var psFolderPath = this.parentStyleSheet.href;
            fontPath = psFolderPath.substring(0, psFolderPath.lastIndexOf('/')) + "/" + fontPath;
        }
        this.openTypeFont = await opentype.load(fontPath);
    }
    return this.openTypeFont;
}
function getTransformedPart(cmd, x, y, t) {
    var px = cmd[x];
    var py = cmd[y];
    cmd[x] = t[0] * px + t[2] * py + t[4],
        cmd[y] = t[1] * px + t[3] * py + t[5];
}
const pathPrototype = opentype.Path.prototype;
pathPrototype.transform = function (matrix) {
    var commands = this.commands;
    for (var i = 0; i < commands.length; i++) {
        var s = commands[i];
        switch (s.type) {
            case "C":
                getTransformedPart(s, 'x2', 'y2', matrix);
            case "Q":
                getTransformedPart(s, 'x1', 'y1', matrix);
            case "M":
            case "L":
                getTransformedPart(s, 'x', 'y', matrix);
                break;
            case "Z":
                break;
            default:
                throw new Error("Unexpected path command " + s.type);
        }
    }
};
const body = document.querySelector('body'), dummy = document.createElement('div');
dummy.style.position = "absolute";
dummy.style.color = "transparent";
dummy.style.zIndex = "-10";
body?.appendChild(dummy);
function getFontFaceRules(sheet, obj) {
    if (!obj) {
        obj = {
            map: {},
            getFormatedFamily: function (family) {
                return family.match(/^(\s|"|')*(.*?)(\s|"|'|)*$/)?.[2];
            },
            push: function (o) {
                var map = this.map, style = o.style, fontFamily = this.getFormatedFamily(style.getPropertyValue('font-family')), fontStyle = style.getPropertyValue('font-style');
                var secMap = map[fontFamily];
                if (!secMap) {
                    secMap = {};
                    map[fontFamily] = secMap;
                }
                map = secMap[fontStyle];
                if (!map) {
                    map = {};
                    secMap[fontStyle] = map;
                }
                map[style.getPropertyValue("font-weight")] = o;
            },
            cloneObj: function (obj, prop, callback) {
                if (!obj)
                    return;
                if (prop) {
                    var f = callback ? callback(obj, prop) : obj[prop];
                    if (!f)
                        return;
                    obj = {};
                    obj[prop] = f;
                }
                else {
                    obj = { ...obj };
                }
                return obj;
            },
            mapFontWieght: function (obj, fontWeight) {
                switch (fontWeight) {
                    case 'lighter':
                        fontWeight = -1;
                        for (var p in obj)
                            if (fontWeight == -1 || fontWeight > Number(p))
                                fontWeight = Number(p);
                        break;
                    case 'normal':
                        fontWeight = 400;
                        break;
                    case 'bold':
                        fontWeight = 700;
                        break;
                    case 'bolder':
                        fontWeight = -1;
                        for (var p in obj)
                            if (fontWeight < Number(p))
                                fontWeight = Number(p);
                        break;
                }
                return obj[fontWeight];
            },
            getCSSFontFaceRules: function (fontFamily, fontStyle, fontWeight) {
                var obj = {}, me = this;
                fontFamily.split(",").forEach(function (family) {
                    family = me.getFormatedFamily(family);
                    var font = me.cloneObj(me.map[family], fontStyle);
                    if (!font)
                        return;
                    for (var s in font) {
                        var st = me.cloneObj(font[s], fontWeight, fontWeight ? me.mapFontWieght : undefined);
                        if (!st)
                            continue;
                        font[s] = st;
                    }
                    obj[family] = font;
                });
                return obj;
            },
            getOpenTypeFont: function (fontFamily, fontStyle, fontWeight) {
                var rules = this.getCSSFontFaceRules(fontFamily, fontStyle, fontWeight);
                for (var p in rules)
                    if (p != 'Notdef') {
                        fontFamily = p;
                        break;
                    }
                rules = rules[fontFamily][fontStyle][fontWeight];
                return getOpenTypeFont.call(rules);
            }
        };
    }
    if (sheet instanceof StyleSheetList || sheet instanceof CSSRuleList) {
        for (var i = 0; i < sheet.length; ++i)
            getFontFaceRules(sheet[i], obj);
    }
    else if (sheet instanceof CSSStyleSheet) {
        try {
            getFontFaceRules((sheet.rules || sheet.cssRules), obj);
        }
        catch (e) {
            console.warn("Can't read the css rules of: " + sheet.href, e);
        }
    }
    else if (sheet instanceof CSSImportRule) {
        getFontFaceRules(sheet.styleSheet, obj);
    }
    else if (sheet instanceof CSSFontFaceRule) {
        obj.push(sheet);
    }
    return obj;
}
let fontRuleMap;
const fontLoader = {
    loadFontList: function () {
        fontRuleMap = getFontFaceRules(document.styleSheets, fontRuleMap);
    },
    loadFont: function (fontFamily, fontStyle, fontWeight) {
        return fontRuleMap?.getOpenTypeFont(fontFamily, fontStyle, fontWeight);
    },
    loadFonts: async function (fonts) {
        if (!fonts || !fonts.length) {
            return;
        }
        fonts.forEach(function (fo) {
            var loader = document.createElement('div');
            loader.style.fontFamily = fo.fontFamily;
            loader.style.fontStyle = fo.fontStyle;
            loader.style.fontWeight = fo.fontWeight;
            loader.innerHTML = 'loading';
            dummy.appendChild(loader);
        });
        await document.fonts.ready;
        dummy.innerHTML = '';
    }
};
async function getImage(path) {
    var img = new Image();
    await new window.Promise(function (resolve, reject) {
        img.onload = resolve;
        img.onerror = reject;
        img.src = path;
    });
    return img;
}

function formatString(t, ...e) {
    return t.replace(/{(\d+)}/g, (function (t, o) {
        return void 0 !== e[o] ? e[o] : t;
    }));
}
async function updateSelectionHandles(fabric) {
    const objDrawControls = fabric.Object.prototype.drawControls;
    function getPrefUnit() {
        return localStorage.getItem('prefUnit') || 'inch';
    }
    fabric.Object.prototype.set({
        borderColor: '#3399FF',
        cornerStyle: 'circle',
        transparentCorners: false,
        rotationFeedback: true,
        scalingFeedback: true,
        feedbackFontSize: 16,
        feedbackFontColor: 'white',
        feedbackFontFamily: 'Arial',
        feedbackBackColor: 'black',
        drawControls: function (ctx, styleOverride) {
            let res = objDrawControls.call(this, ctx, styleOverride);
            if (styleOverride) {
                this._drawRotationFeedback(ctx);
                this._drawScalingFeedback(ctx);
            }
            return res;
        },
        _drawRotationFeedback: function (ctx) {
            if (!this.rotationFeedback || !this.canvas?.isRotating || this.lockRotation) {
                return;
            }
            ctx.save();
            let fontSize = this.feedbackFontSize, fontFamily = this.feedbackFontFamily, angle = this.angle.toFixed(0);
            angle %= 360;
            if (angle < 0) {
                angle += 360;
            }
            let rotationText = angle + '\u00b0';
            ctx.globalAlpha = 1;
            ctx.font = fontSize + 'px ' + fontFamily;
            let textWidth = ctx.measureText(rotationText).width;
            ctx.rotate(-angle * Math.PI / 180);
            var rectWidth = 1.5 * ctx.measureText('360\u00b0').width, rectHeight = 1.5 * fontSize, rectX = -rectWidth / 2, rectY = -rectHeight * 0.85 / 2, cornerRadius = 5;
            ctx.lineJoin = "round";
            ctx.lineWidth = cornerRadius;
            //Draw the background rectangle.
            ctx.strokeStyle = this.feedbackBackColor;
            ctx.fillStyle = this.feedbackBackColor;
            ctx.strokeRect(rectX + (cornerRadius / 2), rectY + (cornerRadius / 2), rectWidth - cornerRadius, rectHeight - cornerRadius);
            ctx.fillRect(rectX + (cornerRadius / 2), rectY + (cornerRadius / 2), rectWidth - cornerRadius, rectHeight - cornerRadius);
            //Draw the rotation angle text.
            let x = rectX + (rectWidth - textWidth) / 2, y = fontSize / 2;
            ctx.fillStyle = this.feedbackFontColor;
            ctx.fillText(rotationText, x, y);
            ctx.restore();
        },
        convertToPrefUnits: function (mm) {
            switch (getPrefUnit()) {
                case 'inch':
                    return (mm / 25.4).toFixed(1);
                default:
                    return mm.toFixed(1);
            }
        },
        _drawScalingFeedback: function (ctx) {
            if (!this.scalingFeedback || !this.canvas?.isScaling || (this.lockScalingX && this.lockScalingY)) {
                return;
            }
            ctx.save();
            let fontSize = this.feedbackFontSize, fontFamily = this.feedbackFontFamily, angle = this.angle.toFixed(0);
            angle %= 360;
            if (angle < 0) {
                angle += 360;
            }
            let width = this.scaleX * this.width, height = this.scaleY * this.height, unit = getPrefUnit() === 'inch' ? 'in' : 'mm';
            let scalingText = formatString("W : {0} {1}\nH : {2} {1}", this.convertToPrefUnits(width), unit, this.convertToPrefUnits(height)).split('\n');
            ctx.globalAlpha = 1;
            ctx.font = fontSize + 'px ' + fontFamily;
            let textWidth = Math.max(ctx.measureText(scalingText[0]).width, ctx.measureText(scalingText[1]).width);
            ctx.rotate(-angle * Math.PI / 180);
            let rectWidth = 1.1 * textWidth, rectHeight = 2.6 * fontSize, rectX = -rectWidth / 2, rectY = -rectHeight * 0.85 / 2, cornerRadius = 5;
            ctx.lineJoin = "round";
            ctx.lineWidth = cornerRadius;
            //Draw the background rectangle.
            ctx.strokeStyle = this.feedbackBackColor;
            ctx.fillStyle = this.feedbackBackColor;
            ctx.strokeRect(rectX + (cornerRadius / 2), rectY + (cornerRadius / 2), rectWidth - cornerRadius, rectHeight - cornerRadius);
            ctx.fillRect(rectX + (cornerRadius / 2), rectY + (cornerRadius / 2), rectWidth - cornerRadius, rectHeight - cornerRadius);
            //Draw the scaling text.
            let x = rectX + (rectWidth - textWidth) / 2;
            ctx.fillStyle = this.feedbackFontColor;
            ctx.fillText(scalingText[0], x, 0);
            ctx.fillText(scalingText[1], x, 1.15 * fontSize);
            ctx.restore();
        }
    });
    var mtrImage = await getImage(img$3);
    var renderIconControl = fabric.controlsUtils.renderIconControl;
    fabric.Object.prototype.controlsSetting.defaultControls.mtr.render = function (ctx, left, top) {
        ctx.save();
        renderIconControl.call(this, ctx, left, top, mtrImage);
        ctx.restore();
    };
    let trImage = await getImage(img$2);
    fabric.Object.prototype.controlsSetting.additionalControls.delete = new fabric.Control({
        x: 0.5,
        y: -0.5,
        cursorStyleHandler: function (eventData, control, fabricObject) {
            if (fabricObject.undeletable) {
                return "not-allowed";
            }
            return "pointer";
        },
        render: function (ctx, left, top, styleOverride, fabricObject) {
            ctx.save();
            renderIconControl.call(this, ctx, left, top, trImage);
            ctx.restore();
        },
        getActionName: function () {
            return 'delete';
        },
        mouseDownHandler: function (eventData, transform) {
            var fabricObject = transform.target;
            if (fabricObject.undeletable) {
                return;
            }
            fabricObject.getParent().remove(fabricObject);
        }
    });
}

function addPrototypeProps(fabric) {
    var IS_DONTENUM_BUGGY = (function () {
        for (var p in { toString: 1 }) {
            if (p === 'toString') {
                return false;
            }
        }
        return true;
    })();
    function addMethods(klass, source, parent) {
        for (var property in source) {
            if (property in klass.prototype &&
                typeof klass.prototype[property] === 'function' &&
                (source[property] + '').indexOf('callSuper') > -1) {
                klass.prototype[property] = (function (property) {
                    return function () {
                        var superclass = this.constructor.superclass;
                        this.constructor.superclass = parent;
                        var returnValue = source[property].apply(this, arguments);
                        this.constructor.superclass = superclass;
                        if (property !== 'initialize') {
                            return returnValue;
                        }
                    };
                })(property);
            }
            else {
                klass.prototype[property] = source[property];
            }
            if (IS_DONTENUM_BUGGY) {
                if (source.toString !== Object.prototype.toString) {
                    klass.prototype.toString = source.toString;
                }
                if (source.valueOf !== Object.prototype.valueOf) {
                    klass.prototype.valueOf = source.valueOf;
                }
            }
        }
    }
    fabric.util.addPrototypeProps = function (klass, obj) {
        if (typeof obj != 'object' || obj instanceof Array)
            return;
        addMethods(klass, obj, klass.superclass);
    };
    // for gpu acceleration.
    fabric.Canvas2dFilterBackend.prototype.applyFilters = function (filters, sourceElement, sourceWidth, sourceHeight, targetCanvas) {
        var ctx = targetCanvas.getContext('2d', { willReadFrequently: true });
        ctx.drawImage(sourceElement, 0, 0, sourceWidth, sourceHeight);
        var imageData = ctx.getImageData(0, 0, sourceWidth, sourceHeight);
        var originalImageData = ctx.getImageData(0, 0, sourceWidth, sourceHeight);
        var pipelineState = {
            sourceWidth: sourceWidth,
            sourceHeight: sourceHeight,
            imageData: imageData,
            originalEl: sourceElement,
            originalImageData: originalImageData,
            canvasEl: targetCanvas,
            ctx: ctx,
            filterBackend: this,
        };
        filters.forEach(function (filter) { filter.applyTo(pipelineState); });
        if (pipelineState.imageData.width !== sourceWidth || pipelineState.imageData.height !== sourceHeight) {
            targetCanvas.width = pipelineState.imageData.width;
            targetCanvas.height = pipelineState.imageData.height;
        }
        ctx.putImageData(pipelineState.imageData, 0, 0);
        return pipelineState;
    };
}

function objectOverrides(fabric) {
    let util = fabric.util, degreesToRadians = util.degreesToRadians, removeFromArray = util.removeFromArray, qrDecompose = util.qrDecompose, multiplyMatrices = util.multiplyTransformMatrices, invertTransform = util.invertTransform;
    util.addPrototypeProps(fabric.Object, {
        emitClip: true,
        getSuperParentLayer: function () {
            var currLayer = this.layer, layer = currLayer;
            while (currLayer) {
                currLayer = currLayer.layer;
                if (currLayer)
                    layer = currLayer;
            }
            return layer;
        },
        getParentLayer: function () {
            return this.layer;
        },
        getParent: function () {
            return this.layer || this.canvas;
        },
        getAngle: function () {
            return this.angle;
        },
        isOnScreen: function (calculate) {
            if (this.previewCanvas)
                return true;
            if (!this.canvas) {
                return false;
            }
            var pointTL = this.canvas.vptCoords.tl, pointBR = this.canvas.vptCoords.br, points = this.getCoords(true, calculate), layer = this.getParentLayer();
            if (layer) {
                return true;
            }
            if (points.some(function (point) {
                return point.x <= pointBR.x && point.x >= pointTL.x &&
                    point.y <= pointBR.y && point.y >= pointTL.y;
            })) {
                return true;
            }
            if (this.intersectsWithRect(pointTL, pointBR, true, calculate)) {
                return true;
            }
            return this._containsCenterOfCanvas(pointTL, pointBR, calculate);
        },
        getViewportTransform: function (skipLayer) {
            if (this.canvas && this.canvas.viewportTransform) {
                return this.calcLayerMatrix().value;
            }
            return fabric.iMatrix.concat();
        },
        transformMatrixKey: function (skipGroup) {
            var sep = '_', prefix = '';
            if (!skipGroup && this.group) {
                prefix = this.group.transformMatrixKey(skipGroup) + sep;
            }
            else if (this.canvas) {
                var vpt = this.canvas.viewportTransform;
                if (vpt) {
                    prefix += JSON.stringify(vpt);
                }
            }
            return prefix + this.top + sep + this.left + sep + this.scaleX + sep + this.scaleY +
                sep + this.skewX + sep + this.skewY + sep + this.angle + sep + this.originX + sep + this.originY +
                sep + this.width + sep + this.height + sep + this.strokeWidth + this.flipX + this.flipY;
        },
        calcLayerMatrix: function () {
            var key = this.transformMatrixKey(true), cache = this.layerMatrixCache || (this.layerMatrixCache = {});
            if (cache.key === key) {
                return cache;
            }
            var layer = this.getParentLayer(), options;
            if (layer) {
                options = {
                    angle: layer.angle,
                    translateX: layer.left,
                    translateY: layer.top,
                    scaleX: layer.scaleX,
                    scaleY: layer.scaleY,
                    skewX: layer.skewX,
                    skewY: layer.skewY,
                    flipX: layer.flipX,
                    flipY: layer.flipY,
                };
                var m = util.composeMatrix(options);
                cache.value = multiplyMatrices(this.canvas.viewportTransform, m);
                //m[4] = 0; m[5] = 0;
                cache.poinerMatrix = invertTransform(m);
            }
            else {
                cache.poinerMatrix = [1, 0, 0, 1, 0, 0];
                cache.value = this.canvas.viewportTransform.slice(0);
            }
            cache.key = key;
            return cache;
        },
        _calculateCurrentDimensions: function () {
            var opt = qrDecompose(this.getViewportTransform()), dim = this._getTransformedDimensions(), p = new fabric.Point(dim.x * opt.scaleX, dim.y * opt.scaleY);
            return p.scalarAdd(2 * this.padding);
        },
        _renderControls: function (ctx, styleOverride) {
            var vpt = this.getViewportTransform(), matrix = this.calcTransformMatrix(), options, drawBorders, drawControls;
            styleOverride = styleOverride || {};
            drawBorders = typeof styleOverride.hasBorders !== 'undefined' ? styleOverride.hasBorders : this.hasBorders;
            drawControls = typeof styleOverride.hasControls !== 'undefined' ? styleOverride.hasControls : this.hasControls;
            matrix = multiplyMatrices(vpt, matrix);
            options = qrDecompose(matrix);
            ctx.save();
            ctx.translate(options.translateX, options.translateY);
            ctx.lineWidth = 1 * this.borderScaleFactor;
            if (!this.group) {
                ctx.globalAlpha = this.isMoving ? this.borderOpacityWhenMoving : 1;
            }
            if (styleOverride.forActiveSelection) {
                ctx.rotate(degreesToRadians(options.angle));
                drawBorders && this.drawBordersInGroup(ctx, options, styleOverride);
            }
            else {
                var layer = this.getParentLayer();
                ctx.rotate(degreesToRadians(layer ? options.angle : this.angle));
                drawBorders && this.drawBorders(ctx, styleOverride);
            }
            drawControls && this.drawControls(ctx, styleOverride);
            ctx.restore();
        },
        calcOCoords: function () {
            var rotateMatrix = this._calcRotateMatrix(), translateMatrix = this._calcTranslateMatrix(), vpt = this.getViewportTransform(), startMatrix = multiplyMatrices(vpt, translateMatrix), finalMatrix = multiplyMatrices(startMatrix, rotateMatrix), dim = this._calculateCurrentDimensions(), coords = {}, opt = qrDecompose(vpt);
            finalMatrix = multiplyMatrices(finalMatrix, [1 / opt.scaleX, 0, 0, 1 / opt.scaleY, 0, 0]);
            this.forEachControl(function (control, key, fabricObject) {
                coords[key] = control.positionHandler(dim, finalMatrix, fabricObject);
            });
            return coords;
        },
        getTotalObjectScaling: function () {
            var scale = this.getObjectScaling(), scaleX = scale.scaleX, scaleY = scale.scaleY;
            if (this.canvas) {
                var retina = this.canvas.getRetinaScaling();
                var zoom = this.canvas.getZoom();
                scaleX *= zoom * retina;
                scaleY *= zoom * retina;
                if (this.layer) {
                    scaleX *= this.layer.scaleX;
                    scaleY *= this.layer.scaleY;
                }
            }
            return { scaleX: scaleX, scaleY: scaleY };
        },
        _updateCacheCanvas: function () {
            var targetCanvas = this.canvas;
            if (!this.layer && this.noScaleCache && targetCanvas && targetCanvas._currentTransform) {
                var target = targetCanvas._currentTransform.target, action = targetCanvas._currentTransform.action;
                if (this === target && action.slice && (action === 'rotate' || action.slice(0, 5) === 'scale')) {
                    return false;
                }
            }
            var canvas = this._cacheCanvas, dims = this._limitCacheSize(this._getCacheCanvasDimensions()), minCacheSize = fabric.minCacheSideLimit, width = dims.width, height = dims.height, drawingWidth, drawingHeight, zoomX = dims.zoomX, zoomY = dims.zoomY, dimensionsChanged = width !== this.cacheWidth || height !== this.cacheHeight, zoomChanged = this.zoomX !== zoomX || this.zoomY !== zoomY, shouldRedraw = dimensionsChanged || zoomChanged, additionalWidth = 0, additionalHeight = 0, shouldResizeCanvas = false;
            if (dimensionsChanged) {
                var canvasWidth = this._cacheCanvas.width, canvasHeight = this._cacheCanvas.height, sizeGrowing = width > canvasWidth || height > canvasHeight, sizeShrinking = (width < canvasWidth * 0.9 || height < canvasHeight * 0.9) && canvasWidth > minCacheSize && canvasHeight > minCacheSize;
                shouldResizeCanvas = sizeGrowing || sizeShrinking;
                if (sizeGrowing && !dims.capped && (width > minCacheSize || height > minCacheSize)) {
                    additionalWidth = width * 0.1;
                    additionalHeight = height * 0.1;
                }
            }
            if (shouldRedraw) {
                if (shouldResizeCanvas) {
                    canvas.width = Math.ceil(width + additionalWidth);
                    canvas.height = Math.ceil(height + additionalHeight);
                }
                else {
                    this._cacheContext.setTransform(1, 0, 0, 1, 0, 0);
                    this._cacheContext.clearRect(0, 0, canvas.width, canvas.height);
                }
                drawingWidth = dims.x / 2;
                drawingHeight = dims.y / 2;
                this.cacheTranslationX = Math.round(canvas.width / 2 - drawingWidth) + drawingWidth;
                this.cacheTranslationY = Math.round(canvas.height / 2 - drawingHeight) + drawingHeight;
                this.cacheWidth = width;
                this.cacheHeight = height;
                this._cacheContext.translate(this.cacheTranslationX, this.cacheTranslationY);
                this._cacheContext.scale(zoomX, zoomY);
                this.zoomX = zoomX;
                this.zoomY = zoomY;
                return true;
            }
            return false;
        },
        isLayer: function () {
            return false;
        },
        isLocked: function () {
            return this.locked || this.getParentLayer()?.isLocked();
        },
        getSvgCommons: function () {
            return [
                this.id ? 'id="' + this.id + '" ' : '',
                this.emitClip && this.clipPath && this.clipPath.clipPathId ? 'clip-path="url(#' + this.clipPath.clipPathId + ')" ' : '',
            ].join('');
        },
        _createBaseSVGMarkup: function (objectMarkup, options) {
            options = options || {};
            var noStyle = options.noStyle, reviver = options.reviver, styleInfo = noStyle ? '' : 'style="' + this.getSvgStyles() + '" ', shadowInfo = options.withShadow ? 'style="' + this.getSvgFilter() + '" ' : '', clipPath = this.emitClip && this.clipPath, vectorEffect = this.strokeUniform ? 'vector-effect="non-scaling-stroke" ' : '', absoluteClipPath = clipPath && clipPath.absolutePositioned, stroke = this.stroke, fill = this.fill, shadow = this.shadow, commonPieces, markup = [], clipPathMarkup, index = objectMarkup.indexOf('COMMON_PARTS'), additionalTransform = options.additionalTransform;
            if (clipPath) {
                clipPath.clipPathId = 'CLIPPATH_' + fabric.Object.__uid++;
                clipPathMarkup = '<clipPath id="' + clipPath.clipPathId + '" >\n' +
                    clipPath.toClipPathSVG(reviver) +
                    '</clipPath>\n';
            }
            if (absoluteClipPath) {
                markup.push('<g ', shadowInfo, this.getSvgCommons(), ' >\n');
            }
            markup.push('<g ', this.getSvgTransform(false), !absoluteClipPath ? shadowInfo + this.getSvgCommons() : '', ' >\n');
            if (fill && fill.toLive) {
                markup.push(fill.toSVG(this));
            }
            if (stroke && stroke.toLive) {
                markup.push(stroke.toSVG(this));
            }
            if (shadow) {
                markup.push(shadow.toSVG(this));
            }
            if (clipPath) {
                markup.push(clipPathMarkup);
            }
            if (this.emitExtraStroke) {
                var extraStrokes = this.getExtraStrokes();
                if (extraStrokes) {
                    for (var i = 0, len = extraStrokes.length; i < len; ++i) {
                        if (objectMarkup[index] = this.emitExtraStroke(extraStrokes[i]))
                            markup.push(objectMarkup.join(''));
                    }
                }
            }
            commonPieces = [
                styleInfo,
                vectorEffect,
                noStyle ? '' : this.addPaintOrder(),
                additionalTransform ? ' transform="' + additionalTransform + '" ' : '',
            ];
            objectMarkup[index] = this.emitNormal(commonPieces);
            markup.push(objectMarkup.join(''));
            markup.push('</g>\n');
            absoluteClipPath && markup.push('</g>\n');
            return reviver ? reviver(markup.join('')) : markup.join('');
        },
        getExtraStrokes: function () {
            var extraStrokes = this.extraStrokes;
            if (!extraStrokes)
                return [];
            var strokeWidth = this.strokeWidth / 2, me = this;
            extraStrokes = extraStrokes.map(function (dec, idx) {
                dec = JSON.parse(JSON.stringify(dec));
                dec.strokeWidth = dec.strokeWidth || me.strokeWidth;
                dec.strokeWidth += strokeWidth;
                strokeWidth = dec.strokeWidth;
                dec.strokeWidth *= 2;
                return dec;
            });
            return extraStrokes.reverse();
        },
        emitNormal: function (common) {
            return common.join('');
        },
        isExcludeFromExport: function () {
            return this.excludeFromExport;
        }
    });
    fabric.util.clipContext = function (receiver, ctx) {
        ctx.save();
        ctx.beginPath();
        receiver.clipTo(ctx);
        ctx.clip();
    };
    fabric.util.getSvgColorString = function (prop, value) {
        if (!value) {
            return prop + ': none; ';
        }
        else if (value.toLive) {
            return prop + ': url(#SVGID_' + value.id + '); ';
        }
        else {
            var color = new fabric.Color(value), str = prop + ': ' + color.toRgb() + '; ', opacity = color.getAlpha();
            if (opacity !== 1) {
                str += prop + '-opacity: ' + opacity.toString() + '; ';
            }
            return str;
        }
    };
    fabric.util.addPrototypeProps(fabric.StaticCanvas, {
        renderCanvas: function (ctx, objects) {
            var v = this.viewportTransform, path = this.clipPath;
            this.cancelRequestedRender();
            this.calcViewportBoundaries();
            this.clearContext(ctx);
            fabric.util.setImageSmoothing(ctx, this.imageSmoothingEnabled);
            this.fire('before:render', { ctx: ctx, });
            this._renderBackground(ctx);
            if (this.renderCustomBackground) {
                this.renderCustomBackground(ctx);
            }
            if (this.clipTo) {
                fabric.util.clipContext(this, ctx);
            }
            ctx.save();
            //apply viewport transform once for all rendering process
            ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
            this._renderObjects(ctx, objects);
            ctx.restore();
            if (!this.controlsAboveOverlay && this.interactive) {
                this.drawControls(ctx);
            }
            if (this.clipTo) {
                ctx.restore();
            }
            if (path) {
                path.canvas = this;
                // needed to setup a couple of variables
                path.shouldCache();
                path._transformDone = true;
                path.renderCache({ forClipping: true });
                this.drawClipPathOnCanvas(ctx);
            }
            this._renderOverlay(ctx);
            if (this.renderCustomOverlay) {
                this.renderCustomOverlay(ctx);
            }
            if (this.controlsAboveOverlay && this.interactive) {
                this.drawControls(ctx);
            }
            this.fire('after:render', { ctx: ctx, });
        },
        sendBackwards: function (object) {
            if (!object) {
                return this;
            }
            var activeSelection = this._activeObject, i, obj, idx, newIdx, objs, lowestIndex = this.lowestFgObjectIndex || 0;
            if (object === activeSelection && object.type === 'activeSelection') {
                objs = activeSelection._objects;
                if (this.getLowestObjectIndex) {
                    lowestIndex = this.getLowestObjectIndex(objs[0]);
                }
                for (i = 0; i < objs.length; i++) {
                    obj = objs[i];
                    idx = this._objects.indexOf(obj);
                    newIdx = idx;
                    if (idx !== lowestIndex) {
                        newIdx = idx - 1;
                        removeFromArray(this._objects, obj);
                        this._objects.splice(newIdx, 0, obj);
                    }
                    lowestIndex = newIdx + 1; // can't go under the previous selected object
                }
            }
            else {
                idx = this._objects.indexOf(object);
                if (this.getLowestObjectIndex) {
                    lowestIndex = this.getLowestObjectIndex(object);
                }
                if (idx !== lowestIndex) {
                    // if object is not on the bottom of stack
                    newIdx = idx - 1;
                    removeFromArray(this._objects, object);
                    this._objects.splice(newIdx, 0, object);
                }
            }
            this.renderOnAddRemove && this.requestRenderAll();
            return this;
        },
        sendToBack: function (object) {
            if (!object) {
                return this;
            }
            var activeSelection = this._activeObject, i, obj, objs, lowestIndex = this.lowestFgObjectIndex || 0;
            if (object === activeSelection && object.type === 'activeSelection') {
                objs = activeSelection._objects;
                for (i = objs.length; i--;) {
                    obj = objs[i];
                    removeFromArray(this._objects, obj);
                    if (this.getLowestObjectIndex) {
                        lowestIndex = this.getLowestObjectIndex(obj);
                    }
                    this._objects.splice(lowestIndex, 0, obj);
                }
            }
            else {
                removeFromArray(this._objects, object);
                if (this.getLowestObjectIndex) {
                    lowestIndex = this.getLowestObjectIndex(object);
                }
                this._objects.splice(lowestIndex, 0, object);
            }
            this.renderOnAddRemove && this.requestRenderAll();
            return this;
        },
        _setSVGObjects: function (markup, reviver) {
            var instance, i, len, objects = this._objects;
            for (i = 0, len = objects.length; i < len; i++) {
                instance = objects[i];
                if (instance.isExcludeFromExport()) {
                    continue;
                }
                this._setSVGObject(markup, instance, reviver);
            }
        },
        closeSVGEditing: function () {
            let layeringTarget = this.layeringTarget;
            if (layeringTarget) {
                this.setSvgEditing(layeringTarget, false);
            }
        }
    });
    function drawImageProportionally(ctx, img, left, top, width, height) {
        var rx = width / img.width, ry = height / img.height;
        if (rx < ry) {
            top += (height - img.height * rx) / 2;
            height = img.height * rx;
        }
        else {
            left += (width - img.width * ry) / 2;
            width = img.width * ry;
        }
        ctx.drawImage(img, left - width / 2, top - height / 2, width, height);
    }
    fabric.Object.prototype.controlsSetting = {
        icon: {
            cornerSize: 24,
            cornerStrokeColor: '#CBCED0',
            cornerColor: 'white',
            cornerPadding: 10
        },
        circle: {
            cornerColor: 'white',
            cornerStrokeColor: '#CBCED0',
            cornerSize: 11
        },
        defaultControls: { ...fabric.Object.prototype.controls },
        defaultTextboxControls: fabric.Textbox.prototype.controls,
        additionalControls: {}
    };
    var renderCircleControl = fabric.controlsUtils.renderCircleControl;
    fabric.controlsUtils.renderCircleControl = function (ctx, left, top, styleOverride, fabricObject) {
        styleOverride.__proto__ = fabric.Object.prototype.controlsSetting.circle;
        return renderCircleControl.call(this, ctx, left, top, styleOverride, fabricObject);
    };
    fabric.controlsUtils.renderIconControl = function (ctx, left, top, icon, settings = {}) {
        settings.__proto__ = fabric.Object.prototype.controlsSetting.icon;
        var size = settings.cornerSize, cornerStrokeColor = settings.cornerStrokeColor, cornerColor = settings.cornerColor, cornerPadding = settings.cornerPadding;
        ctx.strokeStyle = ctx.fillStyle = cornerColor;
        ctx.strokeStyle = cornerStrokeColor;
        var fill = !this.transparentCorners;
        var stroke = !this.transparentCorners && cornerStrokeColor;
        ctx.beginPath();
        ctx.arc(left, top, size / 2, 0, 2 * Math.PI, false);
        if (fill) {
            ctx.save();
            ctx.globalAlpha = 1;
            ctx.fill();
            ctx.restore();
        }
        if (stroke) {
            ctx.stroke();
        }
        if (icon !== undefined) {
            drawImageProportionally(ctx, icon, left, top, size - cornerPadding, size - cornerPadding);
        }
    };
    fabric.Object.prototype.getAbsoluteObject = function () {
        let obj = this;
        const active = this.canvas?._activeObject;
        const objects = active?._objects;
        if (active instanceof fabric.ActiveSelection && objects.some((i) => i === this)) {
            const groupMatrix = this.group.calcOwnMatrix();
            obj = Object.create(this);
            fabric.util.addTransformToObject(obj, groupMatrix);
            obj.group = undefined;
        }
        return obj;
    };
    fabric.Object.prototype.additionalProperties = [
        'id',
        'selectable',
        'evented',
        'locked',
        'hasControls',
        'undeletable'
    ];
    let toObject = fabric.Object.prototype.toObject;
    fabric.Object.prototype.toObject = function (propertiesToInclude) {
        let additionalProperties = this.additionalProperties.concat(propertiesToInclude || []);
        let res = toObject.call(this.getAbsoluteObject(), additionalProperties);
        let keys = Object.keys(res).filter(i => i !== 'type'), proto = Object.getPrototypeOf(this);
        for (let key of keys) {
            if (proto[key] === res[key]) {
                delete res[key];
            }
        }
        return res;
    };
    const applyFilters = fabric.WebglFilterBackend.prototype.applyFilters;
    fabric.WebglFilterBackend.prototype.applyFilters = function (filters, source, width, height, targetCanvas, cacheKey) {
        this.canvas.width = width;
        this.canvas.height = height;
        return applyFilters.apply(this, arguments);
    };
}

function addLayerClass(fabric) {
    let multiplyMatrices = fabric.util.multiplyTransformMatrices, qrDecompose = fabric.util.qrDecompose;
    fabric.Layer = fabric.util.createClass(fabric.Group, {
        type: 'layer',
        renderOnAddRemove: true,
        renderClip: false,
        initialize: function (objects, options) {
            this.callSuper('initialize', objects, options, true);
            this.hasControls = false;
            var me = this;
            this._objects.forEach(function (obj) {
                delete obj.group;
                obj.layer = me;
            });
            if (options.clipPath) {
                options.clipPath.set({
                    layer: me,
                    isLayerClip: true,
                    skipInnerSelection: true
                });
            }
        },
        _renderControls: function () {
            var args = arguments;
            this._objects.forEach(function (obj) {
                obj._renderControls.apply(obj, args);
            });
        },
        isCacheDirty: function (skipCanvas) {
            var val = this.callSuper('isCacheDirty', skipCanvas);
            if (!val && this.canvas && this.canvas._activeObject) {
                val = this.canvas._activeObject.getParentLayer() === this;
            }
            return val;
        },
        __chooseObjectsToRender: fabric.LayeredCanvas.prototype.__chooseObjectsToRender,
        _render: function () {
            var args = arguments;
            this.__chooseObjectsToRender(this.canvas).forEach(function (obj) {
                obj.render.apply(obj, args);
            });
        },
        drawObject: function (ctx) {
            var clipPath = this.clipPath;
            ctx.clearRect(-this.width, -this.height, 2 * this.width, 2 * this.height);
            ctx.save();
            ctx.translate(-this.width / 2, -this.height / 2);
            this._render(ctx);
            ctx.restore();
            this._drawClipPath(ctx);
            if (this.renderClip && clipPath) {
                ctx.save();
                var origX = -((this.width - clipPath.width) / 2 - clipPath.left), origY = -((this.height - clipPath.height) / 2 - clipPath.top);
                ctx.transform(1, 0, 0, 1, origX, origY);
                clipPath._render.call(clipPath, ctx);
                ctx.restore();
            }
        },
        getCanvas: function () {
            var canvas = this.canvas;
            if (!canvas)
                canvas = this.getParentLayer().canvas;
            return canvas;
        },
        _callParent: function (type, args) {
            var arr = [type];
            for (var i = 0; i < args.length; ++i)
                arr.push(args[i]);
            return this.callSuper.apply(this, arr);
        },
        add: function () {
            for (var i = 0; i < arguments.length; ++i) {
                var obj = arguments[i];
                obj.layer = this;
                obj.canvas = this.canvas;
                obj.setCoords();
            }
            return this._callParent('add', arguments);
        },
        _onObjectAdded: function () {
            this.dirty = true;
            fabric.LayeredCanvas.prototype._onObjectAdded.apply(this.canvas, arguments);
        },
        _onObjectRemoved: function () {
            this.dirty = true;
            fabric.LayeredCanvas.prototype._onObjectRemoved.apply(this.canvas, arguments);
        },
        requestRenderAll: function () {
            return this.canvas.requestRenderAll();
        },
        insertAt: function (object) {
            object.layer = this;
            return this._callParent('insertAt', arguments);
        },
        setCoords: function () {
            this._objects.forEach(function (obj) {
                obj.setCoords();
            });
        },
        isOnScreen: function () {
            return true;
        },
        drawClipPathOnCache: function (ctx) {
            var path = this.clipPath;
            ctx.save();
            if (path.inverted) {
                ctx.globalCompositeOperation = 'destination-out';
            }
            else {
                ctx.globalCompositeOperation = 'destination-in';
            }
            ctx.scale(1 / path.zoomX, 1 / path.zoomY);
            var origX = -path.cacheTranslationX - ((this.width - path.width) / 2 - path.left) * path.zoomX, origY = -path.cacheTranslationY - ((this.height - path.height) / 2 - path.top) * path.zoomY;
            ctx.drawImage(path._cacheCanvas, origX, origY);
            ctx.restore();
        },
        isLayer: function () {
            return true;
        },
        bringToFront: fabric.LayeredCanvas.prototype.bringToFront,
        sendToBack: fabric.LayeredCanvas.prototype.sendToBack,
        bringForward: fabric.LayeredCanvas.prototype.bringForward,
        sendBackwards: fabric.LayeredCanvas.prototype.sendBackwards,
        _findNewLowerIndex: fabric.LayeredCanvas.prototype._findNewLowerIndex,
        _findNewUpperIndex: fabric.LayeredCanvas.prototype._findNewUpperIndex,
        getSvgTransform: function (full, additionalTransform) {
            var transform = full ? this.calcTransformMatrix() : this.calcOwnMatrix();
            transform = multiplyMatrices(transform, [1, 0, 0, 1, -this.width / 2, -this.height / 2]);
            var svgTransform = 'transform="' + fabric.util.matrixToSVG(transform);
            return svgTransform +
                (additionalTransform || '') + '" ';
        },
        getAbsolutePosition: function () {
            return {
                x: this.left || 0,
                y: this.top || 0
            };
        },
        toObject: function (propertiesToInclude) {
            var additionalProperties = [
                'renderClip'
            ].concat(propertiesToInclude || []);
            return this.callSuper("toObject", additionalProperties);
        }
    });
    fabric.Layer.fromObject = function (object, callback) {
        var objects = object.objects, options = fabric.util.object.clone(object, true);
        delete options.objects;
        if (typeof objects === 'string') {
            fabric.loadSVGFromURL(objects, function (elements) {
                var group = fabric.util.groupSVGElements(elements, object, objects);
                group.set(options);
                callback && callback(group);
            });
            return;
        }
        fabric.util.enlivenObjects(objects, function (enlivenedObjects) {
            fabric.util.enlivenObjects([object.clipPath], function (enlivedClipPath) {
                var options = fabric.util.object.clone(object, true);
                options.clipPath = enlivedClipPath[0];
                delete options.objects;
                callback && callback(new fabric.Layer(enlivenedObjects, options));
            });
        });
    };
    fabric.Svg = fabric.util.createClass(fabric.Layer, {
        type: 'svg',
        renderClip: true,
        initialize: function (objects, options) {
            this.activePrototype = fabric.Group.prototype;
            fabric.Group.prototype.initialize.call(this, objects, options);
            if (!options.clipPath) {
                this.clipPath = new fabric.Rect({
                    width: this.width,
                    height: this.height,
                    fill: '',
                    stroke: '#000',
                    layer: this,
                    isLayerClip: true,
                    skipInnerSelection: true,
                    evented: false,
                    selectable: false,
                    left: -this.width / 2,
                    top: -this.height / 2
                });
            }
            else {
                this.clipPath.set({
                    layer: this,
                    isLayerClip: true,
                    skipInnerSelection: true
                });
            }
        },
        setEditable: function (val) {
            var me = this;
            if (val) {
                this.dirty = true;
                this.activePrototype = fabric.Layer.prototype;
                this.hasControls = false;
                var matrix = [1, 0, 0, 1, this.width / 2, this.height / 2];
                this._objects.forEach(function (obj) {
                    fabric.util.addTransformToObject(obj, matrix);
                    delete obj.group;
                    obj.layer = me;
                    obj.setCoords();
                });
                var vpt = multiplyMatrices(this.getViewportTransform(), this.calcOwnMatrix()), opt = qrDecompose(vpt), scale = (opt.scaleX > opt.scaleY) ? opt.scaleY : opt.scaleX;
                this.clipPath.set({
                    strokeWidth: 1 / scale
                });
            }
            else {
                this.hasControls = true;
                this.activePrototype = fabric.Group.prototype;
                var matrix = [1, 0, 0, 1, -this.width / 2, -this.height / 2];
                this._objects.forEach(function (obj) {
                    fabric.util.addTransformToObject(obj, matrix);
                    delete obj.layer;
                    obj.group = me;
                    obj.setCoords();
                });
            }
            this.setCoords();
        },
        isEditable: function () {
            return this.activePrototype === fabric.Layer.prototype;
        },
        _renderControls: function () {
            this.activePrototype._renderControls.apply(this, arguments);
        },
        _render: function () {
            this.activePrototype._render.apply(this, arguments);
        },
        drawObject: function () {
            this.activePrototype.drawObject.apply(this, arguments);
        },
        setCoords: function () {
            this.activePrototype.setCoords.apply(this, arguments);
        },
        isCacheDirty: function () {
            return this.activePrototype.isCacheDirty.apply(this, arguments);
        },
        isLayer: function () {
            return this.activePrototype === fabric.Layer.prototype;
        },
        getSvgTransform: function () {
            return this.activePrototype.getSvgTransform.apply(this, arguments);
        },
        drawClipPathOnCache: function (ctx) {
            var path = this.clipPath;
            ctx.save();
            if (path.inverted) {
                ctx.globalCompositeOperation = 'destination-out';
            }
            else {
                ctx.globalCompositeOperation = 'destination-in';
            }
            ctx.scale(1 / path.zoomX, 1 / path.zoomY);
            var origX = -path.cacheTranslationX - (this.width - path.width) * path.zoomX / 2, origY = -path.cacheTranslationY - (this.height - path.height) * path.zoomY / 2, left = path.left + path.width / 2, top = path.top + path.height / 2;
            ctx.drawImage(path._cacheCanvas, origX + left * path.zoomX, origY + top * path.zoomY);
            ctx.restore();
        },
        toObject: function (propertiesToInclude) {
            var needTranslation = this.activePrototype === fabric.Layer.prototype, me = this;
            var _includeDefaultValues = this.includeDefaultValues, objsToObject = this._objects.map(function (obj) {
                var originalDefaults = obj.includeDefaultValues;
                obj.includeDefaultValues = _includeDefaultValues;
                var _obj = obj.toObject(propertiesToInclude);
                obj.includeDefaultValues = originalDefaults;
                if (needTranslation) {
                    _obj.left -= me.width / 2;
                    _obj.top -= me.height / 2;
                }
                return _obj;
            });
            var obj = fabric.Object.prototype.toObject.call(this, propertiesToInclude);
            obj.objects = objsToObject;
            obj.centerPoint = { x: 0, y: 0 };
            return obj;
        }
    });
    fabric.Svg.fromObject = function (object, callback) {
        var objects = object.objects, options = fabric.util.object.clone(object, true);
        delete options.objects;
        if (typeof objects === 'string') {
            fabric.loadSVGFromURL(objects, function (elements) {
                var group = fabric.util.groupSVGElements(elements, object, objects);
                group.set(options);
                callback && callback(group);
            });
            return;
        }
        fabric.util.enlivenObjects(objects, function (enlivenedObjects) {
            fabric.util.enlivenObjects([object.clipPath], function (enlivedClipPath) {
                var options = fabric.util.object.clone(object, true);
                options.clipPath = enlivedClipPath[0];
                delete options.objects;
                callback && callback(new fabric.Svg(enlivenedObjects, options, true));
            });
        });
    };
    fabric.util.groupSVGElements = function (elements, options, path) {
        var object;
        if (elements && elements.length === 1) {
            return elements[0];
        }
        if (options) {
            if (options.width && options.height) {
                options.centerPoint = {
                    x: options.width / 2,
                    y: options.height / 2
                };
            }
            else {
                delete options.width;
                delete options.height;
            }
        }
        object = new fabric.Svg(elements, options);
        if (typeof path !== 'undefined') {
            object.sourcePath = path;
        }
        return object;
    };
}

function addLayerCanvasClass(fabric) {
    let min = Math.min, max = Math.max, util = fabric.util, degreesToRadians = util.degreesToRadians, transformPoint = util.transformPoint;
    var locks = ['lockRotation', 'lockScalingX', 'lockScalingY', 'lockSkewingX', 'lockSkewingY', 'lockMovementX', 'lockMovementY'];
    fabric.LayeredCanvas = fabric.util.createClass(fabric.Canvas, {
        _searchPossibleTargets: function (objs, pointer) {
            var objects = this.getAllObjects({ _objects: objs });
            var target, i = objects.length, subTarget;
            while (i--) {
                var objToCheck = objects[i];
                var pointerToUse = objToCheck.group ?
                    this._normalizePointer(objToCheck.group, pointer) : pointer;
                if (this._checkTarget(pointerToUse, objToCheck, pointer)) {
                    target = objects[i];
                    if (target.subTargetCheck && target instanceof fabric.Group) {
                        subTarget = this._searchPossibleTargets(target._objects, pointer);
                        subTarget && this.targets.push(subTarget);
                    }
                    break;
                }
            }
            return target;
        },
        _transformObject: function (e) {
            var pointer = this.getPointer(e), transform = this._currentTransform;
            if (!transform.target.canvas) {
                return;
            }
            transform.reset = false;
            transform.shiftKey = e.shiftKey;
            transform.altKey = e[this.centeredKey];
            this._performTransformAction(e, transform, transformPoint(pointer, transform.target.calcLayerMatrix().poinerMatrix));
            transform.actionPerformed && this.requestRenderAll();
        },
        _setupCurrentTransform: function (e, target, alreadySelected) {
            if (!target) {
                return;
            }
            var pointer = transformPoint(this.getPointer(e), target.calcLayerMatrix().poinerMatrix), corner = target.__corner, control = target.controls[corner], actionHandler = (alreadySelected && corner) ?
                control.getActionHandler(e, target, control) : fabric.controlsUtils.dragHandler, action = this._getActionFromCorner(alreadySelected, corner, e, target), origin = this._getOriginFromCorner(target, corner), altKey = e[this.centeredKey], transform = {
                target: target,
                action: action,
                actionHandler: actionHandler,
                corner: corner,
                scaleX: target.scaleX,
                scaleY: target.scaleY,
                skewX: target.skewX,
                skewY: target.skewY,
                offsetX: pointer.x - target.left,
                offsetY: pointer.y - target.top,
                originX: origin.x,
                originY: origin.y,
                ex: pointer.x,
                ey: pointer.y,
                lastX: pointer.x,
                lastY: pointer.y,
                theta: degreesToRadians(target.angle),
                width: target.width * target.scaleX,
                shiftKey: e.shiftKey,
                altKey: altKey,
                original: fabric.util.saveObjectTransform(target)
            };
            if (this._shouldCenterTransform(target, action, altKey)) {
                transform.originX = 'center';
                transform.originY = 'center';
            }
            transform.original.originX = origin.x;
            transform.original.originY = origin.y;
            this._currentTransform = transform;
            this._beforeTransform(e);
        },
        _collectObjects: function (e) {
            var group = [], currentObject, x1 = this._groupSelector.ex, y1 = this._groupSelector.ey, x2 = x1 + this._groupSelector.left, y2 = y1 + this._groupSelector.top, selectionX1Y1 = new fabric.Point(min(x1, x2), min(y1, y2)), selectionX2Y2 = new fabric.Point(max(x1, x2), max(y1, y2)), allowIntersect = !this.selectionFullyContained, isClick = x1 === x2 && y1 === y2, allObjs = this.getAllObjects();
            for (var i = allObjs.length; i--;) {
                currentObject = allObjs[i];
                !currentObject.skipInnerSelection;
                if (!currentObject || !currentObject.selectable || !currentObject.visible) {
                    continue;
                }
                if ((allowIntersect && currentObject.intersectsWithRect(selectionX1Y1, selectionX2Y2, true)) ||
                    currentObject.isContainedWithinRect(selectionX1Y1, selectionX2Y2, true) ||
                    (allowIntersect && currentObject.containsPoint(selectionX1Y1, null, true)) ||
                    (allowIntersect && currentObject.containsPoint(selectionX2Y2, null, true))) {
                    group.push(currentObject);
                    if (isClick) {
                        break;
                    }
                }
            }
            if (group.length > 1) {
                group = group.filter(function (object) {
                    return !object.onSelect({ e: e });
                });
            }
            return group;
        },
        getAllObjects: function (fromObject, arr) {
            if (!arr)
                arr = [];
            if (!fromObject)
                fromObject = this;
            fromObject = fromObject._objects;
            for (var i = 0; i < fromObject.length; ++i) {
                var obj = fromObject[i];
                if (!obj.locked && obj.visible) {
                    if (obj.isLayer()) {
                        if (obj.clipPath && obj.selectableClip)
                            arr.push(obj.clipPath);
                        this.getAllObjects(obj, arr);
                    }
                    else {
                        arr.push(obj);
                    }
                }
            }
            return arr;
        },
        _chooseObjectsToRender: function () {
            return this.__chooseObjectsToRender(this);
        },
        getParent: function () { },
        getActiveChildrenOf: function (obj) {
            var active = this._activeObject;
            if (obj && (obj instanceof fabric.StaticCanvas || obj instanceof fabric.Layer)) {
                if (active) {
                    if (obj === active.getParent()) {
                        if (active.type === 'activeSelection')
                            return active._objects.slice(0);
                        else
                            return [active];
                    }
                    else {
                        var parent = active.getParent();
                        while (parent && parent !== obj) {
                            active = parent;
                            parent = active.getParent();
                        }
                        if (parent)
                            return [active];
                    }
                }
            }
            return [];
        },
        __chooseObjectsToRender: function (canvas) {
            var activeChildren = canvas.getActiveChildrenOf(this), object, objsToRender, activeGroupObjects;
            // to fix
            var allObjs = this._objects;
            if (activeChildren.length > 0 && !canvas.preserveObjectStacking) {
                objsToRender = [];
                activeGroupObjects = [];
                for (var i = 0, length = allObjs.length; i < length; i++) {
                    object = allObjs[i];
                    if (activeChildren.indexOf(object) === -1) {
                        objsToRender.push(object);
                    }
                    else {
                        activeGroupObjects.push(object);
                    }
                }
                objsToRender.push.apply(objsToRender, activeGroupObjects);
            }
            else {
                objsToRender = this._objects;
            }
            return objsToRender;
        },
        _discardActiveObject: function (e, object) {
            var obj = this._activeObject;
            if (obj) {
                var pLayer = obj.getParentLayer();
                while (pLayer) {
                    pLayer.dirty = true;
                    pLayer = pLayer.getParentLayer();
                }
                if (obj.onDeselect({ e: e, object: object })) {
                    return false;
                }
                this._activeObject = null;
            }
            return true;
        },
        _groupSelectedObjects: function (e) {
            var group = this._collectObjects(e);
            if (group.length === 1) {
                this.setActiveObject(group[0], e);
            }
            else if (group.length > 1) {
                this.setActiveObject(this.getLayeredSelection(group), e);
            }
        },
        getLayeredSelection: function (group) {
            var layer = group[0].getParentLayer(), group1 = [], options = {
                canvas: this,
                layer: layer
            };
            for (var i = 0; i < group.length; ++i) {
                var obj = group[i];
                if (layer === obj.getParentLayer()) {
                    group1.push(group[i]);
                    locks.forEach(function (lock) {
                        if (obj[lock])
                            options[lock] = true;
                    });
                    if (!obj.hasControls)
                        options.hasControls = false;
                }
            }
            return new fabric.ActiveSelection(group1.reverse(), options);
        },
        _createGroup: function (target) {
            var objects = this._objects, isActiveLower = objects.indexOf(this._activeObject) < objects.indexOf(target), groupObjects = isActiveLower ? [this._activeObject, target] : [target, this._activeObject];
            this._activeObject.isEditing && this._activeObject.exitEditing();
            return this.getLayeredSelection(groupObjects);
        },
        _updateActiveSelection: function (target, e) {
            var activeSelection = this._activeObject;
            if (activeSelection.layer !== target.getParentLayer()) {
                return;
            }
            var res = this.callSuper('_updateActiveSelection', target, e);
            locks.forEach(function (lock) {
                delete activeSelection[lock];
            });
            delete activeSelection.hasControls;
            activeSelection.getObjects().forEach(function (obj) {
                locks.forEach(function (lock) {
                    if (obj[lock])
                        activeSelection[lock] = true;
                });
                if (!obj.hasControls)
                    activeSelection.hasControls = false;
            });
            return res;
        },
        getSubLayers: function () {
            var arr = [];
            if (this._objects)
                this._objects.forEach(function (o) {
                    if (o instanceof fabric.Layer)
                        arr.push(o);
                });
            return arr;
        },
        objectIterator: function (ob, cb, key = "objects") {
            function iterator(obj) {
                if (cb(obj)) {
                    return true;
                }
                if (!obj[key]) {
                    return;
                }
                for (let o of obj[key]) {
                    if (cb(o) || iterator(o)) {
                        return true;
                    }
                }
            }
            cb && iterator(ob);
        },
        loadFromJSON: async function (json, callback, reviver) {
            var types = new Set(['curved-text', 'text', 'textbox', 'i-text', 'textArea']), usedFonts = new Set();
            var serialized = (typeof json === 'string') ? JSON.parse(json) : json;
            this.objectIterator(serialized, function (obj) {
                if (types.has(obj.type)) {
                    usedFonts.add([obj.fontFamily, obj.fontStyle, obj.fontWeight].join('|@|'));
                    if (obj.styles) {
                        Object.values(obj.styles).reduce((prev, next) => {
                            prev.push(...Object.values(next));
                            return prev;
                        }, []).forEach((s) => {
                            usedFonts.add([
                                s.fontFamily || obj.fontFamily,
                                s.fontStyle || obj.fontStyle,
                                s.fontWeight || obj.fontWeight
                            ].join('|@|'));
                        });
                    }
                }
            });
            var usedSetFonts = new Set();
            usedFonts.forEach((font) => {
                var arr = font.split('|@|');
                arr[0].split(',').forEach((f) => {
                    usedSetFonts.add([f, arr[1], arr[2]].join('|@|'));
                });
            });
            await fontLoader.loadFonts(Array.from(usedSetFonts).map((font) => {
                var arr = font.split('|@|');
                return {
                    fontFamily: arr[0],
                    fontStyle: arr[1],
                    fontWeight: arr[2]
                };
            }));
            return this.callSuper('loadFromJSON', json, callback, reviver);
        }
    });
}

function updatePattern(fabric) {
    var toObject = fabric.Pattern.prototype.toObject;
    function supplyFilter() {
        return new fabric.Image.filters.PatternColor({ color: '#000' });
    }
    fabric.util.enlivenPatterns = function (patterns, callback) {
        patterns = patterns || [];
        var enlivenedPatterns = [], numLoadedPatterns = 0, numPatterns = patterns.length;
        function onLoaded() {
            if (++numLoadedPatterns === numPatterns) {
                callback && callback(enlivenedPatterns);
            }
        }
        if (!numPatterns) {
            callback && callback(enlivenedPatterns);
            return;
        }
        patterns.forEach(function (p, index) {
            if (p && p.source) {
                fabric.util.enlivenObjects([p.source], function (enlivedSource) {
                    var options = fabric.util.object.clone(p, true);
                    options.source = enlivedSource[0];
                    new fabric.Pattern(options, function (pattern) {
                        enlivenedPatterns[index] = pattern;
                        onLoaded();
                    });
                });
            }
            else {
                enlivenedPatterns[index] = p;
                onLoaded();
            }
        });
    };
    fabric.Image.prototype.toPatternMarkup = function (width, height, pattern) {
        return `<image xlink:href="${this.getSrc(true)}" 
            width="${width}" height="${height}"></image>`;
    };
    fabric.util.addPrototypeProps(fabric.Pattern, {
        type: 'pattern',
        patternOptions: { scaleX: 1, scaleY: 1, repeat: "repeat", translateX: 0, translateY: 0 },
        patternTransform: [1, 0, 0, 1, 0, 0],
        initialize: function (options, callback) {
            options || (options = {});
            this.id = fabric.Object.__uid++;
            this.setOptions(options);
            var psc = this.source;
            this.source = psc.getElement();
            this.fabricImage = psc;
            callback && callback.apply(this, arguments);
        },
        setTransformation: function (opt, object) {
            if (!opt)
                return;
            var patternOptions = this.patternOptions;
            var patternTransform = this.patternTransform;
            for (var prop in opt)
                patternOptions[prop] = opt[prop];
            var fillScaling = this.getFillScaling(object);
            patternTransform[0] = fillScaling * patternOptions.scaleX;
            patternTransform[3] = fillScaling * patternOptions.scaleY;
            this.repeat = patternOptions.repeat;
            var scale = patternTransform[0];
            var img = typeof this.source === 'function' ? this.source() : this.source;
            patternTransform[4] = (object.width - scale * img.width) / 2 + patternOptions.translateX;
            scale = patternTransform[3];
            patternTransform[5] = (object.height - scale * img.height) / 2 + patternOptions.translateY;
        },
        toObject: function () {
            var obj = toObject.apply(this, arguments);
            obj.color = this.color;
            obj.patternOptions = this.patternOptions;
            obj.source = this.fabricImage.toObject();
            return obj;
        },
        setImage: function (img, callback) {
            var me = this;
            delete me.fillScaling;
            if (typeof img === 'string') {
                fabric.util.loadImage(img, function (im) {
                    me.fabricImage.setElement(im);
                    me.source = me.fabricImage.getElement();
                    callback && callback.apply(me, arguments);
                });
            }
            else if (img) {
                this.fabricImage.setElement(img);
                me.source = me.fabricImage.getElement();
                callback && callback.call(me, img);
            }
        },
        toSVG: function (object) {
            var fabricImage = this.fabricImage, patternTransform = this.patternTransform, width = fabricImage.width * patternTransform[0] / object.scaleX, height = fabricImage.height * patternTransform[3] / object.scaleY, dx, dy;
            dx = object.width / 2;
            dy = object.height / 2;
            return (`<pattern id="SVGID_${this.id}" patternUnits="userSpaceOnUse" width="${width}" height="${height}"
                  x="${patternTransform[4] - dx}" y="${patternTransform[5] - dy}" >${fabricImage.toPatternMarkup(width, height, this)}</pattern>`);
        },
        getFillScaling: function (object) {
            if (this.fillScaling)
                return this.fillScaling;
            var img = typeof this.source === 'function' ? this.source() : this.source, scaleX = object.width / img.width, scaleY = object.height / img.height, scale = (scaleX > scaleY) ? scaleX : scaleY;
            this.fillScaling = scale;
            return scale;
        },
        setColor: function (color, patternFilter = supplyFilter) {
            var im = this.fabricImage;
            if (!im)
                return;
            var filter = im.filters[0];
            if (!filter) {
                filter = patternFilter();
                im.filters.push(filter);
            }
            filter.color = color;
            im.applyFilters();
            this.source = im.getElement();
            this.color = color;
        },
        resetColor: function () {
            var im = this.fabricImage;
            if (!im)
                return;
            im.filters = [];
            im.applyFilters();
            this.source = im.getElement();
        },
        getColor: function () {
            var im = this.fabricImage, color = this.color || '';
            if (!im)
                return color;
            var filter = im.filters[0];
            if (!filter)
                return color;
            return filter.color;
        }
    });
}

function addPatternColorClass(fabric) {
    var extend = fabric.util.object.extend, filters = fabric.Image.filters, createClass = fabric.util.createClass;
    filters.PatternColor = createClass(filters.BaseFilter, {
        type: 'PatternColor',
        fragmentSource: `precision highp float;
        uniform sampler2D uTexture;
        uniform vec4 tint;
        uniform int convert;
        varying vec2 vTexCoord;
        void main() {
            vec4 color = texture2D(uTexture, vTexCoord);
            float alpha = color.a;
            if (convert == 1) {
                alpha = 1.0 - (color.r * 0.3 + color.g * 0.59 + color.b * 0.11);
                if (alpha > color.a) {
                    alpha = color.a;
                }
            }
            gl_FragColor = vec4(tint.r, tint.g, tint.b, alpha);
        }`,
        initialize: function (options) {
            options = options || {};
            this.color = options.color || '#000000';
            this.convert = options.convert;
        },
        applyTo2d: function (options) {
            var imageData = options.imageData, data = imageData.data, i, len = data.length, tintR, tintG, tintB, source = new fabric.Color(this.color).getSource();
            tintR = source[0];
            tintG = source[1];
            tintB = source[2];
            if (this.convert) {
                for (i = 0; i < len; i += 4) {
                    var alpha = data[i + 3];
                    data[i + 3] = (255 - (data[i] * 0.3 + data[i + 1] * 0.59 + data[i + 2] * 0.11)) * data[i + 3] / 255;
                    data[i] = tintR;
                    data[i + 1] = tintG;
                    data[i + 2] = tintB;
                    if (alpha < data[i + 3]) {
                        data[i + 3] = alpha;
                    }
                }
            }
            else {
                for (i = 0; i < len; i += 4) {
                    data[i] = tintR;
                    data[i + 1] = tintG;
                    data[i + 2] = tintB;
                }
            }
        },
        getUniformLocations: function (gl, program) {
            return {
                tint: gl.getUniformLocation(program, 'tint'),
                convert: gl.getUniformLocation(program, 'convert')
            };
        },
        sendUniformData: function (gl, uniformLocations) {
            var source = new fabric.Color(this.color).getSource(), tint = [source[0] / 255, source[1] / 255, source[2] / 255, 1];
            gl.uniform4fv(uniformLocations.tint, tint);
            gl.uniform1i(uniformLocations.convert, this.convert ? 1 : 0);
        },
        toObject: function () {
            return extend(this.callSuper('toObject'), {
                color: this.color
            });
        }
    });
    fabric.Image.filters.PatternColor.fromObject = fabric.Image.filters.BaseFilter.fromObject;
}

var warp = {exports: {}};

/*! Warp.js v1.0.8 (MIT) */

(function (module, exports) {
	!function(e,t){module.exports=t();}("undefined"!=typeof self?self:commonjsGlobal,function(){return function(e){function t(n){if(r[n])return r[n].exports;var a=r[n]={i:n,l:!1,exports:{}};return e[n].call(a.exports,a,a.exports,t),a.l=!0,a.exports}var r={};return t.m=e,t.c=r,t.d=function(e,r,n){t.o(e,r)||Object.defineProperty(e,r,{configurable:!1,enumerable:!0,get:n});},t.n=function(e){var r=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(r,"a",r),r},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=6)}([function(e,t,r){function n(e){return u[e.toLowerCase()]}function a(e){return f.test(e.type)}function i(e){var t={relative:!1};switch(e.length){case 2:t.type="l";break;case 3:t.type="q";break;case 4:t.type="c";break;default:return !1}for(var r=1;r<e.length;r++){var n=(r<e.length-1?r:y.length)-1,a=l(y[n],2),i=a[0],o=a[1];t[i]=e[r][0],t[o]=e[r][1],e[r].length>2&&(t.extended=t.extended||{},t.extended[n]=e[r].slice(2));}return t}function o(e,t){if(e.type===t.type&&e.relative===t.relative){var r=function(e,t,r){if(e&&t){for(var n=[],a=Math.min(e.length,t.length),i=0;i<a;i++)n.push((e[i]+t[i])/2);y.extended[r]=n;}},n=t.type,a=t.relative,i=t.x,o=t.y,l=!!e.extended&&!!t.extended,u={},y={type:n,relative:a,x:i,y:o,extended:u};switch(n){case"l":break;case"q":y.x1=(e.x1+t.x1)/2,y.y1=(e.y1+t.y1)/2,l&&r(e.extended[0],t.extended[0],0);break;case"c":y.x1=(e.x1+e.x2)/2,y.y1=(e.y1+e.y2)/2,y.x2=(t.x1+t.x2)/2,y.y2=(t.y1+t.y2)/2,l&&(r(e.extended[0],e.extended[1],0),r(t.extended[0],t.extended[1],1));break;default:return !1}return t.extended&&t.extended[2]&&(u[2]=t.extended[2]),y}return !1}Object.defineProperty(t,"__esModule",{value:!0});var l=function(){function e(e,t){var r=[],n=!0,a=!1,i=void 0;try{for(var o,l=e[Symbol.iterator]();!(n=(o=l.next()).done)&&(r.push(o.value),!t||r.length!==t);n=!0);}catch(e){a=!0,i=e;}finally{try{!n&&l.return&&l.return();}finally{if(a)throw i}}return r}return function(t,r){if(Array.isArray(t))return t;if(Symbol.iterator in Object(t))return e(t,r);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}();t.getSegmentSchema=n,t.isDrawingSegment=a,t.createLineSegment=i,t.joinSegments=o;var u={m:["x","y"],z:[],l:["x","y"],h:["x"],v:["y"],c:["x1","y1","x2","y2","x","y"],s:["x2","y2","x","y"],q:["x1","y1","x","y"],t:["x","y"],a:["rx","ry","xRotation","largeArc","sweep","x","y"]},y=t.pointGroups=[["x1","y1"],["x2","y2"],["x","y"]],f=/[lhvcsqta]/;},function(e,t,r){function n(e){if(Array.isArray(e)){for(var t=0,r=Array(e.length);t<e.length;t++)r[t]=e[t];return r}return Array.from(e)}function a(e,t){for(var r=[],a=0;a<e.length;a++){var i=JSON.parse(JSON.stringify(e[a])),o=t(i,a,e,r);Array.isArray(o)?r.push.apply(r,n(o)):o&&r.push(o);}return r}Object.defineProperty(t,"__esModule",{value:!0}),t.default=a;},function(e,t,r){function n(e){var t=[],r=void 0;for(i.lastIndex=0;r=i.exec(e);){var n=r[1].toLowerCase(),l=(r[2].match(o)||[]).map(parseFloat),u=n===r[1],y=(0, a.getSegmentSchema)(n);if(l.length<y.length)throw new Error('Malformed path data: type "'+n+'" has '+l.length+" arguments, expected "+scheme.length);if(y.length>0){if(l.length%y.length!=0)throw new Error('Malformed path data: type "'+n+'" has '+l.length+" arguments, "+l.length%y.length+" too many");for(var f=0;f<l.length/y.length;f++){for(var c={type:n,relative:u},v=0;v<y.length;v++)c[y[v]]=l[f*y.length+v];t.push(c);}}else t.push({type:n,relative:u});}return t}Object.defineProperty(t,"__esModule",{value:!0}),t.default=n;var a=r(0),i=/([mzlhvcsqta])([^mzlhvcsqta]*)/gi,o=/-?[0-9]*\.?[0-9]+(?:e[-+]?\d+)?/gi;},function(e,t,r){function n(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:2,r=!1,n=Math.pow(10,t);return e.map(function(e){var t=[],o=e.relative?e.type:e.type.toUpperCase(),l=r!==o,u=(0, i.getSegmentSchema)(e.type);l&&(t.push(o),r=o);var y=!0,f=!1,c=void 0;try{for(var v,p=u[Symbol.iterator]();!(y=(v=p.next()).done);y=!0){var s=v.value,d=e[s],h=void 0;switch(void 0===d?"undefined":a(d)){case"boolean":h=0|d;break;case"number":h=(d*n|0)/n;break;default:throw new Error("Invalid path data")}l||t.push(" "),t.push(h),l=!1;}}catch(e){f=!0,c=e;}finally{try{!y&&p.return&&p.return();}finally{if(f)throw c}}return t.join("")}).join("")}Object.defineProperty(t,"__esModule",{value:!0});var a="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};t.default=n;var i=r(0);},function(e,t,r){function n(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=document.createElementNS("http://www.w3.org/2000/svg",e),n=!0,a=!1,o=void 0;try{for(var l,u=Object.keys(t)[Symbol.iterator]();!(n=(l=u.next()).done);n=!0){var y=l.value;i(r,y,t[y]);}}catch(e){a=!0,o=e;}finally{try{!n&&u.return&&u.return();}finally{if(a)throw o}}return r}function a(e,t){return e[t]instanceof SVGAnimatedLength?e[t].baseVal.value:e.getAttribute(t)}function i(e,t,r){e.setAttribute(t,r);}Object.defineProperty(t,"__esModule",{value:!0}),t.createElement=n,t.getProperty=a,t.setProperty=i;},function(e,t,r){function n(e){for(var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:.5,r=[],n=[],a=[e];a.length<e.length;){for(var i=a[a.length-1],o=[],l=1;l<i.length;l++){for(var u=i[l-1],y=i[l],f=[],c=Math.max(u.length,y.length),v=0;v<c;v++){var p=u[v]||0,s=y[v]||0;f.push(p+(s-p)*t);}o.push(f);}a.push(o);}for(var d=0;d<a.length;d++)r.push(a[d][0]),n.push(a[a.length-1-d][d]);return [r,n]}function a(e,t){for(var r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:i,a=[e],o=[];a.length>0;){var l=a.pop();if(r(l)>t)for(var u=n(l),y=u.length-1;y>=0;y--)a.push(u[y]);else o.push(l);}return o}function i(e){for(var t=e[0],r=e[e.length-1],n=0,a=0;a<t.length;a++){var i=r[a]-t[a];n+=Math.pow(i,2);}return Math.sqrt(n)}Object.defineProperty(t,"__esModule",{value:!0}),t.split=n,t.until=a,t.euclideanDistance=i;},function(e,t,r){var n=r(7),a=function(e){return e&&e.__esModule?e:{default:e}}(n);e.exports=a.default;},function(e,t,r){function n(e){return e&&e.__esModule?e:{default:e}}function a(e){if(Array.isArray(e)){for(var t=0,r=Array(e.length);t<e.length;t++)r[t]=e[t];return r}return Array.from(e)}function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var o=function(){function e(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n);}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}(),l=r(8),u=r(4),y=r(2),f=n(y),c=r(3),v=n(c),p=r(5),s=r(15),d=n(s),h=r(16),x=n(h),g=r(17),m=n(g),b=function(){function e(t){var r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"q";i(this,e),this.element=t,(0, l.shapesToPaths)(t),(0, l.preparePaths)(t,r);var n=Array.from(t.querySelectorAll("path"));this.paths=n.map(function(e){var t=(0, u.getProperty)(e,"d");return {pathElement:e,pathData:(0, f.default)(t)}});}return o(e,[{key:"update",value:function(){var e=!0,t=!1,r=void 0;try{for(var n,a=this.paths[Symbol.iterator]();!(e=(n=a.next()).done);e=!0){var i=n.value,o=i.pathElement,l=i.pathData,y=(0,v.default)(l);(0,u.setProperty)(o,"d",y);}}catch(e){t=!0,r=e;}finally{try{!e&&a.return&&a.return();}finally{if(t)throw r}}}},{key:"transform",value:function(e){e=Array.isArray(e)?e:[e];var t=!0,r=!1,n=void 0;try{for(var a,i=this.paths[Symbol.iterator]();!(t=(a=i.next()).done);t=!0){var o=a.value;o.pathData=(0,d.default)(o.pathData,e);}}catch(e){r=!0,n=e;}finally{try{!t&&i.return&&i.return();}finally{if(r)throw n}}this.update();}},{key:"interpolate",value:function(e){function t(t){var n=[t[0].slice(0,2),t[t.length-1].slice(0,2)],a=(0, p.euclideanDistance)(n);return r=r||a>e,a}var r=!1,n=!0,a=!1,i=void 0;try{for(var o,l=this.paths[Symbol.iterator]();!(n=(o=l.next()).done);n=!0){var u=o.value;u.pathData=(0,x.default)(u.pathData,e,t);}}catch(e){a=!0,i=e;}finally{try{!n&&l.return&&l.return();}finally{if(a)throw i}}return r}},{key:"extrapolate",value:function(e){function t(t){var n=[t[0].slice(0,2),t[t.length-1].slice(0,2)],a=(0, p.euclideanDistance)(n);return r=r||a<=e,a}var r=!1,n=!0,a=!1,i=void 0;try{for(var o,l=this.paths[Symbol.iterator]();!(n=(o=l.next()).done);n=!0){var u=o.value;u.pathData=(0,m.default)(u.pathData,e,t);}}catch(e){a=!0,i=e;}finally{try{!n&&l.return&&l.return();}finally{if(a)throw i}}return r}},{key:"preInterpolate",value:function(e,t){function r(e){var r=[e[0].slice(0,2),e[e.length-1].slice(0,2)],a=(0, p.euclideanDistance)(r);return n=n||a>t,a}var n=!1,i=!0,o=!1,l=void 0;try{for(var u,y=this.paths[Symbol.iterator]();!(i=(u=y.next()).done);i=!0){var f=u.value,c=(0,d.default)(f.pathData,function(t){var r=e(t.slice(0,2));return r.push.apply(r,a(t)),r}),v=(0,x.default)(c,t,r);f.pathData=(0,d.default)(v,function(e){return e.slice(2)});}}catch(e){o=!0,l=e;}finally{try{!i&&y.return&&y.return();}finally{if(o)throw l}}return n}},{key:"preExtrapolate",value:function(e,t){function r(e){var r=[e[0].slice(0,2),e[e.length-1].slice(0,2)],a=(0, p.euclideanDistance)(r);return n=n||a<=t,a}var n=!1,i=!0,o=!1,l=void 0;try{for(var u,y=this.paths[Symbol.iterator]();!(i=(u=y.next()).done);i=!0){var f=u.value,c=(0,d.default)(f.pathData,function(t){var r=e(t.slice(0,2));return r.push.apply(r,a(t)),r}),v=(0,m.default)(c,t,r);f.pathData=(0,d.default)(v,function(e){return e.slice(2)});}}catch(e){o=!0,l=e;}finally{try{!i&&y.return&&y.return();}finally{if(o)throw l}}return n}}]),e}();t.default=b;},function(e,t,r){function n(e){return e&&e.__esModule?e:{default:e}}function a(e){if(Array.isArray(e)){for(var t=0,r=Array(e.length);t<e.length;t++)r[t]=e[t];return r}return Array.from(e)}function i(e){var t={line:function(e){return M.line((0, _.getProperty)(e,"x1"),(0, _.getProperty)(e,"y1"),(0, _.getProperty)(e,"x2"),(0, _.getProperty)(e,"y2"))},polyline:function(e){return M.polyline.apply(M,a(e.points))},polygon:function(e){return M.polygon.apply(M,a(e.points))},rect:function(e){return M.rectangle((0, _.getProperty)(e,"x"),(0, _.getProperty)(e,"y"),(0, _.getProperty)(e,"width"),(0, _.getProperty)(e,"height"),(0, _.getProperty)(e,"rx"),(0, _.getProperty)(e,"ry"))},ellipse:function(e){return M.ellipse((0, _.getProperty)(e,"cx"),(0, _.getProperty)(e,"cy"),(0, _.getProperty)(e,"rx"),(0, _.getProperty)(e,"ry"))},circle:function(e){return M.circle((0, _.getProperty)(e,"cx"),(0, _.getProperty)(e,"cy"),(0, _.getProperty)(e,"r"))}},r=e.querySelectorAll(Object.keys(t).join(",")),n=!0,i=!1,o=void 0;try{for(var l,u=r[Symbol.iterator]();!(n=(l=u.next()).done);n=!0){var y=l.value,c=y.tagName.toLowerCase();if(c in t){var v=t[c](y),p=(0,f.default)(v),s={d:p},d=!0,h=!1,x=void 0;try{for(var g,m=Array.from(y.attributes)[Symbol.iterator]();!(d=(g=m.next()).done);d=!0){var b=g.value,N=b.nodeName,w=b.nodeValue;/^(x|y|x1|y1|x2|y2|width|height|r|rx|ry|cx|cy|points|d)$/.test(N)||(s[N]=w);}}catch(e){h=!0,x=e;}finally{try{!d&&m.return&&m.return();}finally{if(h)throw x}}var P=(0,_.createElement)("path",s);y.parentNode.replaceChild(P,y);}}}catch(e){i=!0,o=e;}finally{try{!n&&u.return&&u.return();}finally{if(i)throw o}}}function o(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"q",r=Array.from(e.querySelectorAll("path")),n=!0,a=!1,i=void 0;try{for(var o,l=r[Symbol.iterator]();!(n=(o=l.next()).done);n=!0){var y=o.value,c=(0,_.getProperty)(y,"d"),p=(0,u.default)(c);p=(0,v.default)(p,(0,s.default)()),p=(0,v.default)(p,(0,h.default)()),p=(0,v.default)(p,(0,g.default)()),p=(0,v.default)(p,(0,b.default)(t)),p=(0,v.default)(p,(0,w.default)()),c=(0,f.default)(p),(0,_.setProperty)(y,"d",c);}}catch(e){a=!0,i=e;}finally{try{!n&&l.return&&l.return();}finally{if(a)throw i}}}Object.defineProperty(t,"__esModule",{value:!0}),t.shapesToPaths=i,t.preparePaths=o;var l=r(2),u=n(l),y=r(3),f=n(y),c=r(1),v=n(c),p=r(9),s=n(p),d=r(10),h=n(d),x=r(11),g=n(x),m=r(12),b=n(m),N=r(13),w=n(N),P=r(14),M=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var r in e)Object.prototype.hasOwnProperty.call(e,r)&&(t[r]=e[r]);return t.default=e,t}(P),_=r(4);},function(e,t,r){function n(){var e=["x","x1","x2"],t=["y","y1","y2"],r=0,n=0,i=NaN,o=NaN;return function(l){if(isNaN(i)&&(0, a.isDrawingSegment)(l)&&(i=r,o=n),"z"!==l.type||isNaN(i)||(r=i,n=o,i=NaN,o=NaN),l.relative){var u=!0,y=!1,f=void 0;try{for(var c,v=e[Symbol.iterator]();!(u=(c=v.next()).done);u=!0){var p=c.value;p in l&&(l[p]+=r);}}catch(e){y=!0,f=e;}finally{try{!u&&v.return&&v.return();}finally{if(y)throw f}}var s=!0,d=!1,h=void 0;try{for(var x,g=t[Symbol.iterator]();!(s=(x=g.next()).done);s=!0){var m=x.value;m in l&&(l[m]+=n);}}catch(e){d=!0,h=e;}finally{try{!s&&g.return&&g.return();}finally{if(d)throw h}}l.relative=!1;}return r="x"in l?l.x:r,n="y"in l?l.y:n,"m"===l.type&&(i=r,o=n),l}}Object.defineProperty(t,"__esModule",{value:!0}),t.default=n;var a=r(0);},function(e,t,r){function n(){var e=0,t=0,r=NaN,n=NaN,a=NaN,i=NaN,o=NaN,l=NaN;return function(u){if(isNaN(r)&&"m"!==u.type)throw new Error('Transform path error: path must start with "moveto"');return "s"===u.type&&(a=isNaN(a)?e:a,i=isNaN(i)?t:i,u.type="c",u.x1=(u.relative?1:2)*e-a,u.y1=(u.relative?1:2)*t-i),"c"===u.type?(a=(u.relative?e:0)+u.x2,i=(u.relative?t:0)+u.y2):(a=NaN,i=NaN),"t"===u.type&&(o=isNaN(o)?e:o,l=isNaN(l)?t:l,u.type="q",u.x1=(u.relative?1:2)*e-o,u.y1=(u.relative?1:2)*t-l),"q"===u.type?(o=(u.relative?e:0)+u.x1,l=(u.relative?t:0)+u.y1):(o=NaN,l=NaN),"z"===u.type&&(e=r,t=n),e="x"in u?(u.relative?e:0)+u.x:e,t="y"in u?(u.relative?t:0)+u.y:t,"m"===u.type&&(r=e,n=t),u}}Object.defineProperty(t,"__esModule",{value:!0}),t.default=n;},function(e,t,r){function n(){var e=0,t=0,r=NaN,n=NaN;return function(a){if(isNaN(r)&&"m"!==a.type)throw new Error('Transform path error: path must start with "moveto"');switch(a.type){case"h":a.type="l",a.y=a.relative?0:t;break;case"v":a.type="l",a.x=a.relative?0:e;break;case"z":a.type="l",a.x=r-(a.relative?e:0),a.y=n-(a.relative?t:0);break;case"a":0!==a.rx&&0!==a.ry||(a.type="l",delete a.rx,delete a.ry,delete a.xRotation,delete a.largeArc,delete a.sweep);}return e=(a.relative?e:0)+a.x,t=(a.relative?t:0)+a.y,"m"===a.type&&(r=e,n=t),a}}Object.defineProperty(t,"__esModule",{value:!0}),t.default=n;},function(e,t,r){function n(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"q",t=0,r=0,n=NaN,i=NaN;return function(o){if(isNaN(n)&&(0, a.isDrawingSegment)(o.type)&&(n=t,i=r),"z"!==o.type||isNaN(n)||(t=n,r=i,n=NaN,i=NaN),"l"===o.type){var l=o.relative?0:t,u=o.relative?0:r;switch(o.type=e,e){case"q":o.x1=(l+o.x)/2,o.y1=(u+o.y)/2;break;case"c":var y=(o.x-l)/3,f=(o.y-u)/3;o.x1=l+y,o.y1=u+f,o.x2=l+2*y,o.y2=u+2*f;break;default:throw new Error('Invalid curve type "'+e+'"')}}return t="x"in o?(o.relative?t:0)+o.x:t,r="y"in o?(o.relative?r:0)+o.y:r,"m"===o.type&&(n=t,i=r),o}}Object.defineProperty(t,"__esModule",{value:!0}),t.default=n;var a=r(0);},function(e,t,r){function n(){var e=0,t=0,r=NaN,n=NaN;return function(i){var l=i;if(isNaN(r)&&(0, o.isDrawingSegment)(i.type)&&(r=e,n=t),"z"!==i.type||isNaN(r)||(e=r,t=n,r=NaN,n=NaN),"a"===i.type){var u=i.relative?0:e,y=i.relative?0:t,f=i.rx,c=i.ry,v=i.xRotation,p=i.largeArc,s=i.sweep,d=i.x,h=i.y,x=a(u,y,f,c,v,p,s,d,h),g=0,m=0,b=!0,N=!1,w=void 0;try{for(var P,M=x[Symbol.iterator]();!(b=(P=M.next()).done);b=!0){var _=P.value;_.relative=i.relative,i.relative&&"c"===_.type&&(_.x-=g,_.x1-=g,_.x2-=g,_.y-=m,_.y1-=m,_.y2-=m),g=_.x,m=_.y;}}catch(e){N=!0,w=e;}finally{try{!b&&M.return&&M.return();}finally{if(N)throw w}}l=x;}return e="x"in i?(i.relative?e:0)+i.x:e,t="y"in i?(i.relative?t:0)+i.y:t,"m"===i.type&&(r=e,n=t),l}}function a(e,t,r,n,a,o,l,u,y){if(e===u&&t===y)return [];if(!r&&!n)return [{type:"l",x:u,y:y}];var f=Math.sin(a*Math.PI/180),c=Math.cos(a*Math.PI/180),v=c*(e-u)/2+f*(t-y)/2,p=-f*(e-u)/2+c*(t-y)/2,s=r*r,d=n*n,h=v*v,x=p*p,g=0,m=s*d-s*x-d*h;if(m<0){var b=Math.sqrt(1-m/(s*d));r*=b,n*=b;}else g=(o&&l||!o&&!l?-1:1)*Math.sqrt(m/(s*x+d*h));var N=g*r*p/n,w=-g*n*v/r,P=c*N-f*w+(e+u)/2,M=f*N+c*w+(t+y)/2,_=i(1,0,(v-N)/r,(p-w)/n),A=i((v-N)/r,(p-w)/n,(-v-N)/r,(-p-w)/n);!l&&A>0?A-=2*Math.PI:l&&A<0&&(A+=2*Math.PI);for(var S=[],j=Math.ceil(Math.abs(A/(Math.PI/2))),O=A/j,k=8/3*Math.sin(O/4)*Math.sin(O/4)/Math.sin(O/2),D=0;D<j;D++){var q=Math.cos(_),E=Math.sin(_),I=_+O,z=Math.cos(I),R=Math.sin(I),T=c*r*z-f*n*R+P,C=f*r*z+c*n*R+M,G=k*(-c*r*E-f*n*q),L=k*(-f*r*E+c*n*q),V=k*(c*r*R+f*n*z),J=k*(f*r*R-c*n*z);S.push({type:"c",x:T,y:C,x1:e+G,y1:t+L,x2:T+V,y2:C+J}),_=I,e=T,t=C;}return S}function i(e,t,r,n){var a=Math.atan2(t,e),i=Math.atan2(n,r);return i>=a?i-a:2*Math.PI-(a-i)}Object.defineProperty(t,"__esModule",{value:!0}),t.default=n;var o=r(0);},function(e,t,r){function n(e,t,r,n){return [{type:"m",relative:!1,x:e,y:t},{type:"l",relative:!1,x:r,y:n}]}function a(){for(var e=arguments.length,t=Array(e),r=0;r<e;r++)t[r]=arguments[r];return t.map(function(e,t){return {type:0===t?"m":"l",relative:!1,x:e.x||e[0],y:e.y||e[1]}})}function i(){var e=a.apply(void 0,arguments);return e.append({type:"z",relative:!1}),e}function o(e,t,r,n){var a=arguments.length>4&&void 0!==arguments[4]?arguments[4]:0,i=arguments.length>5&&void 0!==arguments[5]?arguments[5]:0,o=void 0;if(a>0||i>0){a=a||i,i=i||a;o=[{type:"m",relative:!1,x:e+a,y:t},{type:"h",relative:!1,x:e+r-a},{type:"a",relative:!1,rx:a,ry:i,xRotation:0,largeArc:!1,sweep:!0,x:e+r,y:t+i},{type:"v",relative:!1,y:t+n-i},{type:"a",relative:!1,rx:a,ry:i,xRotation:0,largeArc:!1,sweep:!0,x:e+r-a,y:t+n},{type:"h",relative:!1,x:e+a},{type:"a",relative:!1,rx:a,ry:i,xRotation:0,largeArc:!1,sweep:!0,x:e,y:t+n-i},{type:"v",relative:!1,y:t+i},{type:"a",relative:!1,rx:a,ry:i,xRotation:0,largeArc:!1,sweep:!0,x:e+a,y:t}];}else o=[{type:"m",relative:!1,x:e,y:t},{type:"h",relative:!1,x:e+r},{type:"v",relative:!1,y:t+n},{type:"h",relative:!1,x:e},{type:"v",relative:!1,y:t}];return o}function l(e,t,r,n){return [{type:"m",relative:!1,x:e,y:t-n},{type:"a",relative:!1,rx:r,ry:n,xRotation:0,largeArc:!1,sweep:!0,x:e,y:t+n},{type:"a",relative:!1,rx:r,ry:n,xRotation:0,largeArc:!1,sweep:!0,x:e,y:t-n}]}function u(e,t,r){return l(e,t,r,r)}Object.defineProperty(t,"__esModule",{value:!0}),t.line=n,t.polyline=a,t.polygon=i,t.rectangle=o,t.ellipse=l,t.circle=u;},function(e,t,r){function n(e){if(Array.isArray(e)){for(var t=0,r=Array(e.length);t<e.length;t++)r[t]=e[t];return r}return Array.from(e)}function a(e,t){return (0, l.default)(e,function(e){for(var r=0;r<u.pointGroups.length;r++){var a=i(u.pointGroups[r],2),o=a[0],l=a[1];if(o in e&&l in e){var y=(e.extended?e.extended[r]:null)||[],f=[e[o],e[l]].concat(n(y)),c=t.reduce(function(e,t){return t(e)},f);if(c.length<2)throw new Error("Transformer must return at least 2 points");e[o]=c[0],e[l]=c[1],c.length>2&&(e.extended=e.extended||{},e.extended[r]=c.slice(2));}}return e})}Object.defineProperty(t,"__esModule",{value:!0});var i=function(){function e(e,t){var r=[],n=!0,a=!1,i=void 0;try{for(var o,l=e[Symbol.iterator]();!(n=(o=l.next()).done)&&(r.push(o.value),!t||r.length!==t);n=!0);}catch(e){a=!0,i=e;}finally{try{!n&&l.return&&l.return();}finally{if(a)throw i}}return r}return function(t,r){if(Array.isArray(t))return t;if(Symbol.iterator in Object(t))return e(t,r);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}();t.default=a;var o=r(1),l=function(e){return e&&e.__esModule?e:{default:e}}(o),u=r(0);},function(e,t,r){function n(e){if(Array.isArray(e)){for(var t=0,r=Array(e.length);t<e.length;t++)r[t]=e[t];return r}return Array.from(e)}function a(e,t,r){var a=[];return (0, l.default)(e,function(e){var o=e;if(f.test(e.type)){for(var l=[a],c=0;c<y.pointGroups.length;c++){var v=i(y.pointGroups[c],2),p=v[0],s=v[1];if(p in e&&s in e){var d=(e.extended?e.extended[c]:null)||[],h=[e[p],e[s]].concat(n(d));l.push(h);}}var x=(0, u.until)(l,t,r);x.length>1&&(o=x.map(function(e){return (0, y.createLineSegment)(e)}));}if("x"in e&&"y"in e){var g=(e.extended?e.extended[2]:null)||[],m=[e.x,e.y].concat(n(g));a=m;}return o})}Object.defineProperty(t,"__esModule",{value:!0});var i=function(){function e(e,t){var r=[],n=!0,a=!1,i=void 0;try{for(var o,l=e[Symbol.iterator]();!(n=(o=l.next()).done)&&(r.push(o.value),!t||r.length!==t);n=!0);}catch(e){a=!0,i=e;}finally{try{!n&&l.return&&l.return();}finally{if(a)throw i}}return r}return function(t,r){if(Array.isArray(t))return t;if(Symbol.iterator in Object(t))return e(t,r);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}();t.default=a;var o=r(1),l=function(e){return e&&e.__esModule?e:{default:e}}(o),u=r(5),y=r(0),f=/[lqc]/;},function(e,t,r){function n(e,t,r){return (0, i.default)(e,function(e,n,a,i){if(n>1){var u=i[i.length-1],y=i[i.length-2];if(l.test(e.type)&&u.type===e.type){var f=[[y.x,y.y],[e.x,e.y]];if(r(f)<=t){var c=(0, o.joinSegments)(u,e);if(c)return i[i.length-1]=c,!1}}}return e})}Object.defineProperty(t,"__esModule",{value:!0}),t.default=n;var a=r(1),i=function(e){return e&&e.__esModule?e:{default:e}}(a),o=r(0),l=/[lqc]/;}])});
	
} (warp));

var warpExports = warp.exports;
var Warp = /*@__PURE__*/getDefaultExportFromCjs(warpExports);

function addShapedTextClass(fabric) {
    Warp.prototype.getPathCommands = function () {
        var commands = this.paths[0].pathData;
        for (var i = 0, len = commands.length; i < len; ++i) {
            commands[i].type = commands[i].type.toUpperCase();
        }
        return commands;
    };
    function set(key, value) {
        var res = this.callSuper('set', key, value), needToRerender = false, restoreField = this.openTypeFontRestoreField;
        if (typeof key === 'object') {
            var keys = Object.keys(key);
            needToRerender = keys.some(function (field) {
                return restoreField.has(field);
            });
        }
        else {
            needToRerender = restoreField.has(key);
        }
        if (needToRerender)
            this.loadFontAndRerender();
        return res;
    }
    var getSvgColorString = fabric.util.getSvgColorString;
    fontLoader.loadFontList();
    fabric.ShapedText = fabric.util.createClass(fabric.Text, {
        type: 'shaped-text',
        warpMode: 0,
        warpAmount: 5,
        strokeWidth: 0.00001,
        warpRestoreField: new Set(['warpMode', 'warpAmount', 'text', 'underline', 'fontFamily', 'fontStyle', 'fontWeight', 'tracking', 'fontSize']),
        openTypeFontRestoreField: new Set(['fontFamily', 'fontStyle', 'fontWeight', 'fontSize']),
        dimRestoreField: new Set(['tracking', 'underline', 'warpMode', 'warpAmount', 'fontSize']),
        addonDirtFields: new Set(['textAlign']),
        tracking: 0,
        initialize: function (text, options) {
            this.callSuper('initialize', text, options);
            this.set = set;
            this.loadFontAndRerender();
        },
        loadFontAndRerender: async function () {
            try {
                await this.loadFont();
                this.textPath = null;
                this.dirty = true;
                this.initDimensions();
                if (this.canvas) {
                    this.canvas.renderAll();
                }
            }
            catch (err) { }
        },
        loadFont: async function (callback) {
            this.font = await fontLoader.loadFont(this.fontFamily, this.fontStyle, this.fontWeight);
            callback && callback.call(this, this.font);
        },
        getWarp: function (paths) {
            var warp;
            if (!this.warp) {
                this.warp = new Warp(document.createElement('svg'));
            }
            warp = this.warp;
            for (var i = 0, len = paths.length; i < len; ++i) {
                paths[i].type = paths[i].type.toLowerCase();
                paths[i].relative = false;
            }
            warp.paths = [{
                    pathData: paths,
                    pathElement: warp.element
                }];
            return this.warp;
        },
        getWrappedPoint: function (x, y, warpMode, warpAmount, height, width) {
            var a = 1e8;
            var e = Math.floor(x / width * a), t = Math.ceil(-y / height * a);
            var v = a, s = a, c = height, d = width, p = { x: 0, y: 0 };
            p.x = d / (s - 1) * e;
            p.y = c / (v - 1) * t;
            var u = Math.abs(warpAmount);
            switch (warpMode) {
                case 1:
                    p.y += c / 5 * Math.pow((-1 + v - 2 * e) / v, 2) * warpAmount;
                    break;
                case 2:
                    warpAmount = -u;
                    p.y -= c / 5 * Math.pow((-1 + v - 2 * e) / v, 2) * Math.abs(warpAmount);
                    break;
                case 3:
                    p.y = -c / 2 + c / v * t;
                    warpAmount = u;
                    p.y += c / 5 * Math.pow((-1 + v - 2 * e) / v, 2) * warpAmount * (t / v);
                    p.y -= t / v * (warpAmount * (c / 40));
                    p.y += c / 2;
                    break;
                case 4:
                    warpAmount = -u;
                    p.y -= c / 5 * Math.pow((-1 + v - 2 * e) / v, 2) * Math.abs(warpAmount) * ((v - t) / v);
                    p.y -= (v - t) / v * (warpAmount * (c / 40));
                    p.y += c / 2;
                    break;
                case 5:
                    p.y = -c / 2 + c / v * t;
                    p.y += c / 5 * Math.pow((-1 + v - 1 * e) / v, 2) * warpAmount * (t / v);
                    p.y -= t / v * (warpAmount * (c / 40));
                    p.y += c / 2;
                    break;
                case 6:
                    p.y = -c / 2 + c / v * t;
                    p.y += c / 5 * ((-1 + v - 1 * e) / v) * warpAmount * (t / v);
                    p.y -= t / v * (warpAmount * (c / 40));
                    p.y += c / 2;
                    break;
                case 7:
                    warpAmount = -u;
                    p.y = -c / 2 + c / v * t;
                    p.y *= e < v / 2 ? Math.pow((v / 2 - 2 * e) / (v / 4) * (warpAmount / 10) - 1, 2) : Math.pow((v / 2 - 2 * (v - 1 - e)) / (v / 4) * (warpAmount / 10) - 1, 2);
                    p.y -= 2 * c * ((v - t) / v / 2);
                    break;
                case 8:
                    p.y = -c / 2 + c / v * t;
                    p.y += c / 5 * (-e / v) * warpAmount * ((v - t) / v);
                    p.y -= t / v * (warpAmount * (c / 40));
                    p.y += c / 2;
                    break;
                case 9:
                    p.y += c / 5 * Math.pow((-1 + v - 1 * e) / v, 2) * warpAmount;
                    break;
                case 10:
                    p.y = -c / 2 + c / v * t;
                    p.y += c / 5 * Math.pow(e / v, 2) * warpAmount * (t / v);
                    p.y -= t / v * (warpAmount * (c / 40));
                    p.y += c / 2;
                    break;
                case 11:
                    p.y += c / 5 * Math.cos(e / v * Math.PI * 2) * warpAmount * (t / s) * .5;
                    break;
                case 12:
                    p.y += c / 5 * Math.cos(e / v * Math.PI * 2 + Math.PI) * warpAmount * ((s - t) / s) * .5;
                    break;
                case 13:
                    p.y += c / 5 * Math.pow((-1 + v - (v - e)) / v, 2) * warpAmount;
                    break;
                case 14:
                    p.y = 2 * (c / s * t * (v - e * (warpAmount / 10)) / v + e / v * (c / 2 * (warpAmount / 10)));
                    break;
                case 15:
                    warpAmount = -u;
                    p.y = 2 * (c / v * t * (v - (v - e) * (Math.abs(warpAmount) / 10)) / v + (v - e) / v * (c / 2 * (Math.abs(warpAmount) / 10)));
                    break;
                case 16:
                    warpAmount = -u;
                    p.y -= c / 5 * Math.pow((-1 + v - 2 * e) / v, 2) * Math.abs(warpAmount) * (t / s);
                    p.y -= 2 * c * ((v - t) / v / 2);
                    break;
                case 17:
                    p.y += c / 5 * Math.pow((-1 + v - 2 * e) / v, 2) * warpAmount * ((s - t) / s);
                    p.y -= 2 * c * ((v - t) / v / 2);
                    break;
                case 18:
                    p.y = -c / 2 + c / v * t;
                    p.y += c / 5 * -Math.pow(e / v, 2) * warpAmount * ((v - t) / v);
                    p.y -= t / v * (warpAmount * (c / 40));
                    p.y += c / 2;
                    break;
                case 19:
                    warpAmount = u;
                    p.y += c / 5 * Math.cos(e / v * Math.PI * 2 + Math.PI) * warpAmount * (t / s) / 2;
                    p.y -= 2 * c * ((v - t) / v / 2);
                    break;
                case 20:
                    p.y += c / 10 * Math.cos(e / v * Math.PI * 2) * warpAmount;
                    break;
                case 21:
                    p.y = -c / 2 + c / v * t;
                    p.y *= e < v / 2 ? Math.sqrt(1 - (v / 2 - 4 * e) / (v / 2) * (warpAmount / 10)) : Math.sqrt(Math.max(0, 1 - (v / 2 - 4 * (v - 1 - e)) / (v / 2) * (warpAmount / 10)));
                    break;
                case 22:
                    p.y = c / v * t;
                    p.x = -d / 2 + d / s * e;
                    p.x *= (1 + (s - 2 * t) / s * (warpAmount / 10)) / (2 - (10 - warpAmount) / 10);
                    p.x += d / 2;
                    break;
                case 23:
                    warpAmount = -u;
                    p.y = c / v * t;
                    p.x = -d / 2 + d / s * e;
                    p.x *= (1 + (2 * t - s) / s * (Math.abs(warpAmount) / 10)) / (2 - (10 - Math.abs(warpAmount)) / 10);
                    p.x += d / 2;
                    break;
                case 24:
                    p.y += c / 10 * Math.cos(Math.PI / 1.5 + e / v * Math.PI * 2) * warpAmount;
                    break;
                case 25:
                    warpAmount = -u;
                    p.y += c / 10 * Math.sin(Math.PI / 1.5 + e / v * Math.PI * 2) * warpAmount;
                    break;
                case 26:
                    p.y += c / 10 * Math.cos(Math.PI + e / v * Math.PI) * warpAmount;
                    break;
                case 27:
                    warpAmount = -u;
                    p.y += c / 10 * Math.cos(2 * Math.PI + Math.PI + e / v * Math.PI) * warpAmount;
                    break;
                case 28:
                    p.x += c / 10 * (t / v) * (warpAmount = -u);
                    break;
                case 29:
                    p.x += c / 10 * (t / v) * warpAmount;
                    break;
                case 30:
                    p.y += c / 5 * Math.abs((-1 + v - 2 * e) / v) * warpAmount;
                    break;
                case 31:
                    warpAmount = -u;
                    p.y -= c / 5 * Math.abs((-1 + v - 2 * e) / v) * Math.abs(warpAmount);
            }
            return [p.x, -p.y];
        },
        toSVG: function (reviver) {
            if (!this.text) {
                return '';
            }
            return this._createBaseSVGMarkup(this._toSVG(reviver), { reviver: reviver });
        },
        getStrokeStyle: function (stroke) {
            var strokeWidth = stroke.strokeWidth, stroke = getSvgColorString('stroke', stroke.stroke);
            return [
                stroke,
                'stroke-width: ', strokeWidth, '; ',
                'white-space: pre;'
            ].join('');
        },
        emitExtraStroke: function (stroke) {
            return 'style="' + this.getStrokeStyle(stroke) + '" ';
        },
        _render: function (ctx) {
            if (!this.font)
                return this.callSuper('_render', ctx);
            var path = this.getTextPath(), bbox = path.getBoundingBox(), me = this;
            ctx.save();
            var tx = bbox.x1 + this.width / 2, ty = bbox.y1 + this.height / 2;
            ctx.transform(1, 0, 0, 1, -tx, -ty);
            path.fill = this.fill;
            path.stroke = this.stroke || this.extraStrokes;
            path.strokeWidth = this.strokeWidth;
            var origFill = ctx.fill, origStroke = ctx.stroke, extraStrokes = this.getExtraStrokes();
            if (extraStrokes.length) {
                ctx.fill = function () { };
                ctx.stroke = function () {
                    ctx.save();
                    ctx.transform(1, 0, 0, 1, tx, ty);
                    var args = arguments;
                    extraStrokes.forEach(function (dec) {
                        me._setStrokeStyles(ctx, dec);
                        origStroke.apply(ctx, args);
                    });
                    ctx.restore();
                };
                path.draw(ctx);
            }
            ctx.fill = function () {
                ctx.save();
                ctx.transform(1, 0, 0, 1, tx, ty);
                me._setFillStyles(ctx, me);
                origFill.apply(ctx, arguments);
                ctx.restore();
            };
            ctx.stroke = function () {
                ctx.save();
                ctx.transform(1, 0, 0, 1, tx, ty);
                me._setStrokeStyles(ctx, me);
                origStroke.apply(ctx, arguments);
                ctx.restore();
            };
            path.draw(ctx);
            delete ctx.fill;
            delete ctx.stroke;
            ctx.restore();
        },
        transformMatrixKey: function (skipGroup) {
            return this.callSuper('transformMatrixKey', skipGroup) + this.getEStrokeWidth();
        },
        getEStrokeWidth: function () {
            if (!this.extraStrokes) {
                return 0;
            }
            var strokeWidth = this.strokeWidth;
            return this.extraStrokes.reduce(function (p, c) {
                return p + (c.strokeWidth || strokeWidth);
            }, 0);
        },
        _getNonTransformedDimensions: function () {
            var strokeWidth = this.strokeWidth + this.getEStrokeWidth() * 2, w = this.width + strokeWidth, h = this.height + strokeWidth;
            return { x: w, y: h };
        },
        handleFiller: function (ctx, property, filler) {
            if (filler && filler.toLive) {
                ctx[property] = filler.toLive(ctx, this);
                return this._applyPatternGradientTransform(ctx, filler);
            }
            else {
                ctx[property] = filler || '';
            }
            return { offsetX: 0, offsetY: 0 };
        },
        _getPath: function (font) {
            var tracking = this.tracking;
            return font.getPath(this.text, 0, 0, this.fontSize, {
                tracking: tracking
            });
        },
        getTextPath: function () {
            if (this.textPath)
                return this.textPath;
            var path = this._getPath(this.font), bbox = path.getBoundingBox(), width = Math.abs(bbox.x2 - bbox.x1), height = Math.abs(bbox.y2 - bbox.y1), warpMode = this.warpMode, warpAmount = this.warpAmount;
            if (this.underline) {
                height = this.getHeightOfLine(0);
                var uoffset = this.offsets.underline, uPos = uoffset * height * 0.8, dWidth = uoffset * uoffset * height;
                path.commands.push({ type: "M", x: bbox.x1 - dWidth, y: uPos, relative: false });
                path.commands.push({ type: "L", x: bbox.x2 + dWidth, y: uPos, relative: false });
                path.commands.push({ type: "L", x: bbox.x2 + dWidth, y: uPos + this.fontSize / 15, relative: false });
                path.commands.push({ type: "L", x: bbox.x1 - dWidth, y: uPos + this.fontSize / 15, relative: false });
                path.commands.push({ type: "Z", relative: false });
            }
            if (warpMode) {
                var warp = this.getWarp(path.commands);
                warp.interpolate(width / this.text.length / this.scaleX / 5);
                warp.transform(([x, y]) => this.getWrappedPoint(x, y, warpMode, warpAmount, height, width));
                path.commands = warp.getPathCommands();
            }
            this.textPath = path;
            return path;
        },
        _set: function (key, value) {
            this[key] = value;
            if (this.warpRestoreField.has(key)) {
                this.textPath = null;
                this.dirty = true;
            }
            else if (this.addonDirtFields.has(key)) {
                this.dirty = true;
            }
            if (this.dimRestoreField.has(key)) {
                this.initDimensions();
            }
        },
        calcTextWidth: function () {
            if (!this.font)
                return this.callSuper('calcTextWidth');
            var bbox = this.getTextPath().getBoundingBox();
            this.width = Math.abs(bbox.x2 - bbox.x1);
            return this.width;
        },
        calcTextHeight: function () {
            if (!this.font)
                return this.callSuper('calcTextHeight');
            var bbox = this.getTextPath().getBoundingBox();
            this.height = Math.abs(bbox.y2 - bbox.y1);
            return this.height;
        },
        _toSVG: function () {
            var addTransform = '', tPath = this.getTextPath(), path = tPath.toPathData(), bbox = tPath.getBoundingBox();
            addTransform = ' translate(' + -(bbox.x1 + this.width / 2) + ', ' + -(bbox.y1 + this.height / 2) + ')';
            return [
                '<path ', 'COMMON_PARTS',
                'd="', path,
                '" stroke-linecap="round" ',
                'transform="', addTransform, '"',
                '/>\n'
            ];
        },
        toObject: function (propertiesToInclude) {
            var additionalProperties = [
                'warpMode',
                'warpAmount',
                'tracking',
                'extraStrokes'
            ].concat(propertiesToInclude);
            var obj = this.callSuper('toObject', additionalProperties);
            if (obj.extraStrokes) {
                obj.extraStrokes = JSON.parse(JSON.stringify(obj.extraStrokes));
            }
            return obj;
        }
    });
    function parseDecoration(object) {
        if (object.textDecoration) {
            object.textDecoration.indexOf('underline') > -1 && (object.underline = true);
            object.textDecoration.indexOf('line-through') > -1 && (object.linethrough = true);
            object.textDecoration.indexOf('overline') > -1 && (object.overline = true);
            delete object.textDecoration;
        }
    }
    fabric.ShapedText.fromObject = function (object, callback) {
        parseDecoration(object);
        if (object.styles) {
            for (var i in object.styles) {
                for (var j in object.styles[i]) {
                    parseDecoration(object.styles[i][j]);
                }
            }
        }
        return fabric.Object._fromObject('ShapedText', object, callback, 'shaped-text');
    };
}

function addCurvedTextClass(fabric) {
    var multiplyTransformMatrices = fabric.util.multiplyTransformMatrices;
    if (fabric.CurvedText) {
        fabric.warn('fabric.CurvedText is already defined');
        return;
    }
    function multiplyMatrix(...ms) {
        var res = ms.length ? ms[0] : [1, 0, 0, 1, 0, 0];
        for (var i = 1, len = ms.length; i < len; ++i) {
            res = multiplyTransformMatrices(res, ms[i]);
        }
        return res;
    }
    var makePathSimpler = fabric.util.makePathSimpler;
    function getOpenTypePath(path) {
        path = makePathSimpler(path);
        var destPath = new opentype.Path(), commands = destPath.commands;
        for (var i = 0; i < path.length; i++) {
            var s = path[i];
            var dest = {
                type: s[0]
            };
            switch (s[0]) {
                case "M":
                case "L":
                    dest.x = s[1];
                    dest.y = s[2];
                    break;
                case "C":
                    dest.x1 = s[1];
                    dest.y1 = s[2];
                    dest.x2 = s[3];
                    dest.y2 = s[4];
                    dest.x = s[5];
                    dest.y = s[6];
                    break;
                case "Q":
                    dest.x1 = s[1];
                    dest.y1 = s[2];
                    dest.x = s[3];
                    dest.y = s[4];
                    break;
                case "Z":
                    break;
                default:
                    throw new Error("Unexpected path command ");
            }
            commands.push(dest);
        }
        return destPath;
    }
    function getRotationMatrix(rad) {
        var sin = Math.sin(rad), cos = Math.cos(rad);
        return [cos, sin, -sin, cos, 0, 0];
    }
    var piX2 = 2 * Math.PI;
    fabric.CurvedText = fabric.util.createClass(fabric.ShapedText, {
        type: 'curved-text',
        radius: 50,
        placement: 'outside',
        dimRestoreField: new Set(['tracking', 'underline', 'warpMode', 'warpAmount', 'radius', 'placement', 'fontSize']),
        warpRestoreField: new Set(['radius', 'text', 'underline', 'fontFamily', 'fontStyle', 'fontWeight', 'underline', 'tracking', 'placement', 'fontSize']),
        _getPath: function (font) {
            var s = new opentype.Path(), multiplier = (this.placement === 'inside') ? -1 : 1, angleFactor = this.radius * multiplier, originY = (this.placement === 'inside') ? -(this.radius + this.fontSize) : this.radius, o = {
                tracking: this.tracking
            };
            var calcTextWidth = 0, widthFactor = this.fontSize / font.unitsPerEm, m1 = [1, 0, 0, 1, 0, -originY], m2 = [1, 0, 0, 1, 0, originY];
            font.forEachGlyph(this.text, 0, 0, this.fontSize, o, function (e, t, r, n) {
                var a = e.getPath(0, 0, n, o, this), glyphWidth = e.advanceWidth * widthFactor, half = glyphWidth / 2;
                a.transform(multiplyMatrix(m2, getRotationMatrix(t / angleFactor), m1, [1, 0, 0, 1, half, 0], getRotationMatrix(half / angleFactor), [1, 0, 0, 1, -half, 0]));
                s.extend(a);
                calcTextWidth = t + glyphWidth;
            });
            var endAngle = Math.abs(calcTextWidth / angleFactor);
            if (this.underline) {
                var e = endAngle > piX2 ? piX2 : endAngle;
                s.extend(this._getUnderlinePathPoints(0, e, e > Math.PI));
            }
            s.transform(getRotationMatrix(-multiplier * endAngle / 2));
            return s;
        },
        __getY: function (angle, dRadius) {
            var placement = this.placement;
            var radius = this.radius;
            if (dRadius)
                radius += dRadius;
            if (placement === 'outside') {
                return this.radius - fabric.util.cos(angle) * radius;
            }
            else {
                var fontSize = this.fontSize;
                radius += fontSize;
                return fabric.util.cos(angle) * radius - (this.radius + fontSize);
            }
        },
        __getX: function (angle, dRadius) {
            var radius = this.radius;
            radius = (this.placement !== 'inside') ? radius : (radius + this.fontSize);
            if (dRadius)
                radius += dRadius;
            return fabric.util.sin(angle) * radius;
        },
        _getUnderlinePathPoints: function (startAngle, endAngle, largeFlag) {
            var multiplier = (this.placement === 'inside') ? 1 : -1, dr = multiplier * this.fontSize / 15;
            var startY1 = this.__getY(startAngle, dr), startX1 = this.__getX(startAngle, dr), endY1 = this.__getY(endAngle, dr), endX1 = this.__getX(endAngle, dr);
            largeFlag = largeFlag ? 1 : 0;
            var path = [];
            var sweepFlag = (this.placement === 'outside') ? 1 : 0, radius = this.radius;
            if (this.placement === 'inside') {
                radius += this.fontSize;
            }
            path.push(['M', startX1, startY1], ['A', radius + dr, radius + dr, 0, largeFlag, sweepFlag, endX1, endY1]);
            dr += multiplier * this.fontSize / 15;
            var startY2 = this.__getY(startAngle, dr), startX2 = this.__getX(startAngle, dr), endY2 = this.__getY(endAngle, dr), endX2 = this.__getX(endAngle, dr);
            path.push(['L', endX2, endY2]);
            sweepFlag = (this.placement === 'outside') ? 0 : 1;
            path.push(['A', radius + dr, radius + dr, 0, largeFlag, sweepFlag, startX2, startY2]);
            path.push(['Z']);
            return getOpenTypePath(path);
        },
        setText: function (txt) {
            this.set('text', txt);
        },
        getTextPath: function () {
            if (this.textPath)
                return this.textPath;
            var path = this._getPath(this.font);
            this.textPath = path;
            return path;
        },
        toObject: function (propertiesToInclude) {
            var additionalProperties = [
                'radius',
                'spacing',
                'placement'
            ].concat(propertiesToInclude);
            var obj = this.callSuper('toObject', additionalProperties);
            if (obj.extraStrokes) {
                obj.extraStrokes = JSON.parse(JSON.stringify(obj.extraStrokes));
            }
            return obj;
        }
    });
    fabric.CurvedText.fromObject = function (object, callback) {
        return fabric.Object._fromObject('CurvedText', object, callback, 'text');
    };
}

function updateTextObject(fabric) {
    fabric.Textbox.helpers = fabric.Textbox.helpers || {};
    fabric.Textbox.helpers.Placeholder = fabric.util.createClass(fabric.Text, {
        initialize: function (text, options, target) {
            this.callSuper('initialize', text, options);
            this.target = target;
        },
        _getLeftOffset: function () {
            if (this.target) {
                return this.target._getLeftOffset();
            }
            else {
                return this.callSuper('_getLeftOffset');
            }
        },
        parentProps: ['textAlign', 'width'],
        setParentProps: function () {
            var parent = this.target;
            if (parent) {
                for (var prop of this.parentProps) {
                    this.set(prop, parent[prop]);
                }
            }
        }
    });
    fabric.util.addPrototypeProps(fabric.Textbox, {
        placeholderText: "Type your text here...",
        initialize: function (text, options) {
            this.callSuper('initialize', text, options);
            this.placeholderProps = {
                fill: "#999",
                fontSize: options.fontSize
            };
            this.placeholder = new fabric.Textbox.helpers.Placeholder(this.placeholderText, this.placeholderProps, this);
        },
        toObject: function (propertiesToInclude) {
            var additionalProperties = [
                'placeholderText',
                'lockMovementX',
                'lockMovementY',
                'textAlign'
            ].concat(propertiesToInclude);
            return this.callSuper('toObject', additionalProperties);
        },
        _renderTextCommon: function (ctx, method) {
            if (!this.text) {
                this.placeholder.setParentProps();
                this.placeholder._renderTextCommon(ctx, method);
            }
            else {
                this.callSuper('_renderTextCommon', ctx, method);
            }
        }
    });
}

var img$1 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAApCAYAAABOScuyAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAJFSURBVHgB1ZmPdYIwEMa/+jqAG5hu0A2abuAGZQQ7gY5gJ5AR7AS4gXYC6AS6gc0Z0BASkiBg+r13T8gf+JFc7jAA8YkJy0t7ReRikKDn0o7QoJ8MnbiwubA3YVOEqXDUfQo7WeqZsKz8VUXt34UdbB3OA9oadti8pV9jpF0d+rLEArz36EvQeC47bFCfCpqGH8hpsE1hqAphqaXupB1PLccXJag/SYpw371XDNJdkvL+FctOKbu6xFZpQG4xNqyuFHXgmiaoO/M3+nOBQUTAM+X8gMg1wT9TjMApbm5pjNs+cZJEi3EJuTAzDJvnp2hZ/L7AKZqBfPSIEuISH9o5wSbwF81OVpqeqILkO8JHNNPlHG5NYX5HybtC+wIvDDd0uQTVt70ndIL2BQZuaXKFbrB7NNeCC5quM1fbhAD7ygZbPeQKftBUVrliNhSwCxYB0Fxr0zuwL6wvNMeAwKGwPtAcAwF3hXVBc3QAXuD29yk3tLkXtg06QSDwBub4uekZ1gatJ6tWYBtsZcueYW3QXsA6bA4ZvPOWi/UB64I2AptgWdmWwQzdJ2wbdAN43wILC/RuANhKaziAXbCqOIbfrOPwBHbBjiUODdj0Al9Abr4ViFA6cIG4YJleoAN/IdKRrUTA6k4PQ1xiyvGVc4t6Knz03poqPXxexNGMxQyPFQ3aBoYsXH0yyCDBVe0g/fkX44lAZyWLOtOFsBe1IcM4O/BdLIdlxqkwjQi08lumQpq+IlG6TTDuNzKmHBeQ274UDHZ6wz/9bvJ0bP8fGwAAAABJRU5ErkJggg==";

async function addImageBoxClass(fabric) {
    fabric.ImageBox = fabric.util.createClass(fabric.Image, {
        type: 'imageBox',
        effectiveWidth: 35,
        effectiveHeight: 42,
        dpi: 150,
        initialize: function (element, options) {
            this.callSuper("initialize", element, options);
            this.on('mouseup', this.mouseUpHandler);
            this.on('mousedown', this.onMouseDown);
            var el = document.createElement('input');
            el.type = 'file';
            el.accept = "image/png, image/jpeg";
            var style = el.style;
            style.position = 'absolute';
            style.opacity = 0;
            style['border-radius'] = '50%';
            style.transform = 'translate(-50%, -50%)';
            style.cursor = 'pointer';
            el.onchange = this.onFileChange.bind(this);
            this.inputEl = el;
            this.on('selected', () => {
                var target = this.canvas?.lowerCanvasEl?.parentElement;
                if (target) {
                    target.appendChild(el);
                }
            });
            this.on('deselected', () => {
                var target = this.canvas?.lowerCanvasEl?.parentElement;
                if (target) {
                    target.removeChild(el);
                }
            });
        },
        toObject: function (propertiesToInclude) {
            var additionalProperties = [
                'lockMovementX',
                'lockMovementY',
                'effectiveWidth',
                'effectiveHeight',
                'placeholderSrc'
            ].concat(propertiesToInclude);
            return this.callSuper('toObject', additionalProperties);
        },
        onFileChange: function (e) {
            var file = e.target.files[0];
            if (file) {
                this.updateSrc(URL.createObjectURL(file));
            }
        },
        updateSrc: function (url, skip) {
            return new Promise((accept, reject) => {
                this.setSrc(url, function (obj, isError) {
                    if (!isError && (obj.effectiveWidth || obj.effectiveHeight)) {
                        var sx = obj.effectiveWidth / obj.width, sy = obj.effectiveHeight / obj.height, sz = sx > sy ? sx : sy, canvas = obj.canvas;
                        obj.scaleX = sz;
                        obj.scaleY = sz;
                        obj.dirty = true;
                        if (canvas && !skip) {
                            canvas.fire('object:modified', { target: obj });
                            canvas.renderAll();
                        }
                        accept(obj);
                    }
                    else {
                        reject(isError);
                    }
                });
            });
        },
        saveImage: function (cb) {
            var me = this;
            return new Promise(function (accept, reject) {
                var src = me.getSrc();
                if (src && src.startsWith('blob:')) {
                    fetch(src).then(function (res) {
                        return res.blob();
                    }).then(async function (blob) {
                        let url = await cb && cb(blob);
                        accept(url);
                    }).catch(reject);
                }
                else {
                    accept(src);
                }
            });
        }
    });
    var controls = {};
    Object.assign(controls, fabric.Image.prototype.controls);
    fabric.ImageBox.prototype.controls = controls;
    var updateIcon = await getImage(img$1), renderIconControl = fabric.controlsUtils.renderIconControl;
    fabric.ImageBox.prototype.controls.tl = new fabric.Control({
        x: -0.5,
        y: -0.5,
        cursorStyleHandler: function () {
            return 'pointer';
        },
        getActionName: function () {
            return 'updateImage';
        },
        render: function (ctx, left, top, styleOverride, fabricObject) {
            ctx.save();
            var styleOverrides = {};
            renderIconControl.call(this, ctx, left, top, updateIcon, styleOverrides);
            var style = fabricObject?.inputEl?.style;
            if (style) {
                style.width = styleOverrides.cornerSize + 'px';
                style.height = styleOverrides.cornerSize + 'px';
                style.left = left + 'px';
                style.top = top + 'px';
            }
            ctx.restore();
        }
    });
    fabric.ImageBox.fromObject = function (_object, callback) {
        var object = fabric.util.object.clone(_object);
        fabric.util.loadImage(object.src, function (img, isError) {
            if (isError) {
                callback && callback(null, true);
                return;
            }
            fabric.Image.prototype._initFilters.call(object, object.filters, function (filters) {
                object.filters = filters || [];
                fabric.Image.prototype._initFilters.call(object, [object.resizeFilter], function (resizeFilters) {
                    object.resizeFilter = resizeFilters[0];
                    fabric.util.enlivenObjects([object.clipPath], function (enlivedProps) {
                        object.clipPath = enlivedProps[0];
                        callback(new fabric.ImageBox(img, object), false);
                    });
                });
            });
        }, null, object.crossOrigin);
    };
}

var graphemeSplitter = {exports: {}};

/*
Breaks a Javascript string into individual user-perceived "characters" 
called extended grapheme clusters by implementing the Unicode UAX-29 standard, version 10.0.0

Usage:
var splitter = new GraphemeSplitter();
//returns an array of strings, one string for each grapheme cluster
var graphemes = splitter.splitGraphemes(string); 

*/

(function (module) {
	function GraphemeSplitter(){
		var CR = 0,
			LF = 1,
			Control = 2,
			Extend = 3,
			Regional_Indicator = 4,
			SpacingMark = 5,
			L = 6,
			V = 7,
			T = 8,
			LV = 9,
			LVT = 10,
			Other = 11,
			Prepend = 12,
			E_Base = 13,
			E_Modifier = 14,
			ZWJ = 15,
			Glue_After_Zwj = 16,
			E_Base_GAZ = 17;
			
		// BreakTypes
		var NotBreak = 0,
			BreakStart = 1,
			Break = 2,
			BreakLastRegional = 3,
			BreakPenultimateRegional = 4;
			
		function isSurrogate(str, pos) {
			return  0xd800 <= str.charCodeAt(pos) && str.charCodeAt(pos) <= 0xdbff && 
					0xdc00 <= str.charCodeAt(pos + 1) && str.charCodeAt(pos + 1) <= 0xdfff;
		}
			
		// Private function, gets a Unicode code point from a JavaScript UTF-16 string
		// handling surrogate pairs appropriately
		function codePointAt(str, idx){
			if(idx === undefined){
				idx = 0;
			}
			var code = str.charCodeAt(idx);

			// if a high surrogate
			if (0xD800 <= code && code <= 0xDBFF && 
				idx < str.length - 1){
				var hi = code;
				var low = str.charCodeAt(idx + 1);
				if (0xDC00 <= low && low <= 0xDFFF){
					return ((hi - 0xD800) * 0x400) + (low - 0xDC00) + 0x10000;
				}
				return hi;
			}
			
			// if a low surrogate
			if (0xDC00 <= code && code <= 0xDFFF &&
				idx >= 1){
				var hi = str.charCodeAt(idx - 1);
				var low = code;
				if (0xD800 <= hi && hi <= 0xDBFF){
					return ((hi - 0xD800) * 0x400) + (low - 0xDC00) + 0x10000;
				}
				return low;
			}
			
			//just return the char if an unmatched surrogate half or a 
			//single-char codepoint
			return code;
		}
		
		// Private function, returns whether a break is allowed between the 
		// two given grapheme breaking classes
		function shouldBreak(start, mid, end){
			var all = [start].concat(mid).concat([end]);
			var previous = all[all.length - 2];
			var next = end;
			
			// Lookahead termintor for:
			// GB10. (E_Base | EBG) Extend* ?	E_Modifier
			var eModifierIndex = all.lastIndexOf(E_Modifier);
			if(eModifierIndex > 1 &&
				all.slice(1, eModifierIndex).every(function(c){return c == Extend}) &&
				[Extend, E_Base, E_Base_GAZ].indexOf(start) == -1){
				return Break
			}

			// Lookahead termintor for:
			// GB12. ^ (RI RI)* RI	?	RI
			// GB13. [^RI] (RI RI)* RI	?	RI
			var rIIndex = all.lastIndexOf(Regional_Indicator);
			if(rIIndex > 0 &&
				all.slice(1, rIIndex).every(function(c){return c == Regional_Indicator}) &&
				[Prepend, Regional_Indicator].indexOf(previous) == -1) { 
				if(all.filter(function(c){return c == Regional_Indicator}).length % 2 == 1) {
					return BreakLastRegional
				}
				else {
					return BreakPenultimateRegional
				}
			}
			
			// GB3. CR X LF
			if(previous == CR && next == LF){
				return NotBreak;
			}
			// GB4. (Control|CR|LF) ÷
			else if(previous == Control || previous == CR || previous == LF){
				if(next == E_Modifier && mid.every(function(c){return c == Extend})){
					return Break
				}
				else {
					return BreakStart
				}
			}
			// GB5. ÷ (Control|CR|LF)
			else if(next == Control || next == CR || next == LF){
				return BreakStart;
			}
			// GB6. L X (L|V|LV|LVT)
			else if(previous == L && 
				(next == L || next == V || next == LV || next == LVT)){
				return NotBreak;
			}
			// GB7. (LV|V) X (V|T)
			else if((previous == LV || previous == V) && 
				(next == V || next == T)){
				return NotBreak;
			}
			// GB8. (LVT|T) X (T)
			else if((previous == LVT || previous == T) && 
				next == T){
				return NotBreak;
			}
			// GB9. X (Extend|ZWJ)
			else if (next == Extend || next == ZWJ){
				return NotBreak;
			}
			// GB9a. X SpacingMark
			else if(next == SpacingMark){
				return NotBreak;
			}
			// GB9b. Prepend X
			else if (previous == Prepend){
				return NotBreak;
			}
			
			// GB10. (E_Base | EBG) Extend* ?	E_Modifier
			var previousNonExtendIndex = all.indexOf(Extend) != -1 ? all.lastIndexOf(Extend) - 1 : all.length - 2;
			if([E_Base, E_Base_GAZ].indexOf(all[previousNonExtendIndex]) != -1 &&
				all.slice(previousNonExtendIndex + 1, -1).every(function(c){return c == Extend}) &&
				next == E_Modifier){
				return NotBreak;
			}
			
			// GB11. ZWJ ? (Glue_After_Zwj | EBG)
			if(previous == ZWJ && [Glue_After_Zwj, E_Base_GAZ].indexOf(next) != -1) {
				return NotBreak;
			}

			// GB12. ^ (RI RI)* RI ? RI
			// GB13. [^RI] (RI RI)* RI ? RI
			if(mid.indexOf(Regional_Indicator) != -1) { 
				return Break;
			}
			if(previous == Regional_Indicator && next == Regional_Indicator) {
				return NotBreak;
			}

			// GB999. Any ? Any
			return BreakStart;
		}
		
		// Returns the next grapheme break in the string after the given index
		this.nextBreak = function(string, index){
			if(index === undefined){
				index = 0;
			}
			if(index < 0){
				return 0;
			}
			if(index >= string.length - 1){
				return string.length;
			}
			var prev = getGraphemeBreakProperty(codePointAt(string, index));
			var mid = [];
			for (var i = index + 1; i < string.length; i++) {
				// check for already processed low surrogates
				if(isSurrogate(string, i - 1)){
					continue;
				}
			
				var next = getGraphemeBreakProperty(codePointAt(string, i));
				if(shouldBreak(prev, mid, next)){
					return i;
				}
				
				mid.push(next);
			}
			return string.length;
		};
		
		// Breaks the given string into an array of grapheme cluster strings
		this.splitGraphemes = function(str){
			var res = [];
			var index = 0;
			var brk;
			while((brk = this.nextBreak(str, index)) < str.length){
				res.push(str.slice(index, brk));
				index = brk;
			}
			if(index < str.length){
				res.push(str.slice(index));
			}
			return res;
		};

		// Returns the iterator of grapheme clusters there are in the given string
		this.iterateGraphemes = function(str) {
			var index = 0;
			var res = {
				next: (function() {
					var value;
					var brk;
					if ((brk = this.nextBreak(str, index)) < str.length) {
						value = str.slice(index, brk);
						index = brk;
						return { value: value, done: false };
					}
					if (index < str.length) {
						value = str.slice(index);
						index = str.length;
						return { value: value, done: false };
					}
					return { value: undefined, done: true };
				}).bind(this)
			};
			// ES2015 @@iterator method (iterable) for spread syntax and for...of statement
			if (typeof Symbol !== 'undefined' && Symbol.iterator) {
				res[Symbol.iterator] = function() {return res};
			}
			return res;
		};

		// Returns the number of grapheme clusters there are in the given string
		this.countGraphemes = function(str){
			var count = 0;
			var index = 0;
			var brk;
			while((brk = this.nextBreak(str, index)) < str.length){
				index = brk;
				count++;
			}
			if(index < str.length){
				count++;
			}
			return count;
		};
		
		//given a Unicode code point, determines this symbol's grapheme break property
		function getGraphemeBreakProperty(code){
			
			//grapheme break property for Unicode 10.0.0, 
			//taken from http://www.unicode.org/Public/10.0.0/ucd/auxiliary/GraphemeBreakProperty.txt
			//and adapted to JavaScript rules
			
			if(		
			(0x0600 <= code && code <= 0x0605) || // Cf   [6] ARABIC NUMBER SIGN..ARABIC NUMBER MARK ABOVE
			0x06DD == code || // Cf       ARABIC END OF AYAH
			0x070F == code || // Cf       SYRIAC ABBREVIATION MARK
			0x08E2 == code || // Cf       ARABIC DISPUTED END OF AYAH
			0x0D4E == code || // Lo       MALAYALAM LETTER DOT REPH
			0x110BD == code || // Cf       KAITHI NUMBER SIGN
			(0x111C2 <= code && code <= 0x111C3) || // Lo   [2] SHARADA SIGN JIHVAMULIYA..SHARADA SIGN UPADHMANIYA
			0x11A3A == code || // Lo       ZANABAZAR SQUARE CLUSTER-INITIAL LETTER RA
			(0x11A86 <= code && code <= 0x11A89) || // Lo   [4] SOYOMBO CLUSTER-INITIAL LETTER RA..SOYOMBO CLUSTER-INITIAL LETTER SA
			0x11D46 == code // Lo       MASARAM GONDI REPHA
			){
				return Prepend;
			}
			if(
			0x000D == code // Cc       <control-000D>
			){
				return CR;
			}
			
			if(
			0x000A == code // Cc       <control-000A>
			){
				return LF;
			}
			
			
			if(
			(0x0000 <= code && code <= 0x0009) || // Cc  [10] <control-0000>..<control-0009>
			(0x000B <= code && code <= 0x000C) || // Cc   [2] <control-000B>..<control-000C>
			(0x000E <= code && code <= 0x001F) || // Cc  [18] <control-000E>..<control-001F>
			(0x007F <= code && code <= 0x009F) || // Cc  [33] <control-007F>..<control-009F>
			0x00AD == code || // Cf       SOFT HYPHEN
			0x061C == code || // Cf       ARABIC LETTER MARK
		
			0x180E == code || // Cf       MONGOLIAN VOWEL SEPARATOR
			0x200B == code || // Cf       ZERO WIDTH SPACE
			(0x200E <= code && code <= 0x200F) || // Cf   [2] LEFT-TO-RIGHT MARK..RIGHT-TO-LEFT MARK
			0x2028 == code || // Zl       LINE SEPARATOR
			0x2029 == code || // Zp       PARAGRAPH SEPARATOR
			(0x202A <= code && code <= 0x202E) || // Cf   [5] LEFT-TO-RIGHT EMBEDDING..RIGHT-TO-LEFT OVERRIDE
			(0x2060 <= code && code <= 0x2064) || // Cf   [5] WORD JOINER..INVISIBLE PLUS
			0x2065 == code || // Cn       <reserved-2065>
			(0x2066 <= code && code <= 0x206F) || // Cf  [10] LEFT-TO-RIGHT ISOLATE..NOMINAL DIGIT SHAPES
			(0xD800 <= code && code <= 0xDFFF) || // Cs [2048] <surrogate-D800>..<surrogate-DFFF>
			0xFEFF == code || // Cf       ZERO WIDTH NO-BREAK SPACE
			(0xFFF0 <= code && code <= 0xFFF8) || // Cn   [9] <reserved-FFF0>..<reserved-FFF8>
			(0xFFF9 <= code && code <= 0xFFFB) || // Cf   [3] INTERLINEAR ANNOTATION ANCHOR..INTERLINEAR ANNOTATION TERMINATOR
			(0x1BCA0 <= code && code <= 0x1BCA3) || // Cf   [4] SHORTHAND FORMAT LETTER OVERLAP..SHORTHAND FORMAT UP STEP
			(0x1D173 <= code && code <= 0x1D17A) || // Cf   [8] MUSICAL SYMBOL BEGIN BEAM..MUSICAL SYMBOL END PHRASE
			0xE0000 == code || // Cn       <reserved-E0000>
			0xE0001 == code || // Cf       LANGUAGE TAG
			(0xE0002 <= code && code <= 0xE001F) || // Cn  [30] <reserved-E0002>..<reserved-E001F>
			(0xE0080 <= code && code <= 0xE00FF) || // Cn [128] <reserved-E0080>..<reserved-E00FF>
			(0xE01F0 <= code && code <= 0xE0FFF) // Cn [3600] <reserved-E01F0>..<reserved-E0FFF>
			){
				return Control;
			}
			
			
			if(
			(0x0300 <= code && code <= 0x036F) || // Mn [112] COMBINING GRAVE ACCENT..COMBINING LATIN SMALL LETTER X
			(0x0483 <= code && code <= 0x0487) || // Mn   [5] COMBINING CYRILLIC TITLO..COMBINING CYRILLIC POKRYTIE
			(0x0488 <= code && code <= 0x0489) || // Me   [2] COMBINING CYRILLIC HUNDRED THOUSANDS SIGN..COMBINING CYRILLIC MILLIONS SIGN
			(0x0591 <= code && code <= 0x05BD) || // Mn  [45] HEBREW ACCENT ETNAHTA..HEBREW POINT METEG
			0x05BF == code || // Mn       HEBREW POINT RAFE
			(0x05C1 <= code && code <= 0x05C2) || // Mn   [2] HEBREW POINT SHIN DOT..HEBREW POINT SIN DOT
			(0x05C4 <= code && code <= 0x05C5) || // Mn   [2] HEBREW MARK UPPER DOT..HEBREW MARK LOWER DOT
			0x05C7 == code || // Mn       HEBREW POINT QAMATS QATAN
			(0x0610 <= code && code <= 0x061A) || // Mn  [11] ARABIC SIGN SALLALLAHOU ALAYHE WASSALLAM..ARABIC SMALL KASRA
			(0x064B <= code && code <= 0x065F) || // Mn  [21] ARABIC FATHATAN..ARABIC WAVY HAMZA BELOW
			0x0670 == code || // Mn       ARABIC LETTER SUPERSCRIPT ALEF
			(0x06D6 <= code && code <= 0x06DC) || // Mn   [7] ARABIC SMALL HIGH LIGATURE SAD WITH LAM WITH ALEF MAKSURA..ARABIC SMALL HIGH SEEN
			(0x06DF <= code && code <= 0x06E4) || // Mn   [6] ARABIC SMALL HIGH ROUNDED ZERO..ARABIC SMALL HIGH MADDA
			(0x06E7 <= code && code <= 0x06E8) || // Mn   [2] ARABIC SMALL HIGH YEH..ARABIC SMALL HIGH NOON
			(0x06EA <= code && code <= 0x06ED) || // Mn   [4] ARABIC EMPTY CENTRE LOW STOP..ARABIC SMALL LOW MEEM
			0x0711 == code || // Mn       SYRIAC LETTER SUPERSCRIPT ALAPH
			(0x0730 <= code && code <= 0x074A) || // Mn  [27] SYRIAC PTHAHA ABOVE..SYRIAC BARREKH
			(0x07A6 <= code && code <= 0x07B0) || // Mn  [11] THAANA ABAFILI..THAANA SUKUN
			(0x07EB <= code && code <= 0x07F3) || // Mn   [9] NKO COMBINING SHORT HIGH TONE..NKO COMBINING DOUBLE DOT ABOVE
			(0x0816 <= code && code <= 0x0819) || // Mn   [4] SAMARITAN MARK IN..SAMARITAN MARK DAGESH
			(0x081B <= code && code <= 0x0823) || // Mn   [9] SAMARITAN MARK EPENTHETIC YUT..SAMARITAN VOWEL SIGN A
			(0x0825 <= code && code <= 0x0827) || // Mn   [3] SAMARITAN VOWEL SIGN SHORT A..SAMARITAN VOWEL SIGN U
			(0x0829 <= code && code <= 0x082D) || // Mn   [5] SAMARITAN VOWEL SIGN LONG I..SAMARITAN MARK NEQUDAA
			(0x0859 <= code && code <= 0x085B) || // Mn   [3] MANDAIC AFFRICATION MARK..MANDAIC GEMINATION MARK
			(0x08D4 <= code && code <= 0x08E1) || // Mn  [14] ARABIC SMALL HIGH WORD AR-RUB..ARABIC SMALL HIGH SIGN SAFHA
			(0x08E3 <= code && code <= 0x0902) || // Mn  [32] ARABIC TURNED DAMMA BELOW..DEVANAGARI SIGN ANUSVARA
			0x093A == code || // Mn       DEVANAGARI VOWEL SIGN OE
			0x093C == code || // Mn       DEVANAGARI SIGN NUKTA
			(0x0941 <= code && code <= 0x0948) || // Mn   [8] DEVANAGARI VOWEL SIGN U..DEVANAGARI VOWEL SIGN AI
			0x094D == code || // Mn       DEVANAGARI SIGN VIRAMA
			(0x0951 <= code && code <= 0x0957) || // Mn   [7] DEVANAGARI STRESS SIGN UDATTA..DEVANAGARI VOWEL SIGN UUE
			(0x0962 <= code && code <= 0x0963) || // Mn   [2] DEVANAGARI VOWEL SIGN VOCALIC L..DEVANAGARI VOWEL SIGN VOCALIC LL
			0x0981 == code || // Mn       BENGALI SIGN CANDRABINDU
			0x09BC == code || // Mn       BENGALI SIGN NUKTA
			0x09BE == code || // Mc       BENGALI VOWEL SIGN AA
			(0x09C1 <= code && code <= 0x09C4) || // Mn   [4] BENGALI VOWEL SIGN U..BENGALI VOWEL SIGN VOCALIC RR
			0x09CD == code || // Mn       BENGALI SIGN VIRAMA
			0x09D7 == code || // Mc       BENGALI AU LENGTH MARK
			(0x09E2 <= code && code <= 0x09E3) || // Mn   [2] BENGALI VOWEL SIGN VOCALIC L..BENGALI VOWEL SIGN VOCALIC LL
			(0x0A01 <= code && code <= 0x0A02) || // Mn   [2] GURMUKHI SIGN ADAK BINDI..GURMUKHI SIGN BINDI
			0x0A3C == code || // Mn       GURMUKHI SIGN NUKTA
			(0x0A41 <= code && code <= 0x0A42) || // Mn   [2] GURMUKHI VOWEL SIGN U..GURMUKHI VOWEL SIGN UU
			(0x0A47 <= code && code <= 0x0A48) || // Mn   [2] GURMUKHI VOWEL SIGN EE..GURMUKHI VOWEL SIGN AI
			(0x0A4B <= code && code <= 0x0A4D) || // Mn   [3] GURMUKHI VOWEL SIGN OO..GURMUKHI SIGN VIRAMA
			0x0A51 == code || // Mn       GURMUKHI SIGN UDAAT
			(0x0A70 <= code && code <= 0x0A71) || // Mn   [2] GURMUKHI TIPPI..GURMUKHI ADDAK
			0x0A75 == code || // Mn       GURMUKHI SIGN YAKASH
			(0x0A81 <= code && code <= 0x0A82) || // Mn   [2] GUJARATI SIGN CANDRABINDU..GUJARATI SIGN ANUSVARA
			0x0ABC == code || // Mn       GUJARATI SIGN NUKTA
			(0x0AC1 <= code && code <= 0x0AC5) || // Mn   [5] GUJARATI VOWEL SIGN U..GUJARATI VOWEL SIGN CANDRA E
			(0x0AC7 <= code && code <= 0x0AC8) || // Mn   [2] GUJARATI VOWEL SIGN E..GUJARATI VOWEL SIGN AI
			0x0ACD == code || // Mn       GUJARATI SIGN VIRAMA
			(0x0AE2 <= code && code <= 0x0AE3) || // Mn   [2] GUJARATI VOWEL SIGN VOCALIC L..GUJARATI VOWEL SIGN VOCALIC LL
			(0x0AFA <= code && code <= 0x0AFF) || // Mn   [6] GUJARATI SIGN SUKUN..GUJARATI SIGN TWO-CIRCLE NUKTA ABOVE
			0x0B01 == code || // Mn       ORIYA SIGN CANDRABINDU
			0x0B3C == code || // Mn       ORIYA SIGN NUKTA
			0x0B3E == code || // Mc       ORIYA VOWEL SIGN AA
			0x0B3F == code || // Mn       ORIYA VOWEL SIGN I
			(0x0B41 <= code && code <= 0x0B44) || // Mn   [4] ORIYA VOWEL SIGN U..ORIYA VOWEL SIGN VOCALIC RR
			0x0B4D == code || // Mn       ORIYA SIGN VIRAMA
			0x0B56 == code || // Mn       ORIYA AI LENGTH MARK
			0x0B57 == code || // Mc       ORIYA AU LENGTH MARK
			(0x0B62 <= code && code <= 0x0B63) || // Mn   [2] ORIYA VOWEL SIGN VOCALIC L..ORIYA VOWEL SIGN VOCALIC LL
			0x0B82 == code || // Mn       TAMIL SIGN ANUSVARA
			0x0BBE == code || // Mc       TAMIL VOWEL SIGN AA
			0x0BC0 == code || // Mn       TAMIL VOWEL SIGN II
			0x0BCD == code || // Mn       TAMIL SIGN VIRAMA
			0x0BD7 == code || // Mc       TAMIL AU LENGTH MARK
			0x0C00 == code || // Mn       TELUGU SIGN COMBINING CANDRABINDU ABOVE
			(0x0C3E <= code && code <= 0x0C40) || // Mn   [3] TELUGU VOWEL SIGN AA..TELUGU VOWEL SIGN II
			(0x0C46 <= code && code <= 0x0C48) || // Mn   [3] TELUGU VOWEL SIGN E..TELUGU VOWEL SIGN AI
			(0x0C4A <= code && code <= 0x0C4D) || // Mn   [4] TELUGU VOWEL SIGN O..TELUGU SIGN VIRAMA
			(0x0C55 <= code && code <= 0x0C56) || // Mn   [2] TELUGU LENGTH MARK..TELUGU AI LENGTH MARK
			(0x0C62 <= code && code <= 0x0C63) || // Mn   [2] TELUGU VOWEL SIGN VOCALIC L..TELUGU VOWEL SIGN VOCALIC LL
			0x0C81 == code || // Mn       KANNADA SIGN CANDRABINDU
			0x0CBC == code || // Mn       KANNADA SIGN NUKTA
			0x0CBF == code || // Mn       KANNADA VOWEL SIGN I
			0x0CC2 == code || // Mc       KANNADA VOWEL SIGN UU
			0x0CC6 == code || // Mn       KANNADA VOWEL SIGN E
			(0x0CCC <= code && code <= 0x0CCD) || // Mn   [2] KANNADA VOWEL SIGN AU..KANNADA SIGN VIRAMA
			(0x0CD5 <= code && code <= 0x0CD6) || // Mc   [2] KANNADA LENGTH MARK..KANNADA AI LENGTH MARK
			(0x0CE2 <= code && code <= 0x0CE3) || // Mn   [2] KANNADA VOWEL SIGN VOCALIC L..KANNADA VOWEL SIGN VOCALIC LL
			(0x0D00 <= code && code <= 0x0D01) || // Mn   [2] MALAYALAM SIGN COMBINING ANUSVARA ABOVE..MALAYALAM SIGN CANDRABINDU
			(0x0D3B <= code && code <= 0x0D3C) || // Mn   [2] MALAYALAM SIGN VERTICAL BAR VIRAMA..MALAYALAM SIGN CIRCULAR VIRAMA
			0x0D3E == code || // Mc       MALAYALAM VOWEL SIGN AA
			(0x0D41 <= code && code <= 0x0D44) || // Mn   [4] MALAYALAM VOWEL SIGN U..MALAYALAM VOWEL SIGN VOCALIC RR
			0x0D4D == code || // Mn       MALAYALAM SIGN VIRAMA
			0x0D57 == code || // Mc       MALAYALAM AU LENGTH MARK
			(0x0D62 <= code && code <= 0x0D63) || // Mn   [2] MALAYALAM VOWEL SIGN VOCALIC L..MALAYALAM VOWEL SIGN VOCALIC LL
			0x0DCA == code || // Mn       SINHALA SIGN AL-LAKUNA
			0x0DCF == code || // Mc       SINHALA VOWEL SIGN AELA-PILLA
			(0x0DD2 <= code && code <= 0x0DD4) || // Mn   [3] SINHALA VOWEL SIGN KETTI IS-PILLA..SINHALA VOWEL SIGN KETTI PAA-PILLA
			0x0DD6 == code || // Mn       SINHALA VOWEL SIGN DIGA PAA-PILLA
			0x0DDF == code || // Mc       SINHALA VOWEL SIGN GAYANUKITTA
			0x0E31 == code || // Mn       THAI CHARACTER MAI HAN-AKAT
			(0x0E34 <= code && code <= 0x0E3A) || // Mn   [7] THAI CHARACTER SARA I..THAI CHARACTER PHINTHU
			(0x0E47 <= code && code <= 0x0E4E) || // Mn   [8] THAI CHARACTER MAITAIKHU..THAI CHARACTER YAMAKKAN
			0x0EB1 == code || // Mn       LAO VOWEL SIGN MAI KAN
			(0x0EB4 <= code && code <= 0x0EB9) || // Mn   [6] LAO VOWEL SIGN I..LAO VOWEL SIGN UU
			(0x0EBB <= code && code <= 0x0EBC) || // Mn   [2] LAO VOWEL SIGN MAI KON..LAO SEMIVOWEL SIGN LO
			(0x0EC8 <= code && code <= 0x0ECD) || // Mn   [6] LAO TONE MAI EK..LAO NIGGAHITA
			(0x0F18 <= code && code <= 0x0F19) || // Mn   [2] TIBETAN ASTROLOGICAL SIGN -KHYUD PA..TIBETAN ASTROLOGICAL SIGN SDONG TSHUGS
			0x0F35 == code || // Mn       TIBETAN MARK NGAS BZUNG NYI ZLA
			0x0F37 == code || // Mn       TIBETAN MARK NGAS BZUNG SGOR RTAGS
			0x0F39 == code || // Mn       TIBETAN MARK TSA -PHRU
			(0x0F71 <= code && code <= 0x0F7E) || // Mn  [14] TIBETAN VOWEL SIGN AA..TIBETAN SIGN RJES SU NGA RO
			(0x0F80 <= code && code <= 0x0F84) || // Mn   [5] TIBETAN VOWEL SIGN REVERSED I..TIBETAN MARK HALANTA
			(0x0F86 <= code && code <= 0x0F87) || // Mn   [2] TIBETAN SIGN LCI RTAGS..TIBETAN SIGN YANG RTAGS
			(0x0F8D <= code && code <= 0x0F97) || // Mn  [11] TIBETAN SUBJOINED SIGN LCE TSA CAN..TIBETAN SUBJOINED LETTER JA
			(0x0F99 <= code && code <= 0x0FBC) || // Mn  [36] TIBETAN SUBJOINED LETTER NYA..TIBETAN SUBJOINED LETTER FIXED-FORM RA
			0x0FC6 == code || // Mn       TIBETAN SYMBOL PADMA GDAN
			(0x102D <= code && code <= 0x1030) || // Mn   [4] MYANMAR VOWEL SIGN I..MYANMAR VOWEL SIGN UU
			(0x1032 <= code && code <= 0x1037) || // Mn   [6] MYANMAR VOWEL SIGN AI..MYANMAR SIGN DOT BELOW
			(0x1039 <= code && code <= 0x103A) || // Mn   [2] MYANMAR SIGN VIRAMA..MYANMAR SIGN ASAT
			(0x103D <= code && code <= 0x103E) || // Mn   [2] MYANMAR CONSONANT SIGN MEDIAL WA..MYANMAR CONSONANT SIGN MEDIAL HA
			(0x1058 <= code && code <= 0x1059) || // Mn   [2] MYANMAR VOWEL SIGN VOCALIC L..MYANMAR VOWEL SIGN VOCALIC LL
			(0x105E <= code && code <= 0x1060) || // Mn   [3] MYANMAR CONSONANT SIGN MON MEDIAL NA..MYANMAR CONSONANT SIGN MON MEDIAL LA
			(0x1071 <= code && code <= 0x1074) || // Mn   [4] MYANMAR VOWEL SIGN GEBA KAREN I..MYANMAR VOWEL SIGN KAYAH EE
			0x1082 == code || // Mn       MYANMAR CONSONANT SIGN SHAN MEDIAL WA
			(0x1085 <= code && code <= 0x1086) || // Mn   [2] MYANMAR VOWEL SIGN SHAN E ABOVE..MYANMAR VOWEL SIGN SHAN FINAL Y
			0x108D == code || // Mn       MYANMAR SIGN SHAN COUNCIL EMPHATIC TONE
			0x109D == code || // Mn       MYANMAR VOWEL SIGN AITON AI
			(0x135D <= code && code <= 0x135F) || // Mn   [3] ETHIOPIC COMBINING GEMINATION AND VOWEL LENGTH MARK..ETHIOPIC COMBINING GEMINATION MARK
			(0x1712 <= code && code <= 0x1714) || // Mn   [3] TAGALOG VOWEL SIGN I..TAGALOG SIGN VIRAMA
			(0x1732 <= code && code <= 0x1734) || // Mn   [3] HANUNOO VOWEL SIGN I..HANUNOO SIGN PAMUDPOD
			(0x1752 <= code && code <= 0x1753) || // Mn   [2] BUHID VOWEL SIGN I..BUHID VOWEL SIGN U
			(0x1772 <= code && code <= 0x1773) || // Mn   [2] TAGBANWA VOWEL SIGN I..TAGBANWA VOWEL SIGN U
			(0x17B4 <= code && code <= 0x17B5) || // Mn   [2] KHMER VOWEL INHERENT AQ..KHMER VOWEL INHERENT AA
			(0x17B7 <= code && code <= 0x17BD) || // Mn   [7] KHMER VOWEL SIGN I..KHMER VOWEL SIGN UA
			0x17C6 == code || // Mn       KHMER SIGN NIKAHIT
			(0x17C9 <= code && code <= 0x17D3) || // Mn  [11] KHMER SIGN MUUSIKATOAN..KHMER SIGN BATHAMASAT
			0x17DD == code || // Mn       KHMER SIGN ATTHACAN
			(0x180B <= code && code <= 0x180D) || // Mn   [3] MONGOLIAN FREE VARIATION SELECTOR ONE..MONGOLIAN FREE VARIATION SELECTOR THREE
			(0x1885 <= code && code <= 0x1886) || // Mn   [2] MONGOLIAN LETTER ALI GALI BALUDA..MONGOLIAN LETTER ALI GALI THREE BALUDA
			0x18A9 == code || // Mn       MONGOLIAN LETTER ALI GALI DAGALGA
			(0x1920 <= code && code <= 0x1922) || // Mn   [3] LIMBU VOWEL SIGN A..LIMBU VOWEL SIGN U
			(0x1927 <= code && code <= 0x1928) || // Mn   [2] LIMBU VOWEL SIGN E..LIMBU VOWEL SIGN O
			0x1932 == code || // Mn       LIMBU SMALL LETTER ANUSVARA
			(0x1939 <= code && code <= 0x193B) || // Mn   [3] LIMBU SIGN MUKPHRENG..LIMBU SIGN SA-I
			(0x1A17 <= code && code <= 0x1A18) || // Mn   [2] BUGINESE VOWEL SIGN I..BUGINESE VOWEL SIGN U
			0x1A1B == code || // Mn       BUGINESE VOWEL SIGN AE
			0x1A56 == code || // Mn       TAI THAM CONSONANT SIGN MEDIAL LA
			(0x1A58 <= code && code <= 0x1A5E) || // Mn   [7] TAI THAM SIGN MAI KANG LAI..TAI THAM CONSONANT SIGN SA
			0x1A60 == code || // Mn       TAI THAM SIGN SAKOT
			0x1A62 == code || // Mn       TAI THAM VOWEL SIGN MAI SAT
			(0x1A65 <= code && code <= 0x1A6C) || // Mn   [8] TAI THAM VOWEL SIGN I..TAI THAM VOWEL SIGN OA BELOW
			(0x1A73 <= code && code <= 0x1A7C) || // Mn  [10] TAI THAM VOWEL SIGN OA ABOVE..TAI THAM SIGN KHUEN-LUE KARAN
			0x1A7F == code || // Mn       TAI THAM COMBINING CRYPTOGRAMMIC DOT
			(0x1AB0 <= code && code <= 0x1ABD) || // Mn  [14] COMBINING DOUBLED CIRCUMFLEX ACCENT..COMBINING PARENTHESES BELOW
			0x1ABE == code || // Me       COMBINING PARENTHESES OVERLAY
			(0x1B00 <= code && code <= 0x1B03) || // Mn   [4] BALINESE SIGN ULU RICEM..BALINESE SIGN SURANG
			0x1B34 == code || // Mn       BALINESE SIGN REREKAN
			(0x1B36 <= code && code <= 0x1B3A) || // Mn   [5] BALINESE VOWEL SIGN ULU..BALINESE VOWEL SIGN RA REPA
			0x1B3C == code || // Mn       BALINESE VOWEL SIGN LA LENGA
			0x1B42 == code || // Mn       BALINESE VOWEL SIGN PEPET
			(0x1B6B <= code && code <= 0x1B73) || // Mn   [9] BALINESE MUSICAL SYMBOL COMBINING TEGEH..BALINESE MUSICAL SYMBOL COMBINING GONG
			(0x1B80 <= code && code <= 0x1B81) || // Mn   [2] SUNDANESE SIGN PANYECEK..SUNDANESE SIGN PANGLAYAR
			(0x1BA2 <= code && code <= 0x1BA5) || // Mn   [4] SUNDANESE CONSONANT SIGN PANYAKRA..SUNDANESE VOWEL SIGN PANYUKU
			(0x1BA8 <= code && code <= 0x1BA9) || // Mn   [2] SUNDANESE VOWEL SIGN PAMEPET..SUNDANESE VOWEL SIGN PANEULEUNG
			(0x1BAB <= code && code <= 0x1BAD) || // Mn   [3] SUNDANESE SIGN VIRAMA..SUNDANESE CONSONANT SIGN PASANGAN WA
			0x1BE6 == code || // Mn       BATAK SIGN TOMPI
			(0x1BE8 <= code && code <= 0x1BE9) || // Mn   [2] BATAK VOWEL SIGN PAKPAK E..BATAK VOWEL SIGN EE
			0x1BED == code || // Mn       BATAK VOWEL SIGN KARO O
			(0x1BEF <= code && code <= 0x1BF1) || // Mn   [3] BATAK VOWEL SIGN U FOR SIMALUNGUN SA..BATAK CONSONANT SIGN H
			(0x1C2C <= code && code <= 0x1C33) || // Mn   [8] LEPCHA VOWEL SIGN E..LEPCHA CONSONANT SIGN T
			(0x1C36 <= code && code <= 0x1C37) || // Mn   [2] LEPCHA SIGN RAN..LEPCHA SIGN NUKTA
			(0x1CD0 <= code && code <= 0x1CD2) || // Mn   [3] VEDIC TONE KARSHANA..VEDIC TONE PRENKHA
			(0x1CD4 <= code && code <= 0x1CE0) || // Mn  [13] VEDIC SIGN YAJURVEDIC MIDLINE SVARITA..VEDIC TONE RIGVEDIC KASHMIRI INDEPENDENT SVARITA
			(0x1CE2 <= code && code <= 0x1CE8) || // Mn   [7] VEDIC SIGN VISARGA SVARITA..VEDIC SIGN VISARGA ANUDATTA WITH TAIL
			0x1CED == code || // Mn       VEDIC SIGN TIRYAK
			0x1CF4 == code || // Mn       VEDIC TONE CANDRA ABOVE
			(0x1CF8 <= code && code <= 0x1CF9) || // Mn   [2] VEDIC TONE RING ABOVE..VEDIC TONE DOUBLE RING ABOVE
			(0x1DC0 <= code && code <= 0x1DF9) || // Mn  [58] COMBINING DOTTED GRAVE ACCENT..COMBINING WIDE INVERTED BRIDGE BELOW
			(0x1DFB <= code && code <= 0x1DFF) || // Mn   [5] COMBINING DELETION MARK..COMBINING RIGHT ARROWHEAD AND DOWN ARROWHEAD BELOW
			0x200C == code || // Cf       ZERO WIDTH NON-JOINER
			(0x20D0 <= code && code <= 0x20DC) || // Mn  [13] COMBINING LEFT HARPOON ABOVE..COMBINING FOUR DOTS ABOVE
			(0x20DD <= code && code <= 0x20E0) || // Me   [4] COMBINING ENCLOSING CIRCLE..COMBINING ENCLOSING CIRCLE BACKSLASH
			0x20E1 == code || // Mn       COMBINING LEFT RIGHT ARROW ABOVE
			(0x20E2 <= code && code <= 0x20E4) || // Me   [3] COMBINING ENCLOSING SCREEN..COMBINING ENCLOSING UPWARD POINTING TRIANGLE
			(0x20E5 <= code && code <= 0x20F0) || // Mn  [12] COMBINING REVERSE SOLIDUS OVERLAY..COMBINING ASTERISK ABOVE
			(0x2CEF <= code && code <= 0x2CF1) || // Mn   [3] COPTIC COMBINING NI ABOVE..COPTIC COMBINING SPIRITUS LENIS
			0x2D7F == code || // Mn       TIFINAGH CONSONANT JOINER
			(0x2DE0 <= code && code <= 0x2DFF) || // Mn  [32] COMBINING CYRILLIC LETTER BE..COMBINING CYRILLIC LETTER IOTIFIED BIG YUS
			(0x302A <= code && code <= 0x302D) || // Mn   [4] IDEOGRAPHIC LEVEL TONE MARK..IDEOGRAPHIC ENTERING TONE MARK
			(0x302E <= code && code <= 0x302F) || // Mc   [2] HANGUL SINGLE DOT TONE MARK..HANGUL DOUBLE DOT TONE MARK
			(0x3099 <= code && code <= 0x309A) || // Mn   [2] COMBINING KATAKANA-HIRAGANA VOICED SOUND MARK..COMBINING KATAKANA-HIRAGANA SEMI-VOICED SOUND MARK
			0xA66F == code || // Mn       COMBINING CYRILLIC VZMET
			(0xA670 <= code && code <= 0xA672) || // Me   [3] COMBINING CYRILLIC TEN MILLIONS SIGN..COMBINING CYRILLIC THOUSAND MILLIONS SIGN
			(0xA674 <= code && code <= 0xA67D) || // Mn  [10] COMBINING CYRILLIC LETTER UKRAINIAN IE..COMBINING CYRILLIC PAYEROK
			(0xA69E <= code && code <= 0xA69F) || // Mn   [2] COMBINING CYRILLIC LETTER EF..COMBINING CYRILLIC LETTER IOTIFIED E
			(0xA6F0 <= code && code <= 0xA6F1) || // Mn   [2] BAMUM COMBINING MARK KOQNDON..BAMUM COMBINING MARK TUKWENTIS
			0xA802 == code || // Mn       SYLOTI NAGRI SIGN DVISVARA
			0xA806 == code || // Mn       SYLOTI NAGRI SIGN HASANTA
			0xA80B == code || // Mn       SYLOTI NAGRI SIGN ANUSVARA
			(0xA825 <= code && code <= 0xA826) || // Mn   [2] SYLOTI NAGRI VOWEL SIGN U..SYLOTI NAGRI VOWEL SIGN E
			(0xA8C4 <= code && code <= 0xA8C5) || // Mn   [2] SAURASHTRA SIGN VIRAMA..SAURASHTRA SIGN CANDRABINDU
			(0xA8E0 <= code && code <= 0xA8F1) || // Mn  [18] COMBINING DEVANAGARI DIGIT ZERO..COMBINING DEVANAGARI SIGN AVAGRAHA
			(0xA926 <= code && code <= 0xA92D) || // Mn   [8] KAYAH LI VOWEL UE..KAYAH LI TONE CALYA PLOPHU
			(0xA947 <= code && code <= 0xA951) || // Mn  [11] REJANG VOWEL SIGN I..REJANG CONSONANT SIGN R
			(0xA980 <= code && code <= 0xA982) || // Mn   [3] JAVANESE SIGN PANYANGGA..JAVANESE SIGN LAYAR
			0xA9B3 == code || // Mn       JAVANESE SIGN CECAK TELU
			(0xA9B6 <= code && code <= 0xA9B9) || // Mn   [4] JAVANESE VOWEL SIGN WULU..JAVANESE VOWEL SIGN SUKU MENDUT
			0xA9BC == code || // Mn       JAVANESE VOWEL SIGN PEPET
			0xA9E5 == code || // Mn       MYANMAR SIGN SHAN SAW
			(0xAA29 <= code && code <= 0xAA2E) || // Mn   [6] CHAM VOWEL SIGN AA..CHAM VOWEL SIGN OE
			(0xAA31 <= code && code <= 0xAA32) || // Mn   [2] CHAM VOWEL SIGN AU..CHAM VOWEL SIGN UE
			(0xAA35 <= code && code <= 0xAA36) || // Mn   [2] CHAM CONSONANT SIGN LA..CHAM CONSONANT SIGN WA
			0xAA43 == code || // Mn       CHAM CONSONANT SIGN FINAL NG
			0xAA4C == code || // Mn       CHAM CONSONANT SIGN FINAL M
			0xAA7C == code || // Mn       MYANMAR SIGN TAI LAING TONE-2
			0xAAB0 == code || // Mn       TAI VIET MAI KANG
			(0xAAB2 <= code && code <= 0xAAB4) || // Mn   [3] TAI VIET VOWEL I..TAI VIET VOWEL U
			(0xAAB7 <= code && code <= 0xAAB8) || // Mn   [2] TAI VIET MAI KHIT..TAI VIET VOWEL IA
			(0xAABE <= code && code <= 0xAABF) || // Mn   [2] TAI VIET VOWEL AM..TAI VIET TONE MAI EK
			0xAAC1 == code || // Mn       TAI VIET TONE MAI THO
			(0xAAEC <= code && code <= 0xAAED) || // Mn   [2] MEETEI MAYEK VOWEL SIGN UU..MEETEI MAYEK VOWEL SIGN AAI
			0xAAF6 == code || // Mn       MEETEI MAYEK VIRAMA
			0xABE5 == code || // Mn       MEETEI MAYEK VOWEL SIGN ANAP
			0xABE8 == code || // Mn       MEETEI MAYEK VOWEL SIGN UNAP
			0xABED == code || // Mn       MEETEI MAYEK APUN IYEK
			0xFB1E == code || // Mn       HEBREW POINT JUDEO-SPANISH VARIKA
			(0xFE00 <= code && code <= 0xFE0F) || // Mn  [16] VARIATION SELECTOR-1..VARIATION SELECTOR-16
			(0xFE20 <= code && code <= 0xFE2F) || // Mn  [16] COMBINING LIGATURE LEFT HALF..COMBINING CYRILLIC TITLO RIGHT HALF
			(0xFF9E <= code && code <= 0xFF9F) || // Lm   [2] HALFWIDTH KATAKANA VOICED SOUND MARK..HALFWIDTH KATAKANA SEMI-VOICED SOUND MARK
			0x101FD == code || // Mn       PHAISTOS DISC SIGN COMBINING OBLIQUE STROKE
			0x102E0 == code || // Mn       COPTIC EPACT THOUSANDS MARK
			(0x10376 <= code && code <= 0x1037A) || // Mn   [5] COMBINING OLD PERMIC LETTER AN..COMBINING OLD PERMIC LETTER SII
			(0x10A01 <= code && code <= 0x10A03) || // Mn   [3] KHAROSHTHI VOWEL SIGN I..KHAROSHTHI VOWEL SIGN VOCALIC R
			(0x10A05 <= code && code <= 0x10A06) || // Mn   [2] KHAROSHTHI VOWEL SIGN E..KHAROSHTHI VOWEL SIGN O
			(0x10A0C <= code && code <= 0x10A0F) || // Mn   [4] KHAROSHTHI VOWEL LENGTH MARK..KHAROSHTHI SIGN VISARGA
			(0x10A38 <= code && code <= 0x10A3A) || // Mn   [3] KHAROSHTHI SIGN BAR ABOVE..KHAROSHTHI SIGN DOT BELOW
			0x10A3F == code || // Mn       KHAROSHTHI VIRAMA
			(0x10AE5 <= code && code <= 0x10AE6) || // Mn   [2] MANICHAEAN ABBREVIATION MARK ABOVE..MANICHAEAN ABBREVIATION MARK BELOW
			0x11001 == code || // Mn       BRAHMI SIGN ANUSVARA
			(0x11038 <= code && code <= 0x11046) || // Mn  [15] BRAHMI VOWEL SIGN AA..BRAHMI VIRAMA
			(0x1107F <= code && code <= 0x11081) || // Mn   [3] BRAHMI NUMBER JOINER..KAITHI SIGN ANUSVARA
			(0x110B3 <= code && code <= 0x110B6) || // Mn   [4] KAITHI VOWEL SIGN U..KAITHI VOWEL SIGN AI
			(0x110B9 <= code && code <= 0x110BA) || // Mn   [2] KAITHI SIGN VIRAMA..KAITHI SIGN NUKTA
			(0x11100 <= code && code <= 0x11102) || // Mn   [3] CHAKMA SIGN CANDRABINDU..CHAKMA SIGN VISARGA
			(0x11127 <= code && code <= 0x1112B) || // Mn   [5] CHAKMA VOWEL SIGN A..CHAKMA VOWEL SIGN UU
			(0x1112D <= code && code <= 0x11134) || // Mn   [8] CHAKMA VOWEL SIGN AI..CHAKMA MAAYYAA
			0x11173 == code || // Mn       MAHAJANI SIGN NUKTA
			(0x11180 <= code && code <= 0x11181) || // Mn   [2] SHARADA SIGN CANDRABINDU..SHARADA SIGN ANUSVARA
			(0x111B6 <= code && code <= 0x111BE) || // Mn   [9] SHARADA VOWEL SIGN U..SHARADA VOWEL SIGN O
			(0x111CA <= code && code <= 0x111CC) || // Mn   [3] SHARADA SIGN NUKTA..SHARADA EXTRA SHORT VOWEL MARK
			(0x1122F <= code && code <= 0x11231) || // Mn   [3] KHOJKI VOWEL SIGN U..KHOJKI VOWEL SIGN AI
			0x11234 == code || // Mn       KHOJKI SIGN ANUSVARA
			(0x11236 <= code && code <= 0x11237) || // Mn   [2] KHOJKI SIGN NUKTA..KHOJKI SIGN SHADDA
			0x1123E == code || // Mn       KHOJKI SIGN SUKUN
			0x112DF == code || // Mn       KHUDAWADI SIGN ANUSVARA
			(0x112E3 <= code && code <= 0x112EA) || // Mn   [8] KHUDAWADI VOWEL SIGN U..KHUDAWADI SIGN VIRAMA
			(0x11300 <= code && code <= 0x11301) || // Mn   [2] GRANTHA SIGN COMBINING ANUSVARA ABOVE..GRANTHA SIGN CANDRABINDU
			0x1133C == code || // Mn       GRANTHA SIGN NUKTA
			0x1133E == code || // Mc       GRANTHA VOWEL SIGN AA
			0x11340 == code || // Mn       GRANTHA VOWEL SIGN II
			0x11357 == code || // Mc       GRANTHA AU LENGTH MARK
			(0x11366 <= code && code <= 0x1136C) || // Mn   [7] COMBINING GRANTHA DIGIT ZERO..COMBINING GRANTHA DIGIT SIX
			(0x11370 <= code && code <= 0x11374) || // Mn   [5] COMBINING GRANTHA LETTER A..COMBINING GRANTHA LETTER PA
			(0x11438 <= code && code <= 0x1143F) || // Mn   [8] NEWA VOWEL SIGN U..NEWA VOWEL SIGN AI
			(0x11442 <= code && code <= 0x11444) || // Mn   [3] NEWA SIGN VIRAMA..NEWA SIGN ANUSVARA
			0x11446 == code || // Mn       NEWA SIGN NUKTA
			0x114B0 == code || // Mc       TIRHUTA VOWEL SIGN AA
			(0x114B3 <= code && code <= 0x114B8) || // Mn   [6] TIRHUTA VOWEL SIGN U..TIRHUTA VOWEL SIGN VOCALIC LL
			0x114BA == code || // Mn       TIRHUTA VOWEL SIGN SHORT E
			0x114BD == code || // Mc       TIRHUTA VOWEL SIGN SHORT O
			(0x114BF <= code && code <= 0x114C0) || // Mn   [2] TIRHUTA SIGN CANDRABINDU..TIRHUTA SIGN ANUSVARA
			(0x114C2 <= code && code <= 0x114C3) || // Mn   [2] TIRHUTA SIGN VIRAMA..TIRHUTA SIGN NUKTA
			0x115AF == code || // Mc       SIDDHAM VOWEL SIGN AA
			(0x115B2 <= code && code <= 0x115B5) || // Mn   [4] SIDDHAM VOWEL SIGN U..SIDDHAM VOWEL SIGN VOCALIC RR
			(0x115BC <= code && code <= 0x115BD) || // Mn   [2] SIDDHAM SIGN CANDRABINDU..SIDDHAM SIGN ANUSVARA
			(0x115BF <= code && code <= 0x115C0) || // Mn   [2] SIDDHAM SIGN VIRAMA..SIDDHAM SIGN NUKTA
			(0x115DC <= code && code <= 0x115DD) || // Mn   [2] SIDDHAM VOWEL SIGN ALTERNATE U..SIDDHAM VOWEL SIGN ALTERNATE UU
			(0x11633 <= code && code <= 0x1163A) || // Mn   [8] MODI VOWEL SIGN U..MODI VOWEL SIGN AI
			0x1163D == code || // Mn       MODI SIGN ANUSVARA
			(0x1163F <= code && code <= 0x11640) || // Mn   [2] MODI SIGN VIRAMA..MODI SIGN ARDHACANDRA
			0x116AB == code || // Mn       TAKRI SIGN ANUSVARA
			0x116AD == code || // Mn       TAKRI VOWEL SIGN AA
			(0x116B0 <= code && code <= 0x116B5) || // Mn   [6] TAKRI VOWEL SIGN U..TAKRI VOWEL SIGN AU
			0x116B7 == code || // Mn       TAKRI SIGN NUKTA
			(0x1171D <= code && code <= 0x1171F) || // Mn   [3] AHOM CONSONANT SIGN MEDIAL LA..AHOM CONSONANT SIGN MEDIAL LIGATING RA
			(0x11722 <= code && code <= 0x11725) || // Mn   [4] AHOM VOWEL SIGN I..AHOM VOWEL SIGN UU
			(0x11727 <= code && code <= 0x1172B) || // Mn   [5] AHOM VOWEL SIGN AW..AHOM SIGN KILLER
			(0x11A01 <= code && code <= 0x11A06) || // Mn   [6] ZANABAZAR SQUARE VOWEL SIGN I..ZANABAZAR SQUARE VOWEL SIGN O
			(0x11A09 <= code && code <= 0x11A0A) || // Mn   [2] ZANABAZAR SQUARE VOWEL SIGN REVERSED I..ZANABAZAR SQUARE VOWEL LENGTH MARK
			(0x11A33 <= code && code <= 0x11A38) || // Mn   [6] ZANABAZAR SQUARE FINAL CONSONANT MARK..ZANABAZAR SQUARE SIGN ANUSVARA
			(0x11A3B <= code && code <= 0x11A3E) || // Mn   [4] ZANABAZAR SQUARE CLUSTER-FINAL LETTER YA..ZANABAZAR SQUARE CLUSTER-FINAL LETTER VA
			0x11A47 == code || // Mn       ZANABAZAR SQUARE SUBJOINER
			(0x11A51 <= code && code <= 0x11A56) || // Mn   [6] SOYOMBO VOWEL SIGN I..SOYOMBO VOWEL SIGN OE
			(0x11A59 <= code && code <= 0x11A5B) || // Mn   [3] SOYOMBO VOWEL SIGN VOCALIC R..SOYOMBO VOWEL LENGTH MARK
			(0x11A8A <= code && code <= 0x11A96) || // Mn  [13] SOYOMBO FINAL CONSONANT SIGN G..SOYOMBO SIGN ANUSVARA
			(0x11A98 <= code && code <= 0x11A99) || // Mn   [2] SOYOMBO GEMINATION MARK..SOYOMBO SUBJOINER
			(0x11C30 <= code && code <= 0x11C36) || // Mn   [7] BHAIKSUKI VOWEL SIGN I..BHAIKSUKI VOWEL SIGN VOCALIC L
			(0x11C38 <= code && code <= 0x11C3D) || // Mn   [6] BHAIKSUKI VOWEL SIGN E..BHAIKSUKI SIGN ANUSVARA
			0x11C3F == code || // Mn       BHAIKSUKI SIGN VIRAMA
			(0x11C92 <= code && code <= 0x11CA7) || // Mn  [22] MARCHEN SUBJOINED LETTER KA..MARCHEN SUBJOINED LETTER ZA
			(0x11CAA <= code && code <= 0x11CB0) || // Mn   [7] MARCHEN SUBJOINED LETTER RA..MARCHEN VOWEL SIGN AA
			(0x11CB2 <= code && code <= 0x11CB3) || // Mn   [2] MARCHEN VOWEL SIGN U..MARCHEN VOWEL SIGN E
			(0x11CB5 <= code && code <= 0x11CB6) || // Mn   [2] MARCHEN SIGN ANUSVARA..MARCHEN SIGN CANDRABINDU
			(0x11D31 <= code && code <= 0x11D36) || // Mn   [6] MASARAM GONDI VOWEL SIGN AA..MASARAM GONDI VOWEL SIGN VOCALIC R
			0x11D3A == code || // Mn       MASARAM GONDI VOWEL SIGN E
			(0x11D3C <= code && code <= 0x11D3D) || // Mn   [2] MASARAM GONDI VOWEL SIGN AI..MASARAM GONDI VOWEL SIGN O
			(0x11D3F <= code && code <= 0x11D45) || // Mn   [7] MASARAM GONDI VOWEL SIGN AU..MASARAM GONDI VIRAMA
			0x11D47 == code || // Mn       MASARAM GONDI RA-KARA
			(0x16AF0 <= code && code <= 0x16AF4) || // Mn   [5] BASSA VAH COMBINING HIGH TONE..BASSA VAH COMBINING HIGH-LOW TONE
			(0x16B30 <= code && code <= 0x16B36) || // Mn   [7] PAHAWH HMONG MARK CIM TUB..PAHAWH HMONG MARK CIM TAUM
			(0x16F8F <= code && code <= 0x16F92) || // Mn   [4] MIAO TONE RIGHT..MIAO TONE BELOW
			(0x1BC9D <= code && code <= 0x1BC9E) || // Mn   [2] DUPLOYAN THICK LETTER SELECTOR..DUPLOYAN DOUBLE MARK
			0x1D165 == code || // Mc       MUSICAL SYMBOL COMBINING STEM
			(0x1D167 <= code && code <= 0x1D169) || // Mn   [3] MUSICAL SYMBOL COMBINING TREMOLO-1..MUSICAL SYMBOL COMBINING TREMOLO-3
			(0x1D16E <= code && code <= 0x1D172) || // Mc   [5] MUSICAL SYMBOL COMBINING FLAG-1..MUSICAL SYMBOL COMBINING FLAG-5
			(0x1D17B <= code && code <= 0x1D182) || // Mn   [8] MUSICAL SYMBOL COMBINING ACCENT..MUSICAL SYMBOL COMBINING LOURE
			(0x1D185 <= code && code <= 0x1D18B) || // Mn   [7] MUSICAL SYMBOL COMBINING DOIT..MUSICAL SYMBOL COMBINING TRIPLE TONGUE
			(0x1D1AA <= code && code <= 0x1D1AD) || // Mn   [4] MUSICAL SYMBOL COMBINING DOWN BOW..MUSICAL SYMBOL COMBINING SNAP PIZZICATO
			(0x1D242 <= code && code <= 0x1D244) || // Mn   [3] COMBINING GREEK MUSICAL TRISEME..COMBINING GREEK MUSICAL PENTASEME
			(0x1DA00 <= code && code <= 0x1DA36) || // Mn  [55] SIGNWRITING HEAD RIM..SIGNWRITING AIR SUCKING IN
			(0x1DA3B <= code && code <= 0x1DA6C) || // Mn  [50] SIGNWRITING MOUTH CLOSED NEUTRAL..SIGNWRITING EXCITEMENT
			0x1DA75 == code || // Mn       SIGNWRITING UPPER BODY TILTING FROM HIP JOINTS
			0x1DA84 == code || // Mn       SIGNWRITING LOCATION HEAD NECK
			(0x1DA9B <= code && code <= 0x1DA9F) || // Mn   [5] SIGNWRITING FILL MODIFIER-2..SIGNWRITING FILL MODIFIER-6
			(0x1DAA1 <= code && code <= 0x1DAAF) || // Mn  [15] SIGNWRITING ROTATION MODIFIER-2..SIGNWRITING ROTATION MODIFIER-16
			(0x1E000 <= code && code <= 0x1E006) || // Mn   [7] COMBINING GLAGOLITIC LETTER AZU..COMBINING GLAGOLITIC LETTER ZHIVETE
			(0x1E008 <= code && code <= 0x1E018) || // Mn  [17] COMBINING GLAGOLITIC LETTER ZEMLJA..COMBINING GLAGOLITIC LETTER HERU
			(0x1E01B <= code && code <= 0x1E021) || // Mn   [7] COMBINING GLAGOLITIC LETTER SHTA..COMBINING GLAGOLITIC LETTER YATI
			(0x1E023 <= code && code <= 0x1E024) || // Mn   [2] COMBINING GLAGOLITIC LETTER YU..COMBINING GLAGOLITIC LETTER SMALL YUS
			(0x1E026 <= code && code <= 0x1E02A) || // Mn   [5] COMBINING GLAGOLITIC LETTER YO..COMBINING GLAGOLITIC LETTER FITA
			(0x1E8D0 <= code && code <= 0x1E8D6) || // Mn   [7] MENDE KIKAKUI COMBINING NUMBER TEENS..MENDE KIKAKUI COMBINING NUMBER MILLIONS
			(0x1E944 <= code && code <= 0x1E94A) || // Mn   [7] ADLAM ALIF LENGTHENER..ADLAM NUKTA
			(0xE0020 <= code && code <= 0xE007F) || // Cf  [96] TAG SPACE..CANCEL TAG
			(0xE0100 <= code && code <= 0xE01EF) // Mn [240] VARIATION SELECTOR-17..VARIATION SELECTOR-256
			){
				return Extend;
			}
			
			
			if(
			(0x1F1E6 <= code && code <= 0x1F1FF) // So  [26] REGIONAL INDICATOR SYMBOL LETTER A..REGIONAL INDICATOR SYMBOL LETTER Z
			){
				return Regional_Indicator;
			}
			
			if(
			0x0903 == code || // Mc       DEVANAGARI SIGN VISARGA
			0x093B == code || // Mc       DEVANAGARI VOWEL SIGN OOE
			(0x093E <= code && code <= 0x0940) || // Mc   [3] DEVANAGARI VOWEL SIGN AA..DEVANAGARI VOWEL SIGN II
			(0x0949 <= code && code <= 0x094C) || // Mc   [4] DEVANAGARI VOWEL SIGN CANDRA O..DEVANAGARI VOWEL SIGN AU
			(0x094E <= code && code <= 0x094F) || // Mc   [2] DEVANAGARI VOWEL SIGN PRISHTHAMATRA E..DEVANAGARI VOWEL SIGN AW
			(0x0982 <= code && code <= 0x0983) || // Mc   [2] BENGALI SIGN ANUSVARA..BENGALI SIGN VISARGA
			(0x09BF <= code && code <= 0x09C0) || // Mc   [2] BENGALI VOWEL SIGN I..BENGALI VOWEL SIGN II
			(0x09C7 <= code && code <= 0x09C8) || // Mc   [2] BENGALI VOWEL SIGN E..BENGALI VOWEL SIGN AI
			(0x09CB <= code && code <= 0x09CC) || // Mc   [2] BENGALI VOWEL SIGN O..BENGALI VOWEL SIGN AU
			0x0A03 == code || // Mc       GURMUKHI SIGN VISARGA
			(0x0A3E <= code && code <= 0x0A40) || // Mc   [3] GURMUKHI VOWEL SIGN AA..GURMUKHI VOWEL SIGN II
			0x0A83 == code || // Mc       GUJARATI SIGN VISARGA
			(0x0ABE <= code && code <= 0x0AC0) || // Mc   [3] GUJARATI VOWEL SIGN AA..GUJARATI VOWEL SIGN II
			0x0AC9 == code || // Mc       GUJARATI VOWEL SIGN CANDRA O
			(0x0ACB <= code && code <= 0x0ACC) || // Mc   [2] GUJARATI VOWEL SIGN O..GUJARATI VOWEL SIGN AU
			(0x0B02 <= code && code <= 0x0B03) || // Mc   [2] ORIYA SIGN ANUSVARA..ORIYA SIGN VISARGA
			0x0B40 == code || // Mc       ORIYA VOWEL SIGN II
			(0x0B47 <= code && code <= 0x0B48) || // Mc   [2] ORIYA VOWEL SIGN E..ORIYA VOWEL SIGN AI
			(0x0B4B <= code && code <= 0x0B4C) || // Mc   [2] ORIYA VOWEL SIGN O..ORIYA VOWEL SIGN AU
			0x0BBF == code || // Mc       TAMIL VOWEL SIGN I
			(0x0BC1 <= code && code <= 0x0BC2) || // Mc   [2] TAMIL VOWEL SIGN U..TAMIL VOWEL SIGN UU
			(0x0BC6 <= code && code <= 0x0BC8) || // Mc   [3] TAMIL VOWEL SIGN E..TAMIL VOWEL SIGN AI
			(0x0BCA <= code && code <= 0x0BCC) || // Mc   [3] TAMIL VOWEL SIGN O..TAMIL VOWEL SIGN AU
			(0x0C01 <= code && code <= 0x0C03) || // Mc   [3] TELUGU SIGN CANDRABINDU..TELUGU SIGN VISARGA
			(0x0C41 <= code && code <= 0x0C44) || // Mc   [4] TELUGU VOWEL SIGN U..TELUGU VOWEL SIGN VOCALIC RR
			(0x0C82 <= code && code <= 0x0C83) || // Mc   [2] KANNADA SIGN ANUSVARA..KANNADA SIGN VISARGA
			0x0CBE == code || // Mc       KANNADA VOWEL SIGN AA
			(0x0CC0 <= code && code <= 0x0CC1) || // Mc   [2] KANNADA VOWEL SIGN II..KANNADA VOWEL SIGN U
			(0x0CC3 <= code && code <= 0x0CC4) || // Mc   [2] KANNADA VOWEL SIGN VOCALIC R..KANNADA VOWEL SIGN VOCALIC RR
			(0x0CC7 <= code && code <= 0x0CC8) || // Mc   [2] KANNADA VOWEL SIGN EE..KANNADA VOWEL SIGN AI
			(0x0CCA <= code && code <= 0x0CCB) || // Mc   [2] KANNADA VOWEL SIGN O..KANNADA VOWEL SIGN OO
			(0x0D02 <= code && code <= 0x0D03) || // Mc   [2] MALAYALAM SIGN ANUSVARA..MALAYALAM SIGN VISARGA
			(0x0D3F <= code && code <= 0x0D40) || // Mc   [2] MALAYALAM VOWEL SIGN I..MALAYALAM VOWEL SIGN II
			(0x0D46 <= code && code <= 0x0D48) || // Mc   [3] MALAYALAM VOWEL SIGN E..MALAYALAM VOWEL SIGN AI
			(0x0D4A <= code && code <= 0x0D4C) || // Mc   [3] MALAYALAM VOWEL SIGN O..MALAYALAM VOWEL SIGN AU
			(0x0D82 <= code && code <= 0x0D83) || // Mc   [2] SINHALA SIGN ANUSVARAYA..SINHALA SIGN VISARGAYA
			(0x0DD0 <= code && code <= 0x0DD1) || // Mc   [2] SINHALA VOWEL SIGN KETTI AEDA-PILLA..SINHALA VOWEL SIGN DIGA AEDA-PILLA
			(0x0DD8 <= code && code <= 0x0DDE) || // Mc   [7] SINHALA VOWEL SIGN GAETTA-PILLA..SINHALA VOWEL SIGN KOMBUVA HAA GAYANUKITTA
			(0x0DF2 <= code && code <= 0x0DF3) || // Mc   [2] SINHALA VOWEL SIGN DIGA GAETTA-PILLA..SINHALA VOWEL SIGN DIGA GAYANUKITTA
			0x0E33 == code || // Lo       THAI CHARACTER SARA AM
			0x0EB3 == code || // Lo       LAO VOWEL SIGN AM
			(0x0F3E <= code && code <= 0x0F3F) || // Mc   [2] TIBETAN SIGN YAR TSHES..TIBETAN SIGN MAR TSHES
			0x0F7F == code || // Mc       TIBETAN SIGN RNAM BCAD
			0x1031 == code || // Mc       MYANMAR VOWEL SIGN E
			(0x103B <= code && code <= 0x103C) || // Mc   [2] MYANMAR CONSONANT SIGN MEDIAL YA..MYANMAR CONSONANT SIGN MEDIAL RA
			(0x1056 <= code && code <= 0x1057) || // Mc   [2] MYANMAR VOWEL SIGN VOCALIC R..MYANMAR VOWEL SIGN VOCALIC RR
			0x1084 == code || // Mc       MYANMAR VOWEL SIGN SHAN E
			0x17B6 == code || // Mc       KHMER VOWEL SIGN AA
			(0x17BE <= code && code <= 0x17C5) || // Mc   [8] KHMER VOWEL SIGN OE..KHMER VOWEL SIGN AU
			(0x17C7 <= code && code <= 0x17C8) || // Mc   [2] KHMER SIGN REAHMUK..KHMER SIGN YUUKALEAPINTU
			(0x1923 <= code && code <= 0x1926) || // Mc   [4] LIMBU VOWEL SIGN EE..LIMBU VOWEL SIGN AU
			(0x1929 <= code && code <= 0x192B) || // Mc   [3] LIMBU SUBJOINED LETTER YA..LIMBU SUBJOINED LETTER WA
			(0x1930 <= code && code <= 0x1931) || // Mc   [2] LIMBU SMALL LETTER KA..LIMBU SMALL LETTER NGA
			(0x1933 <= code && code <= 0x1938) || // Mc   [6] LIMBU SMALL LETTER TA..LIMBU SMALL LETTER LA
			(0x1A19 <= code && code <= 0x1A1A) || // Mc   [2] BUGINESE VOWEL SIGN E..BUGINESE VOWEL SIGN O
			0x1A55 == code || // Mc       TAI THAM CONSONANT SIGN MEDIAL RA
			0x1A57 == code || // Mc       TAI THAM CONSONANT SIGN LA TANG LAI
			(0x1A6D <= code && code <= 0x1A72) || // Mc   [6] TAI THAM VOWEL SIGN OY..TAI THAM VOWEL SIGN THAM AI
			0x1B04 == code || // Mc       BALINESE SIGN BISAH
			0x1B35 == code || // Mc       BALINESE VOWEL SIGN TEDUNG
			0x1B3B == code || // Mc       BALINESE VOWEL SIGN RA REPA TEDUNG
			(0x1B3D <= code && code <= 0x1B41) || // Mc   [5] BALINESE VOWEL SIGN LA LENGA TEDUNG..BALINESE VOWEL SIGN TALING REPA TEDUNG
			(0x1B43 <= code && code <= 0x1B44) || // Mc   [2] BALINESE VOWEL SIGN PEPET TEDUNG..BALINESE ADEG ADEG
			0x1B82 == code || // Mc       SUNDANESE SIGN PANGWISAD
			0x1BA1 == code || // Mc       SUNDANESE CONSONANT SIGN PAMINGKAL
			(0x1BA6 <= code && code <= 0x1BA7) || // Mc   [2] SUNDANESE VOWEL SIGN PANAELAENG..SUNDANESE VOWEL SIGN PANOLONG
			0x1BAA == code || // Mc       SUNDANESE SIGN PAMAAEH
			0x1BE7 == code || // Mc       BATAK VOWEL SIGN E
			(0x1BEA <= code && code <= 0x1BEC) || // Mc   [3] BATAK VOWEL SIGN I..BATAK VOWEL SIGN O
			0x1BEE == code || // Mc       BATAK VOWEL SIGN U
			(0x1BF2 <= code && code <= 0x1BF3) || // Mc   [2] BATAK PANGOLAT..BATAK PANONGONAN
			(0x1C24 <= code && code <= 0x1C2B) || // Mc   [8] LEPCHA SUBJOINED LETTER YA..LEPCHA VOWEL SIGN UU
			(0x1C34 <= code && code <= 0x1C35) || // Mc   [2] LEPCHA CONSONANT SIGN NYIN-DO..LEPCHA CONSONANT SIGN KANG
			0x1CE1 == code || // Mc       VEDIC TONE ATHARVAVEDIC INDEPENDENT SVARITA
			(0x1CF2 <= code && code <= 0x1CF3) || // Mc   [2] VEDIC SIGN ARDHAVISARGA..VEDIC SIGN ROTATED ARDHAVISARGA
			0x1CF7 == code || // Mc       VEDIC SIGN ATIKRAMA
			(0xA823 <= code && code <= 0xA824) || // Mc   [2] SYLOTI NAGRI VOWEL SIGN A..SYLOTI NAGRI VOWEL SIGN I
			0xA827 == code || // Mc       SYLOTI NAGRI VOWEL SIGN OO
			(0xA880 <= code && code <= 0xA881) || // Mc   [2] SAURASHTRA SIGN ANUSVARA..SAURASHTRA SIGN VISARGA
			(0xA8B4 <= code && code <= 0xA8C3) || // Mc  [16] SAURASHTRA CONSONANT SIGN HAARU..SAURASHTRA VOWEL SIGN AU
			(0xA952 <= code && code <= 0xA953) || // Mc   [2] REJANG CONSONANT SIGN H..REJANG VIRAMA
			0xA983 == code || // Mc       JAVANESE SIGN WIGNYAN
			(0xA9B4 <= code && code <= 0xA9B5) || // Mc   [2] JAVANESE VOWEL SIGN TARUNG..JAVANESE VOWEL SIGN TOLONG
			(0xA9BA <= code && code <= 0xA9BB) || // Mc   [2] JAVANESE VOWEL SIGN TALING..JAVANESE VOWEL SIGN DIRGA MURE
			(0xA9BD <= code && code <= 0xA9C0) || // Mc   [4] JAVANESE CONSONANT SIGN KERET..JAVANESE PANGKON
			(0xAA2F <= code && code <= 0xAA30) || // Mc   [2] CHAM VOWEL SIGN O..CHAM VOWEL SIGN AI
			(0xAA33 <= code && code <= 0xAA34) || // Mc   [2] CHAM CONSONANT SIGN YA..CHAM CONSONANT SIGN RA
			0xAA4D == code || // Mc       CHAM CONSONANT SIGN FINAL H
			0xAAEB == code || // Mc       MEETEI MAYEK VOWEL SIGN II
			(0xAAEE <= code && code <= 0xAAEF) || // Mc   [2] MEETEI MAYEK VOWEL SIGN AU..MEETEI MAYEK VOWEL SIGN AAU
			0xAAF5 == code || // Mc       MEETEI MAYEK VOWEL SIGN VISARGA
			(0xABE3 <= code && code <= 0xABE4) || // Mc   [2] MEETEI MAYEK VOWEL SIGN ONAP..MEETEI MAYEK VOWEL SIGN INAP
			(0xABE6 <= code && code <= 0xABE7) || // Mc   [2] MEETEI MAYEK VOWEL SIGN YENAP..MEETEI MAYEK VOWEL SIGN SOUNAP
			(0xABE9 <= code && code <= 0xABEA) || // Mc   [2] MEETEI MAYEK VOWEL SIGN CHEINAP..MEETEI MAYEK VOWEL SIGN NUNG
			0xABEC == code || // Mc       MEETEI MAYEK LUM IYEK
			0x11000 == code || // Mc       BRAHMI SIGN CANDRABINDU
			0x11002 == code || // Mc       BRAHMI SIGN VISARGA
			0x11082 == code || // Mc       KAITHI SIGN VISARGA
			(0x110B0 <= code && code <= 0x110B2) || // Mc   [3] KAITHI VOWEL SIGN AA..KAITHI VOWEL SIGN II
			(0x110B7 <= code && code <= 0x110B8) || // Mc   [2] KAITHI VOWEL SIGN O..KAITHI VOWEL SIGN AU
			0x1112C == code || // Mc       CHAKMA VOWEL SIGN E
			0x11182 == code || // Mc       SHARADA SIGN VISARGA
			(0x111B3 <= code && code <= 0x111B5) || // Mc   [3] SHARADA VOWEL SIGN AA..SHARADA VOWEL SIGN II
			(0x111BF <= code && code <= 0x111C0) || // Mc   [2] SHARADA VOWEL SIGN AU..SHARADA SIGN VIRAMA
			(0x1122C <= code && code <= 0x1122E) || // Mc   [3] KHOJKI VOWEL SIGN AA..KHOJKI VOWEL SIGN II
			(0x11232 <= code && code <= 0x11233) || // Mc   [2] KHOJKI VOWEL SIGN O..KHOJKI VOWEL SIGN AU
			0x11235 == code || // Mc       KHOJKI SIGN VIRAMA
			(0x112E0 <= code && code <= 0x112E2) || // Mc   [3] KHUDAWADI VOWEL SIGN AA..KHUDAWADI VOWEL SIGN II
			(0x11302 <= code && code <= 0x11303) || // Mc   [2] GRANTHA SIGN ANUSVARA..GRANTHA SIGN VISARGA
			0x1133F == code || // Mc       GRANTHA VOWEL SIGN I
			(0x11341 <= code && code <= 0x11344) || // Mc   [4] GRANTHA VOWEL SIGN U..GRANTHA VOWEL SIGN VOCALIC RR
			(0x11347 <= code && code <= 0x11348) || // Mc   [2] GRANTHA VOWEL SIGN EE..GRANTHA VOWEL SIGN AI
			(0x1134B <= code && code <= 0x1134D) || // Mc   [3] GRANTHA VOWEL SIGN OO..GRANTHA SIGN VIRAMA
			(0x11362 <= code && code <= 0x11363) || // Mc   [2] GRANTHA VOWEL SIGN VOCALIC L..GRANTHA VOWEL SIGN VOCALIC LL
			(0x11435 <= code && code <= 0x11437) || // Mc   [3] NEWA VOWEL SIGN AA..NEWA VOWEL SIGN II
			(0x11440 <= code && code <= 0x11441) || // Mc   [2] NEWA VOWEL SIGN O..NEWA VOWEL SIGN AU
			0x11445 == code || // Mc       NEWA SIGN VISARGA
			(0x114B1 <= code && code <= 0x114B2) || // Mc   [2] TIRHUTA VOWEL SIGN I..TIRHUTA VOWEL SIGN II
			0x114B9 == code || // Mc       TIRHUTA VOWEL SIGN E
			(0x114BB <= code && code <= 0x114BC) || // Mc   [2] TIRHUTA VOWEL SIGN AI..TIRHUTA VOWEL SIGN O
			0x114BE == code || // Mc       TIRHUTA VOWEL SIGN AU
			0x114C1 == code || // Mc       TIRHUTA SIGN VISARGA
			(0x115B0 <= code && code <= 0x115B1) || // Mc   [2] SIDDHAM VOWEL SIGN I..SIDDHAM VOWEL SIGN II
			(0x115B8 <= code && code <= 0x115BB) || // Mc   [4] SIDDHAM VOWEL SIGN E..SIDDHAM VOWEL SIGN AU
			0x115BE == code || // Mc       SIDDHAM SIGN VISARGA
			(0x11630 <= code && code <= 0x11632) || // Mc   [3] MODI VOWEL SIGN AA..MODI VOWEL SIGN II
			(0x1163B <= code && code <= 0x1163C) || // Mc   [2] MODI VOWEL SIGN O..MODI VOWEL SIGN AU
			0x1163E == code || // Mc       MODI SIGN VISARGA
			0x116AC == code || // Mc       TAKRI SIGN VISARGA
			(0x116AE <= code && code <= 0x116AF) || // Mc   [2] TAKRI VOWEL SIGN I..TAKRI VOWEL SIGN II
			0x116B6 == code || // Mc       TAKRI SIGN VIRAMA
			(0x11720 <= code && code <= 0x11721) || // Mc   [2] AHOM VOWEL SIGN A..AHOM VOWEL SIGN AA
			0x11726 == code || // Mc       AHOM VOWEL SIGN E
			(0x11A07 <= code && code <= 0x11A08) || // Mc   [2] ZANABAZAR SQUARE VOWEL SIGN AI..ZANABAZAR SQUARE VOWEL SIGN AU
			0x11A39 == code || // Mc       ZANABAZAR SQUARE SIGN VISARGA
			(0x11A57 <= code && code <= 0x11A58) || // Mc   [2] SOYOMBO VOWEL SIGN AI..SOYOMBO VOWEL SIGN AU
			0x11A97 == code || // Mc       SOYOMBO SIGN VISARGA
			0x11C2F == code || // Mc       BHAIKSUKI VOWEL SIGN AA
			0x11C3E == code || // Mc       BHAIKSUKI SIGN VISARGA
			0x11CA9 == code || // Mc       MARCHEN SUBJOINED LETTER YA
			0x11CB1 == code || // Mc       MARCHEN VOWEL SIGN I
			0x11CB4 == code || // Mc       MARCHEN VOWEL SIGN O
			(0x16F51 <= code && code <= 0x16F7E) || // Mc  [46] MIAO SIGN ASPIRATION..MIAO VOWEL SIGN NG
			0x1D166 == code || // Mc       MUSICAL SYMBOL COMBINING SPRECHGESANG STEM
			0x1D16D == code // Mc       MUSICAL SYMBOL COMBINING AUGMENTATION DOT
			){
				return SpacingMark;
			}
			
			
			if(
			(0x1100 <= code && code <= 0x115F) || // Lo  [96] HANGUL CHOSEONG KIYEOK..HANGUL CHOSEONG FILLER
			(0xA960 <= code && code <= 0xA97C) // Lo  [29] HANGUL CHOSEONG TIKEUT-MIEUM..HANGUL CHOSEONG SSANGYEORINHIEUH
			){
				return L;
			}
			
			if(
			(0x1160 <= code && code <= 0x11A7) || // Lo  [72] HANGUL JUNGSEONG FILLER..HANGUL JUNGSEONG O-YAE
			(0xD7B0 <= code && code <= 0xD7C6) // Lo  [23] HANGUL JUNGSEONG O-YEO..HANGUL JUNGSEONG ARAEA-E
			){
				return V;
			}
			
			
			if(
			(0x11A8 <= code && code <= 0x11FF) || // Lo  [88] HANGUL JONGSEONG KIYEOK..HANGUL JONGSEONG SSANGNIEUN
			(0xD7CB <= code && code <= 0xD7FB) // Lo  [49] HANGUL JONGSEONG NIEUN-RIEUL..HANGUL JONGSEONG PHIEUPH-THIEUTH
			){
				return T;
			}
			
			if(
			0xAC00 == code || // Lo       HANGUL SYLLABLE GA
			0xAC1C == code || // Lo       HANGUL SYLLABLE GAE
			0xAC38 == code || // Lo       HANGUL SYLLABLE GYA
			0xAC54 == code || // Lo       HANGUL SYLLABLE GYAE
			0xAC70 == code || // Lo       HANGUL SYLLABLE GEO
			0xAC8C == code || // Lo       HANGUL SYLLABLE GE
			0xACA8 == code || // Lo       HANGUL SYLLABLE GYEO
			0xACC4 == code || // Lo       HANGUL SYLLABLE GYE
			0xACE0 == code || // Lo       HANGUL SYLLABLE GO
			0xACFC == code || // Lo       HANGUL SYLLABLE GWA
			0xAD18 == code || // Lo       HANGUL SYLLABLE GWAE
			0xAD34 == code || // Lo       HANGUL SYLLABLE GOE
			0xAD50 == code || // Lo       HANGUL SYLLABLE GYO
			0xAD6C == code || // Lo       HANGUL SYLLABLE GU
			0xAD88 == code || // Lo       HANGUL SYLLABLE GWEO
			0xADA4 == code || // Lo       HANGUL SYLLABLE GWE
			0xADC0 == code || // Lo       HANGUL SYLLABLE GWI
			0xADDC == code || // Lo       HANGUL SYLLABLE GYU
			0xADF8 == code || // Lo       HANGUL SYLLABLE GEU
			0xAE14 == code || // Lo       HANGUL SYLLABLE GYI
			0xAE30 == code || // Lo       HANGUL SYLLABLE GI
			0xAE4C == code || // Lo       HANGUL SYLLABLE GGA
			0xAE68 == code || // Lo       HANGUL SYLLABLE GGAE
			0xAE84 == code || // Lo       HANGUL SYLLABLE GGYA
			0xAEA0 == code || // Lo       HANGUL SYLLABLE GGYAE
			0xAEBC == code || // Lo       HANGUL SYLLABLE GGEO
			0xAED8 == code || // Lo       HANGUL SYLLABLE GGE
			0xAEF4 == code || // Lo       HANGUL SYLLABLE GGYEO
			0xAF10 == code || // Lo       HANGUL SYLLABLE GGYE
			0xAF2C == code || // Lo       HANGUL SYLLABLE GGO
			0xAF48 == code || // Lo       HANGUL SYLLABLE GGWA
			0xAF64 == code || // Lo       HANGUL SYLLABLE GGWAE
			0xAF80 == code || // Lo       HANGUL SYLLABLE GGOE
			0xAF9C == code || // Lo       HANGUL SYLLABLE GGYO
			0xAFB8 == code || // Lo       HANGUL SYLLABLE GGU
			0xAFD4 == code || // Lo       HANGUL SYLLABLE GGWEO
			0xAFF0 == code || // Lo       HANGUL SYLLABLE GGWE
			0xB00C == code || // Lo       HANGUL SYLLABLE GGWI
			0xB028 == code || // Lo       HANGUL SYLLABLE GGYU
			0xB044 == code || // Lo       HANGUL SYLLABLE GGEU
			0xB060 == code || // Lo       HANGUL SYLLABLE GGYI
			0xB07C == code || // Lo       HANGUL SYLLABLE GGI
			0xB098 == code || // Lo       HANGUL SYLLABLE NA
			0xB0B4 == code || // Lo       HANGUL SYLLABLE NAE
			0xB0D0 == code || // Lo       HANGUL SYLLABLE NYA
			0xB0EC == code || // Lo       HANGUL SYLLABLE NYAE
			0xB108 == code || // Lo       HANGUL SYLLABLE NEO
			0xB124 == code || // Lo       HANGUL SYLLABLE NE
			0xB140 == code || // Lo       HANGUL SYLLABLE NYEO
			0xB15C == code || // Lo       HANGUL SYLLABLE NYE
			0xB178 == code || // Lo       HANGUL SYLLABLE NO
			0xB194 == code || // Lo       HANGUL SYLLABLE NWA
			0xB1B0 == code || // Lo       HANGUL SYLLABLE NWAE
			0xB1CC == code || // Lo       HANGUL SYLLABLE NOE
			0xB1E8 == code || // Lo       HANGUL SYLLABLE NYO
			0xB204 == code || // Lo       HANGUL SYLLABLE NU
			0xB220 == code || // Lo       HANGUL SYLLABLE NWEO
			0xB23C == code || // Lo       HANGUL SYLLABLE NWE
			0xB258 == code || // Lo       HANGUL SYLLABLE NWI
			0xB274 == code || // Lo       HANGUL SYLLABLE NYU
			0xB290 == code || // Lo       HANGUL SYLLABLE NEU
			0xB2AC == code || // Lo       HANGUL SYLLABLE NYI
			0xB2C8 == code || // Lo       HANGUL SYLLABLE NI
			0xB2E4 == code || // Lo       HANGUL SYLLABLE DA
			0xB300 == code || // Lo       HANGUL SYLLABLE DAE
			0xB31C == code || // Lo       HANGUL SYLLABLE DYA
			0xB338 == code || // Lo       HANGUL SYLLABLE DYAE
			0xB354 == code || // Lo       HANGUL SYLLABLE DEO
			0xB370 == code || // Lo       HANGUL SYLLABLE DE
			0xB38C == code || // Lo       HANGUL SYLLABLE DYEO
			0xB3A8 == code || // Lo       HANGUL SYLLABLE DYE
			0xB3C4 == code || // Lo       HANGUL SYLLABLE DO
			0xB3E0 == code || // Lo       HANGUL SYLLABLE DWA
			0xB3FC == code || // Lo       HANGUL SYLLABLE DWAE
			0xB418 == code || // Lo       HANGUL SYLLABLE DOE
			0xB434 == code || // Lo       HANGUL SYLLABLE DYO
			0xB450 == code || // Lo       HANGUL SYLLABLE DU
			0xB46C == code || // Lo       HANGUL SYLLABLE DWEO
			0xB488 == code || // Lo       HANGUL SYLLABLE DWE
			0xB4A4 == code || // Lo       HANGUL SYLLABLE DWI
			0xB4C0 == code || // Lo       HANGUL SYLLABLE DYU
			0xB4DC == code || // Lo       HANGUL SYLLABLE DEU
			0xB4F8 == code || // Lo       HANGUL SYLLABLE DYI
			0xB514 == code || // Lo       HANGUL SYLLABLE DI
			0xB530 == code || // Lo       HANGUL SYLLABLE DDA
			0xB54C == code || // Lo       HANGUL SYLLABLE DDAE
			0xB568 == code || // Lo       HANGUL SYLLABLE DDYA
			0xB584 == code || // Lo       HANGUL SYLLABLE DDYAE
			0xB5A0 == code || // Lo       HANGUL SYLLABLE DDEO
			0xB5BC == code || // Lo       HANGUL SYLLABLE DDE
			0xB5D8 == code || // Lo       HANGUL SYLLABLE DDYEO
			0xB5F4 == code || // Lo       HANGUL SYLLABLE DDYE
			0xB610 == code || // Lo       HANGUL SYLLABLE DDO
			0xB62C == code || // Lo       HANGUL SYLLABLE DDWA
			0xB648 == code || // Lo       HANGUL SYLLABLE DDWAE
			0xB664 == code || // Lo       HANGUL SYLLABLE DDOE
			0xB680 == code || // Lo       HANGUL SYLLABLE DDYO
			0xB69C == code || // Lo       HANGUL SYLLABLE DDU
			0xB6B8 == code || // Lo       HANGUL SYLLABLE DDWEO
			0xB6D4 == code || // Lo       HANGUL SYLLABLE DDWE
			0xB6F0 == code || // Lo       HANGUL SYLLABLE DDWI
			0xB70C == code || // Lo       HANGUL SYLLABLE DDYU
			0xB728 == code || // Lo       HANGUL SYLLABLE DDEU
			0xB744 == code || // Lo       HANGUL SYLLABLE DDYI
			0xB760 == code || // Lo       HANGUL SYLLABLE DDI
			0xB77C == code || // Lo       HANGUL SYLLABLE RA
			0xB798 == code || // Lo       HANGUL SYLLABLE RAE
			0xB7B4 == code || // Lo       HANGUL SYLLABLE RYA
			0xB7D0 == code || // Lo       HANGUL SYLLABLE RYAE
			0xB7EC == code || // Lo       HANGUL SYLLABLE REO
			0xB808 == code || // Lo       HANGUL SYLLABLE RE
			0xB824 == code || // Lo       HANGUL SYLLABLE RYEO
			0xB840 == code || // Lo       HANGUL SYLLABLE RYE
			0xB85C == code || // Lo       HANGUL SYLLABLE RO
			0xB878 == code || // Lo       HANGUL SYLLABLE RWA
			0xB894 == code || // Lo       HANGUL SYLLABLE RWAE
			0xB8B0 == code || // Lo       HANGUL SYLLABLE ROE
			0xB8CC == code || // Lo       HANGUL SYLLABLE RYO
			0xB8E8 == code || // Lo       HANGUL SYLLABLE RU
			0xB904 == code || // Lo       HANGUL SYLLABLE RWEO
			0xB920 == code || // Lo       HANGUL SYLLABLE RWE
			0xB93C == code || // Lo       HANGUL SYLLABLE RWI
			0xB958 == code || // Lo       HANGUL SYLLABLE RYU
			0xB974 == code || // Lo       HANGUL SYLLABLE REU
			0xB990 == code || // Lo       HANGUL SYLLABLE RYI
			0xB9AC == code || // Lo       HANGUL SYLLABLE RI
			0xB9C8 == code || // Lo       HANGUL SYLLABLE MA
			0xB9E4 == code || // Lo       HANGUL SYLLABLE MAE
			0xBA00 == code || // Lo       HANGUL SYLLABLE MYA
			0xBA1C == code || // Lo       HANGUL SYLLABLE MYAE
			0xBA38 == code || // Lo       HANGUL SYLLABLE MEO
			0xBA54 == code || // Lo       HANGUL SYLLABLE ME
			0xBA70 == code || // Lo       HANGUL SYLLABLE MYEO
			0xBA8C == code || // Lo       HANGUL SYLLABLE MYE
			0xBAA8 == code || // Lo       HANGUL SYLLABLE MO
			0xBAC4 == code || // Lo       HANGUL SYLLABLE MWA
			0xBAE0 == code || // Lo       HANGUL SYLLABLE MWAE
			0xBAFC == code || // Lo       HANGUL SYLLABLE MOE
			0xBB18 == code || // Lo       HANGUL SYLLABLE MYO
			0xBB34 == code || // Lo       HANGUL SYLLABLE MU
			0xBB50 == code || // Lo       HANGUL SYLLABLE MWEO
			0xBB6C == code || // Lo       HANGUL SYLLABLE MWE
			0xBB88 == code || // Lo       HANGUL SYLLABLE MWI
			0xBBA4 == code || // Lo       HANGUL SYLLABLE MYU
			0xBBC0 == code || // Lo       HANGUL SYLLABLE MEU
			0xBBDC == code || // Lo       HANGUL SYLLABLE MYI
			0xBBF8 == code || // Lo       HANGUL SYLLABLE MI
			0xBC14 == code || // Lo       HANGUL SYLLABLE BA
			0xBC30 == code || // Lo       HANGUL SYLLABLE BAE
			0xBC4C == code || // Lo       HANGUL SYLLABLE BYA
			0xBC68 == code || // Lo       HANGUL SYLLABLE BYAE
			0xBC84 == code || // Lo       HANGUL SYLLABLE BEO
			0xBCA0 == code || // Lo       HANGUL SYLLABLE BE
			0xBCBC == code || // Lo       HANGUL SYLLABLE BYEO
			0xBCD8 == code || // Lo       HANGUL SYLLABLE BYE
			0xBCF4 == code || // Lo       HANGUL SYLLABLE BO
			0xBD10 == code || // Lo       HANGUL SYLLABLE BWA
			0xBD2C == code || // Lo       HANGUL SYLLABLE BWAE
			0xBD48 == code || // Lo       HANGUL SYLLABLE BOE
			0xBD64 == code || // Lo       HANGUL SYLLABLE BYO
			0xBD80 == code || // Lo       HANGUL SYLLABLE BU
			0xBD9C == code || // Lo       HANGUL SYLLABLE BWEO
			0xBDB8 == code || // Lo       HANGUL SYLLABLE BWE
			0xBDD4 == code || // Lo       HANGUL SYLLABLE BWI
			0xBDF0 == code || // Lo       HANGUL SYLLABLE BYU
			0xBE0C == code || // Lo       HANGUL SYLLABLE BEU
			0xBE28 == code || // Lo       HANGUL SYLLABLE BYI
			0xBE44 == code || // Lo       HANGUL SYLLABLE BI
			0xBE60 == code || // Lo       HANGUL SYLLABLE BBA
			0xBE7C == code || // Lo       HANGUL SYLLABLE BBAE
			0xBE98 == code || // Lo       HANGUL SYLLABLE BBYA
			0xBEB4 == code || // Lo       HANGUL SYLLABLE BBYAE
			0xBED0 == code || // Lo       HANGUL SYLLABLE BBEO
			0xBEEC == code || // Lo       HANGUL SYLLABLE BBE
			0xBF08 == code || // Lo       HANGUL SYLLABLE BBYEO
			0xBF24 == code || // Lo       HANGUL SYLLABLE BBYE
			0xBF40 == code || // Lo       HANGUL SYLLABLE BBO
			0xBF5C == code || // Lo       HANGUL SYLLABLE BBWA
			0xBF78 == code || // Lo       HANGUL SYLLABLE BBWAE
			0xBF94 == code || // Lo       HANGUL SYLLABLE BBOE
			0xBFB0 == code || // Lo       HANGUL SYLLABLE BBYO
			0xBFCC == code || // Lo       HANGUL SYLLABLE BBU
			0xBFE8 == code || // Lo       HANGUL SYLLABLE BBWEO
			0xC004 == code || // Lo       HANGUL SYLLABLE BBWE
			0xC020 == code || // Lo       HANGUL SYLLABLE BBWI
			0xC03C == code || // Lo       HANGUL SYLLABLE BBYU
			0xC058 == code || // Lo       HANGUL SYLLABLE BBEU
			0xC074 == code || // Lo       HANGUL SYLLABLE BBYI
			0xC090 == code || // Lo       HANGUL SYLLABLE BBI
			0xC0AC == code || // Lo       HANGUL SYLLABLE SA
			0xC0C8 == code || // Lo       HANGUL SYLLABLE SAE
			0xC0E4 == code || // Lo       HANGUL SYLLABLE SYA
			0xC100 == code || // Lo       HANGUL SYLLABLE SYAE
			0xC11C == code || // Lo       HANGUL SYLLABLE SEO
			0xC138 == code || // Lo       HANGUL SYLLABLE SE
			0xC154 == code || // Lo       HANGUL SYLLABLE SYEO
			0xC170 == code || // Lo       HANGUL SYLLABLE SYE
			0xC18C == code || // Lo       HANGUL SYLLABLE SO
			0xC1A8 == code || // Lo       HANGUL SYLLABLE SWA
			0xC1C4 == code || // Lo       HANGUL SYLLABLE SWAE
			0xC1E0 == code || // Lo       HANGUL SYLLABLE SOE
			0xC1FC == code || // Lo       HANGUL SYLLABLE SYO
			0xC218 == code || // Lo       HANGUL SYLLABLE SU
			0xC234 == code || // Lo       HANGUL SYLLABLE SWEO
			0xC250 == code || // Lo       HANGUL SYLLABLE SWE
			0xC26C == code || // Lo       HANGUL SYLLABLE SWI
			0xC288 == code || // Lo       HANGUL SYLLABLE SYU
			0xC2A4 == code || // Lo       HANGUL SYLLABLE SEU
			0xC2C0 == code || // Lo       HANGUL SYLLABLE SYI
			0xC2DC == code || // Lo       HANGUL SYLLABLE SI
			0xC2F8 == code || // Lo       HANGUL SYLLABLE SSA
			0xC314 == code || // Lo       HANGUL SYLLABLE SSAE
			0xC330 == code || // Lo       HANGUL SYLLABLE SSYA
			0xC34C == code || // Lo       HANGUL SYLLABLE SSYAE
			0xC368 == code || // Lo       HANGUL SYLLABLE SSEO
			0xC384 == code || // Lo       HANGUL SYLLABLE SSE
			0xC3A0 == code || // Lo       HANGUL SYLLABLE SSYEO
			0xC3BC == code || // Lo       HANGUL SYLLABLE SSYE
			0xC3D8 == code || // Lo       HANGUL SYLLABLE SSO
			0xC3F4 == code || // Lo       HANGUL SYLLABLE SSWA
			0xC410 == code || // Lo       HANGUL SYLLABLE SSWAE
			0xC42C == code || // Lo       HANGUL SYLLABLE SSOE
			0xC448 == code || // Lo       HANGUL SYLLABLE SSYO
			0xC464 == code || // Lo       HANGUL SYLLABLE SSU
			0xC480 == code || // Lo       HANGUL SYLLABLE SSWEO
			0xC49C == code || // Lo       HANGUL SYLLABLE SSWE
			0xC4B8 == code || // Lo       HANGUL SYLLABLE SSWI
			0xC4D4 == code || // Lo       HANGUL SYLLABLE SSYU
			0xC4F0 == code || // Lo       HANGUL SYLLABLE SSEU
			0xC50C == code || // Lo       HANGUL SYLLABLE SSYI
			0xC528 == code || // Lo       HANGUL SYLLABLE SSI
			0xC544 == code || // Lo       HANGUL SYLLABLE A
			0xC560 == code || // Lo       HANGUL SYLLABLE AE
			0xC57C == code || // Lo       HANGUL SYLLABLE YA
			0xC598 == code || // Lo       HANGUL SYLLABLE YAE
			0xC5B4 == code || // Lo       HANGUL SYLLABLE EO
			0xC5D0 == code || // Lo       HANGUL SYLLABLE E
			0xC5EC == code || // Lo       HANGUL SYLLABLE YEO
			0xC608 == code || // Lo       HANGUL SYLLABLE YE
			0xC624 == code || // Lo       HANGUL SYLLABLE O
			0xC640 == code || // Lo       HANGUL SYLLABLE WA
			0xC65C == code || // Lo       HANGUL SYLLABLE WAE
			0xC678 == code || // Lo       HANGUL SYLLABLE OE
			0xC694 == code || // Lo       HANGUL SYLLABLE YO
			0xC6B0 == code || // Lo       HANGUL SYLLABLE U
			0xC6CC == code || // Lo       HANGUL SYLLABLE WEO
			0xC6E8 == code || // Lo       HANGUL SYLLABLE WE
			0xC704 == code || // Lo       HANGUL SYLLABLE WI
			0xC720 == code || // Lo       HANGUL SYLLABLE YU
			0xC73C == code || // Lo       HANGUL SYLLABLE EU
			0xC758 == code || // Lo       HANGUL SYLLABLE YI
			0xC774 == code || // Lo       HANGUL SYLLABLE I
			0xC790 == code || // Lo       HANGUL SYLLABLE JA
			0xC7AC == code || // Lo       HANGUL SYLLABLE JAE
			0xC7C8 == code || // Lo       HANGUL SYLLABLE JYA
			0xC7E4 == code || // Lo       HANGUL SYLLABLE JYAE
			0xC800 == code || // Lo       HANGUL SYLLABLE JEO
			0xC81C == code || // Lo       HANGUL SYLLABLE JE
			0xC838 == code || // Lo       HANGUL SYLLABLE JYEO
			0xC854 == code || // Lo       HANGUL SYLLABLE JYE
			0xC870 == code || // Lo       HANGUL SYLLABLE JO
			0xC88C == code || // Lo       HANGUL SYLLABLE JWA
			0xC8A8 == code || // Lo       HANGUL SYLLABLE JWAE
			0xC8C4 == code || // Lo       HANGUL SYLLABLE JOE
			0xC8E0 == code || // Lo       HANGUL SYLLABLE JYO
			0xC8FC == code || // Lo       HANGUL SYLLABLE JU
			0xC918 == code || // Lo       HANGUL SYLLABLE JWEO
			0xC934 == code || // Lo       HANGUL SYLLABLE JWE
			0xC950 == code || // Lo       HANGUL SYLLABLE JWI
			0xC96C == code || // Lo       HANGUL SYLLABLE JYU
			0xC988 == code || // Lo       HANGUL SYLLABLE JEU
			0xC9A4 == code || // Lo       HANGUL SYLLABLE JYI
			0xC9C0 == code || // Lo       HANGUL SYLLABLE JI
			0xC9DC == code || // Lo       HANGUL SYLLABLE JJA
			0xC9F8 == code || // Lo       HANGUL SYLLABLE JJAE
			0xCA14 == code || // Lo       HANGUL SYLLABLE JJYA
			0xCA30 == code || // Lo       HANGUL SYLLABLE JJYAE
			0xCA4C == code || // Lo       HANGUL SYLLABLE JJEO
			0xCA68 == code || // Lo       HANGUL SYLLABLE JJE
			0xCA84 == code || // Lo       HANGUL SYLLABLE JJYEO
			0xCAA0 == code || // Lo       HANGUL SYLLABLE JJYE
			0xCABC == code || // Lo       HANGUL SYLLABLE JJO
			0xCAD8 == code || // Lo       HANGUL SYLLABLE JJWA
			0xCAF4 == code || // Lo       HANGUL SYLLABLE JJWAE
			0xCB10 == code || // Lo       HANGUL SYLLABLE JJOE
			0xCB2C == code || // Lo       HANGUL SYLLABLE JJYO
			0xCB48 == code || // Lo       HANGUL SYLLABLE JJU
			0xCB64 == code || // Lo       HANGUL SYLLABLE JJWEO
			0xCB80 == code || // Lo       HANGUL SYLLABLE JJWE
			0xCB9C == code || // Lo       HANGUL SYLLABLE JJWI
			0xCBB8 == code || // Lo       HANGUL SYLLABLE JJYU
			0xCBD4 == code || // Lo       HANGUL SYLLABLE JJEU
			0xCBF0 == code || // Lo       HANGUL SYLLABLE JJYI
			0xCC0C == code || // Lo       HANGUL SYLLABLE JJI
			0xCC28 == code || // Lo       HANGUL SYLLABLE CA
			0xCC44 == code || // Lo       HANGUL SYLLABLE CAE
			0xCC60 == code || // Lo       HANGUL SYLLABLE CYA
			0xCC7C == code || // Lo       HANGUL SYLLABLE CYAE
			0xCC98 == code || // Lo       HANGUL SYLLABLE CEO
			0xCCB4 == code || // Lo       HANGUL SYLLABLE CE
			0xCCD0 == code || // Lo       HANGUL SYLLABLE CYEO
			0xCCEC == code || // Lo       HANGUL SYLLABLE CYE
			0xCD08 == code || // Lo       HANGUL SYLLABLE CO
			0xCD24 == code || // Lo       HANGUL SYLLABLE CWA
			0xCD40 == code || // Lo       HANGUL SYLLABLE CWAE
			0xCD5C == code || // Lo       HANGUL SYLLABLE COE
			0xCD78 == code || // Lo       HANGUL SYLLABLE CYO
			0xCD94 == code || // Lo       HANGUL SYLLABLE CU
			0xCDB0 == code || // Lo       HANGUL SYLLABLE CWEO
			0xCDCC == code || // Lo       HANGUL SYLLABLE CWE
			0xCDE8 == code || // Lo       HANGUL SYLLABLE CWI
			0xCE04 == code || // Lo       HANGUL SYLLABLE CYU
			0xCE20 == code || // Lo       HANGUL SYLLABLE CEU
			0xCE3C == code || // Lo       HANGUL SYLLABLE CYI
			0xCE58 == code || // Lo       HANGUL SYLLABLE CI
			0xCE74 == code || // Lo       HANGUL SYLLABLE KA
			0xCE90 == code || // Lo       HANGUL SYLLABLE KAE
			0xCEAC == code || // Lo       HANGUL SYLLABLE KYA
			0xCEC8 == code || // Lo       HANGUL SYLLABLE KYAE
			0xCEE4 == code || // Lo       HANGUL SYLLABLE KEO
			0xCF00 == code || // Lo       HANGUL SYLLABLE KE
			0xCF1C == code || // Lo       HANGUL SYLLABLE KYEO
			0xCF38 == code || // Lo       HANGUL SYLLABLE KYE
			0xCF54 == code || // Lo       HANGUL SYLLABLE KO
			0xCF70 == code || // Lo       HANGUL SYLLABLE KWA
			0xCF8C == code || // Lo       HANGUL SYLLABLE KWAE
			0xCFA8 == code || // Lo       HANGUL SYLLABLE KOE
			0xCFC4 == code || // Lo       HANGUL SYLLABLE KYO
			0xCFE0 == code || // Lo       HANGUL SYLLABLE KU
			0xCFFC == code || // Lo       HANGUL SYLLABLE KWEO
			0xD018 == code || // Lo       HANGUL SYLLABLE KWE
			0xD034 == code || // Lo       HANGUL SYLLABLE KWI
			0xD050 == code || // Lo       HANGUL SYLLABLE KYU
			0xD06C == code || // Lo       HANGUL SYLLABLE KEU
			0xD088 == code || // Lo       HANGUL SYLLABLE KYI
			0xD0A4 == code || // Lo       HANGUL SYLLABLE KI
			0xD0C0 == code || // Lo       HANGUL SYLLABLE TA
			0xD0DC == code || // Lo       HANGUL SYLLABLE TAE
			0xD0F8 == code || // Lo       HANGUL SYLLABLE TYA
			0xD114 == code || // Lo       HANGUL SYLLABLE TYAE
			0xD130 == code || // Lo       HANGUL SYLLABLE TEO
			0xD14C == code || // Lo       HANGUL SYLLABLE TE
			0xD168 == code || // Lo       HANGUL SYLLABLE TYEO
			0xD184 == code || // Lo       HANGUL SYLLABLE TYE
			0xD1A0 == code || // Lo       HANGUL SYLLABLE TO
			0xD1BC == code || // Lo       HANGUL SYLLABLE TWA
			0xD1D8 == code || // Lo       HANGUL SYLLABLE TWAE
			0xD1F4 == code || // Lo       HANGUL SYLLABLE TOE
			0xD210 == code || // Lo       HANGUL SYLLABLE TYO
			0xD22C == code || // Lo       HANGUL SYLLABLE TU
			0xD248 == code || // Lo       HANGUL SYLLABLE TWEO
			0xD264 == code || // Lo       HANGUL SYLLABLE TWE
			0xD280 == code || // Lo       HANGUL SYLLABLE TWI
			0xD29C == code || // Lo       HANGUL SYLLABLE TYU
			0xD2B8 == code || // Lo       HANGUL SYLLABLE TEU
			0xD2D4 == code || // Lo       HANGUL SYLLABLE TYI
			0xD2F0 == code || // Lo       HANGUL SYLLABLE TI
			0xD30C == code || // Lo       HANGUL SYLLABLE PA
			0xD328 == code || // Lo       HANGUL SYLLABLE PAE
			0xD344 == code || // Lo       HANGUL SYLLABLE PYA
			0xD360 == code || // Lo       HANGUL SYLLABLE PYAE
			0xD37C == code || // Lo       HANGUL SYLLABLE PEO
			0xD398 == code || // Lo       HANGUL SYLLABLE PE
			0xD3B4 == code || // Lo       HANGUL SYLLABLE PYEO
			0xD3D0 == code || // Lo       HANGUL SYLLABLE PYE
			0xD3EC == code || // Lo       HANGUL SYLLABLE PO
			0xD408 == code || // Lo       HANGUL SYLLABLE PWA
			0xD424 == code || // Lo       HANGUL SYLLABLE PWAE
			0xD440 == code || // Lo       HANGUL SYLLABLE POE
			0xD45C == code || // Lo       HANGUL SYLLABLE PYO
			0xD478 == code || // Lo       HANGUL SYLLABLE PU
			0xD494 == code || // Lo       HANGUL SYLLABLE PWEO
			0xD4B0 == code || // Lo       HANGUL SYLLABLE PWE
			0xD4CC == code || // Lo       HANGUL SYLLABLE PWI
			0xD4E8 == code || // Lo       HANGUL SYLLABLE PYU
			0xD504 == code || // Lo       HANGUL SYLLABLE PEU
			0xD520 == code || // Lo       HANGUL SYLLABLE PYI
			0xD53C == code || // Lo       HANGUL SYLLABLE PI
			0xD558 == code || // Lo       HANGUL SYLLABLE HA
			0xD574 == code || // Lo       HANGUL SYLLABLE HAE
			0xD590 == code || // Lo       HANGUL SYLLABLE HYA
			0xD5AC == code || // Lo       HANGUL SYLLABLE HYAE
			0xD5C8 == code || // Lo       HANGUL SYLLABLE HEO
			0xD5E4 == code || // Lo       HANGUL SYLLABLE HE
			0xD600 == code || // Lo       HANGUL SYLLABLE HYEO
			0xD61C == code || // Lo       HANGUL SYLLABLE HYE
			0xD638 == code || // Lo       HANGUL SYLLABLE HO
			0xD654 == code || // Lo       HANGUL SYLLABLE HWA
			0xD670 == code || // Lo       HANGUL SYLLABLE HWAE
			0xD68C == code || // Lo       HANGUL SYLLABLE HOE
			0xD6A8 == code || // Lo       HANGUL SYLLABLE HYO
			0xD6C4 == code || // Lo       HANGUL SYLLABLE HU
			0xD6E0 == code || // Lo       HANGUL SYLLABLE HWEO
			0xD6FC == code || // Lo       HANGUL SYLLABLE HWE
			0xD718 == code || // Lo       HANGUL SYLLABLE HWI
			0xD734 == code || // Lo       HANGUL SYLLABLE HYU
			0xD750 == code || // Lo       HANGUL SYLLABLE HEU
			0xD76C == code || // Lo       HANGUL SYLLABLE HYI
			0xD788 == code // Lo       HANGUL SYLLABLE HI
			){
				return LV;
			}
			
			if(
			(0xAC01 <= code && code <= 0xAC1B) || // Lo  [27] HANGUL SYLLABLE GAG..HANGUL SYLLABLE GAH
			(0xAC1D <= code && code <= 0xAC37) || // Lo  [27] HANGUL SYLLABLE GAEG..HANGUL SYLLABLE GAEH
			(0xAC39 <= code && code <= 0xAC53) || // Lo  [27] HANGUL SYLLABLE GYAG..HANGUL SYLLABLE GYAH
			(0xAC55 <= code && code <= 0xAC6F) || // Lo  [27] HANGUL SYLLABLE GYAEG..HANGUL SYLLABLE GYAEH
			(0xAC71 <= code && code <= 0xAC8B) || // Lo  [27] HANGUL SYLLABLE GEOG..HANGUL SYLLABLE GEOH
			(0xAC8D <= code && code <= 0xACA7) || // Lo  [27] HANGUL SYLLABLE GEG..HANGUL SYLLABLE GEH
			(0xACA9 <= code && code <= 0xACC3) || // Lo  [27] HANGUL SYLLABLE GYEOG..HANGUL SYLLABLE GYEOH
			(0xACC5 <= code && code <= 0xACDF) || // Lo  [27] HANGUL SYLLABLE GYEG..HANGUL SYLLABLE GYEH
			(0xACE1 <= code && code <= 0xACFB) || // Lo  [27] HANGUL SYLLABLE GOG..HANGUL SYLLABLE GOH
			(0xACFD <= code && code <= 0xAD17) || // Lo  [27] HANGUL SYLLABLE GWAG..HANGUL SYLLABLE GWAH
			(0xAD19 <= code && code <= 0xAD33) || // Lo  [27] HANGUL SYLLABLE GWAEG..HANGUL SYLLABLE GWAEH
			(0xAD35 <= code && code <= 0xAD4F) || // Lo  [27] HANGUL SYLLABLE GOEG..HANGUL SYLLABLE GOEH
			(0xAD51 <= code && code <= 0xAD6B) || // Lo  [27] HANGUL SYLLABLE GYOG..HANGUL SYLLABLE GYOH
			(0xAD6D <= code && code <= 0xAD87) || // Lo  [27] HANGUL SYLLABLE GUG..HANGUL SYLLABLE GUH
			(0xAD89 <= code && code <= 0xADA3) || // Lo  [27] HANGUL SYLLABLE GWEOG..HANGUL SYLLABLE GWEOH
			(0xADA5 <= code && code <= 0xADBF) || // Lo  [27] HANGUL SYLLABLE GWEG..HANGUL SYLLABLE GWEH
			(0xADC1 <= code && code <= 0xADDB) || // Lo  [27] HANGUL SYLLABLE GWIG..HANGUL SYLLABLE GWIH
			(0xADDD <= code && code <= 0xADF7) || // Lo  [27] HANGUL SYLLABLE GYUG..HANGUL SYLLABLE GYUH
			(0xADF9 <= code && code <= 0xAE13) || // Lo  [27] HANGUL SYLLABLE GEUG..HANGUL SYLLABLE GEUH
			(0xAE15 <= code && code <= 0xAE2F) || // Lo  [27] HANGUL SYLLABLE GYIG..HANGUL SYLLABLE GYIH
			(0xAE31 <= code && code <= 0xAE4B) || // Lo  [27] HANGUL SYLLABLE GIG..HANGUL SYLLABLE GIH
			(0xAE4D <= code && code <= 0xAE67) || // Lo  [27] HANGUL SYLLABLE GGAG..HANGUL SYLLABLE GGAH
			(0xAE69 <= code && code <= 0xAE83) || // Lo  [27] HANGUL SYLLABLE GGAEG..HANGUL SYLLABLE GGAEH
			(0xAE85 <= code && code <= 0xAE9F) || // Lo  [27] HANGUL SYLLABLE GGYAG..HANGUL SYLLABLE GGYAH
			(0xAEA1 <= code && code <= 0xAEBB) || // Lo  [27] HANGUL SYLLABLE GGYAEG..HANGUL SYLLABLE GGYAEH
			(0xAEBD <= code && code <= 0xAED7) || // Lo  [27] HANGUL SYLLABLE GGEOG..HANGUL SYLLABLE GGEOH
			(0xAED9 <= code && code <= 0xAEF3) || // Lo  [27] HANGUL SYLLABLE GGEG..HANGUL SYLLABLE GGEH
			(0xAEF5 <= code && code <= 0xAF0F) || // Lo  [27] HANGUL SYLLABLE GGYEOG..HANGUL SYLLABLE GGYEOH
			(0xAF11 <= code && code <= 0xAF2B) || // Lo  [27] HANGUL SYLLABLE GGYEG..HANGUL SYLLABLE GGYEH
			(0xAF2D <= code && code <= 0xAF47) || // Lo  [27] HANGUL SYLLABLE GGOG..HANGUL SYLLABLE GGOH
			(0xAF49 <= code && code <= 0xAF63) || // Lo  [27] HANGUL SYLLABLE GGWAG..HANGUL SYLLABLE GGWAH
			(0xAF65 <= code && code <= 0xAF7F) || // Lo  [27] HANGUL SYLLABLE GGWAEG..HANGUL SYLLABLE GGWAEH
			(0xAF81 <= code && code <= 0xAF9B) || // Lo  [27] HANGUL SYLLABLE GGOEG..HANGUL SYLLABLE GGOEH
			(0xAF9D <= code && code <= 0xAFB7) || // Lo  [27] HANGUL SYLLABLE GGYOG..HANGUL SYLLABLE GGYOH
			(0xAFB9 <= code && code <= 0xAFD3) || // Lo  [27] HANGUL SYLLABLE GGUG..HANGUL SYLLABLE GGUH
			(0xAFD5 <= code && code <= 0xAFEF) || // Lo  [27] HANGUL SYLLABLE GGWEOG..HANGUL SYLLABLE GGWEOH
			(0xAFF1 <= code && code <= 0xB00B) || // Lo  [27] HANGUL SYLLABLE GGWEG..HANGUL SYLLABLE GGWEH
			(0xB00D <= code && code <= 0xB027) || // Lo  [27] HANGUL SYLLABLE GGWIG..HANGUL SYLLABLE GGWIH
			(0xB029 <= code && code <= 0xB043) || // Lo  [27] HANGUL SYLLABLE GGYUG..HANGUL SYLLABLE GGYUH
			(0xB045 <= code && code <= 0xB05F) || // Lo  [27] HANGUL SYLLABLE GGEUG..HANGUL SYLLABLE GGEUH
			(0xB061 <= code && code <= 0xB07B) || // Lo  [27] HANGUL SYLLABLE GGYIG..HANGUL SYLLABLE GGYIH
			(0xB07D <= code && code <= 0xB097) || // Lo  [27] HANGUL SYLLABLE GGIG..HANGUL SYLLABLE GGIH
			(0xB099 <= code && code <= 0xB0B3) || // Lo  [27] HANGUL SYLLABLE NAG..HANGUL SYLLABLE NAH
			(0xB0B5 <= code && code <= 0xB0CF) || // Lo  [27] HANGUL SYLLABLE NAEG..HANGUL SYLLABLE NAEH
			(0xB0D1 <= code && code <= 0xB0EB) || // Lo  [27] HANGUL SYLLABLE NYAG..HANGUL SYLLABLE NYAH
			(0xB0ED <= code && code <= 0xB107) || // Lo  [27] HANGUL SYLLABLE NYAEG..HANGUL SYLLABLE NYAEH
			(0xB109 <= code && code <= 0xB123) || // Lo  [27] HANGUL SYLLABLE NEOG..HANGUL SYLLABLE NEOH
			(0xB125 <= code && code <= 0xB13F) || // Lo  [27] HANGUL SYLLABLE NEG..HANGUL SYLLABLE NEH
			(0xB141 <= code && code <= 0xB15B) || // Lo  [27] HANGUL SYLLABLE NYEOG..HANGUL SYLLABLE NYEOH
			(0xB15D <= code && code <= 0xB177) || // Lo  [27] HANGUL SYLLABLE NYEG..HANGUL SYLLABLE NYEH
			(0xB179 <= code && code <= 0xB193) || // Lo  [27] HANGUL SYLLABLE NOG..HANGUL SYLLABLE NOH
			(0xB195 <= code && code <= 0xB1AF) || // Lo  [27] HANGUL SYLLABLE NWAG..HANGUL SYLLABLE NWAH
			(0xB1B1 <= code && code <= 0xB1CB) || // Lo  [27] HANGUL SYLLABLE NWAEG..HANGUL SYLLABLE NWAEH
			(0xB1CD <= code && code <= 0xB1E7) || // Lo  [27] HANGUL SYLLABLE NOEG..HANGUL SYLLABLE NOEH
			(0xB1E9 <= code && code <= 0xB203) || // Lo  [27] HANGUL SYLLABLE NYOG..HANGUL SYLLABLE NYOH
			(0xB205 <= code && code <= 0xB21F) || // Lo  [27] HANGUL SYLLABLE NUG..HANGUL SYLLABLE NUH
			(0xB221 <= code && code <= 0xB23B) || // Lo  [27] HANGUL SYLLABLE NWEOG..HANGUL SYLLABLE NWEOH
			(0xB23D <= code && code <= 0xB257) || // Lo  [27] HANGUL SYLLABLE NWEG..HANGUL SYLLABLE NWEH
			(0xB259 <= code && code <= 0xB273) || // Lo  [27] HANGUL SYLLABLE NWIG..HANGUL SYLLABLE NWIH
			(0xB275 <= code && code <= 0xB28F) || // Lo  [27] HANGUL SYLLABLE NYUG..HANGUL SYLLABLE NYUH
			(0xB291 <= code && code <= 0xB2AB) || // Lo  [27] HANGUL SYLLABLE NEUG..HANGUL SYLLABLE NEUH
			(0xB2AD <= code && code <= 0xB2C7) || // Lo  [27] HANGUL SYLLABLE NYIG..HANGUL SYLLABLE NYIH
			(0xB2C9 <= code && code <= 0xB2E3) || // Lo  [27] HANGUL SYLLABLE NIG..HANGUL SYLLABLE NIH
			(0xB2E5 <= code && code <= 0xB2FF) || // Lo  [27] HANGUL SYLLABLE DAG..HANGUL SYLLABLE DAH
			(0xB301 <= code && code <= 0xB31B) || // Lo  [27] HANGUL SYLLABLE DAEG..HANGUL SYLLABLE DAEH
			(0xB31D <= code && code <= 0xB337) || // Lo  [27] HANGUL SYLLABLE DYAG..HANGUL SYLLABLE DYAH
			(0xB339 <= code && code <= 0xB353) || // Lo  [27] HANGUL SYLLABLE DYAEG..HANGUL SYLLABLE DYAEH
			(0xB355 <= code && code <= 0xB36F) || // Lo  [27] HANGUL SYLLABLE DEOG..HANGUL SYLLABLE DEOH
			(0xB371 <= code && code <= 0xB38B) || // Lo  [27] HANGUL SYLLABLE DEG..HANGUL SYLLABLE DEH
			(0xB38D <= code && code <= 0xB3A7) || // Lo  [27] HANGUL SYLLABLE DYEOG..HANGUL SYLLABLE DYEOH
			(0xB3A9 <= code && code <= 0xB3C3) || // Lo  [27] HANGUL SYLLABLE DYEG..HANGUL SYLLABLE DYEH
			(0xB3C5 <= code && code <= 0xB3DF) || // Lo  [27] HANGUL SYLLABLE DOG..HANGUL SYLLABLE DOH
			(0xB3E1 <= code && code <= 0xB3FB) || // Lo  [27] HANGUL SYLLABLE DWAG..HANGUL SYLLABLE DWAH
			(0xB3FD <= code && code <= 0xB417) || // Lo  [27] HANGUL SYLLABLE DWAEG..HANGUL SYLLABLE DWAEH
			(0xB419 <= code && code <= 0xB433) || // Lo  [27] HANGUL SYLLABLE DOEG..HANGUL SYLLABLE DOEH
			(0xB435 <= code && code <= 0xB44F) || // Lo  [27] HANGUL SYLLABLE DYOG..HANGUL SYLLABLE DYOH
			(0xB451 <= code && code <= 0xB46B) || // Lo  [27] HANGUL SYLLABLE DUG..HANGUL SYLLABLE DUH
			(0xB46D <= code && code <= 0xB487) || // Lo  [27] HANGUL SYLLABLE DWEOG..HANGUL SYLLABLE DWEOH
			(0xB489 <= code && code <= 0xB4A3) || // Lo  [27] HANGUL SYLLABLE DWEG..HANGUL SYLLABLE DWEH
			(0xB4A5 <= code && code <= 0xB4BF) || // Lo  [27] HANGUL SYLLABLE DWIG..HANGUL SYLLABLE DWIH
			(0xB4C1 <= code && code <= 0xB4DB) || // Lo  [27] HANGUL SYLLABLE DYUG..HANGUL SYLLABLE DYUH
			(0xB4DD <= code && code <= 0xB4F7) || // Lo  [27] HANGUL SYLLABLE DEUG..HANGUL SYLLABLE DEUH
			(0xB4F9 <= code && code <= 0xB513) || // Lo  [27] HANGUL SYLLABLE DYIG..HANGUL SYLLABLE DYIH
			(0xB515 <= code && code <= 0xB52F) || // Lo  [27] HANGUL SYLLABLE DIG..HANGUL SYLLABLE DIH
			(0xB531 <= code && code <= 0xB54B) || // Lo  [27] HANGUL SYLLABLE DDAG..HANGUL SYLLABLE DDAH
			(0xB54D <= code && code <= 0xB567) || // Lo  [27] HANGUL SYLLABLE DDAEG..HANGUL SYLLABLE DDAEH
			(0xB569 <= code && code <= 0xB583) || // Lo  [27] HANGUL SYLLABLE DDYAG..HANGUL SYLLABLE DDYAH
			(0xB585 <= code && code <= 0xB59F) || // Lo  [27] HANGUL SYLLABLE DDYAEG..HANGUL SYLLABLE DDYAEH
			(0xB5A1 <= code && code <= 0xB5BB) || // Lo  [27] HANGUL SYLLABLE DDEOG..HANGUL SYLLABLE DDEOH
			(0xB5BD <= code && code <= 0xB5D7) || // Lo  [27] HANGUL SYLLABLE DDEG..HANGUL SYLLABLE DDEH
			(0xB5D9 <= code && code <= 0xB5F3) || // Lo  [27] HANGUL SYLLABLE DDYEOG..HANGUL SYLLABLE DDYEOH
			(0xB5F5 <= code && code <= 0xB60F) || // Lo  [27] HANGUL SYLLABLE DDYEG..HANGUL SYLLABLE DDYEH
			(0xB611 <= code && code <= 0xB62B) || // Lo  [27] HANGUL SYLLABLE DDOG..HANGUL SYLLABLE DDOH
			(0xB62D <= code && code <= 0xB647) || // Lo  [27] HANGUL SYLLABLE DDWAG..HANGUL SYLLABLE DDWAH
			(0xB649 <= code && code <= 0xB663) || // Lo  [27] HANGUL SYLLABLE DDWAEG..HANGUL SYLLABLE DDWAEH
			(0xB665 <= code && code <= 0xB67F) || // Lo  [27] HANGUL SYLLABLE DDOEG..HANGUL SYLLABLE DDOEH
			(0xB681 <= code && code <= 0xB69B) || // Lo  [27] HANGUL SYLLABLE DDYOG..HANGUL SYLLABLE DDYOH
			(0xB69D <= code && code <= 0xB6B7) || // Lo  [27] HANGUL SYLLABLE DDUG..HANGUL SYLLABLE DDUH
			(0xB6B9 <= code && code <= 0xB6D3) || // Lo  [27] HANGUL SYLLABLE DDWEOG..HANGUL SYLLABLE DDWEOH
			(0xB6D5 <= code && code <= 0xB6EF) || // Lo  [27] HANGUL SYLLABLE DDWEG..HANGUL SYLLABLE DDWEH
			(0xB6F1 <= code && code <= 0xB70B) || // Lo  [27] HANGUL SYLLABLE DDWIG..HANGUL SYLLABLE DDWIH
			(0xB70D <= code && code <= 0xB727) || // Lo  [27] HANGUL SYLLABLE DDYUG..HANGUL SYLLABLE DDYUH
			(0xB729 <= code && code <= 0xB743) || // Lo  [27] HANGUL SYLLABLE DDEUG..HANGUL SYLLABLE DDEUH
			(0xB745 <= code && code <= 0xB75F) || // Lo  [27] HANGUL SYLLABLE DDYIG..HANGUL SYLLABLE DDYIH
			(0xB761 <= code && code <= 0xB77B) || // Lo  [27] HANGUL SYLLABLE DDIG..HANGUL SYLLABLE DDIH
			(0xB77D <= code && code <= 0xB797) || // Lo  [27] HANGUL SYLLABLE RAG..HANGUL SYLLABLE RAH
			(0xB799 <= code && code <= 0xB7B3) || // Lo  [27] HANGUL SYLLABLE RAEG..HANGUL SYLLABLE RAEH
			(0xB7B5 <= code && code <= 0xB7CF) || // Lo  [27] HANGUL SYLLABLE RYAG..HANGUL SYLLABLE RYAH
			(0xB7D1 <= code && code <= 0xB7EB) || // Lo  [27] HANGUL SYLLABLE RYAEG..HANGUL SYLLABLE RYAEH
			(0xB7ED <= code && code <= 0xB807) || // Lo  [27] HANGUL SYLLABLE REOG..HANGUL SYLLABLE REOH
			(0xB809 <= code && code <= 0xB823) || // Lo  [27] HANGUL SYLLABLE REG..HANGUL SYLLABLE REH
			(0xB825 <= code && code <= 0xB83F) || // Lo  [27] HANGUL SYLLABLE RYEOG..HANGUL SYLLABLE RYEOH
			(0xB841 <= code && code <= 0xB85B) || // Lo  [27] HANGUL SYLLABLE RYEG..HANGUL SYLLABLE RYEH
			(0xB85D <= code && code <= 0xB877) || // Lo  [27] HANGUL SYLLABLE ROG..HANGUL SYLLABLE ROH
			(0xB879 <= code && code <= 0xB893) || // Lo  [27] HANGUL SYLLABLE RWAG..HANGUL SYLLABLE RWAH
			(0xB895 <= code && code <= 0xB8AF) || // Lo  [27] HANGUL SYLLABLE RWAEG..HANGUL SYLLABLE RWAEH
			(0xB8B1 <= code && code <= 0xB8CB) || // Lo  [27] HANGUL SYLLABLE ROEG..HANGUL SYLLABLE ROEH
			(0xB8CD <= code && code <= 0xB8E7) || // Lo  [27] HANGUL SYLLABLE RYOG..HANGUL SYLLABLE RYOH
			(0xB8E9 <= code && code <= 0xB903) || // Lo  [27] HANGUL SYLLABLE RUG..HANGUL SYLLABLE RUH
			(0xB905 <= code && code <= 0xB91F) || // Lo  [27] HANGUL SYLLABLE RWEOG..HANGUL SYLLABLE RWEOH
			(0xB921 <= code && code <= 0xB93B) || // Lo  [27] HANGUL SYLLABLE RWEG..HANGUL SYLLABLE RWEH
			(0xB93D <= code && code <= 0xB957) || // Lo  [27] HANGUL SYLLABLE RWIG..HANGUL SYLLABLE RWIH
			(0xB959 <= code && code <= 0xB973) || // Lo  [27] HANGUL SYLLABLE RYUG..HANGUL SYLLABLE RYUH
			(0xB975 <= code && code <= 0xB98F) || // Lo  [27] HANGUL SYLLABLE REUG..HANGUL SYLLABLE REUH
			(0xB991 <= code && code <= 0xB9AB) || // Lo  [27] HANGUL SYLLABLE RYIG..HANGUL SYLLABLE RYIH
			(0xB9AD <= code && code <= 0xB9C7) || // Lo  [27] HANGUL SYLLABLE RIG..HANGUL SYLLABLE RIH
			(0xB9C9 <= code && code <= 0xB9E3) || // Lo  [27] HANGUL SYLLABLE MAG..HANGUL SYLLABLE MAH
			(0xB9E5 <= code && code <= 0xB9FF) || // Lo  [27] HANGUL SYLLABLE MAEG..HANGUL SYLLABLE MAEH
			(0xBA01 <= code && code <= 0xBA1B) || // Lo  [27] HANGUL SYLLABLE MYAG..HANGUL SYLLABLE MYAH
			(0xBA1D <= code && code <= 0xBA37) || // Lo  [27] HANGUL SYLLABLE MYAEG..HANGUL SYLLABLE MYAEH
			(0xBA39 <= code && code <= 0xBA53) || // Lo  [27] HANGUL SYLLABLE MEOG..HANGUL SYLLABLE MEOH
			(0xBA55 <= code && code <= 0xBA6F) || // Lo  [27] HANGUL SYLLABLE MEG..HANGUL SYLLABLE MEH
			(0xBA71 <= code && code <= 0xBA8B) || // Lo  [27] HANGUL SYLLABLE MYEOG..HANGUL SYLLABLE MYEOH
			(0xBA8D <= code && code <= 0xBAA7) || // Lo  [27] HANGUL SYLLABLE MYEG..HANGUL SYLLABLE MYEH
			(0xBAA9 <= code && code <= 0xBAC3) || // Lo  [27] HANGUL SYLLABLE MOG..HANGUL SYLLABLE MOH
			(0xBAC5 <= code && code <= 0xBADF) || // Lo  [27] HANGUL SYLLABLE MWAG..HANGUL SYLLABLE MWAH
			(0xBAE1 <= code && code <= 0xBAFB) || // Lo  [27] HANGUL SYLLABLE MWAEG..HANGUL SYLLABLE MWAEH
			(0xBAFD <= code && code <= 0xBB17) || // Lo  [27] HANGUL SYLLABLE MOEG..HANGUL SYLLABLE MOEH
			(0xBB19 <= code && code <= 0xBB33) || // Lo  [27] HANGUL SYLLABLE MYOG..HANGUL SYLLABLE MYOH
			(0xBB35 <= code && code <= 0xBB4F) || // Lo  [27] HANGUL SYLLABLE MUG..HANGUL SYLLABLE MUH
			(0xBB51 <= code && code <= 0xBB6B) || // Lo  [27] HANGUL SYLLABLE MWEOG..HANGUL SYLLABLE MWEOH
			(0xBB6D <= code && code <= 0xBB87) || // Lo  [27] HANGUL SYLLABLE MWEG..HANGUL SYLLABLE MWEH
			(0xBB89 <= code && code <= 0xBBA3) || // Lo  [27] HANGUL SYLLABLE MWIG..HANGUL SYLLABLE MWIH
			(0xBBA5 <= code && code <= 0xBBBF) || // Lo  [27] HANGUL SYLLABLE MYUG..HANGUL SYLLABLE MYUH
			(0xBBC1 <= code && code <= 0xBBDB) || // Lo  [27] HANGUL SYLLABLE MEUG..HANGUL SYLLABLE MEUH
			(0xBBDD <= code && code <= 0xBBF7) || // Lo  [27] HANGUL SYLLABLE MYIG..HANGUL SYLLABLE MYIH
			(0xBBF9 <= code && code <= 0xBC13) || // Lo  [27] HANGUL SYLLABLE MIG..HANGUL SYLLABLE MIH
			(0xBC15 <= code && code <= 0xBC2F) || // Lo  [27] HANGUL SYLLABLE BAG..HANGUL SYLLABLE BAH
			(0xBC31 <= code && code <= 0xBC4B) || // Lo  [27] HANGUL SYLLABLE BAEG..HANGUL SYLLABLE BAEH
			(0xBC4D <= code && code <= 0xBC67) || // Lo  [27] HANGUL SYLLABLE BYAG..HANGUL SYLLABLE BYAH
			(0xBC69 <= code && code <= 0xBC83) || // Lo  [27] HANGUL SYLLABLE BYAEG..HANGUL SYLLABLE BYAEH
			(0xBC85 <= code && code <= 0xBC9F) || // Lo  [27] HANGUL SYLLABLE BEOG..HANGUL SYLLABLE BEOH
			(0xBCA1 <= code && code <= 0xBCBB) || // Lo  [27] HANGUL SYLLABLE BEG..HANGUL SYLLABLE BEH
			(0xBCBD <= code && code <= 0xBCD7) || // Lo  [27] HANGUL SYLLABLE BYEOG..HANGUL SYLLABLE BYEOH
			(0xBCD9 <= code && code <= 0xBCF3) || // Lo  [27] HANGUL SYLLABLE BYEG..HANGUL SYLLABLE BYEH
			(0xBCF5 <= code && code <= 0xBD0F) || // Lo  [27] HANGUL SYLLABLE BOG..HANGUL SYLLABLE BOH
			(0xBD11 <= code && code <= 0xBD2B) || // Lo  [27] HANGUL SYLLABLE BWAG..HANGUL SYLLABLE BWAH
			(0xBD2D <= code && code <= 0xBD47) || // Lo  [27] HANGUL SYLLABLE BWAEG..HANGUL SYLLABLE BWAEH
			(0xBD49 <= code && code <= 0xBD63) || // Lo  [27] HANGUL SYLLABLE BOEG..HANGUL SYLLABLE BOEH
			(0xBD65 <= code && code <= 0xBD7F) || // Lo  [27] HANGUL SYLLABLE BYOG..HANGUL SYLLABLE BYOH
			(0xBD81 <= code && code <= 0xBD9B) || // Lo  [27] HANGUL SYLLABLE BUG..HANGUL SYLLABLE BUH
			(0xBD9D <= code && code <= 0xBDB7) || // Lo  [27] HANGUL SYLLABLE BWEOG..HANGUL SYLLABLE BWEOH
			(0xBDB9 <= code && code <= 0xBDD3) || // Lo  [27] HANGUL SYLLABLE BWEG..HANGUL SYLLABLE BWEH
			(0xBDD5 <= code && code <= 0xBDEF) || // Lo  [27] HANGUL SYLLABLE BWIG..HANGUL SYLLABLE BWIH
			(0xBDF1 <= code && code <= 0xBE0B) || // Lo  [27] HANGUL SYLLABLE BYUG..HANGUL SYLLABLE BYUH
			(0xBE0D <= code && code <= 0xBE27) || // Lo  [27] HANGUL SYLLABLE BEUG..HANGUL SYLLABLE BEUH
			(0xBE29 <= code && code <= 0xBE43) || // Lo  [27] HANGUL SYLLABLE BYIG..HANGUL SYLLABLE BYIH
			(0xBE45 <= code && code <= 0xBE5F) || // Lo  [27] HANGUL SYLLABLE BIG..HANGUL SYLLABLE BIH
			(0xBE61 <= code && code <= 0xBE7B) || // Lo  [27] HANGUL SYLLABLE BBAG..HANGUL SYLLABLE BBAH
			(0xBE7D <= code && code <= 0xBE97) || // Lo  [27] HANGUL SYLLABLE BBAEG..HANGUL SYLLABLE BBAEH
			(0xBE99 <= code && code <= 0xBEB3) || // Lo  [27] HANGUL SYLLABLE BBYAG..HANGUL SYLLABLE BBYAH
			(0xBEB5 <= code && code <= 0xBECF) || // Lo  [27] HANGUL SYLLABLE BBYAEG..HANGUL SYLLABLE BBYAEH
			(0xBED1 <= code && code <= 0xBEEB) || // Lo  [27] HANGUL SYLLABLE BBEOG..HANGUL SYLLABLE BBEOH
			(0xBEED <= code && code <= 0xBF07) || // Lo  [27] HANGUL SYLLABLE BBEG..HANGUL SYLLABLE BBEH
			(0xBF09 <= code && code <= 0xBF23) || // Lo  [27] HANGUL SYLLABLE BBYEOG..HANGUL SYLLABLE BBYEOH
			(0xBF25 <= code && code <= 0xBF3F) || // Lo  [27] HANGUL SYLLABLE BBYEG..HANGUL SYLLABLE BBYEH
			(0xBF41 <= code && code <= 0xBF5B) || // Lo  [27] HANGUL SYLLABLE BBOG..HANGUL SYLLABLE BBOH
			(0xBF5D <= code && code <= 0xBF77) || // Lo  [27] HANGUL SYLLABLE BBWAG..HANGUL SYLLABLE BBWAH
			(0xBF79 <= code && code <= 0xBF93) || // Lo  [27] HANGUL SYLLABLE BBWAEG..HANGUL SYLLABLE BBWAEH
			(0xBF95 <= code && code <= 0xBFAF) || // Lo  [27] HANGUL SYLLABLE BBOEG..HANGUL SYLLABLE BBOEH
			(0xBFB1 <= code && code <= 0xBFCB) || // Lo  [27] HANGUL SYLLABLE BBYOG..HANGUL SYLLABLE BBYOH
			(0xBFCD <= code && code <= 0xBFE7) || // Lo  [27] HANGUL SYLLABLE BBUG..HANGUL SYLLABLE BBUH
			(0xBFE9 <= code && code <= 0xC003) || // Lo  [27] HANGUL SYLLABLE BBWEOG..HANGUL SYLLABLE BBWEOH
			(0xC005 <= code && code <= 0xC01F) || // Lo  [27] HANGUL SYLLABLE BBWEG..HANGUL SYLLABLE BBWEH
			(0xC021 <= code && code <= 0xC03B) || // Lo  [27] HANGUL SYLLABLE BBWIG..HANGUL SYLLABLE BBWIH
			(0xC03D <= code && code <= 0xC057) || // Lo  [27] HANGUL SYLLABLE BBYUG..HANGUL SYLLABLE BBYUH
			(0xC059 <= code && code <= 0xC073) || // Lo  [27] HANGUL SYLLABLE BBEUG..HANGUL SYLLABLE BBEUH
			(0xC075 <= code && code <= 0xC08F) || // Lo  [27] HANGUL SYLLABLE BBYIG..HANGUL SYLLABLE BBYIH
			(0xC091 <= code && code <= 0xC0AB) || // Lo  [27] HANGUL SYLLABLE BBIG..HANGUL SYLLABLE BBIH
			(0xC0AD <= code && code <= 0xC0C7) || // Lo  [27] HANGUL SYLLABLE SAG..HANGUL SYLLABLE SAH
			(0xC0C9 <= code && code <= 0xC0E3) || // Lo  [27] HANGUL SYLLABLE SAEG..HANGUL SYLLABLE SAEH
			(0xC0E5 <= code && code <= 0xC0FF) || // Lo  [27] HANGUL SYLLABLE SYAG..HANGUL SYLLABLE SYAH
			(0xC101 <= code && code <= 0xC11B) || // Lo  [27] HANGUL SYLLABLE SYAEG..HANGUL SYLLABLE SYAEH
			(0xC11D <= code && code <= 0xC137) || // Lo  [27] HANGUL SYLLABLE SEOG..HANGUL SYLLABLE SEOH
			(0xC139 <= code && code <= 0xC153) || // Lo  [27] HANGUL SYLLABLE SEG..HANGUL SYLLABLE SEH
			(0xC155 <= code && code <= 0xC16F) || // Lo  [27] HANGUL SYLLABLE SYEOG..HANGUL SYLLABLE SYEOH
			(0xC171 <= code && code <= 0xC18B) || // Lo  [27] HANGUL SYLLABLE SYEG..HANGUL SYLLABLE SYEH
			(0xC18D <= code && code <= 0xC1A7) || // Lo  [27] HANGUL SYLLABLE SOG..HANGUL SYLLABLE SOH
			(0xC1A9 <= code && code <= 0xC1C3) || // Lo  [27] HANGUL SYLLABLE SWAG..HANGUL SYLLABLE SWAH
			(0xC1C5 <= code && code <= 0xC1DF) || // Lo  [27] HANGUL SYLLABLE SWAEG..HANGUL SYLLABLE SWAEH
			(0xC1E1 <= code && code <= 0xC1FB) || // Lo  [27] HANGUL SYLLABLE SOEG..HANGUL SYLLABLE SOEH
			(0xC1FD <= code && code <= 0xC217) || // Lo  [27] HANGUL SYLLABLE SYOG..HANGUL SYLLABLE SYOH
			(0xC219 <= code && code <= 0xC233) || // Lo  [27] HANGUL SYLLABLE SUG..HANGUL SYLLABLE SUH
			(0xC235 <= code && code <= 0xC24F) || // Lo  [27] HANGUL SYLLABLE SWEOG..HANGUL SYLLABLE SWEOH
			(0xC251 <= code && code <= 0xC26B) || // Lo  [27] HANGUL SYLLABLE SWEG..HANGUL SYLLABLE SWEH
			(0xC26D <= code && code <= 0xC287) || // Lo  [27] HANGUL SYLLABLE SWIG..HANGUL SYLLABLE SWIH
			(0xC289 <= code && code <= 0xC2A3) || // Lo  [27] HANGUL SYLLABLE SYUG..HANGUL SYLLABLE SYUH
			(0xC2A5 <= code && code <= 0xC2BF) || // Lo  [27] HANGUL SYLLABLE SEUG..HANGUL SYLLABLE SEUH
			(0xC2C1 <= code && code <= 0xC2DB) || // Lo  [27] HANGUL SYLLABLE SYIG..HANGUL SYLLABLE SYIH
			(0xC2DD <= code && code <= 0xC2F7) || // Lo  [27] HANGUL SYLLABLE SIG..HANGUL SYLLABLE SIH
			(0xC2F9 <= code && code <= 0xC313) || // Lo  [27] HANGUL SYLLABLE SSAG..HANGUL SYLLABLE SSAH
			(0xC315 <= code && code <= 0xC32F) || // Lo  [27] HANGUL SYLLABLE SSAEG..HANGUL SYLLABLE SSAEH
			(0xC331 <= code && code <= 0xC34B) || // Lo  [27] HANGUL SYLLABLE SSYAG..HANGUL SYLLABLE SSYAH
			(0xC34D <= code && code <= 0xC367) || // Lo  [27] HANGUL SYLLABLE SSYAEG..HANGUL SYLLABLE SSYAEH
			(0xC369 <= code && code <= 0xC383) || // Lo  [27] HANGUL SYLLABLE SSEOG..HANGUL SYLLABLE SSEOH
			(0xC385 <= code && code <= 0xC39F) || // Lo  [27] HANGUL SYLLABLE SSEG..HANGUL SYLLABLE SSEH
			(0xC3A1 <= code && code <= 0xC3BB) || // Lo  [27] HANGUL SYLLABLE SSYEOG..HANGUL SYLLABLE SSYEOH
			(0xC3BD <= code && code <= 0xC3D7) || // Lo  [27] HANGUL SYLLABLE SSYEG..HANGUL SYLLABLE SSYEH
			(0xC3D9 <= code && code <= 0xC3F3) || // Lo  [27] HANGUL SYLLABLE SSOG..HANGUL SYLLABLE SSOH
			(0xC3F5 <= code && code <= 0xC40F) || // Lo  [27] HANGUL SYLLABLE SSWAG..HANGUL SYLLABLE SSWAH
			(0xC411 <= code && code <= 0xC42B) || // Lo  [27] HANGUL SYLLABLE SSWAEG..HANGUL SYLLABLE SSWAEH
			(0xC42D <= code && code <= 0xC447) || // Lo  [27] HANGUL SYLLABLE SSOEG..HANGUL SYLLABLE SSOEH
			(0xC449 <= code && code <= 0xC463) || // Lo  [27] HANGUL SYLLABLE SSYOG..HANGUL SYLLABLE SSYOH
			(0xC465 <= code && code <= 0xC47F) || // Lo  [27] HANGUL SYLLABLE SSUG..HANGUL SYLLABLE SSUH
			(0xC481 <= code && code <= 0xC49B) || // Lo  [27] HANGUL SYLLABLE SSWEOG..HANGUL SYLLABLE SSWEOH
			(0xC49D <= code && code <= 0xC4B7) || // Lo  [27] HANGUL SYLLABLE SSWEG..HANGUL SYLLABLE SSWEH
			(0xC4B9 <= code && code <= 0xC4D3) || // Lo  [27] HANGUL SYLLABLE SSWIG..HANGUL SYLLABLE SSWIH
			(0xC4D5 <= code && code <= 0xC4EF) || // Lo  [27] HANGUL SYLLABLE SSYUG..HANGUL SYLLABLE SSYUH
			(0xC4F1 <= code && code <= 0xC50B) || // Lo  [27] HANGUL SYLLABLE SSEUG..HANGUL SYLLABLE SSEUH
			(0xC50D <= code && code <= 0xC527) || // Lo  [27] HANGUL SYLLABLE SSYIG..HANGUL SYLLABLE SSYIH
			(0xC529 <= code && code <= 0xC543) || // Lo  [27] HANGUL SYLLABLE SSIG..HANGUL SYLLABLE SSIH
			(0xC545 <= code && code <= 0xC55F) || // Lo  [27] HANGUL SYLLABLE AG..HANGUL SYLLABLE AH
			(0xC561 <= code && code <= 0xC57B) || // Lo  [27] HANGUL SYLLABLE AEG..HANGUL SYLLABLE AEH
			(0xC57D <= code && code <= 0xC597) || // Lo  [27] HANGUL SYLLABLE YAG..HANGUL SYLLABLE YAH
			(0xC599 <= code && code <= 0xC5B3) || // Lo  [27] HANGUL SYLLABLE YAEG..HANGUL SYLLABLE YAEH
			(0xC5B5 <= code && code <= 0xC5CF) || // Lo  [27] HANGUL SYLLABLE EOG..HANGUL SYLLABLE EOH
			(0xC5D1 <= code && code <= 0xC5EB) || // Lo  [27] HANGUL SYLLABLE EG..HANGUL SYLLABLE EH
			(0xC5ED <= code && code <= 0xC607) || // Lo  [27] HANGUL SYLLABLE YEOG..HANGUL SYLLABLE YEOH
			(0xC609 <= code && code <= 0xC623) || // Lo  [27] HANGUL SYLLABLE YEG..HANGUL SYLLABLE YEH
			(0xC625 <= code && code <= 0xC63F) || // Lo  [27] HANGUL SYLLABLE OG..HANGUL SYLLABLE OH
			(0xC641 <= code && code <= 0xC65B) || // Lo  [27] HANGUL SYLLABLE WAG..HANGUL SYLLABLE WAH
			(0xC65D <= code && code <= 0xC677) || // Lo  [27] HANGUL SYLLABLE WAEG..HANGUL SYLLABLE WAEH
			(0xC679 <= code && code <= 0xC693) || // Lo  [27] HANGUL SYLLABLE OEG..HANGUL SYLLABLE OEH
			(0xC695 <= code && code <= 0xC6AF) || // Lo  [27] HANGUL SYLLABLE YOG..HANGUL SYLLABLE YOH
			(0xC6B1 <= code && code <= 0xC6CB) || // Lo  [27] HANGUL SYLLABLE UG..HANGUL SYLLABLE UH
			(0xC6CD <= code && code <= 0xC6E7) || // Lo  [27] HANGUL SYLLABLE WEOG..HANGUL SYLLABLE WEOH
			(0xC6E9 <= code && code <= 0xC703) || // Lo  [27] HANGUL SYLLABLE WEG..HANGUL SYLLABLE WEH
			(0xC705 <= code && code <= 0xC71F) || // Lo  [27] HANGUL SYLLABLE WIG..HANGUL SYLLABLE WIH
			(0xC721 <= code && code <= 0xC73B) || // Lo  [27] HANGUL SYLLABLE YUG..HANGUL SYLLABLE YUH
			(0xC73D <= code && code <= 0xC757) || // Lo  [27] HANGUL SYLLABLE EUG..HANGUL SYLLABLE EUH
			(0xC759 <= code && code <= 0xC773) || // Lo  [27] HANGUL SYLLABLE YIG..HANGUL SYLLABLE YIH
			(0xC775 <= code && code <= 0xC78F) || // Lo  [27] HANGUL SYLLABLE IG..HANGUL SYLLABLE IH
			(0xC791 <= code && code <= 0xC7AB) || // Lo  [27] HANGUL SYLLABLE JAG..HANGUL SYLLABLE JAH
			(0xC7AD <= code && code <= 0xC7C7) || // Lo  [27] HANGUL SYLLABLE JAEG..HANGUL SYLLABLE JAEH
			(0xC7C9 <= code && code <= 0xC7E3) || // Lo  [27] HANGUL SYLLABLE JYAG..HANGUL SYLLABLE JYAH
			(0xC7E5 <= code && code <= 0xC7FF) || // Lo  [27] HANGUL SYLLABLE JYAEG..HANGUL SYLLABLE JYAEH
			(0xC801 <= code && code <= 0xC81B) || // Lo  [27] HANGUL SYLLABLE JEOG..HANGUL SYLLABLE JEOH
			(0xC81D <= code && code <= 0xC837) || // Lo  [27] HANGUL SYLLABLE JEG..HANGUL SYLLABLE JEH
			(0xC839 <= code && code <= 0xC853) || // Lo  [27] HANGUL SYLLABLE JYEOG..HANGUL SYLLABLE JYEOH
			(0xC855 <= code && code <= 0xC86F) || // Lo  [27] HANGUL SYLLABLE JYEG..HANGUL SYLLABLE JYEH
			(0xC871 <= code && code <= 0xC88B) || // Lo  [27] HANGUL SYLLABLE JOG..HANGUL SYLLABLE JOH
			(0xC88D <= code && code <= 0xC8A7) || // Lo  [27] HANGUL SYLLABLE JWAG..HANGUL SYLLABLE JWAH
			(0xC8A9 <= code && code <= 0xC8C3) || // Lo  [27] HANGUL SYLLABLE JWAEG..HANGUL SYLLABLE JWAEH
			(0xC8C5 <= code && code <= 0xC8DF) || // Lo  [27] HANGUL SYLLABLE JOEG..HANGUL SYLLABLE JOEH
			(0xC8E1 <= code && code <= 0xC8FB) || // Lo  [27] HANGUL SYLLABLE JYOG..HANGUL SYLLABLE JYOH
			(0xC8FD <= code && code <= 0xC917) || // Lo  [27] HANGUL SYLLABLE JUG..HANGUL SYLLABLE JUH
			(0xC919 <= code && code <= 0xC933) || // Lo  [27] HANGUL SYLLABLE JWEOG..HANGUL SYLLABLE JWEOH
			(0xC935 <= code && code <= 0xC94F) || // Lo  [27] HANGUL SYLLABLE JWEG..HANGUL SYLLABLE JWEH
			(0xC951 <= code && code <= 0xC96B) || // Lo  [27] HANGUL SYLLABLE JWIG..HANGUL SYLLABLE JWIH
			(0xC96D <= code && code <= 0xC987) || // Lo  [27] HANGUL SYLLABLE JYUG..HANGUL SYLLABLE JYUH
			(0xC989 <= code && code <= 0xC9A3) || // Lo  [27] HANGUL SYLLABLE JEUG..HANGUL SYLLABLE JEUH
			(0xC9A5 <= code && code <= 0xC9BF) || // Lo  [27] HANGUL SYLLABLE JYIG..HANGUL SYLLABLE JYIH
			(0xC9C1 <= code && code <= 0xC9DB) || // Lo  [27] HANGUL SYLLABLE JIG..HANGUL SYLLABLE JIH
			(0xC9DD <= code && code <= 0xC9F7) || // Lo  [27] HANGUL SYLLABLE JJAG..HANGUL SYLLABLE JJAH
			(0xC9F9 <= code && code <= 0xCA13) || // Lo  [27] HANGUL SYLLABLE JJAEG..HANGUL SYLLABLE JJAEH
			(0xCA15 <= code && code <= 0xCA2F) || // Lo  [27] HANGUL SYLLABLE JJYAG..HANGUL SYLLABLE JJYAH
			(0xCA31 <= code && code <= 0xCA4B) || // Lo  [27] HANGUL SYLLABLE JJYAEG..HANGUL SYLLABLE JJYAEH
			(0xCA4D <= code && code <= 0xCA67) || // Lo  [27] HANGUL SYLLABLE JJEOG..HANGUL SYLLABLE JJEOH
			(0xCA69 <= code && code <= 0xCA83) || // Lo  [27] HANGUL SYLLABLE JJEG..HANGUL SYLLABLE JJEH
			(0xCA85 <= code && code <= 0xCA9F) || // Lo  [27] HANGUL SYLLABLE JJYEOG..HANGUL SYLLABLE JJYEOH
			(0xCAA1 <= code && code <= 0xCABB) || // Lo  [27] HANGUL SYLLABLE JJYEG..HANGUL SYLLABLE JJYEH
			(0xCABD <= code && code <= 0xCAD7) || // Lo  [27] HANGUL SYLLABLE JJOG..HANGUL SYLLABLE JJOH
			(0xCAD9 <= code && code <= 0xCAF3) || // Lo  [27] HANGUL SYLLABLE JJWAG..HANGUL SYLLABLE JJWAH
			(0xCAF5 <= code && code <= 0xCB0F) || // Lo  [27] HANGUL SYLLABLE JJWAEG..HANGUL SYLLABLE JJWAEH
			(0xCB11 <= code && code <= 0xCB2B) || // Lo  [27] HANGUL SYLLABLE JJOEG..HANGUL SYLLABLE JJOEH
			(0xCB2D <= code && code <= 0xCB47) || // Lo  [27] HANGUL SYLLABLE JJYOG..HANGUL SYLLABLE JJYOH
			(0xCB49 <= code && code <= 0xCB63) || // Lo  [27] HANGUL SYLLABLE JJUG..HANGUL SYLLABLE JJUH
			(0xCB65 <= code && code <= 0xCB7F) || // Lo  [27] HANGUL SYLLABLE JJWEOG..HANGUL SYLLABLE JJWEOH
			(0xCB81 <= code && code <= 0xCB9B) || // Lo  [27] HANGUL SYLLABLE JJWEG..HANGUL SYLLABLE JJWEH
			(0xCB9D <= code && code <= 0xCBB7) || // Lo  [27] HANGUL SYLLABLE JJWIG..HANGUL SYLLABLE JJWIH
			(0xCBB9 <= code && code <= 0xCBD3) || // Lo  [27] HANGUL SYLLABLE JJYUG..HANGUL SYLLABLE JJYUH
			(0xCBD5 <= code && code <= 0xCBEF) || // Lo  [27] HANGUL SYLLABLE JJEUG..HANGUL SYLLABLE JJEUH
			(0xCBF1 <= code && code <= 0xCC0B) || // Lo  [27] HANGUL SYLLABLE JJYIG..HANGUL SYLLABLE JJYIH
			(0xCC0D <= code && code <= 0xCC27) || // Lo  [27] HANGUL SYLLABLE JJIG..HANGUL SYLLABLE JJIH
			(0xCC29 <= code && code <= 0xCC43) || // Lo  [27] HANGUL SYLLABLE CAG..HANGUL SYLLABLE CAH
			(0xCC45 <= code && code <= 0xCC5F) || // Lo  [27] HANGUL SYLLABLE CAEG..HANGUL SYLLABLE CAEH
			(0xCC61 <= code && code <= 0xCC7B) || // Lo  [27] HANGUL SYLLABLE CYAG..HANGUL SYLLABLE CYAH
			(0xCC7D <= code && code <= 0xCC97) || // Lo  [27] HANGUL SYLLABLE CYAEG..HANGUL SYLLABLE CYAEH
			(0xCC99 <= code && code <= 0xCCB3) || // Lo  [27] HANGUL SYLLABLE CEOG..HANGUL SYLLABLE CEOH
			(0xCCB5 <= code && code <= 0xCCCF) || // Lo  [27] HANGUL SYLLABLE CEG..HANGUL SYLLABLE CEH
			(0xCCD1 <= code && code <= 0xCCEB) || // Lo  [27] HANGUL SYLLABLE CYEOG..HANGUL SYLLABLE CYEOH
			(0xCCED <= code && code <= 0xCD07) || // Lo  [27] HANGUL SYLLABLE CYEG..HANGUL SYLLABLE CYEH
			(0xCD09 <= code && code <= 0xCD23) || // Lo  [27] HANGUL SYLLABLE COG..HANGUL SYLLABLE COH
			(0xCD25 <= code && code <= 0xCD3F) || // Lo  [27] HANGUL SYLLABLE CWAG..HANGUL SYLLABLE CWAH
			(0xCD41 <= code && code <= 0xCD5B) || // Lo  [27] HANGUL SYLLABLE CWAEG..HANGUL SYLLABLE CWAEH
			(0xCD5D <= code && code <= 0xCD77) || // Lo  [27] HANGUL SYLLABLE COEG..HANGUL SYLLABLE COEH
			(0xCD79 <= code && code <= 0xCD93) || // Lo  [27] HANGUL SYLLABLE CYOG..HANGUL SYLLABLE CYOH
			(0xCD95 <= code && code <= 0xCDAF) || // Lo  [27] HANGUL SYLLABLE CUG..HANGUL SYLLABLE CUH
			(0xCDB1 <= code && code <= 0xCDCB) || // Lo  [27] HANGUL SYLLABLE CWEOG..HANGUL SYLLABLE CWEOH
			(0xCDCD <= code && code <= 0xCDE7) || // Lo  [27] HANGUL SYLLABLE CWEG..HANGUL SYLLABLE CWEH
			(0xCDE9 <= code && code <= 0xCE03) || // Lo  [27] HANGUL SYLLABLE CWIG..HANGUL SYLLABLE CWIH
			(0xCE05 <= code && code <= 0xCE1F) || // Lo  [27] HANGUL SYLLABLE CYUG..HANGUL SYLLABLE CYUH
			(0xCE21 <= code && code <= 0xCE3B) || // Lo  [27] HANGUL SYLLABLE CEUG..HANGUL SYLLABLE CEUH
			(0xCE3D <= code && code <= 0xCE57) || // Lo  [27] HANGUL SYLLABLE CYIG..HANGUL SYLLABLE CYIH
			(0xCE59 <= code && code <= 0xCE73) || // Lo  [27] HANGUL SYLLABLE CIG..HANGUL SYLLABLE CIH
			(0xCE75 <= code && code <= 0xCE8F) || // Lo  [27] HANGUL SYLLABLE KAG..HANGUL SYLLABLE KAH
			(0xCE91 <= code && code <= 0xCEAB) || // Lo  [27] HANGUL SYLLABLE KAEG..HANGUL SYLLABLE KAEH
			(0xCEAD <= code && code <= 0xCEC7) || // Lo  [27] HANGUL SYLLABLE KYAG..HANGUL SYLLABLE KYAH
			(0xCEC9 <= code && code <= 0xCEE3) || // Lo  [27] HANGUL SYLLABLE KYAEG..HANGUL SYLLABLE KYAEH
			(0xCEE5 <= code && code <= 0xCEFF) || // Lo  [27] HANGUL SYLLABLE KEOG..HANGUL SYLLABLE KEOH
			(0xCF01 <= code && code <= 0xCF1B) || // Lo  [27] HANGUL SYLLABLE KEG..HANGUL SYLLABLE KEH
			(0xCF1D <= code && code <= 0xCF37) || // Lo  [27] HANGUL SYLLABLE KYEOG..HANGUL SYLLABLE KYEOH
			(0xCF39 <= code && code <= 0xCF53) || // Lo  [27] HANGUL SYLLABLE KYEG..HANGUL SYLLABLE KYEH
			(0xCF55 <= code && code <= 0xCF6F) || // Lo  [27] HANGUL SYLLABLE KOG..HANGUL SYLLABLE KOH
			(0xCF71 <= code && code <= 0xCF8B) || // Lo  [27] HANGUL SYLLABLE KWAG..HANGUL SYLLABLE KWAH
			(0xCF8D <= code && code <= 0xCFA7) || // Lo  [27] HANGUL SYLLABLE KWAEG..HANGUL SYLLABLE KWAEH
			(0xCFA9 <= code && code <= 0xCFC3) || // Lo  [27] HANGUL SYLLABLE KOEG..HANGUL SYLLABLE KOEH
			(0xCFC5 <= code && code <= 0xCFDF) || // Lo  [27] HANGUL SYLLABLE KYOG..HANGUL SYLLABLE KYOH
			(0xCFE1 <= code && code <= 0xCFFB) || // Lo  [27] HANGUL SYLLABLE KUG..HANGUL SYLLABLE KUH
			(0xCFFD <= code && code <= 0xD017) || // Lo  [27] HANGUL SYLLABLE KWEOG..HANGUL SYLLABLE KWEOH
			(0xD019 <= code && code <= 0xD033) || // Lo  [27] HANGUL SYLLABLE KWEG..HANGUL SYLLABLE KWEH
			(0xD035 <= code && code <= 0xD04F) || // Lo  [27] HANGUL SYLLABLE KWIG..HANGUL SYLLABLE KWIH
			(0xD051 <= code && code <= 0xD06B) || // Lo  [27] HANGUL SYLLABLE KYUG..HANGUL SYLLABLE KYUH
			(0xD06D <= code && code <= 0xD087) || // Lo  [27] HANGUL SYLLABLE KEUG..HANGUL SYLLABLE KEUH
			(0xD089 <= code && code <= 0xD0A3) || // Lo  [27] HANGUL SYLLABLE KYIG..HANGUL SYLLABLE KYIH
			(0xD0A5 <= code && code <= 0xD0BF) || // Lo  [27] HANGUL SYLLABLE KIG..HANGUL SYLLABLE KIH
			(0xD0C1 <= code && code <= 0xD0DB) || // Lo  [27] HANGUL SYLLABLE TAG..HANGUL SYLLABLE TAH
			(0xD0DD <= code && code <= 0xD0F7) || // Lo  [27] HANGUL SYLLABLE TAEG..HANGUL SYLLABLE TAEH
			(0xD0F9 <= code && code <= 0xD113) || // Lo  [27] HANGUL SYLLABLE TYAG..HANGUL SYLLABLE TYAH
			(0xD115 <= code && code <= 0xD12F) || // Lo  [27] HANGUL SYLLABLE TYAEG..HANGUL SYLLABLE TYAEH
			(0xD131 <= code && code <= 0xD14B) || // Lo  [27] HANGUL SYLLABLE TEOG..HANGUL SYLLABLE TEOH
			(0xD14D <= code && code <= 0xD167) || // Lo  [27] HANGUL SYLLABLE TEG..HANGUL SYLLABLE TEH
			(0xD169 <= code && code <= 0xD183) || // Lo  [27] HANGUL SYLLABLE TYEOG..HANGUL SYLLABLE TYEOH
			(0xD185 <= code && code <= 0xD19F) || // Lo  [27] HANGUL SYLLABLE TYEG..HANGUL SYLLABLE TYEH
			(0xD1A1 <= code && code <= 0xD1BB) || // Lo  [27] HANGUL SYLLABLE TOG..HANGUL SYLLABLE TOH
			(0xD1BD <= code && code <= 0xD1D7) || // Lo  [27] HANGUL SYLLABLE TWAG..HANGUL SYLLABLE TWAH
			(0xD1D9 <= code && code <= 0xD1F3) || // Lo  [27] HANGUL SYLLABLE TWAEG..HANGUL SYLLABLE TWAEH
			(0xD1F5 <= code && code <= 0xD20F) || // Lo  [27] HANGUL SYLLABLE TOEG..HANGUL SYLLABLE TOEH
			(0xD211 <= code && code <= 0xD22B) || // Lo  [27] HANGUL SYLLABLE TYOG..HANGUL SYLLABLE TYOH
			(0xD22D <= code && code <= 0xD247) || // Lo  [27] HANGUL SYLLABLE TUG..HANGUL SYLLABLE TUH
			(0xD249 <= code && code <= 0xD263) || // Lo  [27] HANGUL SYLLABLE TWEOG..HANGUL SYLLABLE TWEOH
			(0xD265 <= code && code <= 0xD27F) || // Lo  [27] HANGUL SYLLABLE TWEG..HANGUL SYLLABLE TWEH
			(0xD281 <= code && code <= 0xD29B) || // Lo  [27] HANGUL SYLLABLE TWIG..HANGUL SYLLABLE TWIH
			(0xD29D <= code && code <= 0xD2B7) || // Lo  [27] HANGUL SYLLABLE TYUG..HANGUL SYLLABLE TYUH
			(0xD2B9 <= code && code <= 0xD2D3) || // Lo  [27] HANGUL SYLLABLE TEUG..HANGUL SYLLABLE TEUH
			(0xD2D5 <= code && code <= 0xD2EF) || // Lo  [27] HANGUL SYLLABLE TYIG..HANGUL SYLLABLE TYIH
			(0xD2F1 <= code && code <= 0xD30B) || // Lo  [27] HANGUL SYLLABLE TIG..HANGUL SYLLABLE TIH
			(0xD30D <= code && code <= 0xD327) || // Lo  [27] HANGUL SYLLABLE PAG..HANGUL SYLLABLE PAH
			(0xD329 <= code && code <= 0xD343) || // Lo  [27] HANGUL SYLLABLE PAEG..HANGUL SYLLABLE PAEH
			(0xD345 <= code && code <= 0xD35F) || // Lo  [27] HANGUL SYLLABLE PYAG..HANGUL SYLLABLE PYAH
			(0xD361 <= code && code <= 0xD37B) || // Lo  [27] HANGUL SYLLABLE PYAEG..HANGUL SYLLABLE PYAEH
			(0xD37D <= code && code <= 0xD397) || // Lo  [27] HANGUL SYLLABLE PEOG..HANGUL SYLLABLE PEOH
			(0xD399 <= code && code <= 0xD3B3) || // Lo  [27] HANGUL SYLLABLE PEG..HANGUL SYLLABLE PEH
			(0xD3B5 <= code && code <= 0xD3CF) || // Lo  [27] HANGUL SYLLABLE PYEOG..HANGUL SYLLABLE PYEOH
			(0xD3D1 <= code && code <= 0xD3EB) || // Lo  [27] HANGUL SYLLABLE PYEG..HANGUL SYLLABLE PYEH
			(0xD3ED <= code && code <= 0xD407) || // Lo  [27] HANGUL SYLLABLE POG..HANGUL SYLLABLE POH
			(0xD409 <= code && code <= 0xD423) || // Lo  [27] HANGUL SYLLABLE PWAG..HANGUL SYLLABLE PWAH
			(0xD425 <= code && code <= 0xD43F) || // Lo  [27] HANGUL SYLLABLE PWAEG..HANGUL SYLLABLE PWAEH
			(0xD441 <= code && code <= 0xD45B) || // Lo  [27] HANGUL SYLLABLE POEG..HANGUL SYLLABLE POEH
			(0xD45D <= code && code <= 0xD477) || // Lo  [27] HANGUL SYLLABLE PYOG..HANGUL SYLLABLE PYOH
			(0xD479 <= code && code <= 0xD493) || // Lo  [27] HANGUL SYLLABLE PUG..HANGUL SYLLABLE PUH
			(0xD495 <= code && code <= 0xD4AF) || // Lo  [27] HANGUL SYLLABLE PWEOG..HANGUL SYLLABLE PWEOH
			(0xD4B1 <= code && code <= 0xD4CB) || // Lo  [27] HANGUL SYLLABLE PWEG..HANGUL SYLLABLE PWEH
			(0xD4CD <= code && code <= 0xD4E7) || // Lo  [27] HANGUL SYLLABLE PWIG..HANGUL SYLLABLE PWIH
			(0xD4E9 <= code && code <= 0xD503) || // Lo  [27] HANGUL SYLLABLE PYUG..HANGUL SYLLABLE PYUH
			(0xD505 <= code && code <= 0xD51F) || // Lo  [27] HANGUL SYLLABLE PEUG..HANGUL SYLLABLE PEUH
			(0xD521 <= code && code <= 0xD53B) || // Lo  [27] HANGUL SYLLABLE PYIG..HANGUL SYLLABLE PYIH
			(0xD53D <= code && code <= 0xD557) || // Lo  [27] HANGUL SYLLABLE PIG..HANGUL SYLLABLE PIH
			(0xD559 <= code && code <= 0xD573) || // Lo  [27] HANGUL SYLLABLE HAG..HANGUL SYLLABLE HAH
			(0xD575 <= code && code <= 0xD58F) || // Lo  [27] HANGUL SYLLABLE HAEG..HANGUL SYLLABLE HAEH
			(0xD591 <= code && code <= 0xD5AB) || // Lo  [27] HANGUL SYLLABLE HYAG..HANGUL SYLLABLE HYAH
			(0xD5AD <= code && code <= 0xD5C7) || // Lo  [27] HANGUL SYLLABLE HYAEG..HANGUL SYLLABLE HYAEH
			(0xD5C9 <= code && code <= 0xD5E3) || // Lo  [27] HANGUL SYLLABLE HEOG..HANGUL SYLLABLE HEOH
			(0xD5E5 <= code && code <= 0xD5FF) || // Lo  [27] HANGUL SYLLABLE HEG..HANGUL SYLLABLE HEH
			(0xD601 <= code && code <= 0xD61B) || // Lo  [27] HANGUL SYLLABLE HYEOG..HANGUL SYLLABLE HYEOH
			(0xD61D <= code && code <= 0xD637) || // Lo  [27] HANGUL SYLLABLE HYEG..HANGUL SYLLABLE HYEH
			(0xD639 <= code && code <= 0xD653) || // Lo  [27] HANGUL SYLLABLE HOG..HANGUL SYLLABLE HOH
			(0xD655 <= code && code <= 0xD66F) || // Lo  [27] HANGUL SYLLABLE HWAG..HANGUL SYLLABLE HWAH
			(0xD671 <= code && code <= 0xD68B) || // Lo  [27] HANGUL SYLLABLE HWAEG..HANGUL SYLLABLE HWAEH
			(0xD68D <= code && code <= 0xD6A7) || // Lo  [27] HANGUL SYLLABLE HOEG..HANGUL SYLLABLE HOEH
			(0xD6A9 <= code && code <= 0xD6C3) || // Lo  [27] HANGUL SYLLABLE HYOG..HANGUL SYLLABLE HYOH
			(0xD6C5 <= code && code <= 0xD6DF) || // Lo  [27] HANGUL SYLLABLE HUG..HANGUL SYLLABLE HUH
			(0xD6E1 <= code && code <= 0xD6FB) || // Lo  [27] HANGUL SYLLABLE HWEOG..HANGUL SYLLABLE HWEOH
			(0xD6FD <= code && code <= 0xD717) || // Lo  [27] HANGUL SYLLABLE HWEG..HANGUL SYLLABLE HWEH
			(0xD719 <= code && code <= 0xD733) || // Lo  [27] HANGUL SYLLABLE HWIG..HANGUL SYLLABLE HWIH
			(0xD735 <= code && code <= 0xD74F) || // Lo  [27] HANGUL SYLLABLE HYUG..HANGUL SYLLABLE HYUH
			(0xD751 <= code && code <= 0xD76B) || // Lo  [27] HANGUL SYLLABLE HEUG..HANGUL SYLLABLE HEUH
			(0xD76D <= code && code <= 0xD787) || // Lo  [27] HANGUL SYLLABLE HYIG..HANGUL SYLLABLE HYIH
			(0xD789 <= code && code <= 0xD7A3) // Lo  [27] HANGUL SYLLABLE HIG..HANGUL SYLLABLE HIH
			){
				return LVT;
			}
			
			if(
			0x261D == code || // So       WHITE UP POINTING INDEX
			0x26F9 == code || // So       PERSON WITH BALL
			(0x270A <= code && code <= 0x270D) || // So   [4] RAISED FIST..WRITING HAND
			0x1F385 == code || // So       FATHER CHRISTMAS
			(0x1F3C2 <= code && code <= 0x1F3C4) || // So   [3] SNOWBOARDER..SURFER
			0x1F3C7 == code || // So       HORSE RACING
			(0x1F3CA <= code && code <= 0x1F3CC) || // So   [3] SWIMMER..GOLFER
			(0x1F442 <= code && code <= 0x1F443) || // So   [2] EAR..NOSE
			(0x1F446 <= code && code <= 0x1F450) || // So  [11] WHITE UP POINTING BACKHAND INDEX..OPEN HANDS SIGN
			0x1F46E == code || // So       POLICE OFFICER
			(0x1F470 <= code && code <= 0x1F478) || // So   [9] BRIDE WITH VEIL..PRINCESS
			0x1F47C == code || // So       BABY ANGEL
			(0x1F481 <= code && code <= 0x1F483) || // So   [3] INFORMATION DESK PERSON..DANCER
			(0x1F485 <= code && code <= 0x1F487) || // So   [3] NAIL POLISH..HAIRCUT
			0x1F4AA == code || // So       FLEXED BICEPS
			(0x1F574 <= code && code <= 0x1F575) || // So   [2] MAN IN BUSINESS SUIT LEVITATING..SLEUTH OR SPY
			0x1F57A == code || // So       MAN DANCING
			0x1F590 == code || // So       RAISED HAND WITH FINGERS SPLAYED
			(0x1F595 <= code && code <= 0x1F596) || // So   [2] REVERSED HAND WITH MIDDLE FINGER EXTENDED..RAISED HAND WITH PART BETWEEN MIDDLE AND RING FINGERS
			(0x1F645 <= code && code <= 0x1F647) || // So   [3] FACE WITH NO GOOD GESTURE..PERSON BOWING DEEPLY
			(0x1F64B <= code && code <= 0x1F64F) || // So   [5] HAPPY PERSON RAISING ONE HAND..PERSON WITH FOLDED HANDS
			0x1F6A3 == code || // So       ROWBOAT
			(0x1F6B4 <= code && code <= 0x1F6B6) || // So   [3] BICYCLIST..PEDESTRIAN
			0x1F6C0 == code || // So       BATH
			0x1F6CC == code || // So       SLEEPING ACCOMMODATION
			(0x1F918 <= code && code <= 0x1F91C) || // So   [5] SIGN OF THE HORNS..RIGHT-FACING FIST
			(0x1F91E <= code && code <= 0x1F91F) || // So   [2] HAND WITH INDEX AND MIDDLE FINGERS CROSSED..I LOVE YOU HAND SIGN
			0x1F926 == code || // So       FACE PALM
			(0x1F930 <= code && code <= 0x1F939) || // So  [10] PREGNANT WOMAN..JUGGLING
			(0x1F93D <= code && code <= 0x1F93E) || // So   [2] WATER POLO..HANDBALL
			(0x1F9D1 <= code && code <= 0x1F9DD) // So  [13] ADULT..ELF
			){
				return E_Base;
			}

			if(
			(0x1F3FB <= code && code <= 0x1F3FF) // Sk   [5] EMOJI MODIFIER FITZPATRICK TYPE-1-2..EMOJI MODIFIER FITZPATRICK TYPE-6
			){
				return E_Modifier;
			}

			if(
			0x200D == code // Cf       ZERO WIDTH JOINER
			){
				return ZWJ;
			}

			if(
			0x2640 == code || // So       FEMALE SIGN
			0x2642 == code || // So       MALE SIGN
			(0x2695 <= code && code <= 0x2696) || // So   [2] STAFF OF AESCULAPIUS..SCALES
			0x2708 == code || // So       AIRPLANE
			0x2764 == code || // So       HEAVY BLACK HEART
			0x1F308 == code || // So       RAINBOW
			0x1F33E == code || // So       EAR OF RICE
			0x1F373 == code || // So       COOKING
			0x1F393 == code || // So       GRADUATION CAP
			0x1F3A4 == code || // So       MICROPHONE
			0x1F3A8 == code || // So       ARTIST PALETTE
			0x1F3EB == code || // So       SCHOOL
			0x1F3ED == code || // So       FACTORY
			0x1F48B == code || // So       KISS MARK
			(0x1F4BB <= code && code <= 0x1F4BC) || // So   [2] PERSONAL COMPUTER..BRIEFCASE
			0x1F527 == code || // So       WRENCH
			0x1F52C == code || // So       MICROSCOPE
			0x1F5E8 == code || // So       LEFT SPEECH BUBBLE
			0x1F680 == code || // So       ROCKET
			0x1F692 == code // So       FIRE ENGINE
			){
				return Glue_After_Zwj;
			}

			if(
			(0x1F466 <= code && code <= 0x1F469) // So   [4] BOY..WOMAN
			){
				return E_Base_GAZ;
			}
			
			
			//all unlisted characters have a grapheme break property of "Other"
			return Other;
		}
		return this;
	}

	if (module.exports) {
	    module.exports = GraphemeSplitter;
	} 
} (graphemeSplitter));

var graphemeSplitterExports = graphemeSplitter.exports;
var GraphemeSplitter = /*@__PURE__*/getDefaultExportFromCjs(graphemeSplitterExports);

var img = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA4CAYAAACohjseAAAACXBIWXMAAAsTAAALEwEAmpwYAAADyklEQVRoge2aW4hOURTH17jlFiKXwpgHwwOJB5TiYeJj5DJhhDJKzUSUGmFQjNSYjDLF5J7xRAopdyKZ5AEvLk8kD+7MuPfJdf3bn5qa2Zez9z5nj3z/+vU9nbXW/5z97bPP2psoq6z+a3Vg8pkZTBmzhlnHrGQWMilmcLDqLJXHrGUuMJ+Z3wY8Y04wK5h+iVdsoHbMXOY684vMTMn4zpxjijNxg6uIeUhupmQg7iIKZDSXOROhWBduMSOSsSU0i3nn2YSONLM6CXMV5P4/c6GOaR+XuR0WBWEmvcnUMzVMNbObOcZcY95bxNwZh7nKCAVg+O5iJjIdNXHxNMYzW5hXhvExgqb5MgYtNUzcyJQz3S3zdCaxCDB5qhctc7TQKOarQcLj5O8lPZC5pMl310eiTsx9TaIfJO66b2HoVpF8Qqv2kaRCEvwvWHXM85FIoTnU8pV0h+nmGhjDTbWWxJ0tcU1iqD4kFup7mFISI8tZGAKJT9VJCbPgB5KbwxrRy10MpSWkfnqTw5XmR5dJbq4hYF1e1JX5RnKDxeFK86MpJDfXRGK18U9rI8kNngxYlzcdIbnBck85ejKFJBpRPsBaeRIZfvk3kNxgoQdzBcxLRQ4XUHsvXQH3FAFc2wY9yPyTyJZ9uiKeKi7OdTQ4NWZz4IWLwaGOBlMJGEzrilB9Hk1wNIgh+jpmg290RdxQXFzqaBDCMG2M0eBjXQH1iosPejAI9WcWk9insOGQosaruuQbFBc/8uPPWZtJXmOd7uICxcVgXCwlRxM63bL6lusu1i22a2Mp2Vx5zE+S1zfcJMh5RYC3JJZaobRXUhd4YhqkRBEEVHkt2VzYLFWNrhrTQGhZNCkCfSHRu0xSOaTezUITbFiUgNsUwUDSn07lmnoid7oHMB81QVd5KNxEWOKphiae3libwOsVQQFms/lutWuFAwxpTR1HbYOjPfFAExzd7WXW5cuF/xzeaaonB7C2ddoTGU36OwgOk8HHpqEGkTilocuJoVnkI2GZQTLwnMT/sotlniEkOuafDPNtsszTqrYbJgVYDBxgpjO9NXFxUAhD/BSJ4W6aAwv/HF/mKBOsNkIBzcFHNPolZ0nsI14h0Rqx/TbEaia2oyWVFO4QAvYiMbN7fXKtaTbZHR5wAce9UnEbay6sC097NtEaeNfuJ38zdGThRXxbUaCLMUw8I5OzIhf+E2gK48Sg7sWsA01hvCryE3UQQdhuXkBiWKFDpzOMjVb0UbaSOFfTJk4YRhFOS6CfilYHNk5nZn7HMH0D1pVVVm1BfwBQ/sEsI5RHnQAAAABJRU5ErkJggg==";

async function addTextAreaClass(fabric) {
    var splitter = new GraphemeSplitter(), clone = fabric.util.object.clone, multiplyTransformMatrices = fabric.util.multiplyTransformMatrices;
    fabric.TextArea = fabric.util.createClass(fabric.Textbox, {
        type: 'textArea',
        initialize: function (text, options) {
            if (options.width) {
                options.dynamicMinWidth = options.width;
            }
            this.callSuper('initialize', text, options);
            var updateErrors = this.updateErrors.bind(this), me = this;
            this.on('moving', updateErrors);
            this.on('moved', updateErrors);
            this.on('rotating', updateErrors);
            this.on('rotated', updateErrors);
            this.on('scaling', updateErrors);
            this.on('scaled', updateErrors);
            this.on('deselected', function () {
                me.setActiveError(null);
            });
            this.on('removed', function () {
                me.setErrors([]);
            });
        },
        _wordcutter: function (word, lineIndex, desiredWidth, offset) {
            var width = 0, prevGrapheme, skipLeft = true, parts = [], part = [], additionalSpace = this._getWidthOfCharSpacing();
            for (var i = 0, len = word.length; i < len; i++) {
                var box = this._getGraphemeBox(word[i], lineIndex, i + offset, prevGrapheme, skipLeft);
                prevGrapheme = word[i];
                width += box.width;
                if (desiredWidth > (width + additionalSpace)) {
                    part.push(prevGrapheme);
                }
                else {
                    parts.push(part);
                    width = box.width;
                    part = [prevGrapheme];
                }
            }
            parts.push(part);
            return parts;
        },
        getWords: function (_line, lineIndex, desiredWidth) {
            var words = [], me = this, offset = 0;
            _line.split(this._wordJoiners).forEach(word => {
                var parts = me._wordcutter(word, lineIndex, desiredWidth, offset);
                parts.forEach(function (e) {
                    offset += e.length;
                });
                words.push(parts);
                offset++;
            });
            return words;
        },
        splitByGrapheme: true,
        _wrapLine: function (_line, lineIndex, desiredWidth, reservedSpace) {
            if (!this.splitByGrapheme) {
                return this.callSuper('_wrapLine', _line, lineIndex, desiredWidth, reservedSpace);
            }
            var lineWidth = 0, graphemeLines = [], line = [], words = this.getWords(_line, lineIndex, desiredWidth), word = '', offset = 0, wordWidth = 0, lineJustStarted = true, additionalSpace = this._getWidthOfCharSpacing(), reservedSpace = reservedSpace || 0;
            if (words.length === 0) {
                words.push([]);
            }
            desiredWidth -= reservedSpace;
            for (var i = 0; i < words.length; i++) {
                word = words[i];
                if (i !== words.length - 1) {
                    word[word.length - 1].push(' ');
                }
                for (var j = 0; j < word.length; j++) {
                    var wordPart = word[j];
                    wordWidth = this._measureWord(wordPart, lineIndex, offset);
                    offset += wordPart.length;
                    lineWidth += wordWidth - additionalSpace;
                    if (lineWidth > desiredWidth && !lineJustStarted) {
                        graphemeLines.push(line);
                        line = [];
                        lineWidth = wordWidth;
                        lineJustStarted = true;
                    }
                    else {
                        lineWidth += additionalSpace;
                    }
                    line = line.concat(wordPart);
                    offset++;
                    lineJustStarted = false;
                }
            }
            i && graphemeLines.push(line);
            return graphemeLines;
        },
        renderCursor: function (boundaries, ctx) {
            var cursorLocation = this.get2DCursorLocation(), lineIndex = cursorLocation.lineIndex, charIndex = cursorLocation.charIndex > 0 ? cursorLocation.charIndex - 1 : 0, charHeight = this.getValueOfPropertyAt(lineIndex, charIndex, 'fontSize'), multiplier = this.scaleX * this.canvas.getZoom(), cursorWidth = this.cursorWidth / multiplier, topOffset = boundaries.topOffset, dy = this.getValueOfPropertyAt(lineIndex, charIndex, 'deltaY');
            topOffset += (1 - this._fontSizeFraction) * this.getHeightOfLine(lineIndex) / this.lineHeight
                - charHeight * (1 - this._fontSizeFraction);
            if (this.inCompositionMode) {
                this.renderSelection(boundaries, ctx);
            }
            ctx.fillStyle = this.cursorColor || this.getCursorColor();
            ctx.globalAlpha = this.__isMousedown ? 1 : this._currentCursorOpacity;
            ctx.fillRect(boundaries.left + boundaries.leftOffset - cursorWidth / 2, topOffset + boundaries.top + dy, cursorWidth, charHeight);
        },
        getCursorColor: function () {
            if (this.styleCache && this.styleCache.style) {
                return this.styleCache.style.fill || '#000';
            }
            return '#000';
        },
        renderCursorOrSelection: function () {
            if (!this.isEditing || !this.canvas || !this.canvas.contextTop) {
                return;
            }
            var boundaries = this._getCursorBoundaries(), ctx = this.canvas.contextTop;
            this.clearContextTop(true);
            if (this.selectionStart === this.selectionEnd) {
                this.renderCursor(boundaries, ctx);
            }
            else {
                this.renderSelection(boundaries, ctx);
            }
            this.canvas && this.canvas.fire('text:selection:ended', { target: this });
            ctx.restore();
        },
        insertCharStyleObject: function (lineIndex, charIndex, quantity, copiedStyle) {
            if (!this.styles) {
                this.styles = {};
            }
            var currentLineStyles = this.styles[lineIndex], currentLineStylesCloned = currentLineStyles ? clone(currentLineStyles) : {};
            quantity || (quantity = 1);
            for (var index in currentLineStylesCloned) {
                var numericIndex = parseInt(index, 10);
                if (numericIndex >= charIndex) {
                    currentLineStyles[numericIndex + quantity] = currentLineStylesCloned[numericIndex];
                    if (!currentLineStylesCloned[numericIndex - quantity]) {
                        delete currentLineStyles[numericIndex];
                    }
                }
            }
            this._forceClearCache = true;
            if (copiedStyle) {
                while (quantity--) {
                    if (!Object.keys(copiedStyle[quantity]).length) {
                        continue;
                    }
                    if (!this.styles[lineIndex]) {
                        this.styles[lineIndex] = {};
                    }
                    this.styles[lineIndex][charIndex + quantity] = clone(copiedStyle[quantity]);
                }
                return;
            }
            if (!currentLineStyles) {
                return;
            }
            var style;
            if (this.styleCache && this.styleCache.key === this.selectionStart) {
                style = this.styleCache.style;
            }
            var newStyle = style || currentLineStyles[charIndex ? charIndex - 1 : 1];
            while (newStyle && quantity--) {
                this.styles[lineIndex][charIndex + quantity] = clone(newStyle);
            }
        },
        get2DCursorLocation: function (selectionStart, skipWrapping) {
            if (typeof selectionStart === 'undefined') {
                selectionStart = this.selectionStart;
            }
            var lines = skipWrapping ? this._unwrappedTextLines : this._textLines, len = lines.length, offset;
            for (var i = 0; i < len; i++) {
                if (selectionStart <= lines[i].length) {
                    return {
                        lineIndex: i,
                        charIndex: selectionStart
                    };
                }
                offset = skipWrapping ? 1 : this.missingNewlineOffset(i);
                selectionStart -= lines[i].length + offset;
            }
            return {
                lineIndex: i - 1,
                charIndex: lines[i - 1].length < selectionStart ? lines[i - 1].length : selectionStart
            };
        },
        _measureLine: function (lineIndex) {
            var width = 0, i = 0, j, grapheme, line = this._textLines[lineIndex], prevGrapheme, graphemeInfo, numOfSpaces = 0, lineBounds = new Array(line.length), positionInPath = 0, startingPoint, totalPathLength, path = this.path;
            this.__charBounds[lineIndex] = lineBounds;
            if (path) {
                startingPoint = fabric.util.getPointOnPath(path.path, 0, path.segmentsInfo);
                totalPathLength = path.segmentsInfo[path.segmentsInfo.length - 1].length;
                startingPoint.x += path.pathOffset.x;
                startingPoint.y += path.pathOffset.y;
            }
            var graphemes = splitter.splitGraphemes(line.join(''));
            for (j = 0; j < graphemes.length; j++) {
                grapheme = graphemes[j];
                graphemeInfo = this._getGraphemeBox(grapheme, lineIndex, i, prevGrapheme);
                if (path) {
                    if (positionInPath > totalPathLength) {
                        positionInPath %= totalPathLength;
                    }
                    this._setGraphemeOnPath(positionInPath, graphemeInfo, startingPoint);
                }
                for (var x = 0, len = grapheme.split('').length; x < len; ++i, ++x) {
                    lineBounds[i] = Object.assign({ graphemeIdx: j }, graphemeInfo);
                }
                width += graphemeInfo.kernedWidth;
                positionInPath += graphemeInfo.kernedWidth;
                prevGrapheme = grapheme;
            }
            lineBounds[i] = {
                left: graphemeInfo ? graphemeInfo.left + graphemeInfo.width : 0,
                width: 0,
                kernedWidth: 0,
                height: this.fontSize,
                graphemeIdx: j
            };
            return { width: width, numOfSpaces: numOfSpaces };
        },
        getSelectionStartFromPointer: function (e) {
            var mouseOffset = this.getLocalPointer(e), prevWidth = 0, width = 0, height = 0, charIndex = 0, lineIndex = 0, lineLeftOffset, line;
            for (var i = 0, len = this._textLines.length; i < len; i++) {
                if (height <= mouseOffset.y) {
                    height += this.getHeightOfLine(i) * this.scaleY;
                    lineIndex = i;
                    if (i > 0) {
                        charIndex += this._textLines[i - 1].length + this.missingNewlineOffset(i - 1);
                    }
                }
                else {
                    break;
                }
            }
            lineLeftOffset = this._getLineLeftOffset(lineIndex);
            width = lineLeftOffset * this.scaleX;
            line = this._textLines[lineIndex];
            var idx = -1;
            for (var j = 0, jlen = line.length; j < jlen; j++) {
                prevWidth = width;
                var data = this.__charBounds[lineIndex][j];
                if (data.graphemeIdx !== idx) {
                    width += data.kernedWidth * this.scaleX;
                    idx = data.graphemeIdx;
                }
                if (width <= mouseOffset.x) {
                    charIndex++;
                }
                else {
                    break;
                }
            }
            return this._getNewSelectionStartFromOffset(mouseOffset, prevWidth, width, charIndex, jlen);
        },
        _renderChars: function (method, ctx, line, left, top, lineIndex) {
            var lineHeight = this.getHeightOfLine(lineIndex), isJustify = this.textAlign.indexOf('justify') !== -1, actualStyle, nextStyle, charsToRender = '', charBox, boxWidth = 0, timeToRender, path = this.path, shortCut = !isJustify && this.charSpacing === 0 && this.isEmptyStyles(lineIndex) && !path;
            ctx.save();
            top -= lineHeight * this._fontSizeFraction / this.lineHeight;
            if (shortCut) {
                this._renderChar(method, ctx, lineIndex, 0, line.join(''), left, top, lineHeight);
                ctx.restore();
                return;
            }
            var graphemeIdx = -1;
            for (var i = 0, len = line.length - 1; i <= len; i++) {
                timeToRender = i === len || this.charSpacing || path;
                charsToRender += line[i];
                charBox = this.__charBounds[lineIndex][i];
                if (boxWidth === 0) {
                    left += charBox.kernedWidth - charBox.width;
                    boxWidth += charBox.width;
                }
                else if (graphemeIdx !== charBox.graphemeIdx) {
                    boxWidth += charBox.kernedWidth;
                }
                graphemeIdx = charBox.graphemeIdx;
                if (isJustify && !timeToRender) {
                    if (this._reSpaceAndTab.test(line[i])) {
                        timeToRender = true;
                    }
                }
                if (!timeToRender) {
                    actualStyle = actualStyle || this.getCompleteStyleDeclaration(lineIndex, i);
                    nextStyle = this.getCompleteStyleDeclaration(lineIndex, i + 1);
                    timeToRender = this._hasStyleChanged(actualStyle, nextStyle);
                }
                if (timeToRender) {
                    if (path) {
                        ctx.save();
                        ctx.translate(charBox.renderLeft, charBox.renderTop);
                        ctx.rotate(charBox.angle);
                        this._renderChar(method, ctx, lineIndex, i, charsToRender, -boxWidth / 2, 0, lineHeight);
                        ctx.restore();
                    }
                    else {
                        this._renderChar(method, ctx, lineIndex, i, charsToRender, left, top, lineHeight);
                    }
                    charsToRender = '';
                    actualStyle = nextStyle;
                    left += boxWidth;
                    boxWidth = 0;
                }
            }
            ctx.restore();
        },
        _wrapSVGTextAndBg: function (textAndBg) {
            var noShadow = true;
            return [
                textAndBg.textBgRects.join(''),
                '\t\t<text xml:space="preserve" ',
                (this.fontFamily ? 'font-family="' + this.fontFamily.replace(/"/g, '\'') + '" ' : ''),
                (this.fontSize ? 'font-size="' + this.fontSize + '" ' : ''),
                (this.fontStyle ? 'font-style="' + this.fontStyle + '" ' : ''),
                (this.fontWeight ? 'font-weight="' + this.fontWeight + '" ' : ''),
                'style="', this.getSvgStyles(noShadow), '"', this.addPaintOrder(), ' >',
                textAndBg.textSpans.join(''),
                '</text>\n'
            ];
        },
        _setSVGTextLineText: function (textSpans, lineIndex, textLeftOffset, textTopOffset) {
            var lineHeight = this.getHeightOfLine(lineIndex), isJustify = this.textAlign.indexOf('justify') !== -1, actualStyle, nextStyle, charsToRender = '', charBox, style, boxWidth = 0, line = this._textLines[lineIndex], timeToRender;
            textTopOffset += lineHeight * (1 - this._fontSizeFraction) / this.lineHeight;
            for (var i = 0, len = line.length - 1; i <= len; i++) {
                timeToRender = i === len || this.charSpacing;
                charsToRender += line[i];
                charBox = this.__charBounds[lineIndex][i];
                if (boxWidth === 0) {
                    textLeftOffset += charBox.kernedWidth - charBox.width;
                    boxWidth += charBox.width;
                }
                else {
                    boxWidth += charBox.kernedWidth;
                }
                if (isJustify && !timeToRender) {
                    if (this._reSpaceAndTab.test(line[i])) {
                        timeToRender = true;
                    }
                }
                if (!timeToRender) {
                    actualStyle = actualStyle || this.getCompleteStyleDeclaration(lineIndex, i);
                    nextStyle = this.getCompleteStyleDeclaration(lineIndex, i + 1);
                    timeToRender = this._hasStyleChangedForSvg(actualStyle, nextStyle);
                }
                if (timeToRender) {
                    style = this._getStyleDeclaration(lineIndex, i) || {};
                    var textDecoration = this.getSvgTextDecoration(this);
                    if (textDecoration) {
                        var tmp = {};
                        Object.assign(tmp, style);
                        tmp[textDecoration] = true;
                        style = tmp;
                    }
                    textSpans.push(this._createTextCharSpan(charsToRender, style, textLeftOffset, textTopOffset));
                    charsToRender = '';
                    actualStyle = nextStyle;
                    textLeftOffset += boxWidth;
                    boxWidth = 0;
                }
            }
        },
        _renderTextDecoration: function (ctx, type) {
            if (!this[type] && !this.styleHas(type)) {
                return;
            }
            var heightOfLine, size, _size, lineLeftOffset, dy, _dy, line, lastDecoration, leftOffset = this._getLeftOffset(), topOffset = this._getTopOffset(), top, boxStart, boxWidth, charBox, currentDecoration, maxHeight, currentFill, lastFill, path = this.path, charSpacing = this._getWidthOfCharSpacing();
            for (var i = 0, len = this._textLines.length; i < len; i++) {
                heightOfLine = this.getHeightOfLine(i);
                if (!this[type] && !this.styleHas(type, i)) {
                    topOffset += heightOfLine;
                    continue;
                }
                line = this._textLines[i];
                maxHeight = heightOfLine / this.lineHeight;
                lineLeftOffset = this._getLineLeftOffset(i);
                boxStart = 0;
                boxWidth = 0;
                lastDecoration = this.getValueOfPropertyAt(i, 0, type);
                lastFill = this.getValueOfPropertyAt(i, 0, 'fill');
                top = topOffset + maxHeight * (1 - this._fontSizeFraction);
                size = this.getHeightOfChar(i, 0);
                dy = this.getValueOfPropertyAt(i, 0, 'deltaY');
                var graphemeIdx = -1;
                for (var j = 0, jlen = line.length; j < jlen; j++) {
                    charBox = this.__charBounds[i][j];
                    currentDecoration = this.getValueOfPropertyAt(i, j, type);
                    currentFill = this.getValueOfPropertyAt(i, j, 'fill');
                    _size = this.getHeightOfChar(i, j);
                    _dy = this.getValueOfPropertyAt(i, j, 'deltaY');
                    if (path && currentDecoration && currentFill) {
                        ctx.save();
                        ctx.fillStyle = lastFill;
                        ctx.translate(charBox.renderLeft, charBox.renderTop);
                        ctx.rotate(charBox.angle);
                        ctx.fillRect(-charBox.kernedWidth / 2, this.offsets[type] * _size + _dy, charBox.kernedWidth, this.fontSize / 15);
                        ctx.restore();
                    }
                    else if ((currentDecoration !== lastDecoration || currentFill !== lastFill || _size !== size || _dy !== dy)
                        && boxWidth > 0) {
                        if (lastDecoration && lastFill) {
                            ctx.fillStyle = lastFill;
                            ctx.fillRect(leftOffset + lineLeftOffset + boxStart, top + this.offsets[type] * size + dy, boxWidth, this.fontSize / 15);
                        }
                        boxStart = charBox.left;
                        boxWidth = charBox.width;
                        lastDecoration = currentDecoration;
                        lastFill = currentFill;
                        size = _size;
                        dy = _dy;
                    }
                    else if (graphemeIdx !== charBox.graphemeIdx) {
                        boxWidth += charBox.kernedWidth;
                    }
                    graphemeIdx = charBox.graphemeIdx;
                }
                ctx.fillStyle = currentFill;
                currentDecoration && currentFill && ctx.fillRect(leftOffset + lineLeftOffset + boxStart, top + this.offsets[type] * size + dy, boxWidth - charSpacing, this.fontSize / 15);
                topOffset += heightOfLine;
            }
            this._removeShadow(ctx);
        },
        toObject: function (propertiesToInclude) {
            var additionalProperties = [
                'allowedLeft',
                'allowedTop'
            ].concat(propertiesToInclude), obj = this.callSuper('toObject', additionalProperties);
            if (this.isEditing) {
                delete obj.selectable;
                delete obj.evented;
                delete obj.hasControls;
                delete obj.lockMovementX;
                delete obj.lockMovementY;
            }
            return obj;
        },
        initHiddenTextarea: function () {
            this.callSuper('initHiddenTextarea');
            const win = window;
            if (this.enableTransliteration) {
                var me = this, hiddenTextarea = this.hiddenTextarea, ctn = win.enableTransliteration(hiddenTextarea, 'ne'), cb = ctn.suggestionBox.endSuggestions;
                ctn.suggestionBox.endSuggestions = function () {
                    cb.call(this);
                    me.onInput({
                        inputType: 'insertFromPaste',
                        stopPropagation: function () { }
                    });
                };
            }
        },
        _checkGrammar: async function () {
            if (this.checkingGrammer) {
                return;
            }
            var raw = JSON.stringify({
                text: this.text,
                language: "en-US",
                ai: true,
                key: this.textGearAPIKey,
                poweredBy: "textgears-api"
            });
            var requestOptions = {
                method: "POST",
                body: raw,
                redirect: "follow"
            };
            var cnt = this.canvas.wrapperEl;
            var el = fabric.document.createElement('div');
            el.classList.add("spinner");
            el.appendChild(fabric.document.createElement('div'));
            cnt.appendChild(el);
            var m = multiplyTransformMatrices(this.getViewportTransform(), this.calcOwnMatrix());
            m[4] -= this.width / 2;
            m[5] -= this.height / 2;
            el.style.transform = "matrix(" + m.join() + ")";
            el.style.width = this.width + "px";
            el.style.height = this.height + "px";
            this.checkingGrammer = true;
            try {
                var response = await fetch("https://sg.api.textgears.com/analyze", requestOptions), json = JSON.parse(await response.text());
                this.setErrors(json.response.grammar.errors);
            }
            catch (err) {
                console.error(err);
            }
            finally {
                el.remove();
                delete this.checkingGrammer;
            }
        },
        errors: [],
        setErrors: function (err) {
            var cnt = this.canvas.wrapperEl, me = this;
            this.errors.forEach(function (e) {
                cnt.removeChild(e.el);
            });
            this.errors = err.map(function (e) {
                var el = fabric.document.createElement('div');
                el.classList.add("textAreaError");
                el.addEventListener("click", function (event) {
                    me.onErrorAction(event, e);
                });
                cnt.appendChild(el);
                e.el = el;
                return e;
            });
            this.updateErrors();
        },
        onErrorAction: function (event, error) {
            var me = this, target = event.target, dropdown = fabric.document.createElement('div'), select = fabric.document.createElement('ul');
            dropdown.onclick = function (e) {
                e.stopPropagation();
            };
            target.appendChild(dropdown);
            dropdown.classList.add("dropdown");
            dropdown.classList.add(error.type);
            var errorType = fabric.document.createElement('div');
            errorType.classList.add("type");
            errorType.innerHTML = error.type + " error";
            dropdown.appendChild(errorType);
            dropdown.appendChild(select);
            error.better.forEach(function (val) {
                var option = fabric.document.createElement('div');
                option.classList.add("option");
                option.innerHTML = val;
                option.addEventListener("click", function () {
                    me.onSuggestionClick(error, val);
                });
                select.appendChild(option);
            });
            this.setActiveError(error);
        },
        setActiveError: function (error) {
            if (this.activeError) {
                this.activeError.el.innerHTML = '';
                this.activeError.el.style.zIndex = 1;
            }
            if (error) {
                error.el.style.zIndex = 2;
            }
            this.activeError = error;
        },
        onSuggestionClick: function (error, val) {
            var preText = this.text.substring(0, error.offset), text = preText + val + this.text.substring(error.offset + error.length, this.text.length), errors = [], diff = val.length - error.length;
            error.el.remove();
            for (var err of this.errors) {
                if (err.offset < error.offset) {
                    errors.push(err);
                }
                else if (err.offset > error.offset) {
                    err.offset += diff;
                    errors.push(err);
                }
            }
            this.errors = errors;
            this.set({ text });
            var preText = preText.split('\n'), lineIdx = preText.length - 1, charIdx = preText[lineIdx].length, lineStyles = this.styles[lineIdx] || {}, preStyleLen = Math.max(0, ...Object.keys(lineStyles).map(i => Number(i))) + 1, newLineStyle = {}, i = 0, j = 0;
            for (; i < charIdx; ++i) {
                if (lineStyles[i]) {
                    newLineStyle[i] = lineStyles[i];
                }
            }
            var targetStyle = lineStyles[i];
            for (; j < val.length; ++j) {
                if (targetStyle) {
                    newLineStyle[i + j] = Object.assign({}, targetStyle);
                }
            }
            j = j + i;
            for (i += error.length; i < preStyleLen; ++i, ++j) {
                if (lineStyles[i]) {
                    newLineStyle[j] = lineStyles[i];
                }
            }
            this.styles[lineIdx] = newLineStyle;
            this.calcTextWidth();
            this.updateErrors();
            this.canvas.renderAll();
        },
        updateErrors: function () {
            var me = this, vpt = this.getViewportTransform(), m = multiplyTransformMatrices(vpt, this.calcOwnMatrix()), origin = {
                left: m[4],
                top: m[5]
            }, charBounds = this.__charBounds, tmp = 0, tops = [0];
            charBounds.forEach(function (e, i) {
                tmp += me.getHeightOfLine(i);
                tops.push(tmp);
            });
            var fontFactor = this.lineHeight * this._fontSizeMult;
            this.errors.forEach(function (e, i) {
                var el = e.el, start = me.getCharPosition(e.offset), end = me.getCharPosition(e.offset + e.length - 1), startCharBounds = charBounds[start.lineIndex][start.charIndex], endCharBounds = charBounds[end.lineIndex][end.charIndex];
                var width = endCharBounds.left - startCharBounds.left + endCharBounds.width, height = startCharBounds.height, top = me._getTopOffset() + height / 2, left = me._getLeftOffset() + width / 2;
                m[4] = origin.left - width / 2;
                m[5] = origin.top - height / 2;
                var mat = multiplyTransformMatrices(m, [
                    1, 0, 0, 1,
                    startCharBounds.left + left,
                    top + tops[start.lineIndex] + ((tops[start.lineIndex + 1] - tops[start.lineIndex]) / fontFactor - height)
                ]);
                el.style.transform = "matrix(" + mat.join() + ")";
                el.style.width = width + "px";
                el.style.height = height + "px";
            });
        },
        enterEditing: function (e) {
            this.setErrors([]);
            return this.callSuper("enterEditing", e);
        },
        getCharPosition: function (selectionStart) {
            var lines = this._textLines, len = lines.length;
            for (var i = 0; i < len; i++) {
                if (selectionStart < lines[i].length) {
                    return {
                        lineIndex: i,
                        charIndex: selectionStart
                    };
                }
                selectionStart -= lines[i].length + this.missingNewlineOffset(i);
            }
            return {
                lineIndex: i - 1,
                charIndex: selectionStart
            };
        },
        onInput: function (e) {
            var state = { ...this }, res = this.callSuper('onInput', e), canvas = this.canvas;
            if (this.maxWarningHeight < this.height) {
                Object.assign(this, state);
                if (this.hiddenTextarea) {
                    this.hiddenTextarea.value = state.text;
                }
                canvas && canvas.fire('text:limitReached', { target: this });
            }
            return res;
        }
    });
    fabric.TextArea.fromObject = function (object, callback) {
        return fabric.Object._fromObject('TextArea', object, callback, 'text');
    };
    var updateIcon = await getImage(img), renderIconControl = fabric.controlsUtils.renderIconControl;
    fabric.Object.prototype.controlsSetting.additionalControls.gramarlyButton = new fabric.Control({
        x: -0.5,
        y: -0.5,
        cursorStyleHandler: function () {
            return 'pointer';
        },
        getActionName: function () {
            return 'grammarly';
        },
        mouseDownHandler: function (eventData, transform, x, y) {
            var fabricObject = transform.target;
            fabricObject._checkGrammar();
        },
        render: function (ctx, left, top, styleOverride, fabricObject) {
            ctx.save();
            var styleOverrides = {};
            renderIconControl.call(this, ctx, left, top, updateIcon, styleOverrides);
            var style = fabricObject?.inputEl?.style;
            if (style) {
                style.width = styleOverrides.cornerSize + 'px';
                style.height = styleOverrides.cornerSize + 'px';
                style.left = left + 'px';
                style.top = top + 'px';
            }
            ctx.restore();
        }
    });
    fabric.TextArea.prototype.setTextGearAPIKey = function (key) {
        if (key) {
            fabric.TextArea.prototype.controls.tl = fabric.Object.prototype.controlsSetting.additionalControls.gramarlyButton;
        }
        else {
            fabric.TextArea.prototype.controls.tl = fabric.Object.prototype.controlsSetting.defaultControls.tl;
        }
        fabric.TextArea.prototype.textGearAPIKey = key;
    };
}

function addGrayscaleTintColorClass(fabric) {
    var extend = fabric.util.object.extend, filters = fabric.Image.filters, createClass = fabric.util.createClass;
    filters.GrayscaleTintColor = createClass(filters.BaseFilter, {
        type: 'GrayscaleTintColor',
        fragmentSource: `precision highp float;
        uniform sampler2D uTexture;
        uniform vec4 tint;
        uniform int invert;
        varying vec2 vTexCoord;
        void main() {
            vec4 color = texture2D(uTexture, vTexCoord);
            float factor = color.r;
            if (invert == 1) {
                factor = 1.0 - factor;
            }
            gl_FragColor = vec4(
                1.0 + (tint.r - 1.0) * factor,
                1.0 + (tint.g - 1.0) * factor, 
                1.0 + (tint.b - 1.0) * factor,
                color.a
            );
        }`,
        initialize: function (options) {
            options = options || {};
            this.color = options.color || '#000000';
            this.invert = options.invert;
        },
        applyTo2d: function (options) {
            var imageData = options.imageData, data = imageData.data, i, len = data.length, tintR, tintG, tintB, invert = this.invert, source = new fabric.Color(this.color).getSource();
            tintR = source[0];
            tintG = source[1];
            tintB = source[2];
            for (i = 0; i < len; i += 4) {
                var factor = data[i] / 255;
                if (invert) {
                    factor = 1 - factor;
                }
                data[i] = 255 + (tintR - 255) * factor;
                data[i + 1] = 255 + (tintG - 255) * factor;
                data[i + 2] = 255 + (tintB - 255) * factor;
            }
        },
        getUniformLocations: function (gl, program) {
            return {
                tint: gl.getUniformLocation(program, 'tint'),
                invert: gl.getUniformLocation(program, 'invert')
            };
        },
        sendUniformData: function (gl, uniformLocations) {
            var source = new fabric.Color(this.color).getSource(), tint = [source[0] / 255, source[1] / 255, source[2] / 255, 1];
            gl.uniform4fv(uniformLocations.tint, tint);
            gl.uniform1i(uniformLocations.invert, this.invert ? 1 : 0);
        },
        toObject: function () {
            return extend(this.callSuper('toObject'), {
                color: this.color,
                invert: this.invert
            });
        }
    });
    fabric.Image.filters.GrayscaleTintColor.fromObject = fabric.Image.filters.BaseFilter.fromObject;
}

addPrototypeProps(fabric$1.fabric);
objectOverrides(fabric$1.fabric);
addLayerCanvasClass(fabric$1.fabric);
addLayerClass(fabric$1.fabric);
updatePattern(fabric$1.fabric);
addPatternColorClass(fabric$1.fabric);
addGrayscaleTintColorClass(fabric$1.fabric);
addShapedTextClass(fabric$1.fabric);
addCurvedTextClass(fabric$1.fabric);
updateTextObject(fabric$1.fabric);
await addImageBoxClass(fabric$1.fabric);
await addTextAreaClass(fabric$1.fabric);
await updateSelectionHandles(fabric$1.fabric);

function bind(fn, thisArg) {
  return function wrap() {
    return fn.apply(thisArg, arguments);
  };
}

// utils is a library of generic helper functions non-specific to axios

const {toString} = Object.prototype;
const {getPrototypeOf} = Object;

const kindOf = (cache => thing => {
    const str = toString.call(thing);
    return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
})(Object.create(null));

const kindOfTest = (type) => {
  type = type.toLowerCase();
  return (thing) => kindOf(thing) === type
};

const typeOfTest = type => thing => typeof thing === type;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */
const {isArray} = Array;

/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */
const isUndefined = typeOfTest('undefined');

/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
const isArrayBuffer = kindOfTest('ArrayBuffer');


/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  let result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */
const isString = typeOfTest('string');

/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
const isFunction = typeOfTest('function');

/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */
const isNumber = typeOfTest('number');

/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */
const isObject = (thing) => thing !== null && typeof thing === 'object';

/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */
const isBoolean = thing => thing === true || thing === false;

/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */
const isPlainObject = (val) => {
  if (kindOf(val) !== 'object') {
    return false;
  }

  const prototype = getPrototypeOf(val);
  return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};

/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */
const isDate = kindOfTest('Date');

/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
const isFile = kindOfTest('File');

/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */
const isBlob = kindOfTest('Blob');

/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
const isFileList = kindOfTest('FileList');

/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */
const isStream = (val) => isObject(val) && isFunction(val.pipe);

/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */
const isFormData = (thing) => {
  let kind;
  return thing && (
    (typeof FormData === 'function' && thing instanceof FormData) || (
      isFunction(thing.append) && (
        (kind = kindOf(thing)) === 'formdata' ||
        // detect form-data instance
        (kind === 'object' && isFunction(thing.toString) && thing.toString() === '[object FormData]')
      )
    )
  )
};

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
const isURLSearchParams = kindOfTest('URLSearchParams');

const [isReadableStream, isRequest, isResponse, isHeaders] = ['ReadableStream', 'Request', 'Response', 'Headers'].map(kindOfTest);

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */
const trim = (str) => str.trim ?
  str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */
function forEach(obj, fn, {allOwnKeys = false} = {}) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  let i;
  let l;

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
    const len = keys.length;
    let key;

    for (i = 0; i < len; i++) {
      key = keys[i];
      fn.call(null, obj[key], key, obj);
    }
  }
}

function findKey(obj, key) {
  key = key.toLowerCase();
  const keys = Object.keys(obj);
  let i = keys.length;
  let _key;
  while (i-- > 0) {
    _key = keys[i];
    if (key === _key.toLowerCase()) {
      return _key;
    }
  }
  return null;
}

const _global = (() => {
  /*eslint no-undef:0*/
  if (typeof globalThis !== "undefined") return globalThis;
  return typeof self !== "undefined" ? self : (typeof window !== 'undefined' ? window : global)
})();

const isContextDefined = (context) => !isUndefined(context) && context !== _global;

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  const {caseless} = isContextDefined(this) && this || {};
  const result = {};
  const assignValue = (val, key) => {
    const targetKey = caseless && findKey(result, key) || key;
    if (isPlainObject(result[targetKey]) && isPlainObject(val)) {
      result[targetKey] = merge(result[targetKey], val);
    } else if (isPlainObject(val)) {
      result[targetKey] = merge({}, val);
    } else if (isArray(val)) {
      result[targetKey] = val.slice();
    } else {
      result[targetKey] = val;
    }
  };

  for (let i = 0, l = arguments.length; i < l; i++) {
    arguments[i] && forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */
const extend = (a, b, thisArg, {allOwnKeys}= {}) => {
  forEach(b, (val, key) => {
    if (thisArg && isFunction(val)) {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  }, {allOwnKeys});
  return a;
};

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */
const stripBOM = (content) => {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
};

/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */
const inherits = (constructor, superConstructor, props, descriptors) => {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors);
  constructor.prototype.constructor = constructor;
  Object.defineProperty(constructor, 'super', {
    value: superConstructor.prototype
  });
  props && Object.assign(constructor.prototype, props);
};

/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */
const toFlatObject = (sourceObj, destObj, filter, propFilter) => {
  let props;
  let i;
  let prop;
  const merged = {};

  destObj = destObj || {};
  // eslint-disable-next-line no-eq-null,eqeqeq
  if (sourceObj == null) return destObj;

  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = filter !== false && getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);

  return destObj;
};

/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */
const endsWith = (str, searchString, position) => {
  str = String(str);
  if (position === undefined || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  const lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
};


/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */
const toArray = (thing) => {
  if (!thing) return null;
  if (isArray(thing)) return thing;
  let i = thing.length;
  if (!isNumber(i)) return null;
  const arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
};

/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */
// eslint-disable-next-line func-names
const isTypedArray = (TypedArray => {
  // eslint-disable-next-line func-names
  return thing => {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== 'undefined' && getPrototypeOf(Uint8Array));

/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */
const forEachEntry = (obj, fn) => {
  const generator = obj && obj[Symbol.iterator];

  const iterator = generator.call(obj);

  let result;

  while ((result = iterator.next()) && !result.done) {
    const pair = result.value;
    fn.call(obj, pair[0], pair[1]);
  }
};

/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */
const matchAll = (regExp, str) => {
  let matches;
  const arr = [];

  while ((matches = regExp.exec(str)) !== null) {
    arr.push(matches);
  }

  return arr;
};

/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */
const isHTMLForm = kindOfTest('HTMLFormElement');

const toCamelCase = str => {
  return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g,
    function replacer(m, p1, p2) {
      return p1.toUpperCase() + p2;
    }
  );
};

/* Creating a function that will check if an object has a property. */
const hasOwnProperty = (({hasOwnProperty}) => (obj, prop) => hasOwnProperty.call(obj, prop))(Object.prototype);

/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */
const isRegExp = kindOfTest('RegExp');

const reduceDescriptors = (obj, reducer) => {
  const descriptors = Object.getOwnPropertyDescriptors(obj);
  const reducedDescriptors = {};

  forEach(descriptors, (descriptor, name) => {
    let ret;
    if ((ret = reducer(descriptor, name, obj)) !== false) {
      reducedDescriptors[name] = ret || descriptor;
    }
  });

  Object.defineProperties(obj, reducedDescriptors);
};

/**
 * Makes all methods read-only
 * @param {Object} obj
 */

const freezeMethods = (obj) => {
  reduceDescriptors(obj, (descriptor, name) => {
    // skip restricted props in strict mode
    if (isFunction(obj) && ['arguments', 'caller', 'callee'].indexOf(name) !== -1) {
      return false;
    }

    const value = obj[name];

    if (!isFunction(value)) return;

    descriptor.enumerable = false;

    if ('writable' in descriptor) {
      descriptor.writable = false;
      return;
    }

    if (!descriptor.set) {
      descriptor.set = () => {
        throw Error('Can not rewrite read-only method \'' + name + '\'');
      };
    }
  });
};

const toObjectSet = (arrayOrString, delimiter) => {
  const obj = {};

  const define = (arr) => {
    arr.forEach(value => {
      obj[value] = true;
    });
  };

  isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));

  return obj;
};

const noop = () => {};

const toFiniteNumber = (value, defaultValue) => {
  return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};

const ALPHA = 'abcdefghijklmnopqrstuvwxyz';

const DIGIT = '0123456789';

const ALPHABET = {
  DIGIT,
  ALPHA,
  ALPHA_DIGIT: ALPHA + ALPHA.toUpperCase() + DIGIT
};

const generateString = (size = 16, alphabet = ALPHABET.ALPHA_DIGIT) => {
  let str = '';
  const {length} = alphabet;
  while (size--) {
    str += alphabet[Math.random() * length|0];
  }

  return str;
};

/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */
function isSpecCompliantForm(thing) {
  return !!(thing && isFunction(thing.append) && thing[Symbol.toStringTag] === 'FormData' && thing[Symbol.iterator]);
}

const toJSONObject = (obj) => {
  const stack = new Array(10);

  const visit = (source, i) => {

    if (isObject(source)) {
      if (stack.indexOf(source) >= 0) {
        return;
      }

      if(!('toJSON' in source)) {
        stack[i] = source;
        const target = isArray(source) ? [] : {};

        forEach(source, (value, key) => {
          const reducedValue = visit(value, i + 1);
          !isUndefined(reducedValue) && (target[key] = reducedValue);
        });

        stack[i] = undefined;

        return target;
      }
    }

    return source;
  };

  return visit(obj, 0);
};

const isAsyncFn = kindOfTest('AsyncFunction');

const isThenable = (thing) =>
  thing && (isObject(thing) || isFunction(thing)) && isFunction(thing.then) && isFunction(thing.catch);

var utils$1 = {
  isArray,
  isArrayBuffer,
  isBuffer,
  isFormData,
  isArrayBufferView,
  isString,
  isNumber,
  isBoolean,
  isObject,
  isPlainObject,
  isReadableStream,
  isRequest,
  isResponse,
  isHeaders,
  isUndefined,
  isDate,
  isFile,
  isBlob,
  isRegExp,
  isFunction,
  isStream,
  isURLSearchParams,
  isTypedArray,
  isFileList,
  forEach,
  merge,
  extend,
  trim,
  stripBOM,
  inherits,
  toFlatObject,
  kindOf,
  kindOfTest,
  endsWith,
  toArray,
  forEachEntry,
  matchAll,
  isHTMLForm,
  hasOwnProperty,
  hasOwnProp: hasOwnProperty, // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors,
  freezeMethods,
  toObjectSet,
  toCamelCase,
  noop,
  toFiniteNumber,
  findKey,
  global: _global,
  isContextDefined,
  ALPHABET,
  generateString,
  isSpecCompliantForm,
  toJSONObject,
  isAsyncFn,
  isThenable
};

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */
function AxiosError(message, code, config, request, response) {
  Error.call(this);

  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, this.constructor);
  } else {
    this.stack = (new Error()).stack;
  }

  this.message = message;
  this.name = 'AxiosError';
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  response && (this.response = response);
}

utils$1.inherits(AxiosError, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: utils$1.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});

const prototype$1 = AxiosError.prototype;
const descriptors = {};

[
  'ERR_BAD_OPTION_VALUE',
  'ERR_BAD_OPTION',
  'ECONNABORTED',
  'ETIMEDOUT',
  'ERR_NETWORK',
  'ERR_FR_TOO_MANY_REDIRECTS',
  'ERR_DEPRECATED',
  'ERR_BAD_RESPONSE',
  'ERR_BAD_REQUEST',
  'ERR_CANCELED',
  'ERR_NOT_SUPPORT',
  'ERR_INVALID_URL'
// eslint-disable-next-line func-names
].forEach(code => {
  descriptors[code] = {value: code};
});

Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(prototype$1, 'isAxiosError', {value: true});

// eslint-disable-next-line func-names
AxiosError.from = (error, code, config, request, response, customProps) => {
  const axiosError = Object.create(prototype$1);

  utils$1.toFlatObject(error, axiosError, function filter(obj) {
    return obj !== Error.prototype;
  }, prop => {
    return prop !== 'isAxiosError';
  });

  AxiosError.call(axiosError, error.message, code, config, request, response);

  axiosError.cause = error;

  axiosError.name = error.name;

  customProps && Object.assign(axiosError, customProps);

  return axiosError;
};

// eslint-disable-next-line strict
var httpAdapter = null;

/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */
function isVisitable(thing) {
  return utils$1.isPlainObject(thing) || utils$1.isArray(thing);
}

/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */
function removeBrackets(key) {
  return utils$1.endsWith(key, '[]') ? key.slice(0, -2) : key;
}

/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */
function renderKey(path, key, dots) {
  if (!path) return key;
  return path.concat(key).map(function each(token, i) {
    // eslint-disable-next-line no-param-reassign
    token = removeBrackets(token);
    return !dots && i ? '[' + token + ']' : token;
  }).join(dots ? '.' : '');
}

/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */
function isFlatArray(arr) {
  return utils$1.isArray(arr) && !arr.some(isVisitable);
}

const predicates = utils$1.toFlatObject(utils$1, {}, null, function filter(prop) {
  return /^is[A-Z]/.test(prop);
});

/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/

/**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */
function toFormData(obj, formData, options) {
  if (!utils$1.isObject(obj)) {
    throw new TypeError('target must be an object');
  }

  // eslint-disable-next-line no-param-reassign
  formData = formData || new (FormData)();

  // eslint-disable-next-line no-param-reassign
  options = utils$1.toFlatObject(options, {
    metaTokens: true,
    dots: false,
    indexes: false
  }, false, function defined(option, source) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    return !utils$1.isUndefined(source[option]);
  });

  const metaTokens = options.metaTokens;
  // eslint-disable-next-line no-use-before-define
  const visitor = options.visitor || defaultVisitor;
  const dots = options.dots;
  const indexes = options.indexes;
  const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
  const useBlob = _Blob && utils$1.isSpecCompliantForm(formData);

  if (!utils$1.isFunction(visitor)) {
    throw new TypeError('visitor must be a function');
  }

  function convertValue(value) {
    if (value === null) return '';

    if (utils$1.isDate(value)) {
      return value.toISOString();
    }

    if (!useBlob && utils$1.isBlob(value)) {
      throw new AxiosError('Blob is not supported. Use a Buffer instead.');
    }

    if (utils$1.isArrayBuffer(value) || utils$1.isTypedArray(value)) {
      return useBlob && typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
    }

    return value;
  }

  /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */
  function defaultVisitor(value, key, path) {
    let arr = value;

    if (value && !path && typeof value === 'object') {
      if (utils$1.endsWith(key, '{}')) {
        // eslint-disable-next-line no-param-reassign
        key = metaTokens ? key : key.slice(0, -2);
        // eslint-disable-next-line no-param-reassign
        value = JSON.stringify(value);
      } else if (
        (utils$1.isArray(value) && isFlatArray(value)) ||
        ((utils$1.isFileList(value) || utils$1.endsWith(key, '[]')) && (arr = utils$1.toArray(value))
        )) {
        // eslint-disable-next-line no-param-reassign
        key = removeBrackets(key);

        arr.forEach(function each(el, index) {
          !(utils$1.isUndefined(el) || el === null) && formData.append(
            // eslint-disable-next-line no-nested-ternary
            indexes === true ? renderKey([key], index, dots) : (indexes === null ? key : key + '[]'),
            convertValue(el)
          );
        });
        return false;
      }
    }

    if (isVisitable(value)) {
      return true;
    }

    formData.append(renderKey(path, key, dots), convertValue(value));

    return false;
  }

  const stack = [];

  const exposedHelpers = Object.assign(predicates, {
    defaultVisitor,
    convertValue,
    isVisitable
  });

  function build(value, path) {
    if (utils$1.isUndefined(value)) return;

    if (stack.indexOf(value) !== -1) {
      throw Error('Circular reference detected in ' + path.join('.'));
    }

    stack.push(value);

    utils$1.forEach(value, function each(el, key) {
      const result = !(utils$1.isUndefined(el) || el === null) && visitor.call(
        formData, el, utils$1.isString(key) ? key.trim() : key, path, exposedHelpers
      );

      if (result === true) {
        build(el, path ? path.concat(key) : [key]);
      }
    });

    stack.pop();
  }

  if (!utils$1.isObject(obj)) {
    throw new TypeError('data must be an object');
  }

  build(obj);

  return formData;
}

/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */
function encode$1(str) {
  const charMap = {
    '!': '%21',
    "'": '%27',
    '(': '%28',
    ')': '%29',
    '~': '%7E',
    '%20': '+',
    '%00': '\x00'
  };
  return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
    return charMap[match];
  });
}

/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */
function AxiosURLSearchParams(params, options) {
  this._pairs = [];

  params && toFormData(params, this, options);
}

const prototype = AxiosURLSearchParams.prototype;

prototype.append = function append(name, value) {
  this._pairs.push([name, value]);
};

prototype.toString = function toString(encoder) {
  const _encode = encoder ? function(value) {
    return encoder.call(this, value, encode$1);
  } : encode$1;

  return this._pairs.map(function each(pair) {
    return _encode(pair[0]) + '=' + _encode(pair[1]);
  }, '').join('&');
};

/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */
function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @param {?object} options
 *
 * @returns {string} The formatted url
 */
function buildURL(url, params, options) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }
  
  const _encode = options && options.encode || encode;

  const serializeFn = options && options.serialize;

  let serializedParams;

  if (serializeFn) {
    serializedParams = serializeFn(params, options);
  } else {
    serializedParams = utils$1.isURLSearchParams(params) ?
      params.toString() :
      new AxiosURLSearchParams(params, options).toString(_encode);
  }

  if (serializedParams) {
    const hashmarkIndex = url.indexOf("#");

    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
}

class InterceptorManager {
  constructor() {
    this.handlers = [];
  }

  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(fulfilled, rejected, options) {
    this.handlers.push({
      fulfilled,
      rejected,
      synchronous: options ? options.synchronous : false,
      runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
  }

  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(id) {
    if (this.handlers[id]) {
      this.handlers[id] = null;
    }
  }

  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    if (this.handlers) {
      this.handlers = [];
    }
  }

  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(fn) {
    utils$1.forEach(this.handlers, function forEachHandler(h) {
      if (h !== null) {
        fn(h);
      }
    });
  }
}

var transitionalDefaults = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};

var URLSearchParams$1 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : AxiosURLSearchParams;

var FormData$1 = typeof FormData !== 'undefined' ? FormData : null;

var Blob$1 = typeof Blob !== 'undefined' ? Blob : null;

var platform$1 = {
  isBrowser: true,
  classes: {
    URLSearchParams: URLSearchParams$1,
    FormData: FormData$1,
    Blob: Blob$1
  },
  protocols: ['http', 'https', 'file', 'blob', 'url', 'data']
};

const hasBrowserEnv = typeof window !== 'undefined' && typeof document !== 'undefined';

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */
const hasStandardBrowserEnv = (
  (product) => {
    return hasBrowserEnv && ['ReactNative', 'NativeScript', 'NS'].indexOf(product) < 0
  })(typeof navigator !== 'undefined' && navigator.product);

/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */
const hasStandardBrowserWebWorkerEnv = (() => {
  return (
    typeof WorkerGlobalScope !== 'undefined' &&
    // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope &&
    typeof self.importScripts === 'function'
  );
})();

const origin = hasBrowserEnv && window.location.href || 'http://localhost';

var utils = /*#__PURE__*/Object.freeze({
	__proto__: null,
	hasBrowserEnv: hasBrowserEnv,
	hasStandardBrowserEnv: hasStandardBrowserEnv,
	hasStandardBrowserWebWorkerEnv: hasStandardBrowserWebWorkerEnv,
	origin: origin
});

var platform = {
  ...utils,
  ...platform$1
};

function toURLEncodedForm(data, options) {
  return toFormData(data, new platform.classes.URLSearchParams(), Object.assign({
    visitor: function(value, key, path, helpers) {
      if (platform.isNode && utils$1.isBuffer(value)) {
        this.append(key, value.toString('base64'));
        return false;
      }

      return helpers.defaultVisitor.apply(this, arguments);
    }
  }, options));
}

/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */
function parsePropPath(name) {
  // foo[x][y][z]
  // foo.x.y.z
  // foo-x-y-z
  // foo x y z
  return utils$1.matchAll(/\w+|\[(\w*)]/g, name).map(match => {
    return match[0] === '[]' ? '' : match[1] || match[0];
  });
}

/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */
function arrayToObject(arr) {
  const obj = {};
  const keys = Object.keys(arr);
  let i;
  const len = keys.length;
  let key;
  for (i = 0; i < len; i++) {
    key = keys[i];
    obj[key] = arr[key];
  }
  return obj;
}

/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */
function formDataToJSON(formData) {
  function buildPath(path, value, target, index) {
    let name = path[index++];

    if (name === '__proto__') return true;

    const isNumericKey = Number.isFinite(+name);
    const isLast = index >= path.length;
    name = !name && utils$1.isArray(target) ? target.length : name;

    if (isLast) {
      if (utils$1.hasOwnProp(target, name)) {
        target[name] = [target[name], value];
      } else {
        target[name] = value;
      }

      return !isNumericKey;
    }

    if (!target[name] || !utils$1.isObject(target[name])) {
      target[name] = [];
    }

    const result = buildPath(path, value, target[name], index);

    if (result && utils$1.isArray(target[name])) {
      target[name] = arrayToObject(target[name]);
    }

    return !isNumericKey;
  }

  if (utils$1.isFormData(formData) && utils$1.isFunction(formData.entries)) {
    const obj = {};

    utils$1.forEachEntry(formData, (name, value) => {
      buildPath(parsePropPath(name), value, obj, 0);
    });

    return obj;
  }

  return null;
}

/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */
function stringifySafely(rawValue, parser, encoder) {
  if (utils$1.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils$1.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

const defaults = {

  transitional: transitionalDefaults,

  adapter: ['xhr', 'http', 'fetch'],

  transformRequest: [function transformRequest(data, headers) {
    const contentType = headers.getContentType() || '';
    const hasJSONContentType = contentType.indexOf('application/json') > -1;
    const isObjectPayload = utils$1.isObject(data);

    if (isObjectPayload && utils$1.isHTMLForm(data)) {
      data = new FormData(data);
    }

    const isFormData = utils$1.isFormData(data);

    if (isFormData) {
      return hasJSONContentType ? JSON.stringify(formDataToJSON(data)) : data;
    }

    if (utils$1.isArrayBuffer(data) ||
      utils$1.isBuffer(data) ||
      utils$1.isStream(data) ||
      utils$1.isFile(data) ||
      utils$1.isBlob(data) ||
      utils$1.isReadableStream(data)
    ) {
      return data;
    }
    if (utils$1.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils$1.isURLSearchParams(data)) {
      headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
      return data.toString();
    }

    let isFileList;

    if (isObjectPayload) {
      if (contentType.indexOf('application/x-www-form-urlencoded') > -1) {
        return toURLEncodedForm(data, this.formSerializer).toString();
      }

      if ((isFileList = utils$1.isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
        const _FormData = this.env && this.env.FormData;

        return toFormData(
          isFileList ? {'files[]': data} : data,
          _FormData && new _FormData(),
          this.formSerializer
        );
      }
    }

    if (isObjectPayload || hasJSONContentType ) {
      headers.setContentType('application/json', false);
      return stringifySafely(data);
    }

    return data;
  }],

  transformResponse: [function transformResponse(data) {
    const transitional = this.transitional || defaults.transitional;
    const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    const JSONRequested = this.responseType === 'json';

    if (utils$1.isResponse(data) || utils$1.isReadableStream(data)) {
      return data;
    }

    if (data && utils$1.isString(data) && ((forcedJSONParsing && !this.responseType) || JSONRequested)) {
      const silentJSONParsing = transitional && transitional.silentJSONParsing;
      const strictJSONParsing = !silentJSONParsing && JSONRequested;

      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw AxiosError.from(e, AxiosError.ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  env: {
    FormData: platform.classes.FormData,
    Blob: platform.classes.Blob
  },

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*',
      'Content-Type': undefined
    }
  }
};

utils$1.forEach(['delete', 'get', 'head', 'post', 'put', 'patch'], (method) => {
  defaults.headers[method] = {};
});

// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const ignoreDuplicateOf = utils$1.toObjectSet([
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
]);

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */
var parseHeaders = rawHeaders => {
  const parsed = {};
  let key;
  let val;
  let i;

  rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
    i = line.indexOf(':');
    key = line.substring(0, i).trim().toLowerCase();
    val = line.substring(i + 1).trim();

    if (!key || (parsed[key] && ignoreDuplicateOf[key])) {
      return;
    }

    if (key === 'set-cookie') {
      if (parsed[key]) {
        parsed[key].push(val);
      } else {
        parsed[key] = [val];
      }
    } else {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  });

  return parsed;
};

const $internals = Symbol('internals');

function normalizeHeader(header) {
  return header && String(header).trim().toLowerCase();
}

function normalizeValue(value) {
  if (value === false || value == null) {
    return value;
  }

  return utils$1.isArray(value) ? value.map(normalizeValue) : String(value);
}

function parseTokens(str) {
  const tokens = Object.create(null);
  const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let match;

  while ((match = tokensRE.exec(str))) {
    tokens[match[1]] = match[2];
  }

  return tokens;
}

const isValidHeaderName = (str) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());

function matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
  if (utils$1.isFunction(filter)) {
    return filter.call(this, value, header);
  }

  if (isHeaderNameFilter) {
    value = header;
  }

  if (!utils$1.isString(value)) return;

  if (utils$1.isString(filter)) {
    return value.indexOf(filter) !== -1;
  }

  if (utils$1.isRegExp(filter)) {
    return filter.test(value);
  }
}

function formatHeader(header) {
  return header.trim()
    .toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str) => {
      return char.toUpperCase() + str;
    });
}

function buildAccessors(obj, header) {
  const accessorName = utils$1.toCamelCase(' ' + header);

  ['get', 'set', 'has'].forEach(methodName => {
    Object.defineProperty(obj, methodName + accessorName, {
      value: function(arg1, arg2, arg3) {
        return this[methodName].call(this, header, arg1, arg2, arg3);
      },
      configurable: true
    });
  });
}

class AxiosHeaders {
  constructor(headers) {
    headers && this.set(headers);
  }

  set(header, valueOrRewrite, rewrite) {
    const self = this;

    function setHeader(_value, _header, _rewrite) {
      const lHeader = normalizeHeader(_header);

      if (!lHeader) {
        throw new Error('header name must be a non-empty string');
      }

      const key = utils$1.findKey(self, lHeader);

      if(!key || self[key] === undefined || _rewrite === true || (_rewrite === undefined && self[key] !== false)) {
        self[key || _header] = normalizeValue(_value);
      }
    }

    const setHeaders = (headers, _rewrite) =>
      utils$1.forEach(headers, (_value, _header) => setHeader(_value, _header, _rewrite));

    if (utils$1.isPlainObject(header) || header instanceof this.constructor) {
      setHeaders(header, valueOrRewrite);
    } else if(utils$1.isString(header) && (header = header.trim()) && !isValidHeaderName(header)) {
      setHeaders(parseHeaders(header), valueOrRewrite);
    } else if (utils$1.isHeaders(header)) {
      for (const [key, value] of header.entries()) {
        setHeader(value, key, rewrite);
      }
    } else {
      header != null && setHeader(valueOrRewrite, header, rewrite);
    }

    return this;
  }

  get(header, parser) {
    header = normalizeHeader(header);

    if (header) {
      const key = utils$1.findKey(this, header);

      if (key) {
        const value = this[key];

        if (!parser) {
          return value;
        }

        if (parser === true) {
          return parseTokens(value);
        }

        if (utils$1.isFunction(parser)) {
          return parser.call(this, value, key);
        }

        if (utils$1.isRegExp(parser)) {
          return parser.exec(value);
        }

        throw new TypeError('parser must be boolean|regexp|function');
      }
    }
  }

  has(header, matcher) {
    header = normalizeHeader(header);

    if (header) {
      const key = utils$1.findKey(this, header);

      return !!(key && this[key] !== undefined && (!matcher || matchHeaderValue(this, this[key], key, matcher)));
    }

    return false;
  }

  delete(header, matcher) {
    const self = this;
    let deleted = false;

    function deleteHeader(_header) {
      _header = normalizeHeader(_header);

      if (_header) {
        const key = utils$1.findKey(self, _header);

        if (key && (!matcher || matchHeaderValue(self, self[key], key, matcher))) {
          delete self[key];

          deleted = true;
        }
      }
    }

    if (utils$1.isArray(header)) {
      header.forEach(deleteHeader);
    } else {
      deleteHeader(header);
    }

    return deleted;
  }

  clear(matcher) {
    const keys = Object.keys(this);
    let i = keys.length;
    let deleted = false;

    while (i--) {
      const key = keys[i];
      if(!matcher || matchHeaderValue(this, this[key], key, matcher, true)) {
        delete this[key];
        deleted = true;
      }
    }

    return deleted;
  }

  normalize(format) {
    const self = this;
    const headers = {};

    utils$1.forEach(this, (value, header) => {
      const key = utils$1.findKey(headers, header);

      if (key) {
        self[key] = normalizeValue(value);
        delete self[header];
        return;
      }

      const normalized = format ? formatHeader(header) : String(header).trim();

      if (normalized !== header) {
        delete self[header];
      }

      self[normalized] = normalizeValue(value);

      headers[normalized] = true;
    });

    return this;
  }

  concat(...targets) {
    return this.constructor.concat(this, ...targets);
  }

  toJSON(asStrings) {
    const obj = Object.create(null);

    utils$1.forEach(this, (value, header) => {
      value != null && value !== false && (obj[header] = asStrings && utils$1.isArray(value) ? value.join(', ') : value);
    });

    return obj;
  }

  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }

  toString() {
    return Object.entries(this.toJSON()).map(([header, value]) => header + ': ' + value).join('\n');
  }

  get [Symbol.toStringTag]() {
    return 'AxiosHeaders';
  }

  static from(thing) {
    return thing instanceof this ? thing : new this(thing);
  }

  static concat(first, ...targets) {
    const computed = new this(first);

    targets.forEach((target) => computed.set(target));

    return computed;
  }

  static accessor(header) {
    const internals = this[$internals] = (this[$internals] = {
      accessors: {}
    });

    const accessors = internals.accessors;
    const prototype = this.prototype;

    function defineAccessor(_header) {
      const lHeader = normalizeHeader(_header);

      if (!accessors[lHeader]) {
        buildAccessors(prototype, _header);
        accessors[lHeader] = true;
      }
    }

    utils$1.isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);

    return this;
  }
}

AxiosHeaders.accessor(['Content-Type', 'Content-Length', 'Accept', 'Accept-Encoding', 'User-Agent', 'Authorization']);

// reserved names hotfix
utils$1.reduceDescriptors(AxiosHeaders.prototype, ({value}, key) => {
  let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
  return {
    get: () => value,
    set(headerValue) {
      this[mapped] = headerValue;
    }
  }
});

utils$1.freezeMethods(AxiosHeaders);

/**
 * Transform the data for a request or a response
 *
 * @param {Array|Function} fns A single function or Array of functions
 * @param {?Object} response The response object
 *
 * @returns {*} The resulting transformed data
 */
function transformData(fns, response) {
  const config = this || defaults;
  const context = response || config;
  const headers = AxiosHeaders.from(context.headers);
  let data = context.data;

  utils$1.forEach(fns, function transform(fn) {
    data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
  });

  headers.normalize();

  return data;
}

function isCancel(value) {
  return !!(value && value.__CANCEL__);
}

/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */
function CanceledError(message, config, request) {
  // eslint-disable-next-line no-eq-null,eqeqeq
  AxiosError.call(this, message == null ? 'canceled' : message, AxiosError.ERR_CANCELED, config, request);
  this.name = 'CanceledError';
}

utils$1.inherits(CanceledError, AxiosError, {
  __CANCEL__: true
});

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 *
 * @returns {object} The response.
 */
function settle(resolve, reject, response) {
  const validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(new AxiosError(
      'Request failed with status code ' + response.status,
      [AxiosError.ERR_BAD_REQUEST, AxiosError.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
      response.config,
      response.request,
      response
    ));
  }
}

function parseProtocol(url) {
  const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || '';
}

/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */
function speedometer(samplesCount, min) {
  samplesCount = samplesCount || 10;
  const bytes = new Array(samplesCount);
  const timestamps = new Array(samplesCount);
  let head = 0;
  let tail = 0;
  let firstSampleTS;

  min = min !== undefined ? min : 1000;

  return function push(chunkLength) {
    const now = Date.now();

    const startedAt = timestamps[tail];

    if (!firstSampleTS) {
      firstSampleTS = now;
    }

    bytes[head] = chunkLength;
    timestamps[head] = now;

    let i = tail;
    let bytesCount = 0;

    while (i !== head) {
      bytesCount += bytes[i++];
      i = i % samplesCount;
    }

    head = (head + 1) % samplesCount;

    if (head === tail) {
      tail = (tail + 1) % samplesCount;
    }

    if (now - firstSampleTS < min) {
      return;
    }

    const passed = startedAt && now - startedAt;

    return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
  };
}

/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */
function throttle(fn, freq) {
  let timestamp = 0;
  const threshold = 1000 / freq;
  let timer = null;
  return function throttled() {
    const force = this === true;

    const now = Date.now();
    if (force || now - timestamp > threshold) {
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }
      timestamp = now;
      return fn.apply(null, arguments);
    }
    if (!timer) {
      timer = setTimeout(() => {
        timer = null;
        timestamp = Date.now();
        return fn.apply(null, arguments);
      }, threshold - (now - timestamp));
    }
  };
}

var progressEventReducer = (listener, isDownloadStream, freq = 3) => {
  let bytesNotified = 0;
  const _speedometer = speedometer(50, 250);

  return throttle(e => {
    const loaded = e.loaded;
    const total = e.lengthComputable ? e.total : undefined;
    const progressBytes = loaded - bytesNotified;
    const rate = _speedometer(progressBytes);
    const inRange = loaded <= total;

    bytesNotified = loaded;

    const data = {
      loaded,
      total,
      progress: total ? (loaded / total) : undefined,
      bytes: progressBytes,
      rate: rate ? rate : undefined,
      estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
      event: e,
      lengthComputable: total != null
    };

    data[isDownloadStream ? 'download' : 'upload'] = true;

    listener(data);
  }, freq);
};

var isURLSameOrigin = platform.hasStandardBrowserEnv ?

// Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement('a');
    let originURL;

    /**
    * Parse a URL to discover its components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      let href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
          urlParsingNode.pathname :
          '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      const parsed = (utils$1.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
          parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })();

var cookies = platform.hasStandardBrowserEnv ?

  // Standard browser envs support document.cookie
  {
    write(name, value, expires, path, domain, secure) {
      const cookie = [name + '=' + encodeURIComponent(value)];

      utils$1.isNumber(expires) && cookie.push('expires=' + new Date(expires).toGMTString());

      utils$1.isString(path) && cookie.push('path=' + path);

      utils$1.isString(domain) && cookie.push('domain=' + domain);

      secure === true && cookie.push('secure');

      document.cookie = cookie.join('; ');
    },

    read(name) {
      const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
      return (match ? decodeURIComponent(match[3]) : null);
    },

    remove(name) {
      this.write(name, '', Date.now() - 86400000);
    }
  }

  :

  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {},
    read() {
      return null;
    },
    remove() {}
  };

/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 *
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 *
 * @returns {string} The combined URL
 */
function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
}

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 *
 * @returns {string} The combined full path
 */
function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
}

const headersToObject = (thing) => thing instanceof AxiosHeaders ? { ...thing } : thing;

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 *
 * @returns {Object} New object resulting from merging config2 to config1
 */
function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  const config = {};

  function getMergedValue(target, source, caseless) {
    if (utils$1.isPlainObject(target) && utils$1.isPlainObject(source)) {
      return utils$1.merge.call({caseless}, target, source);
    } else if (utils$1.isPlainObject(source)) {
      return utils$1.merge({}, source);
    } else if (utils$1.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(a, b, caseless) {
    if (!utils$1.isUndefined(b)) {
      return getMergedValue(a, b, caseless);
    } else if (!utils$1.isUndefined(a)) {
      return getMergedValue(undefined, a, caseless);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(a, b) {
    if (!utils$1.isUndefined(b)) {
      return getMergedValue(undefined, b);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(a, b) {
    if (!utils$1.isUndefined(b)) {
      return getMergedValue(undefined, b);
    } else if (!utils$1.isUndefined(a)) {
      return getMergedValue(undefined, a);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(a, b, prop) {
    if (prop in config2) {
      return getMergedValue(a, b);
    } else if (prop in config1) {
      return getMergedValue(undefined, a);
    }
  }

  const mergeMap = {
    url: valueFromConfig2,
    method: valueFromConfig2,
    data: valueFromConfig2,
    baseURL: defaultToConfig2,
    transformRequest: defaultToConfig2,
    transformResponse: defaultToConfig2,
    paramsSerializer: defaultToConfig2,
    timeout: defaultToConfig2,
    timeoutMessage: defaultToConfig2,
    withCredentials: defaultToConfig2,
    withXSRFToken: defaultToConfig2,
    adapter: defaultToConfig2,
    responseType: defaultToConfig2,
    xsrfCookieName: defaultToConfig2,
    xsrfHeaderName: defaultToConfig2,
    onUploadProgress: defaultToConfig2,
    onDownloadProgress: defaultToConfig2,
    decompress: defaultToConfig2,
    maxContentLength: defaultToConfig2,
    maxBodyLength: defaultToConfig2,
    beforeRedirect: defaultToConfig2,
    transport: defaultToConfig2,
    httpAgent: defaultToConfig2,
    httpsAgent: defaultToConfig2,
    cancelToken: defaultToConfig2,
    socketPath: defaultToConfig2,
    responseEncoding: defaultToConfig2,
    validateStatus: mergeDirectKeys,
    headers: (a, b) => mergeDeepProperties(headersToObject(a), headersToObject(b), true)
  };

  utils$1.forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
    const merge = mergeMap[prop] || mergeDeepProperties;
    const configValue = merge(config1[prop], config2[prop], prop);
    (utils$1.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
}

var resolveConfig = (config) => {
  const newConfig = mergeConfig({}, config);

  let {data, withXSRFToken, xsrfHeaderName, xsrfCookieName, headers, auth} = newConfig;

  newConfig.headers = headers = AxiosHeaders.from(headers);

  newConfig.url = buildURL(buildFullPath(newConfig.baseURL, newConfig.url), config.params, config.paramsSerializer);

  // HTTP basic authentication
  if (auth) {
    headers.set('Authorization', 'Basic ' +
      btoa((auth.username || '') + ':' + (auth.password ? unescape(encodeURIComponent(auth.password)) : ''))
    );
  }

  let contentType;

  if (utils$1.isFormData(data)) {
    if (platform.hasStandardBrowserEnv || platform.hasStandardBrowserWebWorkerEnv) {
      headers.setContentType(undefined); // Let the browser set it
    } else if ((contentType = headers.getContentType()) !== false) {
      // fix semicolon duplication issue for ReactNative FormData implementation
      const [type, ...tokens] = contentType ? contentType.split(';').map(token => token.trim()).filter(Boolean) : [];
      headers.setContentType([type || 'multipart/form-data', ...tokens].join('; '));
    }
  }

  // Add xsrf header
  // This is only done if running in a standard browser environment.
  // Specifically not if we're in a web worker, or react-native.

  if (platform.hasStandardBrowserEnv) {
    withXSRFToken && utils$1.isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));

    if (withXSRFToken || (withXSRFToken !== false && isURLSameOrigin(newConfig.url))) {
      // Add xsrf header
      const xsrfValue = xsrfHeaderName && xsrfCookieName && cookies.read(xsrfCookieName);

      if (xsrfValue) {
        headers.set(xsrfHeaderName, xsrfValue);
      }
    }
  }

  return newConfig;
};

const isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';

var xhrAdapter = isXHRAdapterSupported && function (config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    const _config = resolveConfig(config);
    let requestData = _config.data;
    const requestHeaders = AxiosHeaders.from(_config.headers).normalize();
    let {responseType} = _config;
    let onCanceled;
    function done() {
      if (_config.cancelToken) {
        _config.cancelToken.unsubscribe(onCanceled);
      }

      if (_config.signal) {
        _config.signal.removeEventListener('abort', onCanceled);
      }
    }

    let request = new XMLHttpRequest();

    request.open(_config.method.toUpperCase(), _config.url, true);

    // Set the request timeout in MS
    request.timeout = _config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      const responseHeaders = AxiosHeaders.from(
        'getAllResponseHeaders' in request && request.getAllResponseHeaders()
      );
      const responseData = !responseType || responseType === 'text' || responseType === 'json' ?
        request.responseText : request.response;
      const response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config,
        request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(new AxiosError('Request aborted', AxiosError.ECONNABORTED, _config, request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(new AxiosError('Network Error', AxiosError.ERR_NETWORK, _config, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
      const transitional = _config.transitional || transitionalDefaults;
      if (_config.timeoutErrorMessage) {
        timeoutErrorMessage = _config.timeoutErrorMessage;
      }
      reject(new AxiosError(
        timeoutErrorMessage,
        transitional.clarifyTimeoutError ? AxiosError.ETIMEDOUT : AxiosError.ECONNABORTED,
        _config,
        request));

      // Clean up request
      request = null;
    };

    // Remove Content-Type if data is undefined
    requestData === undefined && requestHeaders.setContentType(null);

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils$1.forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
        request.setRequestHeader(key, val);
      });
    }

    // Add withCredentials to request if needed
    if (!utils$1.isUndefined(_config.withCredentials)) {
      request.withCredentials = !!_config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = _config.responseType;
    }

    // Handle progress if needed
    if (typeof _config.onDownloadProgress === 'function') {
      request.addEventListener('progress', progressEventReducer(_config.onDownloadProgress, true));
    }

    // Not all browsers support upload events
    if (typeof _config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', progressEventReducer(_config.onUploadProgress));
    }

    if (_config.cancelToken || _config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = cancel => {
        if (!request) {
          return;
        }
        reject(!cancel || cancel.type ? new CanceledError(null, config, request) : cancel);
        request.abort();
        request = null;
      };

      _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
      if (_config.signal) {
        _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
      }
    }

    const protocol = parseProtocol(_config.url);

    if (protocol && platform.protocols.indexOf(protocol) === -1) {
      reject(new AxiosError('Unsupported protocol ' + protocol + ':', AxiosError.ERR_BAD_REQUEST, config));
      return;
    }


    // Send the request
    request.send(requestData || null);
  });
};

const composeSignals = (signals, timeout) => {
  let controller = new AbortController();

  let aborted;

  const onabort = function (cancel) {
    if (!aborted) {
      aborted = true;
      unsubscribe();
      const err = cancel instanceof Error ? cancel : this.reason;
      controller.abort(err instanceof AxiosError ? err : new CanceledError(err instanceof Error ? err.message : err));
    }
  };

  let timer = timeout && setTimeout(() => {
    onabort(new AxiosError(`timeout ${timeout} of ms exceeded`, AxiosError.ETIMEDOUT));
  }, timeout);

  const unsubscribe = () => {
    if (signals) {
      timer && clearTimeout(timer);
      timer = null;
      signals.forEach(signal => {
        signal &&
        (signal.removeEventListener ? signal.removeEventListener('abort', onabort) : signal.unsubscribe(onabort));
      });
      signals = null;
    }
  };

  signals.forEach((signal) => signal && signal.addEventListener && signal.addEventListener('abort', onabort));

  const {signal} = controller;

  signal.unsubscribe = unsubscribe;

  return [signal, () => {
    timer && clearTimeout(timer);
    timer = null;
  }];
};

const streamChunk = function* (chunk, chunkSize) {
  let len = chunk.byteLength;

  if (!chunkSize || len < chunkSize) {
    yield chunk;
    return;
  }

  let pos = 0;
  let end;

  while (pos < len) {
    end = pos + chunkSize;
    yield chunk.slice(pos, end);
    pos = end;
  }
};

const readBytes = async function* (iterable, chunkSize, encode) {
  for await (const chunk of iterable) {
    yield* streamChunk(ArrayBuffer.isView(chunk) ? chunk : (await encode(String(chunk))), chunkSize);
  }
};

const trackStream = (stream, chunkSize, onProgress, onFinish, encode) => {
  const iterator = readBytes(stream, chunkSize, encode);

  let bytes = 0;

  return new ReadableStream({
    type: 'bytes',

    async pull(controller) {
      const {done, value} = await iterator.next();

      if (done) {
        controller.close();
        onFinish();
        return;
      }

      let len = value.byteLength;
      onProgress && onProgress(bytes += len);
      controller.enqueue(new Uint8Array(value));
    },
    cancel(reason) {
      onFinish(reason);
      return iterator.return();
    }
  }, {
    highWaterMark: 2
  })
};

const fetchProgressDecorator = (total, fn) => {
  const lengthComputable = total != null;
  return (loaded) => setTimeout(() => fn({
    lengthComputable,
    total,
    loaded
  }));
};

const isFetchSupported = typeof fetch === 'function' && typeof Request === 'function' && typeof Response === 'function';
const isReadableStreamSupported = isFetchSupported && typeof ReadableStream === 'function';

// used only inside the fetch adapter
const encodeText = isFetchSupported && (typeof TextEncoder === 'function' ?
    ((encoder) => (str) => encoder.encode(str))(new TextEncoder()) :
    async (str) => new Uint8Array(await new Response(str).arrayBuffer())
);

const supportsRequestStream = isReadableStreamSupported && (() => {
  let duplexAccessed = false;

  const hasContentType = new Request(platform.origin, {
    body: new ReadableStream(),
    method: 'POST',
    get duplex() {
      duplexAccessed = true;
      return 'half';
    },
  }).headers.has('Content-Type');

  return duplexAccessed && !hasContentType;
})();

const DEFAULT_CHUNK_SIZE = 64 * 1024;

const supportsResponseStream = isReadableStreamSupported && !!(()=> {
  try {
    return utils$1.isReadableStream(new Response('').body);
  } catch(err) {
    // return undefined
  }
})();

const resolvers = {
  stream: supportsResponseStream && ((res) => res.body)
};

isFetchSupported && (((res) => {
  ['text', 'arrayBuffer', 'blob', 'formData', 'stream'].forEach(type => {
    !resolvers[type] && (resolvers[type] = utils$1.isFunction(res[type]) ? (res) => res[type]() :
      (_, config) => {
        throw new AxiosError(`Response type '${type}' is not supported`, AxiosError.ERR_NOT_SUPPORT, config);
      });
  });
})(new Response));

const getBodyLength = async (body) => {
  if (body == null) {
    return 0;
  }

  if(utils$1.isBlob(body)) {
    return body.size;
  }

  if(utils$1.isSpecCompliantForm(body)) {
    return (await new Request(body).arrayBuffer()).byteLength;
  }

  if(utils$1.isArrayBufferView(body)) {
    return body.byteLength;
  }

  if(utils$1.isURLSearchParams(body)) {
    body = body + '';
  }

  if(utils$1.isString(body)) {
    return (await encodeText(body)).byteLength;
  }
};

const resolveBodyLength = async (headers, body) => {
  const length = utils$1.toFiniteNumber(headers.getContentLength());

  return length == null ? getBodyLength(body) : length;
};

var fetchAdapter = isFetchSupported && (async (config) => {
  let {
    url,
    method,
    data,
    signal,
    cancelToken,
    timeout,
    onDownloadProgress,
    onUploadProgress,
    responseType,
    headers,
    withCredentials = 'same-origin',
    fetchOptions
  } = resolveConfig(config);

  responseType = responseType ? (responseType + '').toLowerCase() : 'text';

  let [composedSignal, stopTimeout] = (signal || cancelToken || timeout) ?
    composeSignals([signal, cancelToken], timeout) : [];

  let finished, request;

  const onFinish = () => {
    !finished && setTimeout(() => {
      composedSignal && composedSignal.unsubscribe();
    });

    finished = true;
  };

  let requestContentLength;

  try {
    if (
      onUploadProgress && supportsRequestStream && method !== 'get' && method !== 'head' &&
      (requestContentLength = await resolveBodyLength(headers, data)) !== 0
    ) {
      let _request = new Request(url, {
        method: 'POST',
        body: data,
        duplex: "half"
      });

      let contentTypeHeader;

      if (utils$1.isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) {
        headers.setContentType(contentTypeHeader);
      }

      if (_request.body) {
        data = trackStream(_request.body, DEFAULT_CHUNK_SIZE, fetchProgressDecorator(
          requestContentLength,
          progressEventReducer(onUploadProgress)
        ), null, encodeText);
      }
    }

    if (!utils$1.isString(withCredentials)) {
      withCredentials = withCredentials ? 'cors' : 'omit';
    }

    request = new Request(url, {
      ...fetchOptions,
      signal: composedSignal,
      method: method.toUpperCase(),
      headers: headers.normalize().toJSON(),
      body: data,
      duplex: "half",
      withCredentials
    });

    let response = await fetch(request);

    const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');

    if (supportsResponseStream && (onDownloadProgress || isStreamResponse)) {
      const options = {};

      ['status', 'statusText', 'headers'].forEach(prop => {
        options[prop] = response[prop];
      });

      const responseContentLength = utils$1.toFiniteNumber(response.headers.get('content-length'));

      response = new Response(
        trackStream(response.body, DEFAULT_CHUNK_SIZE, onDownloadProgress && fetchProgressDecorator(
          responseContentLength,
          progressEventReducer(onDownloadProgress, true)
        ), isStreamResponse && onFinish, encodeText),
        options
      );
    }

    responseType = responseType || 'text';

    let responseData = await resolvers[utils$1.findKey(resolvers, responseType) || 'text'](response, config);

    !isStreamResponse && onFinish();

    stopTimeout && stopTimeout();

    return await new Promise((resolve, reject) => {
      settle(resolve, reject, {
        data: responseData,
        headers: AxiosHeaders.from(response.headers),
        status: response.status,
        statusText: response.statusText,
        config,
        request
      });
    })
  } catch (err) {
    onFinish();

    if (err && err.name === 'TypeError' && /fetch/i.test(err.message)) {
      throw Object.assign(
        new AxiosError('Network Error', AxiosError.ERR_NETWORK, config, request),
        {
          cause: err.cause || err
        }
      )
    }

    throw AxiosError.from(err, err && err.code, config, request);
  }
});

const knownAdapters = {
  http: httpAdapter,
  xhr: xhrAdapter,
  fetch: fetchAdapter
};

utils$1.forEach(knownAdapters, (fn, value) => {
  if (fn) {
    try {
      Object.defineProperty(fn, 'name', {value});
    } catch (e) {
      // eslint-disable-next-line no-empty
    }
    Object.defineProperty(fn, 'adapterName', {value});
  }
});

const renderReason = (reason) => `- ${reason}`;

const isResolvedHandle = (adapter) => utils$1.isFunction(adapter) || adapter === null || adapter === false;

var adapters = {
  getAdapter: (adapters) => {
    adapters = utils$1.isArray(adapters) ? adapters : [adapters];

    const {length} = adapters;
    let nameOrAdapter;
    let adapter;

    const rejectedReasons = {};

    for (let i = 0; i < length; i++) {
      nameOrAdapter = adapters[i];
      let id;

      adapter = nameOrAdapter;

      if (!isResolvedHandle(nameOrAdapter)) {
        adapter = knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];

        if (adapter === undefined) {
          throw new AxiosError(`Unknown adapter '${id}'`);
        }
      }

      if (adapter) {
        break;
      }

      rejectedReasons[id || '#' + i] = adapter;
    }

    if (!adapter) {

      const reasons = Object.entries(rejectedReasons)
        .map(([id, state]) => `adapter ${id} ` +
          (state === false ? 'is not supported by the environment' : 'is not available in the build')
        );

      let s = length ?
        (reasons.length > 1 ? 'since :\n' + reasons.map(renderReason).join('\n') : ' ' + renderReason(reasons[0])) :
        'as no adapter specified';

      throw new AxiosError(
        `There is no suitable adapter to dispatch the request ` + s,
        'ERR_NOT_SUPPORT'
      );
    }

    return adapter;
  },
  adapters: knownAdapters
};

/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new CanceledError(null, config);
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 *
 * @returns {Promise} The Promise to be fulfilled
 */
function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  config.headers = AxiosHeaders.from(config.headers);

  // Transform request data
  config.data = transformData.call(
    config,
    config.transformRequest
  );

  if (['post', 'put', 'patch'].indexOf(config.method) !== -1) {
    config.headers.setContentType('application/x-www-form-urlencoded', false);
  }

  const adapter = adapters.getAdapter(config.adapter || defaults.adapter);

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      config.transformResponse,
      response
    );

    response.headers = AxiosHeaders.from(response.headers);

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          config.transformResponse,
          reason.response
        );
        reason.response.headers = AxiosHeaders.from(reason.response.headers);
      }
    }

    return Promise.reject(reason);
  });
}

const VERSION = "1.7.2";

const validators$1 = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach((type, i) => {
  validators$1[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

const deprecatedWarnings = {};

/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */
validators$1.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return (value, opt, opts) => {
    if (validator === false) {
      throw new AxiosError(
        formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')),
        AxiosError.ERR_DEPRECATED
      );
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new AxiosError('options must be an object', AxiosError.ERR_BAD_OPTION_VALUE);
  }
  const keys = Object.keys(options);
  let i = keys.length;
  while (i-- > 0) {
    const opt = keys[i];
    const validator = schema[opt];
    if (validator) {
      const value = options[opt];
      const result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new AxiosError('option ' + opt + ' must be ' + result, AxiosError.ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new AxiosError('Unknown option ' + opt, AxiosError.ERR_BAD_OPTION);
    }
  }
}

var validator = {
  assertOptions,
  validators: validators$1
};

const validators = validator.validators;

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */
class Axios {
  constructor(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
      request: new InterceptorManager(),
      response: new InterceptorManager()
    };
  }

  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(configOrUrl, config) {
    try {
      return await this._request(configOrUrl, config);
    } catch (err) {
      if (err instanceof Error) {
        let dummy;

        Error.captureStackTrace ? Error.captureStackTrace(dummy = {}) : (dummy = new Error());

        // slice off the Error: ... line
        const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';
        try {
          if (!err.stack) {
            err.stack = stack;
            // match without the 2 top stack lines
          } else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) {
            err.stack += '\n' + stack;
          }
        } catch (e) {
          // ignore the case where "stack" is an un-writable property
        }
      }

      throw err;
    }
  }

  _request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/
    // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === 'string') {
      config = config || {};
      config.url = configOrUrl;
    } else {
      config = configOrUrl || {};
    }

    config = mergeConfig(this.defaults, config);

    const {transitional, paramsSerializer, headers} = config;

    if (transitional !== undefined) {
      validator.assertOptions(transitional, {
        silentJSONParsing: validators.transitional(validators.boolean),
        forcedJSONParsing: validators.transitional(validators.boolean),
        clarifyTimeoutError: validators.transitional(validators.boolean)
      }, false);
    }

    if (paramsSerializer != null) {
      if (utils$1.isFunction(paramsSerializer)) {
        config.paramsSerializer = {
          serialize: paramsSerializer
        };
      } else {
        validator.assertOptions(paramsSerializer, {
          encode: validators.function,
          serialize: validators.function
        }, true);
      }
    }

    // Set config.method
    config.method = (config.method || this.defaults.method || 'get').toLowerCase();

    // Flatten headers
    let contextHeaders = headers && utils$1.merge(
      headers.common,
      headers[config.method]
    );

    headers && utils$1.forEach(
      ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
      (method) => {
        delete headers[method];
      }
    );

    config.headers = AxiosHeaders.concat(contextHeaders, headers);

    // filter out skipped interceptors
    const requestInterceptorChain = [];
    let synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
      if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
        return;
      }

      synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

      requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });

    const responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
      responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });

    let promise;
    let i = 0;
    let len;

    if (!synchronousRequestInterceptors) {
      const chain = [dispatchRequest.bind(this), undefined];
      chain.unshift.apply(chain, requestInterceptorChain);
      chain.push.apply(chain, responseInterceptorChain);
      len = chain.length;

      promise = Promise.resolve(config);

      while (i < len) {
        promise = promise.then(chain[i++], chain[i++]);
      }

      return promise;
    }

    len = requestInterceptorChain.length;

    let newConfig = config;

    i = 0;

    while (i < len) {
      const onFulfilled = requestInterceptorChain[i++];
      const onRejected = requestInterceptorChain[i++];
      try {
        newConfig = onFulfilled(newConfig);
      } catch (error) {
        onRejected.call(this, error);
        break;
      }
    }

    try {
      promise = dispatchRequest.call(this, newConfig);
    } catch (error) {
      return Promise.reject(error);
    }

    i = 0;
    len = responseInterceptorChain.length;

    while (i < len) {
      promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
    }

    return promise;
  }

  getUri(config) {
    config = mergeConfig(this.defaults, config);
    const fullPath = buildFullPath(config.baseURL, config.url);
    return buildURL(fullPath, config.params, config.paramsSerializer);
  }
}

// Provide aliases for supported request methods
utils$1.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method,
      url,
      data: (config || {}).data
    }));
  };
});

utils$1.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/

  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request(mergeConfig(config || {}, {
        method,
        headers: isForm ? {
          'Content-Type': 'multipart/form-data'
        } : {},
        url,
        data
      }));
    };
  }

  Axios.prototype[method] = generateHTTPMethod();

  Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */
class CancelToken {
  constructor(executor) {
    if (typeof executor !== 'function') {
      throw new TypeError('executor must be a function.');
    }

    let resolvePromise;

    this.promise = new Promise(function promiseExecutor(resolve) {
      resolvePromise = resolve;
    });

    const token = this;

    // eslint-disable-next-line func-names
    this.promise.then(cancel => {
      if (!token._listeners) return;

      let i = token._listeners.length;

      while (i-- > 0) {
        token._listeners[i](cancel);
      }
      token._listeners = null;
    });

    // eslint-disable-next-line func-names
    this.promise.then = onfulfilled => {
      let _resolve;
      // eslint-disable-next-line func-names
      const promise = new Promise(resolve => {
        token.subscribe(resolve);
        _resolve = resolve;
      }).then(onfulfilled);

      promise.cancel = function reject() {
        token.unsubscribe(_resolve);
      };

      return promise;
    };

    executor(function cancel(message, config, request) {
      if (token.reason) {
        // Cancellation has already been requested
        return;
      }

      token.reason = new CanceledError(message, config, request);
      resolvePromise(token.reason);
    });
  }

  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason) {
      throw this.reason;
    }
  }

  /**
   * Subscribe to the cancel signal
   */

  subscribe(listener) {
    if (this.reason) {
      listener(this.reason);
      return;
    }

    if (this._listeners) {
      this._listeners.push(listener);
    } else {
      this._listeners = [listener];
    }
  }

  /**
   * Unsubscribe from the cancel signal
   */

  unsubscribe(listener) {
    if (!this._listeners) {
      return;
    }
    const index = this._listeners.indexOf(listener);
    if (index !== -1) {
      this._listeners.splice(index, 1);
    }
  }

  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let cancel;
    const token = new CancelToken(function executor(c) {
      cancel = c;
    });
    return {
      token,
      cancel
    };
  }
}

/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 *
 * @returns {Function}
 */
function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
}

/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 *
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
function isAxiosError(payload) {
  return utils$1.isObject(payload) && (payload.isAxiosError === true);
}

const HttpStatusCode = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
};

Object.entries(HttpStatusCode).forEach(([key, value]) => {
  HttpStatusCode[value] = key;
});

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  const context = new Axios(defaultConfig);
  const instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils$1.extend(instance, Axios.prototype, context, {allOwnKeys: true});

  // Copy context to instance
  utils$1.extend(instance, context, null, {allOwnKeys: true});

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
const axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Expose Cancel & CancelToken
axios.CanceledError = CanceledError;
axios.CancelToken = CancelToken;
axios.isCancel = isCancel;
axios.VERSION = VERSION;
axios.toFormData = toFormData;

// Expose AxiosError class
axios.AxiosError = AxiosError;

// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};

axios.spread = spread;

// Expose isAxiosError
axios.isAxiosError = isAxiosError;

// Expose mergeConfig
axios.mergeConfig = mergeConfig;

axios.AxiosHeaders = AxiosHeaders;

axios.formToJSON = thing => formDataToJSON(utils$1.isHTMLForm(thing) ? new FormData(thing) : thing);

axios.getAdapter = adapters.getAdapter;

axios.HttpStatusCode = HttpStatusCode;

axios.default = axios;

class ActiveObject {
    constructor(obj) {
        this._activeObject = obj;
        if (!obj) {
            this._activeObjects = [];
        }
        else if (obj.type === 'activeSelection') {
            this._activeObjects = obj.getObjects();
        }
        else {
            this._activeObjects = [obj];
        }
    }
    getTargetObjects() {
        return this._activeObjects;
    }
    _getValue(o, key) {
        return o.get(key);
    }
    _setValue(o, key, value) {
        o.set(key, value);
    }
    get(key) {
        const objects = this.getTargetObjects();
        if (!objects.length) {
            return;
        }
        let value = this._getValue(objects[0], key);
        for (let i = 1, len = objects.length; i < len; ++i) {
            if (value !== this._getValue(objects[i], key)) {
                return null;
            }
        }
        return value;
    }
    set(key, value) {
        for (let o of this.getTargetObjects()) {
            this._setValue(o, key, value);
        }
    }
    fireModified() {
        try {
            const o = this._activeObject;
            o?.canvas?.fire('object:modified', { o });
        }
        catch (e) { }
    }
    isEmpty() {
        return !this._activeObjects.length;
    }
    size() {
        return this._activeObjects.length;
    }
}
const rangeProps = new Set([
    "fontSize",
    "fontWeight",
    "fontStyle",
    "fill",
    "stroke",
    "fontFamily",
    "underline",
]);
class ActiveTextareaObject extends ActiveObject {
    constructor(obj) {
        super(obj);
        const Textbox = fabric$1.fabric.IText;
        this._activeObjects = this._activeObjects.filter((o) => o instanceof Textbox);
    }
    getLinedPosition(textLines, position) {
        let lineNum = 0;
        while (position > 0) {
            const len = textLines[lineNum].length + 1;
            if (len > position) {
                break;
            }
            position -= len;
            ++lineNum;
        }
        return { position, lineNum };
    }
    iterateSelectedChars(o, callback) {
        const textLines = o.text.split("\n");
        let { position, lineNum } = this.getLinedPosition(textLines, o.selectionStart);
        let lineLen = textLines[lineNum].length;
        for (let i = 0, len = o.selectionEnd - o.selectionStart; i < len; ++i) {
            if (position > lineLen || lineLen === 0) {
                position = 0;
                lineLen = textLines[++lineNum].length;
            }
            if (lineLen > 0) {
                if (callback(lineNum, position)) {
                    break;
                }
                position++;
            }
        }
    }
    updateStyles(o, style) {
        const styles = o.styles || {};
        this.iterateSelectedChars(o, (lineNum, position) => {
            styles[lineNum] = styles[lineNum] || {};
            styles[lineNum][position] = styles[lineNum][position] || {};
            Object.assign(styles[lineNum][position], style);
        });
        return styles;
    }
    _getValue(o, key) {
        const styles = o.styles || {};
        let val = o.get(key);
        if (rangeProps.has(key) && o.isEditing) {
            if (o.selectionStart !== o.selectionEnd) {
                let res = null;
                this.iterateSelectedChars(o, (lineNum, position) => {
                    const v = styles[lineNum]?.[position]?.[key];
                    if (res === null) {
                        res = v;
                    }
                    if (res !== v) {
                        res = val;
                        return true;
                    }
                });
                return res ? res : val;
            }
            else {
                let styleCache = o.styleCache;
                if (styleCache?.key !== o.selectionStart) {
                    let { position, lineNum } = this.getLinedPosition(o.text.split("\n"), o.selectionStart - 1);
                    styleCache = {
                        key: o.selectionStart,
                        lineNum,
                        style: JSON.parse(JSON.stringify(styles[lineNum]?.[position] || styleCache?.style || {})),
                    };
                    styles[lineNum] = styles[lineNum] || {};
                }
                o.styleCache = styleCache;
                const v = styleCache.style?.[key];
                if (v) {
                    return v;
                }
            }
        }
        return val;
    }
    _setValue(o, key, value) {
        o.dirty = true;
        if (rangeProps.has(key) && o.isEditing) {
            if (o.selectionStart !== o.selectionEnd) {
                o.set("styles", this.updateStyles(o, { [key]: value }));
                if (o.selectionStart === o.styleCache?.key ||
                    o.selectionEnd === o.styleCache?.key) {
                    o.styleCache.style[key] = value;
                }
            }
            else if (o.selectionStart === o.styleCache?.key) {
                o.styleCache.style[key] = value;
            }
            else {
                o.set(key, value);
            }
        }
        else {
            o.set(key, value);
        }
        if (key === "enableTransliteration") {
            o.initHiddenTextarea();
            o.hiddenTextarea.focus();
            o.hiddenTextarea.value = o.text;
            o._updateTextarea();
        }
    }
    set(key, value) {
        const targets = this.getTargetObjects();
        const canvas = targets[0]?.canvas;
        for (let o of targets) {
            this._setValue(o, key, value);
        }
        canvas?.fire("object:modified", { target: targets[0] });
        canvas?.renderAll();
    }
    setProps(object) {
        const targets = this.getTargetObjects();
        const canvas = targets[0]?.canvas;
        for (let key in object) {
            for (let o of targets) {
                this._setValue(o, key, object[key]);
            }
        }
        canvas?.fire("object:modified", { target: targets[0] });
        canvas?.renderAll();
    }
}

const fabric = fabric$1.fabric;
async function initializeCanvasEditor(customCallback) {
    let containerElement = this.wrapper, canvasElement = containerElement.querySelector('.mainCanvas');
    const canvas = this.canvas = new fabric.LayeredCanvas(canvasElement);
    const me = this;
    canvas.on({
        'object:rotated': function () {
            canvas.isRotating = false;
        },
        'object:rotating': function () {
            canvas.isRotating = true;
        },
        'object:scaled': function () {
            canvas.isScaling = false;
        },
        'object:scaling': function () {
            canvas.isScaling = true;
        },
        'object:moved': function ({ target }) {
            me.restrictObject(target, "left", () => target.width * target.scaleX, "allowedLeft");
            me.restrictObject(target, "top", () => target.scaleY * target.height, "allowedTop");
        }
    });
    if (customCallback) {
        await customCallback(this);
    }
    return this;
}
class Page {
    constructor(url) {
        this.url = url;
    }
    async initialize() {
        this.data = await axios(this.url).then(res => res.data);
        return this;
    }
    async getDesign() {
        return this.data;
    }
    setDesign(design) {
        this.data = design;
    }
    getWidth() {
        return this.data.pageWidth;
    }
    getHeight() {
        return this.data.pageHeight;
    }
    getEffectiveWidth() {
        return this.data.pageWidth;
    }
    getEffectiveHeight() {
        return this.data.pageHeight;
    }
    getLeft() {
        return 0;
    }
    getTop() {
        return 0;
    }
}
async function loadDesign(page) {
    return await loadFromJSON.call(this, await page.getDesign());
}
function isObjectEditing(obj) {
    return obj?.isEditing;
}
function onKeydown(editor) {
    return (e) => {
        let left = 0, top = 0, step = 0.5, lockType;
        switch (e.key) {
            case 'ArrowUp':
                top = -step;
                lockType = "lockMovementY";
                break;
            case 'ArrowDown':
                top = step;
                lockType = "lockMovementY";
                break;
            case 'ArrowRight':
                left = step;
                lockType = "lockMovementX";
                break;
            case 'ArrowLeft':
                left = -step;
                lockType = "lockMovementX";
                break;
            case 'Backspace':
                var obj = editor.canvas?.getActiveObject();
                var objects = editor.canvas?.getActiveObjects();
                if (objects && editor.shouldDeleteObjects(objects) && !isObjectEditing(obj)) {
                    editor.deleteObjects(objects);
                }
                return;
            case 'Delete':
                var objects = editor.canvas?.getActiveObjects();
                if (objects && editor.shouldDeleteObjects(objects)) {
                    editor.deleteObjects(objects);
                }
                return;
            default:
                return;
        }
        const { canvas } = editor;
        const activeObject = canvas.getActiveObject();
        if (activeObject && !activeObject[lockType]) {
            activeObject.left += left;
            activeObject.top += top;
            canvas.renderAll();
        }
    };
}
function onKeyup(editor) {
    return (e) => {
        let lockType;
        switch (e.key) {
            case 'ArrowUp':
            case 'ArrowDown':
                lockType = "lockMovementY";
                break;
            case 'ArrowLeft':
            case 'ArrowRight':
                lockType = "lockMovementX";
                break;
            default:
                return;
        }
        const { canvas } = editor;
        const activeObject = canvas.getActiveObject();
        if (activeObject && !activeObject[lockType]) {
            canvas.fire('object:modified', { target: canvas.getActiveObjects() });
        }
    };
}
const FabricContext = createContext(null);
const FabricContainer = FabricContext.Provider;
function useFabricContainer() {
    return useContext(FabricContext);
}
function useFabricCanvas() {
    return useFabricContainer()?.canvas;
}
function useFabricEditor() {
    return useFabricContainer();
}
function useFabricCanvasHandler(dataOrCallback, dependencies = []) {
    const canvas = useFabricCanvas();
    const [handler] = useState({});
    useEffect(() => {
        const data = typeof dataOrCallback === 'function' ? dataOrCallback(canvas) : dataOrCallback;
        if (canvas && data) {
            canvas.off(handler);
            Object.keys(handler).forEach(k => delete handler[k]);
            Object.assign(handler, data);
            canvas.on(handler);
        }
        return () => {
            if (canvas && handler) {
                canvas.off(handler);
            }
        };
    }, [canvas, handler, ...dependencies]);
    return [canvas, handler];
}
function useActiveFabricObject(Wrapper = ActiveObject) {
    const [activeObject, setActiveObject] = useState(new Wrapper(null));
    function updateActiveObject() {
        setActiveObject(new Wrapper(canvas.getActiveObject()));
    }
    const [canvas] = useFabricCanvasHandler(canvas => {
        canvas && setActiveObject(new Wrapper(canvas.getActiveObject()));
        return {
            'selection:created': updateActiveObject,
            'selection:updated': updateActiveObject,
            'selection:cleared': updateActiveObject
        };
    });
    return [activeObject, updateActiveObject];
}
function useFabricCanvasInitalizer({ onShow, page, onPageMount, onPageUnMount, customCallback }) {
    const wrapper = useRef(null);
    const eventHandlers = useRef();
    const mainCanvasWrapper = useRef(null);
    const { width, height } = useContainerDimensions(wrapper);
    const [isEditing, setEditing] = useState(false);
    const editor = useFabricEditor();
    useFabricCanvasHandler({
        'layerTarget:changed': function (e) {
            setEditing(e.editable);
        }
    });
    useEffect(() => {
        if (editor && page) {
            editor.currentPage = page;
            editor.recalcCanvasLayout(width, height);
        }
    }, [width, height, editor, page]);
    useEffect(() => {
        if (editor && page) {
            loadDesign.call(editor, page).then(e => {
                page.isMounted = true;
                page.canvas = editor.canvas;
                onPageMount?.(page);
            });
        }
        return () => {
            if (editor && page) {
                page.isMounted = false;
                editor?.canvas.discardActiveObject();
                page.setDesign(editor.getJSON());
                delete page.canvas;
                onPageUnMount?.(page);
            }
        };
    }, [editor, page]);
    useEffect(() => {
        if (mainCanvasWrapper.current && wrapper.current) {
            mainCanvasWrapper.current.innerHTML = `<canvas class="mainCanvas" />`;
            initializeCanvasEditor.call(new CanvasEditor(wrapper.current, null), customCallback)
                .then(onShow);
        }
    }, []);
    useEffect(() => {
        const el = wrapper.current;
        if (el && editor) {
            eventHandlers.current = {
                onKeydown: onKeydown(editor),
                onKeyup: onKeyup(editor)
            };
            el.addEventListener('keydown', eventHandlers.current.onKeydown);
            el.addEventListener('keyup', eventHandlers.current.onKeyup);
        }
        return () => {
            if (el && editor && eventHandlers.current) {
                el.removeEventListener('keydown', eventHandlers.current.onKeydown);
                el.removeEventListener('keyup', eventHandlers.current.onKeyup);
            }
        };
    }, [editor]);
    return { wrapper, mainCanvasWrapper, editor, isEditing };
}
function useUndoRedoStack() {
    const editor = useFabricEditor();
    const [undoState, setUndoState] = useState(false);
    const [redoState, setRedoState] = useState(false);
    useEffect(() => {
        function updateState() {
            if (editor) {
                setUndoState(editor.canUndo());
                setRedoState(editor.canRedo());
            }
        }
        editor?.onCanvasStateChange(updateState);
        editor && updateState();
        return () => {
            editor?.offCanvasStateChange(updateState);
        };
    }, [editor]);
    return [editor, undoState, redoState];
}

const PageCanvas = ({ onShow, style, page, onPageMount, onPageUnMount, customCallback }) => {
    const { wrapper, mainCanvasWrapper, editor, isEditing } = useFabricCanvasInitalizer({ onShow, page, onPageMount, onPageUnMount, customCallback });
    return React.createElement("div", { tabIndex: 0, style: {
            height: '100%',
            width: '100%',
            outline: 'none',
            position: 'relative',
            ...style
        }, ref: wrapper },
        React.createElement("div", { style: { position: 'absolute', width: "100%", height: "100%" } },
            React.createElement("div", { ref: mainCanvasWrapper, className: "mainCanvasWrapper" },
                React.createElement("canvas", { className: "mainCanvas" })),
            React.createElement("div", { className: `edit-svg ${isEditing ? '' : 'hidden'}` },
                React.createElement("span", { className: "hyperlink", onClick: () => editor?.canvas?.closeSVGEditing() }, "Close Editing"))));
};

var fabric$2 = fabric$1.fabric;
export { ActiveObject, ActiveTextareaObject, CanvasEditor, FabricContainer, Page, PageCanvas, fabric$2 as fabric, fontLoader, getImage, loadFromJSON, opentype, useActiveFabricObject, useFabricCanvas, useFabricCanvasHandler, useFabricCanvasInitalizer, useFabricEditor, useUndoRedoStack };
